!(function (t) {
  const e = (t.en = t.en || {});
  e.dictionary = Object.assign(e.dictionary || {}, {
    "%0 of %1": "%0 of %1",
    "Align cell text to the bottom": "Align cell text to the bottom",
    "Align cell text to the center": "Align cell text to the center",
    "Align cell text to the left": "Align cell text to the left",
    "Align cell text to the middle": "Align cell text to the middle",
    "Align cell text to the right": "Align cell text to the right",
    "Align cell text to the top": "Align cell text to the top",
    "Align center": "Align center",
    "Align left": "Align left",
    "Align right": "Align right",
    "Align table to the left": "Align table to the left",
    "Align table to the right": "Align table to the right",
    Alignment: "Alignment",
    Aquamarine: "Aquamarine",
    Background: "Background",
    Black: "Black",
    "Block quote": "Block quote",
    Blue: "Blue",
    Bold: "Bold",
    Border: "Border",
    "Break text": "Break text",
    "Bulleted List": "Bulleted List",
    Cancel: "Cancel",
    "Caption for image: %0": "Caption for image: %0",
    "Caption for the image": "Caption for the image",
    "Cell properties": "Cell properties",
    "Center table": "Center table",
    "Centered image": "Centered image",
    "Change image text alternative": "Change image text alternative",
    "Choose heading": "Choose heading",
    Code: "Code",
    Color: "Color",
    "Color picker": "Color picker",
    Column: "Column",
    Dashed: "Dashed",
    "Decrease indent": "Decrease indent",
    "Delete column": "Delete column",
    "Delete row": "Delete row",
    "Dim grey": "Dim grey",
    Dimensions: "Dimensions",
    "Document colors": "Document colors",
    Dotted: "Dotted",
    Double: "Double",
    Downloadable: "Downloadable",
    "Dropdown toolbar": "Dropdown toolbar",
    "Edit block": "Edit block",
    "Edit link": "Edit link",
    "Edit source": "Edit source",
    "Editor block content toolbar": "Editor block content toolbar",
    "Editor contextual toolbar": "Editor contextual toolbar",
    "Editor editing area: %0": "Editor editing area: %0",
    "Editor toolbar": "Editor toolbar",
    "Empty snippet content": "Empty snippet content",
    "Enter image caption": "Enter image caption",
    Find: "Find",
    "Find and replace": "Find and replace",
    "Find in text…": "Find in text…",
    "Font Background Color": "Font Background Color",
    "Font Color": "Font Color",
    "Full size image": "Full size image",
    Green: "Green",
    Grey: "Grey",
    Groove: "Groove",
    "Header column": "Header column",
    "Header row": "Header row",
    Heading: "Heading",
    "Heading 1": "Heading 1",
    "Heading 2": "Heading 2",
    "Heading 3": "Heading 3",
    "Heading 4": "Heading 4",
    "Heading 5": "Heading 5",
    "Heading 6": "Heading 6",
    Height: "Height",
    "Horizontal line": "Horizontal line",
    "Horizontal text alignment toolbar": "Horizontal text alignment toolbar",
    "HTML object": "HTML object",
    "HTML snippet": "HTML snippet",
    "Image resize list": "Image resize list",
    "Image toolbar": "Image toolbar",
    "image widget": "image widget",
    "In line": "In line",
    "Increase indent": "Increase indent",
    Insert: "Insert",
    "Insert code block": "Insert code block",
    "Insert column left": "Insert column left",
    "Insert column right": "Insert column right",
    "Insert HTML": "Insert HTML",
    "Insert image": "Insert image",
    "Insert image via URL": "Insert image via URL",
    "Insert media": "Insert media",
    "Insert paragraph after block": "Insert paragraph after block",
    "Insert paragraph before block": "Insert paragraph before block",
    "Insert row above": "Insert row above",
    "Insert row below": "Insert row below",
    "Insert table": "Insert table",
    Inset: "Inset",
    Italic: "Italic",
    Justify: "Justify",
    "Justify cell text": "Justify cell text",
    "Left aligned image": "Left aligned image",
    "Light blue": "Light blue",
    "Light green": "Light green",
    "Light grey": "Light grey",
    Link: "Link",
    "Link image": "Link image",
    "Link URL": "Link URL",
    "Match case": "Match case",
    "Media URL": "Media URL",
    "media widget": "media widget",
    "Merge cell down": "Merge cell down",
    "Merge cell left": "Merge cell left",
    "Merge cell right": "Merge cell right",
    "Merge cell up": "Merge cell up",
    "Merge cells": "Merge cells",
    Next: "Next",
    "Next result": "Next result",
    "No preview available": "No preview available",
    None: "None",
    "Numbered List": "Numbered List",
    "Open in a new tab": "Open in a new tab",
    "Open link in new tab": "Open link in new tab",
    "Open media in new tab": "Open media in new tab",
    Orange: "Orange",
    Original: "Original",
    Outset: "Outset",
    Padding: "Padding",
    Paragraph: "Paragraph",
    "Paste raw HTML here...": "Paste raw HTML here...",
    "Paste the media URL in the input.": "Paste the media URL in the input.",
    "Plain text": "Plain text",
    Previous: "Previous",
    "Previous result": "Previous result",
    Purple: "Purple",
    Red: "Red",
    Redo: "Redo",
    "Remove color": "Remove color",
    "Remove Format": "Remove Format",
    Replace: "Replace",
    "Replace all": "Replace all",
    "Replace with…": "Replace with…",
    "Resize image": "Resize image",
    "Resize image to %0": "Resize image to %0",
    "Resize image to the original size": "Resize image to the original size",
    "Restore default": "Restore default",
    "Rich Text Editor": "Rich Text Editor",
    Ridge: "Ridge",
    "Right aligned image": "Right aligned image",
    Row: "Row",
    Save: "Save",
    "Save changes": "Save changes",
    "Select all": "Select all",
    "Select column": "Select column",
    "Select row": "Select row",
    "Show more items": "Show more items",
    "Show options": "Show options",
    "Side image": "Side image",
    Solid: "Solid",
    Source: "Source",
    "Split cell horizontally": "Split cell horizontally",
    "Split cell vertically": "Split cell vertically",
    Strikethrough: "Strikethrough",
    Style: "Style",
    Subscript: "Subscript",
    Superscript: "Superscript",
    "Table alignment toolbar": "Table alignment toolbar",
    "Table cell text alignment": "Table cell text alignment",
    "Table properties": "Table properties",
    "Table toolbar": "Table toolbar",
    "Text alignment": "Text alignment",
    "Text alignment toolbar": "Text alignment toolbar",
    "Text alternative": "Text alternative",
    "Text to find must not be empty.": "Text to find must not be empty.",
    'The color is invalid. Try "#FF0000" or "rgb(255,0,0)" or "red".':
      'The color is invalid. Try "#FF0000" or "rgb(255,0,0)" or "red".',
    "The URL must not be empty.": "The URL must not be empty.",
    'The value is invalid. Try "10px" or "2em" or simply "2".':
      'The value is invalid. Try "10px" or "2em" or simply "2".',
    "This link has no URL": "This link has no URL",
    "This media URL is not supported.": "This media URL is not supported.",
    "Tip: Find some text first in order to replace it.":
      "Tip: Find some text first in order to replace it.",
    "Tip: Paste the URL into the content to embed faster.":
      "Tip: Paste the URL into the content to embed faster.",
    "Toggle caption off": "Toggle caption off",
    "Toggle caption on": "Toggle caption on",
    Turquoise: "Turquoise",
    Underline: "Underline",
    Undo: "Undo",
    Unlink: "Unlink",
    Update: "Update",
    "Update image URL": "Update image URL",
    "Upload failed": "Upload failed",
    "Upload in progress": "Upload in progress",
    "Vertical text alignment toolbar": "Vertical text alignment toolbar",
    White: "White",
    "Whole words only": "Whole words only",
    "Widget toolbar": "Widget toolbar",
    Width: "Width",
    "Wrap text": "Wrap text",
    Yellow: "Yellow",
  });
})(window.CKEDITOR_TRANSLATIONS || (window.CKEDITOR_TRANSLATIONS = {})),
  /*!
   * @license Copyright (c) 2003-2022, CKSource Holding sp. z o.o. All rights reserved.
   * For licensing, see LICENSE.md.
   */
  (function (t, e) {
    "object" == typeof exports && "object" == typeof module
      ? (module.exports = e())
      : "function" == typeof define && define.amd
      ? define([], e)
      : "object" == typeof exports
      ? (exports.ClassicEditor = e())
      : (t.ClassicEditor = e());
  })(self, () =>
    (() => {
      var t = {
          8180: (t, e, n) => {
            "use strict";
            n.d(e, { Z: () => a });
            var o = n(7537),
              i = n.n(o),
              r = n(3645),
              s = n.n(r)()(i());
            s.push([
              t.id,
              ".ck-content code{background-color:hsla(0,0%,78%,.3);border-radius:2px;padding:.15em}.ck.ck-editor__editable .ck-code_selected{background-color:hsla(0,0%,78%,.5)}",
              "",
              {
                version: 3,
                sources: [
                  "webpack://./node_modules/@ckeditor/ckeditor5-basic-styles/theme/code.css",
                ],
                names: [],
                mappings:
                  "AAKA,iBACC,kCAAuC,CAEvC,iBAAkB,CADlB,aAED,CAEA,0CACC,kCACD",
                sourcesContent: [
                  "/*\n * Copyright (c) 2003-2022, CKSource Holding sp. z o.o. All rights reserved.\n * For licensing, see LICENSE.md or https://ckeditor.com/legal/ckeditor-oss-license\n */\n\n.ck-content code {\n\tbackground-color: hsla(0, 0%, 78%, 0.3);\n\tpadding: .15em;\n\tborder-radius: 2px;\n}\n\n.ck.ck-editor__editable .ck-code_selected  {\n\tbackground-color: hsla(0, 0%, 78%, 0.5);\n}\n",
                ],
                sourceRoot: "",
              },
            ]);
            const a = s;
          },
          636: (t, e, n) => {
            "use strict";
            n.d(e, { Z: () => a });
            var o = n(7537),
              i = n.n(o),
              r = n(3645),
              s = n.n(r)()(i());
            s.push([
              t.id,
              ".ck-content blockquote{border-left:5px solid #ccc;font-style:italic;margin-left:0;margin-right:0;overflow:hidden;padding-left:1.5em;padding-right:1.5em}.ck-content[dir=rtl] blockquote{border-left:0;border-right:5px solid #ccc}",
              "",
              {
                version: 3,
                sources: [
                  "webpack://./node_modules/@ckeditor/ckeditor5-block-quote/theme/blockquote.css",
                ],
                names: [],
                mappings:
                  "AAKA,uBAWC,0BAAsC,CADtC,iBAAkB,CAFlB,aAAc,CACd,cAAe,CAPf,eAAgB,CAIhB,kBAAmB,CADnB,mBAOD,CAEA,gCACC,aAAc,CACd,2BACD",
                sourcesContent: [
                  '/*\n * Copyright (c) 2003-2022, CKSource Holding sp. z o.o. All rights reserved.\n * For licensing, see LICENSE.md or https://ckeditor.com/legal/ckeditor-oss-license\n */\n\n.ck-content blockquote {\n\t/* See #12 */\n\toverflow: hidden;\n\n\t/* https://github.com/ckeditor/ckeditor5-block-quote/issues/15 */\n\tpadding-right: 1.5em;\n\tpadding-left: 1.5em;\n\n\tmargin-left: 0;\n\tmargin-right: 0;\n\tfont-style: italic;\n\tborder-left: solid 5px hsl(0, 0%, 80%);\n}\n\n.ck-content[dir="rtl"] blockquote {\n\tborder-left: 0;\n\tborder-right: solid 5px hsl(0, 0%, 80%);\n}\n',
                ],
                sourceRoot: "",
              },
            ]);
            const a = s;
          },
          390: (t, e, n) => {
            "use strict";
            n.d(e, { Z: () => a });
            var o = n(7537),
              i = n.n(o),
              r = n(3645),
              s = n.n(r)()(i());
            s.push([
              t.id,
              '.ck.ck-editor__editable .ck.ck-clipboard-drop-target-position{display:inline;pointer-events:none;position:relative}.ck.ck-editor__editable .ck.ck-clipboard-drop-target-position span{position:absolute;width:0}.ck.ck-editor__editable .ck-widget:-webkit-drag>.ck-widget__selection-handle,.ck.ck-editor__editable .ck-widget:-webkit-drag>.ck-widget__type-around{display:none}:root{--ck-clipboard-drop-target-dot-width:12px;--ck-clipboard-drop-target-dot-height:8px;--ck-clipboard-drop-target-color:var(--ck-color-focus-border)}.ck.ck-editor__editable .ck.ck-clipboard-drop-target-position span{background:var(--ck-clipboard-drop-target-color);border:1px solid var(--ck-clipboard-drop-target-color);bottom:calc(var(--ck-clipboard-drop-target-dot-height)*-.5);margin-left:-1px;top:calc(var(--ck-clipboard-drop-target-dot-height)*-.5)}.ck.ck-editor__editable .ck.ck-clipboard-drop-target-position span:after{border-color:var(--ck-clipboard-drop-target-color) transparent transparent transparent;border-style:solid;border-width:calc(var(--ck-clipboard-drop-target-dot-height)) calc(var(--ck-clipboard-drop-target-dot-width)*.5) 0 calc(var(--ck-clipboard-drop-target-dot-width)*.5);content:"";display:block;height:0;left:50%;position:absolute;top:calc(var(--ck-clipboard-drop-target-dot-height)*-.5);transform:translateX(-50%);width:0}.ck.ck-editor__editable .ck-widget.ck-clipboard-drop-target-range{outline:var(--ck-widget-outline-thickness) solid var(--ck-clipboard-drop-target-color)!important}.ck.ck-editor__editable .ck-widget:-webkit-drag{zoom:.6;outline:none!important}',
              "",
              {
                version: 3,
                sources: [
                  "webpack://./node_modules/@ckeditor/ckeditor5-clipboard/theme/clipboard.css",
                  "webpack://./node_modules/@ckeditor/ckeditor5-theme-lark/theme/ckeditor5-clipboard/clipboard.css",
                ],
                names: [],
                mappings:
                  "AASC,8DACC,cAAe,CAEf,mBAAoB,CADpB,iBAOD,CAJC,mEACC,iBAAkB,CAClB,OACD,CAWA,qJACC,YACD,CCzBF,MACC,yCAA0C,CAC1C,yCAA0C,CAC1C,6DACD,CAOE,mEAIC,gDAAiD,CADjD,sDAAuD,CAFvD,2DAA8D,CAI9D,gBAAiB,CAHjB,wDAqBD,CAfC,yEAWC,sFAAuF,CAEvF,kBAAmB,CADnB,qKAA0K,CAX1K,UAAW,CAIX,aAAc,CAFd,QAAS,CAIT,QAAS,CADT,iBAAkB,CAElB,wDAA2D,CAE3D,0BAA2B,CAR3B,OAYD,CA2DF,kEACC,gGACD,CAKA,gDACC,OAAS,CACT,sBACD",
                sourcesContent: [
                  "/*\n * Copyright (c) 2003-2022, CKSource Holding sp. z o.o. All rights reserved.\n * For licensing, see LICENSE.md or https://ckeditor.com/legal/ckeditor-oss-license\n */\n\n.ck.ck-editor__editable {\n\t/*\n\t * Vertical drop target (in text).\n\t */\n\t& .ck.ck-clipboard-drop-target-position {\n\t\tdisplay: inline;\n\t\tposition: relative;\n\t\tpointer-events: none;\n\n\t\t& span {\n\t\t\tposition: absolute;\n\t\t\twidth: 0;\n\t\t}\n\t}\n\n\t/*\n\t * Styles of the widget being dragged (its preview).\n\t */\n\t& .ck-widget:-webkit-drag {\n\t\t& > .ck-widget__selection-handle {\n\t\t\tdisplay: none;\n\t\t}\n\n\t\t& > .ck-widget__type-around {\n\t\t\tdisplay: none;\n\t\t}\n\t}\n}\n",
                  '/*\n * Copyright (c) 2003-2022, CKSource Holding sp. z o.o. All rights reserved.\n * For licensing, see LICENSE.md or https://ckeditor.com/legal/ckeditor-oss-license\n */\n\n:root {\n\t--ck-clipboard-drop-target-dot-width: 12px;\n\t--ck-clipboard-drop-target-dot-height: 8px;\n\t--ck-clipboard-drop-target-color: var(--ck-color-focus-border)\n}\n\n.ck.ck-editor__editable {\n\t/*\n\t * Vertical drop target (in text).\n\t */\n\t& .ck.ck-clipboard-drop-target-position {\n\t\t& span {\n\t\t\tbottom: calc(-.5 * var(--ck-clipboard-drop-target-dot-height));\n\t\t\ttop: calc(-.5 * var(--ck-clipboard-drop-target-dot-height));\n\t\t\tborder: 1px solid var(--ck-clipboard-drop-target-color);\n\t\t\tbackground: var(--ck-clipboard-drop-target-color);\n\t\t\tmargin-left: -1px;\n\n\t\t\t/* The triangle above the marker */\n\t\t\t&::after {\n\t\t\t\tcontent: "";\n\t\t\t\twidth: 0;\n\t\t\t\theight: 0;\n\n\t\t\t\tdisplay: block;\n\t\t\t\tposition: absolute;\n\t\t\t\tleft: 50%;\n\t\t\t\ttop: calc(var(--ck-clipboard-drop-target-dot-height) * -.5);\n\n\t\t\t\ttransform: translateX(-50%);\n\t\t\t\tborder-color: var(--ck-clipboard-drop-target-color) transparent transparent transparent;\n\t\t\t\tborder-width: calc(var(--ck-clipboard-drop-target-dot-height)) calc(.5 * var(--ck-clipboard-drop-target-dot-width)) 0 calc(.5 * var(--ck-clipboard-drop-target-dot-width));\n\t\t\t\tborder-style: solid;\n\t\t\t}\n\t\t}\n\t}\n\n\t/*\n\t// Horizontal drop target (between blocks).\n\t& .ck.ck-clipboard-drop-target-position {\n\t\tdisplay: block;\n\t\tposition: relative;\n\t\twidth: 100%;\n\t\theight: 0;\n\t\tmargin: 0;\n\t\ttext-align: initial;\n\n\t\t& .ck-clipboard-drop-target__line {\n\t\t\tposition: absolute;\n\t\t\twidth: 100%;\n\t\t\theight: 0;\n\t\t\tborder: 1px solid var(--ck-clipboard-drop-target-color);\n\t\t\tmargin-top: -1px;\n\n\t\t\t&::before {\n\t\t\t\tcontent: "";\n\t\t\t\twidth: 0;\n\t\t\t\theight: 0;\n\n\t\t\t\tdisplay: block;\n\t\t\t\tposition: absolute;\n\t\t\t\tleft: calc(-1 * var(--ck-clipboard-drop-target-dot-size));\n\t\t\t\ttop: 0;\n\n\t\t\t\ttransform: translateY(-50%);\n\t\t\t\tborder-color: transparent transparent transparent var(--ck-clipboard-drop-target-color);\n\t\t\t\tborder-width: var(--ck-clipboard-drop-target-dot-size) 0 var(--ck-clipboard-drop-target-dot-size) calc(2 * var(--ck-clipboard-drop-target-dot-size));\n\t\t\t\tborder-style: solid;\n\t\t\t}\n\n\t\t\t&::after {\n\t\t\t\tcontent: "";\n\t\t\t\twidth: 0;\n\t\t\t\theight: 0;\n\n\t\t\t\tdisplay: block;\n\t\t\t\tposition: absolute;\n\t\t\t\tright: calc(-1 * var(--ck-clipboard-drop-target-dot-size));\n\t\t\t\ttop: 0;\n\n\t\t\t\ttransform: translateY(-50%);\n\t\t\t\tborder-color: transparent var(--ck-clipboard-drop-target-color) transparent transparent;\n\t\t\t\tborder-width: var(--ck-clipboard-drop-target-dot-size) calc(2 * var(--ck-clipboard-drop-target-dot-size)) var(--ck-clipboard-drop-target-dot-size) 0;\n\t\t\t\tborder-style: solid;\n\t\t\t}\n\t\t}\n\t}\n\t*/\n\n\t/*\n\t * Styles of the widget that it a drop target.\n\t */\n\t& .ck-widget.ck-clipboard-drop-target-range {\n\t\toutline: var(--ck-widget-outline-thickness) solid var(--ck-clipboard-drop-target-color) !important;\n\t}\n\n\t/*\n\t * Styles of the widget being dragged (its preview).\n\t */\n\t& .ck-widget:-webkit-drag {\n\t\tzoom: 0.6;\n\t\toutline: none !important;\n\t}\n}\n',
                ],
                sourceRoot: "",
              },
            ]);
            const a = s;
          },
          9085: (t, e, n) => {
            "use strict";
            n.d(e, { Z: () => a });
            var o = n(7537),
              i = n.n(o),
              r = n(3645),
              s = n.n(r)()(i());
            s.push([
              t.id,
              ".ck-content pre{background:hsla(0,0%,78%,.3);border:1px solid #c4c4c4;border-radius:2px;color:#353535;direction:ltr;font-style:normal;min-width:200px;padding:1em;tab-size:4;text-align:left;white-space:pre-wrap}.ck-content pre code{background:unset;border-radius:0;padding:0}.ck.ck-editor__editable pre{position:relative}.ck.ck-editor__editable pre[data-language]:after{content:attr(data-language);position:absolute}:root{--ck-color-code-block-label-background:#757575}.ck.ck-editor__editable pre[data-language]:after{background:var(--ck-color-code-block-label-background);color:#fff;font-family:var(--ck-font-face);font-size:10px;line-height:16px;padding:var(--ck-spacing-tiny) var(--ck-spacing-medium);right:10px;top:-1px;white-space:nowrap}.ck.ck-code-block-dropdown .ck-dropdown__panel{max-height:250px;overflow-x:hidden;overflow-y:auto}",
              "",
              {
                version: 3,
                sources: [
                  "webpack://./node_modules/@ckeditor/ckeditor5-code-block/theme/codeblock.css",
                  "webpack://./node_modules/@ckeditor/ckeditor5-theme-lark/theme/ckeditor5-code-block/codeblock.css",
                ],
                names: [],
                mappings:
                  "AAKA,gBAGC,4BAAiC,CACjC,wBAAiC,CACjC,iBAAkB,CAHlB,aAAwB,CAOxB,aAAc,CAMd,iBAAkB,CAGlB,eAAgB,CAjBhB,WAAY,CAUZ,UAAW,CAHX,eAAgB,CAIhB,oBAaD,CALC,qBACC,gBAAiB,CAEjB,eAAgB,CADhB,SAED,CAGD,4BACC,iBAMD,CAJC,iDACC,2BAA4B,CAC5B,iBACD,CCjCD,MACC,8CACD,CAEA,iDAGC,sDAAuD,CAMvD,UAAuB,CAHvB,+BAAgC,CADhC,cAAe,CAEf,gBAAiB,CACjB,uDAAwD,CANxD,UAAW,CADX,QAAS,CAST,kBACD,CAEA,+CAEC,gBAAiB,CAEjB,iBAAkB,CADlB,eAED",
                sourcesContent: [
                  "/*\n * Copyright (c) 2003-2022, CKSource Holding sp. z o.o. All rights reserved.\n * For licensing, see LICENSE.md or https://ckeditor.com/legal/ckeditor-oss-license\n */\n\n.ck-content pre {\n\tpadding: 1em;\n\tcolor: hsl(0, 0%, 20.8%);\n\tbackground: hsla(0, 0%, 78%, 0.3);\n\tborder: 1px solid hsl(0, 0%, 77%);\n\tborder-radius: 2px;\n\n\t/* Code block are language direction–agnostic. */\n\ttext-align: left;\n\tdirection: ltr;\n\n\ttab-size: 4;\n\twhite-space: pre-wrap;\n\n\t/* Don't inherit the style, e.g. when in a block quote. */\n\tfont-style: normal;\n\n\t/* Don't let the code be squashed e.g. when in a table cell. */\n\tmin-width: 200px;\n\n\t& code {\n\t\tbackground: unset;\n\t\tpadding: 0;\n\t\tborder-radius: 0;\n\t}\n}\n\n.ck.ck-editor__editable pre {\n\tposition: relative;\n\n\t&[data-language]::after {\n\t\tcontent: attr(data-language);\n\t\tposition: absolute;\n\t}\n}\n",
                  "/*\n * Copyright (c) 2003-2022, CKSource Holding sp. z o.o. All rights reserved.\n * For licensing, see LICENSE.md or https://ckeditor.com/legal/ckeditor-oss-license\n */\n\n:root {\n\t--ck-color-code-block-label-background: hsl(0, 0%, 46%);\n}\n\n.ck.ck-editor__editable pre[data-language]::after {\n\ttop: -1px;\n\tright: 10px;\n\tbackground: var(--ck-color-code-block-label-background);\n\n\tfont-size: 10px;\n\tfont-family: var(--ck-font-face);\n\tline-height: 16px;\n\tpadding: var(--ck-spacing-tiny) var(--ck-spacing-medium);\n\tcolor: hsl(0, 0%, 100%);\n\twhite-space: nowrap;\n}\n\n.ck.ck-code-block-dropdown .ck-dropdown__panel {\n\t/* There could be dozens of languages available. Use scroll to prevent a 10e6px dropdown. */\n\tmax-height: 250px;\n\toverflow-y: auto;\n\toverflow-x: hidden;\n}\n",
                ],
                sourceRoot: "",
              },
            ]);
            const a = s;
          },
          3638: (t, e, n) => {
            "use strict";
            n.d(e, { Z: () => a });
            var o = n(7537),
              i = n.n(o),
              r = n(3645),
              s = n.n(r)()(i());
            s.push([
              t.id,
              ".ck.ck-editor{position:relative}.ck.ck-editor .ck-editor__top .ck-sticky-panel .ck-toolbar{z-index:var(--ck-z-modal)}.ck.ck-editor__top .ck-sticky-panel .ck-toolbar{border-radius:0}.ck-rounded-corners .ck.ck-editor__top .ck-sticky-panel .ck-toolbar,.ck.ck-editor__top .ck-sticky-panel .ck-toolbar.ck-rounded-corners{border-radius:var(--ck-border-radius);border-bottom-left-radius:0;border-bottom-right-radius:0}.ck.ck-editor__top .ck-sticky-panel .ck-toolbar{border-bottom-width:0}.ck.ck-editor__top .ck-sticky-panel .ck-sticky-panel__content_sticky .ck-toolbar{border-bottom-width:1px;border-radius:0}.ck-rounded-corners .ck.ck-editor__top .ck-sticky-panel .ck-sticky-panel__content_sticky .ck-toolbar,.ck.ck-editor__top .ck-sticky-panel .ck-sticky-panel__content_sticky .ck-toolbar.ck-rounded-corners{border-radius:var(--ck-border-radius);border-radius:0}.ck.ck-editor__main>.ck-editor__editable{background:var(--ck-color-base-background);border-radius:0}.ck-rounded-corners .ck.ck-editor__main>.ck-editor__editable,.ck.ck-editor__main>.ck-editor__editable.ck-rounded-corners{border-radius:var(--ck-border-radius);border-top-left-radius:0;border-top-right-radius:0}.ck.ck-editor__main>.ck-editor__editable:not(.ck-focused){border-color:var(--ck-color-base-border)}",
              "",
              {
                version: 3,
                sources: [
                  "webpack://./node_modules/@ckeditor/ckeditor5-editor-classic/theme/classiceditor.css",
                  "webpack://./node_modules/@ckeditor/ckeditor5-theme-lark/theme/ckeditor5-editor-classic/classiceditor.css",
                  "webpack://./node_modules/@ckeditor/ckeditor5-theme-lark/theme/mixins/_rounded.css",
                ],
                names: [],
                mappings:
                  "AAKA,cAIC,iBAMD,CAJC,2DAEC,yBACD,CCLC,gDCED,eDKC,CAPA,uICMA,qCAAsC,CDJpC,2BAA4B,CAC5B,4BAIF,CAPA,gDAMC,qBACD,CAEA,iFACC,uBAAwB,CCR1B,eDaC,CANA,yMCHA,qCAAsC,CDOpC,eAEF,CAKF,yCAEC,0CAA2C,CCpB3C,eD8BD,CAZA,yHCdE,qCAAsC,CDmBtC,wBAAyB,CACzB,yBAMF,CAHC,0DACC,wCACD",
                sourcesContent: [
                  "/*\n * Copyright (c) 2003-2022, CKSource Holding sp. z o.o. All rights reserved.\n * For licensing, see LICENSE.md or https://ckeditor.com/legal/ckeditor-oss-license\n */\n\n.ck.ck-editor {\n\t/* All the elements within `.ck-editor` are positioned relatively to it.\n\t If any element needs to be positioned with respect to the <body>, etc.,\n\t it must land outside of the `.ck-editor` in DOM. */\n\tposition: relative;\n\n\t& .ck-editor__top .ck-sticky-panel .ck-toolbar {\n\t\t/* https://github.com/ckeditor/ckeditor5-editor-classic/issues/62 */\n\t\tz-index: var(--ck-z-modal);\n\t}\n}\n",
                  '/*\n * Copyright (c) 2003-2022, CKSource Holding sp. z o.o. All rights reserved.\n * For licensing, see LICENSE.md or https://ckeditor.com/legal/ckeditor-oss-license\n */\n\n@import "../mixins/_rounded.css";\n\n.ck.ck-editor__top {\n\t& .ck-sticky-panel {\n\t\t& .ck-toolbar {\n\t\t\t@mixin ck-rounded-corners {\n\t\t\t\tborder-bottom-left-radius: 0;\n\t\t\t\tborder-bottom-right-radius: 0;\n\t\t\t}\n\n\t\t\tborder-bottom-width: 0;\n\t\t}\n\n\t\t& .ck-sticky-panel__content_sticky .ck-toolbar {\n\t\t\tborder-bottom-width: 1px;\n\n\t\t\t@mixin ck-rounded-corners {\n\t\t\t\tborder-radius: 0;\n\t\t\t}\n\t\t}\n\t}\n}\n\n/* Note: Use ck-editor__main to make sure these styles don\'t apply to other editor types */\n.ck.ck-editor__main > .ck-editor__editable {\n\t/* https://github.com/ckeditor/ckeditor5-theme-lark/issues/113 */\n\tbackground: var(--ck-color-base-background);\n\n\t@mixin ck-rounded-corners {\n\t\tborder-top-left-radius: 0;\n\t\tborder-top-right-radius: 0;\n\t}\n\n\t&:not(.ck-focused) {\n\t\tborder-color: var(--ck-color-base-border);\n\t}\n}\n',
                  "/*\n * Copyright (c) 2003-2022, CKSource Holding sp. z o.o. All rights reserved.\n * For licensing, see LICENSE.md or https://ckeditor.com/legal/ckeditor-oss-license\n */\n\n/**\n * Implements rounded corner interface for .ck-rounded-corners class.\n *\n * @see $ck-border-radius\n */\n@define-mixin ck-rounded-corners {\n\tborder-radius: 0;\n\n\t@nest .ck-rounded-corners &,\n\t&.ck-rounded-corners {\n\t\tborder-radius: var(--ck-border-radius);\n\t\t@mixin-content;\n\t}\n}\n",
                ],
                sourceRoot: "",
              },
            ]);
            const a = s;
          },
          8894: (t, e, n) => {
            "use strict";
            n.d(e, { Z: () => a });
            var o = n(7537),
              i = n.n(o),
              r = n(3645),
              s = n.n(r)()(i());
            s.push([
              t.id,
              ".ck .ck-placeholder,.ck.ck-placeholder{position:relative}.ck .ck-placeholder:before,.ck.ck-placeholder:before{content:attr(data-placeholder);left:0;pointer-events:none;position:absolute;right:0}.ck.ck-read-only .ck-placeholder:before{display:none}.ck.ck-reset_all .ck-placeholder{position:relative}.ck .ck-placeholder:before,.ck.ck-placeholder:before{color:var(--ck-color-engine-placeholder-text);cursor:text}",
              "",
              {
                version: 3,
                sources: [
                  "webpack://./node_modules/@ckeditor/ckeditor5-engine/theme/placeholder.css",
                  "webpack://./node_modules/@ckeditor/ckeditor5-theme-lark/theme/ckeditor5-engine/placeholder.css",
                ],
                names: [],
                mappings:
                  "AAMA,uCAEC,iBAWD,CATC,qDAIC,8BAA+B,CAF/B,MAAO,CAKP,mBAAoB,CANpB,iBAAkB,CAElB,OAKD,CAKA,wCACC,YACD,CAQD,iCACC,iBACD,CC5BC,qDAEC,6CAA8C,CAD9C,WAED",
                sourcesContent: [
                  "/*\n * Copyright (c) 2003-2022, CKSource Holding sp. z o.o. All rights reserved.\n * For licensing, see LICENSE.md or https://ckeditor.com/legal/ckeditor-oss-license\n */\n\n/* See ckeditor/ckeditor5#936. */\n.ck.ck-placeholder,\n.ck .ck-placeholder {\n\tposition: relative;\n\n\t&::before {\n\t\tposition: absolute;\n\t\tleft: 0;\n\t\tright: 0;\n\t\tcontent: attr(data-placeholder);\n\n\t\t/* See ckeditor/ckeditor5#469. */\n\t\tpointer-events: none;\n\t}\n}\n\n/* See ckeditor/ckeditor5#1987. */\n.ck.ck-read-only .ck-placeholder {\n\t&::before {\n\t\tdisplay: none;\n\t}\n}\n\n/*\n * Rules for the `ck-placeholder` are loaded before the rules for `ck-reset_all` in the base CKEditor 5 DLL build.\n * This fix overwrites the incorrectly set `position: static` from `ck-reset_all`.\n * See https://github.com/ckeditor/ckeditor5/issues/11418.\n */\n.ck.ck-reset_all .ck-placeholder {\n\tposition: relative;\n}\n",
                  "/*\n * Copyright (c) 2003-2022, CKSource Holding sp. z o.o. All rights reserved.\n * For licensing, see LICENSE.md or https://ckeditor.com/legal/ckeditor-oss-license\n */\n\n/* See ckeditor/ckeditor5#936. */\n.ck.ck-placeholder, .ck .ck-placeholder {\n\t&::before {\n\t\tcursor: text;\n\t\tcolor: var(--ck-color-engine-placeholder-text);\n\t}\n}\n",
                ],
                sourceRoot: "",
              },
            ]);
            const a = s;
          },
          4401: (t, e, n) => {
            "use strict";
            n.d(e, { Z: () => a });
            var o = n(7537),
              i = n.n(o),
              r = n(3645),
              s = n.n(r)()(i());
            s.push([
              t.id,
              ".ck.ck-editor__editable span[data-ck-unsafe-element]{display:none}",
              "",
              {
                version: 3,
                sources: [
                  "webpack://./node_modules/@ckeditor/ckeditor5-engine/theme/renderer.css",
                ],
                names: [],
                mappings: "AAMA,qDACC,YACD",
                sourcesContent: [
                  "/*\n * Copyright (c) 2003-2022, CKSource Holding sp. z o.o. All rights reserved.\n * For licensing, see LICENSE.md or https://ckeditor.com/legal/ckeditor-oss-license\n */\n\n/* Elements marked by the Renderer as hidden should be invisible in the editor. */\n.ck.ck-editor__editable span[data-ck-unsafe-element] {\n\tdisplay: none;\n}\n",
                ],
                sourceRoot: "",
              },
            ]);
            const a = s;
          },
          5436: (t, e, n) => {
            "use strict";
            n.d(e, { Z: () => a });
            var o = n(7537),
              i = n.n(o),
              r = n(3645),
              s = n.n(r)()(i());
            s.push([
              t.id,
              ".ck-find-result{background:var(--ck-color-highlight-background);color:var(--ck-color-text)}.ck-find-result_selected{background:#ff9633}",
              "",
              {
                version: 3,
                sources: [
                  "webpack://./node_modules/@ckeditor/ckeditor5-find-and-replace/theme/findandreplace.css",
                ],
                names: [],
                mappings: "AAKA,gBACC,+CAAgD,CAChD,0BACD,CAEA,yBACC,kBACD",
                sourcesContent: [
                  "/*\n * Copyright (c) 2003-2022, CKSource Holding sp. z o.o. All rights reserved.\n * For licensing, see LICENSE.md or https://ckeditor.com/legal/ckeditor-oss-license\n */\n\n.ck-find-result {\n\tbackground: var(--ck-color-highlight-background);\n\tcolor: var(--ck-color-text);\n}\n\n.ck-find-result_selected {\n\tbackground: hsl(29, 100%, 60%);\n}\n",
                ],
                sourceRoot: "",
              },
            ]);
            const a = s;
          },
          9289: (t, e, n) => {
            "use strict";
            n.d(e, { Z: () => a });
            var o = n(7537),
              i = n.n(o),
              r = n(3645),
              s = n.n(r)()(i());
            s.push([
              t.id,
              ".ck.ck-find-and-replace-form{max-width:100%}.ck.ck-find-and-replace-form fieldset{display:flex}.ck.ck-find-and-replace-form fieldset.ck-find-and-replace-form__find .ck-results-counter{position:absolute}.ck.ck-find-and-replace-form{width:400px}.ck.ck-find-and-replace-form:focus{outline:none}.ck.ck-find-and-replace-form fieldset{align-content:stretch;align-items:center;border:0;flex-direction:row;flex-wrap:nowrap;margin:0;padding:var(--ck-spacing-large)}.ck.ck-find-and-replace-form fieldset>.ck-button{flex:0 0 auto}[dir=ltr] .ck.ck-find-and-replace-form fieldset>*+*{margin-left:var(--ck-spacing-standard)}[dir=rtl] .ck.ck-find-and-replace-form fieldset>*+*{margin-right:var(--ck-spacing-standard)}.ck.ck-find-and-replace-form fieldset .ck-labeled-field-view{flex:1 1 auto}.ck.ck-find-and-replace-form fieldset .ck-labeled-field-view .ck-input{min-width:50px;width:100%}.ck.ck-find-and-replace-form fieldset.ck-find-and-replace-form__find{align-items:flex-start}.ck.ck-find-and-replace-form fieldset.ck-find-and-replace-form__find>.ck-button-find{font-weight:700}.ck.ck-find-and-replace-form fieldset.ck-find-and-replace-form__find>.ck-button-find .ck-button__label{padding-left:var(--ck-spacing-large);padding-right:var(--ck-spacing-large)}.ck.ck-find-and-replace-form fieldset.ck-find-and-replace-form__find>.ck-button-prev>.ck-icon{transform:rotate(90deg)}.ck.ck-find-and-replace-form fieldset.ck-find-and-replace-form__find>.ck-button-next>.ck-icon{transform:rotate(-90deg)}.ck.ck-find-and-replace-form fieldset.ck-find-and-replace-form__find .ck-results-counter{top:50%;transform:translateY(-50%)}[dir=ltr] .ck.ck-find-and-replace-form fieldset.ck-find-and-replace-form__find .ck-results-counter{right:var(--ck-spacing-standard)}[dir=rtl] .ck.ck-find-and-replace-form fieldset.ck-find-and-replace-form__find .ck-results-counter{left:var(--ck-spacing-standard)}.ck.ck-find-and-replace-form fieldset.ck-find-and-replace-form__find .ck-results-counter{color:var(--ck-color-base-border)}.ck.ck-find-and-replace-form fieldset.ck-find-and-replace-form__replace{flex-wrap:wrap;justify-content:flex-end;margin-top:calc(var(--ck-spacing-large)*-1)}.ck.ck-find-and-replace-form fieldset.ck-find-and-replace-form__replace>.ck-labeled-field-view{margin-bottom:var(--ck-spacing-large)}.ck.ck-find-and-replace-form fieldset.ck-find-and-replace-form__replace>.ck-options-dropdown{margin-left:0;margin-right:auto}.ck.ck-find-and-replace-form fieldset.ck-find-and-replace-form__replace>.ck-labeled-field-view,.ck.ck-find-and-replace-form fieldset.ck-find-and-replace-form__replace>.ck-labeled-field-view .ck-input{width:100%}@media screen and (max-width:600px){.ck.ck-find-and-replace-form{width:300px}.ck.ck-find-and-replace-form fieldset{flex-wrap:wrap}.ck.ck-find-and-replace-form fieldset.ck-find-and-replace-form__find .ck-labeled-field-view{flex:1 0 auto;margin-bottom:var(--ck-spacing-standard);width:100%}.ck.ck-find-and-replace-form fieldset.ck-find-and-replace-form__find>.ck-button{text-align:center}.ck.ck-find-and-replace-form fieldset.ck-find-and-replace-form__find>.ck-button:first-of-type{flex:1 1 auto}[dir=ltr] .ck.ck-find-and-replace-form fieldset.ck-find-and-replace-form__find>.ck-button:first-of-type{margin-left:0}[dir=rtl] .ck.ck-find-and-replace-form fieldset.ck-find-and-replace-form__find>.ck-button:first-of-type{margin-right:0}.ck.ck-find-and-replace-form fieldset.ck-find-and-replace-form__find>.ck-button:first-of-type .ck-button__label{text-align:center;width:100%}.ck.ck-find-and-replace-form fieldset.ck-find-and-replace-form__replace>:not(.ck-labeled-field-view){flex:1 1 auto}.ck.ck-find-and-replace-form fieldset.ck-find-and-replace-form__replace>.ck-dropdown:not(.ck-labeled-field-view){flex-grow:0}.ck.ck-find-and-replace-form fieldset.ck-find-and-replace-form__replace>.ck-button:not(.ck-labeled-field-view)>.ck-button__label{text-align:center;width:100%}}",
              "",
              {
                version: 3,
                sources: [
                  "webpack://./node_modules/@ckeditor/ckeditor5-find-and-replace/theme/findandreplaceform.css",
                  "webpack://./node_modules/@ckeditor/ckeditor5-theme-lark/theme/ckeditor5-find-and-replace/findandreplaceform.css",
                  "webpack://./node_modules/@ckeditor/ckeditor5-ui/theme/mixins/_rwd.css",
                ],
                names: [],
                mappings:
                  "AAKA,6BACC,cAUD,CARC,sCACC,YAMD,CAHC,yFACC,iBACD,CCNF,6BACC,WAyGD,CAnGC,mCACC,YACD,CAEA,sCAIC,qBAAsB,CADtB,kBAAmB,CAInB,QAAS,CANT,kBAAmB,CACnB,gBAAiB,CAMjB,QAAS,CAFT,+BAwFD,CApFC,iDACC,aACD,CAGC,oDACC,sCACD,CAIA,oDACC,uCACD,CAGD,6DACC,aAMD,CAJC,uEAEC,cAAe,CADf,UAED,CAID,qEAEC,sBAkCD,CAhCC,qFACC,eAOD,CAJC,uGACC,oCAAqC,CACrC,qCACD,CAGD,8FACC,uBACD,CAEA,8FACC,wBACD,CAEA,yFACC,OAAQ,CACR,0BAWD,CAbA,mGAKE,gCAQF,CAbA,mGASE,+BAIF,CAbA,yFAYC,iCACD,CAID,wEACC,cAAe,CACf,wBAAyB,CACzB,2CAeD,CAbC,+FACC,qCACD,CAEA,6FAEC,aAAc,CADd,iBAED,CAEA,wMAEC,UACD,CCzGF,oCD+GA,6BACC,WAiDD,CA/CC,sCACC,cA6CD,CAzCE,4FACC,aAAc,CAEd,wCAAyC,CADzC,UAED,CAEA,gFACC,iBAkBD,CAhBC,8FACC,aAcD,CAfA,wGAIE,aAWF,CAfA,wGAQE,cAOF,CAJC,gHAEC,iBAAkB,CADlB,UAED,CAMH,qGACC,aAUD,CARC,iHACC,WACD,CAEA,iIAEC,iBAAkB,CADlB,UAED,CC5JH",
                sourcesContent: [
                  "/*\n * Copyright (c) 2003-2022, CKSource Holding sp. z o.o. All rights reserved.\n * For licensing, see LICENSE.md or https://ckeditor.com/legal/ckeditor-oss-license\n */\n\n.ck.ck-find-and-replace-form {\n\tmax-width: 100%;\n\n\t& fieldset {\n\t\tdisplay: flex;\n\n\t\t/* The find fieldset */\n\t\t&.ck-find-and-replace-form__find .ck-results-counter {\n\t\t\tposition: absolute;\n\t\t}\n\t}\n}\n",
                  '/*\n * Copyright (c) 2003-2022, CKSource Holding sp. z o.o. All rights reserved.\n * For licensing, see LICENSE.md or https://ckeditor.com/legal/ckeditor-oss-license\n */\n\n@import "@ckeditor/ckeditor5-ui/theme/mixins/_rwd.css";\n@import "@ckeditor/ckeditor5-ui/theme/mixins/_dir.css";\n\n.ck.ck-find-and-replace-form {\n\twidth: 400px;\n\n\t/*\n\t * The <form> needs tabindex="-1" for proper Esc handling after being clicked\n\t * but the side effect is that this creates a nasty focus outline in some browsers.\n\t */\n\t&:focus {\n\t\toutline: none;\n\t}\n\n\t& fieldset {\n\t\tflex-direction: row;\n\t\tflex-wrap: nowrap;\n\t\talign-items: center;\n\t\talign-content: stretch;\n\n\t\tpadding: var(--ck-spacing-large);\n\t\tborder: 0;\n\t\tmargin: 0;\n\n\t\t& > .ck-button {\n\t\t\tflex: 0 0 auto;\n\t\t}\n\n\t\t@mixin ck-dir ltr {\n\t\t\t& > * + * {\n\t\t\t\tmargin-left: var(--ck-spacing-standard);\n\t\t\t}\n\t\t}\n\n\t\t@mixin ck-dir rtl {\n\t\t\t& > * + * {\n\t\t\t\tmargin-right: var(--ck-spacing-standard);\n\t\t\t}\n\t\t}\n\n\t\t& .ck-labeled-field-view {\n\t\t\tflex: 1 1 auto;\n\n\t\t\t& .ck-input {\n\t\t\t\twidth: 100%;\n\t\t\t\tmin-width: 50px;\n\t\t\t}\n\t\t}\n\n\t\t/* The find fieldset */\n\t\t&.ck-find-and-replace-form__find {\n\t\t\t/* To display all controls in line when there\'s an error under the input */\n\t\t\talign-items: flex-start;\n\n\t\t\t& > .ck-button-find {\n\t\t\t\tfont-weight: bold;\n\n\t\t\t\t/* Beef the find button up a little. It\'s the main action button in the form */\n\t\t\t\t& .ck-button__label {\n\t\t\t\t\tpadding-left: var(--ck-spacing-large);\n\t\t\t\t\tpadding-right: var(--ck-spacing-large);\n\t\t\t\t}\n\t\t\t}\n\n\t\t\t& > .ck-button-prev > .ck-icon {\n\t\t\t\ttransform: rotate(90deg);\n\t\t\t}\n\n\t\t\t& > .ck-button-next > .ck-icon {\n\t\t\t\ttransform: rotate(-90deg);\n\t\t\t}\n\n\t\t\t& .ck-results-counter {\n\t\t\t\ttop: 50%;\n\t\t\t\ttransform: translateY(-50%);\n\n\t\t\t\t@mixin ck-dir ltr {\n\t\t\t\t\tright: var(--ck-spacing-standard);\n\t\t\t\t}\n\n\t\t\t\t@mixin ck-dir rtl {\n\t\t\t\t\tleft: var(--ck-spacing-standard);\n\t\t\t\t}\n\n\t\t\t\tcolor: var(--ck-color-base-border);\n\t\t\t}\n\t\t}\n\n\t\t/* The replace fieldset */\n\t\t&.ck-find-and-replace-form__replace {\n\t\t\tflex-wrap: wrap;\n\t\t\tjustify-content: flex-end;\n\t\t\tmargin-top: calc( -1 * var(--ck-spacing-large) );\n\n\t\t\t& > .ck-labeled-field-view {\n\t\t\t\tmargin-bottom: var(--ck-spacing-large);\n\t\t\t}\n\n\t\t\t& > .ck-options-dropdown {\n\t\t\t\tmargin-right: auto;\n\t\t\t\tmargin-left: 0;\n\t\t\t}\n\n\t\t\t& > .ck-labeled-field-view,\n\t\t\t& > .ck-labeled-field-view .ck-input {\n\t\t\t\twidth: 100%;\n\t\t\t}\n\t\t}\n\t}\n}\n\n@mixin ck-media-phone {\n\t.ck.ck-find-and-replace-form {\n\t\twidth: 300px;\n\n\t\t& fieldset {\n\t\t\tflex-wrap: wrap;\n\n\t\t\t/* The find fieldset */\n\t\t\t&.ck-find-and-replace-form__find {\n\t\t\t\t& .ck-labeled-field-view {\n\t\t\t\t\tflex: 1 0 auto;\n\t\t\t\t\twidth: 100%;\n\t\t\t\t\tmargin-bottom: var(--ck-spacing-standard);\n\t\t\t\t}\n\n\t\t\t\t& > .ck-button {\n\t\t\t\t\ttext-align: center;\n\n\t\t\t\t\t&:first-of-type {\n\t\t\t\t\t\tflex: 1 1 auto;\n\n\t\t\t\t\t\t@mixin ck-dir ltr {\n\t\t\t\t\t\t\tmargin-left: 0;\n\t\t\t\t\t\t}\n\n\t\t\t\t\t\t@mixin ck-dir rtl {\n\t\t\t\t\t\t\tmargin-right: 0;\n\t\t\t\t\t\t}\n\n\t\t\t\t\t\t& .ck-button__label {\n\t\t\t\t\t\t\twidth: 100%;\n\t\t\t\t\t\t\ttext-align: center;\n\t\t\t\t\t\t}\n\t\t\t\t\t}\n\t\t\t\t}\n\t\t\t}\n\n\t\t\t/* The replace fieldset */\n\t\t\t&.ck-find-and-replace-form__replace > :not(.ck-labeled-field-view) {\n\t\t\t\tflex: 1 1 auto;\n\n\t\t\t\t&.ck-dropdown {\n\t\t\t\t\tflex-grow: 0;\n\t\t\t\t}\n\n\t\t\t\t&.ck-button > .ck-button__label {\n\t\t\t\t\twidth: 100%;\n\t\t\t\t\ttext-align: center;\n\t\t\t\t}\n\t\t\t}\n\t\t}\n\t}\n}\n',
                  "/*\n * Copyright (c) 2003-2022, CKSource Holding sp. z o.o. All rights reserved.\n * For licensing, see LICENSE.md or https://ckeditor.com/legal/ckeditor-oss-license\n */\n\n@define-mixin ck-media-phone {\n\t@media screen and (max-width: 600px) {\n\t\t@mixin-content;\n\t}\n}\n",
                ],
                sourceRoot: "",
              },
            ]);
            const a = s;
          },
          2585: (t, e, n) => {
            "use strict";
            n.d(e, { Z: () => a });
            var o = n(7537),
              i = n.n(o),
              r = n(3645),
              s = n.n(r)()(i());
            s.push([
              t.id,
              ".ck .ck-button.ck-color-table__remove-color{align-items:center;display:flex;width:100%}label.ck.ck-color-grid__label{font-weight:unset}.ck .ck-button.ck-color-table__remove-color{border-bottom-left-radius:0;border-bottom-right-radius:0;padding:calc(var(--ck-spacing-standard)/2) var(--ck-spacing-standard)}.ck .ck-button.ck-color-table__remove-color:not(:focus){border-bottom:1px solid var(--ck-color-base-border)}[dir=ltr] .ck .ck-button.ck-color-table__remove-color .ck.ck-icon{margin-right:var(--ck-spacing-standard)}[dir=rtl] .ck .ck-button.ck-color-table__remove-color .ck.ck-icon{margin-left:var(--ck-spacing-standard)}",
              "",
              {
                version: 3,
                sources: [
                  "webpack://./node_modules/@ckeditor/ckeditor5-font/theme/fontcolor.css",
                  "webpack://./node_modules/@ckeditor/ckeditor5-theme-lark/theme/ckeditor5-font/fontcolor.css",
                ],
                names: [],
                mappings:
                  "AAKA,4CAEC,kBAAmB,CADnB,YAAa,CAEb,UACD,CAEA,8BACC,iBACD,CCNA,4CAEC,2BAA4B,CAC5B,4BAA6B,CAF7B,qEAiBD,CAbC,wDACC,mDACD,CAEA,kEAEE,uCAMF,CARA,kEAME,sCAEF",
                sourcesContent: [
                  "/*\n * Copyright (c) 2003-2022, CKSource Holding sp. z o.o. All rights reserved.\n * For licensing, see LICENSE.md or https://ckeditor.com/legal/ckeditor-oss-license\n */\n\n.ck .ck-button.ck-color-table__remove-color {\n\tdisplay: flex;\n\talign-items: center;\n\twidth: 100%;\n}\n\nlabel.ck.ck-color-grid__label {\n\tfont-weight: unset;\n}\n",
                  '/*\n * Copyright (c) 2003-2022, CKSource Holding sp. z o.o. All rights reserved.\n * For licensing, see LICENSE.md or https://ckeditor.com/legal/ckeditor-oss-license\n */\n\n@import "@ckeditor/ckeditor5-ui/theme/mixins/_dir.css";\n\n.ck .ck-button.ck-color-table__remove-color {\n\tpadding: calc(var(--ck-spacing-standard) / 2 ) var(--ck-spacing-standard);\n\tborder-bottom-left-radius: 0;\n\tborder-bottom-right-radius: 0;\n\n\t&:not(:focus) {\n\t\tborder-bottom: 1px solid var(--ck-color-base-border);\n\t}\n\n\t& .ck.ck-icon {\n\t\t@mixin ck-dir ltr {\n\t\t\tmargin-right: var(--ck-spacing-standard);\n\t\t}\n\n\t\t@mixin ck-dir rtl {\n\t\t\tmargin-left: var(--ck-spacing-standard);\n\t\t}\n\t}\n}\n\n',
                ],
                sourceRoot: "",
              },
            ]);
            const a = s;
          },
          3230: (t, e, n) => {
            "use strict";
            n.d(e, { Z: () => a });
            var o = n(7537),
              i = n.n(o),
              r = n(3645),
              s = n.n(r)()(i());
            s.push([
              t.id,
              ".ck.ck-heading_heading1{font-size:20px}.ck.ck-heading_heading2{font-size:17px}.ck.ck-heading_heading3{font-size:14px}.ck[class*=ck-heading_heading]{font-weight:700}.ck.ck-dropdown.ck-heading-dropdown .ck-dropdown__button .ck-button__label{width:8em}.ck.ck-dropdown.ck-heading-dropdown .ck-dropdown__panel .ck-list__item{min-width:18em}",
              "",
              {
                version: 3,
                sources: [
                  "webpack://./node_modules/@ckeditor/ckeditor5-heading/theme/heading.css",
                  "webpack://./node_modules/@ckeditor/ckeditor5-theme-lark/theme/ckeditor5-heading/heading.css",
                ],
                names: [],
                mappings:
                  "AAKA,wBACC,cACD,CAEA,wBACC,cACD,CAEA,wBACC,cACD,CAEA,+BACC,eACD,CCZC,2EACC,SACD,CAEA,uEACC,cACD",
                sourcesContent: [
                  '/*\n * Copyright (c) 2003-2022, CKSource Holding sp. z o.o. All rights reserved.\n * For licensing, see LICENSE.md or https://ckeditor.com/legal/ckeditor-oss-license\n */\n\n.ck.ck-heading_heading1 {\n\tfont-size: 20px;\n}\n\n.ck.ck-heading_heading2 {\n\tfont-size: 17px;\n}\n\n.ck.ck-heading_heading3 {\n\tfont-size: 14px;\n}\n\n.ck[class*="ck-heading_heading"] {\n\tfont-weight: bold;\n}\n',
                  "/*\n * Copyright (c) 2003-2022, CKSource Holding sp. z o.o. All rights reserved.\n * For licensing, see LICENSE.md or https://ckeditor.com/legal/ckeditor-oss-license\n */\n\n/* Resize dropdown's button label. */\n.ck.ck-dropdown.ck-heading-dropdown {\n\t& .ck-dropdown__button .ck-button__label {\n\t\twidth: 8em;\n\t}\n\n\t& .ck-dropdown__panel .ck-list__item {\n\t\tmin-width: 18em;\n\t}\n}\n",
                ],
                sourceRoot: "",
              },
            ]);
            const a = s;
          },
          2536: (t, e, n) => {
            "use strict";
            n.d(e, { Z: () => a });
            var o = n(7537),
              i = n.n(o),
              r = n(3645),
              s = n.n(r)()(i());
            s.push([
              t.id,
              ".ck-editor__editable .ck-horizontal-line{display:flow-root}.ck-content hr{background:#dedede;border:0;height:4px;margin:15px 0}",
              "",
              {
                version: 3,
                sources: [
                  "webpack://./node_modules/@ckeditor/ckeditor5-horizontal-line/theme/horizontalline.css",
                ],
                names: [],
                mappings:
                  "AAMA,yCAEC,iBACD,CAEA,eAGC,kBAA2B,CAC3B,QAAS,CAFT,UAAW,CADX,aAID",
                sourcesContent: [
                  "/*\n * Copyright (c) 2003-2022, CKSource Holding sp. z o.o. All rights reserved.\n * For licensing, see LICENSE.md or https://ckeditor.com/legal/ckeditor-oss-license\n */\n\n\n.ck-editor__editable .ck-horizontal-line {\n\t/* Necessary to render properly next to floated objects, e.g. side image case. */\n\tdisplay: flow-root;\n}\n\n.ck-content hr {\n\tmargin: 15px 0;\n\theight: 4px;\n\tbackground: hsl(0, 0%, 87%);\n\tborder: 0;\n}\n",
                ],
                sourceRoot: "",
              },
            ]);
            const a = s;
          },
          3403: (t, e, n) => {
            "use strict";
            n.d(e, { Z: () => a });
            var o = n(7537),
              i = n.n(o),
              r = n(3645),
              s = n.n(r)()(i());
            s.push([
              t.id,
              ".ck-widget.raw-html-embed{display:flow-root;font-style:normal;margin:.9em auto;min-width:15em;position:relative}.ck-widget.raw-html-embed:before{position:absolute;z-index:1}.ck-widget.raw-html-embed .raw-html-embed__buttons-wrapper{display:flex;flex-direction:column;position:absolute}.ck-widget.raw-html-embed .raw-html-embed__preview{display:flex;overflow:hidden;position:relative}.ck-widget.raw-html-embed .raw-html-embed__preview-content{border-collapse:separate;border-spacing:7px;display:table;margin:auto;position:relative;width:100%}.ck-widget.raw-html-embed .raw-html-embed__preview-placeholder{align-items:center;bottom:0;display:flex;justify-content:center;left:0;position:absolute;right:0;top:0}:root{--ck-html-embed-content-width:calc(100% - var(--ck-icon-size)*1.5);--ck-html-embed-source-height:10em;--ck-html-embed-unfocused-outline-width:1px;--ck-html-embed-content-min-height:calc(var(--ck-icon-size) + var(--ck-spacing-standard));--ck-html-embed-source-disabled-background:var(--ck-color-base-foreground);--ck-html-embed-source-disabled-color:#737373}.ck-widget.raw-html-embed{background-color:var(--ck-color-base-foreground);font-size:var(--ck-font-size-base)}.ck-widget.raw-html-embed:not(.ck-widget_selected):not(:hover){outline:var(--ck-html-embed-unfocused-outline-width) dashed var(--ck-color-widget-blurred-border)}.ck-widget.raw-html-embed[dir=ltr]{text-align:left}.ck-widget.raw-html-embed[dir=rtl]{text-align:right}.ck-widget.raw-html-embed:before{background:#999;border-radius:0 0 var(--ck-border-radius) var(--ck-border-radius);color:var(--ck-color-base-background);content:attr(data-html-embed-label);font-family:var(--ck-font-face);font-size:var(--ck-font-size-tiny);left:var(--ck-spacing-standard);padding:calc(var(--ck-spacing-tiny) + var(--ck-html-embed-unfocused-outline-width)) var(--ck-spacing-small) var(--ck-spacing-tiny);top:calc(var(--ck-html-embed-unfocused-outline-width)*-1);transition:background var(--ck-widget-handler-animation-duration) var(--ck-widget-handler-animation-curve)}.ck-widget.raw-html-embed[dir=rtl]:before{left:auto;right:var(--ck-spacing-standard)}.ck-widget.raw-html-embed[dir=ltr] .ck-widget__type-around .ck-widget__type-around__button.ck-widget__type-around__button_before{margin-left:50px}.ck.ck-editor__editable.ck-blurred .ck-widget.raw-html-embed.ck-widget_selected:before{padding:var(--ck-spacing-tiny) var(--ck-spacing-small);top:0}.ck.ck-editor__editable:not(.ck-blurred) .ck-widget.raw-html-embed.ck-widget_selected:before{background:var(--ck-color-focus-border);padding:var(--ck-spacing-tiny) var(--ck-spacing-small);top:0}.ck.ck-editor__editable .ck-widget.raw-html-embed:not(.ck-widget_selected):hover:before{padding:var(--ck-spacing-tiny) var(--ck-spacing-small);top:0}.ck-widget.raw-html-embed .raw-html-embed__content-wrapper{padding:var(--ck-spacing-standard)}.ck-widget.raw-html-embed .raw-html-embed__buttons-wrapper{right:var(--ck-spacing-standard);top:var(--ck-spacing-standard)}.ck-widget.raw-html-embed .raw-html-embed__buttons-wrapper .ck-button.raw-html-embed__save-button{color:var(--ck-color-button-save)}.ck-widget.raw-html-embed .raw-html-embed__buttons-wrapper .ck-button.raw-html-embed__cancel-button{color:var(--ck-color-button-cancel)}.ck-widget.raw-html-embed .raw-html-embed__buttons-wrapper .ck-button:not(:first-child){margin-top:var(--ck-spacing-small)}.ck-widget.raw-html-embed[dir=rtl] .raw-html-embed__buttons-wrapper{left:var(--ck-spacing-standard);right:auto}.ck-widget.raw-html-embed .raw-html-embed__source{box-sizing:border-box;direction:ltr;font-family:monospace;font-size:var(--ck-font-size-base);height:var(--ck-html-embed-source-height);min-width:0;padding:var(--ck-spacing-standard);resize:none;tab-size:4;text-align:left;white-space:pre-wrap;width:var(--ck-html-embed-content-width)}.ck-widget.raw-html-embed .raw-html-embed__source[disabled]{-webkit-text-fill-color:var(--ck-html-embed-source-disabled-color);background:var(--ck-html-embed-source-disabled-background);color:var(--ck-html-embed-source-disabled-color);opacity:1}.ck-widget.raw-html-embed .raw-html-embed__preview{min-height:var(--ck-html-embed-content-min-height);width:var(--ck-html-embed-content-width)}.ck-editor__editable:not(.ck-read-only) .ck-widget.raw-html-embed .raw-html-embed__preview{pointer-events:none}.ck-widget.raw-html-embed .raw-html-embed__preview-content{background-color:var(--ck-color-base-foreground);box-sizing:border-box}.ck-widget.raw-html-embed .raw-html-embed__preview-content>*{margin-left:auto;margin-right:auto}.ck-widget.raw-html-embed .raw-html-embed__preview-placeholder{color:var(--ck-html-embed-source-disabled-color)}",
              "",
              {
                version: 3,
                sources: [
                  "webpack://./node_modules/@ckeditor/ckeditor5-html-embed/theme/htmlembed.css",
                  "webpack://./node_modules/@ckeditor/ckeditor5-theme-lark/theme/ckeditor5-html-embed/htmlembed.css",
                ],
                names: [],
                mappings:
                  "AAMA,0BAMC,iBAAkB,CAOlB,iBAAkB,CATlB,gBAAkB,CAMlB,cAAe,CALf,iBAwDD,CA5CC,iCACC,iBAAkB,CAGlB,SACD,CAKA,2DAEC,YAAa,CACb,qBAAsB,CAFtB,iBAGD,CAEA,mDAGC,YAAa,CADb,eAAgB,CADhB,iBAGD,CAEA,2DAOC,wBAAyB,CACzB,kBAAmB,CAFnB,aAAc,CAHd,WAAY,CADZ,iBAAkB,CADlB,UAQD,CAEA,+DAQC,kBAAmB,CAHnB,QAAS,CAET,YAAa,CAEb,sBAAuB,CAPvB,MAAO,CADP,iBAAkB,CAGlB,OAAQ,CADR,KAOD,CC7DD,MACC,kEAAqE,CACrE,kCAAmC,CACnC,2CAA4C,CAC5C,yFAA0F,CAE1F,0EAA2E,CAC3E,6CACD,CAGA,0BAEC,gDAAiD,CADjD,kCA0ID,CAvIC,+DACC,iGACD,CAGA,mCACC,eACD,CAEA,mCACC,gBACD,CAIA,iCAIC,eAA4B,CAG5B,iEAAkE,CAClE,qCAAsC,CAPtC,mCAAoC,CASpC,+BAAgC,CADhC,kCAAmC,CANnC,+BAAgC,CAGhC,kIAAmI,CAJnI,yDAA4D,CAG5D,0GAMD,CAEA,0CACC,SAAU,CACV,gCACD,CAGA,iIACC,gBACD,CAxCD,uFA4CE,sDAAuD,CADvD,KAgGF,CA3IA,6FAkDE,uCAAwC,CADxC,sDAAuD,CADvD,KA2FF,CA3IA,wFAuDE,sDAAuD,CADvD,KAqFF,CA/EC,2DACC,kCACD,CAGA,2DAEC,gCAAiC,CADjC,8BAcD,CAXC,kGACC,iCACD,CAEA,oGACC,mCACD,CAEA,wFACC,kCACD,CAGD,oEACC,+BAAgC,CAChC,UACD,CAGA,kDACC,qBAAsB,CActB,aAAc,CAPd,qBAAsB,CAGtB,kCAAmC,CATnC,yCAA0C,CAG1C,WAAY,CACZ,kCAAmC,CAFnC,WAAY,CAKZ,UAAW,CAKX,eAAgB,CAJhB,oBAAqB,CAPrB,wCAsBD,CARC,4DAKC,kEAAmE,CAJnE,0DAA2D,CAC3D,gDAAiD,CAIjD,SACD,CAID,mDACC,kDAAmD,CACnD,wCAMD,CARA,2FAME,mBAEF,CAEA,2DAEC,gDAAiD,CADjD,qBAOD,CAJC,6DACC,gBAAiB,CACjB,iBACD,CAGD,+DACC,gDACD",
                sourcesContent: [
                  '/*\n * Copyright (c) 2003-2022, CKSource Holding sp. z o.o. All rights reserved.\n * For licensing, see LICENSE.md or https://ckeditor.com/legal/ckeditor-oss-license\n */\n\n/* The feature container. */\n.ck-widget.raw-html-embed {\n\t/* Give the embed some air. */\n\t/* The first value should be equal to --ck-spacing-large variable if used in the editor context\n\tto avoid the content jumping (See https://github.com/ckeditor/ckeditor5/issues/9825). */\n\tmargin: 0.9em auto;\n\tposition: relative;\n\tdisplay: flow-root;\n\n\t/* Give the html embed some minimal width in the content to prevent them\n\tfrom being "squashed" in tight spaces, e.g. in table cells (https://github.com/ckeditor/ckeditor5/issues/8331) */\n\tmin-width: 15em;\n\n\t/* Don\'t inherit the style, e.g. when in a block quote. */\n\tfont-style: normal;\n\n\t/* ----- Emebed label in the upper left corner ----------------------------------------------- */\n\n\t&::before {\n\t\tposition: absolute;\n\n\t\t/* Make sure the content does not cover the label. */\n\t\tz-index: 1;\n\t}\n\n\t/* ----- Emebed internals --------------------------------------------------------------------- */\n\n\t/* The switch mode button wrapper. */\n\t& .raw-html-embed__buttons-wrapper {\n\t\tposition: absolute;\n\t\tdisplay: flex;\n\t\tflex-direction: column;\n\t}\n\n\t& .raw-html-embed__preview {\n\t\tposition: relative;\n\t\toverflow: hidden;\n\t\tdisplay: flex;\n\t}\n\n\t& .raw-html-embed__preview-content {\n\t\twidth: 100%;\n\t\tposition: relative;\n\t\tmargin: auto;\n\n\t\t/* Gives spacing to the small renderable elements, so they always cover the placeholder. */\n\t\tdisplay: table;\n\t\tborder-collapse: separate;\n\t\tborder-spacing: 7px;\n\t}\n\n\t& .raw-html-embed__preview-placeholder {\n\t\tposition: absolute;\n\t\tleft: 0;\n\t\ttop: 0;\n\t\tright: 0;\n\t\tbottom: 0;\n\n\t\tdisplay: flex;\n\t\talign-items: center;\n\t\tjustify-content: center;\n\t}\n}\n',
                  '/*\n * Copyright (c) 2003-2022, CKSource Holding sp. z o.o. All rights reserved.\n * For licensing, see LICENSE.md or https://ckeditor.com/legal/ckeditor-oss-license\n */\n\n:root {\n\t--ck-html-embed-content-width: calc(100% - 1.5 * var(--ck-icon-size));\n\t--ck-html-embed-source-height: 10em;\n\t--ck-html-embed-unfocused-outline-width: 1px;\n\t--ck-html-embed-content-min-height: calc(var(--ck-icon-size) + var(--ck-spacing-standard));\n\n\t--ck-html-embed-source-disabled-background: var(--ck-color-base-foreground);\n\t--ck-html-embed-source-disabled-color: hsl(0deg 0% 45%);\n}\n\n/* The feature container. */\n.ck-widget.raw-html-embed {\n\tfont-size: var(--ck-font-size-base);\n\tbackground-color: var(--ck-color-base-foreground);\n\n\t&:not(.ck-widget_selected):not(:hover) {\n\t\toutline: var(--ck-html-embed-unfocused-outline-width) dashed var(--ck-color-widget-blurred-border);\n\t}\n\n\t/* HTML embed widget itself should respect UI language direction */\n\t&[dir="ltr"] {\n\t\ttext-align: left;\n\t}\n\n\t&[dir="rtl"] {\n\t\ttext-align: right;\n\t}\n\n\t/* ----- Embed label in the upper left corner ----------------------------------------------- */\n\n\t&::before {\n\t\tcontent: attr(data-html-embed-label);\n\t\ttop: calc(-1 * var(--ck-html-embed-unfocused-outline-width));\n\t\tleft: var(--ck-spacing-standard);\n\t\tbackground: hsl(0deg 0% 60%);\n\t\ttransition: background var(--ck-widget-handler-animation-duration) var(--ck-widget-handler-animation-curve);\n\t\tpadding: calc(var(--ck-spacing-tiny) + var(--ck-html-embed-unfocused-outline-width)) var(--ck-spacing-small) var(--ck-spacing-tiny);\n\t\tborder-radius: 0 0 var(--ck-border-radius) var(--ck-border-radius);\n\t\tcolor: var(--ck-color-base-background);\n\t\tfont-size: var(--ck-font-size-tiny);\n\t\tfont-family: var(--ck-font-face);\n\t}\n\n\t&[dir="rtl"]::before {\n\t\tleft: auto;\n\t\tright: var(--ck-spacing-standard);\n\t}\n\n\t/* Make space for label but it only collides in LTR languages */\n\t&[dir="ltr"] .ck-widget__type-around .ck-widget__type-around__button.ck-widget__type-around__button_before {\n\t\tmargin-left: 50px;\n\t}\n\n\t@nest .ck.ck-editor__editable.ck-blurred &.ck-widget_selected::before {\n\t\ttop: 0px;\n\t\tpadding: var(--ck-spacing-tiny) var(--ck-spacing-small);\n\t}\n\n\t@nest .ck.ck-editor__editable:not(.ck-blurred) &.ck-widget_selected::before {\n\t\ttop: 0;\n\t\tpadding: var(--ck-spacing-tiny) var(--ck-spacing-small);\n\t\tbackground: var(--ck-color-focus-border);\n\t}\n\n\t@nest .ck.ck-editor__editable &:not(.ck-widget_selected):hover::before {\n\t\ttop: 0px;\n\t\tpadding: var(--ck-spacing-tiny) var(--ck-spacing-small);\n\t}\n\n\t/* ----- Emebed internals --------------------------------------------------------------------- */\n\n\t& .raw-html-embed__content-wrapper {\n\t\tpadding: var(--ck-spacing-standard);\n\t}\n\n\t/* The switch mode button wrapper. */\n\t& .raw-html-embed__buttons-wrapper {\n\t\ttop: var(--ck-spacing-standard);\n\t\tright: var(--ck-spacing-standard);\n\n\t\t& .ck-button.raw-html-embed__save-button {\n\t\t\tcolor: var(--ck-color-button-save);\n\t\t}\n\n\t\t& .ck-button.raw-html-embed__cancel-button {\n\t\t\tcolor: var(--ck-color-button-cancel);\n\t\t}\n\n\t\t& .ck-button:not(:first-child) {\n\t\t\tmargin-top: var(--ck-spacing-small);\n\t\t}\n\t}\n\n\t&[dir="rtl"] .raw-html-embed__buttons-wrapper {\n\t\tleft: var(--ck-spacing-standard);\n\t\tright: auto;\n\t}\n\n\t/* The edit source element. */\n\t& .raw-html-embed__source {\n\t\tbox-sizing: border-box;\n\t\theight: var(--ck-html-embed-source-height);\n\t\twidth: var(--ck-html-embed-content-width);\n\t\tresize: none;\n\t\tmin-width: 0;\n\t\tpadding: var(--ck-spacing-standard);\n\n\t\tfont-family: monospace;\n\t\ttab-size: 4;\n\t\twhite-space: pre-wrap;\n\t\tfont-size: var(--ck-font-size-base); /* Safari needs this. */\n\n\t\t/* HTML code is direction–agnostic. */\n\t\ttext-align: left;\n\t\tdirection: ltr;\n\n\t\t&[disabled] {\n\t\t\tbackground: var(--ck-html-embed-source-disabled-background);\n\t\t\tcolor: var(--ck-html-embed-source-disabled-color);\n\n\t\t\t/* Safari needs this for the proper text color in disabled input (https://github.com/ckeditor/ckeditor5/issues/8320). */\n\t\t\t-webkit-text-fill-color: var(--ck-html-embed-source-disabled-color);\n\t\t\topacity: 1;\n\t\t}\n\t}\n\n\t/* The preview data container. */\n\t& .raw-html-embed__preview {\n\t\tmin-height: var(--ck-html-embed-content-min-height);\n\t\twidth: var(--ck-html-embed-content-width);\n\n\t\t/* Disable all mouse interaction as long as the editor is not read–only. */\n\t\t@nest .ck-editor__editable:not(.ck-read-only) & {\n\t\t\tpointer-events: none;\n\t\t}\n\t}\n\n\t& .raw-html-embed__preview-content {\n\t\tbox-sizing: border-box;\n\t\tbackground-color: var(--ck-color-base-foreground);\n\n\t\t& > * {\n\t\t\tmargin-left: auto;\n\t\t\tmargin-right: auto;\n\t\t}\n\t}\n\n\t& .raw-html-embed__preview-placeholder {\n\t\tcolor: var(--ck-html-embed-source-disabled-color)\n\t}\n}\n',
                ],
                sourceRoot: "",
              },
            ]);
            const a = s;
          },
          8468: (t, e, n) => {
            "use strict";
            n.d(e, { Z: () => a });
            var o = n(7537),
              i = n.n(o),
              r = n(3645),
              s = n.n(r)()(i());
            s.push([
              t.id,
              ":root{--ck-html-object-embed-unfocused-outline-width:1px}.ck-widget.html-object-embed{background-color:var(--ck-color-base-foreground);font-size:var(--ck-font-size-base);min-width:calc(76px + var(--ck-spacing-standard));padding:var(--ck-spacing-small);padding-top:calc(var(--ck-font-size-tiny) + var(--ck-spacing-large))}.ck-widget.html-object-embed:not(.ck-widget_selected):not(:hover){outline:var(--ck-html-object-embed-unfocused-outline-width) dashed var(--ck-color-widget-blurred-border)}.ck-widget.html-object-embed:before{background:#999;border-radius:0 0 var(--ck-border-radius) var(--ck-border-radius);color:var(--ck-color-base-background);content:attr(data-html-object-embed-label);font-family:var(--ck-font-face);font-size:var(--ck-font-size-tiny);font-style:normal;font-weight:400;left:var(--ck-spacing-standard);padding:calc(var(--ck-spacing-tiny) + var(--ck-html-object-embed-unfocused-outline-width)) var(--ck-spacing-small) var(--ck-spacing-tiny);position:absolute;top:0;transition:background var(--ck-widget-handler-animation-duration) var(--ck-widget-handler-animation-curve)}.ck-widget.html-object-embed .ck-widget__type-around .ck-widget__type-around__button.ck-widget__type-around__button_before{margin-left:50px}.ck-widget.html-object-embed .html-object-embed__content{pointer-events:none}div.ck-widget.html-object-embed{margin:1em auto}span.ck-widget.html-object-embed{display:inline-block}",
              "",
              {
                version: 3,
                sources: [
                  "webpack://./node_modules/@ckeditor/ckeditor5-html-support/theme/datafilter.css",
                ],
                names: [],
                mappings:
                  "AAKA,MACC,kDACD,CAEA,6BAEC,gDAAiD,CADjD,kCAAmC,CAKnC,iDAAkD,CAHlD,+BAAgC,CAEhC,oEAgCD,CA7BC,kEACC,wGACD,CAEA,oCAOC,eAA4B,CAG5B,iEAAkE,CAClE,qCAAsC,CAPtC,0CAA2C,CAS3C,+BAAgC,CADhC,kCAAmC,CAVnC,iBAAkB,CADlB,eAAmB,CAKnB,+BAAgC,CAGhC,yIAA0I,CAN1I,iBAAkB,CAElB,KAAM,CAGN,0GAMD,CAGA,2HACC,gBACD,CAEA,yDAEC,mBACD,CAGD,gCACC,eACD,CAEA,iCACC,oBACD",
                sourcesContent: [
                  "/*\n * Copyright (c) 2003-2022, CKSource Holding sp. z o.o. All rights reserved.\n * For licensing, see LICENSE.md or https://ckeditor.com/legal/ckeditor-oss-license\n */\n\n:root {\n\t--ck-html-object-embed-unfocused-outline-width: 1px;\n}\n\n.ck-widget.html-object-embed {\n\tfont-size: var(--ck-font-size-base);\n\tbackground-color: var(--ck-color-base-foreground);\n\tpadding: var(--ck-spacing-small);\n\t/* Leave space for label */\n\tpadding-top: calc(var(--ck-font-size-tiny) + var(--ck-spacing-large));\n\tmin-width: calc(76px + var(--ck-spacing-standard));\n\n\t&:not(.ck-widget_selected):not(:hover) {\n\t\toutline: var(--ck-html-object-embed-unfocused-outline-width) dashed var(--ck-color-widget-blurred-border);\n\t}\n\n\t&::before {\n\t\tfont-weight: normal;\n\t\tfont-style: normal;\n\t\tposition: absolute;\n\t\tcontent: attr(data-html-object-embed-label);\n\t\ttop: 0;\n\t\tleft: var(--ck-spacing-standard);\n\t\tbackground: hsl(0deg 0% 60%);\n\t\ttransition: background var(--ck-widget-handler-animation-duration) var(--ck-widget-handler-animation-curve);\n\t\tpadding: calc(var(--ck-spacing-tiny) + var(--ck-html-object-embed-unfocused-outline-width)) var(--ck-spacing-small) var(--ck-spacing-tiny);\n\t\tborder-radius: 0 0 var(--ck-border-radius) var(--ck-border-radius);\n\t\tcolor: var(--ck-color-base-background);\n\t\tfont-size: var(--ck-font-size-tiny);\n\t\tfont-family: var(--ck-font-face);\n\t}\n\n\t/* Make space for label. */\n\t& .ck-widget__type-around .ck-widget__type-around__button.ck-widget__type-around__button_before {\n\t\tmargin-left: 50px;\n\t}\n\n\t& .html-object-embed__content {\n\t\t/* Disable user interaction with embed content */\n\t\tpointer-events: none;\n\t}\n}\n\ndiv.ck-widget.html-object-embed {\n\tmargin: 1em auto;\n}\n\nspan.ck-widget.html-object-embed {\n\tdisplay: inline-block;\n}\n\n",
                ],
                sourceRoot: "",
              },
            ]);
            const a = s;
          },
          9048: (t, e, n) => {
            "use strict";
            n.d(e, { Z: () => a });
            var o = n(7537),
              i = n.n(o),
              r = n(3645),
              s = n.n(r)()(i());
            s.push([
              t.id,
              ".ck-content .image{clear:both;display:table;margin:.9em auto;min-width:50px;text-align:center}.ck-content .image img{display:block;margin:0 auto;max-width:100%;min-width:100%}.ck-content .image-inline{align-items:flex-start;display:inline-flex;max-width:100%}.ck-content .image-inline picture{display:flex}.ck-content .image-inline img,.ck-content .image-inline picture{flex-grow:1;flex-shrink:1;max-width:100%}.ck.ck-editor__editable .image>figcaption.ck-placeholder:before{overflow:hidden;padding-left:inherit;padding-right:inherit;text-overflow:ellipsis;white-space:nowrap}.ck.ck-editor__editable .image-inline.ck-widget_selected,.ck.ck-editor__editable .image.ck-widget_selected{z-index:1}.ck.ck-editor__editable .image-inline.ck-widget_selected ::selection{display:none}.ck.ck-editor__editable td .image-inline img,.ck.ck-editor__editable th .image-inline img{max-width:none}",
              "",
              {
                version: 3,
                sources: [
                  "webpack://./node_modules/@ckeditor/ckeditor5-image/theme/image.css",
                ],
                names: [],
                mappings:
                  "AAMC,mBAEC,UAAW,CADX,aAAc,CAOd,gBAAkB,CAGlB,cAAe,CARf,iBAuBD,CAbC,uBAEC,aAAc,CAGd,aAAc,CAGd,cAAe,CAGf,cACD,CAGD,0BAYC,sBAAuB,CANvB,mBAAoB,CAGpB,cAoBD,CAdC,kCACC,YACD,CAGA,gEAGC,WAAY,CACZ,aAAc,CAGd,cACD,CAUD,gEASC,eAAgB,CARhB,oBAAqB,CACrB,qBAAsB,CAQtB,sBAAuB,CAFvB,kBAGD,CAWA,2GACC,SAUD,CAHC,qEACC,YACD,CAOA,0FACC,cACD",
                sourcesContent: [
                  '/*\n * Copyright (c) 2003-2022, CKSource Holding sp. z o.o. All rights reserved.\n * For licensing, see LICENSE.md or https://ckeditor.com/legal/ckeditor-oss-license\n */\n\n.ck-content {\n\t& .image {\n\t\tdisplay: table;\n\t\tclear: both;\n\t\ttext-align: center;\n\n\t\t/* Make sure there is some space between the content and the image. Center image by default. */\n\t\t/* The first value should be equal to --ck-spacing-large variable if used in the editor context\n\t \tto avoid the content jumping (See https://github.com/ckeditor/ckeditor5/issues/9825). */\n\t\tmargin: 0.9em auto;\n\n\t\t/* Make sure the caption will be displayed properly (See: https://github.com/ckeditor/ckeditor5/issues/1870). */\n\t\tmin-width: 50px;\n\n\t\t& img {\n\t\t\t/* Prevent unnecessary margins caused by line-height (see #44). */\n\t\t\tdisplay: block;\n\n\t\t\t/* Center the image if its width is smaller than the content\'s width. */\n\t\t\tmargin: 0 auto;\n\n\t\t\t/* Make sure the image never exceeds the size of the parent container (ckeditor/ckeditor5-ui#67). */\n\t\t\tmax-width: 100%;\n\n\t\t\t/* Make sure the image is never smaller than the parent container (See: https://github.com/ckeditor/ckeditor5/issues/9300). */\n\t\t\tmin-width: 100%\n\t\t}\n\t}\n\n\t& .image-inline {\n\t\t/*\n\t\t * Normally, the .image-inline would have "display: inline-block" and "img { width: 100% }" (to follow the wrapper while resizing).\n\t\t * Unfortunately, together with "srcset", it gets automatically stretched up to the width of the editing root.\n\t\t * This strange behavior does not happen with inline-flex.\n\t\t */\n\t\tdisplay: inline-flex;\n\n\t\t/* While being resized, don\'t allow the image to exceed the width of the editing root. */\n\t\tmax-width: 100%;\n\n\t\t/* This is required by Safari to resize images in a sensible way. Without this, the browser breaks the ratio. */\n\t\talign-items: flex-start;\n\n\t\t/* When the picture is present it must act as a flex container to let the img resize properly */\n\t\t& picture {\n\t\t\tdisplay: flex;\n\t\t}\n\n\t\t/* When the picture is present, it must act like a resizable img. */\n\t\t& picture,\n\t\t& img {\n\t\t\t/* This is necessary for the img to span the entire .image-inline wrapper and to resize properly. */\n\t\t\tflex-grow: 1;\n\t\t\tflex-shrink: 1;\n\n\t\t\t/* Prevents overflowing the editing root boundaries when an inline image is very wide. */\n\t\t\tmax-width: 100%;\n\t\t}\n\t}\n}\n\n.ck.ck-editor__editable {\n\t/*\n\t * Inhertit the content styles padding of the <figcaption> in case the integration overrides `text-align: center`\n\t * of `.image` (e.g. to the left/right). This ensures the placeholder stays at the padding just like the native\n\t * caret does, and not at the edge of <figcaption>.\n\t */\n\t& .image > figcaption.ck-placeholder::before {\n\t\tpadding-left: inherit;\n\t\tpadding-right: inherit;\n\n\t\t/*\n\t\t * Make sure the image caption placeholder doesn\'t overflow the placeholder area.\n\t\t * See https://github.com/ckeditor/ckeditor5/issues/9162.\n\t\t */\n\t\twhite-space: nowrap;\n\t\toverflow: hidden;\n\t\ttext-overflow: ellipsis;\n\t}\n\n\n\t/*\n\t * Make sure the selected inline image always stays on top of its siblings.\n\t * See https://github.com/ckeditor/ckeditor5/issues/9108.\n\t */\n\t& .image.ck-widget_selected {\n\t\tz-index: 1;\n\t}\n\n\t& .image-inline.ck-widget_selected {\n\t\tz-index: 1;\n\n\t\t/*\n\t\t * Make sure the native browser selection style is not displayed.\n\t\t * Inline image widgets have their own styles for the selected state and\n\t\t * leaving this up to the browser is asking for a visual collision.\n\t\t */\n\t\t& ::selection {\n\t\t\tdisplay: none;\n\t\t}\n\t}\n\n\t/* The inline image nested in the table should have its original size if not resized.\n\tSee https://github.com/ckeditor/ckeditor5/issues/9117. */\n\t& td,\n\t& th {\n\t\t& .image-inline img {\n\t\t\tmax-width: none;\n\t\t}\n\t}\n}\n',
                ],
                sourceRoot: "",
              },
            ]);
            const a = s;
          },
          8662: (t, e, n) => {
            "use strict";
            n.d(e, { Z: () => a });
            var o = n(7537),
              i = n.n(o),
              r = n(3645),
              s = n.n(r)()(i());
            s.push([
              t.id,
              ":root{--ck-color-image-caption-background:#f7f7f7;--ck-color-image-caption-text:#333;--ck-color-image-caption-highligted-background:#fd0}.ck-content .image>figcaption{background-color:var(--ck-color-image-caption-background);caption-side:bottom;color:var(--ck-color-image-caption-text);display:table-caption;font-size:.75em;outline-offset:-1px;padding:.6em;word-break:break-word}.ck.ck-editor__editable .image>figcaption.image__caption_highlighted{animation:ck-image-caption-highlight .6s ease-out}@keyframes ck-image-caption-highlight{0%{background-color:var(--ck-color-image-caption-highligted-background)}to{background-color:var(--ck-color-image-caption-background)}}",
              "",
              {
                version: 3,
                sources: [
                  "webpack://./node_modules/@ckeditor/ckeditor5-image/theme/imagecaption.css",
                ],
                names: [],
                mappings:
                  "AAKA,MACC,2CAAoD,CACpD,kCAA8C,CAC9C,mDACD,CAGA,8BAKC,yDAA0D,CAH1D,mBAAoB,CAEpB,wCAAyC,CAHzC,qBAAsB,CAMtB,eAAgB,CAChB,mBAAoB,CAFpB,YAAa,CAHb,qBAMD,CAGA,qEACC,iDACD,CAEA,sCACC,GACC,oEACD,CAEA,GACC,yDACD,CACD",
                sourcesContent: [
                  "/*\n * Copyright (c) 2003-2022, CKSource Holding sp. z o.o. All rights reserved.\n * For licensing, see LICENSE.md or https://ckeditor.com/legal/ckeditor-oss-license\n */\n\n:root {\n\t--ck-color-image-caption-background: hsl(0, 0%, 97%);\n\t--ck-color-image-caption-text: hsl(0, 0%, 20%);\n\t--ck-color-image-caption-highligted-background: hsl(52deg 100% 50%);\n}\n\n/* Content styles */\n.ck-content .image > figcaption {\n\tdisplay: table-caption;\n\tcaption-side: bottom;\n\tword-break: break-word;\n\tcolor: var(--ck-color-image-caption-text);\n\tbackground-color: var(--ck-color-image-caption-background);\n\tpadding: .6em;\n\tfont-size: .75em;\n\toutline-offset: -1px;\n}\n\n/* Editing styles */\n.ck.ck-editor__editable .image > figcaption.image__caption_highlighted {\n\tanimation: ck-image-caption-highlight .6s ease-out;\n}\n\n@keyframes ck-image-caption-highlight {\n\t0% {\n\t\tbackground-color: var(--ck-color-image-caption-highligted-background);\n\t}\n\n\t100% {\n\t\tbackground-color: var(--ck-color-image-caption-background);\n\t}\n}\n",
                ],
                sourceRoot: "",
              },
            ]);
            const a = s;
          },
          9292: (t, e, n) => {
            "use strict";
            n.d(e, { Z: () => a });
            var o = n(7537),
              i = n.n(o),
              r = n(3645),
              s = n.n(r)()(i());
            s.push([
              t.id,
              ".ck.ck-image-insert__panel{padding:var(--ck-spacing-large)}.ck.ck-image-insert__ck-finder-button{border:1px solid #ccc;border-radius:var(--ck-border-radius);display:block;margin:var(--ck-spacing-standard) auto;width:100%}.ck.ck-splitbutton>.ck-file-dialog-button.ck-button{border:none;margin:0;padding:0}",
              "",
              {
                version: 3,
                sources: [
                  "webpack://./node_modules/@ckeditor/ckeditor5-image/theme/imageinsert.css",
                ],
                names: [],
                mappings:
                  "AAKA,2BACC,+BACD,CAEA,sCAIC,qBAAiC,CACjC,qCAAsC,CAJtC,aAAc,CAEd,sCAAuC,CADvC,UAID,CAGA,oDAGC,WAAY,CADZ,QAAS,CADT,SAGD",
                sourcesContent: [
                  "/*\n * Copyright (c) 2003-2022, CKSource Holding sp. z o.o. All rights reserved.\n * For licensing, see LICENSE.md or https://ckeditor.com/legal/ckeditor-oss-license\n */\n\n.ck.ck-image-insert__panel {\n\tpadding: var(--ck-spacing-large);\n}\n\n.ck.ck-image-insert__ck-finder-button {\n\tdisplay: block;\n\twidth: 100%;\n\tmargin: var(--ck-spacing-standard) auto;\n\tborder: 1px solid hsl(0, 0%, 80%);\n\tborder-radius: var(--ck-border-radius);\n}\n\n/* https://github.com/ckeditor/ckeditor5/issues/7986 */\n.ck.ck-splitbutton > .ck-file-dialog-button.ck-button {\n\tpadding: 0;\n\tmargin: 0;\n\tborder: none;\n}\n",
                ],
                sourceRoot: "",
              },
            ]);
            const a = s;
          },
          5150: (t, e, n) => {
            "use strict";
            n.d(e, { Z: () => a });
            var o = n(7537),
              i = n.n(o),
              r = n(3645),
              s = n.n(r)()(i());
            s.push([
              t.id,
              ".ck.ck-image-insert-form:focus{outline:none}.ck.ck-form__row{display:flex;flex-direction:row;flex-wrap:nowrap;justify-content:space-between}.ck.ck-form__row>:not(.ck-label){flex-grow:1}.ck.ck-form__row.ck-image-insert-form__action-row{margin-top:var(--ck-spacing-standard)}.ck.ck-form__row.ck-image-insert-form__action-row .ck-button-cancel,.ck.ck-form__row.ck-image-insert-form__action-row .ck-button-save{justify-content:center}.ck.ck-form__row.ck-image-insert-form__action-row .ck-button .ck-button__label{color:var(--ck-color-text)}",
              "",
              {
                version: 3,
                sources: [
                  "webpack://./node_modules/@ckeditor/ckeditor5-image/theme/imageinsertformrowview.css",
                ],
                names: [],
                mappings:
                  "AAMC,+BAEC,YACD,CAGD,iBACC,YAAa,CACb,kBAAmB,CACnB,gBAAiB,CACjB,6BAmBD,CAhBC,iCACC,WACD,CAEA,kDACC,qCAUD,CARC,sIAEC,sBACD,CAEA,+EACC,0BACD",
                sourcesContent: [
                  "/*\n * Copyright (c) 2003-2022, CKSource Holding sp. z o.o. All rights reserved.\n * For licensing, see LICENSE.md or https://ckeditor.com/legal/ckeditor-oss-license\n */\n\n.ck.ck-image-insert-form {\n\t&:focus {\n\t\t/* See: https://github.com/ckeditor/ckeditor5/issues/4773 */\n\t\toutline: none;\n\t}\n}\n\n.ck.ck-form__row {\n\tdisplay: flex;\n\tflex-direction: row;\n\tflex-wrap: nowrap;\n\tjustify-content: space-between;\n\n\t/* Ignore labels that work as fieldset legends */\n\t& > *:not(.ck-label) {\n\t\tflex-grow: 1;\n\t}\n\n\t&.ck-image-insert-form__action-row {\n\t\tmargin-top: var(--ck-spacing-standard);\n\n\t\t& .ck-button-save,\n\t\t& .ck-button-cancel {\n\t\t\tjustify-content: center;\n\t\t}\n\n\t\t& .ck-button .ck-button__label {\n\t\t\tcolor: var(--ck-color-text);\n\t\t}\n\t}\n}\n",
                ],
                sourceRoot: "",
              },
            ]);
            const a = s;
          },
          1043: (t, e, n) => {
            "use strict";
            n.d(e, { Z: () => a });
            var o = n(7537),
              i = n.n(o),
              r = n(3645),
              s = n.n(r)()(i());
            s.push([
              t.id,
              ".ck-content .image.image_resized{box-sizing:border-box;display:block;max-width:100%}.ck-content .image.image_resized img{width:100%}.ck-content .image.image_resized>figcaption{display:block}.ck.ck-editor__editable td .image-inline.image_resized img,.ck.ck-editor__editable th .image-inline.image_resized img{max-width:100%}[dir=ltr] .ck.ck-button.ck-button_with-text.ck-resize-image-button .ck-button__icon{margin-right:var(--ck-spacing-standard)}[dir=rtl] .ck.ck-button.ck-button_with-text.ck-resize-image-button .ck-button__icon{margin-left:var(--ck-spacing-standard)}.ck.ck-dropdown .ck-button.ck-resize-image-button .ck-button__label{width:4em}",
              "",
              {
                version: 3,
                sources: [
                  "webpack://./node_modules/@ckeditor/ckeditor5-image/theme/imageresize.css",
                ],
                names: [],
                mappings:
                  "AAKA,iCAQC,qBAAsB,CADtB,aAAc,CANd,cAkBD,CATC,qCAEC,UACD,CAEA,4CAEC,aACD,CAQC,sHACC,cACD,CAIF,oFACC,uCACD,CAEA,oFACC,sCACD,CAEA,oEACC,SACD",
                sourcesContent: [
                  '/*\n * Copyright (c) 2003-2022, CKSource Holding sp. z o.o. All rights reserved.\n * For licensing, see LICENSE.md or https://ckeditor.com/legal/ckeditor-oss-license\n */\n\n.ck-content .image.image_resized {\n\tmax-width: 100%;\n\t/*\n\tThe `<figure>` element for resized images must not use `display:table` as browsers do not support `max-width` for it well.\n\tSee https://stackoverflow.com/questions/4019604/chrome-safari-ignoring-max-width-in-table/14420691#14420691 for more.\n\tFortunately, since we control the width, there is no risk that the image will look bad.\n\t*/\n\tdisplay: block;\n\tbox-sizing: border-box;\n\n\t& img {\n\t\t/* For resized images it is the `<figure>` element that determines the image width. */\n\t\twidth: 100%;\n\t}\n\n\t& > figcaption {\n\t\t/* The `<figure>` element uses `display:block`, so `<figcaption>` also has to. */\n\t\tdisplay: block;\n\t}\n}\n\n.ck.ck-editor__editable {\n\t/* The resized inline image nested in the table should respect its parent size.\n\tSee https://github.com/ckeditor/ckeditor5/issues/9117. */\n\t& td,\n\t& th {\n\t\t& .image-inline.image_resized img {\n\t\t\tmax-width: 100%;\n\t\t}\n\t}\n}\n\n[dir="ltr"] .ck.ck-button.ck-button_with-text.ck-resize-image-button .ck-button__icon {\n\tmargin-right: var(--ck-spacing-standard);\n}\n\n[dir="rtl"] .ck.ck-button.ck-button_with-text.ck-resize-image-button .ck-button__icon {\n\tmargin-left: var(--ck-spacing-standard);\n}\n\n.ck.ck-dropdown .ck-button.ck-resize-image-button .ck-button__label {\n\twidth: 4em;\n}\n',
                ],
                sourceRoot: "",
              },
            ]);
            const a = s;
          },
          4622: (t, e, n) => {
            "use strict";
            n.d(e, { Z: () => a });
            var o = n(7537),
              i = n.n(o),
              r = n(3645),
              s = n.n(r)()(i());
            s.push([
              t.id,
              ":root{--ck-image-style-spacing:1.5em;--ck-inline-image-style-spacing:calc(var(--ck-image-style-spacing)/2)}.ck-content .image-style-block-align-left,.ck-content .image-style-block-align-right{max-width:calc(100% - var(--ck-image-style-spacing))}.ck-content .image-style-align-left,.ck-content .image-style-align-right{clear:none}.ck-content .image-style-side{float:right;margin-left:var(--ck-image-style-spacing);max-width:50%}.ck-content .image-style-align-left{float:left;margin-right:var(--ck-image-style-spacing)}.ck-content .image-style-align-center{margin-left:auto;margin-right:auto}.ck-content .image-style-align-right{float:right;margin-left:var(--ck-image-style-spacing)}.ck-content .image-style-block-align-right{margin-left:auto;margin-right:0}.ck-content .image-style-block-align-left{margin-left:0;margin-right:auto}.ck-content p+.image-style-align-left,.ck-content p+.image-style-align-right,.ck-content p+.image-style-side{margin-top:0}.ck-content .image-inline.image-style-align-left,.ck-content .image-inline.image-style-align-right{margin-bottom:var(--ck-inline-image-style-spacing);margin-top:var(--ck-inline-image-style-spacing)}.ck-content .image-inline.image-style-align-left{margin-right:var(--ck-inline-image-style-spacing)}.ck-content .image-inline.image-style-align-right{margin-left:var(--ck-inline-image-style-spacing)}.ck.ck-splitbutton.ck-splitbutton_flatten.ck-splitbutton_open>.ck-splitbutton__action:not(.ck-disabled),.ck.ck-splitbutton.ck-splitbutton_flatten.ck-splitbutton_open>.ck-splitbutton__arrow:not(.ck-disabled),.ck.ck-splitbutton.ck-splitbutton_flatten.ck-splitbutton_open>.ck-splitbutton__arrow:not(.ck-disabled):not(:hover),.ck.ck-splitbutton.ck-splitbutton_flatten:hover>.ck-splitbutton__action:not(.ck-disabled),.ck.ck-splitbutton.ck-splitbutton_flatten:hover>.ck-splitbutton__arrow:not(.ck-disabled),.ck.ck-splitbutton.ck-splitbutton_flatten:hover>.ck-splitbutton__arrow:not(.ck-disabled):not(:hover){background-color:var(--ck-color-button-on-background)}.ck.ck-splitbutton.ck-splitbutton_flatten.ck-splitbutton_open>.ck-splitbutton__action:not(.ck-disabled):after,.ck.ck-splitbutton.ck-splitbutton_flatten.ck-splitbutton_open>.ck-splitbutton__arrow:not(.ck-disabled):after,.ck.ck-splitbutton.ck-splitbutton_flatten.ck-splitbutton_open>.ck-splitbutton__arrow:not(.ck-disabled):not(:hover):after,.ck.ck-splitbutton.ck-splitbutton_flatten:hover>.ck-splitbutton__action:not(.ck-disabled):after,.ck.ck-splitbutton.ck-splitbutton_flatten:hover>.ck-splitbutton__arrow:not(.ck-disabled):after,.ck.ck-splitbutton.ck-splitbutton_flatten:hover>.ck-splitbutton__arrow:not(.ck-disabled):not(:hover):after{display:none}.ck.ck-splitbutton.ck-splitbutton_flatten.ck-splitbutton_open:hover>.ck-splitbutton__action:not(.ck-disabled),.ck.ck-splitbutton.ck-splitbutton_flatten.ck-splitbutton_open:hover>.ck-splitbutton__arrow:not(.ck-disabled),.ck.ck-splitbutton.ck-splitbutton_flatten.ck-splitbutton_open:hover>.ck-splitbutton__arrow:not(.ck-disabled):not(:hover){background-color:var(--ck-color-button-on-hover-background)}",
              "",
              {
                version: 3,
                sources: [
                  "webpack://./node_modules/@ckeditor/ckeditor5-image/theme/imagestyle.css",
                ],
                names: [],
                mappings:
                  "AAKA,MACC,8BAA+B,CAC/B,qEACD,CAMC,qFAEC,oDACD,CAIA,yEAEC,UACD,CAEA,8BACC,WAAY,CACZ,yCAA0C,CAC1C,aACD,CAEA,oCACC,UAAW,CACX,0CACD,CAEA,sCACC,gBAAiB,CACjB,iBACD,CAEA,qCACC,WAAY,CACZ,yCACD,CAEA,2CAEC,gBAAiB,CADjB,cAED,CAEA,0CACC,aAAc,CACd,iBACD,CAGA,6GAGC,YACD,CAGC,mGAGC,kDAAmD,CADnD,+CAED,CAEA,iDACC,iDACD,CAEA,kDACC,gDACD,CAUC,0lBAGC,qDAKD,CAHC,8nBACC,YACD,CAKD,oVAGC,2DACD",
                sourcesContent: [
                  "/*\n * Copyright (c) 2003-2022, CKSource Holding sp. z o.o. All rights reserved.\n * For licensing, see LICENSE.md or https://ckeditor.com/legal/ckeditor-oss-license\n */\n\n:root {\n\t--ck-image-style-spacing: 1.5em;\n\t--ck-inline-image-style-spacing: calc(var(--ck-image-style-spacing) / 2);\n}\n\n.ck-content {\n\t/* Provides a minimal side margin for the left and right aligned images, so that the user has a visual feedback\n\tconfirming successful application of the style if image width exceeds the editor's size.\n\tSee https://github.com/ckeditor/ckeditor5/issues/9342 */\n\t& .image-style-block-align-left,\n\t& .image-style-block-align-right {\n\t\tmax-width: calc(100% - var(--ck-image-style-spacing));\n\t}\n\n\t/* Allows displaying multiple floating images in the same line.\n\tSee https://github.com/ckeditor/ckeditor5/issues/9183#issuecomment-804988132 */\n\t& .image-style-align-left,\n\t& .image-style-align-right {\n\t\tclear: none;\n\t}\n\n\t& .image-style-side {\n\t\tfloat: right;\n\t\tmargin-left: var(--ck-image-style-spacing);\n\t\tmax-width: 50%;\n\t}\n\n\t& .image-style-align-left {\n\t\tfloat: left;\n\t\tmargin-right: var(--ck-image-style-spacing);\n\t}\n\n\t& .image-style-align-center {\n\t\tmargin-left: auto;\n\t\tmargin-right: auto;\n\t}\n\n\t& .image-style-align-right {\n\t\tfloat: right;\n\t\tmargin-left: var(--ck-image-style-spacing);\n\t}\n\n\t& .image-style-block-align-right {\n\t\tmargin-right: 0;\n\t\tmargin-left: auto;\n\t}\n\n\t& .image-style-block-align-left {\n\t\tmargin-left: 0;\n\t\tmargin-right: auto;\n\t}\n\n\t/* Simulates margin collapsing with the preceding paragraph, which does not work for the floating elements. */\n\t& p + .image-style-align-left,\n\t& p + .image-style-align-right,\n\t& p + .image-style-side {\n\t\tmargin-top: 0;\n\t}\n\n\t& .image-inline {\n\t\t&.image-style-align-left,\n\t\t&.image-style-align-right {\n\t\t\tmargin-top: var(--ck-inline-image-style-spacing);\n\t\t\tmargin-bottom: var(--ck-inline-image-style-spacing);\n\t\t}\n\n\t\t&.image-style-align-left {\n\t\t\tmargin-right: var(--ck-inline-image-style-spacing);\n\t\t}\n\n\t\t&.image-style-align-right {\n\t\t\tmargin-left: var(--ck-inline-image-style-spacing);\n\t\t}\n\t}\n}\n\n.ck.ck-splitbutton {\n\t/* The button should display as a regular drop-down if the action button\n\tis forced to fire the same action as the arrow button. */\n\t&.ck-splitbutton_flatten {\n\t\t&:hover,\n\t\t&.ck-splitbutton_open {\n\t\t\t& > .ck-splitbutton__action:not(.ck-disabled),\n\t\t\t& > .ck-splitbutton__arrow:not(.ck-disabled),\n\t\t\t& > .ck-splitbutton__arrow:not(.ck-disabled):not(:hover) {\n\t\t\t\tbackground-color: var(--ck-color-button-on-background);\n\n\t\t\t\t&::after {\n\t\t\t\t\tdisplay: none;\n\t\t\t\t}\n\t\t\t}\n\t\t}\n\n\t\t&.ck-splitbutton_open:hover {\n\t\t\t& > .ck-splitbutton__action:not(.ck-disabled),\n\t\t\t& > .ck-splitbutton__arrow:not(.ck-disabled),\n\t\t\t& > .ck-splitbutton__arrow:not(.ck-disabled):not(:hover) {\n\t\t\t\tbackground-color: var(--ck-color-button-on-hover-background);\n\t\t\t}\n\t\t}\n\t}\n}\n",
                ],
                sourceRoot: "",
              },
            ]);
            const a = s;
          },
          9899: (t, e, n) => {
            "use strict";
            n.d(e, { Z: () => a });
            var o = n(7537),
              i = n.n(o),
              r = n(3645),
              s = n.n(r)()(i());
            s.push([
              t.id,
              '.ck-image-upload-complete-icon{border-radius:50%;display:block;position:absolute;right:min(var(--ck-spacing-medium),6%);top:min(var(--ck-spacing-medium),6%);z-index:1}.ck-image-upload-complete-icon:after{content:"";position:absolute}:root{--ck-color-image-upload-icon:#fff;--ck-color-image-upload-icon-background:#008a00;--ck-image-upload-icon-size:20;--ck-image-upload-icon-width:2px;--ck-image-upload-icon-is-visible:clamp(0px,100% - 50px,1px)}.ck-image-upload-complete-icon{animation-delay:0ms,3s;animation-duration:.5s,.5s;animation-fill-mode:forwards,forwards;animation-name:ck-upload-complete-icon-show,ck-upload-complete-icon-hide;background:var(--ck-color-image-upload-icon-background);font-size:calc(1px*var(--ck-image-upload-icon-size));height:calc(var(--ck-image-upload-icon-is-visible)*var(--ck-image-upload-icon-size));opacity:0;overflow:hidden;width:calc(var(--ck-image-upload-icon-is-visible)*var(--ck-image-upload-icon-size))}.ck-image-upload-complete-icon:after{animation-delay:.5s;animation-duration:.5s;animation-fill-mode:forwards;animation-name:ck-upload-complete-icon-check;border-right:var(--ck-image-upload-icon-width) solid var(--ck-color-image-upload-icon);border-top:var(--ck-image-upload-icon-width) solid var(--ck-color-image-upload-icon);box-sizing:border-box;height:0;left:25%;opacity:0;top:50%;transform:scaleX(-1) rotate(135deg);transform-origin:left top;width:0}@keyframes ck-upload-complete-icon-show{0%{opacity:0}to{opacity:1}}@keyframes ck-upload-complete-icon-hide{0%{opacity:1}to{opacity:0}}@keyframes ck-upload-complete-icon-check{0%{height:0;opacity:1;width:0}33%{height:0;width:.3em}to{height:.45em;opacity:1;width:.3em}}',
              "",
              {
                version: 3,
                sources: [
                  "webpack://./node_modules/@ckeditor/ckeditor5-image/theme/imageuploadicon.css",
                  "webpack://./node_modules/@ckeditor/ckeditor5-theme-lark/theme/ckeditor5-image/imageuploadicon.css",
                ],
                names: [],
                mappings:
                  "AAKA,+BAUC,iBAAkB,CATlB,aAAc,CACd,iBAAkB,CAOlB,sCAAwC,CADxC,oCAAsC,CAGtC,SAMD,CAJC,qCACC,UAAW,CACX,iBACD,CChBD,MACC,iCAA8C,CAC9C,+CAA4D,CAG5D,8BAA+B,CAC/B,gCAAiC,CACjC,4DACD,CAEA,+BAWC,sBAA4B,CAN5B,0BAAgC,CADhC,qCAAuC,CADvC,wEAA0E,CAD1E,uDAAwD,CAMxD,oDAAuD,CAWvD,oFAAuF,CAlBvF,SAAU,CAgBV,eAAgB,CAChB,mFA0BD,CAtBC,qCAgBC,mBAAsB,CADtB,sBAAyB,CAEzB,4BAA6B,CAH7B,4CAA6C,CAF7C,sFAAuF,CADvF,oFAAqF,CASrF,qBAAsB,CAdtB,QAAS,CAJT,QAAS,CAGT,SAAU,CADV,OAAQ,CAKR,mCAAoC,CACpC,yBAA0B,CAH1B,OAcD,CAGD,wCACC,GACC,SACD,CAEA,GACC,SACD,CACD,CAEA,wCACC,GACC,SACD,CAEA,GACC,SACD,CACD,CAEA,yCACC,GAGC,QAAS,CAFT,SAAU,CACV,OAED,CACA,IAEC,QAAS,CADT,UAED,CACA,GAGC,YAAc,CAFd,SAAU,CACV,UAED,CACD",
                sourcesContent: [
                  '/*\n * Copyright (c) 2003-2022, CKSource Holding sp. z o.o. All rights reserved.\n * For licensing, see LICENSE.md or https://ckeditor.com/legal/ckeditor-oss-license\n */\n\n.ck-image-upload-complete-icon {\n\tdisplay: block;\n\tposition: absolute;\n\n\t/*\n\t * Smaller images should have the icon closer to the border.\n\t * Match the icon position with the linked image indicator brought by the link image feature.\n\t */\n\ttop: min(var(--ck-spacing-medium), 6%);\n\tright: min(var(--ck-spacing-medium), 6%);\n\tborder-radius: 50%;\n\tz-index: 1;\n\n\t&::after {\n\t\tcontent: "";\n\t\tposition: absolute;\n\t}\n}\n',
                  '/*\n * Copyright (c) 2003-2022, CKSource Holding sp. z o.o. All rights reserved.\n * For licensing, see LICENSE.md or https://ckeditor.com/legal/ckeditor-oss-license\n */\n\n:root {\n\t--ck-color-image-upload-icon: hsl(0, 0%, 100%);\n\t--ck-color-image-upload-icon-background: hsl(120, 100%, 27%);\n\n\t/* Match the icon size with the linked image indicator brought by the link image feature. */\n\t--ck-image-upload-icon-size: 20;\n\t--ck-image-upload-icon-width: 2px;\n\t--ck-image-upload-icon-is-visible: clamp(0px, 100% - 50px, 1px);\n}\n\n.ck-image-upload-complete-icon {\n\topacity: 0;\n\tbackground: var(--ck-color-image-upload-icon-background);\n\tanimation-name: ck-upload-complete-icon-show, ck-upload-complete-icon-hide;\n\tanimation-fill-mode: forwards, forwards;\n\tanimation-duration: 500ms, 500ms;\n\n\t/* To make animation scalable. */\n\tfont-size: calc(1px * var(--ck-image-upload-icon-size));\n\n\t/* Hide completed upload icon after 3 seconds. */\n\tanimation-delay: 0ms, 3000ms;\n\n\t/*\n\t * Use CSS math to simulate container queries.\n\t * https://css-tricks.com/the-raven-technique-one-step-closer-to-container-queries/#what-about-showing-and-hiding-things\n\t */\n\toverflow: hidden;\n\twidth: calc(var(--ck-image-upload-icon-is-visible) * var(--ck-image-upload-icon-size));\n\theight: calc(var(--ck-image-upload-icon-is-visible) * var(--ck-image-upload-icon-size));\n\n\t/* This is check icon element made from border-width mixed with animations. */\n\t&::after {\n\t\t/* Because of border transformation we need to "hard code" left position. */\n\t\tleft: 25%;\n\n\t\ttop: 50%;\n\t\topacity: 0;\n\t\theight: 0;\n\t\twidth: 0;\n\n\t\ttransform: scaleX(-1) rotate(135deg);\n\t\ttransform-origin: left top;\n\t\tborder-top: var(--ck-image-upload-icon-width) solid var(--ck-color-image-upload-icon);\n\t\tborder-right: var(--ck-image-upload-icon-width) solid var(--ck-color-image-upload-icon);\n\n\t\tanimation-name: ck-upload-complete-icon-check;\n\t\tanimation-duration: 500ms;\n\t\tanimation-delay: 500ms;\n\t\tanimation-fill-mode: forwards;\n\n\t\t/* #1095. While reset is not providing proper box-sizing for pseudoelements, we need to handle it. */\n\t\tbox-sizing: border-box;\n\t}\n}\n\n@keyframes ck-upload-complete-icon-show {\n\tfrom {\n\t\topacity: 0;\n\t}\n\n\tto {\n\t\topacity: 1;\n\t}\n}\n\n@keyframes ck-upload-complete-icon-hide {\n\tfrom {\n\t\topacity: 1;\n\t}\n\n\tto {\n\t\topacity: 0;\n\t}\n}\n\n@keyframes ck-upload-complete-icon-check {\n\t0% {\n\t\topacity: 1;\n\t\twidth: 0;\n\t\theight: 0;\n\t}\n\t33% {\n\t\twidth: 0.3em;\n\t\theight: 0;\n\t}\n\t100% {\n\t\topacity: 1;\n\t\twidth: 0.3em;\n\t\theight: 0.45em;\n\t}\n}\n',
                ],
                sourceRoot: "",
              },
            ]);
            const a = s;
          },
          9825: (t, e, n) => {
            "use strict";
            n.d(e, { Z: () => a });
            var o = n(7537),
              i = n.n(o),
              r = n(3645),
              s = n.n(r)()(i());
            s.push([
              t.id,
              '.ck .ck-upload-placeholder-loader{align-items:center;display:flex;justify-content:center;left:0;position:absolute;top:0}.ck .ck-upload-placeholder-loader:before{content:"";position:relative}:root{--ck-color-upload-placeholder-loader:#b3b3b3;--ck-upload-placeholder-loader-size:32px;--ck-upload-placeholder-image-aspect-ratio:2.8}.ck .ck-image-upload-placeholder{margin:0;width:100%}.ck .ck-image-upload-placeholder.image-inline{width:calc(var(--ck-upload-placeholder-loader-size)*2*var(--ck-upload-placeholder-image-aspect-ratio))}.ck .ck-image-upload-placeholder img{aspect-ratio:var(--ck-upload-placeholder-image-aspect-ratio)}.ck .ck-upload-placeholder-loader{height:100%;width:100%}.ck .ck-upload-placeholder-loader:before{animation:ck-upload-placeholder-loader 1s linear infinite;border-radius:50%;border-right:2px solid transparent;border-top:3px solid var(--ck-color-upload-placeholder-loader);height:var(--ck-upload-placeholder-loader-size);width:var(--ck-upload-placeholder-loader-size)}@keyframes ck-upload-placeholder-loader{to{transform:rotate(1turn)}}',
              "",
              {
                version: 3,
                sources: [
                  "webpack://./node_modules/@ckeditor/ckeditor5-image/theme/imageuploadloader.css",
                  "webpack://./node_modules/@ckeditor/ckeditor5-theme-lark/theme/ckeditor5-image/imageuploadloader.css",
                ],
                names: [],
                mappings:
                  "AAKA,kCAGC,kBAAmB,CADnB,YAAa,CAEb,sBAAuB,CAEvB,MAAO,CALP,iBAAkB,CAIlB,KAOD,CAJC,yCACC,UAAW,CACX,iBACD,CCXD,MACC,4CAAqD,CACrD,wCAAyC,CACzC,8CACD,CAEA,iCAGC,QAAS,CADT,UAgBD,CAbC,8CACC,sGACD,CAEA,qCAOC,4DACD,CAGD,kCAEC,WAAY,CADZ,UAWD,CARC,yCAMC,yDAA0D,CAH1D,iBAAkB,CAElB,kCAAmC,CADnC,8DAA+D,CAF/D,+CAAgD,CADhD,8CAMD,CAGD,wCACC,GACC,uBACD,CACD",
                sourcesContent: [
                  "/*\n * Copyright (c) 2003-2022, CKSource Holding sp. z o.o. All rights reserved.\n * For licensing, see LICENSE.md or https://ckeditor.com/legal/ckeditor-oss-license\n */\n\n.ck .ck-upload-placeholder-loader {\n\tposition: absolute;\n\tdisplay: flex;\n\talign-items: center;\n\tjustify-content: center;\n\ttop: 0;\n\tleft: 0;\n\n\t&::before {\n\t\tcontent: '';\n\t\tposition: relative;\n\t}\n}\n",
                  "/*\n * Copyright (c) 2003-2022, CKSource Holding sp. z o.o. All rights reserved.\n * For licensing, see LICENSE.md or https://ckeditor.com/legal/ckeditor-oss-license\n */\n\n:root {\n\t--ck-color-upload-placeholder-loader: hsl(0, 0%, 70%);\n\t--ck-upload-placeholder-loader-size: 32px;\n\t--ck-upload-placeholder-image-aspect-ratio: 2.8;\n}\n\n.ck .ck-image-upload-placeholder {\n\t/* We need to control the full width of the SVG gray background. */\n\twidth: 100%;\n\tmargin: 0;\n\n\t&.image-inline {\n\t\twidth: calc( 2 * var(--ck-upload-placeholder-loader-size) * var(--ck-upload-placeholder-image-aspect-ratio) );\n\t}\n\n\t& img {\n\t\t/*\n\t\t * This is an arbitrary aspect for a 1x1 px GIF to display to the user. Not too tall, not too short.\n\t\t * There's nothing special about this number except that it should make the image placeholder look like\n\t\t * a real image during this short period after the upload started and before the image was read from the\n\t\t * file system (and a rich preview was loaded).\n\t\t */\n\t\taspect-ratio: var(--ck-upload-placeholder-image-aspect-ratio);\n\t}\n}\n\n.ck .ck-upload-placeholder-loader {\n\twidth: 100%;\n\theight: 100%;\n\n\t&::before {\n\t\twidth: var(--ck-upload-placeholder-loader-size);\n\t\theight: var(--ck-upload-placeholder-loader-size);\n\t\tborder-radius: 50%;\n\t\tborder-top: 3px solid var(--ck-color-upload-placeholder-loader);\n\t\tborder-right: 2px solid transparent;\n\t\tanimation: ck-upload-placeholder-loader 1s linear infinite;\n\t}\n}\n\n@keyframes ck-upload-placeholder-loader {\n\tto {\n\t\ttransform: rotate( 360deg );\n\t}\n}\n",
                ],
                sourceRoot: "",
              },
            ]);
            const a = s;
          },
          5870: (t, e, n) => {
            "use strict";
            n.d(e, { Z: () => a });
            var o = n(7537),
              i = n.n(o),
              r = n(3645),
              s = n.n(r)()(i());
            s.push([
              t.id,
              ".ck.ck-editor__editable .image,.ck.ck-editor__editable .image-inline{position:relative}.ck.ck-editor__editable .image .ck-progress-bar,.ck.ck-editor__editable .image-inline .ck-progress-bar{left:0;position:absolute;top:0}.ck.ck-editor__editable .image-inline.ck-appear,.ck.ck-editor__editable .image.ck-appear{animation:fadeIn .7s}.ck.ck-editor__editable .image .ck-progress-bar,.ck.ck-editor__editable .image-inline .ck-progress-bar{background:var(--ck-color-upload-bar-background);height:2px;transition:width .1s;width:0}@keyframes fadeIn{0%{opacity:0}to{opacity:1}}",
              "",
              {
                version: 3,
                sources: [
                  "webpack://./node_modules/@ckeditor/ckeditor5-image/theme/imageuploadprogress.css",
                  "webpack://./node_modules/@ckeditor/ckeditor5-theme-lark/theme/ckeditor5-image/imageuploadprogress.css",
                ],
                names: [],
                mappings:
                  "AAMC,qEAEC,iBACD,CAGA,uGAIC,MAAO,CAFP,iBAAkB,CAClB,KAED,CCRC,yFACC,oBACD,CAID,uGAIC,gDAAiD,CAFjD,UAAW,CAGX,oBAAuB,CAFvB,OAGD,CAGD,kBACC,GAAO,SAAY,CACnB,GAAO,SAAY,CACpB",
                sourcesContent: [
                  "/*\n * Copyright (c) 2003-2022, CKSource Holding sp. z o.o. All rights reserved.\n * For licensing, see LICENSE.md or https://ckeditor.com/legal/ckeditor-oss-license\n */\n\n.ck.ck-editor__editable {\n\t& .image,\n\t& .image-inline {\n\t\tposition: relative;\n\t}\n\n\t/* Upload progress bar. */\n\t& .image .ck-progress-bar,\n\t& .image-inline .ck-progress-bar {\n\t\tposition: absolute;\n\t\ttop: 0;\n\t\tleft: 0;\n\t}\n}\n",
                  "/*\n * Copyright (c) 2003-2022, CKSource Holding sp. z o.o. All rights reserved.\n * For licensing, see LICENSE.md or https://ckeditor.com/legal/ckeditor-oss-license\n */\n\n.ck.ck-editor__editable {\n\t& .image,\n\t& .image-inline {\n\t\t/* Showing animation. */\n\t\t&.ck-appear {\n\t\t\tanimation: fadeIn 700ms;\n\t\t}\n\t}\n\n\t/* Upload progress bar. */\n\t& .image .ck-progress-bar,\n\t& .image-inline .ck-progress-bar {\n\t\theight: 2px;\n\t\twidth: 0;\n\t\tbackground: var(--ck-color-upload-bar-background);\n\t\ttransition: width 100ms;\n\t}\n}\n\n@keyframes fadeIn {\n\tfrom { opacity: 0; }\n\tto   { opacity: 1; }\n}\n",
                ],
                sourceRoot: "",
              },
            ]);
            const a = s;
          },
          6831: (t, e, n) => {
            "use strict";
            n.d(e, { Z: () => a });
            var o = n(7537),
              i = n.n(o),
              r = n(3645),
              s = n.n(r)()(i());
            s.push([
              t.id,
              ".ck.ck-text-alternative-form{display:flex;flex-direction:row;flex-wrap:nowrap}.ck.ck-text-alternative-form .ck-labeled-field-view{display:inline-block}.ck.ck-text-alternative-form .ck-label{display:none}@media screen and (max-width:600px){.ck.ck-text-alternative-form{flex-wrap:wrap}.ck.ck-text-alternative-form .ck-labeled-field-view{flex-basis:100%}.ck.ck-text-alternative-form .ck-button{flex-basis:50%}}",
              "",
              {
                version: 3,
                sources: [
                  "webpack://./node_modules/@ckeditor/ckeditor5-image/theme/textalternativeform.css",
                  "webpack://./node_modules/@ckeditor/ckeditor5-ui/theme/mixins/_rwd.css",
                ],
                names: [],
                mappings:
                  "AAOA,6BACC,YAAa,CACb,kBAAmB,CACnB,gBAqBD,CAnBC,oDACC,oBACD,CAEA,uCACC,YACD,CCZA,oCDCD,6BAcE,cAUF,CARE,oDACC,eACD,CAEA,wCACC,cACD,CCrBD",
                sourcesContent: [
                  '/*\n * Copyright (c) 2003-2022, CKSource Holding sp. z o.o. All rights reserved.\n * For licensing, see LICENSE.md or https://ckeditor.com/legal/ckeditor-oss-license\n */\n\n@import "@ckeditor/ckeditor5-ui/theme/mixins/_rwd.css";\n\n.ck.ck-text-alternative-form {\n\tdisplay: flex;\n\tflex-direction: row;\n\tflex-wrap: nowrap;\n\n\t& .ck-labeled-field-view {\n\t\tdisplay: inline-block;\n\t}\n\n\t& .ck-label {\n\t\tdisplay: none;\n\t}\n\n\t@mixin ck-media-phone {\n\t\tflex-wrap: wrap;\n\n\t\t& .ck-labeled-field-view {\n\t\t\tflex-basis: 100%;\n\t\t}\n\n\t\t& .ck-button {\n\t\t\tflex-basis: 50%;\n\t\t}\n\t}\n}\n',
                  "/*\n * Copyright (c) 2003-2022, CKSource Holding sp. z o.o. All rights reserved.\n * For licensing, see LICENSE.md or https://ckeditor.com/legal/ckeditor-oss-license\n */\n\n@define-mixin ck-media-phone {\n\t@media screen and (max-width: 600px) {\n\t\t@mixin-content;\n\t}\n}\n",
                ],
                sourceRoot: "",
              },
            ]);
            const a = s;
          },
          399: (t, e, n) => {
            "use strict";
            n.d(e, { Z: () => a });
            var o = n(7537),
              i = n.n(o),
              r = n(3645),
              s = n.n(r)()(i());
            s.push([
              t.id,
              ".ck .ck-link_selected{background:var(--ck-color-link-selected-background)}.ck .ck-link_selected span.image-inline{outline:var(--ck-widget-outline-thickness) solid var(--ck-color-link-selected-background)}.ck .ck-fake-link-selection{background:var(--ck-color-link-fake-selection)}.ck .ck-fake-link-selection_collapsed{border-right:1px solid var(--ck-color-base-text);height:100%;margin-right:-1px;outline:1px solid hsla(0,0%,100%,.5)}",
              "",
              {
                version: 3,
                sources: [
                  "webpack://./node_modules/@ckeditor/ckeditor5-theme-lark/theme/ckeditor5-link/link.css",
                ],
                names: [],
                mappings:
                  "AAMA,sBACC,mDAMD,CAHC,wCACC,yFACD,CAOD,4BACC,8CACD,CAGA,sCAEC,gDAAiD,CADjD,WAAY,CAEZ,iBAAkB,CAClB,oCACD",
                sourcesContent: [
                  '/*\n * Copyright (c) 2003-2022, CKSource Holding sp. z o.o. All rights reserved.\n * For licensing, see LICENSE.md or https://ckeditor.com/legal/ckeditor-oss-license\n */\n\n/* Class added to span element surrounding currently selected link. */\n.ck .ck-link_selected {\n\tbackground: var(--ck-color-link-selected-background);\n\n\t/* Give linked inline images some outline to let the user know they are also part of the link. */\n\t& span.image-inline {\n\t\toutline: var(--ck-widget-outline-thickness) solid var(--ck-color-link-selected-background);\n\t}\n}\n\n/*\n * Classes used by the "fake visual selection" displayed in the content when an input\n * in the link UI has focus (the browser does not render the native selection in this state).\n */\n.ck .ck-fake-link-selection {\n\tbackground: var(--ck-color-link-fake-selection);\n}\n\n/* A collapsed fake visual selection. */\n.ck .ck-fake-link-selection_collapsed {\n\theight: 100%;\n\tborder-right: 1px solid var(--ck-color-base-text);\n\tmargin-right: -1px;\n\toutline: solid 1px hsla(0, 0%, 100%, .5);\n}\n',
                ],
                sourceRoot: "",
              },
            ]);
            const a = s;
          },
          9465: (t, e, n) => {
            "use strict";
            n.d(e, { Z: () => a });
            var o = n(7537),
              i = n.n(o),
              r = n(3645),
              s = n.n(r)()(i());
            s.push([
              t.id,
              ".ck.ck-link-actions{display:flex;flex-direction:row;flex-wrap:nowrap}.ck.ck-link-actions .ck-link-actions__preview{display:inline-block}.ck.ck-link-actions .ck-link-actions__preview .ck-button__label{overflow:hidden}@media screen and (max-width:600px){.ck.ck-link-actions{flex-wrap:wrap}.ck.ck-link-actions .ck-link-actions__preview{flex-basis:100%}.ck.ck-link-actions .ck-button:not(.ck-link-actions__preview){flex-basis:50%}}.ck.ck-link-actions .ck-button.ck-link-actions__preview{padding-left:0;padding-right:0}.ck.ck-link-actions .ck-button.ck-link-actions__preview .ck-button__label{color:var(--ck-color-link-default);cursor:pointer;max-width:var(--ck-input-width);min-width:3em;padding:0 var(--ck-spacing-medium);text-align:center;text-overflow:ellipsis}.ck.ck-link-actions .ck-button.ck-link-actions__preview .ck-button__label:hover{text-decoration:underline}.ck.ck-link-actions .ck-button.ck-link-actions__preview,.ck.ck-link-actions .ck-button.ck-link-actions__preview:active,.ck.ck-link-actions .ck-button.ck-link-actions__preview:focus,.ck.ck-link-actions .ck-button.ck-link-actions__preview:hover{background:none}.ck.ck-link-actions .ck-button.ck-link-actions__preview:active{box-shadow:none}.ck.ck-link-actions .ck-button.ck-link-actions__preview:focus .ck-button__label{text-decoration:underline}[dir=ltr] .ck.ck-link-actions .ck-button:not(:first-child),[dir=rtl] .ck.ck-link-actions .ck-button:not(:last-child){margin-left:var(--ck-spacing-standard)}@media screen and (max-width:600px){.ck.ck-link-actions .ck-button.ck-link-actions__preview{margin:var(--ck-spacing-standard) var(--ck-spacing-standard) 0}.ck.ck-link-actions .ck-button.ck-link-actions__preview .ck-button__label{max-width:100%;min-width:0}[dir=ltr] .ck.ck-link-actions .ck-button:not(.ck-link-actions__preview),[dir=rtl] .ck.ck-link-actions .ck-button:not(.ck-link-actions__preview){margin-left:0}}",
              "",
              {
                version: 3,
                sources: [
                  "webpack://./node_modules/@ckeditor/ckeditor5-link/theme/linkactions.css",
                  "webpack://./node_modules/@ckeditor/ckeditor5-ui/theme/mixins/_rwd.css",
                  "webpack://./node_modules/@ckeditor/ckeditor5-theme-lark/theme/ckeditor5-link/linkactions.css",
                ],
                names: [],
                mappings:
                  "AAOA,oBACC,YAAa,CACb,kBAAmB,CACnB,gBAqBD,CAnBC,8CACC,oBAKD,CAHC,gEACC,eACD,CCXD,oCDCD,oBAcE,cAUF,CARE,8CACC,eACD,CAEA,8DACC,cACD,CCrBD,CCIA,wDACC,cAAe,CACf,eAmCD,CAjCC,0EAEC,kCAAmC,CAEnC,cAAe,CAIf,+BAAgC,CAChC,aAAc,CARd,kCAAmC,CASnC,iBAAkB,CAPlB,sBAYD,CAHC,gFACC,yBACD,CAGD,mPAIC,eACD,CAEA,+DACC,eACD,CAGC,gFACC,yBACD,CAWD,qHACC,sCACD,CDtDD,oCC0DC,wDACC,8DAMD,CAJC,0EAEC,cAAe,CADf,WAED,CAGD,gJAME,aAEF,CDzED",
                sourcesContent: [
                  '/*\n * Copyright (c) 2003-2022, CKSource Holding sp. z o.o. All rights reserved.\n * For licensing, see LICENSE.md or https://ckeditor.com/legal/ckeditor-oss-license\n */\n\n@import "@ckeditor/ckeditor5-ui/theme/mixins/_rwd.css";\n\n.ck.ck-link-actions {\n\tdisplay: flex;\n\tflex-direction: row;\n\tflex-wrap: nowrap;\n\n\t& .ck-link-actions__preview {\n\t\tdisplay: inline-block;\n\n\t\t& .ck-button__label {\n\t\t\toverflow: hidden;\n\t\t}\n\t}\n\n\t@mixin ck-media-phone {\n\t\tflex-wrap: wrap;\n\n\t\t& .ck-link-actions__preview {\n\t\t\tflex-basis: 100%;\n\t\t}\n\n\t\t& .ck-button:not(.ck-link-actions__preview) {\n\t\t\tflex-basis: 50%;\n\t\t}\n\t}\n}\n',
                  "/*\n * Copyright (c) 2003-2022, CKSource Holding sp. z o.o. All rights reserved.\n * For licensing, see LICENSE.md or https://ckeditor.com/legal/ckeditor-oss-license\n */\n\n@define-mixin ck-media-phone {\n\t@media screen and (max-width: 600px) {\n\t\t@mixin-content;\n\t}\n}\n",
                  '/*\n * Copyright (c) 2003-2022, CKSource Holding sp. z o.o. All rights reserved.\n * For licensing, see LICENSE.md or https://ckeditor.com/legal/ckeditor-oss-license\n */\n\n@import "@ckeditor/ckeditor5-ui/theme/mixins/_unselectable.css";\n@import "@ckeditor/ckeditor5-ui/theme/mixins/_dir.css";\n@import "../mixins/_focus.css";\n@import "../mixins/_shadow.css";\n@import "@ckeditor/ckeditor5-ui/theme/mixins/_rwd.css";\n\n.ck.ck-link-actions {\n\t& .ck-button.ck-link-actions__preview {\n\t\tpadding-left: 0;\n\t\tpadding-right: 0;\n\n\t\t& .ck-button__label {\n\t\t\tpadding: 0 var(--ck-spacing-medium);\n\t\t\tcolor: var(--ck-color-link-default);\n\t\t\ttext-overflow: ellipsis;\n\t\t\tcursor: pointer;\n\n\t\t\t/* Match the box model of the link editor form\'s input so the balloon\n\t\t\tdoes not change width when moving between actions and the form. */\n\t\t\tmax-width: var(--ck-input-width);\n\t\t\tmin-width: 3em;\n\t\t\ttext-align: center;\n\n\t\t\t&:hover {\n\t\t\t\ttext-decoration: underline;\n\t\t\t}\n\t\t}\n\n\t\t&,\n\t\t&:hover,\n\t\t&:focus,\n\t\t&:active {\n\t\t\tbackground: none;\n\t\t}\n\n\t\t&:active {\n\t\t\tbox-shadow: none;\n\t\t}\n\n\t\t&:focus {\n\t\t\t& .ck-button__label {\n\t\t\t\ttext-decoration: underline;\n\t\t\t}\n\t\t}\n\t}\n\n\t@mixin ck-dir ltr {\n\t\t& .ck-button:not(:first-child) {\n\t\t\tmargin-left: var(--ck-spacing-standard);\n\t\t}\n\t}\n\n\t@mixin ck-dir rtl {\n\t\t& .ck-button:not(:last-child) {\n\t\t\tmargin-left: var(--ck-spacing-standard);\n\t\t}\n\t}\n\n\t@mixin ck-media-phone {\n\t\t& .ck-button.ck-link-actions__preview {\n\t\t\tmargin: var(--ck-spacing-standard) var(--ck-spacing-standard) 0;\n\n\t\t\t& .ck-button__label {\n\t\t\t\tmin-width: 0;\n\t\t\t\tmax-width: 100%;\n\t\t\t}\n\t\t}\n\n\t\t& .ck-button:not(.ck-link-actions__preview) {\n\t\t\t@mixin ck-dir ltr {\n\t\t\t\tmargin-left: 0;\n\t\t\t}\n\n\t\t\t@mixin ck-dir rtl {\n\t\t\t\tmargin-left: 0;\n\t\t\t}\n\t\t}\n\t}\n}\n',
                ],
                sourceRoot: "",
              },
            ]);
            const a = s;
          },
          4827: (t, e, n) => {
            "use strict";
            n.d(e, { Z: () => a });
            var o = n(7537),
              i = n.n(o),
              r = n(3645),
              s = n.n(r)()(i());
            s.push([
              t.id,
              ".ck.ck-link-form{display:flex}.ck.ck-link-form .ck-label{display:none}@media screen and (max-width:600px){.ck.ck-link-form{flex-wrap:wrap}.ck.ck-link-form .ck-labeled-field-view{flex-basis:100%}.ck.ck-link-form .ck-button{flex-basis:50%}}.ck.ck-link-form_layout-vertical{display:block}.ck.ck-link-form_layout-vertical .ck-button.ck-button-cancel,.ck.ck-link-form_layout-vertical .ck-button.ck-button-save{margin-top:var(--ck-spacing-medium)}.ck.ck-link-form_layout-vertical{min-width:var(--ck-input-width);padding:0}.ck.ck-link-form_layout-vertical .ck-labeled-field-view{margin:var(--ck-spacing-large) var(--ck-spacing-large) var(--ck-spacing-small)}.ck.ck-link-form_layout-vertical .ck-labeled-field-view .ck-input-text{min-width:0;width:100%}.ck.ck-link-form_layout-vertical>.ck-button{border-radius:0;margin:0;padding:var(--ck-spacing-standard);width:50%}.ck.ck-link-form_layout-vertical>.ck-button:not(:focus){border-top:1px solid var(--ck-color-base-border)}[dir=ltr] .ck.ck-link-form_layout-vertical>.ck-button,[dir=rtl] .ck.ck-link-form_layout-vertical>.ck-button{margin-left:0}[dir=rtl] .ck.ck-link-form_layout-vertical>.ck-button:last-of-type{border-right:1px solid var(--ck-color-base-border)}.ck.ck-link-form_layout-vertical .ck.ck-list{margin:var(--ck-spacing-standard) var(--ck-spacing-large)}.ck.ck-link-form_layout-vertical .ck.ck-list .ck-button.ck-switchbutton{padding:0;width:100%}.ck.ck-link-form_layout-vertical .ck.ck-list .ck-button.ck-switchbutton:hover{background:none}",
              "",
              {
                version: 3,
                sources: [
                  "webpack://./node_modules/@ckeditor/ckeditor5-link/theme/linkform.css",
                  "webpack://./node_modules/@ckeditor/ckeditor5-ui/theme/mixins/_rwd.css",
                  "webpack://./node_modules/@ckeditor/ckeditor5-theme-lark/theme/ckeditor5-link/linkform.css",
                ],
                names: [],
                mappings:
                  "AAOA,iBACC,YAiBD,CAfC,2BACC,YACD,CCNA,oCDCD,iBAQE,cAUF,CARE,wCACC,eACD,CAEA,4BACC,cACD,CCfD,CDuBD,iCACC,aAYD,CALE,wHAEC,mCACD,CE/BF,iCAEC,+BAAgC,CADhC,SAgDD,CA7CC,wDACC,8EAMD,CAJC,uEACC,WAAY,CACZ,UACD,CAGD,4CAIC,eAAgB,CAFhB,QAAS,CADT,kCAAmC,CAEnC,SAkBD,CAfC,wDACC,gDACD,CARD,4GAeE,aAMF,CAJE,mEACC,kDACD,CAKF,6CACC,yDAUD,CARC,wEACC,SAAU,CACV,UAKD,CAHC,8EACC,eACD",
                sourcesContent: [
                  '/*\n * Copyright (c) 2003-2022, CKSource Holding sp. z o.o. All rights reserved.\n * For licensing, see LICENSE.md or https://ckeditor.com/legal/ckeditor-oss-license\n */\n\n@import "@ckeditor/ckeditor5-ui/theme/mixins/_rwd.css";\n\n.ck.ck-link-form {\n\tdisplay: flex;\n\n\t& .ck-label {\n\t\tdisplay: none;\n\t}\n\n\t@mixin ck-media-phone {\n\t\tflex-wrap: wrap;\n\n\t\t& .ck-labeled-field-view {\n\t\t\tflex-basis: 100%;\n\t\t}\n\n\t\t& .ck-button {\n\t\t\tflex-basis: 50%;\n\t\t}\n\t}\n}\n\n/*\n * Style link form differently when manual decorators are available.\n * See: https://github.com/ckeditor/ckeditor5-link/issues/186.\n */\n.ck.ck-link-form_layout-vertical {\n\tdisplay: block;\n\n\t/*\n\t * Whether the form is in the responsive mode or not, if there are decorator buttons\n\t * keep the top margin of action buttons medium.\n\t */\n\t& .ck-button {\n\t\t&.ck-button-save,\n\t\t&.ck-button-cancel {\n\t\t\tmargin-top: var(--ck-spacing-medium);\n\t\t}\n\t}\n}\n',
                  "/*\n * Copyright (c) 2003-2022, CKSource Holding sp. z o.o. All rights reserved.\n * For licensing, see LICENSE.md or https://ckeditor.com/legal/ckeditor-oss-license\n */\n\n@define-mixin ck-media-phone {\n\t@media screen and (max-width: 600px) {\n\t\t@mixin-content;\n\t}\n}\n",
                  '/*\n * Copyright (c) 2003-2022, CKSource Holding sp. z o.o. All rights reserved.\n * For licensing, see LICENSE.md or https://ckeditor.com/legal/ckeditor-oss-license\n */\n\n@import "@ckeditor/ckeditor5-ui/theme/mixins/_dir.css";\n\n/*\n * Style link form differently when manual decorators are available.\n * See: https://github.com/ckeditor/ckeditor5-link/issues/186.\n */\n.ck.ck-link-form_layout-vertical {\n\tpadding: 0;\n\tmin-width: var(--ck-input-width);\n\n\t& .ck-labeled-field-view {\n\t\tmargin: var(--ck-spacing-large) var(--ck-spacing-large) var(--ck-spacing-small);\n\n\t\t& .ck-input-text {\n\t\t\tmin-width: 0;\n\t\t\twidth: 100%;\n\t\t}\n\t}\n\n\t& > .ck-button {\n\t\tpadding: var(--ck-spacing-standard);\n\t\tmargin: 0;\n\t\twidth: 50%;\n\t\tborder-radius: 0;\n\n\t\t&:not(:focus) {\n\t\t\tborder-top: 1px solid var(--ck-color-base-border);\n\t\t}\n\n\t\t@mixin ck-dir ltr {\n\t\t\tmargin-left: 0;\n\t\t}\n\n\t\t@mixin ck-dir rtl {\n\t\t\tmargin-left: 0;\n\n\t\t\t&:last-of-type {\n\t\t\t\tborder-right: 1px solid var(--ck-color-base-border);\n\t\t\t}\n\t\t}\n\t}\n\n\t/* Using additional `.ck` class for stronger CSS specificity than `.ck.ck-link-form > :not(:first-child)`. */\n\t& .ck.ck-list {\n\t\tmargin: var(--ck-spacing-standard) var(--ck-spacing-large);\n\n\t\t& .ck-button.ck-switchbutton {\n\t\t\tpadding: 0;\n\t\t\twidth: 100%;\n\n\t\t\t&:hover {\n\t\t\t\tbackground: none;\n\t\t\t}\n\t\t}\n\t}\n}\n',
                ],
                sourceRoot: "",
              },
            ]);
            const a = s;
          },
          3858: (t, e, n) => {
            "use strict";
            n.d(e, { Z: () => h });
            var o = n(7537),
              i = n.n(o),
              r = n(3645),
              s = n.n(r),
              a = n(1667),
              l = n.n(a),
              c = new URL(n(8491), n.b),
              d = s()(i()),
              u = l()(c);
            d.push([
              t.id,
              ".ck.ck-editor__editable a span.image-inline:after,.ck.ck-editor__editable figure.image>a:after{display:block;position:absolute}:root{--ck-link-image-indicator-icon-size:20;--ck-link-image-indicator-icon-is-visible:clamp(0px,100% - 50px,1px)}.ck.ck-editor__editable a span.image-inline:after,.ck.ck-editor__editable figure.image>a:after{background-color:rgba(0,0,0,.4);background-image:url(" +
                u +
                ');background-position:50%;background-repeat:no-repeat;background-size:14px;border-radius:100%;content:"";height:calc(var(--ck-link-image-indicator-icon-is-visible)*var(--ck-link-image-indicator-icon-size));overflow:hidden;right:min(var(--ck-spacing-medium),6%);top:min(var(--ck-spacing-medium),6%);width:calc(var(--ck-link-image-indicator-icon-is-visible)*var(--ck-link-image-indicator-icon-size))}',
              "",
              {
                version: 3,
                sources: [
                  "webpack://./node_modules/@ckeditor/ckeditor5-link/theme/linkimage.css",
                  "webpack://./node_modules/@ckeditor/ckeditor5-theme-lark/theme/ckeditor5-link/linkimage.css",
                ],
                names: [],
                mappings:
                  "AASE,+FACC,aAAc,CACd,iBACD,CCPF,MAEC,sCAAuC,CACvC,oEACD,CAME,+FAUC,+BAAqC,CACrC,wDAA+3B,CAG/3B,uBAA2B,CAD3B,2BAA4B,CAD5B,oBAAqB,CAGrB,kBAAmB,CAdnB,UAAW,CAsBX,oGAAuG,CAFvG,eAAgB,CAbhB,sCAAwC,CADxC,oCAAsC,CAetC,mGAED",
                sourcesContent: [
                  "/*\n * Copyright (c) 2003-2022, CKSource Holding sp. z o.o. All rights reserved.\n * For licensing, see LICENSE.md or https://ckeditor.com/legal/ckeditor-oss-license\n */\n\n.ck.ck-editor__editable {\n\t/* Linked image indicator */\n\t& figure.image > a,\n\t& a span.image-inline {\n\t\t&::after {\n\t\t\tdisplay: block;\n\t\t\tposition: absolute;\n\t\t}\n\t}\n}\n\n",
                  '/*\n * Copyright (c) 2003-2022, CKSource Holding sp. z o.o. All rights reserved.\n * For licensing, see LICENSE.md or https://ckeditor.com/legal/ckeditor-oss-license\n */\n\n:root {\n\t/* Match the icon size with the upload indicator brought by the image upload feature. */\n\t--ck-link-image-indicator-icon-size: 20;\n\t--ck-link-image-indicator-icon-is-visible: clamp(0px, 100% - 50px, 1px);\n}\n\n.ck.ck-editor__editable {\n\t/* Linked image indicator */\n\t& figure.image > a,\n\t& a span.image-inline {\n\t\t&::after {\n\t\t\tcontent: "";\n\n\t\t\t/*\n\t\t\t * Smaller images should have the icon closer to the border.\n\t\t\t * Match the icon position with the upload indicator brought by the image upload feature.\n\t\t\t */\n\t\t\ttop: min(var(--ck-spacing-medium), 6%);\n\t\t\tright: min(var(--ck-spacing-medium), 6%);\n\n\t\t\tbackground-color: hsla(0, 0%, 0%, .4);\n\t\t\tbackground-image: url("data:image/svg+xml;base64,PHN2ZyB2aWV3Qm94PSIwIDAgMjAgMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+PHBhdGggZmlsbD0iI2ZmZiIgZD0ibTExLjA3NyAxNSAuOTkxLTEuNDE2YS43NS43NSAwIDEgMSAxLjIyOS44NmwtMS4xNDggMS42NGEuNzQ4Ljc0OCAwIDAgMS0uMjE3LjIwNiA1LjI1MSA1LjI1MSAwIDAgMS04LjUwMy01Ljk1NS43NDEuNzQxIDAgMCAxIC4xMi0uMjc0bDEuMTQ3LTEuNjM5YS43NS43NSAwIDEgMSAxLjIyOC44Nkw0LjkzMyAxMC43bC4wMDYuMDAzYTMuNzUgMy43NSAwIDAgMCA2LjEzMiA0LjI5NGwuMDA2LjAwNHptNS40OTQtNS4zMzVhLjc0OC43NDggMCAwIDEtLjEyLjI3NGwtMS4xNDcgMS42MzlhLjc1Ljc1IDAgMSAxLTEuMjI4LS44NmwuODYtMS4yM2EzLjc1IDMuNzUgMCAwIDAtNi4xNDQtNC4zMDFsLS44NiAxLjIyOWEuNzUuNzUgMCAwIDEtMS4yMjktLjg2bDEuMTQ4LTEuNjRhLjc0OC43NDggMCAwIDEgLjIxNy0uMjA2IDUuMjUxIDUuMjUxIDAgMCAxIDguNTAzIDUuOTU1em0tNC41NjMtMi41MzJhLjc1Ljc1IDAgMCAxIC4xODQgMS4wNDVsLTMuMTU1IDQuNTA1YS43NS43NSAwIDEgMS0xLjIyOS0uODZsMy4xNTUtNC41MDZhLjc1Ljc1IDAgMCAxIDEuMDQ1LS4xODR6Ii8+PC9zdmc+");\n\t\t\tbackground-size: 14px;\n\t\t\tbackground-repeat: no-repeat;\n\t\t\tbackground-position: center;\n\t\t\tborder-radius: 100%;\n\n\t\t\t/*\n\t\t\t* Use CSS math to simulate container queries.\n\t\t\t* https://css-tricks.com/the-raven-technique-one-step-closer-to-container-queries/#what-about-showing-and-hiding-things\n\t\t\t*/\n\t\t\toverflow: hidden;\n\t\t\twidth: calc(var(--ck-link-image-indicator-icon-is-visible) * var(--ck-link-image-indicator-icon-size));\n\t\t\theight: calc(var(--ck-link-image-indicator-icon-is-visible) * var(--ck-link-image-indicator-icon-size));\n\t\t}\n\t}\n}\n\n',
                ],
                sourceRoot: "",
              },
            ]);
            const h = d;
          },
          5777: (t, e, n) => {
            "use strict";
            n.d(e, { Z: () => a });
            var o = n(7537),
              i = n.n(o),
              r = n(3645),
              s = n.n(r)()(i());
            s.push([
              t.id,
              ".ck-content .media{clear:both;display:block;margin:.9em 0;min-width:15em}",
              "",
              {
                version: 3,
                sources: [
                  "webpack://./node_modules/@ckeditor/ckeditor5-media-embed/theme/mediaembed.css",
                ],
                names: [],
                mappings: "AAKA,mBAGC,UAAW,CASX,aAAc,CAJd,aAAe,CAQf,cACD",
                sourcesContent: [
                  '/*\n * Copyright (c) 2003-2022, CKSource Holding sp. z o.o. All rights reserved.\n * For licensing, see LICENSE.md or https://ckeditor.com/legal/ckeditor-oss-license\n */\n\n.ck-content .media {\n\t/* Don\'t allow floated content overlap the media.\n\thttps://github.com/ckeditor/ckeditor5-media-embed/issues/53 */\n\tclear: both;\n\n\t/* Make sure there is some space between the content and the media. */\n\t/* The first value should be equal to --ck-spacing-large variable if used in the editor context\n\tto avoid the content jumping (See https://github.com/ckeditor/ckeditor5/issues/9825). */\n\tmargin: 0.9em 0;\n\n\t/* Make sure media is not overriden with Bootstrap default `flex` value.\n\tSee: https://github.com/ckeditor/ckeditor5/issues/1373. */\n\tdisplay: block;\n\n\t/* Give the media some minimal width in the content to prevent them\n\tfrom being "squashed" in tight spaces, e.g. in table cells (#44) */\n\tmin-width: 15em;\n}\n',
                ],
                sourceRoot: "",
              },
            ]);
            const a = s;
          },
          952: (t, e, n) => {
            "use strict";
            n.d(e, { Z: () => b });
            var o = n(7537),
              i = n.n(o),
              r = n(3645),
              s = n.n(r),
              a = n(1667),
              l = n.n(a),
              c = new URL(n(4493), n.b),
              d = new URL(n(2739), n.b),
              u = new URL(n(6631), n.b),
              h = new URL(n(7511), n.b),
              m = s()(i()),
              g = l()(c),
              p = l()(d),
              f = l()(u),
              k = l()(h);
            m.push([
              t.id,
              '.ck-media__wrapper .ck-media__placeholder{align-items:center;display:flex;flex-direction:column}.ck-media__wrapper .ck-media__placeholder .ck-media__placeholder__url{max-width:100%;position:relative}.ck-media__wrapper .ck-media__placeholder .ck-media__placeholder__url .ck-media__placeholder__url__text{display:block;overflow:hidden}.ck-media__wrapper[data-oembed-url*="facebook.com"] .ck-media__placeholder__icon *,.ck-media__wrapper[data-oembed-url*="goo.gl/maps"] .ck-media__placeholder__icon *,.ck-media__wrapper[data-oembed-url*="google.com/maps"] .ck-media__placeholder__icon *,.ck-media__wrapper[data-oembed-url*="instagram.com"] .ck-media__placeholder__icon *,.ck-media__wrapper[data-oembed-url*="maps.app.goo.gl"] .ck-media__placeholder__icon *,.ck-media__wrapper[data-oembed-url*="maps.google.com"] .ck-media__placeholder__icon *,.ck-media__wrapper[data-oembed-url*="twitter.com"] .ck-media__placeholder__icon *{display:none}.ck-editor__editable:not(.ck-read-only) .ck-media__wrapper>:not(.ck-media__placeholder),.ck-editor__editable:not(.ck-read-only) .ck-widget:not(.ck-widget_selected) .ck-media__placeholder{pointer-events:none}:root{--ck-media-embed-placeholder-icon-size:3em;--ck-color-media-embed-placeholder-url-text:#757575;--ck-color-media-embed-placeholder-url-text-hover:var(--ck-color-base-text)}.ck-media__wrapper{margin:0 auto}.ck-media__wrapper .ck-media__placeholder{background:var(--ck-color-base-foreground);padding:calc(var(--ck-spacing-standard)*3)}.ck-media__wrapper .ck-media__placeholder .ck-media__placeholder__icon{background-position:50%;background-size:cover;height:var(--ck-media-embed-placeholder-icon-size);margin-bottom:var(--ck-spacing-large);min-width:var(--ck-media-embed-placeholder-icon-size)}.ck-media__wrapper .ck-media__placeholder .ck-media__placeholder__icon .ck-icon{height:100%;width:100%}.ck-media__wrapper .ck-media__placeholder .ck-media__placeholder__url__text{color:var(--ck-color-media-embed-placeholder-url-text);font-style:italic;text-align:center;text-overflow:ellipsis;white-space:nowrap}.ck-media__wrapper .ck-media__placeholder .ck-media__placeholder__url__text:hover{color:var(--ck-color-media-embed-placeholder-url-text-hover);cursor:pointer;text-decoration:underline}.ck-media__wrapper[data-oembed-url*="open.spotify.com"]{max-height:380px;max-width:300px}.ck-media__wrapper[data-oembed-url*="goo.gl/maps"] .ck-media__placeholder__icon,.ck-media__wrapper[data-oembed-url*="google.com/maps"] .ck-media__placeholder__icon,.ck-media__wrapper[data-oembed-url*="maps.app.goo.gl"] .ck-media__placeholder__icon,.ck-media__wrapper[data-oembed-url*="maps.google.com"] .ck-media__placeholder__icon{background-image:url(' +
                g +
                ')}.ck-media__wrapper[data-oembed-url*="facebook.com"] .ck-media__placeholder{background:#4268b3}.ck-media__wrapper[data-oembed-url*="facebook.com"] .ck-media__placeholder .ck-media__placeholder__icon{background-image:url(' +
                p +
                ')}.ck-media__wrapper[data-oembed-url*="facebook.com"] .ck-media__placeholder .ck-media__placeholder__url__text{color:#cdf}.ck-media__wrapper[data-oembed-url*="facebook.com"] .ck-media__placeholder .ck-media__placeholder__url__text:hover{color:#fff}.ck-media__wrapper[data-oembed-url*="instagram.com"] .ck-media__placeholder{background:linear-gradient(-135deg,#1400c7,#b800b1,#f50000)}.ck-media__wrapper[data-oembed-url*="instagram.com"] .ck-media__placeholder .ck-media__placeholder__icon{background-image:url(' +
                f +
                ')}.ck-media__wrapper[data-oembed-url*="instagram.com"] .ck-media__placeholder .ck-media__placeholder__url__text{color:#ffe0fe}.ck-media__wrapper[data-oembed-url*="instagram.com"] .ck-media__placeholder .ck-media__placeholder__url__text:hover{color:#fff}.ck-media__wrapper[data-oembed-url*="twitter.com"] .ck.ck-media__placeholder{background:linear-gradient(90deg,#71c6f4,#0d70a5)}.ck-media__wrapper[data-oembed-url*="twitter.com"] .ck.ck-media__placeholder .ck-media__placeholder__icon{background-image:url(' +
                k +
                ')}.ck-media__wrapper[data-oembed-url*="twitter.com"] .ck.ck-media__placeholder .ck-media__placeholder__url__text{color:#b8e6ff}.ck-media__wrapper[data-oembed-url*="twitter.com"] .ck.ck-media__placeholder .ck-media__placeholder__url__text:hover{color:#fff}',
              "",
              {
                version: 3,
                sources: [
                  "webpack://./node_modules/@ckeditor/ckeditor5-media-embed/theme/mediaembedediting.css",
                  "webpack://./node_modules/@ckeditor/ckeditor5-theme-lark/theme/ckeditor5-media-embed/mediaembedediting.css",
                ],
                names: [],
                mappings:
                  "AAMC,0CAGC,kBAAmB,CAFnB,YAAa,CACb,qBAcD,CAXC,sEAEC,cAAe,CAEf,iBAMD,CAJC,wGAEC,aAAc,CADd,eAED,CAWD,6kBACC,YACD,CAYF,2LACC,mBACD,CC1CA,MACC,0CAA2C,CAE3C,mDAA4D,CAC5D,2EACD,CAEA,mBACC,aA+FD,CA7FC,0CAEC,0CAA2C,CAD3C,0CA6BD,CA1BC,uEAIC,uBAA2B,CAC3B,qBAAsB,CAHtB,kDAAmD,CACnD,qCAAsC,CAFtC,qDAUD,CAJC,gFAEC,WAAY,CADZ,UAED,CAGD,4EACC,sDAAuD,CAGvD,iBAAkB,CADlB,iBAAkB,CAElB,sBAAuB,CAHvB,kBAUD,CALC,kFACC,4DAA6D,CAC7D,cAAe,CACf,yBACD,CAIF,wDAEC,gBAAiB,CADjB,eAED,CAEA,4UAIC,wDACD,CAEA,2EACC,kBAaD,CAXC,wGACC,wDACD,CAEA,6GACC,UAKD,CAHC,mHACC,UACD,CAIF,4EACC,2DAcD,CAZC,yGACC,wDACD,CAGA,8GACC,aAKD,CAHC,oHACC,UACD,CAIF,6EAEC,iDAaD,CAXC,0GACC,wDACD,CAEA,+GACC,aAKD,CAHC,qHACC,UACD",
                sourcesContent: [
                  '/*\n * Copyright (c) 2003-2022, CKSource Holding sp. z o.o. All rights reserved.\n * For licensing, see LICENSE.md or https://ckeditor.com/legal/ckeditor-oss-license\n */\n\n.ck-media__wrapper {\n\t& .ck-media__placeholder {\n\t\tdisplay: flex;\n\t\tflex-direction: column;\n\t\talign-items: center;\n\n\t\t& .ck-media__placeholder__url {\n\t\t\t/* Otherwise the URL will overflow when the content is very narrow. */\n\t\t\tmax-width: 100%;\n\n\t\t\tposition: relative;\n\n\t\t\t& .ck-media__placeholder__url__text {\n\t\t\t\toverflow: hidden;\n\t\t\t\tdisplay: block;\n\t\t\t}\n\t\t}\n\t}\n\n\t&[data-oembed-url*="twitter.com"],\n\t&[data-oembed-url*="google.com/maps"],\n\t&[data-oembed-url*="goo.gl/maps"],\n\t&[data-oembed-url*="maps.google.com"],\n\t&[data-oembed-url*="maps.app.goo.gl"],\n\t&[data-oembed-url*="facebook.com"],\n\t&[data-oembed-url*="instagram.com"] {\n\t\t& .ck-media__placeholder__icon * {\n\t\t\tdisplay: none;\n\t\t}\n\t}\n}\n\n/* Disable all mouse interaction as long as the editor is not read–only.\n   https://github.com/ckeditor/ckeditor5-media-embed/issues/58 */\n.ck-editor__editable:not(.ck-read-only) .ck-media__wrapper > *:not(.ck-media__placeholder) {\n\tpointer-events: none;\n}\n\n/* Disable all mouse interaction when the widget is not selected (e.g. to avoid opening links by accident).\n   https://github.com/ckeditor/ckeditor5-media-embed/issues/18 */\n.ck-editor__editable:not(.ck-read-only) .ck-widget:not(.ck-widget_selected) .ck-media__placeholder {\n\tpointer-events: none;\n}\n',
                  '/*\n * Copyright (c) 2003-2022, CKSource Holding sp. z o.o. All rights reserved.\n * For licensing, see LICENSE.md or https://ckeditor.com/legal/ckeditor-oss-license\n */\n\n:root {\n\t--ck-media-embed-placeholder-icon-size: 3em;\n\n\t--ck-color-media-embed-placeholder-url-text: hsl(0, 0%, 46%);\n\t--ck-color-media-embed-placeholder-url-text-hover: var(--ck-color-base-text);\n}\n\n.ck-media__wrapper {\n\tmargin: 0 auto;\n\n\t& .ck-media__placeholder {\n\t\tpadding: calc( 3 * var(--ck-spacing-standard) );\n\t\tbackground: var(--ck-color-base-foreground);\n\n\t\t& .ck-media__placeholder__icon {\n\t\t\tmin-width: var(--ck-media-embed-placeholder-icon-size);\n\t\t\theight: var(--ck-media-embed-placeholder-icon-size);\n\t\t\tmargin-bottom: var(--ck-spacing-large);\n\t\t\tbackground-position: center;\n\t\t\tbackground-size: cover;\n\n\t\t\t& .ck-icon {\n\t\t\t\twidth: 100%;\n\t\t\t\theight: 100%;\n\t\t\t}\n\t\t}\n\n\t\t& .ck-media__placeholder__url__text {\n\t\t\tcolor: var(--ck-color-media-embed-placeholder-url-text);\n\t\t\twhite-space: nowrap;\n\t\t\ttext-align: center;\n\t\t\tfont-style: italic;\n\t\t\ttext-overflow: ellipsis;\n\n\t\t\t&:hover {\n\t\t\t\tcolor: var(--ck-color-media-embed-placeholder-url-text-hover);\n\t\t\t\tcursor: pointer;\n\t\t\t\ttext-decoration: underline;\n\t\t\t}\n\t\t}\n\t}\n\n\t&[data-oembed-url*="open.spotify.com"] {\n\t\tmax-width: 300px;\n\t\tmax-height: 380px;\n\t}\n\n\t&[data-oembed-url*="google.com/maps"] .ck-media__placeholder__icon,\n\t&[data-oembed-url*="goo.gl/maps"] .ck-media__placeholder__icon,\n\t&[data-oembed-url*="maps.google.com"] .ck-media__placeholder__icon,\n\t&[data-oembed-url*="maps.app.goo.gl"] .ck-media__placeholder__icon {\n\t\tbackground-image: url(data:image/svg+xml;base64,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);\n\t}\n\n\t&[data-oembed-url*="facebook.com"] .ck-media__placeholder {\n\t\tbackground: hsl(220, 46%, 48%);\n\n\t\t& .ck-media__placeholder__icon {\n\t\t\tbackground-image: url(data:image/svg+xml;base64,PD94bWwgdmVyc2lvbj0iMS4wIiBlbmNvZGluZz0iVVRGLTgiPz48c3ZnIHdpZHRoPSIxMDI0cHgiIGhlaWdodD0iMTAyNHB4IiB2aWV3Qm94PSIwIDAgMTAyNCAxMDI0IiB2ZXJzaW9uPSIxLjEiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyIgeG1sbnM6eGxpbms9Imh0dHA6Ly93d3cudzMub3JnLzE5OTkveGxpbmsiPiAgICAgICAgPHRpdGxlPkZpbGwgMTwvdGl0bGU+ICAgIDxkZXNjPkNyZWF0ZWQgd2l0aCBTa2V0Y2guPC9kZXNjPiAgICA8ZGVmcz48L2RlZnM+ICAgIDxnIGlkPSJQYWdlLTEiIHN0cm9rZT0ibm9uZSIgc3Ryb2tlLXdpZHRoPSIxIiBmaWxsPSJub25lIiBmaWxsLXJ1bGU9ImV2ZW5vZGQiPiAgICAgICAgPGcgaWQ9ImZMb2dvX1doaXRlIiBmaWxsPSIjRkZGRkZFIj4gICAgICAgICAgICA8cGF0aCBkPSJNOTY3LjQ4NCwwIEw1Ni41MTcsMCBDMjUuMzA0LDAgMCwyNS4zMDQgMCw1Ni41MTcgTDAsOTY3LjQ4MyBDMCw5OTguNjk0IDI1LjI5NywxMDI0IDU2LjUyMiwxMDI0IEw1NDcsMTAyNCBMNTQ3LDYyOCBMNDE0LDYyOCBMNDE0LDQ3MyBMNTQ3LDQ3MyBMNTQ3LDM1OS4wMjkgQzU0NywyMjYuNzY3IDYyNy43NzMsMTU0Ljc0NyA3NDUuNzU2LDE1NC43NDcgQzgwMi4yNjksMTU0Ljc0NyA4NTAuODQyLDE1OC45NTUgODY1LDE2MC44MzYgTDg2NSwyOTkgTDc4My4zODQsMjk5LjAzNyBDNzE5LjM5MSwyOTkuMDM3IDcwNywzMjkuNTI5IDcwNywzNzQuMjczIEw3MDcsNDczIEw4NjAuNDg3LDQ3MyBMODQwLjUwMSw2MjggTDcwNyw2MjggTDcwNywxMDI0IEw5NjcuNDg0LDEwMjQgQzk5OC42OTcsMTAyNCAxMDI0LDk5OC42OTcgMTAyNCw5NjcuNDg0IEwxMDI0LDU2LjUxNSBDMTAyNCwyNS4zMDMgOTk4LjY5NywwIDk2Ny40ODQsMCIgaWQ9IkZpbGwtMSI+PC9wYXRoPiAgICAgICAgPC9nPiAgICA8L2c+PC9zdmc+);\n\t\t}\n\n\t\t& .ck-media__placeholder__url__text {\n\t\t\tcolor: hsl(220, 100%, 90%);\n\n\t\t\t&:hover {\n\t\t\t\tcolor: hsl(0, 0%, 100%);\n\t\t\t}\n\t\t}\n\t}\n\n\t&[data-oembed-url*="instagram.com"] .ck-media__placeholder {\n\t\tbackground: linear-gradient(-135deg,hsl(246, 100%, 39%),hsl(302, 100%, 36%),hsl(0, 100%, 48%));\n\n\t\t& .ck-media__placeholder__icon {\n\t\t\tbackground-image: url(data:image/svg+xml;base64,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);\n\t\t}\n\n\t\t/* stylelint-disable-next-line no-descending-specificity */\n\t\t& .ck-media__placeholder__url__text {\n\t\t\tcolor: hsl(302, 100%, 94%);\n\n\t\t\t&:hover {\n\t\t\t\tcolor: hsl(0, 0%, 100%);\n\t\t\t}\n\t\t}\n\t}\n\n\t&[data-oembed-url*="twitter.com"] .ck.ck-media__placeholder {\n\t\t/* Use gradient to contrast with focused widget (ckeditor/ckeditor5-media-embed#22). */\n\t\tbackground: linear-gradient( to right, hsl(201, 85%, 70%), hsl(201, 85%, 35%) );\n\n\t\t& .ck-media__placeholder__icon {\n\t\t\tbackground-image: url(data:image/svg+xml;base64,PD94bWwgdmVyc2lvbj0iMS4wIiBlbmNvZGluZz0idXRmLTgiPz48c3ZnIHZlcnNpb249IjEuMSIgaWQ9IldoaXRlIiB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHhtbG5zOnhsaW5rPSJodHRwOi8vd3d3LnczLm9yZy8xOTk5L3hsaW5rIiB4PSIwcHgiIHk9IjBweCIgdmlld0JveD0iMCAwIDQwMCA0MDAiIHN0eWxlPSJlbmFibGUtYmFja2dyb3VuZDpuZXcgMCAwIDQwMCA0MDA7IiB4bWw6c3BhY2U9InByZXNlcnZlIj48c3R5bGUgdHlwZT0idGV4dC9jc3MiPi5zdDB7ZmlsbDojRkZGRkZGO308L3N0eWxlPjxwYXRoIGNsYXNzPSJzdDAiIGQ9Ik00MDAsMjAwYzAsMTEwLjUtODkuNSwyMDAtMjAwLDIwMFMwLDMxMC41LDAsMjAwUzg5LjUsMCwyMDAsMFM0MDAsODkuNSw0MDAsMjAweiBNMTYzLjQsMzA1LjVjODguNywwLDEzNy4yLTczLjUsMTM3LjItMTM3LjJjMC0yLjEsMC00LjItMC4xLTYuMmM5LjQtNi44LDE3LjYtMTUuMywyNC4xLTI1Yy04LjYsMy44LTE3LjksNi40LTI3LjcsNy42YzEwLTYsMTcuNi0xNS40LDIxLjItMjYuN2MtOS4zLDUuNS0xOS42LDkuNS0zMC42LDExLjdjLTguOC05LjQtMjEuMy0xNS4yLTM1LjItMTUuMmMtMjYuNiwwLTQ4LjIsMjEuNi00OC4yLDQ4LjJjMCwzLjgsMC40LDcuNSwxLjMsMTFjLTQwLjEtMi03NS42LTIxLjItOTkuNC01MC40Yy00LjEsNy4xLTYuNSwxNS40LTYuNSwyNC4yYzAsMTYuNyw4LjUsMzEuNSwyMS41LDQwLjFjLTcuOS0wLjItMTUuMy0yLjQtMjEuOC02YzAsMC4yLDAsMC40LDAsMC42YzAsMjMuNCwxNi42LDQyLjgsMzguNyw0Ny4zYy00LDEuMS04LjMsMS43LTEyLjcsMS43Yy0zLjEsMC02LjEtMC4zLTkuMS0wLjljNi4xLDE5LjIsMjMuOSwzMy4xLDQ1LDMzLjVjLTE2LjUsMTIuOS0zNy4zLDIwLjYtNTkuOSwyMC42Yy0zLjksMC03LjctMC4yLTExLjUtMC43QzExMC44LDI5Ny41LDEzNi4yLDMwNS41LDE2My40LDMwNS41Ii8+PC9zdmc+);\n\t\t}\n\n\t\t& .ck-media__placeholder__url__text {\n\t\t\tcolor: hsl(201, 100%, 86%);\n\n\t\t\t&:hover {\n\t\t\t\tcolor: hsl(0, 0%, 100%);\n\t\t\t}\n\t\t}\n\t}\n}\n',
                ],
                sourceRoot: "",
              },
            ]);
            const b = m;
          },
          3525: (t, e, n) => {
            "use strict";
            n.d(e, { Z: () => a });
            var o = n(7537),
              i = n.n(o),
              r = n(3645),
              s = n.n(r)()(i());
            s.push([
              t.id,
              ".ck.ck-media-form{align-items:flex-start;display:flex;flex-direction:row;flex-wrap:nowrap}.ck.ck-media-form .ck-labeled-field-view{display:inline-block}.ck.ck-media-form .ck-label{display:none}@media screen and (max-width:600px){.ck.ck-media-form{flex-wrap:wrap}.ck.ck-media-form .ck-labeled-field-view{flex-basis:100%}.ck.ck-media-form .ck-button{flex-basis:50%}}",
              "",
              {
                version: 3,
                sources: [
                  "webpack://./node_modules/@ckeditor/ckeditor5-media-embed/theme/mediaform.css",
                  "webpack://./node_modules/@ckeditor/ckeditor5-ui/theme/mixins/_rwd.css",
                ],
                names: [],
                mappings:
                  "AAOA,kBAEC,sBAAuB,CADvB,YAAa,CAEb,kBAAmB,CACnB,gBAqBD,CAnBC,yCACC,oBACD,CAEA,4BACC,YACD,CCbA,oCDCD,kBAeE,cAUF,CARE,yCACC,eACD,CAEA,6BACC,cACD,CCtBD",
                sourcesContent: [
                  '/*\n * Copyright (c) 2003-2022, CKSource Holding sp. z o.o. All rights reserved.\n * For licensing, see LICENSE.md or https://ckeditor.com/legal/ckeditor-oss-license\n */\n\n@import "@ckeditor/ckeditor5-ui/theme/mixins/_rwd.css";\n\n.ck.ck-media-form {\n\tdisplay: flex;\n\talign-items: flex-start;\n\tflex-direction: row;\n\tflex-wrap: nowrap;\n\n\t& .ck-labeled-field-view {\n\t\tdisplay: inline-block;\n\t}\n\n\t& .ck-label {\n\t\tdisplay: none;\n\t}\n\n\t@mixin ck-media-phone {\n\t\tflex-wrap: wrap;\n\n\t\t& .ck-labeled-field-view {\n\t\t\tflex-basis: 100%;\n\t\t}\n\n\t\t& .ck-button {\n\t\t\tflex-basis: 50%;\n\t\t}\n\t}\n}\n',
                  "/*\n * Copyright (c) 2003-2022, CKSource Holding sp. z o.o. All rights reserved.\n * For licensing, see LICENSE.md or https://ckeditor.com/legal/ckeditor-oss-license\n */\n\n@define-mixin ck-media-phone {\n\t@media screen and (max-width: 600px) {\n\t\t@mixin-content;\n\t}\n}\n",
                ],
                sourceRoot: "",
              },
            ]);
            const a = s;
          },
          671: (t, e, n) => {
            "use strict";
            n.d(e, { Z: () => a });
            var o = n(7537),
              i = n.n(o),
              r = n(3645),
              s = n.n(r)()(i());
            s.push([
              t.id,
              '.ck-source-editing-area{overflow:hidden;position:relative}.ck-source-editing-area textarea,.ck-source-editing-area:after{border:1px solid transparent;font-family:monospace;font-size:var(--ck-font-size-normal);line-height:var(--ck-line-height-base);margin:0;padding:var(--ck-spacing-large);white-space:pre-wrap}.ck-source-editing-area:after{content:attr(data-value) " ";display:block;visibility:hidden}.ck-source-editing-area textarea{border-color:var(--ck-color-base-border);border-radius:0;box-sizing:border-box;height:100%;outline:none;overflow:hidden;position:absolute;resize:none;width:100%}.ck-rounded-corners .ck-source-editing-area textarea,.ck-source-editing-area textarea.ck-rounded-corners{border-radius:var(--ck-border-radius);border-top-left-radius:0;border-top-right-radius:0}.ck-source-editing-area textarea:not([readonly]):focus{border:var(--ck-focus-ring);box-shadow:var(--ck-inner-shadow),0 0;outline:none}',
              "",
              {
                version: 3,
                sources: [
                  "webpack://./node_modules/@ckeditor/ckeditor5-source-editing/theme/sourceediting.css",
                  "webpack://./node_modules/@ckeditor/ckeditor5-theme-lark/theme/mixins/_rounded.css",
                  "webpack://./node_modules/@ckeditor/ckeditor5-theme-lark/theme/mixins/_focus.css",
                  "webpack://./node_modules/@ckeditor/ckeditor5-theme-lark/theme/mixins/_shadow.css",
                ],
                names: [],
                mappings:
                  "AASA,wBAEC,eAAgB,CADhB,iBAED,CAEA,+DAIC,4BAA6B,CAG7B,qBAAsB,CADtB,oCAAqC,CADrC,sCAAuC,CAFvC,QAAS,CADT,+BAAgC,CAMhC,oBACD,CAEA,8BACC,4BAA6B,CAE7B,aAAc,CADd,iBAED,CAEA,iCASC,wCAAyC,CC7BzC,eAAgB,CD2BhB,qBAAsB,CAJtB,WAAY,CAEZ,YAAa,CACb,eAAgB,CALhB,iBAAkB,CAGlB,WAAY,CAFZ,UAkBD,CApBA,yGChBE,qCAAsC,CD4BtC,wBAAyB,CACzB,yBAOF,CAJC,uDEpCA,2BAA2B,CCF3B,qCAA8B,CDC9B,YFwCA",
                sourcesContent: [
                  '/*\n * Copyright (c) 2003-2022, CKSource Holding sp. z o.o. All rights reserved.\n * For licensing, see LICENSE.md or https://ckeditor.com/legal/ckeditor-oss-license\n */\n\n@import "@ckeditor/ckeditor5-theme-lark/theme/mixins/_rounded.css";\n@import "@ckeditor/ckeditor5-theme-lark/theme/mixins/_focus.css";\n@import "@ckeditor/ckeditor5-theme-lark/theme/mixins/_shadow.css";\n\n.ck-source-editing-area {\n\tposition: relative;\n\toverflow: hidden;\n}\n\n.ck-source-editing-area::after,\n.ck-source-editing-area textarea {\n\tpadding: var(--ck-spacing-large);\n\tmargin: 0;\n\tborder: 1px solid transparent;\n\tline-height: var(--ck-line-height-base);\n\tfont-size: var(--ck-font-size-normal);\n\tfont-family: monospace;\n\twhite-space: pre-wrap;\n}\n\n.ck-source-editing-area::after {\n\tcontent: attr(data-value) " ";\n\tvisibility: hidden;\n\tdisplay: block;\n}\n\n.ck-source-editing-area textarea {\n\tposition: absolute;\n\twidth: 100%;\n\theight: 100%;\n\tresize: none;\n\toutline: none;\n\toverflow: hidden;\n\tbox-sizing: border-box;\n\n\tborder-color: var(--ck-color-base-border);\n\n\t@mixin ck-rounded-corners {\n\t\tborder-top-left-radius: 0;\n\t\tborder-top-right-radius: 0;\n\t}\n\n\t&:not([readonly]):focus {\n\t\t@mixin ck-focus-ring;\n\t\t@mixin ck-box-shadow var(--ck-inner-shadow);\n\t}\n}\n',
                  "/*\n * Copyright (c) 2003-2022, CKSource Holding sp. z o.o. All rights reserved.\n * For licensing, see LICENSE.md or https://ckeditor.com/legal/ckeditor-oss-license\n */\n\n/**\n * Implements rounded corner interface for .ck-rounded-corners class.\n *\n * @see $ck-border-radius\n */\n@define-mixin ck-rounded-corners {\n\tborder-radius: 0;\n\n\t@nest .ck-rounded-corners &,\n\t&.ck-rounded-corners {\n\t\tborder-radius: var(--ck-border-radius);\n\t\t@mixin-content;\n\t}\n}\n",
                  "/*\n * Copyright (c) 2003-2022, CKSource Holding sp. z o.o. All rights reserved.\n * For licensing, see LICENSE.md or https://ckeditor.com/legal/ckeditor-oss-license\n */\n\n/**\n * A visual style of focused element's border.\n */\n@define-mixin ck-focus-ring {\n\t/* Disable native outline. */\n\toutline: none;\n\tborder: var(--ck-focus-ring)\n}\n",
                  "/*\n * Copyright (c) 2003-2022, CKSource Holding sp. z o.o. All rights reserved.\n * For licensing, see LICENSE.md or https://ckeditor.com/legal/ckeditor-oss-license\n */\n\n/**\n * A helper to combine multiple shadows.\n */\n@define-mixin ck-box-shadow $shadowA, $shadowB: 0 0 {\n\tbox-shadow: $shadowA, $shadowB;\n}\n\n/**\n * Gives an element a drop shadow so it looks like a floating panel.\n */\n@define-mixin ck-drop-shadow {\n\t@mixin ck-box-shadow var(--ck-drop-shadow);\n}\n",
                ],
                sourceRoot: "",
              },
            ]);
            const a = s;
          },
          4082: (t, e, n) => {
            "use strict";
            n.d(e, { Z: () => a });
            var o = n(7537),
              i = n.n(o),
              r = n(3645),
              s = n.n(r)()(i());
            s.push([
              t.id,
              ".ck.ck-input-color{display:flex;flex-direction:row-reverse;width:100%}.ck.ck-input-color>input.ck.ck-input-text{flex-grow:1;min-width:auto}.ck.ck-input-color>div.ck.ck-dropdown{min-width:auto}.ck.ck-input-color>div.ck.ck-dropdown>.ck-input-color__button .ck-dropdown__arrow{display:none}.ck.ck-input-color .ck.ck-input-color__button{display:flex}.ck.ck-input-color .ck.ck-input-color__button .ck.ck-input-color__button__preview{overflow:hidden;position:relative}.ck.ck-input-color .ck.ck-input-color__button .ck.ck-input-color__button__preview>.ck.ck-input-color__button__preview__no-color-indicator{display:block;position:absolute}[dir=ltr] .ck.ck-input-color>.ck.ck-input-text{border-bottom-right-radius:0;border-top-right-radius:0}[dir=rtl] .ck.ck-input-color>.ck.ck-input-text{border-bottom-left-radius:0;border-top-left-radius:0}.ck.ck-input-color>.ck.ck-input-text:focus{z-index:0}.ck.ck-input-color>.ck.ck-dropdown>.ck.ck-button.ck-input-color__button{padding:0}[dir=ltr] .ck.ck-input-color>.ck.ck-dropdown>.ck.ck-button.ck-input-color__button{border-bottom-left-radius:0;border-top-left-radius:0}[dir=ltr] .ck.ck-input-color>.ck.ck-dropdown>.ck.ck-button.ck-input-color__button:not(:focus){border-left:1px solid transparent}[dir=rtl] .ck.ck-input-color>.ck.ck-dropdown>.ck.ck-button.ck-input-color__button{border-bottom-right-radius:0;border-top-right-radius:0}[dir=rtl] .ck.ck-input-color>.ck.ck-dropdown>.ck.ck-button.ck-input-color__button:not(:focus){border-right:1px solid transparent}.ck.ck-input-color>.ck.ck-dropdown>.ck.ck-button.ck-input-color__button.ck-disabled{background:var(--ck-color-input-disabled-background)}.ck.ck-input-color>.ck.ck-dropdown>.ck.ck-button.ck-input-color__button>.ck.ck-input-color__button__preview{border-radius:0}.ck-rounded-corners .ck.ck-input-color>.ck.ck-dropdown>.ck.ck-button.ck-input-color__button>.ck.ck-input-color__button__preview,.ck.ck-input-color>.ck.ck-dropdown>.ck.ck-button.ck-input-color__button>.ck.ck-input-color__button__preview.ck-rounded-corners{border-radius:var(--ck-border-radius)}.ck.ck-input-color>.ck.ck-dropdown>.ck.ck-button.ck-input-color__button>.ck.ck-input-color__button__preview{border:1px solid var(--ck-color-input-border);height:20px;width:20px}.ck.ck-input-color>.ck.ck-dropdown>.ck.ck-button.ck-input-color__button>.ck.ck-input-color__button__preview>.ck.ck-input-color__button__preview__no-color-indicator{background:red;border-radius:2px;height:150%;left:50%;top:-30%;transform:rotate(45deg);transform-origin:50%;width:8%}.ck.ck-input-color .ck.ck-input-color__remove-color{border-bottom-left-radius:0;border-bottom-right-radius:0;padding:calc(var(--ck-spacing-standard)/2) var(--ck-spacing-standard);width:100%}.ck.ck-input-color .ck.ck-input-color__remove-color:not(:focus){border-bottom:1px solid var(--ck-color-input-border)}[dir=ltr] .ck.ck-input-color .ck.ck-input-color__remove-color{border-top-right-radius:0}[dir=rtl] .ck.ck-input-color .ck.ck-input-color__remove-color{border-top-left-radius:0}.ck.ck-input-color .ck.ck-input-color__remove-color .ck.ck-icon{margin-right:var(--ck-spacing-standard)}[dir=rtl] .ck.ck-input-color .ck.ck-input-color__remove-color .ck.ck-icon{margin-left:var(--ck-spacing-standard);margin-right:0}",
              "",
              {
                version: 3,
                sources: [
                  "webpack://./node_modules/@ckeditor/ckeditor5-table/theme/colorinput.css",
                  "webpack://./node_modules/@ckeditor/ckeditor5-theme-lark/theme/ckeditor5-table/colorinput.css",
                  "webpack://./node_modules/@ckeditor/ckeditor5-theme-lark/theme/mixins/_rounded.css",
                ],
                names: [],
                mappings:
                  "AAKA,mBAEC,YAAa,CACb,0BAA2B,CAF3B,UAgCD,CA5BC,0CAEC,WAAY,CADZ,cAED,CAEA,sCACC,cAMD,CAHC,kFACC,YACD,CAGD,8CAEC,YAWD,CATC,kFAEC,eAAgB,CADhB,iBAOD,CAJC,0IAEC,aAAc,CADd,iBAED,CC1BF,+CAGE,4BAA6B,CAD7B,yBAcF,CAhBA,+CAQE,2BAA4B,CAD5B,wBASF,CAHC,2CACC,SACD,CAIA,wEACC,SA0CD,CA3CA,kFAKE,2BAA4B,CAD5B,wBAuCF,CApCE,8FACC,iCACD,CATF,kFAcE,4BAA6B,CAD7B,yBA8BF,CA3BE,8FACC,kCACD,CAGD,oFACC,oDACD,CAEA,4GC1CF,eD2DE,CAjBA,+PCtCD,qCDuDC,CAjBA,4GAKC,6CAA8C,CAD9C,WAAY,CADZ,UAcD,CAVC,oKAKC,cAA6B,CAC7B,iBAAkB,CAHlB,WAAY,CADZ,QAAS,CADT,QAAS,CAMT,uBAAwB,CACxB,oBAAqB,CAJrB,QAKD,CAKH,oDAIC,2BAA4B,CAC5B,4BAA6B,CAH7B,qEAAwE,CADxE,UA0BD,CApBC,gEACC,oDACD,CATD,8DAYE,yBAeF,CA3BA,8DAgBE,wBAWF,CARC,gEACC,uCAMD,CAPA,0EAKE,sCAAuC,CADvC,cAGF",
                sourcesContent: [
                  "/*\n * Copyright (c) 2003-2022, CKSource Holding sp. z o.o. All rights reserved.\n * For licensing, see LICENSE.md or https://ckeditor.com/legal/ckeditor-oss-license\n */\n\n.ck.ck-input-color {\n\twidth: 100%;\n\tdisplay: flex;\n\tflex-direction: row-reverse;\n\n\t& > input.ck.ck-input-text {\n\t\tmin-width: auto;\n\t\tflex-grow: 1;\n\t}\n\n\t& > div.ck.ck-dropdown {\n\t\tmin-width: auto;\n\n\t\t/* This dropdown has no arrow but a color preview instead. */\n\t\t& > .ck-input-color__button .ck-dropdown__arrow {\n\t\t\tdisplay: none;\n\t\t}\n\t}\n\n\t& .ck.ck-input-color__button {\n\t\t/* Resolving issue with misaligned buttons on Safari (see #10589) */\n\t\tdisplay: flex;\n\n\t\t& .ck.ck-input-color__button__preview {\n\t\t\tposition: relative;\n\t\t\toverflow: hidden;\n\n\t\t\t& > .ck.ck-input-color__button__preview__no-color-indicator {\n\t\t\t\tposition: absolute;\n\t\t\t\tdisplay: block;\n\t\t\t}\n\t\t}\n\t}\n}\n",
                  '/*\n * Copyright (c) 2003-2022, CKSource Holding sp. z o.o. All rights reserved.\n * For licensing, see LICENSE.md or https://ckeditor.com/legal/ckeditor-oss-license\n */\n\n@import "@ckeditor/ckeditor5-ui/theme/mixins/_dir.css";\n@import "../mixins/_rounded.css";\n\n.ck.ck-input-color {\n\t& > .ck.ck-input-text {\n\t\t@mixin ck-dir ltr {\n\t\t\tborder-top-right-radius: 0;\n\t\t\tborder-bottom-right-radius: 0;\n\t\t}\n\n\t\t@mixin ck-dir rtl {\n\t\t\tborder-top-left-radius: 0;\n\t\t\tborder-bottom-left-radius: 0;\n\t\t}\n\n\t\t/* Make sure the focused input is always on top of the dropdown button so its\n\t\t   outline and border are never cropped (also when the input is read-only). */\n\t\t&:focus {\n\t\t\tz-index: 0;\n\t\t}\n\t}\n\n\t& > .ck.ck-dropdown {\n\t\t& > .ck.ck-button.ck-input-color__button {\n\t\t\tpadding: 0;\n\n\t\t\t@mixin ck-dir ltr {\n\t\t\t\tborder-top-left-radius: 0;\n\t\t\t\tborder-bottom-left-radius: 0;\n\n\t\t\t\t&:not(:focus) {\n\t\t\t\t\tborder-left: 1px solid transparent;\n\t\t\t\t}\n\t\t\t}\n\n\t\t\t@mixin ck-dir rtl {\n\t\t\t\tborder-top-right-radius: 0;\n\t\t\t\tborder-bottom-right-radius: 0;\n\n\t\t\t\t&:not(:focus) {\n\t\t\t\t\tborder-right: 1px solid transparent;\n\t\t\t\t}\n\t\t\t}\n\n\t\t\t&.ck-disabled {\n\t\t\t\tbackground: var(--ck-color-input-disabled-background);\n\t\t\t}\n\n\t\t\t& > .ck.ck-input-color__button__preview {\n\t\t\t\t@mixin ck-rounded-corners;\n\n\t\t\t\twidth: 20px;\n\t\t\t\theight: 20px;\n\t\t\t\tborder: 1px solid var(--ck-color-input-border);\n\n\t\t\t\t& > .ck.ck-input-color__button__preview__no-color-indicator {\n\t\t\t\t\ttop: -30%;\n\t\t\t\t\tleft: 50%;\n\t\t\t\t\theight: 150%;\n\t\t\t\t\twidth: 8%;\n\t\t\t\t\tbackground: hsl(0, 100%, 50%);\n\t\t\t\t\tborder-radius: 2px;\n\t\t\t\t\ttransform: rotate(45deg);\n\t\t\t\t\ttransform-origin: 50%;\n\t\t\t\t}\n\t\t\t}\n\t\t}\n\t}\n\n\t& .ck.ck-input-color__remove-color {\n\t\twidth: 100%;\n\t\tpadding: calc(var(--ck-spacing-standard) / 2) var(--ck-spacing-standard);\n\n\t\tborder-bottom-left-radius: 0;\n\t\tborder-bottom-right-radius: 0;\n\n\t\t&:not(:focus) {\n\t\t\tborder-bottom: 1px solid var(--ck-color-input-border);\n\t\t}\n\n\t\t@mixin ck-dir ltr {\n\t\t\tborder-top-right-radius: 0;\n\t\t}\n\n\t\t@mixin ck-dir rtl {\n\t\t\tborder-top-left-radius: 0;\n\t\t}\n\n\t\t& .ck.ck-icon {\n\t\t\tmargin-right: var(--ck-spacing-standard);\n\n\t\t\t@mixin ck-dir rtl {\n\t\t\t\tmargin-right: 0;\n\t\t\t\tmargin-left: var(--ck-spacing-standard);\n\t\t\t}\n\t\t}\n\t}\n}\n',
                  "/*\n * Copyright (c) 2003-2022, CKSource Holding sp. z o.o. All rights reserved.\n * For licensing, see LICENSE.md or https://ckeditor.com/legal/ckeditor-oss-license\n */\n\n/**\n * Implements rounded corner interface for .ck-rounded-corners class.\n *\n * @see $ck-border-radius\n */\n@define-mixin ck-rounded-corners {\n\tborder-radius: 0;\n\n\t@nest .ck-rounded-corners &,\n\t&.ck-rounded-corners {\n\t\tborder-radius: var(--ck-border-radius);\n\t\t@mixin-content;\n\t}\n}\n",
                ],
                sourceRoot: "",
              },
            ]);
            const a = s;
          },
          4880: (t, e, n) => {
            "use strict";
            n.d(e, { Z: () => a });
            var o = n(7537),
              i = n.n(o),
              r = n(3645),
              s = n.n(r)()(i());
            s.push([
              t.id,
              ".ck.ck-form{padding:0 0 var(--ck-spacing-large)}.ck.ck-form:focus{outline:none}.ck.ck-form .ck.ck-input-text{min-width:100%;width:0}.ck.ck-form .ck.ck-dropdown{min-width:100%}.ck.ck-form .ck.ck-dropdown .ck-dropdown__button:not(:focus){border:1px solid var(--ck-color-base-border)}.ck.ck-form .ck.ck-dropdown .ck-dropdown__button .ck-button__label{width:100%}",
              "",
              {
                version: 3,
                sources: [
                  "webpack://./node_modules/@ckeditor/ckeditor5-theme-lark/theme/ckeditor5-table/form.css",
                ],
                names: [],
                mappings:
                  "AAKA,YACC,mCAyBD,CAvBC,kBAEC,YACD,CAEA,8BACC,cAAe,CACf,OACD,CAEA,4BACC,cAWD,CARE,6DACC,4CACD,CAEA,mEACC,UACD",
                sourcesContent: [
                  "/*\n * Copyright (c) 2003-2022, CKSource Holding sp. z o.o. All rights reserved.\n * For licensing, see LICENSE.md or https://ckeditor.com/legal/ckeditor-oss-license\n */\n\n.ck.ck-form {\n\tpadding: 0 0 var(--ck-spacing-large);\n\n\t&:focus {\n\t\t/* See: https://github.com/ckeditor/ckeditor5/issues/4773 */\n\t\toutline: none;\n\t}\n\n\t& .ck.ck-input-text {\n\t\tmin-width: 100%;\n\t\twidth: 0;\n\t}\n\n\t& .ck.ck-dropdown {\n\t\tmin-width: 100%;\n\n\t\t& .ck-dropdown__button {\n\t\t\t&:not(:focus) {\n\t\t\t\tborder: 1px solid var(--ck-color-base-border);\n\t\t\t}\n\n\t\t\t& .ck-button__label {\n\t\t\t\twidth: 100%;\n\t\t\t}\n\t\t}\n\t}\n}\n",
                ],
                sourceRoot: "",
              },
            ]);
            const a = s;
          },
          9865: (t, e, n) => {
            "use strict";
            n.d(e, { Z: () => a });
            var o = n(7537),
              i = n.n(o),
              r = n(3645),
              s = n.n(r)()(i());
            s.push([
              t.id,
              ".ck.ck-form__row{display:flex;flex-direction:row;flex-wrap:nowrap;justify-content:space-between}.ck.ck-form__row>:not(.ck-label){flex-grow:1}.ck.ck-form__row.ck-table-form__action-row .ck-button-cancel,.ck.ck-form__row.ck-table-form__action-row .ck-button-save{justify-content:center}.ck.ck-form__row{padding:var(--ck-spacing-standard) var(--ck-spacing-large) 0}[dir=ltr] .ck.ck-form__row>:not(.ck-label)+*{margin-left:var(--ck-spacing-large)}[dir=rtl] .ck.ck-form__row>:not(.ck-label)+*{margin-right:var(--ck-spacing-large)}.ck.ck-form__row>.ck-label{min-width:100%;width:100%}.ck.ck-form__row.ck-table-form__action-row{margin-top:var(--ck-spacing-large)}.ck.ck-form__row.ck-table-form__action-row .ck-button .ck-button__label{color:var(--ck-color-text)}",
              "",
              {
                version: 3,
                sources: [
                  "webpack://./node_modules/@ckeditor/ckeditor5-table/theme/formrow.css",
                  "webpack://./node_modules/@ckeditor/ckeditor5-theme-lark/theme/ckeditor5-table/formrow.css",
                ],
                names: [],
                mappings:
                  "AAKA,iBACC,YAAa,CACb,kBAAmB,CACnB,gBAAiB,CACjB,6BAaD,CAVC,iCACC,WACD,CAGC,wHAEC,sBACD,CCbF,iBACC,4DA2BD,CAvBE,6CAEE,mCAMF,CARA,6CAME,oCAEF,CAGD,2BAEC,cAAe,CADf,UAED,CAEA,2CACC,kCAKD,CAHC,wEACC,0BACD",
                sourcesContent: [
                  "/*\n * Copyright (c) 2003-2022, CKSource Holding sp. z o.o. All rights reserved.\n * For licensing, see LICENSE.md or https://ckeditor.com/legal/ckeditor-oss-license\n */\n\n.ck.ck-form__row {\n\tdisplay: flex;\n\tflex-direction: row;\n\tflex-wrap: nowrap;\n\tjustify-content: space-between;\n\n\t/* Ignore labels that work as fieldset legends */\n\t& > *:not(.ck-label) {\n\t\tflex-grow: 1;\n\t}\n\n\t&.ck-table-form__action-row {\n\t\t& .ck-button-save,\n\t\t& .ck-button-cancel {\n\t\t\tjustify-content: center;\n\t\t}\n\t}\n}\n",
                  '/*\n * Copyright (c) 2003-2022, CKSource Holding sp. z o.o. All rights reserved.\n * For licensing, see LICENSE.md or https://ckeditor.com/legal/ckeditor-oss-license\n */\n\n@import "@ckeditor/ckeditor5-ui/theme/mixins/_dir.css";\n\n.ck.ck-form__row {\n\tpadding: var(--ck-spacing-standard) var(--ck-spacing-large) 0;\n\n\t/* Ignore labels that work as fieldset legends */\n\t& > *:not(.ck-label) {\n\t\t& + * {\n\t\t\t@mixin ck-dir ltr {\n\t\t\t\tmargin-left: var(--ck-spacing-large);\n\t\t\t}\n\n\t\t\t@mixin ck-dir rtl {\n\t\t\t\tmargin-right: var(--ck-spacing-large);\n\t\t\t}\n\t\t}\n\t}\n\n\t& > .ck-label {\n\t\twidth: 100%;\n\t\tmin-width: 100%;\n\t}\n\n\t&.ck-table-form__action-row {\n\t\tmargin-top: var(--ck-spacing-large);\n\n\t\t& .ck-button .ck-button__label {\n\t\t\tcolor: var(--ck-color-text);\n\t\t}\n\t}\n}\n',
                ],
                sourceRoot: "",
              },
            ]);
            const a = s;
          },
          8085: (t, e, n) => {
            "use strict";
            n.d(e, { Z: () => a });
            var o = n(7537),
              i = n.n(o),
              r = n(3645),
              s = n.n(r)()(i());
            s.push([
              t.id,
              ".ck .ck-insert-table-dropdown__grid{display:flex;flex-direction:row;flex-wrap:wrap}:root{--ck-insert-table-dropdown-padding:10px;--ck-insert-table-dropdown-box-height:11px;--ck-insert-table-dropdown-box-width:12px;--ck-insert-table-dropdown-box-margin:1px}.ck .ck-insert-table-dropdown__grid{padding:var(--ck-insert-table-dropdown-padding) var(--ck-insert-table-dropdown-padding) 0;width:calc(var(--ck-insert-table-dropdown-box-width)*10 + var(--ck-insert-table-dropdown-box-margin)*20 + var(--ck-insert-table-dropdown-padding)*2)}.ck .ck-insert-table-dropdown__label{text-align:center}.ck .ck-insert-table-dropdown-grid-box{border:1px solid var(--ck-color-base-border);border-radius:1px;margin:var(--ck-insert-table-dropdown-box-margin);min-height:var(--ck-insert-table-dropdown-box-height);min-width:var(--ck-insert-table-dropdown-box-width);outline:none;transition:none}.ck .ck-insert-table-dropdown-grid-box:focus{box-shadow:none}.ck .ck-insert-table-dropdown-grid-box.ck-on{background:var(--ck-color-focus-outer-shadow);border-color:var(--ck-color-focus-border)}",
              "",
              {
                version: 3,
                sources: [
                  "webpack://./node_modules/@ckeditor/ckeditor5-table/theme/inserttable.css",
                  "webpack://./node_modules/@ckeditor/ckeditor5-theme-lark/theme/ckeditor5-table/inserttable.css",
                ],
                names: [],
                mappings:
                  "AAKA,oCACC,YAAa,CACb,kBAAmB,CACnB,cACD,CCJA,MACC,uCAAwC,CACxC,0CAA2C,CAC3C,yCAA0C,CAC1C,yCACD,CAEA,oCAGC,yFAA0F,CAD1F,oJAED,CAEA,qCACC,iBACD,CAEA,uCAIC,4CAA6C,CAC7C,iBAAkB,CAFlB,iDAAkD,CADlD,qDAAsD,CADtD,mDAAoD,CAKpD,YAAa,CACb,eAUD,CARC,6CACC,eACD,CAEA,6CAEC,6CAA8C,CAD9C,yCAED",
                sourcesContent: [
                  "/*\n * Copyright (c) 2003-2022, CKSource Holding sp. z o.o. All rights reserved.\n * For licensing, see LICENSE.md or https://ckeditor.com/legal/ckeditor-oss-license\n */\n\n.ck .ck-insert-table-dropdown__grid {\n\tdisplay: flex;\n\tflex-direction: row;\n\tflex-wrap: wrap;\n}\n",
                  "/*\n * Copyright (c) 2003-2022, CKSource Holding sp. z o.o. All rights reserved.\n * For licensing, see LICENSE.md or https://ckeditor.com/legal/ckeditor-oss-license\n */\n\n:root {\n\t--ck-insert-table-dropdown-padding: 10px;\n\t--ck-insert-table-dropdown-box-height: 11px;\n\t--ck-insert-table-dropdown-box-width: 12px;\n\t--ck-insert-table-dropdown-box-margin: 1px;\n}\n\n.ck .ck-insert-table-dropdown__grid {\n\t/* The width of a container should match 10 items in a row so there will be a 10x10 grid. */\n\twidth: calc(var(--ck-insert-table-dropdown-box-width) * 10 + var(--ck-insert-table-dropdown-box-margin) * 20 + var(--ck-insert-table-dropdown-padding) * 2);\n\tpadding: var(--ck-insert-table-dropdown-padding) var(--ck-insert-table-dropdown-padding) 0;\n}\n\n.ck .ck-insert-table-dropdown__label {\n\ttext-align: center;\n}\n\n.ck .ck-insert-table-dropdown-grid-box {\n\tmin-width: var(--ck-insert-table-dropdown-box-width);\n\tmin-height: var(--ck-insert-table-dropdown-box-height);\n\tmargin: var(--ck-insert-table-dropdown-box-margin);\n\tborder: 1px solid var(--ck-color-base-border);\n\tborder-radius: 1px;\n\toutline: none;\n\ttransition: none;\n\n\t&:focus {\n\t\tbox-shadow: none;\n\t}\n\n\t&.ck-on {\n\t\tborder-color: var(--ck-color-focus-border);\n\t\tbackground: var(--ck-color-focus-outer-shadow);\n\t}\n}\n\n",
                ],
                sourceRoot: "",
              },
            ]);
            const a = s;
          },
          4104: (t, e, n) => {
            "use strict";
            n.d(e, { Z: () => a });
            var o = n(7537),
              i = n.n(o),
              r = n(3645),
              s = n.n(r)()(i());
            s.push([
              t.id,
              ".ck-content .table{display:table;margin:.9em auto}.ck-content .table table{border:1px double #b3b3b3;border-collapse:collapse;border-spacing:0;height:100%;width:100%}.ck-content .table table td,.ck-content .table table th{border:1px solid #bfbfbf;min-width:2em;padding:.4em}.ck-content .table table th{background:rgba(0,0,0,.05);font-weight:700}.ck-content[dir=rtl] .table th{text-align:right}.ck-content[dir=ltr] .table th{text-align:left}.ck-editor__editable .ck-table-bogus-paragraph{display:inline-block;width:100%}",
              "",
              {
                version: 3,
                sources: [
                  "webpack://./node_modules/@ckeditor/ckeditor5-table/theme/table.css",
                ],
                names: [],
                mappings:
                  "AAKA,mBAKC,aAAc,CADd,gBAiCD,CA9BC,yBAYC,yBAAkC,CAVlC,wBAAyB,CACzB,gBAAiB,CAKjB,WAAY,CADZ,UAsBD,CAfC,wDAQC,wBAAiC,CANjC,aAAc,CACd,YAMD,CAEA,4BAEC,0BAA+B,CAD/B,eAED,CAMF,+BACC,gBACD,CAEA,+BACC,eACD,CAEA,+CAKC,oBAAqB,CAMrB,UACD",
                sourcesContent: [
                  '/*\n * Copyright (c) 2003-2022, CKSource Holding sp. z o.o. All rights reserved.\n * For licensing, see LICENSE.md or https://ckeditor.com/legal/ckeditor-oss-license\n */\n\n.ck-content .table {\n\t/* Give the table widget some air and center it horizontally */\n\t/* The first value should be equal to --ck-spacing-large variable if used in the editor context\n\tto avoid the content jumping (See https://github.com/ckeditor/ckeditor5/issues/9825). */\n\tmargin: 0.9em auto;\n\tdisplay: table;\n\n\t& table {\n\t\t/* The table cells should have slight borders */\n\t\tborder-collapse: collapse;\n\t\tborder-spacing: 0;\n\n\t\t/* Table width and height are set on the parent <figure>. Make sure the table inside stretches\n\t\tto the full dimensions of the container (https://github.com/ckeditor/ckeditor5/issues/6186). */\n\t\twidth: 100%;\n\t\theight: 100%;\n\n\t\t/* The outer border of the table should be slightly darker than the inner lines.\n\t\tAlso see https://github.com/ckeditor/ckeditor5-table/issues/50. */\n\t\tborder: 1px double hsl(0, 0%, 70%);\n\n\t\t& td,\n\t\t& th {\n\t\t\tmin-width: 2em;\n\t\t\tpadding: .4em;\n\n\t\t\t/* The border is inherited from .ck-editor__nested-editable styles, so theoretically it\'s not necessary here.\n\t\t\tHowever, the border is a content style, so it should use .ck-content (so it works outside the editor).\n\t\t\tHence, the duplication. See https://github.com/ckeditor/ckeditor5/issues/6314 */\n\t\t\tborder: 1px solid hsl(0, 0%, 75%);\n\t\t}\n\n\t\t& th {\n\t\t\tfont-weight: bold;\n\t\t\tbackground: hsla(0, 0%, 0%, 5%);\n\t\t}\n\t}\n}\n\n/* Text alignment of the table header should match the editor settings and override the native browser styling,\nwhen content is available outside the editor. See https://github.com/ckeditor/ckeditor5/issues/6638 */\n.ck-content[dir="rtl"] .table th {\n\ttext-align: right;\n}\n\n.ck-content[dir="ltr"] .table th {\n\ttext-align: left;\n}\n\n.ck-editor__editable .ck-table-bogus-paragraph {\n\t/*\n\t * Use display:inline-block to force Chrome/Safari to limit text mutations to this element.\n\t * See https://github.com/ckeditor/ckeditor5/issues/6062.\n\t */\n\tdisplay: inline-block;\n\n\t/*\n\t * Inline HTML elements nested in the span should always be dimensioned in relation to the whole cell width.\n\t * See https://github.com/ckeditor/ckeditor5/issues/9117.\n\t */\n\twidth: 100%;\n}\n',
                ],
                sourceRoot: "",
              },
            ]);
            const a = s;
          },
          5737: (t, e, n) => {
            "use strict";
            n.d(e, { Z: () => a });
            var o = n(7537),
              i = n.n(o),
              r = n(3645),
              s = n.n(r)()(i());
            s.push([
              t.id,
              ".ck.ck-table-cell-properties-form .ck-form__row.ck-table-cell-properties-form__alignment-row{flex-wrap:wrap}.ck.ck-table-cell-properties-form .ck-form__row.ck-table-cell-properties-form__alignment-row .ck.ck-toolbar:first-of-type{flex-grow:0.57}.ck.ck-table-cell-properties-form .ck-form__row.ck-table-cell-properties-form__alignment-row .ck.ck-toolbar:last-of-type{flex-grow:0.43}.ck.ck-table-cell-properties-form .ck-form__row.ck-table-cell-properties-form__alignment-row .ck.ck-toolbar .ck-button{flex-grow:1}.ck.ck-table-cell-properties-form{width:320px}.ck.ck-table-cell-properties-form .ck-form__row.ck-table-cell-properties-form__padding-row{align-self:flex-end;padding:0;width:25%}.ck.ck-table-cell-properties-form .ck-form__row.ck-table-cell-properties-form__alignment-row .ck.ck-toolbar{background:none;margin-top:var(--ck-spacing-standard)}",
              "",
              {
                version: 3,
                sources: [
                  "webpack://./node_modules/@ckeditor/ckeditor5-table/theme/tablecellproperties.css",
                  "webpack://./node_modules/@ckeditor/ckeditor5-theme-lark/theme/ckeditor5-table/tablecellproperties.css",
                ],
                names: [],
                mappings:
                  "AAOE,6FACC,cAiBD,CAdE,0HAEC,cACD,CAEA,yHAEC,cACD,CAEA,uHACC,WACD,CClBJ,kCACC,WAkBD,CAfE,2FACC,mBAAoB,CACpB,SAAU,CACV,SACD,CAGC,4GACC,eAAgB,CAGhB,qCACD",
                sourcesContent: [
                  "/*\n * Copyright (c) 2003-2022, CKSource Holding sp. z o.o. All rights reserved.\n * For licensing, see LICENSE.md or https://ckeditor.com/legal/ckeditor-oss-license\n */\n\n.ck.ck-table-cell-properties-form {\n\t& .ck-form__row {\n\t\t&.ck-table-cell-properties-form__alignment-row {\n\t\t\tflex-wrap: wrap;\n\n\t\t\t& .ck.ck-toolbar {\n\t\t\t\t&:first-of-type {\n\t\t\t\t\t/* 4 buttons out of 7 (h-alignment + v-alignment) = 0.57 */\n\t\t\t\t\tflex-grow: 0.57;\n\t\t\t\t}\n\n\t\t\t\t&:last-of-type {\n\t\t\t\t\t/* 3 buttons out of 7 (h-alignment + v-alignment) = 0.43 */\n\t\t\t\t\tflex-grow: 0.43;\n\t\t\t\t}\n\n\t\t\t\t& .ck-button {\n\t\t\t\t\tflex-grow: 1;\n\t\t\t\t}\n\t\t\t}\n\t\t}\n\t}\n}\n",
                  "/*\n * Copyright (c) 2003-2022, CKSource Holding sp. z o.o. All rights reserved.\n * For licensing, see LICENSE.md or https://ckeditor.com/legal/ckeditor-oss-license\n */\n\n.ck.ck-table-cell-properties-form {\n\twidth: 320px;\n\n\t& .ck-form__row {\n\t\t&.ck-table-cell-properties-form__padding-row {\n\t\t\talign-self: flex-end;\n\t\t\tpadding: 0;\n\t\t\twidth: 25%;\n\t\t}\n\n\t\t&.ck-table-cell-properties-form__alignment-row {\n\t\t\t& .ck.ck-toolbar {\n\t\t\t\tbackground: none;\n\n\t\t\t\t/* Compensate for missing input label that would push the margin (toolbar has no inputs). */\n\t\t\t\tmargin-top: var(--ck-spacing-standard);\n\t\t\t}\n\t\t}\n\t}\n}\n",
                ],
                sourceRoot: "",
              },
            ]);
            const a = s;
          },
          4777: (t, e, n) => {
            "use strict";
            n.d(e, { Z: () => a });
            var o = n(7537),
              i = n.n(o),
              r = n(3645),
              s = n.n(r)()(i());
            s.push([
              t.id,
              ":root{--ck-color-table-focused-cell-background:rgba(158,201,250,.3)}.ck-widget.table td.ck-editor__nested-editable.ck-editor__nested-editable_focused,.ck-widget.table td.ck-editor__nested-editable:focus,.ck-widget.table th.ck-editor__nested-editable.ck-editor__nested-editable_focused,.ck-widget.table th.ck-editor__nested-editable:focus{background:var(--ck-color-table-focused-cell-background);border-style:none;outline:1px solid var(--ck-color-focus-border);outline-offset:-1px}",
              "",
              {
                version: 3,
                sources: [
                  "webpack://./node_modules/@ckeditor/ckeditor5-theme-lark/theme/ckeditor5-table/tableediting.css",
                ],
                names: [],
                mappings:
                  "AAKA,MACC,6DACD,CAKE,8QAGC,wDAAyD,CAKzD,iBAAkB,CAClB,8CAA+C,CAC/C,mBACD",
                sourcesContent: [
                  "/*\n * Copyright (c) 2003-2022, CKSource Holding sp. z o.o. All rights reserved.\n * For licensing, see LICENSE.md or https://ckeditor.com/legal/ckeditor-oss-license\n */\n\n:root {\n\t--ck-color-table-focused-cell-background: hsla(212, 90%, 80%, .3);\n}\n\n.ck-widget.table {\n\t& td,\n\t& th {\n\t\t&.ck-editor__nested-editable.ck-editor__nested-editable_focused,\n\t\t&.ck-editor__nested-editable:focus {\n\t\t\t/* A very slight background to highlight the focused cell */\n\t\t\tbackground: var(--ck-color-table-focused-cell-background);\n\n\t\t\t/* Fixes the problem where surrounding cells cover the focused cell's border.\n\t\t\tIt does not fix the problem in all places but the UX is improved.\n\t\t\tSee https://github.com/ckeditor/ckeditor5-table/issues/29. */\n\t\t\tborder-style: none;\n\t\t\toutline: 1px solid var(--ck-color-focus-border);\n\t\t\toutline-offset: -1px; /* progressive enhancement - no IE support */\n\t\t}\n\t}\n}\n",
                ],
                sourceRoot: "",
              },
            ]);
            const a = s;
          },
          198: (t, e, n) => {
            "use strict";
            n.d(e, { Z: () => a });
            var o = n(7537),
              i = n.n(o),
              r = n(3645),
              s = n.n(r)()(i());
            s.push([
              t.id,
              '.ck.ck-table-form .ck-form__row.ck-table-form__background-row,.ck.ck-table-form .ck-form__row.ck-table-form__border-row{flex-wrap:wrap}.ck.ck-table-form .ck-form__row.ck-table-form__dimensions-row{align-items:center;flex-wrap:wrap}.ck.ck-table-form .ck-form__row.ck-table-form__dimensions-row .ck-labeled-field-view{align-items:center;display:flex;flex-direction:column-reverse}.ck.ck-table-form .ck-form__row.ck-table-form__dimensions-row .ck-labeled-field-view .ck.ck-dropdown,.ck.ck-table-form .ck-form__row.ck-table-form__dimensions-row .ck-table-form__dimension-operator{flex-grow:0}.ck.ck-table-form .ck.ck-labeled-field-view{position:relative}.ck.ck-table-form .ck.ck-labeled-field-view .ck.ck-labeled-field-view__status{bottom:calc(var(--ck-table-properties-error-arrow-size)*-1);left:50%;position:absolute;transform:translate(-50%,100%);z-index:1}.ck.ck-table-form .ck.ck-labeled-field-view .ck.ck-labeled-field-view__status:after{content:"";left:50%;position:absolute;top:calc(var(--ck-table-properties-error-arrow-size)*-1);transform:translateX(-50%)}:root{--ck-table-properties-error-arrow-size:6px;--ck-table-properties-min-error-width:150px}.ck.ck-table-form .ck-form__row.ck-table-form__border-row .ck-labeled-field-view>.ck-label{font-size:var(--ck-font-size-tiny);text-align:center}.ck.ck-table-form .ck-form__row.ck-table-form__border-row .ck-table-form__border-style,.ck.ck-table-form .ck-form__row.ck-table-form__border-row .ck-table-form__border-width{max-width:80px;min-width:80px;width:80px}.ck.ck-table-form .ck-form__row.ck-table-form__dimensions-row{padding:0}.ck.ck-table-form .ck-form__row.ck-table-form__dimensions-row .ck-table-form__dimensions-row__height,.ck.ck-table-form .ck-form__row.ck-table-form__dimensions-row .ck-table-form__dimensions-row__width{margin:0}.ck.ck-table-form .ck-form__row.ck-table-form__dimensions-row .ck-table-form__dimension-operator{align-self:flex-end;display:inline-block;height:var(--ck-ui-component-min-height);line-height:var(--ck-ui-component-min-height);margin:0 var(--ck-spacing-small)}.ck.ck-table-form .ck.ck-labeled-field-view{padding-top:var(--ck-spacing-standard)}.ck.ck-table-form .ck.ck-labeled-field-view .ck.ck-labeled-field-view__status{border-radius:0}.ck-rounded-corners .ck.ck-table-form .ck.ck-labeled-field-view .ck.ck-labeled-field-view__status,.ck.ck-table-form .ck.ck-labeled-field-view .ck.ck-labeled-field-view__status.ck-rounded-corners{border-radius:var(--ck-border-radius)}.ck.ck-table-form .ck.ck-labeled-field-view .ck.ck-labeled-field-view__status{background:var(--ck-color-base-error);color:var(--ck-color-base-background);min-width:var(--ck-table-properties-min-error-width);padding:var(--ck-spacing-small) var(--ck-spacing-medium);text-align:center}.ck.ck-table-form .ck.ck-labeled-field-view .ck.ck-labeled-field-view__status:after{border-color:transparent transparent var(--ck-color-base-error) transparent;border-style:solid;border-width:0 var(--ck-table-properties-error-arrow-size) var(--ck-table-properties-error-arrow-size) var(--ck-table-properties-error-arrow-size)}.ck.ck-table-form .ck.ck-labeled-field-view .ck.ck-labeled-field-view__status{animation:ck-table-form-labeled-view-status-appear .15s ease both}.ck.ck-table-form .ck.ck-labeled-field-view .ck-input.ck-error:not(:focus)+.ck.ck-labeled-field-view__status{display:none}@keyframes ck-table-form-labeled-view-status-appear{0%{opacity:0}to{opacity:1}}',
              "",
              {
                version: 3,
                sources: [
                  "webpack://./node_modules/@ckeditor/ckeditor5-table/theme/tableform.css",
                  "webpack://./node_modules/@ckeditor/ckeditor5-theme-lark/theme/ckeditor5-table/tableform.css",
                  "webpack://./node_modules/@ckeditor/ckeditor5-theme-lark/theme/mixins/_rounded.css",
                ],
                names: [],
                mappings:
                  "AAWE,wHACC,cACD,CAEA,8DAEC,kBAAmB,CADnB,cAgBD,CAbC,qFAGC,kBAAmB,CAFnB,YAAa,CACb,6BAMD,CAEA,sMACC,WACD,CAIF,4CAEC,iBAoBD,CAlBC,8EAGC,2DAAgE,CADhE,QAAS,CADT,iBAAkB,CAGlB,8BAA+B,CAG/B,SAUD,CAPC,oFACC,UAAW,CAGX,QAAS,CAFT,iBAAkB,CAClB,wDAA6D,CAE7D,0BACD,CChDH,MACC,0CAA2C,CAC3C,2CACD,CAMI,2FACC,kCAAmC,CACnC,iBACD,CAGD,8KAIC,cAAe,CADf,cAAe,CADf,UAGD,CAGD,8DACC,SAcD,CAZC,yMAEC,QACD,CAEA,iGACC,mBAAoB,CACpB,oBAAqB,CACrB,wCAAyC,CACzC,6CAA8C,CAC9C,gCACD,CAIF,4CACC,sCAyBD,CAvBC,8ECxCD,eDyDC,CAjBA,mMCpCA,qCDqDA,CAjBA,8EAGC,qCAAsC,CACtC,qCAAsC,CAEtC,oDAAqD,CADrD,wDAAyD,CAEzD,iBAUD,CAPC,oFACC,2EAA4E,CAE5E,kBAAmB,CADnB,kJAED,CAdD,8EAgBC,iEACD,CAGA,6GACC,YACD,CAIF,oDACC,GACC,SACD,CAEA,GACC,SACD,CACD",
                sourcesContent: [
                  '/*\n * Copyright (c) 2003-2022, CKSource Holding sp. z o.o. All rights reserved.\n * For licensing, see LICENSE.md or https://ckeditor.com/legal/ckeditor-oss-license\n */\n\n.ck.ck-table-form {\n\t& .ck-form__row {\n\t\t&.ck-table-form__border-row {\n\t\t\tflex-wrap: wrap;\n\t\t}\n\n\t\t&.ck-table-form__background-row {\n\t\t\tflex-wrap: wrap;\n\t\t}\n\n\t\t&.ck-table-form__dimensions-row {\n\t\t\tflex-wrap: wrap;\n\t\t\talign-items: center;\n\n\t\t\t& .ck-labeled-field-view {\n\t\t\t\tdisplay: flex;\n\t\t\t\tflex-direction: column-reverse;\n\t\t\t\talign-items: center;\n\n\t\t\t\t& .ck.ck-dropdown {\n\t\t\t\t\tflex-grow: 0;\n\t\t\t\t}\n\t\t\t}\n\n\t\t\t& .ck-table-form__dimension-operator {\n\t\t\t\tflex-grow: 0;\n\t\t\t}\n\t\t}\n\t}\n\n\t& .ck.ck-labeled-field-view {\n\t\t/* Allow absolute positioning of the status (error) balloons. */\n\t\tposition: relative;\n\n\t\t& .ck.ck-labeled-field-view__status {\n\t\t\tposition: absolute;\n\t\t\tleft: 50%;\n\t\t\tbottom: calc( -1 * var(--ck-table-properties-error-arrow-size) );\n\t\t\ttransform: translate(-50%,100%);\n\n\t\t\t/* Make sure the balloon status stays on top of other form elements. */\n\t\t\tz-index: 1;\n\n\t\t\t/* The arrow pointing towards the field. */\n\t\t\t&::after {\n\t\t\t\tcontent: "";\n\t\t\t\tposition: absolute;\n\t\t\t\ttop: calc( -1 * var(--ck-table-properties-error-arrow-size) );\n\t\t\t\tleft: 50%;\n\t\t\t\ttransform: translateX( -50% );\n\t\t\t}\n\t\t}\n\t}\n}\n',
                  '/*\n * Copyright (c) 2003-2022, CKSource Holding sp. z o.o. All rights reserved.\n * For licensing, see LICENSE.md or https://ckeditor.com/legal/ckeditor-oss-license\n */\n\n@import "../mixins/_rounded.css";\n\n:root {\n\t--ck-table-properties-error-arrow-size: 6px;\n\t--ck-table-properties-min-error-width: 150px;\n}\n\n.ck.ck-table-form {\n\t& .ck-form__row {\n\t\t&.ck-table-form__border-row {\n\t\t\t& .ck-labeled-field-view {\n\t\t\t\t& > .ck-label {\n\t\t\t\t\tfont-size: var(--ck-font-size-tiny);\n\t\t\t\t\ttext-align: center;\n\t\t\t\t}\n\t\t\t}\n\n\t\t\t& .ck-table-form__border-style,\n\t\t\t& .ck-table-form__border-width {\n\t\t\t\twidth: 80px;\n\t\t\t\tmin-width: 80px;\n\t\t\t\tmax-width: 80px;\n\t\t\t}\n\t\t}\n\n\t\t&.ck-table-form__dimensions-row {\n\t\t\tpadding: 0;\n\n\t\t\t& .ck-table-form__dimensions-row__width,\n\t\t\t& .ck-table-form__dimensions-row__height {\n\t\t\t\tmargin: 0\n\t\t\t}\n\n\t\t\t& .ck-table-form__dimension-operator {\n\t\t\t\talign-self: flex-end;\n\t\t\t\tdisplay: inline-block;\n\t\t\t\theight: var(--ck-ui-component-min-height);\n\t\t\t\tline-height: var(--ck-ui-component-min-height);\n\t\t\t\tmargin: 0 var(--ck-spacing-small);\n\t\t\t}\n\t\t}\n\t}\n\n\t& .ck.ck-labeled-field-view {\n\t\tpadding-top: var(--ck-spacing-standard);\n\n\t\t& .ck.ck-labeled-field-view__status {\n\t\t\t@mixin ck-rounded-corners;\n\n\t\t\tbackground: var(--ck-color-base-error);\n\t\t\tcolor: var(--ck-color-base-background);\n\t\t\tpadding: var(--ck-spacing-small) var(--ck-spacing-medium);\n\t\t\tmin-width: var(--ck-table-properties-min-error-width);\n\t\t\ttext-align: center;\n\n\t\t\t/* The arrow pointing towards the field. */\n\t\t\t&::after {\n\t\t\t\tborder-color: transparent transparent var(--ck-color-base-error) transparent;\n\t\t\t\tborder-width: 0 var(--ck-table-properties-error-arrow-size) var(--ck-table-properties-error-arrow-size) var(--ck-table-properties-error-arrow-size);\n\t\t\t\tborder-style: solid;\n\t\t\t}\n\n\t\t\tanimation: ck-table-form-labeled-view-status-appear .15s ease both;\n\t\t}\n\n\t\t/* Hide the error balloon when the field is blurred. Makes the experience much more clear. */\n\t\t& .ck-input.ck-error:not(:focus) + .ck.ck-labeled-field-view__status {\n\t\t\tdisplay: none;\n\t\t}\n\t}\n}\n\n@keyframes ck-table-form-labeled-view-status-appear {\n\t0% {\n\t\topacity: 0;\n\t}\n\n\t100% {\n\t\topacity: 1;\n\t}\n}\n',
                  "/*\n * Copyright (c) 2003-2022, CKSource Holding sp. z o.o. All rights reserved.\n * For licensing, see LICENSE.md or https://ckeditor.com/legal/ckeditor-oss-license\n */\n\n/**\n * Implements rounded corner interface for .ck-rounded-corners class.\n *\n * @see $ck-border-radius\n */\n@define-mixin ck-rounded-corners {\n\tborder-radius: 0;\n\n\t@nest .ck-rounded-corners &,\n\t&.ck-rounded-corners {\n\t\tborder-radius: var(--ck-border-radius);\n\t\t@mixin-content;\n\t}\n}\n",
                ],
                sourceRoot: "",
              },
            ]);
            const a = s;
          },
          9221: (t, e, n) => {
            "use strict";
            n.d(e, { Z: () => a });
            var o = n(7537),
              i = n.n(o),
              r = n(3645),
              s = n.n(r)()(i());
            s.push([
              t.id,
              ".ck.ck-table-properties-form .ck-form__row.ck-table-properties-form__alignment-row{align-content:baseline;flex-basis:0;flex-wrap:wrap}.ck.ck-table-properties-form .ck-form__row.ck-table-properties-form__alignment-row .ck.ck-toolbar .ck-toolbar__items{flex-wrap:nowrap}.ck.ck-table-properties-form{width:320px}.ck.ck-table-properties-form .ck-form__row.ck-table-properties-form__alignment-row{align-self:flex-end;padding:0}.ck.ck-table-properties-form .ck-form__row.ck-table-properties-form__alignment-row .ck.ck-toolbar{background:none;margin-top:var(--ck-spacing-standard)}.ck.ck-table-properties-form .ck-form__row.ck-table-properties-form__alignment-row .ck.ck-toolbar .ck-toolbar__items>*{width:40px}",
              "",
              {
                version: 3,
                sources: [
                  "webpack://./node_modules/@ckeditor/ckeditor5-table/theme/tableproperties.css",
                  "webpack://./node_modules/@ckeditor/ckeditor5-theme-lark/theme/ckeditor5-table/tableproperties.css",
                ],
                names: [],
                mappings:
                  "AAOE,mFAGC,sBAAuB,CADvB,YAAa,CADb,cAOD,CAHC,qHACC,gBACD,CCTH,6BACC,WAmBD,CAhBE,mFACC,mBAAoB,CACpB,SAYD,CAVC,kGACC,eAAgB,CAGhB,qCAKD,CAHC,uHACC,UACD",
                sourcesContent: [
                  "/*\n * Copyright (c) 2003-2022, CKSource Holding sp. z o.o. All rights reserved.\n * For licensing, see LICENSE.md or https://ckeditor.com/legal/ckeditor-oss-license\n */\n\n.ck.ck-table-properties-form {\n\t& .ck-form__row {\n\t\t&.ck-table-properties-form__alignment-row {\n\t\t\tflex-wrap: wrap;\n\t\t\tflex-basis: 0;\n\t\t\talign-content: baseline;\n\n\t\t\t& .ck.ck-toolbar .ck-toolbar__items {\n\t\t\t\tflex-wrap: nowrap;\n\t\t\t}\n\t\t}\n\t}\n}\n",
                  "/*\n * Copyright (c) 2003-2022, CKSource Holding sp. z o.o. All rights reserved.\n * For licensing, see LICENSE.md or https://ckeditor.com/legal/ckeditor-oss-license\n */\n\n.ck.ck-table-properties-form {\n\twidth: 320px;\n\n\t& .ck-form__row {\n\t\t&.ck-table-properties-form__alignment-row {\n\t\t\talign-self: flex-end;\n\t\t\tpadding: 0;\n\n\t\t\t& .ck.ck-toolbar {\n\t\t\t\tbackground: none;\n\n\t\t\t\t/* Compensate for missing input label that would push the margin (toolbar has no inputs). */\n\t\t\t\tmargin-top: var(--ck-spacing-standard);\n\n\t\t\t\t& .ck-toolbar__items > * {\n\t\t\t\t\twidth: 40px;\n\t\t\t\t}\n\t\t\t}\n\t\t}\n\t}\n}\n",
                ],
                sourceRoot: "",
              },
            ]);
            const a = s;
          },
          5593: (t, e, n) => {
            "use strict";
            n.d(e, { Z: () => a });
            var o = n(7537),
              i = n.n(o),
              r = n(3645),
              s = n.n(r)()(i());
            s.push([
              t.id,
              ':root{--ck-table-selected-cell-background:rgba(158,207,250,.3)}.ck.ck-editor__editable .table table td.ck-editor__editable_selected,.ck.ck-editor__editable .table table th.ck-editor__editable_selected{box-shadow:unset;caret-color:transparent;outline:unset;position:relative}.ck.ck-editor__editable .table table td.ck-editor__editable_selected:after,.ck.ck-editor__editable .table table th.ck-editor__editable_selected:after{background-color:var(--ck-table-selected-cell-background);bottom:0;content:"";left:0;pointer-events:none;position:absolute;right:0;top:0}.ck.ck-editor__editable .table table td.ck-editor__editable_selected ::selection,.ck.ck-editor__editable .table table td.ck-editor__editable_selected:focus,.ck.ck-editor__editable .table table th.ck-editor__editable_selected ::selection,.ck.ck-editor__editable .table table th.ck-editor__editable_selected:focus{background-color:transparent}.ck.ck-editor__editable .table table td.ck-editor__editable_selected .ck-widget,.ck.ck-editor__editable .table table th.ck-editor__editable_selected .ck-widget{outline:unset}.ck.ck-editor__editable .table table td.ck-editor__editable_selected .ck-widget>.ck-widget__selection-handle,.ck.ck-editor__editable .table table th.ck-editor__editable_selected .ck-widget>.ck-widget__selection-handle{display:none}',
              "",
              {
                version: 3,
                sources: [
                  "webpack://./node_modules/@ckeditor/ckeditor5-theme-lark/theme/ckeditor5-table/tableselection.css",
                ],
                names: [],
                mappings:
                  "AAKA,MACC,wDACD,CAGC,0IAKC,gBAAiB,CAFjB,uBAAwB,CACxB,aAAc,CAFd,iBAiCD,CA3BC,sJAGC,yDAA0D,CAK1D,QAAS,CAPT,UAAW,CAKX,MAAO,CAJP,mBAAoB,CAEpB,iBAAkB,CAGlB,OAAQ,CAFR,KAID,CAEA,wTAEC,4BACD,CAMA,gKACC,aAKD,CAHC,0NACC,YACD",
                sourcesContent: [
                  "/*\n * Copyright (c) 2003-2022, CKSource Holding sp. z o.o. All rights reserved.\n * For licensing, see LICENSE.md or https://ckeditor.com/legal/ckeditor-oss-license\n */\n\n:root {\n\t--ck-table-selected-cell-background: hsla(208, 90%, 80%, .3);\n}\n\n.ck.ck-editor__editable .table table {\n\t& td.ck-editor__editable_selected,\n\t& th.ck-editor__editable_selected {\n\t\tposition: relative;\n\t\tcaret-color: transparent;\n\t\toutline: unset;\n\t\tbox-shadow: unset;\n\n\t\t/* https://github.com/ckeditor/ckeditor5/issues/6446 */\n\t\t&:after {\n\t\t\tcontent: '';\n\t\t\tpointer-events: none;\n\t\t\tbackground-color: var(--ck-table-selected-cell-background);\n\t\t\tposition: absolute;\n\t\t\ttop: 0;\n\t\t\tleft: 0;\n\t\t\tright: 0;\n\t\t\tbottom: 0;\n\t\t}\n\n\t\t& ::selection,\n\t\t&:focus {\n\t\t\tbackground-color: transparent;\n\t\t}\n\n\t\t/*\n\t\t * To reduce the amount of noise, all widgets in the table selection have no outline and no selection handle.\n\t\t * See https://github.com/ckeditor/ckeditor5/issues/9491.\n\t\t */\n\t\t& .ck-widget {\n\t\t\toutline: unset;\n\n\t\t\t& > .ck-widget__selection-handle {\n\t\t\t\tdisplay: none;\n\t\t\t}\n\t\t}\n\t}\n}\n",
                ],
                sourceRoot: "",
              },
            ]);
            const a = s;
          },
          4499: (t, e, n) => {
            "use strict";
            n.d(e, { Z: () => a });
            var o = n(7537),
              i = n.n(o),
              r = n(3645),
              s = n.n(r)()(i());
            s.push([
              t.id,
              ".ck.ck-button,a.ck.ck-button{align-items:center;display:inline-flex;justify-content:left;position:relative;-moz-user-select:none;-webkit-user-select:none;-ms-user-select:none;user-select:none}.ck.ck-button .ck-button__label,a.ck.ck-button .ck-button__label{display:none}.ck.ck-button.ck-button_with-text .ck-button__label,a.ck.ck-button.ck-button_with-text .ck-button__label{display:inline-block}.ck.ck-button:not(.ck-button_with-text),a.ck.ck-button:not(.ck-button_with-text){justify-content:center}.ck.ck-button,a.ck.ck-button{background:var(--ck-color-button-default-background)}.ck.ck-button:not(.ck-disabled):hover,a.ck.ck-button:not(.ck-disabled):hover{background:var(--ck-color-button-default-hover-background)}.ck.ck-button:not(.ck-disabled):active,a.ck.ck-button:not(.ck-disabled):active{background:var(--ck-color-button-default-active-background)}.ck.ck-button.ck-disabled,a.ck.ck-button.ck-disabled{background:var(--ck-color-button-default-disabled-background)}.ck.ck-button,a.ck.ck-button{border-radius:0}.ck-rounded-corners .ck.ck-button,.ck-rounded-corners a.ck.ck-button,.ck.ck-button.ck-rounded-corners,a.ck.ck-button.ck-rounded-corners{border-radius:var(--ck-border-radius)}.ck.ck-button,a.ck.ck-button{-webkit-appearance:none;border:1px solid transparent;cursor:default;font-size:inherit;line-height:1;min-height:var(--ck-ui-component-min-height);min-width:var(--ck-ui-component-min-height);padding:var(--ck-spacing-tiny);text-align:center;transition:box-shadow .2s ease-in-out,border .2s ease-in-out;vertical-align:middle;white-space:nowrap}.ck.ck-button:active,.ck.ck-button:focus,a.ck.ck-button:active,a.ck.ck-button:focus{border:var(--ck-focus-ring);box-shadow:var(--ck-focus-outer-shadow),0 0;outline:none}.ck.ck-button .ck-button__icon use,.ck.ck-button .ck-button__icon use *,a.ck.ck-button .ck-button__icon use,a.ck.ck-button .ck-button__icon use *{color:inherit}.ck.ck-button .ck-button__label,a.ck.ck-button .ck-button__label{color:inherit;cursor:inherit;font-size:inherit;font-weight:inherit;vertical-align:middle}[dir=ltr] .ck.ck-button .ck-button__label,[dir=ltr] a.ck.ck-button .ck-button__label{text-align:left}[dir=rtl] .ck.ck-button .ck-button__label,[dir=rtl] a.ck.ck-button .ck-button__label{text-align:right}.ck.ck-button .ck-button__keystroke,a.ck.ck-button .ck-button__keystroke{color:inherit}[dir=ltr] .ck.ck-button .ck-button__keystroke,[dir=ltr] a.ck.ck-button .ck-button__keystroke{margin-left:var(--ck-spacing-large)}[dir=rtl] .ck.ck-button .ck-button__keystroke,[dir=rtl] a.ck.ck-button .ck-button__keystroke{margin-right:var(--ck-spacing-large)}.ck.ck-button .ck-button__keystroke,a.ck.ck-button .ck-button__keystroke{font-weight:700;opacity:.7}.ck.ck-button.ck-disabled:active,.ck.ck-button.ck-disabled:focus,a.ck.ck-button.ck-disabled:active,a.ck.ck-button.ck-disabled:focus{box-shadow:var(--ck-focus-disabled-outer-shadow),0 0}.ck.ck-button.ck-disabled .ck-button__icon,.ck.ck-button.ck-disabled .ck-button__label,a.ck.ck-button.ck-disabled .ck-button__icon,a.ck.ck-button.ck-disabled .ck-button__label{opacity:var(--ck-disabled-opacity)}.ck.ck-button.ck-disabled .ck-button__keystroke,a.ck.ck-button.ck-disabled .ck-button__keystroke{opacity:.3}.ck.ck-button.ck-button_with-text,a.ck.ck-button.ck-button_with-text{padding:var(--ck-spacing-tiny) var(--ck-spacing-standard)}[dir=ltr] .ck.ck-button.ck-button_with-text .ck-button__icon,[dir=ltr] a.ck.ck-button.ck-button_with-text .ck-button__icon{margin-left:calc(var(--ck-spacing-small)*-1);margin-right:var(--ck-spacing-small)}[dir=rtl] .ck.ck-button.ck-button_with-text .ck-button__icon,[dir=rtl] a.ck.ck-button.ck-button_with-text .ck-button__icon{margin-left:var(--ck-spacing-small);margin-right:calc(var(--ck-spacing-small)*-1)}.ck.ck-button.ck-button_with-keystroke .ck-button__label,a.ck.ck-button.ck-button_with-keystroke .ck-button__label{flex-grow:1}.ck.ck-button.ck-on,a.ck.ck-button.ck-on{background:var(--ck-color-button-on-background)}.ck.ck-button.ck-on:not(.ck-disabled):hover,a.ck.ck-button.ck-on:not(.ck-disabled):hover{background:var(--ck-color-button-on-hover-background)}.ck.ck-button.ck-on:not(.ck-disabled):active,a.ck.ck-button.ck-on:not(.ck-disabled):active{background:var(--ck-color-button-on-active-background)}.ck.ck-button.ck-on.ck-disabled,a.ck.ck-button.ck-on.ck-disabled{background:var(--ck-color-button-on-disabled-background)}.ck.ck-button.ck-on,a.ck.ck-button.ck-on{color:var(--ck-color-button-on-color)}.ck.ck-button.ck-button-save,a.ck.ck-button.ck-button-save{color:var(--ck-color-button-save)}.ck.ck-button.ck-button-cancel,a.ck.ck-button.ck-button-cancel{color:var(--ck-color-button-cancel)}.ck.ck-button-action,a.ck.ck-button-action{background:var(--ck-color-button-action-background)}.ck.ck-button-action:not(.ck-disabled):hover,a.ck.ck-button-action:not(.ck-disabled):hover{background:var(--ck-color-button-action-hover-background)}.ck.ck-button-action:not(.ck-disabled):active,a.ck.ck-button-action:not(.ck-disabled):active{background:var(--ck-color-button-action-active-background)}.ck.ck-button-action.ck-disabled,a.ck.ck-button-action.ck-disabled{background:var(--ck-color-button-action-disabled-background)}.ck.ck-button-action,a.ck.ck-button-action{color:var(--ck-color-button-action-text)}.ck.ck-button-bold,a.ck.ck-button-bold{font-weight:700}",
              "",
              {
                version: 3,
                sources: [
                  "webpack://./node_modules/@ckeditor/ckeditor5-ui/theme/components/button/button.css",
                  "webpack://./node_modules/@ckeditor/ckeditor5-ui/theme/mixins/_unselectable.css",
                  "webpack://./node_modules/@ckeditor/ckeditor5-theme-lark/theme/ckeditor5-ui/components/button/button.css",
                  "webpack://./node_modules/@ckeditor/ckeditor5-theme-lark/theme/ckeditor5-ui/mixins/_button.css",
                  "webpack://./node_modules/@ckeditor/ckeditor5-theme-lark/theme/mixins/_rounded.css",
                  "webpack://./node_modules/@ckeditor/ckeditor5-theme-lark/theme/mixins/_focus.css",
                  "webpack://./node_modules/@ckeditor/ckeditor5-theme-lark/theme/mixins/_shadow.css",
                  "webpack://./node_modules/@ckeditor/ckeditor5-theme-lark/theme/mixins/_disabled.css",
                ],
                names: [],
                mappings:
                  "AAOA,6BAMC,kBAAmB,CADnB,mBAAoB,CAEpB,oBAAqB,CAHrB,iBAAkB,CCFlB,qBAAsB,CACtB,wBAAyB,CACzB,oBAAqB,CACrB,gBDkBD,CAdC,iEACC,YACD,CAGC,yGACC,oBACD,CAID,iFACC,sBACD,CEjBD,6BCAC,oDD4ID,CCzIE,6EACC,0DACD,CAEA,+EACC,2DACD,CAID,qDACC,6DACD,CDfD,6BEDC,eF6ID,CA5IA,wIEGE,qCFyIF,CA5IA,6BA6BC,uBAAwB,CANxB,4BAA6B,CAjB7B,cAAe,CAcf,iBAAkB,CAHlB,aAAc,CAJd,4CAA6C,CAD7C,2CAA4C,CAJ5C,8BAA+B,CAC/B,iBAAkB,CAiBlB,4DAA8D,CAnB9D,qBAAsB,CAFtB,kBAuID,CA7GC,oFGhCA,2BAA2B,CCF3B,2CAA8B,CDC9B,YHqCA,CAIC,kJAEC,aACD,CAGD,iEAIC,aAAc,CACd,cAAe,CAHf,iBAAkB,CAClB,mBAAoB,CAMpB,qBASD,CAlBA,qFAYE,eAMF,CAlBA,qFAgBE,gBAEF,CAEA,yEACC,aAYD,CAbA,6FAIE,mCASF,CAbA,6FAQE,oCAKF,CAbA,yEAWC,eAAiB,CACjB,UACD,CAIC,oIIrFD,oDJyFC,CAOA,gLKhGD,kCLkGC,CAEA,iGACC,UACD,CAGD,qEACC,yDAcD,CAXC,2HAEE,4CAA+C,CAC/C,oCAOF,CAVA,2HAQE,mCAAoC,CADpC,6CAGF,CAKA,mHACC,WACD,CAID,yCC/HA,+CDmIA,CChIC,yFACC,qDACD,CAEA,2FACC,sDACD,CAID,iEACC,wDACD,CDgHA,yCAGC,qCACD,CAEA,2DACC,iCACD,CAEA,+DACC,mCACD,CAID,2CC/IC,mDDoJD,CCjJE,2FACC,yDACD,CAEA,6FACC,0DACD,CAID,mEACC,4DACD,CDgID,2CAIC,wCACD,CAEA,uCAEC,eACD",
                sourcesContent: [
                  '/*\n * Copyright (c) 2003-2022, CKSource Holding sp. z o.o. All rights reserved.\n * For licensing, see LICENSE.md or https://ckeditor.com/legal/ckeditor-oss-license\n */\n\n@import "../../mixins/_unselectable.css";\n\n.ck.ck-button,\na.ck.ck-button {\n\t@mixin ck-unselectable;\n\n\tposition: relative;\n\tdisplay: inline-flex;\n\talign-items: center;\n\tjustify-content: left;\n\n\t& .ck-button__label {\n\t\tdisplay: none;\n\t}\n\n\t&.ck-button_with-text {\n\t\t& .ck-button__label {\n\t\t\tdisplay: inline-block;\n\t\t}\n\t}\n\n\t/* Center the icon horizontally in a button without text. */\n\t&:not(.ck-button_with-text)  {\n\t\tjustify-content: center;\n\t}\n}\n',
                  "/*\n * Copyright (c) 2003-2022, CKSource Holding sp. z o.o. All rights reserved.\n * For licensing, see LICENSE.md or https://ckeditor.com/legal/ckeditor-oss-license\n */\n\n/**\n * Makes element unselectable.\n */\n@define-mixin ck-unselectable {\n\t-moz-user-select: none;\n\t-webkit-user-select: none;\n\t-ms-user-select: none;\n\tuser-select: none\n}\n",
                  '/*\n * Copyright (c) 2003-2022, CKSource Holding sp. z o.o. All rights reserved.\n * For licensing, see LICENSE.md or https://ckeditor.com/legal/ckeditor-oss-license\n */\n\n@import "../../../mixins/_focus.css";\n@import "../../../mixins/_shadow.css";\n@import "../../../mixins/_disabled.css";\n@import "../../../mixins/_rounded.css";\n@import "../../mixins/_button.css";\n@import "@ckeditor/ckeditor5-ui/theme/mixins/_dir.css";\n\n.ck.ck-button,\na.ck.ck-button {\n\t@mixin ck-button-colors --ck-color-button-default;\n\t@mixin ck-rounded-corners;\n\n\twhite-space: nowrap;\n\tcursor: default;\n\tvertical-align: middle;\n\tpadding: var(--ck-spacing-tiny);\n\ttext-align: center;\n\n\t/* A very important piece of styling. Go to variable declaration to learn more. */\n\tmin-width: var(--ck-ui-component-min-height);\n\tmin-height: var(--ck-ui-component-min-height);\n\n\t/* Normalize the height of the line. Removing this will break consistent height\n\tamong text and text-less buttons (with icons). */\n\tline-height: 1;\n\n\t/* Enable font size inheritance, which allows fluid UI scaling. */\n\tfont-size: inherit;\n\n\t/* Avoid flickering when the foucs border shows up. */\n\tborder: 1px solid transparent;\n\n\t/* Apply some smooth transition to the box-shadow and border. */\n\ttransition: box-shadow .2s ease-in-out, border .2s ease-in-out;\n\n\t/* https://github.com/ckeditor/ckeditor5-theme-lark/issues/189 */\n\t-webkit-appearance: none;\n\n\t&:active,\n\t&:focus {\n\t\t@mixin ck-focus-ring;\n\t\t@mixin ck-box-shadow var(--ck-focus-outer-shadow);\n\t}\n\n\t/* Allow icon coloring using the text "color" property. */\n\t& .ck-button__icon {\n\t\t& use,\n\t\t& use * {\n\t\t\tcolor: inherit;\n\t\t}\n\t}\n\n\t& .ck-button__label {\n\t\t/* Enable font size inheritance, which allows fluid UI scaling. */\n\t\tfont-size: inherit;\n\t\tfont-weight: inherit;\n\t\tcolor: inherit;\n\t\tcursor: inherit;\n\n\t\t/* Must be consistent with .ck-icon\'s vertical align. Otherwise, buttons with and\n\t\twithout labels (but with icons) have different sizes in Chrome */\n\t\tvertical-align: middle;\n\n\t\t@mixin ck-dir ltr {\n\t\t\ttext-align: left;\n\t\t}\n\n\t\t@mixin ck-dir rtl {\n\t\t\ttext-align: right;\n\t\t}\n\t}\n\n\t& .ck-button__keystroke {\n\t\tcolor: inherit;\n\n\t\t@mixin ck-dir ltr {\n\t\t\tmargin-left: var(--ck-spacing-large);\n\t\t}\n\n\t\t@mixin ck-dir rtl {\n\t\t\tmargin-right: var(--ck-spacing-large);\n\t\t}\n\n\t\tfont-weight: bold;\n\t\topacity: .7;\n\t}\n\n\t/* https://github.com/ckeditor/ckeditor5-theme-lark/issues/70 */\n\t&.ck-disabled {\n\t\t&:active,\n\t\t&:focus {\n\t\t\t/* The disabled button should have a slightly less visible shadow when focused. */\n\t\t\t@mixin ck-box-shadow var(--ck-focus-disabled-outer-shadow);\n\t\t}\n\n\t\t& .ck-button__icon {\n\t\t\t@mixin ck-disabled;\n\t\t}\n\n\t\t/* https://github.com/ckeditor/ckeditor5-theme-lark/issues/98 */\n\t\t& .ck-button__label {\n\t\t\t@mixin ck-disabled;\n\t\t}\n\n\t\t& .ck-button__keystroke {\n\t\t\topacity: .3;\n\t\t}\n\t}\n\n\t&.ck-button_with-text {\n\t\tpadding: var(--ck-spacing-tiny) var(--ck-spacing-standard);\n\n\t\t/* stylelint-disable-next-line no-descending-specificity */\n\t\t& .ck-button__icon {\n\t\t\t@mixin ck-dir ltr {\n\t\t\t\tmargin-left: calc(-1 * var(--ck-spacing-small));\n\t\t\t\tmargin-right: var(--ck-spacing-small);\n\t\t\t}\n\n\t\t\t@mixin ck-dir rtl {\n\t\t\t\tmargin-right: calc(-1 * var(--ck-spacing-small));\n\t\t\t\tmargin-left: var(--ck-spacing-small);\n\t\t\t}\n\t\t}\n\t}\n\n\t&.ck-button_with-keystroke {\n\t\t/* stylelint-disable-next-line no-descending-specificity */\n\t\t& .ck-button__label {\n\t\t\tflex-grow: 1;\n\t\t}\n\t}\n\n\t/* A style of the button which is currently on, e.g. its feature is active. */\n\t&.ck-on {\n\t\t@mixin ck-button-colors --ck-color-button-on;\n\n\t\tcolor: var(--ck-color-button-on-color);\n\t}\n\n\t&.ck-button-save {\n\t\tcolor: var(--ck-color-button-save);\n\t}\n\n\t&.ck-button-cancel {\n\t\tcolor: var(--ck-color-button-cancel);\n\t}\n}\n\n/* A style of the button which handles the primary action. */\n.ck.ck-button-action,\na.ck.ck-button-action {\n\t@mixin ck-button-colors --ck-color-button-action;\n\n\tcolor: var(--ck-color-button-action-text);\n}\n\n.ck.ck-button-bold,\na.ck.ck-button-bold {\n\tfont-weight: bold;\n}\n',
                  "/*\n * Copyright (c) 2003-2022, CKSource Holding sp. z o.o. All rights reserved.\n * For licensing, see LICENSE.md or https://ckeditor.com/legal/ckeditor-oss-license\n */\n\n/**\n * Implements a button of given background color.\n *\n * @param {String} $background - Background color of the button.\n * @param {String} $border - Border color of the button.\n */\n@define-mixin ck-button-colors $prefix {\n\tbackground: var($(prefix)-background);\n\n\t&:not(.ck-disabled) {\n\t\t&:hover {\n\t\t\tbackground: var($(prefix)-hover-background);\n\t\t}\n\n\t\t&:active {\n\t\t\tbackground: var($(prefix)-active-background);\n\t\t}\n\t}\n\n\t/* https://github.com/ckeditor/ckeditor5-theme-lark/issues/98 */\n\t&.ck-disabled {\n\t\tbackground: var($(prefix)-disabled-background);\n\t}\n}\n",
                  "/*\n * Copyright (c) 2003-2022, CKSource Holding sp. z o.o. All rights reserved.\n * For licensing, see LICENSE.md or https://ckeditor.com/legal/ckeditor-oss-license\n */\n\n/**\n * Implements rounded corner interface for .ck-rounded-corners class.\n *\n * @see $ck-border-radius\n */\n@define-mixin ck-rounded-corners {\n\tborder-radius: 0;\n\n\t@nest .ck-rounded-corners &,\n\t&.ck-rounded-corners {\n\t\tborder-radius: var(--ck-border-radius);\n\t\t@mixin-content;\n\t}\n}\n",
                  "/*\n * Copyright (c) 2003-2022, CKSource Holding sp. z o.o. All rights reserved.\n * For licensing, see LICENSE.md or https://ckeditor.com/legal/ckeditor-oss-license\n */\n\n/**\n * A visual style of focused element's border.\n */\n@define-mixin ck-focus-ring {\n\t/* Disable native outline. */\n\toutline: none;\n\tborder: var(--ck-focus-ring)\n}\n",
                  "/*\n * Copyright (c) 2003-2022, CKSource Holding sp. z o.o. All rights reserved.\n * For licensing, see LICENSE.md or https://ckeditor.com/legal/ckeditor-oss-license\n */\n\n/**\n * A helper to combine multiple shadows.\n */\n@define-mixin ck-box-shadow $shadowA, $shadowB: 0 0 {\n\tbox-shadow: $shadowA, $shadowB;\n}\n\n/**\n * Gives an element a drop shadow so it looks like a floating panel.\n */\n@define-mixin ck-drop-shadow {\n\t@mixin ck-box-shadow var(--ck-drop-shadow);\n}\n",
                  "/*\n * Copyright (c) 2003-2022, CKSource Holding sp. z o.o. All rights reserved.\n * For licensing, see LICENSE.md or https://ckeditor.com/legal/ckeditor-oss-license\n */\n\n/**\n * A class which indicates that an element holding it is disabled.\n */\n@define-mixin ck-disabled {\n\topacity: var(--ck-disabled-opacity);\n}\n",
                ],
                sourceRoot: "",
              },
            ]);
            const a = s;
          },
          9681: (t, e, n) => {
            "use strict";
            n.d(e, { Z: () => a });
            var o = n(7537),
              i = n.n(o),
              r = n(3645),
              s = n.n(r)()(i());
            s.push([
              t.id,
              ".ck.ck-button.ck-switchbutton .ck-button__toggle,.ck.ck-button.ck-switchbutton .ck-button__toggle .ck-button__toggle__inner{display:block}:root{--ck-switch-button-toggle-width:2.6153846154em;--ck-switch-button-toggle-inner-size:calc(1.07692em + 1px);--ck-switch-button-translation:calc(var(--ck-switch-button-toggle-width) - var(--ck-switch-button-toggle-inner-size) - 2px);--ck-switch-button-inner-hover-shadow:0 0 0 5px var(--ck-color-switch-button-inner-shadow)}.ck.ck-button.ck-switchbutton,.ck.ck-button.ck-switchbutton.ck-on:active,.ck.ck-button.ck-switchbutton.ck-on:focus,.ck.ck-button.ck-switchbutton.ck-on:hover,.ck.ck-button.ck-switchbutton:active,.ck.ck-button.ck-switchbutton:focus,.ck.ck-button.ck-switchbutton:hover{background:transparent;color:inherit}[dir=ltr] .ck.ck-button.ck-switchbutton .ck-button__label{margin-right:calc(var(--ck-spacing-large)*2)}[dir=rtl] .ck.ck-button.ck-switchbutton .ck-button__label{margin-left:calc(var(--ck-spacing-large)*2)}.ck.ck-button.ck-switchbutton .ck-button__toggle{border-radius:0}.ck-rounded-corners .ck.ck-button.ck-switchbutton .ck-button__toggle,.ck.ck-button.ck-switchbutton .ck-button__toggle.ck-rounded-corners{border-radius:var(--ck-border-radius)}[dir=ltr] .ck.ck-button.ck-switchbutton .ck-button__toggle{margin-left:auto}[dir=rtl] .ck.ck-button.ck-switchbutton .ck-button__toggle{margin-right:auto}.ck.ck-button.ck-switchbutton .ck-button__toggle{background:var(--ck-color-switch-button-off-background);border:1px solid transparent;transition:background .4s ease,box-shadow .2s ease-in-out,outline .2s ease-in-out;width:var(--ck-switch-button-toggle-width)}.ck.ck-button.ck-switchbutton .ck-button__toggle .ck-button__toggle__inner{border-radius:0}.ck-rounded-corners .ck.ck-button.ck-switchbutton .ck-button__toggle .ck-button__toggle__inner,.ck.ck-button.ck-switchbutton .ck-button__toggle .ck-button__toggle__inner.ck-rounded-corners{border-radius:var(--ck-border-radius);border-radius:calc(var(--ck-border-radius)*.5)}.ck.ck-button.ck-switchbutton .ck-button__toggle .ck-button__toggle__inner{background:var(--ck-color-switch-button-inner-background);height:var(--ck-switch-button-toggle-inner-size);transition:all .3s ease;width:var(--ck-switch-button-toggle-inner-size)}.ck.ck-button.ck-switchbutton .ck-button__toggle:hover{background:var(--ck-color-switch-button-off-hover-background)}.ck.ck-button.ck-switchbutton .ck-button__toggle:hover .ck-button__toggle__inner{box-shadow:var(--ck-switch-button-inner-hover-shadow)}.ck.ck-button.ck-switchbutton.ck-disabled .ck-button__toggle{opacity:var(--ck-disabled-opacity)}.ck.ck-button.ck-switchbutton:focus{border-color:transparent;box-shadow:none;outline:none}.ck.ck-button.ck-switchbutton:focus .ck-button__toggle{box-shadow:0 0 0 1px var(--ck-color-base-background),0 0 0 5px var(--ck-color-focus-outer-shadow);outline:var(--ck-focus-ring);outline-offset:1px}.ck.ck-button.ck-switchbutton.ck-on .ck-button__toggle{background:var(--ck-color-switch-button-on-background)}.ck.ck-button.ck-switchbutton.ck-on .ck-button__toggle:hover{background:var(--ck-color-switch-button-on-hover-background)}[dir=ltr] .ck.ck-button.ck-switchbutton.ck-on .ck-button__toggle .ck-button__toggle__inner{transform:translateX(var( --ck-switch-button-translation ))}[dir=rtl] .ck.ck-button.ck-switchbutton.ck-on .ck-button__toggle .ck-button__toggle__inner{transform:translateX(calc(var( --ck-switch-button-translation )*-1))}",
              "",
              {
                version: 3,
                sources: [
                  "webpack://./node_modules/@ckeditor/ckeditor5-ui/theme/components/button/switchbutton.css",
                  "webpack://./node_modules/@ckeditor/ckeditor5-theme-lark/theme/ckeditor5-ui/components/button/switchbutton.css",
                  "webpack://./node_modules/@ckeditor/ckeditor5-theme-lark/theme/mixins/_rounded.css",
                  "webpack://./node_modules/@ckeditor/ckeditor5-theme-lark/theme/mixins/_disabled.css",
                ],
                names: [],
                mappings:
                  "AASE,4HACC,aACD,CCCF,MAEC,8CAA+C,CAE/C,0DAAgE,CAChE,2HAIC,CACD,0FACD,CAOC,0QAEC,sBAAuB,CADvB,aAED,CAEA,0DAGE,4CAOF,CAVA,0DAQE,2CAEF,CAEA,iDCpCA,eD4EA,CAxCA,yIChCC,qCDwED,CAxCA,2DAKE,gBAmCF,CAxCA,2DAUE,iBA8BF,CAxCA,iDAkBC,uDAAwD,CAFxD,4BAA6B,CAD7B,iFAAsF,CAEtF,0CAuBD,CApBC,2ECxDD,eDmEC,CAXA,6LCpDA,qCAAsC,CDsDpC,8CASF,CAXA,2EAOC,yDAA0D,CAD1D,gDAAiD,CAIjD,uBAA0B,CAL1B,+CAMD,CAEA,uDACC,6DAKD,CAHC,iFACC,qDACD,CAIF,6DEhFA,kCFkFA,CAGA,oCACC,wBAAyB,CAEzB,eAAgB,CADhB,YAQD,CALC,uDACC,iGAAmG,CAEnG,4BAA6B,CAD7B,kBAED,CAKA,uDACC,sDAkBD,CAhBC,6DACC,4DACD,CAEA,2FAKE,2DAMF,CAXA,2FASE,oEAEF",
                sourcesContent: [
                  "/*\n * Copyright (c) 2003-2022, CKSource Holding sp. z o.o. All rights reserved.\n * For licensing, see LICENSE.md or https://ckeditor.com/legal/ckeditor-oss-license\n */\n\n.ck.ck-button.ck-switchbutton {\n\t& .ck-button__toggle {\n\t\tdisplay: block;\n\n\t\t& .ck-button__toggle__inner {\n\t\t\tdisplay: block;\n\t\t}\n\t}\n}\n",
                  '/*\n * Copyright (c) 2003-2022, CKSource Holding sp. z o.o. All rights reserved.\n * For licensing, see LICENSE.md or https://ckeditor.com/legal/ckeditor-oss-license\n */\n\n@import "../../../mixins/_rounded.css";\n@import "../../../mixins/_disabled.css";\n@import "@ckeditor/ckeditor5-ui/theme/mixins/_dir.css";\n\n/* Note: To avoid rendering issues (aliasing) but to preserve the responsive nature\nof the component, floating–point numbers have been used which, for the default font size\n(see: --ck-font-size-base), will generate simple integers. */\n:root {\n\t/* 34px at 13px font-size */\n\t--ck-switch-button-toggle-width: 2.6153846154em;\n\t/* 14px at 13px font-size */\n\t--ck-switch-button-toggle-inner-size: calc(1.0769230769em + 1px);\n\t--ck-switch-button-translation: calc(\n\t\tvar(--ck-switch-button-toggle-width) -\n\t\tvar(--ck-switch-button-toggle-inner-size) -\n\t\t2px /* Border */\n\t);\n\t--ck-switch-button-inner-hover-shadow: 0 0 0 5px var(--ck-color-switch-button-inner-shadow);\n}\n\n.ck.ck-button.ck-switchbutton {\n\t/* Unlike a regular button, the switch button text color and background should never change.\n\t * Changing toggle switch (background, outline) is enough to carry the information about the\n\t * state of the entire component (https://github.com/ckeditor/ckeditor5/issues/12519)\n\t */\n\t&, &:hover, &:focus, &:active, &.ck-on:hover, &.ck-on:focus, &.ck-on:active {\n\t\tcolor: inherit;\n\t\tbackground: transparent;\n\t}\n\n\t& .ck-button__label {\n\t\t@mixin ck-dir ltr {\n\t\t\t/* Separate the label from the switch */\n\t\t\tmargin-right: calc(2 * var(--ck-spacing-large));\n\t\t}\n\n\t\t@mixin ck-dir rtl {\n\t\t\t/* Separate the label from the switch */\n\t\t\tmargin-left: calc(2 * var(--ck-spacing-large));\n\t\t}\n\t}\n\n\t& .ck-button__toggle {\n\t\t@mixin ck-rounded-corners;\n\n\t\t@mixin ck-dir ltr {\n\t\t\t/* Make sure the toggle is always to the right as far as possible. */\n\t\t\tmargin-left: auto;\n\t\t}\n\n\t\t@mixin ck-dir rtl {\n\t\t\t/* Make sure the toggle is always to the left as far as possible. */\n\t\t\tmargin-right: auto;\n\t\t}\n\n\t\t/* Apply some smooth transition to the box-shadow and border. */\n\t\t/* Gently animate the background color of the toggle switch */\n\t\ttransition: background 400ms ease, box-shadow .2s ease-in-out, outline .2s ease-in-out;\n\t\tborder: 1px solid transparent;\n\t\twidth: var(--ck-switch-button-toggle-width);\n\t\tbackground: var(--ck-color-switch-button-off-background);\n\n\t\t& .ck-button__toggle__inner {\n\t\t\t@mixin ck-rounded-corners {\n\t\t\t\tborder-radius: calc(.5 * var(--ck-border-radius));\n\t\t\t}\n\n\t\t\twidth: var(--ck-switch-button-toggle-inner-size);\n\t\t\theight: var(--ck-switch-button-toggle-inner-size);\n\t\t\tbackground: var(--ck-color-switch-button-inner-background);\n\n\t\t\t/* Gently animate the inner part of the toggle switch */\n\t\t\ttransition: all 300ms ease;\n\t\t}\n\n\t\t&:hover {\n\t\t\tbackground: var(--ck-color-switch-button-off-hover-background);\n\n\t\t\t& .ck-button__toggle__inner {\n\t\t\t\tbox-shadow: var(--ck-switch-button-inner-hover-shadow);\n\t\t\t}\n\t\t}\n\t}\n\n\t&.ck-disabled .ck-button__toggle {\n\t\t@mixin ck-disabled;\n\t}\n\n\t/* Overriding default .ck-button:focus styles + an outline around the toogle */\n\t&:focus {\n\t\tborder-color: transparent;\n\t\toutline: none;\n\t\tbox-shadow: none;\n\n\t\t& .ck-button__toggle {\n\t\t\tbox-shadow: 0 0 0 1px var(--ck-color-base-background), 0 0 0 5px var(--ck-color-focus-outer-shadow);\n\t\t\toutline-offset: 1px;\n\t\t\toutline: var(--ck-focus-ring);\n\t\t}\n\t}\n\n\t/* stylelint-disable-next-line no-descending-specificity */\n\t&.ck-on {\n\t\t& .ck-button__toggle {\n\t\t\tbackground: var(--ck-color-switch-button-on-background);\n\n\t\t\t&:hover {\n\t\t\t\tbackground: var(--ck-color-switch-button-on-hover-background);\n\t\t\t}\n\n\t\t\t& .ck-button__toggle__inner {\n\t\t\t\t/*\n\t\t\t\t* Move the toggle switch to the right. It will be animated.\n\t\t\t\t*/\n\t\t\t\t@mixin ck-dir ltr {\n\t\t\t\t\ttransform: translateX( var( --ck-switch-button-translation ) );\n\t\t\t\t}\n\n\t\t\t\t@mixin ck-dir rtl {\n\t\t\t\t\ttransform: translateX( calc( -1 * var( --ck-switch-button-translation ) ) );\n\t\t\t\t}\n\t\t\t}\n\t\t}\n\t}\n}\n',
                  "/*\n * Copyright (c) 2003-2022, CKSource Holding sp. z o.o. All rights reserved.\n * For licensing, see LICENSE.md or https://ckeditor.com/legal/ckeditor-oss-license\n */\n\n/**\n * Implements rounded corner interface for .ck-rounded-corners class.\n *\n * @see $ck-border-radius\n */\n@define-mixin ck-rounded-corners {\n\tborder-radius: 0;\n\n\t@nest .ck-rounded-corners &,\n\t&.ck-rounded-corners {\n\t\tborder-radius: var(--ck-border-radius);\n\t\t@mixin-content;\n\t}\n}\n",
                  "/*\n * Copyright (c) 2003-2022, CKSource Holding sp. z o.o. All rights reserved.\n * For licensing, see LICENSE.md or https://ckeditor.com/legal/ckeditor-oss-license\n */\n\n/**\n * A class which indicates that an element holding it is disabled.\n */\n@define-mixin ck-disabled {\n\topacity: var(--ck-disabled-opacity);\n}\n",
                ],
                sourceRoot: "",
              },
            ]);
            const a = s;
          },
          4923: (t, e, n) => {
            "use strict";
            n.d(e, { Z: () => a });
            var o = n(7537),
              i = n.n(o),
              r = n(3645),
              s = n.n(r)()(i());
            s.push([
              t.id,
              ".ck.ck-color-grid{display:grid}:root{--ck-color-grid-tile-size:24px;--ck-color-color-grid-check-icon:#166fd4}.ck.ck-color-grid{grid-gap:5px;padding:8px}.ck.ck-color-grid__tile{border:0;height:var(--ck-color-grid-tile-size);min-height:var(--ck-color-grid-tile-size);min-width:var(--ck-color-grid-tile-size);padding:0;transition:box-shadow .2s ease;width:var(--ck-color-grid-tile-size)}.ck.ck-color-grid__tile.ck-disabled{cursor:unset;transition:unset}.ck.ck-color-grid__tile.ck-color-table__color-tile_bordered{box-shadow:0 0 0 1px var(--ck-color-base-border)}.ck.ck-color-grid__tile .ck.ck-icon{color:var(--ck-color-color-grid-check-icon);display:none}.ck.ck-color-grid__tile.ck-on{box-shadow:inset 0 0 0 1px var(--ck-color-base-background),0 0 0 2px var(--ck-color-base-text)}.ck.ck-color-grid__tile.ck-on .ck.ck-icon{display:block}.ck.ck-color-grid__tile.ck-on,.ck.ck-color-grid__tile:focus:not(.ck-disabled),.ck.ck-color-grid__tile:hover:not(.ck-disabled){border:0}.ck.ck-color-grid__tile:focus:not(.ck-disabled),.ck.ck-color-grid__tile:hover:not(.ck-disabled){box-shadow:inset 0 0 0 1px var(--ck-color-base-background),0 0 0 2px var(--ck-color-focus-border)}.ck.ck-color-grid__label{padding:0 var(--ck-spacing-standard)}",
              "",
              {
                version: 3,
                sources: [
                  "webpack://./node_modules/@ckeditor/ckeditor5-ui/theme/components/colorgrid/colorgrid.css",
                  "webpack://./node_modules/@ckeditor/ckeditor5-theme-lark/theme/ckeditor5-ui/components/colorgrid/colorgrid.css",
                ],
                names: [],
                mappings:
                  "AAKA,kBACC,YACD,CCAA,MACC,8BAA+B,CAK/B,wCACD,CAEA,kBACC,YAAa,CACb,WACD,CAEA,wBAOC,QAAS,CALT,qCAAsC,CAEtC,yCAA0C,CAD1C,wCAAyC,CAEzC,SAAU,CACV,8BAA+B,CAL/B,oCAyCD,CAjCC,oCACC,YAAa,CACb,gBACD,CAEA,4DACC,gDACD,CAEA,oCAEC,2CAA4C,CAD5C,YAED,CAEA,8BACC,8FAKD,CAHC,0CACC,aACD,CAGD,8HAIC,QACD,CAEA,gGAEC,iGACD,CAGD,yBACC,oCACD",
                sourcesContent: [
                  "/*\n * Copyright (c) 2003-2022, CKSource Holding sp. z o.o. All rights reserved.\n * For licensing, see LICENSE.md or https://ckeditor.com/legal/ckeditor-oss-license\n */\n\n.ck.ck-color-grid {\n\tdisplay: grid;\n}\n",
                  '/*\n * Copyright (c) 2003-2022, CKSource Holding sp. z o.o. All rights reserved.\n * For licensing, see LICENSE.md or https://ckeditor.com/legal/ckeditor-oss-license\n */\n\n@import "../../../mixins/_rounded.css";\n\n:root {\n\t--ck-color-grid-tile-size: 24px;\n\n\t/* Not using global colors here because these may change but some colors in a pallette\n\t * require special treatment. For instance, this ensures no matter what the UI text color is,\n\t * the check icon will look good on the black color tile. */\n\t--ck-color-color-grid-check-icon: hsl(212, 81%, 46%);\n}\n\n.ck.ck-color-grid {\n\tgrid-gap: 5px;\n\tpadding: 8px;\n}\n\n.ck.ck-color-grid__tile {\n\twidth: var(--ck-color-grid-tile-size);\n\theight: var(--ck-color-grid-tile-size);\n\tmin-width: var(--ck-color-grid-tile-size);\n\tmin-height: var(--ck-color-grid-tile-size);\n\tpadding: 0;\n\ttransition: .2s ease box-shadow;\n\tborder: 0;\n\n\t&.ck-disabled {\n\t\tcursor: unset;\n\t\ttransition: unset;\n\t}\n\n\t&.ck-color-table__color-tile_bordered {\n\t\tbox-shadow: 0 0 0 1px var(--ck-color-base-border);\n\t}\n\n\t& .ck.ck-icon {\n\t\tdisplay: none;\n\t\tcolor: var(--ck-color-color-grid-check-icon);\n\t}\n\n\t&.ck-on {\n\t\tbox-shadow: inset 0 0 0 1px var(--ck-color-base-background), 0 0 0 2px var(--ck-color-base-text);\n\n\t\t& .ck.ck-icon {\n\t\t\tdisplay: block;\n\t\t}\n\t}\n\n\t&.ck-on,\n\t&:focus:not( .ck-disabled ),\n\t&:hover:not( .ck-disabled ) {\n\t\t/* Disable the default .ck-button\'s border ring. */\n\t\tborder: 0;\n\t}\n\n\t&:focus:not( .ck-disabled ),\n\t&:hover:not( .ck-disabled ) {\n\t\tbox-shadow: inset 0 0 0 1px var(--ck-color-base-background), 0 0 0 2px var(--ck-color-focus-border);\n\t}\n}\n\n.ck.ck-color-grid__label {\n\tpadding: 0 var(--ck-spacing-standard);\n}\n',
                ],
                sourceRoot: "",
              },
            ]);
            const a = s;
          },
          3488: (t, e, n) => {
            "use strict";
            n.d(e, { Z: () => a });
            var o = n(7537),
              i = n.n(o),
              r = n(3645),
              s = n.n(r)()(i());
            s.push([
              t.id,
              ":root{--ck-dropdown-max-width:75vw}.ck.ck-dropdown{display:inline-block;position:relative}.ck.ck-dropdown .ck-dropdown__arrow{pointer-events:none;z-index:var(--ck-z-default)}.ck.ck-dropdown .ck-button.ck-dropdown__button{width:100%}.ck.ck-dropdown .ck-dropdown__panel{display:none;max-width:var(--ck-dropdown-max-width);position:absolute;z-index:var(--ck-z-modal)}.ck.ck-dropdown .ck-dropdown__panel.ck-dropdown__panel-visible{display:inline-block}.ck.ck-dropdown .ck-dropdown__panel.ck-dropdown__panel_n,.ck.ck-dropdown .ck-dropdown__panel.ck-dropdown__panel_ne,.ck.ck-dropdown .ck-dropdown__panel.ck-dropdown__panel_nme,.ck.ck-dropdown .ck-dropdown__panel.ck-dropdown__panel_nmw,.ck.ck-dropdown .ck-dropdown__panel.ck-dropdown__panel_nw{bottom:100%}.ck.ck-dropdown .ck-dropdown__panel.ck-dropdown__panel_s,.ck.ck-dropdown .ck-dropdown__panel.ck-dropdown__panel_se,.ck.ck-dropdown .ck-dropdown__panel.ck-dropdown__panel_sme,.ck.ck-dropdown .ck-dropdown__panel.ck-dropdown__panel_smw,.ck.ck-dropdown .ck-dropdown__panel.ck-dropdown__panel_sw{bottom:auto;top:100%}.ck.ck-dropdown .ck-dropdown__panel.ck-dropdown__panel_ne,.ck.ck-dropdown .ck-dropdown__panel.ck-dropdown__panel_se{left:0}.ck.ck-dropdown .ck-dropdown__panel.ck-dropdown__panel_nw,.ck.ck-dropdown .ck-dropdown__panel.ck-dropdown__panel_sw{right:0}.ck.ck-dropdown .ck-dropdown__panel.ck-dropdown__panel_n,.ck.ck-dropdown .ck-dropdown__panel.ck-dropdown__panel_s{left:50%;transform:translateX(-50%)}.ck.ck-dropdown .ck-dropdown__panel.ck-dropdown__panel_nmw,.ck.ck-dropdown .ck-dropdown__panel.ck-dropdown__panel_smw{left:75%;transform:translateX(-75%)}.ck.ck-dropdown .ck-dropdown__panel.ck-dropdown__panel_nme,.ck.ck-dropdown .ck-dropdown__panel.ck-dropdown__panel_sme{left:25%;transform:translateX(-25%)}.ck.ck-toolbar .ck-dropdown__panel{z-index:calc(var(--ck-z-modal) + 1)}:root{--ck-dropdown-arrow-size:calc(var(--ck-icon-size)*0.5)}.ck.ck-dropdown{font-size:inherit}.ck.ck-dropdown .ck-dropdown__arrow{width:var(--ck-dropdown-arrow-size)}[dir=ltr] .ck.ck-dropdown .ck-dropdown__arrow{margin-left:var(--ck-spacing-standard);right:var(--ck-spacing-standard)}[dir=rtl] .ck.ck-dropdown .ck-dropdown__arrow{left:var(--ck-spacing-standard);margin-right:var(--ck-spacing-small)}.ck.ck-dropdown.ck-disabled .ck-dropdown__arrow{opacity:var(--ck-disabled-opacity)}[dir=ltr] .ck.ck-dropdown .ck-button.ck-dropdown__button:not(.ck-button_with-text){padding-left:var(--ck-spacing-small)}[dir=rtl] .ck.ck-dropdown .ck-button.ck-dropdown__button:not(.ck-button_with-text){padding-right:var(--ck-spacing-small)}.ck.ck-dropdown .ck-button.ck-dropdown__button .ck-button__label{overflow:hidden;text-overflow:ellipsis;width:7em}.ck.ck-dropdown .ck-button.ck-dropdown__button.ck-disabled .ck-button__label{opacity:var(--ck-disabled-opacity)}.ck.ck-dropdown .ck-button.ck-dropdown__button.ck-on{border-bottom-left-radius:0;border-bottom-right-radius:0}.ck.ck-dropdown .ck-button.ck-dropdown__button.ck-dropdown__button_label-width_auto .ck-button__label{width:auto}.ck.ck-dropdown .ck-button.ck-dropdown__button.ck-off:active,.ck.ck-dropdown .ck-button.ck-dropdown__button.ck-on:active{box-shadow:none}.ck.ck-dropdown .ck-button.ck-dropdown__button.ck-off:active:focus,.ck.ck-dropdown .ck-button.ck-dropdown__button.ck-on:active:focus{box-shadow:var(--ck-focus-outer-shadow),0 0}.ck.ck-dropdown__panel{border-radius:0}.ck-rounded-corners .ck.ck-dropdown__panel,.ck.ck-dropdown__panel.ck-rounded-corners{border-radius:var(--ck-border-radius)}.ck.ck-dropdown__panel{background:var(--ck-color-dropdown-panel-background);border:1px solid var(--ck-color-dropdown-panel-border);bottom:0;box-shadow:var(--ck-drop-shadow),0 0;min-width:100%}.ck.ck-dropdown__panel.ck-dropdown__panel_se{border-top-left-radius:0}.ck.ck-dropdown__panel.ck-dropdown__panel_sw{border-top-right-radius:0}.ck.ck-dropdown__panel.ck-dropdown__panel_ne{border-bottom-left-radius:0}.ck.ck-dropdown__panel.ck-dropdown__panel_nw{border-bottom-right-radius:0}",
              "",
              {
                version: 3,
                sources: [
                  "webpack://./node_modules/@ckeditor/ckeditor5-ui/theme/components/dropdown/dropdown.css",
                  "webpack://./node_modules/@ckeditor/ckeditor5-theme-lark/theme/ckeditor5-ui/components/dropdown/dropdown.css",
                  "webpack://./node_modules/@ckeditor/ckeditor5-theme-lark/theme/mixins/_disabled.css",
                  "webpack://./node_modules/@ckeditor/ckeditor5-theme-lark/theme/mixins/_shadow.css",
                  "webpack://./node_modules/@ckeditor/ckeditor5-theme-lark/theme/mixins/_rounded.css",
                ],
                names: [],
                mappings:
                  "AAKA,MACC,4BACD,CAEA,gBACC,oBAAqB,CACrB,iBA2ED,CAzEC,oCACC,mBAAoB,CACpB,2BACD,CAGA,+CACC,UACD,CAEA,oCACC,YAAa,CAEb,sCAAuC,CAEvC,iBAAkB,CAHlB,yBA4DD,CAvDC,+DACC,oBACD,CAEA,mSAKC,WACD,CAEA,mSAUC,WAAY,CADZ,QAED,CAEA,oHAEC,MACD,CAEA,oHAEC,OACD,CAEA,kHAGC,QAAS,CACT,0BACD,CAEA,sHAGC,QAAS,CACT,0BACD,CAEA,sHAGC,QAAS,CACT,0BACD,CAQF,mCACC,mCACD,CCpFA,MACC,sDACD,CAEA,gBAEC,iBA2ED,CAzEC,oCACC,mCACD,CAGC,8CAIC,sCAAuC,CAHvC,gCAID,CAIA,8CACC,+BAAgC,CAGhC,oCACD,CAGD,gDC/BA,kCDiCA,CAIE,mFAEC,oCACD,CAIA,mFAEC,qCACD,CAID,iEAEC,eAAgB,CAChB,sBAAuB,CAFvB,SAGD,CAGA,6EC1DD,kCD4DC,CAGA,qDACC,2BAA4B,CAC5B,4BACD,CAEA,sGACC,UACD,CAGA,yHAEC,eAKD,CAHC,qIE7EF,2CF+EE,CAKH,uBGlFC,eH8GD,CA5BA,qFG9EE,qCH0GF,CA5BA,uBAIC,oDAAqD,CACrD,sDAAuD,CACvD,QAAS,CE1FT,oCAA8B,CF6F9B,cAmBD,CAfC,6CACC,wBACD,CAEA,6CACC,yBACD,CAEA,6CACC,2BACD,CAEA,6CACC,4BACD",
                sourcesContent: [
                  "/*\n * Copyright (c) 2003-2022, CKSource Holding sp. z o.o. All rights reserved.\n * For licensing, see LICENSE.md or https://ckeditor.com/legal/ckeditor-oss-license\n */\n\n:root {\n\t--ck-dropdown-max-width: 75vw;\n}\n\n.ck.ck-dropdown {\n\tdisplay: inline-block;\n\tposition: relative;\n\n\t& .ck-dropdown__arrow {\n\t\tpointer-events: none;\n\t\tz-index: var(--ck-z-default);\n\t}\n\n\t/* Dropdown button should span horizontally, e.g. in vertical toolbars */\n\t& .ck-button.ck-dropdown__button {\n\t\twidth: 100%;\n\t}\n\n\t& .ck-dropdown__panel {\n\t\tdisplay: none;\n\t\tz-index: var(--ck-z-modal);\n\t\tmax-width: var(--ck-dropdown-max-width);\n\n\t\tposition: absolute;\n\n\t\t&.ck-dropdown__panel-visible {\n\t\t\tdisplay: inline-block;\n\t\t}\n\n\t\t&.ck-dropdown__panel_ne,\n\t\t&.ck-dropdown__panel_nw,\n\t\t&.ck-dropdown__panel_n,\n\t\t&.ck-dropdown__panel_nmw,\n\t\t&.ck-dropdown__panel_nme {\n\t\t\tbottom: 100%;\n\t\t}\n\n\t\t&.ck-dropdown__panel_se,\n\t\t&.ck-dropdown__panel_sw,\n\t\t&.ck-dropdown__panel_smw,\n\t\t&.ck-dropdown__panel_sme,\n\t\t&.ck-dropdown__panel_s {\n\t\t\t/*\n\t\t\t * Using transform: translate3d( 0, 100%, 0 ) causes blurry dropdown on Chrome 67-78+ on non-retina displays.\n\t\t\t * See https://github.com/ckeditor/ckeditor5/issues/1053.\n\t\t\t */\n\t\t\ttop: 100%;\n\t\t\tbottom: auto;\n\t\t}\n\n\t\t&.ck-dropdown__panel_ne,\n\t\t&.ck-dropdown__panel_se {\n\t\t\tleft: 0px;\n\t\t}\n\n\t\t&.ck-dropdown__panel_nw,\n\t\t&.ck-dropdown__panel_sw {\n\t\t\tright: 0px;\n\t\t}\n\n\t\t&.ck-dropdown__panel_s,\n\t\t&.ck-dropdown__panel_n {\n\t\t\t/* Positioning panels relative to the center of the button */\n\t\t\tleft: 50%;\n\t\t\ttransform: translateX(-50%);\n\t\t}\n\n\t\t&.ck-dropdown__panel_nmw,\n\t\t&.ck-dropdown__panel_smw {\n\t\t\t/* Positioning panels relative to the middle-west of the button */\n\t\t\tleft: 75%;\n\t\t\ttransform: translateX(-75%);\n\t\t}\n\n\t\t&.ck-dropdown__panel_nme,\n\t\t&.ck-dropdown__panel_sme {\n\t\t\t/* Positioning panels relative to the middle-east of the button */\n\t\t\tleft: 25%;\n\t\t\ttransform: translateX(-25%);\n\t\t}\n\t}\n}\n\n/*\n * Toolbar dropdown panels should be always above the UI (eg. other dropdown panels) from the editor's content.\n * See https://github.com/ckeditor/ckeditor5/issues/7874\n */\n.ck.ck-toolbar .ck-dropdown__panel {\n\tz-index: calc( var(--ck-z-modal) + 1 );\n}\n",
                  '/*\n * Copyright (c) 2003-2022, CKSource Holding sp. z o.o. All rights reserved.\n * For licensing, see LICENSE.md or https://ckeditor.com/legal/ckeditor-oss-license\n */\n\n@import "../../../mixins/_rounded.css";\n@import "../../../mixins/_disabled.css";\n@import "../../../mixins/_shadow.css";\n@import "@ckeditor/ckeditor5-ui/theme/mixins/_dir.css";\n\n:root {\n\t--ck-dropdown-arrow-size: calc(0.5 * var(--ck-icon-size));\n}\n\n.ck.ck-dropdown {\n\t/* Enable font size inheritance, which allows fluid UI scaling. */\n\tfont-size: inherit;\n\n\t& .ck-dropdown__arrow {\n\t\twidth: var(--ck-dropdown-arrow-size);\n\t}\n\n\t@mixin ck-dir ltr {\n\t\t& .ck-dropdown__arrow {\n\t\t\tright: var(--ck-spacing-standard);\n\n\t\t\t/* A space to accommodate the triangle. */\n\t\t\tmargin-left: var(--ck-spacing-standard);\n\t\t}\n\t}\n\n\t@mixin ck-dir rtl {\n\t\t& .ck-dropdown__arrow {\n\t\t\tleft: var(--ck-spacing-standard);\n\n\t\t\t/* A space to accommodate the triangle. */\n\t\t\tmargin-right: var(--ck-spacing-small);\n\t\t}\n\t}\n\n\t&.ck-disabled .ck-dropdown__arrow {\n\t\t@mixin ck-disabled;\n\t}\n\n\t& .ck-button.ck-dropdown__button {\n\t\t@mixin ck-dir ltr {\n\t\t\t&:not(.ck-button_with-text) {\n\t\t\t\t/* Make sure dropdowns with just an icon have the right inner spacing */\n\t\t\t\tpadding-left: var(--ck-spacing-small);\n\t\t\t}\n\t\t}\n\n\t\t@mixin ck-dir rtl {\n\t\t\t&:not(.ck-button_with-text) {\n\t\t\t\t/* Make sure dropdowns with just an icon have the right inner spacing */\n\t\t\t\tpadding-right: var(--ck-spacing-small);\n\t\t\t}\n\t\t}\n\n\t\t/* #23 */\n\t\t& .ck-button__label {\n\t\t\twidth: 7em;\n\t\t\toverflow: hidden;\n\t\t\ttext-overflow: ellipsis;\n\t\t}\n\n\t\t/* https://github.com/ckeditor/ckeditor5-theme-lark/issues/70 */\n\t\t&.ck-disabled .ck-button__label {\n\t\t\t@mixin ck-disabled;\n\t\t}\n\n\t\t/* https://github.com/ckeditor/ckeditor5/issues/816 */\n\t\t&.ck-on {\n\t\t\tborder-bottom-left-radius: 0;\n\t\t\tborder-bottom-right-radius: 0;\n\t\t}\n\n\t\t&.ck-dropdown__button_label-width_auto .ck-button__label {\n\t\t\twidth: auto;\n\t\t}\n\n\t\t/* https://github.com/ckeditor/ckeditor5/issues/8699 */\n\t\t&.ck-off:active,\n\t\t&.ck-on:active {\n\t\t\tbox-shadow: none;\n\t\t\t\n\t\t\t&:focus {\n\t\t\t\t@mixin ck-box-shadow var(--ck-focus-outer-shadow);\n\t\t\t}\n\t\t}\n\t}\n}\n\n.ck.ck-dropdown__panel {\n\t@mixin ck-rounded-corners;\n\t@mixin ck-drop-shadow;\n\n\tbackground: var(--ck-color-dropdown-panel-background);\n\tborder: 1px solid var(--ck-color-dropdown-panel-border);\n\tbottom: 0;\n\n\t/* Make sure the panel is at least as wide as the drop-down\'s button. */\n\tmin-width: 100%;\n\n\t/* Disabled corner border radius to be consistent with the .dropdown__button\n\thttps://github.com/ckeditor/ckeditor5/issues/816 */\n\t&.ck-dropdown__panel_se {\n\t\tborder-top-left-radius: 0;\n\t}\n\n\t&.ck-dropdown__panel_sw {\n\t\tborder-top-right-radius: 0;\n\t}\n\n\t&.ck-dropdown__panel_ne {\n\t\tborder-bottom-left-radius: 0;\n\t}\n\n\t&.ck-dropdown__panel_nw {\n\t\tborder-bottom-right-radius: 0;\n\t}\n}\n',
                  "/*\n * Copyright (c) 2003-2022, CKSource Holding sp. z o.o. All rights reserved.\n * For licensing, see LICENSE.md or https://ckeditor.com/legal/ckeditor-oss-license\n */\n\n/**\n * A class which indicates that an element holding it is disabled.\n */\n@define-mixin ck-disabled {\n\topacity: var(--ck-disabled-opacity);\n}\n",
                  "/*\n * Copyright (c) 2003-2022, CKSource Holding sp. z o.o. All rights reserved.\n * For licensing, see LICENSE.md or https://ckeditor.com/legal/ckeditor-oss-license\n */\n\n/**\n * A helper to combine multiple shadows.\n */\n@define-mixin ck-box-shadow $shadowA, $shadowB: 0 0 {\n\tbox-shadow: $shadowA, $shadowB;\n}\n\n/**\n * Gives an element a drop shadow so it looks like a floating panel.\n */\n@define-mixin ck-drop-shadow {\n\t@mixin ck-box-shadow var(--ck-drop-shadow);\n}\n",
                  "/*\n * Copyright (c) 2003-2022, CKSource Holding sp. z o.o. All rights reserved.\n * For licensing, see LICENSE.md or https://ckeditor.com/legal/ckeditor-oss-license\n */\n\n/**\n * Implements rounded corner interface for .ck-rounded-corners class.\n *\n * @see $ck-border-radius\n */\n@define-mixin ck-rounded-corners {\n\tborder-radius: 0;\n\n\t@nest .ck-rounded-corners &,\n\t&.ck-rounded-corners {\n\t\tborder-radius: var(--ck-border-radius);\n\t\t@mixin-content;\n\t}\n}\n",
                ],
                sourceRoot: "",
              },
            ]);
            const a = s;
          },
          6875: (t, e, n) => {
            "use strict";
            n.d(e, { Z: () => a });
            var o = n(7537),
              i = n.n(o),
              r = n(3645),
              s = n.n(r)()(i());
            s.push([
              t.id,
              ".ck.ck-dropdown .ck-dropdown__panel .ck-list{border-radius:0}.ck-rounded-corners .ck.ck-dropdown .ck-dropdown__panel .ck-list,.ck.ck-dropdown .ck-dropdown__panel .ck-list.ck-rounded-corners{border-radius:var(--ck-border-radius);border-top-left-radius:0}.ck.ck-dropdown .ck-dropdown__panel .ck-list .ck-list__item:first-child .ck-button{border-radius:0}.ck-rounded-corners .ck.ck-dropdown .ck-dropdown__panel .ck-list .ck-list__item:first-child .ck-button,.ck.ck-dropdown .ck-dropdown__panel .ck-list .ck-list__item:first-child .ck-button.ck-rounded-corners{border-radius:var(--ck-border-radius);border-bottom-left-radius:0;border-bottom-right-radius:0;border-top-left-radius:0}.ck.ck-dropdown .ck-dropdown__panel .ck-list .ck-list__item:last-child .ck-button{border-radius:0}.ck-rounded-corners .ck.ck-dropdown .ck-dropdown__panel .ck-list .ck-list__item:last-child .ck-button,.ck.ck-dropdown .ck-dropdown__panel .ck-list .ck-list__item:last-child .ck-button.ck-rounded-corners{border-radius:var(--ck-border-radius);border-top-left-radius:0;border-top-right-radius:0}",
              "",
              {
                version: 3,
                sources: [
                  "webpack://./node_modules/@ckeditor/ckeditor5-theme-lark/theme/ckeditor5-ui/components/dropdown/listdropdown.css",
                  "webpack://./node_modules/@ckeditor/ckeditor5-theme-lark/theme/mixins/_rounded.css",
                ],
                names: [],
                mappings:
                  "AAOA,6CCIC,eDqBD,CAzBA,iICQE,qCAAsC,CDJtC,wBAqBF,CAfE,mFCND,eDYC,CANA,6MCFA,qCAAsC,CDKpC,2BAA4B,CAC5B,4BAA6B,CAF7B,wBAIF,CAEA,kFCdD,eDmBC,CALA,2MCVA,qCAAsC,CDYpC,wBAAyB,CACzB,yBAEF",
                sourcesContent: [
                  '/*\n * Copyright (c) 2003-2022, CKSource Holding sp. z o.o. All rights reserved.\n * For licensing, see LICENSE.md or https://ckeditor.com/legal/ckeditor-oss-license\n */\n\n@import "../../../mixins/_rounded.css";\n\n.ck.ck-dropdown .ck-dropdown__panel .ck-list {\n\t/* Disabled radius of top-left border to be consistent with .dropdown__button\n\thttps://github.com/ckeditor/ckeditor5/issues/816 */\n\t@mixin ck-rounded-corners {\n\t\tborder-top-left-radius: 0;\n\t}\n\n\t/* Make sure the button belonging to the first/last child of the list goes well with the\n\tborder radius of the entire panel. */\n\t& .ck-list__item {\n\t\t&:first-child .ck-button {\n\t\t\t@mixin ck-rounded-corners {\n\t\t\t\tborder-top-left-radius: 0;\n\t\t\t\tborder-bottom-left-radius: 0;\n\t\t\t\tborder-bottom-right-radius: 0;\n\t\t\t}\n\t\t}\n\n\t\t&:last-child .ck-button {\n\t\t\t@mixin ck-rounded-corners {\n\t\t\t\tborder-top-left-radius: 0;\n\t\t\t\tborder-top-right-radius: 0;\n\t\t\t}\n\t\t}\n\t}\n}\n',
                  "/*\n * Copyright (c) 2003-2022, CKSource Holding sp. z o.o. All rights reserved.\n * For licensing, see LICENSE.md or https://ckeditor.com/legal/ckeditor-oss-license\n */\n\n/**\n * Implements rounded corner interface for .ck-rounded-corners class.\n *\n * @see $ck-border-radius\n */\n@define-mixin ck-rounded-corners {\n\tborder-radius: 0;\n\n\t@nest .ck-rounded-corners &,\n\t&.ck-rounded-corners {\n\t\tborder-radius: var(--ck-border-radius);\n\t\t@mixin-content;\n\t}\n}\n",
                ],
                sourceRoot: "",
              },
            ]);
            const a = s;
          },
          66: (t, e, n) => {
            "use strict";
            n.d(e, { Z: () => a });
            var o = n(7537),
              i = n.n(o),
              r = n(3645),
              s = n.n(r)()(i());
            s.push([
              t.id,
              '.ck.ck-splitbutton{font-size:inherit}.ck.ck-splitbutton .ck-splitbutton__action:focus{z-index:calc(var(--ck-z-default) + 1)}:root{--ck-color-split-button-hover-background:#ebebeb;--ck-color-split-button-hover-border:#b3b3b3}[dir=ltr] .ck.ck-splitbutton.ck-splitbutton_open>.ck-splitbutton__action,[dir=ltr] .ck.ck-splitbutton:hover>.ck-splitbutton__action{border-bottom-right-radius:unset;border-top-right-radius:unset}[dir=rtl] .ck.ck-splitbutton.ck-splitbutton_open>.ck-splitbutton__action,[dir=rtl] .ck.ck-splitbutton:hover>.ck-splitbutton__action{border-bottom-left-radius:unset;border-top-left-radius:unset}.ck.ck-splitbutton>.ck-splitbutton__arrow{min-width:unset}[dir=ltr] .ck.ck-splitbutton>.ck-splitbutton__arrow{border-bottom-left-radius:unset;border-top-left-radius:unset}[dir=rtl] .ck.ck-splitbutton>.ck-splitbutton__arrow{border-bottom-right-radius:unset;border-top-right-radius:unset}.ck.ck-splitbutton>.ck-splitbutton__arrow svg{width:var(--ck-dropdown-arrow-size)}.ck.ck-splitbutton.ck-splitbutton_open>.ck-button:not(.ck-on):not(.ck-disabled):not(:hover),.ck.ck-splitbutton:hover>.ck-button:not(.ck-on):not(.ck-disabled):not(:hover){background:var(--ck-color-split-button-hover-background)}.ck.ck-splitbutton.ck-splitbutton_open>.ck-splitbutton__arrow:not(.ck-disabled):after,.ck.ck-splitbutton:hover>.ck-splitbutton__arrow:not(.ck-disabled):after{background-color:var(--ck-color-split-button-hover-border);content:"";height:100%;position:absolute;width:1px}[dir=ltr] .ck.ck-splitbutton.ck-splitbutton_open>.ck-splitbutton__arrow:not(.ck-disabled):after,[dir=ltr] .ck.ck-splitbutton:hover>.ck-splitbutton__arrow:not(.ck-disabled):after{left:-1px}[dir=rtl] .ck.ck-splitbutton.ck-splitbutton_open>.ck-splitbutton__arrow:not(.ck-disabled):after,[dir=rtl] .ck.ck-splitbutton:hover>.ck-splitbutton__arrow:not(.ck-disabled):after{right:-1px}.ck.ck-splitbutton.ck-splitbutton_open{border-radius:0}.ck-rounded-corners .ck.ck-splitbutton.ck-splitbutton_open,.ck.ck-splitbutton.ck-splitbutton_open.ck-rounded-corners{border-radius:var(--ck-border-radius)}.ck-rounded-corners .ck.ck-splitbutton.ck-splitbutton_open>.ck-splitbutton__action,.ck.ck-splitbutton.ck-splitbutton_open.ck-rounded-corners>.ck-splitbutton__action{border-bottom-left-radius:0}.ck-rounded-corners .ck.ck-splitbutton.ck-splitbutton_open>.ck-splitbutton__arrow,.ck.ck-splitbutton.ck-splitbutton_open.ck-rounded-corners>.ck-splitbutton__arrow{border-bottom-right-radius:0}',
              "",
              {
                version: 3,
                sources: [
                  "webpack://./node_modules/@ckeditor/ckeditor5-ui/theme/components/dropdown/splitbutton.css",
                  "webpack://./node_modules/@ckeditor/ckeditor5-theme-lark/theme/ckeditor5-ui/components/dropdown/splitbutton.css",
                  "webpack://./node_modules/@ckeditor/ckeditor5-theme-lark/theme/mixins/_rounded.css",
                ],
                names: [],
                mappings:
                  "AAKA,mBAEC,iBAKD,CAHC,iDACC,qCACD,CCJD,MACC,gDAAyD,CACzD,4CACD,CAMC,oIAKE,gCAAiC,CADjC,6BASF,CAbA,oIAWE,+BAAgC,CADhC,4BAGF,CAEA,0CAGC,eAiBD,CApBA,oDAQE,+BAAgC,CADhC,4BAaF,CApBA,oDAcE,gCAAiC,CADjC,6BAOF,CAHC,8CACC,mCACD,CASA,0KACC,wDACD,CAIA,8JAKC,0DAA2D,CAJ3D,UAAW,CAGX,WAAY,CAFZ,iBAAkB,CAClB,SAGD,CAGC,kLACC,SACD,CAIA,kLACC,UACD,CAMF,uCC7EA,eDuFA,CAVA,qHCzEC,qCDmFD,CARE,qKACC,2BACD,CAEA,mKACC,4BACD",
                sourcesContent: [
                  "/*\n * Copyright (c) 2003-2022, CKSource Holding sp. z o.o. All rights reserved.\n * For licensing, see LICENSE.md or https://ckeditor.com/legal/ckeditor-oss-license\n */\n\n.ck.ck-splitbutton {\n\t/* Enable font size inheritance, which allows fluid UI scaling. */\n\tfont-size: inherit;\n\n\t& .ck-splitbutton__action:focus {\n\t\tz-index: calc(var(--ck-z-default) + 1);\n\t}\n}\n\n",
                  '/*\n * Copyright (c) 2003-2022, CKSource Holding sp. z o.o. All rights reserved.\n * For licensing, see LICENSE.md or https://ckeditor.com/legal/ckeditor-oss-license\n */\n\n@import "../../../mixins/_rounded.css";\n\n:root {\n\t--ck-color-split-button-hover-background: hsl(0, 0%, 92%);\n\t--ck-color-split-button-hover-border: hsl(0, 0%, 70%);\n}\n\n.ck.ck-splitbutton {\n\t/*\n\t * Note: ck-rounded and ck-dir mixins don\'t go together (because they both use @nest).\n\t */\n\t&:hover > .ck-splitbutton__action,\n\t&.ck-splitbutton_open > .ck-splitbutton__action {\n\t\t@nest [dir="ltr"] & {\n\t\t\t/* Don\'t round the action button on the right side */\n\t\t\tborder-top-right-radius: unset;\n\t\t\tborder-bottom-right-radius: unset;\n\t\t}\n\n\t\t@nest [dir="rtl"] & {\n\t\t\t/* Don\'t round the action button on the left side */\n\t\t\tborder-top-left-radius: unset;\n\t\t\tborder-bottom-left-radius: unset;\n\t\t}\n\t}\n\n\t& > .ck-splitbutton__arrow {\n\t\t/* It\'s a text-less button and since the icon is positioned absolutely in such situation,\n\t\tit must get some arbitrary min-width. */\n\t\tmin-width: unset;\n\n\t\t@nest [dir="ltr"] & {\n\t\t\t/* Don\'t round the arrow button on the left side */\n\t\t\tborder-top-left-radius: unset;\n\t\t\tborder-bottom-left-radius: unset;\n\t\t}\n\n\t\t@nest [dir="rtl"] & {\n\t\t\t/* Don\'t round the arrow button on the right side */\n\t\t\tborder-top-right-radius: unset;\n\t\t\tborder-bottom-right-radius: unset;\n\t\t}\n\n\t\t& svg {\n\t\t\twidth: var(--ck-dropdown-arrow-size);\n\t\t}\n\t}\n\n\t/* When the split button is "open" (the arrow is on) or being hovered, it should get some styling\n\tas a whole. The background of both buttons should stand out and there should be a visual\n\tseparation between both buttons. */\n\t&.ck-splitbutton_open,\n\t&:hover {\n\t\t/* When the split button hovered as a whole, not as individual buttons. */\n\t\t& > .ck-button:not(.ck-on):not(.ck-disabled):not(:hover) {\n\t\t\tbackground: var(--ck-color-split-button-hover-background);\n\t\t}\n\n\t\t/* Splitbutton separator needs to be set with the ::after pseudoselector\n\t\tto display properly the borders on focus */\n\t\t& > .ck-splitbutton__arrow:not(.ck-disabled)::after {\n\t\t\tcontent: \'\';\n\t\t\tposition: absolute;\n\t\t\twidth: 1px;\n\t\t\theight: 100%;\n\t\t\tbackground-color: var(--ck-color-split-button-hover-border);\n\t\t}\n\n\t\t@nest [dir="ltr"] & {\n\t\t\t& > .ck-splitbutton__arrow:not(.ck-disabled)::after {\n\t\t\t\tleft: -1px;\n\t\t\t}\n\t\t}\n\n\t\t@nest [dir="rtl"] & {\n\t\t\t& > .ck-splitbutton__arrow:not(.ck-disabled)::after {\n\t\t\t\tright: -1px;\n\t\t\t}\n\t\t}\n\t}\n\n\t/* Don\'t round the bottom left and right corners of the buttons when "open"\n\thttps://github.com/ckeditor/ckeditor5/issues/816 */\n\t&.ck-splitbutton_open {\n\t\t@mixin ck-rounded-corners {\n\t\t\t& > .ck-splitbutton__action {\n\t\t\t\tborder-bottom-left-radius: 0;\n\t\t\t}\n\n\t\t\t& > .ck-splitbutton__arrow {\n\t\t\t\tborder-bottom-right-radius: 0;\n\t\t\t}\n\t\t}\n\t}\n}\n',
                  "/*\n * Copyright (c) 2003-2022, CKSource Holding sp. z o.o. All rights reserved.\n * For licensing, see LICENSE.md or https://ckeditor.com/legal/ckeditor-oss-license\n */\n\n/**\n * Implements rounded corner interface for .ck-rounded-corners class.\n *\n * @see $ck-border-radius\n */\n@define-mixin ck-rounded-corners {\n\tborder-radius: 0;\n\n\t@nest .ck-rounded-corners &,\n\t&.ck-rounded-corners {\n\t\tborder-radius: var(--ck-border-radius);\n\t\t@mixin-content;\n\t}\n}\n",
                ],
                sourceRoot: "",
              },
            ]);
            const a = s;
          },
          5075: (t, e, n) => {
            "use strict";
            n.d(e, { Z: () => a });
            var o = n(7537),
              i = n.n(o),
              r = n(3645),
              s = n.n(r)()(i());
            s.push([
              t.id,
              ":root{--ck-toolbar-dropdown-max-width:60vw}.ck.ck-toolbar-dropdown>.ck-dropdown__panel{max-width:var(--ck-toolbar-dropdown-max-width);width:max-content}.ck.ck-toolbar-dropdown>.ck-dropdown__panel .ck-button:focus{z-index:calc(var(--ck-z-default) + 1)}.ck.ck-toolbar-dropdown .ck-toolbar{border:0}",
              "",
              {
                version: 3,
                sources: [
                  "webpack://./node_modules/@ckeditor/ckeditor5-ui/theme/components/dropdown/toolbardropdown.css",
                  "webpack://./node_modules/@ckeditor/ckeditor5-theme-lark/theme/ckeditor5-ui/components/dropdown/toolbardropdown.css",
                ],
                names: [],
                mappings:
                  "AAKA,MACC,oCACD,CAEA,4CAGC,8CAA+C,CAD/C,iBAQD,CAJE,6DACC,qCACD,CCZF,oCACC,QACD",
                sourcesContent: [
                  "/*\n * Copyright (c) 2003-2022, CKSource Holding sp. z o.o. All rights reserved.\n * For licensing, see LICENSE.md or https://ckeditor.com/legal/ckeditor-oss-license\n */\n\n:root {\n\t--ck-toolbar-dropdown-max-width: 60vw;\n}\n\n.ck.ck-toolbar-dropdown > .ck-dropdown__panel {\n\t/* https://github.com/ckeditor/ckeditor5/issues/5586 */\n\twidth: max-content;\n\tmax-width: var(--ck-toolbar-dropdown-max-width);\n\n\t& .ck-button {\n\t\t&:focus {\n\t\t\tz-index: calc(var(--ck-z-default) + 1);\n\t\t}\n\t}\n}\n",
                  "/*\n * Copyright (c) 2003-2022, CKSource Holding sp. z o.o. All rights reserved.\n * For licensing, see LICENSE.md or https://ckeditor.com/legal/ckeditor-oss-license\n */\n\n.ck.ck-toolbar-dropdown .ck-toolbar {\n\tborder: 0;\n}\n",
                ],
                sourceRoot: "",
              },
            ]);
            const a = s;
          },
          4547: (t, e, n) => {
            "use strict";
            n.d(e, { Z: () => a });
            var o = n(7537),
              i = n.n(o),
              r = n(3645),
              s = n.n(r)()(i());
            s.push([
              t.id,
              ":root{--ck-color-editable-blur-selection:#d9d9d9}.ck.ck-editor__editable:not(.ck-editor__nested-editable){border-radius:0}.ck-rounded-corners .ck.ck-editor__editable:not(.ck-editor__nested-editable),.ck.ck-editor__editable.ck-rounded-corners:not(.ck-editor__nested-editable){border-radius:var(--ck-border-radius)}.ck.ck-editor__editable.ck-focused:not(.ck-editor__nested-editable){border:var(--ck-focus-ring);box-shadow:var(--ck-inner-shadow),0 0;outline:none}.ck.ck-editor__editable_inline{border:1px solid transparent;overflow:auto;padding:0 var(--ck-spacing-standard)}.ck.ck-editor__editable_inline[dir=ltr]{text-align:left}.ck.ck-editor__editable_inline[dir=rtl]{text-align:right}.ck.ck-editor__editable_inline>:first-child{margin-top:var(--ck-spacing-large)}.ck.ck-editor__editable_inline>:last-child{margin-bottom:var(--ck-spacing-large)}.ck.ck-editor__editable_inline.ck-blurred ::selection{background:var(--ck-color-editable-blur-selection)}.ck.ck-balloon-panel.ck-toolbar-container[class*=arrow_n]:after{border-bottom-color:var(--ck-color-base-foreground)}.ck.ck-balloon-panel.ck-toolbar-container[class*=arrow_s]:after{border-top-color:var(--ck-color-base-foreground)}",
              "",
              {
                version: 3,
                sources: [
                  "webpack://./node_modules/@ckeditor/ckeditor5-theme-lark/theme/ckeditor5-ui/components/editorui/editorui.css",
                  "webpack://./node_modules/@ckeditor/ckeditor5-theme-lark/theme/mixins/_rounded.css",
                  "webpack://./node_modules/@ckeditor/ckeditor5-theme-lark/theme/mixins/_focus.css",
                  "webpack://./node_modules/@ckeditor/ckeditor5-theme-lark/theme/mixins/_shadow.css",
                ],
                names: [],
                mappings:
                  "AAWA,MACC,0CACD,CAEA,yDCJC,eDWD,CAPA,yJCAE,qCDOF,CAJC,oEEPA,2BAA2B,CCF3B,qCAA8B,CDC9B,YFWA,CAGD,+BAGC,4BAA6B,CAF7B,aAAc,CACd,oCA6BD,CA1BC,wCACC,eACD,CAEA,wCACC,gBACD,CAGA,4CACC,kCACD,CAGA,2CAKC,qCACD,CAGA,sDACC,kDACD,CAKA,gEACC,mDACD,CAIA,gEACC,gDACD",
                sourcesContent: [
                  '/*\n * Copyright (c) 2003-2022, CKSource Holding sp. z o.o. All rights reserved.\n * For licensing, see LICENSE.md or https://ckeditor.com/legal/ckeditor-oss-license\n */\n\n@import "../../../mixins/_rounded.css";\n@import "../../../mixins/_disabled.css";\n@import "../../../mixins/_shadow.css";\n@import "../../../mixins/_focus.css";\n@import "../../mixins/_button.css";\n\n:root {\n\t--ck-color-editable-blur-selection: hsl(0, 0%, 85%);\n}\n\n.ck.ck-editor__editable:not(.ck-editor__nested-editable) {\n\t@mixin ck-rounded-corners;\n\n\t&.ck-focused {\n\t\t@mixin ck-focus-ring;\n\t\t@mixin ck-box-shadow var(--ck-inner-shadow);\n\t}\n}\n\n.ck.ck-editor__editable_inline {\n\toverflow: auto;\n\tpadding: 0 var(--ck-spacing-standard);\n\tborder: 1px solid transparent;\n\n\t&[dir="ltr"] {\n\t\ttext-align: left;\n\t}\n\n\t&[dir="rtl"] {\n\t\ttext-align: right;\n\t}\n\n\t/* https://github.com/ckeditor/ckeditor5-theme-lark/issues/116 */\n\t& > *:first-child {\n\t\tmargin-top: var(--ck-spacing-large);\n\t}\n\n\t/* https://github.com/ckeditor/ckeditor5/issues/847 */\n\t& > *:last-child {\n\t\t/*\n\t\t * This value should match with the default margins of the block elements (like .media or .image)\n\t\t * to avoid a content jumping when the fake selection container shows up (See https://github.com/ckeditor/ckeditor5/issues/9825).\n\t\t */\n\t\tmargin-bottom: var(--ck-spacing-large);\n\t}\n\n\t/* https://github.com/ckeditor/ckeditor5/issues/6517 */\n\t&.ck-blurred ::selection {\n\t\tbackground: var(--ck-color-editable-blur-selection);\n\t}\n}\n\n/* https://github.com/ckeditor/ckeditor5-theme-lark/issues/111 */\n.ck.ck-balloon-panel.ck-toolbar-container[class*="arrow_n"] {\n\t&::after {\n\t\tborder-bottom-color: var(--ck-color-base-foreground);\n\t}\n}\n\n.ck.ck-balloon-panel.ck-toolbar-container[class*="arrow_s"] {\n\t&::after {\n\t\tborder-top-color: var(--ck-color-base-foreground);\n\t}\n}\n',
                  "/*\n * Copyright (c) 2003-2022, CKSource Holding sp. z o.o. All rights reserved.\n * For licensing, see LICENSE.md or https://ckeditor.com/legal/ckeditor-oss-license\n */\n\n/**\n * Implements rounded corner interface for .ck-rounded-corners class.\n *\n * @see $ck-border-radius\n */\n@define-mixin ck-rounded-corners {\n\tborder-radius: 0;\n\n\t@nest .ck-rounded-corners &,\n\t&.ck-rounded-corners {\n\t\tborder-radius: var(--ck-border-radius);\n\t\t@mixin-content;\n\t}\n}\n",
                  "/*\n * Copyright (c) 2003-2022, CKSource Holding sp. z o.o. All rights reserved.\n * For licensing, see LICENSE.md or https://ckeditor.com/legal/ckeditor-oss-license\n */\n\n/**\n * A visual style of focused element's border.\n */\n@define-mixin ck-focus-ring {\n\t/* Disable native outline. */\n\toutline: none;\n\tborder: var(--ck-focus-ring)\n}\n",
                  "/*\n * Copyright (c) 2003-2022, CKSource Holding sp. z o.o. All rights reserved.\n * For licensing, see LICENSE.md or https://ckeditor.com/legal/ckeditor-oss-license\n */\n\n/**\n * A helper to combine multiple shadows.\n */\n@define-mixin ck-box-shadow $shadowA, $shadowB: 0 0 {\n\tbox-shadow: $shadowA, $shadowB;\n}\n\n/**\n * Gives an element a drop shadow so it looks like a floating panel.\n */\n@define-mixin ck-drop-shadow {\n\t@mixin ck-box-shadow var(--ck-drop-shadow);\n}\n",
                ],
                sourceRoot: "",
              },
            ]);
            const a = s;
          },
          5523: (t, e, n) => {
            "use strict";
            n.d(e, { Z: () => a });
            var o = n(7537),
              i = n.n(o),
              r = n(3645),
              s = n.n(r)()(i());
            s.push([
              t.id,
              ".ck.ck-form__header{align-items:center;display:flex;flex-direction:row;flex-wrap:nowrap;justify-content:space-between}:root{--ck-form-header-height:38px}.ck.ck-form__header{border-bottom:1px solid var(--ck-color-base-border);height:var(--ck-form-header-height);line-height:var(--ck-form-header-height);padding:var(--ck-spacing-small) var(--ck-spacing-large)}.ck.ck-form__header .ck-form__header__label{font-weight:700}",
              "",
              {
                version: 3,
                sources: [
                  "webpack://./node_modules/@ckeditor/ckeditor5-ui/theme/components/formheader/formheader.css",
                  "webpack://./node_modules/@ckeditor/ckeditor5-theme-lark/theme/ckeditor5-ui/components/formheader/formheader.css",
                ],
                names: [],
                mappings:
                  "AAKA,oBAIC,kBAAmB,CAHnB,YAAa,CACb,kBAAmB,CACnB,gBAAiB,CAEjB,6BACD,CCNA,MACC,4BACD,CAEA,oBAIC,mDAAoD,CAFpD,mCAAoC,CACpC,wCAAyC,CAFzC,uDAQD,CAHC,4CACC,eACD",
                sourcesContent: [
                  "/*\n * Copyright (c) 2003-2022, CKSource Holding sp. z o.o. All rights reserved.\n * For licensing, see LICENSE.md or https://ckeditor.com/legal/ckeditor-oss-license\n */\n\n.ck.ck-form__header {\n\tdisplay: flex;\n\tflex-direction: row;\n\tflex-wrap: nowrap;\n\talign-items: center;\n\tjustify-content: space-between;\n}\n",
                  "/*\n * Copyright (c) 2003-2022, CKSource Holding sp. z o.o. All rights reserved.\n * For licensing, see LICENSE.md or https://ckeditor.com/legal/ckeditor-oss-license\n */\n\n:root {\n\t--ck-form-header-height: 38px;\n}\n\n.ck.ck-form__header {\n\tpadding: var(--ck-spacing-small) var(--ck-spacing-large);\n\theight: var(--ck-form-header-height);\n\tline-height: var(--ck-form-header-height);\n\tborder-bottom: 1px solid var(--ck-color-base-border);\n\n\t& .ck-form__header__label {\n\t\tfont-weight: bold;\n\t}\n}\n",
                ],
                sourceRoot: "",
              },
            ]);
            const a = s;
          },
          1174: (t, e, n) => {
            "use strict";
            n.d(e, { Z: () => a });
            var o = n(7537),
              i = n.n(o),
              r = n(3645),
              s = n.n(r)()(i());
            s.push([
              t.id,
              ".ck.ck-icon{vertical-align:middle}:root{--ck-icon-size:calc(var(--ck-line-height-base)*var(--ck-font-size-normal))}.ck.ck-icon{font-size:.8333350694em;height:var(--ck-icon-size);width:var(--ck-icon-size);will-change:transform}.ck.ck-icon,.ck.ck-icon *{cursor:inherit}.ck.ck-icon.ck-icon_inherit-color,.ck.ck-icon.ck-icon_inherit-color *{color:inherit}.ck.ck-icon.ck-icon_inherit-color :not([fill]){fill:currentColor}",
              "",
              {
                version: 3,
                sources: [
                  "webpack://./node_modules/@ckeditor/ckeditor5-ui/theme/components/icon/icon.css",
                  "webpack://./node_modules/@ckeditor/ckeditor5-theme-lark/theme/ckeditor5-ui/components/icon/icon.css",
                ],
                names: [],
                mappings:
                  "AAKA,YACC,qBACD,CCFA,MACC,0EACD,CAEA,YAKC,uBAAwB,CAHxB,0BAA2B,CAD3B,yBAA0B,CAU1B,qBAoBD,CAlBC,0BALA,cAQA,CAMC,sEACC,aAMD,CAJC,+CAEC,iBACD",
                sourcesContent: [
                  "/*\n * Copyright (c) 2003-2022, CKSource Holding sp. z o.o. All rights reserved.\n * For licensing, see LICENSE.md or https://ckeditor.com/legal/ckeditor-oss-license\n */\n\n.ck.ck-icon {\n\tvertical-align: middle;\n}\n",
                  '/*\n * Copyright (c) 2003-2022, CKSource Holding sp. z o.o. All rights reserved.\n * For licensing, see LICENSE.md or https://ckeditor.com/legal/ckeditor-oss-license\n */\n\n:root {\n\t--ck-icon-size: calc(var(--ck-line-height-base) * var(--ck-font-size-normal));\n}\n\n.ck.ck-icon {\n\twidth: var(--ck-icon-size);\n\theight: var(--ck-icon-size);\n\n\t/* Multiplied by the height of the line in "px" should give SVG "viewport" dimensions */\n\tfont-size: .8333350694em;\n\n\t/* Inherit cursor style (#5). */\n\tcursor: inherit;\n\n\t/* This will prevent blurry icons on Firefox. See #340. */\n\twill-change: transform;\n\n\t& * {\n\t\t/* Inherit cursor style (#5). */\n\t\tcursor: inherit;\n\t}\n\n\t/* Allows dynamic coloring of an icon by inheriting its color from the parent. */\n\t&.ck-icon_inherit-color {\n\t\tcolor: inherit;\n\n\t\t& * {\n\t\t\tcolor: inherit;\n\n\t\t\t&:not([fill]) {\n\t\t\t\t/* Needed by FF. */\n\t\t\t\tfill: currentColor;\n\t\t\t}\n\t\t}\n\t}\n}\n',
                ],
                sourceRoot: "",
              },
            ]);
            const a = s;
          },
          6985: (t, e, n) => {
            "use strict";
            n.d(e, { Z: () => a });
            var o = n(7537),
              i = n.n(o),
              r = n(3645),
              s = n.n(r)()(i());
            s.push([
              t.id,
              ":root{--ck-input-width:18em;--ck-input-text-width:var(--ck-input-width)}.ck.ck-input{border-radius:0}.ck-rounded-corners .ck.ck-input,.ck.ck-input.ck-rounded-corners{border-radius:var(--ck-border-radius)}.ck.ck-input{background:var(--ck-color-input-background);border:1px solid var(--ck-color-input-border);min-height:var(--ck-ui-component-min-height);min-width:var(--ck-input-width);padding:var(--ck-spacing-extra-tiny) var(--ck-spacing-medium);transition:box-shadow .1s ease-in-out,border .1s ease-in-out}.ck.ck-input:focus{border:var(--ck-focus-ring);box-shadow:var(--ck-focus-outer-shadow),0 0;outline:none}.ck.ck-input[readonly]{background:var(--ck-color-input-disabled-background);border:1px solid var(--ck-color-input-disabled-border);color:var(--ck-color-input-disabled-text)}.ck.ck-input[readonly]:focus{box-shadow:var(--ck-focus-disabled-outer-shadow),0 0}.ck.ck-input.ck-error{animation:ck-input-shake .3s ease both;border-color:var(--ck-color-input-error-border)}.ck.ck-input.ck-error:focus{box-shadow:var(--ck-focus-error-outer-shadow),0 0}@keyframes ck-input-shake{20%{transform:translateX(-2px)}40%{transform:translateX(2px)}60%{transform:translateX(-1px)}80%{transform:translateX(1px)}}",
              "",
              {
                version: 3,
                sources: [
                  "webpack://./node_modules/@ckeditor/ckeditor5-theme-lark/theme/ckeditor5-ui/components/input/input.css",
                  "webpack://./node_modules/@ckeditor/ckeditor5-theme-lark/theme/mixins/_rounded.css",
                  "webpack://./node_modules/@ckeditor/ckeditor5-theme-lark/theme/mixins/_focus.css",
                  "webpack://./node_modules/@ckeditor/ckeditor5-theme-lark/theme/mixins/_shadow.css",
                ],
                names: [],
                mappings:
                  "AASA,MACC,qBAAsB,CAGtB,2CACD,CAEA,aCLC,eD2CD,CAtCA,iECDE,qCDuCF,CAtCA,aAGC,2CAA4C,CAC5C,6CAA8C,CAK9C,4CAA6C,CAH7C,+BAAgC,CADhC,6DAA8D,CAO9D,4DA0BD,CAxBC,mBEnBA,2BAA2B,CCF3B,2CAA8B,CDC9B,YFuBA,CAEA,uBAEC,oDAAqD,CADrD,sDAAuD,CAEvD,yCAMD,CAJC,6BG/BD,oDHkCC,CAGD,sBAEC,sCAAuC,CADvC,+CAMD,CAHC,4BGzCD,iDH2CC,CAIF,0BACC,IACC,0BACD,CAEA,IACC,yBACD,CAEA,IACC,0BACD,CAEA,IACC,yBACD,CACD",
                sourcesContent: [
                  '/*\n * Copyright (c) 2003-2022, CKSource Holding sp. z o.o. All rights reserved.\n * For licensing, see LICENSE.md or https://ckeditor.com/legal/ckeditor-oss-license\n */\n\n@import "../../../mixins/_rounded.css";\n@import "../../../mixins/_focus.css";\n@import "../../../mixins/_shadow.css";\n\n:root {\n\t--ck-input-width: 18em;\n\n\t/* Backward compatibility. */\n\t--ck-input-text-width: var(--ck-input-width);\n}\n\n.ck.ck-input {\n\t@mixin ck-rounded-corners;\n\n\tbackground: var(--ck-color-input-background);\n\tborder: 1px solid var(--ck-color-input-border);\n\tpadding: var(--ck-spacing-extra-tiny) var(--ck-spacing-medium);\n\tmin-width: var(--ck-input-width);\n\n\t/* This is important to stay of the same height as surrounding buttons */\n\tmin-height: var(--ck-ui-component-min-height);\n\n\t/* Apply some smooth transition to the box-shadow and border. */\n\ttransition: box-shadow .1s ease-in-out, border .1s ease-in-out;\n\n\t&:focus {\n\t\t@mixin ck-focus-ring;\n\t\t@mixin ck-box-shadow var(--ck-focus-outer-shadow);\n\t}\n\n\t&[readonly] {\n\t\tborder: 1px solid var(--ck-color-input-disabled-border);\n\t\tbackground: var(--ck-color-input-disabled-background);\n\t\tcolor: var(--ck-color-input-disabled-text);\n\n\t\t&:focus {\n\t\t\t/* The read-only input should have a slightly less visible shadow when focused. */\n\t\t\t@mixin ck-box-shadow var(--ck-focus-disabled-outer-shadow);\n\t\t}\n\t}\n\n\t&.ck-error {\n\t\tborder-color: var(--ck-color-input-error-border);\n\t\tanimation: ck-input-shake .3s ease both;\n\n\t\t&:focus {\n\t\t\t@mixin ck-box-shadow var(--ck-focus-error-outer-shadow);\n\t\t}\n\t}\n}\n\n@keyframes ck-input-shake {\n\t20% {\n\t\ttransform: translateX(-2px);\n\t}\n\n\t40% {\n\t\ttransform: translateX(2px);\n\t}\n\n\t60% {\n\t\ttransform: translateX(-1px);\n\t}\n\n\t80% {\n\t\ttransform: translateX(1px);\n\t}\n}\n',
                  "/*\n * Copyright (c) 2003-2022, CKSource Holding sp. z o.o. All rights reserved.\n * For licensing, see LICENSE.md or https://ckeditor.com/legal/ckeditor-oss-license\n */\n\n/**\n * Implements rounded corner interface for .ck-rounded-corners class.\n *\n * @see $ck-border-radius\n */\n@define-mixin ck-rounded-corners {\n\tborder-radius: 0;\n\n\t@nest .ck-rounded-corners &,\n\t&.ck-rounded-corners {\n\t\tborder-radius: var(--ck-border-radius);\n\t\t@mixin-content;\n\t}\n}\n",
                  "/*\n * Copyright (c) 2003-2022, CKSource Holding sp. z o.o. All rights reserved.\n * For licensing, see LICENSE.md or https://ckeditor.com/legal/ckeditor-oss-license\n */\n\n/**\n * A visual style of focused element's border.\n */\n@define-mixin ck-focus-ring {\n\t/* Disable native outline. */\n\toutline: none;\n\tborder: var(--ck-focus-ring)\n}\n",
                  "/*\n * Copyright (c) 2003-2022, CKSource Holding sp. z o.o. All rights reserved.\n * For licensing, see LICENSE.md or https://ckeditor.com/legal/ckeditor-oss-license\n */\n\n/**\n * A helper to combine multiple shadows.\n */\n@define-mixin ck-box-shadow $shadowA, $shadowB: 0 0 {\n\tbox-shadow: $shadowA, $shadowB;\n}\n\n/**\n * Gives an element a drop shadow so it looks like a floating panel.\n */\n@define-mixin ck-drop-shadow {\n\t@mixin ck-box-shadow var(--ck-drop-shadow);\n}\n",
                ],
                sourceRoot: "",
              },
            ]);
            const a = s;
          },
          2751: (t, e, n) => {
            "use strict";
            n.d(e, { Z: () => a });
            var o = n(7537),
              i = n.n(o),
              r = n(3645),
              s = n.n(r)()(i());
            s.push([
              t.id,
              ".ck.ck-label{display:block}.ck.ck-voice-label{display:none}.ck.ck-label{font-weight:700}",
              "",
              {
                version: 3,
                sources: [
                  "webpack://./node_modules/@ckeditor/ckeditor5-ui/theme/components/label/label.css",
                  "webpack://./node_modules/@ckeditor/ckeditor5-theme-lark/theme/ckeditor5-ui/components/label/label.css",
                ],
                names: [],
                mappings: "AAKA,aACC,aACD,CAEA,mBACC,YACD,CCNA,aACC,eACD",
                sourcesContent: [
                  "/*\n * Copyright (c) 2003-2022, CKSource Holding sp. z o.o. All rights reserved.\n * For licensing, see LICENSE.md or https://ckeditor.com/legal/ckeditor-oss-license\n */\n\n.ck.ck-label {\n\tdisplay: block;\n}\n\n.ck.ck-voice-label {\n\tdisplay: none;\n}\n",
                  "/*\n * Copyright (c) 2003-2022, CKSource Holding sp. z o.o. All rights reserved.\n * For licensing, see LICENSE.md or https://ckeditor.com/legal/ckeditor-oss-license\n */\n\n.ck.ck-label {\n\tfont-weight: bold;\n}\n",
                ],
                sourceRoot: "",
              },
            ]);
            const a = s;
          },
          8111: (t, e, n) => {
            "use strict";
            n.d(e, { Z: () => a });
            var o = n(7537),
              i = n.n(o),
              r = n(3645),
              s = n.n(r)()(i());
            s.push([
              t.id,
              ".ck.ck-labeled-field-view>.ck.ck-labeled-field-view__input-wrapper{display:flex;position:relative}.ck.ck-labeled-field-view .ck.ck-label{display:block;position:absolute}:root{--ck-labeled-field-view-transition:.1s cubic-bezier(0,0,0.24,0.95);--ck-labeled-field-empty-unfocused-max-width:100% - 2 * var(--ck-spacing-medium);--ck-labeled-field-label-default-position-x:var(--ck-spacing-medium);--ck-labeled-field-label-default-position-y:calc(var(--ck-font-size-base)*0.6);--ck-color-labeled-field-label-background:var(--ck-color-base-background)}.ck.ck-labeled-field-view{border-radius:0}.ck-rounded-corners .ck.ck-labeled-field-view,.ck.ck-labeled-field-view.ck-rounded-corners{border-radius:var(--ck-border-radius)}.ck.ck-labeled-field-view>.ck.ck-labeled-field-view__input-wrapper{width:100%}.ck.ck-labeled-field-view>.ck.ck-labeled-field-view__input-wrapper>.ck.ck-label{top:0}[dir=ltr] .ck.ck-labeled-field-view>.ck.ck-labeled-field-view__input-wrapper>.ck.ck-label{left:0}[dir=rtl] .ck.ck-labeled-field-view>.ck.ck-labeled-field-view__input-wrapper>.ck.ck-label{right:0}.ck.ck-labeled-field-view>.ck.ck-labeled-field-view__input-wrapper>.ck.ck-label{background:var(--ck-color-labeled-field-label-background);font-weight:400;line-height:normal;max-width:100%;overflow:hidden;padding:0 calc(var(--ck-font-size-tiny)*.5);pointer-events:none;text-overflow:ellipsis;transform:translate(var(--ck-spacing-medium),-6px) scale(.75);transform-origin:0 0;transition:transform var(--ck-labeled-field-view-transition),padding var(--ck-labeled-field-view-transition),background var(--ck-labeled-field-view-transition)}.ck.ck-labeled-field-view.ck-error .ck-input:not([readonly])+.ck.ck-label,.ck.ck-labeled-field-view.ck-error>.ck.ck-labeled-field-view__input-wrapper>.ck.ck-label{color:var(--ck-color-base-error)}.ck.ck-labeled-field-view .ck-labeled-field-view__status{font-size:var(--ck-font-size-small);margin-top:var(--ck-spacing-small);white-space:normal}.ck.ck-labeled-field-view .ck-labeled-field-view__status.ck-labeled-field-view__status_error{color:var(--ck-color-base-error)}.ck.ck-labeled-field-view.ck-disabled>.ck.ck-labeled-field-view__input-wrapper>.ck.ck-label,.ck.ck-labeled-field-view.ck-labeled-field-view_empty:not(.ck-labeled-field-view_focused)>.ck.ck-labeled-field-view__input-wrapper>.ck.ck-label{color:var(--ck-color-input-disabled-text)}[dir=ltr] .ck.ck-labeled-field-view.ck-disabled.ck-labeled-field-view_empty>.ck.ck-labeled-field-view__input-wrapper>.ck.ck-label,[dir=ltr] .ck.ck-labeled-field-view.ck-labeled-field-view_empty:not(.ck-labeled-field-view_focused):not(.ck-labeled-field-view_placeholder)>.ck.ck-labeled-field-view__input-wrapper>.ck.ck-label{transform:translate(var(--ck-labeled-field-label-default-position-x),var(--ck-labeled-field-label-default-position-y)) scale(1)}[dir=rtl] .ck.ck-labeled-field-view.ck-disabled.ck-labeled-field-view_empty>.ck.ck-labeled-field-view__input-wrapper>.ck.ck-label,[dir=rtl] .ck.ck-labeled-field-view.ck-labeled-field-view_empty:not(.ck-labeled-field-view_focused):not(.ck-labeled-field-view_placeholder)>.ck.ck-labeled-field-view__input-wrapper>.ck.ck-label{transform:translate(calc(var(--ck-labeled-field-label-default-position-x)*-1),var(--ck-labeled-field-label-default-position-y)) scale(1)}.ck.ck-labeled-field-view.ck-disabled.ck-labeled-field-view_empty>.ck.ck-labeled-field-view__input-wrapper>.ck.ck-label,.ck.ck-labeled-field-view.ck-labeled-field-view_empty:not(.ck-labeled-field-view_focused):not(.ck-labeled-field-view_placeholder)>.ck.ck-labeled-field-view__input-wrapper>.ck.ck-label{background:transparent;max-width:calc(var(--ck-labeled-field-empty-unfocused-max-width));padding:0}.ck.ck-labeled-field-view>.ck.ck-labeled-field-view__input-wrapper>.ck-dropdown>.ck.ck-button{background:transparent}.ck.ck-labeled-field-view.ck-labeled-field-view_empty>.ck.ck-labeled-field-view__input-wrapper>.ck-dropdown>.ck-button>.ck-button__label{opacity:0}.ck.ck-labeled-field-view.ck-labeled-field-view_empty:not(.ck-labeled-field-view_focused):not(.ck-labeled-field-view_placeholder)>.ck.ck-labeled-field-view__input-wrapper>.ck-dropdown+.ck-label{max-width:calc(var(--ck-labeled-field-empty-unfocused-max-width) - var(--ck-dropdown-arrow-size) - var(--ck-spacing-standard))}",
              "",
              {
                version: 3,
                sources: [
                  "webpack://./node_modules/@ckeditor/ckeditor5-ui/theme/components/labeledfield/labeledfieldview.css",
                  "webpack://./node_modules/@ckeditor/ckeditor5-theme-lark/theme/ckeditor5-ui/components/labeledfield/labeledfieldview.css",
                  "webpack://./node_modules/@ckeditor/ckeditor5-theme-lark/theme/mixins/_rounded.css",
                ],
                names: [],
                mappings:
                  "AAMC,mEACC,YAAa,CACb,iBACD,CAEA,uCACC,aAAc,CACd,iBACD,CCND,MACC,kEAAsE,CACtE,gFAAiF,CACjF,oEAAqE,CACrE,8EAAiF,CACjF,yEACD,CAEA,0BCLC,eD8GD,CAzGA,2FCDE,qCD0GF,CAtGC,mEACC,UAmCD,CAjCC,gFACC,KA+BD,CAhCA,0FAIE,MA4BF,CAhCA,0FAQE,OAwBF,CAhCA,gFAiBC,yDAA0D,CAG1D,eAAmB,CADnB,kBAAoB,CAOpB,cAAe,CAFf,eAAgB,CANhB,2CAA8C,CAP9C,mBAAoB,CAYpB,sBAAuB,CARvB,6DAA+D,CAH/D,oBAAqB,CAgBrB,+JAID,CAQA,mKACC,gCACD,CAGD,yDACC,mCAAoC,CACpC,kCAAmC,CAInC,kBAKD,CAHC,6FACC,gCACD,CAID,4OAEC,yCACD,CAIA,oUAGE,+HAYF,CAfA,oUAOE,wIAQF,CAfA,gTAaC,sBAAuB,CAFvB,iEAAkE,CAGlE,SACD,CAKA,8FACC,sBACD,CAGA,yIACC,SACD,CAGA,kMACC,8HACD",
                sourcesContent: [
                  "/*\n * Copyright (c) 2003-2022, CKSource Holding sp. z o.o. All rights reserved.\n * For licensing, see LICENSE.md or https://ckeditor.com/legal/ckeditor-oss-license\n */\n\n.ck.ck-labeled-field-view {\n\t& > .ck.ck-labeled-field-view__input-wrapper {\n\t\tdisplay: flex;\n\t\tposition: relative;\n\t}\n\n\t& .ck.ck-label {\n\t\tdisplay: block;\n\t\tposition: absolute;\n\t}\n}\n",
                  '/*\n * Copyright (c) 2003-2022, CKSource Holding sp. z o.o. All rights reserved.\n * For licensing, see LICENSE.md or https://ckeditor.com/legal/ckeditor-oss-license\n */\n\n@import "@ckeditor/ckeditor5-ui/theme/mixins/_dir.css";\n@import "../../../mixins/_rounded.css";\n\n:root {\n\t--ck-labeled-field-view-transition: .1s cubic-bezier(0, 0, 0.24, 0.95);\n\t--ck-labeled-field-empty-unfocused-max-width: 100% - 2 * var(--ck-spacing-medium);\n\t--ck-labeled-field-label-default-position-x: var(--ck-spacing-medium);\n\t--ck-labeled-field-label-default-position-y: calc(0.6 * var(--ck-font-size-base));\n\t--ck-color-labeled-field-label-background: var(--ck-color-base-background);\n}\n\n.ck.ck-labeled-field-view {\n\t@mixin ck-rounded-corners;\n\n\t& > .ck.ck-labeled-field-view__input-wrapper {\n\t\twidth: 100%;\n\n\t\t& > .ck.ck-label {\n\t\t\ttop: 0px;\n\n\t\t\t@mixin ck-dir ltr {\n\t\t\t\tleft: 0px;\n\t\t\t}\n\n\t\t\t@mixin ck-dir rtl {\n\t\t\t\tright: 0px;\n\t\t\t}\n\n\t\t\tpointer-events: none;\n\t\t\ttransform-origin: 0 0;\n\n\t\t\t/* By default, display the label scaled down above the field. */\n\t\t\ttransform: translate(var(--ck-spacing-medium), -6px) scale(.75);\n\n\t\t\tbackground: var(--ck-color-labeled-field-label-background);\n\t\t\tpadding: 0 calc(.5 * var(--ck-font-size-tiny));\n\t\t\tline-height: initial;\n\t\t\tfont-weight: normal;\n\n\t\t\t/* Prevent overflow when the label is longer than the input */\n\t\t\ttext-overflow: ellipsis;\n\t\t\toverflow: hidden;\n\n\t\t\tmax-width: 100%;\n\n\t\t\ttransition:\n\t\t\t\ttransform var(--ck-labeled-field-view-transition),\n\t\t\t\tpadding var(--ck-labeled-field-view-transition),\n\t\t\t\tbackground var(--ck-labeled-field-view-transition);\n\t\t}\n\t}\n\n\t&.ck-error {\n\t\t& > .ck.ck-labeled-field-view__input-wrapper > .ck.ck-label {\n\t\t\tcolor: var(--ck-color-base-error);\n\t\t}\n\n\t\t& .ck-input:not([readonly]) + .ck.ck-label {\n\t\t\tcolor: var(--ck-color-base-error);\n\t\t}\n\t}\n\n\t& .ck-labeled-field-view__status {\n\t\tfont-size: var(--ck-font-size-small);\n\t\tmargin-top: var(--ck-spacing-small);\n\n\t\t/* Let the info wrap to the next line to avoid stretching the layout horizontally.\n\t\tThe status could be very long. */\n\t\twhite-space: normal;\n\n\t\t&.ck-labeled-field-view__status_error {\n\t\t\tcolor: var(--ck-color-base-error);\n\t\t}\n\t}\n\n\t/* Disabled fields and fields that have no focus should fade out. */\n\t&.ck-disabled > .ck.ck-labeled-field-view__input-wrapper > .ck.ck-label,\n\t&.ck-labeled-field-view_empty:not(.ck-labeled-field-view_focused) > .ck.ck-labeled-field-view__input-wrapper > .ck.ck-label {\n\t\tcolor: var(--ck-color-input-disabled-text);\n\t}\n\n\t/* Fields that are disabled or not focused and without a placeholder should have full-sized labels. */\n\t/* stylelint-disable-next-line no-descending-specificity */\n\t&.ck-disabled.ck-labeled-field-view_empty > .ck.ck-labeled-field-view__input-wrapper > .ck.ck-label,\n\t&.ck-labeled-field-view_empty:not(.ck-labeled-field-view_focused):not(.ck-labeled-field-view_placeholder) > .ck.ck-labeled-field-view__input-wrapper > .ck.ck-label {\n\t\t@mixin ck-dir ltr {\n\t\t\ttransform: translate(var(--ck-labeled-field-label-default-position-x), var(--ck-labeled-field-label-default-position-y)) scale(1);\n\t\t}\n\n\t\t@mixin ck-dir rtl {\n\t\t\ttransform: translate(calc(-1 * var(--ck-labeled-field-label-default-position-x)), var(--ck-labeled-field-label-default-position-y)) scale(1);\n\t\t}\n\n\t\t/* Compensate for the default translate position. */\n\t\tmax-width: calc(var(--ck-labeled-field-empty-unfocused-max-width));\n\n\t\tbackground: transparent;\n\t\tpadding: 0;\n\t}\n\n\t/*------ DropdownView integration ----------------------------------------------------------------------------------- */\n\n\t/* Make sure dropdown\' background color in any of dropdown\'s state does not collide with labeled field. */\n\t& > .ck.ck-labeled-field-view__input-wrapper > .ck-dropdown > .ck.ck-button {\n\t\tbackground: transparent;\n\t}\n\n\t/* When the dropdown is "empty", the labeled field label replaces its label. */\n\t&.ck-labeled-field-view_empty > .ck.ck-labeled-field-view__input-wrapper > .ck-dropdown > .ck-button > .ck-button__label {\n\t\topacity: 0;\n\t}\n\n\t/* Make sure the label of the empty, unfocused input does not cover the dropdown arrow. */\n\t&.ck-labeled-field-view_empty:not(.ck-labeled-field-view_focused):not(.ck-labeled-field-view_placeholder) > .ck.ck-labeled-field-view__input-wrapper > .ck-dropdown + .ck-label {\n\t\tmax-width: calc(var(--ck-labeled-field-empty-unfocused-max-width) - var(--ck-dropdown-arrow-size) - var(--ck-spacing-standard));\n\t}\n}\n',
                  "/*\n * Copyright (c) 2003-2022, CKSource Holding sp. z o.o. All rights reserved.\n * For licensing, see LICENSE.md or https://ckeditor.com/legal/ckeditor-oss-license\n */\n\n/**\n * Implements rounded corner interface for .ck-rounded-corners class.\n *\n * @see $ck-border-radius\n */\n@define-mixin ck-rounded-corners {\n\tborder-radius: 0;\n\n\t@nest .ck-rounded-corners &,\n\t&.ck-rounded-corners {\n\t\tborder-radius: var(--ck-border-radius);\n\t\t@mixin-content;\n\t}\n}\n",
                ],
                sourceRoot: "",
              },
            ]);
            const a = s;
          },
          1162: (t, e, n) => {
            "use strict";
            n.d(e, { Z: () => a });
            var o = n(7537),
              i = n.n(o),
              r = n(3645),
              s = n.n(r)()(i());
            s.push([
              t.id,
              ".ck.ck-list{display:flex;flex-direction:column;-moz-user-select:none;-webkit-user-select:none;-ms-user-select:none;user-select:none}.ck.ck-list .ck-list__item,.ck.ck-list .ck-list__separator{display:block}.ck.ck-list .ck-list__item>:focus{position:relative;z-index:var(--ck-z-default)}.ck.ck-list{border-radius:0}.ck-rounded-corners .ck.ck-list,.ck.ck-list.ck-rounded-corners{border-radius:var(--ck-border-radius)}.ck.ck-list{background:var(--ck-color-list-background);list-style-type:none}.ck.ck-list__item{cursor:default;min-width:12em}.ck.ck-list__item .ck-button{border-radius:0;min-height:unset;padding:calc(var(--ck-line-height-base)*.2*var(--ck-font-size-base)) calc(var(--ck-line-height-base)*.4*var(--ck-font-size-base));text-align:left;width:100%}.ck.ck-list__item .ck-button .ck-button__label{line-height:calc(var(--ck-line-height-base)*1.2*var(--ck-font-size-base))}.ck.ck-list__item .ck-button:active{box-shadow:none}.ck.ck-list__item .ck-button.ck-on{background:var(--ck-color-list-button-on-background);color:var(--ck-color-list-button-on-text)}.ck.ck-list__item .ck-button.ck-on:active{box-shadow:none}.ck.ck-list__item .ck-button.ck-on:hover:not(.ck-disabled){background:var(--ck-color-list-button-on-background-focus)}.ck.ck-list__item .ck-button.ck-on:focus:not(.ck-switchbutton):not(.ck-disabled){border-color:var(--ck-color-base-background)}.ck.ck-list__item .ck-button:hover:not(.ck-disabled){background:var(--ck-color-list-button-hover-background)}.ck.ck-list__item .ck-switchbutton.ck-on{background:var(--ck-color-list-background);color:inherit}.ck.ck-list__item .ck-switchbutton.ck-on:hover:not(.ck-disabled){background:var(--ck-color-list-button-hover-background);color:inherit}.ck.ck-list__separator{background:var(--ck-color-base-border);height:1px;width:100%}",
              "",
              {
                version: 3,
                sources: [
                  "webpack://./node_modules/@ckeditor/ckeditor5-ui/theme/components/list/list.css",
                  "webpack://./node_modules/@ckeditor/ckeditor5-ui/theme/mixins/_unselectable.css",
                  "webpack://./node_modules/@ckeditor/ckeditor5-theme-lark/theme/ckeditor5-ui/components/list/list.css",
                  "webpack://./node_modules/@ckeditor/ckeditor5-theme-lark/theme/mixins/_rounded.css",
                ],
                names: [],
                mappings:
                  "AAOA,YAGC,YAAa,CACb,qBAAsB,CCFtB,qBAAsB,CACtB,wBAAyB,CACzB,oBAAqB,CACrB,gBDaD,CAZC,2DAEC,aACD,CAKA,kCACC,iBAAkB,CAClB,2BACD,CEfD,YCEC,eDGD,CALA,+DCME,qCDDF,CALA,YAIC,0CAA2C,CAD3C,oBAED,CAEA,kBACC,cAAe,CACf,cA2DD,CAzDC,6BAIC,eAAgB,CAHhB,gBAAiB,CAQjB,iIAEiE,CARjE,eAAgB,CADhB,UAwCD,CA7BC,+CAEC,yEACD,CAEA,oCACC,eACD,CAEA,mCACC,oDAAqD,CACrD,yCAaD,CAXC,0CACC,eACD,CAEA,2DACC,0DACD,CAEA,iFACC,4CACD,CAGD,qDACC,uDACD,CAMA,yCACC,0CAA2C,CAC3C,aAMD,CAJC,iEACC,uDAAwD,CACxD,aACD,CAKH,uBAGC,sCAAuC,CAFvC,UAAW,CACX,UAED",
                sourcesContent: [
                  '/*\n * Copyright (c) 2003-2022, CKSource Holding sp. z o.o. All rights reserved.\n * For licensing, see LICENSE.md or https://ckeditor.com/legal/ckeditor-oss-license\n */\n\n@import "../../mixins/_unselectable.css";\n\n.ck.ck-list {\n\t@mixin ck-unselectable;\n\n\tdisplay: flex;\n\tflex-direction: column;\n\n\t& .ck-list__item,\n\t& .ck-list__separator {\n\t\tdisplay: block;\n\t}\n\n\t/* Make sure that whatever child of the list item gets focus, it remains on the\n\ttop. Thanks to that, styles like box-shadow, outline, etc. are not masked by\n\tadjacent list items. */\n\t& .ck-list__item > *:focus {\n\t\tposition: relative;\n\t\tz-index: var(--ck-z-default);\n\t}\n}\n',
                  "/*\n * Copyright (c) 2003-2022, CKSource Holding sp. z o.o. All rights reserved.\n * For licensing, see LICENSE.md or https://ckeditor.com/legal/ckeditor-oss-license\n */\n\n/**\n * Makes element unselectable.\n */\n@define-mixin ck-unselectable {\n\t-moz-user-select: none;\n\t-webkit-user-select: none;\n\t-ms-user-select: none;\n\tuser-select: none\n}\n",
                  '/*\n * Copyright (c) 2003-2022, CKSource Holding sp. z o.o. All rights reserved.\n * For licensing, see LICENSE.md or https://ckeditor.com/legal/ckeditor-oss-license\n */\n\n@import "../../../mixins/_disabled.css";\n@import "../../../mixins/_rounded.css";\n@import "../../../mixins/_shadow.css";\n\n.ck.ck-list {\n\t@mixin ck-rounded-corners;\n\n\tlist-style-type: none;\n\tbackground: var(--ck-color-list-background);\n}\n\n.ck.ck-list__item {\n\tcursor: default;\n\tmin-width: 12em;\n\n\t& .ck-button {\n\t\tmin-height: unset;\n\t\twidth: 100%;\n\t\ttext-align: left;\n\t\tborder-radius: 0;\n\n\t\t/* List items should have the same height. Use absolute units to make sure it is so\n\t\t   because e.g. different heading styles may have different height\n\t\t   https://github.com/ckeditor/ckeditor5-heading/issues/63 */\n\t\tpadding:\n\t\t\tcalc(.2 * var(--ck-line-height-base) * var(--ck-font-size-base))\n\t\t\tcalc(.4 * var(--ck-line-height-base) * var(--ck-font-size-base));\n\n\t\t& .ck-button__label {\n\t\t\t/* https://github.com/ckeditor/ckeditor5-heading/issues/63 */\n\t\t\tline-height: calc(1.2 * var(--ck-line-height-base) * var(--ck-font-size-base));\n\t\t}\n\n\t\t&:active {\n\t\t\tbox-shadow: none;\n\t\t}\n\n\t\t&.ck-on {\n\t\t\tbackground: var(--ck-color-list-button-on-background);\n\t\t\tcolor: var(--ck-color-list-button-on-text);\n\n\t\t\t&:active {\n\t\t\t\tbox-shadow: none;\n\t\t\t}\n\n\t\t\t&:hover:not(.ck-disabled) {\n\t\t\t\tbackground: var(--ck-color-list-button-on-background-focus);\n\t\t\t}\n\n\t\t\t&:focus:not(.ck-switchbutton):not(.ck-disabled) {\n\t\t\t\tborder-color: var(--ck-color-base-background);\n\t\t\t}\n\t\t}\n\n\t\t&:hover:not(.ck-disabled) {\n\t\t\tbackground: var(--ck-color-list-button-hover-background);\n\t\t}\n\t}\n\n\t/* It\'s unnecessary to change the background/text of a switch toggle; it has different ways\n\tof conveying its state (like the switcher) */\n\t& .ck-switchbutton {\n\t\t&.ck-on {\n\t\t\tbackground: var(--ck-color-list-background);\n\t\t\tcolor: inherit;\n\n\t\t\t&:hover:not(.ck-disabled) {\n\t\t\t\tbackground: var(--ck-color-list-button-hover-background);\n\t\t\t\tcolor: inherit;\n\t\t\t}\n\t\t}\n\t}\n}\n\n.ck.ck-list__separator {\n\theight: 1px;\n\twidth: 100%;\n\tbackground: var(--ck-color-base-border);\n}\n',
                  "/*\n * Copyright (c) 2003-2022, CKSource Holding sp. z o.o. All rights reserved.\n * For licensing, see LICENSE.md or https://ckeditor.com/legal/ckeditor-oss-license\n */\n\n/**\n * Implements rounded corner interface for .ck-rounded-corners class.\n *\n * @see $ck-border-radius\n */\n@define-mixin ck-rounded-corners {\n\tborder-radius: 0;\n\n\t@nest .ck-rounded-corners &,\n\t&.ck-rounded-corners {\n\t\tborder-radius: var(--ck-border-radius);\n\t\t@mixin-content;\n\t}\n}\n",
                ],
                sourceRoot: "",
              },
            ]);
            const a = s;
          },
          8245: (t, e, n) => {
            "use strict";
            n.d(e, { Z: () => a });
            var o = n(7537),
              i = n.n(o),
              r = n(3645),
              s = n.n(r)()(i());
            s.push([
              t.id,
              ':root{--ck-balloon-panel-arrow-z-index:calc(var(--ck-z-default) - 3)}.ck.ck-balloon-panel{display:none;position:absolute;z-index:var(--ck-z-modal)}.ck.ck-balloon-panel.ck-balloon-panel_with-arrow:after,.ck.ck-balloon-panel.ck-balloon-panel_with-arrow:before{content:"";position:absolute}.ck.ck-balloon-panel.ck-balloon-panel_with-arrow:before{z-index:var(--ck-balloon-panel-arrow-z-index)}.ck.ck-balloon-panel.ck-balloon-panel_with-arrow:after{z-index:calc(var(--ck-balloon-panel-arrow-z-index) + 1)}.ck.ck-balloon-panel[class*=arrow_n]:before{z-index:var(--ck-balloon-panel-arrow-z-index)}.ck.ck-balloon-panel[class*=arrow_n]:after{z-index:calc(var(--ck-balloon-panel-arrow-z-index) + 1)}.ck.ck-balloon-panel[class*=arrow_s]:before{z-index:var(--ck-balloon-panel-arrow-z-index)}.ck.ck-balloon-panel[class*=arrow_s]:after{z-index:calc(var(--ck-balloon-panel-arrow-z-index) + 1)}.ck.ck-balloon-panel.ck-balloon-panel_visible{display:block}:root{--ck-balloon-border-width:1px;--ck-balloon-arrow-offset:2px;--ck-balloon-arrow-height:10px;--ck-balloon-arrow-half-width:8px;--ck-balloon-arrow-drop-shadow:0 2px 2px var(--ck-color-shadow-drop)}.ck.ck-balloon-panel{border-radius:0}.ck-rounded-corners .ck.ck-balloon-panel,.ck.ck-balloon-panel.ck-rounded-corners{border-radius:var(--ck-border-radius)}.ck.ck-balloon-panel{background:var(--ck-color-panel-background);border:var(--ck-balloon-border-width) solid var(--ck-color-panel-border);box-shadow:var(--ck-drop-shadow),0 0;min-height:15px}.ck.ck-balloon-panel.ck-balloon-panel_with-arrow:after,.ck.ck-balloon-panel.ck-balloon-panel_with-arrow:before{border-style:solid;height:0;width:0}.ck.ck-balloon-panel[class*=arrow_n]:after,.ck.ck-balloon-panel[class*=arrow_n]:before{border-width:0 var(--ck-balloon-arrow-half-width) var(--ck-balloon-arrow-height) var(--ck-balloon-arrow-half-width)}.ck.ck-balloon-panel[class*=arrow_n]:before{border-color:transparent transparent var(--ck-color-panel-border) transparent;margin-top:calc(var(--ck-balloon-border-width)*-1)}.ck.ck-balloon-panel[class*=arrow_n]:after{border-color:transparent transparent var(--ck-color-panel-background) transparent;margin-top:calc(var(--ck-balloon-arrow-offset) - var(--ck-balloon-border-width))}.ck.ck-balloon-panel[class*=arrow_s]:after,.ck.ck-balloon-panel[class*=arrow_s]:before{border-width:var(--ck-balloon-arrow-height) var(--ck-balloon-arrow-half-width) 0 var(--ck-balloon-arrow-half-width)}.ck.ck-balloon-panel[class*=arrow_s]:before{border-color:var(--ck-color-panel-border) transparent transparent;filter:drop-shadow(var(--ck-balloon-arrow-drop-shadow));margin-bottom:calc(var(--ck-balloon-border-width)*-1)}.ck.ck-balloon-panel[class*=arrow_s]:after{border-color:var(--ck-color-panel-background) transparent transparent transparent;margin-bottom:calc(var(--ck-balloon-arrow-offset) - var(--ck-balloon-border-width))}.ck.ck-balloon-panel[class*=arrow_e]:after,.ck.ck-balloon-panel[class*=arrow_e]:before{border-width:var(--ck-balloon-arrow-half-width) 0 var(--ck-balloon-arrow-half-width) var(--ck-balloon-arrow-height)}.ck.ck-balloon-panel[class*=arrow_e]:before{border-color:transparent transparent transparent var(--ck-color-panel-border);margin-right:calc(var(--ck-balloon-border-width)*-1)}.ck.ck-balloon-panel[class*=arrow_e]:after{border-color:transparent transparent transparent var(--ck-color-panel-background);margin-right:calc(var(--ck-balloon-arrow-offset) - var(--ck-balloon-border-width))}.ck.ck-balloon-panel[class*=arrow_w]:after,.ck.ck-balloon-panel[class*=arrow_w]:before{border-width:var(--ck-balloon-arrow-half-width) var(--ck-balloon-arrow-height) var(--ck-balloon-arrow-half-width) 0}.ck.ck-balloon-panel[class*=arrow_w]:before{border-color:transparent var(--ck-color-panel-border) transparent transparent;margin-left:calc(var(--ck-balloon-border-width)*-1)}.ck.ck-balloon-panel[class*=arrow_w]:after{border-color:transparent var(--ck-color-panel-background) transparent transparent;margin-left:calc(var(--ck-balloon-arrow-offset) - var(--ck-balloon-border-width))}.ck.ck-balloon-panel.ck-balloon-panel_arrow_n:after,.ck.ck-balloon-panel.ck-balloon-panel_arrow_n:before{left:50%;margin-left:calc(var(--ck-balloon-arrow-half-width)*-1);top:calc(var(--ck-balloon-arrow-height)*-1)}.ck.ck-balloon-panel.ck-balloon-panel_arrow_nw:after,.ck.ck-balloon-panel.ck-balloon-panel_arrow_nw:before{left:calc(var(--ck-balloon-arrow-half-width)*2);top:calc(var(--ck-balloon-arrow-height)*-1)}.ck.ck-balloon-panel.ck-balloon-panel_arrow_ne:after,.ck.ck-balloon-panel.ck-balloon-panel_arrow_ne:before{right:calc(var(--ck-balloon-arrow-half-width)*2);top:calc(var(--ck-balloon-arrow-height)*-1)}.ck.ck-balloon-panel.ck-balloon-panel_arrow_s:after,.ck.ck-balloon-panel.ck-balloon-panel_arrow_s:before{bottom:calc(var(--ck-balloon-arrow-height)*-1);left:50%;margin-left:calc(var(--ck-balloon-arrow-half-width)*-1)}.ck.ck-balloon-panel.ck-balloon-panel_arrow_sw:after,.ck.ck-balloon-panel.ck-balloon-panel_arrow_sw:before{bottom:calc(var(--ck-balloon-arrow-height)*-1);left:calc(var(--ck-balloon-arrow-half-width)*2)}.ck.ck-balloon-panel.ck-balloon-panel_arrow_se:after,.ck.ck-balloon-panel.ck-balloon-panel_arrow_se:before{bottom:calc(var(--ck-balloon-arrow-height)*-1);right:calc(var(--ck-balloon-arrow-half-width)*2)}.ck.ck-balloon-panel.ck-balloon-panel_arrow_sme:after,.ck.ck-balloon-panel.ck-balloon-panel_arrow_sme:before{bottom:calc(var(--ck-balloon-arrow-height)*-1);margin-right:calc(var(--ck-balloon-arrow-half-width)*2);right:25%}.ck.ck-balloon-panel.ck-balloon-panel_arrow_smw:after,.ck.ck-balloon-panel.ck-balloon-panel_arrow_smw:before{bottom:calc(var(--ck-balloon-arrow-height)*-1);left:25%;margin-left:calc(var(--ck-balloon-arrow-half-width)*2)}.ck.ck-balloon-panel.ck-balloon-panel_arrow_nme:after,.ck.ck-balloon-panel.ck-balloon-panel_arrow_nme:before{margin-right:calc(var(--ck-balloon-arrow-half-width)*2);right:25%;top:calc(var(--ck-balloon-arrow-height)*-1)}.ck.ck-balloon-panel.ck-balloon-panel_arrow_nmw:after,.ck.ck-balloon-panel.ck-balloon-panel_arrow_nmw:before{left:25%;margin-left:calc(var(--ck-balloon-arrow-half-width)*2);top:calc(var(--ck-balloon-arrow-height)*-1)}.ck.ck-balloon-panel.ck-balloon-panel_arrow_e:after,.ck.ck-balloon-panel.ck-balloon-panel_arrow_e:before{margin-top:calc(var(--ck-balloon-arrow-half-width)*-1);right:calc(var(--ck-balloon-arrow-height)*-1);top:50%}.ck.ck-balloon-panel.ck-balloon-panel_arrow_w:after,.ck.ck-balloon-panel.ck-balloon-panel_arrow_w:before{left:calc(var(--ck-balloon-arrow-height)*-1);margin-top:calc(var(--ck-balloon-arrow-half-width)*-1);top:50%}',
              "",
              {
                version: 3,
                sources: [
                  "webpack://./node_modules/@ckeditor/ckeditor5-ui/theme/components/panel/balloonpanel.css",
                  "webpack://./node_modules/@ckeditor/ckeditor5-theme-lark/theme/ckeditor5-ui/components/panel/balloonpanel.css",
                  "webpack://./node_modules/@ckeditor/ckeditor5-theme-lark/theme/mixins/_rounded.css",
                  "webpack://./node_modules/@ckeditor/ckeditor5-theme-lark/theme/mixins/_shadow.css",
                ],
                names: [],
                mappings:
                  "AAKA,MAEC,8DACD,CAEA,qBACC,YAAa,CACb,iBAAkB,CAElB,yBAyCD,CAtCE,+GAEC,UAAW,CACX,iBACD,CAEA,wDACC,6CACD,CAEA,uDACC,uDACD,CAIA,4CACC,6CACD,CAEA,2CACC,uDACD,CAIA,4CACC,6CACD,CAEA,2CACC,uDACD,CAGD,8CACC,aACD,CC9CD,MACC,6BAA8B,CAC9B,6BAA8B,CAC9B,8BAA+B,CAC/B,iCAAkC,CAClC,oEACD,CAEA,qBCLC,eDmMD,CA9LA,iFCDE,qCD+LF,CA9LA,qBAMC,2CAA4C,CAC5C,wEAAyE,CEdzE,oCAA8B,CFW9B,eA0LD,CApLE,+GAIC,kBAAmB,CADnB,QAAS,CADT,OAGD,CAIA,uFAEC,mHACD,CAEA,4CACC,6EAA8E,CAC9E,kDACD,CAEA,2CACC,iFAAkF,CAClF,gFACD,CAIA,uFAEC,mHACD,CAEA,4CACC,iEAAkE,CAClE,uDAAwD,CACxD,qDACD,CAEA,2CACC,iFAAkF,CAClF,mFACD,CAIA,uFAEC,mHACD,CAEA,4CACC,6EAA8E,CAC9E,oDACD,CAEA,2CACC,iFAAkF,CAClF,kFACD,CAIA,uFAEC,mHACD,CAEA,4CACC,6EAA8E,CAC9E,mDACD,CAEA,2CACC,iFAAkF,CAClF,iFACD,CAIA,yGAEC,QAAS,CACT,uDAA0D,CAC1D,2CACD,CAIA,2GAEC,+CAAkD,CAClD,2CACD,CAIA,2GAEC,gDAAmD,CACnD,2CACD,CAIA,yGAIC,8CAAiD,CAFjD,QAAS,CACT,uDAED,CAIA,2GAGC,8CAAiD,CADjD,+CAED,CAIA,2GAGC,8CAAiD,CADjD,gDAED,CAIA,6GAIC,8CAAiD,CADjD,uDAA0D,CAD1D,SAGD,CAIA,6GAIC,8CAAiD,CAFjD,QAAS,CACT,sDAED,CAIA,6GAGC,uDAA0D,CAD1D,SAAU,CAEV,2CACD,CAIA,6GAEC,QAAS,CACT,sDAAyD,CACzD,2CACD,CAIA,yGAGC,sDAAyD,CADzD,6CAAgD,CAEhD,OACD,CAIA,yGAEC,4CAA+C,CAC/C,sDAAyD,CACzD,OACD",
                sourcesContent: [
                  '/*\n * Copyright (c) 2003-2022, CKSource Holding sp. z o.o. All rights reserved.\n * For licensing, see LICENSE.md or https://ckeditor.com/legal/ckeditor-oss-license\n */\n\n:root {\n\t/* Make sure the balloon arrow does not float over its children. */\n\t--ck-balloon-panel-arrow-z-index: calc(var(--ck-z-default) - 3);\n}\n\n.ck.ck-balloon-panel {\n\tdisplay: none;\n\tposition: absolute;\n\n\tz-index: var(--ck-z-modal);\n\n\t&.ck-balloon-panel_with-arrow {\n\t\t&::before,\n\t\t&::after {\n\t\t\tcontent: "";\n\t\t\tposition: absolute;\n\t\t}\n\n\t\t&::before {\n\t\t\tz-index: var(--ck-balloon-panel-arrow-z-index);\n\t\t}\n\n\t\t&::after {\n\t\t\tz-index: calc(var(--ck-balloon-panel-arrow-z-index) + 1);\n\t\t}\n\t}\n\n\t&[class*="arrow_n"] {\n\t\t&::before {\n\t\t\tz-index: var(--ck-balloon-panel-arrow-z-index);\n\t\t}\n\n\t\t&::after {\n\t\t\tz-index: calc(var(--ck-balloon-panel-arrow-z-index) + 1);\n\t\t}\n\t}\n\n\t&[class*="arrow_s"] {\n\t\t&::before {\n\t\t\tz-index: var(--ck-balloon-panel-arrow-z-index);\n\t\t}\n\n\t\t&::after {\n\t\t\tz-index: calc(var(--ck-balloon-panel-arrow-z-index) + 1);\n\t\t}\n\t}\n\n\t&.ck-balloon-panel_visible {\n\t\tdisplay: block;\n\t}\n}\n',
                  '/*\n * Copyright (c) 2003-2022, CKSource Holding sp. z o.o. All rights reserved.\n * For licensing, see LICENSE.md or https://ckeditor.com/legal/ckeditor-oss-license\n */\n\n@import "../../../mixins/_rounded.css";\n@import "../../../mixins/_shadow.css";\n\n:root {\n\t--ck-balloon-border-width: 1px;\n\t--ck-balloon-arrow-offset: 2px;\n\t--ck-balloon-arrow-height: 10px;\n\t--ck-balloon-arrow-half-width: 8px;\n\t--ck-balloon-arrow-drop-shadow: 0 2px 2px var(--ck-color-shadow-drop);\n}\n\n.ck.ck-balloon-panel {\n\t@mixin ck-rounded-corners;\n\t@mixin ck-drop-shadow;\n\n\tmin-height: 15px;\n\n\tbackground: var(--ck-color-panel-background);\n\tborder: var(--ck-balloon-border-width) solid var(--ck-color-panel-border);\n\n\t&.ck-balloon-panel_with-arrow {\n\t\t&::before,\n\t\t&::after {\n\t\t\twidth: 0;\n\t\t\theight: 0;\n\t\t\tborder-style: solid;\n\t\t}\n\t}\n\n\t&[class*="arrow_n"] {\n\t\t&::before,\n\t\t&::after {\n\t\t\tborder-width: 0 var(--ck-balloon-arrow-half-width) var(--ck-balloon-arrow-height) var(--ck-balloon-arrow-half-width);\n\t\t}\n\n\t\t&::before {\n\t\t\tborder-color: transparent transparent var(--ck-color-panel-border) transparent;\n\t\t\tmargin-top: calc( -1 * var(--ck-balloon-border-width) );\n\t\t}\n\n\t\t&::after {\n\t\t\tborder-color: transparent transparent var(--ck-color-panel-background) transparent;\n\t\t\tmargin-top: calc( var(--ck-balloon-arrow-offset) - var(--ck-balloon-border-width) );\n\t\t}\n\t}\n\n\t&[class*="arrow_s"] {\n\t\t&::before,\n\t\t&::after {\n\t\t\tborder-width: var(--ck-balloon-arrow-height) var(--ck-balloon-arrow-half-width) 0 var(--ck-balloon-arrow-half-width);\n\t\t}\n\n\t\t&::before {\n\t\t\tborder-color: var(--ck-color-panel-border) transparent transparent;\n\t\t\tfilter: drop-shadow(var(--ck-balloon-arrow-drop-shadow));\n\t\t\tmargin-bottom: calc( -1 * var(--ck-balloon-border-width) );\n\t\t}\n\n\t\t&::after {\n\t\t\tborder-color: var(--ck-color-panel-background) transparent transparent transparent;\n\t\t\tmargin-bottom: calc( var(--ck-balloon-arrow-offset) - var(--ck-balloon-border-width) );\n\t\t}\n\t}\n\n\t&[class*="arrow_e"] {\n\t\t&::before,\n\t\t&::after {\n\t\t\tborder-width: var(--ck-balloon-arrow-half-width) 0 var(--ck-balloon-arrow-half-width) var(--ck-balloon-arrow-height);\n\t\t}\n\n\t\t&::before {\n\t\t\tborder-color: transparent transparent transparent var(--ck-color-panel-border);\n\t\t\tmargin-right: calc( -1 * var(--ck-balloon-border-width) );\n\t\t}\n\n\t\t&::after {\n\t\t\tborder-color: transparent transparent transparent var(--ck-color-panel-background);\n\t\t\tmargin-right: calc( var(--ck-balloon-arrow-offset) - var(--ck-balloon-border-width) );\n\t\t}\n\t}\n\n\t&[class*="arrow_w"] {\n\t\t&::before,\n\t\t&::after {\n\t\t\tborder-width: var(--ck-balloon-arrow-half-width) var(--ck-balloon-arrow-height) var(--ck-balloon-arrow-half-width) 0;\n\t\t}\n\n\t\t&::before {\n\t\t\tborder-color: transparent var(--ck-color-panel-border) transparent transparent;\n\t\t\tmargin-left: calc( -1 * var(--ck-balloon-border-width) );\n\t\t}\n\n\t\t&::after {\n\t\t\tborder-color: transparent var(--ck-color-panel-background) transparent transparent;\n\t\t\tmargin-left: calc( var(--ck-balloon-arrow-offset) - var(--ck-balloon-border-width) );\n\t\t}\n\t}\n\n\t&.ck-balloon-panel_arrow_n {\n\t\t&::before,\n\t\t&::after {\n\t\t\tleft: 50%;\n\t\t\tmargin-left: calc(-1 * var(--ck-balloon-arrow-half-width));\n\t\t\ttop: calc(-1 * var(--ck-balloon-arrow-height));\n\t\t}\n\t}\n\n\t&.ck-balloon-panel_arrow_nw {\n\t\t&::before,\n\t\t&::after {\n\t\t\tleft: calc(2 * var(--ck-balloon-arrow-half-width));\n\t\t\ttop: calc(-1 * var(--ck-balloon-arrow-height));\n\t\t}\n\t}\n\n\t&.ck-balloon-panel_arrow_ne {\n\t\t&::before,\n\t\t&::after {\n\t\t\tright: calc(2 * var(--ck-balloon-arrow-half-width));\n\t\t\ttop: calc(-1 * var(--ck-balloon-arrow-height));\n\t\t}\n\t}\n\n\t&.ck-balloon-panel_arrow_s {\n\t\t&::before,\n\t\t&::after {\n\t\t\tleft: 50%;\n\t\t\tmargin-left: calc(-1 * var(--ck-balloon-arrow-half-width));\n\t\t\tbottom: calc(-1 * var(--ck-balloon-arrow-height));\n\t\t}\n\t}\n\n\t&.ck-balloon-panel_arrow_sw {\n\t\t&::before,\n\t\t&::after {\n\t\t\tleft: calc(2 * var(--ck-balloon-arrow-half-width));\n\t\t\tbottom: calc(-1 * var(--ck-balloon-arrow-height));\n\t\t}\n\t}\n\n\t&.ck-balloon-panel_arrow_se {\n\t\t&::before,\n\t\t&::after {\n\t\t\tright: calc(2 * var(--ck-balloon-arrow-half-width));\n\t\t\tbottom: calc(-1 * var(--ck-balloon-arrow-height));\n\t\t}\n\t}\n\n\t&.ck-balloon-panel_arrow_sme {\n\t\t&::before,\n\t\t&::after {\n\t\t\tright: 25%;\n\t\t\tmargin-right: calc(2 * var(--ck-balloon-arrow-half-width));\n\t\t\tbottom: calc(-1 * var(--ck-balloon-arrow-height));\n\t\t}\n\t}\n\n\t&.ck-balloon-panel_arrow_smw {\n\t\t&::before,\n\t\t&::after {\n\t\t\tleft: 25%;\n\t\t\tmargin-left: calc(2 * var(--ck-balloon-arrow-half-width));\n\t\t\tbottom: calc(-1 * var(--ck-balloon-arrow-height));\n\t\t}\n\t}\n\n\t&.ck-balloon-panel_arrow_nme {\n\t\t&::before,\n\t\t&::after {\n\t\t\tright: 25%;\n\t\t\tmargin-right: calc(2 * var(--ck-balloon-arrow-half-width));\n\t\t\ttop: calc(-1 * var(--ck-balloon-arrow-height));\n\t\t}\n\t}\n\n\t&.ck-balloon-panel_arrow_nmw {\n\t\t&::before,\n\t\t&::after {\n\t\t\tleft: 25%;\n\t\t\tmargin-left: calc(2 * var(--ck-balloon-arrow-half-width));\n\t\t\ttop: calc(-1 * var(--ck-balloon-arrow-height));\n\t\t}\n\t}\n\n\t&.ck-balloon-panel_arrow_e {\n\t\t&::before,\n\t\t&::after {\n\t\t\tright: calc(-1 * var(--ck-balloon-arrow-height));\n\t\t\tmargin-top: calc(-1 * var(--ck-balloon-arrow-half-width));\n\t\t\ttop: 50%;\n\t\t}\n\t}\n\n\t&.ck-balloon-panel_arrow_w {\n\t\t&::before,\n\t\t&::after {\n\t\t\tleft: calc(-1 * var(--ck-balloon-arrow-height));\n\t\t\tmargin-top: calc(-1 * var(--ck-balloon-arrow-half-width));\n\t\t\ttop: 50%;\n\t\t}\n\t}\n}\n',
                  "/*\n * Copyright (c) 2003-2022, CKSource Holding sp. z o.o. All rights reserved.\n * For licensing, see LICENSE.md or https://ckeditor.com/legal/ckeditor-oss-license\n */\n\n/**\n * Implements rounded corner interface for .ck-rounded-corners class.\n *\n * @see $ck-border-radius\n */\n@define-mixin ck-rounded-corners {\n\tborder-radius: 0;\n\n\t@nest .ck-rounded-corners &,\n\t&.ck-rounded-corners {\n\t\tborder-radius: var(--ck-border-radius);\n\t\t@mixin-content;\n\t}\n}\n",
                  "/*\n * Copyright (c) 2003-2022, CKSource Holding sp. z o.o. All rights reserved.\n * For licensing, see LICENSE.md or https://ckeditor.com/legal/ckeditor-oss-license\n */\n\n/**\n * A helper to combine multiple shadows.\n */\n@define-mixin ck-box-shadow $shadowA, $shadowB: 0 0 {\n\tbox-shadow: $shadowA, $shadowB;\n}\n\n/**\n * Gives an element a drop shadow so it looks like a floating panel.\n */\n@define-mixin ck-drop-shadow {\n\t@mixin ck-box-shadow var(--ck-drop-shadow);\n}\n",
                ],
                sourceRoot: "",
              },
            ]);
            const a = s;
          },
          1757: (t, e, n) => {
            "use strict";
            n.d(e, { Z: () => a });
            var o = n(7537),
              i = n.n(o),
              r = n(3645),
              s = n.n(r)()(i());
            s.push([
              t.id,
              ".ck .ck-balloon-rotator__navigation{align-items:center;display:flex;justify-content:center}.ck .ck-balloon-rotator__content .ck-toolbar{justify-content:center}.ck .ck-balloon-rotator__navigation{background:var(--ck-color-toolbar-background);border-bottom:1px solid var(--ck-color-toolbar-border);padding:0 var(--ck-spacing-small)}.ck .ck-balloon-rotator__navigation>*{margin-bottom:var(--ck-spacing-small);margin-right:var(--ck-spacing-small);margin-top:var(--ck-spacing-small)}.ck .ck-balloon-rotator__navigation .ck-balloon-rotator__counter{margin-left:var(--ck-spacing-small);margin-right:var(--ck-spacing-standard)}.ck .ck-balloon-rotator__content .ck.ck-annotation-wrapper{box-shadow:none}",
              "",
              {
                version: 3,
                sources: [
                  "webpack://./node_modules/@ckeditor/ckeditor5-ui/theme/components/panel/balloonrotator.css",
                  "webpack://./node_modules/@ckeditor/ckeditor5-theme-lark/theme/ckeditor5-ui/components/panel/balloonrotator.css",
                ],
                names: [],
                mappings:
                  "AAKA,oCAEC,kBAAmB,CADnB,YAAa,CAEb,sBACD,CAKA,6CACC,sBACD,CCXA,oCACC,6CAA8C,CAC9C,sDAAuD,CACvD,iCAgBD,CAbC,sCAGC,qCAAsC,CAFtC,oCAAqC,CACrC,kCAED,CAGA,iEAIC,mCAAoC,CAHpC,uCAID,CAMA,2DACC,eACD",
                sourcesContent: [
                  "/*\n * Copyright (c) 2003-2022, CKSource Holding sp. z o.o. All rights reserved.\n * For licensing, see LICENSE.md or https://ckeditor.com/legal/ckeditor-oss-license\n */\n\n.ck .ck-balloon-rotator__navigation {\n\tdisplay: flex;\n\talign-items: center;\n\tjustify-content: center;\n}\n\n/* Buttons inside a toolbar should be centered when rotator bar is wider.\n * See: https://github.com/ckeditor/ckeditor5-ui/issues/495\n */\n.ck .ck-balloon-rotator__content .ck-toolbar {\n\tjustify-content: center;\n}\n",
                  "/*\n * Copyright (c) 2003-2022, CKSource Holding sp. z o.o. All rights reserved.\n * For licensing, see LICENSE.md or https://ckeditor.com/legal/ckeditor-oss-license\n */\n\n.ck .ck-balloon-rotator__navigation {\n\tbackground: var(--ck-color-toolbar-background);\n\tborder-bottom: 1px solid var(--ck-color-toolbar-border);\n\tpadding: 0 var(--ck-spacing-small);\n\n\t/* Let's keep similar appearance to `ck-toolbar`. */\n\t& > * {\n\t\tmargin-right: var(--ck-spacing-small);\n\t\tmargin-top: var(--ck-spacing-small);\n\t\tmargin-bottom: var(--ck-spacing-small);\n\t}\n\n\t/* Gives counter more breath than buttons. */\n\t& .ck-balloon-rotator__counter {\n\t\tmargin-right: var(--ck-spacing-standard);\n\n\t\t/* We need to use smaller margin because of previous button's right margin. */\n\t\tmargin-left: var(--ck-spacing-small);\n\t}\n}\n\n.ck .ck-balloon-rotator__content {\n\n\t/* Disable default annotation shadow inside rotator with fake panels. */\n\t& .ck.ck-annotation-wrapper {\n\t\tbox-shadow: none;\n\t}\n}\n",
                ],
                sourceRoot: "",
              },
            ]);
            const a = s;
          },
          3553: (t, e, n) => {
            "use strict";
            n.d(e, { Z: () => a });
            var o = n(7537),
              i = n.n(o),
              r = n(3645),
              s = n.n(r)()(i());
            s.push([
              t.id,
              ".ck .ck-fake-panel{position:absolute;z-index:calc(var(--ck-z-modal) - 1)}.ck .ck-fake-panel div{position:absolute}.ck .ck-fake-panel div:first-child{z-index:2}.ck .ck-fake-panel div:nth-child(2){z-index:1}:root{--ck-balloon-fake-panel-offset-horizontal:6px;--ck-balloon-fake-panel-offset-vertical:6px}.ck .ck-fake-panel div{background:var(--ck-color-panel-background);border:1px solid var(--ck-color-panel-border);border-radius:var(--ck-border-radius);box-shadow:var(--ck-drop-shadow),0 0;height:100%;min-height:15px;width:100%}.ck .ck-fake-panel div:first-child{margin-left:var(--ck-balloon-fake-panel-offset-horizontal);margin-top:var(--ck-balloon-fake-panel-offset-vertical)}.ck .ck-fake-panel div:nth-child(2){margin-left:calc(var(--ck-balloon-fake-panel-offset-horizontal)*2);margin-top:calc(var(--ck-balloon-fake-panel-offset-vertical)*2)}.ck .ck-fake-panel div:nth-child(3){margin-left:calc(var(--ck-balloon-fake-panel-offset-horizontal)*3);margin-top:calc(var(--ck-balloon-fake-panel-offset-vertical)*3)}.ck .ck-balloon-panel_arrow_s+.ck-fake-panel,.ck .ck-balloon-panel_arrow_se+.ck-fake-panel,.ck .ck-balloon-panel_arrow_sw+.ck-fake-panel{--ck-balloon-fake-panel-offset-vertical:-6px}",
              "",
              {
                version: 3,
                sources: [
                  "webpack://./node_modules/@ckeditor/ckeditor5-ui/theme/components/panel/fakepanel.css",
                  "webpack://./node_modules/@ckeditor/ckeditor5-theme-lark/theme/ckeditor5-ui/components/panel/fakepanel.css",
                  "webpack://./node_modules/@ckeditor/ckeditor5-theme-lark/theme/mixins/_shadow.css",
                ],
                names: [],
                mappings:
                  "AAKA,mBACC,iBAAkB,CAGlB,mCACD,CAEA,uBACC,iBACD,CAEA,mCACC,SACD,CAEA,oCACC,SACD,CCfA,MACC,6CAA8C,CAC9C,2CACD,CAGA,uBAKC,2CAA4C,CAC5C,6CAA8C,CAC9C,qCAAsC,CCXtC,oCAA8B,CDc9B,WAAY,CAPZ,eAAgB,CAMhB,UAED,CAEA,mCACC,0DAA2D,CAC3D,uDACD,CAEA,oCACC,kEAAqE,CACrE,+DACD,CACA,oCACC,kEAAqE,CACrE,+DACD,CAGA,yIAGC,4CACD",
                sourcesContent: [
                  "/*\n * Copyright (c) 2003-2022, CKSource Holding sp. z o.o. All rights reserved.\n * For licensing, see LICENSE.md or https://ckeditor.com/legal/ckeditor-oss-license\n */\n\n.ck .ck-fake-panel {\n\tposition: absolute;\n\n\t/* Fake panels should be placed under main balloon content. */\n\tz-index: calc(var(--ck-z-modal) - 1);\n}\n\n.ck .ck-fake-panel div {\n\tposition: absolute;\n}\n\n.ck .ck-fake-panel div:nth-child( 1 ) {\n\tz-index: 2;\n}\n\n.ck .ck-fake-panel div:nth-child( 2 ) {\n\tz-index: 1;\n}\n",
                  '/*\n * Copyright (c) 2003-2022, CKSource Holding sp. z o.o. All rights reserved.\n * For licensing, see LICENSE.md or https://ckeditor.com/legal/ckeditor-oss-license\n */\n\n@import "../../../mixins/_shadow.css";\n\n:root {\n\t--ck-balloon-fake-panel-offset-horizontal: 6px;\n\t--ck-balloon-fake-panel-offset-vertical: 6px;\n}\n\n/* Let\'s use `.ck-balloon-panel` appearance. See: balloonpanel.css. */\n.ck .ck-fake-panel div {\n\t@mixin ck-drop-shadow;\n\n\tmin-height: 15px;\n\n\tbackground: var(--ck-color-panel-background);\n\tborder: 1px solid var(--ck-color-panel-border);\n\tborder-radius: var(--ck-border-radius);\n\n\twidth: 100%;\n\theight: 100%;\n}\n\n.ck .ck-fake-panel div:nth-child( 1 ) {\n\tmargin-left: var(--ck-balloon-fake-panel-offset-horizontal);\n\tmargin-top: var(--ck-balloon-fake-panel-offset-vertical);\n}\n\n.ck .ck-fake-panel div:nth-child( 2 ) {\n\tmargin-left: calc(var(--ck-balloon-fake-panel-offset-horizontal) * 2);\n\tmargin-top: calc(var(--ck-balloon-fake-panel-offset-vertical) * 2);\n}\n.ck .ck-fake-panel div:nth-child( 3 ) {\n\tmargin-left: calc(var(--ck-balloon-fake-panel-offset-horizontal) * 3);\n\tmargin-top: calc(var(--ck-balloon-fake-panel-offset-vertical) * 3);\n}\n\n/* If balloon is positioned above element, we need to move fake panel to the top. */\n.ck .ck-balloon-panel_arrow_s + .ck-fake-panel,\n.ck .ck-balloon-panel_arrow_se + .ck-fake-panel,\n.ck .ck-balloon-panel_arrow_sw + .ck-fake-panel {\n\t--ck-balloon-fake-panel-offset-vertical: -6px;\n}\n',
                  "/*\n * Copyright (c) 2003-2022, CKSource Holding sp. z o.o. All rights reserved.\n * For licensing, see LICENSE.md or https://ckeditor.com/legal/ckeditor-oss-license\n */\n\n/**\n * A helper to combine multiple shadows.\n */\n@define-mixin ck-box-shadow $shadowA, $shadowB: 0 0 {\n\tbox-shadow: $shadowA, $shadowB;\n}\n\n/**\n * Gives an element a drop shadow so it looks like a floating panel.\n */\n@define-mixin ck-drop-shadow {\n\t@mixin ck-box-shadow var(--ck-drop-shadow);\n}\n",
                ],
                sourceRoot: "",
              },
            ]);
            const a = s;
          },
          3609: (t, e, n) => {
            "use strict";
            n.d(e, { Z: () => a });
            var o = n(7537),
              i = n.n(o),
              r = n(3645),
              s = n.n(r)()(i());
            s.push([
              t.id,
              ".ck.ck-sticky-panel .ck-sticky-panel__content_sticky{position:fixed;top:0;z-index:var(--ck-z-modal)}.ck.ck-sticky-panel .ck-sticky-panel__content_sticky_bottom-limit{position:absolute;top:auto}.ck.ck-sticky-panel .ck-sticky-panel__content_sticky{border-top-left-radius:0;border-top-right-radius:0;border-width:0 1px 1px;box-shadow:var(--ck-drop-shadow),0 0}",
              "",
              {
                version: 3,
                sources: [
                  "webpack://./node_modules/@ckeditor/ckeditor5-ui/theme/components/panel/stickypanel.css",
                  "webpack://./node_modules/@ckeditor/ckeditor5-theme-lark/theme/ckeditor5-ui/components/panel/stickypanel.css",
                  "webpack://./node_modules/@ckeditor/ckeditor5-theme-lark/theme/mixins/_shadow.css",
                ],
                names: [],
                mappings:
                  "AAMC,qDAEC,cAAe,CACf,KAAM,CAFN,yBAGD,CAEA,kEAEC,iBAAkB,CADlB,QAED,CCPA,qDAIC,wBAAyB,CACzB,yBAA0B,CAF1B,sBAAuB,CCFxB,oCDKA",
                sourcesContent: [
                  "/*\n * Copyright (c) 2003-2022, CKSource Holding sp. z o.o. All rights reserved.\n * For licensing, see LICENSE.md or https://ckeditor.com/legal/ckeditor-oss-license\n */\n\n.ck.ck-sticky-panel {\n\t& .ck-sticky-panel__content_sticky {\n\t\tz-index: var(--ck-z-modal); /* #315 */\n\t\tposition: fixed;\n\t\ttop: 0;\n\t}\n\n\t& .ck-sticky-panel__content_sticky_bottom-limit {\n\t\ttop: auto;\n\t\tposition: absolute;\n\t}\n}\n",
                  '/*\n * Copyright (c) 2003-2022, CKSource Holding sp. z o.o. All rights reserved.\n * For licensing, see LICENSE.md or https://ckeditor.com/legal/ckeditor-oss-license\n */\n\n@import "../../../mixins/_shadow.css";\n\n.ck.ck-sticky-panel {\n\t& .ck-sticky-panel__content_sticky {\n\t\t@mixin ck-drop-shadow;\n\n\t\tborder-width: 0 1px 1px;\n\t\tborder-top-left-radius: 0;\n\t\tborder-top-right-radius: 0;\n\t}\n}\n',
                  "/*\n * Copyright (c) 2003-2022, CKSource Holding sp. z o.o. All rights reserved.\n * For licensing, see LICENSE.md or https://ckeditor.com/legal/ckeditor-oss-license\n */\n\n/**\n * A helper to combine multiple shadows.\n */\n@define-mixin ck-box-shadow $shadowA, $shadowB: 0 0 {\n\tbox-shadow: $shadowA, $shadowB;\n}\n\n/**\n * Gives an element a drop shadow so it looks like a floating panel.\n */\n@define-mixin ck-drop-shadow {\n\t@mixin ck-box-shadow var(--ck-drop-shadow);\n}\n",
                ],
                sourceRoot: "",
              },
            ]);
            const a = s;
          },
          1590: (t, e, n) => {
            "use strict";
            n.d(e, { Z: () => a });
            var o = n(7537),
              i = n.n(o),
              r = n(3645),
              s = n.n(r)()(i());
            s.push([
              t.id,
              '.ck-vertical-form .ck-button:after{bottom:-1px;content:"";position:absolute;right:-1px;top:-1px;width:0;z-index:1}.ck-vertical-form .ck-button:focus:after{display:none}@media screen and (max-width:600px){.ck.ck-responsive-form .ck-button:after{bottom:-1px;content:"";position:absolute;right:-1px;top:-1px;width:0;z-index:1}.ck.ck-responsive-form .ck-button:focus:after{display:none}}.ck-vertical-form>.ck-button:nth-last-child(2):after{border-right:1px solid var(--ck-color-base-border)}.ck.ck-responsive-form{padding:var(--ck-spacing-large)}.ck.ck-responsive-form:focus{outline:none}[dir=ltr] .ck.ck-responsive-form>:not(:first-child),[dir=rtl] .ck.ck-responsive-form>:not(:last-child){margin-left:var(--ck-spacing-standard)}@media screen and (max-width:600px){.ck.ck-responsive-form{padding:0;width:calc(var(--ck-input-width)*.8)}.ck.ck-responsive-form .ck-labeled-field-view{margin:var(--ck-spacing-large) var(--ck-spacing-large) 0}.ck.ck-responsive-form .ck-labeled-field-view .ck-input-text{min-width:0;width:100%}.ck.ck-responsive-form .ck-labeled-field-view .ck-labeled-field-view__error{white-space:normal}.ck.ck-responsive-form>.ck-button:nth-last-child(2):after{border-right:1px solid var(--ck-color-base-border)}.ck.ck-responsive-form>.ck-button:last-child,.ck.ck-responsive-form>.ck-button:nth-last-child(2){border-radius:0;margin-top:var(--ck-spacing-large);padding:var(--ck-spacing-standard)}.ck.ck-responsive-form>.ck-button:last-child:not(:focus),.ck.ck-responsive-form>.ck-button:nth-last-child(2):not(:focus){border-top:1px solid var(--ck-color-base-border)}[dir=ltr] .ck.ck-responsive-form>.ck-button:last-child,[dir=ltr] .ck.ck-responsive-form>.ck-button:nth-last-child(2),[dir=rtl] .ck.ck-responsive-form>.ck-button:last-child,[dir=rtl] .ck.ck-responsive-form>.ck-button:nth-last-child(2){margin-left:0}[dir=rtl] .ck.ck-responsive-form>.ck-button:last-child:last-of-type,[dir=rtl] .ck.ck-responsive-form>.ck-button:nth-last-child(2):last-of-type{border-right:1px solid var(--ck-color-base-border)}}',
              "",
              {
                version: 3,
                sources: [
                  "webpack://./node_modules/@ckeditor/ckeditor5-ui/theme/components/responsive-form/responsiveform.css",
                  "webpack://./node_modules/@ckeditor/ckeditor5-ui/theme/mixins/_rwd.css",
                  "webpack://./node_modules/@ckeditor/ckeditor5-theme-lark/theme/ckeditor5-ui/components/responsive-form/responsiveform.css",
                ],
                names: [],
                mappings:
                  "AAQC,mCAMC,WAAY,CALZ,UAAW,CAEX,iBAAkB,CAClB,UAAW,CACX,QAAS,CAHT,OAAQ,CAKR,SACD,CAEA,yCACC,YACD,CCdA,oCDoBE,wCAMC,WAAY,CALZ,UAAW,CAEX,iBAAkB,CAClB,UAAW,CACX,QAAS,CAHT,OAAQ,CAKR,SACD,CAEA,8CACC,YACD,CC9BF,CCAD,qDACC,kDACD,CAEA,uBACC,+BAmED,CAjEC,6BAEC,YACD,CASC,uGACC,sCACD,CDvBD,oCCMD,uBAqBE,SAAU,CACV,oCA8CF,CA5CE,8CACC,wDAWD,CATC,6DACC,WAAY,CACZ,UACD,CAGA,4EACC,kBACD,CAKA,0DACC,kDACD,CAGD,iGAIC,eAAgB,CADhB,kCAAmC,CADnC,kCAmBD,CAfC,yHACC,gDACD,CARD,0OAeE,aAMF,CAJE,+IACC,kDACD,CDpEH",
                sourcesContent: [
                  '/*\n * Copyright (c) 2003-2022, CKSource Holding sp. z o.o. All rights reserved.\n * For licensing, see LICENSE.md or https://ckeditor.com/legal/ckeditor-oss-license\n */\n\n@import "@ckeditor/ckeditor5-ui/theme/mixins/_rwd.css";\n\n.ck-vertical-form .ck-button {\n\t&::after {\n\t\tcontent: "";\n\t\twidth: 0;\n\t\tposition: absolute;\n\t\tright: -1px;\n\t\ttop: -1px;\n\t\tbottom: -1px;\n\t\tz-index: 1;\n\t}\n\n\t&:focus::after {\n\t\tdisplay: none;\n\t}\n}\n\n.ck.ck-responsive-form {\n\t@mixin ck-media-phone {\n\t\t& .ck-button {\n\t\t\t&::after {\n\t\t\t\tcontent: "";\n\t\t\t\twidth: 0;\n\t\t\t\tposition: absolute;\n\t\t\t\tright: -1px;\n\t\t\t\ttop: -1px;\n\t\t\t\tbottom: -1px;\n\t\t\t\tz-index: 1;\n\t\t\t}\n\n\t\t\t&:focus::after {\n\t\t\t\tdisplay: none;\n\t\t\t}\n\t\t}\n\t}\n}\n',
                  "/*\n * Copyright (c) 2003-2022, CKSource Holding sp. z o.o. All rights reserved.\n * For licensing, see LICENSE.md or https://ckeditor.com/legal/ckeditor-oss-license\n */\n\n@define-mixin ck-media-phone {\n\t@media screen and (max-width: 600px) {\n\t\t@mixin-content;\n\t}\n}\n",
                  '/*\n * Copyright (c) 2003-2022, CKSource Holding sp. z o.o. All rights reserved.\n * For licensing, see LICENSE.md or https://ckeditor.com/legal/ckeditor-oss-license\n */\n\n@import "@ckeditor/ckeditor5-ui/theme/mixins/_rwd.css";\n@import "@ckeditor/ckeditor5-ui/theme/mixins/_dir.css";\n\n.ck-vertical-form > .ck-button:nth-last-child(2)::after {\n\tborder-right: 1px solid var(--ck-color-base-border);\n}\n\n.ck.ck-responsive-form {\n\tpadding: var(--ck-spacing-large);\n\n\t&:focus {\n\t\t/* See: https://github.com/ckeditor/ckeditor5/issues/4773 */\n\t\toutline: none;\n\t}\n\n\t@mixin ck-dir ltr {\n\t\t& > :not(:first-child) {\n\t\t\tmargin-left: var(--ck-spacing-standard);\n\t\t}\n\t}\n\n\t@mixin ck-dir rtl {\n\t\t& > :not(:last-child) {\n\t\t\tmargin-left: var(--ck-spacing-standard);\n\t\t}\n\t}\n\n\t@mixin ck-media-phone {\n\t\tpadding: 0;\n\t\twidth: calc(.8 * var(--ck-input-width));\n\n\t\t& .ck-labeled-field-view {\n\t\t\tmargin: var(--ck-spacing-large) var(--ck-spacing-large) 0;\n\n\t\t\t& .ck-input-text {\n\t\t\t\tmin-width: 0;\n\t\t\t\twidth: 100%;\n\t\t\t}\n\n\t\t\t/* Let the long error messages wrap in the narrow form. */\n\t\t\t& .ck-labeled-field-view__error {\n\t\t\t\twhite-space: normal;\n\t\t\t}\n\t\t}\n\n\t\t/* Styles for two last buttons in the form (save&cancel, edit&unlink, etc.). */\n\t\t& > .ck-button:nth-last-child(2) {\n\t\t\t&::after {\n\t\t\t\tborder-right: 1px solid var(--ck-color-base-border);\n\t\t\t}\n\t\t}\n\n\t\t& > .ck-button:nth-last-child(1),\n\t\t& > .ck-button:nth-last-child(2) {\n\t\t\tpadding: var(--ck-spacing-standard);\n\t\t\tmargin-top: var(--ck-spacing-large);\n\t\t\tborder-radius: 0;\n\n\t\t\t&:not(:focus) {\n\t\t\t\tborder-top: 1px solid var(--ck-color-base-border);\n\t\t\t}\n\n\t\t\t@mixin ck-dir ltr {\n\t\t\t\tmargin-left: 0;\n\t\t\t}\n\n\t\t\t@mixin ck-dir rtl {\n\t\t\t\tmargin-left: 0;\n\n\t\t\t\t&:last-of-type {\n\t\t\t\t\tborder-right: 1px solid var(--ck-color-base-border);\n\t\t\t\t}\n\t\t\t}\n\t\t}\n\t}\n}\n',
                ],
                sourceRoot: "",
              },
            ]);
            const a = s;
          },
          6706: (t, e, n) => {
            "use strict";
            n.d(e, { Z: () => a });
            var o = n(7537),
              i = n.n(o),
              r = n(3645),
              s = n.n(r)()(i());
            s.push([
              t.id,
              ".ck.ck-block-toolbar-button{position:absolute;z-index:var(--ck-z-default)}:root{--ck-color-block-toolbar-button:var(--ck-color-text);--ck-block-toolbar-button-size:var(--ck-font-size-normal)}.ck.ck-block-toolbar-button{color:var(--ck-color-block-toolbar-button);font-size:var(--ck-block-toolbar-size)}",
              "",
              {
                version: 3,
                sources: [
                  "webpack://./node_modules/@ckeditor/ckeditor5-ui/theme/components/toolbar/blocktoolbar.css",
                  "webpack://./node_modules/@ckeditor/ckeditor5-theme-lark/theme/ckeditor5-ui/components/toolbar/blocktoolbar.css",
                ],
                names: [],
                mappings:
                  "AAKA,4BACC,iBAAkB,CAClB,2BACD,CCHA,MACC,oDAAqD,CACrD,yDACD,CAEA,4BACC,0CAA2C,CAC3C,sCACD",
                sourcesContent: [
                  "/*\n * Copyright (c) 2003-2022, CKSource Holding sp. z o.o. All rights reserved.\n * For licensing, see LICENSE.md or https://ckeditor.com/legal/ckeditor-oss-license\n */\n\n.ck.ck-block-toolbar-button {\n\tposition: absolute;\n\tz-index: var(--ck-z-default);\n}\n",
                  "/*\n * Copyright (c) 2003-2022, CKSource Holding sp. z o.o. All rights reserved.\n * For licensing, see LICENSE.md or https://ckeditor.com/legal/ckeditor-oss-license\n */\n\n:root {\n\t--ck-color-block-toolbar-button: var(--ck-color-text);\n\t--ck-block-toolbar-button-size: var(--ck-font-size-normal);\n}\n\n.ck.ck-block-toolbar-button {\n\tcolor: var(--ck-color-block-toolbar-button);\n\tfont-size: var(--ck-block-toolbar-size);\n}\n",
                ],
                sourceRoot: "",
              },
            ]);
            const a = s;
          },
          5571: (t, e, n) => {
            "use strict";
            n.d(e, { Z: () => a });
            var o = n(7537),
              i = n.n(o),
              r = n(3645),
              s = n.n(r)()(i());
            s.push([
              t.id,
              ".ck.ck-toolbar{align-items:center;display:flex;flex-flow:row nowrap;-moz-user-select:none;-webkit-user-select:none;-ms-user-select:none;user-select:none}.ck.ck-toolbar>.ck-toolbar__items{align-items:center;display:flex;flex-flow:row wrap;flex-grow:1}.ck.ck-toolbar .ck.ck-toolbar__separator{display:inline-block}.ck.ck-toolbar .ck.ck-toolbar__separator:first-child,.ck.ck-toolbar .ck.ck-toolbar__separator:last-child{display:none}.ck.ck-toolbar .ck-toolbar__line-break{flex-basis:100%}.ck.ck-toolbar.ck-toolbar_grouping>.ck-toolbar__items{flex-wrap:nowrap}.ck.ck-toolbar.ck-toolbar_vertical>.ck-toolbar__items{flex-direction:column}.ck.ck-toolbar.ck-toolbar_floating>.ck-toolbar__items{flex-wrap:nowrap}.ck.ck-toolbar>.ck.ck-toolbar__grouped-dropdown>.ck-dropdown__button .ck-dropdown__arrow{display:none}.ck.ck-toolbar{border-radius:0}.ck-rounded-corners .ck.ck-toolbar,.ck.ck-toolbar.ck-rounded-corners{border-radius:var(--ck-border-radius)}.ck.ck-toolbar{background:var(--ck-color-toolbar-background);border:1px solid var(--ck-color-toolbar-border);padding:0 var(--ck-spacing-small)}.ck.ck-toolbar .ck.ck-toolbar__separator{align-self:stretch;background:var(--ck-color-toolbar-border);margin-bottom:var(--ck-spacing-small);margin-top:var(--ck-spacing-small);min-width:1px;width:1px}.ck.ck-toolbar .ck-toolbar__line-break{height:0}.ck.ck-toolbar>.ck-toolbar__items>:not(.ck-toolbar__line-break){margin-right:var(--ck-spacing-small)}.ck.ck-toolbar>.ck-toolbar__items:empty+.ck.ck-toolbar__separator{display:none}.ck.ck-toolbar>.ck-toolbar__items>:not(.ck-toolbar__line-break),.ck.ck-toolbar>.ck.ck-toolbar__grouped-dropdown{margin-bottom:var(--ck-spacing-small);margin-top:var(--ck-spacing-small)}.ck.ck-toolbar.ck-toolbar_vertical{padding:0}.ck.ck-toolbar.ck-toolbar_vertical>.ck-toolbar__items>.ck{border-radius:0;margin:0;width:100%}.ck.ck-toolbar.ck-toolbar_compact{padding:0}.ck.ck-toolbar.ck-toolbar_compact>.ck-toolbar__items>*{margin:0}.ck.ck-toolbar.ck-toolbar_compact>.ck-toolbar__items>:not(:first-child):not(:last-child){border-radius:0}.ck.ck-toolbar>.ck.ck-toolbar__grouped-dropdown>.ck.ck-button.ck-dropdown__button{padding-left:var(--ck-spacing-tiny)}.ck.ck-toolbar .ck-toolbar__nested-toolbar-dropdown>.ck-dropdown__panel{min-width:auto}.ck.ck-toolbar .ck-toolbar__nested-toolbar-dropdown>.ck-button>.ck-button__label{max-width:7em;width:auto}.ck-toolbar-container .ck.ck-toolbar{border:0}.ck.ck-toolbar[dir=rtl]>.ck-toolbar__items>.ck,[dir=rtl] .ck.ck-toolbar>.ck-toolbar__items>.ck{margin-right:0}.ck.ck-toolbar[dir=rtl]:not(.ck-toolbar_compact)>.ck-toolbar__items>.ck,[dir=rtl] .ck.ck-toolbar:not(.ck-toolbar_compact)>.ck-toolbar__items>.ck{margin-left:var(--ck-spacing-small)}.ck.ck-toolbar[dir=rtl]>.ck-toolbar__items>.ck:last-child,[dir=rtl] .ck.ck-toolbar>.ck-toolbar__items>.ck:last-child{margin-left:0}.ck.ck-toolbar.ck-toolbar_compact[dir=rtl]>.ck-toolbar__items>.ck:first-child,[dir=rtl] .ck.ck-toolbar.ck-toolbar_compact>.ck-toolbar__items>.ck:first-child{border-bottom-left-radius:0;border-top-left-radius:0}.ck.ck-toolbar.ck-toolbar_compact[dir=rtl]>.ck-toolbar__items>.ck:last-child,[dir=rtl] .ck.ck-toolbar.ck-toolbar_compact>.ck-toolbar__items>.ck:last-child{border-bottom-right-radius:0;border-top-right-radius:0}.ck.ck-toolbar.ck-toolbar_grouping[dir=rtl]>.ck-toolbar__items:not(:empty):not(:only-child),.ck.ck-toolbar[dir=rtl]>.ck.ck-toolbar__separator,[dir=rtl] .ck.ck-toolbar.ck-toolbar_grouping>.ck-toolbar__items:not(:empty):not(:only-child),[dir=rtl] .ck.ck-toolbar>.ck.ck-toolbar__separator{margin-left:var(--ck-spacing-small)}.ck.ck-toolbar[dir=ltr]>.ck-toolbar__items>.ck:last-child,[dir=ltr] .ck.ck-toolbar>.ck-toolbar__items>.ck:last-child{margin-right:0}.ck.ck-toolbar.ck-toolbar_compact[dir=ltr]>.ck-toolbar__items>.ck:first-child,[dir=ltr] .ck.ck-toolbar.ck-toolbar_compact>.ck-toolbar__items>.ck:first-child{border-bottom-right-radius:0;border-top-right-radius:0}.ck.ck-toolbar.ck-toolbar_compact[dir=ltr]>.ck-toolbar__items>.ck:last-child,[dir=ltr] .ck.ck-toolbar.ck-toolbar_compact>.ck-toolbar__items>.ck:last-child{border-bottom-left-radius:0;border-top-left-radius:0}.ck.ck-toolbar.ck-toolbar_grouping[dir=ltr]>.ck-toolbar__items:not(:empty):not(:only-child),.ck.ck-toolbar[dir=ltr]>.ck.ck-toolbar__separator,[dir=ltr] .ck.ck-toolbar.ck-toolbar_grouping>.ck-toolbar__items:not(:empty):not(:only-child),[dir=ltr] .ck.ck-toolbar>.ck.ck-toolbar__separator{margin-right:var(--ck-spacing-small)}",
              "",
              {
                version: 3,
                sources: [
                  "webpack://./node_modules/@ckeditor/ckeditor5-ui/theme/components/toolbar/toolbar.css",
                  "webpack://./node_modules/@ckeditor/ckeditor5-ui/theme/mixins/_unselectable.css",
                  "webpack://./node_modules/@ckeditor/ckeditor5-theme-lark/theme/ckeditor5-ui/components/toolbar/toolbar.css",
                  "webpack://./node_modules/@ckeditor/ckeditor5-theme-lark/theme/mixins/_rounded.css",
                ],
                names: [],
                mappings:
                  "AAOA,eAKC,kBAAmB,CAFnB,YAAa,CACb,oBAAqB,CCFrB,qBAAsB,CACtB,wBAAyB,CACzB,oBAAqB,CACrB,gBD6CD,CA3CC,kCAGC,kBAAmB,CAFnB,YAAa,CACb,kBAAmB,CAEnB,WAED,CAEA,yCACC,oBAWD,CAJC,yGAEC,YACD,CAGD,uCACC,eACD,CAEA,sDACC,gBACD,CAEA,sDACC,qBACD,CAEA,sDACC,gBACD,CAGC,yFACC,YACD,CE/CF,eCGC,eDoGD,CAvGA,qECOE,qCDgGF,CAvGA,eAGC,6CAA8C,CAE9C,+CAAgD,CADhD,iCAmGD,CAhGC,yCACC,kBAAmB,CAGnB,yCAA0C,CAO1C,qCAAsC,CADtC,kCAAmC,CAPnC,aAAc,CADd,SAUD,CAEA,uCACC,QACD,CAGC,gEAEC,oCACD,CAIA,kEACC,YACD,CAGD,gHAIC,qCAAsC,CADtC,kCAED,CAEA,mCAEC,SAaD,CAVC,0DAQC,eAAgB,CAHhB,QAAS,CAHT,UAOD,CAGD,kCAEC,SAWD,CATC,uDAEC,QAMD,CAHC,yFACC,eACD,CASD,kFACC,mCACD,CAMA,wEACC,cACD,CAEA,iFACC,aAAc,CACd,UACD,CAjGF,qCAqGE,QAEF,CAYC,+FACC,cACD,CAEA,iJAEC,mCACD,CAEA,qHACC,aACD,CAIC,6JAEC,2BAA4B,CAD5B,wBAED,CAGA,2JAEC,4BAA6B,CAD7B,yBAED,CASD,8RACC,mCACD,CAWA,qHACC,cACD,CAIC,6JAEC,4BAA6B,CAD7B,yBAED,CAGA,2JAEC,2BAA4B,CAD5B,wBAED,CASD,8RACC,oCACD",
                sourcesContent: [
                  '/*\n * Copyright (c) 2003-2022, CKSource Holding sp. z o.o. All rights reserved.\n * For licensing, see LICENSE.md or https://ckeditor.com/legal/ckeditor-oss-license\n */\n\n@import "../../mixins/_unselectable.css";\n\n.ck.ck-toolbar {\n\t@mixin ck-unselectable;\n\n\tdisplay: flex;\n\tflex-flow: row nowrap;\n\talign-items: center;\n\n\t& > .ck-toolbar__items {\n\t\tdisplay: flex;\n\t\tflex-flow: row wrap;\n\t\talign-items: center;\n\t\tflex-grow: 1;\n\n\t}\n\n\t& .ck.ck-toolbar__separator {\n\t\tdisplay: inline-block;\n\n\t\t/*\n\t\t * A leading or trailing separator makes no sense (separates from nothing on one side).\n\t\t * For instance, it can happen when toolbar items (also separators) are getting grouped one by one and\n\t\t * moved to another toolbar in the dropdown.\n\t\t */\n\t\t&:first-child,\n\t\t&:last-child {\n\t\t\tdisplay: none;\n\t\t}\n\t}\n\n\t& .ck-toolbar__line-break {\n\t\tflex-basis: 100%;\n\t}\n\n\t&.ck-toolbar_grouping > .ck-toolbar__items {\n\t\tflex-wrap: nowrap;\n\t}\n\n\t&.ck-toolbar_vertical > .ck-toolbar__items {\n\t\tflex-direction: column;\n\t}\n\n\t&.ck-toolbar_floating > .ck-toolbar__items {\n\t\tflex-wrap: nowrap;\n\t}\n\n\t& > .ck.ck-toolbar__grouped-dropdown {\n\t\t& > .ck-dropdown__button .ck-dropdown__arrow {\n\t\t\tdisplay: none;\n\t\t}\n\t}\n}\n',
                  "/*\n * Copyright (c) 2003-2022, CKSource Holding sp. z o.o. All rights reserved.\n * For licensing, see LICENSE.md or https://ckeditor.com/legal/ckeditor-oss-license\n */\n\n/**\n * Makes element unselectable.\n */\n@define-mixin ck-unselectable {\n\t-moz-user-select: none;\n\t-webkit-user-select: none;\n\t-ms-user-select: none;\n\tuser-select: none\n}\n",
                  '/*\n * Copyright (c) 2003-2022, CKSource Holding sp. z o.o. All rights reserved.\n * For licensing, see LICENSE.md or https://ckeditor.com/legal/ckeditor-oss-license\n */\n\n@import "../../../mixins/_rounded.css";\n@import "@ckeditor/ckeditor5-ui/theme/mixins/_dir.css";\n\n.ck.ck-toolbar {\n\t@mixin ck-rounded-corners;\n\n\tbackground: var(--ck-color-toolbar-background);\n\tpadding: 0 var(--ck-spacing-small);\n\tborder: 1px solid var(--ck-color-toolbar-border);\n\n\t& .ck.ck-toolbar__separator {\n\t\talign-self: stretch;\n\t\twidth: 1px;\n\t\tmin-width: 1px;\n\t\tbackground: var(--ck-color-toolbar-border);\n\n\t\t/*\n\t\t * These margins make the separators look better in balloon toolbars (when aligned with the "tip").\n\t\t * See https://github.com/ckeditor/ckeditor5/issues/7493.\n\t\t */\n\t\tmargin-top: var(--ck-spacing-small);\n\t\tmargin-bottom: var(--ck-spacing-small);\n\t}\n\n\t& .ck-toolbar__line-break {\n\t\theight: 0;\n\t}\n\n\t& > .ck-toolbar__items {\n\t\t& > *:not(.ck-toolbar__line-break) {\n\t\t\t/* (#11) Separate toolbar items. */\n\t\t\tmargin-right: var(--ck-spacing-small);\n\t\t}\n\n\t\t/* Don\'t display a separator after an empty items container, for instance,\n\t\twhen all items were grouped */\n\t\t&:empty + .ck.ck-toolbar__separator {\n\t\t\tdisplay: none;\n\t\t}\n\t}\n\n\t& > .ck-toolbar__items > *:not(.ck-toolbar__line-break),\n\t& > .ck.ck-toolbar__grouped-dropdown {\n\t\t/* Make sure items wrapped to the next line have v-spacing */\n\t\tmargin-top: var(--ck-spacing-small);\n\t\tmargin-bottom: var(--ck-spacing-small);\n\t}\n\n\t&.ck-toolbar_vertical {\n\t\t/* Items in a vertical toolbar span the entire width. */\n\t\tpadding: 0;\n\n\t\t/* Specificity matters here. See https://github.com/ckeditor/ckeditor5-theme-lark/issues/168. */\n\t\t& > .ck-toolbar__items > .ck {\n\t\t\t/* Items in a vertical toolbar should span the horizontal space. */\n\t\t\twidth: 100%;\n\n\t\t\t/* Items in a vertical toolbar should have no margin. */\n\t\t\tmargin: 0;\n\n\t\t\t/* Items in a vertical toolbar span the entire width so rounded corners are pointless. */\n\t\t\tborder-radius: 0;\n\t\t}\n\t}\n\n\t&.ck-toolbar_compact {\n\t\t/* No spacing around items. */\n\t\tpadding: 0;\n\n\t\t& > .ck-toolbar__items > * {\n\t\t\t/* Compact toolbar items have no spacing between them. */\n\t\t\tmargin: 0;\n\n\t\t\t/* "Middle" children should have no rounded corners. */\n\t\t\t&:not(:first-child):not(:last-child) {\n\t\t\t\tborder-radius: 0;\n\t\t\t}\n\t\t}\n\t}\n\n\t& > .ck.ck-toolbar__grouped-dropdown {\n\t\t/*\n\t\t * Dropdown button has asymmetric padding to fit the arrow.\n\t\t * This button has no arrow so let\'s revert that padding back to normal.\n\t\t */\n\t\t& > .ck.ck-button.ck-dropdown__button {\n\t\t\tpadding-left: var(--ck-spacing-tiny);\n\t\t}\n\t}\n\n\t/* A drop-down containing the nested toolbar with configured items. */\n\t& .ck-toolbar__nested-toolbar-dropdown {\n\t\t/* Prevent empty space in the panel when the dropdown label is visible and long but the toolbar has few items. */\n\t\t& > .ck-dropdown__panel {\n\t\t\tmin-width: auto;\n\t\t}\n\n\t\t& > .ck-button > .ck-button__label {\n\t\t\tmax-width: 7em;\n\t\t\twidth: auto;\n\t\t}\n\t}\n\n\t@nest .ck-toolbar-container & {\n\t\tborder: 0;\n\t}\n}\n\n/* stylelint-disable */\n\n/*\n * Styles for RTL toolbars.\n *\n * Note: In some cases (e.g. a decoupled editor), the toolbar has its own "dir"\n * because its parent is not controlled by the editor framework.\n */\n[dir="rtl"] .ck.ck-toolbar,\n.ck.ck-toolbar[dir="rtl"] {\n\t& > .ck-toolbar__items > .ck {\n\t\tmargin-right: 0;\n\t}\n\n\t&:not(.ck-toolbar_compact) > .ck-toolbar__items > .ck {\n\t\t/* (#11) Separate toolbar items. */\n\t\tmargin-left: var(--ck-spacing-small);\n\t}\n\n\t& > .ck-toolbar__items > .ck:last-child {\n\t\tmargin-left: 0;\n\t}\n\n\t&.ck-toolbar_compact > .ck-toolbar__items > .ck {\n\t\t/* No rounded corners on the right side of the first child. */\n\t\t&:first-child {\n\t\t\tborder-top-left-radius: 0;\n\t\t\tborder-bottom-left-radius: 0;\n\t\t}\n\n\t\t/* No rounded corners on the left side of the last child. */\n\t\t&:last-child {\n\t\t\tborder-top-right-radius: 0;\n\t\t\tborder-bottom-right-radius: 0;\n\t\t}\n\t}\n\n\t/* Separate the the separator form the grouping dropdown when some items are grouped. */\n\t& > .ck.ck-toolbar__separator {\n\t\tmargin-left: var(--ck-spacing-small);\n\t}\n\n\t/* Some spacing between the items and the separator before the grouped items dropdown. */\n\t&.ck-toolbar_grouping > .ck-toolbar__items:not(:empty):not(:only-child) {\n\t\tmargin-left: var(--ck-spacing-small);\n\t}\n}\n\n/*\n * Styles for LTR toolbars.\n *\n * Note: In some cases (e.g. a decoupled editor), the toolbar has its own "dir"\n * because its parent is not controlled by the editor framework.\n */\n[dir="ltr"] .ck.ck-toolbar,\n.ck.ck-toolbar[dir="ltr"] {\n\t& > .ck-toolbar__items > .ck:last-child {\n\t\tmargin-right: 0;\n\t}\n\n\t&.ck-toolbar_compact > .ck-toolbar__items > .ck {\n\t\t/* No rounded corners on the right side of the first child. */\n\t\t&:first-child {\n\t\t\tborder-top-right-radius: 0;\n\t\t\tborder-bottom-right-radius: 0;\n\t\t}\n\n\t\t/* No rounded corners on the left side of the last child. */\n\t\t&:last-child {\n\t\t\tborder-top-left-radius: 0;\n\t\t\tborder-bottom-left-radius: 0;\n\t\t}\n\t}\n\n\t/* Separate the the separator form the grouping dropdown when some items are grouped. */\n\t& > .ck.ck-toolbar__separator {\n\t\tmargin-right: var(--ck-spacing-small);\n\t}\n\n\t/* Some spacing between the items and the separator before the grouped items dropdown. */\n\t&.ck-toolbar_grouping > .ck-toolbar__items:not(:empty):not(:only-child) {\n\t\tmargin-right: var(--ck-spacing-small);\n\t}\n}\n\n/* stylelint-enable */\n',
                  "/*\n * Copyright (c) 2003-2022, CKSource Holding sp. z o.o. All rights reserved.\n * For licensing, see LICENSE.md or https://ckeditor.com/legal/ckeditor-oss-license\n */\n\n/**\n * Implements rounded corner interface for .ck-rounded-corners class.\n *\n * @see $ck-border-radius\n */\n@define-mixin ck-rounded-corners {\n\tborder-radius: 0;\n\n\t@nest .ck-rounded-corners &,\n\t&.ck-rounded-corners {\n\t\tborder-radius: var(--ck-border-radius);\n\t\t@mixin-content;\n\t}\n}\n",
                ],
                sourceRoot: "",
              },
            ]);
            const a = s;
          },
          9948: (t, e, n) => {
            "use strict";
            n.d(e, { Z: () => a });
            var o = n(7537),
              i = n.n(o),
              r = n(3645),
              s = n.n(r)()(i());
            s.push([
              t.id,
              ".ck.ck-balloon-panel.ck-tooltip{--ck-balloon-border-width:0px;--ck-balloon-arrow-offset:0px;--ck-balloon-arrow-half-width:4px;--ck-balloon-arrow-height:4px;--ck-color-panel-background:var(--ck-color-tooltip-background);padding:0 var(--ck-spacing-medium);pointer-events:none;z-index:calc(var(--ck-z-modal) + 100)}.ck.ck-balloon-panel.ck-tooltip .ck-tooltip__text{color:var(--ck-color-tooltip-text);font-size:.9em;line-height:1.5}.ck.ck-balloon-panel.ck-tooltip{box-shadow:none}.ck.ck-balloon-panel.ck-tooltip:before{display:none}",
              "",
              {
                version: 3,
                sources: [
                  "webpack://./node_modules/@ckeditor/ckeditor5-ui/theme/components/tooltip/tooltip.css",
                  "webpack://./node_modules/@ckeditor/ckeditor5-theme-lark/theme/ckeditor5-ui/components/tooltip/tooltip.css",
                ],
                names: [],
                mappings:
                  "AAKA,gCCGC,6BAA8B,CAC9B,6BAA8B,CAC9B,iCAAkC,CAClC,6BAA8B,CAC9B,8DAA+D,CAE/D,kCAAmC,CDPnC,mBAAoB,CAEpB,qCACD,CCMC,kDAGC,kCAAmC,CAFnC,cAAe,CACf,eAED,CAbD,gCAgBC,eAMD,CAHC,uCACC,YACD",
                sourcesContent: [
                  "/*\n * Copyright (c) 2003-2022, CKSource Holding sp. z o.o. All rights reserved.\n * For licensing, see LICENSE.md or https://ckeditor.com/legal/ckeditor-oss-license\n */\n\n.ck.ck-balloon-panel.ck-tooltip {\n\t/* Keep tooltips transparent for any interactions. */\n\tpointer-events: none;\n\n\tz-index: calc( var(--ck-z-modal) + 100 );\n}\n",
                  '/*\n * Copyright (c) 2003-2022, CKSource Holding sp. z o.o. All rights reserved.\n * For licensing, see LICENSE.md or https://ckeditor.com/legal/ckeditor-oss-license\n */\n\n@import "../../../mixins/_rounded.css";\n\n.ck.ck-balloon-panel.ck-tooltip {\n\t--ck-balloon-border-width: 0px;\n\t--ck-balloon-arrow-offset: 0px;\n\t--ck-balloon-arrow-half-width: 4px;\n\t--ck-balloon-arrow-height: 4px;\n\t--ck-color-panel-background: var(--ck-color-tooltip-background);\n\n\tpadding: 0 var(--ck-spacing-medium);\n\n\t& .ck-tooltip__text {\n\t\tfont-size: .9em;\n\t\tline-height: 1.5;\n\t\tcolor: var(--ck-color-tooltip-text);\n\t}\n\n\t/* Reset balloon panel styles */\n\tbox-shadow: none;\n\n\t/* Hide the default shadow of the .ck-balloon-panel tip */\n\t&::before {\n\t\tdisplay: none;\n\t}\n}\n',
                ],
                sourceRoot: "",
              },
            ]);
            const a = s;
          },
          6150: (t, e, n) => {
            "use strict";
            n.d(e, { Z: () => a });
            var o = n(7537),
              i = n.n(o),
              r = n(3645),
              s = n.n(r)()(i());
            s.push([
              t.id,
              ".ck-hidden{display:none!important}.ck-reset_all :not(.ck-reset_all-excluded *),.ck.ck-reset,.ck.ck-reset_all{box-sizing:border-box;height:auto;position:static;width:auto}:root{--ck-z-default:1;--ck-z-modal:calc(var(--ck-z-default) + 999)}.ck-transitions-disabled,.ck-transitions-disabled *{transition:none!important}:root{--ck-color-base-foreground:#fafafa;--ck-color-base-background:#fff;--ck-color-base-border:#ccced1;--ck-color-base-action:#53a336;--ck-color-base-focus:#6cb5f9;--ck-color-base-text:#333;--ck-color-base-active:#2977ff;--ck-color-base-active-focus:#0d65ff;--ck-color-base-error:#db3700;--ck-color-focus-border-coordinates:218,81.8%,56.9%;--ck-color-focus-border:hsl(var(--ck-color-focus-border-coordinates));--ck-color-focus-outer-shadow:#cae1fc;--ck-color-focus-disabled-shadow:rgba(119,186,248,.3);--ck-color-focus-error-shadow:rgba(255,64,31,.3);--ck-color-text:var(--ck-color-base-text);--ck-color-shadow-drop:rgba(0,0,0,.15);--ck-color-shadow-drop-active:rgba(0,0,0,.2);--ck-color-shadow-inner:rgba(0,0,0,.1);--ck-color-button-default-background:transparent;--ck-color-button-default-hover-background:#f0f0f0;--ck-color-button-default-active-background:#f0f0f0;--ck-color-button-default-disabled-background:transparent;--ck-color-button-on-background:#f0f7ff;--ck-color-button-on-hover-background:#dbecff;--ck-color-button-on-active-background:#dbecff;--ck-color-button-on-disabled-background:#f0f2f4;--ck-color-button-on-color:#2977ff;--ck-color-button-action-background:var(--ck-color-base-action);--ck-color-button-action-hover-background:#4d9d30;--ck-color-button-action-active-background:#4d9d30;--ck-color-button-action-disabled-background:#7ec365;--ck-color-button-action-text:var(--ck-color-base-background);--ck-color-button-save:#008a00;--ck-color-button-cancel:#db3700;--ck-color-switch-button-off-background:#939393;--ck-color-switch-button-off-hover-background:#7d7d7d;--ck-color-switch-button-on-background:var(--ck-color-button-action-background);--ck-color-switch-button-on-hover-background:#4d9d30;--ck-color-switch-button-inner-background:var(--ck-color-base-background);--ck-color-switch-button-inner-shadow:rgba(0,0,0,.1);--ck-color-dropdown-panel-background:var(--ck-color-base-background);--ck-color-dropdown-panel-border:var(--ck-color-base-border);--ck-color-input-background:var(--ck-color-base-background);--ck-color-input-border:var(--ck-color-base-border);--ck-color-input-error-border:var(--ck-color-base-error);--ck-color-input-text:var(--ck-color-base-text);--ck-color-input-disabled-background:#f2f2f2;--ck-color-input-disabled-border:var(--ck-color-base-border);--ck-color-input-disabled-text:#757575;--ck-color-list-background:var(--ck-color-base-background);--ck-color-list-button-hover-background:var(--ck-color-button-default-hover-background);--ck-color-list-button-on-background:var(--ck-color-button-on-color);--ck-color-list-button-on-background-focus:var(--ck-color-button-on-color);--ck-color-list-button-on-text:var(--ck-color-base-background);--ck-color-panel-background:var(--ck-color-base-background);--ck-color-panel-border:var(--ck-color-base-border);--ck-color-toolbar-background:var(--ck-color-base-background);--ck-color-toolbar-border:var(--ck-color-base-border);--ck-color-tooltip-background:var(--ck-color-base-text);--ck-color-tooltip-text:var(--ck-color-base-background);--ck-color-engine-placeholder-text:#707070;--ck-color-upload-bar-background:#6cb5f9;--ck-color-link-default:#0000f0;--ck-color-link-selected-background:rgba(31,176,255,.1);--ck-color-link-fake-selection:rgba(31,176,255,.3);--ck-color-highlight-background:#ff0;--ck-disabled-opacity:.5;--ck-focus-outer-shadow-geometry:0 0 0 3px;--ck-focus-outer-shadow:var(--ck-focus-outer-shadow-geometry) var(--ck-color-focus-outer-shadow);--ck-focus-disabled-outer-shadow:var(--ck-focus-outer-shadow-geometry) var(--ck-color-focus-disabled-shadow);--ck-focus-error-outer-shadow:var(--ck-focus-outer-shadow-geometry) var(--ck-color-focus-error-shadow);--ck-focus-ring:1px solid var(--ck-color-focus-border);--ck-font-size-base:13px;--ck-line-height-base:1.84615;--ck-font-face:Helvetica,Arial,Tahoma,Verdana,Sans-Serif;--ck-font-size-tiny:0.7em;--ck-font-size-small:0.75em;--ck-font-size-normal:1em;--ck-font-size-big:1.4em;--ck-font-size-large:1.8em;--ck-ui-component-min-height:2.3em}.ck-reset_all :not(.ck-reset_all-excluded *),.ck.ck-reset,.ck.ck-reset_all{word-wrap:break-word;background:transparent;border:0;margin:0;padding:0;text-decoration:none;transition:none;vertical-align:middle}.ck-reset_all :not(.ck-reset_all-excluded *),.ck.ck-reset_all{border-collapse:collapse;color:var(--ck-color-text);cursor:auto;float:none;font:normal normal normal var(--ck-font-size-base)/var(--ck-line-height-base) var(--ck-font-face);text-align:left;white-space:nowrap}.ck-reset_all .ck-rtl :not(.ck-reset_all-excluded *){text-align:right}.ck-reset_all iframe:not(.ck-reset_all-excluded *){vertical-align:inherit}.ck-reset_all textarea:not(.ck-reset_all-excluded *){white-space:pre-wrap}.ck-reset_all input[type=password]:not(.ck-reset_all-excluded *),.ck-reset_all input[type=text]:not(.ck-reset_all-excluded *),.ck-reset_all textarea:not(.ck-reset_all-excluded *){cursor:text}.ck-reset_all input[type=password][disabled]:not(.ck-reset_all-excluded *),.ck-reset_all input[type=text][disabled]:not(.ck-reset_all-excluded *),.ck-reset_all textarea[disabled]:not(.ck-reset_all-excluded *){cursor:default}.ck-reset_all fieldset:not(.ck-reset_all-excluded *){border:2px groove #dfdee3;padding:10px}.ck-reset_all button:not(.ck-reset_all-excluded *)::-moz-focus-inner{border:0;padding:0}.ck[dir=rtl],.ck[dir=rtl] .ck{text-align:right}:root{--ck-border-radius:2px;--ck-inner-shadow:2px 2px 3px var(--ck-color-shadow-inner) inset;--ck-drop-shadow:0 1px 2px 1px var(--ck-color-shadow-drop);--ck-drop-shadow-active:0 3px 6px 1px var(--ck-color-shadow-drop-active);--ck-spacing-unit:0.6em;--ck-spacing-large:calc(var(--ck-spacing-unit)*1.5);--ck-spacing-standard:var(--ck-spacing-unit);--ck-spacing-medium:calc(var(--ck-spacing-unit)*0.8);--ck-spacing-small:calc(var(--ck-spacing-unit)*0.5);--ck-spacing-tiny:calc(var(--ck-spacing-unit)*0.3);--ck-spacing-extra-tiny:calc(var(--ck-spacing-unit)*0.16)}",
              "",
              {
                version: 3,
                sources: [
                  "webpack://./node_modules/@ckeditor/ckeditor5-ui/theme/globals/_hidden.css",
                  "webpack://./node_modules/@ckeditor/ckeditor5-ui/theme/globals/_reset.css",
                  "webpack://./node_modules/@ckeditor/ckeditor5-ui/theme/globals/_zindex.css",
                  "webpack://./node_modules/@ckeditor/ckeditor5-ui/theme/globals/_transition.css",
                  "webpack://./node_modules/@ckeditor/ckeditor5-theme-lark/theme/ckeditor5-ui/globals/_colors.css",
                  "webpack://./node_modules/@ckeditor/ckeditor5-theme-lark/theme/ckeditor5-ui/globals/_disabled.css",
                  "webpack://./node_modules/@ckeditor/ckeditor5-theme-lark/theme/ckeditor5-ui/globals/_focus.css",
                  "webpack://./node_modules/@ckeditor/ckeditor5-theme-lark/theme/ckeditor5-ui/globals/_fonts.css",
                  "webpack://./node_modules/@ckeditor/ckeditor5-theme-lark/theme/ckeditor5-ui/globals/_reset.css",
                  "webpack://./node_modules/@ckeditor/ckeditor5-theme-lark/theme/ckeditor5-ui/globals/_rounded.css",
                  "webpack://./node_modules/@ckeditor/ckeditor5-theme-lark/theme/ckeditor5-ui/globals/_shadow.css",
                  "webpack://./node_modules/@ckeditor/ckeditor5-theme-lark/theme/ckeditor5-ui/globals/_spacing.css",
                ],
                names: [],
                mappings:
                  "AAQA,WAGC,sBACD,CCPA,2EAGC,qBAAsB,CAEtB,WAAY,CACZ,eAAgB,CAFhB,UAGD,CCPA,MACC,gBAAiB,CACjB,4CACD,CCAA,oDAEC,yBACD,CCNA,MACC,kCAAmD,CACnD,+BAAoD,CACpD,8BAAkD,CAClD,8BAAuD,CACvD,6BAAmD,CACnD,yBAA+C,CAC/C,8BAAsD,CACtD,oCAA4D,CAC5D,6BAAkD,CAIlD,mDAA4D,CAC5D,qEAA+E,CAC/E,qCAA4D,CAC5D,qDAA8D,CAC9D,gDAAyD,CACzD,yCAAqD,CACrD,sCAAsD,CACtD,4CAA0D,CAC1D,sCAAsD,CAItD,gDAAuD,CACvD,kDAAiE,CACjE,mDAAkE,CAClE,yDAA8D,CAE9D,uCAA6D,CAC7D,6CAAoE,CACpE,8CAAoE,CACpE,gDAAiE,CACjE,kCAAyD,CAGzD,+DAAsE,CACtE,iDAAsE,CACtE,kDAAsE,CACtE,oDAAoE,CACpE,6DAAsE,CAEtE,8BAAoD,CACpD,gCAAqD,CAErD,+CAA8D,CAC9D,qDAAiE,CACjE,+EAAqF,CACrF,oDAAuE,CACvE,yEAA8E,CAC9E,oDAAgE,CAIhE,oEAA2E,CAC3E,4DAAoE,CAIpE,2DAAoE,CACpE,mDAA6D,CAC7D,wDAAgE,CAChE,+CAA0D,CAC1D,4CAA2D,CAC3D,4DAAoE,CACpE,sCAAsD,CAItD,0DAAmE,CACnE,uFAA6F,CAC7F,oEAA2E,CAC3E,0EAA+E,CAC/E,8DAAsE,CAItE,2DAAoE,CACpE,mDAA6D,CAI7D,6DAAsE,CACtE,qDAA+D,CAI/D,uDAAgE,CAChE,uDAAiE,CAIjE,0CAAyD,CAIzD,wCAA2D,CAI3D,+BAAoD,CACpD,uDAAmE,CACnE,kDAAgE,CAIhE,oCAAwD,CCvGxD,wBAAyB,CCAzB,0CAA2C,CAK3C,gGAAiG,CAKjG,4GAA6G,CAK7G,sGAAuG,CAKvG,sDAAuD,CCvBvD,wBAAyB,CACzB,6BAA8B,CAC9B,wDAA6D,CAE7D,yBAA0B,CAC1B,2BAA4B,CAC5B,yBAA0B,CAC1B,wBAAyB,CACzB,0BAA2B,CCJ3B,kCJuGD,CIjGA,2EAaC,oBAAqB,CANrB,sBAAuB,CADvB,QAAS,CAFT,QAAS,CACT,SAAU,CAGV,oBAAqB,CAErB,eAAgB,CADhB,qBAKD,CAKA,8DAGC,wBAAyB,CAEzB,0BAA2B,CAG3B,WAAY,CACZ,UAAW,CALX,iGAAkG,CAElG,eAAgB,CAChB,kBAGD,CAGC,qDACC,gBACD,CAEA,mDAEC,sBACD,CAEA,qDACC,oBACD,CAEA,mLAGC,WACD,CAEA,iNAGC,cACD,CAEA,qDAEC,yBAAoC,CADpC,YAED,CAEA,qEAGC,QAAQ,CADR,SAED,CAMD,8BAEC,gBACD,CCnFA,MACC,sBAAuB,CCAvB,gEAAiE,CAKjE,0DAA2D,CAK3D,wEAAyE,CCbzE,uBAA8B,CAC9B,mDAA2D,CAC3D,4CAAkD,CAClD,oDAA4D,CAC5D,mDAA2D,CAC3D,kDAA2D,CAC3D,yDFFD",
                sourcesContent: [
                  "/*\n * Copyright (c) 2003-2022, CKSource Holding sp. z o.o. All rights reserved.\n * For licensing, see LICENSE.md or https://ckeditor.com/legal/ckeditor-oss-license\n */\n\n/**\n * A class which hides an element in DOM.\n */\n.ck-hidden {\n\t/* Override selector specificity. Otherwise, all elements with some display\n\tstyle defined will override this one, which is not a desired result. */\n\tdisplay: none !important;\n}\n",
                  "/*\n * Copyright (c) 2003-2022, CKSource Holding sp. z o.o. All rights reserved.\n * For licensing, see LICENSE.md or https://ckeditor.com/legal/ckeditor-oss-license\n */\n\n.ck.ck-reset,\n.ck.ck-reset_all,\n.ck-reset_all *:not(.ck-reset_all-excluded *) {\n\tbox-sizing: border-box;\n\twidth: auto;\n\theight: auto;\n\tposition: static;\n}\n",
                  "/*\n * Copyright (c) 2003-2022, CKSource Holding sp. z o.o. All rights reserved.\n * For licensing, see LICENSE.md or https://ckeditor.com/legal/ckeditor-oss-license\n */\n\n:root {\n\t--ck-z-default: 1;\n\t--ck-z-modal: calc( var(--ck-z-default) + 999 );\n}\n",
                  "/*\n * Copyright (c) 2003-2022, CKSource Holding sp. z o.o. All rights reserved.\n * For licensing, see LICENSE.md or https://ckeditor.com/legal/ckeditor-oss-license\n */\n\n/**\n * A class that disables all transitions of the element and its children.\n */\n.ck-transitions-disabled,\n.ck-transitions-disabled * {\n\ttransition: none !important;\n}\n",
                  "/*\n * Copyright (c) 2003-2022, CKSource Holding sp. z o.o. All rights reserved.\n * For licensing, see LICENSE.md or https://ckeditor.com/legal/ckeditor-oss-license\n */\n\n:root {\n\t--ck-color-base-foreground: \t\t\t\t\t\t\t\thsl(0, 0%, 98%);\n\t--ck-color-base-background: \t\t\t\t\t\t\t\thsl(0, 0%, 100%);\n\t--ck-color-base-border: \t\t\t\t\t\t\t\t\thsl(220, 6%, 81%);\n\t--ck-color-base-action: \t\t\t\t\t\t\t\t\thsl(104, 50.2%, 42.5%);\n\t--ck-color-base-focus: \t\t\t\t\t\t\t\t\t\thsl(209, 92%, 70%);\n\t--ck-color-base-text: \t\t\t\t\t\t\t\t\t\thsl(0, 0%, 20%);\n\t--ck-color-base-active: \t\t\t\t\t\t\t\t\thsl(218.1, 100%, 58%);\n\t--ck-color-base-active-focus:\t\t\t\t\t\t\t\thsl(218.2, 100%, 52.5%);\n\t--ck-color-base-error:\t\t\t\t\t\t\t\t\t\thsl(15, 100%, 43%);\n\n\t/* -- Generic colors ------------------------------------------------------------------------ */\n\n\t--ck-color-focus-border-coordinates: \t\t\t\t\t\t218, 81.8%, 56.9%;\n\t--ck-color-focus-border: \t\t\t\t\t\t\t\t\thsl(var(--ck-color-focus-border-coordinates));\n\t--ck-color-focus-outer-shadow:\t\t\t\t\t\t\t\thsl(212.4, 89.3%, 89%);\n\t--ck-color-focus-disabled-shadow:\t\t\t\t\t\t\thsla(209, 90%, 72%,.3);\n\t--ck-color-focus-error-shadow:\t\t\t\t\t\t\t\thsla(9,100%,56%,.3);\n\t--ck-color-text: \t\t\t\t\t\t\t\t\t\t\tvar(--ck-color-base-text);\n\t--ck-color-shadow-drop: \t\t\t\t\t\t\t\t\thsla(0, 0%, 0%, 0.15);\n\t--ck-color-shadow-drop-active:\t\t\t\t\t\t\t\thsla(0, 0%, 0%, 0.2);\n\t--ck-color-shadow-inner: \t\t\t\t\t\t\t\t\thsla(0, 0%, 0%, 0.1);\n\n\t/* -- Buttons ------------------------------------------------------------------------------- */\n\n\t--ck-color-button-default-background: \t\t\t\t\t\ttransparent;\n\t--ck-color-button-default-hover-background: \t\t\t\thsl(0, 0%, 94.1%);\n\t--ck-color-button-default-active-background: \t\t\t\thsl(0, 0%, 94.1%);\n\t--ck-color-button-default-disabled-background: \t\t\t\ttransparent;\n\n\t--ck-color-button-on-background: \t\t\t\t\t\t\thsl(212, 100%, 97.1%);\n\t--ck-color-button-on-hover-background: \t\t\t\t\t\thsl(211.7, 100%, 92.9%);\n\t--ck-color-button-on-active-background: \t\t\t\t\thsl(211.7, 100%, 92.9%);\n\t--ck-color-button-on-disabled-background: \t\t\t\t\thsl(211, 15%, 95%);\n\t--ck-color-button-on-color:\t\t\t\t\t\t\t\t\thsl(218.1, 100%, 58%);\n\n\n\t--ck-color-button-action-background: \t\t\t\t\t\tvar(--ck-color-base-action);\n\t--ck-color-button-action-hover-background: \t\t\t\t\thsl(104, 53.2%, 40.2%);\n\t--ck-color-button-action-active-background: \t\t\t\thsl(104, 53.2%, 40.2%);\n\t--ck-color-button-action-disabled-background: \t\t\t\thsl(104, 44%, 58%);\n\t--ck-color-button-action-text: \t\t\t\t\t\t\t\tvar(--ck-color-base-background);\n\n\t--ck-color-button-save: \t\t\t\t\t\t\t\t\thsl(120, 100%, 27%);\n\t--ck-color-button-cancel: \t\t\t\t\t\t\t\t\thsl(15, 100%, 43%);\n\n\t--ck-color-switch-button-off-background:\t\t\t\t\thsl(0, 0%, 57.6%);\n\t--ck-color-switch-button-off-hover-background:\t\t\t\thsl(0, 0%, 49%);\n\t--ck-color-switch-button-on-background:\t\t\t\t\t\tvar(--ck-color-button-action-background);\n\t--ck-color-switch-button-on-hover-background:\t\t\t\thsl(104, 53.2%, 40.2%);\n\t--ck-color-switch-button-inner-background:\t\t\t\t\tvar(--ck-color-base-background);\n\t--ck-color-switch-button-inner-shadow:\t\t\t\t\t\thsla(0, 0%, 0%, 0.1);\n\n\t/* -- Dropdown ------------------------------------------------------------------------------ */\n\n\t--ck-color-dropdown-panel-background: \t\t\t\t\t\tvar(--ck-color-base-background);\n\t--ck-color-dropdown-panel-border: \t\t\t\t\t\t\tvar(--ck-color-base-border);\n\n\t/* -- Input --------------------------------------------------------------------------------- */\n\n\t--ck-color-input-background: \t\t\t\t\t\t\t\tvar(--ck-color-base-background);\n\t--ck-color-input-border: \t\t\t\t\t\t\t\t\tvar(--ck-color-base-border);\n\t--ck-color-input-error-border:\t\t\t\t\t\t\t\tvar(--ck-color-base-error);\n\t--ck-color-input-text: \t\t\t\t\t\t\t\t\t\tvar(--ck-color-base-text);\n\t--ck-color-input-disabled-background: \t\t\t\t\t\thsl(0, 0%, 95%);\n\t--ck-color-input-disabled-border: \t\t\t\t\t\t\tvar(--ck-color-base-border);\n\t--ck-color-input-disabled-text: \t\t\t\t\t\t\thsl(0, 0%, 46%);\n\n\t/* -- List ---------------------------------------------------------------------------------- */\n\n\t--ck-color-list-background: \t\t\t\t\t\t\t\tvar(--ck-color-base-background);\n\t--ck-color-list-button-hover-background: \t\t\t\t\tvar(--ck-color-button-default-hover-background);\n\t--ck-color-list-button-on-background: \t\t\t\t\t\tvar(--ck-color-button-on-color);\n\t--ck-color-list-button-on-background-focus: \t\t\t\tvar(--ck-color-button-on-color);\n\t--ck-color-list-button-on-text:\t\t\t\t\t\t\t\tvar(--ck-color-base-background);\n\n\t/* -- Panel --------------------------------------------------------------------------------- */\n\n\t--ck-color-panel-background: \t\t\t\t\t\t\t\tvar(--ck-color-base-background);\n\t--ck-color-panel-border: \t\t\t\t\t\t\t\t\tvar(--ck-color-base-border);\n\n\t/* -- Toolbar ------------------------------------------------------------------------------- */\n\n\t--ck-color-toolbar-background: \t\t\t\t\t\t\t\tvar(--ck-color-base-background);\n\t--ck-color-toolbar-border: \t\t\t\t\t\t\t\t\tvar(--ck-color-base-border);\n\n\t/* -- Tooltip ------------------------------------------------------------------------------- */\n\n\t--ck-color-tooltip-background: \t\t\t\t\t\t\t\tvar(--ck-color-base-text);\n\t--ck-color-tooltip-text: \t\t\t\t\t\t\t\t\tvar(--ck-color-base-background);\n\n\t/* -- Engine -------------------------------------------------------------------------------- */\n\n\t--ck-color-engine-placeholder-text: \t\t\t\t\t\thsl(0, 0%, 44%);\n\n\t/* -- Upload -------------------------------------------------------------------------------- */\n\n\t--ck-color-upload-bar-background:\t\t \t\t\t\t\thsl(209, 92%, 70%);\n\n\t/* -- Link -------------------------------------------------------------------------------- */\n\n\t--ck-color-link-default:\t\t\t\t\t\t\t\t\thsl(240, 100%, 47%);\n\t--ck-color-link-selected-background:\t\t\t\t\t\thsla(201, 100%, 56%, 0.1);\n\t--ck-color-link-fake-selection:\t\t\t\t\t\t\t\thsla(201, 100%, 56%, 0.3);\n\n\t/* -- Search result highlight ---------------------------------------------------------------- */\n\n\t--ck-color-highlight-background:\t\t\t\t\t\t\thsl(60, 100%, 50%)\n}\n",
                  "/*\n * Copyright (c) 2003-2022, CKSource Holding sp. z o.o. All rights reserved.\n * For licensing, see LICENSE.md or https://ckeditor.com/legal/ckeditor-oss-license\n */\n\n:root {\n\t/**\n\t * An opacity value of disabled UI item.\n\t */\n\t--ck-disabled-opacity: .5;\n}\n",
                  "/*\n * Copyright (c) 2003-2022, CKSource Holding sp. z o.o. All rights reserved.\n * For licensing, see LICENSE.md or https://ckeditor.com/legal/ckeditor-oss-license\n */\n\n:root {\n\t/**\n\t * The geometry of the of focused element's outer shadow.\n\t */\n\t--ck-focus-outer-shadow-geometry: 0 0 0 3px;\n\n\t/**\n\t * A visual style of focused element's outer shadow.\n\t */\n\t--ck-focus-outer-shadow: var(--ck-focus-outer-shadow-geometry) var(--ck-color-focus-outer-shadow);\n\n\t/**\n\t * A visual style of focused element's outer shadow (when disabled).\n\t */\n\t--ck-focus-disabled-outer-shadow: var(--ck-focus-outer-shadow-geometry) var(--ck-color-focus-disabled-shadow);\n\n\t/**\n\t * A visual style of focused element's outer shadow (when has errors).\n\t */\n\t--ck-focus-error-outer-shadow: var(--ck-focus-outer-shadow-geometry) var(--ck-color-focus-error-shadow);\n\n\t/**\n\t * A visual style of focused element's border or outline.\n\t */\n\t--ck-focus-ring: 1px solid var(--ck-color-focus-border);\n}\n",
                  "/*\n * Copyright (c) 2003-2022, CKSource Holding sp. z o.o. All rights reserved.\n * For licensing, see LICENSE.md or https://ckeditor.com/legal/ckeditor-oss-license\n */\n\n:root {\n\t--ck-font-size-base: 13px;\n\t--ck-line-height-base: 1.84615;\n\t--ck-font-face: Helvetica, Arial, Tahoma, Verdana, Sans-Serif;\n\n\t--ck-font-size-tiny: 0.7em;\n\t--ck-font-size-small: 0.75em;\n\t--ck-font-size-normal: 1em;\n\t--ck-font-size-big: 1.4em;\n\t--ck-font-size-large: 1.8em;\n}\n",
                  '/*\n * Copyright (c) 2003-2022, CKSource Holding sp. z o.o. All rights reserved.\n * For licensing, see LICENSE.md or https://ckeditor.com/legal/ckeditor-oss-license\n */\n\n:root {\n\t/* This is super-important. This is **manually** adjusted so a button without an icon\n\tis never smaller than a button with icon, additionally making sure that text-less buttons\n\tare perfect squares. The value is also shared by other components which should stay "in-line"\n\twith buttons. */\n\t--ck-ui-component-min-height: 2.3em;\n}\n\n/**\n * Resets an element, ignoring its children.\n */\n.ck.ck-reset,\n.ck.ck-reset_all,\n.ck-reset_all *:not(.ck-reset_all-excluded *) {\n\t/* Do not include inheritable rules here. */\n\tmargin: 0;\n\tpadding: 0;\n\tborder: 0;\n\tbackground: transparent;\n\ttext-decoration: none;\n\tvertical-align: middle;\n\ttransition: none;\n\n\t/* https://github.com/ckeditor/ckeditor5-theme-lark/issues/105 */\n\tword-wrap: break-word;\n}\n\n/**\n * Resets an element AND its children.\n */\n.ck.ck-reset_all,\n.ck-reset_all *:not(.ck-reset_all-excluded *) {\n\t/* These are rule inherited by all children elements. */\n\tborder-collapse: collapse;\n\tfont: normal normal normal var(--ck-font-size-base)/var(--ck-line-height-base) var(--ck-font-face);\n\tcolor: var(--ck-color-text);\n\ttext-align: left;\n\twhite-space: nowrap;\n\tcursor: auto;\n\tfloat: none;\n}\n\n.ck-reset_all {\n\t& .ck-rtl *:not(.ck-reset_all-excluded *) {\n\t\ttext-align: right;\n\t}\n\n\t& iframe:not(.ck-reset_all-excluded *) {\n\t\t/* For IE */\n\t\tvertical-align: inherit;\n\t}\n\n\t& textarea:not(.ck-reset_all-excluded *) {\n\t\twhite-space: pre-wrap;\n\t}\n\n\t& textarea:not(.ck-reset_all-excluded *),\n\t& input[type="text"]:not(.ck-reset_all-excluded *),\n\t& input[type="password"]:not(.ck-reset_all-excluded *) {\n\t\tcursor: text;\n\t}\n\n\t& textarea[disabled]:not(.ck-reset_all-excluded *),\n\t& input[type="text"][disabled]:not(.ck-reset_all-excluded *),\n\t& input[type="password"][disabled]:not(.ck-reset_all-excluded *) {\n\t\tcursor: default;\n\t}\n\n\t& fieldset:not(.ck-reset_all-excluded *) {\n\t\tpadding: 10px;\n\t\tborder: 2px groove hsl(255, 7%, 88%);\n\t}\n\n\t& button:not(.ck-reset_all-excluded *)::-moz-focus-inner {\n\t\t/* See http://stackoverflow.com/questions/5517744/remove-extra-button-spacing-padding-in-firefox */\n\t\tpadding: 0;\n\t\tborder: 0\n\t}\n}\n\n/**\n * Default UI rules for RTL languages.\n */\n.ck[dir="rtl"],\n.ck[dir="rtl"] .ck {\n\ttext-align: right;\n}\n',
                  "/*\n * Copyright (c) 2003-2022, CKSource Holding sp. z o.o. All rights reserved.\n * For licensing, see LICENSE.md or https://ckeditor.com/legal/ckeditor-oss-license\n */\n\n/**\n * Default border-radius value.\n */\n:root{\n\t--ck-border-radius: 2px;\n}\n",
                  "/*\n * Copyright (c) 2003-2022, CKSource Holding sp. z o.o. All rights reserved.\n * For licensing, see LICENSE.md or https://ckeditor.com/legal/ckeditor-oss-license\n */\n\n:root {\n\t/**\n\t * A visual style of element's inner shadow (i.e. input).\n\t */\n\t--ck-inner-shadow: 2px 2px 3px var(--ck-color-shadow-inner) inset;\n\n\t/**\n\t * A visual style of element's drop shadow (i.e. panel).\n\t */\n\t--ck-drop-shadow: 0 1px 2px 1px var(--ck-color-shadow-drop);\n\n\t/**\n\t * A visual style of element's active shadow (i.e. comment or suggestion).\n\t */\n\t--ck-drop-shadow-active: 0 3px 6px 1px var(--ck-color-shadow-drop-active);\n}\n",
                  "/*\n * Copyright (c) 2003-2022, CKSource Holding sp. z o.o. All rights reserved.\n * For licensing, see LICENSE.md or https://ckeditor.com/legal/ckeditor-oss-license\n */\n\n:root {\n\t--ck-spacing-unit: \t\t\t\t\t\t0.6em;\n\t--ck-spacing-large: \t\t\t\t\tcalc(var(--ck-spacing-unit) * 1.5);\n\t--ck-spacing-standard: \t\t\t\t\tvar(--ck-spacing-unit);\n\t--ck-spacing-medium: \t\t\t\t\tcalc(var(--ck-spacing-unit) * 0.8);\n\t--ck-spacing-small: \t\t\t\t\tcalc(var(--ck-spacing-unit) * 0.5);\n\t--ck-spacing-tiny: \t\t\t\t\t\tcalc(var(--ck-spacing-unit) * 0.3);\n\t--ck-spacing-extra-tiny: \t\t\t\tcalc(var(--ck-spacing-unit) * 0.16);\n}\n",
                ],
                sourceRoot: "",
              },
            ]);
            const a = s;
          },
          6507: (t, e, n) => {
            "use strict";
            n.d(e, { Z: () => a });
            var o = n(7537),
              i = n.n(o),
              r = n(3645),
              s = n.n(r)()(i());
            s.push([
              t.id,
              ":root{--ck-color-resizer:var(--ck-color-focus-border);--ck-color-resizer-tooltip-background:#262626;--ck-color-resizer-tooltip-text:#f2f2f2;--ck-resizer-border-radius:var(--ck-border-radius);--ck-resizer-tooltip-offset:10px;--ck-resizer-tooltip-height:calc(var(--ck-spacing-small)*2 + 10px)}.ck .ck-widget,.ck .ck-widget.ck-widget_with-selection-handle{position:relative}.ck .ck-widget.ck-widget_with-selection-handle .ck-widget__selection-handle{position:absolute}.ck .ck-widget.ck-widget_with-selection-handle .ck-widget__selection-handle .ck-icon{display:block}.ck .ck-widget.ck-widget_with-selection-handle.ck-widget_selected>.ck-widget__selection-handle,.ck .ck-widget.ck-widget_with-selection-handle:hover>.ck-widget__selection-handle{visibility:visible}.ck .ck-size-view{background:var(--ck-color-resizer-tooltip-background);border:1px solid var(--ck-color-resizer-tooltip-text);border-radius:var(--ck-resizer-border-radius);color:var(--ck-color-resizer-tooltip-text);display:block;font-size:var(--ck-font-size-tiny);height:var(--ck-resizer-tooltip-height);line-height:var(--ck-resizer-tooltip-height);padding:0 var(--ck-spacing-small)}.ck .ck-size-view.ck-orientation-above-center,.ck .ck-size-view.ck-orientation-bottom-left,.ck .ck-size-view.ck-orientation-bottom-right,.ck .ck-size-view.ck-orientation-top-left,.ck .ck-size-view.ck-orientation-top-right{position:absolute}.ck .ck-size-view.ck-orientation-top-left{left:var(--ck-resizer-tooltip-offset);top:var(--ck-resizer-tooltip-offset)}.ck .ck-size-view.ck-orientation-top-right{right:var(--ck-resizer-tooltip-offset);top:var(--ck-resizer-tooltip-offset)}.ck .ck-size-view.ck-orientation-bottom-right{bottom:var(--ck-resizer-tooltip-offset);right:var(--ck-resizer-tooltip-offset)}.ck .ck-size-view.ck-orientation-bottom-left{bottom:var(--ck-resizer-tooltip-offset);left:var(--ck-resizer-tooltip-offset)}.ck .ck-size-view.ck-orientation-above-center{left:50%;top:calc(var(--ck-resizer-tooltip-height)*-1);transform:translate(-50%)}:root{--ck-widget-outline-thickness:3px;--ck-widget-handler-icon-size:16px;--ck-widget-handler-animation-duration:200ms;--ck-widget-handler-animation-curve:ease;--ck-color-widget-blurred-border:#dedede;--ck-color-widget-hover-border:#ffc83d;--ck-color-widget-editable-focus-background:var(--ck-color-base-background);--ck-color-widget-drag-handler-icon-color:var(--ck-color-base-background)}.ck .ck-widget{outline-color:transparent;outline-style:solid;outline-width:var(--ck-widget-outline-thickness);transition:outline-color var(--ck-widget-handler-animation-duration) var(--ck-widget-handler-animation-curve)}.ck .ck-widget.ck-widget_selected,.ck .ck-widget.ck-widget_selected:hover{outline:var(--ck-widget-outline-thickness) solid var(--ck-color-focus-border)}.ck .ck-widget:hover{outline-color:var(--ck-color-widget-hover-border)}.ck .ck-editor__nested-editable{border:1px solid transparent}.ck .ck-editor__nested-editable.ck-editor__nested-editable_focused,.ck .ck-editor__nested-editable:focus{background-color:var(--ck-color-widget-editable-focus-background);border:var(--ck-focus-ring);box-shadow:var(--ck-inner-shadow),0 0;outline:none}.ck .ck-widget.ck-widget_with-selection-handle .ck-widget__selection-handle{background-color:transparent;border-radius:var(--ck-border-radius) var(--ck-border-radius) 0 0;box-sizing:border-box;left:calc(0px - var(--ck-widget-outline-thickness));opacity:0;padding:4px;top:0;transform:translateY(-100%);transition:background-color var(--ck-widget-handler-animation-duration) var(--ck-widget-handler-animation-curve),visibility var(--ck-widget-handler-animation-duration) var(--ck-widget-handler-animation-curve),opacity var(--ck-widget-handler-animation-duration) var(--ck-widget-handler-animation-curve)}.ck .ck-widget.ck-widget_with-selection-handle .ck-widget__selection-handle .ck-icon{color:var(--ck-color-widget-drag-handler-icon-color);height:var(--ck-widget-handler-icon-size);width:var(--ck-widget-handler-icon-size)}.ck .ck-widget.ck-widget_with-selection-handle .ck-widget__selection-handle .ck-icon .ck-icon__selected-indicator{opacity:0;transition:opacity .3s var(--ck-widget-handler-animation-curve)}.ck .ck-widget.ck-widget_with-selection-handle .ck-widget__selection-handle:hover .ck-icon .ck-icon__selected-indicator{opacity:1}.ck .ck-widget.ck-widget_with-selection-handle:hover>.ck-widget__selection-handle{background-color:var(--ck-color-widget-hover-border);opacity:1}.ck .ck-widget.ck-widget_with-selection-handle.ck-widget_selected:hover>.ck-widget__selection-handle,.ck .ck-widget.ck-widget_with-selection-handle.ck-widget_selected>.ck-widget__selection-handle{background-color:var(--ck-color-focus-border);opacity:1}.ck .ck-widget.ck-widget_with-selection-handle.ck-widget_selected:hover>.ck-widget__selection-handle .ck-icon .ck-icon__selected-indicator,.ck .ck-widget.ck-widget_with-selection-handle.ck-widget_selected>.ck-widget__selection-handle .ck-icon .ck-icon__selected-indicator{opacity:1}.ck[dir=rtl] .ck-widget.ck-widget_with-selection-handle .ck-widget__selection-handle{left:auto;right:calc(0px - var(--ck-widget-outline-thickness))}.ck.ck-editor__editable.ck-read-only .ck-widget{transition:none}.ck.ck-editor__editable.ck-read-only .ck-widget:not(.ck-widget_selected){--ck-widget-outline-thickness:0px}.ck.ck-editor__editable.ck-read-only .ck-widget.ck-widget_with-selection-handle .ck-widget__selection-handle,.ck.ck-editor__editable.ck-read-only .ck-widget.ck-widget_with-selection-handle .ck-widget__selection-handle:hover{background:var(--ck-color-widget-blurred-border)}.ck.ck-editor__editable.ck-blurred .ck-widget.ck-widget_selected,.ck.ck-editor__editable.ck-blurred .ck-widget.ck-widget_selected:hover{outline-color:var(--ck-color-widget-blurred-border)}.ck.ck-editor__editable.ck-blurred .ck-widget.ck-widget_selected.ck-widget_with-selection-handle:hover>.ck-widget__selection-handle,.ck.ck-editor__editable.ck-blurred .ck-widget.ck-widget_selected.ck-widget_with-selection-handle:hover>.ck-widget__selection-handle:hover,.ck.ck-editor__editable.ck-blurred .ck-widget.ck-widget_selected.ck-widget_with-selection-handle>.ck-widget__selection-handle,.ck.ck-editor__editable.ck-blurred .ck-widget.ck-widget_selected.ck-widget_with-selection-handle>.ck-widget__selection-handle:hover{background:var(--ck-color-widget-blurred-border)}.ck.ck-editor__editable blockquote>.ck-widget.ck-widget_with-selection-handle:first-child,.ck.ck-editor__editable>.ck-widget.ck-widget_with-selection-handle:first-child{margin-top:calc(1em + var(--ck-widget-handler-icon-size))}",
              "",
              {
                version: 3,
                sources: [
                  "webpack://./node_modules/@ckeditor/ckeditor5-widget/theme/widget.css",
                  "webpack://./node_modules/@ckeditor/ckeditor5-theme-lark/theme/ckeditor5-widget/widget.css",
                  "webpack://./node_modules/@ckeditor/ckeditor5-theme-lark/theme/mixins/_focus.css",
                  "webpack://./node_modules/@ckeditor/ckeditor5-theme-lark/theme/mixins/_shadow.css",
                ],
                names: [],
                mappings:
                  "AAKA,MACC,+CAAgD,CAChD,6CAAsD,CACtD,uCAAgD,CAEhD,kDAAmD,CACnD,gCAAiC,CACjC,kEACD,CAOA,8DAEC,iBAqBD,CAnBC,4EACC,iBAOD,CALC,qFAGC,aACD,CASD,iLACC,kBACD,CAGD,kBACC,qDAAsD,CAEtD,qDAAsD,CACtD,6CAA8C,CAF9C,0CAA2C,CAI3C,aAAc,CADd,kCAAmC,CAGnC,uCAAwC,CACxC,4CAA6C,CAF7C,iCAsCD,CAlCC,8NAKC,iBACD,CAEA,0CAEC,qCAAsC,CADtC,oCAED,CAEA,2CAEC,sCAAuC,CADvC,oCAED,CAEA,8CACC,uCAAwC,CACxC,sCACD,CAEA,6CACC,uCAAwC,CACxC,qCACD,CAGA,8CAEC,QAAS,CADT,6CAAgD,CAEhD,yBACD,CCjFD,MACC,iCAAkC,CAClC,kCAAmC,CACnC,4CAA6C,CAC7C,wCAAyC,CAEzC,wCAAiD,CACjD,sCAAkD,CAClD,2EAA4E,CAC5E,yEACD,CAEA,eAGC,yBAA0B,CAD1B,mBAAoB,CADpB,gDAAiD,CAGjD,6GAUD,CARC,0EAEC,6EACD,CAEA,qBACC,iDACD,CAGD,gCACC,4BAWD,CAPC,yGAKC,iEAAkE,CCnCnE,2BAA2B,CCF3B,qCAA8B,CDC9B,YDqCA,CAIA,4EAKC,4BAA6B,CAa7B,iEAAkE,CAhBlE,qBAAsB,CAoBtB,mDAAoD,CAhBpD,SAAU,CALV,WAAY,CAsBZ,KAAM,CAFN,2BAA4B,CAT5B,6SAgCD,CAnBC,qFAIC,oDAAqD,CADrD,yCAA0C,CAD1C,wCAWD,CANC,kHACC,SAAU,CAGV,+DACD,CAID,wHACC,SACD,CAID,kFAEC,oDAAqD,CADrD,SAED,CAKC,oMAEC,6CAA8C,CAD9C,SAOD,CAHC,gRACC,SACD,CAOH,qFACC,SAAU,CACV,oDACD,CAGA,gDAEC,eAkBD,CAhBC,yEAOC,iCACD,CAGC,gOAEC,gDACD,CAOD,wIAEC,mDAQD,CALE,ghBAEC,gDACD,CAKH,yKAOC,yDACD",
                sourcesContent: [
                  "/*\n * Copyright (c) 2003-2022, CKSource Holding sp. z o.o. All rights reserved.\n * For licensing, see LICENSE.md or https://ckeditor.com/legal/ckeditor-oss-license\n */\n\n:root {\n\t--ck-color-resizer: var(--ck-color-focus-border);\n\t--ck-color-resizer-tooltip-background: hsl(0, 0%, 15%);\n\t--ck-color-resizer-tooltip-text: hsl(0, 0%, 95%);\n\n\t--ck-resizer-border-radius: var(--ck-border-radius);\n\t--ck-resizer-tooltip-offset: 10px;\n\t--ck-resizer-tooltip-height: calc(var(--ck-spacing-small) * 2 + 10px);\n}\n\n.ck .ck-widget {\n\t/* This is neccessary for type around UI to be positioned properly. */\n\tposition: relative;\n}\n\n.ck .ck-widget.ck-widget_with-selection-handle {\n\t/* Make the widget wrapper a relative positioning container for the drag handle. */\n\tposition: relative;\n\n\t& .ck-widget__selection-handle {\n\t\tposition: absolute;\n\n\t\t& .ck-icon {\n\t\t\t/* Make sure the icon in not a subject to font-size or line-height to avoid\n\t\t\tunnecessary spacing around it. */\n\t\t\tdisplay: block;\n\t\t}\n\t}\n\n\t/* Show the selection handle on mouse hover over the widget, but not for nested widgets. */\n\t&:hover > .ck-widget__selection-handle {\n\t\tvisibility: visible;\n\t}\n\n\t/* Show the selection handle when the widget is selected, but not for nested widgets. */\n\t&.ck-widget_selected > .ck-widget__selection-handle {\n\t\tvisibility: visible;\n\t}\n}\n\n.ck .ck-size-view {\n\tbackground: var(--ck-color-resizer-tooltip-background);\n\tcolor: var(--ck-color-resizer-tooltip-text);\n\tborder: 1px solid var(--ck-color-resizer-tooltip-text);\n\tborder-radius: var(--ck-resizer-border-radius);\n\tfont-size: var(--ck-font-size-tiny);\n\tdisplay: block;\n\tpadding: 0 var(--ck-spacing-small);\n\theight: var(--ck-resizer-tooltip-height);\n\tline-height: var(--ck-resizer-tooltip-height);\n\n\t&.ck-orientation-top-left,\n\t&.ck-orientation-top-right,\n\t&.ck-orientation-bottom-right,\n\t&.ck-orientation-bottom-left,\n\t&.ck-orientation-above-center {\n\t\tposition: absolute;\n\t}\n\n\t&.ck-orientation-top-left {\n\t\ttop: var(--ck-resizer-tooltip-offset);\n\t\tleft: var(--ck-resizer-tooltip-offset);\n\t}\n\n\t&.ck-orientation-top-right {\n\t\ttop: var(--ck-resizer-tooltip-offset);\n\t\tright: var(--ck-resizer-tooltip-offset);\n\t}\n\n\t&.ck-orientation-bottom-right {\n\t\tbottom: var(--ck-resizer-tooltip-offset);\n\t\tright: var(--ck-resizer-tooltip-offset);\n\t}\n\n\t&.ck-orientation-bottom-left {\n\t\tbottom: var(--ck-resizer-tooltip-offset);\n\t\tleft: var(--ck-resizer-tooltip-offset);\n\t}\n\n\t/* Class applied if the widget is too small to contain the size label */\n\t&.ck-orientation-above-center {\n\t\ttop: calc(var(--ck-resizer-tooltip-height) * -1);\n\t\tleft: 50%;\n\t\ttransform: translate(-50%);\n\t}\n}\n",
                  '/*\n * Copyright (c) 2003-2022, CKSource Holding sp. z o.o. All rights reserved.\n * For licensing, see LICENSE.md or https://ckeditor.com/legal/ckeditor-oss-license\n */\n\n@import "../mixins/_focus.css";\n@import "../mixins/_shadow.css";\n\n:root {\n\t--ck-widget-outline-thickness: 3px;\n\t--ck-widget-handler-icon-size: 16px;\n\t--ck-widget-handler-animation-duration: 200ms;\n\t--ck-widget-handler-animation-curve: ease;\n\n\t--ck-color-widget-blurred-border: hsl(0, 0%, 87%);\n\t--ck-color-widget-hover-border: hsl(43, 100%, 62%);\n\t--ck-color-widget-editable-focus-background: var(--ck-color-base-background);\n\t--ck-color-widget-drag-handler-icon-color: var(--ck-color-base-background);\n}\n\n.ck .ck-widget {\n\toutline-width: var(--ck-widget-outline-thickness);\n\toutline-style: solid;\n\toutline-color: transparent;\n\ttransition: outline-color var(--ck-widget-handler-animation-duration) var(--ck-widget-handler-animation-curve);\n\n\t&.ck-widget_selected,\n\t&.ck-widget_selected:hover {\n\t\toutline: var(--ck-widget-outline-thickness) solid var(--ck-color-focus-border);\n\t}\n\n\t&:hover {\n\t\toutline-color: var(--ck-color-widget-hover-border);\n\t}\n}\n\n.ck .ck-editor__nested-editable {\n\tborder: 1px solid transparent;\n\n\t/* The :focus style is applied before .ck-editor__nested-editable_focused class is rendered in the view.\n\tThese styles show a different border for a blink of an eye, so `:focus` need to have same styles applied. */\n\t&.ck-editor__nested-editable_focused,\n\t&:focus {\n\t\t@mixin ck-focus-ring;\n\t\t@mixin ck-box-shadow var(--ck-inner-shadow);\n\n\t\tbackground-color: var(--ck-color-widget-editable-focus-background);\n\t}\n}\n\n.ck .ck-widget.ck-widget_with-selection-handle {\n\t& .ck-widget__selection-handle {\n\t\tpadding: 4px;\n\t\tbox-sizing: border-box;\n\n\t\t/* Background and opacity will be animated as the handler shows up or the widget gets selected. */\n\t\tbackground-color: transparent;\n\t\topacity: 0;\n\n\t\t/* Transition:\n\t\t   * background-color for the .ck-widget_selected state change,\n\t\t   * visibility for hiding the handler,\n\t\t   * opacity for the proper look of the icon when the handler disappears. */\n\t\ttransition:\n\t\t\tbackground-color var(--ck-widget-handler-animation-duration) var(--ck-widget-handler-animation-curve),\n\t\t\tvisibility var(--ck-widget-handler-animation-duration) var(--ck-widget-handler-animation-curve),\n\t\t\topacity var(--ck-widget-handler-animation-duration) var(--ck-widget-handler-animation-curve);\n\n\t\t/* Make only top corners round. */\n\t\tborder-radius: var(--ck-border-radius) var(--ck-border-radius) 0 0;\n\n\t\t/* Place the drag handler outside the widget wrapper. */\n\t\ttransform: translateY(-100%);\n\t\tleft: calc(0px - var(--ck-widget-outline-thickness));\n\t\ttop: 0;\n\n\t\t& .ck-icon {\n\t\t\t/* Make sure the dimensions of the icon are independent of the fon-size of the content. */\n\t\t\twidth: var(--ck-widget-handler-icon-size);\n\t\t\theight: var(--ck-widget-handler-icon-size);\n\t\t\tcolor: var(--ck-color-widget-drag-handler-icon-color);\n\n\t\t\t/* The "selected" part of the icon is invisible by default */\n\t\t\t& .ck-icon__selected-indicator {\n\t\t\t\topacity: 0;\n\n\t\t\t\t/* Note: The animation is longer on purpose. Simply feels better. */\n\t\t\t\ttransition: opacity 300ms var(--ck-widget-handler-animation-curve);\n\t\t\t}\n\t\t}\n\n\t\t/* Advertise using the look of the icon that once clicked the handler, the widget will be selected. */\n\t\t&:hover .ck-icon .ck-icon__selected-indicator {\n\t\t\topacity: 1;\n\t\t}\n\t}\n\n\t/* Show the selection handler on mouse hover over the widget, but not for nested widgets. */\n\t&:hover > .ck-widget__selection-handle {\n\t\topacity: 1;\n\t\tbackground-color: var(--ck-color-widget-hover-border);\n\t}\n\n\t/* Show the selection handler when the widget is selected, but not for nested widgets. */\n\t&.ck-widget_selected,\n\t&.ck-widget_selected:hover {\n\t\t& > .ck-widget__selection-handle {\n\t\t\topacity: 1;\n\t\t\tbackground-color: var(--ck-color-focus-border);\n\n\t\t\t/* When the widget is selected, notify the user using the proper look of the icon. */\n\t\t\t& .ck-icon .ck-icon__selected-indicator {\n\t\t\t\topacity: 1;\n\t\t\t}\n\t\t}\n\t}\n}\n\n/* In a RTL environment, align the selection handler to the right side of the widget */\n/* stylelint-disable-next-line no-descending-specificity */\n.ck[dir="rtl"] .ck-widget.ck-widget_with-selection-handle .ck-widget__selection-handle {\n\tleft: auto;\n\tright: calc(0px - var(--ck-widget-outline-thickness));\n}\n\n/* https://github.com/ckeditor/ckeditor5/issues/6415 */\n.ck.ck-editor__editable.ck-read-only .ck-widget {\n\t/* Prevent the :hover outline from showing up because of the used outline-color transition. */\n\ttransition: none;\n\n\t&:not(.ck-widget_selected) {\n\t\t/* Disable visual effects of hover/active widget when CKEditor is in readOnly mode.\n\t\t * See: https://github.com/ckeditor/ckeditor5/issues/1261\n\t\t *\n\t\t * Leave the unit because this custom property is used in calc() by other features.\n\t\t * See: https://github.com/ckeditor/ckeditor5/issues/6775\n\t\t */\n\t\t--ck-widget-outline-thickness: 0px;\n\t}\n\n\t&.ck-widget_with-selection-handle {\n\t\t& .ck-widget__selection-handle,\n\t\t& .ck-widget__selection-handle:hover {\n\t\t\tbackground: var(--ck-color-widget-blurred-border);\n\t\t}\n\t}\n}\n\n/* Style the widget when it\'s selected but the editable it belongs to lost focus. */\n/* stylelint-disable-next-line no-descending-specificity */\n.ck.ck-editor__editable.ck-blurred .ck-widget {\n\t&.ck-widget_selected,\n\t&.ck-widget_selected:hover {\n\t\toutline-color: var(--ck-color-widget-blurred-border);\n\n\t\t&.ck-widget_with-selection-handle {\n\t\t\t& > .ck-widget__selection-handle,\n\t\t\t& > .ck-widget__selection-handle:hover {\n\t\t\t\tbackground: var(--ck-color-widget-blurred-border);\n\t\t\t}\n\t\t}\n\t}\n}\n\n.ck.ck-editor__editable > .ck-widget.ck-widget_with-selection-handle:first-child,\n.ck.ck-editor__editable blockquote > .ck-widget.ck-widget_with-selection-handle:first-child {\n\t/* Do not crop selection handler if a widget is a first-child in the blockquote or in the root editable.\n\tIn fact, anything with overflow: hidden.\n\thttps://github.com/ckeditor/ckeditor5-block-quote/issues/28\n\thttps://github.com/ckeditor/ckeditor5-widget/issues/44\n\thttps://github.com/ckeditor/ckeditor5-widget/issues/66 */\n\tmargin-top: calc(1em + var(--ck-widget-handler-icon-size));\n}\n',
                  "/*\n * Copyright (c) 2003-2022, CKSource Holding sp. z o.o. All rights reserved.\n * For licensing, see LICENSE.md or https://ckeditor.com/legal/ckeditor-oss-license\n */\n\n/**\n * A visual style of focused element's border.\n */\n@define-mixin ck-focus-ring {\n\t/* Disable native outline. */\n\toutline: none;\n\tborder: var(--ck-focus-ring)\n}\n",
                  "/*\n * Copyright (c) 2003-2022, CKSource Holding sp. z o.o. All rights reserved.\n * For licensing, see LICENSE.md or https://ckeditor.com/legal/ckeditor-oss-license\n */\n\n/**\n * A helper to combine multiple shadows.\n */\n@define-mixin ck-box-shadow $shadowA, $shadowB: 0 0 {\n\tbox-shadow: $shadowA, $shadowB;\n}\n\n/**\n * Gives an element a drop shadow so it looks like a floating panel.\n */\n@define-mixin ck-drop-shadow {\n\t@mixin ck-box-shadow var(--ck-drop-shadow);\n}\n",
                ],
                sourceRoot: "",
              },
            ]);
            const a = s;
          },
          2263: (t, e, n) => {
            "use strict";
            n.d(e, { Z: () => a });
            var o = n(7537),
              i = n.n(o),
              r = n(3645),
              s = n.n(r)()(i());
            s.push([
              t.id,
              ".ck .ck-widget_with-resizer{position:relative}.ck .ck-widget__resizer{display:none;left:0;pointer-events:none;position:absolute;top:0}.ck-focused .ck-widget_with-resizer.ck-widget_selected>.ck-widget__resizer{display:block}.ck .ck-widget__resizer__handle{pointer-events:all;position:absolute}.ck .ck-widget__resizer__handle.ck-widget__resizer__handle-bottom-right,.ck .ck-widget__resizer__handle.ck-widget__resizer__handle-top-left{cursor:nwse-resize}.ck .ck-widget__resizer__handle.ck-widget__resizer__handle-bottom-left,.ck .ck-widget__resizer__handle.ck-widget__resizer__handle-top-right{cursor:nesw-resize}:root{--ck-resizer-size:10px;--ck-resizer-offset:calc(var(--ck-resizer-size)/-2 - 2px);--ck-resizer-border-width:1px}.ck .ck-widget__resizer{outline:1px solid var(--ck-color-resizer)}.ck .ck-widget__resizer__handle{background:var(--ck-color-focus-border);border:var(--ck-resizer-border-width) solid #fff;border-radius:var(--ck-resizer-border-radius);height:var(--ck-resizer-size);width:var(--ck-resizer-size)}.ck .ck-widget__resizer__handle.ck-widget__resizer__handle-top-left{left:var(--ck-resizer-offset);top:var(--ck-resizer-offset)}.ck .ck-widget__resizer__handle.ck-widget__resizer__handle-top-right{right:var(--ck-resizer-offset);top:var(--ck-resizer-offset)}.ck .ck-widget__resizer__handle.ck-widget__resizer__handle-bottom-right{bottom:var(--ck-resizer-offset);right:var(--ck-resizer-offset)}.ck .ck-widget__resizer__handle.ck-widget__resizer__handle-bottom-left{bottom:var(--ck-resizer-offset);left:var(--ck-resizer-offset)}",
              "",
              {
                version: 3,
                sources: [
                  "webpack://./node_modules/@ckeditor/ckeditor5-widget/theme/widgetresize.css",
                  "webpack://./node_modules/@ckeditor/ckeditor5-theme-lark/theme/ckeditor5-widget/widgetresize.css",
                ],
                names: [],
                mappings:
                  "AAKA,4BAEC,iBACD,CAEA,wBACC,YAAa,CAMb,MAAO,CAFP,mBAAoB,CAHpB,iBAAkB,CAMlB,KACD,CAGC,2EACC,aACD,CAGD,gCAIC,kBAAmB,CAHnB,iBAcD,CATC,4IAEC,kBACD,CAEA,4IAEC,kBACD,CCpCD,MACC,sBAAuB,CAGvB,yDAAiE,CACjE,6BACD,CAEA,wBACC,yCACD,CAEA,gCAGC,uCAAwC,CACxC,gDAA6D,CAC7D,6CAA8C,CAH9C,6BAA8B,CAD9B,4BAyBD,CAnBC,oEAEC,6BAA8B,CAD9B,4BAED,CAEA,qEAEC,8BAA+B,CAD/B,4BAED,CAEA,wEACC,+BAAgC,CAChC,8BACD,CAEA,uEACC,+BAAgC,CAChC,6BACD",
                sourcesContent: [
                  "/*\n * Copyright (c) 2003-2022, CKSource Holding sp. z o.o. All rights reserved.\n * For licensing, see LICENSE.md or https://ckeditor.com/legal/ckeditor-oss-license\n */\n\n.ck .ck-widget_with-resizer {\n\t/* Make the widget wrapper a relative positioning container for the drag handle. */\n\tposition: relative;\n}\n\n.ck .ck-widget__resizer {\n\tdisplay: none;\n\tposition: absolute;\n\n\t/* The wrapper itself should not interfere with the pointer device, only the handles should. */\n\tpointer-events: none;\n\n\tleft: 0;\n\ttop: 0;\n}\n\n.ck-focused .ck-widget_with-resizer.ck-widget_selected {\n\t& > .ck-widget__resizer {\n\t\tdisplay: block;\n\t}\n}\n\n.ck .ck-widget__resizer__handle {\n\tposition: absolute;\n\n\t/* Resizers are the only UI elements that should interfere with a pointer device. */\n\tpointer-events: all;\n\n\t&.ck-widget__resizer__handle-top-left,\n\t&.ck-widget__resizer__handle-bottom-right {\n\t\tcursor: nwse-resize;\n\t}\n\n\t&.ck-widget__resizer__handle-top-right,\n\t&.ck-widget__resizer__handle-bottom-left {\n\t\tcursor: nesw-resize;\n\t}\n}\n",
                  "/*\n * Copyright (c) 2003-2022, CKSource Holding sp. z o.o. All rights reserved.\n * For licensing, see LICENSE.md or https://ckeditor.com/legal/ckeditor-oss-license\n */\n\n:root {\n\t--ck-resizer-size: 10px;\n\n\t/* Set the resizer with a 50% offset. */\n\t--ck-resizer-offset: calc( ( var(--ck-resizer-size) / -2 ) - 2px);\n\t--ck-resizer-border-width: 1px;\n}\n\n.ck .ck-widget__resizer {\n\toutline: 1px solid var(--ck-color-resizer);\n}\n\n.ck .ck-widget__resizer__handle {\n\twidth: var(--ck-resizer-size);\n\theight: var(--ck-resizer-size);\n\tbackground: var(--ck-color-focus-border);\n\tborder: var(--ck-resizer-border-width) solid hsl(0, 0%, 100%);\n\tborder-radius: var(--ck-resizer-border-radius);\n\n\t&.ck-widget__resizer__handle-top-left {\n\t\ttop: var(--ck-resizer-offset);\n\t\tleft: var(--ck-resizer-offset);\n\t}\n\n\t&.ck-widget__resizer__handle-top-right {\n\t\ttop: var(--ck-resizer-offset);\n\t\tright: var(--ck-resizer-offset);\n\t}\n\n\t&.ck-widget__resizer__handle-bottom-right {\n\t\tbottom: var(--ck-resizer-offset);\n\t\tright: var(--ck-resizer-offset);\n\t}\n\n\t&.ck-widget__resizer__handle-bottom-left {\n\t\tbottom: var(--ck-resizer-offset);\n\t\tleft: var(--ck-resizer-offset);\n\t}\n}\n",
                ],
                sourceRoot: "",
              },
            ]);
            const a = s;
          },
          5137: (t, e, n) => {
            "use strict";
            n.d(e, { Z: () => a });
            var o = n(7537),
              i = n.n(o),
              r = n(3645),
              s = n.n(r)()(i());
            s.push([
              t.id,
              '.ck .ck-widget .ck-widget__type-around__button{display:block;overflow:hidden;position:absolute;z-index:var(--ck-z-default)}.ck .ck-widget .ck-widget__type-around__button svg{left:50%;position:absolute;top:50%;z-index:calc(var(--ck-z-default) + 2)}.ck .ck-widget .ck-widget__type-around__button.ck-widget__type-around__button_before{left:min(10%,30px);top:calc(var(--ck-widget-outline-thickness)*-.5);transform:translateY(-50%)}.ck .ck-widget .ck-widget__type-around__button.ck-widget__type-around__button_after{bottom:calc(var(--ck-widget-outline-thickness)*-.5);right:min(10%,30px);transform:translateY(50%)}.ck .ck-widget.ck-widget_selected>.ck-widget__type-around>.ck-widget__type-around__button:after,.ck .ck-widget>.ck-widget__type-around>.ck-widget__type-around__button:hover:after{content:"";display:block;left:1px;position:absolute;top:1px;z-index:calc(var(--ck-z-default) + 1)}.ck .ck-widget>.ck-widget__type-around>.ck-widget__type-around__fake-caret{display:none;left:0;position:absolute;right:0}.ck .ck-widget:hover>.ck-widget__type-around>.ck-widget__type-around__fake-caret{left:calc(var(--ck-widget-outline-thickness)*-1);right:calc(var(--ck-widget-outline-thickness)*-1)}.ck .ck-widget.ck-widget_type-around_show-fake-caret_before>.ck-widget__type-around>.ck-widget__type-around__fake-caret{display:block;top:calc(var(--ck-widget-outline-thickness)*-1 - 1px)}.ck .ck-widget.ck-widget_type-around_show-fake-caret_after>.ck-widget__type-around>.ck-widget__type-around__fake-caret{bottom:calc(var(--ck-widget-outline-thickness)*-1 - 1px);display:block}.ck.ck-editor__editable.ck-read-only .ck-widget__type-around,.ck.ck-editor__editable.ck-restricted-editing_mode_restricted .ck-widget__type-around,.ck.ck-editor__editable.ck-widget__type-around_disabled .ck-widget__type-around{display:none}:root{--ck-widget-type-around-button-size:20px;--ck-color-widget-type-around-button-active:var(--ck-color-focus-border);--ck-color-widget-type-around-button-hover:var(--ck-color-widget-hover-border);--ck-color-widget-type-around-button-blurred-editable:var(--ck-color-widget-blurred-border);--ck-color-widget-type-around-button-radar-start-alpha:0;--ck-color-widget-type-around-button-radar-end-alpha:.3;--ck-color-widget-type-around-button-icon:var(--ck-color-base-background)}.ck .ck-widget .ck-widget__type-around__button{background:var(--ck-color-widget-type-around-button);border-radius:100px;height:var(--ck-widget-type-around-button-size);opacity:0;pointer-events:none;transition:opacity var(--ck-widget-handler-animation-duration) var(--ck-widget-handler-animation-curve),background var(--ck-widget-handler-animation-duration) var(--ck-widget-handler-animation-curve);width:var(--ck-widget-type-around-button-size)}.ck .ck-widget .ck-widget__type-around__button svg{height:8px;margin-top:1px;transform:translate(-50%,-50%);transition:transform .5s ease;width:10px}.ck .ck-widget .ck-widget__type-around__button svg *{stroke-dasharray:10;stroke-dashoffset:0;fill:none;stroke:var(--ck-color-widget-type-around-button-icon);stroke-width:1.5px;stroke-linecap:round;stroke-linejoin:round}.ck .ck-widget .ck-widget__type-around__button svg line{stroke-dasharray:7}.ck .ck-widget .ck-widget__type-around__button:hover{animation:ck-widget-type-around-button-sonar 1s ease infinite}.ck .ck-widget .ck-widget__type-around__button:hover svg polyline{animation:ck-widget-type-around-arrow-dash 2s linear}.ck .ck-widget .ck-widget__type-around__button:hover svg line{animation:ck-widget-type-around-arrow-tip-dash 2s linear}.ck .ck-widget.ck-widget_selected>.ck-widget__type-around>.ck-widget__type-around__button,.ck .ck-widget:hover>.ck-widget__type-around>.ck-widget__type-around__button{opacity:1;pointer-events:auto}.ck .ck-widget:not(.ck-widget_selected)>.ck-widget__type-around>.ck-widget__type-around__button{background:var(--ck-color-widget-type-around-button-hover)}.ck .ck-widget.ck-widget_selected>.ck-widget__type-around>.ck-widget__type-around__button,.ck .ck-widget>.ck-widget__type-around>.ck-widget__type-around__button:hover{background:var(--ck-color-widget-type-around-button-active)}.ck .ck-widget.ck-widget_selected>.ck-widget__type-around>.ck-widget__type-around__button:after,.ck .ck-widget>.ck-widget__type-around>.ck-widget__type-around__button:hover:after{background:linear-gradient(135deg,hsla(0,0%,100%,0),hsla(0,0%,100%,.3));border-radius:100px;height:calc(var(--ck-widget-type-around-button-size) - 2px);width:calc(var(--ck-widget-type-around-button-size) - 2px)}.ck .ck-widget.ck-widget_with-selection-handle>.ck-widget__type-around>.ck-widget__type-around__button_before{margin-left:20px}.ck .ck-widget .ck-widget__type-around__fake-caret{animation:ck-widget-type-around-fake-caret-pulse 1s linear infinite normal forwards;background:var(--ck-color-base-text);height:1px;outline:1px solid hsla(0,0%,100%,.5);pointer-events:none}.ck .ck-widget.ck-widget_selected.ck-widget_type-around_show-fake-caret_after,.ck .ck-widget.ck-widget_selected.ck-widget_type-around_show-fake-caret_before{outline-color:transparent}.ck .ck-widget.ck-widget_type-around_show-fake-caret_after.ck-widget_selected:hover,.ck .ck-widget.ck-widget_type-around_show-fake-caret_before.ck-widget_selected:hover{outline-color:var(--ck-color-widget-hover-border)}.ck .ck-widget.ck-widget_type-around_show-fake-caret_after>.ck-widget__type-around>.ck-widget__type-around__button,.ck .ck-widget.ck-widget_type-around_show-fake-caret_before>.ck-widget__type-around>.ck-widget__type-around__button{opacity:0;pointer-events:none}.ck .ck-widget.ck-widget_type-around_show-fake-caret_after.ck-widget_selected.ck-widget_with-resizer>.ck-widget__resizer,.ck .ck-widget.ck-widget_type-around_show-fake-caret_after.ck-widget_with-selection-handle.ck-widget_selected:hover>.ck-widget__selection-handle,.ck .ck-widget.ck-widget_type-around_show-fake-caret_after.ck-widget_with-selection-handle.ck-widget_selected>.ck-widget__selection-handle,.ck .ck-widget.ck-widget_type-around_show-fake-caret_before.ck-widget_selected.ck-widget_with-resizer>.ck-widget__resizer,.ck .ck-widget.ck-widget_type-around_show-fake-caret_before.ck-widget_with-selection-handle.ck-widget_selected:hover>.ck-widget__selection-handle,.ck .ck-widget.ck-widget_type-around_show-fake-caret_before.ck-widget_with-selection-handle.ck-widget_selected>.ck-widget__selection-handle{opacity:0}.ck[dir=rtl] .ck-widget.ck-widget_with-selection-handle .ck-widget__type-around>.ck-widget__type-around__button_before{margin-left:0;margin-right:20px}.ck-editor__nested-editable.ck-editor__editable_selected .ck-widget.ck-widget_selected>.ck-widget__type-around>.ck-widget__type-around__button,.ck-editor__nested-editable.ck-editor__editable_selected .ck-widget:hover>.ck-widget__type-around>.ck-widget__type-around__button{opacity:0;pointer-events:none}.ck-editor__editable.ck-blurred .ck-widget.ck-widget_selected>.ck-widget__type-around>.ck-widget__type-around__button:not(:hover){background:var(--ck-color-widget-type-around-button-blurred-editable)}.ck-editor__editable.ck-blurred .ck-widget.ck-widget_selected>.ck-widget__type-around>.ck-widget__type-around__button:not(:hover) svg *{stroke:#999}@keyframes ck-widget-type-around-arrow-dash{0%{stroke-dashoffset:10}20%,to{stroke-dashoffset:0}}@keyframes ck-widget-type-around-arrow-tip-dash{0%,20%{stroke-dashoffset:7}40%,to{stroke-dashoffset:0}}@keyframes ck-widget-type-around-button-sonar{0%{box-shadow:0 0 0 0 hsla(var(--ck-color-focus-border-coordinates),var(--ck-color-widget-type-around-button-radar-start-alpha))}50%{box-shadow:0 0 0 5px hsla(var(--ck-color-focus-border-coordinates),var(--ck-color-widget-type-around-button-radar-end-alpha))}to{box-shadow:0 0 0 5px hsla(var(--ck-color-focus-border-coordinates),var(--ck-color-widget-type-around-button-radar-start-alpha))}}@keyframes ck-widget-type-around-fake-caret-pulse{0%{opacity:1}49%{opacity:1}50%{opacity:0}99%{opacity:0}to{opacity:1}}',
              "",
              {
                version: 3,
                sources: [
                  "webpack://./node_modules/@ckeditor/ckeditor5-widget/theme/widgettypearound.css",
                  "webpack://./node_modules/@ckeditor/ckeditor5-theme-lark/theme/ckeditor5-widget/widgettypearound.css",
                ],
                names: [],
                mappings:
                  "AASC,+CACC,aAAc,CAEd,eAAgB,CADhB,iBAAkB,CAElB,2BAwBD,CAtBC,mDAGC,QAAS,CAFT,iBAAkB,CAClB,OAAQ,CAER,qCACD,CAEA,qFAGC,kBAAoB,CADpB,gDAAoD,CAGpD,0BACD,CAEA,oFAEC,mDAAuD,CACvD,mBAAqB,CAErB,yBACD,CAUA,mLACC,UAAW,CACX,aAAc,CAGd,QAAS,CAFT,iBAAkB,CAClB,OAAQ,CAER,qCACD,CAMD,2EACC,YAAa,CAEb,MAAO,CADP,iBAAkB,CAElB,OACD,CAOA,iFACC,gDAAqD,CACrD,iDACD,CAKA,wHAEC,aAAc,CADd,qDAED,CAKA,uHACC,wDAA6D,CAC7D,aACD,CAoBD,mOACC,YACD,CC3GA,MACC,wCAAyC,CACzC,wEAAyE,CACzE,8EAA+E,CAC/E,2FAA4F,CAC5F,wDAAyD,CACzD,uDAAwD,CACxD,yEACD,CAgBC,+CAGC,oDAAqD,CACrD,mBAAoB,CAFpB,+CAAgD,CAVjD,SAAU,CACV,mBAAoB,CAYnB,uMAAyM,CAJzM,8CAkDD,CA1CC,mDAEC,UAAW,CAGX,cAAe,CAFf,8BAA+B,CAC/B,6BAA8B,CAH9B,UAoBD,CAdC,qDACC,mBAAoB,CACpB,mBAAoB,CAEpB,SAAU,CACV,qDAAsD,CACtD,kBAAmB,CACnB,oBAAqB,CACrB,qBACD,CAEA,wDACC,kBACD,CAGD,qDAIC,6DAcD,CARE,kEACC,oDACD,CAEA,8DACC,wDACD,CAUF,uKAvED,SAAU,CACV,mBAwEC,CAOD,gGACC,0DACD,CAOA,uKAEC,2DAQD,CANC,mLAIC,uEAAkF,CADlF,mBAAoB,CADpB,2DAA4D,CAD5D,0DAID,CAOD,8GACC,gBACD,CAKA,mDAGC,mFAAoF,CAOpF,oCAAqC,CARrC,UAAW,CAOX,oCAAwC,CARxC,mBAUD,CAOC,6JAEC,yBACD,CAUA,yKACC,iDACD,CAMA,uOAlJD,SAAU,CACV,mBAmJC,CAoBA,6yBACC,SACD,CASF,uHACC,aAAc,CACd,iBACD,CAYG,iRAlMF,SAAU,CACV,mBAmME,CAQH,kIACC,qEAKD,CAHC,wIACC,WACD,CAGD,4CACC,GACC,oBACD,CACA,OACC,mBACD,CACD,CAEA,gDACC,OACC,mBACD,CACA,OACC,mBACD,CACD,CAEA,8CACC,GACC,6HACD,CACA,IACC,6HACD,CACA,GACC,+HACD,CACD,CAEA,kDACC,GACC,SACD,CACA,IACC,SACD,CACA,IACC,SACD,CACA,IACC,SACD,CACA,GACC,SACD,CACD",
                sourcesContent: [
                  '/*\n * Copyright (c) 2003-2022, CKSource Holding sp. z o.o. All rights reserved.\n * For licensing, see LICENSE.md or https://ckeditor.com/legal/ckeditor-oss-license\n */\n\n.ck .ck-widget {\n\t/*\n\t * Styles of the type around buttons\n\t */\n\t& .ck-widget__type-around__button {\n\t\tdisplay: block;\n\t\tposition: absolute;\n\t\toverflow: hidden;\n\t\tz-index: var(--ck-z-default);\n\n\t\t& svg {\n\t\t\tposition: absolute;\n\t\t\ttop: 50%;\n\t\t\tleft: 50%;\n\t\t\tz-index: calc(var(--ck-z-default) + 2);\n\t\t}\n\n\t\t&.ck-widget__type-around__button_before {\n\t\t\t/* Place it in the middle of the outline */\n\t\t\ttop: calc(-0.5 * var(--ck-widget-outline-thickness));\n\t\t\tleft: min(10%, 30px);\n\n\t\t\ttransform: translateY(-50%);\n\t\t}\n\n\t\t&.ck-widget__type-around__button_after {\n\t\t\t/* Place it in the middle of the outline */\n\t\t\tbottom: calc(-0.5 * var(--ck-widget-outline-thickness));\n\t\t\tright: min(10%, 30px);\n\n\t\t\ttransform: translateY(50%);\n\t\t}\n\t}\n\n\t/*\n\t * Styles for the buttons when:\n\t * - the widget is selected,\n\t * - or the button is being hovered (regardless of the widget state).\n\t */\n\t&.ck-widget_selected > .ck-widget__type-around > .ck-widget__type-around__button,\n\t& > .ck-widget__type-around > .ck-widget__type-around__button:hover {\n\t\t&::after {\n\t\t\tcontent: "";\n\t\t\tdisplay: block;\n\t\t\tposition: absolute;\n\t\t\ttop: 1px;\n\t\t\tleft: 1px;\n\t\t\tz-index: calc(var(--ck-z-default) + 1);\n\t\t}\n\t}\n\n\t/*\n\t * Styles for the horizontal "fake caret" which is displayed when the user navigates using the keyboard.\n\t */\n\t& > .ck-widget__type-around > .ck-widget__type-around__fake-caret {\n\t\tdisplay: none;\n\t\tposition: absolute;\n\t\tleft: 0;\n\t\tright: 0;\n\t}\n\n\t/*\n\t * When the widget is hovered the "fake caret" would normally be narrower than the\n\t * extra outline displayed around the widget. Let\'s extend the "fake caret" to match\n\t * the full width of the widget.\n\t */\n\t&:hover > .ck-widget__type-around > .ck-widget__type-around__fake-caret {\n\t\tleft: calc( -1 * var(--ck-widget-outline-thickness) );\n\t\tright: calc( -1 * var(--ck-widget-outline-thickness) );\n\t}\n\n\t/*\n\t * Styles for the horizontal "fake caret" when it should be displayed before the widget (backward keyboard navigation).\n\t */\n\t&.ck-widget_type-around_show-fake-caret_before > .ck-widget__type-around > .ck-widget__type-around__fake-caret {\n\t\ttop: calc( -1 * var(--ck-widget-outline-thickness) - 1px );\n\t\tdisplay: block;\n\t}\n\n\t/*\n\t * Styles for the horizontal "fake caret" when it should be displayed after the widget (forward keyboard navigation).\n\t */\n\t&.ck-widget_type-around_show-fake-caret_after > .ck-widget__type-around > .ck-widget__type-around__fake-caret {\n\t\tbottom: calc( -1 * var(--ck-widget-outline-thickness) - 1px );\n\t\tdisplay: block;\n\t}\n}\n\n/*\n * Integration with the read-only mode of the editor.\n */\n.ck.ck-editor__editable.ck-read-only .ck-widget__type-around {\n\tdisplay: none;\n}\n\n/*\n * Integration with the restricted editing mode (feature) of the editor.\n */\n.ck.ck-editor__editable.ck-restricted-editing_mode_restricted .ck-widget__type-around {\n\tdisplay: none;\n}\n\n/*\n * Integration with the #isEnabled property of the WidgetTypeAround plugin.\n */\n.ck.ck-editor__editable.ck-widget__type-around_disabled .ck-widget__type-around {\n\tdisplay: none;\n}\n',
                  '/*\n * Copyright (c) 2003-2022, CKSource Holding sp. z o.o. All rights reserved.\n * For licensing, see LICENSE.md or https://ckeditor.com/legal/ckeditor-oss-license\n */\n\n:root {\n\t--ck-widget-type-around-button-size: 20px;\n\t--ck-color-widget-type-around-button-active: var(--ck-color-focus-border);\n\t--ck-color-widget-type-around-button-hover: var(--ck-color-widget-hover-border);\n\t--ck-color-widget-type-around-button-blurred-editable: var(--ck-color-widget-blurred-border);\n\t--ck-color-widget-type-around-button-radar-start-alpha: 0;\n\t--ck-color-widget-type-around-button-radar-end-alpha: .3;\n\t--ck-color-widget-type-around-button-icon: var(--ck-color-base-background);\n}\n\n@define-mixin ck-widget-type-around-button-visible {\n\topacity: 1;\n\tpointer-events: auto;\n}\n\n@define-mixin ck-widget-type-around-button-hidden {\n\topacity: 0;\n\tpointer-events: none;\n}\n\n.ck .ck-widget {\n\t/*\n\t * Styles of the type around buttons\n\t */\n\t& .ck-widget__type-around__button {\n\t\twidth: var(--ck-widget-type-around-button-size);\n\t\theight: var(--ck-widget-type-around-button-size);\n\t\tbackground: var(--ck-color-widget-type-around-button);\n\t\tborder-radius: 100px;\n\t\ttransition: opacity var(--ck-widget-handler-animation-duration) var(--ck-widget-handler-animation-curve), background var(--ck-widget-handler-animation-duration) var(--ck-widget-handler-animation-curve);\n\n\t\t@mixin ck-widget-type-around-button-hidden;\n\n\t\t& svg {\n\t\t\twidth: 10px;\n\t\t\theight: 8px;\n\t\t\ttransform: translate(-50%,-50%);\n\t\t\ttransition: transform .5s ease;\n\t\t\tmargin-top: 1px;\n\n\t\t\t& * {\n\t\t\t\tstroke-dasharray: 10;\n\t\t\t\tstroke-dashoffset: 0;\n\n\t\t\t\tfill: none;\n\t\t\t\tstroke: var(--ck-color-widget-type-around-button-icon);\n\t\t\t\tstroke-width: 1.5px;\n\t\t\t\tstroke-linecap: round;\n\t\t\t\tstroke-linejoin: round;\n\t\t\t}\n\n\t\t\t& line {\n\t\t\t\tstroke-dasharray: 7;\n\t\t\t}\n\t\t}\n\n\t\t&:hover {\n\t\t\t/*\n\t\t\t * Display the "sonar" around the button when hovered.\n\t\t\t */\n\t\t\tanimation: ck-widget-type-around-button-sonar 1s ease infinite;\n\n\t\t\t/*\n\t\t\t * Animate active button\'s icon.\n\t\t\t */\n\t\t\t& svg {\n\t\t\t\t& polyline {\n\t\t\t\t\tanimation: ck-widget-type-around-arrow-dash 2s linear;\n\t\t\t\t}\n\n\t\t\t\t& line {\n\t\t\t\t\tanimation: ck-widget-type-around-arrow-tip-dash 2s linear;\n\t\t\t\t}\n\t\t\t}\n\t\t}\n\t}\n\n\t/*\n\t * Show type around buttons when the widget gets selected or being hovered.\n\t */\n\t&.ck-widget_selected,\n\t&:hover {\n\t\t& > .ck-widget__type-around > .ck-widget__type-around__button {\n\t\t\t@mixin ck-widget-type-around-button-visible;\n\t\t}\n\t}\n\n\t/*\n\t * Styles for the buttons when the widget is NOT selected (but the buttons are visible\n\t * and still can be hovered).\n\t */\n\t&:not(.ck-widget_selected) > .ck-widget__type-around > .ck-widget__type-around__button {\n\t\tbackground: var(--ck-color-widget-type-around-button-hover);\n\t}\n\n\t/*\n\t * Styles for the buttons when:\n\t * - the widget is selected,\n\t * - or the button is being hovered (regardless of the widget state).\n\t */\n\t&.ck-widget_selected > .ck-widget__type-around > .ck-widget__type-around__button,\n\t& > .ck-widget__type-around > .ck-widget__type-around__button:hover {\n\t\tbackground: var(--ck-color-widget-type-around-button-active);\n\n\t\t&::after {\n\t\t\twidth: calc(var(--ck-widget-type-around-button-size) - 2px);\n\t\t\theight: calc(var(--ck-widget-type-around-button-size) - 2px);\n\t\t\tborder-radius: 100px;\n\t\t\tbackground: linear-gradient(135deg, hsla(0,0%,100%,0) 0%, hsla(0,0%,100%,.3) 100%);\n\t\t}\n\t}\n\n\t/*\n\t * Styles for the "before" button when the widget has a selection handle. Because some space\n\t * is consumed by the handle, the button must be moved slightly to the right to let it breathe.\n\t */\n\t&.ck-widget_with-selection-handle > .ck-widget__type-around > .ck-widget__type-around__button_before {\n\t\tmargin-left: 20px;\n\t}\n\n\t/*\n\t * Styles for the horizontal "fake caret" which is displayed when the user navigates using the keyboard.\n\t */\n\t& .ck-widget__type-around__fake-caret {\n\t\tpointer-events: none;\n\t\theight: 1px;\n\t\tanimation: ck-widget-type-around-fake-caret-pulse linear 1s infinite normal forwards;\n\n\t\t/*\n\t\t * The semi-transparent-outline+background combo improves the contrast\n\t\t * when the background underneath the fake caret is dark.\n\t\t */\n\t\toutline: solid 1px hsla(0, 0%, 100%, .5);\n\t\tbackground: var(--ck-color-base-text);\n\t}\n\n\t/*\n\t * Styles of the widget when the "fake caret" is blinking (e.g. upon keyboard navigation).\n\t * Despite the widget being physically selected in the model, its outline should disappear.\n\t */\n\t&.ck-widget_selected {\n\t\t&.ck-widget_type-around_show-fake-caret_before,\n\t\t&.ck-widget_type-around_show-fake-caret_after {\n\t\t\toutline-color: transparent;\n\t\t}\n\t}\n\n\t&.ck-widget_type-around_show-fake-caret_before,\n\t&.ck-widget_type-around_show-fake-caret_after {\n\t\t/*\n\t\t * When the "fake caret" is visible we simulate that the widget is not selected\n\t\t * (despite being physically selected), so the outline color should be for the\n\t\t * unselected widget.\n\t\t */\n\t\t&.ck-widget_selected:hover {\n\t\t\toutline-color: var(--ck-color-widget-hover-border);\n\t\t}\n\n\t\t/*\n\t\t * Styles of the type around buttons when the "fake caret" is blinking (e.g. upon keyboard navigation).\n\t\t * In this state, the type around buttons would collide with the fake carets so they should disappear.\n\t\t */\n\t\t& > .ck-widget__type-around > .ck-widget__type-around__button {\n\t\t\t@mixin ck-widget-type-around-button-hidden;\n\t\t}\n\n\t\t/*\n\t\t * Fake horizontal caret integration with the selection handle. When the caret is visible, simply\n\t\t * hide the handle because it intersects with the caret (and does not make much sense anyway).\n\t\t */\n\t\t&.ck-widget_with-selection-handle {\n\t\t\t&.ck-widget_selected,\n\t\t\t&.ck-widget_selected:hover {\n\t\t\t\t& > .ck-widget__selection-handle {\n\t\t\t\t\topacity: 0\n\t\t\t\t}\n\t\t\t}\n\t\t}\n\n\t\t/*\n\t\t * Fake horizontal caret integration with the resize UI. When the caret is visible, simply\n\t\t * hide the resize UI because it creates too much noise. It can be visible when the user\n\t\t * hovers the widget, though.\n\t\t */\n\t\t&.ck-widget_selected.ck-widget_with-resizer > .ck-widget__resizer {\n\t\t\topacity: 0\n\t\t}\n\t}\n}\n\n/*\n * Styles for the "before" button when the widget has a selection handle in an RTL environment.\n * The selection handler is aligned to the right side of the widget so there is no need to create\n * additional space for it next to the "before" button.\n */\n.ck[dir="rtl"] .ck-widget.ck-widget_with-selection-handle .ck-widget__type-around > .ck-widget__type-around__button_before {\n\tmargin-left: 0;\n\tmargin-right: 20px;\n}\n\n/*\n * Hide type around buttons when the widget is selected as a child of a selected\n * nested editable (e.g. mulit-cell table selection).\n *\n * See https://github.com/ckeditor/ckeditor5/issues/7263.\n */\n.ck-editor__nested-editable.ck-editor__editable_selected {\n\t& .ck-widget {\n\t\t&.ck-widget_selected,\n\t\t&:hover {\n\t\t\t& > .ck-widget__type-around > .ck-widget__type-around__button {\n\t\t\t\t@mixin ck-widget-type-around-button-hidden;\n\t\t\t}\n\t\t}\n\t}\n}\n\n/*\n * Styles for the buttons when the widget is selected but the user clicked outside of the editor (blurred the editor).\n */\n.ck-editor__editable.ck-blurred .ck-widget.ck-widget_selected > .ck-widget__type-around > .ck-widget__type-around__button:not(:hover) {\n\tbackground: var(--ck-color-widget-type-around-button-blurred-editable);\n\n\t& svg * {\n\t\tstroke: hsl(0,0%,60%);\n\t}\n}\n\n@keyframes ck-widget-type-around-arrow-dash {\n\t0% {\n\t\tstroke-dashoffset: 10;\n\t}\n\t20%, 100% {\n\t\tstroke-dashoffset: 0;\n\t}\n}\n\n@keyframes ck-widget-type-around-arrow-tip-dash {\n\t0%, 20% {\n\t\tstroke-dashoffset: 7;\n\t}\n\t40%, 100% {\n\t\tstroke-dashoffset: 0;\n\t}\n}\n\n@keyframes ck-widget-type-around-button-sonar {\n\t0% {\n\t\tbox-shadow: 0 0 0 0 hsla(var(--ck-color-focus-border-coordinates), var(--ck-color-widget-type-around-button-radar-start-alpha));\n\t}\n\t50% {\n\t\tbox-shadow: 0 0 0 5px hsla(var(--ck-color-focus-border-coordinates), var(--ck-color-widget-type-around-button-radar-end-alpha));\n\t}\n\t100% {\n\t\tbox-shadow: 0 0 0 5px hsla(var(--ck-color-focus-border-coordinates), var(--ck-color-widget-type-around-button-radar-start-alpha));\n\t}\n}\n\n@keyframes ck-widget-type-around-fake-caret-pulse {\n\t0% {\n\t\topacity: 1;\n\t}\n\t49% {\n\t\topacity: 1;\n\t}\n\t50% {\n\t\topacity: 0;\n\t}\n\t99% {\n\t\topacity: 0;\n\t}\n\t100% {\n\t\topacity: 1;\n\t}\n}\n',
                ],
                sourceRoot: "",
              },
            ]);
            const a = s;
          },
          3101: (t, e, n) => {
            "use strict";
            n.d(e, { Z: () => a });
            var o = n(7537),
              i = n.n(o),
              r = n(3645),
              s = n.n(r)()(i());
            s.push([
              t.id,
              ".ck-editor.ck-plugin-full-screen{align-items:center;background-color:#fff;display:flex;flex-direction:column;height:100vh;left:0;position:fixed;top:0;width:100%;z-index:100}.ck-editor.ck-plugin-full-screen .ck-editor__main,.ck-editor.ck-plugin-full-screen .ck-editor__top{max-width:1000px;width:100%}.ck-editor.ck-plugin-full-screen .ck-editor__top{margin-top:2em}.ck-editor.ck-plugin-full-screen .ck-editor__main{flex-grow:1;margin-bottom:2em;overflow-y:hidden}.ck-editor.ck-plugin-full-screen .ck-source-editing-area{height:100%}.ck-editor.ck-plugin-full-screen .ck-source-editing-area textarea{overflow-y:scroll}",
              "",
              {
                version: 3,
                sources: [
                  "webpack://./node_modules/ckeditor5-full-screen/theme/fullscreen.css",
                ],
                names: [],
                mappings:
                  "AAAA,iCASE,kBAAmB,CACnB,qBAAsB,CAHtB,YAAa,CACb,qBAAsB,CAFtB,YAAa,CAHb,MAAO,CAFP,cAAe,CACf,KAAM,CAGN,UAAW,CADX,WAOF,CAEA,mGAGE,gBAAiB,CADjB,UAEF,CAEA,iDACE,cACF,CAEA,kDAEE,WAAY,CAEZ,iBAAkB,CADlB,iBAEF,CAGA,yDACE,WACF,CAEA,kEACE,iBACF",
                sourcesContent: [
                  ".ck-editor.ck-plugin-full-screen {\n  position: fixed;\n  top: 0;\n  left: 0;\n  z-index: 100;\n  width: 100%;\n  height: 100vh;\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  background-color: #fff;\n}\n\n.ck-editor.ck-plugin-full-screen .ck-editor__top,\n.ck-editor.ck-plugin-full-screen .ck-editor__main {\n  width: 100%;\n  max-width: 1000px;\n}\n\n.ck-editor.ck-plugin-full-screen .ck-editor__top {\n  margin-top: 2em;\n}\n\n.ck-editor.ck-plugin-full-screen .ck-editor__main {\n  /* Fill the rest of the height of the parent */\n  flex-grow: 1;\n  overflow-y: hidden;\n  margin-bottom: 2em;\n}\n\n/* Make source view also cover the whole viewport */\n.ck-editor.ck-plugin-full-screen .ck-source-editing-area {\n  height: 100%;\n}\n\n.ck-editor.ck-plugin-full-screen .ck-source-editing-area textarea {\n  overflow-y: scroll;\n}\n",
                ],
                sourceRoot: "",
              },
            ]);
            const a = s;
          },
          3645: (t) => {
            "use strict";
            t.exports = function (t) {
              var e = [];
              return (
                (e.toString = function () {
                  return this.map(function (e) {
                    var n = "",
                      o = void 0 !== e[5];
                    return (
                      e[4] && (n += "@supports (".concat(e[4], ") {")),
                      e[2] && (n += "@media ".concat(e[2], " {")),
                      o &&
                        (n += "@layer".concat(
                          e[5].length > 0 ? " ".concat(e[5]) : "",
                          " {"
                        )),
                      (n += t(e)),
                      o && (n += "}"),
                      e[2] && (n += "}"),
                      e[4] && (n += "}"),
                      n
                    );
                  }).join("");
                }),
                (e.i = function (t, n, o, i, r) {
                  "string" == typeof t && (t = [[null, t, void 0]]);
                  var s = {};
                  if (o)
                    for (var a = 0; a < this.length; a++) {
                      var l = this[a][0];
                      null != l && (s[l] = !0);
                    }
                  for (var c = 0; c < t.length; c++) {
                    var d = [].concat(t[c]);
                    (o && s[d[0]]) ||
                      (void 0 !== r &&
                        (void 0 === d[5] ||
                          (d[1] = "@layer"
                            .concat(
                              d[5].length > 0 ? " ".concat(d[5]) : "",
                              " {"
                            )
                            .concat(d[1], "}")),
                        (d[5] = r)),
                      n &&
                        (d[2]
                          ? ((d[1] = "@media "
                              .concat(d[2], " {")
                              .concat(d[1], "}")),
                            (d[2] = n))
                          : (d[2] = n)),
                      i &&
                        (d[4]
                          ? ((d[1] = "@supports ("
                              .concat(d[4], ") {")
                              .concat(d[1], "}")),
                            (d[4] = i))
                          : (d[4] = "".concat(i))),
                      e.push(d));
                  }
                }),
                e
              );
            };
          },
          1667: (t) => {
            "use strict";
            t.exports = function (t, e) {
              return (
                e || (e = {}),
                t
                  ? ((t = String(t.__esModule ? t.default : t)),
                    /^['"].*['"]$/.test(t) && (t = t.slice(1, -1)),
                    e.hash && (t += e.hash),
                    /["'() \t\n]|(%20)/.test(t) || e.needQuotes
                      ? '"'.concat(
                          t.replace(/"/g, '\\"').replace(/\n/g, "\\n"),
                          '"'
                        )
                      : t)
                  : t
              );
            };
          },
          7537: (t) => {
            "use strict";
            t.exports = function (t) {
              var e = t[1],
                n = t[3];
              if (!n) return e;
              if ("function" == typeof btoa) {
                var o = btoa(unescape(encodeURIComponent(JSON.stringify(n)))),
                  i =
                    "sourceMappingURL=data:application/json;charset=utf-8;base64,".concat(
                      o
                    ),
                  r = "/*# ".concat(i, " */"),
                  s = n.sources.map(function (t) {
                    return "/*# sourceURL="
                      .concat(n.sourceRoot || "")
                      .concat(t, " */");
                  });
                return [e].concat(s).concat([r]).join("\n");
              }
              return [e].join("\n");
            };
          },
          3379: (t) => {
            "use strict";
            var e = [];
            function n(t) {
              for (var n = -1, o = 0; o < e.length; o++)
                if (e[o].identifier === t) {
                  n = o;
                  break;
                }
              return n;
            }
            function o(t, o) {
              for (var r = {}, s = [], a = 0; a < t.length; a++) {
                var l = t[a],
                  c = o.base ? l[0] + o.base : l[0],
                  d = r[c] || 0,
                  u = "".concat(c, " ").concat(d);
                r[c] = d + 1;
                var h = n(u),
                  m = {
                    css: l[1],
                    media: l[2],
                    sourceMap: l[3],
                    supports: l[4],
                    layer: l[5],
                  };
                if (-1 !== h) e[h].references++, e[h].updater(m);
                else {
                  var g = i(m, o);
                  (o.byIndex = a),
                    e.splice(a, 0, {
                      identifier: u,
                      updater: g,
                      references: 1,
                    });
                }
                s.push(u);
              }
              return s;
            }
            function i(t, e) {
              var n = e.domAPI(e);
              n.update(t);
              return function (e) {
                if (e) {
                  if (
                    e.css === t.css &&
                    e.media === t.media &&
                    e.sourceMap === t.sourceMap &&
                    e.supports === t.supports &&
                    e.layer === t.layer
                  )
                    return;
                  n.update((t = e));
                } else n.remove();
              };
            }
            t.exports = function (t, i) {
              var r = o((t = t || []), (i = i || {}));
              return function (t) {
                t = t || [];
                for (var s = 0; s < r.length; s++) {
                  var a = n(r[s]);
                  e[a].references--;
                }
                for (var l = o(t, i), c = 0; c < r.length; c++) {
                  var d = n(r[c]);
                  0 === e[d].references && (e[d].updater(), e.splice(d, 1));
                }
                r = l;
              };
            };
          },
          569: (t) => {
            "use strict";
            var e = {};
            t.exports = function (t, n) {
              var o = (function (t) {
                if (void 0 === e[t]) {
                  var n = document.querySelector(t);
                  if (
                    window.HTMLIFrameElement &&
                    n instanceof window.HTMLIFrameElement
                  )
                    try {
                      n = n.contentDocument.head;
                    } catch (t) {
                      n = null;
                    }
                  e[t] = n;
                }
                return e[t];
              })(t);
              if (!o)
                throw new Error(
                  "Couldn't find a style target. This probably means that the value for the 'insert' parameter is invalid."
                );
              o.appendChild(n);
            };
          },
          9216: (t) => {
            "use strict";
            t.exports = function (t) {
              var e = document.createElement("style");
              return (
                t.setAttributes(e, t.attributes), t.insert(e, t.options), e
              );
            };
          },
          8575: (t) => {
            "use strict";
            t.exports = function (t, e) {
              Object.keys(e).forEach(function (n) {
                t.setAttribute(n, e[n]);
              });
            };
          },
          9037: (t) => {
            "use strict";
            var e,
              n =
                ((e = []),
                function (t, n) {
                  return (e[t] = n), e.filter(Boolean).join("\n");
                });
            function o(t, e, o, i) {
              var r;
              if (o) r = "";
              else {
                (r = ""),
                  i.supports && (r += "@supports (".concat(i.supports, ") {")),
                  i.media && (r += "@media ".concat(i.media, " {"));
                var s = void 0 !== i.layer;
                s &&
                  (r += "@layer".concat(
                    i.layer.length > 0 ? " ".concat(i.layer) : "",
                    " {"
                  )),
                  (r += i.css),
                  s && (r += "}"),
                  i.media && (r += "}"),
                  i.supports && (r += "}");
              }
              if (t.styleSheet) t.styleSheet.cssText = n(e, r);
              else {
                var a = document.createTextNode(r),
                  l = t.childNodes;
                l[e] && t.removeChild(l[e]),
                  l.length ? t.insertBefore(a, l[e]) : t.appendChild(a);
              }
            }
            var i = { singleton: null, singletonCounter: 0 };
            t.exports = function (t) {
              var e = i.singletonCounter++,
                n = i.singleton || (i.singleton = t.insertStyleElement(t));
              return {
                update: function (t) {
                  o(n, e, !1, t);
                },
                remove: function (t) {
                  o(n, e, !0, t);
                },
              };
            };
          },
          8491: (t) => {
            "use strict";
            t.exports =
              "data:image/svg+xml;base64,PHN2ZyB2aWV3Qm94PSIwIDAgMjAgMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+PHBhdGggZmlsbD0iI2ZmZiIgZD0ibTExLjA3NyAxNSAuOTkxLTEuNDE2YS43NS43NSAwIDEgMSAxLjIyOS44NmwtMS4xNDggMS42NGEuNzQ4Ljc0OCAwIDAgMS0uMjE3LjIwNiA1LjI1MSA1LjI1MSAwIDAgMS04LjUwMy01Ljk1NS43NDEuNzQxIDAgMCAxIC4xMi0uMjc0bDEuMTQ3LTEuNjM5YS43NS43NSAwIDEgMSAxLjIyOC44Nkw0LjkzMyAxMC43bC4wMDYuMDAzYTMuNzUgMy43NSAwIDAgMCA2LjEzMiA0LjI5NGwuMDA2LjAwNHptNS40OTQtNS4zMzVhLjc0OC43NDggMCAwIDEtLjEyLjI3NGwtMS4xNDcgMS42MzlhLjc1Ljc1IDAgMSAxLTEuMjI4LS44NmwuODYtMS4yM2EzLjc1IDMuNzUgMCAwIDAtNi4xNDQtNC4zMDFsLS44NiAxLjIyOWEuNzUuNzUgMCAwIDEtMS4yMjktLjg2bDEuMTQ4LTEuNjRhLjc0OC43NDggMCAwIDEgLjIxNy0uMjA2IDUuMjUxIDUuMjUxIDAgMCAxIDguNTAzIDUuOTU1em0tNC41NjMtMi41MzJhLjc1Ljc1IDAgMCAxIC4xODQgMS4wNDVsLTMuMTU1IDQuNTA1YS43NS43NSAwIDEgMS0xLjIyOS0uODZsMy4xNTUtNC41MDZhLjc1Ljc1IDAgMCAxIDEuMDQ1LS4xODR6Ii8+PC9zdmc+";
          },
          2739: (t) => {
            "use strict";
            t.exports =
              "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTAyNCIgaGVpZ2h0PSIxMDI0IiB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciPjxwYXRoIGQ9Ik05NjcuNDg0IDBINTYuNTE3QzI1LjMwNCAwIDAgMjUuMzA0IDAgNTYuNTE3djkxMC45NjZDMCA5OTguNjk0IDI1LjI5NyAxMDI0IDU2LjUyMiAxMDI0SDU0N1Y2MjhINDE0VjQ3M2gxMzNWMzU5LjAyOWMwLTEzMi4yNjIgODAuNzczLTIwNC4yODIgMTk4Ljc1Ni0yMDQuMjgyIDU2LjUxMyAwIDEwNS4wODYgNC4yMDggMTE5LjI0NCA2LjA4OVYyOTlsLTgxLjYxNi4wMzdjLTYzLjk5MyAwLTc2LjM4NCAzMC40OTItNzYuMzg0IDc1LjIzNlY0NzNoMTUzLjQ4N2wtMTkuOTg2IDE1NUg3MDd2Mzk2aDI2MC40ODRjMzEuMjEzIDAgNTYuNTE2LTI1LjMwMyA1Ni41MTYtNTYuNTE2VjU2LjUxNUMxMDI0IDI1LjMwMyA5OTguNjk3IDAgOTY3LjQ4NCAwIiBmaWxsPSIjRkZGRkZFIiBmaWxsLXJ1bGU9ImV2ZW5vZGQiLz48L3N2Zz4=";
          },
          6631: (t) => {
            "use strict";
            t.exports =
              "data:image/svg+xml;base64,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";
          },
          7511: (t) => {
            "use strict";
            t.exports =
              "data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHZpZXdCb3g9IjAgMCA0MDAgNDAwIiBzdHlsZT0iZW5hYmxlLWJhY2tncm91bmQ6bmV3IDAgMCA0MDAgNDAwIiB4bWw6c3BhY2U9InByZXNlcnZlIj48cGF0aCBkPSJNNDAwIDIwMGMwIDExMC41LTg5LjUgMjAwLTIwMCAyMDBTMCAzMTAuNSAwIDIwMCA4OS41IDAgMjAwIDBzMjAwIDg5LjUgMjAwIDIwMHpNMTYzLjQgMzA1LjVjODguNyAwIDEzNy4yLTczLjUgMTM3LjItMTM3LjIgMC0yLjEgMC00LjItLjEtNi4yIDkuNC02LjggMTcuNi0xNS4zIDI0LjEtMjUtOC42IDMuOC0xNy45IDYuNC0yNy43IDcuNiAxMC02IDE3LjYtMTUuNCAyMS4yLTI2LjctOS4zIDUuNS0xOS42IDkuNS0zMC42IDExLjctOC44LTkuNC0yMS4zLTE1LjItMzUuMi0xNS4yLTI2LjYgMC00OC4yIDIxLjYtNDguMiA0OC4yIDAgMy44LjQgNy41IDEuMyAxMS00MC4xLTItNzUuNi0yMS4yLTk5LjQtNTAuNC00LjEgNy4xLTYuNSAxNS40LTYuNSAyNC4yIDAgMTYuNyA4LjUgMzEuNSAyMS41IDQwLjEtNy45LS4yLTE1LjMtMi40LTIxLjgtNnYuNmMwIDIzLjQgMTYuNiA0Mi44IDM4LjcgNDcuMy00IDEuMS04LjMgMS43LTEyLjcgMS43LTMuMSAwLTYuMS0uMy05LjEtLjkgNi4xIDE5LjIgMjMuOSAzMy4xIDQ1IDMzLjUtMTYuNSAxMi45LTM3LjMgMjAuNi01OS45IDIwLjYtMy45IDAtNy43LS4yLTExLjUtLjcgMjEuMSAxMy44IDQ2LjUgMjEuOCA3My43IDIxLjgiIHN0eWxlPSJmaWxsOiNmZmYiLz48L3N2Zz4=";
          },
          4493: (t) => {
            "use strict";
            t.exports =
              "data:image/svg+xml;base64,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";
          },
          1576: () => {},
        },
        e = {};
      function n(o) {
        var i = e[o];
        if (void 0 !== i) return i.exports;
        var r = (e[o] = { id: o, exports: {} });
        return t[o](r, r.exports, n), r.exports;
      }
      (n.m = t),
        (n.n = (t) => {
          var e = t && t.__esModule ? () => t.default : () => t;
          return n.d(e, { a: e }), e;
        }),
        (n.d = (t, e) => {
          for (var o in e)
            n.o(e, o) &&
              !n.o(t, o) &&
              Object.defineProperty(t, o, { enumerable: !0, get: e[o] });
        }),
        (n.g = (function () {
          if ("object" == typeof globalThis) return globalThis;
          try {
            return this || new Function("return this")();
          } catch (t) {
            if ("object" == typeof window) return window;
          }
        })()),
        (n.o = (t, e) => Object.prototype.hasOwnProperty.call(t, e)),
        (n.b = document.baseURI || self.location.href);
      var o = {};
      return (
        (() => {
          "use strict";
          n.d(o, { default: () => rI });
          const t = function () {
            return function t() {
              t.called = !0;
            };
          };
          class e {
            constructor(e, n) {
              (this.source = e),
                (this.name = n),
                (this.path = []),
                (this.stop = t()),
                (this.off = t());
            }
          }
          const i = new Array(256)
            .fill("")
            .map((t, e) => ("0" + e.toString(16)).slice(-2));
          function r() {
            const t = (4294967296 * Math.random()) >>> 0,
              e = (4294967296 * Math.random()) >>> 0,
              n = (4294967296 * Math.random()) >>> 0,
              o = (4294967296 * Math.random()) >>> 0;
            return (
              "e" +
              i[(t >> 0) & 255] +
              i[(t >> 8) & 255] +
              i[(t >> 16) & 255] +
              i[(t >> 24) & 255] +
              i[(e >> 0) & 255] +
              i[(e >> 8) & 255] +
              i[(e >> 16) & 255] +
              i[(e >> 24) & 255] +
              i[(n >> 0) & 255] +
              i[(n >> 8) & 255] +
              i[(n >> 16) & 255] +
              i[(n >> 24) & 255] +
              i[(o >> 0) & 255] +
              i[(o >> 8) & 255] +
              i[(o >> 16) & 255] +
              i[(o >> 24) & 255]
            );
          }
          const s = {
            get(t = "normal") {
              return "number" != typeof t ? this[t] || this.normal : t;
            },
            highest: 1e5,
            high: 1e3,
            normal: 0,
            low: -1e3,
            lowest: -1e5,
          };
          function a(t, e) {
            const n = s.get(e.priority);
            for (let o = 0; o < t.length; o++)
              if (s.get(t[o].priority) < n) return void t.splice(o, 0, e);
            t.push(e);
          }
          class l extends Error {
            constructor(t, e, n) {
              super(
                (function (t, e) {
                  const n = new WeakSet(),
                    o = (t, e) => {
                      if ("object" == typeof e && null !== e) {
                        if (n.has(e)) return `[object ${e.constructor.name}]`;
                        n.add(e);
                      }
                      return e;
                    },
                    i = e ? ` ${JSON.stringify(e, o)}` : "",
                    r = d(t);
                  return t + i + r;
                })(t, n)
              ),
                (this.name = "CKEditorError"),
                (this.context = e),
                (this.data = n);
            }
            is(t) {
              return "CKEditorError" === t;
            }
            static rethrowUnexpectedError(t, e) {
              if (t.is && t.is("CKEditorError")) throw t;
              const n = new l(t.message, e);
              throw ((n.stack = t.stack), n);
            }
          }
          function c(t, e) {
            console.warn(...u(t, e));
          }
          function d(t) {
            return `\nRead more: https://ckeditor.com/docs/ckeditor5/latest/support/error-codes.html#error-${t}`;
          }
          function u(t, e) {
            const n = d(t);
            return e ? [t, e, n] : [t, n];
          }
          const h = "35.3.2",
            m = "object" == typeof window ? window : n.g;
          if (m.CKEDITOR_VERSION)
            throw new l("ckeditor-duplicated-modules", null);
          m.CKEDITOR_VERSION = h;
          const g = Symbol("listeningTo"),
            p = Symbol("emitterId"),
            f = Symbol("delegations");
          function k(t) {
            return class extends t {
              on(t, e, n) {
                this.listenTo(this, t, e, n);
              }
              once(t, e, n) {
                let o = !1;
                this.listenTo(
                  this,
                  t,
                  (t, ...n) => {
                    o || ((o = !0), t.off(), e.call(this, t, ...n));
                  },
                  n
                );
              }
              off(t, e) {
                this.stopListening(this, t, e);
              }
              listenTo(t, e, n, o = {}) {
                let i, r;
                this[g] || (this[g] = {});
                const s = this[g];
                A(t) || w(t);
                const a = A(t);
                (i = s[a]) || (i = s[a] = { emitter: t, callbacks: {} }),
                  (r = i.callbacks[e]) || (r = i.callbacks[e] = []),
                  r.push(n),
                  (function (t, e, n, o, i) {
                    e._addEventListener
                      ? e._addEventListener(n, o, i)
                      : t._addEventListener.call(e, n, o, i);
                  })(this, t, e, n, o);
              }
              stopListening(t, e, n) {
                const o = this[g];
                let i = t && A(t);
                const r = o && i ? o[i] : void 0,
                  s = r && e ? r.callbacks[e] : void 0;
                if (!(!o || (t && !r) || (e && !s)))
                  if (n) {
                    x(this, t, e, n);
                    -1 !== s.indexOf(n) &&
                      (1 === s.length
                        ? delete r.callbacks[e]
                        : x(this, t, e, n));
                  } else if (s) {
                    for (; (n = s.pop()); ) x(this, t, e, n);
                    delete r.callbacks[e];
                  } else if (r) {
                    for (e in r.callbacks) this.stopListening(t, e);
                    delete o[i];
                  } else {
                    for (i in o) this.stopListening(o[i].emitter);
                    delete this[g];
                  }
              }
              fire(t, ...n) {
                try {
                  const o = t instanceof e ? t : new e(this, t),
                    i = o.name;
                  let r = v(this, i);
                  if ((o.path.push(this), r)) {
                    const t = [o, ...n];
                    r = Array.from(r);
                    for (
                      let e = 0;
                      e < r.length &&
                      (r[e].callback.apply(this, t),
                      o.off.called &&
                        (delete o.off.called,
                        this._removeEventListener(i, r[e].callback)),
                      !o.stop.called);
                      e++
                    );
                  }
                  const s = this[f];
                  if (s) {
                    const t = s.get(i),
                      e = s.get("*");
                    t && y(t, o, n), e && y(e, o, n);
                  }
                  return o.return;
                } catch (t) {
                  l.rethrowUnexpectedError(t, this);
                }
              }
              delegate(...t) {
                return {
                  to: (e, n) => {
                    this[f] || (this[f] = new Map()),
                      t.forEach((t) => {
                        const o = this[f].get(t);
                        o ? o.set(e, n) : this[f].set(t, new Map([[e, n]]));
                      });
                  },
                };
              }
              stopDelegating(t, e) {
                if (this[f])
                  if (t)
                    if (e) {
                      const n = this[f].get(t);
                      n && n.delete(e);
                    } else this[f].delete(t);
                  else this[f].clear();
              }
              _addEventListener(t, e, n) {
                !(function (t, e) {
                  const n = _(t);
                  if (n[e]) return;
                  let o = e,
                    i = null;
                  const r = [];
                  for (; "" !== o && !n[o]; )
                    (n[o] = { callbacks: [], childEvents: [] }),
                      r.push(n[o]),
                      i && n[o].childEvents.push(i),
                      (i = o),
                      (o = o.substr(0, o.lastIndexOf(":")));
                  if ("" !== o) {
                    for (const t of r) t.callbacks = n[o].callbacks.slice();
                    n[o].childEvents.push(i);
                  }
                })(this, t);
                const o = C(this, t),
                  i = { callback: e, priority: s.get(n.priority) };
                for (const t of o) a(t, i);
              }
              _removeEventListener(t, e) {
                const n = C(this, t);
                for (const t of n)
                  for (let n = 0; n < t.length; n++)
                    t[n].callback == e && (t.splice(n, 1), n--);
              }
            };
          }
          const b = k(Object);
          function w(t, e) {
            t[p] || (t[p] = e || r());
          }
          function A(t) {
            return t[p];
          }
          function _(t) {
            return (
              t._events || Object.defineProperty(t, "_events", { value: {} }),
              t._events
            );
          }
          function C(t, e) {
            const n = _(t)[e];
            if (!n) return [];
            let o = [n.callbacks];
            for (let e = 0; e < n.childEvents.length; e++) {
              const i = C(t, n.childEvents[e]);
              o = o.concat(i);
            }
            return o;
          }
          function v(t, e) {
            let n;
            return t._events && (n = t._events[e]) && n.callbacks.length
              ? n.callbacks
              : e.indexOf(":") > -1
              ? v(t, e.substr(0, e.lastIndexOf(":")))
              : null;
          }
          function y(t, n, o) {
            for (let [i, r] of t) {
              r ? "function" == typeof r && (r = r(n.name)) : (r = n.name);
              const t = new e(n.source, r);
              (t.path = [...n.path]), i.fire(t, ...o);
            }
          }
          function x(t, e, n, o) {
            e._removeEventListener
              ? e._removeEventListener(n, o)
              : t._removeEventListener.call(e, n, o);
          }
          [
            "on",
            "once",
            "off",
            "listenTo",
            "stopListening",
            "fire",
            "delegate",
            "stopDelegating",
            "_addEventListener",
            "_removeEventListener",
          ].forEach((t) => {
            k[t] = b.prototype[t];
          });
          const E = function (t) {
              var e = typeof t;
              return null != t && ("object" == e || "function" == e);
            },
            D = Symbol("observableProperties"),
            S = Symbol("boundObservables"),
            I = Symbol("boundProperties"),
            T = Symbol("decoratedMethods"),
            M = Symbol("decoratedOriginal");
          function B(t) {
            return class extends t {
              set(t, e) {
                if (E(t))
                  return void Object.keys(t).forEach((e) => {
                    this.set(e, t[e]);
                  }, this);
                z(this);
                const n = this[D];
                if (t in this && !n.has(t))
                  throw new l("observable-set-cannot-override", this);
                Object.defineProperty(this, t, {
                  enumerable: !0,
                  configurable: !0,
                  get: () => n.get(t),
                  set(e) {
                    const o = n.get(t);
                    let i = this.fire(`set:${t}`, t, e, o);
                    void 0 === i && (i = e),
                      (o === i && n.has(t)) ||
                        (n.set(t, i), this.fire(`change:${t}`, t, i, o));
                  },
                }),
                  (this[t] = e);
              }
              bind(...t) {
                if (!t.length || !R(t))
                  throw new l("observable-bind-wrong-properties", this);
                if (new Set(t).size !== t.length)
                  throw new l("observable-bind-duplicate-properties", this);
                z(this);
                const e = this[I];
                t.forEach((t) => {
                  if (e.has(t)) throw new l("observable-bind-rebind", this);
                });
                const n = new Map();
                return (
                  t.forEach((t) => {
                    const o = { property: t, to: [] };
                    e.set(t, o), n.set(t, o);
                  }),
                  {
                    to: P,
                    toMany: L,
                    _observable: this,
                    _bindProperties: t,
                    _to: [],
                    _bindings: n,
                  }
                );
              }
              unbind(...t) {
                if (!this[D]) return;
                const e = this[I],
                  n = this[S];
                if (t.length) {
                  if (!R(t))
                    throw new l("observable-unbind-wrong-properties", this);
                  t.forEach((t) => {
                    const o = e.get(t);
                    o &&
                      (o.to.forEach(([t, e]) => {
                        const i = n.get(t),
                          r = i[e];
                        r.delete(o),
                          r.size || delete i[e],
                          Object.keys(i).length ||
                            (n.delete(t), this.stopListening(t, "change"));
                      }),
                      e.delete(t));
                  });
                } else
                  n.forEach((t, e) => {
                    this.stopListening(e, "change");
                  }),
                    n.clear(),
                    e.clear();
              }
              decorate(t) {
                z(this);
                const e = this[t];
                if (!e)
                  throw new l(
                    "observablemixin-cannot-decorate-undefined",
                    this,
                    { object: this, methodName: t }
                  );
                this.on(t, (t, n) => {
                  t.return = e.apply(this, n);
                }),
                  (this[t] = function (...e) {
                    return this.fire(t, e);
                  }),
                  (this[t][M] = e),
                  this[T] || (this[T] = []),
                  this[T].push(t);
              }
              stopListening(t, e, n) {
                if (!t && this[T]) {
                  for (const t of this[T]) this[t] = this[t][M];
                  delete this[T];
                }
                b.prototype.stopListening.call(this, t, e, n);
              }
            };
          }
          const N = B(b);
          function z(t) {
            t[D] ||
              (Object.defineProperty(t, D, { value: new Map() }),
              Object.defineProperty(t, S, { value: new Map() }),
              Object.defineProperty(t, I, { value: new Map() }));
          }
          function P(...t) {
            const e = (function (...t) {
                if (!t.length)
                  throw new l("observable-bind-to-parse-error", null);
                const e = { to: [] };
                let n;
                "function" == typeof t[t.length - 1] && (e.callback = t.pop());
                return (
                  t.forEach((t) => {
                    if ("string" == typeof t) n.properties.push(t);
                    else {
                      if ("object" != typeof t)
                        throw new l("observable-bind-to-parse-error", null);
                      (n = { observable: t, properties: [] }), e.to.push(n);
                    }
                  }),
                  e
                );
              })(...t),
              n = Array.from(this._bindings.keys()),
              o = n.length;
            if (!e.callback && e.to.length > 1)
              throw new l("observable-bind-to-no-callback", this);
            if (o > 1 && e.callback)
              throw new l("observable-bind-to-extra-callback", this);
            var i;
            e.to.forEach((t) => {
              if (t.properties.length && t.properties.length !== o)
                throw new l("observable-bind-to-properties-length", this);
              t.properties.length || (t.properties = this._bindProperties);
            }),
              (this._to = e.to),
              e.callback && (this._bindings.get(n[0]).callback = e.callback),
              (i = this._observable),
              this._to.forEach((t) => {
                const e = i[S];
                let n;
                e.get(t.observable) ||
                  i.listenTo(t.observable, "change", (o, r) => {
                    (n = e.get(t.observable)[r]),
                      n &&
                        n.forEach((t) => {
                          O(i, t.property);
                        });
                  });
              }),
              (function (t) {
                let e;
                t._bindings.forEach((n, o) => {
                  t._to.forEach((i) => {
                    (e =
                      i.properties[
                        n.callback ? 0 : t._bindProperties.indexOf(o)
                      ]),
                      n.to.push([i.observable, e]),
                      (function (t, e, n, o) {
                        const i = t[S],
                          r = i.get(n),
                          s = r || {};
                        s[o] || (s[o] = new Set());
                        s[o].add(e), r || i.set(n, s);
                      })(t._observable, n, i.observable, e);
                  });
                });
              })(this),
              this._bindProperties.forEach((t) => {
                O(this._observable, t);
              });
          }
          function L(t, e, n) {
            if (this._bindings.size > 1)
              throw new l("observable-bind-to-many-not-one-binding", this);
            this.to(
              ...(function (t, e) {
                const n = t.map((t) => [t, e]);
                return Array.prototype.concat.apply([], n);
              })(t, e),
              n
            );
          }
          function R(t) {
            return t.every((t) => "string" == typeof t);
          }
          function O(t, e) {
            const n = t[I].get(e);
            let o;
            n.callback
              ? (o = n.callback.apply(
                  t,
                  n.to.map((t) => t[0][t[1]])
                ))
              : ((o = n.to[0]), (o = o[0][o[1]])),
              Object.prototype.hasOwnProperty.call(t, e)
                ? (t[e] = o)
                : t.set(e, o);
          }
          [
            "set",
            "bind",
            "unbind",
            "decorate",
            "on",
            "once",
            "off",
            "listenTo",
            "stopListening",
            "fire",
            "delegate",
            "stopDelegating",
            "_addEventListener",
            "_removeEventListener",
          ].forEach((t) => {
            B[t] = N.prototype[t];
          });
          class j extends N {
            constructor(t) {
              super(),
                (this.editor = t),
                this.set("isEnabled", !0),
                (this._disableStack = new Set());
            }
            forceDisabled(t) {
              this._disableStack.add(t),
                1 == this._disableStack.size &&
                  (this.on("set:isEnabled", V, { priority: "highest" }),
                  (this.isEnabled = !1));
            }
            clearForceDisabled(t) {
              this._disableStack.delete(t),
                0 == this._disableStack.size &&
                  (this.off("set:isEnabled", V), (this.isEnabled = !0));
            }
            destroy() {
              this.stopListening();
            }
            static get isContextPlugin() {
              return !1;
            }
          }
          function V(t) {
            (t.return = !1), t.stop();
          }
          class F extends N {
            constructor(t) {
              super(),
                (this.editor = t),
                this.set("value", void 0),
                this.set("isEnabled", !1),
                (this._affectsData = !0),
                (this._disableStack = new Set()),
                this.decorate("execute"),
                this.listenTo(this.editor.model.document, "change", () => {
                  this.refresh();
                }),
                this.on(
                  "execute",
                  (t) => {
                    this.isEnabled || t.stop();
                  },
                  { priority: "high" }
                ),
                this.listenTo(t, "change:isReadOnly", (t, e, n) => {
                  n && this.affectsData
                    ? this.forceDisabled("readOnlyMode")
                    : this.clearForceDisabled("readOnlyMode");
                });
            }
            get affectsData() {
              return this._affectsData;
            }
            set affectsData(t) {
              this._affectsData = t;
            }
            refresh() {
              this.isEnabled = !0;
            }
            forceDisabled(t) {
              this._disableStack.add(t),
                1 == this._disableStack.size &&
                  (this.on("set:isEnabled", H, { priority: "highest" }),
                  (this.isEnabled = !1));
            }
            clearForceDisabled(t) {
              this._disableStack.delete(t),
                0 == this._disableStack.size &&
                  (this.off("set:isEnabled", H), this.refresh());
            }
            execute(...t) {}
            destroy() {
              this.stopListening();
            }
          }
          function H(t) {
            (t.return = !1), t.stop();
          }
          class U extends F {
            constructor(t) {
              super(t), (this._childCommandsDefinitions = []);
            }
            refresh() {}
            execute(...t) {
              const e = this._getFirstEnabledCommand();
              return !!e && e.execute(t);
            }
            registerChildCommand(t, e = {}) {
              a(this._childCommandsDefinitions, {
                command: t,
                priority: e.priority || "normal",
              }),
                t.on("change:isEnabled", () => this._checkEnabled()),
                this._checkEnabled();
            }
            _checkEnabled() {
              this.isEnabled = !!this._getFirstEnabledCommand();
            }
            _getFirstEnabledCommand() {
              const t = this._childCommandsDefinitions.find(
                ({ command: t }) => t.isEnabled
              );
              return t && t.command;
            }
          }
          const W =
            "object" == typeof global &&
            global &&
            global.Object === Object &&
            global;
          var $ =
            "object" == typeof self && self && self.Object === Object && self;
          const q = W || $ || Function("return this")();
          const G = q.Symbol;
          var Z = Object.prototype,
            Y = Z.hasOwnProperty,
            K = Z.toString,
            Q = G ? G.toStringTag : void 0;
          const J = function (t) {
            var e = Y.call(t, Q),
              n = t[Q];
            try {
              t[Q] = void 0;
              var o = !0;
            } catch (t) {}
            var i = K.call(t);
            return o && (e ? (t[Q] = n) : delete t[Q]), i;
          };
          var X = Object.prototype.toString;
          const tt = function (t) {
            return X.call(t);
          };
          var et = G ? G.toStringTag : void 0;
          const nt = function (t) {
            return null == t
              ? void 0 === t
                ? "[object Undefined]"
                : "[object Null]"
              : et && et in Object(t)
              ? J(t)
              : tt(t);
          };
          const ot = function (t, e) {
            return function (n) {
              return t(e(n));
            };
          };
          const it = ot(Object.getPrototypeOf, Object);
          const rt = function (t) {
            return null != t && "object" == typeof t;
          };
          var st = Function.prototype,
            at = Object.prototype,
            lt = st.toString,
            ct = at.hasOwnProperty,
            dt = lt.call(Object);
          const ut = function (t) {
            if (!rt(t) || "[object Object]" != nt(t)) return !1;
            var e = it(t);
            if (null === e) return !0;
            var n = ct.call(e, "constructor") && e.constructor;
            return "function" == typeof n && n instanceof n && lt.call(n) == dt;
          };
          const ht = function () {
            (this.__data__ = []), (this.size = 0);
          };
          const mt = function (t, e) {
            return t === e || (t != t && e != e);
          };
          const gt = function (t, e) {
            for (var n = t.length; n--; ) if (mt(t[n][0], e)) return n;
            return -1;
          };
          var pt = Array.prototype.splice;
          const ft = function (t) {
            var e = this.__data__,
              n = gt(e, t);
            return (
              !(n < 0) &&
              (n == e.length - 1 ? e.pop() : pt.call(e, n, 1), --this.size, !0)
            );
          };
          const kt = function (t) {
            var e = this.__data__,
              n = gt(e, t);
            return n < 0 ? void 0 : e[n][1];
          };
          const bt = function (t) {
            return gt(this.__data__, t) > -1;
          };
          const wt = function (t, e) {
            var n = this.__data__,
              o = gt(n, t);
            return o < 0 ? (++this.size, n.push([t, e])) : (n[o][1] = e), this;
          };
          function At(t) {
            var e = -1,
              n = null == t ? 0 : t.length;
            for (this.clear(); ++e < n; ) {
              var o = t[e];
              this.set(o[0], o[1]);
            }
          }
          (At.prototype.clear = ht),
            (At.prototype.delete = ft),
            (At.prototype.get = kt),
            (At.prototype.has = bt),
            (At.prototype.set = wt);
          const _t = At;
          const Ct = function () {
            (this.__data__ = new _t()), (this.size = 0);
          };
          const vt = function (t) {
            var e = this.__data__,
              n = e.delete(t);
            return (this.size = e.size), n;
          };
          const yt = function (t) {
            return this.__data__.get(t);
          };
          const xt = function (t) {
            return this.__data__.has(t);
          };
          const Et = function (t) {
            if (!E(t)) return !1;
            var e = nt(t);
            return (
              "[object Function]" == e ||
              "[object GeneratorFunction]" == e ||
              "[object AsyncFunction]" == e ||
              "[object Proxy]" == e
            );
          };
          const Dt = q["__core-js_shared__"];
          var St = (function () {
            var t = /[^.]+$/.exec((Dt && Dt.keys && Dt.keys.IE_PROTO) || "");
            return t ? "Symbol(src)_1." + t : "";
          })();
          const It = function (t) {
            return !!St && St in t;
          };
          var Tt = Function.prototype.toString;
          const Mt = function (t) {
            if (null != t) {
              try {
                return Tt.call(t);
              } catch (t) {}
              try {
                return t + "";
              } catch (t) {}
            }
            return "";
          };
          var Bt = /^\[object .+?Constructor\]$/,
            Nt = Function.prototype,
            zt = Object.prototype,
            Pt = Nt.toString,
            Lt = zt.hasOwnProperty,
            Rt = RegExp(
              "^" +
                Pt.call(Lt)
                  .replace(/[\\^$.*+?()[\]{}|]/g, "\\$&")
                  .replace(
                    /hasOwnProperty|(function).*?(?=\\\()| for .+?(?=\\\])/g,
                    "$1.*?"
                  ) +
                "$"
            );
          const Ot = function (t) {
            return !(!E(t) || It(t)) && (Et(t) ? Rt : Bt).test(Mt(t));
          };
          const jt = function (t, e) {
            return null == t ? void 0 : t[e];
          };
          const Vt = function (t, e) {
            var n = jt(t, e);
            return Ot(n) ? n : void 0;
          };
          const Ft = Vt(q, "Map");
          const Ht = Vt(Object, "create");
          const Ut = function () {
            (this.__data__ = Ht ? Ht(null) : {}), (this.size = 0);
          };
          const Wt = function (t) {
            var e = this.has(t) && delete this.__data__[t];
            return (this.size -= e ? 1 : 0), e;
          };
          var $t = Object.prototype.hasOwnProperty;
          const qt = function (t) {
            var e = this.__data__;
            if (Ht) {
              var n = e[t];
              return "__lodash_hash_undefined__" === n ? void 0 : n;
            }
            return $t.call(e, t) ? e[t] : void 0;
          };
          var Gt = Object.prototype.hasOwnProperty;
          const Zt = function (t) {
            var e = this.__data__;
            return Ht ? void 0 !== e[t] : Gt.call(e, t);
          };
          const Yt = function (t, e) {
            var n = this.__data__;
            return (
              (this.size += this.has(t) ? 0 : 1),
              (n[t] = Ht && void 0 === e ? "__lodash_hash_undefined__" : e),
              this
            );
          };
          function Kt(t) {
            var e = -1,
              n = null == t ? 0 : t.length;
            for (this.clear(); ++e < n; ) {
              var o = t[e];
              this.set(o[0], o[1]);
            }
          }
          (Kt.prototype.clear = Ut),
            (Kt.prototype.delete = Wt),
            (Kt.prototype.get = qt),
            (Kt.prototype.has = Zt),
            (Kt.prototype.set = Yt);
          const Qt = Kt;
          const Jt = function () {
            (this.size = 0),
              (this.__data__ = {
                hash: new Qt(),
                map: new (Ft || _t)(),
                string: new Qt(),
              });
          };
          const Xt = function (t) {
            var e = typeof t;
            return "string" == e ||
              "number" == e ||
              "symbol" == e ||
              "boolean" == e
              ? "__proto__" !== t
              : null === t;
          };
          const te = function (t, e) {
            var n = t.__data__;
            return Xt(e) ? n["string" == typeof e ? "string" : "hash"] : n.map;
          };
          const ee = function (t) {
            var e = te(this, t).delete(t);
            return (this.size -= e ? 1 : 0), e;
          };
          const ne = function (t) {
            return te(this, t).get(t);
          };
          const oe = function (t) {
            return te(this, t).has(t);
          };
          const ie = function (t, e) {
            var n = te(this, t),
              o = n.size;
            return n.set(t, e), (this.size += n.size == o ? 0 : 1), this;
          };
          function re(t) {
            var e = -1,
              n = null == t ? 0 : t.length;
            for (this.clear(); ++e < n; ) {
              var o = t[e];
              this.set(o[0], o[1]);
            }
          }
          (re.prototype.clear = Jt),
            (re.prototype.delete = ee),
            (re.prototype.get = ne),
            (re.prototype.has = oe),
            (re.prototype.set = ie);
          const se = re;
          const ae = function (t, e) {
            var n = this.__data__;
            if (n instanceof _t) {
              var o = n.__data__;
              if (!Ft || o.length < 199)
                return o.push([t, e]), (this.size = ++n.size), this;
              n = this.__data__ = new se(o);
            }
            return n.set(t, e), (this.size = n.size), this;
          };
          function le(t) {
            var e = (this.__data__ = new _t(t));
            this.size = e.size;
          }
          (le.prototype.clear = Ct),
            (le.prototype.delete = vt),
            (le.prototype.get = yt),
            (le.prototype.has = xt),
            (le.prototype.set = ae);
          const ce = le;
          const de = function (t, e) {
            for (
              var n = -1, o = null == t ? 0 : t.length;
              ++n < o && !1 !== e(t[n], n, t);

            );
            return t;
          };
          const ue = (function () {
            try {
              var t = Vt(Object, "defineProperty");
              return t({}, "", {}), t;
            } catch (t) {}
          })();
          const he = function (t, e, n) {
            "__proto__" == e && ue
              ? ue(t, e, {
                  configurable: !0,
                  enumerable: !0,
                  value: n,
                  writable: !0,
                })
              : (t[e] = n);
          };
          var me = Object.prototype.hasOwnProperty;
          const ge = function (t, e, n) {
            var o = t[e];
            (me.call(t, e) && mt(o, n) && (void 0 !== n || e in t)) ||
              he(t, e, n);
          };
          const pe = function (t, e, n, o) {
            var i = !n;
            n || (n = {});
            for (var r = -1, s = e.length; ++r < s; ) {
              var a = e[r],
                l = o ? o(n[a], t[a], a, n, t) : void 0;
              void 0 === l && (l = t[a]), i ? he(n, a, l) : ge(n, a, l);
            }
            return n;
          };
          const fe = function (t, e) {
            for (var n = -1, o = Array(t); ++n < t; ) o[n] = e(n);
            return o;
          };
          const ke = function (t) {
            return rt(t) && "[object Arguments]" == nt(t);
          };
          var be = Object.prototype,
            we = be.hasOwnProperty,
            Ae = be.propertyIsEnumerable;
          const _e = ke(
            (function () {
              return arguments;
            })()
          )
            ? ke
            : function (t) {
                return rt(t) && we.call(t, "callee") && !Ae.call(t, "callee");
              };
          const Ce = Array.isArray;
          const ve = function () {
            return !1;
          };
          var ye =
              "object" == typeof exports &&
              exports &&
              !exports.nodeType &&
              exports,
            xe =
              ye &&
              "object" == typeof module &&
              module &&
              !module.nodeType &&
              module,
            Ee = xe && xe.exports === ye ? q.Buffer : void 0;
          const De = (Ee ? Ee.isBuffer : void 0) || ve;
          var Se = /^(?:0|[1-9]\d*)$/;
          const Ie = function (t, e) {
            var n = typeof t;
            return (
              !!(e = null == e ? 9007199254740991 : e) &&
              ("number" == n || ("symbol" != n && Se.test(t))) &&
              t > -1 &&
              t % 1 == 0 &&
              t < e
            );
          };
          const Te = function (t) {
            return (
              "number" == typeof t &&
              t > -1 &&
              t % 1 == 0 &&
              t <= 9007199254740991
            );
          };
          var Me = {};
          (Me["[object Float32Array]"] =
            Me["[object Float64Array]"] =
            Me["[object Int8Array]"] =
            Me["[object Int16Array]"] =
            Me["[object Int32Array]"] =
            Me["[object Uint8Array]"] =
            Me["[object Uint8ClampedArray]"] =
            Me["[object Uint16Array]"] =
            Me["[object Uint32Array]"] =
              !0),
            (Me["[object Arguments]"] =
              Me["[object Array]"] =
              Me["[object ArrayBuffer]"] =
              Me["[object Boolean]"] =
              Me["[object DataView]"] =
              Me["[object Date]"] =
              Me["[object Error]"] =
              Me["[object Function]"] =
              Me["[object Map]"] =
              Me["[object Number]"] =
              Me["[object Object]"] =
              Me["[object RegExp]"] =
              Me["[object Set]"] =
              Me["[object String]"] =
              Me["[object WeakMap]"] =
                !1);
          const Be = function (t) {
            return rt(t) && Te(t.length) && !!Me[nt(t)];
          };
          const Ne = function (t) {
            return function (e) {
              return t(e);
            };
          };
          var ze =
              "object" == typeof exports &&
              exports &&
              !exports.nodeType &&
              exports,
            Pe =
              ze &&
              "object" == typeof module &&
              module &&
              !module.nodeType &&
              module,
            Le = Pe && Pe.exports === ze && W.process;
          const Re = (function () {
            try {
              var t = Pe && Pe.require && Pe.require("util").types;
              return t || (Le && Le.binding && Le.binding("util"));
            } catch (t) {}
          })();
          var Oe = Re && Re.isTypedArray;
          const je = Oe ? Ne(Oe) : Be;
          var Ve = Object.prototype.hasOwnProperty;
          const Fe = function (t, e) {
            var n = Ce(t),
              o = !n && _e(t),
              i = !n && !o && De(t),
              r = !n && !o && !i && je(t),
              s = n || o || i || r,
              a = s ? fe(t.length, String) : [],
              l = a.length;
            for (var c in t)
              (!e && !Ve.call(t, c)) ||
                (s &&
                  ("length" == c ||
                    (i && ("offset" == c || "parent" == c)) ||
                    (r &&
                      ("buffer" == c ||
                        "byteLength" == c ||
                        "byteOffset" == c)) ||
                    Ie(c, l))) ||
                a.push(c);
            return a;
          };
          var He = Object.prototype;
          const Ue = function (t) {
            var e = t && t.constructor;
            return t === (("function" == typeof e && e.prototype) || He);
          };
          const We = ot(Object.keys, Object);
          var $e = Object.prototype.hasOwnProperty;
          const qe = function (t) {
            if (!Ue(t)) return We(t);
            var e = [];
            for (var n in Object(t))
              $e.call(t, n) && "constructor" != n && e.push(n);
            return e;
          };
          const Ge = function (t) {
            return null != t && Te(t.length) && !Et(t);
          };
          const Ze = function (t) {
            return Ge(t) ? Fe(t) : qe(t);
          };
          const Ye = function (t, e) {
            return t && pe(e, Ze(e), t);
          };
          const Ke = function (t) {
            var e = [];
            if (null != t) for (var n in Object(t)) e.push(n);
            return e;
          };
          var Qe = Object.prototype.hasOwnProperty;
          const Je = function (t) {
            if (!E(t)) return Ke(t);
            var e = Ue(t),
              n = [];
            for (var o in t)
              ("constructor" != o || (!e && Qe.call(t, o))) && n.push(o);
            return n;
          };
          const Xe = function (t) {
            return Ge(t) ? Fe(t, !0) : Je(t);
          };
          const tn = function (t, e) {
            return t && pe(e, Xe(e), t);
          };
          var en =
              "object" == typeof exports &&
              exports &&
              !exports.nodeType &&
              exports,
            nn =
              en &&
              "object" == typeof module &&
              module &&
              !module.nodeType &&
              module,
            on = nn && nn.exports === en ? q.Buffer : void 0,
            rn = on ? on.allocUnsafe : void 0;
          const sn = function (t, e) {
            if (e) return t.slice();
            var n = t.length,
              o = rn ? rn(n) : new t.constructor(n);
            return t.copy(o), o;
          };
          const an = function (t, e) {
            var n = -1,
              o = t.length;
            for (e || (e = Array(o)); ++n < o; ) e[n] = t[n];
            return e;
          };
          const ln = function (t, e) {
            for (
              var n = -1, o = null == t ? 0 : t.length, i = 0, r = [];
              ++n < o;

            ) {
              var s = t[n];
              e(s, n, t) && (r[i++] = s);
            }
            return r;
          };
          const cn = function () {
            return [];
          };
          var dn = Object.prototype.propertyIsEnumerable,
            un = Object.getOwnPropertySymbols;
          const hn = un
            ? function (t) {
                return null == t
                  ? []
                  : ((t = Object(t)),
                    ln(un(t), function (e) {
                      return dn.call(t, e);
                    }));
              }
            : cn;
          const mn = function (t, e) {
            return pe(t, hn(t), e);
          };
          const gn = function (t, e) {
            for (var n = -1, o = e.length, i = t.length; ++n < o; )
              t[i + n] = e[n];
            return t;
          };
          const pn = Object.getOwnPropertySymbols
            ? function (t) {
                for (var e = []; t; ) gn(e, hn(t)), (t = it(t));
                return e;
              }
            : cn;
          const fn = function (t, e) {
            return pe(t, pn(t), e);
          };
          const kn = function (t, e, n) {
            var o = e(t);
            return Ce(t) ? o : gn(o, n(t));
          };
          const bn = function (t) {
            return kn(t, Ze, hn);
          };
          const wn = function (t) {
            return kn(t, Xe, pn);
          };
          const An = Vt(q, "DataView");
          const _n = Vt(q, "Promise");
          const Cn = Vt(q, "Set");
          const vn = Vt(q, "WeakMap");
          var yn = "[object Map]",
            xn = "[object Promise]",
            En = "[object Set]",
            Dn = "[object WeakMap]",
            Sn = "[object DataView]",
            In = Mt(An),
            Tn = Mt(Ft),
            Mn = Mt(_n),
            Bn = Mt(Cn),
            Nn = Mt(vn),
            zn = nt;
          ((An && zn(new An(new ArrayBuffer(1))) != Sn) ||
            (Ft && zn(new Ft()) != yn) ||
            (_n && zn(_n.resolve()) != xn) ||
            (Cn && zn(new Cn()) != En) ||
            (vn && zn(new vn()) != Dn)) &&
            (zn = function (t) {
              var e = nt(t),
                n = "[object Object]" == e ? t.constructor : void 0,
                o = n ? Mt(n) : "";
              if (o)
                switch (o) {
                  case In:
                    return Sn;
                  case Tn:
                    return yn;
                  case Mn:
                    return xn;
                  case Bn:
                    return En;
                  case Nn:
                    return Dn;
                }
              return e;
            });
          const Pn = zn;
          var Ln = Object.prototype.hasOwnProperty;
          const Rn = function (t) {
            var e = t.length,
              n = new t.constructor(e);
            return (
              e &&
                "string" == typeof t[0] &&
                Ln.call(t, "index") &&
                ((n.index = t.index), (n.input = t.input)),
              n
            );
          };
          const On = q.Uint8Array;
          const jn = function (t) {
            var e = new t.constructor(t.byteLength);
            return new On(e).set(new On(t)), e;
          };
          const Vn = function (t, e) {
            var n = e ? jn(t.buffer) : t.buffer;
            return new t.constructor(n, t.byteOffset, t.byteLength);
          };
          var Fn = /\w*$/;
          const Hn = function (t) {
            var e = new t.constructor(t.source, Fn.exec(t));
            return (e.lastIndex = t.lastIndex), e;
          };
          var Un = G ? G.prototype : void 0,
            Wn = Un ? Un.valueOf : void 0;
          const $n = function (t) {
            return Wn ? Object(Wn.call(t)) : {};
          };
          const qn = function (t, e) {
            var n = e ? jn(t.buffer) : t.buffer;
            return new t.constructor(n, t.byteOffset, t.length);
          };
          const Gn = function (t, e, n) {
            var o = t.constructor;
            switch (e) {
              case "[object ArrayBuffer]":
                return jn(t);
              case "[object Boolean]":
              case "[object Date]":
                return new o(+t);
              case "[object DataView]":
                return Vn(t, n);
              case "[object Float32Array]":
              case "[object Float64Array]":
              case "[object Int8Array]":
              case "[object Int16Array]":
              case "[object Int32Array]":
              case "[object Uint8Array]":
              case "[object Uint8ClampedArray]":
              case "[object Uint16Array]":
              case "[object Uint32Array]":
                return qn(t, n);
              case "[object Map]":
              case "[object Set]":
                return new o();
              case "[object Number]":
              case "[object String]":
                return new o(t);
              case "[object RegExp]":
                return Hn(t);
              case "[object Symbol]":
                return $n(t);
            }
          };
          var Zn = Object.create;
          const Yn = (function () {
            function t() {}
            return function (e) {
              if (!E(e)) return {};
              if (Zn) return Zn(e);
              t.prototype = e;
              var n = new t();
              return (t.prototype = void 0), n;
            };
          })();
          const Kn = function (t) {
            return "function" != typeof t.constructor || Ue(t) ? {} : Yn(it(t));
          };
          const Qn = function (t) {
            return rt(t) && "[object Map]" == Pn(t);
          };
          var Jn = Re && Re.isMap;
          const Xn = Jn ? Ne(Jn) : Qn;
          const to = function (t) {
            return rt(t) && "[object Set]" == Pn(t);
          };
          var eo = Re && Re.isSet;
          const no = eo ? Ne(eo) : to;
          var oo = "[object Arguments]",
            io = "[object Function]",
            ro = "[object Object]",
            so = {};
          (so[oo] =
            so["[object Array]"] =
            so["[object ArrayBuffer]"] =
            so["[object DataView]"] =
            so["[object Boolean]"] =
            so["[object Date]"] =
            so["[object Float32Array]"] =
            so["[object Float64Array]"] =
            so["[object Int8Array]"] =
            so["[object Int16Array]"] =
            so["[object Int32Array]"] =
            so["[object Map]"] =
            so["[object Number]"] =
            so["[object Object]"] =
            so["[object RegExp]"] =
            so["[object Set]"] =
            so["[object String]"] =
            so["[object Symbol]"] =
            so["[object Uint8Array]"] =
            so["[object Uint8ClampedArray]"] =
            so["[object Uint16Array]"] =
            so["[object Uint32Array]"] =
              !0),
            (so["[object Error]"] = so[io] = so["[object WeakMap]"] = !1);
          const ao = function t(e, n, o, i, r, s) {
            var a,
              l = 1 & n,
              c = 2 & n,
              d = 4 & n;
            if ((o && (a = r ? o(e, i, r, s) : o(e)), void 0 !== a)) return a;
            if (!E(e)) return e;
            var u = Ce(e);
            if (u) {
              if (((a = Rn(e)), !l)) return an(e, a);
            } else {
              var h = Pn(e),
                m = h == io || "[object GeneratorFunction]" == h;
              if (De(e)) return sn(e, l);
              if (h == ro || h == oo || (m && !r)) {
                if (((a = c || m ? {} : Kn(e)), !l))
                  return c ? fn(e, tn(a, e)) : mn(e, Ye(a, e));
              } else {
                if (!so[h]) return r ? e : {};
                a = Gn(e, h, l);
              }
            }
            s || (s = new ce());
            var g = s.get(e);
            if (g) return g;
            s.set(e, a),
              no(e)
                ? e.forEach(function (i) {
                    a.add(t(i, n, o, i, e, s));
                  })
                : Xn(e) &&
                  e.forEach(function (i, r) {
                    a.set(r, t(i, n, o, r, e, s));
                  });
            var p = u ? void 0 : (d ? (c ? wn : bn) : c ? Xe : Ze)(e);
            return (
              de(p || e, function (i, r) {
                p && (i = e[(r = i)]), ge(a, r, t(i, n, o, r, e, s));
              }),
              a
            );
          };
          const lo = function (t, e) {
            return ao(t, 5, (e = "function" == typeof e ? e : void 0));
          };
          const co = function (t) {
            return rt(t) && 1 === t.nodeType && !ut(t);
          };
          class uo {
            constructor(t, e) {
              (this._config = {}),
                e && this.define(ho(e)),
                t && this._setObjectToTarget(this._config, t);
            }
            set(t, e) {
              this._setToTarget(this._config, t, e);
            }
            define(t, e) {
              this._setToTarget(this._config, t, e, !0);
            }
            get(t) {
              return this._getFromSource(this._config, t);
            }
            *names() {
              for (const t of Object.keys(this._config)) yield t;
            }
            _setToTarget(t, e, n, o = !1) {
              if (ut(e)) return void this._setObjectToTarget(t, e, o);
              const i = e.split(".");
              e = i.pop();
              for (const e of i) ut(t[e]) || (t[e] = {}), (t = t[e]);
              if (ut(n))
                return (
                  ut(t[e]) || (t[e] = {}),
                  (t = t[e]),
                  void this._setObjectToTarget(t, n, o)
                );
              (o && void 0 !== t[e]) || (t[e] = n);
            }
            _getFromSource(t, e) {
              const n = e.split(".");
              e = n.pop();
              for (const e of n) {
                if (!ut(t[e])) {
                  t = null;
                  break;
                }
                t = t[e];
              }
              return t ? ho(t[e]) : void 0;
            }
            _setObjectToTarget(t, e, n) {
              Object.keys(e).forEach((o) => {
                this._setToTarget(t, o, e[o], n);
              });
            }
          }
          function ho(t) {
            return lo(t, mo);
          }
          function mo(t) {
            return co(t) ? t : void 0;
          }
          function go(t) {
            return !(!t || !t[Symbol.iterator]);
          }
          class po extends b {
            constructor(t = {}, e = {}) {
              super();
              const n = go(t);
              if (
                (n || (e = t),
                (this._items = []),
                (this._itemMap = new Map()),
                (this._idProperty = e.idProperty || "id"),
                (this._bindToExternalToInternalMap = new WeakMap()),
                (this._bindToInternalToExternalMap = new WeakMap()),
                (this._skippedIndexesFromExternal = []),
                n)
              )
                for (const e of t)
                  this._items.push(e),
                    this._itemMap.set(this._getItemIdBeforeAdding(e), e);
            }
            get length() {
              return this._items.length;
            }
            get first() {
              return this._items[0] || null;
            }
            get last() {
              return this._items[this.length - 1] || null;
            }
            add(t, e) {
              return this.addMany([t], e);
            }
            addMany(t, e) {
              if (void 0 === e) e = this._items.length;
              else if (e > this._items.length || e < 0)
                throw new l("collection-add-item-invalid-index", this);
              let n = 0;
              for (const o of t) {
                const t = this._getItemIdBeforeAdding(o),
                  i = e + n;
                this._items.splice(i, 0, o),
                  this._itemMap.set(t, o),
                  this.fire("add", o, i),
                  n++;
              }
              return (
                this.fire("change", { added: t, removed: [], index: e }), this
              );
            }
            get(t) {
              let e;
              if ("string" == typeof t) e = this._itemMap.get(t);
              else {
                if ("number" != typeof t)
                  throw new l("collection-get-invalid-arg", this);
                e = this._items[t];
              }
              return e || null;
            }
            has(t) {
              if ("string" == typeof t) return this._itemMap.has(t);
              {
                const e = t[this._idProperty];
                return e && this._itemMap.has(e);
              }
            }
            getIndex(t) {
              let e;
              return (
                (e = "string" == typeof t ? this._itemMap.get(t) : t),
                e ? this._items.indexOf(e) : -1
              );
            }
            remove(t) {
              const [e, n] = this._remove(t);
              return (
                this.fire("change", { added: [], removed: [e], index: n }), e
              );
            }
            map(t, e) {
              return this._items.map(t, e);
            }
            find(t, e) {
              return this._items.find(t, e);
            }
            filter(t, e) {
              return this._items.filter(t, e);
            }
            clear() {
              this._bindToCollection &&
                (this.stopListening(this._bindToCollection),
                (this._bindToCollection = null));
              const t = Array.from(this._items);
              for (; this.length; ) this._remove(0);
              this.fire("change", { added: [], removed: t, index: 0 });
            }
            bindTo(t) {
              if (this._bindToCollection)
                throw new l("collection-bind-to-rebind", this);
              return (
                (this._bindToCollection = t),
                {
                  as: (t) => {
                    this._setUpBindToBinding((e) => new t(e));
                  },
                  using: (t) => {
                    "function" == typeof t
                      ? this._setUpBindToBinding(t)
                      : this._setUpBindToBinding((e) => e[t]);
                  },
                }
              );
            }
            _setUpBindToBinding(t) {
              const e = this._bindToCollection,
                n = (n, o, i) => {
                  const r = e._bindToCollection == this,
                    s = e._bindToInternalToExternalMap.get(o);
                  if (r && s)
                    this._bindToExternalToInternalMap.set(o, s),
                      this._bindToInternalToExternalMap.set(s, o);
                  else {
                    const n = t(o);
                    if (!n)
                      return void this._skippedIndexesFromExternal.push(i);
                    let r = i;
                    for (const t of this._skippedIndexesFromExternal)
                      i > t && r--;
                    for (const t of e._skippedIndexesFromExternal)
                      r >= t && r++;
                    this._bindToExternalToInternalMap.set(o, n),
                      this._bindToInternalToExternalMap.set(n, o),
                      this.add(n, r);
                    for (
                      let t = 0;
                      t < e._skippedIndexesFromExternal.length;
                      t++
                    )
                      r <= e._skippedIndexesFromExternal[t] &&
                        e._skippedIndexesFromExternal[t]++;
                  }
                };
              for (const t of e) n(0, t, e.getIndex(t));
              this.listenTo(e, "add", n),
                this.listenTo(e, "remove", (t, e, n) => {
                  const o = this._bindToExternalToInternalMap.get(e);
                  o && this.remove(o),
                    (this._skippedIndexesFromExternal =
                      this._skippedIndexesFromExternal.reduce(
                        (t, e) => (
                          n < e && t.push(e - 1), n > e && t.push(e), t
                        ),
                        []
                      ));
                });
            }
            _getItemIdBeforeAdding(t) {
              const e = this._idProperty;
              let n;
              if (e in t) {
                if (((n = t[e]), "string" != typeof n))
                  throw new l("collection-add-invalid-id", this);
                if (this.get(n))
                  throw new l("collection-add-item-already-exists", this);
              } else t[e] = n = r();
              return n;
            }
            _remove(t) {
              let e,
                n,
                o,
                i = !1;
              const r = this._idProperty;
              if (
                ("string" == typeof t
                  ? ((n = t),
                    (o = this._itemMap.get(n)),
                    (i = !o),
                    o && (e = this._items.indexOf(o)))
                  : "number" == typeof t
                  ? ((e = t), (o = this._items[e]), (i = !o), o && (n = o[r]))
                  : ((o = t),
                    (n = o[r]),
                    (e = this._items.indexOf(o)),
                    (i = -1 == e || !this._itemMap.get(n))),
                i)
              )
                throw new l("collection-remove-404", this);
              this._items.splice(e, 1), this._itemMap.delete(n);
              const s = this._bindToInternalToExternalMap.get(o);
              return (
                this._bindToInternalToExternalMap.delete(o),
                this._bindToExternalToInternalMap.delete(s),
                this.fire("remove", o, e),
                [o, e]
              );
            }
            [Symbol.iterator]() {
              return this._items[Symbol.iterator]();
            }
          }
          class fo extends b {
            constructor(t, e = [], n = []) {
              super(),
                (this._context = t),
                (this._plugins = new Map()),
                (this._availablePlugins = new Map());
              for (const t of e)
                t.pluginName && this._availablePlugins.set(t.pluginName, t);
              this._contextPlugins = new Map();
              for (const [t, e] of n)
                this._contextPlugins.set(t, e),
                  this._contextPlugins.set(e, t),
                  t.pluginName && this._availablePlugins.set(t.pluginName, t);
            }
            *[Symbol.iterator]() {
              for (const t of this._plugins)
                "function" == typeof t[0] && (yield t);
            }
            get(t) {
              const e = this._plugins.get(t);
              if (!e) {
                let e = t;
                throw (
                  ("function" == typeof t && (e = t.pluginName || t.name),
                  new l("plugincollection-plugin-not-loaded", this._context, {
                    plugin: e,
                  }))
                );
              }
              return e;
            }
            has(t) {
              return this._plugins.has(t);
            }
            init(t, e = [], n = []) {
              const o = this,
                i = this._context;
              !(function t(e, n = new Set()) {
                e.forEach((e) => {
                  a(e) &&
                    (n.has(e) ||
                      (n.add(e),
                      e.pluginName &&
                        !o._availablePlugins.has(e.pluginName) &&
                        o._availablePlugins.set(e.pluginName, e),
                      e.requires && t(e.requires, n)));
                });
              })(t),
                h(t);
              const r = [
                ...(function t(e, n = new Set()) {
                  return e
                    .map((t) => (a(t) ? t : o._availablePlugins.get(t)))
                    .reduce(
                      (e, o) =>
                        n.has(o)
                          ? e
                          : (n.add(o),
                            o.requires &&
                              (h(o.requires, o),
                              t(o.requires, n).forEach((t) => e.add(t))),
                            e.add(o)),
                      new Set()
                    );
                })(t.filter((t) => !d(t, e))),
              ];
              !(function (t, e) {
                for (const n of e) {
                  if ("function" != typeof n)
                    throw new l(
                      "plugincollection-replace-plugin-invalid-type",
                      null,
                      { pluginItem: n }
                    );
                  const e = n.pluginName;
                  if (!e)
                    throw new l(
                      "plugincollection-replace-plugin-missing-name",
                      null,
                      { pluginItem: n }
                    );
                  if (n.requires && n.requires.length)
                    throw new l(
                      "plugincollection-plugin-for-replacing-cannot-have-dependencies",
                      null,
                      { pluginName: e }
                    );
                  const i = o._availablePlugins.get(e);
                  if (!i)
                    throw new l(
                      "plugincollection-plugin-for-replacing-not-exist",
                      null,
                      { pluginName: e }
                    );
                  const r = t.indexOf(i);
                  if (-1 === r) {
                    if (o._contextPlugins.has(i)) return;
                    throw new l(
                      "plugincollection-plugin-for-replacing-not-loaded",
                      null,
                      { pluginName: e }
                    );
                  }
                  if (i.requires && i.requires.length)
                    throw new l(
                      "plugincollection-replaced-plugin-cannot-have-dependencies",
                      null,
                      { pluginName: e }
                    );
                  t.splice(r, 1, n), o._availablePlugins.set(e, n);
                }
              })(r, n);
              const s = (function (t) {
                return t.map((t) => {
                  let e = o._contextPlugins.get(t);
                  return (e = e || new t(i)), o._add(t, e), e;
                });
              })(r);
              return m(s, "init")
                .then(() => m(s, "afterInit"))
                .then(() => s);
              function a(t) {
                return "function" == typeof t;
              }
              function c(t) {
                return a(t) && t.isContextPlugin;
              }
              function d(t, e) {
                return e.some((e) => e === t || u(t) === e || u(e) === t);
              }
              function u(t) {
                return a(t) ? t.pluginName || t.name : t;
              }
              function h(t, n = null) {
                t.map((t) =>
                  a(t) ? t : o._availablePlugins.get(t) || t
                ).forEach((t) => {
                  !(function (t, e) {
                    if (a(t)) return;
                    if (e)
                      throw new l("plugincollection-soft-required", i, {
                        missingPlugin: t,
                        requiredBy: u(e),
                      });
                    throw new l("plugincollection-plugin-not-found", i, {
                      plugin: t,
                    });
                  })(t, n),
                    (function (t, e) {
                      if (!c(e)) return;
                      if (c(t)) return;
                      throw new l("plugincollection-context-required", i, {
                        plugin: u(t),
                        requiredBy: u(e),
                      });
                    })(t, n),
                    (function (t, n) {
                      if (!n) return;
                      if (!d(t, e)) return;
                      throw new l("plugincollection-required", i, {
                        plugin: u(t),
                        requiredBy: u(n),
                      });
                    })(t, n);
                });
              }
              function m(t, e) {
                return t.reduce(
                  (t, n) =>
                    n[e]
                      ? o._contextPlugins.has(n)
                        ? t
                        : t.then(n[e].bind(n))
                      : t,
                  Promise.resolve()
                );
              }
            }
            destroy() {
              const t = [];
              for (const [, e] of this)
                "function" != typeof e.destroy ||
                  this._contextPlugins.has(e) ||
                  t.push(e.destroy());
              return Promise.all(t);
            }
            _add(t, e) {
              this._plugins.set(t, e);
              const n = t.pluginName;
              if (n) {
                if (this._plugins.has(n))
                  throw new l("plugincollection-plugin-name-conflict", null, {
                    pluginName: n,
                    plugin1: this._plugins.get(n).constructor,
                    plugin2: t,
                  });
                this._plugins.set(n, e);
              }
            }
          }
          function ko(t) {
            return Array.isArray(t) ? t : [t];
          }
          let bo;
          try {
            bo = { window, document };
          } catch (t) {
            bo = { window: {}, document: {} };
          }
          const wo = bo;
          function Ao(t, e, n = 1) {
            if ("number" != typeof n)
              throw new l("translation-service-quantity-not-a-number", null, {
                quantity: n,
              });
            const o = Object.keys(wo.window.CKEDITOR_TRANSLATIONS).length;
            1 === o && (t = Object.keys(wo.window.CKEDITOR_TRANSLATIONS)[0]);
            const i = e.id || e.string;
            if (
              0 === o ||
              !(function (t, e) {
                return (
                  !!wo.window.CKEDITOR_TRANSLATIONS[t] &&
                  !!wo.window.CKEDITOR_TRANSLATIONS[t].dictionary[e]
                );
              })(t, i)
            )
              return 1 !== n ? e.plural : e.string;
            const r = wo.window.CKEDITOR_TRANSLATIONS[t].dictionary,
              s =
                wo.window.CKEDITOR_TRANSLATIONS[t].getPluralForm ||
                ((t) => (1 === t ? 0 : 1)),
              a = r[i];
            if ("string" == typeof a) return a;
            return a[Number(s(n))];
          }
          wo.window.CKEDITOR_TRANSLATIONS ||
            (wo.window.CKEDITOR_TRANSLATIONS = {});
          const _o = [
            "ar",
            "ara",
            "fa",
            "per",
            "fas",
            "he",
            "heb",
            "ku",
            "kur",
            "ug",
            "uig",
          ];
          function Co(t) {
            return _o.includes(t) ? "rtl" : "ltr";
          }
          class vo {
            constructor(t = {}) {
              (this.uiLanguage = t.uiLanguage || "en"),
                (this.contentLanguage = t.contentLanguage || this.uiLanguage),
                (this.uiLanguageDirection = Co(this.uiLanguage)),
                (this.contentLanguageDirection = Co(this.contentLanguage)),
                (this.t = (t, e) => this._t(t, e));
            }
            get language() {
              return (
                console.warn(
                  "locale-deprecated-language-property: The Locale#language property has been deprecated and will be removed in the near future. Please use #uiLanguage and #contentLanguage properties instead."
                ),
                this.uiLanguage
              );
            }
            _t(t, e = []) {
              (e = ko(e)), "string" == typeof t && (t = { string: t });
              const n = !!t.plural ? e[0] : 1;
              return (function (t, e) {
                return t.replace(/%(\d+)/g, (t, n) =>
                  n < e.length ? e[n] : t
                );
              })(Ao(this.uiLanguage, t, n), e);
            }
          }
          class yo {
            constructor(t) {
              this.config = new uo(t, this.constructor.defaultConfig);
              const e = this.constructor.builtinPlugins;
              this.config.define("plugins", e),
                (this.plugins = new fo(this, e));
              const n = this.config.get("language") || {};
              (this.locale = new vo({
                uiLanguage: "string" == typeof n ? n : n.ui,
                contentLanguage: this.config.get("language.content"),
              })),
                (this.t = this.locale.t),
                (this.editors = new po()),
                (this._contextOwner = null);
            }
            initPlugins() {
              const t = this.config.get("plugins") || [],
                e = this.config.get("substitutePlugins") || [];
              for (const n of t.concat(e)) {
                if ("function" != typeof n)
                  throw new l("context-initplugins-constructor-only", null, {
                    Plugin: n,
                  });
                if (!0 !== n.isContextPlugin)
                  throw new l("context-initplugins-invalid-plugin", null, {
                    Plugin: n,
                  });
              }
              return this.plugins.init(t, [], e);
            }
            destroy() {
              return Promise.all(
                Array.from(this.editors, (t) => t.destroy())
              ).then(() => this.plugins.destroy());
            }
            _addEditor(t, e) {
              if (this._contextOwner)
                throw new l("context-addeditor-private-context");
              this.editors.add(t), e && (this._contextOwner = t);
            }
            _removeEditor(t) {
              return (
                this.editors.has(t) && this.editors.remove(t),
                this._contextOwner === t ? this.destroy() : Promise.resolve()
              );
            }
            _getEditorConfig() {
              const t = {};
              for (const e of this.config.names())
                ["plugins", "removePlugins", "extraPlugins"].includes(e) ||
                  (t[e] = this.config.get(e));
              return t;
            }
            static create(t) {
              return new Promise((e) => {
                const n = new this(t);
                e(n.initPlugins().then(() => n));
              });
            }
          }
          class xo extends N {
            constructor(t) {
              super(), (this.context = t);
            }
            destroy() {
              this.stopListening();
            }
            static get isContextPlugin() {
              return !0;
            }
          }
          class Eo {
            is() {
              throw new Error("is() method is abstract");
            }
          }
          function Do(t, e) {
            const n = Math.min(t.length, e.length);
            for (let o = 0; o < n; o++) if (t[o] != e[o]) return o;
            return t.length == e.length
              ? "same"
              : t.length < e.length
              ? "prefix"
              : "extension";
          }
          const So = function (t) {
            return ao(t, 4);
          };
          class Io extends k(Eo) {
            constructor(t) {
              super(), (this.document = t), (this.parent = null);
            }
            get index() {
              let t;
              if (!this.parent) return null;
              if (-1 == (t = this.parent.getChildIndex(this)))
                throw new l("view-node-not-found-in-parent", this);
              return t;
            }
            get nextSibling() {
              const t = this.index;
              return (null !== t && this.parent.getChild(t + 1)) || null;
            }
            get previousSibling() {
              const t = this.index;
              return (null !== t && this.parent.getChild(t - 1)) || null;
            }
            get root() {
              let t = this;
              for (; t.parent; ) t = t.parent;
              return t;
            }
            isAttached() {
              return this.root.is("rootElement");
            }
            getPath() {
              const t = [];
              let e = this;
              for (; e.parent; ) t.unshift(e.index), (e = e.parent);
              return t;
            }
            getAncestors(t = {}) {
              const e = [];
              let n = t.includeSelf ? this : this.parent;
              for (; n; )
                e[t.parentFirst ? "push" : "unshift"](n), (n = n.parent);
              return e;
            }
            getCommonAncestor(t, e = {}) {
              const n = this.getAncestors(e),
                o = t.getAncestors(e);
              let i = 0;
              for (; n[i] == o[i] && n[i]; ) i++;
              return 0 === i ? null : n[i - 1];
            }
            isBefore(t) {
              if (this == t) return !1;
              if (this.root !== t.root) return !1;
              const e = this.getPath(),
                n = t.getPath(),
                o = Do(e, n);
              switch (o) {
                case "prefix":
                  return !0;
                case "extension":
                  return !1;
                default:
                  return e[o] < n[o];
              }
            }
            isAfter(t) {
              return this != t && this.root === t.root && !this.isBefore(t);
            }
            _remove() {
              this.parent._removeChildren(this.index);
            }
            _fireChange(t, e) {
              this.fire(`change:${t}`, e),
                this.parent && this.parent._fireChange(t, e);
            }
            toJSON() {
              const t = So(this);
              return delete t.parent, t;
            }
          }
          Io.prototype.is = function (t) {
            return "node" === t || "view:node" === t;
          };
          class To extends Io {
            constructor(t, e) {
              super(t), (this._textData = e);
            }
            get data() {
              return this._textData;
            }
            get _data() {
              return this.data;
            }
            set _data(t) {
              this._fireChange("text", this), (this._textData = t);
            }
            isSimilar(t) {
              return t instanceof To && (this === t || this.data === t.data);
            }
            _clone() {
              return new To(this.document, this.data);
            }
          }
          To.prototype.is = function (t) {
            return (
              "$text" === t ||
              "view:$text" === t ||
              "text" === t ||
              "view:text" === t ||
              "node" === t ||
              "view:node" === t
            );
          };
          class Mo extends Eo {
            constructor(t, e, n) {
              if ((super(), (this.textNode = t), e < 0 || e > t.data.length))
                throw new l("view-textproxy-wrong-offsetintext", this);
              if (n < 0 || e + n > t.data.length)
                throw new l("view-textproxy-wrong-length", this);
              (this.data = t.data.substring(e, e + n)), (this.offsetInText = e);
            }
            get offsetSize() {
              return this.data.length;
            }
            get isPartial() {
              return this.data.length !== this.textNode.data.length;
            }
            get parent() {
              return this.textNode.parent;
            }
            get root() {
              return this.textNode.root;
            }
            get document() {
              return this.textNode.document;
            }
            getAncestors(t = {}) {
              const e = [];
              let n = t.includeSelf ? this.textNode : this.parent;
              for (; null !== n; )
                e[t.parentFirst ? "push" : "unshift"](n), (n = n.parent);
              return e;
            }
          }
          function Bo(t) {
            return go(t)
              ? new Map(t)
              : (function (t) {
                  const e = new Map();
                  for (const n in t) e.set(n, t[n]);
                  return e;
                })(t);
          }
          Mo.prototype.is = function (t) {
            return (
              "$textProxy" === t ||
              "view:$textProxy" === t ||
              "textProxy" === t ||
              "view:textProxy" === t
            );
          };
          class No {
            constructor(...t) {
              (this._patterns = []), this.add(...t);
            }
            add(...t) {
              for (let e of t)
                ("string" == typeof e || e instanceof RegExp) &&
                  (e = { name: e }),
                  this._patterns.push(e);
            }
            match(...t) {
              for (const e of t)
                for (const t of this._patterns) {
                  const n = zo(e, t);
                  if (n) return { element: e, pattern: t, match: n };
                }
              return null;
            }
            matchAll(...t) {
              const e = [];
              for (const n of t)
                for (const t of this._patterns) {
                  const o = zo(n, t);
                  o && e.push({ element: n, pattern: t, match: o });
                }
              return e.length > 0 ? e : null;
            }
            getElementName() {
              if (1 !== this._patterns.length) return null;
              const t = this._patterns[0],
                e = t.name;
              return "function" == typeof t || !e || e instanceof RegExp
                ? null
                : e;
            }
          }
          function zo(t, e) {
            if ("function" == typeof e) return e(t);
            const n = {};
            return (e.name &&
              ((n.name = (function (t, e) {
                if (t instanceof RegExp) return !!e.match(t);
                return t === e;
              })(e.name, t.name)),
              !n.name)) ||
              (e.attributes &&
                ((n.attributes = (function (t, e) {
                  const n = new Set(e.getAttributeKeys());
                  ut(t)
                    ? (void 0 !== t.style &&
                        c("matcher-pattern-deprecated-attributes-style-key", t),
                      void 0 !== t.class &&
                        c("matcher-pattern-deprecated-attributes-class-key", t))
                    : (n.delete("style"), n.delete("class"));
                  return Po(t, n, (t) => e.getAttribute(t));
                })(e.attributes, t)),
                !n.attributes)) ||
              (e.classes &&
                ((n.classes = (function (t, e) {
                  return Po(t, e.getClassNames(), () => {});
                })(e.classes, t)),
                !n.classes)) ||
              (e.styles &&
                ((n.styles = (function (t, e) {
                  return Po(t, e.getStyleNames(!0), (t) => e.getStyle(t));
                })(e.styles, t)),
                !n.styles))
              ? null
              : n;
          }
          function Po(t, e, n) {
            const o = (function (t) {
                if (Array.isArray(t))
                  return t.map((t) =>
                    ut(t)
                      ? ((void 0 !== t.key && void 0 !== t.value) ||
                          c("matcher-pattern-missing-key-or-value", t),
                        [t.key, t.value])
                      : [t, !0]
                  );
                if (ut(t)) return Object.entries(t);
                return [[t, !0]];
              })(t),
              i = Array.from(e),
              r = [];
            if (
              (o.forEach(([t, e]) => {
                i.forEach((o) => {
                  (function (t, e) {
                    return (
                      !0 === t || t === e || (t instanceof RegExp && e.match(t))
                    );
                  })(t, o) &&
                    (function (t, e, n) {
                      if (!0 === t) return !0;
                      const o = n(e);
                      return (
                        t === o || (t instanceof RegExp && !!String(o).match(t))
                      );
                    })(e, o, n) &&
                    r.push(o);
                });
              }),
              o.length && !(r.length < o.length))
            )
              return r;
          }
          const Lo = function (t) {
            return (
              "symbol" == typeof t || (rt(t) && "[object Symbol]" == nt(t))
            );
          };
          var Ro = /\.|\[(?:[^[\]]*|(["'])(?:(?!\1)[^\\]|\\.)*?\1)\]/,
            Oo = /^\w*$/;
          const jo = function (t, e) {
            if (Ce(t)) return !1;
            var n = typeof t;
            return (
              !(
                "number" != n &&
                "symbol" != n &&
                "boolean" != n &&
                null != t &&
                !Lo(t)
              ) ||
              Oo.test(t) ||
              !Ro.test(t) ||
              (null != e && t in Object(e))
            );
          };
          function Vo(t, e) {
            if ("function" != typeof t || (null != e && "function" != typeof e))
              throw new TypeError("Expected a function");
            var n = function () {
              var o = arguments,
                i = e ? e.apply(this, o) : o[0],
                r = n.cache;
              if (r.has(i)) return r.get(i);
              var s = t.apply(this, o);
              return (n.cache = r.set(i, s) || r), s;
            };
            return (n.cache = new (Vo.Cache || se)()), n;
          }
          Vo.Cache = se;
          const Fo = Vo;
          var Ho =
              /[^.[\]]+|\[(?:(-?\d+(?:\.\d+)?)|(["'])((?:(?!\2)[^\\]|\\.)*?)\2)\]|(?=(?:\.|\[\])(?:\.|\[\]|$))/g,
            Uo = /\\(\\)?/g,
            Wo = (function (t) {
              var e = Fo(t, function (t) {
                  return 500 === n.size && n.clear(), t;
                }),
                n = e.cache;
              return e;
            })(function (t) {
              var e = [];
              return (
                46 === t.charCodeAt(0) && e.push(""),
                t.replace(Ho, function (t, n, o, i) {
                  e.push(o ? i.replace(Uo, "$1") : n || t);
                }),
                e
              );
            });
          const $o = Wo;
          const qo = function (t, e) {
            for (
              var n = -1, o = null == t ? 0 : t.length, i = Array(o);
              ++n < o;

            )
              i[n] = e(t[n], n, t);
            return i;
          };
          var Go = G ? G.prototype : void 0,
            Zo = Go ? Go.toString : void 0;
          const Yo = function t(e) {
            if ("string" == typeof e) return e;
            if (Ce(e)) return qo(e, t) + "";
            if (Lo(e)) return Zo ? Zo.call(e) : "";
            var n = e + "";
            return "0" == n && 1 / e == -Infinity ? "-0" : n;
          };
          const Ko = function (t) {
            return null == t ? "" : Yo(t);
          };
          const Qo = function (t, e) {
            return Ce(t) ? t : jo(t, e) ? [t] : $o(Ko(t));
          };
          const Jo = function (t) {
            var e = null == t ? 0 : t.length;
            return e ? t[e - 1] : void 0;
          };
          const Xo = function (t) {
            if ("string" == typeof t || Lo(t)) return t;
            var e = t + "";
            return "0" == e && 1 / t == -Infinity ? "-0" : e;
          };
          const ti = function (t, e) {
            for (var n = 0, o = (e = Qo(e, t)).length; null != t && n < o; )
              t = t[Xo(e[n++])];
            return n && n == o ? t : void 0;
          };
          const ei = function (t, e, n) {
            var o = -1,
              i = t.length;
            e < 0 && (e = -e > i ? 0 : i + e),
              (n = n > i ? i : n) < 0 && (n += i),
              (i = e > n ? 0 : (n - e) >>> 0),
              (e >>>= 0);
            for (var r = Array(i); ++o < i; ) r[o] = t[o + e];
            return r;
          };
          const ni = function (t, e) {
            return e.length < 2 ? t : ti(t, ei(e, 0, -1));
          };
          const oi = function (t, e) {
            return (
              (e = Qo(e, t)), null == (t = ni(t, e)) || delete t[Xo(Jo(e))]
            );
          };
          const ii = function (t, e) {
            return null == t || oi(t, e);
          };
          const ri = function (t, e, n) {
            var o = null == t ? void 0 : ti(t, e);
            return void 0 === o ? n : o;
          };
          const si = function (t, e, n) {
            ((void 0 !== n && !mt(t[e], n)) || (void 0 === n && !(e in t))) &&
              he(t, e, n);
          };
          const ai = (function (t) {
            return function (e, n, o) {
              for (var i = -1, r = Object(e), s = o(e), a = s.length; a--; ) {
                var l = s[t ? a : ++i];
                if (!1 === n(r[l], l, r)) break;
              }
              return e;
            };
          })();
          const li = function (t) {
            return rt(t) && Ge(t);
          };
          const ci = function (t, e) {
            if (
              ("constructor" !== e || "function" != typeof t[e]) &&
              "__proto__" != e
            )
              return t[e];
          };
          const di = function (t) {
            return pe(t, Xe(t));
          };
          const ui = function (t, e, n, o, i, r, s) {
            var a = ci(t, n),
              l = ci(e, n),
              c = s.get(l);
            if (c) si(t, n, c);
            else {
              var d = r ? r(a, l, n + "", t, e, s) : void 0,
                u = void 0 === d;
              if (u) {
                var h = Ce(l),
                  m = !h && De(l),
                  g = !h && !m && je(l);
                (d = l),
                  h || m || g
                    ? Ce(a)
                      ? (d = a)
                      : li(a)
                      ? (d = an(a))
                      : m
                      ? ((u = !1), (d = sn(l, !0)))
                      : g
                      ? ((u = !1), (d = qn(l, !0)))
                      : (d = [])
                    : ut(l) || _e(l)
                    ? ((d = a),
                      _e(a) ? (d = di(a)) : (E(a) && !Et(a)) || (d = Kn(l)))
                    : (u = !1);
              }
              u && (s.set(l, d), i(d, l, o, r, s), s.delete(l)), si(t, n, d);
            }
          };
          const hi = function t(e, n, o, i, r) {
            e !== n &&
              ai(
                n,
                function (s, a) {
                  if ((r || (r = new ce()), E(s))) ui(e, n, a, o, t, i, r);
                  else {
                    var l = i ? i(ci(e, a), s, a + "", e, n, r) : void 0;
                    void 0 === l && (l = s), si(e, a, l);
                  }
                },
                Xe
              );
          };
          const mi = function (t) {
            return t;
          };
          const gi = function (t, e, n) {
            switch (n.length) {
              case 0:
                return t.call(e);
              case 1:
                return t.call(e, n[0]);
              case 2:
                return t.call(e, n[0], n[1]);
              case 3:
                return t.call(e, n[0], n[1], n[2]);
            }
            return t.apply(e, n);
          };
          var pi = Math.max;
          const fi = function (t, e, n) {
            return (
              (e = pi(void 0 === e ? t.length - 1 : e, 0)),
              function () {
                for (
                  var o = arguments,
                    i = -1,
                    r = pi(o.length - e, 0),
                    s = Array(r);
                  ++i < r;

                )
                  s[i] = o[e + i];
                i = -1;
                for (var a = Array(e + 1); ++i < e; ) a[i] = o[i];
                return (a[e] = n(s)), gi(t, this, a);
              }
            );
          };
          const ki = function (t) {
            return function () {
              return t;
            };
          };
          const bi = ue
            ? function (t, e) {
                return ue(t, "toString", {
                  configurable: !0,
                  enumerable: !1,
                  value: ki(e),
                  writable: !0,
                });
              }
            : mi;
          var wi = Date.now;
          const Ai = function (t) {
            var e = 0,
              n = 0;
            return function () {
              var o = wi(),
                i = 16 - (o - n);
              if (((n = o), i > 0)) {
                if (++e >= 800) return arguments[0];
              } else e = 0;
              return t.apply(void 0, arguments);
            };
          };
          const _i = Ai(bi);
          const Ci = function (t, e) {
            return _i(fi(t, e, mi), t + "");
          };
          const vi = function (t, e, n) {
            if (!E(n)) return !1;
            var o = typeof e;
            return (
              !!("number" == o
                ? Ge(n) && Ie(e, n.length)
                : "string" == o && e in n) && mt(n[e], t)
            );
          };
          const yi = function (t) {
            return Ci(function (e, n) {
              var o = -1,
                i = n.length,
                r = i > 1 ? n[i - 1] : void 0,
                s = i > 2 ? n[2] : void 0;
              for (
                r = t.length > 3 && "function" == typeof r ? (i--, r) : void 0,
                  s && vi(n[0], n[1], s) && ((r = i < 3 ? void 0 : r), (i = 1)),
                  e = Object(e);
                ++o < i;

              ) {
                var a = n[o];
                a && t(e, a, o, r);
              }
              return e;
            });
          };
          const xi = yi(function (t, e, n) {
            hi(t, e, n);
          });
          const Ei = function (t, e, n, o) {
            if (!E(t)) return t;
            for (
              var i = -1, r = (e = Qo(e, t)).length, s = r - 1, a = t;
              null != a && ++i < r;

            ) {
              var l = Xo(e[i]),
                c = n;
              if ("__proto__" === l || "constructor" === l || "prototype" === l)
                return t;
              if (i != s) {
                var d = a[l];
                void 0 === (c = o ? o(d, l, a) : void 0) &&
                  (c = E(d) ? d : Ie(e[i + 1]) ? [] : {});
              }
              ge(a, l, c), (a = a[l]);
            }
            return t;
          };
          const Di = function (t, e, n) {
            return null == t ? t : Ei(t, e, n);
          };
          class Si {
            constructor(t) {
              (this._styles = {}), (this._styleProcessor = t);
            }
            get isEmpty() {
              const t = Object.entries(this._styles);
              return !Array.from(t).length;
            }
            get size() {
              return this.isEmpty ? 0 : this.getStyleNames().length;
            }
            setTo(t) {
              this.clear();
              const e = Array.from(
                (function (t) {
                  let e = null,
                    n = 0,
                    o = 0,
                    i = null;
                  const r = new Map();
                  if ("" === t) return r;
                  ";" != t.charAt(t.length - 1) && (t += ";");
                  for (let s = 0; s < t.length; s++) {
                    const a = t.charAt(s);
                    if (null === e)
                      switch (a) {
                        case ":":
                          i || ((i = t.substr(n, s - n)), (o = s + 1));
                          break;
                        case '"':
                        case "'":
                          e = a;
                          break;
                        case ";": {
                          const e = t.substr(o, s - o);
                          i && r.set(i.trim(), e.trim()),
                            (i = null),
                            (n = s + 1);
                          break;
                        }
                      }
                    else a === e && (e = null);
                  }
                  return r;
                })(t).entries()
              );
              for (const [t, n] of e)
                this._styleProcessor.toNormalizedForm(t, n, this._styles);
            }
            has(t) {
              if (this.isEmpty) return !1;
              const e = this._styleProcessor
                .getReducedForm(t, this._styles)
                .find(([e]) => e === t);
              return Array.isArray(e);
            }
            set(t, e) {
              if (E(t))
                for (const [e, n] of Object.entries(t))
                  this._styleProcessor.toNormalizedForm(e, n, this._styles);
              else this._styleProcessor.toNormalizedForm(t, e, this._styles);
            }
            remove(t) {
              const e = Ti(t);
              ii(this._styles, e),
                delete this._styles[t],
                this._cleanEmptyObjectsOnPath(e);
            }
            getNormalized(t) {
              return this._styleProcessor.getNormalized(t, this._styles);
            }
            toString() {
              return this.isEmpty
                ? ""
                : this._getStylesEntries()
                    .map((t) => t.join(":"))
                    .sort()
                    .join(";") + ";";
            }
            getAsString(t) {
              if (this.isEmpty) return;
              if (this._styles[t] && !E(this._styles[t]))
                return this._styles[t];
              const e = this._styleProcessor
                .getReducedForm(t, this._styles)
                .find(([e]) => e === t);
              return Array.isArray(e) ? e[1] : void 0;
            }
            getStyleNames(t = !1) {
              if (this.isEmpty) return [];
              if (t) return this._styleProcessor.getStyleNames(this._styles);
              return this._getStylesEntries().map(([t]) => t);
            }
            clear() {
              this._styles = {};
            }
            _getStylesEntries() {
              const t = [],
                e = Object.keys(this._styles);
              for (const n of e)
                t.push(...this._styleProcessor.getReducedForm(n, this._styles));
              return t;
            }
            _cleanEmptyObjectsOnPath(t) {
              const e = t.split(".");
              if (!(e.length > 1)) return;
              const n = e.splice(0, e.length - 1).join("."),
                o = ri(this._styles, n);
              if (!o) return;
              !Array.from(Object.keys(o)).length && this.remove(n);
            }
          }
          class Ii {
            constructor() {
              (this._normalizers = new Map()),
                (this._extractors = new Map()),
                (this._reducers = new Map()),
                (this._consumables = new Map());
            }
            toNormalizedForm(t, e, n) {
              if (E(e)) Mi(n, Ti(t), e);
              else if (this._normalizers.has(t)) {
                const o = this._normalizers.get(t),
                  { path: i, value: r } = o(e);
                Mi(n, i, r);
              } else Mi(n, t, e);
            }
            getNormalized(t, e) {
              if (!t) return xi({}, e);
              if (void 0 !== e[t]) return e[t];
              if (this._extractors.has(t)) {
                const n = this._extractors.get(t);
                if ("string" == typeof n) return ri(e, n);
                const o = n(t, e);
                if (o) return o;
              }
              return ri(e, Ti(t));
            }
            getReducedForm(t, e) {
              const n = this.getNormalized(t, e);
              if (void 0 === n) return [];
              if (this._reducers.has(t)) {
                return this._reducers.get(t)(n);
              }
              return [[t, n]];
            }
            getStyleNames(t) {
              const e = Array.from(this._consumables.keys()).filter((e) => {
                  const n = this.getNormalized(e, t);
                  return n && "object" == typeof n ? Object.keys(n).length : n;
                }),
                n = new Set([...e, ...Object.keys(t)]);
              return Array.from(n.values());
            }
            getRelatedStyles(t) {
              return this._consumables.get(t) || [];
            }
            setNormalizer(t, e) {
              this._normalizers.set(t, e);
            }
            setExtractor(t, e) {
              this._extractors.set(t, e);
            }
            setReducer(t, e) {
              this._reducers.set(t, e);
            }
            setStyleRelation(t, e) {
              this._mapStyleNames(t, e);
              for (const n of e) this._mapStyleNames(n, [t]);
            }
            _mapStyleNames(t, e) {
              this._consumables.has(t) || this._consumables.set(t, []),
                this._consumables.get(t).push(...e);
            }
          }
          function Ti(t) {
            return t.replace("-", ".");
          }
          function Mi(t, e, n) {
            let o = n;
            E(n) && (o = xi({}, ri(t, e), n)), Di(t, e, o);
          }
          class Bi extends Io {
            constructor(t, e, n, o) {
              if (
                (super(t),
                (this.name = e),
                (this._attrs = (function (t) {
                  const e = Bo(t);
                  for (const [t, n] of e)
                    null === n
                      ? e.delete(t)
                      : "string" != typeof n && e.set(t, String(n));
                  return e;
                })(n)),
                (this._children = []),
                o && this._insertChild(0, o),
                (this._classes = new Set()),
                this._attrs.has("class"))
              ) {
                const t = this._attrs.get("class");
                Ni(this._classes, t), this._attrs.delete("class");
              }
              (this._styles = new Si(this.document.stylesProcessor)),
                this._attrs.has("style") &&
                  (this._styles.setTo(this._attrs.get("style")),
                  this._attrs.delete("style")),
                (this._customProperties = new Map()),
                (this._unsafeAttributesToRender = []);
            }
            get childCount() {
              return this._children.length;
            }
            get isEmpty() {
              return 0 === this._children.length;
            }
            getChild(t) {
              return this._children[t];
            }
            getChildIndex(t) {
              return this._children.indexOf(t);
            }
            getChildren() {
              return this._children[Symbol.iterator]();
            }
            *getAttributeKeys() {
              this._classes.size > 0 && (yield "class"),
                this._styles.isEmpty || (yield "style"),
                yield* this._attrs.keys();
            }
            *getAttributes() {
              yield* this._attrs.entries(),
                this._classes.size > 0 &&
                  (yield ["class", this.getAttribute("class")]),
                this._styles.isEmpty ||
                  (yield ["style", this.getAttribute("style")]);
            }
            getAttribute(t) {
              if ("class" == t)
                return this._classes.size > 0
                  ? [...this._classes].join(" ")
                  : void 0;
              if ("style" == t) {
                const t = this._styles.toString();
                return "" == t ? void 0 : t;
              }
              return this._attrs.get(t);
            }
            hasAttribute(t) {
              return "class" == t
                ? this._classes.size > 0
                : "style" == t
                ? !this._styles.isEmpty
                : this._attrs.has(t);
            }
            isSimilar(t) {
              if (!(t instanceof Bi)) return !1;
              if (this === t) return !0;
              if (this.name != t.name) return !1;
              if (
                this._attrs.size !== t._attrs.size ||
                this._classes.size !== t._classes.size ||
                this._styles.size !== t._styles.size
              )
                return !1;
              for (const [e, n] of this._attrs)
                if (!t._attrs.has(e) || t._attrs.get(e) !== n) return !1;
              for (const e of this._classes) if (!t._classes.has(e)) return !1;
              for (const e of this._styles.getStyleNames())
                if (
                  !t._styles.has(e) ||
                  t._styles.getAsString(e) !== this._styles.getAsString(e)
                )
                  return !1;
              return !0;
            }
            hasClass(...t) {
              for (const e of t) if (!this._classes.has(e)) return !1;
              return !0;
            }
            getClassNames() {
              return this._classes.keys();
            }
            getStyle(t) {
              return this._styles.getAsString(t);
            }
            getNormalizedStyle(t) {
              return this._styles.getNormalized(t);
            }
            getStyleNames(t) {
              return this._styles.getStyleNames(t);
            }
            hasStyle(...t) {
              for (const e of t) if (!this._styles.has(e)) return !1;
              return !0;
            }
            findAncestor(...t) {
              const e = new No(...t);
              let n = this.parent;
              for (; n && !n.is("documentFragment"); ) {
                if (e.match(n)) return n;
                n = n.parent;
              }
              return null;
            }
            getCustomProperty(t) {
              return this._customProperties.get(t);
            }
            *getCustomProperties() {
              yield* this._customProperties.entries();
            }
            getIdentity() {
              const t = Array.from(this._classes).sort().join(","),
                e = this._styles.toString(),
                n = Array.from(this._attrs)
                  .map((t) => `${t[0]}="${t[1]}"`)
                  .sort()
                  .join(" ");
              return (
                this.name +
                ("" == t ? "" : ` class="${t}"`) +
                (e ? ` style="${e}"` : "") +
                ("" == n ? "" : ` ${n}`)
              );
            }
            shouldRenderUnsafeAttribute(t) {
              return this._unsafeAttributesToRender.includes(t);
            }
            _clone(t = !1) {
              const e = [];
              if (t) for (const n of this.getChildren()) e.push(n._clone(t));
              const n = new this.constructor(
                this.document,
                this.name,
                this._attrs,
                e
              );
              return (
                (n._classes = new Set(this._classes)),
                n._styles.set(this._styles.getNormalized()),
                (n._customProperties = new Map(this._customProperties)),
                (n.getFillerOffset = this.getFillerOffset),
                (n._unsafeAttributesToRender = this._unsafeAttributesToRender),
                n
              );
            }
            _appendChild(t) {
              return this._insertChild(this.childCount, t);
            }
            _insertChild(t, e) {
              this._fireChange("children", this);
              let n = 0;
              const o = (function (t, e) {
                if ("string" == typeof e) return [new To(t, e)];
                go(e) || (e = [e]);
                return Array.from(e).map((e) =>
                  "string" == typeof e
                    ? new To(t, e)
                    : e instanceof Mo
                    ? new To(t, e.data)
                    : e
                );
              })(this.document, e);
              for (const e of o)
                null !== e.parent && e._remove(),
                  (e.parent = this),
                  (e.document = this.document),
                  this._children.splice(t, 0, e),
                  t++,
                  n++;
              return n;
            }
            _removeChildren(t, e = 1) {
              this._fireChange("children", this);
              for (let n = t; n < t + e; n++) this._children[n].parent = null;
              return this._children.splice(t, e);
            }
            _setAttribute(t, e) {
              (e = String(e)),
                this._fireChange("attributes", this),
                "class" == t
                  ? Ni(this._classes, e)
                  : "style" == t
                  ? this._styles.setTo(e)
                  : this._attrs.set(t, e);
            }
            _removeAttribute(t) {
              return (
                this._fireChange("attributes", this),
                "class" == t
                  ? this._classes.size > 0 && (this._classes.clear(), !0)
                  : "style" == t
                  ? !this._styles.isEmpty && (this._styles.clear(), !0)
                  : this._attrs.delete(t)
              );
            }
            _addClass(t) {
              this._fireChange("attributes", this);
              for (const e of ko(t)) this._classes.add(e);
            }
            _removeClass(t) {
              this._fireChange("attributes", this);
              for (const e of ko(t)) this._classes.delete(e);
            }
            _setStyle(t, e) {
              this._fireChange("attributes", this),
                ut(t) ? this._styles.set(t) : this._styles.set(t, e);
            }
            _removeStyle(t) {
              this._fireChange("attributes", this);
              for (const e of ko(t)) this._styles.remove(e);
            }
            _setCustomProperty(t, e) {
              this._customProperties.set(t, e);
            }
            _removeCustomProperty(t) {
              return this._customProperties.delete(t);
            }
          }
          function Ni(t, e) {
            const n = e.split(/\s+/);
            t.clear(), n.forEach((e) => t.add(e));
          }
          Bi.prototype.is = function (t, e) {
            return e
              ? e === this.name && ("element" === t || "view:element" === t)
              : "element" === t ||
                  "view:element" === t ||
                  "node" === t ||
                  "view:node" === t;
          };
          class zi extends Bi {
            constructor(...t) {
              super(...t), (this.getFillerOffset = Pi);
            }
          }
          function Pi() {
            const t = [...this.getChildren()],
              e = t[this.childCount - 1];
            if (e && e.is("element", "br")) return this.childCount;
            for (const e of t) if (!e.is("uiElement")) return null;
            return this.childCount;
          }
          zi.prototype.is = function (t, e) {
            return e
              ? e === this.name &&
                  ("containerElement" === t ||
                    "view:containerElement" === t ||
                    "element" === t ||
                    "view:element" === t)
              : "containerElement" === t ||
                  "view:containerElement" === t ||
                  "element" === t ||
                  "view:element" === t ||
                  "node" === t ||
                  "view:node" === t;
          };
          class Li extends B(zi) {
            constructor(...t) {
              super(...t);
              const e = t[0];
              this.set("isReadOnly", !1),
                this.set("isFocused", !1),
                this.bind("isReadOnly").to(e),
                this.bind("isFocused").to(
                  e,
                  "isFocused",
                  (t) => t && e.selection.editableElement == this
                ),
                this.listenTo(e.selection, "change", () => {
                  this.isFocused =
                    e.isFocused && e.selection.editableElement == this;
                });
            }
            destroy() {
              this.stopListening();
            }
          }
          Li.prototype.is = function (t, e) {
            return e
              ? e === this.name &&
                  ("editableElement" === t ||
                    "view:editableElement" === t ||
                    "containerElement" === t ||
                    "view:containerElement" === t ||
                    "element" === t ||
                    "view:element" === t)
              : "editableElement" === t ||
                  "view:editableElement" === t ||
                  "containerElement" === t ||
                  "view:containerElement" === t ||
                  "element" === t ||
                  "view:element" === t ||
                  "node" === t ||
                  "view:node" === t;
          };
          const Ri = Symbol("rootName");
          class Oi extends Li {
            constructor(t, e) {
              super(t, e), (this.rootName = "main");
            }
            get rootName() {
              return this.getCustomProperty(Ri);
            }
            set rootName(t) {
              this._setCustomProperty(Ri, t);
            }
            set _name(t) {
              this.name = t;
            }
          }
          Oi.prototype.is = function (t, e) {
            return e
              ? e === this.name &&
                  ("rootElement" === t ||
                    "view:rootElement" === t ||
                    "editableElement" === t ||
                    "view:editableElement" === t ||
                    "containerElement" === t ||
                    "view:containerElement" === t ||
                    "element" === t ||
                    "view:element" === t)
              : "rootElement" === t ||
                  "view:rootElement" === t ||
                  "editableElement" === t ||
                  "view:editableElement" === t ||
                  "containerElement" === t ||
                  "view:containerElement" === t ||
                  "element" === t ||
                  "view:element" === t ||
                  "node" === t ||
                  "view:node" === t;
          };
          class ji {
            constructor(t = {}) {
              if (!t.boundaries && !t.startPosition)
                throw new l("view-tree-walker-no-start-position", null);
              if (
                t.direction &&
                "forward" != t.direction &&
                "backward" != t.direction
              )
                throw new l(
                  "view-tree-walker-unknown-direction",
                  t.startPosition,
                  { direction: t.direction }
                );
              (this.boundaries = t.boundaries || null),
                t.startPosition
                  ? (this.position = Vi._createAt(t.startPosition))
                  : (this.position = Vi._createAt(
                      t.boundaries["backward" == t.direction ? "end" : "start"]
                    )),
                (this.direction = t.direction || "forward"),
                (this.singleCharacters = !!t.singleCharacters),
                (this.shallow = !!t.shallow),
                (this.ignoreElementEnd = !!t.ignoreElementEnd),
                (this._boundaryStartParent = this.boundaries
                  ? this.boundaries.start.parent
                  : null),
                (this._boundaryEndParent = this.boundaries
                  ? this.boundaries.end.parent
                  : null);
            }
            [Symbol.iterator]() {
              return this;
            }
            skip(t) {
              let e, n, o;
              do {
                (o = this.position), ({ done: e, value: n } = this.next());
              } while (!e && t(n));
              e || (this.position = o);
            }
            next() {
              return "forward" == this.direction
                ? this._next()
                : this._previous();
            }
            _next() {
              let t = this.position.clone();
              const e = this.position,
                n = t.parent;
              if (null === n.parent && t.offset === n.childCount)
                return { done: !0, value: void 0 };
              if (
                n === this._boundaryEndParent &&
                t.offset == this.boundaries.end.offset
              )
                return { done: !0, value: void 0 };
              let o;
              if (n instanceof To) {
                if (t.isAtEnd)
                  return (this.position = Vi._createAfter(n)), this._next();
                o = n.data[t.offset];
              } else o = n.getChild(t.offset);
              if (o instanceof Bi)
                return (
                  this.shallow ? t.offset++ : (t = new Vi(o, 0)),
                  (this.position = t),
                  this._formatReturnValue("elementStart", o, e, t, 1)
                );
              if (o instanceof To) {
                if (this.singleCharacters)
                  return (t = new Vi(o, 0)), (this.position = t), this._next();
                {
                  let n,
                    i = o.data.length;
                  return (
                    o == this._boundaryEndParent
                      ? ((i = this.boundaries.end.offset),
                        (n = new Mo(o, 0, i)),
                        (t = Vi._createAfter(n)))
                      : ((n = new Mo(o, 0, o.data.length)), t.offset++),
                    (this.position = t),
                    this._formatReturnValue("text", n, e, t, i)
                  );
                }
              }
              if ("string" == typeof o) {
                let o;
                if (this.singleCharacters) o = 1;
                else {
                  o =
                    (n === this._boundaryEndParent
                      ? this.boundaries.end.offset
                      : n.data.length) - t.offset;
                }
                const i = new Mo(n, t.offset, o);
                return (
                  (t.offset += o),
                  (this.position = t),
                  this._formatReturnValue("text", i, e, t, o)
                );
              }
              return (
                (t = Vi._createAfter(n)),
                (this.position = t),
                this.ignoreElementEnd
                  ? this._next()
                  : this._formatReturnValue("elementEnd", n, e, t)
              );
            }
            _previous() {
              let t = this.position.clone();
              const e = this.position,
                n = t.parent;
              if (null === n.parent && 0 === t.offset)
                return { done: !0, value: void 0 };
              if (
                n == this._boundaryStartParent &&
                t.offset == this.boundaries.start.offset
              )
                return { done: !0, value: void 0 };
              let o;
              if (n instanceof To) {
                if (t.isAtStart)
                  return (
                    (this.position = Vi._createBefore(n)), this._previous()
                  );
                o = n.data[t.offset - 1];
              } else o = n.getChild(t.offset - 1);
              if (o instanceof Bi)
                return this.shallow
                  ? (t.offset--,
                    (this.position = t),
                    this._formatReturnValue("elementStart", o, e, t, 1))
                  : ((t = new Vi(o, o.childCount)),
                    (this.position = t),
                    this.ignoreElementEnd
                      ? this._previous()
                      : this._formatReturnValue("elementEnd", o, e, t));
              if (o instanceof To) {
                if (this.singleCharacters)
                  return (
                    (t = new Vi(o, o.data.length)),
                    (this.position = t),
                    this._previous()
                  );
                {
                  let n,
                    i = o.data.length;
                  if (o == this._boundaryStartParent) {
                    const e = this.boundaries.start.offset;
                    (n = new Mo(o, e, o.data.length - e)),
                      (i = n.data.length),
                      (t = Vi._createBefore(n));
                  } else (n = new Mo(o, 0, o.data.length)), t.offset--;
                  return (
                    (this.position = t),
                    this._formatReturnValue("text", n, e, t, i)
                  );
                }
              }
              if ("string" == typeof o) {
                let o;
                if (this.singleCharacters) o = 1;
                else {
                  const e =
                    n === this._boundaryStartParent
                      ? this.boundaries.start.offset
                      : 0;
                  o = t.offset - e;
                }
                t.offset -= o;
                const i = new Mo(n, t.offset, o);
                return (
                  (this.position = t),
                  this._formatReturnValue("text", i, e, t, o)
                );
              }
              return (
                (t = Vi._createBefore(n)),
                (this.position = t),
                this._formatReturnValue("elementStart", n, e, t, 1)
              );
            }
            _formatReturnValue(t, e, n, o, i) {
              return (
                e instanceof Mo &&
                  (e.offsetInText + e.data.length == e.textNode.data.length &&
                    ("forward" != this.direction ||
                    (this.boundaries &&
                      this.boundaries.end.isEqual(this.position))
                      ? (n = Vi._createAfter(e.textNode))
                      : ((o = Vi._createAfter(e.textNode)),
                        (this.position = o))),
                  0 === e.offsetInText &&
                    ("backward" != this.direction ||
                    (this.boundaries &&
                      this.boundaries.start.isEqual(this.position))
                      ? (n = Vi._createBefore(e.textNode))
                      : ((o = Vi._createBefore(e.textNode)),
                        (this.position = o)))),
                {
                  done: !1,
                  value: {
                    type: t,
                    item: e,
                    previousPosition: n,
                    nextPosition: o,
                    length: i,
                  },
                }
              );
            }
          }
          class Vi extends Eo {
            constructor(t, e) {
              super(), (this.parent = t), (this.offset = e);
            }
            get nodeAfter() {
              return this.parent.is("$text")
                ? null
                : this.parent.getChild(this.offset) || null;
            }
            get nodeBefore() {
              return this.parent.is("$text")
                ? null
                : this.parent.getChild(this.offset - 1) || null;
            }
            get isAtStart() {
              return 0 === this.offset;
            }
            get isAtEnd() {
              const t = this.parent.is("$text")
                ? this.parent.data.length
                : this.parent.childCount;
              return this.offset === t;
            }
            get root() {
              return this.parent.root;
            }
            get editableElement() {
              let t = this.parent;
              for (; !(t instanceof Li); ) {
                if (!t.parent) return null;
                t = t.parent;
              }
              return t;
            }
            getShiftedBy(t) {
              const e = Vi._createAt(this),
                n = e.offset + t;
              return (e.offset = n < 0 ? 0 : n), e;
            }
            getLastMatchingPosition(t, e = {}) {
              e.startPosition = this;
              const n = new ji(e);
              return n.skip(t), n.position;
            }
            getAncestors() {
              return this.parent.is("documentFragment")
                ? [this.parent]
                : this.parent.getAncestors({ includeSelf: !0 });
            }
            getCommonAncestor(t) {
              const e = this.getAncestors(),
                n = t.getAncestors();
              let o = 0;
              for (; e[o] == n[o] && e[o]; ) o++;
              return 0 === o ? null : e[o - 1];
            }
            isEqual(t) {
              return this.parent == t.parent && this.offset == t.offset;
            }
            isBefore(t) {
              return "before" == this.compareWith(t);
            }
            isAfter(t) {
              return "after" == this.compareWith(t);
            }
            compareWith(t) {
              if (this.root !== t.root) return "different";
              if (this.isEqual(t)) return "same";
              const e = this.parent.is("node") ? this.parent.getPath() : [],
                n = t.parent.is("node") ? t.parent.getPath() : [];
              e.push(this.offset), n.push(t.offset);
              const o = Do(e, n);
              switch (o) {
                case "prefix":
                  return "before";
                case "extension":
                  return "after";
                default:
                  return e[o] < n[o] ? "before" : "after";
              }
            }
            getWalker(t = {}) {
              return (t.startPosition = this), new ji(t);
            }
            clone() {
              return new Vi(this.parent, this.offset);
            }
            static _createAt(t, e) {
              if (t instanceof Vi) return new this(t.parent, t.offset);
              {
                const n = t;
                if ("end" == e)
                  e = n.is("$text") ? n.data.length : n.childCount;
                else {
                  if ("before" == e) return this._createBefore(n);
                  if ("after" == e) return this._createAfter(n);
                  if (0 !== e && !e)
                    throw new l("view-createpositionat-offset-required", n);
                }
                return new Vi(n, e);
              }
            }
            static _createAfter(t) {
              if (t.is("$textProxy"))
                return new Vi(t.textNode, t.offsetInText + t.data.length);
              if (!t.parent)
                throw new l("view-position-after-root", t, { root: t });
              return new Vi(t.parent, t.index + 1);
            }
            static _createBefore(t) {
              if (t.is("$textProxy")) return new Vi(t.textNode, t.offsetInText);
              if (!t.parent)
                throw new l("view-position-before-root", t, { root: t });
              return new Vi(t.parent, t.index);
            }
          }
          Vi.prototype.is = function (t) {
            return "position" === t || "view:position" === t;
          };
          class Fi extends Eo {
            constructor(t, e = null) {
              super(),
                (this.start = t.clone()),
                (this.end = e ? e.clone() : t.clone());
            }
            *[Symbol.iterator]() {
              yield* new ji({ boundaries: this, ignoreElementEnd: !0 });
            }
            get isCollapsed() {
              return this.start.isEqual(this.end);
            }
            get isFlat() {
              return this.start.parent === this.end.parent;
            }
            get root() {
              return this.start.root;
            }
            getEnlarged() {
              let t = this.start.getLastMatchingPosition(Hi, {
                  direction: "backward",
                }),
                e = this.end.getLastMatchingPosition(Hi);
              return (
                t.parent.is("$text") &&
                  t.isAtStart &&
                  (t = Vi._createBefore(t.parent)),
                e.parent.is("$text") &&
                  e.isAtEnd &&
                  (e = Vi._createAfter(e.parent)),
                new Fi(t, e)
              );
            }
            getTrimmed() {
              let t = this.start.getLastMatchingPosition(Hi);
              if (t.isAfter(this.end) || t.isEqual(this.end))
                return new Fi(t, t);
              let e = this.end.getLastMatchingPosition(Hi, {
                direction: "backward",
              });
              const n = t.nodeAfter,
                o = e.nodeBefore;
              return (
                n && n.is("$text") && (t = new Vi(n, 0)),
                o && o.is("$text") && (e = new Vi(o, o.data.length)),
                new Fi(t, e)
              );
            }
            isEqual(t) {
              return (
                this == t ||
                (this.start.isEqual(t.start) && this.end.isEqual(t.end))
              );
            }
            containsPosition(t) {
              return t.isAfter(this.start) && t.isBefore(this.end);
            }
            containsRange(t, e = !1) {
              t.isCollapsed && (e = !1);
              const n =
                  this.containsPosition(t.start) ||
                  (e && this.start.isEqual(t.start)),
                o =
                  this.containsPosition(t.end) ||
                  (e && this.end.isEqual(t.end));
              return n && o;
            }
            getDifference(t) {
              const e = [];
              return (
                this.isIntersecting(t)
                  ? (this.containsPosition(t.start) &&
                      e.push(new Fi(this.start, t.start)),
                    this.containsPosition(t.end) &&
                      e.push(new Fi(t.end, this.end)))
                  : e.push(this.clone()),
                e
              );
            }
            getIntersection(t) {
              if (this.isIntersecting(t)) {
                let e = this.start,
                  n = this.end;
                return (
                  this.containsPosition(t.start) && (e = t.start),
                  this.containsPosition(t.end) && (n = t.end),
                  new Fi(e, n)
                );
              }
              return null;
            }
            getWalker(t = {}) {
              return (t.boundaries = this), new ji(t);
            }
            getCommonAncestor() {
              return this.start.getCommonAncestor(this.end);
            }
            getContainedElement() {
              if (this.isCollapsed) return null;
              let t = this.start.nodeAfter,
                e = this.end.nodeBefore;
              return (
                this.start.parent.is("$text") &&
                  this.start.isAtEnd &&
                  this.start.parent.nextSibling &&
                  (t = this.start.parent.nextSibling),
                this.end.parent.is("$text") &&
                  this.end.isAtStart &&
                  this.end.parent.previousSibling &&
                  (e = this.end.parent.previousSibling),
                t && t.is("element") && t === e ? t : null
              );
            }
            clone() {
              return new Fi(this.start, this.end);
            }
            *getItems(t = {}) {
              (t.boundaries = this), (t.ignoreElementEnd = !0);
              const e = new ji(t);
              for (const t of e) yield t.item;
            }
            *getPositions(t = {}) {
              t.boundaries = this;
              const e = new ji(t);
              yield e.position;
              for (const t of e) yield t.nextPosition;
            }
            isIntersecting(t) {
              return this.start.isBefore(t.end) && this.end.isAfter(t.start);
            }
            static _createFromParentsAndOffsets(t, e, n, o) {
              return new this(new Vi(t, e), new Vi(n, o));
            }
            static _createFromPositionAndShift(t, e) {
              const n = t,
                o = t.getShiftedBy(e);
              return e > 0 ? new this(n, o) : new this(o, n);
            }
            static _createIn(t) {
              return this._createFromParentsAndOffsets(t, 0, t, t.childCount);
            }
            static _createOn(t) {
              const e = t.is("$textProxy") ? t.offsetSize : 1;
              return this._createFromPositionAndShift(Vi._createBefore(t), e);
            }
          }
          function Hi(t) {
            return !(!t.item.is("attributeElement") && !t.item.is("uiElement"));
          }
          function Ui(t) {
            let e = 0;
            for (const n of t) e++;
            return e;
          }
          Fi.prototype.is = function (t) {
            return "range" === t || "view:range" === t;
          };
          class Wi extends k(Eo) {
            constructor(...t) {
              super(),
                (this._ranges = []),
                (this._lastRangeBackward = !1),
                (this._isFake = !1),
                (this._fakeSelectionLabel = ""),
                t.length && this.setTo(...t);
            }
            get isFake() {
              return this._isFake;
            }
            get fakeSelectionLabel() {
              return this._fakeSelectionLabel;
            }
            get anchor() {
              if (!this._ranges.length) return null;
              const t = this._ranges[this._ranges.length - 1];
              return (this._lastRangeBackward ? t.end : t.start).clone();
            }
            get focus() {
              if (!this._ranges.length) return null;
              const t = this._ranges[this._ranges.length - 1];
              return (this._lastRangeBackward ? t.start : t.end).clone();
            }
            get isCollapsed() {
              return 1 === this.rangeCount && this._ranges[0].isCollapsed;
            }
            get rangeCount() {
              return this._ranges.length;
            }
            get isBackward() {
              return !this.isCollapsed && this._lastRangeBackward;
            }
            get editableElement() {
              return this.anchor ? this.anchor.editableElement : null;
            }
            *getRanges() {
              for (const t of this._ranges) yield t.clone();
            }
            getFirstRange() {
              let t = null;
              for (const e of this._ranges)
                (t && !e.start.isBefore(t.start)) || (t = e);
              return t ? t.clone() : null;
            }
            getLastRange() {
              let t = null;
              for (const e of this._ranges)
                (t && !e.end.isAfter(t.end)) || (t = e);
              return t ? t.clone() : null;
            }
            getFirstPosition() {
              const t = this.getFirstRange();
              return t ? t.start.clone() : null;
            }
            getLastPosition() {
              const t = this.getLastRange();
              return t ? t.end.clone() : null;
            }
            isEqual(t) {
              if (this.isFake != t.isFake) return !1;
              if (
                this.isFake &&
                this.fakeSelectionLabel != t.fakeSelectionLabel
              )
                return !1;
              if (this.rangeCount != t.rangeCount) return !1;
              if (0 === this.rangeCount) return !0;
              if (
                !this.anchor.isEqual(t.anchor) ||
                !this.focus.isEqual(t.focus)
              )
                return !1;
              for (const e of this._ranges) {
                let n = !1;
                for (const o of t._ranges)
                  if (e.isEqual(o)) {
                    n = !0;
                    break;
                  }
                if (!n) return !1;
              }
              return !0;
            }
            isSimilar(t) {
              if (this.isBackward != t.isBackward) return !1;
              const e = Ui(this.getRanges());
              if (e != Ui(t.getRanges())) return !1;
              if (0 == e) return !0;
              for (let e of this.getRanges()) {
                e = e.getTrimmed();
                let n = !1;
                for (let o of t.getRanges())
                  if (
                    ((o = o.getTrimmed()),
                    e.start.isEqual(o.start) && e.end.isEqual(o.end))
                  ) {
                    n = !0;
                    break;
                  }
                if (!n) return !1;
              }
              return !0;
            }
            getSelectedElement() {
              return 1 !== this.rangeCount
                ? null
                : this.getFirstRange().getContainedElement();
            }
            setTo(...t) {
              let [e, n, o] = t;
              if (("object" == typeof n && ((o = n), (n = void 0)), null === e))
                this._setRanges([]), this._setFakeOptions(o);
              else if (e instanceof Wi || e instanceof $i)
                this._setRanges(e.getRanges(), e.isBackward),
                  this._setFakeOptions({
                    fake: e.isFake,
                    label: e.fakeSelectionLabel,
                  });
              else if (e instanceof Fi)
                this._setRanges([e], o && o.backward), this._setFakeOptions(o);
              else if (e instanceof Vi)
                this._setRanges([new Fi(e)]), this._setFakeOptions(o);
              else if (e instanceof Io) {
                const t = !!o && !!o.backward;
                let i;
                if (void 0 === n)
                  throw new l(
                    "view-selection-setto-required-second-parameter",
                    this
                  );
                (i =
                  "in" == n
                    ? Fi._createIn(e)
                    : "on" == n
                    ? Fi._createOn(e)
                    : new Fi(Vi._createAt(e, n))),
                  this._setRanges([i], t),
                  this._setFakeOptions(o);
              } else {
                if (!go(e))
                  throw new l("view-selection-setto-not-selectable", this);
                this._setRanges(e, o && o.backward), this._setFakeOptions(o);
              }
              this.fire("change");
            }
            setFocus(t, e) {
              if (null === this.anchor)
                throw new l("view-selection-setfocus-no-ranges", this);
              const n = Vi._createAt(t, e);
              if ("same" == n.compareWith(this.focus)) return;
              const o = this.anchor;
              this._ranges.pop(),
                "before" == n.compareWith(o)
                  ? this._addRange(new Fi(n, o), !0)
                  : this._addRange(new Fi(o, n)),
                this.fire("change");
            }
            _setRanges(t, e = !1) {
              (t = Array.from(t)), (this._ranges = []);
              for (const e of t) this._addRange(e);
              this._lastRangeBackward = !!e;
            }
            _setFakeOptions(t = {}) {
              (this._isFake = !!t.fake),
                (this._fakeSelectionLabel = (t.fake && t.label) || "");
            }
            _addRange(t, e = !1) {
              if (!(t instanceof Fi))
                throw new l("view-selection-add-range-not-range", this);
              this._pushRange(t), (this._lastRangeBackward = !!e);
            }
            _pushRange(t) {
              for (const e of this._ranges)
                if (t.isIntersecting(e))
                  throw new l("view-selection-range-intersects", this, {
                    addedRange: t,
                    intersectingRange: e,
                  });
              this._ranges.push(new Fi(t.start, t.end));
            }
          }
          Wi.prototype.is = function (t) {
            return "selection" === t || "view:selection" === t;
          };
          class $i extends k(Eo) {
            constructor(...t) {
              super(),
                (this._selection = new Wi()),
                this._selection.delegate("change").to(this),
                t.length && this._selection.setTo(...t);
            }
            get isFake() {
              return this._selection.isFake;
            }
            get fakeSelectionLabel() {
              return this._selection.fakeSelectionLabel;
            }
            get anchor() {
              return this._selection.anchor;
            }
            get focus() {
              return this._selection.focus;
            }
            get isCollapsed() {
              return this._selection.isCollapsed;
            }
            get rangeCount() {
              return this._selection.rangeCount;
            }
            get isBackward() {
              return this._selection.isBackward;
            }
            get editableElement() {
              return this._selection.editableElement;
            }
            get _ranges() {
              return this._selection._ranges;
            }
            *getRanges() {
              yield* this._selection.getRanges();
            }
            getFirstRange() {
              return this._selection.getFirstRange();
            }
            getLastRange() {
              return this._selection.getLastRange();
            }
            getFirstPosition() {
              return this._selection.getFirstPosition();
            }
            getLastPosition() {
              return this._selection.getLastPosition();
            }
            getSelectedElement() {
              return this._selection.getSelectedElement();
            }
            isEqual(t) {
              return this._selection.isEqual(t);
            }
            isSimilar(t) {
              return this._selection.isSimilar(t);
            }
            _setTo(...t) {
              this._selection.setTo(...t);
            }
            _setFocus(t, e) {
              this._selection.setFocus(t, e);
            }
          }
          $i.prototype.is = function (t) {
            return (
              "selection" === t ||
              "documentSelection" == t ||
              "view:selection" == t ||
              "view:documentSelection" == t
            );
          };
          class qi extends e {
            constructor(t, e, n) {
              super(t, e),
                (this.startRange = n),
                (this._eventPhase = "none"),
                (this._currentTarget = null);
            }
            get eventPhase() {
              return this._eventPhase;
            }
            get currentTarget() {
              return this._currentTarget;
            }
          }
          const Gi = Symbol("bubbling contexts");
          function Zi(t) {
            return class extends t {
              fire(t, ...n) {
                try {
                  const o = t instanceof e ? t : new e(this, t),
                    i = Ji(this);
                  if (!i.size) return;
                  if ((Yi(o, "capturing", this), Ki(i, "$capture", o, ...n)))
                    return o.return;
                  const r = o.startRange || this.selection.getFirstRange(),
                    s = r ? r.getContainedElement() : null,
                    a = !!s && Boolean(Qi(i, s));
                  let l =
                    s ||
                    (function (t) {
                      if (!t) return null;
                      const e = t.start.parent,
                        n = t.end.parent,
                        o = e.getPath(),
                        i = n.getPath();
                      return o.length > i.length ? e : n;
                    })(r);
                  if ((Yi(o, "atTarget", l), !a)) {
                    if (Ki(i, "$text", o, ...n)) return o.return;
                    Yi(o, "bubbling", l);
                  }
                  for (; l; ) {
                    if (l.is("rootElement")) {
                      if (Ki(i, "$root", o, ...n)) return o.return;
                    } else if (l.is("element") && Ki(i, l.name, o, ...n))
                      return o.return;
                    if (Ki(i, l, o, ...n)) return o.return;
                    (l = l.parent), Yi(o, "bubbling", l);
                  }
                  return (
                    Yi(o, "bubbling", this),
                    Ki(i, "$document", o, ...n),
                    o.return
                  );
                } catch (t) {
                  l.rethrowUnexpectedError(t, this);
                }
              }
              _addEventListener(t, e, n) {
                const o = ko(n.context || "$document"),
                  i = Ji(this);
                for (const r of o) {
                  let o = i.get(r);
                  o || ((o = new b()), i.set(r, o)), this.listenTo(o, t, e, n);
                }
              }
              _removeEventListener(t, e) {
                const n = Ji(this);
                for (const o of n.values()) this.stopListening(o, t, e);
              }
            };
          }
          {
            const t = Zi(Object);
            ["fire", "_addEventListener", "_removeEventListener"].forEach(
              (e) => {
                Zi[e] = t.prototype[e];
              }
            );
          }
          function Yi(t, e, n) {
            t instanceof qi && ((t._eventPhase = e), (t._currentTarget = n));
          }
          function Ki(t, e, n, ...o) {
            const i = "string" == typeof e ? t.get(e) : Qi(t, e);
            return !!i && (i.fire(n, ...o), n.stop.called);
          }
          function Qi(t, e) {
            for (const [n, o] of t)
              if ("function" == typeof n && n(e)) return o;
            return null;
          }
          function Ji(t) {
            return t[Gi] || (t[Gi] = new Map()), t[Gi];
          }
          class Xi extends Zi(N) {
            constructor(t) {
              super(),
                (this.selection = new $i()),
                (this.roots = new po({ idProperty: "rootName" })),
                (this.stylesProcessor = t),
                this.set("isReadOnly", !1),
                this.set("isFocused", !1),
                this.set("isSelecting", !1),
                this.set("isComposing", !1),
                (this._postFixers = new Set());
            }
            getRoot(t = "main") {
              return this.roots.get(t);
            }
            registerPostFixer(t) {
              this._postFixers.add(t);
            }
            destroy() {
              this.roots.map((t) => t.destroy()), this.stopListening();
            }
            _callPostFixers(t) {
              let e = !1;
              do {
                for (const n of this._postFixers) if (((e = n(t)), e)) break;
              } while (e);
            }
          }
          class tr extends Bi {
            constructor(...t) {
              super(...t),
                (this.getFillerOffset = er),
                (this._priority = 10),
                (this._id = null),
                (this._clonesGroup = null);
            }
            get priority() {
              return this._priority;
            }
            get id() {
              return this._id;
            }
            getElementsWithSameId() {
              if (null === this.id)
                throw new l(
                  "attribute-element-get-elements-with-same-id-no-id",
                  this
                );
              return new Set(this._clonesGroup);
            }
            isSimilar(t) {
              return null !== this.id || null !== t.id
                ? this.id === t.id
                : super.isSimilar(t) && this.priority == t.priority;
            }
            _clone(t = !1) {
              const e = super._clone(t);
              return (e._priority = this._priority), (e._id = this._id), e;
            }
          }
          function er() {
            if (nr(this)) return null;
            let t = this.parent;
            for (; t && t.is("attributeElement"); ) {
              if (nr(t) > 1) return null;
              t = t.parent;
            }
            return !t || nr(t) > 1 ? null : this.childCount;
          }
          function nr(t) {
            return Array.from(t.getChildren()).filter((t) => !t.is("uiElement"))
              .length;
          }
          (tr.DEFAULT_PRIORITY = 10),
            (tr.prototype.is = function (t, e) {
              return e
                ? e === this.name &&
                    ("attributeElement" === t ||
                      "view:attributeElement" === t ||
                      "element" === t ||
                      "view:element" === t)
                : "attributeElement" === t ||
                    "view:attributeElement" === t ||
                    "element" === t ||
                    "view:element" === t ||
                    "node" === t ||
                    "view:node" === t;
            });
          class or extends Bi {
            constructor(t, e, n, o) {
              super(t, e, n, o), (this.getFillerOffset = ir);
            }
            _insertChild(t, e) {
              if (e && (e instanceof Io || Array.from(e).length > 0))
                throw new l("view-emptyelement-cannot-add", [this, e]);
              return 0;
            }
          }
          function ir() {
            return null;
          }
          or.prototype.is = function (t, e) {
            return e
              ? e === this.name &&
                  ("emptyElement" === t ||
                    "view:emptyElement" === t ||
                    "element" === t ||
                    "view:element" === t)
              : "emptyElement" === t ||
                  "view:emptyElement" === t ||
                  "element" === t ||
                  "view:element" === t ||
                  "node" === t ||
                  "view:node" === t;
          };
          const rr = (function () {
              try {
                return navigator.userAgent.toLowerCase();
              } catch (t) {
                return "";
              }
            })(),
            sr = {
              isMac: lr(rr),
              isWindows: (function (t) {
                return t.indexOf("windows") > -1;
              })(rr),
              isGecko: (function (t) {
                return !!t.match(/gecko\/\d+/);
              })(rr),
              isSafari: (function (t) {
                return (
                  t.indexOf(" applewebkit/") > -1 && -1 === t.indexOf("chrome")
                );
              })(rr),
              isiOS: (function (t) {
                return (
                  !!t.match(/iphone|ipad/i) ||
                  (lr(t) && navigator.maxTouchPoints > 0)
                );
              })(rr),
              isAndroid: (function (t) {
                return t.indexOf("android") > -1;
              })(rr),
              isBlink: (function (t) {
                return t.indexOf("chrome/") > -1 && t.indexOf("edge/") < 0;
              })(rr),
              features: {
                isRegExpUnicodePropertySupported: (function () {
                  let t = !1;
                  try {
                    t = 0 === "ć".search(new RegExp("[\\p{L}]", "u"));
                  } catch (t) {}
                  return t;
                })(),
              },
            },
            ar = sr;
          function lr(t) {
            return t.indexOf("macintosh") > -1;
          }
          const cr = { ctrl: "⌃", cmd: "⌘", alt: "⌥", shift: "⇧" },
            dr = { ctrl: "Ctrl+", alt: "Alt+", shift: "Shift+" },
            ur = (function () {
              const t = {
                arrowleft: 37,
                arrowup: 38,
                arrowright: 39,
                arrowdown: 40,
                backspace: 8,
                delete: 46,
                enter: 13,
                space: 32,
                esc: 27,
                tab: 9,
                ctrl: 1114112,
                shift: 2228224,
                alt: 4456448,
                cmd: 8912896,
              };
              for (let e = 65; e <= 90; e++) {
                const n = String.fromCharCode(e);
                t[n.toLowerCase()] = e;
              }
              for (let e = 48; e <= 57; e++) t[e - 48] = e;
              for (let e = 112; e <= 123; e++) t["f" + (e - 111)] = e;
              for (const e of "`-=[];',./\\") t[e] = e.charCodeAt(0);
              return t;
            })(),
            hr = Object.fromEntries(
              Object.entries(ur).map(([t, e]) => [
                e,
                t.charAt(0).toUpperCase() + t.slice(1),
              ])
            );
          function mr(t) {
            let e;
            if ("string" == typeof t) {
              if (((e = ur[t.toLowerCase()]), !e))
                throw new l("keyboard-unknown-key", null, { key: t });
            } else
              e =
                t.keyCode +
                (t.altKey ? ur.alt : 0) +
                (t.ctrlKey ? ur.ctrl : 0) +
                (t.shiftKey ? ur.shift : 0) +
                (t.metaKey ? ur.cmd : 0);
            return e;
          }
          function gr(t) {
            return (
              "string" == typeof t &&
                (t = (function (t) {
                  return t.split("+").map((t) => t.trim());
                })(t)),
              t
                .map((t) =>
                  "string" == typeof t
                    ? (function (t) {
                        if (t.endsWith("!")) return mr(t.slice(0, -1));
                        const e = mr(t);
                        return ar.isMac && e == ur.ctrl ? ur.cmd : e;
                      })(t)
                    : t
                )
                .reduce((t, e) => e + t, 0)
            );
          }
          function pr(t) {
            let e = gr(t);
            return (
              Object.entries(ar.isMac ? cr : dr).reduce(
                (t, [n, o]) => (
                  0 != (e & ur[n]) && ((e &= ~ur[n]), (t += o)), t
                ),
                ""
              ) + (e ? hr[e] : "")
            );
          }
          function fr(t, e) {
            const n = "ltr" === e;
            switch (t) {
              case ur.arrowleft:
                return n ? "left" : "right";
              case ur.arrowright:
                return n ? "right" : "left";
              case ur.arrowup:
                return "up";
              case ur.arrowdown:
                return "down";
            }
          }
          class kr extends Bi {
            constructor(...t) {
              super(...t), (this.getFillerOffset = wr);
            }
            _insertChild(t, e) {
              if (e && (e instanceof Io || Array.from(e).length > 0))
                throw new l("view-uielement-cannot-add", [this, e]);
              return 0;
            }
            render(t, e) {
              return this.toDomElement(t);
            }
            toDomElement(t) {
              const e = t.createElement(this.name);
              for (const t of this.getAttributeKeys())
                e.setAttribute(t, this.getAttribute(t));
              return e;
            }
          }
          function br(t) {
            t.document.on(
              "arrowKey",
              (e, n) =>
                (function (t, e, n) {
                  if (e.keyCode == ur.arrowright) {
                    const t =
                        e.domTarget.ownerDocument.defaultView.getSelection(),
                      o = 1 == t.rangeCount && t.getRangeAt(0).collapsed;
                    if (o || e.shiftKey) {
                      const e = t.focusNode,
                        i = t.focusOffset,
                        r = n.domPositionToView(e, i);
                      if (null === r) return;
                      let s = !1;
                      const a = r.getLastMatchingPosition(
                        (t) => (
                          t.item.is("uiElement") && (s = !0),
                          !(
                            !t.item.is("uiElement") &&
                            !t.item.is("attributeElement")
                          )
                        )
                      );
                      if (s) {
                        const e = n.viewPositionToDom(a);
                        o
                          ? t.collapse(e.parent, e.offset)
                          : t.extend(e.parent, e.offset);
                      }
                    }
                  }
                })(0, n, t.domConverter),
              { priority: "low" }
            );
          }
          function wr() {
            return null;
          }
          kr.prototype.is = function (t, e) {
            return e
              ? e === this.name &&
                  ("uiElement" === t ||
                    "view:uiElement" === t ||
                    "element" === t ||
                    "view:element" === t)
              : "uiElement" === t ||
                  "view:uiElement" === t ||
                  "element" === t ||
                  "view:element" === t ||
                  "node" === t ||
                  "view:node" === t;
          };
          class Ar extends Bi {
            constructor(...t) {
              super(...t), (this.getFillerOffset = _r);
            }
            _insertChild(t, e) {
              if (e && (e instanceof Io || Array.from(e).length > 0))
                throw new l("view-rawelement-cannot-add", [this, e]);
              return 0;
            }
            render() {}
          }
          function _r() {
            return null;
          }
          Ar.prototype.is = function (t, e) {
            return e
              ? e === this.name &&
                  ("rawElement" === t ||
                    "view:rawElement" === t ||
                    "element" === t ||
                    "view:element" === t)
              : "rawElement" === t ||
                  "view:rawElement" === t ||
                  t === this.name ||
                  t === "view:" + this.name ||
                  "element" === t ||
                  "view:element" === t ||
                  "node" === t ||
                  "view:node" === t;
          };
          class Cr extends k(Eo) {
            constructor(t, e) {
              super(),
                (this.document = t),
                (this._children = []),
                e && this._insertChild(0, e);
            }
            [Symbol.iterator]() {
              return this._children[Symbol.iterator]();
            }
            get childCount() {
              return this._children.length;
            }
            get isEmpty() {
              return 0 === this.childCount;
            }
            get root() {
              return this;
            }
            get parent() {
              return null;
            }
            _appendChild(t) {
              return this._insertChild(this.childCount, t);
            }
            getChild(t) {
              return this._children[t];
            }
            getChildIndex(t) {
              return this._children.indexOf(t);
            }
            getChildren() {
              return this._children[Symbol.iterator]();
            }
            _insertChild(t, e) {
              this._fireChange("children", this);
              let n = 0;
              const o = (function (t, e) {
                if ("string" == typeof e) return [new To(t, e)];
                go(e) || (e = [e]);
                return Array.from(e).map((e) =>
                  "string" == typeof e
                    ? new To(t, e)
                    : e instanceof Mo
                    ? new To(t, e.data)
                    : e
                );
              })(this.document, e);
              for (const e of o)
                null !== e.parent && e._remove(),
                  (e.parent = this),
                  this._children.splice(t, 0, e),
                  t++,
                  n++;
              return n;
            }
            _removeChildren(t, e = 1) {
              this._fireChange("children", this);
              for (let n = t; n < t + e; n++) this._children[n].parent = null;
              return this._children.splice(t, e);
            }
            _fireChange(t, e) {
              this.fire("change:" + t, e);
            }
          }
          Cr.prototype.is = function (t) {
            return "documentFragment" === t || "view:documentFragment" === t;
          };
          class vr {
            constructor(t) {
              (this.document = t),
                (this._cloneGroups = new Map()),
                (this._slotFactory = null);
            }
            setSelection(...t) {
              this.document.selection._setTo(...t);
            }
            setSelectionFocus(...t) {
              this.document.selection._setFocus(...t);
            }
            createDocumentFragment(t) {
              return new Cr(this.document, t);
            }
            createText(t) {
              return new To(this.document, t);
            }
            createAttributeElement(t, e, n = {}) {
              const o = new tr(this.document, t, e);
              return (
                "number" == typeof n.priority && (o._priority = n.priority),
                n.id && (o._id = n.id),
                n.renderUnsafeAttributes &&
                  o._unsafeAttributesToRender.push(...n.renderUnsafeAttributes),
                o
              );
            }
            createContainerElement(t, e, n = {}, o = {}) {
              let i = null;
              ut(n) ? (o = n) : (i = n);
              const r = new zi(this.document, t, e, i);
              return (
                o.renderUnsafeAttributes &&
                  r._unsafeAttributesToRender.push(...o.renderUnsafeAttributes),
                r
              );
            }
            createEditableElement(t, e, n = {}) {
              const o = new Li(this.document, t, e);
              return (
                n.renderUnsafeAttributes &&
                  o._unsafeAttributesToRender.push(...n.renderUnsafeAttributes),
                o
              );
            }
            createEmptyElement(t, e, n = {}) {
              const o = new or(this.document, t, e);
              return (
                n.renderUnsafeAttributes &&
                  o._unsafeAttributesToRender.push(...n.renderUnsafeAttributes),
                o
              );
            }
            createUIElement(t, e, n) {
              const o = new kr(this.document, t, e);
              return n && (o.render = n), o;
            }
            createRawElement(t, e, n, o = {}) {
              const i = new Ar(this.document, t, e);
              return (
                n && (i.render = n),
                o.renderUnsafeAttributes &&
                  i._unsafeAttributesToRender.push(...o.renderUnsafeAttributes),
                i
              );
            }
            setAttribute(t, e, n) {
              n._setAttribute(t, e);
            }
            removeAttribute(t, e) {
              e._removeAttribute(t);
            }
            addClass(t, e) {
              e._addClass(t);
            }
            removeClass(t, e) {
              e._removeClass(t);
            }
            setStyle(t, e, n) {
              ut(t) && void 0 === n ? e._setStyle(t) : n._setStyle(t, e);
            }
            removeStyle(t, e) {
              e._removeStyle(t);
            }
            setCustomProperty(t, e, n) {
              n._setCustomProperty(t, e);
            }
            removeCustomProperty(t, e) {
              return e._removeCustomProperty(t);
            }
            breakAttributes(t) {
              return t instanceof Vi
                ? this._breakAttributes(t)
                : this._breakAttributesRange(t);
            }
            breakContainer(t) {
              const e = t.parent;
              if (!e.is("containerElement"))
                throw new l(
                  "view-writer-break-non-container-element",
                  this.document
                );
              if (!e.parent)
                throw new l("view-writer-break-root", this.document);
              if (t.isAtStart) return Vi._createBefore(e);
              if (!t.isAtEnd) {
                const n = e._clone(!1);
                this.insert(Vi._createAfter(e), n);
                const o = new Fi(t, Vi._createAt(e, "end")),
                  i = new Vi(n, 0);
                this.move(o, i);
              }
              return Vi._createAfter(e);
            }
            mergeAttributes(t) {
              const e = t.offset,
                n = t.parent;
              if (n.is("$text")) return t;
              if (n.is("attributeElement") && 0 === n.childCount) {
                const t = n.parent,
                  e = n.index;
                return (
                  n._remove(),
                  this._removeFromClonedElementsGroup(n),
                  this.mergeAttributes(new Vi(t, e))
                );
              }
              const o = n.getChild(e - 1),
                i = n.getChild(e);
              if (!o || !i) return t;
              if (o.is("$text") && i.is("$text")) return Sr(o, i);
              if (
                o.is("attributeElement") &&
                i.is("attributeElement") &&
                o.isSimilar(i)
              ) {
                const t = o.childCount;
                return (
                  o._appendChild(i.getChildren()),
                  i._remove(),
                  this._removeFromClonedElementsGroup(i),
                  this.mergeAttributes(new Vi(o, t))
                );
              }
              return t;
            }
            mergeContainers(t) {
              const e = t.nodeBefore,
                n = t.nodeAfter;
              if (
                !(
                  e &&
                  n &&
                  e.is("containerElement") &&
                  n.is("containerElement")
                )
              )
                throw new l(
                  "view-writer-merge-containers-invalid-position",
                  this.document
                );
              const o = e.getChild(e.childCount - 1),
                i =
                  o instanceof To
                    ? Vi._createAt(o, "end")
                    : Vi._createAt(e, "end");
              return (
                this.move(Fi._createIn(n), Vi._createAt(e, "end")),
                this.remove(Fi._createOn(n)),
                i
              );
            }
            insert(t, e) {
              Tr((e = go(e) ? [...e] : [e]), this.document);
              const n = e.reduce((t, e) => {
                const n = t[t.length - 1],
                  o = !e.is("uiElement");
                return (
                  n && n.breakAttributes == o
                    ? n.nodes.push(e)
                    : t.push({ breakAttributes: o, nodes: [e] }),
                  t
                );
              }, []);
              let o = null,
                i = t;
              for (const { nodes: t, breakAttributes: e } of n) {
                const n = this._insertNodes(i, t, e);
                o || (o = n.start), (i = n.end);
              }
              return o ? new Fi(o, i) : new Fi(t);
            }
            remove(t) {
              const e = t instanceof Fi ? t : Fi._createOn(t);
              if ((Br(e, this.document), e.isCollapsed))
                return new Cr(this.document);
              const { start: n, end: o } = this._breakAttributesRange(e, !0),
                i = n.parent,
                r = o.offset - n.offset,
                s = i._removeChildren(n.offset, r);
              for (const t of s) this._removeFromClonedElementsGroup(t);
              const a = this.mergeAttributes(n);
              return (
                (e.start = a), (e.end = a.clone()), new Cr(this.document, s)
              );
            }
            clear(t, e) {
              Br(t, this.document);
              const n = t.getWalker({
                direction: "backward",
                ignoreElementEnd: !0,
              });
              for (const o of n) {
                const n = o.item;
                let i;
                if (n.is("element") && e.isSimilar(n)) i = Fi._createOn(n);
                else if (
                  !o.nextPosition.isAfter(t.start) &&
                  n.is("$textProxy")
                ) {
                  const t = n
                    .getAncestors()
                    .find((t) => t.is("element") && e.isSimilar(t));
                  t && (i = Fi._createIn(t));
                }
                i &&
                  (i.end.isAfter(t.end) && (i.end = t.end),
                  i.start.isBefore(t.start) && (i.start = t.start),
                  this.remove(i));
              }
            }
            move(t, e) {
              let n;
              if (e.isAfter(t.end)) {
                const o = (e = this._breakAttributes(e, !0)).parent,
                  i = o.childCount;
                (t = this._breakAttributesRange(t, !0)),
                  (n = this.remove(t)),
                  (e.offset += o.childCount - i);
              } else n = this.remove(t);
              return this.insert(e, n);
            }
            wrap(t, e) {
              if (!(e instanceof tr))
                throw new l(
                  "view-writer-wrap-invalid-attribute",
                  this.document
                );
              if ((Br(t, this.document), t.isCollapsed)) {
                let o = t.start;
                o.parent.is("element") &&
                  ((n = o.parent),
                  !Array.from(n.getChildren()).some(
                    (t) => !t.is("uiElement")
                  )) &&
                  (o = o.getLastMatchingPosition((t) =>
                    t.item.is("uiElement")
                  )),
                  (o = this._wrapPosition(o, e));
                const i = this.document.selection;
                return (
                  i.isCollapsed &&
                    i.getFirstPosition().isEqual(t.start) &&
                    this.setSelection(o),
                  new Fi(o)
                );
              }
              return this._wrapRange(t, e);
              var n;
            }
            unwrap(t, e) {
              if (!(e instanceof tr))
                throw new l(
                  "view-writer-unwrap-invalid-attribute",
                  this.document
                );
              if ((Br(t, this.document), t.isCollapsed)) return t;
              const { start: n, end: o } = this._breakAttributesRange(t, !0),
                i = n.parent,
                r = this._unwrapChildren(i, n.offset, o.offset, e),
                s = this.mergeAttributes(r.start);
              s.isEqual(r.start) || r.end.offset--;
              const a = this.mergeAttributes(r.end);
              return new Fi(s, a);
            }
            rename(t, e) {
              const n = new zi(this.document, t, e.getAttributes());
              return (
                this.insert(Vi._createAfter(e), n),
                this.move(Fi._createIn(e), Vi._createAt(n, 0)),
                this.remove(Fi._createOn(e)),
                n
              );
            }
            clearClonedElementsGroup(t) {
              this._cloneGroups.delete(t);
            }
            createPositionAt(t, e) {
              return Vi._createAt(t, e);
            }
            createPositionAfter(t) {
              return Vi._createAfter(t);
            }
            createPositionBefore(t) {
              return Vi._createBefore(t);
            }
            createRange(...t) {
              return new Fi(...t);
            }
            createRangeOn(t) {
              return Fi._createOn(t);
            }
            createRangeIn(t) {
              return Fi._createIn(t);
            }
            createSelection(...t) {
              return new Wi(...t);
            }
            createSlot(t) {
              if (!this._slotFactory)
                throw new l(
                  "view-writer-invalid-create-slot-context",
                  this.document
                );
              return this._slotFactory(this, t);
            }
            _registerSlotFactory(t) {
              this._slotFactory = t;
            }
            _clearSlotFactory() {
              this._slotFactory = null;
            }
            _insertNodes(t, e, n) {
              let o, i;
              if (
                ((o = n
                  ? yr(t)
                  : t.parent.is("$text")
                  ? t.parent.parent
                  : t.parent),
                !o)
              )
                throw new l(
                  "view-writer-invalid-position-container",
                  this.document
                );
              i = n
                ? this._breakAttributes(t, !0)
                : t.parent.is("$text")
                ? Dr(t)
                : t;
              const r = o._insertChild(i.offset, e);
              for (const t of e) this._addToClonedElementsGroup(t);
              const s = i.getShiftedBy(r),
                a = this.mergeAttributes(i);
              a.isEqual(i) || s.offset--;
              const c = this.mergeAttributes(s);
              return new Fi(a, c);
            }
            _wrapChildren(t, e, n, o) {
              let i = e;
              const r = [];
              for (; i < n; ) {
                const e = t.getChild(i),
                  n = e.is("$text"),
                  s = e.is("attributeElement");
                if (s && this._wrapAttributeElement(o, e)) r.push(new Vi(t, i));
                else if (n || !s || xr(o, e)) {
                  const n = o._clone();
                  e._remove(),
                    n._appendChild(e),
                    t._insertChild(i, n),
                    this._addToClonedElementsGroup(n),
                    r.push(new Vi(t, i));
                } else this._wrapChildren(e, 0, e.childCount, o);
                i++;
              }
              let s = 0;
              for (const t of r) {
                if (((t.offset -= s), t.offset == e)) continue;
                this.mergeAttributes(t).isEqual(t) || (s++, n--);
              }
              return Fi._createFromParentsAndOffsets(t, e, t, n);
            }
            _unwrapChildren(t, e, n, o) {
              let i = e;
              const r = [];
              for (; i < n; ) {
                const e = t.getChild(i);
                if (e.is("attributeElement"))
                  if (e.isSimilar(o)) {
                    const o = e.getChildren(),
                      s = e.childCount;
                    e._remove(),
                      t._insertChild(i, o),
                      this._removeFromClonedElementsGroup(e),
                      r.push(new Vi(t, i), new Vi(t, i + s)),
                      (i += s),
                      (n += s - 1);
                  } else
                    this._unwrapAttributeElement(o, e)
                      ? (r.push(new Vi(t, i), new Vi(t, i + 1)), i++)
                      : (this._unwrapChildren(e, 0, e.childCount, o), i++);
                else i++;
              }
              let s = 0;
              for (const t of r) {
                if (((t.offset -= s), t.offset == e || t.offset == n)) continue;
                this.mergeAttributes(t).isEqual(t) || (s++, n--);
              }
              return Fi._createFromParentsAndOffsets(t, e, t, n);
            }
            _wrapRange(t, e) {
              const { start: n, end: o } = this._breakAttributesRange(t, !0),
                i = n.parent,
                r = this._wrapChildren(i, n.offset, o.offset, e),
                s = this.mergeAttributes(r.start);
              s.isEqual(r.start) || r.end.offset--;
              const a = this.mergeAttributes(r.end);
              return new Fi(s, a);
            }
            _wrapPosition(t, e) {
              if (e.isSimilar(t.parent)) return Er(t.clone());
              t.parent.is("$text") && (t = Dr(t));
              const n = this.createAttributeElement(
                "_wrapPosition-fake-element"
              );
              (n._priority = Number.POSITIVE_INFINITY),
                (n.isSimilar = () => !1),
                t.parent._insertChild(t.offset, n);
              const o = new Fi(t, t.getShiftedBy(1));
              this.wrap(o, e);
              const i = new Vi(n.parent, n.index);
              n._remove();
              const r = i.nodeBefore,
                s = i.nodeAfter;
              return r instanceof To && s instanceof To ? Sr(r, s) : Er(i);
            }
            _wrapAttributeElement(t, e) {
              if (!Nr(t, e)) return !1;
              if (t.name !== e.name || t.priority !== e.priority) return !1;
              for (const n of t.getAttributeKeys())
                if (
                  "class" !== n &&
                  "style" !== n &&
                  e.hasAttribute(n) &&
                  e.getAttribute(n) !== t.getAttribute(n)
                )
                  return !1;
              for (const n of t.getStyleNames())
                if (e.hasStyle(n) && e.getStyle(n) !== t.getStyle(n)) return !1;
              for (const n of t.getAttributeKeys())
                "class" !== n &&
                  "style" !== n &&
                  (e.hasAttribute(n) ||
                    this.setAttribute(n, t.getAttribute(n), e));
              for (const n of t.getStyleNames())
                e.hasStyle(n) || this.setStyle(n, t.getStyle(n), e);
              for (const n of t.getClassNames())
                e.hasClass(n) || this.addClass(n, e);
              return !0;
            }
            _unwrapAttributeElement(t, e) {
              if (!Nr(t, e)) return !1;
              if (t.name !== e.name || t.priority !== e.priority) return !1;
              for (const n of t.getAttributeKeys())
                if (
                  "class" !== n &&
                  "style" !== n &&
                  (!e.hasAttribute(n) ||
                    e.getAttribute(n) !== t.getAttribute(n))
                )
                  return !1;
              if (!e.hasClass(...t.getClassNames())) return !1;
              for (const n of t.getStyleNames())
                if (!e.hasStyle(n) || e.getStyle(n) !== t.getStyle(n))
                  return !1;
              for (const n of t.getAttributeKeys())
                "class" !== n && "style" !== n && this.removeAttribute(n, e);
              return (
                this.removeClass(Array.from(t.getClassNames()), e),
                this.removeStyle(Array.from(t.getStyleNames()), e),
                !0
              );
            }
            _breakAttributesRange(t, e = !1) {
              const n = t.start,
                o = t.end;
              if ((Br(t, this.document), t.isCollapsed)) {
                const n = this._breakAttributes(t.start, e);
                return new Fi(n, n);
              }
              const i = this._breakAttributes(o, e),
                r = i.parent.childCount,
                s = this._breakAttributes(n, e);
              return (i.offset += i.parent.childCount - r), new Fi(s, i);
            }
            _breakAttributes(t, e = !1) {
              const n = t.offset,
                o = t.parent;
              if (t.parent.is("emptyElement"))
                throw new l(
                  "view-writer-cannot-break-empty-element",
                  this.document
                );
              if (t.parent.is("uiElement"))
                throw new l(
                  "view-writer-cannot-break-ui-element",
                  this.document
                );
              if (t.parent.is("rawElement"))
                throw new l(
                  "view-writer-cannot-break-raw-element",
                  this.document
                );
              if (!e && o.is("$text") && Mr(o.parent)) return t.clone();
              if (Mr(o)) return t.clone();
              if (o.is("$text")) return this._breakAttributes(Dr(t), e);
              if (n == o.childCount) {
                const t = new Vi(o.parent, o.index + 1);
                return this._breakAttributes(t, e);
              }
              if (0 === n) {
                const t = new Vi(o.parent, o.index);
                return this._breakAttributes(t, e);
              }
              {
                const t = o.index + 1,
                  i = o._clone();
                o.parent._insertChild(t, i), this._addToClonedElementsGroup(i);
                const r = o.childCount - n,
                  s = o._removeChildren(n, r);
                i._appendChild(s);
                const a = new Vi(o.parent, t);
                return this._breakAttributes(a, e);
              }
            }
            _addToClonedElementsGroup(t) {
              if (!t.root.is("rootElement")) return;
              if (t.is("element"))
                for (const e of t.getChildren())
                  this._addToClonedElementsGroup(e);
              const e = t.id;
              if (!e) return;
              let n = this._cloneGroups.get(e);
              n || ((n = new Set()), this._cloneGroups.set(e, n)),
                n.add(t),
                (t._clonesGroup = n);
            }
            _removeFromClonedElementsGroup(t) {
              if (t.is("element"))
                for (const e of t.getChildren())
                  this._removeFromClonedElementsGroup(e);
              const e = t.id;
              if (!e) return;
              const n = this._cloneGroups.get(e);
              n && n.delete(t);
            }
          }
          function yr(t) {
            let e = t.parent;
            for (; !Mr(e); ) {
              if (!e) return;
              e = e.parent;
            }
            return e;
          }
          function xr(t, e) {
            return (
              t.priority < e.priority ||
              (!(t.priority > e.priority) && t.getIdentity() < e.getIdentity())
            );
          }
          function Er(t) {
            const e = t.nodeBefore;
            if (e && e.is("$text")) return new Vi(e, e.data.length);
            const n = t.nodeAfter;
            return n && n.is("$text") ? new Vi(n, 0) : t;
          }
          function Dr(t) {
            if (t.offset == t.parent.data.length)
              return new Vi(t.parent.parent, t.parent.index + 1);
            if (0 === t.offset) return new Vi(t.parent.parent, t.parent.index);
            const e = t.parent.data.slice(t.offset);
            return (
              (t.parent._data = t.parent.data.slice(0, t.offset)),
              t.parent.parent._insertChild(
                t.parent.index + 1,
                new To(t.root.document, e)
              ),
              new Vi(t.parent.parent, t.parent.index + 1)
            );
          }
          function Sr(t, e) {
            const n = t.data.length;
            return (t._data += e.data), e._remove(), new Vi(t, n);
          }
          const Ir = [To, tr, zi, or, Ar, kr];
          function Tr(t, e) {
            for (const n of t) {
              if (!Ir.some((t) => n instanceof t))
                throw new l("view-writer-insert-invalid-node-type", e);
              n.is("$text") || Tr(n.getChildren(), e);
            }
          }
          function Mr(t) {
            return t && (t.is("containerElement") || t.is("documentFragment"));
          }
          function Br(t, e) {
            const n = yr(t.start),
              o = yr(t.end);
            if (!n || !o || n !== o)
              throw new l("view-writer-invalid-range-container", e);
          }
          function Nr(t, e) {
            return null === t.id && null === e.id;
          }
          function zr(t) {
            return "[object Text]" == Object.prototype.toString.call(t);
          }
          const Pr = (t) => t.createTextNode(" "),
            Lr = (t) => {
              const e = t.createElement("span");
              return (e.dataset.ckeFiller = "true"), (e.innerText = " "), e;
            },
            Rr = (t) => {
              const e = t.createElement("br");
              return (e.dataset.ckeFiller = "true"), e;
            },
            Or = "⁠".repeat(7);
          function jr(t) {
            return zr(t) && t.data.substr(0, 7) === Or;
          }
          function Vr(t) {
            return 7 == t.data.length && jr(t);
          }
          function Fr(t) {
            return jr(t) ? t.data.slice(7) : t.data;
          }
          function Hr(t, e) {
            if (e.keyCode == ur.arrowleft) {
              const t = e.domTarget.ownerDocument.defaultView.getSelection();
              if (1 == t.rangeCount && t.getRangeAt(0).collapsed) {
                const e = t.getRangeAt(0).startContainer,
                  n = t.getRangeAt(0).startOffset;
                jr(e) && n <= 7 && t.collapse(e, 0);
              }
            }
          }
          function Ur(t, e, n, o = !1) {
            n =
              n ||
              function (t, e) {
                return t === e;
              };
            const i = Array.isArray(t) ? t : Array.prototype.slice.call(t),
              r = Array.isArray(e) ? e : Array.prototype.slice.call(e),
              s = (function (t, e, n) {
                const o = Wr(t, e, n);
                if (-1 === o)
                  return { firstIndex: -1, lastIndexOld: -1, lastIndexNew: -1 };
                const i = $r(t, o),
                  r = $r(e, o),
                  s = Wr(i, r, n),
                  a = t.length - s,
                  l = e.length - s;
                return { firstIndex: o, lastIndexOld: a, lastIndexNew: l };
              })(i, r, n);
            return o
              ? (function (t, e) {
                  const { firstIndex: n, lastIndexOld: o, lastIndexNew: i } = t;
                  if (-1 === n) return Array(e).fill("equal");
                  let r = [];
                  n > 0 && (r = r.concat(Array(n).fill("equal")));
                  i - n > 0 && (r = r.concat(Array(i - n).fill("insert")));
                  o - n > 0 && (r = r.concat(Array(o - n).fill("delete")));
                  i < e && (r = r.concat(Array(e - i).fill("equal")));
                  return r;
                })(s, r.length)
              : (function (t, e) {
                  const n = [],
                    { firstIndex: o, lastIndexOld: i, lastIndexNew: r } = e;
                  r - o > 0 &&
                    n.push({ index: o, type: "insert", values: t.slice(o, r) });
                  i - o > 0 &&
                    n.push({
                      index: o + (r - o),
                      type: "delete",
                      howMany: i - o,
                    });
                  return n;
                })(r, s);
          }
          function Wr(t, e, n) {
            for (let o = 0; o < Math.max(t.length, e.length); o++)
              if (void 0 === t[o] || void 0 === e[o] || !n(t[o], e[o]))
                return o;
            return -1;
          }
          function $r(t, e) {
            return t.slice(e).reverse();
          }
          function qr(t, e, n) {
            n =
              n ||
              function (t, e) {
                return t === e;
              };
            const o = t.length,
              i = e.length;
            if (o > 200 || i > 200 || o + i > 300)
              return qr.fastDiff(t, e, n, !0);
            let r, s;
            if (i < o) {
              const n = t;
              (t = e), (e = n), (r = "delete"), (s = "insert");
            } else (r = "insert"), (s = "delete");
            const a = t.length,
              l = e.length,
              c = l - a,
              d = {},
              u = {};
            function h(o) {
              const i = (void 0 !== u[o - 1] ? u[o - 1] : -1) + 1,
                c = void 0 !== u[o + 1] ? u[o + 1] : -1,
                h = i > c ? -1 : 1;
              d[o + h] && (d[o] = d[o + h].slice(0)),
                d[o] || (d[o] = []),
                d[o].push(i > c ? r : s);
              let m = Math.max(i, c),
                g = m - o;
              for (; g < a && m < l && n(t[g], e[m]); )
                g++, m++, d[o].push("equal");
              return m;
            }
            let m,
              g = 0;
            do {
              for (m = -g; m < c; m++) u[m] = h(m);
              for (m = c + g; m > c; m--) u[m] = h(m);
              (u[c] = h(c)), g++;
            } while (u[c] !== l);
            return d[c].slice(1);
          }
          function Gr(t, e, n) {
            t.insertBefore(n, t.childNodes[e] || null);
          }
          function Zr(t) {
            const e = t.parentNode;
            e && e.removeChild(t);
          }
          function Yr(t) {
            return t && t.nodeType === Node.COMMENT_NODE;
          }
          function Kr(t) {
            if (t) {
              if (t.defaultView) return t instanceof t.defaultView.Document;
              if (t.ownerDocument && t.ownerDocument.defaultView)
                return t instanceof t.ownerDocument.defaultView.Node;
            }
            return !1;
          }
          qr.fastDiff = Ur;
          var Qr = n(3379),
            Jr = n.n(Qr),
            Xr = n(9037),
            ts = n.n(Xr),
            es = n(569),
            ns = n.n(es),
            os = n(8575),
            is = n.n(os),
            rs = n(9216),
            ss = n.n(rs),
            as = n(4401),
            ls = { attributes: { "data-cke": !0 } };
          (ls.setAttributes = is()),
            (ls.insert = ns().bind(null, "head")),
            (ls.domAPI = ts()),
            (ls.insertStyleElement = ss());
          Jr()(as.Z, ls);
          as.Z && as.Z.locals && as.Z.locals;
          class cs extends N {
            constructor(t, e) {
              super(),
                (this.domDocuments = new Set()),
                (this.domConverter = t),
                (this.markedAttributes = new Set()),
                (this.markedChildren = new Set()),
                (this.markedTexts = new Set()),
                (this.selection = e),
                this.set("isFocused", !1),
                this.set("isSelecting", !1),
                ar.isBlink &&
                  !ar.isAndroid &&
                  this.on("change:isSelecting", () => {
                    this.isSelecting || this.render();
                  }),
                this.set("isComposing", !1),
                this.on("change:isComposing", () => {
                  this.isComposing || this.render();
                }),
                (this._inlineFiller = null),
                (this._fakeSelectionContainer = null);
            }
            markToSync(t, e) {
              if ("text" === t)
                this.domConverter.mapViewToDom(e.parent) &&
                  this.markedTexts.add(e);
              else {
                if (!this.domConverter.mapViewToDom(e)) return;
                if ("attributes" === t) this.markedAttributes.add(e);
                else {
                  if ("children" !== t)
                    throw new l("view-renderer-unknown-type", this);
                  this.markedChildren.add(e);
                }
              }
            }
            render() {
              if (this.isComposing && !ar.isAndroid) return;
              let t = null;
              const e = !(ar.isBlink && !ar.isAndroid) || !this.isSelecting;
              for (const t of this.markedChildren)
                this._updateChildrenMappings(t);
              e
                ? (this._inlineFiller &&
                    !this._isSelectionInInlineFiller() &&
                    this._removeInlineFiller(),
                  this._inlineFiller
                    ? (t = this._getInlineFillerPosition())
                    : this._needsInlineFillerAtSelection() &&
                      ((t = this.selection.getFirstPosition()),
                      this.markedChildren.add(t.parent)))
                : this._inlineFiller &&
                  this._inlineFiller.parentNode &&
                  ((t = this.domConverter.domPositionToView(
                    this._inlineFiller
                  )),
                  t &&
                    t.parent.is("$text") &&
                    (t = Vi._createBefore(t.parent)));
              for (const t of this.markedAttributes) this._updateAttrs(t);
              for (const e of this.markedChildren)
                this._updateChildren(e, { inlineFillerPosition: t });
              for (const e of this.markedTexts)
                !this.markedChildren.has(e.parent) &&
                  this.domConverter.mapViewToDom(e.parent) &&
                  this._updateText(e, { inlineFillerPosition: t });
              if (e)
                if (t) {
                  const e = this.domConverter.viewPositionToDom(t),
                    n = e.parent.ownerDocument;
                  jr(e.parent)
                    ? (this._inlineFiller = e.parent)
                    : (this._inlineFiller = ds(n, e.parent, e.offset));
                } else this._inlineFiller = null;
              this._updateFocus(),
                this._updateSelection(),
                this.markedTexts.clear(),
                this.markedAttributes.clear(),
                this.markedChildren.clear();
            }
            _updateChildrenMappings(t) {
              if (!this.domConverter.mapViewToDom(t)) return;
              const e = Array.from(
                  this.domConverter.mapViewToDom(t).childNodes
                ),
                n = Array.from(
                  this.domConverter.viewChildrenToDom(t, { withChildren: !1 })
                ),
                o = this._diffNodeLists(e, n),
                i = this._findReplaceActions(o, e, n);
              if (-1 !== i.indexOf("replace")) {
                const o = { equal: 0, insert: 0, delete: 0 };
                for (const r of i)
                  if ("replace" === r) {
                    const i = o.equal + o.insert,
                      r = o.equal + o.delete,
                      s = t.getChild(i);
                    !s ||
                      s.is("uiElement") ||
                      s.is("rawElement") ||
                      this._updateElementMappings(s, e[r]),
                      Zr(n[i]),
                      o.equal++;
                  } else o[r]++;
              }
            }
            _updateElementMappings(t, e) {
              this.domConverter.unbindDomElement(e),
                this.domConverter.bindElements(e, t),
                this.markedChildren.add(t),
                this.markedAttributes.add(t);
            }
            _getInlineFillerPosition() {
              const t = this.selection.getFirstPosition();
              return t.parent.is("$text") ? Vi._createBefore(t.parent) : t;
            }
            _isSelectionInInlineFiller() {
              if (1 != this.selection.rangeCount || !this.selection.isCollapsed)
                return !1;
              const t = this.selection.getFirstPosition(),
                e = this.domConverter.viewPositionToDom(t);
              return !!(e && zr(e.parent) && jr(e.parent));
            }
            _removeInlineFiller() {
              const t = this._inlineFiller;
              if (!jr(t)) throw new l("view-renderer-filler-was-lost", this);
              Vr(t) ? t.remove() : (t.data = t.data.substr(7)),
                (this._inlineFiller = null);
            }
            _needsInlineFillerAtSelection() {
              if (1 != this.selection.rangeCount || !this.selection.isCollapsed)
                return !1;
              const t = this.selection.getFirstPosition(),
                e = t.parent,
                n = t.offset;
              if (!this.domConverter.mapViewToDom(e.root)) return !1;
              if (!e.is("element")) return !1;
              if (
                !(function (t) {
                  if ("false" == t.getAttribute("contenteditable")) return !1;
                  const e = t.findAncestor((t) =>
                    t.hasAttribute("contenteditable")
                  );
                  return !e || "true" == e.getAttribute("contenteditable");
                })(e)
              )
                return !1;
              if (n === e.getFillerOffset()) return !1;
              const o = t.nodeBefore,
                i = t.nodeAfter;
              return (
                !(o instanceof To || i instanceof To) &&
                (!ar.isAndroid || (!o && !i))
              );
            }
            _updateText(t, e) {
              const n = this.domConverter.findCorrespondingDomText(t);
              let o = this.domConverter.viewToDom(t).data;
              const i = e.inlineFillerPosition;
              i && i.parent == t.parent && i.offset == t.index && (o = Or + o),
                gs(n, o);
            }
            _updateAttrs(t) {
              const e = this.domConverter.mapViewToDom(t);
              if (!e) return;
              const n = Array.from(e.attributes).map((t) => t.name),
                o = t.getAttributeKeys();
              for (const n of o)
                this.domConverter.setDomElementAttribute(
                  e,
                  n,
                  t.getAttribute(n),
                  t
                );
              for (const o of n)
                t.hasAttribute(o) ||
                  this.domConverter.removeDomElementAttribute(e, o);
            }
            _updateChildren(t, e) {
              const n = this.domConverter.mapViewToDom(t);
              if (!n) return;
              if (ar.isAndroid) {
                let t = null;
                for (const e of Array.from(n.childNodes)) {
                  if (t && zr(t) && zr(e)) {
                    n.normalize();
                    break;
                  }
                  t = e;
                }
              }
              const o = e.inlineFillerPosition,
                i = n.childNodes,
                r = Array.from(
                  this.domConverter.viewChildrenToDom(t, { bind: !0 })
                );
              o && o.parent === t && ds(n.ownerDocument, r, o.offset);
              const s = this._diffNodeLists(i, r),
                a = ar.isAndroid
                  ? this._findReplaceActions(s, i, r, { replaceText: !0 })
                  : s;
              let l = 0;
              const c = new Set();
              for (const t of a)
                "delete" === t
                  ? (c.add(i[l]), Zr(i[l]))
                  : ("equal" !== t && "replace" !== t) || l++;
              l = 0;
              for (const t of a)
                "insert" === t
                  ? (Gr(n, l, r[l]), l++)
                  : "replace" === t
                  ? (gs(i[l], r[l].data), l++)
                  : "equal" === t &&
                    (this._markDescendantTextToSync(
                      this.domConverter.domToView(r[l])
                    ),
                    l++);
              for (const t of c)
                t.parentNode || this.domConverter.unbindDomElement(t);
            }
            _diffNodeLists(t, e) {
              return qr(
                (t = (function (t, e) {
                  const n = Array.from(t);
                  if (0 == n.length || !e) return n;
                  n[n.length - 1] == e && n.pop();
                  return n;
                })(t, this._fakeSelectionContainer)),
                e,
                ms.bind(null, this.domConverter)
              );
            }
            _findReplaceActions(t, e, n, o = {}) {
              if (-1 === t.indexOf("insert") || -1 === t.indexOf("delete"))
                return t;
              let i = [],
                r = [],
                s = [];
              const a = { equal: 0, insert: 0, delete: 0 };
              for (const l of t)
                "insert" === l
                  ? s.push(n[a.equal + a.insert])
                  : "delete" === l
                  ? r.push(e[a.equal + a.delete])
                  : ((i = i.concat(
                      qr(r, s, o.replaceText ? hs : us).map((t) =>
                        "equal" === t ? "replace" : t
                      )
                    )),
                    i.push("equal"),
                    (r = []),
                    (s = [])),
                  a[l]++;
              return i.concat(
                qr(r, s, o.replaceText ? hs : us).map((t) =>
                  "equal" === t ? "replace" : t
                )
              );
            }
            _markDescendantTextToSync(t) {
              if (t)
                if (t.is("$text")) this.markedTexts.add(t);
                else if (t.is("element"))
                  for (const e of t.getChildren())
                    this._markDescendantTextToSync(e);
            }
            _updateSelection() {
              if (
                ar.isBlink &&
                !ar.isAndroid &&
                this.isSelecting &&
                !this.markedChildren.size
              )
                return;
              if (0 === this.selection.rangeCount)
                return (
                  this._removeDomSelection(), void this._removeFakeSelection()
                );
              const t = this.domConverter.mapViewToDom(
                this.selection.editableElement
              );
              this.isFocused &&
                t &&
                (this.selection.isFake
                  ? this._updateFakeSelection(t)
                  : this._fakeSelectionContainer &&
                    this._fakeSelectionContainer.isConnected
                  ? (this._removeFakeSelection(), this._updateDomSelection(t))
                  : (this.isComposing && ar.isAndroid) ||
                    this._updateDomSelection(t));
            }
            _updateFakeSelection(t) {
              const e = t.ownerDocument;
              this._fakeSelectionContainer ||
                (this._fakeSelectionContainer = (function (t) {
                  const e = t.createElement("div");
                  return (
                    (e.className = "ck-fake-selection-container"),
                    Object.assign(e.style, {
                      position: "fixed",
                      top: 0,
                      left: "-9999px",
                      width: "42px",
                    }),
                    (e.textContent = " "),
                    e
                  );
                })(e));
              const n = this._fakeSelectionContainer;
              if (
                (this.domConverter.bindFakeSelection(n, this.selection),
                !this._fakeSelectionNeedsUpdate(t))
              )
                return;
              (n.parentElement && n.parentElement == t) || t.appendChild(n),
                (n.textContent = this.selection.fakeSelectionLabel || " ");
              const o = e.getSelection(),
                i = e.createRange();
              o.removeAllRanges(), i.selectNodeContents(n), o.addRange(i);
            }
            _updateDomSelection(t) {
              const e = t.ownerDocument.defaultView.getSelection();
              if (!this._domSelectionNeedsUpdate(e)) return;
              const n = this.domConverter.viewPositionToDom(
                  this.selection.anchor
                ),
                o = this.domConverter.viewPositionToDom(this.selection.focus);
              e.collapse(n.parent, n.offset),
                e.extend(o.parent, o.offset),
                ar.isGecko &&
                  (function (t, e) {
                    const n = t.parent;
                    if (
                      n.nodeType != Node.ELEMENT_NODE ||
                      t.offset != n.childNodes.length - 1
                    )
                      return;
                    const o = n.childNodes[t.offset];
                    o && "BR" == o.tagName && e.addRange(e.getRangeAt(0));
                  })(o, e);
            }
            _domSelectionNeedsUpdate(t) {
              if (!this.domConverter.isDomSelectionCorrect(t)) return !0;
              const e = t && this.domConverter.domSelectionToView(t);
              return (
                (!e || !this.selection.isEqual(e)) &&
                !(!this.selection.isCollapsed && this.selection.isSimilar(e))
              );
            }
            _fakeSelectionNeedsUpdate(t) {
              const e = this._fakeSelectionContainer,
                n = t.ownerDocument.getSelection();
              return (
                !e ||
                e.parentElement !== t ||
                (n.anchorNode !== e && !e.contains(n.anchorNode)) ||
                e.textContent !== this.selection.fakeSelectionLabel
              );
            }
            _removeDomSelection() {
              for (const t of this.domDocuments) {
                const e = t.getSelection();
                if (e.rangeCount) {
                  const n = t.activeElement,
                    o = this.domConverter.mapDomToView(n);
                  n && o && e.removeAllRanges();
                }
              }
            }
            _removeFakeSelection() {
              const t = this._fakeSelectionContainer;
              t && t.remove();
            }
            _updateFocus() {
              if (this.isFocused) {
                const t = this.selection.editableElement;
                t && this.domConverter.focus(t);
              }
            }
          }
          function ds(t, e, n) {
            const o = e instanceof Array ? e : e.childNodes,
              i = o[n];
            if (zr(i)) return (i.data = Or + i.data), i;
            {
              const i = t.createTextNode(Or);
              return Array.isArray(e) ? o.splice(n, 0, i) : Gr(e, n, i), i;
            }
          }
          function us(t, e) {
            return (
              Kr(t) &&
              Kr(e) &&
              !zr(t) &&
              !zr(e) &&
              !Yr(t) &&
              !Yr(e) &&
              t.tagName.toLowerCase() === e.tagName.toLowerCase()
            );
          }
          function hs(t, e) {
            return Kr(t) && Kr(e) && zr(t) && zr(e);
          }
          function ms(t, e, n) {
            return (
              e === n ||
              (zr(e) && zr(n)
                ? e.data === n.data
                : !(!t.isBlockFiller(e) || !t.isBlockFiller(n)))
            );
          }
          function gs(t, e) {
            const n = t.data;
            if (n == e) return;
            const o = Ur(n, e);
            for (const e of o)
              "insert" === e.type
                ? t.insertData(e.index, e.values.join(""))
                : t.deleteData(e.index, e.howMany);
          }
          function ps(t) {
            let e = 0;
            for (; t.previousSibling; ) (t = t.previousSibling), e++;
            return e;
          }
          function fs(t) {
            const e = [];
            let n = t;
            for (; n && n.nodeType != Node.DOCUMENT_NODE; )
              e.unshift(n), (n = n.parentNode);
            return e;
          }
          const ks = Rr(wo.document),
            bs = Pr(wo.document),
            ws = Lr(wo.document),
            As = "data-ck-unsafe-attribute-",
            _s = "data-ck-unsafe-element";
          class Cs {
            constructor(t, e = {}) {
              (this.document = t),
                (this.renderingMode = e.renderingMode || "editing"),
                (this.blockFillerMode =
                  e.blockFillerMode ||
                  ("editing" === this.renderingMode ? "br" : "nbsp")),
                (this.preElements = ["pre"]),
                (this.blockElements = [
                  "address",
                  "article",
                  "aside",
                  "blockquote",
                  "caption",
                  "center",
                  "dd",
                  "details",
                  "dir",
                  "div",
                  "dl",
                  "dt",
                  "fieldset",
                  "figcaption",
                  "figure",
                  "footer",
                  "form",
                  "h1",
                  "h2",
                  "h3",
                  "h4",
                  "h5",
                  "h6",
                  "header",
                  "hgroup",
                  "legend",
                  "li",
                  "main",
                  "menu",
                  "nav",
                  "ol",
                  "p",
                  "pre",
                  "section",
                  "summary",
                  "table",
                  "tbody",
                  "td",
                  "tfoot",
                  "th",
                  "thead",
                  "tr",
                  "ul",
                ]),
                (this.inlineObjectElements = [
                  "object",
                  "iframe",
                  "input",
                  "button",
                  "textarea",
                  "select",
                  "option",
                  "video",
                  "embed",
                  "audio",
                  "img",
                  "canvas",
                ]),
                (this.unsafeElements = ["script", "style"]),
                (this._domDocument =
                  "editing" === this.renderingMode
                    ? wo.document
                    : wo.document.implementation.createHTMLDocument("")),
                (this._domToViewMapping = new WeakMap()),
                (this._viewToDomMapping = new WeakMap()),
                (this._fakeSelectionMapping = new WeakMap()),
                (this._rawContentElementMatcher = new No()),
                (this._encounteredRawContentDomNodes = new WeakSet());
            }
            bindFakeSelection(t, e) {
              this._fakeSelectionMapping.set(t, new Wi(e));
            }
            fakeSelectionToView(t) {
              return this._fakeSelectionMapping.get(t);
            }
            bindElements(t, e) {
              this._domToViewMapping.set(t, e),
                this._viewToDomMapping.set(e, t);
            }
            unbindDomElement(t) {
              const e = this._domToViewMapping.get(t);
              if (e) {
                this._domToViewMapping.delete(t),
                  this._viewToDomMapping.delete(e);
                for (const e of Array.from(t.children))
                  this.unbindDomElement(e);
              }
            }
            bindDocumentFragments(t, e) {
              this._domToViewMapping.set(t, e),
                this._viewToDomMapping.set(e, t);
            }
            shouldRenderAttribute(t, e, n) {
              return (
                "data" === this.renderingMode ||
                (!(t = t.toLowerCase()).startsWith("on") &&
                  ("srcdoc" !== t ||
                    !e.match(/\bon\S+\s*=|javascript:|<\s*\/*script/i)) &&
                  (("img" === n && ("src" === t || "srcset" === t)) ||
                    ("source" === n && "srcset" === t) ||
                    !e.match(
                      /^\s*(javascript:|data:(image\/svg|text\/x?html))/i
                    )))
              );
            }
            setContentOf(t, e) {
              if ("data" === this.renderingMode) return void (t.innerHTML = e);
              const n = new DOMParser().parseFromString(e, "text/html"),
                o = n.createDocumentFragment(),
                i = n.body.childNodes;
              for (; i.length > 0; ) o.appendChild(i[0]);
              const r = n.createTreeWalker(o, NodeFilter.SHOW_ELEMENT),
                s = [];
              let a;
              for (; (a = r.nextNode()); ) s.push(a);
              for (const t of s) {
                for (const e of t.getAttributeNames())
                  this.setDomElementAttribute(t, e, t.getAttribute(e));
                const e = t.tagName.toLowerCase();
                this._shouldRenameElement(e) &&
                  (xs(e),
                  t.replaceWith(this._createReplacementDomElement(e, t)));
              }
              for (; t.firstChild; ) t.firstChild.remove();
              t.append(o);
            }
            viewToDom(t, e = {}) {
              if (t.is("$text")) {
                const e = this._processDataFromViewText(t);
                return this._domDocument.createTextNode(e);
              }
              {
                if (this.mapViewToDom(t)) return this.mapViewToDom(t);
                let n;
                if (t.is("documentFragment"))
                  (n = this._domDocument.createDocumentFragment()),
                    e.bind && this.bindDocumentFragments(n, t);
                else {
                  if (t.is("uiElement"))
                    return (
                      (n =
                        "$comment" === t.name
                          ? this._domDocument.createComment(
                              t.getCustomProperty("$rawContent")
                            )
                          : t.render(this._domDocument, this)),
                      e.bind && this.bindElements(n, t),
                      n
                    );
                  this._shouldRenameElement(t.name)
                    ? (xs(t.name),
                      (n = this._createReplacementDomElement(t.name)))
                    : (n = t.hasAttribute("xmlns")
                        ? this._domDocument.createElementNS(
                            t.getAttribute("xmlns"),
                            t.name
                          )
                        : this._domDocument.createElement(t.name)),
                    t.is("rawElement") && t.render(n, this),
                    e.bind && this.bindElements(n, t);
                  for (const e of t.getAttributeKeys())
                    this.setDomElementAttribute(n, e, t.getAttribute(e), t);
                }
                if (!1 !== e.withChildren)
                  for (const o of this.viewChildrenToDom(t, e))
                    n.appendChild(o);
                return n;
              }
            }
            setDomElementAttribute(t, e, n, o) {
              const i =
                this.shouldRenderAttribute(e, n, t.tagName.toLowerCase()) ||
                (o && o.shouldRenderUnsafeAttribute(e));
              i ||
                c("domconverter-unsafe-attribute-detected", {
                  domElement: t,
                  key: e,
                  value: n,
                }),
                t.hasAttribute(e) && !i
                  ? t.removeAttribute(e)
                  : t.hasAttribute(As + e) && i && t.removeAttribute(As + e),
                t.setAttribute(i ? e : As + e, n);
            }
            removeDomElementAttribute(t, e) {
              e != _s && (t.removeAttribute(e), t.removeAttribute(As + e));
            }
            *viewChildrenToDom(t, e = {}) {
              const n = t.getFillerOffset && t.getFillerOffset();
              let o = 0;
              for (const i of t.getChildren()) {
                n === o && (yield this._getBlockFiller());
                const t =
                  i.is("element") &&
                  i.getCustomProperty("dataPipeline:transparentRendering");
                t && "data" == this.renderingMode
                  ? yield* this.viewChildrenToDom(i, e)
                  : (t &&
                      c(
                        "domconverter-transparent-rendering-unsupported-in-editing-pipeline",
                        { viewElement: i }
                      ),
                    yield this.viewToDom(i, e)),
                  o++;
              }
              n === o && (yield this._getBlockFiller());
            }
            viewRangeToDom(t) {
              const e = this.viewPositionToDom(t.start),
                n = this.viewPositionToDom(t.end),
                o = this._domDocument.createRange();
              return (
                o.setStart(e.parent, e.offset), o.setEnd(n.parent, n.offset), o
              );
            }
            viewPositionToDom(t) {
              const e = t.parent;
              if (e.is("$text")) {
                const n = this.findCorrespondingDomText(e);
                if (!n) return null;
                let o = t.offset;
                return jr(n) && (o += 7), { parent: n, offset: o };
              }
              {
                let n, o, i;
                if (0 === t.offset) {
                  if (((n = this.mapViewToDom(e)), !n)) return null;
                  i = n.childNodes[0];
                } else {
                  const e = t.nodeBefore;
                  if (
                    ((o = e.is("$text")
                      ? this.findCorrespondingDomText(e)
                      : this.mapViewToDom(e)),
                    !o)
                  )
                    return null;
                  (n = o.parentNode), (i = o.nextSibling);
                }
                if (zr(i) && jr(i)) return { parent: i, offset: 7 };
                return { parent: n, offset: o ? ps(o) + 1 : 0 };
              }
            }
            domToView(t, e = {}) {
              if (this.isBlockFiller(t)) return null;
              const n = this.getHostViewElement(t);
              if (n) return n;
              if (Yr(t) && e.skipComments) return null;
              if (zr(t)) {
                if (Vr(t)) return null;
                {
                  const e = this._processDataFromDomText(t);
                  return "" === e ? null : new To(this.document, e);
                }
              }
              {
                if (this.mapDomToView(t)) return this.mapDomToView(t);
                let n;
                if (this.isDocumentFragment(t))
                  (n = new Cr(this.document)),
                    e.bind && this.bindDocumentFragments(t, n);
                else {
                  (n = this._createViewElement(t, e)),
                    e.bind && this.bindElements(t, n);
                  const o = t.attributes;
                  if (o)
                    for (let t = o.length, e = 0; e < t; e++)
                      n._setAttribute(o[e].name, o[e].value);
                  if (this._isViewElementWithRawContent(n, e) || Yr(t)) {
                    const e = Yr(t) ? t.data : t.innerHTML;
                    return (
                      n._setCustomProperty("$rawContent", e),
                      this._encounteredRawContentDomNodes.add(t),
                      n
                    );
                  }
                }
                if (!1 !== e.withChildren)
                  for (const o of this.domChildrenToView(t, e))
                    n._appendChild(o);
                return n;
              }
            }
            *domChildrenToView(t, e) {
              for (let n = 0; n < t.childNodes.length; n++) {
                const o = t.childNodes[n],
                  i = this.domToView(o, e);
                null !== i && (yield i);
              }
            }
            domSelectionToView(t) {
              if (1 === t.rangeCount) {
                let e = t.getRangeAt(0).startContainer;
                zr(e) && (e = e.parentNode);
                const n = this.fakeSelectionToView(e);
                if (n) return n;
              }
              const e = this.isDomSelectionBackward(t),
                n = [];
              for (let e = 0; e < t.rangeCount; e++) {
                const o = t.getRangeAt(e),
                  i = this.domRangeToView(o);
                i && n.push(i);
              }
              return new Wi(n, { backward: e });
            }
            domRangeToView(t) {
              const e = this.domPositionToView(t.startContainer, t.startOffset),
                n = this.domPositionToView(t.endContainer, t.endOffset);
              return e && n ? new Fi(e, n) : null;
            }
            domPositionToView(t, e = 0) {
              if (this.isBlockFiller(t))
                return this.domPositionToView(t.parentNode, ps(t));
              const n = this.mapDomToView(t);
              if (n && (n.is("uiElement") || n.is("rawElement")))
                return Vi._createBefore(n);
              if (zr(t)) {
                if (Vr(t)) return this.domPositionToView(t.parentNode, ps(t));
                const n = this.findCorrespondingViewText(t);
                let o = e;
                return n
                  ? (jr(t) && ((o -= 7), (o = o < 0 ? 0 : o)), new Vi(n, o))
                  : null;
              }
              if (0 === e) {
                const e = this.mapDomToView(t);
                if (e) return new Vi(e, 0);
              } else {
                const n = t.childNodes[e - 1];
                if (zr(n) && Vr(n))
                  return this.domPositionToView(n.parentNode, ps(n));
                const o = zr(n)
                  ? this.findCorrespondingViewText(n)
                  : this.mapDomToView(n);
                if (o && o.parent) return new Vi(o.parent, o.index + 1);
              }
              return null;
            }
            mapDomToView(t) {
              return (
                this.getHostViewElement(t) || this._domToViewMapping.get(t)
              );
            }
            findCorrespondingViewText(t) {
              if (Vr(t)) return null;
              const e = this.getHostViewElement(t);
              if (e) return e;
              const n = t.previousSibling;
              if (n) {
                if (!this.isElement(n)) return null;
                const t = this.mapDomToView(n);
                if (t) {
                  const e = t.nextSibling;
                  return e instanceof To ? e : null;
                }
              } else {
                const e = this.mapDomToView(t.parentNode);
                if (e) {
                  const t = e.getChild(0);
                  return t instanceof To ? t : null;
                }
              }
              return null;
            }
            mapViewToDom(t) {
              return this._viewToDomMapping.get(t);
            }
            findCorrespondingDomText(t) {
              const e = t.previousSibling;
              return e && this.mapViewToDom(e)
                ? this.mapViewToDom(e).nextSibling
                : !e && t.parent && this.mapViewToDom(t.parent)
                ? this.mapViewToDom(t.parent).childNodes[0]
                : null;
            }
            focus(t) {
              const e = this.mapViewToDom(t);
              if (e && e.ownerDocument.activeElement !== e) {
                const { scrollX: t, scrollY: n } = wo.window,
                  o = [];
                vs(e, (t) => {
                  const { scrollLeft: e, scrollTop: n } = t;
                  o.push([e, n]);
                }),
                  e.focus(),
                  vs(e, (t) => {
                    const [e, n] = o.shift();
                    (t.scrollLeft = e), (t.scrollTop = n);
                  }),
                  wo.window.scrollTo(t, n);
              }
            }
            isElement(t) {
              return t && t.nodeType == Node.ELEMENT_NODE;
            }
            isDocumentFragment(t) {
              return t && t.nodeType == Node.DOCUMENT_FRAGMENT_NODE;
            }
            isBlockFiller(t) {
              return "br" == this.blockFillerMode
                ? t.isEqualNode(ks)
                : !(
                    "BR" !== t.tagName ||
                    !ys(t, this.blockElements) ||
                    1 !== t.parentNode.childNodes.length
                  ) ||
                    t.isEqualNode(ws) ||
                    (function (t, e) {
                      return (
                        t.isEqualNode(bs) &&
                        ys(t, e) &&
                        1 === t.parentNode.childNodes.length
                      );
                    })(t, this.blockElements);
            }
            isDomSelectionBackward(t) {
              if (t.isCollapsed) return !1;
              const e = this._domDocument.createRange();
              try {
                e.setStart(t.anchorNode, t.anchorOffset),
                  e.setEnd(t.focusNode, t.focusOffset);
              } catch (t) {
                return !1;
              }
              const n = e.collapsed;
              return e.detach(), n;
            }
            getHostViewElement(t) {
              const e = fs(t);
              for (e.pop(); e.length; ) {
                const t = e.pop(),
                  n = this._domToViewMapping.get(t);
                if (n && (n.is("uiElement") || n.is("rawElement"))) return n;
              }
              return null;
            }
            isDomSelectionCorrect(t) {
              return (
                this._isDomSelectionPositionCorrect(
                  t.anchorNode,
                  t.anchorOffset
                ) &&
                this._isDomSelectionPositionCorrect(t.focusNode, t.focusOffset)
              );
            }
            registerRawContentMatcher(t) {
              this._rawContentElementMatcher.add(t);
            }
            _getBlockFiller() {
              switch (this.blockFillerMode) {
                case "nbsp":
                  return Pr(this._domDocument);
                case "markedNbsp":
                  return Lr(this._domDocument);
                case "br":
                  return Rr(this._domDocument);
              }
            }
            _isDomSelectionPositionCorrect(t, e) {
              if (zr(t) && jr(t) && e < 7) return !1;
              if (this.isElement(t) && jr(t.childNodes[e])) return !1;
              const n = this.mapDomToView(t);
              return !n || (!n.is("uiElement") && !n.is("rawElement"));
            }
            _processDataFromViewText(t) {
              let e = t.data;
              if (
                t.getAncestors().some((t) => this.preElements.includes(t.name))
              )
                return e;
              if (" " == e.charAt(0)) {
                const n = this._getTouchingInlineViewNode(t, !1);
                (!(n && n.is("$textProxy") && this._nodeEndsWithSpace(n)) &&
                  n) ||
                  (e = " " + e.substr(1));
              }
              if (" " == e.charAt(e.length - 1)) {
                const n = this._getTouchingInlineViewNode(t, !0),
                  o = n && n.is("$textProxy") && " " == n.data.charAt(0);
                (" " != e.charAt(e.length - 2) && n && !o) ||
                  (e = e.substr(0, e.length - 1) + " ");
              }
              return e.replace(/ {2}/g, "  ");
            }
            _nodeEndsWithSpace(t) {
              if (
                t.getAncestors().some((t) => this.preElements.includes(t.name))
              )
                return !1;
              const e = this._processDataFromViewText(t);
              return " " == e.charAt(e.length - 1);
            }
            _processDataFromDomText(t) {
              let e = t.data;
              if (
                (function (t, e) {
                  return fs(t).some(
                    (t) => t.tagName && e.includes(t.tagName.toLowerCase())
                  );
                })(t, this.preElements)
              )
                return Fr(t);
              e = e.replace(/[ \n\t\r]{1,}/g, " ");
              const n = this._getTouchingInlineDomNode(t, !1),
                o = this._getTouchingInlineDomNode(t, !0),
                i = this._checkShouldLeftTrimDomText(t, n),
                r = this._checkShouldRightTrimDomText(t, o);
              i && (e = e.replace(/^ /, "")),
                r && (e = e.replace(/ $/, "")),
                (e = Fr(new Text(e))),
                (e = e.replace(/ \u00A0/g, "  "));
              const s = o && this.isElement(o) && "BR" != o.tagName,
                a = o && zr(o) && " " == o.data.charAt(0);
              return (
                (/( |\u00A0)\u00A0$/.test(e) || !o || s || a) &&
                  (e = e.replace(/\u00A0$/, " ")),
                (i || (n && this.isElement(n) && "BR" != n.tagName)) &&
                  (e = e.replace(/^\u00A0/, " ")),
                e
              );
            }
            _checkShouldLeftTrimDomText(t, e) {
              return (
                !e ||
                (this.isElement(e)
                  ? "BR" === e.tagName
                  : !this._encounteredRawContentDomNodes.has(
                      t.previousSibling
                    ) && /[^\S\u00A0]/.test(e.data.charAt(e.data.length - 1)))
              );
            }
            _checkShouldRightTrimDomText(t, e) {
              return !e && !jr(t);
            }
            _getTouchingInlineViewNode(t, e) {
              const n = new ji({
                startPosition: e ? Vi._createAfter(t) : Vi._createBefore(t),
                direction: e ? "forward" : "backward",
              });
              for (const t of n) {
                if (
                  t.item.is("element") &&
                  this.inlineObjectElements.includes(t.item.name)
                )
                  return t.item;
                if (t.item.is("containerElement")) return null;
                if (t.item.is("element", "br")) return null;
                if (t.item.is("$textProxy")) return t.item;
              }
              return null;
            }
            _getTouchingInlineDomNode(t, e) {
              if (!t.parentNode) return null;
              const n = e ? "firstChild" : "lastChild",
                o = e ? "nextSibling" : "previousSibling";
              let i = !0,
                r = t;
              do {
                if (
                  (!i && r[n]
                    ? (r = r[n])
                    : r[o]
                    ? ((r = r[o]), (i = !1))
                    : ((r = r.parentNode), (i = !0)),
                  !r || this._isBlockElement(r))
                )
                  return null;
              } while (
                !zr(r) &&
                "BR" != r.tagName &&
                !this._isInlineObjectElement(r)
              );
              return r;
            }
            _isBlockElement(t) {
              return (
                this.isElement(t) &&
                this.blockElements.includes(t.tagName.toLowerCase())
              );
            }
            _isInlineObjectElement(t) {
              return (
                this.isElement(t) &&
                this.inlineObjectElements.includes(t.tagName.toLowerCase())
              );
            }
            _createViewElement(t, e) {
              if (Yr(t)) return new kr(this.document, "$comment");
              const n = e.keepOriginalCase
                ? t.tagName
                : t.tagName.toLowerCase();
              return new Bi(this.document, n);
            }
            _isViewElementWithRawContent(t, e) {
              return (
                !1 !== e.withChildren &&
                !!this._rawContentElementMatcher.match(t)
              );
            }
            _shouldRenameElement(t) {
              const e = t.toLowerCase();
              return (
                "editing" === this.renderingMode &&
                this.unsafeElements.includes(e)
              );
            }
            _createReplacementDomElement(t, e) {
              const n = this._domDocument.createElement("span");
              if ((n.setAttribute(_s, t), e)) {
                for (; e.firstChild; ) n.appendChild(e.firstChild);
                for (const t of e.getAttributeNames())
                  n.setAttribute(t, e.getAttribute(t));
              }
              return n;
            }
          }
          function vs(t, e) {
            let n = t;
            for (; n; ) e(n), (n = n.parentElement);
          }
          function ys(t, e) {
            const n = t.parentNode;
            return !!n && !!n.tagName && e.includes(n.tagName.toLowerCase());
          }
          function xs(t) {
            "script" === t && c("domconverter-unsafe-script-element-detected"),
              "style" === t && c("domconverter-unsafe-style-element-detected");
          }
          function Es(t) {
            const e = Object.prototype.toString.apply(t);
            return "[object Window]" == e || "[object global]" == e;
          }
          function Ds(t) {
            return class extends t {
              listenTo(t, e, n, o = {}) {
                if (Kr(t) || Es(t)) {
                  const i = {
                      capture: !!o.useCapture,
                      passive: !!o.usePassive,
                    },
                    r = this._getProxyEmitter(t, i) || new Is(t, i);
                  this.listenTo(r, e, n, o);
                } else b.prototype.listenTo.call(this, t, e, n, o);
              }
              stopListening(t, e, n) {
                if (Kr(t) || Es(t)) {
                  const o = this._getAllProxyEmitters(t);
                  for (const t of o) this.stopListening(t, e, n);
                } else b.prototype.stopListening.call(this, t, e, n);
              }
              _getProxyEmitter(t, e) {
                return (function (t, e) {
                  const n = t[g];
                  return n && n[e] ? n[e].emitter : null;
                })(this, Ts(t, e));
              }
              _getAllProxyEmitters(t) {
                return [
                  { capture: !1, passive: !1 },
                  { capture: !1, passive: !0 },
                  { capture: !0, passive: !1 },
                  { capture: !0, passive: !0 },
                ]
                  .map((e) => this._getProxyEmitter(t, e))
                  .filter((t) => !!t);
              }
            };
          }
          const Ss = Ds(b);
          [
            "_getProxyEmitter",
            "_getAllProxyEmitters",
            "on",
            "once",
            "off",
            "listenTo",
            "stopListening",
            "fire",
            "delegate",
            "stopDelegating",
            "_addEventListener",
            "_removeEventListener",
          ].forEach((t) => {
            Ds[t] = Ss.prototype[t];
          });
          class Is extends b {
            constructor(t, e) {
              super(),
                w(this, Ts(t, e)),
                (this._domNode = t),
                (this._options = e);
            }
            attach(t) {
              if (this._domListeners && this._domListeners[t]) return;
              const e = this._createDomListener(t);
              this._domNode.addEventListener(t, e, this._options),
                this._domListeners || (this._domListeners = {}),
                (this._domListeners[t] = e);
            }
            detach(t) {
              let e;
              !this._domListeners[t] ||
                ((e = this._events[t]) && e.callbacks.length) ||
                this._domListeners[t].removeListener();
            }
            _addEventListener(t, e, n) {
              this.attach(t), b.prototype._addEventListener.call(this, t, e, n);
            }
            _removeEventListener(t, e) {
              b.prototype._removeEventListener.call(this, t, e), this.detach(t);
            }
            _createDomListener(t) {
              const e = (e) => {
                this.fire(t, e);
              };
              return (
                (e.removeListener = () => {
                  this._domNode.removeEventListener(t, e, this._options),
                    delete this._domListeners[t];
                }),
                e
              );
            }
          }
          function Ts(t, e) {
            let n = (function (t) {
              return t["data-ck-expando"] || (t["data-ck-expando"] = r());
            })(t);
            for (const t of Object.keys(e).sort()) e[t] && (n += "-" + t);
            return n;
          }
          class Ms extends Ss {
            constructor(t) {
              super(),
                (this.view = t),
                (this.document = t.document),
                (this.isEnabled = !1);
            }
            enable() {
              this.isEnabled = !0;
            }
            disable() {
              this.isEnabled = !1;
            }
            destroy() {
              this.disable(), this.stopListening();
            }
            checkShouldIgnoreEventFromTarget(t) {
              return (
                t && 3 === t.nodeType && (t = t.parentNode),
                !(!t || 1 !== t.nodeType) &&
                  t.matches(
                    "[data-cke-ignore-events], [data-cke-ignore-events] *"
                  )
              );
            }
          }
          const Bs = yi(function (t, e) {
            pe(e, Xe(e), t);
          });
          class Ns {
            constructor(t, e, n) {
              (this.view = t),
                (this.document = t.document),
                (this.domEvent = e),
                (this.domTarget = e.target),
                Bs(this, n);
            }
            get target() {
              return this.view.domConverter.mapDomToView(this.domTarget);
            }
            preventDefault() {
              this.domEvent.preventDefault();
            }
            stopPropagation() {
              this.domEvent.stopPropagation();
            }
          }
          class zs extends Ms {
            constructor(t) {
              super(t), (this.useCapture = !1);
            }
            observe(t) {
              ("string" == typeof this.domEventType
                ? [this.domEventType]
                : this.domEventType
              ).forEach((e) => {
                this.listenTo(
                  t,
                  e,
                  (t, e) => {
                    this.isEnabled &&
                      !this.checkShouldIgnoreEventFromTarget(e.target) &&
                      this.onDomEvent(e);
                  },
                  { useCapture: this.useCapture }
                );
              });
            }
            fire(t, e, n) {
              this.isEnabled && this.document.fire(t, new Ns(this.view, e, n));
            }
          }
          class Ps extends zs {
            constructor(t) {
              super(t), (this.domEventType = ["keydown", "keyup"]);
            }
            onDomEvent(t) {
              const e = {
                keyCode: t.keyCode,
                altKey: t.altKey,
                ctrlKey: t.ctrlKey,
                shiftKey: t.shiftKey,
                metaKey: t.metaKey,
                get keystroke() {
                  return mr(this);
                },
              };
              this.fire(t.type, t, e);
            }
          }
          const Ls = function () {
            return q.Date.now();
          };
          var Rs = /\s/;
          const Os = function (t) {
            for (var e = t.length; e-- && Rs.test(t.charAt(e)); );
            return e;
          };
          var js = /^\s+/;
          const Vs = function (t) {
            return t ? t.slice(0, Os(t) + 1).replace(js, "") : t;
          };
          var Fs = /^[-+]0x[0-9a-f]+$/i,
            Hs = /^0b[01]+$/i,
            Us = /^0o[0-7]+$/i,
            Ws = parseInt;
          const $s = function (t) {
            if ("number" == typeof t) return t;
            if (Lo(t)) return NaN;
            if (E(t)) {
              var e = "function" == typeof t.valueOf ? t.valueOf() : t;
              t = E(e) ? e + "" : e;
            }
            if ("string" != typeof t) return 0 === t ? t : +t;
            t = Vs(t);
            var n = Hs.test(t);
            return n || Us.test(t)
              ? Ws(t.slice(2), n ? 2 : 8)
              : Fs.test(t)
              ? NaN
              : +t;
          };
          var qs = Math.max,
            Gs = Math.min;
          const Zs = function (t, e, n) {
            var o,
              i,
              r,
              s,
              a,
              l,
              c = 0,
              d = !1,
              u = !1,
              h = !0;
            if ("function" != typeof t)
              throw new TypeError("Expected a function");
            function m(e) {
              var n = o,
                r = i;
              return (o = i = void 0), (c = e), (s = t.apply(r, n));
            }
            function g(t) {
              return (c = t), (a = setTimeout(f, e)), d ? m(t) : s;
            }
            function p(t) {
              var n = t - l;
              return void 0 === l || n >= e || n < 0 || (u && t - c >= r);
            }
            function f() {
              var t = Ls();
              if (p(t)) return k(t);
              a = setTimeout(
                f,
                (function (t) {
                  var n = e - (t - l);
                  return u ? Gs(n, r - (t - c)) : n;
                })(t)
              );
            }
            function k(t) {
              return (a = void 0), h && o ? m(t) : ((o = i = void 0), s);
            }
            function b() {
              var t = Ls(),
                n = p(t);
              if (((o = arguments), (i = this), (l = t), n)) {
                if (void 0 === a) return g(l);
                if (u) return clearTimeout(a), (a = setTimeout(f, e)), m(l);
              }
              return void 0 === a && (a = setTimeout(f, e)), s;
            }
            return (
              (e = $s(e) || 0),
              E(n) &&
                ((d = !!n.leading),
                (r = (u = "maxWait" in n) ? qs($s(n.maxWait) || 0, e) : r),
                (h = "trailing" in n ? !!n.trailing : h)),
              (b.cancel = function () {
                void 0 !== a && clearTimeout(a),
                  (c = 0),
                  (o = l = i = a = void 0);
              }),
              (b.flush = function () {
                return void 0 === a ? s : k(Ls());
              }),
              b
            );
          };
          class Ys extends Ms {
            constructor(t) {
              super(t),
                (this._fireSelectionChangeDoneDebounced = Zs((t) => {
                  this.document.fire("selectionChangeDone", t);
                }, 200));
            }
            observe() {
              const t = this.document;
              t.on(
                "arrowKey",
                (e, n) => {
                  t.selection.isFake && this.isEnabled && n.preventDefault();
                },
                { context: "$capture" }
              ),
                t.on(
                  "arrowKey",
                  (e, n) => {
                    t.selection.isFake &&
                      this.isEnabled &&
                      this._handleSelectionMove(n.keyCode);
                  },
                  { priority: "lowest" }
                );
            }
            destroy() {
              super.destroy(), this._fireSelectionChangeDoneDebounced.cancel();
            }
            _handleSelectionMove(t) {
              const e = this.document.selection,
                n = new Wi(e.getRanges(), { backward: e.isBackward, fake: !1 });
              (t != ur.arrowleft && t != ur.arrowup) ||
                n.setTo(n.getFirstPosition()),
                (t != ur.arrowright && t != ur.arrowdown) ||
                  n.setTo(n.getLastPosition());
              const o = {
                oldSelection: e,
                newSelection: n,
                domSelection: null,
              };
              this.document.fire("selectionChange", o),
                this._fireSelectionChangeDoneDebounced(o);
            }
          }
          const Ks = function (t) {
            return this.__data__.set(t, "__lodash_hash_undefined__"), this;
          };
          const Qs = function (t) {
            return this.__data__.has(t);
          };
          function Js(t) {
            var e = -1,
              n = null == t ? 0 : t.length;
            for (this.__data__ = new se(); ++e < n; ) this.add(t[e]);
          }
          (Js.prototype.add = Js.prototype.push = Ks), (Js.prototype.has = Qs);
          const Xs = Js;
          const ta = function (t, e) {
            for (var n = -1, o = null == t ? 0 : t.length; ++n < o; )
              if (e(t[n], n, t)) return !0;
            return !1;
          };
          const ea = function (t, e) {
            return t.has(e);
          };
          const na = function (t, e, n, o, i, r) {
            var s = 1 & n,
              a = t.length,
              l = e.length;
            if (a != l && !(s && l > a)) return !1;
            var c = r.get(t),
              d = r.get(e);
            if (c && d) return c == e && d == t;
            var u = -1,
              h = !0,
              m = 2 & n ? new Xs() : void 0;
            for (r.set(t, e), r.set(e, t); ++u < a; ) {
              var g = t[u],
                p = e[u];
              if (o) var f = s ? o(p, g, u, e, t, r) : o(g, p, u, t, e, r);
              if (void 0 !== f) {
                if (f) continue;
                h = !1;
                break;
              }
              if (m) {
                if (
                  !ta(e, function (t, e) {
                    if (!ea(m, e) && (g === t || i(g, t, n, o, r)))
                      return m.push(e);
                  })
                ) {
                  h = !1;
                  break;
                }
              } else if (g !== p && !i(g, p, n, o, r)) {
                h = !1;
                break;
              }
            }
            return r.delete(t), r.delete(e), h;
          };
          const oa = function (t) {
            var e = -1,
              n = Array(t.size);
            return (
              t.forEach(function (t, o) {
                n[++e] = [o, t];
              }),
              n
            );
          };
          const ia = function (t) {
            var e = -1,
              n = Array(t.size);
            return (
              t.forEach(function (t) {
                n[++e] = t;
              }),
              n
            );
          };
          var ra = G ? G.prototype : void 0,
            sa = ra ? ra.valueOf : void 0;
          const aa = function (t, e, n, o, i, r, s) {
            switch (n) {
              case "[object DataView]":
                if (
                  t.byteLength != e.byteLength ||
                  t.byteOffset != e.byteOffset
                )
                  return !1;
                (t = t.buffer), (e = e.buffer);
              case "[object ArrayBuffer]":
                return !(
                  t.byteLength != e.byteLength || !r(new On(t), new On(e))
                );
              case "[object Boolean]":
              case "[object Date]":
              case "[object Number]":
                return mt(+t, +e);
              case "[object Error]":
                return t.name == e.name && t.message == e.message;
              case "[object RegExp]":
              case "[object String]":
                return t == e + "";
              case "[object Map]":
                var a = oa;
              case "[object Set]":
                var l = 1 & o;
                if ((a || (a = ia), t.size != e.size && !l)) return !1;
                var c = s.get(t);
                if (c) return c == e;
                (o |= 2), s.set(t, e);
                var d = na(a(t), a(e), o, i, r, s);
                return s.delete(t), d;
              case "[object Symbol]":
                if (sa) return sa.call(t) == sa.call(e);
            }
            return !1;
          };
          var la = Object.prototype.hasOwnProperty;
          const ca = function (t, e, n, o, i, r) {
            var s = 1 & n,
              a = bn(t),
              l = a.length;
            if (l != bn(e).length && !s) return !1;
            for (var c = l; c--; ) {
              var d = a[c];
              if (!(s ? d in e : la.call(e, d))) return !1;
            }
            var u = r.get(t),
              h = r.get(e);
            if (u && h) return u == e && h == t;
            var m = !0;
            r.set(t, e), r.set(e, t);
            for (var g = s; ++c < l; ) {
              var p = t[(d = a[c])],
                f = e[d];
              if (o) var k = s ? o(f, p, d, e, t, r) : o(p, f, d, t, e, r);
              if (!(void 0 === k ? p === f || i(p, f, n, o, r) : k)) {
                m = !1;
                break;
              }
              g || (g = "constructor" == d);
            }
            if (m && !g) {
              var b = t.constructor,
                w = e.constructor;
              b == w ||
                !("constructor" in t) ||
                !("constructor" in e) ||
                ("function" == typeof b &&
                  b instanceof b &&
                  "function" == typeof w &&
                  w instanceof w) ||
                (m = !1);
            }
            return r.delete(t), r.delete(e), m;
          };
          var da = "[object Arguments]",
            ua = "[object Array]",
            ha = "[object Object]",
            ma = Object.prototype.hasOwnProperty;
          const ga = function (t, e, n, o, i, r) {
            var s = Ce(t),
              a = Ce(e),
              l = s ? ua : Pn(t),
              c = a ? ua : Pn(e),
              d = (l = l == da ? ha : l) == ha,
              u = (c = c == da ? ha : c) == ha,
              h = l == c;
            if (h && De(t)) {
              if (!De(e)) return !1;
              (s = !0), (d = !1);
            }
            if (h && !d)
              return (
                r || (r = new ce()),
                s || je(t) ? na(t, e, n, o, i, r) : aa(t, e, l, n, o, i, r)
              );
            if (!(1 & n)) {
              var m = d && ma.call(t, "__wrapped__"),
                g = u && ma.call(e, "__wrapped__");
              if (m || g) {
                var p = m ? t.value() : t,
                  f = g ? e.value() : e;
                return r || (r = new ce()), i(p, f, n, o, r);
              }
            }
            return !!h && (r || (r = new ce()), ca(t, e, n, o, i, r));
          };
          const pa = function t(e, n, o, i, r) {
            return (
              e === n ||
              (null == e || null == n || (!rt(e) && !rt(n))
                ? e != e && n != n
                : ga(e, n, o, i, t, r))
            );
          };
          const fa = function (t, e, n) {
            var o = (n = "function" == typeof n ? n : void 0)
              ? n(t, e)
              : void 0;
            return void 0 === o ? pa(t, e, void 0, n) : !!o;
          };
          class ka extends Ms {
            constructor(t) {
              super(t),
                (this._config = {
                  childList: !0,
                  characterData: !0,
                  subtree: !0,
                }),
                (this.domConverter = t.domConverter),
                (this.renderer = t._renderer),
                (this._domElements = []),
                (this._mutationObserver = new window.MutationObserver(
                  this._onMutations.bind(this)
                ));
            }
            flush() {
              this._onMutations(this._mutationObserver.takeRecords());
            }
            observe(t) {
              this._domElements.push(t),
                this.isEnabled &&
                  this._mutationObserver.observe(t, this._config);
            }
            enable() {
              super.enable();
              for (const t of this._domElements)
                this._mutationObserver.observe(t, this._config);
            }
            disable() {
              super.disable(), this._mutationObserver.disconnect();
            }
            destroy() {
              super.destroy(), this._mutationObserver.disconnect();
            }
            _onMutations(t) {
              if (0 === t.length) return;
              const e = this.domConverter,
                n = new Set(),
                o = new Set();
              for (const n of t) {
                const t = e.mapDomToView(n.target);
                t &&
                  (t.is("uiElement") ||
                    t.is("rawElement") ||
                    "childList" !== n.type ||
                    this._isBogusBrMutation(n) ||
                    o.add(t));
              }
              for (const i of t) {
                const t = e.mapDomToView(i.target);
                if (
                  (!t || (!t.is("uiElement") && !t.is("rawElement"))) &&
                  "characterData" === i.type
                ) {
                  const t = e.findCorrespondingViewText(i.target);
                  t && !o.has(t.parent)
                    ? n.add(t)
                    : !t &&
                      jr(i.target) &&
                      o.add(e.mapDomToView(i.target.parentNode));
                }
              }
              let i = !1;
              for (const t of n) (i = !0), this.renderer.markToSync("text", t);
              for (const t of o) {
                const n = e.mapViewToDom(t),
                  o = Array.from(t.getChildren()),
                  r = Array.from(e.domChildrenToView(n, { withChildren: !1 }));
                fa(o, r, ba) ||
                  ((i = !0), this.renderer.markToSync("children", t));
              }
              i && this.view.forceRender();
            }
            _isBogusBrMutation(t) {
              let e = null;
              return (
                null === t.nextSibling &&
                  0 === t.removedNodes.length &&
                  1 == t.addedNodes.length &&
                  (e = this.domConverter.domToView(t.addedNodes[0], {
                    withChildren: !1,
                  })),
                e && e.is("element", "br")
              );
            }
          }
          function ba(t, e) {
            if (!Array.isArray(t))
              return (
                t === e ||
                (!(!t.is("$text") || !e.is("$text")) && t.data === e.data)
              );
          }
          class wa extends Ms {
            constructor(t) {
              super(t),
                (this.mutationObserver = t.getObserver(ka)),
                (this.selection = this.document.selection),
                (this.domConverter = t.domConverter),
                (this._documents = new WeakSet()),
                (this._fireSelectionChangeDoneDebounced = Zs((t) => {
                  this.document.fire("selectionChangeDone", t);
                }, 200)),
                (this._clearInfiniteLoopInterval = setInterval(
                  () => this._clearInfiniteLoop(),
                  1e3
                )),
                (this._documentIsSelectingInactivityTimeoutDebounced = Zs(
                  () => (this.document.isSelecting = !1),
                  5e3
                )),
                (this._loopbackCounter = 0);
            }
            observe(t) {
              const e = t.ownerDocument,
                n = () => {
                  this.document.isSelecting &&
                    (this._handleSelectionChange(null, e),
                    (this.document.isSelecting = !1),
                    this._documentIsSelectingInactivityTimeoutDebounced.cancel());
                };
              this.listenTo(
                t,
                "selectstart",
                () => {
                  (this.document.isSelecting = !0),
                    this._documentIsSelectingInactivityTimeoutDebounced();
                },
                { priority: "highest" }
              ),
                this.listenTo(t, "keydown", n, {
                  priority: "highest",
                  useCapture: !0,
                }),
                this.listenTo(t, "keyup", n, {
                  priority: "highest",
                  useCapture: !0,
                }),
                this._documents.has(e) ||
                  (this.listenTo(e, "mouseup", n, {
                    priority: "highest",
                    useCapture: !0,
                  }),
                  this.listenTo(e, "selectionchange", (t, n) => {
                    (this.document.isComposing && !ar.isAndroid) ||
                      (this._handleSelectionChange(n, e),
                      this._documentIsSelectingInactivityTimeoutDebounced());
                  }),
                  this._documents.add(e));
            }
            destroy() {
              super.destroy(),
                clearInterval(this._clearInfiniteLoopInterval),
                this._fireSelectionChangeDoneDebounced.cancel(),
                this._documentIsSelectingInactivityTimeoutDebounced.cancel();
            }
            _handleSelectionChange(t, e) {
              if (!this.isEnabled) return;
              const n = e.defaultView.getSelection();
              if (this.checkShouldIgnoreEventFromTarget(n.anchorNode)) return;
              this.mutationObserver.flush();
              const o = this.domConverter.domSelectionToView(n);
              if (0 != o.rangeCount) {
                if (
                  ((this.view.hasDomSelection = !0),
                  !(
                    (this.selection.isEqual(o) &&
                      this.domConverter.isDomSelectionCorrect(n)) ||
                    ++this._loopbackCounter > 60
                  ))
                )
                  if (this.selection.isSimilar(o)) this.view.forceRender();
                  else {
                    const t = {
                      oldSelection: this.selection,
                      newSelection: o,
                      domSelection: n,
                    };
                    this.document.fire("selectionChange", t),
                      this._fireSelectionChangeDoneDebounced(t);
                  }
              } else this.view.hasDomSelection = !1;
            }
            _clearInfiniteLoop() {
              this._loopbackCounter = 0;
            }
          }
          class Aa extends zs {
            constructor(t) {
              super(t),
                (this.domEventType = ["focus", "blur"]),
                (this.useCapture = !0);
              const e = this.document;
              e.on("focus", () => {
                (e.isFocused = !0),
                  (this._renderTimeoutId = setTimeout(
                    () => t.change(() => {}),
                    50
                  ));
              }),
                e.on("blur", (n, o) => {
                  const i = e.selection.editableElement;
                  (null !== i && i !== o.target) ||
                    ((e.isFocused = !1), t.change(() => {}));
                });
            }
            onDomEvent(t) {
              this.fire(t.type, t);
            }
            destroy() {
              this._renderTimeoutId && clearTimeout(this._renderTimeoutId),
                super.destroy();
            }
          }
          class _a extends zs {
            constructor(t) {
              super(t),
                (this.domEventType = [
                  "compositionstart",
                  "compositionupdate",
                  "compositionend",
                ]);
              const e = this.document;
              e.on(
                "compositionstart",
                () => {
                  e.isComposing = !0;
                },
                { priority: "low" }
              ),
                e.on(
                  "compositionend",
                  () => {
                    e.isComposing = !1;
                  },
                  { priority: "low" }
                );
            }
            onDomEvent(t) {
              this.fire(t.type, t, { data: t.data });
            }
          }
          class Ca {
            constructor(t) {
              (this.files = (function (t) {
                const e = Array.from(t.files || []),
                  n = Array.from(t.items || []);
                if (e.length) return e;
                return n
                  .filter((t) => "file" === t.kind)
                  .map((t) => t.getAsFile());
              })(t)),
                (this._native = t);
            }
            get types() {
              return this._native.types;
            }
            getData(t) {
              return this._native.getData(t);
            }
            setData(t, e) {
              this._native.setData(t, e);
            }
            set effectAllowed(t) {
              this._native.effectAllowed = t;
            }
            get effectAllowed() {
              return this._native.effectAllowed;
            }
            set dropEffect(t) {
              this._native.dropEffect = t;
            }
            get dropEffect() {
              return this._native.dropEffect;
            }
            get isCanceled() {
              return (
                "none" == this._native.dropEffect ||
                !!this._native.mozUserCancelled
              );
            }
          }
          class va extends zs {
            constructor(t) {
              super(t), (this.domEventType = ["beforeinput"]);
            }
            onDomEvent(t) {
              const e = t.getTargetRanges(),
                n = this.view,
                o = n.document;
              let i = null,
                r = null,
                s = [];
              if (
                (t.dataTransfer && (i = new Ca(t.dataTransfer)),
                null !== t.data
                  ? (r = t.data)
                  : i && (r = i.getData("text/plain")),
                o.selection.isFake)
              )
                s = Array.from(o.selection.getRanges());
              else if (e.length)
                s = e.map((t) => n.domConverter.domRangeToView(t));
              else if (ar.isAndroid) {
                const e = t.target.ownerDocument.defaultView.getSelection();
                s = Array.from(
                  n.domConverter.domSelectionToView(e).getRanges()
                );
              }
              if (
                ar.isAndroid &&
                "insertCompositionText" == t.inputType &&
                r &&
                r.endsWith("\n")
              )
                this.fire(t.type, t, {
                  inputType: "insertParagraph",
                  targetRanges: [n.createRange(s[0].end)],
                });
              else if ("insertText" == t.inputType && r && r.includes("\n")) {
                const e = r.split(/\n{1,2}/g);
                let n = s;
                for (let r = 0; r < e.length; r++) {
                  const s = e[r];
                  "" != s &&
                    (this.fire(t.type, t, {
                      data: s,
                      dataTransfer: i,
                      targetRanges: n,
                      inputType: t.inputType,
                      isComposing: t.isComposing,
                    }),
                    (n = [o.selection.getFirstRange()])),
                    r + 1 < e.length &&
                      (this.fire(t.type, t, {
                        inputType: "insertParagraph",
                        targetRanges: n,
                      }),
                      (n = [o.selection.getFirstRange()]));
                }
              } else
                this.fire(t.type, t, {
                  data: r,
                  dataTransfer: i,
                  targetRanges: s,
                  inputType: t.inputType,
                  isComposing: t.isComposing,
                });
            }
          }
          function ya(t, ...e) {
            e.forEach((e) => {
              const n = Object.getOwnPropertyNames(e),
                o = Object.getOwnPropertySymbols(e);
              n.concat(o).forEach((n) => {
                if (n in t.prototype) return;
                if (
                  "function" == typeof e &&
                  ("length" == n || "name" == n || "prototype" == n)
                )
                  return;
                const o = Object.getOwnPropertyDescriptor(e, n);
                (o.enumerable = !1), Object.defineProperty(t.prototype, n, o);
              });
            });
          }
          class xa {
            constructor() {
              this._replacedElements = [];
            }
            replace(t, e) {
              this._replacedElements.push({ element: t, newElement: e }),
                (t.style.display = "none"),
                e && t.parentNode.insertBefore(e, t.nextSibling);
            }
            restore() {
              this._replacedElements.forEach(
                ({ element: t, newElement: e }) => {
                  (t.style.display = ""), e && e.remove();
                }
              ),
                (this._replacedElements = []);
            }
          }
          const Ea = function (t) {
            return (
              "string" == typeof t ||
              (!Ce(t) && rt(t) && "[object String]" == nt(t))
            );
          };
          function Da(t, e, n = {}, o = []) {
            const i = n && n.xmlns,
              r = i ? t.createElementNS(i, e) : t.createElement(e);
            for (const t in n) r.setAttribute(t, n[t]);
            (!Ea(o) && go(o)) || (o = [o]);
            for (let e of o)
              Ea(e) && (e = t.createTextNode(e)), r.appendChild(e);
            return r;
          }
          function Sa(t) {
            return "[object Range]" == Object.prototype.toString.apply(t);
          }
          function Ia(t) {
            const e = t.ownerDocument.defaultView.getComputedStyle(t);
            return {
              top: parseInt(e.borderTopWidth, 10),
              right: parseInt(e.borderRightWidth, 10),
              bottom: parseInt(e.borderBottomWidth, 10),
              left: parseInt(e.borderLeftWidth, 10),
            };
          }
          const Ta = ["top", "right", "bottom", "left", "width", "height"];
          class Ma {
            constructor(t) {
              const e = Sa(t);
              if (
                (Object.defineProperty(this, "_source", {
                  value: t._source || t,
                  writable: !0,
                  enumerable: !1,
                }),
                za(t) || e)
              )
                if (e) {
                  const e = Ma.getDomRangeRects(t);
                  Ba(this, Ma.getBoundingRect(e));
                } else Ba(this, t.getBoundingClientRect());
              else if (Es(t)) {
                const { innerWidth: e, innerHeight: n } = t;
                Ba(this, {
                  top: 0,
                  right: e,
                  bottom: n,
                  left: 0,
                  width: e,
                  height: n,
                });
              } else Ba(this, t);
            }
            clone() {
              return new Ma(this);
            }
            moveTo(t, e) {
              return (
                (this.top = e),
                (this.right = t + this.width),
                (this.bottom = e + this.height),
                (this.left = t),
                this
              );
            }
            moveBy(t, e) {
              return (
                (this.top += e),
                (this.right += t),
                (this.left += t),
                (this.bottom += e),
                this
              );
            }
            getIntersection(t) {
              const e = {
                top: Math.max(this.top, t.top),
                right: Math.min(this.right, t.right),
                bottom: Math.min(this.bottom, t.bottom),
                left: Math.max(this.left, t.left),
                width: 0,
                height: 0,
              };
              return (
                (e.width = e.right - e.left),
                (e.height = e.bottom - e.top),
                e.width < 0 || e.height < 0 ? null : new Ma(e)
              );
            }
            getIntersectionArea(t) {
              const e = this.getIntersection(t);
              return e ? e.getArea() : 0;
            }
            getArea() {
              return this.width * this.height;
            }
            getVisible() {
              const t = this._source;
              let e = this.clone();
              if (!Na(t)) {
                let n = t.parentNode || t.commonAncestorContainer;
                for (; n && !Na(n); ) {
                  const t = new Ma(n),
                    o = e.getIntersection(t);
                  if (!o) return null;
                  o.getArea() < e.getArea() && (e = o), (n = n.parentNode);
                }
              }
              return e;
            }
            isEqual(t) {
              for (const e of Ta) if (this[e] !== t[e]) return !1;
              return !0;
            }
            contains(t) {
              const e = this.getIntersection(t);
              return !(!e || !e.isEqual(t));
            }
            excludeScrollbarsAndBorders() {
              const t = this._source;
              let e, n, o;
              if (Es(t))
                (e = t.innerWidth - t.document.documentElement.clientWidth),
                  (n = t.innerHeight - t.document.documentElement.clientHeight),
                  (o = t.getComputedStyle(
                    t.document.documentElement
                  ).direction);
              else {
                const i = Ia(t);
                (e = t.offsetWidth - t.clientWidth - i.left - i.right),
                  (n = t.offsetHeight - t.clientHeight - i.top - i.bottom),
                  (o =
                    t.ownerDocument.defaultView.getComputedStyle(t).direction),
                  (this.left += i.left),
                  (this.top += i.top),
                  (this.right -= i.right),
                  (this.bottom -= i.bottom),
                  (this.width = this.right - this.left),
                  (this.height = this.bottom - this.top);
              }
              return (
                (this.width -= e),
                "ltr" === o ? (this.right -= e) : (this.left += e),
                (this.height -= n),
                (this.bottom -= n),
                this
              );
            }
            static getDomRangeRects(t) {
              const e = [],
                n = Array.from(t.getClientRects());
              if (n.length) for (const t of n) e.push(new Ma(t));
              else {
                let n = t.startContainer;
                zr(n) && (n = n.parentNode);
                const o = new Ma(n.getBoundingClientRect());
                (o.right = o.left), (o.width = 0), e.push(o);
              }
              return e;
            }
            static getBoundingRect(t) {
              const e = {
                left: Number.POSITIVE_INFINITY,
                top: Number.POSITIVE_INFINITY,
                right: Number.NEGATIVE_INFINITY,
                bottom: Number.NEGATIVE_INFINITY,
                width: 0,
                height: 0,
              };
              let n = 0;
              for (const o of t)
                n++,
                  (e.left = Math.min(e.left, o.left)),
                  (e.top = Math.min(e.top, o.top)),
                  (e.right = Math.max(e.right, o.right)),
                  (e.bottom = Math.max(e.bottom, o.bottom));
              return 0 == n
                ? null
                : ((e.width = e.right - e.left),
                  (e.height = e.bottom - e.top),
                  new Ma(e));
            }
          }
          function Ba(t, e) {
            for (const n of Ta) t[n] = e[n];
          }
          function Na(t) {
            return !!za(t) && t === t.ownerDocument.body;
          }
          function za(t) {
            return (
              null !== t &&
              "object" == typeof t &&
              1 === t.nodeType &&
              "function" == typeof t.getBoundingClientRect
            );
          }
          class Pa {
            constructor(t, e) {
              Pa._observerInstance || Pa._createObserver(),
                (this._element = t),
                (this._callback = e),
                Pa._addElementCallback(t, e),
                Pa._observerInstance.observe(t);
            }
            destroy() {
              Pa._deleteElementCallback(this._element, this._callback);
            }
            static _addElementCallback(t, e) {
              Pa._elementCallbacks || (Pa._elementCallbacks = new Map());
              let n = Pa._elementCallbacks.get(t);
              n || ((n = new Set()), Pa._elementCallbacks.set(t, n)), n.add(e);
            }
            static _deleteElementCallback(t, e) {
              const n = Pa._getElementCallbacks(t);
              n &&
                (n.delete(e),
                n.size ||
                  (Pa._elementCallbacks.delete(t),
                  Pa._observerInstance.unobserve(t))),
                Pa._elementCallbacks &&
                  !Pa._elementCallbacks.size &&
                  ((Pa._observerInstance = null),
                  (Pa._elementCallbacks = null));
            }
            static _getElementCallbacks(t) {
              return Pa._elementCallbacks ? Pa._elementCallbacks.get(t) : null;
            }
            static _createObserver() {
              Pa._observerInstance = new wo.window.ResizeObserver((t) => {
                for (const e of t) {
                  const t = Pa._getElementCallbacks(e.target);
                  if (t) for (const n of t) n(e);
                }
              });
            }
          }
          function La(t) {
            return !!(t && t.getClientRects && t.getClientRects().length);
          }
          function Ra(t) {
            const e = t.next();
            return e.done ? null : e.value;
          }
          (Pa._observerInstance = null), (Pa._elementCallbacks = null);
          class Oa extends Ds(N) {
            constructor() {
              super(),
                this.set("isFocused", !1),
                this.set("focusedElement", null),
                (this._elements = new Set()),
                (this._nextEventLoopTimeout = null);
            }
            add(t) {
              if (this._elements.has(t))
                throw new l("focustracker-add-element-already-exist", this);
              this.listenTo(t, "focus", () => this._focus(t), {
                useCapture: !0,
              }),
                this.listenTo(t, "blur", () => this._blur(), {
                  useCapture: !0,
                }),
                this._elements.add(t);
            }
            remove(t) {
              t === this.focusedElement && this._blur(),
                this._elements.has(t) &&
                  (this.stopListening(t), this._elements.delete(t));
            }
            destroy() {
              this.stopListening();
            }
            _focus(t) {
              clearTimeout(this._nextEventLoopTimeout),
                (this.focusedElement = t),
                (this.isFocused = !0);
            }
            _blur() {
              clearTimeout(this._nextEventLoopTimeout),
                (this._nextEventLoopTimeout = setTimeout(() => {
                  (this.focusedElement = null), (this.isFocused = !1);
                }, 0));
            }
          }
          class ja {
            constructor() {
              this._listener = new Ss();
            }
            listenTo(t) {
              this._listener.listenTo(t, "keydown", (t, e) => {
                this._listener.fire("_keydown:" + mr(e), e);
              });
            }
            set(t, e, n = {}) {
              const o = gr(t),
                i = n.priority;
              this._listener.listenTo(
                this._listener,
                "_keydown:" + o,
                (t, n) => {
                  e(n, () => {
                    n.preventDefault(), n.stopPropagation(), t.stop();
                  }),
                    (t.return = !0);
                },
                { priority: i }
              );
            }
            press(t) {
              return !!this._listener.fire("_keydown:" + mr(t), t);
            }
            destroy() {
              this._listener.stopListening();
            }
          }
          class Va extends Ms {
            constructor(t) {
              super(t),
                this.document.on("keydown", (t, e) => {
                  if (
                    this.isEnabled &&
                    ((n = e.keyCode) == ur.arrowright ||
                      n == ur.arrowleft ||
                      n == ur.arrowup ||
                      n == ur.arrowdown)
                  ) {
                    const n = new qi(
                      this.document,
                      "arrowKey",
                      this.document.selection.getFirstRange()
                    );
                    this.document.fire(n, e), n.stop.called && t.stop();
                  }
                  var n;
                });
            }
            observe() {}
          }
          class Fa extends Ms {
            constructor(t) {
              super(t);
              const e = this.document;
              e.on("keydown", (t, n) => {
                if (!this.isEnabled || n.keyCode != ur.tab || n.ctrlKey) return;
                const o = new qi(e, "tab", e.selection.getFirstRange());
                e.fire(o, n), o.stop.called && t.stop();
              });
            }
            observe() {}
          }
          function Ha({ target: t, viewportOffset: e = 0 }) {
            const n = Ya(t);
            let o = n,
              i = null;
            for (; o; ) {
              let r;
              (r = Ka(o == n ? t : i)), Wa(r, () => Qa(t, o));
              const s = Qa(t, o);
              if ((Ua(o, s, e), o.parent != o)) {
                if (((i = o.frameElement), (o = o.parent), !i)) return;
              } else o = null;
            }
          }
          function Ua(t, e, n) {
            const o = e.clone().moveBy(0, n),
              i = e.clone().moveBy(0, -n),
              r = new Ma(t).excludeScrollbarsAndBorders();
            if (![i, o].every((t) => r.contains(t))) {
              let { scrollX: s, scrollY: a } = t;
              qa(i, r)
                ? (a -= r.top - e.top + n)
                : $a(o, r) && (a += e.bottom - r.bottom + n),
                Ga(e, r)
                  ? (s -= r.left - e.left + n)
                  : Za(e, r) && (s += e.right - r.right + n),
                t.scrollTo(s, a);
            }
          }
          function Wa(t, e) {
            const n = Ya(t);
            let o, i;
            for (; t != n.document.body; )
              (i = e()),
                (o = new Ma(t).excludeScrollbarsAndBorders()),
                o.contains(i) ||
                  (qa(i, o)
                    ? (t.scrollTop -= o.top - i.top)
                    : $a(i, o) && (t.scrollTop += i.bottom - o.bottom),
                  Ga(i, o)
                    ? (t.scrollLeft -= o.left - i.left)
                    : Za(i, o) && (t.scrollLeft += i.right - o.right)),
                (t = t.parentNode);
          }
          function $a(t, e) {
            return t.bottom > e.bottom;
          }
          function qa(t, e) {
            return t.top < e.top;
          }
          function Ga(t, e) {
            return t.left < e.left;
          }
          function Za(t, e) {
            return t.right > e.right;
          }
          function Ya(t) {
            return Sa(t)
              ? t.startContainer.ownerDocument.defaultView
              : t.ownerDocument.defaultView;
          }
          function Ka(t) {
            if (Sa(t)) {
              let e = t.commonAncestorContainer;
              return zr(e) && (e = e.parentNode), e;
            }
            return t.parentNode;
          }
          function Qa(t, e) {
            const n = Ya(t),
              o = new Ma(t);
            if (n === e) return o;
            {
              let t = n;
              for (; t != e; ) {
                const e = t.frameElement,
                  n = new Ma(e).excludeScrollbarsAndBorders();
                o.moveBy(n.left, n.top), (t = t.parent);
              }
            }
            return o;
          }
          class Ja extends N {
            constructor(t) {
              super(),
                (this.document = new Xi(t)),
                (this.domConverter = new Cs(this.document)),
                (this.domRoots = new Map()),
                this.set("isRenderingInProgress", !1),
                this.set("hasDomSelection", !1),
                (this._renderer = new cs(
                  this.domConverter,
                  this.document.selection
                )),
                this._renderer
                  .bind("isFocused", "isSelecting", "isComposing")
                  .to(this.document, "isFocused", "isSelecting", "isComposing"),
                (this._initialDomRootAttributes = new WeakMap()),
                (this._observers = new Map()),
                (this._ongoingChange = !1),
                (this._postFixersInProgress = !1),
                (this._renderingDisabled = !1),
                (this._hasChangedSinceTheLastRendering = !1),
                (this._writer = new vr(this.document)),
                this.addObserver(ka),
                this.addObserver(wa),
                this.addObserver(Aa),
                this.addObserver(Ps),
                this.addObserver(Ys),
                this.addObserver(_a),
                this.addObserver(Va),
                this.addObserver(va),
                this.addObserver(Fa),
                this.document.on("arrowKey", Hr, { priority: "low" }),
                br(this),
                this.on("render", () => {
                  this._render(),
                    this.document.fire("layoutChanged"),
                    (this._hasChangedSinceTheLastRendering = !1);
                }),
                this.listenTo(this.document.selection, "change", () => {
                  this._hasChangedSinceTheLastRendering = !0;
                }),
                this.listenTo(this.document, "change:isFocused", () => {
                  this._hasChangedSinceTheLastRendering = !0;
                });
            }
            attachDomRoot(t, e = "main") {
              const n = this.document.getRoot(e);
              n._name = t.tagName.toLowerCase();
              const o = {};
              for (const { name: e, value: i } of Array.from(t.attributes))
                (o[e] = i),
                  "class" === e
                    ? this._writer.addClass(i.split(" "), n)
                    : this._writer.setAttribute(e, i, n);
              this._initialDomRootAttributes.set(t, o);
              const i = () => {
                this._writer.setAttribute(
                  "contenteditable",
                  (!n.isReadOnly).toString(),
                  n
                ),
                  n.isReadOnly
                    ? this._writer.addClass("ck-read-only", n)
                    : this._writer.removeClass("ck-read-only", n);
              };
              i(),
                this.domRoots.set(e, t),
                this.domConverter.bindElements(t, n),
                this._renderer.markToSync("children", n),
                this._renderer.markToSync("attributes", n),
                this._renderer.domDocuments.add(t.ownerDocument),
                n.on("change:children", (t, e) =>
                  this._renderer.markToSync("children", e)
                ),
                n.on("change:attributes", (t, e) =>
                  this._renderer.markToSync("attributes", e)
                ),
                n.on("change:text", (t, e) =>
                  this._renderer.markToSync("text", e)
                ),
                n.on("change:isReadOnly", () => this.change(i)),
                n.on("change", () => {
                  this._hasChangedSinceTheLastRendering = !0;
                });
              for (const n of this._observers.values()) n.observe(t, e);
            }
            detachDomRoot(t) {
              const e = this.domRoots.get(t);
              Array.from(e.attributes).forEach(({ name: t }) =>
                e.removeAttribute(t)
              );
              const n = this._initialDomRootAttributes.get(e);
              for (const t in n) e.setAttribute(t, n[t]);
              this.domRoots.delete(t), this.domConverter.unbindDomElement(e);
            }
            getDomRoot(t = "main") {
              return this.domRoots.get(t);
            }
            addObserver(t) {
              let e = this._observers.get(t);
              if (e) return e;
              (e = new t(this)), this._observers.set(t, e);
              for (const [t, n] of this.domRoots) e.observe(n, t);
              return e.enable(), e;
            }
            getObserver(t) {
              return this._observers.get(t);
            }
            disableObservers() {
              for (const t of this._observers.values()) t.disable();
            }
            enableObservers() {
              for (const t of this._observers.values()) t.enable();
            }
            scrollToTheSelection() {
              const t = this.document.selection.getFirstRange();
              t &&
                Ha({
                  target: this.domConverter.viewRangeToDom(t),
                  viewportOffset: 20,
                });
            }
            focus() {
              if (!this.document.isFocused) {
                const t = this.document.selection.editableElement;
                t && (this.domConverter.focus(t), this.forceRender());
              }
            }
            change(t) {
              if (this.isRenderingInProgress || this._postFixersInProgress)
                throw new l("cannot-change-view-tree", this);
              try {
                if (this._ongoingChange) return t(this._writer);
                this._ongoingChange = !0;
                const e = t(this._writer);
                return (
                  (this._ongoingChange = !1),
                  !this._renderingDisabled &&
                    this._hasChangedSinceTheLastRendering &&
                    ((this._postFixersInProgress = !0),
                    this.document._callPostFixers(this._writer),
                    (this._postFixersInProgress = !1),
                    this.fire("render")),
                  e
                );
              } catch (t) {
                l.rethrowUnexpectedError(t, this);
              }
            }
            forceRender() {
              (this._hasChangedSinceTheLastRendering = !0),
                this.change(() => {});
            }
            destroy() {
              for (const t of this._observers.values()) t.destroy();
              this.document.destroy(), this.stopListening();
            }
            createPositionAt(t, e) {
              return Vi._createAt(t, e);
            }
            createPositionAfter(t) {
              return Vi._createAfter(t);
            }
            createPositionBefore(t) {
              return Vi._createBefore(t);
            }
            createRange(...t) {
              return new Fi(...t);
            }
            createRangeOn(t) {
              return Fi._createOn(t);
            }
            createRangeIn(t) {
              return Fi._createIn(t);
            }
            createSelection(...t) {
              return new Wi(...t);
            }
            _disableRendering(t) {
              (this._renderingDisabled = t), 0 == t && this.change(() => {});
            }
            _render() {
              (this.isRenderingInProgress = !0),
                this.disableObservers(),
                this._renderer.render(),
                this.enableObservers(),
                (this.isRenderingInProgress = !1);
            }
          }
          class Xa {
            is() {
              throw new Error("is() method is abstract");
            }
          }
          class tl extends Xa {
            constructor(t) {
              super(), (this.parent = null), (this._attrs = Bo(t));
            }
            get document() {
              return null;
            }
            get index() {
              let t;
              if (!this.parent) return null;
              if (null === (t = this.parent.getChildIndex(this)))
                throw new l("model-node-not-found-in-parent", this);
              return t;
            }
            get startOffset() {
              let t;
              if (!this.parent) return null;
              if (null === (t = this.parent.getChildStartOffset(this)))
                throw new l("model-node-not-found-in-parent", this);
              return t;
            }
            get offsetSize() {
              return 1;
            }
            get endOffset() {
              return this.parent ? this.startOffset + this.offsetSize : null;
            }
            get nextSibling() {
              const t = this.index;
              return (null !== t && this.parent.getChild(t + 1)) || null;
            }
            get previousSibling() {
              const t = this.index;
              return (null !== t && this.parent.getChild(t - 1)) || null;
            }
            get root() {
              let t = this;
              for (; t.parent; ) t = t.parent;
              return t;
            }
            isAttached() {
              return this.root.is("rootElement");
            }
            getPath() {
              const t = [];
              let e = this;
              for (; e.parent; ) t.unshift(e.startOffset), (e = e.parent);
              return t;
            }
            getAncestors(t = {}) {
              const e = [];
              let n = t.includeSelf ? this : this.parent;
              for (; n; )
                e[t.parentFirst ? "push" : "unshift"](n), (n = n.parent);
              return e;
            }
            getCommonAncestor(t, e = {}) {
              const n = this.getAncestors(e),
                o = t.getAncestors(e);
              let i = 0;
              for (; n[i] == o[i] && n[i]; ) i++;
              return 0 === i ? null : n[i - 1];
            }
            isBefore(t) {
              if (this == t) return !1;
              if (this.root !== t.root) return !1;
              const e = this.getPath(),
                n = t.getPath(),
                o = Do(e, n);
              switch (o) {
                case "prefix":
                  return !0;
                case "extension":
                  return !1;
                default:
                  return e[o] < n[o];
              }
            }
            isAfter(t) {
              return this != t && this.root === t.root && !this.isBefore(t);
            }
            hasAttribute(t) {
              return this._attrs.has(t);
            }
            getAttribute(t) {
              return this._attrs.get(t);
            }
            getAttributes() {
              return this._attrs.entries();
            }
            getAttributeKeys() {
              return this._attrs.keys();
            }
            toJSON() {
              const t = {};
              return (
                this._attrs.size &&
                  (t.attributes = Array.from(this._attrs).reduce(
                    (t, e) => ((t[e[0]] = e[1]), t),
                    {}
                  )),
                t
              );
            }
            _clone(t) {
              return new tl(this._attrs);
            }
            _remove() {
              this.parent._removeChildren(this.index);
            }
            _setAttribute(t, e) {
              this._attrs.set(t, e);
            }
            _setAttributesTo(t) {
              this._attrs = Bo(t);
            }
            _removeAttribute(t) {
              return this._attrs.delete(t);
            }
            _clearAttributes() {
              this._attrs.clear();
            }
          }
          tl.prototype.is = function (t) {
            return "node" === t || "model:node" === t;
          };
          class el {
            constructor(t) {
              (this._nodes = []), t && this._insertNodes(0, t);
            }
            [Symbol.iterator]() {
              return this._nodes[Symbol.iterator]();
            }
            get length() {
              return this._nodes.length;
            }
            get maxOffset() {
              return this._nodes.reduce((t, e) => t + e.offsetSize, 0);
            }
            getNode(t) {
              return this._nodes[t] || null;
            }
            getNodeIndex(t) {
              const e = this._nodes.indexOf(t);
              return -1 == e ? null : e;
            }
            getNodeStartOffset(t) {
              const e = this.getNodeIndex(t);
              return null === e
                ? null
                : this._nodes.slice(0, e).reduce((t, e) => t + e.offsetSize, 0);
            }
            indexToOffset(t) {
              if (t == this._nodes.length) return this.maxOffset;
              const e = this._nodes[t];
              if (!e) throw new l("model-nodelist-index-out-of-bounds", this);
              return this.getNodeStartOffset(e);
            }
            offsetToIndex(t) {
              let e = 0;
              for (const n of this._nodes) {
                if (t >= e && t < e + n.offsetSize) return this.getNodeIndex(n);
                e += n.offsetSize;
              }
              if (e != t)
                throw new l("model-nodelist-offset-out-of-bounds", this, {
                  offset: t,
                  nodeList: this,
                });
              return this.length;
            }
            _insertNodes(t, e) {
              for (const t of e)
                if (!(t instanceof tl))
                  throw new l("model-nodelist-insertnodes-not-node", this);
              this._nodes = (function (t, e, n, o) {
                if (Math.max(e.length, t.length) > 1e4)
                  return t
                    .slice(0, n)
                    .concat(e)
                    .concat(t.slice(n + o, t.length));
                {
                  const i = Array.from(t);
                  return i.splice(n, o, ...e), i;
                }
              })(this._nodes, Array.from(e), t, 0);
            }
            _removeNodes(t, e = 1) {
              return this._nodes.splice(t, e);
            }
            toJSON() {
              return this._nodes.map((t) => t.toJSON());
            }
          }
          class nl extends tl {
            constructor(t, e) {
              super(e), (this._data = t || "");
            }
            get offsetSize() {
              return this.data.length;
            }
            get data() {
              return this._data;
            }
            toJSON() {
              const t = super.toJSON();
              return (t.data = this.data), t;
            }
            _clone() {
              return new nl(this.data, this.getAttributes());
            }
            static fromJSON(t) {
              return new nl(t.data, t.attributes);
            }
          }
          nl.prototype.is = function (t) {
            return (
              "$text" === t ||
              "model:$text" === t ||
              "text" === t ||
              "model:text" === t ||
              "node" === t ||
              "model:node" === t
            );
          };
          class ol extends Xa {
            constructor(t, e, n) {
              if ((super(), (this.textNode = t), e < 0 || e > t.offsetSize))
                throw new l("model-textproxy-wrong-offsetintext", this);
              if (n < 0 || e + n > t.offsetSize)
                throw new l("model-textproxy-wrong-length", this);
              (this.data = t.data.substring(e, e + n)), (this.offsetInText = e);
            }
            get startOffset() {
              return null !== this.textNode.startOffset
                ? this.textNode.startOffset + this.offsetInText
                : null;
            }
            get offsetSize() {
              return this.data.length;
            }
            get endOffset() {
              return null !== this.startOffset
                ? this.startOffset + this.offsetSize
                : null;
            }
            get isPartial() {
              return this.offsetSize !== this.textNode.offsetSize;
            }
            get parent() {
              return this.textNode.parent;
            }
            get root() {
              return this.textNode.root;
            }
            getPath() {
              const t = this.textNode.getPath();
              return t.length > 0 && (t[t.length - 1] += this.offsetInText), t;
            }
            getAncestors(t = {}) {
              const e = [];
              let n = t.includeSelf ? this : this.parent;
              for (; n; )
                e[t.parentFirst ? "push" : "unshift"](n), (n = n.parent);
              return e;
            }
            hasAttribute(t) {
              return this.textNode.hasAttribute(t);
            }
            getAttribute(t) {
              return this.textNode.getAttribute(t);
            }
            getAttributes() {
              return this.textNode.getAttributes();
            }
            getAttributeKeys() {
              return this.textNode.getAttributeKeys();
            }
          }
          ol.prototype.is = function (t) {
            return (
              "$textProxy" === t ||
              "model:$textProxy" === t ||
              "textProxy" === t ||
              "model:textProxy" === t
            );
          };
          class il extends tl {
            constructor(t, e, n) {
              super(e),
                (this.name = t),
                (this._children = new el()),
                n && this._insertChild(0, n);
            }
            get childCount() {
              return this._children.length;
            }
            get maxOffset() {
              return this._children.maxOffset;
            }
            get isEmpty() {
              return 0 === this.childCount;
            }
            getChild(t) {
              return this._children.getNode(t);
            }
            getChildren() {
              return this._children[Symbol.iterator]();
            }
            getChildIndex(t) {
              return this._children.getNodeIndex(t);
            }
            getChildStartOffset(t) {
              return this._children.getNodeStartOffset(t);
            }
            offsetToIndex(t) {
              return this._children.offsetToIndex(t);
            }
            getNodeByPath(t) {
              let e = this;
              for (const n of t) e = e.getChild(e.offsetToIndex(n));
              return e;
            }
            findAncestor(t, e = {}) {
              let n = e.includeSelf ? this : this.parent;
              for (; n; ) {
                if (n.name === t) return n;
                n = n.parent;
              }
              return null;
            }
            toJSON() {
              const t = super.toJSON();
              if (((t.name = this.name), this._children.length > 0)) {
                t.children = [];
                for (const e of this._children) t.children.push(e.toJSON());
              }
              return t;
            }
            _clone(t = !1) {
              const e = t
                ? Array.from(this._children).map((t) => t._clone(!0))
                : void 0;
              return new il(this.name, this.getAttributes(), e);
            }
            _appendChild(t) {
              this._insertChild(this.childCount, t);
            }
            _insertChild(t, e) {
              const n = (function (t) {
                if ("string" == typeof t) return [new nl(t)];
                go(t) || (t = [t]);
                return Array.from(t).map((t) =>
                  "string" == typeof t
                    ? new nl(t)
                    : t instanceof ol
                    ? new nl(t.data, t.getAttributes())
                    : t
                );
              })(e);
              for (const t of n)
                null !== t.parent && t._remove(), (t.parent = this);
              this._children._insertNodes(t, n);
            }
            _removeChildren(t, e = 1) {
              const n = this._children._removeNodes(t, e);
              for (const t of n) t.parent = null;
              return n;
            }
            static fromJSON(t) {
              let e;
              if (t.children) {
                e = [];
                for (const n of t.children)
                  n.name ? e.push(il.fromJSON(n)) : e.push(nl.fromJSON(n));
              }
              return new il(t.name, t.attributes, e);
            }
          }
          il.prototype.is = function (t, e) {
            return e
              ? e === this.name && ("element" === t || "model:element" === t)
              : "element" === t ||
                  "model:element" === t ||
                  "node" === t ||
                  "model:node" === t;
          };
          class rl {
            constructor(t = {}) {
              if (!t.boundaries && !t.startPosition)
                throw new l("model-tree-walker-no-start-position", null);
              const e = t.direction || "forward";
              if ("forward" != e && "backward" != e)
                throw new l("model-tree-walker-unknown-direction", t, {
                  direction: e,
                });
              (this.direction = e),
                (this.boundaries = t.boundaries || null),
                t.startPosition
                  ? (this.position = t.startPosition.clone())
                  : (this.position = al._createAt(
                      this.boundaries[
                        "backward" == this.direction ? "end" : "start"
                      ]
                    )),
                (this.position.stickiness = "toNone"),
                (this.singleCharacters = !!t.singleCharacters),
                (this.shallow = !!t.shallow),
                (this.ignoreElementEnd = !!t.ignoreElementEnd),
                (this._boundaryStartParent = this.boundaries
                  ? this.boundaries.start.parent
                  : null),
                (this._boundaryEndParent = this.boundaries
                  ? this.boundaries.end.parent
                  : null),
                (this._visitedParent = this.position.parent);
            }
            [Symbol.iterator]() {
              return this;
            }
            skip(t) {
              let e, n, o, i;
              do {
                (o = this.position),
                  (i = this._visitedParent),
                  ({ done: e, value: n } = this.next());
              } while (!e && t(n));
              e || ((this.position = o), (this._visitedParent = i));
            }
            next() {
              return "forward" == this.direction
                ? this._next()
                : this._previous();
            }
            _next() {
              const t = this.position,
                e = this.position.clone(),
                n = this._visitedParent;
              if (null === n.parent && e.offset === n.maxOffset)
                return { done: !0, value: void 0 };
              if (
                n === this._boundaryEndParent &&
                e.offset == this.boundaries.end.offset
              )
                return { done: !0, value: void 0 };
              const o = ll(e, n),
                i = o || cl(e, n, o);
              if (i instanceof il)
                return (
                  this.shallow
                    ? e.offset++
                    : (e.path.push(0), (this._visitedParent = i)),
                  (this.position = e),
                  sl("elementStart", i, t, e, 1)
                );
              if (i instanceof nl) {
                let o;
                if (this.singleCharacters) o = 1;
                else {
                  let t = i.endOffset;
                  this._boundaryEndParent == n &&
                    this.boundaries.end.offset < t &&
                    (t = this.boundaries.end.offset),
                    (o = t - e.offset);
                }
                const r = e.offset - i.startOffset,
                  s = new ol(i, r, o);
                return (
                  (e.offset += o), (this.position = e), sl("text", s, t, e, o)
                );
              }
              return (
                e.path.pop(),
                e.offset++,
                (this.position = e),
                (this._visitedParent = n.parent),
                this.ignoreElementEnd ? this._next() : sl("elementEnd", n, t, e)
              );
            }
            _previous() {
              const t = this.position,
                e = this.position.clone(),
                n = this._visitedParent;
              if (null === n.parent && 0 === e.offset)
                return { done: !0, value: void 0 };
              if (
                n == this._boundaryStartParent &&
                e.offset == this.boundaries.start.offset
              )
                return { done: !0, value: void 0 };
              const o = e.parent,
                i = ll(e, o),
                r = i || dl(e, o, i);
              if (r instanceof il)
                return (
                  e.offset--,
                  this.shallow
                    ? ((this.position = e), sl("elementStart", r, t, e, 1))
                    : (e.path.push(r.maxOffset),
                      (this.position = e),
                      (this._visitedParent = r),
                      this.ignoreElementEnd
                        ? this._previous()
                        : sl("elementEnd", r, t, e))
                );
              if (r instanceof nl) {
                let o;
                if (this.singleCharacters) o = 1;
                else {
                  let t = r.startOffset;
                  this._boundaryStartParent == n &&
                    this.boundaries.start.offset > t &&
                    (t = this.boundaries.start.offset),
                    (o = e.offset - t);
                }
                const i = e.offset - r.startOffset,
                  s = new ol(r, i - o, o);
                return (
                  (e.offset -= o), (this.position = e), sl("text", s, t, e, o)
                );
              }
              return (
                e.path.pop(),
                (this.position = e),
                (this._visitedParent = n.parent),
                sl("elementStart", n, t, e, 1)
              );
            }
          }
          function sl(t, e, n, o, i) {
            return {
              done: !1,
              value: {
                type: t,
                item: e,
                previousPosition: n,
                nextPosition: o,
                length: i,
              },
            };
          }
          class al extends Xa {
            constructor(t, e, n = "toNone") {
              if ((super(), !t.is("element") && !t.is("documentFragment")))
                throw new l("model-position-root-invalid", t);
              if (!(e instanceof Array) || 0 === e.length)
                throw new l("model-position-path-incorrect-format", t, {
                  path: e,
                });
              t.is("rootElement")
                ? (e = e.slice())
                : ((e = [...t.getPath(), ...e]), (t = t.root)),
                (this.root = t),
                (this.path = e),
                (this.stickiness = n);
            }
            get offset() {
              return this.path[this.path.length - 1];
            }
            set offset(t) {
              this.path[this.path.length - 1] = t;
            }
            get parent() {
              let t = this.root;
              for (let e = 0; e < this.path.length - 1; e++)
                if (((t = t.getChild(t.offsetToIndex(this.path[e]))), !t))
                  throw new l("model-position-path-incorrect", this, {
                    position: this,
                  });
              if (t.is("$text"))
                throw new l("model-position-path-incorrect", this, {
                  position: this,
                });
              return t;
            }
            get index() {
              return this.parent.offsetToIndex(this.offset);
            }
            get textNode() {
              return ll(this, this.parent);
            }
            get nodeAfter() {
              const t = this.parent;
              return cl(this, t, ll(this, t));
            }
            get nodeBefore() {
              const t = this.parent;
              return dl(this, t, ll(this, t));
            }
            get isAtStart() {
              return 0 === this.offset;
            }
            get isAtEnd() {
              return this.offset == this.parent.maxOffset;
            }
            compareWith(t) {
              if (this.root != t.root) return "different";
              const e = Do(this.path, t.path);
              switch (e) {
                case "same":
                  return "same";
                case "prefix":
                  return "before";
                case "extension":
                  return "after";
                default:
                  return this.path[e] < t.path[e] ? "before" : "after";
              }
            }
            getLastMatchingPosition(t, e = {}) {
              e.startPosition = this;
              const n = new rl(e);
              return n.skip(t), n.position;
            }
            getParentPath() {
              return this.path.slice(0, -1);
            }
            getAncestors() {
              const t = this.parent;
              return t.is("documentFragment")
                ? [t]
                : t.getAncestors({ includeSelf: !0 });
            }
            findAncestor(t) {
              const e = this.parent;
              return e.is("element")
                ? e.findAncestor(t, { includeSelf: !0 })
                : null;
            }
            getCommonPath(t) {
              if (this.root != t.root) return [];
              const e = Do(this.path, t.path),
                n =
                  "string" == typeof e
                    ? Math.min(this.path.length, t.path.length)
                    : e;
              return this.path.slice(0, n);
            }
            getCommonAncestor(t) {
              const e = this.getAncestors(),
                n = t.getAncestors();
              let o = 0;
              for (; e[o] == n[o] && e[o]; ) o++;
              return 0 === o ? null : e[o - 1];
            }
            getShiftedBy(t) {
              const e = this.clone(),
                n = e.offset + t;
              return (e.offset = n < 0 ? 0 : n), e;
            }
            isAfter(t) {
              return "after" == this.compareWith(t);
            }
            isBefore(t) {
              return "before" == this.compareWith(t);
            }
            isEqual(t) {
              return "same" == this.compareWith(t);
            }
            isTouching(t) {
              if (this.root !== t.root) return !1;
              const e = Math.min(this.path.length, t.path.length);
              for (let n = 0; n < e; n++) {
                const e = this.path[n] - t.path[n];
                if (e < -1 || e > 1) return !1;
                if (1 === e) return ul(t, this, n);
                if (-1 === e) return ul(this, t, n);
              }
              return (
                this.path.length === t.path.length ||
                (this.path.length > t.path.length
                  ? hl(this.path, e)
                  : hl(t.path, e))
              );
            }
            hasSameParentAs(t) {
              if (this.root !== t.root) return !1;
              return "same" == Do(this.getParentPath(), t.getParentPath());
            }
            getTransformedByOperation(t) {
              let e;
              switch (t.type) {
                case "insert":
                  e = this._getTransformedByInsertOperation(t);
                  break;
                case "move":
                case "remove":
                case "reinsert":
                  e = this._getTransformedByMoveOperation(t);
                  break;
                case "split":
                  e = this._getTransformedBySplitOperation(t);
                  break;
                case "merge":
                  e = this._getTransformedByMergeOperation(t);
                  break;
                default:
                  e = al._createAt(this);
              }
              return e;
            }
            _getTransformedByInsertOperation(t) {
              return this._getTransformedByInsertion(t.position, t.howMany);
            }
            _getTransformedByMoveOperation(t) {
              return this._getTransformedByMove(
                t.sourcePosition,
                t.targetPosition,
                t.howMany
              );
            }
            _getTransformedBySplitOperation(t) {
              const e = t.movedRange;
              return e.containsPosition(this) ||
                (e.start.isEqual(this) && "toNext" == this.stickiness)
                ? this._getCombined(t.splitPosition, t.moveTargetPosition)
                : t.graveyardPosition
                ? this._getTransformedByMove(
                    t.graveyardPosition,
                    t.insertionPosition,
                    1
                  )
                : this._getTransformedByInsertion(t.insertionPosition, 1);
            }
            _getTransformedByMergeOperation(t) {
              const e = t.movedRange;
              let n;
              return (
                e.containsPosition(this) || e.start.isEqual(this)
                  ? ((n = this._getCombined(
                      t.sourcePosition,
                      t.targetPosition
                    )),
                    t.sourcePosition.isBefore(t.targetPosition) &&
                      (n = n._getTransformedByDeletion(t.deletionPosition, 1)))
                  : (n = this.isEqual(t.deletionPosition)
                      ? al._createAt(t.deletionPosition)
                      : this._getTransformedByMove(
                          t.deletionPosition,
                          t.graveyardPosition,
                          1
                        )),
                n
              );
            }
            _getTransformedByDeletion(t, e) {
              const n = al._createAt(this);
              if (this.root != t.root) return n;
              if ("same" == Do(t.getParentPath(), this.getParentPath())) {
                if (t.offset < this.offset) {
                  if (t.offset + e > this.offset) return null;
                  n.offset -= e;
                }
              } else if (
                "prefix" == Do(t.getParentPath(), this.getParentPath())
              ) {
                const o = t.path.length - 1;
                if (t.offset <= this.path[o]) {
                  if (t.offset + e > this.path[o]) return null;
                  n.path[o] -= e;
                }
              }
              return n;
            }
            _getTransformedByInsertion(t, e) {
              const n = al._createAt(this);
              if (this.root != t.root) return n;
              if ("same" == Do(t.getParentPath(), this.getParentPath()))
                (t.offset < this.offset ||
                  (t.offset == this.offset &&
                    "toPrevious" != this.stickiness)) &&
                  (n.offset += e);
              else if (
                "prefix" == Do(t.getParentPath(), this.getParentPath())
              ) {
                const o = t.path.length - 1;
                t.offset <= this.path[o] && (n.path[o] += e);
              }
              return n;
            }
            _getTransformedByMove(t, e, n) {
              if (((e = e._getTransformedByDeletion(t, n)), t.isEqual(e)))
                return al._createAt(this);
              const o = this._getTransformedByDeletion(t, n);
              return null === o ||
                (t.isEqual(this) && "toNext" == this.stickiness) ||
                (t.getShiftedBy(n).isEqual(this) &&
                  "toPrevious" == this.stickiness)
                ? this._getCombined(t, e)
                : o._getTransformedByInsertion(e, n);
            }
            _getCombined(t, e) {
              const n = t.path.length - 1,
                o = al._createAt(e);
              return (
                (o.stickiness = this.stickiness),
                (o.offset = o.offset + this.path[n] - t.offset),
                (o.path = [...o.path, ...this.path.slice(n + 1)]),
                o
              );
            }
            toJSON() {
              return {
                root: this.root.toJSON(),
                path: Array.from(this.path),
                stickiness: this.stickiness,
              };
            }
            clone() {
              return new this.constructor(
                this.root,
                this.path,
                this.stickiness
              );
            }
            static _createAt(t, e, n = "toNone") {
              if (t instanceof al) return new al(t.root, t.path, t.stickiness);
              {
                const o = t;
                if ("end" == e) e = o.maxOffset;
                else {
                  if ("before" == e) return this._createBefore(o, n);
                  if ("after" == e) return this._createAfter(o, n);
                  if (0 !== e && !e)
                    throw new l("model-createpositionat-offset-required", [
                      this,
                      t,
                    ]);
                }
                if (!o.is("element") && !o.is("documentFragment"))
                  throw new l("model-position-parent-incorrect", [this, t]);
                const i = o.getPath();
                return i.push(e), new this(o.root, i, n);
              }
            }
            static _createAfter(t, e) {
              if (!t.parent)
                throw new l("model-position-after-root", [this, t], {
                  root: t,
                });
              return this._createAt(t.parent, t.endOffset, e);
            }
            static _createBefore(t, e) {
              if (!t.parent)
                throw new l("model-position-before-root", t, { root: t });
              return this._createAt(t.parent, t.startOffset, e);
            }
            static fromJSON(t, e) {
              if ("$graveyard" === t.root) {
                const n = new al(e.graveyard, t.path);
                return (n.stickiness = t.stickiness), n;
              }
              if (!e.getRoot(t.root))
                throw new l("model-position-fromjson-no-root", e, {
                  rootName: t.root,
                });
              return new al(e.getRoot(t.root), t.path, t.stickiness);
            }
          }
          function ll(t, e) {
            const n = e.getChild(e.offsetToIndex(t.offset));
            return n && n.is("$text") && n.startOffset < t.offset ? n : null;
          }
          function cl(t, e, n) {
            return null !== n ? null : e.getChild(e.offsetToIndex(t.offset));
          }
          function dl(t, e, n) {
            return null !== n
              ? null
              : e.getChild(e.offsetToIndex(t.offset) - 1);
          }
          function ul(t, e, n) {
            return (
              n + 1 !== t.path.length &&
              !!hl(e.path, n + 1) &&
              !!(function (t, e) {
                let n = t.parent,
                  o = t.path.length - 1,
                  i = 0;
                for (; o >= e; ) {
                  if (t.path[o] + i !== n.maxOffset) return !1;
                  (i = 1), o--, (n = n.parent);
                }
                return !0;
              })(t, n + 1)
            );
          }
          function hl(t, e) {
            for (; e < t.length; ) {
              if (0 !== t[e]) return !1;
              e++;
            }
            return !0;
          }
          al.prototype.is = function (t) {
            return "position" === t || "model:position" === t;
          };
          class ml extends Xa {
            constructor(t, e) {
              super(),
                (this.start = al._createAt(t)),
                (this.end = e ? al._createAt(e) : al._createAt(t)),
                (this.start.stickiness = this.isCollapsed
                  ? "toNone"
                  : "toNext"),
                (this.end.stickiness = this.isCollapsed
                  ? "toNone"
                  : "toPrevious");
            }
            *[Symbol.iterator]() {
              yield* new rl({ boundaries: this, ignoreElementEnd: !0 });
            }
            get isCollapsed() {
              return this.start.isEqual(this.end);
            }
            get isFlat() {
              return (
                "same" ==
                Do(this.start.getParentPath(), this.end.getParentPath())
              );
            }
            get root() {
              return this.start.root;
            }
            containsPosition(t) {
              return t.isAfter(this.start) && t.isBefore(this.end);
            }
            containsRange(t, e = !1) {
              t.isCollapsed && (e = !1);
              const n =
                  this.containsPosition(t.start) ||
                  (e && this.start.isEqual(t.start)),
                o =
                  this.containsPosition(t.end) ||
                  (e && this.end.isEqual(t.end));
              return n && o;
            }
            containsItem(t) {
              const e = al._createBefore(t);
              return this.containsPosition(e) || this.start.isEqual(e);
            }
            isEqual(t) {
              return this.start.isEqual(t.start) && this.end.isEqual(t.end);
            }
            isIntersecting(t) {
              return this.start.isBefore(t.end) && this.end.isAfter(t.start);
            }
            getDifference(t) {
              const e = [];
              return (
                this.isIntersecting(t)
                  ? (this.containsPosition(t.start) &&
                      e.push(new ml(this.start, t.start)),
                    this.containsPosition(t.end) &&
                      e.push(new ml(t.end, this.end)))
                  : e.push(new ml(this.start, this.end)),
                e
              );
            }
            getIntersection(t) {
              if (this.isIntersecting(t)) {
                let e = this.start,
                  n = this.end;
                return (
                  this.containsPosition(t.start) && (e = t.start),
                  this.containsPosition(t.end) && (n = t.end),
                  new ml(e, n)
                );
              }
              return null;
            }
            getJoined(t, e = !1) {
              let n = this.isIntersecting(t);
              if (
                (n ||
                  (n = this.start.isBefore(t.start)
                    ? e
                      ? this.end.isTouching(t.start)
                      : this.end.isEqual(t.start)
                    : e
                    ? t.end.isTouching(this.start)
                    : t.end.isEqual(this.start)),
                !n)
              )
                return null;
              let o = this.start,
                i = this.end;
              return (
                t.start.isBefore(o) && (o = t.start),
                t.end.isAfter(i) && (i = t.end),
                new ml(o, i)
              );
            }
            getMinimalFlatRanges() {
              const t = [],
                e = this.start.getCommonPath(this.end).length,
                n = al._createAt(this.start);
              let o = n.parent;
              for (; n.path.length > e + 1; ) {
                const e = o.maxOffset - n.offset;
                0 !== e && t.push(new ml(n, n.getShiftedBy(e))),
                  (n.path = n.path.slice(0, -1)),
                  n.offset++,
                  (o = o.parent);
              }
              for (; n.path.length <= this.end.path.length; ) {
                const e = this.end.path[n.path.length - 1],
                  o = e - n.offset;
                0 !== o && t.push(new ml(n, n.getShiftedBy(o))),
                  (n.offset = e),
                  n.path.push(0);
              }
              return t;
            }
            getWalker(t = {}) {
              return (t.boundaries = this), new rl(t);
            }
            *getItems(t = {}) {
              (t.boundaries = this), (t.ignoreElementEnd = !0);
              const e = new rl(t);
              for (const t of e) yield t.item;
            }
            *getPositions(t = {}) {
              t.boundaries = this;
              const e = new rl(t);
              yield e.position;
              for (const t of e) yield t.nextPosition;
            }
            getTransformedByOperation(t) {
              switch (t.type) {
                case "insert":
                  return this._getTransformedByInsertOperation(t);
                case "move":
                case "remove":
                case "reinsert":
                  return this._getTransformedByMoveOperation(t);
                case "split":
                  return [this._getTransformedBySplitOperation(t)];
                case "merge":
                  return [this._getTransformedByMergeOperation(t)];
              }
              return [new ml(this.start, this.end)];
            }
            getTransformedByOperations(t) {
              const e = [new ml(this.start, this.end)];
              for (const n of t)
                for (let t = 0; t < e.length; t++) {
                  const o = e[t].getTransformedByOperation(n);
                  e.splice(t, 1, ...o), (t += o.length - 1);
                }
              for (let t = 0; t < e.length; t++) {
                const n = e[t];
                for (let o = t + 1; o < e.length; o++) {
                  const t = e[o];
                  (n.containsRange(t) || t.containsRange(n) || n.isEqual(t)) &&
                    e.splice(o, 1);
                }
              }
              return e;
            }
            getCommonAncestor() {
              return this.start.getCommonAncestor(this.end);
            }
            getContainedElement() {
              if (this.isCollapsed) return null;
              const t = this.start.nodeAfter,
                e = this.end.nodeBefore;
              return t && t.is("element") && t === e ? t : null;
            }
            toJSON() {
              return { start: this.start.toJSON(), end: this.end.toJSON() };
            }
            clone() {
              return new this.constructor(this.start, this.end);
            }
            _getTransformedByInsertOperation(t, e = !1) {
              return this._getTransformedByInsertion(t.position, t.howMany, e);
            }
            _getTransformedByMoveOperation(t, e = !1) {
              const n = t.sourcePosition,
                o = t.howMany,
                i = t.targetPosition;
              return this._getTransformedByMove(n, i, o, e);
            }
            _getTransformedBySplitOperation(t) {
              const e = this.start._getTransformedBySplitOperation(t);
              let n = this.end._getTransformedBySplitOperation(t);
              return (
                this.end.isEqual(t.insertionPosition) &&
                  (n = this.end.getShiftedBy(1)),
                e.root != n.root && (n = this.end.getShiftedBy(-1)),
                new ml(e, n)
              );
            }
            _getTransformedByMergeOperation(t) {
              if (
                this.start.isEqual(t.targetPosition) &&
                this.end.isEqual(t.deletionPosition)
              )
                return new ml(this.start);
              let e = this.start._getTransformedByMergeOperation(t),
                n = this.end._getTransformedByMergeOperation(t);
              return (
                e.root != n.root && (n = this.end.getShiftedBy(-1)),
                e.isAfter(n)
                  ? (t.sourcePosition.isBefore(t.targetPosition)
                      ? ((e = al._createAt(n)), (e.offset = 0))
                      : (t.deletionPosition.isEqual(e) ||
                          (n = t.deletionPosition),
                        (e = t.targetPosition)),
                    new ml(e, n))
                  : new ml(e, n)
              );
            }
            _getTransformedByInsertion(t, e, n = !1) {
              if (n && this.containsPosition(t))
                return [
                  new ml(this.start, t),
                  new ml(
                    t.getShiftedBy(e),
                    this.end._getTransformedByInsertion(t, e)
                  ),
                ];
              {
                const n = new ml(this.start, this.end);
                return (
                  (n.start = n.start._getTransformedByInsertion(t, e)),
                  (n.end = n.end._getTransformedByInsertion(t, e)),
                  [n]
                );
              }
            }
            _getTransformedByMove(t, e, n, o = !1) {
              if (this.isCollapsed) {
                const o = this.start._getTransformedByMove(t, e, n);
                return [new ml(o)];
              }
              const i = ml._createFromPositionAndShift(t, n),
                r = e._getTransformedByDeletion(t, n);
              if (
                this.containsPosition(e) &&
                !o &&
                (i.containsPosition(this.start) || i.containsPosition(this.end))
              ) {
                const o = this.start._getTransformedByMove(t, e, n),
                  i = this.end._getTransformedByMove(t, e, n);
                return [new ml(o, i)];
              }
              let s;
              const a = this.getDifference(i);
              let l = null;
              const c = this.getIntersection(i);
              if (
                (1 == a.length
                  ? (l = new ml(
                      a[0].start._getTransformedByDeletion(t, n),
                      a[0].end._getTransformedByDeletion(t, n)
                    ))
                  : 2 == a.length &&
                    (l = new ml(
                      this.start,
                      this.end._getTransformedByDeletion(t, n)
                    )),
                (s = l
                  ? l._getTransformedByInsertion(r, n, null !== c || o)
                  : []),
                c)
              ) {
                const t = new ml(
                  c.start._getCombined(i.start, r),
                  c.end._getCombined(i.start, r)
                );
                2 == s.length ? s.splice(1, 0, t) : s.push(t);
              }
              return s;
            }
            _getTransformedByDeletion(t, e) {
              let n = this.start._getTransformedByDeletion(t, e),
                o = this.end._getTransformedByDeletion(t, e);
              return null == n && null == o
                ? null
                : (null == n && (n = t), null == o && (o = t), new ml(n, o));
            }
            static _createFromPositionAndShift(t, e) {
              const n = t,
                o = t.getShiftedBy(e);
              return e > 0 ? new this(n, o) : new this(o, n);
            }
            static _createIn(t) {
              return new this(al._createAt(t, 0), al._createAt(t, t.maxOffset));
            }
            static _createOn(t) {
              return this._createFromPositionAndShift(
                al._createBefore(t),
                t.offsetSize
              );
            }
            static _createFromRanges(t) {
              if (0 === t.length)
                throw new l("range-create-from-ranges-empty-array", null);
              if (1 == t.length) return t[0].clone();
              const e = t[0];
              t.sort((t, e) => (t.start.isAfter(e.start) ? 1 : -1));
              const n = t.indexOf(e),
                o = new this(e.start, e.end);
              if (n > 0)
                for (let e = n - 1; t[e].end.isEqual(o.start); e++)
                  o.start = al._createAt(t[e].start);
              for (
                let e = n + 1;
                e < t.length && t[e].start.isEqual(o.end);
                e++
              )
                o.end = al._createAt(t[e].end);
              return o;
            }
            static fromJSON(t, e) {
              return new this(al.fromJSON(t.start, e), al.fromJSON(t.end, e));
            }
          }
          ml.prototype.is = function (t) {
            return "range" === t || "model:range" === t;
          };
          class gl extends b {
            constructor() {
              super(),
                (this._modelToViewMapping = new WeakMap()),
                (this._viewToModelMapping = new WeakMap()),
                (this._viewToModelLengthCallbacks = new Map()),
                (this._markerNameToElements = new Map()),
                (this._elementToMarkerNames = new Map()),
                (this._deferredBindingRemovals = new Map()),
                (this._unboundMarkerNames = new Set()),
                this.on(
                  "modelToViewPosition",
                  (t, e) => {
                    if (e.viewPosition) return;
                    const n = this._modelToViewMapping.get(
                      e.modelPosition.parent
                    );
                    if (!n)
                      throw new l(
                        "mapping-model-position-view-parent-not-found",
                        this,
                        { modelPosition: e.modelPosition }
                      );
                    e.viewPosition = this.findPositionIn(
                      n,
                      e.modelPosition.offset
                    );
                  },
                  { priority: "low" }
                ),
                this.on(
                  "viewToModelPosition",
                  (t, e) => {
                    if (e.modelPosition) return;
                    const n = this.findMappedViewAncestor(e.viewPosition),
                      o = this._viewToModelMapping.get(n),
                      i = this._toModelOffset(
                        e.viewPosition.parent,
                        e.viewPosition.offset,
                        n
                      );
                    e.modelPosition = al._createAt(o, i);
                  },
                  { priority: "low" }
                );
            }
            bindElements(t, e) {
              this._modelToViewMapping.set(t, e),
                this._viewToModelMapping.set(e, t);
            }
            unbindViewElement(t, e = {}) {
              const n = this.toModelElement(t);
              if (this._elementToMarkerNames.has(t))
                for (const e of this._elementToMarkerNames.get(t))
                  this._unboundMarkerNames.add(e);
              e.defer
                ? this._deferredBindingRemovals.set(t, t.root)
                : (this._viewToModelMapping.delete(t),
                  this._modelToViewMapping.get(n) == t &&
                    this._modelToViewMapping.delete(n));
            }
            unbindModelElement(t) {
              const e = this.toViewElement(t);
              this._modelToViewMapping.delete(t),
                this._viewToModelMapping.get(e) == t &&
                  this._viewToModelMapping.delete(e);
            }
            bindElementToMarker(t, e) {
              const n = this._markerNameToElements.get(e) || new Set();
              n.add(t);
              const o = this._elementToMarkerNames.get(t) || new Set();
              o.add(e),
                this._markerNameToElements.set(e, n),
                this._elementToMarkerNames.set(t, o);
            }
            unbindElementFromMarkerName(t, e) {
              const n = this._markerNameToElements.get(e);
              n &&
                (n.delete(t),
                0 == n.size && this._markerNameToElements.delete(e));
              const o = this._elementToMarkerNames.get(t);
              o &&
                (o.delete(e),
                0 == o.size && this._elementToMarkerNames.delete(t));
            }
            flushUnboundMarkerNames() {
              const t = Array.from(this._unboundMarkerNames);
              return this._unboundMarkerNames.clear(), t;
            }
            flushDeferredBindings() {
              for (const [t, e] of this._deferredBindingRemovals)
                t.root == e && this.unbindViewElement(t);
              this._deferredBindingRemovals = new Map();
            }
            clearBindings() {
              (this._modelToViewMapping = new WeakMap()),
                (this._viewToModelMapping = new WeakMap()),
                (this._markerNameToElements = new Map()),
                (this._elementToMarkerNames = new Map()),
                (this._unboundMarkerNames = new Set()),
                (this._deferredBindingRemovals = new Map());
            }
            toModelElement(t) {
              return this._viewToModelMapping.get(t);
            }
            toViewElement(t) {
              return this._modelToViewMapping.get(t);
            }
            toModelRange(t) {
              return new ml(
                this.toModelPosition(t.start),
                this.toModelPosition(t.end)
              );
            }
            toViewRange(t) {
              return new Fi(
                this.toViewPosition(t.start),
                this.toViewPosition(t.end)
              );
            }
            toModelPosition(t) {
              const e = { viewPosition: t, mapper: this };
              return this.fire("viewToModelPosition", e), e.modelPosition;
            }
            toViewPosition(t, e = {}) {
              const n = {
                modelPosition: t,
                mapper: this,
                isPhantom: e.isPhantom,
              };
              return this.fire("modelToViewPosition", n), n.viewPosition;
            }
            markerNameToElements(t) {
              const e = this._markerNameToElements.get(t);
              if (!e) return null;
              const n = new Set();
              for (const t of e)
                if (t.is("attributeElement"))
                  for (const e of t.getElementsWithSameId()) n.add(e);
                else n.add(t);
              return n;
            }
            registerViewToModelLength(t, e) {
              this._viewToModelLengthCallbacks.set(t, e);
            }
            findMappedViewAncestor(t) {
              let e = t.parent;
              for (; !this._viewToModelMapping.has(e); ) e = e.parent;
              return e;
            }
            _toModelOffset(t, e, n) {
              if (n != t) {
                return (
                  this._toModelOffset(t.parent, t.index, n) +
                  this._toModelOffset(t, e, t)
                );
              }
              if (t.is("$text")) return e;
              let o = 0;
              for (let n = 0; n < e; n++)
                o += this.getModelLength(t.getChild(n));
              return o;
            }
            getModelLength(t) {
              if (this._viewToModelLengthCallbacks.get(t.name)) {
                return this._viewToModelLengthCallbacks.get(t.name)(t);
              }
              if (this._viewToModelMapping.has(t)) return 1;
              if (t.is("$text")) return t.data.length;
              if (t.is("uiElement")) return 0;
              {
                let e = 0;
                for (const n of t.getChildren()) e += this.getModelLength(n);
                return e;
              }
            }
            findPositionIn(t, e) {
              let n,
                o = 0,
                i = 0,
                r = 0;
              if (t.is("$text")) return new Vi(t, e);
              for (; i < e; )
                (n = t.getChild(r)),
                  (o = this.getModelLength(n)),
                  (i += o),
                  r++;
              return i == e
                ? this._moveViewPositionToTextNode(new Vi(t, r))
                : this.findPositionIn(n, e - (i - o));
            }
            _moveViewPositionToTextNode(t) {
              const e = t.nodeBefore,
                n = t.nodeAfter;
              return e instanceof To
                ? new Vi(e, e.data.length)
                : n instanceof To
                ? new Vi(n, 0)
                : t;
            }
          }
          class pl {
            constructor() {
              (this._consumable = new Map()),
                (this._textProxyRegistry = new Map());
            }
            add(t, e) {
              (e = fl(e)),
                t instanceof ol && (t = this._getSymbolForTextProxy(t)),
                this._consumable.has(t) || this._consumable.set(t, new Map()),
                this._consumable.get(t).set(e, !0);
            }
            consume(t, e) {
              return (
                (e = fl(e)),
                t instanceof ol && (t = this._getSymbolForTextProxy(t)),
                !!this.test(t, e) && (this._consumable.get(t).set(e, !1), !0)
              );
            }
            test(t, e) {
              (e = fl(e)),
                t instanceof ol && (t = this._getSymbolForTextProxy(t));
              const n = this._consumable.get(t);
              if (void 0 === n) return null;
              const o = n.get(e);
              return void 0 === o ? null : o;
            }
            revert(t, e) {
              (e = fl(e)),
                t instanceof ol && (t = this._getSymbolForTextProxy(t));
              const n = this.test(t, e);
              return !1 === n
                ? (this._consumable.get(t).set(e, !0), !0)
                : !0 !== n && null;
            }
            verifyAllConsumed(t) {
              const e = [];
              for (const [n, o] of this._consumable)
                for (const [i, r] of o) {
                  const o = i.split(":")[0];
                  r &&
                    t == o &&
                    e.push({ event: i, item: n.name || n.description });
                }
              if (e.length)
                throw new l("conversion-model-consumable-not-consumed", null, {
                  items: e,
                });
            }
            _getSymbolForTextProxy(t) {
              let e = null;
              const n = this._textProxyRegistry.get(t.startOffset);
              if (n) {
                const o = n.get(t.endOffset);
                o && (e = o.get(t.parent));
              }
              return e || (e = this._addSymbolForTextProxy(t)), e;
            }
            _addSymbolForTextProxy(t) {
              const e = t.startOffset,
                n = t.endOffset,
                o = t.parent,
                i = Symbol("$textProxy:" + t.data);
              let r, s;
              return (
                (r = this._textProxyRegistry.get(e)),
                r || ((r = new Map()), this._textProxyRegistry.set(e, r)),
                (s = r.get(n)),
                s || ((s = new Map()), r.set(n, s)),
                s.set(o, i),
                i
              );
            }
          }
          function fl(t) {
            const e = t.split(":");
            return "insert" == e[0]
              ? e[0]
              : "addMarker" == e[0] || "removeMarker" == e[0]
              ? t
              : e.length > 1
              ? e[0] + ":" + e[1]
              : e[0];
          }
          class kl extends b {
            constructor(t) {
              super(),
                (this._conversionApi = { dispatcher: this, ...t }),
                (this._firedEventsMap = new WeakMap());
            }
            convertChanges(t, e, n) {
              const o = this._createConversionApi(n, t.getRefreshedItems());
              for (const e of t.getMarkersToRemove())
                this._convertMarkerRemove(e.name, e.range, o);
              const i = this._reduceChanges(t.getChanges());
              for (const t of i)
                "insert" === t.type
                  ? this._convertInsert(
                      ml._createFromPositionAndShift(t.position, t.length),
                      o
                    )
                  : "reinsert" === t.type
                  ? this._convertReinsert(
                      ml._createFromPositionAndShift(t.position, t.length),
                      o
                    )
                  : "remove" === t.type
                  ? this._convertRemove(t.position, t.length, t.name, o)
                  : this._convertAttribute(
                      t.range,
                      t.attributeKey,
                      t.attributeOldValue,
                      t.attributeNewValue,
                      o
                    );
              for (const t of o.mapper.flushUnboundMarkerNames()) {
                const n = e.get(t).getRange();
                this._convertMarkerRemove(t, n, o),
                  this._convertMarkerAdd(t, n, o);
              }
              for (const e of t.getMarkersToAdd())
                this._convertMarkerAdd(e.name, e.range, o);
              o.mapper.flushDeferredBindings(),
                o.consumable.verifyAllConsumed("insert");
            }
            convert(t, e, n, o = {}) {
              const i = this._createConversionApi(n, void 0, o);
              this._convertInsert(t, i);
              for (const [t, n] of e) this._convertMarkerAdd(t, n, i);
              i.consumable.verifyAllConsumed("insert");
            }
            convertSelection(t, e, n) {
              const o = Array.from(
                  e.getMarkersAtPosition(t.getFirstPosition())
                ),
                i = this._createConversionApi(n);
              if (
                (this._addConsumablesForSelection(i.consumable, t, o),
                this.fire("selection", { selection: t }, i),
                t.isCollapsed)
              ) {
                for (const e of o) {
                  const n = e.getRange();
                  if (!bl(t.getFirstPosition(), e, i.mapper)) continue;
                  const o = { item: t, markerName: e.name, markerRange: n };
                  i.consumable.test(t, "addMarker:" + e.name) &&
                    this.fire(`addMarker:${e.name}`, o, i);
                }
                for (const e of t.getAttributeKeys()) {
                  const n = {
                    item: t,
                    range: t.getFirstRange(),
                    attributeKey: e,
                    attributeOldValue: null,
                    attributeNewValue: t.getAttribute(e),
                  };
                  i.consumable.test(t, "attribute:" + n.attributeKey) &&
                    this.fire(`attribute:${n.attributeKey}:$text`, n, i);
                }
              }
            }
            _convertInsert(t, e, n = {}) {
              n.doNotAddConsumables ||
                this._addConsumablesForInsert(e.consumable, Array.from(t));
              for (const n of Array.from(t.getWalker({ shallow: !0 })).map(wl))
                this._testAndFire("insert", n, e);
            }
            _convertRemove(t, e, n, o) {
              this.fire(`remove:${n}`, { position: t, length: e }, o);
            }
            _convertAttribute(t, e, n, o, i) {
              this._addConsumablesForRange(i.consumable, t, `attribute:${e}`);
              for (const r of t) {
                const t = {
                  item: r.item,
                  range: ml._createFromPositionAndShift(
                    r.previousPosition,
                    r.length
                  ),
                  attributeKey: e,
                  attributeOldValue: n,
                  attributeNewValue: o,
                };
                this._testAndFire(`attribute:${e}`, t, i);
              }
            }
            _convertReinsert(t, e) {
              const n = Array.from(t.getWalker({ shallow: !0 }));
              this._addConsumablesForInsert(e.consumable, n);
              for (const t of n.map(wl))
                this._testAndFire("insert", { ...t, reconversion: !0 }, e);
            }
            _convertMarkerAdd(t, e, n) {
              if ("$graveyard" == e.root.rootName) return;
              const o = `addMarker:${t}`;
              if (
                (n.consumable.add(e, o),
                this.fire(o, { markerName: t, markerRange: e }, n),
                n.consumable.consume(e, o))
              ) {
                this._addConsumablesForRange(n.consumable, e, o);
                for (const i of e.getItems()) {
                  if (!n.consumable.test(i, o)) continue;
                  const r = {
                    item: i,
                    range: ml._createOn(i),
                    markerName: t,
                    markerRange: e,
                  };
                  this.fire(o, r, n);
                }
              }
            }
            _convertMarkerRemove(t, e, n) {
              "$graveyard" != e.root.rootName &&
                this.fire(
                  `removeMarker:${t}`,
                  { markerName: t, markerRange: e },
                  n
                );
            }
            _reduceChanges(t) {
              const e = { changes: t };
              return this.fire("reduceChanges", e), e.changes;
            }
            _addConsumablesForInsert(t, e) {
              for (const n of e) {
                const e = n.item;
                if (null === t.test(e, "insert")) {
                  t.add(e, "insert");
                  for (const n of e.getAttributeKeys())
                    t.add(e, "attribute:" + n);
                }
              }
              return t;
            }
            _addConsumablesForRange(t, e, n) {
              for (const o of e.getItems()) t.add(o, n);
              return t;
            }
            _addConsumablesForSelection(t, e, n) {
              t.add(e, "selection");
              for (const o of n) t.add(e, "addMarker:" + o.name);
              for (const n of e.getAttributeKeys()) t.add(e, "attribute:" + n);
              return t;
            }
            _testAndFire(t, e, n) {
              const o = (function (t, e) {
                  const n = e.item.is("element") ? e.item.name : "$text";
                  return `${t}:${n}`;
                })(t, e),
                i = e.item.is("$textProxy")
                  ? n.consumable._getSymbolForTextProxy(e.item)
                  : e.item,
                r = this._firedEventsMap.get(n),
                s = r.get(i);
              if (s) {
                if (s.has(o)) return;
                s.add(o);
              } else r.set(i, new Set([o]));
              this.fire(o, e, n);
            }
            _testAndFireAddAttributes(t, e) {
              const n = { item: t, range: ml._createOn(t) };
              for (const t of n.item.getAttributeKeys())
                (n.attributeKey = t),
                  (n.attributeOldValue = null),
                  (n.attributeNewValue = n.item.getAttribute(t)),
                  this._testAndFire(`attribute:${t}`, n, e);
            }
            _createConversionApi(t, e = new Set(), n = {}) {
              const o = {
                ...this._conversionApi,
                consumable: new pl(),
                writer: t,
                options: n,
                convertItem: (t) => this._convertInsert(ml._createOn(t), o),
                convertChildren: (t) =>
                  this._convertInsert(ml._createIn(t), o, {
                    doNotAddConsumables: !0,
                  }),
                convertAttributes: (t) => this._testAndFireAddAttributes(t, o),
                canReuseView: (t) => !e.has(o.mapper.toModelElement(t)),
              };
              return this._firedEventsMap.set(o, new Map()), o;
            }
          }
          function bl(t, e, n) {
            const o = e.getRange(),
              i = Array.from(t.getAncestors());
            i.shift(), i.reverse();
            return !i.some((t) => {
              if (o.containsItem(t)) {
                return !!n.toViewElement(t).getCustomProperty("addHighlight");
              }
            });
          }
          function wl(t) {
            return {
              item: t.item,
              range: ml._createFromPositionAndShift(
                t.previousPosition,
                t.length
              ),
            };
          }
          class Al extends k(Xa) {
            constructor(...t) {
              super(),
                (this._lastRangeBackward = !1),
                (this._ranges = []),
                (this._attrs = new Map()),
                t.length && this.setTo(...t);
            }
            get anchor() {
              if (this._ranges.length > 0) {
                const t = this._ranges[this._ranges.length - 1];
                return this._lastRangeBackward ? t.end : t.start;
              }
              return null;
            }
            get focus() {
              if (this._ranges.length > 0) {
                const t = this._ranges[this._ranges.length - 1];
                return this._lastRangeBackward ? t.start : t.end;
              }
              return null;
            }
            get isCollapsed() {
              return 1 === this._ranges.length && this._ranges[0].isCollapsed;
            }
            get rangeCount() {
              return this._ranges.length;
            }
            get isBackward() {
              return !this.isCollapsed && this._lastRangeBackward;
            }
            isEqual(t) {
              if (this.rangeCount != t.rangeCount) return !1;
              if (0 === this.rangeCount) return !0;
              if (
                !this.anchor.isEqual(t.anchor) ||
                !this.focus.isEqual(t.focus)
              )
                return !1;
              for (const e of this._ranges) {
                let n = !1;
                for (const o of t._ranges)
                  if (e.isEqual(o)) {
                    n = !0;
                    break;
                  }
                if (!n) return !1;
              }
              return !0;
            }
            *getRanges() {
              for (const t of this._ranges) yield new ml(t.start, t.end);
            }
            getFirstRange() {
              let t = null;
              for (const e of this._ranges)
                (t && !e.start.isBefore(t.start)) || (t = e);
              return t ? new ml(t.start, t.end) : null;
            }
            getLastRange() {
              let t = null;
              for (const e of this._ranges)
                (t && !e.end.isAfter(t.end)) || (t = e);
              return t ? new ml(t.start, t.end) : null;
            }
            getFirstPosition() {
              const t = this.getFirstRange();
              return t ? t.start.clone() : null;
            }
            getLastPosition() {
              const t = this.getLastRange();
              return t ? t.end.clone() : null;
            }
            setTo(...t) {
              let [e, n, o] = t;
              if (("object" == typeof n && ((o = n), (n = void 0)), null === e))
                this._setRanges([]);
              else if (e instanceof Al)
                this._setRanges(e.getRanges(), e.isBackward);
              else if (e && "function" == typeof e.getRanges)
                this._setRanges(e.getRanges(), e.isBackward);
              else if (e instanceof ml)
                this._setRanges([e], !!o && !!o.backward);
              else if (e instanceof al) this._setRanges([new ml(e)]);
              else if (e instanceof tl) {
                const t = !!o && !!o.backward;
                let i;
                if ("in" == n) i = ml._createIn(e);
                else if ("on" == n) i = ml._createOn(e);
                else {
                  if (void 0 === n)
                    throw new l(
                      "model-selection-setto-required-second-parameter",
                      [this, e]
                    );
                  i = new ml(al._createAt(e, n));
                }
                this._setRanges([i], t);
              } else {
                if (!go(e))
                  throw new l("model-selection-setto-not-selectable", [
                    this,
                    e,
                  ]);
                this._setRanges(e, o && !!o.backward);
              }
            }
            _setRanges(t, e = !1) {
              const n = Array.from(t),
                o = n.some((e) => {
                  if (!(e instanceof ml))
                    throw new l("model-selection-set-ranges-not-range", [
                      this,
                      t,
                    ]);
                  return this._ranges.every((t) => !t.isEqual(e));
                });
              (n.length !== this._ranges.length || o) &&
                (this._replaceAllRanges(n),
                (this._lastRangeBackward = !!e),
                this.fire("change:range", { directChange: !0 }));
            }
            setFocus(t, e) {
              if (null === this.anchor)
                throw new l("model-selection-setfocus-no-ranges", [this, t]);
              const n = al._createAt(t, e);
              if ("same" == n.compareWith(this.focus)) return;
              const o = this.anchor;
              this._ranges.length && this._popRange(),
                "before" == n.compareWith(o)
                  ? (this._pushRange(new ml(n, o)),
                    (this._lastRangeBackward = !0))
                  : (this._pushRange(new ml(o, n)),
                    (this._lastRangeBackward = !1)),
                this.fire("change:range", { directChange: !0 });
            }
            getAttribute(t) {
              return this._attrs.get(t);
            }
            getAttributes() {
              return this._attrs.entries();
            }
            getAttributeKeys() {
              return this._attrs.keys();
            }
            hasAttribute(t) {
              return this._attrs.has(t);
            }
            removeAttribute(t) {
              this.hasAttribute(t) &&
                (this._attrs.delete(t),
                this.fire("change:attribute", {
                  attributeKeys: [t],
                  directChange: !0,
                }));
            }
            setAttribute(t, e) {
              this.getAttribute(t) !== e &&
                (this._attrs.set(t, e),
                this.fire("change:attribute", {
                  attributeKeys: [t],
                  directChange: !0,
                }));
            }
            getSelectedElement() {
              return 1 !== this.rangeCount
                ? null
                : this.getFirstRange().getContainedElement();
            }
            *getSelectedBlocks() {
              const t = new WeakSet();
              for (const e of this.getRanges()) {
                const n = vl(e.start, t);
                n && yl(n, e) && (yield n);
                for (const n of e.getWalker()) {
                  const o = n.item;
                  "elementEnd" == n.type && Cl(o, t, e) && (yield o);
                }
                const o = vl(e.end, t);
                o &&
                  !e.end.isTouching(al._createAt(o, 0)) &&
                  yl(o, e) &&
                  (yield o);
              }
            }
            containsEntireContent(t = this.anchor.root) {
              const e = al._createAt(t, 0),
                n = al._createAt(t, "end");
              return (
                e.isTouching(this.getFirstPosition()) &&
                n.isTouching(this.getLastPosition())
              );
            }
            _pushRange(t) {
              this._checkRange(t), this._ranges.push(new ml(t.start, t.end));
            }
            _checkRange(t) {
              for (let e = 0; e < this._ranges.length; e++)
                if (t.isIntersecting(this._ranges[e]))
                  throw new l("model-selection-range-intersects", [this, t], {
                    addedRange: t,
                    intersectingRange: this._ranges[e],
                  });
            }
            _replaceAllRanges(t) {
              this._removeAllRanges();
              for (const e of t) this._pushRange(e);
            }
            _removeAllRanges() {
              for (; this._ranges.length > 0; ) this._popRange();
            }
            _popRange() {
              this._ranges.pop();
            }
          }
          function _l(t, e) {
            return (
              !e.has(t) &&
              (e.add(t), t.root.document.model.schema.isBlock(t) && !!t.parent)
            );
          }
          function Cl(t, e, n) {
            return _l(t, e) && yl(t, n);
          }
          function vl(t, e) {
            const n = t.parent.root.document.model.schema,
              o = t.parent.getAncestors({ parentFirst: !0, includeSelf: !0 });
            let i = !1;
            const r = o.find((t) => !i && ((i = n.isLimit(t)), !i && _l(t, e)));
            return o.forEach((t) => e.add(t)), r;
          }
          function yl(t, e) {
            const n = (function (t) {
              const e = t.root.document.model.schema;
              let n = t.parent;
              for (; n; ) {
                if (e.isBlock(n)) return n;
                n = n.parent;
              }
            })(t);
            if (!n) return !0;
            return !e.containsRange(ml._createOn(n), !0);
          }
          Al.prototype.is = function (t) {
            return "selection" === t || "model:selection" === t;
          };
          class xl extends k(ml) {
            constructor(t, e) {
              super(t, e), El.call(this);
            }
            detach() {
              this.stopListening();
            }
            toRange() {
              return new ml(this.start, this.end);
            }
            static fromRange(t) {
              return new xl(t.start, t.end);
            }
          }
          function El() {
            this.listenTo(
              this.root.document.model,
              "applyOperation",
              (t, e) => {
                const n = e[0];
                n.isDocumentOperation && Dl.call(this, n);
              },
              { priority: "low" }
            );
          }
          function Dl(t) {
            const e = this.getTransformedByOperation(t),
              n = ml._createFromRanges(e),
              o = !n.isEqual(this),
              i = (function (t, e) {
                switch (e.type) {
                  case "insert":
                    return t.containsPosition(e.position);
                  case "move":
                  case "remove":
                  case "reinsert":
                  case "merge":
                    return (
                      t.containsPosition(e.sourcePosition) ||
                      t.start.isEqual(e.sourcePosition) ||
                      t.containsPosition(e.targetPosition)
                    );
                  case "split":
                    return (
                      t.containsPosition(e.splitPosition) ||
                      t.containsPosition(e.insertionPosition)
                    );
                }
                return !1;
              })(this, t);
            let r = null;
            if (o) {
              "$graveyard" == n.root.rootName &&
                (r =
                  "remove" == t.type ? t.sourcePosition : t.deletionPosition);
              const e = this.toRange();
              (this.start = n.start),
                (this.end = n.end),
                this.fire("change:range", e, { deletionPosition: r });
            } else
              i &&
                this.fire("change:content", this.toRange(), {
                  deletionPosition: r,
                });
          }
          xl.prototype.is = function (t) {
            return (
              "liveRange" === t ||
              "model:liveRange" === t ||
              "range" == t ||
              "model:range" === t
            );
          };
          const Sl = "selection:";
          class Il extends k(Xa) {
            constructor(t) {
              super(),
                (this._selection = new Tl(t)),
                this._selection.delegate("change:range").to(this),
                this._selection.delegate("change:attribute").to(this),
                this._selection.delegate("change:marker").to(this);
            }
            get isCollapsed() {
              return this._selection.isCollapsed;
            }
            get anchor() {
              return this._selection.anchor;
            }
            get focus() {
              return this._selection.focus;
            }
            get rangeCount() {
              return this._selection.rangeCount;
            }
            get hasOwnRange() {
              return this._selection.hasOwnRange;
            }
            get isBackward() {
              return this._selection.isBackward;
            }
            get isGravityOverridden() {
              return this._selection.isGravityOverridden;
            }
            get markers() {
              return this._selection.markers;
            }
            get _ranges() {
              return this._selection._ranges;
            }
            getRanges() {
              return this._selection.getRanges();
            }
            getFirstPosition() {
              return this._selection.getFirstPosition();
            }
            getLastPosition() {
              return this._selection.getLastPosition();
            }
            getFirstRange() {
              return this._selection.getFirstRange();
            }
            getLastRange() {
              return this._selection.getLastRange();
            }
            getSelectedBlocks() {
              return this._selection.getSelectedBlocks();
            }
            getSelectedElement() {
              return this._selection.getSelectedElement();
            }
            containsEntireContent(t) {
              return this._selection.containsEntireContent(t);
            }
            destroy() {
              this._selection.destroy();
            }
            getAttributeKeys() {
              return this._selection.getAttributeKeys();
            }
            getAttributes() {
              return this._selection.getAttributes();
            }
            getAttribute(t) {
              return this._selection.getAttribute(t);
            }
            hasAttribute(t) {
              return this._selection.hasAttribute(t);
            }
            refresh() {
              this._selection.updateMarkers(),
                this._selection._updateAttributes(!1);
            }
            observeMarkers(t) {
              this._selection.observeMarkers(t);
            }
            _setFocus(t, e) {
              this._selection.setFocus(t, e);
            }
            _setTo(...t) {
              this._selection.setTo(...t);
            }
            _setAttribute(t, e) {
              this._selection.setAttribute(t, e);
            }
            _removeAttribute(t) {
              this._selection.removeAttribute(t);
            }
            _getStoredAttributes() {
              return this._selection.getStoredAttributes();
            }
            _overrideGravity() {
              return this._selection.overrideGravity();
            }
            _restoreGravity(t) {
              this._selection.restoreGravity(t);
            }
            static _getStoreAttributeKey(t) {
              return Sl + t;
            }
            static _isStoreAttributeKey(t) {
              return t.startsWith(Sl);
            }
          }
          Il.prototype.is = function (t) {
            return (
              "selection" === t ||
              "model:selection" == t ||
              "documentSelection" == t ||
              "model:documentSelection" == t
            );
          };
          class Tl extends Al {
            constructor(t) {
              super(),
                (this.markers = new po({ idProperty: "name" })),
                (this._model = t.model),
                (this._document = t),
                (this._attributePriority = new Map()),
                (this._selectionRestorePosition = null),
                (this._hasChangedRange = !1),
                (this._overriddenGravityRegister = new Set()),
                (this._observedMarkers = new Set()),
                this.listenTo(
                  this._model,
                  "applyOperation",
                  (t, e) => {
                    const n = e[0];
                    n.isDocumentOperation &&
                      "marker" != n.type &&
                      "rename" != n.type &&
                      "noop" != n.type &&
                      (0 == this._ranges.length &&
                        this._selectionRestorePosition &&
                        this._fixGraveyardSelection(
                          this._selectionRestorePosition
                        ),
                      (this._selectionRestorePosition = null),
                      this._hasChangedRange &&
                        ((this._hasChangedRange = !1),
                        this.fire("change:range", { directChange: !1 })));
                  },
                  { priority: "lowest" }
                ),
                this.on("change:range", () => {
                  this._validateSelectionRanges(this.getRanges());
                }),
                this.listenTo(this._model.markers, "update", (t, e, n, o) => {
                  this._updateMarker(e, o);
                }),
                this.listenTo(this._document, "change", (t, e) => {
                  !(function (t, e) {
                    const n = t.document.differ;
                    for (const o of n.getChanges()) {
                      if ("insert" != o.type) continue;
                      const n = o.position.parent;
                      o.length === n.maxOffset &&
                        t.enqueueChange(e, (t) => {
                          const e = Array.from(n.getAttributeKeys()).filter(
                            (t) => t.startsWith(Sl)
                          );
                          for (const o of e) t.removeAttribute(o, n);
                        });
                    }
                  })(this._model, e);
                });
            }
            get isCollapsed() {
              return 0 === this._ranges.length
                ? this._document._getDefaultRange().isCollapsed
                : super.isCollapsed;
            }
            get anchor() {
              return super.anchor || this._document._getDefaultRange().start;
            }
            get focus() {
              return super.focus || this._document._getDefaultRange().end;
            }
            get rangeCount() {
              return this._ranges.length ? this._ranges.length : 1;
            }
            get hasOwnRange() {
              return this._ranges.length > 0;
            }
            get isGravityOverridden() {
              return !!this._overriddenGravityRegister.size;
            }
            destroy() {
              for (let t = 0; t < this._ranges.length; t++)
                this._ranges[t].detach();
              this.stopListening();
            }
            *getRanges() {
              this._ranges.length
                ? yield* super.getRanges()
                : yield this._document._getDefaultRange();
            }
            getFirstRange() {
              return super.getFirstRange() || this._document._getDefaultRange();
            }
            getLastRange() {
              return super.getLastRange() || this._document._getDefaultRange();
            }
            setTo(...t) {
              super.setTo(...t),
                this._updateAttributes(!0),
                this.updateMarkers();
            }
            setFocus(t, e) {
              super.setFocus(t, e),
                this._updateAttributes(!0),
                this.updateMarkers();
            }
            setAttribute(t, e) {
              if (this._setAttribute(t, e)) {
                const e = [t];
                this.fire("change:attribute", {
                  attributeKeys: e,
                  directChange: !0,
                });
              }
            }
            removeAttribute(t) {
              if (this._removeAttribute(t)) {
                const e = [t];
                this.fire("change:attribute", {
                  attributeKeys: e,
                  directChange: !0,
                });
              }
            }
            overrideGravity() {
              const t = r();
              return (
                this._overriddenGravityRegister.add(t),
                1 === this._overriddenGravityRegister.size &&
                  this._updateAttributes(!0),
                t
              );
            }
            restoreGravity(t) {
              if (!this._overriddenGravityRegister.has(t))
                throw new l("document-selection-gravity-wrong-restore", this, {
                  uid: t,
                });
              this._overriddenGravityRegister.delete(t),
                this.isGravityOverridden || this._updateAttributes(!0);
            }
            observeMarkers(t) {
              this._observedMarkers.add(t), this.updateMarkers();
            }
            _replaceAllRanges(t) {
              this._validateSelectionRanges(t), super._replaceAllRanges(t);
            }
            _popRange() {
              this._ranges.pop().detach();
            }
            _pushRange(t) {
              const e = this._prepareRange(t);
              e && this._ranges.push(e);
            }
            _validateSelectionRanges(t) {
              for (const e of t)
                if (!this._document._validateSelectionRange(e))
                  throw new l("document-selection-wrong-position", this, {
                    range: e,
                  });
            }
            _prepareRange(t) {
              if ((this._checkRange(t), t.root == this._document.graveyard))
                return;
              const e = xl.fromRange(t);
              return (
                e.on("change:range", (t, n, o) => {
                  if (
                    ((this._hasChangedRange = !0),
                    e.root == this._document.graveyard)
                  ) {
                    this._selectionRestorePosition = o.deletionPosition;
                    const t = this._ranges.indexOf(e);
                    this._ranges.splice(t, 1), e.detach();
                  }
                }),
                e
              );
            }
            updateMarkers() {
              if (!this._observedMarkers.size) return;
              const t = [];
              let e = !1;
              for (const e of this._model.markers) {
                const n = e.name.split(":", 1)[0];
                if (!this._observedMarkers.has(n)) continue;
                const o = e.getRange();
                for (const n of this.getRanges())
                  o.containsRange(n, !n.isCollapsed) && t.push(e);
              }
              const n = Array.from(this.markers);
              for (const n of t)
                this.markers.has(n) || (this.markers.add(n), (e = !0));
              for (const n of Array.from(this.markers))
                t.includes(n) || (this.markers.remove(n), (e = !0));
              e &&
                this.fire("change:marker", { oldMarkers: n, directChange: !1 });
            }
            _updateMarker(t, e) {
              const n = t.name.split(":", 1)[0];
              if (!this._observedMarkers.has(n)) return;
              let o = !1;
              const i = Array.from(this.markers),
                r = this.markers.has(t);
              if (e) {
                let n = !1;
                for (const t of this.getRanges())
                  if (e.containsRange(t, !t.isCollapsed)) {
                    n = !0;
                    break;
                  }
                n && !r
                  ? (this.markers.add(t), (o = !0))
                  : !n && r && (this.markers.remove(t), (o = !0));
              } else r && (this.markers.remove(t), (o = !0));
              o &&
                this.fire("change:marker", { oldMarkers: i, directChange: !1 });
            }
            _updateAttributes(t) {
              const e = Bo(this._getSurroundingAttributes()),
                n = Bo(this.getAttributes());
              if (t)
                (this._attributePriority = new Map()),
                  (this._attrs = new Map());
              else
                for (const [t, e] of this._attributePriority)
                  "low" == e &&
                    (this._attrs.delete(t), this._attributePriority.delete(t));
              this._setAttributesTo(e);
              const o = [];
              for (const [t, e] of this.getAttributes())
                (n.has(t) && n.get(t) === e) || o.push(t);
              for (const [t] of n) this.hasAttribute(t) || o.push(t);
              o.length > 0 &&
                this.fire("change:attribute", {
                  attributeKeys: o,
                  directChange: !1,
                });
            }
            _setAttribute(t, e, n = !0) {
              const o = n ? "normal" : "low";
              if ("low" == o && "normal" == this._attributePriority.get(t))
                return !1;
              return (
                super.getAttribute(t) !== e &&
                (this._attrs.set(t, e), this._attributePriority.set(t, o), !0)
              );
            }
            _removeAttribute(t, e = !0) {
              const n = e ? "normal" : "low";
              return (
                ("low" != n || "normal" != this._attributePriority.get(t)) &&
                (this._attributePriority.set(t, n),
                !!super.hasAttribute(t) && (this._attrs.delete(t), !0))
              );
            }
            _setAttributesTo(t) {
              const e = new Set();
              for (const [e, n] of this.getAttributes())
                t.get(e) !== n && this._removeAttribute(e, !1);
              for (const [n, o] of t) {
                this._setAttribute(n, o, !1) && e.add(n);
              }
              return e;
            }
            *getStoredAttributes() {
              const t = this.getFirstPosition().parent;
              if (this.isCollapsed && t.isEmpty)
                for (const e of t.getAttributeKeys())
                  if (e.startsWith(Sl)) {
                    const n = e.substr(Sl.length);
                    yield [n, t.getAttribute(e)];
                  }
            }
            _getSurroundingAttributes() {
              const t = this.getFirstPosition(),
                e = this._model.schema;
              let n = null;
              if (this.isCollapsed) {
                const o = t.textNode ? t.textNode : t.nodeBefore,
                  i = t.textNode ? t.textNode : t.nodeAfter;
                if (
                  (this.isGravityOverridden || (n = Ml(o)),
                  n || (n = Ml(i)),
                  !this.isGravityOverridden && !n)
                ) {
                  let t = o;
                  for (; t && !e.isInline(t) && !n; )
                    (t = t.previousSibling), (n = Ml(t));
                }
                if (!n) {
                  let t = i;
                  for (; t && !e.isInline(t) && !n; )
                    (t = t.nextSibling), (n = Ml(t));
                }
                n || (n = this.getStoredAttributes());
              } else {
                const t = this.getFirstRange();
                for (const o of t) {
                  if (o.item.is("element") && e.isObject(o.item)) break;
                  if ("text" == o.type) {
                    n = o.item.getAttributes();
                    break;
                  }
                }
              }
              return n;
            }
            _fixGraveyardSelection(t) {
              const e = this._model.schema.getNearestSelectionRange(t);
              e && this._pushRange(e);
            }
          }
          function Ml(t) {
            return t instanceof ol || t instanceof nl
              ? t.getAttributes()
              : null;
          }
          class Bl {
            constructor(t) {
              this._dispatchers = t;
            }
            add(t) {
              for (const e of this._dispatchers) t(e);
              return this;
            }
          }
          const Nl = function (t) {
            return ao(t, 5);
          };
          class zl extends Bl {
            elementToElement(t) {
              return this.add(
                (function (t) {
                  const e = Rl(t.model),
                    n = Ol(t.view, "container");
                  e.attributes.length && (e.children = !0);
                  return (o) => {
                    o.on(
                      `insert:${e.name}`,
                      (function (t, e = ql) {
                        return (n, o, i) => {
                          if (!e(o.item, i.consumable, { preflight: !0 }))
                            return;
                          const r = t(o.item, i, o);
                          if (!r) return;
                          e(o.item, i.consumable);
                          const s = i.mapper.toViewPosition(o.range.start);
                          i.mapper.bindElements(o.item, r),
                            i.writer.insert(s, r),
                            i.convertAttributes(o.item),
                            Wl(r, o.item.getChildren(), i, {
                              reconversion: o.reconversion,
                            });
                        };
                      })(n, Ul(e)),
                      { priority: t.converterPriority || "normal" }
                    ),
                      (e.children || e.attributes.length) &&
                        o.on("reduceChanges", Hl(e), { priority: "low" });
                  };
                })(t)
              );
            }
            elementToStructure(t) {
              return this.add(
                (function (t) {
                  const e = Rl(t.model),
                    n = Ol(t.view, "container");
                  return (
                    (e.children = !0),
                    (o) => {
                      if (o._conversionApi.schema.checkChild(e.name, "$text"))
                        throw new l(
                          "conversion-element-to-structure-disallowed-text",
                          o,
                          { elementName: e.name }
                        );
                      var i, r;
                      o.on(
                        `insert:${e.name}`,
                        ((i = n),
                        (r = Ul(e)),
                        (t, e, n) => {
                          if (!r(e.item, n.consumable, { preflight: !0 }))
                            return;
                          const o = new Map();
                          n.writer._registerSlotFactory(
                            (function (t, e, n) {
                              return (o, i = "children") => {
                                const r = o.createContainerElement("$slot");
                                let s = null;
                                if ("children" === i)
                                  s = Array.from(t.getChildren());
                                else {
                                  if ("function" != typeof i)
                                    throw new l(
                                      "conversion-slot-mode-unknown",
                                      n.dispatcher,
                                      { modeOrFilter: i }
                                    );
                                  s = Array.from(t.getChildren()).filter((t) =>
                                    i(t)
                                  );
                                }
                                return e.set(r, s), r;
                              };
                            })(e.item, o, n)
                          );
                          const s = i(e.item, n, e);
                          if ((n.writer._clearSlotFactory(), !s)) return;
                          !(function (t, e, n) {
                            const o = Array.from(e.values()).flat(),
                              i = new Set(o);
                            if (i.size != o.length)
                              throw new l(
                                "conversion-slot-filter-overlap",
                                n.dispatcher,
                                { element: t }
                              );
                            if (i.size != t.childCount)
                              throw new l(
                                "conversion-slot-filter-incomplete",
                                n.dispatcher,
                                { element: t }
                              );
                          })(e.item, o, n),
                            r(e.item, n.consumable);
                          const a = n.mapper.toViewPosition(e.range.start);
                          n.mapper.bindElements(e.item, s),
                            n.writer.insert(a, s),
                            n.convertAttributes(e.item),
                            (function (t, e, n, o) {
                              n.mapper.on("modelToViewPosition", s, {
                                priority: "highest",
                              });
                              let i = null,
                                r = null;
                              for ([i, r] of e)
                                Wl(t, r, n, o),
                                  n.writer.move(
                                    n.writer.createRangeIn(i),
                                    n.writer.createPositionBefore(i)
                                  ),
                                  n.writer.remove(i);
                              function s(t, e) {
                                const n = e.modelPosition.nodeAfter,
                                  o = r.indexOf(n);
                                o < 0 ||
                                  (e.viewPosition = e.mapper.findPositionIn(
                                    i,
                                    o
                                  ));
                              }
                              n.mapper.off("modelToViewPosition", s);
                            })(s, o, n, { reconversion: e.reconversion });
                        }),
                        { priority: t.converterPriority || "normal" }
                      ),
                        o.on("reduceChanges", Hl(e), { priority: "low" });
                    }
                  );
                })(t)
              );
            }
            attributeToElement(t) {
              return this.add(
                (function (t) {
                  let e = (t = Nl(t)).model;
                  "string" == typeof e && (e = { key: e });
                  let n = `attribute:${e.key}`;
                  e.name && (n += ":" + e.name);
                  if (e.values)
                    for (const n of e.values)
                      t.view[n] = Ol(t.view[n], "attribute");
                  else t.view = Ol(t.view, "attribute");
                  const o = jl(t);
                  return (e) => {
                    e.on(
                      n,
                      (function (t) {
                        return (e, n, o) => {
                          if (!o.consumable.test(n.item, e.name)) return;
                          const i = t(n.attributeOldValue, o, n),
                            r = t(n.attributeNewValue, o, n);
                          if (!i && !r) return;
                          o.consumable.consume(n.item, e.name);
                          const s = o.writer,
                            a = s.document.selection;
                          if (n.item instanceof Al || n.item instanceof Il)
                            s.wrap(a.getFirstRange(), r);
                          else {
                            let t = o.mapper.toViewRange(n.range);
                            null !== n.attributeOldValue &&
                              i &&
                              (t = s.unwrap(t, i)),
                              null !== n.attributeNewValue && r && s.wrap(t, r);
                          }
                        };
                      })(o),
                      { priority: t.converterPriority || "normal" }
                    );
                  };
                })(t)
              );
            }
            attributeToAttribute(t) {
              return this.add(
                (function (t) {
                  let e = (t = Nl(t)).model;
                  "string" == typeof e && (e = { key: e });
                  let n = `attribute:${e.key}`;
                  e.name && (n += ":" + e.name);
                  if (e.values)
                    for (const n of e.values) t.view[n] = Vl(t.view[n]);
                  else t.view = Vl(t.view);
                  const o = jl(t);
                  return (e) => {
                    var i;
                    e.on(
                      n,
                      ((i = o),
                      (t, e, n) => {
                        if (!n.consumable.test(e.item, t.name)) return;
                        const o = i(e.attributeOldValue, n, e),
                          r = i(e.attributeNewValue, n, e);
                        if (!o && !r) return;
                        n.consumable.consume(e.item, t.name);
                        const s = n.mapper.toViewElement(e.item),
                          a = n.writer;
                        if (!s)
                          throw new l(
                            "conversion-attribute-to-attribute-on-text",
                            n.dispatcher,
                            e
                          );
                        if (null !== e.attributeOldValue && o)
                          if ("class" == o.key) {
                            const t = ko(o.value);
                            for (const e of t) a.removeClass(e, s);
                          } else if ("style" == o.key) {
                            const t = Object.keys(o.value);
                            for (const e of t) a.removeStyle(e, s);
                          } else a.removeAttribute(o.key, s);
                        if (null !== e.attributeNewValue && r)
                          if ("class" == r.key) {
                            const t = ko(r.value);
                            for (const e of t) a.addClass(e, s);
                          } else if ("style" == r.key) {
                            const t = Object.keys(r.value);
                            for (const e of t) a.setStyle(e, r.value[e], s);
                          } else a.setAttribute(r.key, r.value, s);
                      }),
                      { priority: t.converterPriority || "normal" }
                    );
                  };
                })(t)
              );
            }
            markerToElement(t) {
              return this.add(
                (function (t) {
                  const e = Ol(t.view, "ui");
                  return (n) => {
                    var o;
                    n.on(
                      `addMarker:${t.model}`,
                      ((o = e),
                      (t, e, n) => {
                        e.isOpening = !0;
                        const i = o(e, n);
                        e.isOpening = !1;
                        const r = o(e, n);
                        if (!i || !r) return;
                        const s = e.markerRange;
                        if (s.isCollapsed && !n.consumable.consume(s, t.name))
                          return;
                        for (const e of s)
                          if (!n.consumable.consume(e.item, t.name)) return;
                        const a = n.mapper,
                          l = n.writer;
                        l.insert(a.toViewPosition(s.start), i),
                          n.mapper.bindElementToMarker(i, e.markerName),
                          s.isCollapsed ||
                            (l.insert(a.toViewPosition(s.end), r),
                            n.mapper.bindElementToMarker(r, e.markerName)),
                          t.stop();
                      }),
                      { priority: t.converterPriority || "normal" }
                    ),
                      n.on(
                        `removeMarker:${t.model}`,
                        (t, e, n) => {
                          const o = n.mapper.markerNameToElements(e.markerName);
                          if (o) {
                            for (const t of o)
                              n.mapper.unbindElementFromMarkerName(
                                t,
                                e.markerName
                              ),
                                n.writer.clear(n.writer.createRangeOn(t), t);
                            n.writer.clearClonedElementsGroup(e.markerName),
                              t.stop();
                          }
                        },
                        { priority: t.converterPriority || "normal" }
                      );
                  };
                })(t)
              );
            }
            markerToHighlight(t) {
              return this.add(
                (function (t) {
                  return (e) => {
                    var n;
                    e.on(
                      `addMarker:${t.model}`,
                      ((n = t.view),
                      (t, e, o) => {
                        if (!e.item) return;
                        if (
                          !(
                            e.item instanceof Al ||
                            e.item instanceof Il ||
                            e.item.is("$textProxy")
                          )
                        )
                          return;
                        const i = Fl(n, e, o);
                        if (!i) return;
                        if (!o.consumable.consume(e.item, t.name)) return;
                        const r = o.writer,
                          s = Pl(r, i),
                          a = r.document.selection;
                        if (e.item instanceof Al || e.item instanceof Il)
                          r.wrap(a.getFirstRange(), s);
                        else {
                          const t = o.mapper.toViewRange(e.range),
                            n = r.wrap(t, s);
                          for (const t of n.getItems())
                            if (t.is("attributeElement") && t.isSimilar(s)) {
                              o.mapper.bindElementToMarker(t, e.markerName);
                              break;
                            }
                        }
                      }),
                      { priority: t.converterPriority || "normal" }
                    ),
                      e.on(
                        `addMarker:${t.model}`,
                        (function (t) {
                          return (e, n, o) => {
                            if (!n.item) return;
                            if (!(n.item instanceof il)) return;
                            const i = Fl(t, n, o);
                            if (!i) return;
                            if (!o.consumable.test(n.item, e.name)) return;
                            const r = o.mapper.toViewElement(n.item);
                            if (r && r.getCustomProperty("addHighlight")) {
                              o.consumable.consume(n.item, e.name);
                              for (const t of ml._createIn(n.item))
                                o.consumable.consume(t.item, e.name);
                              r.getCustomProperty("addHighlight")(
                                r,
                                i,
                                o.writer
                              ),
                                o.mapper.bindElementToMarker(r, n.markerName);
                            }
                          };
                        })(t.view),
                        { priority: t.converterPriority || "normal" }
                      ),
                      e.on(
                        `removeMarker:${t.model}`,
                        (function (t) {
                          return (e, n, o) => {
                            if (n.markerRange.isCollapsed) return;
                            const i = Fl(t, n, o);
                            if (!i) return;
                            const r = Pl(o.writer, i),
                              s = o.mapper.markerNameToElements(n.markerName);
                            if (s) {
                              for (const t of s)
                                if (
                                  (o.mapper.unbindElementFromMarkerName(
                                    t,
                                    n.markerName
                                  ),
                                  t.is("attributeElement"))
                                )
                                  o.writer.unwrap(o.writer.createRangeOn(t), r);
                                else {
                                  t.getCustomProperty("removeHighlight")(
                                    t,
                                    i.id,
                                    o.writer
                                  );
                                }
                              o.writer.clearClonedElementsGroup(n.markerName),
                                e.stop();
                            }
                          };
                        })(t.view),
                        { priority: t.converterPriority || "normal" }
                      );
                  };
                })(t)
              );
            }
            markerToData(t) {
              return this.add(
                (function (t) {
                  const e = (t = Nl(t)).model;
                  let n = t.view;
                  n ||
                    (n = (n) => ({
                      group: e,
                      name: n.substr(t.model.length + 1),
                    }));
                  return (o) => {
                    var i;
                    o.on(
                      `addMarker:${e}`,
                      ((i = n),
                      (t, e, n) => {
                        const o = i(e.markerName, n);
                        if (!o) return;
                        const r = e.markerRange;
                        n.consumable.consume(r, t.name) &&
                          (Ll(r, !1, n, e, o), Ll(r, !0, n, e, o), t.stop());
                      }),
                      { priority: t.converterPriority || "normal" }
                    ),
                      o.on(
                        `removeMarker:${e}`,
                        (function (t) {
                          return (e, n, o) => {
                            const i = t(n.markerName, o);
                            if (!i) return;
                            const r = o.mapper.markerNameToElements(
                              n.markerName
                            );
                            if (r) {
                              for (const t of r)
                                o.mapper.unbindElementFromMarkerName(
                                  t,
                                  n.markerName
                                ),
                                  t.is("containerElement")
                                    ? (s(`data-${i.group}-start-before`, t),
                                      s(`data-${i.group}-start-after`, t),
                                      s(`data-${i.group}-end-before`, t),
                                      s(`data-${i.group}-end-after`, t))
                                    : o.writer.clear(
                                        o.writer.createRangeOn(t),
                                        t
                                      );
                              o.writer.clearClonedElementsGroup(n.markerName),
                                e.stop();
                            }
                            function s(t, e) {
                              if (e.hasAttribute(t)) {
                                const n = new Set(e.getAttribute(t).split(","));
                                n.delete(i.name),
                                  0 == n.size
                                    ? o.writer.removeAttribute(t, e)
                                    : o.writer.setAttribute(
                                        t,
                                        Array.from(n).join(","),
                                        e
                                      );
                              }
                            }
                          };
                        })(n),
                        { priority: t.converterPriority || "normal" }
                      );
                  };
                })(t)
              );
            }
          }
          function Pl(t, e) {
            const n = t.createAttributeElement("span", e.attributes);
            return (
              e.classes && n._addClass(e.classes),
              "number" == typeof e.priority && (n._priority = e.priority),
              (n._id = e.id),
              n
            );
          }
          function Ll(t, e, n, o, i) {
            const r = e ? t.start : t.end,
              s = r.nodeAfter && r.nodeAfter.is("element") ? r.nodeAfter : null,
              a =
                r.nodeBefore && r.nodeBefore.is("element")
                  ? r.nodeBefore
                  : null;
            if (s || a) {
              let t, r;
              (e && s) || (!e && !a)
                ? ((t = s), (r = !0))
                : ((t = a), (r = !1));
              const l = n.mapper.toViewElement(t);
              if (l)
                return void (function (t, e, n, o, i, r) {
                  const s = `data-${r.group}-${e ? "start" : "end"}-${
                      n ? "before" : "after"
                    }`,
                    a = t.hasAttribute(s) ? t.getAttribute(s).split(",") : [];
                  a.unshift(r.name),
                    o.writer.setAttribute(s, a.join(","), t),
                    o.mapper.bindElementToMarker(t, i.markerName);
                })(l, e, r, n, o, i);
            }
            !(function (t, e, n, o, i) {
              const r = `${i.group}-${e ? "start" : "end"}`,
                s = i.name ? { name: i.name } : null,
                a = n.writer.createUIElement(r, s);
              n.writer.insert(t, a),
                n.mapper.bindElementToMarker(a, o.markerName);
            })(n.mapper.toViewPosition(r), e, n, o, i);
          }
          function Rl(t) {
            return (
              "string" == typeof t && (t = { name: t }),
              t.attributes
                ? Array.isArray(t.attributes) || (t.attributes = [t.attributes])
                : (t.attributes = []),
              (t.children = !!t.children),
              t
            );
          }
          function Ol(t, e) {
            return "function" == typeof t
              ? t
              : (n, o) =>
                  (function (t, e, n) {
                    "string" == typeof t && (t = { name: t });
                    let o;
                    const i = e.writer,
                      r = Object.assign({}, t.attributes);
                    if ("container" == n)
                      o = i.createContainerElement(t.name, r);
                    else if ("attribute" == n) {
                      const e = { priority: t.priority || tr.DEFAULT_PRIORITY };
                      o = i.createAttributeElement(t.name, r, e);
                    } else o = i.createUIElement(t.name, r);
                    if (t.styles) {
                      const e = Object.keys(t.styles);
                      for (const n of e) i.setStyle(n, t.styles[n], o);
                    }
                    if (t.classes) {
                      const e = t.classes;
                      if ("string" == typeof e) i.addClass(e, o);
                      else for (const t of e) i.addClass(t, o);
                    }
                    return o;
                  })(t, o, e);
          }
          function jl(t) {
            return t.model.values
              ? (e, n, o) => {
                  const i = t.view[e];
                  return i ? i(e, n, o) : null;
                }
              : t.view;
          }
          function Vl(t) {
            return "string" == typeof t
              ? (e) => ({ key: t, value: e })
              : "object" == typeof t
              ? t.value
                ? () => t
                : (e) => ({ key: t.key, value: e })
              : t;
          }
          function Fl(t, e, n) {
            const o = "function" == typeof t ? t(e, n) : t;
            return o
              ? (o.priority || (o.priority = 10),
                o.id || (o.id = e.markerName),
                o)
              : null;
          }
          function Hl(t) {
            const e = (function (t) {
              return (e, n) => {
                if (!e.is("element", t.name)) return !1;
                if ("attribute" == n.type) {
                  if (t.attributes.includes(n.attributeKey)) return !0;
                } else if (t.children) return !0;
                return !1;
              };
            })(t);
            return (t, n) => {
              const o = [];
              n.reconvertedElements || (n.reconvertedElements = new Set());
              for (const t of n.changes) {
                const i =
                  "attribute" == t.type
                    ? t.range.start.nodeAfter
                    : t.position.parent;
                if (i && e(i, t)) {
                  if (!n.reconvertedElements.has(i)) {
                    n.reconvertedElements.add(i);
                    const t = al._createBefore(i);
                    o.push(
                      { type: "remove", name: i.name, position: t, length: 1 },
                      { type: "reinsert", name: i.name, position: t, length: 1 }
                    );
                  }
                } else o.push(t);
              }
              n.changes = o;
            };
          }
          function Ul(t) {
            return (e, n, o = {}) => {
              const i = ["insert"];
              for (const n of t.attributes)
                e.hasAttribute(n) && i.push(`attribute:${n}`);
              return (
                !!i.every((t) => n.test(e, t)) &&
                (o.preflight || i.forEach((t) => n.consume(e, t)), !0)
              );
            };
          }
          function Wl(t, e, n, o) {
            for (const i of e) $l(t.root, i, n, o) || n.convertItem(i);
          }
          function $l(t, e, n, o) {
            const { writer: i, mapper: r } = n;
            if (!o.reconversion) return !1;
            const s = r.toViewElement(e);
            return (
              !(!s || s.root == t) &&
              !!n.canReuseView(s) &&
              (i.move(
                i.createRangeOn(s),
                r.toViewPosition(al._createBefore(e))
              ),
              !0)
            );
          }
          function ql(t, e, { preflight: n } = {}) {
            return n ? e.test(t, "insert") : e.consume(t, "insert");
          }
          function Gl(t) {
            const { schema: e, document: n } = t.model;
            for (const o of n.getRootNames()) {
              const i = n.getRoot(o);
              if (
                i.isEmpty &&
                !e.checkChild(i, "$text") &&
                e.checkChild(i, "paragraph")
              )
                return t.insertElement("paragraph", i), !0;
            }
            return !1;
          }
          function Zl(t, e, n) {
            const o = n.createContext(t);
            return (
              !!n.checkChild(o, "paragraph") &&
              !!n.checkChild(o.push("paragraph"), e)
            );
          }
          function Yl(t, e) {
            const n = e.createElement("paragraph");
            return e.insert(n, t), e.createPositionAt(n, 0);
          }
          class Kl extends Bl {
            elementToElement(t) {
              return this.add(Ql(t));
            }
            elementToAttribute(t) {
              return this.add(
                (function (t) {
                  tc((t = Nl(t)));
                  const e = ec(t, !1),
                    n = Jl(t.view),
                    o = n ? `element:${n}` : "element";
                  return (n) => {
                    n.on(o, e, { priority: t.converterPriority || "low" });
                  };
                })(t)
              );
            }
            attributeToAttribute(t) {
              return this.add(
                (function (t) {
                  t = Nl(t);
                  let e = null;
                  ("string" == typeof t.view || t.view.key) &&
                    (e = (function (t) {
                      "string" == typeof t.view && (t.view = { key: t.view });
                      const e = t.view.key;
                      let n;
                      if ("class" == e || "style" == e) {
                        n = {
                          ["class" == e ? "classes" : "styles"]: t.view.value,
                        };
                      } else {
                        n = {
                          attributes: {
                            [e]:
                              void 0 === t.view.value
                                ? /[\s\S]*/
                                : t.view.value,
                          },
                        };
                      }
                      t.view.name && (n.name = t.view.name);
                      return (t.view = n), e;
                    })(t));
                  tc(t, e);
                  const n = ec(t, !0);
                  return (e) => {
                    e.on("element", n, {
                      priority: t.converterPriority || "low",
                    });
                  };
                })(t)
              );
            }
            elementToMarker(t) {
              return this.add(
                (function (t) {
                  const e = (function (t) {
                    return (e, n) => {
                      const o = "string" == typeof t ? t : t(e, n);
                      return n.writer.createElement("$marker", {
                        "data-name": o,
                      });
                    };
                  })(t.model);
                  return Ql({ ...t, model: e });
                })(t)
              );
            }
            dataToMarker(t) {
              return this.add(
                (function (t) {
                  (t = Nl(t)).model ||
                    (t.model = (e) => (e ? t.view + ":" + e : t.view));
                  const e = { view: t.view, model: t.model },
                    n = Xl(nc(e, "start")),
                    o = Xl(nc(e, "end"));
                  return (i) => {
                    i.on(`element:${t.view}-start`, n, {
                      priority: t.converterPriority || "normal",
                    }),
                      i.on(`element:${t.view}-end`, o, {
                        priority: t.converterPriority || "normal",
                      });
                    const r = s.get("low"),
                      a = s.get("highest"),
                      l = s.get(t.converterPriority) / a;
                    i.on(
                      "element",
                      (function (t) {
                        return (e, n, o) => {
                          const i = `data-${t.view}`;
                          function r(e, i) {
                            for (const r of i) {
                              const i = t.model(r, o),
                                s = o.writer.createElement("$marker", {
                                  "data-name": i,
                                });
                              o.writer.insert(s, e),
                                n.modelCursor.isEqual(e)
                                  ? (n.modelCursor =
                                      n.modelCursor.getShiftedBy(1))
                                  : (n.modelCursor =
                                      n.modelCursor._getTransformedByInsertion(
                                        e,
                                        1
                                      )),
                                (n.modelRange =
                                  n.modelRange._getTransformedByInsertion(
                                    e,
                                    1
                                  )[0]);
                            }
                          }
                          (o.consumable.test(n.viewItem, {
                            attributes: i + "-end-after",
                          }) ||
                            o.consumable.test(n.viewItem, {
                              attributes: i + "-start-after",
                            }) ||
                            o.consumable.test(n.viewItem, {
                              attributes: i + "-end-before",
                            }) ||
                            o.consumable.test(n.viewItem, {
                              attributes: i + "-start-before",
                            })) &&
                            (n.modelRange ||
                              Object.assign(
                                n,
                                o.convertChildren(n.viewItem, n.modelCursor)
                              ),
                            o.consumable.consume(n.viewItem, {
                              attributes: i + "-end-after",
                            }) &&
                              r(
                                n.modelRange.end,
                                n.viewItem
                                  .getAttribute(i + "-end-after")
                                  .split(",")
                              ),
                            o.consumable.consume(n.viewItem, {
                              attributes: i + "-start-after",
                            }) &&
                              r(
                                n.modelRange.end,
                                n.viewItem
                                  .getAttribute(i + "-start-after")
                                  .split(",")
                              ),
                            o.consumable.consume(n.viewItem, {
                              attributes: i + "-end-before",
                            }) &&
                              r(
                                n.modelRange.start,
                                n.viewItem
                                  .getAttribute(i + "-end-before")
                                  .split(",")
                              ),
                            o.consumable.consume(n.viewItem, {
                              attributes: i + "-start-before",
                            }) &&
                              r(
                                n.modelRange.start,
                                n.viewItem
                                  .getAttribute(i + "-start-before")
                                  .split(",")
                              ));
                        };
                      })(e),
                      { priority: r + l }
                    );
                  };
                })(t)
              );
            }
          }
          function Ql(t) {
            const e = Xl((t = Nl(t))),
              n = Jl(t.view),
              o = n ? `element:${n}` : "element";
            return (n) => {
              n.on(o, e, { priority: t.converterPriority || "normal" });
            };
          }
          function Jl(t) {
            return "string" == typeof t
              ? t
              : "object" == typeof t && "string" == typeof t.name
              ? t.name
              : null;
          }
          function Xl(t) {
            const e = new No(t.view);
            return (n, o, i) => {
              const r = e.match(o.viewItem);
              if (!r) return;
              const s = r.match;
              if (((s.name = !0), !i.consumable.test(o.viewItem, s))) return;
              const a = (function (t, e, n) {
                return t instanceof Function
                  ? t(e, n)
                  : n.writer.createElement(t);
              })(t.model, o.viewItem, i);
              a &&
                i.safeInsert(a, o.modelCursor) &&
                (i.consumable.consume(o.viewItem, s),
                i.convertChildren(o.viewItem, a),
                i.updateConversionResult(a, o));
            };
          }
          function tc(t, e = null) {
            const n = null === e || ((t) => t.getAttribute(e)),
              o = "object" != typeof t.model ? t.model : t.model.key,
              i =
                "object" != typeof t.model || void 0 === t.model.value
                  ? n
                  : t.model.value;
            t.model = { key: o, value: i };
          }
          function ec(t, e) {
            const n = new No(t.view);
            return (o, i, r) => {
              if (!i.modelRange && e) return;
              const s = n.match(i.viewItem);
              if (!s) return;
              if (
                (!(function (t, e) {
                  const n = "function" == typeof t ? t(e) : t;
                  if ("object" == typeof n && !Jl(n)) return !1;
                  return !n.classes && !n.attributes && !n.styles;
                })(t.view, i.viewItem)
                  ? delete s.match.name
                  : (s.match.name = !0),
                !r.consumable.test(i.viewItem, s.match))
              )
                return;
              const a = t.model.key,
                l =
                  "function" == typeof t.model.value
                    ? t.model.value(i.viewItem, r)
                    : t.model.value;
              if (null === l) return;
              i.modelRange ||
                Object.assign(i, r.convertChildren(i.viewItem, i.modelCursor));
              const c = (function (t, e, n, o) {
                let i = !1;
                for (const r of Array.from(t.getItems({ shallow: n })))
                  o.schema.checkAttribute(r, e.key) &&
                    ((i = !0),
                    r.hasAttribute(e.key) ||
                      o.writer.setAttribute(e.key, e.value, r));
                return i;
              })(i.modelRange, { key: a, value: l }, e, r);
              c &&
                (r.consumable.test(i.viewItem, { name: !0 }) &&
                  (s.match.name = !0),
                r.consumable.consume(i.viewItem, s.match));
            };
          }
          function nc(t, e) {
            return {
              view: `${t.view}-${e}`,
              model: (e, n) => {
                const o = e.getAttribute("name"),
                  i = t.model(o, n);
                return n.writer.createElement("$marker", { "data-name": i });
              },
            };
          }
          class oc extends N {
            constructor(t, e) {
              super(),
                (this.model = t),
                (this.view = new Ja(e)),
                (this.mapper = new gl()),
                (this.downcastDispatcher = new kl({
                  mapper: this.mapper,
                  schema: t.schema,
                }));
              const n = this.model.document,
                o = n.selection,
                i = this.model.markers;
              this.listenTo(
                this.model,
                "_beforeChanges",
                () => {
                  this.view._disableRendering(!0);
                },
                { priority: "highest" }
              ),
                this.listenTo(
                  this.model,
                  "_afterChanges",
                  () => {
                    this.view._disableRendering(!1);
                  },
                  { priority: "lowest" }
                ),
                this.listenTo(
                  n,
                  "change",
                  () => {
                    this.view.change((t) => {
                      this.downcastDispatcher.convertChanges(n.differ, i, t),
                        this.downcastDispatcher.convertSelection(o, i, t);
                    });
                  },
                  { priority: "low" }
                ),
                this.listenTo(
                  this.view.document,
                  "selectionChange",
                  (function (t, e) {
                    return (n, o) => {
                      const i = o.newSelection,
                        r = [];
                      for (const t of i.getRanges()) r.push(e.toModelRange(t));
                      const s = t.createSelection(r, {
                        backward: i.isBackward,
                      });
                      s.isEqual(t.document.selection) ||
                        t.change((t) => {
                          t.setSelection(s);
                        });
                    };
                  })(this.model, this.mapper)
                ),
                this.downcastDispatcher.on(
                  "insert:$text",
                  (t, e, n) => {
                    if (!n.consumable.consume(e.item, t.name)) return;
                    const o = n.writer,
                      i = n.mapper.toViewPosition(e.range.start),
                      r = o.createText(e.item.data);
                    o.insert(i, r);
                  },
                  { priority: "lowest" }
                ),
                this.downcastDispatcher.on(
                  "insert",
                  (t, e, n) => {
                    n.convertAttributes(e.item),
                      e.reconversion ||
                        !e.item.is("element") ||
                        e.item.isEmpty ||
                        n.convertChildren(e.item);
                  },
                  { priority: "lowest" }
                ),
                this.downcastDispatcher.on(
                  "remove",
                  (t, e, n) => {
                    const o = n.mapper.toViewPosition(e.position),
                      i = e.position.getShiftedBy(e.length),
                      r = n.mapper.toViewPosition(i, { isPhantom: !0 }),
                      s = n.writer.createRange(o, r),
                      a = n.writer.remove(s.getTrimmed());
                    for (const t of n.writer.createRangeIn(a).getItems())
                      n.mapper.unbindViewElement(t, { defer: !0 });
                  },
                  { priority: "low" }
                ),
                this.downcastDispatcher.on(
                  "selection",
                  (t, e, n) => {
                    const o = n.writer,
                      i = o.document.selection;
                    for (const t of i.getRanges())
                      t.isCollapsed &&
                        t.end.parent.isAttached() &&
                        n.writer.mergeAttributes(t.start);
                    o.setSelection(null);
                  },
                  { priority: "high" }
                ),
                this.downcastDispatcher.on(
                  "selection",
                  (t, e, n) => {
                    const o = e.selection;
                    if (o.isCollapsed) return;
                    if (!n.consumable.consume(o, "selection")) return;
                    const i = [];
                    for (const t of o.getRanges())
                      i.push(n.mapper.toViewRange(t));
                    n.writer.setSelection(i, { backward: o.isBackward });
                  },
                  { priority: "low" }
                ),
                this.downcastDispatcher.on(
                  "selection",
                  (t, e, n) => {
                    const o = e.selection;
                    if (!o.isCollapsed) return;
                    if (!n.consumable.consume(o, "selection")) return;
                    const i = n.writer,
                      r = o.getFirstPosition(),
                      s = n.mapper.toViewPosition(r),
                      a = i.breakAttributes(s);
                    i.setSelection(a);
                  },
                  { priority: "low" }
                ),
                this.view.document.roots
                  .bindTo(this.model.document.roots)
                  .using((t) => {
                    if ("$graveyard" == t.rootName) return null;
                    const e = new Oi(this.view.document, t.name);
                    return (
                      (e.rootName = t.rootName),
                      this.mapper.bindElements(t, e),
                      e
                    );
                  });
            }
            destroy() {
              this.view.destroy(), this.stopListening();
            }
            reconvertMarker(t) {
              const e = "string" == typeof t ? t : t.name,
                n = this.model.markers.get(e);
              if (!n)
                throw new l(
                  "editingcontroller-reconvertmarker-marker-not-exist",
                  this,
                  { markerName: e }
                );
              this.model.change(() => {
                this.model.markers._refresh(n);
              });
            }
            reconvertItem(t) {
              this.model.change(() => {
                this.model.document.differ._refreshItem(t);
              });
            }
          }
          class ic {
            constructor() {
              this._commands = new Map();
            }
            add(t, e) {
              this._commands.set(t, e);
            }
            get(t) {
              return this._commands.get(t);
            }
            execute(t, ...e) {
              const n = this.get(t);
              if (!n)
                throw new l("commandcollection-command-not-found", this, {
                  commandName: t,
                });
              return n.execute(...e);
            }
            *names() {
              yield* this._commands.keys();
            }
            *commands() {
              yield* this._commands.values();
            }
            [Symbol.iterator]() {
              return this._commands[Symbol.iterator]();
            }
            destroy() {
              for (const t of this.commands()) t.destroy();
            }
          }
          class rc {
            constructor() {
              this._consumables = new Map();
            }
            add(t, e) {
              let n;
              t.is("$text") || t.is("documentFragment")
                ? this._consumables.set(t, !0)
                : (this._consumables.has(t)
                    ? (n = this._consumables.get(t))
                    : ((n = new ac(t)), this._consumables.set(t, n)),
                  n.add(e));
            }
            test(t, e) {
              const n = this._consumables.get(t);
              return void 0 === n
                ? null
                : t.is("$text") || t.is("documentFragment")
                ? n
                : n.test(e);
            }
            consume(t, e) {
              return (
                !!this.test(t, e) &&
                (t.is("$text") || t.is("documentFragment")
                  ? this._consumables.set(t, !1)
                  : this._consumables.get(t).consume(e),
                !0)
              );
            }
            revert(t, e) {
              const n = this._consumables.get(t);
              void 0 !== n &&
                (t.is("$text") || t.is("documentFragment")
                  ? this._consumables.set(t, !0)
                  : n.revert(e));
            }
            static consumablesFromElement(t) {
              const e = {
                  element: t,
                  name: !0,
                  attributes: [],
                  classes: [],
                  styles: [],
                },
                n = t.getAttributeKeys();
              for (const t of n)
                "style" != t && "class" != t && e.attributes.push(t);
              const o = t.getClassNames();
              for (const t of o) e.classes.push(t);
              const i = t.getStyleNames();
              for (const t of i) e.styles.push(t);
              return e;
            }
            static createFrom(t, e) {
              if ((e || (e = new rc()), t.is("$text"))) return e.add(t), e;
              t.is("element") && e.add(t, rc.consumablesFromElement(t)),
                t.is("documentFragment") && e.add(t);
              for (const n of t.getChildren()) e = rc.createFrom(n, e);
              return e;
            }
          }
          const sc = ["attributes", "classes", "styles"];
          class ac {
            constructor(t) {
              (this.element = t),
                (this._canConsumeName = null),
                (this._consumables = {
                  attributes: new Map(),
                  styles: new Map(),
                  classes: new Map(),
                });
            }
            add(t) {
              t.name && (this._canConsumeName = !0);
              for (const e of sc) e in t && this._add(e, t[e]);
            }
            test(t) {
              if (t.name && !this._canConsumeName) return this._canConsumeName;
              for (const e of sc)
                if (e in t) {
                  const n = this._test(e, t[e]);
                  if (!0 !== n) return n;
                }
              return !0;
            }
            consume(t) {
              t.name && (this._canConsumeName = !1);
              for (const e of sc) e in t && this._consume(e, t[e]);
            }
            revert(t) {
              t.name && (this._canConsumeName = !0);
              for (const e of sc) e in t && this._revert(e, t[e]);
            }
            _add(t, e) {
              const n = Ce(e) ? e : [e],
                o = this._consumables[t];
              for (const e of n) {
                if ("attributes" === t && ("class" === e || "style" === e))
                  throw new l("viewconsumable-invalid-attribute", this);
                if ((o.set(e, !0), "styles" === t))
                  for (const t of this.element.document.stylesProcessor.getRelatedStyles(
                    e
                  ))
                    o.set(t, !0);
              }
            }
            _test(t, e) {
              const n = Ce(e) ? e : [e],
                o = this._consumables[t];
              for (const e of n)
                if ("attributes" !== t || ("class" !== e && "style" !== e)) {
                  const t = o.get(e);
                  if (void 0 === t) return null;
                  if (!t) return !1;
                } else {
                  const t = "class" == e ? "classes" : "styles",
                    n = this._test(t, [...this._consumables[t].keys()]);
                  if (!0 !== n) return n;
                }
              return !0;
            }
            _consume(t, e) {
              const n = Ce(e) ? e : [e],
                o = this._consumables[t];
              for (const e of n)
                if ("attributes" !== t || ("class" !== e && "style" !== e)) {
                  if ((o.set(e, !1), "styles" == t))
                    for (const t of this.element.document.stylesProcessor.getRelatedStyles(
                      e
                    ))
                      o.set(t, !1);
                } else {
                  const t = "class" == e ? "classes" : "styles";
                  this._consume(t, [...this._consumables[t].keys()]);
                }
            }
            _revert(t, e) {
              const n = Ce(e) ? e : [e],
                o = this._consumables[t];
              for (const e of n)
                if ("attributes" !== t || ("class" !== e && "style" !== e)) {
                  !1 === o.get(e) && o.set(e, !0);
                } else {
                  const t = "class" == e ? "classes" : "styles";
                  this._revert(t, [...this._consumables[t].keys()]);
                }
            }
          }
          class lc extends N {
            constructor() {
              super(),
                (this._sourceDefinitions = {}),
                (this._attributeProperties = {}),
                this.decorate("checkChild"),
                this.decorate("checkAttribute"),
                this.on(
                  "checkAttribute",
                  (t, e) => {
                    e[0] = new cc(e[0]);
                  },
                  { priority: "highest" }
                ),
                this.on(
                  "checkChild",
                  (t, e) => {
                    (e[0] = new cc(e[0])), (e[1] = this.getDefinition(e[1]));
                  },
                  { priority: "highest" }
                );
            }
            register(t, e) {
              if (this._sourceDefinitions[t])
                throw new l("schema-cannot-register-item-twice", this, {
                  itemName: t,
                });
              (this._sourceDefinitions[t] = [Object.assign({}, e)]),
                this._clearCache();
            }
            extend(t, e) {
              if (!this._sourceDefinitions[t])
                throw new l("schema-cannot-extend-missing-item", this, {
                  itemName: t,
                });
              this._sourceDefinitions[t].push(Object.assign({}, e)),
                this._clearCache();
            }
            getDefinitions() {
              return (
                this._compiledDefinitions || this._compile(),
                this._compiledDefinitions
              );
            }
            getDefinition(t) {
              let e;
              return (
                (e =
                  "string" == typeof t
                    ? t
                    : "is" in t && (t.is("$text") || t.is("$textProxy"))
                    ? "$text"
                    : t.name),
                this.getDefinitions()[e]
              );
            }
            isRegistered(t) {
              return !!this.getDefinition(t);
            }
            isBlock(t) {
              const e = this.getDefinition(t);
              return !(!e || !e.isBlock);
            }
            isLimit(t) {
              const e = this.getDefinition(t);
              return !!e && !(!e.isLimit && !e.isObject);
            }
            isObject(t) {
              const e = this.getDefinition(t);
              return (
                !!e &&
                !!(e.isObject || (e.isLimit && e.isSelectable && e.isContent))
              );
            }
            isInline(t) {
              const e = this.getDefinition(t);
              return !(!e || !e.isInline);
            }
            isSelectable(t) {
              const e = this.getDefinition(t);
              return !!e && !(!e.isSelectable && !e.isObject);
            }
            isContent(t) {
              const e = this.getDefinition(t);
              return !!e && !(!e.isContent && !e.isObject);
            }
            checkChild(t, e) {
              return !!e && this._checkContextMatch(e, t);
            }
            checkAttribute(t, e) {
              const n = this.getDefinition(t.last);
              return !!n && n.allowAttributes.includes(e);
            }
            checkMerge(t, e) {
              if (t instanceof al) {
                const e = t.nodeBefore,
                  n = t.nodeAfter;
                if (!(e instanceof il))
                  throw new l("schema-check-merge-no-element-before", this);
                if (!(n instanceof il))
                  throw new l("schema-check-merge-no-element-after", this);
                return this.checkMerge(e, n);
              }
              for (const n of e.getChildren())
                if (!this.checkChild(t, n)) return !1;
              return !0;
            }
            addChildCheck(t) {
              this.on(
                "checkChild",
                (e, [n, o]) => {
                  if (!o) return;
                  const i = t(n, o);
                  "boolean" == typeof i && (e.stop(), (e.return = i));
                },
                { priority: "high" }
              );
            }
            addAttributeCheck(t) {
              this.on(
                "checkAttribute",
                (e, [n, o]) => {
                  const i = t(n, o);
                  "boolean" == typeof i && (e.stop(), (e.return = i));
                },
                { priority: "high" }
              );
            }
            setAttributeProperties(t, e) {
              this._attributeProperties[t] = Object.assign(
                this.getAttributeProperties(t),
                e
              );
            }
            getAttributeProperties(t) {
              return this._attributeProperties[t] || {};
            }
            getLimitElement(t) {
              let e;
              if (t instanceof al) e = t.parent;
              else {
                e = (t instanceof ml ? [t] : Array.from(t.getRanges())).reduce(
                  (t, e) => {
                    const n = e.getCommonAncestor();
                    return t ? t.getCommonAncestor(n, { includeSelf: !0 }) : n;
                  },
                  null
                );
              }
              for (; !this.isLimit(e) && e.parent; ) e = e.parent;
              return e;
            }
            checkAttributeInSelection(t, e) {
              if (t.isCollapsed) {
                const n = [
                  ...t.getFirstPosition().getAncestors(),
                  new nl("", t.getAttributes()),
                ];
                return this.checkAttribute(n, e);
              }
              {
                const n = t.getRanges();
                for (const t of n)
                  for (const n of t)
                    if (this.checkAttribute(n.item, e)) return !0;
              }
              return !1;
            }
            *getValidRanges(t, e) {
              t = (function* (t) {
                for (const e of t) yield* e.getMinimalFlatRanges();
              })(t);
              for (const n of t) yield* this._getValidRangesForRange(n, e);
            }
            getNearestSelectionRange(t, e = "both") {
              if (this.checkChild(t, "$text")) return new ml(t);
              let n, o;
              const i =
                t
                  .getAncestors()
                  .reverse()
                  .find((t) => this.isLimit(t)) || t.root;
              ("both" != e && "backward" != e) ||
                (n = new rl({
                  boundaries: ml._createIn(i),
                  startPosition: t,
                  direction: "backward",
                })),
                ("both" != e && "forward" != e) ||
                  (o = new rl({
                    boundaries: ml._createIn(i),
                    startPosition: t,
                  }));
              for (const t of (function* (t, e) {
                let n = !1;
                for (; !n; ) {
                  if (((n = !0), t)) {
                    const e = t.next();
                    e.done || ((n = !1), yield { walker: t, value: e.value });
                  }
                  if (e) {
                    const t = e.next();
                    t.done || ((n = !1), yield { walker: e, value: t.value });
                  }
                }
              })(n, o)) {
                const e = t.walker == n ? "elementEnd" : "elementStart",
                  o = t.value;
                if (o.type == e && this.isObject(o.item))
                  return ml._createOn(o.item);
                if (this.checkChild(o.nextPosition, "$text"))
                  return new ml(o.nextPosition);
              }
              return null;
            }
            findAllowedParent(t, e) {
              let n = t.parent;
              for (; n; ) {
                if (this.checkChild(n, e)) return n;
                if (this.isLimit(n)) return null;
                n = n.parent;
              }
              return null;
            }
            setAllowedAttributes(t, e, n) {
              const o = n.model;
              for (const [i, r] of Object.entries(e))
                o.schema.checkAttribute(t, i) && n.setAttribute(i, r, t);
            }
            removeDisallowedAttributes(t, e) {
              for (const n of t)
                if (n.is("$text")) Cc(this, n, e);
                else {
                  const t = ml._createIn(n).getPositions();
                  for (const n of t) {
                    Cc(this, n.nodeBefore || n.parent, e);
                  }
                }
            }
            getAttributesWithProperty(t, e, n) {
              const o = {};
              for (const [i, r] of t.getAttributes()) {
                const t = this.getAttributeProperties(i);
                void 0 !== t[e] && ((void 0 !== n && n !== t[e]) || (o[i] = r));
              }
              return o;
            }
            createContext(t) {
              return new cc(t);
            }
            _clearCache() {
              this._compiledDefinitions = null;
            }
            _compile() {
              const t = {},
                e = this._sourceDefinitions,
                n = Object.keys(e);
              for (const o of n) t[o] = dc(e[o], o);
              for (const e of n) uc(t, e);
              for (const e of n) hc(t, e);
              for (const e of n) mc(t, e);
              for (const e of n) gc(t, e), pc(t, e);
              for (const e of n) fc(t, e), kc(t, e), bc(t, e);
              this._compiledDefinitions = t;
            }
            _checkContextMatch(t, e, n = e.length - 1) {
              const o = e.getItem(n);
              if (t.allowIn.includes(o.name)) {
                if (0 == n) return !0;
                {
                  const t = this.getDefinition(o);
                  return this._checkContextMatch(t, e, n - 1);
                }
              }
              return !1;
            }
            *_getValidRangesForRange(t, e) {
              let n = t.start,
                o = t.start;
              for (const i of t.getItems({ shallow: !0 }))
                i.is("element") &&
                  (yield* this._getValidRangesForRange(ml._createIn(i), e)),
                  this.checkAttribute(i, e) ||
                    (n.isEqual(o) || (yield new ml(n, o)),
                    (n = al._createAfter(i))),
                  (o = al._createAfter(i));
              n.isEqual(o) || (yield new ml(n, o));
            }
          }
          class cc {
            constructor(t) {
              if (t instanceof cc) return t;
              let e;
              (e =
                "string" == typeof t
                  ? [t]
                  : Array.isArray(t)
                  ? t
                  : t.getAncestors({ includeSelf: !0 })),
                (this._items = e.map(_c));
            }
            get length() {
              return this._items.length;
            }
            get last() {
              return this._items[this._items.length - 1];
            }
            [Symbol.iterator]() {
              return this._items[Symbol.iterator]();
            }
            push(t) {
              const e = new cc([t]);
              return (e._items = [...this._items, ...e._items]), e;
            }
            getItem(t) {
              return this._items[t];
            }
            *getNames() {
              yield* this._items.map((t) => t.name);
            }
            endsWith(t) {
              return Array.from(this.getNames()).join(" ").endsWith(t);
            }
            startsWith(t) {
              return Array.from(this.getNames()).join(" ").startsWith(t);
            }
          }
          function dc(t, e) {
            const n = {
              name: e,
              allowIn: [],
              allowContentOf: [],
              allowWhere: [],
              allowAttributes: [],
              allowAttributesOf: [],
              allowChildren: [],
              inheritTypesFrom: [],
            };
            return (
              (function (t, e) {
                for (const n of t) {
                  const t = Object.keys(n).filter((t) => t.startsWith("is"));
                  for (const o of t) e[o] = !!n[o];
                }
              })(t, n),
              wc(t, n, "allowIn"),
              wc(t, n, "allowContentOf"),
              wc(t, n, "allowWhere"),
              wc(t, n, "allowAttributes"),
              wc(t, n, "allowAttributesOf"),
              wc(t, n, "allowChildren"),
              wc(t, n, "inheritTypesFrom"),
              (function (t, e) {
                for (const n of t) {
                  const t = n.inheritAllFrom;
                  t &&
                    (e.allowContentOf.push(t),
                    e.allowWhere.push(t),
                    e.allowAttributesOf.push(t),
                    e.inheritTypesFrom.push(t));
                }
              })(t, n),
              n
            );
          }
          function uc(t, e) {
            const n = t[e];
            for (const o of n.allowChildren) {
              const n = t[o];
              n && n.allowIn.push(e);
            }
            n.allowChildren.length = 0;
          }
          function hc(t, e) {
            for (const n of t[e].allowContentOf)
              if (t[n]) {
                Ac(t, n).forEach((t) => {
                  t.allowIn.push(e);
                });
              }
            delete t[e].allowContentOf;
          }
          function mc(t, e) {
            for (const n of t[e].allowWhere) {
              const o = t[n];
              if (o) {
                const n = o.allowIn;
                t[e].allowIn.push(...n);
              }
            }
            delete t[e].allowWhere;
          }
          function gc(t, e) {
            for (const n of t[e].allowAttributesOf) {
              const o = t[n];
              if (o) {
                const n = o.allowAttributes;
                t[e].allowAttributes.push(...n);
              }
            }
            delete t[e].allowAttributesOf;
          }
          function pc(t, e) {
            const n = t[e];
            for (const e of n.inheritTypesFrom) {
              const o = t[e];
              if (o) {
                const t = Object.keys(o).filter((t) => t.startsWith("is"));
                for (const e of t) e in n || (n[e] = o[e]);
              }
            }
            delete n.inheritTypesFrom;
          }
          function fc(t, e) {
            const n = t[e],
              o = n.allowIn.filter((e) => t[e]);
            n.allowIn = Array.from(new Set(o));
          }
          function kc(t, e) {
            const n = t[e];
            for (const o of n.allowIn) {
              t[o].allowChildren.push(e);
            }
          }
          function bc(t, e) {
            const n = t[e];
            n.allowAttributes = Array.from(new Set(n.allowAttributes));
          }
          function wc(t, e, n) {
            for (const o of t) {
              const t = o[n];
              "string" == typeof t
                ? e[n].push(t)
                : Array.isArray(t) && e[n].push(...t);
            }
          }
          function Ac(t, e) {
            const n = t[e];
            return ((o = t), Object.keys(o).map((t) => o[t])).filter((t) =>
              t.allowIn.includes(n.name)
            );
            var o;
          }
          function _c(t) {
            return "string" == typeof t || t.is("documentFragment")
              ? {
                  name: "string" == typeof t ? t : "$documentFragment",
                  *getAttributeKeys() {},
                  getAttribute() {},
                }
              : {
                  name: t.is("element") ? t.name : "$text",
                  *getAttributeKeys() {
                    yield* t.getAttributeKeys();
                  },
                  getAttribute: (e) => t.getAttribute(e),
                };
          }
          function Cc(t, e, n) {
            for (const o of e.getAttributeKeys())
              t.checkAttribute(e, o) || n.removeAttribute(o, e);
          }
          class vc extends b {
            constructor(t) {
              super(),
                (this._splitParts = new Map()),
                (this._cursorParents = new Map()),
                (this._modelCursor = null),
                (this._emptyElementsToKeep = new Set()),
                (this.conversionApi = {
                  ...t,
                  consumable: null,
                  writer: null,
                  store: null,
                  convertItem: (t, e) => this._convertItem(t, e),
                  convertChildren: (t, e) => this._convertChildren(t, e),
                  safeInsert: (t, e) => this._safeInsert(t, e),
                  updateConversionResult: (t, e) =>
                    this._updateConversionResult(t, e),
                  splitToAllowedParent: (t, e) =>
                    this._splitToAllowedParent(t, e),
                  getSplitParts: (t) => this._getSplitParts(t),
                  keepEmptyElement: (t) => this._keepEmptyElement(t),
                });
            }
            convert(t, e, n = ["$root"]) {
              this.fire("viewCleanup", t),
                (this._modelCursor = (function (t, e) {
                  let n;
                  for (const o of new cc(t)) {
                    const t = {};
                    for (const e of o.getAttributeKeys())
                      t[e] = o.getAttribute(e);
                    const i = e.createElement(o.name, t);
                    n && e.insert(i, n), (n = al._createAt(i, 0));
                  }
                  return n;
                })(n, e)),
                (this.conversionApi.writer = e),
                (this.conversionApi.consumable = rc.createFrom(t)),
                (this.conversionApi.store = {});
              const { modelRange: o } = this._convertItem(t, this._modelCursor),
                i = e.createDocumentFragment();
              if (o) {
                this._removeEmptyElements();
                for (const t of Array.from(
                  this._modelCursor.parent.getChildren()
                ))
                  e.append(t, i);
                i.markers = (function (t, e) {
                  const n = new Set(),
                    o = new Map(),
                    i = ml._createIn(t).getItems();
                  for (const t of i) t.is("element", "$marker") && n.add(t);
                  for (const t of n) {
                    const n = t.getAttribute("data-name"),
                      i = e.createPositionBefore(t);
                    o.has(n)
                      ? (o.get(n).end = i.clone())
                      : o.set(n, new ml(i.clone())),
                      e.remove(t);
                  }
                  return o;
                })(i, e);
              }
              return (
                (this._modelCursor = null),
                this._splitParts.clear(),
                this._cursorParents.clear(),
                this._emptyElementsToKeep.clear(),
                (this.conversionApi.writer = null),
                (this.conversionApi.store = null),
                i
              );
            }
            _convertItem(t, e) {
              const n = { viewItem: t, modelCursor: e, modelRange: null };
              if (
                (t.is("element")
                  ? this.fire(`element:${t.name}`, n, this.conversionApi)
                  : t.is("$text")
                  ? this.fire("text", n, this.conversionApi)
                  : this.fire("documentFragment", n, this.conversionApi),
                n.modelRange && !(n.modelRange instanceof ml))
              )
                throw new l(
                  "view-conversion-dispatcher-incorrect-result",
                  this
                );
              return { modelRange: n.modelRange, modelCursor: n.modelCursor };
            }
            _convertChildren(t, e) {
              let n = e.is("position") ? e : al._createAt(e, 0);
              const o = new ml(n);
              for (const e of Array.from(t.getChildren())) {
                const t = this._convertItem(e, n);
                t.modelRange instanceof ml &&
                  ((o.end = t.modelRange.end), (n = t.modelCursor));
              }
              return { modelRange: o, modelCursor: n };
            }
            _safeInsert(t, e) {
              const n = this._splitToAllowedParent(t, e);
              return (
                !!n && (this.conversionApi.writer.insert(t, n.position), !0)
              );
            }
            _updateConversionResult(t, e) {
              const n = this._getSplitParts(t),
                o = this.conversionApi.writer;
              e.modelRange ||
                (e.modelRange = o.createRange(
                  o.createPositionBefore(t),
                  o.createPositionAfter(n[n.length - 1])
                ));
              const i = this._cursorParents.get(t);
              e.modelCursor = i ? o.createPositionAt(i, 0) : e.modelRange.end;
            }
            _splitToAllowedParent(t, e) {
              const { schema: n, writer: o } = this.conversionApi;
              let i = n.findAllowedParent(e, t);
              if (i) {
                if (i === e.parent) return { position: e };
                this._modelCursor.parent.getAncestors().includes(i) &&
                  (i = null);
              }
              if (!i) return Zl(e, t, n) ? { position: Yl(e, o) } : null;
              const r = this.conversionApi.writer.split(e, i),
                s = [];
              for (const t of r.range.getWalker())
                if ("elementEnd" == t.type) s.push(t.item);
                else {
                  const e = s.pop(),
                    n = t.item;
                  this._registerSplitPair(e, n);
                }
              const a = r.range.end.parent;
              return (
                this._cursorParents.set(t, a),
                { position: r.position, cursorParent: a }
              );
            }
            _registerSplitPair(t, e) {
              this._splitParts.has(t) || this._splitParts.set(t, [t]);
              const n = this._splitParts.get(t);
              this._splitParts.set(e, n), n.push(e);
            }
            _getSplitParts(t) {
              let e;
              return (
                (e = this._splitParts.has(t) ? this._splitParts.get(t) : [t]), e
              );
            }
            _keepEmptyElement(t) {
              this._emptyElementsToKeep.add(t);
            }
            _removeEmptyElements() {
              let t = !1;
              for (const e of this._splitParts.keys())
                e.isEmpty &&
                  !this._emptyElementsToKeep.has(e) &&
                  (this.conversionApi.writer.remove(e),
                  this._splitParts.delete(e),
                  (t = !0));
              t && this._removeEmptyElements();
            }
          }
          class yc {
            getHtml(t) {
              const e = document.implementation
                .createHTMLDocument("")
                .createElement("div");
              return e.appendChild(t), e.innerHTML;
            }
          }
          class xc {
            constructor(t) {
              (this.domParser = new DOMParser()),
                (this.domConverter = new Cs(t, { renderingMode: "data" })),
                (this.htmlWriter = new yc());
            }
            toData(t) {
              const e = this.domConverter.viewToDom(t);
              return this.htmlWriter.getHtml(e);
            }
            toView(t) {
              const e = this._toDom(t);
              return this.domConverter.domToView(e);
            }
            registerRawContentMatcher(t) {
              this.domConverter.registerRawContentMatcher(t);
            }
            useFillerType(t) {
              this.domConverter.blockFillerMode =
                "marked" == t ? "markedNbsp" : "nbsp";
            }
            _toDom(t) {
              t.match(/<(?:html|body|head|meta)(?:\s[^>]*)?>/i) ||
                (t = `<body>${t}</body>`);
              const e = this.domParser.parseFromString(t, "text/html"),
                n = e.createDocumentFragment(),
                o = e.body.childNodes;
              for (; o.length > 0; ) n.appendChild(o[0]);
              return n;
            }
          }
          class Ec extends b {
            constructor(t, e) {
              super(),
                (this.model = t),
                (this.mapper = new gl()),
                (this.downcastDispatcher = new kl({
                  mapper: this.mapper,
                  schema: t.schema,
                })),
                this.downcastDispatcher.on(
                  "insert:$text",
                  (t, e, n) => {
                    if (!n.consumable.consume(e.item, t.name)) return;
                    const o = n.writer,
                      i = n.mapper.toViewPosition(e.range.start),
                      r = o.createText(e.item.data);
                    o.insert(i, r);
                  },
                  { priority: "lowest" }
                ),
                this.downcastDispatcher.on(
                  "insert",
                  (t, e, n) => {
                    n.convertAttributes(e.item),
                      e.reconversion ||
                        !e.item.is("element") ||
                        e.item.isEmpty ||
                        n.convertChildren(e.item);
                  },
                  { priority: "lowest" }
                ),
                (this.upcastDispatcher = new vc({ schema: t.schema })),
                (this.viewDocument = new Xi(e)),
                (this.stylesProcessor = e),
                (this.htmlProcessor = new xc(this.viewDocument)),
                (this.processor = this.htmlProcessor),
                (this._viewWriter = new vr(this.viewDocument)),
                this.upcastDispatcher.on(
                  "text",
                  (t, e, { schema: n, consumable: o, writer: i }) => {
                    let r = e.modelCursor;
                    if (!o.test(e.viewItem)) return;
                    if (!n.checkChild(r, "$text")) {
                      if (!Zl(r, "$text", n)) return;
                      if (0 == e.viewItem.data.trim().length) return;
                      r = Yl(r, i);
                    }
                    o.consume(e.viewItem);
                    const s = i.createText(e.viewItem.data);
                    i.insert(s, r),
                      (e.modelRange = i.createRange(
                        r,
                        r.getShiftedBy(s.offsetSize)
                      )),
                      (e.modelCursor = e.modelRange.end);
                  },
                  { priority: "lowest" }
                ),
                this.upcastDispatcher.on(
                  "element",
                  (t, e, n) => {
                    if (
                      !e.modelRange &&
                      n.consumable.consume(e.viewItem, { name: !0 })
                    ) {
                      const { modelRange: t, modelCursor: o } =
                        n.convertChildren(e.viewItem, e.modelCursor);
                      (e.modelRange = t), (e.modelCursor = o);
                    }
                  },
                  { priority: "lowest" }
                ),
                this.upcastDispatcher.on(
                  "documentFragment",
                  (t, e, n) => {
                    if (
                      !e.modelRange &&
                      n.consumable.consume(e.viewItem, { name: !0 })
                    ) {
                      const { modelRange: t, modelCursor: o } =
                        n.convertChildren(e.viewItem, e.modelCursor);
                      (e.modelRange = t), (e.modelCursor = o);
                    }
                  },
                  { priority: "lowest" }
                ),
                N.prototype.decorate.call(this, "init"),
                N.prototype.decorate.call(this, "set"),
                N.prototype.decorate.call(this, "get"),
                this.on(
                  "init",
                  () => {
                    this.fire("ready");
                  },
                  { priority: "lowest" }
                ),
                this.on(
                  "ready",
                  () => {
                    this.model.enqueueChange({ isUndoable: !1 }, Gl);
                  },
                  { priority: "lowest" }
                );
            }
            get(t = {}) {
              const { rootName: e = "main", trim: n = "empty" } = t;
              if (!this._checkIfRootsExists([e]))
                throw new l("datacontroller-get-non-existent-root", this);
              const o = this.model.document.getRoot(e);
              return "empty" !== n ||
                this.model.hasContent(o, { ignoreWhitespaces: !0 })
                ? this.stringify(o, t)
                : "";
            }
            stringify(t, e = {}) {
              const n = this.toView(t, e);
              return this.processor.toData(n);
            }
            toView(t, e = {}) {
              const n = this.viewDocument,
                o = this._viewWriter;
              this.mapper.clearBindings();
              const i = ml._createIn(t),
                r = new Cr(n);
              this.mapper.bindElements(t, r);
              const s = t.is("documentFragment")
                ? t.markers
                : (function (t) {
                    const e = [],
                      n = t.root.document;
                    if (!n) return new Map();
                    const o = ml._createIn(t);
                    for (const t of n.model.markers) {
                      const n = t.getRange(),
                        i = n.isCollapsed,
                        r = n.start.isEqual(o.start) || n.end.isEqual(o.end);
                      if (i && r) e.push([t.name, n]);
                      else {
                        const i = o.getIntersection(n);
                        i && e.push([t.name, i]);
                      }
                    }
                    return (
                      e.sort(([t, e], [n, o]) => {
                        if ("after" !== e.end.compareWith(o.start)) return 1;
                        if ("before" !== e.start.compareWith(o.end)) return -1;
                        switch (e.start.compareWith(o.start)) {
                          case "before":
                            return 1;
                          case "after":
                            return -1;
                          default:
                            switch (e.end.compareWith(o.end)) {
                              case "before":
                                return 1;
                              case "after":
                                return -1;
                              default:
                                return n.localeCompare(t);
                            }
                        }
                      }),
                      new Map(e)
                    );
                  })(t);
              return this.downcastDispatcher.convert(i, s, o, e), r;
            }
            init(t) {
              if (this.model.document.version)
                throw new l("datacontroller-init-document-not-empty", this);
              let e = {};
              if (
                ("string" == typeof t ? (e.main = t) : (e = t),
                !this._checkIfRootsExists(Object.keys(e)))
              )
                throw new l("datacontroller-init-non-existent-root", this);
              return (
                this.model.enqueueChange({ isUndoable: !1 }, (t) => {
                  for (const n of Object.keys(e)) {
                    const o = this.model.document.getRoot(n);
                    t.insert(this.parse(e[n], o), o, 0);
                  }
                }),
                Promise.resolve()
              );
            }
            set(t, e = {}) {
              let n = {};
              if (
                ("string" == typeof t ? (n.main = t) : (n = t),
                !this._checkIfRootsExists(Object.keys(n)))
              )
                throw new l("datacontroller-set-non-existent-root", this);
              this.model.enqueueChange(e.batchType || {}, (t) => {
                t.setSelection(null),
                  t.removeSelectionAttribute(
                    this.model.document.selection.getAttributeKeys()
                  );
                for (const e of Object.keys(n)) {
                  const o = this.model.document.getRoot(e);
                  t.remove(t.createRangeIn(o)),
                    t.insert(this.parse(n[e], o), o, 0);
                }
              });
            }
            parse(t, e = "$root") {
              const n = this.processor.toView(t);
              return this.toModel(n, e);
            }
            toModel(t, e = "$root") {
              return this.model.change((n) =>
                this.upcastDispatcher.convert(t, n, e)
              );
            }
            addStyleProcessorRules(t) {
              t(this.stylesProcessor);
            }
            registerRawContentMatcher(t) {
              this.processor &&
                this.processor !== this.htmlProcessor &&
                this.processor.registerRawContentMatcher(t),
                this.htmlProcessor.registerRawContentMatcher(t);
            }
            destroy() {
              this.stopListening();
            }
            _checkIfRootsExists(t) {
              for (const e of t)
                if (!this.model.document.getRootNames().includes(e)) return !1;
              return !0;
            }
          }
          class Dc {
            constructor(t, e) {
              (this._helpers = new Map()),
                (this._downcast = ko(t)),
                this._createConversionHelpers({
                  name: "downcast",
                  dispatchers: this._downcast,
                  isDowncast: !0,
                }),
                (this._upcast = ko(e)),
                this._createConversionHelpers({
                  name: "upcast",
                  dispatchers: this._upcast,
                  isDowncast: !1,
                });
            }
            addAlias(t, e) {
              const n = this._downcast.includes(e);
              if (!this._upcast.includes(e) && !n)
                throw new l(
                  "conversion-add-alias-dispatcher-not-registered",
                  this
                );
              this._createConversionHelpers({
                name: t,
                dispatchers: [e],
                isDowncast: n,
              });
            }
            for(t) {
              if (!this._helpers.has(t))
                throw new l("conversion-for-unknown-group", this);
              return this._helpers.get(t);
            }
            elementToElement(t) {
              this.for("downcast").elementToElement(t);
              for (const { model: e, view: n } of Sc(t))
                this.for("upcast").elementToElement({
                  model: e,
                  view: n,
                  converterPriority: t.converterPriority,
                });
            }
            attributeToElement(t) {
              this.for("downcast").attributeToElement(t);
              for (const { model: e, view: n } of Sc(t))
                this.for("upcast").elementToAttribute({
                  view: n,
                  model: e,
                  converterPriority: t.converterPriority,
                });
            }
            attributeToAttribute(t) {
              this.for("downcast").attributeToAttribute(t);
              for (const { model: e, view: n } of Sc(t))
                this.for("upcast").attributeToAttribute({ view: n, model: e });
            }
            _createConversionHelpers({
              name: t,
              dispatchers: e,
              isDowncast: n,
            }) {
              if (this._helpers.has(t))
                throw new l("conversion-group-exists", this);
              const o = n ? new zl(e) : new Kl(e);
              this._helpers.set(t, o);
            }
          }
          function* Sc(t) {
            if (t.model.values)
              for (const e of t.model.values) {
                const n = { key: t.model.key, value: e },
                  o = t.view[e],
                  i = t.upcastAlso ? t.upcastAlso[e] : void 0;
                yield* Ic(n, o, i);
              }
            else yield* Ic(t.model, t.view, t.upcastAlso);
          }
          function* Ic(t, e, n) {
            if ((yield { model: t, view: e }, n))
              for (const e of ko(n)) yield { model: t, view: e };
          }
          class Tc {
            constructor(t = {}) {
              "string" == typeof t &&
                ((t = "transparent" === t ? { isUndoable: !1 } : {}),
                c("batch-constructor-deprecated-string-type"));
              const {
                isUndoable: e = !0,
                isLocal: n = !0,
                isUndo: o = !1,
                isTyping: i = !1,
              } = t;
              (this.operations = []),
                (this.isUndoable = e),
                (this.isLocal = n),
                (this.isUndo = o),
                (this.isTyping = i);
            }
            get type() {
              return c("batch-type-deprecated"), "default";
            }
            get baseVersion() {
              for (const t of this.operations)
                if (null !== t.baseVersion) return t.baseVersion;
              return null;
            }
            addOperation(t) {
              return (t.batch = this), this.operations.push(t), t;
            }
          }
          class Mc {
            constructor(t) {
              (this._markerCollection = t),
                (this._changesInElement = new Map()),
                (this._elementSnapshots = new Map()),
                (this._changedMarkers = new Map()),
                (this._changeCount = 0),
                (this._cachedChanges = null),
                (this._cachedChangesWithGraveyard = null),
                (this._refreshedItems = new Set());
            }
            get isEmpty() {
              return (
                0 == this._changesInElement.size &&
                0 == this._changedMarkers.size
              );
            }
            bufferOperation(t) {
              const e = t;
              switch (e.type) {
                case "insert":
                  if (this._isInInsertedElement(e.position.parent)) return;
                  this._markInsert(
                    e.position.parent,
                    e.position.offset,
                    e.nodes.maxOffset
                  );
                  break;
                case "addAttribute":
                case "removeAttribute":
                case "changeAttribute":
                  for (const t of e.range.getItems({ shallow: !0 }))
                    this._isInInsertedElement(t.parent) ||
                      this._markAttribute(t);
                  break;
                case "remove":
                case "move":
                case "reinsert": {
                  if (
                    e.sourcePosition.isEqual(e.targetPosition) ||
                    e.sourcePosition
                      .getShiftedBy(e.howMany)
                      .isEqual(e.targetPosition)
                  )
                    return;
                  const t = this._isInInsertedElement(e.sourcePosition.parent),
                    n = this._isInInsertedElement(e.targetPosition.parent);
                  t ||
                    this._markRemove(
                      e.sourcePosition.parent,
                      e.sourcePosition.offset,
                      e.howMany
                    ),
                    n ||
                      this._markInsert(
                        e.targetPosition.parent,
                        e.getMovedRangeStart().offset,
                        e.howMany
                      );
                  break;
                }
                case "rename": {
                  if (this._isInInsertedElement(e.position.parent)) return;
                  this._markRemove(e.position.parent, e.position.offset, 1),
                    this._markInsert(e.position.parent, e.position.offset, 1);
                  const t = ml._createFromPositionAndShift(e.position, 1);
                  for (const e of this._markerCollection.getMarkersIntersectingRange(
                    t
                  )) {
                    const t = e.getData();
                    this.bufferMarkerChange(e.name, t, t);
                  }
                  break;
                }
                case "split": {
                  const t = e.splitPosition.parent;
                  this._isInInsertedElement(t) ||
                    this._markRemove(t, e.splitPosition.offset, e.howMany),
                    this._isInInsertedElement(e.insertionPosition.parent) ||
                      this._markInsert(
                        e.insertionPosition.parent,
                        e.insertionPosition.offset,
                        1
                      ),
                    e.graveyardPosition &&
                      this._markRemove(
                        e.graveyardPosition.parent,
                        e.graveyardPosition.offset,
                        1
                      );
                  break;
                }
                case "merge": {
                  const t = e.sourcePosition.parent;
                  this._isInInsertedElement(t.parent) ||
                    this._markRemove(t.parent, t.startOffset, 1);
                  const n = e.graveyardPosition.parent;
                  this._markInsert(n, e.graveyardPosition.offset, 1);
                  const o = e.targetPosition.parent;
                  this._isInInsertedElement(o) ||
                    this._markInsert(o, e.targetPosition.offset, t.maxOffset);
                  break;
                }
              }
              this._cachedChanges = null;
            }
            bufferMarkerChange(t, e, n) {
              const o = this._changedMarkers.get(t);
              o
                ? ((o.newMarkerData = n),
                  null == o.oldMarkerData.range &&
                    null == n.range &&
                    this._changedMarkers.delete(t))
                : this._changedMarkers.set(t, {
                    newMarkerData: n,
                    oldMarkerData: e,
                  });
            }
            getMarkersToRemove() {
              const t = [];
              for (const [e, n] of this._changedMarkers)
                null != n.oldMarkerData.range &&
                  t.push({ name: e, range: n.oldMarkerData.range });
              return t;
            }
            getMarkersToAdd() {
              const t = [];
              for (const [e, n] of this._changedMarkers)
                null != n.newMarkerData.range &&
                  t.push({ name: e, range: n.newMarkerData.range });
              return t;
            }
            getChangedMarkers() {
              return Array.from(this._changedMarkers).map(([t, e]) => ({
                name: t,
                data: {
                  oldRange: e.oldMarkerData.range,
                  newRange: e.newMarkerData.range,
                },
              }));
            }
            hasDataChanges() {
              if (this._changesInElement.size > 0) return !0;
              for (const {
                newMarkerData: t,
                oldMarkerData: e,
              } of this._changedMarkers.values()) {
                if (t.affectsData !== e.affectsData) return !0;
                if (t.affectsData) {
                  const n = t.range && !e.range,
                    o = !t.range && e.range,
                    i = t.range && e.range && !t.range.isEqual(e.range);
                  if (n || o || i) return !0;
                }
              }
              return !1;
            }
            getChanges(t = {}) {
              if (this._cachedChanges)
                return t.includeChangesInGraveyard
                  ? this._cachedChangesWithGraveyard.slice()
                  : this._cachedChanges.slice();
              let e = [];
              for (const t of this._changesInElement.keys()) {
                const n = this._changesInElement
                    .get(t)
                    .sort((t, e) =>
                      t.offset === e.offset
                        ? t.type != e.type
                          ? "remove" == t.type
                            ? -1
                            : 1
                          : 0
                        : t.offset < e.offset
                        ? -1
                        : 1
                    ),
                  o = this._elementSnapshots.get(t),
                  i = Bc(t.getChildren()),
                  r = Nc(o.length, n);
                let s = 0,
                  a = 0;
                for (const n of r)
                  if ("i" === n) e.push(this._getInsertDiff(t, s, i[s])), s++;
                  else if ("r" === n)
                    e.push(this._getRemoveDiff(t, s, o[a])), a++;
                  else if ("a" === n) {
                    const n = i[s].attributes,
                      r = o[a].attributes;
                    let l;
                    if ("$text" == i[s].name)
                      l = new ml(al._createAt(t, s), al._createAt(t, s + 1));
                    else {
                      const e = t.offsetToIndex(s);
                      l = new ml(
                        al._createAt(t, s),
                        al._createAt(t.getChild(e), 0)
                      );
                    }
                    e.push(...this._getAttributesDiff(l, r, n)), s++, a++;
                  } else s++, a++;
              }
              e.sort((t, e) =>
                t.position.root != e.position.root
                  ? t.position.root.rootName < e.position.root.rootName
                    ? -1
                    : 1
                  : t.position.isEqual(e.position)
                  ? t.changeCount - e.changeCount
                  : t.position.isBefore(e.position)
                  ? -1
                  : 1
              );
              for (let t = 1, n = 0; t < e.length; t++) {
                const o = e[n],
                  i = e[t],
                  r =
                    "remove" == o.type &&
                    "remove" == i.type &&
                    "$text" == o.name &&
                    "$text" == i.name &&
                    o.position.isEqual(i.position),
                  s =
                    "insert" == o.type &&
                    "insert" == i.type &&
                    "$text" == o.name &&
                    "$text" == i.name &&
                    o.position.parent == i.position.parent &&
                    o.position.offset + o.length == i.position.offset,
                  a =
                    "attribute" == o.type &&
                    "attribute" == i.type &&
                    o.position.parent == i.position.parent &&
                    o.range.isFlat &&
                    i.range.isFlat &&
                    o.position.offset + o.length == i.position.offset &&
                    o.attributeKey == i.attributeKey &&
                    o.attributeOldValue == i.attributeOldValue &&
                    o.attributeNewValue == i.attributeNewValue;
                r || s || a
                  ? (o.length++,
                    a && (o.range.end = o.range.end.getShiftedBy(1)),
                    (e[t] = null))
                  : (n = t);
              }
              e = e.filter((t) => t);
              for (const t of e)
                delete t.changeCount,
                  "attribute" == t.type && (delete t.position, delete t.length);
              return (
                (this._changeCount = 0),
                (this._cachedChangesWithGraveyard = e),
                (this._cachedChanges = e.filter(zc)),
                t.includeChangesInGraveyard
                  ? this._cachedChangesWithGraveyard.slice()
                  : this._cachedChanges.slice()
              );
            }
            getRefreshedItems() {
              return new Set(this._refreshedItems);
            }
            reset() {
              this._changesInElement.clear(),
                this._elementSnapshots.clear(),
                this._changedMarkers.clear(),
                (this._refreshedItems = new Set()),
                (this._cachedChanges = null);
            }
            _refreshItem(t) {
              if (this._isInInsertedElement(t.parent)) return;
              this._markRemove(t.parent, t.startOffset, t.offsetSize),
                this._markInsert(t.parent, t.startOffset, t.offsetSize),
                this._refreshedItems.add(t);
              const e = ml._createOn(t);
              for (const t of this._markerCollection.getMarkersIntersectingRange(
                e
              )) {
                const e = t.getData();
                this.bufferMarkerChange(t.name, e, e);
              }
              this._cachedChanges = null;
            }
            _markInsert(t, e, n) {
              const o = {
                type: "insert",
                offset: e,
                howMany: n,
                count: this._changeCount++,
              };
              this._markChange(t, o);
            }
            _markRemove(t, e, n) {
              const o = {
                type: "remove",
                offset: e,
                howMany: n,
                count: this._changeCount++,
              };
              this._markChange(t, o), this._removeAllNestedChanges(t, e, n);
            }
            _markAttribute(t) {
              const e = {
                type: "attribute",
                offset: t.startOffset,
                howMany: t.offsetSize,
                count: this._changeCount++,
              };
              this._markChange(t.parent, e);
            }
            _markChange(t, e) {
              this._makeSnapshot(t);
              const n = this._getChangesForElement(t);
              this._handleChange(e, n), n.push(e);
              for (let t = 0; t < n.length; t++)
                n[t].howMany < 1 && (n.splice(t, 1), t--);
            }
            _getChangesForElement(t) {
              let e;
              return (
                this._changesInElement.has(t)
                  ? (e = this._changesInElement.get(t))
                  : ((e = []), this._changesInElement.set(t, e)),
                e
              );
            }
            _makeSnapshot(t) {
              this._elementSnapshots.has(t) ||
                this._elementSnapshots.set(t, Bc(t.getChildren()));
            }
            _handleChange(t, e) {
              t.nodesToHandle = t.howMany;
              for (const n of e) {
                const o = t.offset + t.howMany,
                  i = n.offset + n.howMany;
                if (
                  "insert" == t.type &&
                  ("insert" == n.type &&
                    (t.offset <= n.offset
                      ? (n.offset += t.howMany)
                      : t.offset < i &&
                        ((n.howMany += t.nodesToHandle),
                        (t.nodesToHandle = 0))),
                  "remove" == n.type &&
                    t.offset < n.offset &&
                    (n.offset += t.howMany),
                  "attribute" == n.type)
                )
                  if (t.offset <= n.offset) n.offset += t.howMany;
                  else if (t.offset < i) {
                    const i = n.howMany;
                    (n.howMany = t.offset - n.offset),
                      e.unshift({
                        type: "attribute",
                        offset: o,
                        howMany: i - n.howMany,
                        count: this._changeCount++,
                      });
                  }
                if ("remove" == t.type) {
                  if ("insert" == n.type)
                    if (o <= n.offset) n.offset -= t.howMany;
                    else if (o <= i)
                      if (t.offset < n.offset) {
                        const e = o - n.offset;
                        (n.offset = t.offset),
                          (n.howMany -= e),
                          (t.nodesToHandle -= e);
                      } else
                        (n.howMany -= t.nodesToHandle), (t.nodesToHandle = 0);
                    else if (t.offset <= n.offset)
                      (t.nodesToHandle -= n.howMany), (n.howMany = 0);
                    else if (t.offset < i) {
                      const e = i - t.offset;
                      (n.howMany -= e), (t.nodesToHandle -= e);
                    }
                  if (
                    ("remove" == n.type &&
                      (o <= n.offset
                        ? (n.offset -= t.howMany)
                        : t.offset < n.offset &&
                          ((t.nodesToHandle += n.howMany), (n.howMany = 0))),
                    "attribute" == n.type)
                  )
                    if (o <= n.offset) n.offset -= t.howMany;
                    else if (t.offset < n.offset) {
                      const e = o - n.offset;
                      (n.offset = t.offset), (n.howMany -= e);
                    } else if (t.offset < i)
                      if (o <= i) {
                        const o = n.howMany;
                        n.howMany = t.offset - n.offset;
                        const i = o - n.howMany - t.nodesToHandle;
                        e.unshift({
                          type: "attribute",
                          offset: t.offset,
                          howMany: i,
                          count: this._changeCount++,
                        });
                      } else n.howMany -= i - t.offset;
                }
                if ("attribute" == t.type) {
                  if ("insert" == n.type)
                    if (t.offset < n.offset && o > n.offset) {
                      if (o > i) {
                        const t = {
                          type: "attribute",
                          offset: i,
                          howMany: o - i,
                          count: this._changeCount++,
                        };
                        this._handleChange(t, e), e.push(t);
                      }
                      (t.nodesToHandle = n.offset - t.offset),
                        (t.howMany = t.nodesToHandle);
                    } else
                      t.offset >= n.offset &&
                        t.offset < i &&
                        (o > i
                          ? ((t.nodesToHandle = o - i), (t.offset = i))
                          : (t.nodesToHandle = 0));
                  if (
                    "remove" == n.type &&
                    t.offset < n.offset &&
                    o > n.offset
                  ) {
                    const i = {
                      type: "attribute",
                      offset: n.offset,
                      howMany: o - n.offset,
                      count: this._changeCount++,
                    };
                    this._handleChange(i, e),
                      e.push(i),
                      (t.nodesToHandle = n.offset - t.offset),
                      (t.howMany = t.nodesToHandle);
                  }
                  "attribute" == n.type &&
                    (t.offset >= n.offset && o <= i
                      ? ((t.nodesToHandle = 0), (t.howMany = 0), (t.offset = 0))
                      : t.offset <= n.offset && o >= i && (n.howMany = 0));
                }
              }
              (t.howMany = t.nodesToHandle), delete t.nodesToHandle;
            }
            _getInsertDiff(t, e, n) {
              return {
                type: "insert",
                position: al._createAt(t, e),
                name: n.name,
                attributes: new Map(n.attributes),
                length: 1,
                changeCount: this._changeCount++,
              };
            }
            _getRemoveDiff(t, e, n) {
              return {
                type: "remove",
                position: al._createAt(t, e),
                name: n.name,
                attributes: new Map(n.attributes),
                length: 1,
                changeCount: this._changeCount++,
              };
            }
            _getAttributesDiff(t, e, n) {
              const o = [];
              n = new Map(n);
              for (const [i, r] of e) {
                const e = n.has(i) ? n.get(i) : null;
                e !== r &&
                  o.push({
                    type: "attribute",
                    position: t.start,
                    range: t.clone(),
                    length: 1,
                    attributeKey: i,
                    attributeOldValue: r,
                    attributeNewValue: e,
                    changeCount: this._changeCount++,
                  }),
                  n.delete(i);
              }
              for (const [e, i] of n)
                o.push({
                  type: "attribute",
                  position: t.start,
                  range: t.clone(),
                  length: 1,
                  attributeKey: e,
                  attributeOldValue: null,
                  attributeNewValue: i,
                  changeCount: this._changeCount++,
                });
              return o;
            }
            _isInInsertedElement(t) {
              const e = t.parent;
              if (!e) return !1;
              const n = this._changesInElement.get(e),
                o = t.startOffset;
              if (n)
                for (const t of n)
                  if (
                    "insert" == t.type &&
                    o >= t.offset &&
                    o < t.offset + t.howMany
                  )
                    return !0;
              return this._isInInsertedElement(e);
            }
            _removeAllNestedChanges(t, e, n) {
              const o = new ml(al._createAt(t, e), al._createAt(t, e + n));
              for (const t of o.getItems({ shallow: !0 }))
                t.is("element") &&
                  (this._elementSnapshots.delete(t),
                  this._changesInElement.delete(t),
                  this._removeAllNestedChanges(t, 0, t.maxOffset));
            }
          }
          function Bc(t) {
            const e = [];
            for (const n of t)
              if (n.is("$text"))
                for (let t = 0; t < n.data.length; t++)
                  e.push({
                    name: "$text",
                    attributes: new Map(n.getAttributes()),
                  });
              else
                e.push({
                  name: n.name,
                  attributes: new Map(n.getAttributes()),
                });
            return e;
          }
          function Nc(t, e) {
            const n = [];
            let o = 0,
              i = 0;
            for (const t of e) {
              if (t.offset > o) {
                for (let e = 0; e < t.offset - o; e++) n.push("e");
                i += t.offset - o;
              }
              if ("insert" == t.type) {
                for (let e = 0; e < t.howMany; e++) n.push("i");
                o = t.offset + t.howMany;
              } else if ("remove" == t.type) {
                for (let e = 0; e < t.howMany; e++) n.push("r");
                (o = t.offset), (i += t.howMany);
              } else
                n.push(..."a".repeat(t.howMany).split("")),
                  (o = t.offset + t.howMany),
                  (i += t.howMany);
            }
            if (i < t) for (let e = 0; e < t - i - o; e++) n.push("e");
            return n;
          }
          function zc(t) {
            const e =
                "position" in t && "$graveyard" == t.position.root.rootName,
              n = "range" in t && "$graveyard" == t.range.root.rootName;
            return !e && !n;
          }
          class Pc {
            constructor() {
              (this._operations = []),
                (this._undoPairs = new Map()),
                (this._undoneOperations = new Set()),
                (this._baseVersionToOperationIndex = new Map()),
                (this._version = 0),
                (this._gaps = new Map());
            }
            get version() {
              return this._version;
            }
            set version(t) {
              this._operations.length &&
                t > this._version + 1 &&
                this._gaps.set(this._version, t),
                (this._version = t);
            }
            get lastOperation() {
              return this._operations[this._operations.length - 1];
            }
            addOperation(t) {
              if (t.baseVersion !== this.version)
                throw new l(
                  "model-document-history-addoperation-incorrect-version",
                  this,
                  { operation: t, historyVersion: this.version }
                );
              this._operations.push(t),
                this._version++,
                this._baseVersionToOperationIndex.set(
                  t.baseVersion,
                  this._operations.length - 1
                );
            }
            getOperations(t, e = this.version) {
              if (!this._operations.length) return [];
              const n = this._operations[0];
              void 0 === t && (t = n.baseVersion);
              let o = e - 1;
              for (const [e, n] of this._gaps)
                t > e && t < n && (t = n), o > e && o < n && (o = e - 1);
              if (o < n.baseVersion || t > this.lastOperation.baseVersion)
                return [];
              let i = this._baseVersionToOperationIndex.get(t);
              void 0 === i && (i = 0);
              let r = this._baseVersionToOperationIndex.get(o);
              return (
                void 0 === r && (r = this._operations.length - 1),
                this._operations.slice(i, r + 1)
              );
            }
            getOperation(t) {
              const e = this._baseVersionToOperationIndex.get(t);
              if (void 0 !== e) return this._operations[e];
            }
            setOperationAsUndone(t, e) {
              this._undoPairs.set(e, t), this._undoneOperations.add(t);
            }
            isUndoingOperation(t) {
              return this._undoPairs.has(t);
            }
            isUndoneOperation(t) {
              return this._undoneOperations.has(t);
            }
            getUndoneOperation(t) {
              return this._undoPairs.get(t);
            }
            reset() {
              (this._version = 0),
                (this._undoPairs = new Map()),
                (this._operations = []),
                (this._undoneOperations = new Set()),
                (this._gaps = new Map()),
                (this._baseVersionToOperationIndex = new Map());
            }
          }
          class Lc extends il {
            constructor(t, e, n = "main") {
              super(e), (this._document = t), (this.rootName = n);
            }
            get document() {
              return this._document;
            }
            toJSON() {
              return this.rootName;
            }
          }
          function Rc(t, e) {
            return (
              !!(n = t.charAt(e - 1)) &&
              1 == n.length &&
              /[\ud800-\udbff]/.test(n) &&
              (function (t) {
                return !!t && 1 == t.length && /[\udc00-\udfff]/.test(t);
              })(t.charAt(e))
            );
            var n;
          }
          function Oc(t, e) {
            return (
              !!(n = t.charAt(e)) &&
              1 == n.length &&
              /[\u0300-\u036f\u1ab0-\u1aff\u1dc0-\u1dff\u20d0-\u20ff\ufe20-\ufe2f]/.test(
                n
              )
            );
            var n;
          }
          Lc.prototype.is = function (t, e) {
            return e
              ? e === this.name &&
                  ("rootElement" === t ||
                    "model:rootElement" === t ||
                    "element" === t ||
                    "model:element" === t)
              : "rootElement" === t ||
                  "model:rootElement" === t ||
                  "element" === t ||
                  "model:element" === t ||
                  "node" === t ||
                  "model:node" === t;
          };
          const jc = (function () {
            const t = /\p{Regional_Indicator}{2}/u.source,
              e =
                "(?:" +
                [
                  /\p{Emoji}[\u{E0020}-\u{E007E}]+\u{E007F}/u,
                  /\p{Emoji}\u{FE0F}?\u{20E3}/u,
                  /\p{Emoji}\u{FE0F}/u,
                  /(?=\p{General_Category=Other_Symbol})\p{Emoji}\p{Emoji_Modifier}*/u,
                ]
                  .map((t) => t.source)
                  .join("|") +
                ")";
            return new RegExp(`${t}|${e}(?:‍${e})*`, "ug");
          })();
          function Vc(t, e) {
            const n = String(t).matchAll(jc);
            return Array.from(n).some(
              (t) => t.index < e && e < t.index + t[0].length
            );
          }
          const Fc = "$graveyard";
          class Hc extends b {
            constructor(t) {
              super(),
                (this.model = t),
                (this.history = new Pc()),
                (this.selection = new Il(this)),
                (this.roots = new po({ idProperty: "rootName" })),
                (this.differ = new Mc(t.markers)),
                (this._postFixers = new Set()),
                (this._hasSelectionChangedFromTheLastChangeBlock = !1),
                this.createRoot("$root", Fc),
                this.listenTo(
                  t,
                  "applyOperation",
                  (t, e) => {
                    const n = e[0];
                    n.isDocumentOperation && this.differ.bufferOperation(n);
                  },
                  { priority: "high" }
                ),
                this.listenTo(
                  t,
                  "applyOperation",
                  (t, e) => {
                    const n = e[0];
                    n.isDocumentOperation && this.history.addOperation(n);
                  },
                  { priority: "low" }
                ),
                this.listenTo(this.selection, "change", () => {
                  this._hasSelectionChangedFromTheLastChangeBlock = !0;
                }),
                this.listenTo(t.markers, "update", (t, e, n, o, i) => {
                  const r = { ...e.getData(), range: o };
                  this.differ.bufferMarkerChange(e.name, i, r),
                    null === n &&
                      e.on("change", (t, n) => {
                        const o = e.getData();
                        this.differ.bufferMarkerChange(
                          e.name,
                          { ...o, range: n },
                          o
                        );
                      });
                });
            }
            get version() {
              return this.history.version;
            }
            set version(t) {
              this.history.version = t;
            }
            get graveyard() {
              return this.getRoot(Fc);
            }
            createRoot(t = "$root", e = "main") {
              if (this.roots.get(e))
                throw new l("model-document-createroot-name-exists", this, {
                  name: e,
                });
              const n = new Lc(this, t, e);
              return this.roots.add(n), n;
            }
            destroy() {
              this.selection.destroy(), this.stopListening();
            }
            getRoot(t = "main") {
              return this.roots.get(t);
            }
            getRootNames() {
              return Array.from(this.roots, (t) => t.rootName).filter(
                (t) => t != Fc
              );
            }
            registerPostFixer(t) {
              this._postFixers.add(t);
            }
            toJSON() {
              const t = So(this);
              return (
                (t.selection = "[engine.model.DocumentSelection]"),
                (t.model = "[engine.model.Model]"),
                t
              );
            }
            _handleChangeBlock(t) {
              this._hasDocumentChangedFromTheLastChangeBlock() &&
                (this._callPostFixers(t),
                this.selection.refresh(),
                this.differ.hasDataChanges()
                  ? this.fire("change:data", t.batch)
                  : this.fire("change", t.batch),
                this.selection.refresh(),
                this.differ.reset()),
                (this._hasSelectionChangedFromTheLastChangeBlock = !1);
            }
            _hasDocumentChangedFromTheLastChangeBlock() {
              return (
                !this.differ.isEmpty ||
                this._hasSelectionChangedFromTheLastChangeBlock
              );
            }
            _getDefaultRoot() {
              for (const t of this.roots) if (t !== this.graveyard) return t;
              return this.graveyard;
            }
            _getDefaultRange() {
              const t = this._getDefaultRoot(),
                e = this.model,
                n = e.schema,
                o = e.createPositionFromPath(t, [0]);
              return n.getNearestSelectionRange(o) || e.createRange(o);
            }
            _validateSelectionRange(t) {
              return Uc(t.start) && Uc(t.end);
            }
            _callPostFixers(t) {
              let e = !1;
              do {
                for (const n of this._postFixers)
                  if ((this.selection.refresh(), (e = n(t)), e)) break;
              } while (e);
            }
          }
          function Uc(t) {
            const e = t.textNode;
            if (e) {
              const n = e.data,
                o = t.offset - e.startOffset;
              return !Rc(n, o) && !Oc(n, o);
            }
            return !0;
          }
          class Wc extends b {
            constructor() {
              super(), (this._markers = new Map());
            }
            [Symbol.iterator]() {
              return this._markers.values();
            }
            has(t) {
              const e = t instanceof $c ? t.name : t;
              return this._markers.has(e);
            }
            get(t) {
              return this._markers.get(t) || null;
            }
            _set(t, e, n = !1, o = !1) {
              const i = t instanceof $c ? t.name : t;
              if (i.includes(","))
                throw new l("markercollection-incorrect-marker-name", this);
              const r = this._markers.get(i);
              if (r) {
                const t = r.getData(),
                  s = r.getRange();
                let a = !1;
                return (
                  s.isEqual(e) ||
                    (r._attachLiveRange(xl.fromRange(e)), (a = !0)),
                  n != r.managedUsingOperations &&
                    ((r._managedUsingOperations = n), (a = !0)),
                  "boolean" == typeof o &&
                    o != r.affectsData &&
                    ((r._affectsData = o), (a = !0)),
                  a && this.fire(`update:${i}`, r, s, e, t),
                  r
                );
              }
              const s = xl.fromRange(e),
                a = new $c(i, s, n, o);
              return (
                this._markers.set(i, a),
                this.fire(`update:${i}`, a, null, e, {
                  ...a.getData(),
                  range: null,
                }),
                a
              );
            }
            _remove(t) {
              const e = t instanceof $c ? t.name : t,
                n = this._markers.get(e);
              return (
                !!n &&
                (this._markers.delete(e),
                this.fire(`update:${e}`, n, n.getRange(), null, n.getData()),
                this._destroyMarker(n),
                !0)
              );
            }
            _refresh(t) {
              const e = t instanceof $c ? t.name : t,
                n = this._markers.get(e);
              if (!n)
                throw new l("markercollection-refresh-marker-not-exists", this);
              const o = n.getRange();
              this.fire(`update:${e}`, n, o, o, n.getData());
            }
            *getMarkersAtPosition(t) {
              for (const e of this)
                e.getRange().containsPosition(t) && (yield e);
            }
            *getMarkersIntersectingRange(t) {
              for (const e of this)
                null !== e.getRange().getIntersection(t) && (yield e);
            }
            destroy() {
              for (const t of this._markers.values()) this._destroyMarker(t);
              (this._markers = null), this.stopListening();
            }
            *getMarkersGroup(t) {
              for (const e of this._markers.values())
                e.name.startsWith(t + ":") && (yield e);
            }
            _destroyMarker(t) {
              t.stopListening(), t._detachLiveRange();
            }
          }
          class $c extends k(Xa) {
            constructor(t, e, n, o) {
              super(),
                (this.name = t),
                (this._liveRange = this._attachLiveRange(e)),
                (this._managedUsingOperations = n),
                (this._affectsData = o);
            }
            get managedUsingOperations() {
              if (!this._liveRange) throw new l("marker-destroyed", this);
              return this._managedUsingOperations;
            }
            get affectsData() {
              if (!this._liveRange) throw new l("marker-destroyed", this);
              return this._affectsData;
            }
            getData() {
              return {
                range: this.getRange(),
                affectsData: this.affectsData,
                managedUsingOperations: this.managedUsingOperations,
              };
            }
            getStart() {
              if (!this._liveRange) throw new l("marker-destroyed", this);
              return this._liveRange.start.clone();
            }
            getEnd() {
              if (!this._liveRange) throw new l("marker-destroyed", this);
              return this._liveRange.end.clone();
            }
            getRange() {
              if (!this._liveRange) throw new l("marker-destroyed", this);
              return this._liveRange.toRange();
            }
            _attachLiveRange(t) {
              return (
                this._liveRange && this._detachLiveRange(),
                t.delegate("change:range").to(this),
                t.delegate("change:content").to(this),
                (this._liveRange = t),
                t
              );
            }
            _detachLiveRange() {
              this._liveRange.stopDelegating("change:range", this),
                this._liveRange.stopDelegating("change:content", this),
                this._liveRange.detach(),
                (this._liveRange = null);
            }
          }
          $c.prototype.is = function (t) {
            return "marker" === t || "model:marker" === t;
          };
          class qc {
            constructor(t) {
              (this.baseVersion = t),
                (this.isDocumentOperation = null !== this.baseVersion),
                (this.batch = null);
            }
            _validate() {}
            toJSON() {
              const t = Object.assign({}, this);
              return (
                (t.__className = this.constructor.className),
                delete t.batch,
                delete t.isDocumentOperation,
                t
              );
            }
            static get className() {
              return "Operation";
            }
            static fromJSON(t, e) {
              return new this(t.baseVersion);
            }
          }
          function Gc(t, e) {
            const n = Kc(e),
              o = n.reduce((t, e) => t + e.offsetSize, 0),
              i = t.parent;
            Jc(t);
            const r = t.index;
            return (
              i._insertChild(r, n),
              Qc(i, r + n.length),
              Qc(i, r),
              new ml(t, t.getShiftedBy(o))
            );
          }
          function Zc(t) {
            if (!t.isFlat)
              throw new l("operation-utils-remove-range-not-flat", this);
            const e = t.start.parent;
            Jc(t.start), Jc(t.end);
            const n = e._removeChildren(
              t.start.index,
              t.end.index - t.start.index
            );
            return Qc(e, t.start.index), n;
          }
          function Yc(t, e) {
            if (!t.isFlat)
              throw new l("operation-utils-move-range-not-flat", this);
            const n = Zc(t);
            return Gc(
              (e = e._getTransformedByDeletion(
                t.start,
                t.end.offset - t.start.offset
              )),
              n
            );
          }
          function Kc(t) {
            const e = [];
            !(function t(n) {
              if ("string" == typeof n) e.push(new nl(n));
              else if (n instanceof ol)
                e.push(new nl(n.data, n.getAttributes()));
              else if (n instanceof tl) e.push(n);
              else if (go(n)) for (const e of n) t(e);
            })(t);
            for (let t = 1; t < e.length; t++) {
              const n = e[t],
                o = e[t - 1];
              n instanceof nl &&
                o instanceof nl &&
                Xc(n, o) &&
                (e.splice(t - 1, 2, new nl(o.data + n.data, o.getAttributes())),
                t--);
            }
            return e;
          }
          function Qc(t, e) {
            const n = t.getChild(e - 1),
              o = t.getChild(e);
            if (n && o && n.is("$text") && o.is("$text") && Xc(n, o)) {
              const i = new nl(n.data + o.data, n.getAttributes());
              t._removeChildren(e - 1, 2), t._insertChild(e - 1, i);
            }
          }
          function Jc(t) {
            const e = t.textNode,
              n = t.parent;
            if (e) {
              const o = t.offset - e.startOffset,
                i = e.index;
              n._removeChildren(i, 1);
              const r = new nl(e.data.substr(0, o), e.getAttributes()),
                s = new nl(e.data.substr(o), e.getAttributes());
              n._insertChild(i, [r, s]);
            }
          }
          function Xc(t, e) {
            const n = t.getAttributes(),
              o = e.getAttributes();
            for (const t of n) {
              if (t[1] !== e.getAttribute(t[0])) return !1;
              o.next();
            }
            return o.next().done;
          }
          const td = function (t, e) {
            return pa(t, e);
          };
          class ed extends qc {
            constructor(t, e, n, o, i) {
              super(i),
                (this.range = t.clone()),
                (this.key = e),
                (this.oldValue = void 0 === n ? null : n),
                (this.newValue = void 0 === o ? null : o);
            }
            get type() {
              return null === this.oldValue
                ? "addAttribute"
                : null === this.newValue
                ? "removeAttribute"
                : "changeAttribute";
            }
            clone() {
              return new ed(
                this.range,
                this.key,
                this.oldValue,
                this.newValue,
                this.baseVersion
              );
            }
            getReversed() {
              return new ed(
                this.range,
                this.key,
                this.newValue,
                this.oldValue,
                this.baseVersion + 1
              );
            }
            toJSON() {
              const t = super.toJSON();
              return (t.range = this.range.toJSON()), t;
            }
            _validate() {
              if (!this.range.isFlat)
                throw new l("attribute-operation-range-not-flat", this);
              for (const t of this.range.getItems({ shallow: !0 })) {
                if (
                  null !== this.oldValue &&
                  !td(t.getAttribute(this.key), this.oldValue)
                )
                  throw new l("attribute-operation-wrong-old-value", this, {
                    item: t,
                    key: this.key,
                    value: this.oldValue,
                  });
                if (
                  null === this.oldValue &&
                  null !== this.newValue &&
                  t.hasAttribute(this.key)
                )
                  throw new l("attribute-operation-attribute-exists", this, {
                    node: t,
                    key: this.key,
                  });
              }
            }
            _execute() {
              td(this.oldValue, this.newValue) ||
                (function (t, e, n) {
                  Jc(t.start), Jc(t.end);
                  for (const o of t.getItems({ shallow: !0 })) {
                    const t = o.is("$textProxy") ? o.textNode : o;
                    null !== n ? t._setAttribute(e, n) : t._removeAttribute(e),
                      Qc(t.parent, t.index);
                  }
                  Qc(t.end.parent, t.end.index);
                })(this.range, this.key, this.newValue);
            }
            static get className() {
              return "AttributeOperation";
            }
            static fromJSON(t, e) {
              return new ed(
                ml.fromJSON(t.range, e),
                t.key,
                t.oldValue,
                t.newValue,
                t.baseVersion
              );
            }
          }
          class nd extends qc {
            constructor(t, e, n, o) {
              super(o),
                (this.sourcePosition = t.clone()),
                (this.sourcePosition.stickiness = "toNext"),
                (this.howMany = e),
                (this.targetPosition = n.clone()),
                (this.targetPosition.stickiness = "toNone");
            }
            get type() {
              return "$graveyard" == this.targetPosition.root.rootName
                ? "remove"
                : "$graveyard" == this.sourcePosition.root.rootName
                ? "reinsert"
                : "move";
            }
            clone() {
              return new nd(
                this.sourcePosition,
                this.howMany,
                this.targetPosition,
                this.baseVersion
              );
            }
            getMovedRangeStart() {
              return this.targetPosition._getTransformedByDeletion(
                this.sourcePosition,
                this.howMany
              );
            }
            getReversed() {
              const t = this.sourcePosition._getTransformedByInsertion(
                this.targetPosition,
                this.howMany
              );
              return new nd(
                this.getMovedRangeStart(),
                this.howMany,
                t,
                this.baseVersion + 1
              );
            }
            _validate() {
              const t = this.sourcePosition.parent,
                e = this.targetPosition.parent,
                n = this.sourcePosition.offset,
                o = this.targetPosition.offset;
              if (n + this.howMany > t.maxOffset)
                throw new l("move-operation-nodes-do-not-exist", this);
              if (t === e && n < o && o < n + this.howMany)
                throw new l("move-operation-range-into-itself", this);
              if (
                this.sourcePosition.root == this.targetPosition.root &&
                "prefix" ==
                  Do(
                    this.sourcePosition.getParentPath(),
                    this.targetPosition.getParentPath()
                  )
              ) {
                const t = this.sourcePosition.path.length - 1;
                if (
                  this.targetPosition.path[t] >= n &&
                  this.targetPosition.path[t] < n + this.howMany
                )
                  throw new l("move-operation-node-into-itself", this);
              }
            }
            _execute() {
              Yc(
                ml._createFromPositionAndShift(
                  this.sourcePosition,
                  this.howMany
                ),
                this.targetPosition
              );
            }
            toJSON() {
              const t = super.toJSON();
              return (
                (t.sourcePosition = this.sourcePosition.toJSON()),
                (t.targetPosition = this.targetPosition.toJSON()),
                t
              );
            }
            static get className() {
              return "MoveOperation";
            }
            static fromJSON(t, e) {
              const n = al.fromJSON(t.sourcePosition, e),
                o = al.fromJSON(t.targetPosition, e);
              return new this(n, t.howMany, o, t.baseVersion);
            }
          }
          class od extends qc {
            constructor(t, e, n) {
              super(n),
                (this.position = t.clone()),
                (this.position.stickiness = "toNone"),
                (this.nodes = new el(Kc(e))),
                (this.shouldReceiveAttributes = !1);
            }
            get type() {
              return "insert";
            }
            get howMany() {
              return this.nodes.maxOffset;
            }
            clone() {
              const t = new el([...this.nodes].map((t) => t._clone(!0))),
                e = new od(this.position, t, this.baseVersion);
              return (
                (e.shouldReceiveAttributes = this.shouldReceiveAttributes), e
              );
            }
            getReversed() {
              const t = this.position.root.document.graveyard,
                e = new al(t, [0]);
              return new nd(
                this.position,
                this.nodes.maxOffset,
                e,
                this.baseVersion + 1
              );
            }
            _validate() {
              const t = this.position.parent;
              if (!t || t.maxOffset < this.position.offset)
                throw new l("insert-operation-position-invalid", this);
            }
            _execute() {
              const t = this.nodes;
              (this.nodes = new el([...t].map((t) => t._clone(!0)))),
                Gc(this.position, t);
            }
            toJSON() {
              const t = super.toJSON();
              return (
                (t.position = this.position.toJSON()),
                (t.nodes = this.nodes.toJSON()),
                t
              );
            }
            static get className() {
              return "InsertOperation";
            }
            static fromJSON(t, e) {
              const n = [];
              for (const e of t.nodes)
                e.name ? n.push(il.fromJSON(e)) : n.push(nl.fromJSON(e));
              const o = new od(al.fromJSON(t.position, e), n, t.baseVersion);
              return (o.shouldReceiveAttributes = t.shouldReceiveAttributes), o;
            }
          }
          class id extends qc {
            constructor(t, e, n, o, i, r) {
              super(r),
                (this.name = t),
                (this.oldRange = e ? e.clone() : null),
                (this.newRange = n ? n.clone() : null),
                (this.affectsData = i),
                (this._markers = o);
            }
            get type() {
              return "marker";
            }
            clone() {
              return new id(
                this.name,
                this.oldRange,
                this.newRange,
                this._markers,
                this.affectsData,
                this.baseVersion
              );
            }
            getReversed() {
              return new id(
                this.name,
                this.newRange,
                this.oldRange,
                this._markers,
                this.affectsData,
                this.baseVersion + 1
              );
            }
            _execute() {
              this.newRange
                ? this._markers._set(
                    this.name,
                    this.newRange,
                    !0,
                    this.affectsData
                  )
                : this._markers._remove(this.name);
            }
            toJSON() {
              const t = super.toJSON();
              return (
                this.oldRange && (t.oldRange = this.oldRange.toJSON()),
                this.newRange && (t.newRange = this.newRange.toJSON()),
                delete t._markers,
                t
              );
            }
            static get className() {
              return "MarkerOperation";
            }
            static fromJSON(t, e) {
              return new id(
                t.name,
                t.oldRange ? ml.fromJSON(t.oldRange, e) : null,
                t.newRange ? ml.fromJSON(t.newRange, e) : null,
                e.model.markers,
                t.affectsData,
                t.baseVersion
              );
            }
          }
          class rd extends qc {
            get type() {
              return "noop";
            }
            clone() {
              return new rd(this.baseVersion);
            }
            getReversed() {
              return new rd(this.baseVersion + 1);
            }
            _execute() {}
            static get className() {
              return "NoOperation";
            }
          }
          class sd extends qc {
            constructor(t, e, n, o) {
              super(o),
                (this.position = t),
                (this.position.stickiness = "toNext"),
                (this.oldName = e),
                (this.newName = n);
            }
            get type() {
              return "rename";
            }
            clone() {
              return new sd(
                this.position.clone(),
                this.oldName,
                this.newName,
                this.baseVersion
              );
            }
            getReversed() {
              return new sd(
                this.position.clone(),
                this.newName,
                this.oldName,
                this.baseVersion + 1
              );
            }
            _validate() {
              const t = this.position.nodeAfter;
              if (!(t instanceof il))
                throw new l("rename-operation-wrong-position", this);
              if (t.name !== this.oldName)
                throw new l("rename-operation-wrong-name", this);
            }
            _execute() {
              this.position.nodeAfter.name = this.newName;
            }
            toJSON() {
              const t = super.toJSON();
              return (t.position = this.position.toJSON()), t;
            }
            static get className() {
              return "RenameOperation";
            }
            static fromJSON(t, e) {
              return new sd(
                al.fromJSON(t.position, e),
                t.oldName,
                t.newName,
                t.baseVersion
              );
            }
          }
          class ad extends qc {
            constructor(t, e, n, o, i) {
              super(i),
                (this.root = t),
                (this.key = e),
                (this.oldValue = n),
                (this.newValue = o);
            }
            get type() {
              return null === this.oldValue
                ? "addRootAttribute"
                : null === this.newValue
                ? "removeRootAttribute"
                : "changeRootAttribute";
            }
            clone() {
              return new ad(
                this.root,
                this.key,
                this.oldValue,
                this.newValue,
                this.baseVersion
              );
            }
            getReversed() {
              return new ad(
                this.root,
                this.key,
                this.newValue,
                this.oldValue,
                this.baseVersion + 1
              );
            }
            _validate() {
              if (
                this.root != this.root.root ||
                this.root.is("documentFragment")
              )
                throw new l("rootattribute-operation-not-a-root", this, {
                  root: this.root,
                  key: this.key,
                });
              if (
                null !== this.oldValue &&
                this.root.getAttribute(this.key) !== this.oldValue
              )
                throw new l("rootattribute-operation-wrong-old-value", this, {
                  root: this.root,
                  key: this.key,
                });
              if (
                null === this.oldValue &&
                null !== this.newValue &&
                this.root.hasAttribute(this.key)
              )
                throw new l("rootattribute-operation-attribute-exists", this, {
                  root: this.root,
                  key: this.key,
                });
            }
            _execute() {
              null !== this.newValue
                ? this.root._setAttribute(this.key, this.newValue)
                : this.root._removeAttribute(this.key);
            }
            toJSON() {
              const t = super.toJSON();
              return (t.root = this.root.toJSON()), t;
            }
            static get className() {
              return "RootAttributeOperation";
            }
            static fromJSON(t, e) {
              if (!e.getRoot(t.root))
                throw new l("rootattribute-operation-fromjson-no-root", this, {
                  rootName: t.root,
                });
              return new ad(
                e.getRoot(t.root),
                t.key,
                t.oldValue,
                t.newValue,
                t.baseVersion
              );
            }
          }
          class ld extends qc {
            constructor(t, e, n, o, i) {
              super(i),
                (this.sourcePosition = t.clone()),
                (this.sourcePosition.stickiness = "toPrevious"),
                (this.howMany = e),
                (this.targetPosition = n.clone()),
                (this.targetPosition.stickiness = "toNext"),
                (this.graveyardPosition = o.clone());
            }
            get type() {
              return "merge";
            }
            get deletionPosition() {
              return new al(
                this.sourcePosition.root,
                this.sourcePosition.path.slice(0, -1)
              );
            }
            get movedRange() {
              const t = this.sourcePosition.getShiftedBy(
                Number.POSITIVE_INFINITY
              );
              return new ml(this.sourcePosition, t);
            }
            clone() {
              return new ld(
                this.sourcePosition,
                this.howMany,
                this.targetPosition,
                this.graveyardPosition,
                this.baseVersion
              );
            }
            getReversed() {
              const t =
                  this.targetPosition._getTransformedByMergeOperation(this),
                e = this.sourcePosition.path.slice(0, -1),
                n = new al(
                  this.sourcePosition.root,
                  e
                )._getTransformedByMergeOperation(this);
              return new cd(
                t,
                this.howMany,
                n,
                this.graveyardPosition,
                this.baseVersion + 1
              );
            }
            _validate() {
              const t = this.sourcePosition.parent,
                e = this.targetPosition.parent;
              if (!t.parent)
                throw new l("merge-operation-source-position-invalid", this);
              if (!e.parent)
                throw new l("merge-operation-target-position-invalid", this);
              if (this.howMany != t.maxOffset)
                throw new l("merge-operation-how-many-invalid", this);
            }
            _execute() {
              const t = this.sourcePosition.parent;
              Yc(ml._createIn(t), this.targetPosition),
                Yc(ml._createOn(t), this.graveyardPosition);
            }
            toJSON() {
              const t = super.toJSON();
              return (
                (t.sourcePosition = t.sourcePosition.toJSON()),
                (t.targetPosition = t.targetPosition.toJSON()),
                (t.graveyardPosition = t.graveyardPosition.toJSON()),
                t
              );
            }
            static get className() {
              return "MergeOperation";
            }
            static fromJSON(t, e) {
              const n = al.fromJSON(t.sourcePosition, e),
                o = al.fromJSON(t.targetPosition, e),
                i = al.fromJSON(t.graveyardPosition, e);
              return new this(n, t.howMany, o, i, t.baseVersion);
            }
          }
          class cd extends qc {
            constructor(t, e, n, o, i) {
              super(i),
                (this.splitPosition = t.clone()),
                (this.splitPosition.stickiness = "toNext"),
                (this.howMany = e),
                (this.insertionPosition = n),
                (this.graveyardPosition = o ? o.clone() : null),
                this.graveyardPosition &&
                  (this.graveyardPosition.stickiness = "toNext");
            }
            get type() {
              return "split";
            }
            get moveTargetPosition() {
              const t = this.insertionPosition.path.slice();
              return t.push(0), new al(this.insertionPosition.root, t);
            }
            get movedRange() {
              const t = this.splitPosition.getShiftedBy(
                Number.POSITIVE_INFINITY
              );
              return new ml(this.splitPosition, t);
            }
            clone() {
              return new cd(
                this.splitPosition,
                this.howMany,
                this.insertionPosition,
                this.graveyardPosition,
                this.baseVersion
              );
            }
            getReversed() {
              const t = this.splitPosition.root.document.graveyard,
                e = new al(t, [0]);
              return new ld(
                this.moveTargetPosition,
                this.howMany,
                this.splitPosition,
                e,
                this.baseVersion + 1
              );
            }
            _validate() {
              const t = this.splitPosition.parent,
                e = this.splitPosition.offset;
              if (!t || t.maxOffset < e)
                throw new l("split-operation-position-invalid", this);
              if (!t.parent) throw new l("split-operation-split-in-root", this);
              if (this.howMany != t.maxOffset - this.splitPosition.offset)
                throw new l("split-operation-how-many-invalid", this);
              if (this.graveyardPosition && !this.graveyardPosition.nodeAfter)
                throw new l("split-operation-graveyard-position-invalid", this);
            }
            _execute() {
              const t = this.splitPosition.parent;
              if (this.graveyardPosition)
                Yc(
                  ml._createFromPositionAndShift(this.graveyardPosition, 1),
                  this.insertionPosition
                );
              else {
                const e = t._clone();
                Gc(this.insertionPosition, e);
              }
              Yc(
                new ml(
                  al._createAt(t, this.splitPosition.offset),
                  al._createAt(t, t.maxOffset)
                ),
                this.moveTargetPosition
              );
            }
            toJSON() {
              const t = super.toJSON();
              return (
                (t.splitPosition = this.splitPosition.toJSON()),
                (t.insertionPosition = this.insertionPosition.toJSON()),
                this.graveyardPosition &&
                  (t.graveyardPosition = this.graveyardPosition.toJSON()),
                t
              );
            }
            static get className() {
              return "SplitOperation";
            }
            static getInsertionPosition(t) {
              const e = t.path.slice(0, -1);
              return e[e.length - 1]++, new al(t.root, e, "toPrevious");
            }
            static fromJSON(t, e) {
              const n = al.fromJSON(t.splitPosition, e),
                o = al.fromJSON(t.insertionPosition, e),
                i = t.graveyardPosition
                  ? al.fromJSON(t.graveyardPosition, e)
                  : null;
              return new this(n, t.howMany, o, i, t.baseVersion);
            }
          }
          const dd = {};
          (dd[ed.className] = ed),
            (dd[od.className] = od),
            (dd[id.className] = id),
            (dd[nd.className] = nd),
            (dd[rd.className] = rd),
            (dd[qc.className] = qc),
            (dd[sd.className] = sd),
            (dd[ad.className] = ad),
            (dd[cd.className] = cd),
            (dd[ld.className] = ld);
          class ud {
            static fromJSON(t, e) {
              return dd[t.__className].fromJSON(t, e);
            }
          }
          class hd extends qc {
            constructor(t, e) {
              super(null),
                (this.sourcePosition = t.clone()),
                (this.howMany = e);
            }
            get type() {
              return "detach";
            }
            toJSON() {
              const t = super.toJSON();
              return (t.sourcePosition = this.sourcePosition.toJSON()), t;
            }
            _validate() {
              if (this.sourcePosition.root.document)
                throw new l("detach-operation-on-document-node", this);
            }
            _execute() {
              Zc(
                ml._createFromPositionAndShift(
                  this.sourcePosition,
                  this.howMany
                )
              );
            }
            static get className() {
              return "DetachOperation";
            }
          }
          class md extends Xa {
            constructor(t) {
              super(),
                (this.markers = new Map()),
                (this._children = new el()),
                t && this._insertChild(0, t);
            }
            [Symbol.iterator]() {
              return this.getChildren();
            }
            get childCount() {
              return this._children.length;
            }
            get maxOffset() {
              return this._children.maxOffset;
            }
            get isEmpty() {
              return 0 === this.childCount;
            }
            get nextSibling() {
              return null;
            }
            get previousSibling() {
              return null;
            }
            get root() {
              return this;
            }
            get parent() {
              return null;
            }
            get document() {
              return null;
            }
            getAncestors() {
              return [];
            }
            getChild(t) {
              return this._children.getNode(t);
            }
            getChildren() {
              return this._children[Symbol.iterator]();
            }
            getChildIndex(t) {
              return this._children.getNodeIndex(t);
            }
            getChildStartOffset(t) {
              return this._children.getNodeStartOffset(t);
            }
            getPath() {
              return [];
            }
            getNodeByPath(t) {
              let e = this;
              for (const n of t) e = e.getChild(e.offsetToIndex(n));
              return e;
            }
            offsetToIndex(t) {
              return this._children.offsetToIndex(t);
            }
            toJSON() {
              const t = [];
              for (const e of this._children) t.push(e.toJSON());
              return t;
            }
            static fromJSON(t) {
              const e = [];
              for (const n of t)
                n.name ? e.push(il.fromJSON(n)) : e.push(nl.fromJSON(n));
              return new md(e);
            }
            _appendChild(t) {
              this._insertChild(this.childCount, t);
            }
            _insertChild(t, e) {
              const n = (function (t) {
                if ("string" == typeof t) return [new nl(t)];
                go(t) || (t = [t]);
                return Array.from(t).map((t) =>
                  "string" == typeof t
                    ? new nl(t)
                    : t instanceof ol
                    ? new nl(t.data, t.getAttributes())
                    : t
                );
              })(e);
              for (const t of n)
                null !== t.parent && t._remove(), (t.parent = this);
              this._children._insertNodes(t, n);
            }
            _removeChildren(t, e = 1) {
              const n = this._children._removeNodes(t, e);
              for (const t of n) t.parent = null;
              return n;
            }
          }
          md.prototype.is = function (t) {
            return "documentFragment" === t || "model:documentFragment" === t;
          };
          class gd {
            constructor(t, e) {
              (this.model = t), (this.batch = e);
            }
            createText(t, e) {
              return new nl(t, e);
            }
            createElement(t, e) {
              return new il(t, e);
            }
            createDocumentFragment() {
              return new md();
            }
            cloneElement(t, e = !0) {
              return t._clone(e);
            }
            insert(t, e, n = 0) {
              if (
                (this._assertWriterUsedCorrectly(),
                t instanceof nl && "" == t.data)
              )
                return;
              const o = al._createAt(e, n);
              if (t.parent) {
                if (wd(t.root, o.root))
                  return void this.move(ml._createOn(t), o);
                if (t.root.document)
                  throw new l("model-writer-insert-forbidden-move", this);
                this.remove(t);
              }
              const i = o.root.document ? o.root.document.version : null,
                r = new od(o, t, i);
              if (
                (t instanceof nl && (r.shouldReceiveAttributes = !0),
                this.batch.addOperation(r),
                this.model.applyOperation(r),
                t instanceof md)
              )
                for (const [e, n] of t.markers) {
                  const t = al._createAt(n.root, 0),
                    i = {
                      range: new ml(
                        n.start._getCombined(t, o),
                        n.end._getCombined(t, o)
                      ),
                      usingOperation: !0,
                      affectsData: !0,
                    };
                  this.model.markers.has(e)
                    ? this.updateMarker(e, i)
                    : this.addMarker(e, i);
                }
            }
            insertText(t, e, n, o) {
              e instanceof md || e instanceof il || e instanceof al
                ? this.insert(this.createText(t), e, n)
                : this.insert(this.createText(t, e), n, o);
            }
            insertElement(t, e, n, o) {
              e instanceof md || e instanceof il || e instanceof al
                ? this.insert(this.createElement(t), e, n)
                : this.insert(this.createElement(t, e), n, o);
            }
            append(t, e) {
              this.insert(t, e, "end");
            }
            appendText(t, e, n) {
              e instanceof md || e instanceof il
                ? this.insert(this.createText(t), e, "end")
                : this.insert(this.createText(t, e), n, "end");
            }
            appendElement(t, e, n) {
              e instanceof md || e instanceof il
                ? this.insert(this.createElement(t), e, "end")
                : this.insert(this.createElement(t, e), n, "end");
            }
            setAttribute(t, e, n) {
              if ((this._assertWriterUsedCorrectly(), n instanceof ml)) {
                const o = n.getMinimalFlatRanges();
                for (const n of o) pd(this, t, e, n);
              } else fd(this, t, e, n);
            }
            setAttributes(t, e) {
              for (const [n, o] of Bo(t)) this.setAttribute(n, o, e);
            }
            removeAttribute(t, e) {
              if ((this._assertWriterUsedCorrectly(), e instanceof ml)) {
                const n = e.getMinimalFlatRanges();
                for (const e of n) pd(this, t, null, e);
              } else fd(this, t, null, e);
            }
            clearAttributes(t) {
              this._assertWriterUsedCorrectly();
              const e = (t) => {
                for (const e of t.getAttributeKeys())
                  this.removeAttribute(e, t);
              };
              if (t instanceof ml) for (const n of t.getItems()) e(n);
              else e(t);
            }
            move(t, e, n) {
              if ((this._assertWriterUsedCorrectly(), !(t instanceof ml)))
                throw new l("writer-move-invalid-range", this);
              if (!t.isFlat) throw new l("writer-move-range-not-flat", this);
              const o = al._createAt(e, n);
              if (o.isEqual(t.start)) return;
              if (
                (this._addOperationForAffectedMarkers("move", t),
                !wd(t.root, o.root))
              )
                throw new l("writer-move-different-document", this);
              const i = t.root.document ? t.root.document.version : null,
                r = new nd(t.start, t.end.offset - t.start.offset, o, i);
              this.batch.addOperation(r), this.model.applyOperation(r);
            }
            remove(t) {
              this._assertWriterUsedCorrectly();
              const e = (t instanceof ml ? t : ml._createOn(t))
                .getMinimalFlatRanges()
                .reverse();
              for (const t of e)
                this._addOperationForAffectedMarkers("move", t),
                  bd(
                    t.start,
                    t.end.offset - t.start.offset,
                    this.batch,
                    this.model
                  );
            }
            merge(t) {
              this._assertWriterUsedCorrectly();
              const e = t.nodeBefore,
                n = t.nodeAfter;
              if (
                (this._addOperationForAffectedMarkers("merge", t),
                !(e instanceof il))
              )
                throw new l("writer-merge-no-element-before", this);
              if (!(n instanceof il))
                throw new l("writer-merge-no-element-after", this);
              t.root.document ? this._merge(t) : this._mergeDetached(t);
            }
            createPositionFromPath(t, e, n) {
              return this.model.createPositionFromPath(t, e, n);
            }
            createPositionAt(t, e) {
              return this.model.createPositionAt(t, e);
            }
            createPositionAfter(t) {
              return this.model.createPositionAfter(t);
            }
            createPositionBefore(t) {
              return this.model.createPositionBefore(t);
            }
            createRange(t, e) {
              return this.model.createRange(t, e);
            }
            createRangeIn(t) {
              return this.model.createRangeIn(t);
            }
            createRangeOn(t) {
              return this.model.createRangeOn(t);
            }
            createSelection(...t) {
              return this.model.createSelection(...t);
            }
            _mergeDetached(t) {
              const e = t.nodeBefore,
                n = t.nodeAfter;
              this.move(ml._createIn(n), al._createAt(e, "end")),
                this.remove(n);
            }
            _merge(t) {
              const e = al._createAt(t.nodeBefore, "end"),
                n = al._createAt(t.nodeAfter, 0),
                o = t.root.document.graveyard,
                i = new al(o, [0]),
                r = t.root.document.version,
                s = new ld(n, t.nodeAfter.maxOffset, e, i, r);
              this.batch.addOperation(s), this.model.applyOperation(s);
            }
            rename(t, e) {
              if ((this._assertWriterUsedCorrectly(), !(t instanceof il)))
                throw new l("writer-rename-not-element-instance", this);
              const n = t.root.document ? t.root.document.version : null,
                o = new sd(al._createBefore(t), t.name, e, n);
              this.batch.addOperation(o), this.model.applyOperation(o);
            }
            split(t, e) {
              this._assertWriterUsedCorrectly();
              let n,
                o,
                i = t.parent;
              if (!i.parent)
                throw new l("writer-split-element-no-parent", this);
              if (
                (e || (e = i.parent),
                !t.parent.getAncestors({ includeSelf: !0 }).includes(e))
              )
                throw new l("writer-split-invalid-limit-element", this);
              do {
                const e = i.root.document ? i.root.document.version : null,
                  r = i.maxOffset - t.offset,
                  s = cd.getInsertionPosition(t),
                  a = new cd(t, r, s, null, e);
                this.batch.addOperation(a),
                  this.model.applyOperation(a),
                  n || o || ((n = i), (o = t.parent.nextSibling)),
                  (i = (t = this.createPositionAfter(t.parent)).parent);
              } while (i !== e);
              return {
                position: t,
                range: new ml(al._createAt(n, "end"), al._createAt(o, 0)),
              };
            }
            wrap(t, e) {
              if ((this._assertWriterUsedCorrectly(), !t.isFlat))
                throw new l("writer-wrap-range-not-flat", this);
              const n = e instanceof il ? e : new il(e);
              if (n.childCount > 0)
                throw new l("writer-wrap-element-not-empty", this);
              if (null !== n.parent)
                throw new l("writer-wrap-element-attached", this);
              this.insert(n, t.start);
              const o = new ml(t.start.getShiftedBy(1), t.end.getShiftedBy(1));
              this.move(o, al._createAt(n, 0));
            }
            unwrap(t) {
              if ((this._assertWriterUsedCorrectly(), null === t.parent))
                throw new l("writer-unwrap-element-no-parent", this);
              this.move(ml._createIn(t), this.createPositionAfter(t)),
                this.remove(t);
            }
            addMarker(t, e) {
              if (
                (this._assertWriterUsedCorrectly(),
                !e || "boolean" != typeof e.usingOperation)
              )
                throw new l("writer-addmarker-no-usingoperation", this);
              const n = e.usingOperation,
                o = e.range,
                i = void 0 !== e.affectsData && e.affectsData;
              if (this.model.markers.has(t))
                throw new l("writer-addmarker-marker-exists", this);
              if (!o) throw new l("writer-addmarker-no-range", this);
              return n
                ? (kd(this, t, null, o, i), this.model.markers.get(t))
                : this.model.markers._set(t, o, n, i);
            }
            updateMarker(t, e) {
              this._assertWriterUsedCorrectly();
              const n = "string" == typeof t ? t : t.name,
                o = this.model.markers.get(n);
              if (!o)
                throw new l("writer-updatemarker-marker-not-exists", this);
              if (!e)
                return (
                  c("writer-updatemarker-reconvert-using-editingcontroller", {
                    markerName: n,
                  }),
                  void this.model.markers._refresh(o)
                );
              const i = "boolean" == typeof e.usingOperation,
                r = "boolean" == typeof e.affectsData,
                s = r ? e.affectsData : o.affectsData;
              if (!i && !e.range && !r)
                throw new l("writer-updatemarker-wrong-options", this);
              const a = o.getRange(),
                d = e.range ? e.range : a;
              i && e.usingOperation !== o.managedUsingOperations
                ? e.usingOperation
                  ? kd(this, n, null, d, s)
                  : (kd(this, n, a, null, s),
                    this.model.markers._set(n, d, void 0, s))
                : o.managedUsingOperations
                ? kd(this, n, a, d, s)
                : this.model.markers._set(n, d, void 0, s);
            }
            removeMarker(t) {
              this._assertWriterUsedCorrectly();
              const e = "string" == typeof t ? t : t.name;
              if (!this.model.markers.has(e))
                throw new l("writer-removemarker-no-marker", this);
              const n = this.model.markers.get(e);
              if (!n.managedUsingOperations)
                return void this.model.markers._remove(e);
              kd(this, e, n.getRange(), null, n.affectsData);
            }
            setSelection(...t) {
              this._assertWriterUsedCorrectly(),
                this.model.document.selection._setTo(...t);
            }
            setSelectionFocus(t, e) {
              this._assertWriterUsedCorrectly(),
                this.model.document.selection._setFocus(t, e);
            }
            setSelectionAttribute(t, e) {
              if ((this._assertWriterUsedCorrectly(), "string" == typeof t))
                this._setSelectionAttribute(t, e);
              else
                for (const [e, n] of Bo(t)) this._setSelectionAttribute(e, n);
            }
            removeSelectionAttribute(t) {
              if ((this._assertWriterUsedCorrectly(), "string" == typeof t))
                this._removeSelectionAttribute(t);
              else for (const e of t) this._removeSelectionAttribute(e);
            }
            overrideSelectionGravity() {
              return this.model.document.selection._overrideGravity();
            }
            restoreSelectionGravity(t) {
              this.model.document.selection._restoreGravity(t);
            }
            _setSelectionAttribute(t, e) {
              const n = this.model.document.selection;
              if (n.isCollapsed && n.anchor.parent.isEmpty) {
                const o = Il._getStoreAttributeKey(t);
                this.setAttribute(o, e, n.anchor.parent);
              }
              n._setAttribute(t, e);
            }
            _removeSelectionAttribute(t) {
              const e = this.model.document.selection;
              if (e.isCollapsed && e.anchor.parent.isEmpty) {
                const n = Il._getStoreAttributeKey(t);
                this.removeAttribute(n, e.anchor.parent);
              }
              e._removeAttribute(t);
            }
            _assertWriterUsedCorrectly() {
              if (this.model._currentWriter !== this)
                throw new l("writer-incorrect-use", this);
            }
            _addOperationForAffectedMarkers(t, e) {
              for (const n of this.model.markers) {
                if (!n.managedUsingOperations) continue;
                const o = n.getRange();
                let i = !1;
                if ("move" === t) {
                  const t = e;
                  i =
                    t.containsPosition(o.start) ||
                    t.start.isEqual(o.start) ||
                    t.containsPosition(o.end) ||
                    t.end.isEqual(o.end);
                } else {
                  const t = e,
                    n = t.nodeBefore,
                    r = t.nodeAfter,
                    s = o.start.parent == n && o.start.isAtEnd,
                    a = o.end.parent == r && 0 == o.end.offset,
                    l = o.end.nodeAfter == r,
                    c = o.start.nodeAfter == r;
                  i = s || a || l || c;
                }
                i && this.updateMarker(n.name, { range: o });
              }
            }
          }
          function pd(t, e, n, o) {
            const i = t.model,
              r = i.document;
            let s,
              a,
              l,
              c = o.start;
            for (const t of o.getWalker({ shallow: !0 }))
              (l = t.item.getAttribute(e)),
                s && a != l && (a != n && d(), (c = s)),
                (s = t.nextPosition),
                (a = l);
            function d() {
              const o = new ml(c, s),
                l = o.root.document ? r.version : null,
                d = new ed(o, e, a, n, l);
              t.batch.addOperation(d), i.applyOperation(d);
            }
            s instanceof al && s != c && a != n && d();
          }
          function fd(t, e, n, o) {
            const i = t.model,
              r = i.document,
              s = o.getAttribute(e);
            let a, l;
            if (s != n) {
              if (o.root === o) {
                const t = o.document ? r.version : null;
                l = new ad(o, e, s, n, t);
              } else {
                a = new ml(al._createBefore(o), t.createPositionAfter(o));
                const i = a.root.document ? r.version : null;
                l = new ed(a, e, s, n, i);
              }
              t.batch.addOperation(l), i.applyOperation(l);
            }
          }
          function kd(t, e, n, o, i) {
            const r = t.model,
              s = r.document,
              a = new id(e, n, o, r.markers, !!i, s.version);
            t.batch.addOperation(a), r.applyOperation(a);
          }
          function bd(t, e, n, o) {
            let i;
            if (t.root.document) {
              const n = o.document,
                r = new al(n.graveyard, [0]);
              i = new nd(t, e, r, n.version);
            } else i = new hd(t, e);
            n.addOperation(i), o.applyOperation(i);
          }
          function wd(t, e) {
            return t === e || (t instanceof Lc && e instanceof Lc);
          }
          function Ad(t) {
            t.document.registerPostFixer((e) =>
              (function (t, e) {
                const n = e.document.selection,
                  o = e.schema,
                  i = [];
                let r = !1;
                for (const t of n.getRanges()) {
                  const e = _d(t, o);
                  e && !e.isEqual(t) ? (i.push(e), (r = !0)) : i.push(t);
                }
                r &&
                  t.setSelection(
                    (function (t) {
                      const e = [...t],
                        n = new Set();
                      let o = 1;
                      for (; o < e.length; ) {
                        const t = e[o],
                          i = e.slice(0, o);
                        for (const [r, s] of i.entries())
                          if (!n.has(r))
                            if (t.isEqual(s)) n.add(r);
                            else if (t.isIntersecting(s)) {
                              n.add(r), n.add(o);
                              const i = t.getJoined(s);
                              e.push(i);
                            }
                        o++;
                      }
                      return e.filter((t, e) => !n.has(e));
                    })(i),
                    { backward: n.isBackward }
                  );
                return !1;
              })(e, t)
            );
          }
          function _d(t, e) {
            return t.isCollapsed
              ? (function (t, e) {
                  const n = t.start,
                    o = e.getNearestSelectionRange(n);
                  if (!o) {
                    const t = n
                      .getAncestors()
                      .reverse()
                      .find((t) => e.isObject(t));
                    return t ? ml._createOn(t) : null;
                  }
                  if (!o.isCollapsed) return o;
                  const i = o.start;
                  if (n.isEqual(i)) return null;
                  return new ml(i);
                })(t, e)
              : (function (t, e) {
                  const { start: n, end: o } = t,
                    i = e.checkChild(n, "$text"),
                    r = e.checkChild(o, "$text"),
                    s = e.getLimitElement(n),
                    a = e.getLimitElement(o);
                  if (s === a) {
                    if (i && r) return null;
                    if (
                      (function (t, e, n) {
                        const o =
                            (t.nodeAfter && !n.isLimit(t.nodeAfter)) ||
                            n.checkChild(t, "$text"),
                          i =
                            (e.nodeBefore && !n.isLimit(e.nodeBefore)) ||
                            n.checkChild(e, "$text");
                        return o || i;
                      })(n, o, e)
                    ) {
                      const t =
                          n.nodeAfter && e.isSelectable(n.nodeAfter)
                            ? null
                            : e.getNearestSelectionRange(n, "forward"),
                        i =
                          o.nodeBefore && e.isSelectable(o.nodeBefore)
                            ? null
                            : e.getNearestSelectionRange(o, "backward"),
                        r = t ? t.start : n,
                        s = i ? i.end : o;
                      return new ml(r, s);
                    }
                  }
                  const l = s && !s.is("rootElement"),
                    c = a && !a.is("rootElement");
                  if (l || c) {
                    const t =
                        n.nodeAfter &&
                        o.nodeBefore &&
                        n.nodeAfter.parent === o.nodeBefore.parent,
                      i = l && (!t || !vd(n.nodeAfter, e)),
                      r = c && (!t || !vd(o.nodeBefore, e));
                    let d = n,
                      u = o;
                    return (
                      i && (d = al._createBefore(Cd(s, e))),
                      r && (u = al._createAfter(Cd(a, e))),
                      new ml(d, u)
                    );
                  }
                  return null;
                })(t, e);
          }
          function Cd(t, e) {
            let n = t,
              o = n;
            for (; e.isLimit(o) && o.parent; ) (n = o), (o = o.parent);
            return n;
          }
          function vd(t, e) {
            return t && e.isSelectable(t);
          }
          class yd extends k(al) {
            constructor(t, e, n = "toNone") {
              if ((super(t, e, n), !this.root.is("rootElement")))
                throw new l("model-liveposition-root-not-rootelement", t);
              xd.call(this);
            }
            detach() {
              this.stopListening();
            }
            toPosition() {
              return new al(this.root, this.path.slice(), this.stickiness);
            }
            static fromPosition(t, e) {
              return new this(t.root, t.path.slice(), e || t.stickiness);
            }
          }
          function xd() {
            this.listenTo(
              this.root.document.model,
              "applyOperation",
              (t, e) => {
                const n = e[0];
                n.isDocumentOperation && Ed.call(this, n);
              },
              { priority: "low" }
            );
          }
          function Ed(t) {
            const e = this.getTransformedByOperation(t);
            if (!this.isEqual(e)) {
              const t = this.toPosition();
              (this.path = e.path),
                (this.root = e.root),
                this.fire("change", t);
            }
          }
          function Dd(t, e, n = {}) {
            if (e.isCollapsed) return;
            const o = e.getFirstRange();
            if ("$graveyard" == o.root.rootName) return;
            const i = t.schema;
            t.change((t) => {
              if (
                !n.doNotResetEntireContent &&
                (function (t, e) {
                  const n = t.getLimitElement(e);
                  if (!e.containsEntireContent(n)) return !1;
                  const o = e.getFirstRange();
                  if (o.start.parent == o.end.parent) return !1;
                  return t.checkChild(n, "paragraph");
                })(i, e)
              )
                return void (function (t, e) {
                  const n = t.model.schema.getLimitElement(e);
                  t.remove(t.createRangeIn(n)),
                    Md(t, t.createPositionAt(n, 0), e);
                })(t, e);
              const r = {};
              if (!n.doNotAutoparagraph) {
                const t = e.getSelectedElement();
                t &&
                  Object.assign(
                    r,
                    i.getAttributesWithProperty(t, "copyOnReplace", !0)
                  );
              }
              const [s, a] = (function (t) {
                const e = t.root.document.model,
                  n = t.start;
                let o = t.end;
                if (e.hasContent(t, { ignoreMarkers: !0 })) {
                  const n = (function (t) {
                    const e = t.parent,
                      n = e.root.document.model.schema,
                      o = e.getAncestors({ parentFirst: !0, includeSelf: !0 });
                    for (const t of o) {
                      if (n.isLimit(t)) return null;
                      if (n.isBlock(t)) return t;
                    }
                  })(o);
                  if (n && o.isTouching(e.createPositionAt(n, 0))) {
                    const n = e.createSelection(t);
                    e.modifySelection(n, { direction: "backward" });
                    const i = n.getLastPosition(),
                      r = e.createRange(i, o);
                    e.hasContent(r, { ignoreMarkers: !0 }) || (o = i);
                  }
                }
                return [
                  yd.fromPosition(n, "toPrevious"),
                  yd.fromPosition(o, "toNext"),
                ];
              })(o);
              s.isTouching(a) || t.remove(t.createRange(s, a)),
                n.leaveUnmerged ||
                  (!(function (t, e, n) {
                    const o = t.model;
                    if (!Td(t.model.schema, e, n)) return;
                    const [i, r] = (function (t, e) {
                      const n = t.getAncestors(),
                        o = e.getAncestors();
                      let i = 0;
                      for (; n[i] && n[i] == o[i]; ) i++;
                      return [n[i], o[i]];
                    })(e, n);
                    if (!i || !r) return;
                    !o.hasContent(i, { ignoreMarkers: !0 }) &&
                    o.hasContent(r, { ignoreMarkers: !0 })
                      ? Id(t, e, n, i.parent)
                      : Sd(t, e, n, i.parent);
                  })(t, s, a),
                  i.removeDisallowedAttributes(s.parent.getChildren(), t)),
                Bd(t, e, s),
                !n.doNotAutoparagraph &&
                  (function (t, e) {
                    const n = t.checkChild(e, "$text"),
                      o = t.checkChild(e, "paragraph");
                    return !n && o;
                  })(i, s) &&
                  Md(t, s, e, r),
                s.detach(),
                a.detach();
            });
          }
          function Sd(t, e, n, o) {
            const i = e.parent,
              r = n.parent;
            if (i != o && r != o) {
              for (
                e = t.createPositionAfter(i),
                  (n = t.createPositionBefore(r)).isEqual(e) || t.insert(r, e),
                  t.merge(e);
                n.parent.isEmpty;

              ) {
                const e = n.parent;
                (n = t.createPositionBefore(e)), t.remove(e);
              }
              Td(t.model.schema, e, n) && Sd(t, e, n, o);
            }
          }
          function Id(t, e, n, o) {
            const i = e.parent,
              r = n.parent;
            if (i != o && r != o) {
              for (
                e = t.createPositionAfter(i),
                  (n = t.createPositionBefore(r)).isEqual(e) || t.insert(i, n);
                e.parent.isEmpty;

              ) {
                const n = e.parent;
                (e = t.createPositionBefore(n)), t.remove(n);
              }
              (n = t.createPositionBefore(r)),
                (function (t, e) {
                  const n = e.nodeBefore,
                    o = e.nodeAfter;
                  n.name != o.name && t.rename(n, o.name);
                  t.clearAttributes(n),
                    t.setAttributes(Object.fromEntries(o.getAttributes()), n),
                    t.merge(e);
                })(t, n),
                Td(t.model.schema, e, n) && Id(t, e, n, o);
            }
          }
          function Td(t, e, n) {
            const o = e.parent,
              i = n.parent;
            return (
              o != i &&
              !t.isLimit(o) &&
              !t.isLimit(i) &&
              (function (t, e, n) {
                const o = new ml(t, e);
                for (const t of o.getWalker()) if (n.isLimit(t.item)) return !1;
                return !0;
              })(e, n, t)
            );
          }
          function Md(t, e, n, o = {}) {
            const i = t.createElement("paragraph");
            t.model.schema.setAllowedAttributes(i, o, t),
              t.insert(i, e),
              Bd(t, n, t.createPositionAt(i, 0));
          }
          function Bd(t, e, n) {
            e instanceof Il ? t.setSelection(n) : e.setTo(n);
          }
          function Nd(t, e) {
            const n = [];
            Array.from(t.getItems({ direction: "backward" }))
              .map((t) => e.createRangeOn(t))
              .filter(
                (e) =>
                  (e.start.isAfter(t.start) || e.start.isEqual(t.start)) &&
                  (e.end.isBefore(t.end) || e.end.isEqual(t.end))
              )
              .forEach((t) => {
                n.push(t.start.parent), e.remove(t);
              }),
              n.forEach((t) => {
                let n = t;
                for (; n.parent && n.isEmpty; ) {
                  const t = e.createRangeOn(n);
                  (n = n.parent), e.remove(t);
                }
              });
          }
          yd.prototype.is = function (t) {
            return (
              "livePosition" === t ||
              "model:livePosition" === t ||
              "position" == t ||
              "model:position" === t
            );
          };
          var zd = n(8894),
            Pd = { attributes: { "data-cke": !0 } };
          (Pd.setAttributes = is()),
            (Pd.insert = ns().bind(null, "head")),
            (Pd.domAPI = ts()),
            (Pd.insertStyleElement = ss());
          Jr()(zd.Z, Pd);
          zd.Z && zd.Z.locals && zd.Z.locals;
          const Ld = new WeakMap();
          function Rd(t) {
            const {
                view: e,
                element: n,
                text: o,
                isDirectHost: i = !0,
                keepOnFocus: r = !1,
              } = t,
              s = e.document;
            Ld.has(s) ||
              (Ld.set(s, new Map()),
              s.registerPostFixer((t) => jd(s, t)),
              s.on(
                "change:isComposing",
                () => {
                  e.change((t) => jd(s, t));
                },
                { priority: "high" }
              )),
              Ld.get(s).set(n, {
                text: o,
                isDirectHost: i,
                keepOnFocus: r,
                hostElement: i ? n : null,
              }),
              e.change((t) => jd(s, t));
          }
          function Od(t, e) {
            return (
              !!e.hasClass("ck-placeholder") &&
              (t.removeClass("ck-placeholder", e), !0)
            );
          }
          function jd(t, e) {
            const n = Ld.get(t),
              o = [];
            let i = !1;
            for (const [t, r] of n)
              r.isDirectHost && (o.push(t), Vd(e, t, r) && (i = !0));
            for (const [t, r] of n) {
              if (r.isDirectHost) continue;
              const n = Fd(t);
              n &&
                (o.includes(n) ||
                  ((r.hostElement = n), Vd(e, t, r) && (i = !0)));
            }
            return i;
          }
          function Vd(t, e, n) {
            const { text: o, isDirectHost: i, hostElement: r } = n;
            let s = !1;
            r.getAttribute("data-placeholder") !== o &&
              (t.setAttribute("data-placeholder", o, r), (s = !0));
            return (
              (i || 1 == e.childCount) &&
              (function (t, e) {
                if (!t.isAttached()) return !1;
                const n = Array.from(t.getChildren()).some(
                  (t) => !t.is("uiElement")
                );
                if (n) return !1;
                const o = t.document,
                  i = o.selection.anchor;
                return !(
                  (o.isComposing && i && i.parent === t) ||
                  (!e && o.isFocused && (!i || i.parent === t))
                );
              })(r, n.keepOnFocus)
                ? (function (t, e) {
                    return (
                      !e.hasClass("ck-placeholder") &&
                      (t.addClass("ck-placeholder", e), !0)
                    );
                  })(t, r) && (s = !0)
                : Od(t, r) && (s = !0),
              s
            );
          }
          function Fd(t) {
            if (t.childCount) {
              const e = t.getChild(0);
              if (
                e.is("element") &&
                !e.is("uiElement") &&
                !e.is("attributeElement")
              )
                return e;
            }
            return null;
          }
          const Hd = new Map();
          function Ud(t, e, n) {
            let o = Hd.get(t);
            o || ((o = new Map()), Hd.set(t, o)), o.set(e, n);
          }
          function Wd(t) {
            return [t];
          }
          function $d(t, e, n = {}) {
            const o = (function (t, e) {
              const n = Hd.get(t);
              return n && n.has(e) ? n.get(e) : Wd;
            })(t.constructor, e.constructor);
            try {
              return o((t = t.clone()), e, n);
            } catch (t) {
              throw t;
            }
          }
          function qd(t, e, n) {
            (t = t.slice()), (e = e.slice());
            const o = new Gd(n.document, n.useRelations, n.forceWeakRemove);
            o.setOriginalOperations(t), o.setOriginalOperations(e);
            const i = o.originalOperations;
            if (0 == t.length || 0 == e.length)
              return { operationsA: t, operationsB: e, originalOperations: i };
            const r = new WeakMap();
            for (const e of t) r.set(e, 0);
            const s = {
              nextBaseVersionA: t[t.length - 1].baseVersion + 1,
              nextBaseVersionB: e[e.length - 1].baseVersion + 1,
              originalOperationsACount: t.length,
              originalOperationsBCount: e.length,
            };
            let a = 0;
            for (; a < t.length; ) {
              const n = t[a],
                i = r.get(n);
              if (i == e.length) {
                a++;
                continue;
              }
              const s = e[i],
                l = $d(n, s, o.getContext(n, s, !0)),
                c = $d(s, n, o.getContext(s, n, !1));
              o.updateRelation(n, s),
                o.setOriginalOperations(l, n),
                o.setOriginalOperations(c, s);
              for (const t of l) r.set(t, i + c.length);
              t.splice(a, 1, ...l), e.splice(i, 1, ...c);
            }
            if (n.padWithNoOps) {
              const n = t.length - s.originalOperationsACount,
                o = e.length - s.originalOperationsBCount;
              Yd(t, o - n), Yd(e, n - o);
            }
            return (
              Zd(t, s.nextBaseVersionB),
              Zd(e, s.nextBaseVersionA),
              { operationsA: t, operationsB: e, originalOperations: i }
            );
          }
          class Gd {
            constructor(t, e, n = !1) {
              (this.originalOperations = new Map()),
                (this._history = t.history),
                (this._useRelations = e),
                (this._forceWeakRemove = !!n),
                (this._relations = new Map());
            }
            setOriginalOperations(t, e = null) {
              const n = e ? this.originalOperations.get(e) : null;
              for (const e of t) this.originalOperations.set(e, n || e);
            }
            updateRelation(t, e) {
              if (t instanceof nd)
                e instanceof ld
                  ? t.targetPosition.isEqual(e.sourcePosition) ||
                    e.movedRange.containsPosition(t.targetPosition)
                    ? this._setRelation(t, e, "insertAtSource")
                    : t.targetPosition.isEqual(e.deletionPosition)
                    ? this._setRelation(t, e, "insertBetween")
                    : t.targetPosition.isAfter(e.sourcePosition) &&
                      this._setRelation(t, e, "moveTargetAfter")
                  : e instanceof nd &&
                    (t.targetPosition.isEqual(e.sourcePosition) ||
                    t.targetPosition.isBefore(e.sourcePosition)
                      ? this._setRelation(t, e, "insertBefore")
                      : this._setRelation(t, e, "insertAfter"));
              else if (t instanceof cd) {
                if (e instanceof ld)
                  t.splitPosition.isBefore(e.sourcePosition) &&
                    this._setRelation(t, e, "splitBefore");
                else if (e instanceof nd)
                  if (
                    t.splitPosition.isEqual(e.sourcePosition) ||
                    t.splitPosition.isBefore(e.sourcePosition)
                  )
                    this._setRelation(t, e, "splitBefore");
                  else {
                    const n = ml._createFromPositionAndShift(
                      e.sourcePosition,
                      e.howMany
                    );
                    if (
                      t.splitPosition.hasSameParentAs(e.sourcePosition) &&
                      n.containsPosition(t.splitPosition)
                    ) {
                      const o = n.end.offset - t.splitPosition.offset,
                        i = t.splitPosition.offset - n.start.offset;
                      this._setRelation(t, e, { howMany: o, offset: i });
                    }
                  }
              } else if (t instanceof ld)
                e instanceof ld
                  ? (t.targetPosition.isEqual(e.sourcePosition) ||
                      this._setRelation(t, e, "mergeTargetNotMoved"),
                    t.sourcePosition.isEqual(e.targetPosition) &&
                      this._setRelation(t, e, "mergeSourceNotMoved"),
                    t.sourcePosition.isEqual(e.sourcePosition) &&
                      this._setRelation(t, e, "mergeSameElement"))
                  : e instanceof cd &&
                    t.sourcePosition.isEqual(e.splitPosition) &&
                    this._setRelation(t, e, "splitAtSource");
              else if (t instanceof id) {
                const n = t.newRange;
                if (!n) return;
                if (e instanceof nd) {
                  const o = ml._createFromPositionAndShift(
                      e.sourcePosition,
                      e.howMany
                    ),
                    i = o.containsPosition(n.start) || o.start.isEqual(n.start),
                    r = o.containsPosition(n.end) || o.end.isEqual(n.end);
                  (!i && !r) ||
                    o.containsRange(n) ||
                    this._setRelation(t, e, {
                      side: i ? "left" : "right",
                      path: i ? n.start.path.slice() : n.end.path.slice(),
                    });
                } else if (e instanceof ld) {
                  const o = n.start.isEqual(e.targetPosition),
                    i = n.start.isEqual(e.deletionPosition),
                    r = n.end.isEqual(e.deletionPosition),
                    s = n.end.isEqual(e.sourcePosition);
                  (o || i || r || s) &&
                    this._setRelation(t, e, {
                      wasInLeftElement: o,
                      wasStartBeforeMergedElement: i,
                      wasEndBeforeMergedElement: r,
                      wasInRightElement: s,
                    });
                }
              }
            }
            getContext(t, e, n) {
              return {
                aIsStrong: n,
                aWasUndone: this._wasUndone(t),
                bWasUndone: this._wasUndone(e),
                abRelation: this._useRelations ? this._getRelation(t, e) : null,
                baRelation: this._useRelations ? this._getRelation(e, t) : null,
                forceWeakRemove: this._forceWeakRemove,
              };
            }
            _wasUndone(t) {
              const e = this.originalOperations.get(t);
              return e.wasUndone || this._history.isUndoneOperation(e);
            }
            _getRelation(t, e) {
              const n = this.originalOperations.get(e),
                o = this._history.getUndoneOperation(n);
              if (!o) return null;
              const i = this.originalOperations.get(t),
                r = this._relations.get(i);
              return (r && r.get(o)) || null;
            }
            _setRelation(t, e, n) {
              const o = this.originalOperations.get(t),
                i = this.originalOperations.get(e);
              let r = this._relations.get(o);
              r || ((r = new Map()), this._relations.set(o, r)), r.set(i, n);
            }
          }
          function Zd(t, e) {
            for (const n of t) n.baseVersion = e++;
          }
          function Yd(t, e) {
            for (let n = 0; n < e; n++) t.push(new rd(0));
          }
          function Kd(t, e, n) {
            const o = t.nodes.getNode(0).getAttribute(e);
            if (o == n) return null;
            const i = new ml(t.position, t.position.getShiftedBy(t.howMany));
            return new ed(i, e, o, n, 0);
          }
          function Qd(t, e) {
            return (
              null ===
              t.targetPosition._getTransformedByDeletion(
                e.sourcePosition,
                e.howMany
              )
            );
          }
          function Jd(t, e) {
            const n = [];
            for (let o = 0; o < t.length; o++) {
              const i = t[o],
                r = new nd(i.start, i.end.offset - i.start.offset, e, 0);
              n.push(r);
              for (let e = o + 1; e < t.length; e++)
                t[e] = t[e]._getTransformedByMove(
                  r.sourcePosition,
                  r.targetPosition,
                  r.howMany
                )[0];
              e = e._getTransformedByMove(
                r.sourcePosition,
                r.targetPosition,
                r.howMany
              );
            }
            return n;
          }
          Ud(ed, ed, (t, e, n) => {
            if (
              t.key === e.key &&
              t.range.start.hasSameParentAs(e.range.start)
            ) {
              const o = t.range
                  .getDifference(e.range)
                  .map((e) => new ed(e, t.key, t.oldValue, t.newValue, 0)),
                i = t.range.getIntersection(e.range);
              return (
                i &&
                  n.aIsStrong &&
                  o.push(new ed(i, e.key, e.newValue, t.newValue, 0)),
                0 == o.length ? [new rd(0)] : o
              );
            }
            return [t];
          }),
            Ud(ed, od, (t, e) => {
              if (
                t.range.start.hasSameParentAs(e.position) &&
                t.range.containsPosition(e.position)
              ) {
                const n = t.range
                  ._getTransformedByInsertion(
                    e.position,
                    e.howMany,
                    !e.shouldReceiveAttributes
                  )
                  .map(
                    (e) =>
                      new ed(e, t.key, t.oldValue, t.newValue, t.baseVersion)
                  );
                if (e.shouldReceiveAttributes) {
                  const o = Kd(e, t.key, t.oldValue);
                  o && n.unshift(o);
                }
                return n;
              }
              return (
                (t.range = t.range._getTransformedByInsertion(
                  e.position,
                  e.howMany,
                  !1
                )[0]),
                [t]
              );
            }),
            Ud(ed, ld, (t, e) => {
              const n = [];
              t.range.start.hasSameParentAs(e.deletionPosition) &&
                (t.range.containsPosition(e.deletionPosition) ||
                  t.range.start.isEqual(e.deletionPosition)) &&
                n.push(ml._createFromPositionAndShift(e.graveyardPosition, 1));
              const o = t.range._getTransformedByMergeOperation(e);
              return (
                o.isCollapsed || n.push(o),
                n.map(
                  (e) => new ed(e, t.key, t.oldValue, t.newValue, t.baseVersion)
                )
              );
            }),
            Ud(ed, nd, (t, e) => {
              const n = (function (t, e) {
                const n = ml._createFromPositionAndShift(
                  e.sourcePosition,
                  e.howMany
                );
                let o = null,
                  i = [];
                n.containsRange(t, !0)
                  ? (o = t)
                  : t.start.hasSameParentAs(n.start)
                  ? ((i = t.getDifference(n)), (o = t.getIntersection(n)))
                  : (i = [t]);
                const r = [];
                for (let t of i) {
                  t = t._getTransformedByDeletion(e.sourcePosition, e.howMany);
                  const n = e.getMovedRangeStart(),
                    o = t.start.hasSameParentAs(n),
                    i = t._getTransformedByInsertion(n, e.howMany, o);
                  r.push(...i);
                }
                o &&
                  r.push(
                    o._getTransformedByMove(
                      e.sourcePosition,
                      e.targetPosition,
                      e.howMany,
                      !1
                    )[0]
                  );
                return r;
              })(t.range, e);
              return n.map(
                (e) => new ed(e, t.key, t.oldValue, t.newValue, t.baseVersion)
              );
            }),
            Ud(ed, cd, (t, e) => {
              if (t.range.end.isEqual(e.insertionPosition))
                return e.graveyardPosition || t.range.end.offset++, [t];
              if (
                t.range.start.hasSameParentAs(e.splitPosition) &&
                t.range.containsPosition(e.splitPosition)
              ) {
                const n = t.clone();
                return (
                  (n.range = new ml(
                    e.moveTargetPosition.clone(),
                    t.range.end._getCombined(
                      e.splitPosition,
                      e.moveTargetPosition
                    )
                  )),
                  (t.range.end = e.splitPosition.clone()),
                  (t.range.end.stickiness = "toPrevious"),
                  [t, n]
                );
              }
              return (
                (t.range = t.range._getTransformedBySplitOperation(e)), [t]
              );
            }),
            Ud(od, ed, (t, e) => {
              const n = [t];
              if (
                t.shouldReceiveAttributes &&
                t.position.hasSameParentAs(e.range.start) &&
                e.range.containsPosition(t.position)
              ) {
                const o = Kd(t, e.key, e.newValue);
                o && n.push(o);
              }
              return n;
            }),
            Ud(
              od,
              od,
              (t, e, n) => (
                (t.position.isEqual(e.position) && n.aIsStrong) ||
                  (t.position = t.position._getTransformedByInsertOperation(e)),
                [t]
              )
            ),
            Ud(
              od,
              nd,
              (t, e) => (
                (t.position = t.position._getTransformedByMoveOperation(e)), [t]
              )
            ),
            Ud(
              od,
              cd,
              (t, e) => (
                (t.position = t.position._getTransformedBySplitOperation(e)),
                [t]
              )
            ),
            Ud(
              od,
              ld,
              (t, e) => (
                (t.position = t.position._getTransformedByMergeOperation(e)),
                [t]
              )
            ),
            Ud(
              id,
              od,
              (t, e) => (
                t.oldRange &&
                  (t.oldRange =
                    t.oldRange._getTransformedByInsertOperation(e)[0]),
                t.newRange &&
                  (t.newRange =
                    t.newRange._getTransformedByInsertOperation(e)[0]),
                [t]
              )
            ),
            Ud(id, id, (t, e, n) => {
              if (t.name == e.name) {
                if (!n.aIsStrong) return [new rd(0)];
                t.oldRange = e.newRange ? e.newRange.clone() : null;
              }
              return [t];
            }),
            Ud(
              id,
              ld,
              (t, e) => (
                t.oldRange &&
                  (t.oldRange = t.oldRange._getTransformedByMergeOperation(e)),
                t.newRange &&
                  (t.newRange = t.newRange._getTransformedByMergeOperation(e)),
                [t]
              )
            ),
            Ud(id, nd, (t, e, n) => {
              if (
                (t.oldRange &&
                  (t.oldRange = ml._createFromRanges(
                    t.oldRange._getTransformedByMoveOperation(e)
                  )),
                t.newRange)
              ) {
                if (n.abRelation) {
                  const o = ml._createFromRanges(
                    t.newRange._getTransformedByMoveOperation(e)
                  );
                  if (
                    "left" == n.abRelation.side &&
                    e.targetPosition.isEqual(t.newRange.start)
                  )
                    return (
                      (t.newRange.end = o.end),
                      (t.newRange.start.path = n.abRelation.path),
                      [t]
                    );
                  if (
                    "right" == n.abRelation.side &&
                    e.targetPosition.isEqual(t.newRange.end)
                  )
                    return (
                      (t.newRange.start = o.start),
                      (t.newRange.end.path = n.abRelation.path),
                      [t]
                    );
                }
                t.newRange = ml._createFromRanges(
                  t.newRange._getTransformedByMoveOperation(e)
                );
              }
              return [t];
            }),
            Ud(id, cd, (t, e, n) => {
              if (
                (t.oldRange &&
                  (t.oldRange = t.oldRange._getTransformedBySplitOperation(e)),
                t.newRange)
              ) {
                if (n.abRelation) {
                  const o = t.newRange._getTransformedBySplitOperation(e);
                  return (
                    t.newRange.start.isEqual(e.splitPosition) &&
                    n.abRelation.wasStartBeforeMergedElement
                      ? (t.newRange.start = al._createAt(e.insertionPosition))
                      : t.newRange.start.isEqual(e.splitPosition) &&
                        !n.abRelation.wasInLeftElement &&
                        (t.newRange.start = al._createAt(e.moveTargetPosition)),
                    t.newRange.end.isEqual(e.splitPosition) &&
                    n.abRelation.wasInRightElement
                      ? (t.newRange.end = al._createAt(e.moveTargetPosition))
                      : t.newRange.end.isEqual(e.splitPosition) &&
                        n.abRelation.wasEndBeforeMergedElement
                      ? (t.newRange.end = al._createAt(e.insertionPosition))
                      : (t.newRange.end = o.end),
                    [t]
                  );
                }
                t.newRange = t.newRange._getTransformedBySplitOperation(e);
              }
              return [t];
            }),
            Ud(
              ld,
              od,
              (t, e) => (
                t.sourcePosition.hasSameParentAs(e.position) &&
                  (t.howMany += e.howMany),
                (t.sourcePosition =
                  t.sourcePosition._getTransformedByInsertOperation(e)),
                (t.targetPosition =
                  t.targetPosition._getTransformedByInsertOperation(e)),
                [t]
              )
            ),
            Ud(ld, ld, (t, e, n) => {
              if (
                t.sourcePosition.isEqual(e.sourcePosition) &&
                t.targetPosition.isEqual(e.targetPosition)
              ) {
                if (n.bWasUndone) {
                  const n = e.graveyardPosition.path.slice();
                  return (
                    n.push(0),
                    (t.sourcePosition = new al(e.graveyardPosition.root, n)),
                    (t.howMany = 0),
                    [t]
                  );
                }
                return [new rd(0)];
              }
              if (
                t.sourcePosition.isEqual(e.sourcePosition) &&
                !t.targetPosition.isEqual(e.targetPosition) &&
                !n.bWasUndone &&
                "splitAtSource" != n.abRelation
              ) {
                const o = "$graveyard" == t.targetPosition.root.rootName,
                  i = "$graveyard" == e.targetPosition.root.rootName,
                  r = o && !i;
                if ((i && !o) || (!r && n.aIsStrong)) {
                  const n = e.targetPosition._getTransformedByMergeOperation(e),
                    o = t.targetPosition._getTransformedByMergeOperation(e);
                  return [new nd(n, t.howMany, o, 0)];
                }
                return [new rd(0)];
              }
              return (
                t.sourcePosition.hasSameParentAs(e.targetPosition) &&
                  (t.howMany += e.howMany),
                (t.sourcePosition =
                  t.sourcePosition._getTransformedByMergeOperation(e)),
                (t.targetPosition =
                  t.targetPosition._getTransformedByMergeOperation(e)),
                (t.graveyardPosition.isEqual(e.graveyardPosition) &&
                  n.aIsStrong) ||
                  (t.graveyardPosition =
                    t.graveyardPosition._getTransformedByMergeOperation(e)),
                [t]
              );
            }),
            Ud(ld, nd, (t, e, n) => {
              const o = ml._createFromPositionAndShift(
                e.sourcePosition,
                e.howMany
              );
              return "remove" == e.type &&
                !n.bWasUndone &&
                !n.forceWeakRemove &&
                t.deletionPosition.hasSameParentAs(e.sourcePosition) &&
                o.containsPosition(t.sourcePosition)
                ? [new rd(0)]
                : (t.sourcePosition.hasSameParentAs(e.targetPosition) &&
                    (t.howMany += e.howMany),
                  t.sourcePosition.hasSameParentAs(e.sourcePosition) &&
                    (t.howMany -= e.howMany),
                  (t.sourcePosition =
                    t.sourcePosition._getTransformedByMoveOperation(e)),
                  (t.targetPosition =
                    t.targetPosition._getTransformedByMoveOperation(e)),
                  t.graveyardPosition.isEqual(e.targetPosition) ||
                    (t.graveyardPosition =
                      t.graveyardPosition._getTransformedByMoveOperation(e)),
                  [t]);
            }),
            Ud(ld, cd, (t, e, n) => {
              if (
                (e.graveyardPosition &&
                  ((t.graveyardPosition =
                    t.graveyardPosition._getTransformedByDeletion(
                      e.graveyardPosition,
                      1
                    )),
                  t.deletionPosition.isEqual(e.graveyardPosition) &&
                    (t.howMany = e.howMany)),
                t.targetPosition.isEqual(e.splitPosition))
              ) {
                const o = 0 != e.howMany,
                  i =
                    e.graveyardPosition &&
                    t.deletionPosition.isEqual(e.graveyardPosition);
                if (o || i || "mergeTargetNotMoved" == n.abRelation)
                  return (
                    (t.sourcePosition =
                      t.sourcePosition._getTransformedBySplitOperation(e)),
                    [t]
                  );
              }
              if (t.sourcePosition.isEqual(e.splitPosition)) {
                if ("mergeSourceNotMoved" == n.abRelation)
                  return (
                    (t.howMany = 0),
                    (t.targetPosition =
                      t.targetPosition._getTransformedBySplitOperation(e)),
                    [t]
                  );
                if (
                  "mergeSameElement" == n.abRelation ||
                  t.sourcePosition.offset > 0
                )
                  return (
                    (t.sourcePosition = e.moveTargetPosition.clone()),
                    (t.targetPosition =
                      t.targetPosition._getTransformedBySplitOperation(e)),
                    [t]
                  );
              }
              return (
                t.sourcePosition.hasSameParentAs(e.splitPosition) &&
                  (t.howMany = e.splitPosition.offset),
                (t.sourcePosition =
                  t.sourcePosition._getTransformedBySplitOperation(e)),
                (t.targetPosition =
                  t.targetPosition._getTransformedBySplitOperation(e)),
                [t]
              );
            }),
            Ud(nd, od, (t, e) => {
              const n = ml
                ._createFromPositionAndShift(t.sourcePosition, t.howMany)
                ._getTransformedByInsertOperation(e, !1)[0];
              return (
                (t.sourcePosition = n.start),
                (t.howMany = n.end.offset - n.start.offset),
                t.targetPosition.isEqual(e.position) ||
                  (t.targetPosition =
                    t.targetPosition._getTransformedByInsertOperation(e)),
                [t]
              );
            }),
            Ud(nd, nd, (t, e, n) => {
              const o = ml._createFromPositionAndShift(
                  t.sourcePosition,
                  t.howMany
                ),
                i = ml._createFromPositionAndShift(e.sourcePosition, e.howMany);
              let r,
                s = n.aIsStrong,
                a = !n.aIsStrong;
              if (
                ("insertBefore" == n.abRelation || "insertAfter" == n.baRelation
                  ? (a = !0)
                  : ("insertAfter" != n.abRelation &&
                      "insertBefore" != n.baRelation) ||
                    (a = !1),
                (r =
                  t.targetPosition.isEqual(e.targetPosition) && a
                    ? t.targetPosition._getTransformedByDeletion(
                        e.sourcePosition,
                        e.howMany
                      )
                    : t.targetPosition._getTransformedByMove(
                        e.sourcePosition,
                        e.targetPosition,
                        e.howMany
                      )),
                Qd(t, e) && Qd(e, t))
              )
                return [e.getReversed()];
              if (
                o.containsPosition(e.targetPosition) &&
                o.containsRange(i, !0)
              )
                return (
                  (o.start = o.start._getTransformedByMove(
                    e.sourcePosition,
                    e.targetPosition,
                    e.howMany
                  )),
                  (o.end = o.end._getTransformedByMove(
                    e.sourcePosition,
                    e.targetPosition,
                    e.howMany
                  )),
                  Jd([o], r)
                );
              if (
                i.containsPosition(t.targetPosition) &&
                i.containsRange(o, !0)
              )
                return (
                  (o.start = o.start._getCombined(
                    e.sourcePosition,
                    e.getMovedRangeStart()
                  )),
                  (o.end = o.end._getCombined(
                    e.sourcePosition,
                    e.getMovedRangeStart()
                  )),
                  Jd([o], r)
                );
              const l = Do(
                t.sourcePosition.getParentPath(),
                e.sourcePosition.getParentPath()
              );
              if ("prefix" == l || "extension" == l)
                return (
                  (o.start = o.start._getTransformedByMove(
                    e.sourcePosition,
                    e.targetPosition,
                    e.howMany
                  )),
                  (o.end = o.end._getTransformedByMove(
                    e.sourcePosition,
                    e.targetPosition,
                    e.howMany
                  )),
                  Jd([o], r)
                );
              "remove" != t.type ||
              "remove" == e.type ||
              n.aWasUndone ||
              n.forceWeakRemove
                ? "remove" == t.type ||
                  "remove" != e.type ||
                  n.bWasUndone ||
                  n.forceWeakRemove ||
                  (s = !1)
                : (s = !0);
              const c = [],
                d = o.getDifference(i);
              for (const t of d) {
                (t.start = t.start._getTransformedByDeletion(
                  e.sourcePosition,
                  e.howMany
                )),
                  (t.end = t.end._getTransformedByDeletion(
                    e.sourcePosition,
                    e.howMany
                  ));
                const n =
                    "same" ==
                    Do(
                      t.start.getParentPath(),
                      e.getMovedRangeStart().getParentPath()
                    ),
                  o = t._getTransformedByInsertion(
                    e.getMovedRangeStart(),
                    e.howMany,
                    n
                  );
                c.push(...o);
              }
              const u = o.getIntersection(i);
              return (
                null !== u &&
                  s &&
                  ((u.start = u.start._getCombined(
                    e.sourcePosition,
                    e.getMovedRangeStart()
                  )),
                  (u.end = u.end._getCombined(
                    e.sourcePosition,
                    e.getMovedRangeStart()
                  )),
                  0 === c.length
                    ? c.push(u)
                    : 1 == c.length
                    ? i.start.isBefore(o.start) || i.start.isEqual(o.start)
                      ? c.unshift(u)
                      : c.push(u)
                    : c.splice(1, 0, u)),
                0 === c.length ? [new rd(t.baseVersion)] : Jd(c, r)
              );
            }),
            Ud(nd, cd, (t, e, n) => {
              let o = t.targetPosition.clone();
              (t.targetPosition.isEqual(e.insertionPosition) &&
                e.graveyardPosition &&
                "moveTargetAfter" != n.abRelation) ||
                (o = t.targetPosition._getTransformedBySplitOperation(e));
              const i = ml._createFromPositionAndShift(
                t.sourcePosition,
                t.howMany
              );
              if (i.end.isEqual(e.insertionPosition))
                return (
                  e.graveyardPosition || t.howMany++,
                  (t.targetPosition = o),
                  [t]
                );
              if (
                i.start.hasSameParentAs(e.splitPosition) &&
                i.containsPosition(e.splitPosition)
              ) {
                let t = new ml(e.splitPosition, i.end);
                t = t._getTransformedBySplitOperation(e);
                return Jd([new ml(i.start, e.splitPosition), t], o);
              }
              t.targetPosition.isEqual(e.splitPosition) &&
                "insertAtSource" == n.abRelation &&
                (o = e.moveTargetPosition),
                t.targetPosition.isEqual(e.insertionPosition) &&
                  "insertBetween" == n.abRelation &&
                  (o = t.targetPosition);
              const r = [i._getTransformedBySplitOperation(e)];
              if (e.graveyardPosition) {
                const o =
                  i.start.isEqual(e.graveyardPosition) ||
                  i.containsPosition(e.graveyardPosition);
                t.howMany > 1 &&
                  o &&
                  !n.aWasUndone &&
                  r.push(
                    ml._createFromPositionAndShift(e.insertionPosition, 1)
                  );
              }
              return Jd(r, o);
            }),
            Ud(nd, ld, (t, e, n) => {
              const o = ml._createFromPositionAndShift(
                t.sourcePosition,
                t.howMany
              );
              if (
                e.deletionPosition.hasSameParentAs(t.sourcePosition) &&
                o.containsPosition(e.sourcePosition)
              )
                if ("remove" != t.type || n.forceWeakRemove) {
                  if (1 == t.howMany)
                    return n.bWasUndone
                      ? ((t.sourcePosition = e.graveyardPosition.clone()),
                        (t.targetPosition =
                          t.targetPosition._getTransformedByMergeOperation(e)),
                        [t])
                      : [new rd(0)];
                } else if (!n.aWasUndone) {
                  const n = [];
                  let o = e.graveyardPosition.clone(),
                    i = e.targetPosition._getTransformedByMergeOperation(e);
                  t.howMany > 1 &&
                    (n.push(
                      new nd(
                        t.sourcePosition,
                        t.howMany - 1,
                        t.targetPosition,
                        0
                      )
                    ),
                    (o = o._getTransformedByMove(
                      t.sourcePosition,
                      t.targetPosition,
                      t.howMany - 1
                    )),
                    (i = i._getTransformedByMove(
                      t.sourcePosition,
                      t.targetPosition,
                      t.howMany - 1
                    )));
                  const r = e.deletionPosition._getCombined(
                      t.sourcePosition,
                      t.targetPosition
                    ),
                    s = new nd(o, 1, r, 0),
                    a = s.getMovedRangeStart().path.slice();
                  a.push(0);
                  const l = new al(s.targetPosition.root, a);
                  i = i._getTransformedByMove(o, r, 1);
                  const c = new nd(i, e.howMany, l, 0);
                  return n.push(s), n.push(c), n;
                }
              const i = ml
                ._createFromPositionAndShift(t.sourcePosition, t.howMany)
                ._getTransformedByMergeOperation(e);
              return (
                (t.sourcePosition = i.start),
                (t.howMany = i.end.offset - i.start.offset),
                (t.targetPosition =
                  t.targetPosition._getTransformedByMergeOperation(e)),
                [t]
              );
            }),
            Ud(
              sd,
              od,
              (t, e) => (
                (t.position = t.position._getTransformedByInsertOperation(e)),
                [t]
              )
            ),
            Ud(sd, ld, (t, e) =>
              t.position.isEqual(e.deletionPosition)
                ? ((t.position = e.graveyardPosition.clone()),
                  (t.position.stickiness = "toNext"),
                  [t])
                : ((t.position = t.position._getTransformedByMergeOperation(e)),
                  [t])
            ),
            Ud(
              sd,
              nd,
              (t, e) => (
                (t.position = t.position._getTransformedByMoveOperation(e)), [t]
              )
            ),
            Ud(sd, sd, (t, e, n) => {
              if (t.position.isEqual(e.position)) {
                if (!n.aIsStrong) return [new rd(0)];
                t.oldName = e.newName;
              }
              return [t];
            }),
            Ud(sd, cd, (t, e) => {
              if (
                "same" ==
                  Do(t.position.path, e.splitPosition.getParentPath()) &&
                !e.graveyardPosition
              ) {
                const e = new sd(
                  t.position.getShiftedBy(1),
                  t.oldName,
                  t.newName,
                  0
                );
                return [t, e];
              }
              return (
                (t.position = t.position._getTransformedBySplitOperation(e)),
                [t]
              );
            }),
            Ud(ad, ad, (t, e, n) => {
              if (t.root === e.root && t.key === e.key) {
                if (!n.aIsStrong || t.newValue === e.newValue)
                  return [new rd(0)];
                t.oldValue = e.newValue;
              }
              return [t];
            }),
            Ud(
              cd,
              od,
              (t, e) => (
                t.splitPosition.hasSameParentAs(e.position) &&
                  t.splitPosition.offset < e.position.offset &&
                  (t.howMany += e.howMany),
                (t.splitPosition =
                  t.splitPosition._getTransformedByInsertOperation(e)),
                (t.insertionPosition =
                  t.insertionPosition._getTransformedByInsertOperation(e)),
                [t]
              )
            ),
            Ud(cd, ld, (t, e, n) => {
              if (
                !t.graveyardPosition &&
                !n.bWasUndone &&
                t.splitPosition.hasSameParentAs(e.sourcePosition)
              ) {
                const n = e.graveyardPosition.path.slice();
                n.push(0);
                const o = new al(e.graveyardPosition.root, n),
                  i = cd.getInsertionPosition(
                    new al(e.graveyardPosition.root, n)
                  ),
                  r = new cd(o, 0, i, null, 0);
                return (
                  (t.splitPosition =
                    t.splitPosition._getTransformedByMergeOperation(e)),
                  (t.insertionPosition = cd.getInsertionPosition(
                    t.splitPosition
                  )),
                  (t.graveyardPosition = r.insertionPosition.clone()),
                  (t.graveyardPosition.stickiness = "toNext"),
                  [r, t]
                );
              }
              return (
                t.splitPosition.hasSameParentAs(e.deletionPosition) &&
                  !t.splitPosition.isAfter(e.deletionPosition) &&
                  t.howMany--,
                t.splitPosition.hasSameParentAs(e.targetPosition) &&
                  (t.howMany += e.howMany),
                (t.splitPosition =
                  t.splitPosition._getTransformedByMergeOperation(e)),
                (t.insertionPosition = cd.getInsertionPosition(
                  t.splitPosition
                )),
                t.graveyardPosition &&
                  (t.graveyardPosition =
                    t.graveyardPosition._getTransformedByMergeOperation(e)),
                [t]
              );
            }),
            Ud(cd, nd, (t, e, n) => {
              const o = ml._createFromPositionAndShift(
                e.sourcePosition,
                e.howMany
              );
              if (t.graveyardPosition) {
                const i =
                  o.start.isEqual(t.graveyardPosition) ||
                  o.containsPosition(t.graveyardPosition);
                if (!n.bWasUndone && i) {
                  const n = t.splitPosition._getTransformedByMoveOperation(e),
                    o = t.graveyardPosition._getTransformedByMoveOperation(e),
                    i = o.path.slice();
                  i.push(0);
                  const r = new al(o.root, i);
                  return [new nd(n, t.howMany, r, 0)];
                }
                t.graveyardPosition =
                  t.graveyardPosition._getTransformedByMoveOperation(e);
              }
              const i = t.splitPosition.isEqual(e.targetPosition);
              if (
                i &&
                ("insertAtSource" == n.baRelation ||
                  "splitBefore" == n.abRelation)
              )
                return (
                  (t.howMany += e.howMany),
                  (t.splitPosition = t.splitPosition._getTransformedByDeletion(
                    e.sourcePosition,
                    e.howMany
                  )),
                  (t.insertionPosition = cd.getInsertionPosition(
                    t.splitPosition
                  )),
                  [t]
                );
              if (i && n.abRelation && n.abRelation.howMany) {
                const { howMany: e, offset: o } = n.abRelation;
                return (
                  (t.howMany += e),
                  (t.splitPosition = t.splitPosition.getShiftedBy(o)),
                  [t]
                );
              }
              if (
                t.splitPosition.hasSameParentAs(e.sourcePosition) &&
                o.containsPosition(t.splitPosition)
              ) {
                const n =
                  e.howMany -
                  (t.splitPosition.offset - e.sourcePosition.offset);
                return (
                  (t.howMany -= n),
                  t.splitPosition.hasSameParentAs(e.targetPosition) &&
                    t.splitPosition.offset < e.targetPosition.offset &&
                    (t.howMany += e.howMany),
                  (t.splitPosition = e.sourcePosition.clone()),
                  (t.insertionPosition = cd.getInsertionPosition(
                    t.splitPosition
                  )),
                  [t]
                );
              }
              return (
                e.sourcePosition.isEqual(e.targetPosition) ||
                  (t.splitPosition.hasSameParentAs(e.sourcePosition) &&
                    t.splitPosition.offset <= e.sourcePosition.offset &&
                    (t.howMany -= e.howMany),
                  t.splitPosition.hasSameParentAs(e.targetPosition) &&
                    t.splitPosition.offset < e.targetPosition.offset &&
                    (t.howMany += e.howMany)),
                (t.splitPosition.stickiness = "toNone"),
                (t.splitPosition =
                  t.splitPosition._getTransformedByMoveOperation(e)),
                (t.splitPosition.stickiness = "toNext"),
                t.graveyardPosition
                  ? (t.insertionPosition =
                      t.insertionPosition._getTransformedByMoveOperation(e))
                  : (t.insertionPosition = cd.getInsertionPosition(
                      t.splitPosition
                    )),
                [t]
              );
            }),
            Ud(cd, cd, (t, e, n) => {
              if (t.splitPosition.isEqual(e.splitPosition)) {
                if (!t.graveyardPosition && !e.graveyardPosition)
                  return [new rd(0)];
                if (
                  t.graveyardPosition &&
                  e.graveyardPosition &&
                  t.graveyardPosition.isEqual(e.graveyardPosition)
                )
                  return [new rd(0)];
                if ("splitBefore" == n.abRelation)
                  return (
                    (t.howMany = 0),
                    (t.graveyardPosition =
                      t.graveyardPosition._getTransformedBySplitOperation(e)),
                    [t]
                  );
              }
              if (
                t.graveyardPosition &&
                e.graveyardPosition &&
                t.graveyardPosition.isEqual(e.graveyardPosition)
              ) {
                const o = "$graveyard" == t.splitPosition.root.rootName,
                  i = "$graveyard" == e.splitPosition.root.rootName,
                  r = o && !i;
                if ((i && !o) || (!r && n.aIsStrong)) {
                  const n = [];
                  return (
                    e.howMany &&
                      n.push(
                        new nd(
                          e.moveTargetPosition,
                          e.howMany,
                          e.splitPosition,
                          0
                        )
                      ),
                    t.howMany &&
                      n.push(
                        new nd(
                          t.splitPosition,
                          t.howMany,
                          t.moveTargetPosition,
                          0
                        )
                      ),
                    n
                  );
                }
                return [new rd(0)];
              }
              if (
                (t.graveyardPosition &&
                  (t.graveyardPosition =
                    t.graveyardPosition._getTransformedBySplitOperation(e)),
                t.splitPosition.isEqual(e.insertionPosition) &&
                  "splitBefore" == n.abRelation)
              )
                return t.howMany++, [t];
              if (
                e.splitPosition.isEqual(t.insertionPosition) &&
                "splitBefore" == n.baRelation
              ) {
                const n = e.insertionPosition.path.slice();
                n.push(0);
                const o = new al(e.insertionPosition.root, n);
                return [t, new nd(t.insertionPosition, 1, o, 0)];
              }
              return (
                t.splitPosition.hasSameParentAs(e.splitPosition) &&
                  t.splitPosition.offset < e.splitPosition.offset &&
                  (t.howMany -= e.howMany),
                (t.splitPosition =
                  t.splitPosition._getTransformedBySplitOperation(e)),
                (t.insertionPosition = cd.getInsertionPosition(
                  t.splitPosition
                )),
                [t]
              );
            });
          class Xd extends zs {
            constructor(t) {
              super(t), (this.domEventType = "click");
            }
            onDomEvent(t) {
              this.fire(t.type, t);
            }
          }
          class tu extends zs {
            constructor(t) {
              super(t),
                (this.domEventType = [
                  "mousedown",
                  "mouseup",
                  "mouseover",
                  "mouseout",
                ]);
            }
            onDomEvent(t) {
              this.fire(t.type, t);
            }
          }
          class eu {
            constructor(t) {
              this.document = t;
            }
            createDocumentFragment(t) {
              return new Cr(this.document, t);
            }
            createElement(t, e, n) {
              return new Bi(this.document, t, e, n);
            }
            createText(t) {
              return new To(this.document, t);
            }
            clone(t, e = !1) {
              return t._clone(e);
            }
            appendChild(t, e) {
              return e._appendChild(t);
            }
            insertChild(t, e, n) {
              return n._insertChild(t, e);
            }
            removeChildren(t, e, n) {
              return n._removeChildren(t, e);
            }
            remove(t) {
              const e = t.parent;
              return e ? this.removeChildren(e.getChildIndex(t), 1, e) : [];
            }
            replace(t, e) {
              const n = t.parent;
              if (n) {
                const o = n.getChildIndex(t);
                return (
                  this.removeChildren(o, 1, n), this.insertChild(o, e, n), !0
                );
              }
              return !1;
            }
            unwrapElement(t) {
              const e = t.parent;
              if (e) {
                const n = e.getChildIndex(t);
                this.remove(t), this.insertChild(n, t.getChildren(), e);
              }
            }
            rename(t, e) {
              const n = new Bi(
                this.document,
                t,
                e.getAttributes(),
                e.getChildren()
              );
              return this.replace(e, n) ? n : null;
            }
            setAttribute(t, e, n) {
              n._setAttribute(t, e);
            }
            removeAttribute(t, e) {
              e._removeAttribute(t);
            }
            addClass(t, e) {
              e._addClass(t);
            }
            removeClass(t, e) {
              e._removeClass(t);
            }
            setStyle(t, e, n) {
              ut(t) && void 0 === n ? e._setStyle(t) : n._setStyle(t, e);
            }
            removeStyle(t, e) {
              e._removeStyle(t);
            }
            setCustomProperty(t, e, n) {
              n._setCustomProperty(t, e);
            }
            removeCustomProperty(t, e) {
              return e._removeCustomProperty(t);
            }
            createPositionAt(t, e) {
              return Vi._createAt(t, e);
            }
            createPositionAfter(t) {
              return Vi._createAfter(t);
            }
            createPositionBefore(t) {
              return Vi._createBefore(t);
            }
            createRange(t, e) {
              return new Fi(t, e);
            }
            createRangeOn(t) {
              return Fi._createOn(t);
            }
            createRangeIn(t) {
              return Fi._createIn(t);
            }
            createSelection(...t) {
              return new Wi(...t);
            }
          }
          const nu = /^#([0-9a-f]{3,4}|[0-9a-f]{6}|[0-9a-f]{8})$/i,
            ou = /^rgb\([ ]?([0-9]{1,3}[ %]?,[ ]?){2,3}[0-9]{1,3}[ %]?\)$/i,
            iu =
              /^rgba\([ ]?([0-9]{1,3}[ %]?,[ ]?){3}(1|[0-9]+%|[0]?\.?[0-9]+)\)$/i,
            ru =
              /^hsl\([ ]?([0-9]{1,3}[ %]?[,]?[ ]*){3}(1|[0-9]+%|[0]?\.?[0-9]+)?\)$/i,
            su =
              /^hsla\([ ]?([0-9]{1,3}[ %]?,[ ]?){2,3}(1|[0-9]+%|[0]?\.?[0-9]+)\)$/i,
            au = new Set([
              "black",
              "silver",
              "gray",
              "white",
              "maroon",
              "red",
              "purple",
              "fuchsia",
              "green",
              "lime",
              "olive",
              "yellow",
              "navy",
              "blue",
              "teal",
              "aqua",
              "orange",
              "aliceblue",
              "antiquewhite",
              "aquamarine",
              "azure",
              "beige",
              "bisque",
              "blanchedalmond",
              "blueviolet",
              "brown",
              "burlywood",
              "cadetblue",
              "chartreuse",
              "chocolate",
              "coral",
              "cornflowerblue",
              "cornsilk",
              "crimson",
              "cyan",
              "darkblue",
              "darkcyan",
              "darkgoldenrod",
              "darkgray",
              "darkgreen",
              "darkgrey",
              "darkkhaki",
              "darkmagenta",
              "darkolivegreen",
              "darkorange",
              "darkorchid",
              "darkred",
              "darksalmon",
              "darkseagreen",
              "darkslateblue",
              "darkslategray",
              "darkslategrey",
              "darkturquoise",
              "darkviolet",
              "deeppink",
              "deepskyblue",
              "dimgray",
              "dimgrey",
              "dodgerblue",
              "firebrick",
              "floralwhite",
              "forestgreen",
              "gainsboro",
              "ghostwhite",
              "gold",
              "goldenrod",
              "greenyellow",
              "grey",
              "honeydew",
              "hotpink",
              "indianred",
              "indigo",
              "ivory",
              "khaki",
              "lavender",
              "lavenderblush",
              "lawngreen",
              "lemonchiffon",
              "lightblue",
              "lightcoral",
              "lightcyan",
              "lightgoldenrodyellow",
              "lightgray",
              "lightgreen",
              "lightgrey",
              "lightpink",
              "lightsalmon",
              "lightseagreen",
              "lightskyblue",
              "lightslategray",
              "lightslategrey",
              "lightsteelblue",
              "lightyellow",
              "limegreen",
              "linen",
              "magenta",
              "mediumaquamarine",
              "mediumblue",
              "mediumorchid",
              "mediumpurple",
              "mediumseagreen",
              "mediumslateblue",
              "mediumspringgreen",
              "mediumturquoise",
              "mediumvioletred",
              "midnightblue",
              "mintcream",
              "mistyrose",
              "moccasin",
              "navajowhite",
              "oldlace",
              "olivedrab",
              "orangered",
              "orchid",
              "palegoldenrod",
              "palegreen",
              "paleturquoise",
              "palevioletred",
              "papayawhip",
              "peachpuff",
              "peru",
              "pink",
              "plum",
              "powderblue",
              "rosybrown",
              "royalblue",
              "saddlebrown",
              "salmon",
              "sandybrown",
              "seagreen",
              "seashell",
              "sienna",
              "skyblue",
              "slateblue",
              "slategray",
              "slategrey",
              "snow",
              "springgreen",
              "steelblue",
              "tan",
              "thistle",
              "tomato",
              "turquoise",
              "violet",
              "wheat",
              "whitesmoke",
              "yellowgreen",
              "activeborder",
              "activecaption",
              "appworkspace",
              "background",
              "buttonface",
              "buttonhighlight",
              "buttonshadow",
              "buttontext",
              "captiontext",
              "graytext",
              "highlight",
              "highlighttext",
              "inactiveborder",
              "inactivecaption",
              "inactivecaptiontext",
              "infobackground",
              "infotext",
              "menu",
              "menutext",
              "scrollbar",
              "threeddarkshadow",
              "threedface",
              "threedhighlight",
              "threedlightshadow",
              "threedshadow",
              "window",
              "windowframe",
              "windowtext",
              "rebeccapurple",
              "currentcolor",
              "transparent",
            ]);
          function lu(t) {
            return t.startsWith("#")
              ? nu.test(t)
              : t.startsWith("rgb")
              ? ou.test(t) || iu.test(t)
              : t.startsWith("hsl")
              ? ru.test(t) || su.test(t)
              : au.has(t.toLowerCase());
          }
          const cu = [
            "none",
            "hidden",
            "dotted",
            "dashed",
            "solid",
            "double",
            "groove",
            "ridge",
            "inset",
            "outset",
          ];
          function du(t) {
            return cu.includes(t);
          }
          const uu =
            /^([+-]?[0-9]*([.][0-9]+)?(px|cm|mm|in|pc|pt|ch|em|ex|rem|vh|vw|vmin|vmax)|0)$/;
          function hu(t) {
            return uu.test(t);
          }
          const mu = /^[+-]?[0-9]*([.][0-9]+)?%$/;
          const gu = [
            "repeat-x",
            "repeat-y",
            "repeat",
            "space",
            "round",
            "no-repeat",
          ];
          function pu(t) {
            return gu.includes(t);
          }
          const fu = ["center", "top", "bottom", "left", "right"];
          function ku(t) {
            return fu.includes(t);
          }
          const bu = ["fixed", "scroll", "local"];
          function wu(t) {
            return bu.includes(t);
          }
          const Au = /^url\(/;
          function _u(t) {
            return Au.test(t);
          }
          function Cu(t = "") {
            if ("" === t)
              return {
                top: void 0,
                right: void 0,
                bottom: void 0,
                left: void 0,
              };
            const e = Eu(t),
              n = e[0],
              o = e[2] || n,
              i = e[1] || n;
            return { top: n, bottom: o, right: i, left: e[3] || i };
          }
          function vu(t) {
            return (e) => {
              const { top: n, right: o, bottom: i, left: r } = e,
                s = [];
              return (
                [n, o, r, i].every((t) => !!t)
                  ? s.push([t, yu(e)])
                  : (n && s.push([t + "-top", n]),
                    o && s.push([t + "-right", o]),
                    i && s.push([t + "-bottom", i]),
                    r && s.push([t + "-left", r])),
                s
              );
            };
          }
          function yu({ top: t, right: e, bottom: n, left: o }) {
            const i = [];
            return (
              o !== e
                ? i.push(t, e, n, o)
                : n !== t
                ? i.push(t, e, n)
                : e !== t
                ? i.push(t, e)
                : i.push(t),
              i.join(" ")
            );
          }
          function xu(t) {
            return (e) => ({ path: t, value: Cu(e) });
          }
          function Eu(t) {
            return t
              .replace(/, /g, ",")
              .split(" ")
              .map((t) => t.replace(/,/g, ", "));
          }
          function Du(t) {
            t.setNormalizer("background", (t) => {
              const e = {},
                n = Eu(t);
              for (const t of n)
                pu(t)
                  ? ((e.repeat = e.repeat || []), e.repeat.push(t))
                  : ku(t)
                  ? ((e.position = e.position || []), e.position.push(t))
                  : wu(t)
                  ? (e.attachment = t)
                  : lu(t)
                  ? (e.color = t)
                  : _u(t) && (e.image = t);
              return { path: "background", value: e };
            }),
              t.setNormalizer("background-color", (t) => ({
                path: "background.color",
                value: t,
              })),
              t.setReducer("background", (t) => {
                const e = [];
                return e.push(["background-color", t.color]), e;
              }),
              t.setStyleRelation("background", ["background-color"]);
          }
          function Su(t) {
            t.setNormalizer("border", (t) => {
              const { color: e, style: n, width: o } = Pu(t);
              return {
                path: "border",
                value: { color: Cu(e), style: Cu(n), width: Cu(o) },
              };
            }),
              t.setNormalizer("border-top", Iu("top")),
              t.setNormalizer("border-right", Iu("right")),
              t.setNormalizer("border-bottom", Iu("bottom")),
              t.setNormalizer("border-left", Iu("left")),
              t.setNormalizer("border-color", Tu("color")),
              t.setNormalizer("border-width", Tu("width")),
              t.setNormalizer("border-style", Tu("style")),
              t.setNormalizer("border-top-color", Bu("color", "top")),
              t.setNormalizer("border-top-style", Bu("style", "top")),
              t.setNormalizer("border-top-width", Bu("width", "top")),
              t.setNormalizer("border-right-color", Bu("color", "right")),
              t.setNormalizer("border-right-style", Bu("style", "right")),
              t.setNormalizer("border-right-width", Bu("width", "right")),
              t.setNormalizer("border-bottom-color", Bu("color", "bottom")),
              t.setNormalizer("border-bottom-style", Bu("style", "bottom")),
              t.setNormalizer("border-bottom-width", Bu("width", "bottom")),
              t.setNormalizer("border-left-color", Bu("color", "left")),
              t.setNormalizer("border-left-style", Bu("style", "left")),
              t.setNormalizer("border-left-width", Bu("width", "left")),
              t.setExtractor("border-top", Nu("top")),
              t.setExtractor("border-right", Nu("right")),
              t.setExtractor("border-bottom", Nu("bottom")),
              t.setExtractor("border-left", Nu("left")),
              t.setExtractor("border-top-color", "border.color.top"),
              t.setExtractor("border-right-color", "border.color.right"),
              t.setExtractor("border-bottom-color", "border.color.bottom"),
              t.setExtractor("border-left-color", "border.color.left"),
              t.setExtractor("border-top-width", "border.width.top"),
              t.setExtractor("border-right-width", "border.width.right"),
              t.setExtractor("border-bottom-width", "border.width.bottom"),
              t.setExtractor("border-left-width", "border.width.left"),
              t.setExtractor("border-top-style", "border.style.top"),
              t.setExtractor("border-right-style", "border.style.right"),
              t.setExtractor("border-bottom-style", "border.style.bottom"),
              t.setExtractor("border-left-style", "border.style.left"),
              t.setReducer("border-color", vu("border-color")),
              t.setReducer("border-style", vu("border-style")),
              t.setReducer("border-width", vu("border-width")),
              t.setReducer("border-top", Lu("top")),
              t.setReducer("border-right", Lu("right")),
              t.setReducer("border-bottom", Lu("bottom")),
              t.setReducer("border-left", Lu("left")),
              t.setReducer(
                "border",
                (function () {
                  return (e) => {
                    const n = zu(e, "top"),
                      o = zu(e, "right"),
                      i = zu(e, "bottom"),
                      r = zu(e, "left"),
                      s = [n, o, i, r],
                      a = {
                        width: t(s, "width"),
                        style: t(s, "style"),
                        color: t(s, "color"),
                      },
                      l = Ru(a, "all");
                    if (l.length) return l;
                    const c = Object.entries(a).reduce(
                      (t, [e, n]) => (
                        n &&
                          (t.push([`border-${e}`, n]),
                          s.forEach((t) => delete t[e])),
                        t
                      ),
                      []
                    );
                    return [
                      ...c,
                      ...Ru(n, "top"),
                      ...Ru(o, "right"),
                      ...Ru(i, "bottom"),
                      ...Ru(r, "left"),
                    ];
                  };
                  function t(t, e) {
                    return t
                      .map((t) => t[e])
                      .reduce((t, e) => (t == e ? t : null));
                  }
                })()
              ),
              t.setStyleRelation("border", [
                "border-color",
                "border-style",
                "border-width",
                "border-top",
                "border-right",
                "border-bottom",
                "border-left",
                "border-top-color",
                "border-right-color",
                "border-bottom-color",
                "border-left-color",
                "border-top-style",
                "border-right-style",
                "border-bottom-style",
                "border-left-style",
                "border-top-width",
                "border-right-width",
                "border-bottom-width",
                "border-left-width",
              ]),
              t.setStyleRelation("border-color", [
                "border-top-color",
                "border-right-color",
                "border-bottom-color",
                "border-left-color",
              ]),
              t.setStyleRelation("border-style", [
                "border-top-style",
                "border-right-style",
                "border-bottom-style",
                "border-left-style",
              ]),
              t.setStyleRelation("border-width", [
                "border-top-width",
                "border-right-width",
                "border-bottom-width",
                "border-left-width",
              ]),
              t.setStyleRelation("border-top", [
                "border-top-color",
                "border-top-style",
                "border-top-width",
              ]),
              t.setStyleRelation("border-right", [
                "border-right-color",
                "border-right-style",
                "border-right-width",
              ]),
              t.setStyleRelation("border-bottom", [
                "border-bottom-color",
                "border-bottom-style",
                "border-bottom-width",
              ]),
              t.setStyleRelation("border-left", [
                "border-left-color",
                "border-left-style",
                "border-left-width",
              ]);
          }
          function Iu(t) {
            return (e) => {
              const { color: n, style: o, width: i } = Pu(e),
                r = {};
              return (
                void 0 !== n && (r.color = { [t]: n }),
                void 0 !== o && (r.style = { [t]: o }),
                void 0 !== i && (r.width = { [t]: i }),
                { path: "border", value: r }
              );
            };
          }
          function Tu(t) {
            return (e) => ({ path: "border", value: Mu(e, t) });
          }
          function Mu(t, e) {
            return { [e]: Cu(t) };
          }
          function Bu(t, e) {
            return (n) => ({ path: "border", value: { [t]: { [e]: n } } });
          }
          function Nu(t) {
            return (e, n) => {
              if (n.border) return zu(n.border, t);
            };
          }
          function zu(t, e) {
            const n = {};
            return (
              t.width && t.width[e] && (n.width = t.width[e]),
              t.style && t.style[e] && (n.style = t.style[e]),
              t.color && t.color[e] && (n.color = t.color[e]),
              n
            );
          }
          function Pu(t) {
            const e = {},
              n = Eu(t);
            for (const t of n)
              hu(t) || /thin|medium|thick/.test(t)
                ? (e.width = t)
                : du(t)
                ? (e.style = t)
                : (e.color = t);
            return e;
          }
          function Lu(t) {
            return (e) => Ru(e, t);
          }
          function Ru(t, e) {
            const n = [];
            if (
              (t && t.width && n.push("width"),
              t && t.style && n.push("style"),
              t && t.color && n.push("color"),
              3 == n.length)
            ) {
              const o = n.map((e) => t[e]).join(" ");
              return ["all" == e ? ["border", o] : [`border-${e}`, o]];
            }
            return "all" == e ? [] : n.map((n) => [`border-${e}-${n}`, t[n]]);
          }
          function Ou(t) {
            t.setNormalizer("margin", xu("margin")),
              t.setNormalizer("margin-top", (t) => ({
                path: "margin.top",
                value: t,
              })),
              t.setNormalizer("margin-right", (t) => ({
                path: "margin.right",
                value: t,
              })),
              t.setNormalizer("margin-bottom", (t) => ({
                path: "margin.bottom",
                value: t,
              })),
              t.setNormalizer("margin-left", (t) => ({
                path: "margin.left",
                value: t,
              })),
              t.setReducer("margin", vu("margin")),
              t.setStyleRelation("margin", [
                "margin-top",
                "margin-right",
                "margin-bottom",
                "margin-left",
              ]);
          }
          function ju(t) {
            t.setNormalizer("padding", xu("padding")),
              t.setNormalizer("padding-top", (t) => ({
                path: "padding.top",
                value: t,
              })),
              t.setNormalizer("padding-right", (t) => ({
                path: "padding.right",
                value: t,
              })),
              t.setNormalizer("padding-bottom", (t) => ({
                path: "padding.bottom",
                value: t,
              })),
              t.setNormalizer("padding-left", (t) => ({
                path: "padding.left",
                value: t,
              })),
              t.setReducer("padding", vu("padding")),
              t.setStyleRelation("padding", [
                "padding-top",
                "padding-right",
                "padding-bottom",
                "padding-left",
              ]);
          }
          class Vu {
            constructor(t, e, n) {
              (this.model = t),
                (this.writer = e),
                (this.position = n),
                (this.canMergeWith = new Set([this.position.parent])),
                (this.schema = t.schema),
                (this._documentFragment = e.createDocumentFragment()),
                (this._documentFragmentPosition = e.createPositionAt(
                  this._documentFragment,
                  0
                )),
                (this._firstNode = null),
                (this._lastNode = null),
                (this._lastAutoParagraph = null),
                (this._filterAttributesOf = []),
                (this._affectedStart = null),
                (this._affectedEnd = null);
            }
            handleNodes(t) {
              for (const e of Array.from(t)) this._handleNode(e);
              this._insertPartialFragment(),
                this._lastAutoParagraph &&
                  this._updateLastNodeFromAutoParagraph(
                    this._lastAutoParagraph
                  ),
                this._mergeOnRight(),
                this.schema.removeDisallowedAttributes(
                  this._filterAttributesOf,
                  this.writer
                ),
                (this._filterAttributesOf = []);
            }
            _updateLastNodeFromAutoParagraph(t) {
              const e = this.writer.createPositionAfter(this._lastNode),
                n = this.writer.createPositionAfter(t);
              if (n.isAfter(e)) {
                if (
                  ((this._lastNode = t),
                  this.position.parent != t || !this.position.isAtEnd)
                )
                  throw new l("insertcontent-invalid-insertion-position", this);
                (this.position = n), this._setAffectedBoundaries(this.position);
              }
            }
            getSelectionRange() {
              return this._nodeToSelect
                ? ml._createOn(this._nodeToSelect)
                : this.model.schema.getNearestSelectionRange(this.position);
            }
            getAffectedRange() {
              return this._affectedStart
                ? new ml(this._affectedStart, this._affectedEnd)
                : null;
            }
            destroy() {
              this._affectedStart && this._affectedStart.detach(),
                this._affectedEnd && this._affectedEnd.detach();
            }
            _handleNode(t) {
              if (this.schema.isObject(t)) return void this._handleObject(t);
              let e = this._checkAndAutoParagraphToAllowedPosition(t);
              e || ((e = this._checkAndSplitToAllowedPosition(t)), e)
                ? (this._appendToFragment(t),
                  this._firstNode || (this._firstNode = t),
                  (this._lastNode = t))
                : this._handleDisallowedNode(t);
            }
            _insertPartialFragment() {
              if (this._documentFragment.isEmpty) return;
              const t = yd.fromPosition(this.position, "toNext");
              this._setAffectedBoundaries(this.position),
                this._documentFragment.getChild(0) == this._firstNode &&
                  (this.writer.insert(this._firstNode, this.position),
                  this._mergeOnLeft(),
                  (this.position = t.toPosition())),
                this._documentFragment.isEmpty ||
                  this.writer.insert(this._documentFragment, this.position),
                (this._documentFragmentPosition = this.writer.createPositionAt(
                  this._documentFragment,
                  0
                )),
                (this.position = t.toPosition()),
                t.detach();
            }
            _handleObject(t) {
              this._checkAndSplitToAllowedPosition(t)
                ? this._appendToFragment(t)
                : this._tryAutoparagraphing(t);
            }
            _handleDisallowedNode(t) {
              t.is("element")
                ? this.handleNodes(t.getChildren())
                : this._tryAutoparagraphing(t);
            }
            _appendToFragment(t) {
              if (!this.schema.checkChild(this.position, t))
                throw new l("insertcontent-wrong-position", this, {
                  node: t,
                  position: this.position,
                });
              this.writer.insert(t, this._documentFragmentPosition),
                (this._documentFragmentPosition =
                  this._documentFragmentPosition.getShiftedBy(t.offsetSize)),
                this.schema.isObject(t) &&
                !this.schema.checkChild(this.position, "$text")
                  ? (this._nodeToSelect = t)
                  : (this._nodeToSelect = null),
                this._filterAttributesOf.push(t);
            }
            _setAffectedBoundaries(t) {
              this._affectedStart ||
                (this._affectedStart = yd.fromPosition(t, "toPrevious")),
                (this._affectedEnd && !this._affectedEnd.isBefore(t)) ||
                  (this._affectedEnd && this._affectedEnd.detach(),
                  (this._affectedEnd = yd.fromPosition(t, "toNext")));
            }
            _mergeOnLeft() {
              const t = this._firstNode;
              if (!(t instanceof il)) return;
              if (!this._canMergeLeft(t)) return;
              const e = yd._createBefore(t);
              e.stickiness = "toNext";
              const n = yd.fromPosition(this.position, "toNext");
              this._affectedStart.isEqual(e) &&
                (this._affectedStart.detach(),
                (this._affectedStart = yd._createAt(
                  e.nodeBefore,
                  "end",
                  "toPrevious"
                ))),
                this._firstNode === this._lastNode &&
                  ((this._firstNode = e.nodeBefore),
                  (this._lastNode = e.nodeBefore)),
                this.writer.merge(e),
                e.isEqual(this._affectedEnd) &&
                  this._firstNode === this._lastNode &&
                  (this._affectedEnd.detach(),
                  (this._affectedEnd = yd._createAt(
                    e.nodeBefore,
                    "end",
                    "toNext"
                  ))),
                (this.position = n.toPosition()),
                n.detach(),
                this._filterAttributesOf.push(this.position.parent),
                e.detach();
            }
            _mergeOnRight() {
              const t = this._lastNode;
              if (!(t instanceof il)) return;
              if (!this._canMergeRight(t)) return;
              const e = yd._createAfter(t);
              if (((e.stickiness = "toNext"), !this.position.isEqual(e)))
                throw new l("insertcontent-invalid-insertion-position", this);
              this.position = al._createAt(e.nodeBefore, "end");
              const n = yd.fromPosition(this.position, "toPrevious");
              this._affectedEnd.isEqual(e) &&
                (this._affectedEnd.detach(),
                (this._affectedEnd = yd._createAt(
                  e.nodeBefore,
                  "end",
                  "toNext"
                ))),
                this._firstNode === this._lastNode &&
                  ((this._firstNode = e.nodeBefore),
                  (this._lastNode = e.nodeBefore)),
                this.writer.merge(e),
                e.getShiftedBy(-1).isEqual(this._affectedStart) &&
                  this._firstNode === this._lastNode &&
                  (this._affectedStart.detach(),
                  (this._affectedStart = yd._createAt(
                    e.nodeBefore,
                    0,
                    "toPrevious"
                  ))),
                (this.position = n.toPosition()),
                n.detach(),
                this._filterAttributesOf.push(this.position.parent),
                e.detach();
            }
            _canMergeLeft(t) {
              const e = t.previousSibling;
              return (
                e instanceof il &&
                this.canMergeWith.has(e) &&
                this.model.schema.checkMerge(e, t)
              );
            }
            _canMergeRight(t) {
              const e = t.nextSibling;
              return (
                e instanceof il &&
                this.canMergeWith.has(e) &&
                this.model.schema.checkMerge(t, e)
              );
            }
            _tryAutoparagraphing(t) {
              const e = this.writer.createElement("paragraph");
              this._getAllowedIn(this.position.parent, e) &&
                this.schema.checkChild(e, t) &&
                (e._appendChild(t), this._handleNode(e));
            }
            _checkAndAutoParagraphToAllowedPosition(t) {
              if (this.schema.checkChild(this.position.parent, t)) return !0;
              if (
                !this.schema.checkChild(this.position.parent, "paragraph") ||
                !this.schema.checkChild("paragraph", t)
              )
                return !1;
              this._insertPartialFragment();
              const e = this.writer.createElement("paragraph");
              return (
                this.writer.insert(e, this.position),
                this._setAffectedBoundaries(this.position),
                (this._lastAutoParagraph = e),
                (this.position = this.writer.createPositionAt(e, 0)),
                !0
              );
            }
            _checkAndSplitToAllowedPosition(t) {
              const e = this._getAllowedIn(this.position.parent, t);
              if (!e) return !1;
              for (
                e != this.position.parent && this._insertPartialFragment();
                e != this.position.parent;

              )
                if (this.position.isAtStart) {
                  const t = this.position.parent;
                  (this.position = this.writer.createPositionBefore(t)),
                    t.isEmpty && t.parent === e && this.writer.remove(t);
                } else if (this.position.isAtEnd)
                  this.position = this.writer.createPositionAfter(
                    this.position.parent
                  );
                else {
                  const t = this.writer.createPositionAfter(
                    this.position.parent
                  );
                  this._setAffectedBoundaries(this.position),
                    this.writer.split(this.position),
                    (this.position = t),
                    this.canMergeWith.add(this.position.nodeAfter);
                }
              return !0;
            }
            _getAllowedIn(t, e) {
              return this.schema.checkChild(t, e)
                ? t
                : this.schema.isLimit(t)
                ? null
                : this._getAllowedIn(t.parent, e);
            }
          }
          function Fu(t, e, n = "auto") {
            const o = t.getSelectedElement();
            if (o && e.schema.isObject(o) && !e.schema.isInline(o))
              return "before" == n || "after" == n
                ? e.createRange(e.createPositionAt(o, n))
                : e.createRangeOn(o);
            const i = Ra(t.getSelectedBlocks());
            if (!i) return e.createRange(t.focus);
            if (i.isEmpty) return e.createRange(e.createPositionAt(i, 0));
            const r = e.createPositionAfter(i);
            return t.focus.isTouching(r)
              ? e.createRange(r)
              : e.createRange(e.createPositionBefore(i));
          }
          function Hu(t, e, n, o, i = {}) {
            if (!t.schema.isObject(e))
              throw new l("insertobject-element-not-an-object", t, {
                object: e,
              });
            let r;
            r = n
              ? n instanceof Al || n instanceof Il
                ? n
                : t.createSelection(n, o)
              : t.document.selection;
            let s = r;
            i.findOptimalPosition &&
              t.schema.isBlock(e) &&
              (s = t.createSelection(Fu(r, t, i.findOptimalPosition)));
            const a = Ra(r.getSelectedBlocks()),
              c = {};
            return (
              a &&
                Object.assign(
                  c,
                  t.schema.getAttributesWithProperty(a, "copyOnReplace", !0)
                ),
              t.change((n) => {
                s.isCollapsed || t.deleteContent(s, { doNotAutoparagraph: !0 });
                let o = e;
                const r = s.anchor.parent;
                !t.schema.checkChild(r, e) &&
                  t.schema.checkChild(r, "paragraph") &&
                  t.schema.checkChild("paragraph", e) &&
                  ((o = n.createElement("paragraph")), n.insert(e, o)),
                  t.schema.setAllowedAttributes(o, c, n);
                const a = t.insertContent(o, s);
                return (
                  a.isCollapsed ||
                    (i.setSelection &&
                      (function (t, e, n, o) {
                        const i = t.model;
                        if ("after" == n) {
                          let n = e.nextSibling;
                          !(n && i.schema.checkChild(n, "$text")) &&
                            i.schema.checkChild(e.parent, "paragraph") &&
                            ((n = t.createElement("paragraph")),
                            i.schema.setAllowedAttributes(n, o, t),
                            i.insertContent(n, t.createPositionAfter(e))),
                            n && t.setSelection(n, 0);
                        } else {
                          if ("on" != n)
                            throw new l(
                              "insertobject-invalid-place-parameter-value",
                              i
                            );
                          t.setSelection(e, "on");
                        }
                      })(n, e, i.setSelection, c)),
                  a
                );
              })
            );
          }
          function Uu(t, e) {
            const {
                isForward: n,
                walker: o,
                unit: i,
                schema: r,
                treatEmojiAsSingleUnit: s,
              } = t,
              { type: a, item: l, nextPosition: c } = e;
            if ("text" == a)
              return "word" === t.unit
                ? (function (t, e) {
                    let n = t.position.textNode;
                    n || (n = e ? t.position.nodeAfter : t.position.nodeBefore);
                    for (; n && n.is("$text"); ) {
                      const o = t.position.offset - n.startOffset;
                      if (qu(n, o, e))
                        n = e ? t.position.nodeAfter : t.position.nodeBefore;
                      else {
                        if ($u(n.data, o, e)) break;
                        t.next();
                      }
                    }
                    return t.position;
                  })(o, n)
                : (function (t, e, n) {
                    const o = t.position.textNode;
                    if (o) {
                      const i = o.data;
                      let r = t.position.offset - o.startOffset;
                      for (
                        ;
                        Rc(i, r) ||
                        ("character" == e && Oc(i, r)) ||
                        (n && Vc(i, r));

                      )
                        t.next(), (r = t.position.offset - o.startOffset);
                    }
                    return t.position;
                  })(o, i, s);
            if (a == (n ? "elementStart" : "elementEnd")) {
              if (r.isSelectable(l))
                return al._createAt(l, n ? "after" : "before");
              if (r.checkChild(c, "$text")) return c;
            } else {
              if (r.isLimit(l)) return void o.skip(() => !0);
              if (r.checkChild(c, "$text")) return c;
            }
          }
          function Wu(t, e) {
            const n = t.root,
              o = al._createAt(n, e ? "end" : 0);
            return e ? new ml(t, o) : new ml(o, t);
          }
          function $u(t, e, n) {
            const o = e + (n ? 0 : -1);
            return ' ,.?!:;"-()'.includes(t.charAt(o));
          }
          function qu(t, e, n) {
            return e === (n ? t.offsetSize : 0);
          }
          class Gu extends N {
            constructor() {
              super(),
                (this.markers = new Wc()),
                (this.document = new Hc(this)),
                (this.schema = new lc()),
                (this._pendingChanges = []),
                (this._currentWriter = null),
                [
                  "insertContent",
                  "insertObject",
                  "deleteContent",
                  "modifySelection",
                  "getSelectedContent",
                  "applyOperation",
                ].forEach((t) => this.decorate(t)),
                this.on(
                  "applyOperation",
                  (t, e) => {
                    e[0]._validate();
                  },
                  { priority: "highest" }
                ),
                this.schema.register("$root", { isLimit: !0 }),
                this.schema.register("$container", {
                  allowIn: ["$root", "$container"],
                }),
                this.schema.register("$block", {
                  allowIn: ["$root", "$container"],
                  isBlock: !0,
                }),
                this.schema.register("$blockObject", {
                  allowWhere: "$block",
                  isBlock: !0,
                  isObject: !0,
                }),
                this.schema.register("$inlineObject", {
                  allowWhere: "$text",
                  allowAttributesOf: "$text",
                  isInline: !0,
                  isObject: !0,
                }),
                this.schema.register("$text", {
                  allowIn: "$block",
                  isInline: !0,
                  isContent: !0,
                }),
                this.schema.register("$clipboardHolder", {
                  allowContentOf: "$root",
                  allowChildren: "$text",
                  isLimit: !0,
                }),
                this.schema.register("$documentFragment", {
                  allowContentOf: "$root",
                  allowChildren: "$text",
                  isLimit: !0,
                }),
                this.schema.register("$marker"),
                this.schema.addChildCheck((t, e) => {
                  if ("$marker" === e.name) return !0;
                }),
                Ad(this),
                this.document.registerPostFixer(Gl);
            }
            change(t) {
              try {
                return 0 === this._pendingChanges.length
                  ? (this._pendingChanges.push({
                      batch: new Tc(),
                      callback: t,
                    }),
                    this._runPendingChanges()[0])
                  : t(this._currentWriter);
              } catch (t) {
                l.rethrowUnexpectedError(t, this);
              }
            }
            enqueueChange(t, e) {
              try {
                t
                  ? "function" == typeof t
                    ? ((e = t), (t = new Tc()))
                    : t instanceof Tc || (t = new Tc(t))
                  : (t = new Tc()),
                  this._pendingChanges.push({ batch: t, callback: e }),
                  1 == this._pendingChanges.length && this._runPendingChanges();
              } catch (t) {
                l.rethrowUnexpectedError(t, this);
              }
            }
            applyOperation(t) {
              t._execute();
            }
            insertContent(t, e, n) {
              return (function (t, e, n, o) {
                return t.change((i) => {
                  let r;
                  (r = n
                    ? n instanceof Al || n instanceof Il
                      ? n
                      : i.createSelection(n, o)
                    : t.document.selection),
                    r.isCollapsed ||
                      t.deleteContent(r, { doNotAutoparagraph: !0 });
                  const s = new Vu(t, i, r.anchor),
                    a = [];
                  let l;
                  if (e.is("documentFragment")) {
                    if (e.markers.size) {
                      const t = [];
                      for (const [n, o] of e.markers) {
                        const { start: e, end: i } = o,
                          r = e.isEqual(i);
                        t.push(
                          { position: e, name: n, isCollapsed: r },
                          { position: i, name: n, isCollapsed: r }
                        );
                      }
                      t.sort(({ position: t }, { position: e }) =>
                        t.isBefore(e) ? 1 : -1
                      );
                      for (const {
                        position: n,
                        name: o,
                        isCollapsed: r,
                      } of t) {
                        let t = null,
                          s = null;
                        const l = n.parent === e && n.isAtStart,
                          c = n.parent === e && n.isAtEnd;
                        l || c
                          ? r && (s = l ? "start" : "end")
                          : ((t = i.createElement("$marker")), i.insert(t, n)),
                          a.push({ name: o, element: t, collapsed: s });
                      }
                    }
                    l = e.getChildren();
                  } else l = [e];
                  s.handleNodes(l);
                  let c = s.getSelectionRange();
                  if (e.is("documentFragment") && a.length) {
                    const t = c ? xl.fromRange(c) : null,
                      e = {};
                    for (let t = a.length - 1; t >= 0; t--) {
                      const { name: n, element: o, collapsed: r } = a[t],
                        l = !e[n];
                      if ((l && (e[n] = []), o)) {
                        const t = i.createPositionAt(o, "before");
                        e[n].push(t), i.remove(o);
                      } else {
                        const t = s.getAffectedRange();
                        if (!t) {
                          r && e[n].push(s.position);
                          continue;
                        }
                        r ? e[n].push(t[r]) : e[n].push(l ? t.start : t.end);
                      }
                    }
                    for (const [t, [n, o]] of Object.entries(e))
                      n &&
                        o &&
                        n.root === o.root &&
                        i.addMarker(t, {
                          usingOperation: !0,
                          affectsData: !0,
                          range: new ml(n, o),
                        });
                    t && ((c = t.toRange()), t.detach());
                  }
                  c && (r instanceof Il ? i.setSelection(c) : r.setTo(c));
                  const d = s.getAffectedRange() || t.createRange(r.anchor);
                  return s.destroy(), d;
                });
              })(this, t, e, n);
            }
            insertObject(t, e, n, o) {
              return Hu(this, t, e, n, o);
            }
            deleteContent(t, e) {
              Dd(this, t, e);
            }
            modifySelection(t, e) {
              !(function (t, e, n = {}) {
                const o = t.schema,
                  i = "backward" != n.direction,
                  r = n.unit ? n.unit : "character",
                  s = !!n.treatEmojiAsSingleUnit,
                  a = e.focus,
                  l = new rl({
                    boundaries: Wu(a, i),
                    singleCharacters: !0,
                    direction: i ? "forward" : "backward",
                  }),
                  c = {
                    walker: l,
                    schema: o,
                    isForward: i,
                    unit: r,
                    treatEmojiAsSingleUnit: s,
                  };
                let d;
                for (; (d = l.next()); ) {
                  if (d.done) return;
                  const n = Uu(c, d.value);
                  if (n)
                    return void (e instanceof Il
                      ? t.change((t) => {
                          t.setSelectionFocus(n);
                        })
                      : e.setFocus(n));
                }
              })(this, t, e);
            }
            getSelectedContent(t) {
              return (function (t, e) {
                return t.change((t) => {
                  const n = t.createDocumentFragment(),
                    o = e.getFirstRange();
                  if (!o || o.isCollapsed) return n;
                  const i = o.start.root,
                    r = o.start.getCommonPath(o.end),
                    s = i.getNodeByPath(r);
                  let a;
                  a =
                    o.start.parent == o.end.parent
                      ? o
                      : t.createRange(
                          t.createPositionAt(s, o.start.path[r.length]),
                          t.createPositionAt(s, o.end.path[r.length] + 1)
                        );
                  const l = a.end.offset - a.start.offset;
                  for (const e of a.getItems({ shallow: !0 }))
                    e.is("$textProxy")
                      ? t.appendText(e.data, e.getAttributes(), n)
                      : t.append(t.cloneElement(e, !0), n);
                  if (a != o) {
                    const e = o._getTransformedByMove(
                        a.start,
                        t.createPositionAt(n, 0),
                        l
                      )[0],
                      i = t.createRange(t.createPositionAt(n, 0), e.start);
                    Nd(t.createRange(e.end, t.createPositionAt(n, "end")), t),
                      Nd(i, t);
                  }
                  return n;
                });
              })(this, t);
            }
            hasContent(t, e = {}) {
              const n = t instanceof ml ? t : ml._createIn(t);
              if (n.isCollapsed) return !1;
              const { ignoreWhitespaces: o = !1, ignoreMarkers: i = !1 } = e;
              if (!i)
                for (const t of this.markers.getMarkersIntersectingRange(n))
                  if (t.affectsData) return !0;
              for (const t of n.getItems())
                if (this.schema.isContent(t)) {
                  if (!t.is("$textProxy")) return !0;
                  if (!o) return !0;
                  if (-1 !== t.data.search(/\S/)) return !0;
                }
              return !1;
            }
            createPositionFromPath(t, e, n) {
              return new al(t, e, n);
            }
            createPositionAt(t, e) {
              return al._createAt(t, e);
            }
            createPositionAfter(t) {
              return al._createAfter(t);
            }
            createPositionBefore(t) {
              return al._createBefore(t);
            }
            createRange(t, e) {
              return new ml(t, e);
            }
            createRangeIn(t) {
              return ml._createIn(t);
            }
            createRangeOn(t) {
              return ml._createOn(t);
            }
            createSelection(...t) {
              return new Al(...t);
            }
            createBatch(t) {
              return new Tc(t);
            }
            createOperationFromJSON(t) {
              return ud.fromJSON(t, this.document);
            }
            destroy() {
              this.document.destroy(), this.stopListening();
            }
            _runPendingChanges() {
              const t = [];
              this.fire("_beforeChanges");
              try {
                for (; this._pendingChanges.length; ) {
                  const e = this._pendingChanges[0].batch;
                  this._currentWriter = new gd(this, e);
                  const n = this._pendingChanges[0].callback(
                    this._currentWriter
                  );
                  t.push(n),
                    this.document._handleChangeBlock(this._currentWriter),
                    this._pendingChanges.shift(),
                    (this._currentWriter = null);
                }
              } finally {
                (this._pendingChanges.length = 0),
                  (this._currentWriter = null),
                  this.fire("_afterChanges");
              }
              return t;
            }
          }
          class Zu extends ja {
            constructor(t) {
              super(), (this.editor = t);
            }
            set(t, e, n = {}) {
              if ("string" == typeof e) {
                const t = e;
                e = (e, n) => {
                  this.editor.execute(t), n();
                };
              }
              super.set(t, e, n);
            }
          }
          class Yu extends N {
            constructor(t = {}) {
              super();
              const e = this.constructor,
                n = t.language || (e.defaultConfig && e.defaultConfig.language);
              (this._context = t.context || new yo({ language: n })),
                this._context._addEditor(this, !t.context);
              const o = Array.from(e.builtinPlugins || []);
              (this.config = new uo(t, e.defaultConfig)),
                this.config.define("plugins", o),
                this.config.define(this._context._getEditorConfig()),
                (this.plugins = new fo(this, o, this._context.plugins)),
                (this.locale = this._context.locale),
                (this.t = this.locale.t),
                (this._readOnlyLocks = new Set()),
                (this.commands = new ic()),
                this.set("state", "initializing"),
                this.once("ready", () => (this.state = "ready"), {
                  priority: "high",
                }),
                this.once("destroy", () => (this.state = "destroyed"), {
                  priority: "high",
                }),
                (this.model = new Gu());
              const i = new Ii();
              (this.data = new Ec(this.model, i)),
                (this.editing = new oc(this.model, i)),
                this.editing.view.document.bind("isReadOnly").to(this),
                (this.conversion = new Dc(
                  [
                    this.editing.downcastDispatcher,
                    this.data.downcastDispatcher,
                  ],
                  this.data.upcastDispatcher
                )),
                this.conversion.addAlias(
                  "dataDowncast",
                  this.data.downcastDispatcher
                ),
                this.conversion.addAlias(
                  "editingDowncast",
                  this.editing.downcastDispatcher
                ),
                (this.keystrokes = new Zu(this)),
                this.keystrokes.listenTo(this.editing.view.document);
            }
            get isReadOnly() {
              return this._readOnlyLocks.size > 0;
            }
            set isReadOnly(t) {
              throw new l("editor-isreadonly-has-no-setter");
            }
            enableReadOnlyMode(t) {
              if ("string" != typeof t && "symbol" != typeof t)
                throw new l("editor-read-only-lock-id-invalid", null, {
                  lockId: t,
                });
              this._readOnlyLocks.has(t) ||
                (this._readOnlyLocks.add(t),
                1 === this._readOnlyLocks.size &&
                  this.fire("change:isReadOnly", "isReadOnly", !0, !1));
            }
            disableReadOnlyMode(t) {
              if ("string" != typeof t && "symbol" != typeof t)
                throw new l("editor-read-only-lock-id-invalid", null, {
                  lockId: t,
                });
              this._readOnlyLocks.has(t) &&
                (this._readOnlyLocks.delete(t),
                0 === this._readOnlyLocks.size &&
                  this.fire("change:isReadOnly", "isReadOnly", !1, !0));
            }
            initPlugins() {
              const t = this.config,
                e = t.get("plugins"),
                n = t.get("removePlugins") || [],
                o = t.get("extraPlugins") || [],
                i = t.get("substitutePlugins") || [];
              return this.plugins.init(e.concat(o), n, i);
            }
            destroy() {
              let t = Promise.resolve();
              return (
                "initializing" == this.state &&
                  (t = new Promise((t) => this.once("ready", t))),
                t
                  .then(() => {
                    this.fire("destroy"),
                      this.stopListening(),
                      this.commands.destroy();
                  })
                  .then(() => this.plugins.destroy())
                  .then(() => {
                    this.model.destroy(),
                      this.data.destroy(),
                      this.editing.destroy(),
                      this.keystrokes.destroy();
                  })
                  .then(() => this._context._removeEditor(this))
              );
            }
            execute(t, ...e) {
              try {
                return this.commands.execute(t, ...e);
              } catch (t) {
                l.rethrowUnexpectedError(t, this);
              }
            }
            focus() {
              this.editing.view.focus();
            }
          }
          class Ku {
            constructor(t) {
              (this.editor = t), (this._components = new Map());
            }
            *names() {
              for (const t of this._components.values()) yield t.originalName;
            }
            add(t, e) {
              this._components.set(Qu(t), { callback: e, originalName: t });
            }
            create(t) {
              if (!this.has(t))
                throw new l("componentfactory-item-missing", this, { name: t });
              return this._components.get(Qu(t)).callback(this.editor.locale);
            }
            has(t) {
              return this._components.has(Qu(t));
            }
          }
          function Qu(t) {
            return String(t).toLowerCase();
          }
          class Ju extends po {
            constructor(t = []) {
              super(t, { idProperty: "viewUid" }),
                this.on("add", (t, e, n) => {
                  this._renderViewIntoCollectionParent(e, n);
                }),
                this.on("remove", (t, e) => {
                  e.element && this._parentElement && e.element.remove();
                }),
                (this._parentElement = null);
            }
            destroy() {
              this.map((t) => t.destroy());
            }
            setParent(t) {
              this._parentElement = t;
              for (const t of this) this._renderViewIntoCollectionParent(t);
            }
            delegate(...t) {
              if (!t.length || !t.every((t) => "string" == typeof t))
                throw new l("ui-viewcollection-delegate-wrong-events", this);
              return {
                to: (e) => {
                  for (const n of this) for (const o of t) n.delegate(o).to(e);
                  this.on("add", (n, o) => {
                    for (const n of t) o.delegate(n).to(e);
                  }),
                    this.on("remove", (n, o) => {
                      for (const n of t) o.stopDelegating(n, e);
                    });
                },
              };
            }
            _renderViewIntoCollectionParent(t, e) {
              t.isRendered || t.render(),
                t.element &&
                  this._parentElement &&
                  this._parentElement.insertBefore(
                    t.element,
                    this._parentElement.children[e]
                  );
            }
          }
          class Xu extends b {
            constructor(t) {
              super(),
                Object.assign(this, ch(lh(t))),
                (this._isRendered = !1),
                (this._revertData = null);
            }
            render() {
              const t = this._renderNode({ intoFragment: !0 });
              return (this._isRendered = !0), t;
            }
            apply(t) {
              return (
                (this._revertData = {
                  children: [],
                  bindings: [],
                  attributes: {},
                }),
                this._renderNode({
                  node: t,
                  intoFragment: !1,
                  isApplying: !0,
                  revertData: this._revertData,
                }),
                t
              );
            }
            revert(t) {
              if (!this._revertData)
                throw new l("ui-template-revert-not-applied", [this, t]);
              this._revertTemplateFromNode(t, this._revertData);
            }
            *getViews() {
              yield* (function* t(e) {
                if (e.children)
                  for (const n of e.children)
                    ph(n) ? yield n : fh(n) && (yield* t(n));
              })(this);
            }
            static bind(t, e) {
              return {
                to: (n, o) =>
                  new eh({
                    eventNameOrFunction: n,
                    attribute: n,
                    observable: t,
                    emitter: e,
                    callback: o,
                  }),
                if: (n, o, i) =>
                  new nh({
                    observable: t,
                    emitter: e,
                    attribute: n,
                    valueIfTrue: o,
                    callback: i,
                  }),
              };
            }
            static extend(t, e) {
              if (t._isRendered)
                throw new l("template-extend-render", [this, t]);
              mh(t, ch(lh(e)));
            }
            _renderNode(t) {
              let e;
              if (
                ((e = t.node
                  ? this.tag && this.text
                  : this.tag
                  ? this.text
                  : !this.text),
                e)
              )
                throw new l("ui-template-wrong-syntax", this);
              return this.text ? this._renderText(t) : this._renderElement(t);
            }
            _renderElement(t) {
              let e = t.node;
              return (
                e ||
                  (e = t.node =
                    document.createElementNS(
                      this.ns || "http://www.w3.org/1999/xhtml",
                      this.tag
                    )),
                this._renderAttributes(t),
                this._renderElementChildren(t),
                this._setUpListeners(t),
                e
              );
            }
            _renderText(t) {
              let e = t.node;
              return (
                e
                  ? (t.revertData.text = e.textContent)
                  : (e = t.node = document.createTextNode("")),
                oh(this.text)
                  ? this._bindToObservable({
                      schema: this.text,
                      updater: rh(e),
                      data: t,
                    })
                  : (e.textContent = this.text.join("")),
                e
              );
            }
            _renderAttributes(t) {
              if (!this.attributes) return;
              const e = t.node,
                n = t.revertData;
              for (const o in this.attributes) {
                const i = e.getAttribute(o),
                  r = this.attributes[o];
                n && (n.attributes[o] = i);
                const s = bh(r) ? r[0].ns : null;
                if (oh(r)) {
                  const a = bh(r) ? r[0].value : r;
                  n && wh(o) && a.unshift(i),
                    this._bindToObservable({
                      schema: a,
                      updater: sh(e, o, s),
                      data: t,
                    });
                } else if ("style" == o && "string" != typeof r[0])
                  this._renderStyleAttribute(r[0], t);
                else {
                  n && i && wh(o) && r.unshift(i);
                  const t = r
                    .map((t) => (t && t.value) || t)
                    .reduce((t, e) => t.concat(e), [])
                    .reduce(uh, "");
                  gh(t) || e.setAttributeNS(s, o, t);
                }
              }
            }
            _renderStyleAttribute(t, e) {
              const n = e.node;
              for (const o in t) {
                const i = t[o];
                oh(i)
                  ? this._bindToObservable({
                      schema: [i],
                      updater: ah(n, o),
                      data: e,
                    })
                  : (n.style[o] = i);
              }
            }
            _renderElementChildren(t) {
              const e = t.node,
                n = t.intoFragment ? document.createDocumentFragment() : e,
                o = t.isApplying;
              let i = 0;
              for (const r of this.children)
                if (kh(r)) {
                  if (!o) {
                    r.setParent(e);
                    for (const t of r) n.appendChild(t.element);
                  }
                } else if (ph(r))
                  o || (r.isRendered || r.render(), n.appendChild(r.element));
                else if (Kr(r)) n.appendChild(r);
                else if (o) {
                  const e = { children: [], bindings: [], attributes: {} };
                  t.revertData.children.push(e),
                    r._renderNode({
                      intoFragment: !1,
                      node: n.childNodes[i++],
                      isApplying: !0,
                      revertData: e,
                    });
                } else n.appendChild(r.render());
              t.intoFragment && e.appendChild(n);
            }
            _setUpListeners(t) {
              if (this.eventListeners)
                for (const e in this.eventListeners) {
                  const n = this.eventListeners[e].map((n) => {
                    const [o, i] = e.split("@");
                    return n.activateDomEventListener(o, i, t);
                  });
                  t.revertData && t.revertData.bindings.push(n);
                }
            }
            _bindToObservable({ schema: t, updater: e, data: n }) {
              const o = n.revertData;
              ih(t, e, n);
              const i = t
                .filter((t) => !gh(t))
                .filter((t) => t.observable)
                .map((o) => o.activateAttributeListener(t, e, n));
              o && o.bindings.push(i);
            }
            _revertTemplateFromNode(t, e) {
              for (const t of e.bindings) for (const e of t) e();
              if (e.text) return void (t.textContent = e.text);
              const n = t;
              for (const t in e.attributes) {
                const o = e.attributes[t];
                null === o ? n.removeAttribute(t) : n.setAttribute(t, o);
              }
              for (let t = 0; t < e.children.length; ++t)
                this._revertTemplateFromNode(n.childNodes[t], e.children[t]);
            }
          }
          class th {
            constructor(t) {
              (this.attribute = t.attribute),
                (this.observable = t.observable),
                (this.emitter = t.emitter),
                (this.callback = t.callback);
            }
            getValue(t) {
              const e = this.observable[this.attribute];
              return this.callback ? this.callback(e, t) : e;
            }
            activateAttributeListener(t, e, n) {
              const o = () => ih(t, e, n);
              return (
                this.emitter.listenTo(
                  this.observable,
                  `change:${this.attribute}`,
                  o
                ),
                () => {
                  this.emitter.stopListening(
                    this.observable,
                    `change:${this.attribute}`,
                    o
                  );
                }
              );
            }
          }
          class eh extends th {
            constructor(t) {
              super(t), (this.eventNameOrFunction = t.eventNameOrFunction);
            }
            activateDomEventListener(t, e, n) {
              const o = (t, n) => {
                (e && !n.target.matches(e)) ||
                  ("function" == typeof this.eventNameOrFunction
                    ? this.eventNameOrFunction(n)
                    : this.observable.fire(this.eventNameOrFunction, n));
              };
              return (
                this.emitter.listenTo(n.node, t, o),
                () => {
                  this.emitter.stopListening(n.node, t, o);
                }
              );
            }
          }
          class nh extends th {
            constructor(t) {
              super(t), (this.valueIfTrue = t.valueIfTrue);
            }
            getValue(t) {
              return !gh(super.getValue(t)) && (this.valueIfTrue || !0);
            }
          }
          function oh(t) {
            return (
              !!t &&
              (t.value && (t = t.value),
              Array.isArray(t) ? t.some(oh) : t instanceof th)
            );
          }
          function ih(t, e, { node: n }) {
            const o = (function (t, e) {
              return t.map((t) => (t instanceof th ? t.getValue(e) : t));
            })(t, n);
            let i;
            (i = 1 == t.length && t[0] instanceof nh ? o[0] : o.reduce(uh, "")),
              gh(i) ? e.remove() : e.set(i);
          }
          function rh(t) {
            return {
              set(e) {
                t.textContent = e;
              },
              remove() {
                t.textContent = "";
              },
            };
          }
          function sh(t, e, n) {
            return {
              set(o) {
                t.setAttributeNS(n, e, o);
              },
              remove() {
                t.removeAttributeNS(n, e);
              },
            };
          }
          function ah(t, e) {
            return {
              set(n) {
                t.style[e] = n;
              },
              remove() {
                t.style[e] = null;
              },
            };
          }
          function lh(t) {
            return lo(t, (t) => {
              if (t && (t instanceof th || fh(t) || ph(t) || kh(t))) return t;
            });
          }
          function ch(t) {
            if (
              ("string" == typeof t
                ? (t = (function (t) {
                    return { text: [t] };
                  })(t))
                : t.text &&
                  (function (t) {
                    t.text = ko(t.text);
                  })(t),
              t.on &&
                ((t.eventListeners = (function (t) {
                  for (const e in t) dh(t, e);
                  return t;
                })(t.on)),
                delete t.on),
              !t.text)
            ) {
              t.attributes &&
                (function (t) {
                  for (const e in t)
                    t[e].value && (t[e].value = ko(t[e].value)), dh(t, e);
                })(t.attributes);
              const e = [];
              if (t.children)
                if (kh(t.children)) e.push(t.children);
                else
                  for (const n of t.children)
                    fh(n) || ph(n) || Kr(n) ? e.push(n) : e.push(new Xu(n));
              t.children = e;
            }
            return t;
          }
          function dh(t, e) {
            t[e] = ko(t[e]);
          }
          function uh(t, e) {
            return gh(e) ? t : gh(t) ? e : `${t} ${e}`;
          }
          function hh(t, e) {
            for (const n in e) t[n] ? t[n].push(...e[n]) : (t[n] = e[n]);
          }
          function mh(t, e) {
            if (
              (e.attributes &&
                (t.attributes || (t.attributes = {}),
                hh(t.attributes, e.attributes)),
              e.eventListeners &&
                (t.eventListeners || (t.eventListeners = {}),
                hh(t.eventListeners, e.eventListeners)),
              e.text && t.text.push(...e.text),
              e.children && e.children.length)
            ) {
              if (t.children.length != e.children.length)
                throw new l("ui-template-extend-children-mismatch", t);
              let n = 0;
              for (const o of e.children) mh(t.children[n++], o);
            }
          }
          function gh(t) {
            return !t && 0 !== t;
          }
          function ph(t) {
            return t instanceof Ch;
          }
          function fh(t) {
            return t instanceof Xu;
          }
          function kh(t) {
            return t instanceof Ju;
          }
          function bh(t) {
            return E(t[0]) && t[0].ns;
          }
          function wh(t) {
            return "class" == t || "style" == t;
          }
          var Ah = n(6150),
            _h = { attributes: { "data-cke": !0 } };
          (_h.setAttributes = is()),
            (_h.insert = ns().bind(null, "head")),
            (_h.domAPI = ts()),
            (_h.insertStyleElement = ss());
          Jr()(Ah.Z, _h);
          Ah.Z && Ah.Z.locals && Ah.Z.locals;
          class Ch extends Ds(N) {
            constructor(t) {
              super(),
                (this.element = null),
                (this.isRendered = !1),
                (this.locale = t),
                (this.t = t && t.t),
                (this._viewCollections = new po()),
                (this._unboundChildren = this.createCollection()),
                this._viewCollections.on("add", (e, n) => {
                  (n.locale = t), (n.t = t && t.t);
                }),
                this.decorate("render");
            }
            get bindTemplate() {
              return this._bindTemplate
                ? this._bindTemplate
                : (this._bindTemplate = Xu.bind(this, this));
            }
            createCollection(t) {
              const e = new Ju(t);
              return this._viewCollections.add(e), e;
            }
            registerChild(t) {
              go(t) || (t = [t]);
              for (const e of t) this._unboundChildren.add(e);
            }
            deregisterChild(t) {
              go(t) || (t = [t]);
              for (const e of t) this._unboundChildren.remove(e);
            }
            setTemplate(t) {
              this.template = new Xu(t);
            }
            extendTemplate(t) {
              Xu.extend(this.template, t);
            }
            render() {
              if (this.isRendered)
                throw new l("ui-view-render-already-rendered", this);
              this.template &&
                ((this.element = this.template.render()),
                this.registerChild(this.template.getViews())),
                (this.isRendered = !0);
            }
            destroy() {
              this.stopListening(),
                this._viewCollections.map((t) => t.destroy()),
                this.template &&
                  this.template._revertData &&
                  this.template.revert(this.element);
            }
          }
          function vh({
            element: t,
            target: e,
            positions: n,
            limiter: o,
            fitInViewport: i,
            viewportOffsetConfig: r,
          }) {
            Et(e) && (e = e()), Et(o) && (o = o());
            const s = (function (t) {
                return t && t.parentNode
                  ? t.offsetParent === wo.document.body
                    ? null
                    : t.offsetParent
                  : null;
              })(t),
              a = new Ma(t),
              l = new Ma(e);
            let c;
            const d =
                (i &&
                  (function (t) {
                    t = Object.assign(
                      { top: 0, bottom: 0, left: 0, right: 0 },
                      t
                    );
                    const e = new Ma(wo.window);
                    return (
                      (e.top += t.top),
                      (e.height -= t.top),
                      (e.bottom -= t.bottom),
                      (e.height -= t.bottom),
                      e
                    );
                  })(r)) ||
                null,
              u = {
                targetRect: l,
                elementRect: a,
                positionedElementAncestor: s,
                viewportRect: d,
              };
            if (o || i) {
              const t = o && new Ma(o).getVisible();
              Object.assign(u, { limiterRect: t, viewportRect: d }),
                (c =
                  (function (t, e) {
                    const { elementRect: n } = e,
                      o = n.getArea(),
                      i = t.map((t) => new xh(t, e)).filter((t) => !!t.name);
                    let r = 0,
                      s = null;
                    for (const t of i) {
                      const {
                        limiterIntersectionArea: e,
                        viewportIntersectionArea: n,
                      } = t;
                      if (e === o) return t;
                      const i = n ** 2 + e ** 2;
                      i > r && ((r = i), (s = t));
                    }
                    return s;
                  })(n, u) || new xh(n[0], u));
            } else c = new xh(n[0], u);
            return c;
          }
          function yh(t) {
            const { scrollX: e, scrollY: n } = wo.window;
            return t.clone().moveBy(e, n);
          }
          class xh {
            constructor(t, e) {
              const n = t(e.targetRect, e.elementRect, e.viewportRect);
              if (!n) return;
              const { left: o, top: i, name: r, config: s } = n;
              (this.name = r),
                (this.config = s),
                (this._positioningFunctionCorrdinates = { left: o, top: i }),
                (this._options = e);
            }
            get left() {
              return this._absoluteRect.left;
            }
            get top() {
              return this._absoluteRect.top;
            }
            get limiterIntersectionArea() {
              const t = this._options.limiterRect;
              if (t) {
                const e = this._options.viewportRect;
                if (!e) return t.getIntersectionArea(this._rect);
                {
                  const n = t.getIntersection(e);
                  if (n) return n.getIntersectionArea(this._rect);
                }
              }
              return 0;
            }
            get viewportIntersectionArea() {
              const t = this._options.viewportRect;
              return t ? t.getIntersectionArea(this._rect) : 0;
            }
            get _rect() {
              return (
                this._cachedRect ||
                  (this._cachedRect = this._options.elementRect
                    .clone()
                    .moveTo(
                      this._positioningFunctionCorrdinates.left,
                      this._positioningFunctionCorrdinates.top
                    )),
                this._cachedRect
              );
            }
            get _absoluteRect() {
              return (
                this._cachedAbsoluteRect ||
                  ((this._cachedAbsoluteRect = yh(this._rect)),
                  this._options.positionedElementAncestor &&
                    (function (t, e) {
                      const n = yh(new Ma(e)),
                        o = Ia(e);
                      let i = 0,
                        r = 0;
                      (i -= n.left),
                        (r -= n.top),
                        (i += e.scrollLeft),
                        (r += e.scrollTop),
                        (i -= o.left),
                        (r -= o.top),
                        t.moveBy(i, r);
                    })(
                      this._cachedAbsoluteRect,
                      this._options.positionedElementAncestor
                    )),
                this._cachedAbsoluteRect
              );
            }
          }
          function Eh(t) {
            return (e) => e + t;
          }
          var Dh = n(8245),
            Sh = { attributes: { "data-cke": !0 } };
          (Sh.setAttributes = is()),
            (Sh.insert = ns().bind(null, "head")),
            (Sh.domAPI = ts()),
            (Sh.insertStyleElement = ss());
          Jr()(Dh.Z, Sh);
          Dh.Z && Dh.Z.locals && Dh.Z.locals;
          const Ih = Eh("px"),
            Th = wo.document.body;
          class Mh extends Ch {
            constructor(t) {
              super(t);
              const e = this.bindTemplate;
              this.set("top", 0),
                this.set("left", 0),
                this.set("position", "arrow_nw"),
                this.set("isVisible", !1),
                this.set("withArrow", !0),
                this.set("class", void 0),
                (this._pinWhenIsVisibleCallback = null),
                (this.content = this.createCollection()),
                this.setTemplate({
                  tag: "div",
                  attributes: {
                    class: [
                      "ck",
                      "ck-balloon-panel",
                      e.to("position", (t) => `ck-balloon-panel_${t}`),
                      e.if("isVisible", "ck-balloon-panel_visible"),
                      e.if("withArrow", "ck-balloon-panel_with-arrow"),
                      e.to("class"),
                    ],
                    style: { top: e.to("top", Ih), left: e.to("left", Ih) },
                  },
                  children: this.content,
                });
            }
            show() {
              this.isVisible = !0;
            }
            hide() {
              this.isVisible = !1;
            }
            attachTo(t) {
              this.show();
              const e = Mh.defaultPositions,
                n = Object.assign(
                  {},
                  {
                    element: this.element,
                    positions: [
                      e.southArrowNorth,
                      e.southArrowNorthMiddleWest,
                      e.southArrowNorthMiddleEast,
                      e.southArrowNorthWest,
                      e.southArrowNorthEast,
                      e.northArrowSouth,
                      e.northArrowSouthMiddleWest,
                      e.northArrowSouthMiddleEast,
                      e.northArrowSouthWest,
                      e.northArrowSouthEast,
                      e.viewportStickyNorth,
                    ],
                    limiter: Th,
                    fitInViewport: !0,
                  },
                  t
                ),
                o = Mh._getOptimalPosition(n),
                i = parseInt(o.left),
                r = parseInt(o.top),
                s = o.name,
                a = o.config || {},
                { withArrow: l = !0 } = a;
              (this.top = r),
                (this.left = i),
                (this.position = s),
                (this.withArrow = l);
            }
            pin(t) {
              this.unpin(),
                (this._pinWhenIsVisibleCallback = () => {
                  this.isVisible ? this._startPinning(t) : this._stopPinning();
                }),
                this._startPinning(t),
                this.listenTo(
                  this,
                  "change:isVisible",
                  this._pinWhenIsVisibleCallback
                );
            }
            unpin() {
              this._pinWhenIsVisibleCallback &&
                (this._stopPinning(),
                this.stopListening(
                  this,
                  "change:isVisible",
                  this._pinWhenIsVisibleCallback
                ),
                (this._pinWhenIsVisibleCallback = null),
                this.hide());
            }
            _startPinning(t) {
              this.attachTo(t);
              const e = Bh(t.target),
                n = t.limiter ? Bh(t.limiter) : Th;
              this.listenTo(
                wo.document,
                "scroll",
                (o, i) => {
                  const r = i.target,
                    s = e && r.contains(e),
                    a = n && r.contains(n);
                  (!s && !a && e && n) || this.attachTo(t);
                },
                { useCapture: !0 }
              ),
                this.listenTo(wo.window, "resize", () => {
                  this.attachTo(t);
                });
            }
            _stopPinning() {
              this.stopListening(wo.document, "scroll"),
                this.stopListening(wo.window, "resize");
            }
          }
          function Bh(t) {
            return co(t)
              ? t
              : Sa(t)
              ? t.commonAncestorContainer
              : "function" == typeof t
              ? Bh(t())
              : null;
          }
          function Nh(t = {}) {
            const {
              sideOffset: e = Mh.arrowSideOffset,
              heightOffset: n = Mh.arrowHeightOffset,
              stickyVerticalOffset: o = Mh.stickyVerticalOffset,
              config: i,
            } = t;
            return {
              northWestArrowSouthWest: (t, n) => ({
                top: r(t, n),
                left: t.left - e,
                name: "arrow_sw",
                ...(i && { config: i }),
              }),
              northWestArrowSouthMiddleWest: (t, n) => ({
                top: r(t, n),
                left: t.left - 0.25 * n.width - e,
                name: "arrow_smw",
                ...(i && { config: i }),
              }),
              northWestArrowSouth: (t, e) => ({
                top: r(t, e),
                left: t.left - e.width / 2,
                name: "arrow_s",
                ...(i && { config: i }),
              }),
              northWestArrowSouthMiddleEast: (t, n) => ({
                top: r(t, n),
                left: t.left - 0.75 * n.width + e,
                name: "arrow_sme",
                ...(i && { config: i }),
              }),
              northWestArrowSouthEast: (t, n) => ({
                top: r(t, n),
                left: t.left - n.width + e,
                name: "arrow_se",
                ...(i && { config: i }),
              }),
              northArrowSouthWest: (t, n) => ({
                top: r(t, n),
                left: t.left + t.width / 2 - e,
                name: "arrow_sw",
                ...(i && { config: i }),
              }),
              northArrowSouthMiddleWest: (t, n) => ({
                top: r(t, n),
                left: t.left + t.width / 2 - 0.25 * n.width - e,
                name: "arrow_smw",
                ...(i && { config: i }),
              }),
              northArrowSouth: (t, e) => ({
                top: r(t, e),
                left: t.left + t.width / 2 - e.width / 2,
                name: "arrow_s",
                ...(i && { config: i }),
              }),
              northArrowSouthMiddleEast: (t, n) => ({
                top: r(t, n),
                left: t.left + t.width / 2 - 0.75 * n.width + e,
                name: "arrow_sme",
                ...(i && { config: i }),
              }),
              northArrowSouthEast: (t, n) => ({
                top: r(t, n),
                left: t.left + t.width / 2 - n.width + e,
                name: "arrow_se",
                ...(i && { config: i }),
              }),
              northEastArrowSouthWest: (t, n) => ({
                top: r(t, n),
                left: t.right - e,
                name: "arrow_sw",
                ...(i && { config: i }),
              }),
              northEastArrowSouthMiddleWest: (t, n) => ({
                top: r(t, n),
                left: t.right - 0.25 * n.width - e,
                name: "arrow_smw",
                ...(i && { config: i }),
              }),
              northEastArrowSouth: (t, e) => ({
                top: r(t, e),
                left: t.right - e.width / 2,
                name: "arrow_s",
                ...(i && { config: i }),
              }),
              northEastArrowSouthMiddleEast: (t, n) => ({
                top: r(t, n),
                left: t.right - 0.75 * n.width + e,
                name: "arrow_sme",
                ...(i && { config: i }),
              }),
              northEastArrowSouthEast: (t, n) => ({
                top: r(t, n),
                left: t.right - n.width + e,
                name: "arrow_se",
                ...(i && { config: i }),
              }),
              southWestArrowNorthWest: (t) => ({
                top: s(t),
                left: t.left - e,
                name: "arrow_nw",
                ...(i && { config: i }),
              }),
              southWestArrowNorthMiddleWest: (t, n) => ({
                top: s(t),
                left: t.left - 0.25 * n.width - e,
                name: "arrow_nmw",
                ...(i && { config: i }),
              }),
              southWestArrowNorth: (t, e) => ({
                top: s(t),
                left: t.left - e.width / 2,
                name: "arrow_n",
                ...(i && { config: i }),
              }),
              southWestArrowNorthMiddleEast: (t, n) => ({
                top: s(t),
                left: t.left - 0.75 * n.width + e,
                name: "arrow_nme",
                ...(i && { config: i }),
              }),
              southWestArrowNorthEast: (t, n) => ({
                top: s(t),
                left: t.left - n.width + e,
                name: "arrow_ne",
                ...(i && { config: i }),
              }),
              southArrowNorthWest: (t) => ({
                top: s(t),
                left: t.left + t.width / 2 - e,
                name: "arrow_nw",
                ...(i && { config: i }),
              }),
              southArrowNorthMiddleWest: (t, n) => ({
                top: s(t),
                left: t.left + t.width / 2 - 0.25 * n.width - e,
                name: "arrow_nmw",
                ...(i && { config: i }),
              }),
              southArrowNorth: (t, e) => ({
                top: s(t),
                left: t.left + t.width / 2 - e.width / 2,
                name: "arrow_n",
                ...(i && { config: i }),
              }),
              southArrowNorthMiddleEast: (t, n) => ({
                top: s(t),
                left: t.left + t.width / 2 - 0.75 * n.width + e,
                name: "arrow_nme",
                ...(i && { config: i }),
              }),
              southArrowNorthEast: (t, n) => ({
                top: s(t),
                left: t.left + t.width / 2 - n.width + e,
                name: "arrow_ne",
                ...(i && { config: i }),
              }),
              southEastArrowNorthWest: (t) => ({
                top: s(t),
                left: t.right - e,
                name: "arrow_nw",
                ...(i && { config: i }),
              }),
              southEastArrowNorthMiddleWest: (t, n) => ({
                top: s(t),
                left: t.right - 0.25 * n.width - e,
                name: "arrow_nmw",
                ...(i && { config: i }),
              }),
              southEastArrowNorth: (t, e) => ({
                top: s(t),
                left: t.right - e.width / 2,
                name: "arrow_n",
                ...(i && { config: i }),
              }),
              southEastArrowNorthMiddleEast: (t, n) => ({
                top: s(t),
                left: t.right - 0.75 * n.width + e,
                name: "arrow_nme",
                ...(i && { config: i }),
              }),
              southEastArrowNorthEast: (t, n) => ({
                top: s(t),
                left: t.right - n.width + e,
                name: "arrow_ne",
                ...(i && { config: i }),
              }),
              westArrowEast: (t, e) => ({
                top: t.top + t.height / 2 - e.height / 2,
                left: t.left - e.width - n,
                name: "arrow_e",
                ...(i && { config: i }),
              }),
              eastArrowWest: (t, e) => ({
                top: t.top + t.height / 2 - e.height / 2,
                left: t.right + n,
                name: "arrow_w",
                ...(i && { config: i }),
              }),
              viewportStickyNorth: (t, e, n) =>
                t.getIntersection(n)
                  ? {
                      top: n.top + o,
                      left: t.left + t.width / 2 - e.width / 2,
                      name: "arrowless",
                      config: { withArrow: !1, ...i },
                    }
                  : null,
            };
            function r(t, e) {
              return t.top - e.height - n;
            }
            function s(t) {
              return t.bottom + n;
            }
          }
          (Mh.arrowSideOffset = 25),
            (Mh.arrowHeightOffset = 10),
            (Mh.stickyVerticalOffset = 20),
            (Mh._getOptimalPosition = vh),
            (Mh.defaultPositions = Nh());
          var zh = n(9948),
            Ph = { attributes: { "data-cke": !0 } };
          (Ph.setAttributes = is()),
            (Ph.insert = ns().bind(null, "head")),
            (Ph.domAPI = ts()),
            (Ph.insertStyleElement = ss());
          Jr()(zh.Z, Ph);
          zh.Z && zh.Z.locals && zh.Z.locals;
          const Lh = "ck-tooltip";
          class Rh extends Ss {
            constructor(t) {
              if ((super(), Rh._editors.add(t), Rh._instance))
                return Rh._instance;
              (Rh._instance = this),
                (this.tooltipTextView = new Ch(t.locale)),
                this.tooltipTextView.set("text", ""),
                this.tooltipTextView.setTemplate({
                  tag: "span",
                  attributes: { class: ["ck", "ck-tooltip__text"] },
                  children: [
                    { text: this.tooltipTextView.bindTemplate.to("text") },
                  ],
                }),
                (this.balloonPanelView = new Mh(t.locale)),
                (this.balloonPanelView.class = Lh),
                this.balloonPanelView.content.add(this.tooltipTextView),
                (this._resizeObserver = null),
                (this._currentElementWithTooltip = null),
                (this._currentTooltipPosition = null),
                (this._pinTooltipDebounced = Zs(this._pinTooltip, 600)),
                this.listenTo(
                  wo.document,
                  "mouseenter",
                  this._onEnterOrFocus.bind(this),
                  { useCapture: !0 }
                ),
                this.listenTo(
                  wo.document,
                  "mouseleave",
                  this._onLeaveOrBlur.bind(this),
                  { useCapture: !0 }
                ),
                this.listenTo(
                  wo.document,
                  "focus",
                  this._onEnterOrFocus.bind(this),
                  { useCapture: !0 }
                ),
                this.listenTo(
                  wo.document,
                  "blur",
                  this._onLeaveOrBlur.bind(this),
                  { useCapture: !0 }
                ),
                this.listenTo(
                  wo.document,
                  "scroll",
                  this._onScroll.bind(this),
                  { useCapture: !0 }
                ),
                (this._watchdogExcluded = !0);
            }
            destroy(t) {
              const e = t.ui.view && t.ui.view.body;
              Rh._editors.delete(t),
                this.stopListening(t.ui),
                e &&
                  e.has(this.balloonPanelView) &&
                  e.remove(this.balloonPanelView),
                Rh._editors.size ||
                  (this._unpinTooltip(),
                  this.balloonPanelView.destroy(),
                  this.stopListening(),
                  (Rh._instance = null));
            }
            static getPositioningFunctions(t) {
              const e = Rh.defaultBalloonPositions;
              return {
                s: [
                  e.southArrowNorth,
                  e.southArrowNorthEast,
                  e.southArrowNorthWest,
                ],
                n: [e.northArrowSouth],
                e: [e.eastArrowWest],
                w: [e.westArrowEast],
                sw: [e.southArrowNorthEast],
                se: [e.southArrowNorthWest],
              }[t];
            }
            _onEnterOrFocus(t, { target: e }) {
              const n = Oh(e);
              var o;
              n &&
                n !== this._currentElementWithTooltip &&
                (this._unpinTooltip(),
                this._pinTooltipDebounced(n, {
                  text: (o = n).dataset.ckeTooltipText,
                  position: o.dataset.ckeTooltipPosition || "s",
                  cssClass: o.dataset.ckeTooltipClass || "",
                }));
            }
            _onLeaveOrBlur(t, { target: e, relatedTarget: n }) {
              if ("mouseleave" === t.name) {
                if (!co(e)) return;
                if (
                  this._currentElementWithTooltip &&
                  e !== this._currentElementWithTooltip
                )
                  return;
                const t = Oh(e),
                  o = Oh(n);
                t && t !== o && this._unpinTooltip();
              } else {
                if (
                  this._currentElementWithTooltip &&
                  e !== this._currentElementWithTooltip
                )
                  return;
                this._unpinTooltip();
              }
            }
            _onScroll(t, { target: e }) {
              this._currentElementWithTooltip &&
                ((e.contains(this.balloonPanelView.element) &&
                  e.contains(this._currentElementWithTooltip)) ||
                  this._unpinTooltip());
            }
            _pinTooltip(t, { text: e, position: n, cssClass: o }) {
              const i = Ra(Rh._editors.values()).ui.view.body;
              i.has(this.balloonPanelView) || i.add(this.balloonPanelView),
                (this.tooltipTextView.text = e),
                this.balloonPanelView.pin({
                  target: t,
                  positions: Rh.getPositioningFunctions(n),
                }),
                (this._resizeObserver = new Pa(t, () => {
                  La(t) || this._unpinTooltip();
                })),
                (this.balloonPanelView.class = [Lh, o]
                  .filter((t) => t)
                  .join(" "));
              for (const t of Rh._editors)
                this.listenTo(
                  t.ui,
                  "update",
                  this._updateTooltipPosition.bind(this),
                  { priority: "low" }
                );
              (this._currentElementWithTooltip = t),
                (this._currentTooltipPosition = n);
            }
            _unpinTooltip() {
              this._pinTooltipDebounced.cancel(), this.balloonPanelView.unpin();
              for (const t of Rh._editors) this.stopListening(t.ui, "update");
              (this._currentElementWithTooltip = null),
                (this._currentTooltipPosition = null),
                this._resizeObserver && this._resizeObserver.destroy();
            }
            _updateTooltipPosition() {
              La(this._currentElementWithTooltip)
                ? this.balloonPanelView.pin({
                    target: this._currentElementWithTooltip,
                    positions: Rh.getPositioningFunctions(
                      this._currentTooltipPosition
                    ),
                  })
                : this._unpinTooltip();
            }
          }
          function Oh(t) {
            return co(t)
              ? t.closest(
                  "[data-cke-tooltip-text]:not([data-cke-tooltip-disabled])"
                )
              : null;
          }
          (Rh.defaultBalloonPositions = Nh({
            heightOffset: 5,
            sideOffset: 13,
          })),
            (Rh._editors = new Set()),
            (Rh._instance = null);
          class jh extends N {
            constructor(t) {
              super(),
                (this.editor = t),
                (this.componentFactory = new Ku(t)),
                (this.focusTracker = new Oa()),
                (this.tooltipManager = new Rh(t)),
                this.set(
                  "viewportOffset",
                  this._readViewportOffsetFromConfig()
                ),
                (this.isReady = !1),
                this.once("ready", () => {
                  this.isReady = !0;
                }),
                (this._editableElementsMap = new Map()),
                (this._focusableToolbarDefinitions = []),
                this.listenTo(t.editing.view.document, "layoutChanged", () =>
                  this.update()
                ),
                this._initFocusTracking();
            }
            get element() {
              return null;
            }
            update() {
              this.fire("update");
            }
            destroy() {
              this.stopListening(),
                this.focusTracker.destroy(),
                this.tooltipManager.destroy(this.editor);
              for (const t of this._editableElementsMap.values())
                t.ckeditorInstance = null;
              (this._editableElementsMap = new Map()),
                (this._focusableToolbarDefinitions = []);
            }
            setEditableElement(t, e) {
              this._editableElementsMap.set(t, e),
                e.ckeditorInstance || (e.ckeditorInstance = this.editor),
                this.focusTracker.add(e);
              const n = () => {
                this.editor.editing.view.getDomRoot(t) ||
                  this.editor.keystrokes.listenTo(e);
              };
              this.isReady ? n() : this.once("ready", n);
            }
            getEditableElement(t = "main") {
              return this._editableElementsMap.get(t);
            }
            getEditableElementsNames() {
              return this._editableElementsMap.keys();
            }
            addToolbar(t, e = {}) {
              t.isRendered
                ? (this.focusTracker.add(t.element),
                  this.editor.keystrokes.listenTo(t.element))
                : t.once("render", () => {
                    this.focusTracker.add(t.element),
                      this.editor.keystrokes.listenTo(t.element);
                  }),
                this._focusableToolbarDefinitions.push({
                  toolbarView: t,
                  options: e,
                });
            }
            get _editableElements() {
              return (
                console.warn(
                  "editor-ui-deprecated-editable-elements: The EditorUI#_editableElements property has been deprecated and will be removed in the near future.",
                  { editorUI: this }
                ),
                this._editableElementsMap
              );
            }
            _readViewportOffsetFromConfig() {
              const t = this.editor,
                e = t.config.get("ui.viewportOffset");
              if (e) return e;
              const n = t.config.get("toolbar.viewportTopOffset");
              return n
                ? (console.warn(
                    "editor-ui-deprecated-viewport-offset-config: The `toolbar.vieportTopOffset` configuration option is deprecated. It will be removed from future CKEditor versions. Use `ui.viewportOffset.top` instead."
                  ),
                  { top: n })
                : { top: 0 };
            }
            _initFocusTracking() {
              const t = this.editor,
                e = t.editing.view;
              let n, o;
              t.keystrokes.set("Alt+F10", (t, i) => {
                const r = this.focusTracker.focusedElement;
                Array.from(this._editableElementsMap.values()).includes(r) &&
                  !Array.from(e.domRoots.values()).includes(r) &&
                  (n = r);
                const s = this._getCurrentFocusedToolbarDefinition();
                (s && o) ||
                  (o = this._getFocusableCandidateToolbarDefinitions());
                for (let t = 0; t < o.length; t++) {
                  const t = o.shift();
                  if (
                    (o.push(t),
                    t !== s && this._focusFocusableCandidateToolbar(t))
                  ) {
                    s && s.options.afterBlur && s.options.afterBlur();
                    break;
                  }
                }
                i();
              }),
                t.keystrokes.set("Esc", (e, o) => {
                  const i = this._getCurrentFocusedToolbarDefinition();
                  i &&
                    (n ? (n.focus(), (n = null)) : t.editing.view.focus(),
                    i.options.afterBlur && i.options.afterBlur(),
                    o());
                });
            }
            _getFocusableCandidateToolbarDefinitions() {
              const t = [];
              for (const e of this._focusableToolbarDefinitions) {
                const { toolbarView: n, options: o } = e;
                (La(n.element) || o.beforeFocus) && t.push(e);
              }
              return t.sort((t, e) => Vh(t) - Vh(e)), t;
            }
            _getCurrentFocusedToolbarDefinition() {
              for (const t of this._focusableToolbarDefinitions)
                if (
                  t.toolbarView.element &&
                  t.toolbarView.element.contains(
                    this.focusTracker.focusedElement
                  )
                )
                  return t;
              return null;
            }
            _focusFocusableCandidateToolbar(t) {
              const {
                toolbarView: e,
                options: { beforeFocus: n },
              } = t;
              return n && n(), !!La(e.element) && (e.focus(), !0);
            }
          }
          function Vh(t) {
            const { toolbarView: e, options: n } = t;
            let o = 10;
            return La(e.element) && o--, n.isContextual && o--, o;
          }
          function Fh(t) {
            return class extends t {
              setData(t) {
                this.data.set(t);
              }
              getData(t) {
                return this.data.get(t);
              }
            };
          }
          {
            const t = Fh(Object);
            (Fh.setData = t.prototype.setData),
              (Fh.getData = t.prototype.getData);
          }
          function Hh(t, e) {
            t instanceof HTMLTextAreaElement && (t.value = e),
              (t.innerHTML = e);
          }
          function Uh(t) {
            return class extends t {
              updateSourceElement(t = this.data.get()) {
                if (!this.sourceElement)
                  throw new l("editor-missing-sourceelement", this);
                const e = this.config.get("updateSourceElementOnDestroy"),
                  n = this.sourceElement instanceof HTMLTextAreaElement;
                Hh(this.sourceElement, e || n ? t : "");
              }
            };
          }
          Uh.updateSourceElement = Uh(Object).prototype.updateSourceElement;
          class Wh extends xo {
            static get pluginName() {
              return "PendingActions";
            }
            init() {
              this.set("hasAny", !1),
                (this._actions = new po({ idProperty: "_id" })),
                this._actions.delegate("add", "remove").to(this);
            }
            add(t) {
              if ("string" != typeof t)
                throw new l("pendingactions-add-invalid-message", this);
              const e = new N();
              return (
                e.set("message", t), this._actions.add(e), (this.hasAny = !0), e
              );
            }
            remove(t) {
              this._actions.remove(t), (this.hasAny = !!this._actions.length);
            }
            get first() {
              return this._actions.get(0);
            }
            [Symbol.iterator]() {
              return this._actions[Symbol.iterator]();
            }
          }
          const $h = {
            bold: '<svg viewBox="0 0 20 20" xmlns="http://www.w3.org/2000/svg"><path d="M10.187 17H5.773c-.637 0-1.092-.138-1.364-.415-.273-.277-.409-.718-.409-1.323V4.738c0-.617.14-1.062.419-1.332.279-.27.73-.406 1.354-.406h4.68c.69 0 1.288.041 1.793.124.506.083.96.242 1.36.478.341.197.644.447.906.75a3.262 3.262 0 0 1 .808 2.162c0 1.401-.722 2.426-2.167 3.075C15.05 10.175 16 11.315 16 13.01a3.756 3.756 0 0 1-2.296 3.504 6.1 6.1 0 0 1-1.517.377c-.571.073-1.238.11-2 .11zm-.217-6.217H7v4.087h3.069c1.977 0 2.965-.69 2.965-2.072 0-.707-.256-1.22-.768-1.537-.512-.319-1.277-.478-2.296-.478zM7 5.13v3.619h2.606c.729 0 1.292-.067 1.69-.2a1.6 1.6 0 0 0 .91-.765c.165-.267.247-.566.247-.897 0-.707-.26-1.176-.778-1.409-.519-.232-1.31-.348-2.375-.348H7z"/></svg>',
            cancel:
              '<svg viewBox="0 0 20 20" xmlns="http://www.w3.org/2000/svg"><path d="m11.591 10.177 4.243 4.242a1 1 0 0 1-1.415 1.415l-4.242-4.243-4.243 4.243a1 1 0 0 1-1.414-1.415l4.243-4.242L4.52 5.934A1 1 0 0 1 5.934 4.52l4.243 4.243 4.242-4.243a1 1 0 1 1 1.415 1.414l-4.243 4.243z"/></svg>',
            caption:
              '<svg viewBox="0 0 20 20" xmlns="http://www.w3.org/2000/svg"><path d="M2 16h9a1 1 0 0 1 0 2H2a1 1 0 0 1 0-2z"/><path d="M17 1a2 2 0 0 1 2 2v9a2 2 0 0 1-2 2H3a2 2 0 0 1-2-2V3a2 2 0 0 1 2-2h14zm0 1.5H3a.5.5 0 0 0-.492.41L2.5 3v9a.5.5 0 0 0 .41.492L3 12.5h14a.5.5 0 0 0 .492-.41L17.5 12V3a.5.5 0 0 0-.41-.492L17 2.5z" fill-opacity=".6"/></svg>',
            check:
              '<svg viewBox="0 0 20 20" xmlns="http://www.w3.org/2000/svg"><path d="M6.972 16.615a.997.997 0 0 1-.744-.292l-4.596-4.596a1 1 0 1 1 1.414-1.414l3.926 3.926 9.937-9.937a1 1 0 0 1 1.414 1.415L7.717 16.323a.997.997 0 0 1-.745.292z"/></svg>',
            cog: '<svg viewBox="0 0 20 20" xmlns="http://www.w3.org/2000/svg"><path d="m11.333 2 .19 2.263a5.899 5.899 0 0 1 1.458.604L14.714 3.4 16.6 5.286l-1.467 1.733c.263.452.468.942.605 1.46L18 8.666v2.666l-2.263.19a5.899 5.899 0 0 1-.604 1.458l1.467 1.733-1.886 1.886-1.733-1.467a5.899 5.899 0 0 1-1.46.605L11.334 18H8.667l-.19-2.263a5.899 5.899 0 0 1-1.458-.604L5.286 16.6 3.4 14.714l1.467-1.733a5.899 5.899 0 0 1-.604-1.458L2 11.333V8.667l2.262-.189a5.899 5.899 0 0 1 .605-1.459L3.4 5.286 5.286 3.4l1.733 1.467a5.899 5.899 0 0 1 1.46-.605L8.666 2h2.666zM10 6.267a3.733 3.733 0 1 0 0 7.466 3.733 3.733 0 0 0 0-7.466z"/></svg>',
            eraser:
              '<svg viewBox="0 0 20 20" xmlns="http://www.w3.org/2000/svg"><path d="m8.636 9.531-2.758 3.94a.5.5 0 0 0 .122.696l3.224 2.284h1.314l2.636-3.736L8.636 9.53zm.288 8.451L5.14 15.396a2 2 0 0 1-.491-2.786l6.673-9.53a2 2 0 0 1 2.785-.49l3.742 2.62a2 2 0 0 1 .491 2.785l-7.269 10.053-2.147-.066z"/><path d="M4 18h5.523v-1H4zm-2 0h1v-1H2z"/></svg>',
            image:
              '<svg viewBox="0 0 20 20" xmlns="http://www.w3.org/2000/svg"><path d="M6.91 10.54c.26-.23.64-.21.88.03l3.36 3.14 2.23-2.06a.64.64 0 0 1 .87 0l2.52 2.97V4.5H3.2v10.12l3.71-4.08zm10.27-7.51c.6 0 1.09.47 1.09 1.05v11.84c0 .59-.49 1.06-1.09 1.06H2.79c-.6 0-1.09-.47-1.09-1.06V4.08c0-.58.49-1.05 1.1-1.05h14.38zm-5.22 5.56a1.96 1.96 0 1 1 3.4-1.96 1.96 1.96 0 0 1-3.4 1.96z"/></svg>',
            lowVision:
              '<svg viewBox="0 0 20 20" xmlns="http://www.w3.org/2000/svg"><path d="M5.085 6.22 2.943 4.078a.75.75 0 1 1 1.06-1.06l2.592 2.59A11.094 11.094 0 0 1 10 5.068c4.738 0 8.578 3.101 8.578 5.083 0 1.197-1.401 2.803-3.555 3.887l1.714 1.713a.75.75 0 0 1-.09 1.138.488.488 0 0 1-.15.084.75.75 0 0 1-.821-.16L6.17 7.304c-.258.11-.51.233-.757.365l6.239 6.24-.006.005.78.78c-.388.094-.78.166-1.174.215l-1.11-1.11h.011L4.55 8.197a7.2 7.2 0 0 0-.665.514l-.112.098 4.897 4.897-.005.006 1.276 1.276a10.164 10.164 0 0 1-1.477-.117l-.479-.479-.009.009-4.863-4.863-.022.031a2.563 2.563 0 0 0-.124.2c-.043.077-.08.158-.108.241a.534.534 0 0 0-.028.133.29.29 0 0 0 .008.072.927.927 0 0 0 .082.226c.067.133.145.26.234.379l3.242 3.365.025.01.59.623c-3.265-.918-5.59-3.155-5.59-4.668 0-1.194 1.448-2.838 3.663-3.93zm7.07.531a4.632 4.632 0 0 1 1.108 5.992l.345.344.046-.018a9.313 9.313 0 0 0 2-1.112c.256-.187.5-.392.727-.613.137-.134.27-.277.392-.431.072-.091.141-.185.203-.286.057-.093.107-.19.148-.292a.72.72 0 0 0 .036-.12.29.29 0 0 0 .008-.072.492.492 0 0 0-.028-.133.999.999 0 0 0-.036-.096 2.165 2.165 0 0 0-.071-.145 2.917 2.917 0 0 0-.125-.2 3.592 3.592 0 0 0-.263-.335 5.444 5.444 0 0 0-.53-.523 7.955 7.955 0 0 0-1.054-.768 9.766 9.766 0 0 0-1.879-.891c-.337-.118-.68-.219-1.027-.301zm-2.85.21-.069.002a.508.508 0 0 0-.254.097.496.496 0 0 0-.104.679.498.498 0 0 0 .326.199l.045.005c.091.003.181.003.272.012a2.45 2.45 0 0 1 2.017 1.513c.024.061.043.125.069.185a.494.494 0 0 0 .45.287h.008a.496.496 0 0 0 .35-.158.482.482 0 0 0 .13-.335.638.638 0 0 0-.048-.219 3.379 3.379 0 0 0-.36-.723 3.438 3.438 0 0 0-2.791-1.543l-.028-.001h-.013z"/></svg>',
            importExport:
              '<svg viewBox="0 0 20 20" xmlns="http://www.w3.org/2000/svg"><g clip-path="url(#a)"><path clip-rule="evenodd" d="M19 4.5 14 0H3v12.673l.868-1.041c.185-.222.4-.402.632-.54V1.5h8v5h5v7.626a2.24 2.24 0 0 1 1.5.822V4.5ZM14 5V2l3.3 3H14Zm-3.692 12.5c.062.105.133.206.213.303L11.52 19H8v-.876a2.243 2.243 0 0 0 1.82-.624h.488Zm7.518-.657a.75.75 0 0 0-1.152-.96L15.5 17.29V12H14v5.29l-1.174-1.408a.75.75 0 0 0-1.152.96l2.346 2.816a.95.95 0 0 0 1.46 0l2.346-2.815Zm-15.056-.38a.75.75 0 0 1-.096-1.056l2.346-2.815a.95.95 0 0 1 1.46 0l2.346 2.815a.75.75 0 1 1-1.152.96L6.5 14.96V20H5v-5.04l-1.174 1.408a.75.75 0 0 1-1.056.096Z"/></g><defs><clipPath id="a"><path d="M0 0h20v20H0z"/></clipPath></defs></svg>',
            paragraph:
              '<svg viewBox="0 0 20 20" xmlns="http://www.w3.org/2000/svg"><path d="M10.5 5.5H7v5h3.5a2.5 2.5 0 1 0 0-5zM5 3h6.5v.025a5 5 0 0 1 0 9.95V13H7v4a1 1 0 0 1-1 1H5a1 1 0 0 1-1-1V4a1 1 0 0 1 1-1z"/></svg>',
            plus: '<svg viewBox="0 0 20 20" xmlns="http://www.w3.org/2000/svg"><path d="M10 2a1 1 0 0 0-1 1v6H3a1 1 0 1 0 0 2h6v6a1 1 0 1 0 2 0v-6h6a1 1 0 1 0 0-2h-6V3a1 1 0 0 0-1-1Z"/></svg>',
            text: '<svg viewBox="0 0 20 20" xmlns="http://www.w3.org/2000/svg"><g clip-path="url(#a)"><path d="M9.816 11.5 7.038 4.785 4.261 11.5h5.555Zm.62 1.5H3.641l-1.666 4.028H.312l5.789-14h1.875l5.789 14h-1.663L10.436 13Z"/><path clip-rule="evenodd" d="m12.09 17-.534-1.292.848-1.971.545 1.319L12.113 17h-.023Zm1.142-5.187.545 1.319L15.5 9.13l1.858 4.316h-3.45l.398.965h3.467L18.887 17H20l-3.873-9h-1.254l-1.641 3.813Z"/></g><defs><clipPath id="a"><path d="M0 0h20v20H0z"/></clipPath></defs></svg>',
            alignBottom:
              '<svg viewBox="0 0 20 20" xmlns="http://www.w3.org/2000/svg"><path d="m9.239 13.938-2.88-1.663a.75.75 0 0 1 .75-1.3L9 12.067V4.75a.75.75 0 1 1 1.5 0v7.318l1.89-1.093a.75.75 0 0 1 .75 1.3l-2.879 1.663a.752.752 0 0 1-.511.187.752.752 0 0 1-.511-.187zM4.25 17a.75.75 0 1 1 0-1.5h10.5a.75.75 0 0 1 0 1.5H4.25z"/></svg>',
            alignMiddle:
              '<svg viewBox="0 0 20 20" xmlns="http://www.w3.org/2000/svg"><path d="M9.75 11.875a.752.752 0 0 1 .508.184l2.883 1.666a.75.75 0 0 1-.659 1.344l-.091-.044-1.892-1.093.001 4.318a.75.75 0 1 1-1.5 0v-4.317l-1.89 1.092a.75.75 0 0 1-.75-1.3l2.879-1.663a.752.752 0 0 1 .51-.187zM15.25 9a.75.75 0 1 1 0 1.5H4.75a.75.75 0 1 1 0-1.5h10.5zM9.75.375a.75.75 0 0 1 .75.75v4.318l1.89-1.093.092-.045a.75.75 0 0 1 .659 1.344l-2.883 1.667a.752.752 0 0 1-.508.184.752.752 0 0 1-.511-.187L6.359 5.65a.75.75 0 0 1 .75-1.299L9 5.442V1.125a.75.75 0 0 1 .75-.75z"/></svg>',
            alignTop:
              '<svg viewBox="0 0 20 20" xmlns="http://www.w3.org/2000/svg"><path d="m10.261 7.062 2.88 1.663a.75.75 0 0 1-.75 1.3L10.5 8.933v7.317a.75.75 0 1 1-1.5 0V8.932l-1.89 1.093a.75.75 0 0 1-.75-1.3l2.879-1.663a.752.752 0 0 1 .511-.187.752.752 0 0 1 .511.187zM15.25 4a.75.75 0 1 1 0 1.5H4.75a.75.75 0 0 1 0-1.5h10.5z"/></svg>',
            alignLeft:
              '<svg viewBox="0 0 20 20" xmlns="http://www.w3.org/2000/svg"><path d="M2 3.75c0 .414.336.75.75.75h14.5a.75.75 0 1 0 0-1.5H2.75a.75.75 0 0 0-.75.75zm0 8c0 .414.336.75.75.75h14.5a.75.75 0 1 0 0-1.5H2.75a.75.75 0 0 0-.75.75zm0 4c0 .414.336.75.75.75h9.929a.75.75 0 1 0 0-1.5H2.75a.75.75 0 0 0-.75.75zm0-8c0 .414.336.75.75.75h9.929a.75.75 0 1 0 0-1.5H2.75a.75.75 0 0 0-.75.75z"/></svg>',
            alignCenter:
              '<svg viewBox="0 0 20 20" xmlns="http://www.w3.org/2000/svg"><path d="M2 3.75c0 .414.336.75.75.75h14.5a.75.75 0 1 0 0-1.5H2.75a.75.75 0 0 0-.75.75zm0 8c0 .414.336.75.75.75h14.5a.75.75 0 1 0 0-1.5H2.75a.75.75 0 0 0-.75.75zm2.286 4c0 .414.336.75.75.75h9.928a.75.75 0 1 0 0-1.5H5.036a.75.75 0 0 0-.75.75zm0-8c0 .414.336.75.75.75h9.928a.75.75 0 1 0 0-1.5H5.036a.75.75 0 0 0-.75.75z"/></svg>',
            alignRight:
              '<svg viewBox="0 0 20 20" xmlns="http://www.w3.org/2000/svg"><path d="M18 3.75a.75.75 0 0 1-.75.75H2.75a.75.75 0 1 1 0-1.5h14.5a.75.75 0 0 1 .75.75zm0 8a.75.75 0 0 1-.75.75H2.75a.75.75 0 1 1 0-1.5h14.5a.75.75 0 0 1 .75.75zm0 4a.75.75 0 0 1-.75.75H7.321a.75.75 0 1 1 0-1.5h9.929a.75.75 0 0 1 .75.75zm0-8a.75.75 0 0 1-.75.75H7.321a.75.75 0 1 1 0-1.5h9.929a.75.75 0 0 1 .75.75z"/></svg>',
            alignJustify:
              '<svg viewBox="0 0 20 20" xmlns="http://www.w3.org/2000/svg"><path d="M2 3.75c0 .414.336.75.75.75h14.5a.75.75 0 1 0 0-1.5H2.75a.75.75 0 0 0-.75.75zm0 8c0 .414.336.75.75.75h14.5a.75.75 0 1 0 0-1.5H2.75a.75.75 0 0 0-.75.75zm0 4c0 .414.336.75.75.75h9.929a.75.75 0 1 0 0-1.5H2.75a.75.75 0 0 0-.75.75zm0-8c0 .414.336.75.75.75h14.5a.75.75 0 1 0 0-1.5H2.75a.75.75 0 0 0-.75.75z"/></svg>',
            objectLeft:
              '<svg viewBox="0 0 20 20" xmlns="http://www.w3.org/2000/svg"><path opacity=".5" d="M2 3h16v1.5H2zm11.5 9H18v1.5h-4.5zm0-3H18v1.5h-4.5zm0-3H18v1.5h-4.5zM2 15h16v1.5H2z"/><path d="M12.003 7v5.5a1 1 0 0 1-1 1H2.996a1 1 0 0 1-1-1V7a1 1 0 0 1 1-1h8.007a1 1 0 0 1 1 1zm-1.506.5H3.5V12h6.997V7.5z"/></svg>',
            objectCenter:
              '<svg viewBox="0 0 20 20" xmlns="http://www.w3.org/2000/svg"><path opacity=".5" d="M2 3h16v1.5H2zm0 12h16v1.5H2z"/><path d="M15.003 7v5.5a1 1 0 0 1-1 1H5.996a1 1 0 0 1-1-1V7a1 1 0 0 1 1-1h8.007a1 1 0 0 1 1 1zm-1.506.5H6.5V12h6.997V7.5z"/></svg>',
            objectRight:
              '<svg viewBox="0 0 20 20" xmlns="http://www.w3.org/2000/svg"><path opacity=".5" d="M2 3h16v1.5H2zm0 12h16v1.5H2zm0-9h5v1.5H2zm0 3h5v1.5H2zm0 3h5v1.5H2z"/><path d="M18.003 7v5.5a1 1 0 0 1-1 1H8.996a1 1 0 0 1-1-1V7a1 1 0 0 1 1-1h8.007a1 1 0 0 1 1 1zm-1.506.5H9.5V12h6.997V7.5z"/></svg>',
            objectFullWidth:
              '<svg viewBox="0 0 20 20" xmlns="http://www.w3.org/2000/svg"><path opacity=".5" d="M2 3h16v1.5H2zm0 12h16v1.5H2z"/><path d="M18 7v5.5a1 1 0 0 1-1 1H3a1 1 0 0 1-1-1V7a1 1 0 0 1 1-1h14a1 1 0 0 1 1 1zm-1.505.5H3.504V12h12.991V7.5z"/></svg>',
            objectInline:
              '<svg viewBox="0 0 20 20" xmlns="http://www.w3.org/2000/svg"><path opacity=".5" d="M2 3h16v1.5H2zm11.5 9H18v1.5h-4.5zM2 15h16v1.5H2z"/><path d="M12.003 7v5.5a1 1 0 0 1-1 1H2.996a1 1 0 0 1-1-1V7a1 1 0 0 1 1-1h8.007a1 1 0 0 1 1 1zm-1.506.5H3.5V12h6.997V7.5z"/></svg>',
            objectBlockLeft:
              '<svg viewBox="0 0 20 20" xmlns="http://www.w3.org/2000/svg"><path opacity=".5" d="M2 3h16v1.5H2zm0 12h16v1.5H2z"/><path d="M12.003 7v5.5a1 1 0 0 1-1 1H2.996a1 1 0 0 1-1-1V7a1 1 0 0 1 1-1h8.007a1 1 0 0 1 1 1zm-1.506.5H3.5V12h6.997V7.5z"/></svg>',
            objectBlockRight:
              '<svg viewBox="0 0 20 20" xmlns="http://www.w3.org/2000/svg"><path opacity=".5" d="M2 3h16v1.5H2zm0 12h16v1.5H2z"/><path d="M18.003 7v5.5a1 1 0 0 1-1 1H8.996a1 1 0 0 1-1-1V7a1 1 0 0 1 1-1h8.007a1 1 0 0 1 1 1zm-1.506.5H9.5V12h6.997V7.5z"/></svg>',
            objectSizeFull:
              '<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 20 20"><path d="M2.5 17v1h-1v-1h1zm2 0v1h-1v-1h1zm2 0v1h-1v-1h1zm2 0v1h-1v-1h1zm2 0v1h-1v-1h1zm2 0v1h-1v-1h1zm2 0v1h-1v-1h1zm2 0v1h-1v-1h1zm2 0v1h-1v-1h1zM1 15.5v1H0v-1h1zm19 0v1h-1v-1h1zm-19-2v1H0v-1h1zm19 0v1h-1v-1h1zm-19-2v1H0v-1h1zm19 0v1h-1v-1h1zm-19-2v1H0v-1h1zm19 0v1h-1v-1h1zm-19-2v1H0v-1h1zm19 0v1h-1v-1h1zm-19-2v1H0v-1h1zm19 0v1h-1v-1h1zm0-2v1h-1v-1h1zm-19 0v1H0v-1h1zM14.5 2v1h-1V2h1zm2 0v1h-1V2h1zm2 0v1h-1V2h1zm-8 0v1h-1V2h1zm-2 0v1h-1V2h1zm-2 0v1h-1V2h1zm-2 0v1h-1V2h1zm8 0v1h-1V2h1zm-10 0v1h-1V2h1z"/><path d="M18.095 2H1.905C.853 2 0 2.895 0 4v12c0 1.105.853 2 1.905 2h16.19C19.147 18 20 17.105 20 16V4c0-1.105-.853-2-1.905-2zm0 1.5c.263 0 .476.224.476.5v12c0 .276-.213.5-.476.5H1.905a.489.489 0 0 1-.476-.5V4c0-.276.213-.5.476-.5h16.19z"/></svg>',
            objectSizeLarge:
              '<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 20 20"><path d="M2.5 17v1h-1v-1h1zm2 0v1h-1v-1h1zm2 0v1h-1v-1h1zm2 0v1h-1v-1h1zm2 0v1h-1v-1h1zm2 0v1h-1v-1h1zm2 0v1h-1v-1h1zm2 0v1h-1v-1h1zm2 0v1h-1v-1h1zM1 15.5v1H0v-1h1zm19 0v1h-1v-1h1zm-19-2v1H0v-1h1zm19 0v1h-1v-1h1zm-19-2v1H0v-1h1zm19 0v1h-1v-1h1zm-19-2v1H0v-1h1zm19 0v1h-1v-1h1zm-19-2v1H0v-1h1zm19 0v1h-1v-1h1zm-19-2v1H0v-1h1zm19 0v1h-1v-1h1zm0-2v1h-1v-1h1zm-19 0v1H0v-1h1zM14.5 2v1h-1V2h1zm2 0v1h-1V2h1zm2 0v1h-1V2h1zm-8 0v1h-1V2h1zm-2 0v1h-1V2h1zm-2 0v1h-1V2h1zm-2 0v1h-1V2h1zm8 0v1h-1V2h1zm-10 0v1h-1V2h1z"/><path d="M13 6H2a2 2 0 0 0-2 2v8a2 2 0 0 0 2 2h11a2 2 0 0 0 2-2V8a2 2 0 0 0-2-2zm0 1.5a.5.5 0 0 1 .5.5v8a.5.5 0 0 1-.5.5H2a.5.5 0 0 1-.5-.5V8a.5.5 0 0 1 .5-.5h11z"/></svg>',
            objectSizeSmall:
              '<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 20 20"><path d="M2.5 17v1h-1v-1h1zm2 0v1h-1v-1h1zm2 0v1h-1v-1h1zm2 0v1h-1v-1h1zm2 0v1h-1v-1h1zm2 0v1h-1v-1h1zm2 0v1h-1v-1h1zm2 0v1h-1v-1h1zm2 0v1h-1v-1h1zM1 15.5v1H0v-1h1zm19 0v1h-1v-1h1zm-19-2v1H0v-1h1zm19 0v1h-1v-1h1zm-19-2v1H0v-1h1zm19 0v1h-1v-1h1zm-19-2v1H0v-1h1zm19 0v1h-1v-1h1zm-19-2v1H0v-1h1zm19 0v1h-1v-1h1zm-19-2v1H0v-1h1zm19 0v1h-1v-1h1zm0-2v1h-1v-1h1zm-19 0v1H0v-1h1zM14.5 2v1h-1V2h1zm2 0v1h-1V2h1zm2 0v1h-1V2h1zm-8 0v1h-1V2h1zm-2 0v1h-1V2h1zm-2 0v1h-1V2h1zm-2 0v1h-1V2h1zm8 0v1h-1V2h1zm-10 0v1h-1V2h1z"/><path d="M7 10H2a2 2 0 0 0-2 2v4a2 2 0 0 0 2 2h5a2 2 0 0 0 2-2v-4a2 2 0 0 0-2-2zm0 1.5a.5.5 0 0 1 .5.5v4a.5.5 0 0 1-.5.5H2a.5.5 0 0 1-.5-.5v-4a.5.5 0 0 1 .5-.5h5z"/></svg>',
            objectSizeMedium:
              '<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 20 20"><path d="M2.5 17v1h-1v-1h1zm2 0v1h-1v-1h1zm2 0v1h-1v-1h1zm2 0v1h-1v-1h1zm2 0v1h-1v-1h1zm2 0v1h-1v-1h1zm2 0v1h-1v-1h1zm2 0v1h-1v-1h1zm2 0v1h-1v-1h1zM1 15.5v1H0v-1h1zm19 0v1h-1v-1h1zm-19-2v1H0v-1h1zm19 0v1h-1v-1h1zm-19-2v1H0v-1h1zm19 0v1h-1v-1h1zm-19-2v1H0v-1h1zm19 0v1h-1v-1h1zm-19-2v1H0v-1h1zm19 0v1h-1v-1h1zm-19-2v1H0v-1h1zm19 0v1h-1v-1h1zm0-2v1h-1v-1h1zm-19 0v1H0v-1h1zM14.5 2v1h-1V2h1zm2 0v1h-1V2h1zm2 0v1h-1V2h1zm-8 0v1h-1V2h1zm-2 0v1h-1V2h1zm-2 0v1h-1V2h1zm-2 0v1h-1V2h1zm8 0v1h-1V2h1zm-10 0v1h-1V2h1z"/><path d="M10 8H2a2 2 0 0 0-2 2v6a2 2 0 0 0 2 2h8a2 2 0 0 0 2-2v-6a2 2 0 0 0-2-2zm0 1.5a.5.5 0 0 1 .5.5v6a.5.5 0 0 1-.5.5H2a.5.5 0 0 1-.5-.5v-6a.5.5 0 0 1 .5-.5h8z"/></svg>',
            pencil:
              '<svg viewBox="0 0 20 20" xmlns="http://www.w3.org/2000/svg"><path d="m7.3 17.37-.061.088a1.518 1.518 0 0 1-.934.535l-4.178.663-.806-4.153a1.495 1.495 0 0 1 .187-1.058l.056-.086L8.77 2.639c.958-1.351 2.803-1.076 4.296-.03 1.497 1.047 2.387 2.693 1.433 4.055L7.3 17.37zM9.14 4.728l-5.545 8.346 3.277 2.294 5.544-8.346L9.14 4.728zM6.07 16.512l-3.276-2.295.53 2.73 2.746-.435zM9.994 3.506 13.271 5.8c.316-.452-.16-1.333-1.065-1.966-.905-.634-1.895-.78-2.212-.328zM8 18.5 9.375 17H19v1.5H8z"/></svg>',
            pilcrow:
              '<svg viewBox="0 0 20 20" xmlns="http://www.w3.org/2000/svg"><path d="M6.999 2H15a1 1 0 0 1 0 2h-1.004v13a1 1 0 1 1-2 0V4H8.999v13a1 1 0 1 1-2 0v-7A4 4 0 0 1 3 6a4 4 0 0 1 3.999-4z"/></svg>',
            quote:
              '<svg viewBox="0 0 20 20" xmlns="http://www.w3.org/2000/svg"><path d="M3 10.423a6.5 6.5 0 0 1 6.056-6.408l.038.67C6.448 5.423 5.354 7.663 5.22 10H9c.552 0 .5.432.5.986v4.511c0 .554-.448.503-1 .503h-5c-.552 0-.5-.449-.5-1.003v-4.574zm8 0a6.5 6.5 0 0 1 6.056-6.408l.038.67c-2.646.739-3.74 2.979-3.873 5.315H17c.552 0 .5.432.5.986v4.511c0 .554-.448.503-1 .503h-5c-.552 0-.5-.449-.5-1.003v-4.574z"/></svg>',
            threeVerticalDots:
              '<svg viewBox="0 0 20 20" xmlns="http://www.w3.org/2000/svg"><circle cx="9.5" cy="4.5" r="1.5"/><circle cx="9.5" cy="10.5" r="1.5"/><circle cx="9.5" cy="16.5" r="1.5"/></svg>',
          };
          function qh({
            emitter: t,
            activator: e,
            callback: n,
            contextElements: o,
          }) {
            t.listenTo(document, "mousedown", (t, i) => {
              if (!e()) return;
              const r =
                "function" == typeof i.composedPath ? i.composedPath() : [];
              for (const t of o)
                if (t.contains(i.target) || r.includes(t)) return;
              n();
            });
          }
          function Gh(t) {
            const e = t;
            e.set("_isCssTransitionsDisabled", !1),
              (e.disableCssTransitions = () => {
                e._isCssTransitionsDisabled = !0;
              }),
              (e.enableCssTransitions = () => {
                e._isCssTransitionsDisabled = !1;
              }),
              e.extendTemplate({
                attributes: {
                  class: [
                    e.bindTemplate.if(
                      "_isCssTransitionsDisabled",
                      "ck-transitions-disabled"
                    ),
                  ],
                },
              });
          }
          function Zh({ view: t }) {
            t.listenTo(
              t.element,
              "submit",
              (e, n) => {
                n.preventDefault(), t.fire("submit");
              },
              { useCapture: !0 }
            );
          }
          function Yh({
            keystrokeHandler: t,
            focusTracker: e,
            gridItems: n,
            numberOfColumns: o,
          }) {
            const i = "number" == typeof o ? () => o : o;
            function r(t) {
              return (o) => {
                const i = n.find((t) => t.element === e.focusedElement),
                  r = n.getIndex(i),
                  s = t(r, n);
                n.get(s).focus(), o.stopPropagation(), o.preventDefault();
              };
            }
            t.set(
              "arrowright",
              r((t, e) => (t === e.length - 1 ? 0 : t + 1))
            ),
              t.set(
                "arrowleft",
                r((t, e) => (0 === t ? e.length - 1 : t - 1))
              ),
              t.set(
                "arrowup",
                r((t, e) => {
                  let n = t - i();
                  return (
                    n < 0 &&
                      ((n = t + i() * Math.floor(e.length / i())),
                      n > e.length - 1 && (n -= i())),
                    n
                  );
                })
              ),
              t.set(
                "arrowdown",
                r((t, e) => {
                  let n = t + i();
                  return n > e.length - 1 && (n = t % i()), n;
                })
              );
          }
          class Kh extends Ju {
            constructor(t, e = []) {
              super(e), (this.locale = t);
            }
            attachToDom() {
              this._bodyCollectionContainer = new Xu({
                tag: "div",
                attributes: {
                  class: [
                    "ck",
                    "ck-reset_all",
                    "ck-body",
                    "ck-rounded-corners",
                  ],
                  dir: this.locale.uiLanguageDirection,
                },
                children: this,
              }).render();
              let t = document.querySelector(".ck-body-wrapper");
              t ||
                ((t = Da(document, "div", { class: "ck-body-wrapper" })),
                document.body.appendChild(t)),
                t.appendChild(this._bodyCollectionContainer);
            }
            detachFromDom() {
              super.destroy(),
                this._bodyCollectionContainer &&
                  this._bodyCollectionContainer.remove();
              const t = document.querySelector(".ck-body-wrapper");
              t && 0 == t.childElementCount && t.remove();
            }
          }
          var Qh = n(1174),
            Jh = { attributes: { "data-cke": !0 } };
          (Jh.setAttributes = is()),
            (Jh.insert = ns().bind(null, "head")),
            (Jh.domAPI = ts()),
            (Jh.insertStyleElement = ss());
          Jr()(Qh.Z, Jh);
          Qh.Z && Qh.Z.locals && Qh.Z.locals;
          class Xh extends Ch {
            constructor() {
              super();
              const t = this.bindTemplate;
              this.set("content", ""),
                this.set("viewBox", "0 0 20 20"),
                this.set("fillColor", ""),
                this.set("isColorInherited", !0),
                this.setTemplate({
                  tag: "svg",
                  ns: "http://www.w3.org/2000/svg",
                  attributes: {
                    class: [
                      "ck",
                      "ck-icon",
                      "ck-reset_all-excluded",
                      t.if("isColorInherited", "ck-icon_inherit-color"),
                    ],
                    viewBox: t.to("viewBox"),
                  },
                });
            }
            render() {
              super.render(),
                this._updateXMLContent(),
                this._colorFillPaths(),
                this.on("change:content", () => {
                  this._updateXMLContent(), this._colorFillPaths();
                }),
                this.on("change:fillColor", () => {
                  this._colorFillPaths();
                });
            }
            _updateXMLContent() {
              if (this.content) {
                const t = new DOMParser()
                    .parseFromString(this.content.trim(), "image/svg+xml")
                    .querySelector("svg"),
                  e = t.getAttribute("viewBox");
                e && (this.viewBox = e);
                for (const { name: e, value: n } of Array.from(t.attributes))
                  Xh.presentationalAttributeNames.includes(e) &&
                    this.element.setAttribute(e, n);
                for (; this.element.firstChild; )
                  this.element.removeChild(this.element.firstChild);
                for (; t.childNodes.length > 0; )
                  this.element.appendChild(t.childNodes[0]);
              }
            }
            _colorFillPaths() {
              this.fillColor &&
                this.element.querySelectorAll(".ck-icon__fill").forEach((t) => {
                  t.style.fill = this.fillColor;
                });
            }
          }
          Xh.presentationalAttributeNames = [
            "alignment-baseline",
            "baseline-shift",
            "clip-path",
            "clip-rule",
            "color",
            "color-interpolation",
            "color-interpolation-filters",
            "color-rendering",
            "cursor",
            "direction",
            "display",
            "dominant-baseline",
            "fill",
            "fill-opacity",
            "fill-rule",
            "filter",
            "flood-color",
            "flood-opacity",
            "font-family",
            "font-size",
            "font-size-adjust",
            "font-stretch",
            "font-style",
            "font-variant",
            "font-weight",
            "image-rendering",
            "letter-spacing",
            "lighting-color",
            "marker-end",
            "marker-mid",
            "marker-start",
            "mask",
            "opacity",
            "overflow",
            "paint-order",
            "pointer-events",
            "shape-rendering",
            "stop-color",
            "stop-opacity",
            "stroke",
            "stroke-dasharray",
            "stroke-dashoffset",
            "stroke-linecap",
            "stroke-linejoin",
            "stroke-miterlimit",
            "stroke-opacity",
            "stroke-width",
            "text-anchor",
            "text-decoration",
            "text-overflow",
            "text-rendering",
            "transform",
            "unicode-bidi",
            "vector-effect",
            "visibility",
            "white-space",
            "word-spacing",
            "writing-mode",
          ];
          var tm = n(4499),
            em = { attributes: { "data-cke": !0 } };
          (em.setAttributes = is()),
            (em.insert = ns().bind(null, "head")),
            (em.domAPI = ts()),
            (em.insertStyleElement = ss());
          Jr()(tm.Z, em);
          tm.Z && tm.Z.locals && tm.Z.locals;
          class nm extends Ch {
            constructor(t) {
              super(t);
              const e = this.bindTemplate,
                n = r();
              this.set("class", void 0),
                this.set("labelStyle", void 0),
                this.set("icon", void 0),
                this.set("isEnabled", !0),
                this.set("isOn", !1),
                this.set("isVisible", !0),
                this.set("isToggleable", !1),
                this.set("keystroke", void 0),
                this.set("label", void 0),
                this.set("tabindex", -1),
                this.set("tooltip", !1),
                this.set("tooltipPosition", "s"),
                this.set("type", "button"),
                this.set("withText", !1),
                this.set("withKeystroke", !1),
                (this.children = this.createCollection()),
                (this.labelView = this._createLabelView(n)),
                (this.iconView = new Xh()),
                this.iconView.extendTemplate({
                  attributes: { class: "ck-button__icon" },
                }),
                (this.keystrokeView = this._createKeystrokeView()),
                this.bind("_tooltipString").to(
                  this,
                  "tooltip",
                  this,
                  "label",
                  this,
                  "keystroke",
                  this._getTooltipString.bind(this)
                );
              const o = {
                tag: "button",
                attributes: {
                  class: [
                    "ck",
                    "ck-button",
                    e.to("class"),
                    e.if("isEnabled", "ck-disabled", (t) => !t),
                    e.if("isVisible", "ck-hidden", (t) => !t),
                    e.to("isOn", (t) => (t ? "ck-on" : "ck-off")),
                    e.if("withText", "ck-button_with-text"),
                    e.if("withKeystroke", "ck-button_with-keystroke"),
                  ],
                  type: e.to("type", (t) => t || "button"),
                  tabindex: e.to("tabindex"),
                  "aria-labelledby": `ck-editor__aria-label_${n}`,
                  "aria-disabled": e.if("isEnabled", !0, (t) => !t),
                  "aria-pressed": e.to(
                    "isOn",
                    (t) => !!this.isToggleable && String(!!t)
                  ),
                  "data-cke-tooltip-text": e.to("_tooltipString"),
                  "data-cke-tooltip-position": e.to("tooltipPosition"),
                },
                children: this.children,
                on: {
                  click: e.to((t) => {
                    this.isEnabled ? this.fire("execute") : t.preventDefault();
                  }),
                },
              };
              ar.isSafari &&
                (o.on.mousedown = e.to((t) => {
                  this.focus(), t.preventDefault();
                })),
                this.setTemplate(o);
            }
            render() {
              super.render(),
                this.icon &&
                  (this.iconView.bind("content").to(this, "icon"),
                  this.children.add(this.iconView)),
                this.children.add(this.labelView),
                this.withKeystroke &&
                  this.keystroke &&
                  this.children.add(this.keystrokeView);
            }
            focus() {
              this.element.focus();
            }
            _createLabelView(t) {
              const e = new Ch(),
                n = this.bindTemplate;
              return (
                e.setTemplate({
                  tag: "span",
                  attributes: {
                    class: ["ck", "ck-button__label"],
                    style: n.to("labelStyle"),
                    id: `ck-editor__aria-label_${t}`,
                  },
                  children: [{ text: this.bindTemplate.to("label") }],
                }),
                e
              );
            }
            _createKeystrokeView() {
              const t = new Ch();
              return (
                t.setTemplate({
                  tag: "span",
                  attributes: { class: ["ck", "ck-button__keystroke"] },
                  children: [
                    { text: this.bindTemplate.to("keystroke", (t) => pr(t)) },
                  ],
                }),
                t
              );
            }
            _getTooltipString(t, e, n) {
              return t
                ? "string" == typeof t
                  ? t
                  : (n && (n = pr(n)),
                    t instanceof Function
                      ? t(e, n)
                      : `${e}${n ? ` (${n})` : ""}`)
                : "";
            }
          }
          var om = n(9681),
            im = { attributes: { "data-cke": !0 } };
          (im.setAttributes = is()),
            (im.insert = ns().bind(null, "head")),
            (im.domAPI = ts()),
            (im.insertStyleElement = ss());
          Jr()(om.Z, im);
          om.Z && om.Z.locals && om.Z.locals;
          class rm extends nm {
            constructor(t) {
              super(t),
                (this.isToggleable = !0),
                (this.toggleSwitchView = this._createToggleView()),
                this.extendTemplate({
                  attributes: { class: "ck-switchbutton" },
                });
            }
            render() {
              super.render(), this.children.add(this.toggleSwitchView);
            }
            _createToggleView() {
              const t = new Ch();
              return (
                t.setTemplate({
                  tag: "span",
                  attributes: { class: ["ck", "ck-button__toggle"] },
                  children: [
                    {
                      tag: "span",
                      attributes: { class: ["ck", "ck-button__toggle__inner"] },
                    },
                  ],
                }),
                t
              );
            }
          }
          function sm(t, e) {
            const n = t.t,
              o = {
                Black: n("Black"),
                "Dim grey": n("Dim grey"),
                Grey: n("Grey"),
                "Light grey": n("Light grey"),
                White: n("White"),
                Red: n("Red"),
                Orange: n("Orange"),
                Yellow: n("Yellow"),
                "Light green": n("Light green"),
                Green: n("Green"),
                Aquamarine: n("Aquamarine"),
                Turquoise: n("Turquoise"),
                "Light blue": n("Light blue"),
                Blue: n("Blue"),
                Purple: n("Purple"),
              };
            return e.map((t) => {
              const e = o[t.label];
              return e && e != t.label && (t.label = e), t;
            });
          }
          function am(t) {
            return t.map(lm).filter((t) => !!t);
          }
          function lm(t) {
            return "string" == typeof t
              ? {
                  model: t,
                  label: t,
                  hasBorder: !1,
                  view: { name: "span", styles: { color: t } },
                }
              : {
                  model: t.color,
                  label: t.label || t.color,
                  hasBorder: void 0 !== t.hasBorder && t.hasBorder,
                  view: { name: "span", styles: { color: `${t.color}` } },
                };
          }
          class cm extends nm {
            constructor(t) {
              super(t);
              const e = this.bindTemplate;
              this.set("color", void 0),
                this.set("hasBorder", !1),
                (this.icon =
                  '<svg viewBox="0 0 20 20" xmlns="http://www.w3.org/2000/svg"><path class="ck-icon__fill" d="M16.935 5.328a2 2 0 0 1 0 2.829l-7.778 7.778a2 2 0 0 1-2.829 0L3.5 13.107a1.999 1.999 0 1 1 2.828-2.829l.707.707a1 1 0 0 0 1.414 0l5.658-5.657a2 2 0 0 1 2.828 0z"/><path d="M14.814 6.035 8.448 12.4a1 1 0 0 1-1.414 0l-1.413-1.415A1 1 0 1 0 4.207 12.4l2.829 2.829a1 1 0 0 0 1.414 0l7.778-7.778a1 1 0 1 0-1.414-1.415z"/></svg>'),
                this.extendTemplate({
                  attributes: {
                    style: { backgroundColor: e.to("color") },
                    class: [
                      "ck",
                      "ck-color-grid__tile",
                      e.if("hasBorder", "ck-color-table__color-tile_bordered"),
                    ],
                  },
                });
            }
            render() {
              super.render(), (this.iconView.fillColor = "hsl(0, 0%, 100%)");
            }
          }
          var dm = n(4923),
            um = { attributes: { "data-cke": !0 } };
          (um.setAttributes = is()),
            (um.insert = ns().bind(null, "head")),
            (um.domAPI = ts()),
            (um.insertStyleElement = ss());
          Jr()(dm.Z, um);
          dm.Z && dm.Z.locals && dm.Z.locals;
          class hm extends Ch {
            constructor(t, e) {
              super(t);
              const n = (e && e.colorDefinitions) || [];
              this.columns = e && e.columns ? e.columns : 5;
              const o = {
                gridTemplateColumns: `repeat( ${this.columns}, 1fr)`,
              };
              this.set("selectedColor", void 0),
                (this.items = this.createCollection()),
                (this.focusTracker = new Oa()),
                (this.keystrokes = new ja()),
                this.items.on("add", (t, e) => {
                  e.isOn = e.color === this.selectedColor;
                }),
                n.forEach((t) => {
                  const e = new cm();
                  e.set({
                    color: t.color,
                    label: t.label,
                    tooltip: !0,
                    hasBorder: t.options.hasBorder,
                  }),
                    e.on("execute", () => {
                      this.fire("execute", {
                        value: t.color,
                        hasBorder: t.options.hasBorder,
                        label: t.label,
                      });
                    }),
                    this.items.add(e);
                }),
                this.setTemplate({
                  tag: "div",
                  children: this.items,
                  attributes: { class: ["ck", "ck-color-grid"], style: o },
                }),
                this.on("change:selectedColor", (t, e, n) => {
                  for (const t of this.items) t.isOn = t.color === n;
                });
            }
            focus() {
              this.items.length && this.items.first.focus();
            }
            focusLast() {
              this.items.length && this.items.last.focus();
            }
            render() {
              super.render();
              for (const t of this.items) this.focusTracker.add(t.element);
              this.items.on("add", (t, e) => {
                this.focusTracker.add(e.element);
              }),
                this.items.on("remove", (t, e) => {
                  this.focusTracker.remove(e.element);
                }),
                this.keystrokes.listenTo(this.element),
                Yh({
                  keystrokeHandler: this.keystrokes,
                  focusTracker: this.focusTracker,
                  gridItems: this.items,
                  numberOfColumns: this.columns,
                });
            }
            destroy() {
              super.destroy(),
                this.focusTracker.destroy(),
                this.keystrokes.destroy();
            }
          }
          const mm =
            '<svg viewBox="0 0 10 10" xmlns="http://www.w3.org/2000/svg"><path d="M.941 4.523a.75.75 0 1 1 1.06-1.06l3.006 3.005 3.005-3.005a.75.75 0 1 1 1.06 1.06l-3.549 3.55a.75.75 0 0 1-1.168-.136L.941 4.523z"/></svg>';
          class gm extends nm {
            constructor(t) {
              super(t),
                (this.arrowView = this._createArrowView()),
                this.extendTemplate({
                  attributes: {
                    "aria-haspopup": !0,
                    "aria-expanded": this.bindTemplate.to("isOn", (t) =>
                      String(t)
                    ),
                  },
                }),
                this.delegate("execute").to(this, "open");
            }
            render() {
              super.render(), this.children.add(this.arrowView);
            }
            _createArrowView() {
              const t = new Xh();
              return (
                (t.content = mm),
                t.extendTemplate({
                  attributes: { class: "ck-dropdown__arrow" },
                }),
                t
              );
            }
          }
          var pm = n(66),
            fm = { attributes: { "data-cke": !0 } };
          (fm.setAttributes = is()),
            (fm.insert = ns().bind(null, "head")),
            (fm.domAPI = ts()),
            (fm.insertStyleElement = ss());
          Jr()(pm.Z, fm);
          pm.Z && pm.Z.locals && pm.Z.locals;
          class km extends Ch {
            constructor(t) {
              super(t);
              const e = this.bindTemplate;
              this.set("class", void 0),
                this.set("labelStyle", void 0),
                this.set("icon", void 0),
                this.set("isEnabled", !0),
                this.set("isOn", !1),
                this.set("isToggleable", !1),
                this.set("isVisible", !0),
                this.set("keystroke", void 0),
                this.set("withKeystroke", !1),
                this.set("label", void 0),
                this.set("tabindex", -1),
                this.set("tooltip", !1),
                this.set("tooltipPosition", "s"),
                this.set("type", "button"),
                this.set("withText", !1),
                (this.children = this.createCollection()),
                (this.actionView = this._createActionView()),
                (this.arrowView = this._createArrowView()),
                (this.keystrokes = new ja()),
                (this.focusTracker = new Oa()),
                this.setTemplate({
                  tag: "div",
                  attributes: {
                    class: [
                      "ck",
                      "ck-splitbutton",
                      e.to("class"),
                      e.if("isVisible", "ck-hidden", (t) => !t),
                      this.arrowView.bindTemplate.if(
                        "isOn",
                        "ck-splitbutton_open"
                      ),
                    ],
                  },
                  children: this.children,
                });
            }
            render() {
              super.render(),
                this.children.add(this.actionView),
                this.children.add(this.arrowView),
                this.focusTracker.add(this.actionView.element),
                this.focusTracker.add(this.arrowView.element),
                this.keystrokes.listenTo(this.element),
                this.keystrokes.set("arrowright", (t, e) => {
                  this.focusTracker.focusedElement ===
                    this.actionView.element && (this.arrowView.focus(), e());
                }),
                this.keystrokes.set("arrowleft", (t, e) => {
                  this.focusTracker.focusedElement === this.arrowView.element &&
                    (this.actionView.focus(), e());
                });
            }
            destroy() {
              super.destroy(),
                this.focusTracker.destroy(),
                this.keystrokes.destroy();
            }
            focus() {
              this.actionView.focus();
            }
            _createActionView() {
              const t = new nm();
              return (
                t
                  .bind(
                    "icon",
                    "isEnabled",
                    "isOn",
                    "isToggleable",
                    "keystroke",
                    "label",
                    "tabindex",
                    "tooltip",
                    "tooltipPosition",
                    "type",
                    "withText"
                  )
                  .to(this),
                t.extendTemplate({
                  attributes: { class: "ck-splitbutton__action" },
                }),
                t.delegate("execute").to(this),
                t
              );
            }
            _createArrowView() {
              const t = new nm(),
                e = t.bindTemplate;
              return (
                (t.icon = mm),
                t.extendTemplate({
                  attributes: {
                    class: ["ck-splitbutton__arrow"],
                    "data-cke-tooltip-disabled": e.to("isOn"),
                    "aria-haspopup": !0,
                    "aria-expanded": e.to("isOn", (t) => String(t)),
                  },
                }),
                t.bind("isEnabled").to(this),
                t.bind("label").to(this),
                t.bind("tooltip").to(this),
                t.delegate("execute").to(this, "open"),
                t
              );
            }
          }
          class bm extends Ch {
            constructor(t) {
              super(t);
              const e = this.bindTemplate;
              this.set("isVisible", !1),
                this.set("position", "se"),
                (this.children = this.createCollection()),
                this.setTemplate({
                  tag: "div",
                  attributes: {
                    class: [
                      "ck",
                      "ck-reset",
                      "ck-dropdown__panel",
                      e.to("position", (t) => `ck-dropdown__panel_${t}`),
                      e.if("isVisible", "ck-dropdown__panel-visible"),
                    ],
                  },
                  children: this.children,
                  on: { selectstart: e.to((t) => t.preventDefault()) },
                });
            }
            focus() {
              if (this.children.length) {
                const t = this.children.first;
                "function" == typeof t.focus
                  ? t.focus()
                  : c("ui-dropdown-panel-focus-child-missing-focus", {
                      childView: this.children.first,
                      dropdownPanel: this,
                    });
              }
            }
            focusLast() {
              if (this.children.length) {
                const t = this.children.last;
                "function" == typeof t.focusLast ? t.focusLast() : t.focus();
              }
            }
          }
          var wm = n(3488),
            Am = { attributes: { "data-cke": !0 } };
          (Am.setAttributes = is()),
            (Am.insert = ns().bind(null, "head")),
            (Am.domAPI = ts()),
            (Am.insertStyleElement = ss());
          Jr()(wm.Z, Am);
          wm.Z && wm.Z.locals && wm.Z.locals;
          class _m extends Ch {
            constructor(t, e, n) {
              super(t);
              const o = this.bindTemplate;
              (this.buttonView = e),
                (this.panelView = n),
                this.set("isOpen", !1),
                this.set("isEnabled", !0),
                this.set("class", void 0),
                this.set("id", void 0),
                this.set("panelPosition", "auto"),
                (this.keystrokes = new ja()),
                (this.focusTracker = new Oa()),
                this.setTemplate({
                  tag: "div",
                  attributes: {
                    class: [
                      "ck",
                      "ck-dropdown",
                      o.to("class"),
                      o.if("isEnabled", "ck-disabled", (t) => !t),
                    ],
                    id: o.to("id"),
                    "aria-describedby": o.to("ariaDescribedById"),
                  },
                  children: [e, n],
                }),
                e.extendTemplate({
                  attributes: {
                    class: ["ck-dropdown__button"],
                    "data-cke-tooltip-disabled": o.to("isOpen"),
                  },
                });
            }
            render() {
              super.render(),
                this.focusTracker.add(this.buttonView.element),
                this.focusTracker.add(this.panelView.element),
                this.listenTo(this.buttonView, "open", () => {
                  this.isOpen = !this.isOpen;
                }),
                this.panelView.bind("isVisible").to(this, "isOpen"),
                this.on("change:isOpen", (t, e, n) => {
                  n &&
                    ("auto" === this.panelPosition
                      ? (this.panelView.position = _m._getOptimalPosition({
                          element: this.panelView.element,
                          target: this.buttonView.element,
                          fitInViewport: !0,
                          positions: this._panelPositions,
                        }).name)
                      : (this.panelView.position = this.panelPosition));
                }),
                this.keystrokes.listenTo(this.element);
              const t = (t, e) => {
                this.isOpen && ((this.isOpen = !1), e());
              };
              this.keystrokes.set("arrowdown", (t, e) => {
                this.buttonView.isEnabled &&
                  !this.isOpen &&
                  ((this.isOpen = !0), e());
              }),
                this.keystrokes.set("arrowright", (t, e) => {
                  this.isOpen && e();
                }),
                this.keystrokes.set("arrowleft", t),
                this.keystrokes.set("esc", t);
            }
            focus() {
              this.buttonView.focus();
            }
            get _panelPositions() {
              const {
                south: t,
                north: e,
                southEast: n,
                southWest: o,
                northEast: i,
                northWest: r,
                southMiddleEast: s,
                southMiddleWest: a,
                northMiddleEast: l,
                northMiddleWest: c,
              } = _m.defaultPanelPositions;
              return "rtl" !== this.locale.uiLanguageDirection
                ? [n, o, s, a, t, i, r, l, c, e]
                : [o, n, a, s, t, r, i, c, l, e];
            }
          }
          (_m.defaultPanelPositions = {
            south: (t, e) => ({
              top: t.bottom,
              left: t.left - (e.width - t.width) / 2,
              name: "s",
            }),
            southEast: (t) => ({ top: t.bottom, left: t.left, name: "se" }),
            southWest: (t, e) => ({
              top: t.bottom,
              left: t.left - e.width + t.width,
              name: "sw",
            }),
            southMiddleEast: (t, e) => ({
              top: t.bottom,
              left: t.left - (e.width - t.width) / 4,
              name: "sme",
            }),
            southMiddleWest: (t, e) => ({
              top: t.bottom,
              left: t.left - (3 * (e.width - t.width)) / 4,
              name: "smw",
            }),
            north: (t, e) => ({
              top: t.top - e.height,
              left: t.left - (e.width - t.width) / 2,
              name: "n",
            }),
            northEast: (t, e) => ({
              top: t.top - e.height,
              left: t.left,
              name: "ne",
            }),
            northWest: (t, e) => ({
              top: t.top - e.height,
              left: t.left - e.width + t.width,
              name: "nw",
            }),
            northMiddleEast: (t, e) => ({
              top: t.top - e.height,
              left: t.left - (e.width - t.width) / 4,
              name: "nme",
            }),
            northMiddleWest: (t, e) => ({
              top: t.top - e.height,
              left: t.left - (3 * (e.width - t.width)) / 4,
              name: "nmw",
            }),
          }),
            (_m._getOptimalPosition = vh);
          class Cm {
            constructor(t) {
              if (
                ((this.focusables = t.focusables),
                (this.focusTracker = t.focusTracker),
                (this.keystrokeHandler = t.keystrokeHandler),
                (this.actions = t.actions),
                t.actions && t.keystrokeHandler)
              )
                for (const e in t.actions) {
                  let n = t.actions[e];
                  "string" == typeof n && (n = [n]);
                  for (const o of n)
                    t.keystrokeHandler.set(o, (t, n) => {
                      this[e](), n();
                    });
                }
            }
            get first() {
              return this.focusables.find(vm) || null;
            }
            get last() {
              return this.focusables.filter(vm).slice(-1)[0] || null;
            }
            get next() {
              return this._getFocusableItem(1);
            }
            get previous() {
              return this._getFocusableItem(-1);
            }
            get current() {
              let t = null;
              return null === this.focusTracker.focusedElement
                ? null
                : (this.focusables.find((e, n) => {
                    const o = e.element === this.focusTracker.focusedElement;
                    return o && (t = n), o;
                  }),
                  t);
            }
            focusFirst() {
              this._focus(this.first);
            }
            focusLast() {
              this._focus(this.last);
            }
            focusNext() {
              this._focus(this.next);
            }
            focusPrevious() {
              this._focus(this.previous);
            }
            _focus(t) {
              t && t.focus();
            }
            _getFocusableItem(t) {
              const e = this.current,
                n = this.focusables.length;
              if (!n) return null;
              if (null === e) return this[1 === t ? "first" : "last"];
              let o = (e + n + t) % n;
              do {
                const e = this.focusables.get(o);
                if (vm(e)) return e;
                o = (o + n + t) % n;
              } while (o !== e);
              return null;
            }
          }
          function vm(t) {
            return !(!t.focus || !La(t.element));
          }
          class ym extends Ch {
            constructor(t) {
              super(t),
                this.setTemplate({
                  tag: "span",
                  attributes: { class: ["ck", "ck-toolbar__separator"] },
                });
            }
          }
          class xm extends Ch {
            constructor(t) {
              super(t),
                this.setTemplate({
                  tag: "span",
                  attributes: { class: ["ck", "ck-toolbar__line-break"] },
                });
            }
          }
          function Em(t) {
            return Array.isArray(t)
              ? { items: t, removeItems: [] }
              : t
              ? Object.assign({ items: [], removeItems: [] }, t)
              : { items: [], removeItems: [] };
          }
          var Dm = n(5571),
            Sm = { attributes: { "data-cke": !0 } };
          (Sm.setAttributes = is()),
            (Sm.insert = ns().bind(null, "head")),
            (Sm.domAPI = ts()),
            (Sm.insertStyleElement = ss());
          Jr()(Dm.Z, Sm);
          Dm.Z && Dm.Z.locals && Dm.Z.locals;
          const { threeVerticalDots: Im } = $h,
            Tm = {
              alignLeft: $h.alignLeft,
              bold: $h.bold,
              importExport: $h.importExport,
              paragraph: $h.paragraph,
              plus: $h.plus,
              text: $h.text,
              threeVerticalDots: $h.threeVerticalDots,
            };
          class Mm extends Ch {
            constructor(t, e) {
              super(t);
              const n = this.bindTemplate,
                o = this.t;
              (this.options = e || {}),
                this.set("ariaLabel", o("Editor toolbar")),
                this.set("maxWidth", "auto"),
                (this.items = this.createCollection()),
                (this.focusTracker = new Oa()),
                (this.keystrokes = new ja()),
                this.set("class", void 0),
                this.set("isCompact", !1),
                (this.itemsView = new Bm(t)),
                (this.children = this.createCollection()),
                this.children.add(this.itemsView),
                (this.focusables = this.createCollection());
              const i = "rtl" === t.uiLanguageDirection;
              this._focusCycler = new Cm({
                focusables: this.focusables,
                focusTracker: this.focusTracker,
                keystrokeHandler: this.keystrokes,
                actions: {
                  focusPrevious: [i ? "arrowright" : "arrowleft", "arrowup"],
                  focusNext: [i ? "arrowleft" : "arrowright", "arrowdown"],
                },
              });
              const r = [
                "ck",
                "ck-toolbar",
                n.to("class"),
                n.if("isCompact", "ck-toolbar_compact"),
              ];
              var s;
              this.options.shouldGroupWhenFull &&
                this.options.isFloating &&
                r.push("ck-toolbar_floating"),
                this.setTemplate({
                  tag: "div",
                  attributes: {
                    class: r,
                    role: "toolbar",
                    "aria-label": n.to("ariaLabel"),
                    style: { maxWidth: n.to("maxWidth") },
                  },
                  children: this.children,
                  on: {
                    mousedown:
                      ((s = this),
                      s.bindTemplate.to((t) => {
                        t.target === s.element && t.preventDefault();
                      })),
                  },
                }),
                (this._behavior = this.options.shouldGroupWhenFull
                  ? new zm(this)
                  : new Nm(this));
            }
            render() {
              super.render();
              for (const t of this.items) this.focusTracker.add(t.element);
              this.items.on("add", (t, e) => {
                this.focusTracker.add(e.element);
              }),
                this.items.on("remove", (t, e) => {
                  this.focusTracker.remove(e.element);
                }),
                this.keystrokes.listenTo(this.element),
                this._behavior.render(this);
            }
            destroy() {
              return (
                this._behavior.destroy(),
                this.focusTracker.destroy(),
                this.keystrokes.destroy(),
                super.destroy()
              );
            }
            focus() {
              this._focusCycler.focusFirst();
            }
            focusLast() {
              this._focusCycler.focusLast();
            }
            fillFromConfig(t, e, n) {
              const o = Em(t),
                i = n || o.removeItems,
                r = this._cleanItemsConfiguration(o.items, e, i)
                  .map((t) =>
                    E(t)
                      ? this._createNestedToolbarDropdown(t, e, i)
                      : "|" === t
                      ? new ym()
                      : "-" === t
                      ? new xm()
                      : e.create(t)
                  )
                  .filter((t) => !!t);
              this.items.addMany(r);
            }
            _cleanItemsConfiguration(t, e, n) {
              const o = t.filter(
                (t, o, i) =>
                  "|" === t ||
                  (-1 === n.indexOf(t) &&
                    ("-" === t
                      ? !this.options.shouldGroupWhenFull ||
                        (c(
                          "toolbarview-line-break-ignored-when-grouping-items",
                          i
                        ),
                        !1)
                      : !(!E(t) && !e.has(t)) ||
                        (c("toolbarview-item-unavailable", { item: t }), !1)))
              );
              return this._cleanSeparatorsAndLineBreaks(o);
            }
            _cleanSeparatorsAndLineBreaks(t) {
              const e = (t) => "-" !== t && "|" !== t,
                n = t.length,
                o = t.findIndex(e);
              if (-1 === o) return [];
              const i = n - t.slice().reverse().findIndex(e);
              return t.slice(o, i).filter((t, n, o) => {
                if (e(t)) return !0;
                return !(n > 0 && o[n - 1] === t);
              });
            }
            _createNestedToolbarDropdown(t, e, n) {
              let {
                label: o,
                icon: i,
                items: r,
                tooltip: s = !0,
                withText: a = !1,
              } = t;
              if (((r = this._cleanItemsConfiguration(r, e, n)), !r.length))
                return null;
              const l = Wm(this.locale);
              return (
                o || c("toolbarview-nested-toolbar-dropdown-missing-label", t),
                (l.class = "ck-toolbar__nested-toolbar-dropdown"),
                l.buttonView.set({ label: o, tooltip: s, withText: !!a }),
                !1 !== i
                  ? (l.buttonView.icon = Tm[i] || i || Im)
                  : (l.buttonView.withText = !0),
                $m(l, []),
                l.toolbarView.fillFromConfig(r, e, n),
                l
              );
            }
          }
          class Bm extends Ch {
            constructor(t) {
              super(t),
                (this.children = this.createCollection()),
                this.setTemplate({
                  tag: "div",
                  attributes: { class: ["ck", "ck-toolbar__items"] },
                  children: this.children,
                });
            }
          }
          class Nm {
            constructor(t) {
              const e = t.bindTemplate;
              t.set("isVertical", !1),
                t.itemsView.children.bindTo(t.items).using((t) => t),
                t.focusables.bindTo(t.items).using((t) => t),
                t.extendTemplate({
                  attributes: {
                    class: [e.if("isVertical", "ck-toolbar_vertical")],
                  },
                });
            }
            render() {}
            destroy() {}
          }
          class zm {
            constructor(t) {
              (this.view = t),
                (this.viewChildren = t.children),
                (this.viewFocusables = t.focusables),
                (this.viewItemsView = t.itemsView),
                (this.viewFocusTracker = t.focusTracker),
                (this.viewLocale = t.locale),
                (this.ungroupedItems = t.createCollection()),
                (this.groupedItems = t.createCollection()),
                (this.groupedItemsDropdown =
                  this._createGroupedItemsDropdown()),
                (this.resizeObserver = null),
                (this.cachedPadding = null),
                (this.shouldUpdateGroupingOnNextResize = !1),
                t.itemsView.children
                  .bindTo(this.ungroupedItems)
                  .using((t) => t),
                this.ungroupedItems.on(
                  "add",
                  this._updateFocusCycleableItems.bind(this)
                ),
                this.ungroupedItems.on(
                  "remove",
                  this._updateFocusCycleableItems.bind(this)
                ),
                t.children.on(
                  "add",
                  this._updateFocusCycleableItems.bind(this)
                ),
                t.children.on(
                  "remove",
                  this._updateFocusCycleableItems.bind(this)
                ),
                t.items.on("change", (t, e) => {
                  const n = e.index,
                    o = Array.from(e.added);
                  for (const t of e.removed)
                    n >= this.ungroupedItems.length
                      ? this.groupedItems.remove(t)
                      : this.ungroupedItems.remove(t);
                  for (let t = n; t < n + o.length; t++) {
                    const e = o[t - n];
                    t > this.ungroupedItems.length
                      ? this.groupedItems.add(e, t - this.ungroupedItems.length)
                      : this.ungroupedItems.add(e, t);
                  }
                  this._updateGrouping();
                }),
                t.extendTemplate({
                  attributes: { class: ["ck-toolbar_grouping"] },
                });
            }
            render(t) {
              (this.viewElement = t.element),
                this._enableGroupingOnResize(),
                this._enableGroupingOnMaxWidthChange(t);
            }
            destroy() {
              this.groupedItemsDropdown.destroy(),
                this.resizeObserver.destroy();
            }
            _updateGrouping() {
              if (
                !this.viewElement.ownerDocument.body.contains(this.viewElement)
              )
                return;
              if (!La(this.viewElement))
                return void (this.shouldUpdateGroupingOnNextResize = !0);
              const t = this.groupedItems.length;
              let e;
              for (; this._areItemsOverflowing; )
                this._groupLastItem(), (e = !0);
              if (!e && this.groupedItems.length) {
                for (; this.groupedItems.length && !this._areItemsOverflowing; )
                  this._ungroupFirstItem();
                this._areItemsOverflowing && this._groupLastItem();
              }
              this.groupedItems.length !== t &&
                this.view.fire("groupedItemsUpdate");
            }
            get _areItemsOverflowing() {
              if (!this.ungroupedItems.length) return !1;
              const t = this.viewElement,
                e = this.viewLocale.uiLanguageDirection,
                n = new Ma(t.lastChild),
                o = new Ma(t);
              if (!this.cachedPadding) {
                const n = wo.window.getComputedStyle(t),
                  o = "ltr" === e ? "paddingRight" : "paddingLeft";
                this.cachedPadding = Number.parseInt(n[o]);
              }
              return "ltr" === e
                ? n.right > o.right - this.cachedPadding
                : n.left < o.left + this.cachedPadding;
            }
            _enableGroupingOnResize() {
              let t;
              (this.resizeObserver = new Pa(this.viewElement, (e) => {
                (t &&
                  t === e.contentRect.width &&
                  !this.shouldUpdateGroupingOnNextResize) ||
                  ((this.shouldUpdateGroupingOnNextResize = !1),
                  this._updateGrouping(),
                  (t = e.contentRect.width));
              })),
                this._updateGrouping();
            }
            _enableGroupingOnMaxWidthChange(t) {
              t.on("change:maxWidth", () => {
                this._updateGrouping();
              });
            }
            _groupLastItem() {
              this.groupedItems.length ||
                (this.viewChildren.add(new ym()),
                this.viewChildren.add(this.groupedItemsDropdown),
                this.viewFocusTracker.add(this.groupedItemsDropdown.element)),
                this.groupedItems.add(
                  this.ungroupedItems.remove(this.ungroupedItems.last),
                  0
                );
            }
            _ungroupFirstItem() {
              this.ungroupedItems.add(
                this.groupedItems.remove(this.groupedItems.first)
              ),
                this.groupedItems.length ||
                  (this.viewChildren.remove(this.groupedItemsDropdown),
                  this.viewChildren.remove(this.viewChildren.last),
                  this.viewFocusTracker.remove(
                    this.groupedItemsDropdown.element
                  ));
            }
            _createGroupedItemsDropdown() {
              const t = this.viewLocale,
                e = t.t,
                n = Wm(t);
              return (
                (n.class = "ck-toolbar__grouped-dropdown"),
                (n.panelPosition =
                  "ltr" === t.uiLanguageDirection ? "sw" : "se"),
                $m(n, []),
                n.buttonView.set({
                  label: e("Show more items"),
                  tooltip: !0,
                  tooltipPosition:
                    "rtl" === t.uiLanguageDirection ? "se" : "sw",
                  icon: Im,
                }),
                n.toolbarView.items.bindTo(this.groupedItems).using((t) => t),
                n
              );
            }
            _updateFocusCycleableItems() {
              this.viewFocusables.clear(),
                this.ungroupedItems.map((t) => {
                  this.viewFocusables.add(t);
                }),
                this.groupedItems.length &&
                  this.viewFocusables.add(this.groupedItemsDropdown);
            }
          }
          var Pm = n(1162),
            Lm = { attributes: { "data-cke": !0 } };
          (Lm.setAttributes = is()),
            (Lm.insert = ns().bind(null, "head")),
            (Lm.domAPI = ts()),
            (Lm.insertStyleElement = ss());
          Jr()(Pm.Z, Lm);
          Pm.Z && Pm.Z.locals && Pm.Z.locals;
          class Rm extends Ch {
            constructor(t) {
              super(t),
                (this.items = this.createCollection()),
                (this.focusTracker = new Oa()),
                (this.keystrokes = new ja()),
                (this._focusCycler = new Cm({
                  focusables: this.items,
                  focusTracker: this.focusTracker,
                  keystrokeHandler: this.keystrokes,
                  actions: { focusPrevious: "arrowup", focusNext: "arrowdown" },
                })),
                this.setTemplate({
                  tag: "ul",
                  attributes: { class: ["ck", "ck-reset", "ck-list"] },
                  children: this.items,
                });
            }
            render() {
              super.render();
              for (const t of this.items) this.focusTracker.add(t.element);
              this.items.on("add", (t, e) => {
                this.focusTracker.add(e.element);
              }),
                this.items.on("remove", (t, e) => {
                  this.focusTracker.remove(e.element);
                }),
                this.keystrokes.listenTo(this.element);
            }
            destroy() {
              super.destroy(),
                this.focusTracker.destroy(),
                this.keystrokes.destroy();
            }
            focus() {
              this._focusCycler.focusFirst();
            }
            focusLast() {
              this._focusCycler.focusLast();
            }
          }
          class Om extends Ch {
            constructor(t) {
              super(t);
              const e = this.bindTemplate;
              this.set("isVisible", !0),
                (this.children = this.createCollection()),
                this.setTemplate({
                  tag: "li",
                  attributes: {
                    class: [
                      "ck",
                      "ck-list__item",
                      e.if("isVisible", "ck-hidden", (t) => !t),
                    ],
                  },
                  children: this.children,
                });
            }
            focus() {
              this.children.first.focus();
            }
          }
          class jm extends Ch {
            constructor(t) {
              super(t),
                this.setTemplate({
                  tag: "li",
                  attributes: { class: ["ck", "ck-list__separator"] },
                });
            }
          }
          var Vm = n(5075),
            Fm = { attributes: { "data-cke": !0 } };
          (Fm.setAttributes = is()),
            (Fm.insert = ns().bind(null, "head")),
            (Fm.domAPI = ts()),
            (Fm.insertStyleElement = ss());
          Jr()(Vm.Z, Fm);
          Vm.Z && Vm.Z.locals && Vm.Z.locals;
          var Hm = n(6875),
            Um = { attributes: { "data-cke": !0 } };
          (Um.setAttributes = is()),
            (Um.insert = ns().bind(null, "head")),
            (Um.domAPI = ts()),
            (Um.insertStyleElement = ss());
          Jr()(Hm.Z, Um);
          Hm.Z && Hm.Z.locals && Hm.Z.locals;
          function Wm(t, e = gm) {
            const n = new e(t),
              o = new bm(t),
              i = new _m(t, n, o);
            return (
              n.bind("isEnabled").to(i),
              n instanceof km
                ? n.arrowView.bind("isOn").to(i, "isOpen")
                : n.bind("isOn").to(i, "isOpen"),
              (function (t) {
                (function (t) {
                  t.on("render", () => {
                    qh({
                      emitter: t,
                      activator: () => t.isOpen,
                      callback: () => {
                        t.isOpen = !1;
                      },
                      contextElements: [t.element],
                    });
                  });
                })(t),
                  (function (t) {
                    t.on("execute", (e) => {
                      e.source instanceof rm || (t.isOpen = !1);
                    });
                  })(t),
                  (function (t) {
                    t.focusTracker.on("change:isFocused", (e, n, o) => {
                      t.isOpen && !o && (t.isOpen = !1);
                    });
                  })(t),
                  (function (t) {
                    t.keystrokes.set("arrowdown", (e, n) => {
                      t.isOpen && (t.panelView.focus(), n());
                    }),
                      t.keystrokes.set("arrowup", (e, n) => {
                        t.isOpen && (t.panelView.focusLast(), n());
                      });
                  })(t),
                  (function (t) {
                    t.on("change:isOpen", (e, n, o) => {
                      o ||
                        (t.panelView.element.contains(
                          wo.document.activeElement
                        ) &&
                          t.buttonView.focus());
                    });
                  })(t),
                  (function (t) {
                    t.on(
                      "change:isOpen",
                      (e, n, o) => {
                        o && t.panelView.focus();
                      },
                      { priority: "low" }
                    );
                  })(t);
              })(i),
              i
            );
          }
          function $m(t, e, n = {}) {
            const o = t.locale,
              i = o.t,
              r = (t.toolbarView = new Mm(o));
            r.set("ariaLabel", i("Dropdown toolbar")),
              t.extendTemplate({
                attributes: { class: ["ck-toolbar-dropdown"] },
              }),
              e.map((t) => r.items.add(t)),
              n.enableActiveItemFocusOnDropdownOpen &&
                Gm(t, () => r.items.find((t) => t.isOn)),
              t.panelView.children.add(r),
              r.items.delegate("execute").to(t);
          }
          function qm(t, e) {
            const n = t.locale,
              o = (t.listView = new Rm(n));
            o.items.bindTo(e).using((t) => {
              if ("separator" === t.type) return new jm(n);
              if ("button" === t.type || "switchbutton" === t.type) {
                const e = new Om(n);
                let o;
                return (
                  (o = "button" === t.type ? new nm(n) : new rm(n)),
                  o.bind(...Object.keys(t.model)).to(t.model),
                  o.delegate("execute").to(e),
                  e.children.add(o),
                  e
                );
              }
              return null;
            }),
              t.panelView.children.add(o),
              o.items.delegate("execute").to(t),
              Gm(t, () =>
                o.items.find((t) => t instanceof Om && t.children.first.isOn)
              );
          }
          function Gm(t, e) {
            t.on(
              "change:isOpen",
              () => {
                if (!t.isOpen) return;
                const n = e();
                n &&
                  ("function" == typeof n.focus
                    ? n.focus()
                    : c("ui-dropdown-focus-child-on-open-child-missing-focus", {
                        view: n,
                      }));
              },
              { priority: s.low - 10 }
            );
          }
          var Zm = n(4547),
            Ym = { attributes: { "data-cke": !0 } };
          (Ym.setAttributes = is()),
            (Ym.insert = ns().bind(null, "head")),
            (Ym.domAPI = ts()),
            (Ym.insertStyleElement = ss());
          Jr()(Zm.Z, Ym);
          Zm.Z && Zm.Z.locals && Zm.Z.locals;
          class Km extends Ch {
            constructor(t) {
              super(t), (this.body = new Kh(t));
            }
            render() {
              super.render(), this.body.attachToDom();
            }
            destroy() {
              return this.body.detachFromDom(), super.destroy();
            }
          }
          var Qm = n(2751),
            Jm = { attributes: { "data-cke": !0 } };
          (Jm.setAttributes = is()),
            (Jm.insert = ns().bind(null, "head")),
            (Jm.domAPI = ts()),
            (Jm.insertStyleElement = ss());
          Jr()(Qm.Z, Jm);
          Qm.Z && Qm.Z.locals && Qm.Z.locals;
          class Xm extends Ch {
            constructor(t) {
              super(t),
                this.set("text", void 0),
                this.set("for", void 0),
                (this.id = `ck-editor__label_${r()}`);
              const e = this.bindTemplate;
              this.setTemplate({
                tag: "label",
                attributes: {
                  class: ["ck", "ck-label"],
                  id: this.id,
                  for: e.to("for"),
                },
                children: [{ text: e.to("text") }],
              });
            }
          }
          class tg extends Km {
            constructor(t) {
              super(t),
                (this.top = this.createCollection()),
                (this.main = this.createCollection()),
                (this._voiceLabelView = this._createVoiceLabel()),
                this.setTemplate({
                  tag: "div",
                  attributes: {
                    class: [
                      "ck",
                      "ck-reset",
                      "ck-editor",
                      "ck-rounded-corners",
                    ],
                    role: "application",
                    dir: t.uiLanguageDirection,
                    lang: t.uiLanguage,
                    "aria-labelledby": this._voiceLabelView.id,
                  },
                  children: [
                    this._voiceLabelView,
                    {
                      tag: "div",
                      attributes: {
                        class: ["ck", "ck-editor__top", "ck-reset_all"],
                        role: "presentation",
                      },
                      children: this.top,
                    },
                    {
                      tag: "div",
                      attributes: {
                        class: ["ck", "ck-editor__main"],
                        role: "presentation",
                      },
                      children: this.main,
                    },
                  ],
                });
            }
            _createVoiceLabel() {
              const t = this.t,
                e = new Xm();
              return (
                (e.text = t("Rich Text Editor")),
                e.extendTemplate({ attributes: { class: "ck-voice-label" } }),
                e
              );
            }
          }
          class eg extends Ch {
            constructor(t, e, n) {
              super(t),
                this.setTemplate({
                  tag: "div",
                  attributes: {
                    class: [
                      "ck",
                      "ck-content",
                      "ck-editor__editable",
                      "ck-rounded-corners",
                    ],
                    lang: t.contentLanguage,
                    dir: t.contentLanguageDirection,
                  },
                }),
                (this.name = null),
                this.set("isFocused", !1),
                (this._editableElement = n),
                (this._hasExternalElement = !!this._editableElement),
                (this._editingView = e);
            }
            render() {
              super.render(),
                this._hasExternalElement
                  ? this.template.apply((this.element = this._editableElement))
                  : (this._editableElement = this.element),
                this.on("change:isFocused", () =>
                  this._updateIsFocusedClasses()
                ),
                this._updateIsFocusedClasses();
            }
            destroy() {
              this._hasExternalElement &&
                this.template.revert(this._editableElement),
                super.destroy();
            }
            _updateIsFocusedClasses() {
              const t = this._editingView;
              function e(e) {
                t.change((n) => {
                  const o = t.document.getRoot(e.name);
                  n.addClass(e.isFocused ? "ck-focused" : "ck-blurred", o),
                    n.removeClass(e.isFocused ? "ck-blurred" : "ck-focused", o);
                });
              }
              t.isRenderingInProgress
                ? (function n(o) {
                    t.once("change:isRenderingInProgress", (t, i, r) => {
                      r ? n(o) : e(o);
                    });
                  })(this)
                : e(this);
            }
          }
          class ng extends eg {
            constructor(t, e, n, o = {}) {
              super(t, e, n);
              const i = t.t;
              this.extendTemplate({
                attributes: {
                  role: "textbox",
                  class: "ck-editor__editable_inline",
                },
              }),
                (this._generateLabel =
                  o.label || (() => i("Editor editing area: %0", this.name)));
            }
            render() {
              super.render();
              const t = this._editingView;
              t.change((e) => {
                const n = t.document.getRoot(this.name);
                e.setAttribute("aria-label", this._generateLabel(this), n);
              });
            }
          }
          var og = n(5523),
            ig = { attributes: { "data-cke": !0 } };
          (ig.setAttributes = is()),
            (ig.insert = ns().bind(null, "head")),
            (ig.domAPI = ts()),
            (ig.insertStyleElement = ss());
          Jr()(og.Z, ig);
          og.Z && og.Z.locals && og.Z.locals;
          class rg extends Ch {
            constructor(t, e = {}) {
              super(t);
              const n = this.bindTemplate;
              this.set("label", e.label || ""),
                this.set("class", e.class || null),
                (this.children = this.createCollection()),
                this.setTemplate({
                  tag: "div",
                  attributes: {
                    class: ["ck", "ck-form__header", n.to("class")],
                  },
                  children: this.children,
                });
              const o = new Ch(t);
              o.setTemplate({
                tag: "span",
                attributes: { class: ["ck", "ck-form__header__label"] },
                children: [{ text: n.to("label") }],
              }),
                this.children.add(o);
            }
          }
          var sg = n(6985),
            ag = { attributes: { "data-cke": !0 } };
          (ag.setAttributes = is()),
            (ag.insert = ns().bind(null, "head")),
            (ag.domAPI = ts()),
            (ag.insertStyleElement = ss());
          Jr()(sg.Z, ag);
          sg.Z && sg.Z.locals && sg.Z.locals;
          class lg extends Ch {
            constructor(t) {
              super(t),
                this.set("value", void 0),
                this.set("id", void 0),
                this.set("placeholder", void 0),
                this.set("isReadOnly", !1),
                this.set("hasError", !1),
                this.set("ariaDescribedById", void 0),
                (this.focusTracker = new Oa()),
                this.bind("isFocused").to(this.focusTracker),
                this.set("isEmpty", !0),
                this.set("inputMode", "text");
              const e = this.bindTemplate;
              this.setTemplate({
                tag: "input",
                attributes: {
                  class: [
                    "ck",
                    "ck-input",
                    e.if("isFocused", "ck-input_focused"),
                    e.if("isEmpty", "ck-input-text_empty"),
                    e.if("hasError", "ck-error"),
                  ],
                  id: e.to("id"),
                  placeholder: e.to("placeholder"),
                  readonly: e.to("isReadOnly"),
                  inputmode: e.to("inputMode"),
                  "aria-invalid": e.if("hasError", !0),
                  "aria-describedby": e.to("ariaDescribedById"),
                },
                on: {
                  input: e.to((...t) => {
                    this.fire("input", ...t), this._updateIsEmpty();
                  }),
                  change: e.to(this._updateIsEmpty.bind(this)),
                },
              });
            }
            render() {
              super.render(),
                this.focusTracker.add(this.element),
                this._setDomElementValue(this.value),
                this._updateIsEmpty(),
                this.on("change:value", (t, e, n) => {
                  this._setDomElementValue(n), this._updateIsEmpty();
                });
            }
            destroy() {
              super.destroy(), this.focusTracker.destroy();
            }
            select() {
              this.element.select();
            }
            focus() {
              this.element.focus();
            }
            _updateIsEmpty() {
              this.isEmpty = !this.element.value;
            }
            _setDomElementValue(t) {
              this.element.value = t || 0 === t ? t : "";
            }
          }
          class cg extends lg {
            constructor(t) {
              super(t),
                this.extendTemplate({
                  attributes: { type: "text", class: ["ck-input-text"] },
                });
            }
          }
          var dg = n(8111),
            ug = { attributes: { "data-cke": !0 } };
          (ug.setAttributes = is()),
            (ug.insert = ns().bind(null, "head")),
            (ug.domAPI = ts()),
            (ug.insertStyleElement = ss());
          Jr()(dg.Z, ug);
          dg.Z && dg.Z.locals && dg.Z.locals;
          class hg extends Ch {
            constructor(t, e) {
              super(t);
              const n = `ck-labeled-field-view-${r()}`,
                o = `ck-labeled-field-view-status-${r()}`;
              (this.fieldView = e(this, n, o)),
                this.set("label", void 0),
                this.set("isEnabled", !0),
                this.set("isEmpty", !0),
                this.set("isFocused", !1),
                this.set("errorText", null),
                this.set("infoText", null),
                this.set("class", void 0),
                this.set("placeholder", void 0),
                (this.labelView = this._createLabelView(n)),
                (this.statusView = this._createStatusView(o)),
                (this.fieldWrapperChildren = this.createCollection([
                  this.fieldView,
                  this.labelView,
                ])),
                this.bind("_statusText").to(
                  this,
                  "errorText",
                  this,
                  "infoText",
                  (t, e) => t || e
                );
              const i = this.bindTemplate;
              this.setTemplate({
                tag: "div",
                attributes: {
                  class: [
                    "ck",
                    "ck-labeled-field-view",
                    i.to("class"),
                    i.if("isEnabled", "ck-disabled", (t) => !t),
                    i.if("isEmpty", "ck-labeled-field-view_empty"),
                    i.if("isFocused", "ck-labeled-field-view_focused"),
                    i.if("placeholder", "ck-labeled-field-view_placeholder"),
                    i.if("errorText", "ck-error"),
                  ],
                },
                children: [
                  {
                    tag: "div",
                    attributes: {
                      class: ["ck", "ck-labeled-field-view__input-wrapper"],
                    },
                    children: this.fieldWrapperChildren,
                  },
                  this.statusView,
                ],
              });
            }
            _createLabelView(t) {
              const e = new Xm(this.locale);
              return (e.for = t), e.bind("text").to(this, "label"), e;
            }
            _createStatusView(t) {
              const e = new Ch(this.locale),
                n = this.bindTemplate;
              return (
                e.setTemplate({
                  tag: "div",
                  attributes: {
                    class: [
                      "ck",
                      "ck-labeled-field-view__status",
                      n.if("errorText", "ck-labeled-field-view__status_error"),
                      n.if("_statusText", "ck-hidden", (t) => !t),
                    ],
                    id: t,
                    role: n.if("errorText", "alert"),
                  },
                  children: [{ text: n.to("_statusText") }],
                }),
                e
              );
            }
            focus() {
              this.fieldView.focus();
            }
          }
          function mg(t, e, n) {
            const o = new cg(t.locale);
            return (
              o.set({ id: e, ariaDescribedById: n }),
              o.bind("isReadOnly").to(t, "isEnabled", (t) => !t),
              o.bind("hasError").to(t, "errorText", (t) => !!t),
              o.on("input", () => {
                t.errorText = null;
              }),
              t.bind("isEmpty", "isFocused", "placeholder").to(o),
              o
            );
          }
          function gg(t, e, n) {
            const o = Wm(t.locale);
            return (
              o.set({ id: e, ariaDescribedById: n }),
              o.bind("isEnabled").to(t),
              o
            );
          }
          class pg extends xo {
            static get pluginName() {
              return "Notification";
            }
            init() {
              this.on(
                "show:warning",
                (t, e) => {
                  window.alert(e.message);
                },
                { priority: "lowest" }
              );
            }
            showSuccess(t, e = {}) {
              this._showNotification({
                message: t,
                type: "success",
                namespace: e.namespace,
                title: e.title,
              });
            }
            showInfo(t, e = {}) {
              this._showNotification({
                message: t,
                type: "info",
                namespace: e.namespace,
                title: e.title,
              });
            }
            showWarning(t, e = {}) {
              this._showNotification({
                message: t,
                type: "warning",
                namespace: e.namespace,
                title: e.title,
              });
            }
            _showNotification(t) {
              const e = t.namespace
                ? `show:${t.type}:${t.namespace}`
                : `show:${t.type}`;
              this.fire(e, {
                message: t.message,
                type: t.type,
                title: t.title || "",
              });
            }
          }
          class fg extends N {
            constructor(t, e) {
              super(), e && Bs(this, e), t && this.set(t);
            }
          }
          const kg =
            '<svg viewBox="0 0 20 20" xmlns="http://www.w3.org/2000/svg"><path d="M11.463 5.187a.888.888 0 1 1 1.254 1.255L9.16 10l3.557 3.557a.888.888 0 1 1-1.254 1.255L7.26 10.61a.888.888 0 0 1 .16-1.382l4.043-4.042z"/></svg>';
          var bg = n(1757),
            wg = { attributes: { "data-cke": !0 } };
          (wg.setAttributes = is()),
            (wg.insert = ns().bind(null, "head")),
            (wg.domAPI = ts()),
            (wg.insertStyleElement = ss());
          Jr()(bg.Z, wg);
          bg.Z && bg.Z.locals && bg.Z.locals;
          var Ag = n(3553),
            _g = { attributes: { "data-cke": !0 } };
          (_g.setAttributes = is()),
            (_g.insert = ns().bind(null, "head")),
            (_g.domAPI = ts()),
            (_g.insertStyleElement = ss());
          Jr()(Ag.Z, _g);
          Ag.Z && Ag.Z.locals && Ag.Z.locals;
          const Cg = Eh("px");
          class vg extends j {
            static get pluginName() {
              return "ContextualBalloon";
            }
            constructor(t) {
              super(t),
                (this.positionLimiter = () => {
                  const t = this.editor.editing.view,
                    e = t.document.selection.editableElement;
                  return e ? t.domConverter.mapViewToDom(e.root) : null;
                }),
                this.set("visibleView", null),
                (this.view = new Mh(t.locale)),
                t.ui.view.body.add(this.view),
                t.ui.focusTracker.add(this.view.element),
                (this._viewToStack = new Map()),
                (this._idToStack = new Map()),
                this.set("_numberOfStacks", 0),
                this.set("_singleViewMode", !1),
                (this._rotatorView = this._createRotatorView()),
                (this._fakePanelsView = this._createFakePanelsView());
            }
            destroy() {
              super.destroy(),
                this.view.destroy(),
                this._rotatorView.destroy(),
                this._fakePanelsView.destroy();
            }
            hasView(t) {
              return Array.from(this._viewToStack.keys()).includes(t);
            }
            add(t) {
              if (this.hasView(t.view))
                throw new l("contextualballoon-add-view-exist", [this, t]);
              const e = t.stackId || "main";
              if (!this._idToStack.has(e))
                return (
                  this._idToStack.set(e, new Map([[t.view, t]])),
                  this._viewToStack.set(t.view, this._idToStack.get(e)),
                  (this._numberOfStacks = this._idToStack.size),
                  void (
                    (this._visibleStack && !t.singleViewMode) ||
                    this.showStack(e)
                  )
                );
              const n = this._idToStack.get(e);
              t.singleViewMode && this.showStack(e),
                n.set(t.view, t),
                this._viewToStack.set(t.view, n),
                n === this._visibleStack && this._showView(t);
            }
            remove(t) {
              if (!this.hasView(t))
                throw new l("contextualballoon-remove-view-not-exist", [
                  this,
                  t,
                ]);
              const e = this._viewToStack.get(t);
              this._singleViewMode &&
                this.visibleView === t &&
                (this._singleViewMode = !1),
                this.visibleView === t &&
                  (1 === e.size
                    ? this._idToStack.size > 1
                      ? this._showNextStack()
                      : (this.view.hide(),
                        (this.visibleView = null),
                        this._rotatorView.hideView())
                    : this._showView(Array.from(e.values())[e.size - 2])),
                1 === e.size
                  ? (this._idToStack.delete(this._getStackId(e)),
                    (this._numberOfStacks = this._idToStack.size))
                  : e.delete(t),
                this._viewToStack.delete(t);
            }
            updatePosition(t) {
              t && (this._visibleStack.get(this.visibleView).position = t),
                this.view.pin(this._getBalloonPosition()),
                this._fakePanelsView.updatePosition();
            }
            showStack(t) {
              this.visibleStack = t;
              const e = this._idToStack.get(t);
              if (!e)
                throw new l(
                  "contextualballoon-showstack-stack-not-exist",
                  this
                );
              this._visibleStack !== e &&
                this._showView(Array.from(e.values()).pop());
            }
            get _visibleStack() {
              return this._viewToStack.get(this.visibleView);
            }
            _getStackId(t) {
              return Array.from(this._idToStack.entries()).find(
                (e) => e[1] === t
              )[0];
            }
            _showNextStack() {
              const t = Array.from(this._idToStack.values());
              let e = t.indexOf(this._visibleStack) + 1;
              t[e] || (e = 0), this.showStack(this._getStackId(t[e]));
            }
            _showPrevStack() {
              const t = Array.from(this._idToStack.values());
              let e = t.indexOf(this._visibleStack) - 1;
              t[e] || (e = t.length - 1),
                this.showStack(this._getStackId(t[e]));
            }
            _createRotatorView() {
              const t = new yg(this.editor.locale),
                e = this.editor.locale.t;
              return (
                this.view.content.add(t),
                t
                  .bind("isNavigationVisible")
                  .to(
                    this,
                    "_numberOfStacks",
                    this,
                    "_singleViewMode",
                    (t, e) => !e && t > 1
                  ),
                t.on(
                  "change:isNavigationVisible",
                  () => this.updatePosition(),
                  { priority: "low" }
                ),
                t
                  .bind("counter")
                  .to(this, "visibleView", this, "_numberOfStacks", (t, n) => {
                    if (n < 2) return "";
                    const o =
                      Array.from(this._idToStack.values()).indexOf(
                        this._visibleStack
                      ) + 1;
                    return e("%0 of %1", [o, n]);
                  }),
                t.buttonNextView.on("execute", () => {
                  t.focusTracker.isFocused && this.editor.editing.view.focus(),
                    this._showNextStack();
                }),
                t.buttonPrevView.on("execute", () => {
                  t.focusTracker.isFocused && this.editor.editing.view.focus(),
                    this._showPrevStack();
                }),
                t
              );
            }
            _createFakePanelsView() {
              const t = new xg(this.editor.locale, this.view);
              return (
                t
                  .bind("numberOfPanels")
                  .to(
                    this,
                    "_numberOfStacks",
                    this,
                    "_singleViewMode",
                    (t, e) => (!e && t >= 2 ? Math.min(t - 1, 2) : 0)
                  ),
                t.listenTo(this.view, "change:top", () => t.updatePosition()),
                t.listenTo(this.view, "change:left", () => t.updatePosition()),
                this.editor.ui.view.body.add(t),
                t
              );
            }
            _showView({
              view: t,
              balloonClassName: e = "",
              withArrow: n = !0,
              singleViewMode: o = !1,
            }) {
              (this.view.class = e),
                (this.view.withArrow = n),
                this._rotatorView.showView(t),
                (this.visibleView = t),
                this.view.pin(this._getBalloonPosition()),
                this._fakePanelsView.updatePosition(),
                o && (this._singleViewMode = !0);
            }
            _getBalloonPosition() {
              let t = Array.from(this._visibleStack.values()).pop().position;
              return (
                t &&
                  (t.limiter ||
                    (t = Object.assign({}, t, {
                      limiter: this.positionLimiter,
                    })),
                  (t = Object.assign({}, t, {
                    viewportOffsetConfig: this.editor.ui.viewportOffset,
                  }))),
                t
              );
            }
          }
          class yg extends Ch {
            constructor(t) {
              super(t);
              const e = t.t,
                n = this.bindTemplate;
              this.set("isNavigationVisible", !0),
                (this.focusTracker = new Oa()),
                (this.buttonPrevView = this._createButtonView(
                  e("Previous"),
                  kg
                )),
                (this.buttonNextView = this._createButtonView(
                  e("Next"),
                  '<svg viewBox="0 0 20 20" xmlns="http://www.w3.org/2000/svg"><path d="M8.537 14.813a.888.888 0 1 1-1.254-1.255L10.84 10 7.283 6.442a.888.888 0 1 1 1.254-1.255L12.74 9.39a.888.888 0 0 1-.16 1.382l-4.043 4.042z"/></svg>'
                )),
                (this.content = this.createCollection()),
                this.setTemplate({
                  tag: "div",
                  attributes: {
                    class: ["ck", "ck-balloon-rotator"],
                    "z-index": "-1",
                  },
                  children: [
                    {
                      tag: "div",
                      attributes: {
                        class: [
                          "ck-balloon-rotator__navigation",
                          n.to("isNavigationVisible", (t) =>
                            t ? "" : "ck-hidden"
                          ),
                        ],
                      },
                      children: [
                        this.buttonPrevView,
                        {
                          tag: "span",
                          attributes: {
                            class: ["ck-balloon-rotator__counter"],
                          },
                          children: [{ text: n.to("counter") }],
                        },
                        this.buttonNextView,
                      ],
                    },
                    {
                      tag: "div",
                      attributes: { class: "ck-balloon-rotator__content" },
                      children: this.content,
                    },
                  ],
                });
            }
            render() {
              super.render(), this.focusTracker.add(this.element);
            }
            destroy() {
              super.destroy(), this.focusTracker.destroy();
            }
            showView(t) {
              this.hideView(), this.content.add(t);
            }
            hideView() {
              this.content.clear();
            }
            _createButtonView(t, e) {
              const n = new nm(this.locale);
              return n.set({ label: t, icon: e, tooltip: !0 }), n;
            }
          }
          class xg extends Ch {
            constructor(t, e) {
              super(t);
              const n = this.bindTemplate;
              this.set("top", 0),
                this.set("left", 0),
                this.set("height", 0),
                this.set("width", 0),
                this.set("numberOfPanels", 0),
                (this.content = this.createCollection()),
                (this._balloonPanelView = e),
                this.setTemplate({
                  tag: "div",
                  attributes: {
                    class: [
                      "ck-fake-panel",
                      n.to("numberOfPanels", (t) => (t ? "" : "ck-hidden")),
                    ],
                    style: {
                      top: n.to("top", Cg),
                      left: n.to("left", Cg),
                      width: n.to("width", Cg),
                      height: n.to("height", Cg),
                    },
                  },
                  children: this.content,
                }),
                this.on("change:numberOfPanels", (t, e, n, o) => {
                  n > o ? this._addPanels(n - o) : this._removePanels(o - n),
                    this.updatePosition();
                });
            }
            _addPanels(t) {
              for (; t--; ) {
                const t = new Ch();
                t.setTemplate({ tag: "div" }),
                  this.content.add(t),
                  this.registerChild(t);
              }
            }
            _removePanels(t) {
              for (; t--; ) {
                const t = this.content.last;
                this.content.remove(t), this.deregisterChild(t), t.destroy();
              }
            }
            updatePosition() {
              if (this.numberOfPanels) {
                const { top: t, left: e } = this._balloonPanelView,
                  { width: n, height: o } = new Ma(
                    this._balloonPanelView.element
                  );
                Object.assign(this, { top: t, left: e, width: n, height: o });
              }
            }
          }
          var Eg = n(3609),
            Dg = { attributes: { "data-cke": !0 } };
          (Dg.setAttributes = is()),
            (Dg.insert = ns().bind(null, "head")),
            (Dg.domAPI = ts()),
            (Dg.insertStyleElement = ss());
          Jr()(Eg.Z, Dg);
          Eg.Z && Eg.Z.locals && Eg.Z.locals;
          const Sg = Eh("px");
          class Ig extends Ch {
            constructor(t) {
              super(t);
              const e = this.bindTemplate;
              this.set("isActive", !1),
                this.set("isSticky", !1),
                this.set("limiterElement", null),
                this.set("limiterBottomOffset", 50),
                this.set("viewportTopOffset", 0),
                this.set("_marginLeft", null),
                this.set("_isStickyToTheLimiter", !1),
                this.set("_hasViewportTopOffset", !1),
                (this.content = this.createCollection()),
                (this._contentPanelPlaceholder = new Xu({
                  tag: "div",
                  attributes: {
                    class: ["ck", "ck-sticky-panel__placeholder"],
                    style: {
                      display: e.to("isSticky", (t) => (t ? "block" : "none")),
                      height: e.to("isSticky", (t) =>
                        t ? Sg(this._panelRect.height) : null
                      ),
                    },
                  },
                }).render()),
                (this._contentPanel = new Xu({
                  tag: "div",
                  attributes: {
                    class: [
                      "ck",
                      "ck-sticky-panel__content",
                      e.if("isSticky", "ck-sticky-panel__content_sticky"),
                      e.if(
                        "_isStickyToTheLimiter",
                        "ck-sticky-panel__content_sticky_bottom-limit"
                      ),
                    ],
                    style: {
                      width: e.to("isSticky", (t) =>
                        t
                          ? Sg(
                              this._contentPanelPlaceholder.getBoundingClientRect()
                                .width
                            )
                          : null
                      ),
                      top: e.to("_hasViewportTopOffset", (t) =>
                        t ? Sg(this.viewportTopOffset) : null
                      ),
                      bottom: e.to("_isStickyToTheLimiter", (t) =>
                        t ? Sg(this.limiterBottomOffset) : null
                      ),
                      marginLeft: e.to("_marginLeft"),
                    },
                  },
                  children: this.content,
                }).render()),
                this.setTemplate({
                  tag: "div",
                  attributes: { class: ["ck", "ck-sticky-panel"] },
                  children: [this._contentPanelPlaceholder, this._contentPanel],
                });
            }
            render() {
              super.render(),
                this._checkIfShouldBeSticky(),
                this.listenTo(wo.window, "scroll", () => {
                  this._checkIfShouldBeSticky();
                }),
                this.listenTo(this, "change:isActive", () => {
                  this._checkIfShouldBeSticky();
                });
            }
            _checkIfShouldBeSticky() {
              const t = (this._panelRect =
                this._contentPanel.getBoundingClientRect());
              let e;
              this.limiterElement
                ? ((e = this._limiterRect =
                    this.limiterElement.getBoundingClientRect()),
                  (this.isSticky =
                    this.isActive &&
                    e.top < this.viewportTopOffset &&
                    this._panelRect.height + this.limiterBottomOffset <
                      e.height))
                : (this.isSticky = !1),
                this.isSticky
                  ? ((this._isStickyToTheLimiter =
                      e.bottom <
                      t.height +
                        this.limiterBottomOffset +
                        this.viewportTopOffset),
                    (this._hasViewportTopOffset =
                      !this._isStickyToTheLimiter && !!this.viewportTopOffset),
                    (this._marginLeft = this._isStickyToTheLimiter
                      ? null
                      : Sg(-wo.window.scrollX)))
                  : ((this._isStickyToTheLimiter = !1),
                    (this._hasViewportTopOffset = !1),
                    (this._marginLeft = null));
            }
          }
          Eh("px");
          var Tg = n(6706),
            Mg = { attributes: { "data-cke": !0 } };
          (Mg.setAttributes = is()),
            (Mg.insert = ns().bind(null, "head")),
            (Mg.domAPI = ts()),
            (Mg.insertStyleElement = ss());
          Jr()(Tg.Z, Mg);
          Tg.Z && Tg.Z.locals && Tg.Z.locals, Eh("px");
          Eh("px");
          class Bg extends jh {
            constructor(t, e) {
              super(t),
                (this.view = e),
                (this._toolbarConfig = Em(t.config.get("toolbar"))),
                (this._elementReplacer = new xa());
            }
            get element() {
              return this.view.element;
            }
            init(t) {
              const e = this.editor,
                n = this.view,
                o = e.editing.view,
                i = n.editable,
                r = o.document.getRoot();
              (i.name = r.rootName), n.render();
              const s = i.element;
              this.setEditableElement(i.name, s),
                n.editable.bind("isFocused").to(this.focusTracker),
                o.attachDomRoot(s),
                t && this._elementReplacer.replace(t, this.element),
                this._initPlaceholder(),
                this._initToolbar(),
                this.fire("ready");
            }
            destroy() {
              super.destroy();
              const t = this.view,
                e = this.editor.editing.view;
              this._elementReplacer.restore(),
                e.detachDomRoot(t.editable.name),
                t.destroy();
            }
            _initToolbar() {
              const t = this.view;
              t.stickyPanel.bind("isActive").to(this.focusTracker, "isFocused"),
                (t.stickyPanel.limiterElement = t.element),
                t.stickyPanel
                  .bind("viewportTopOffset")
                  .to(this, "viewportOffset", ({ top: t }) => t),
                t.toolbar.fillFromConfig(
                  this._toolbarConfig,
                  this.componentFactory
                ),
                this.addToolbar(t.toolbar);
            }
            _initPlaceholder() {
              const t = this.editor,
                e = t.editing.view,
                n = e.document.getRoot(),
                o = t.sourceElement,
                i =
                  t.config.get("placeholder") ||
                  (o &&
                    "textarea" === o.tagName.toLowerCase() &&
                    o.getAttribute("placeholder"));
              i &&
                Rd({
                  view: e,
                  element: n,
                  text: i,
                  isDirectHost: !1,
                  keepOnFocus: !0,
                });
            }
          }
          var Ng = n(3638),
            zg = { attributes: { "data-cke": !0 } };
          (zg.setAttributes = is()),
            (zg.insert = ns().bind(null, "head")),
            (zg.domAPI = ts()),
            (zg.insertStyleElement = ss());
          Jr()(Ng.Z, zg);
          Ng.Z && Ng.Z.locals && Ng.Z.locals;
          class Pg extends tg {
            constructor(t, e, n = {}) {
              super(t),
                (this.stickyPanel = new Ig(t)),
                (this.toolbar = new Mm(t, {
                  shouldGroupWhenFull: n.shouldToolbarGroupWhenFull,
                })),
                (this.editable = new ng(t, e));
            }
            render() {
              super.render(),
                this.stickyPanel.content.add(this.toolbar),
                this.top.add(this.stickyPanel),
                this.main.add(this.editable);
            }
          }
          class Lg extends Yu {
            constructor(t, e = {}) {
              if (!co(t) && void 0 !== e.initialData)
                throw new l("editor-create-initial-data", null);
              super(e),
                void 0 === this.config.get("initialData") &&
                  this.config.set(
                    "initialData",
                    (function (t) {
                      return co(t)
                        ? ((e = t),
                          e instanceof HTMLTextAreaElement
                            ? e.value
                            : e.innerHTML)
                        : t;
                      var e;
                    })(t)
                  ),
                co(t) && (this.sourceElement = t),
                this.model.document.createRoot();
              const n = !this.config.get("toolbar.shouldNotGroupWhenFull"),
                o = new Pg(this.locale, this.editing.view, {
                  shouldToolbarGroupWhenFull: n,
                });
              (this.ui = new Bg(this, o)),
                (function (t) {
                  if (!Et(t.updateSourceElement))
                    throw new l("attachtoform-missing-elementapi-interface", t);
                  const e = t.sourceElement;
                  if (
                    (function (t) {
                      return !!t && "textarea" === t.tagName.toLowerCase();
                    })(e) &&
                    e.form
                  ) {
                    let n;
                    const o = e.form,
                      i = () => t.updateSourceElement();
                    Et(o.submit) &&
                      ((n = o.submit),
                      (o.submit = () => {
                        i(), n.apply(o);
                      })),
                      o.addEventListener("submit", i),
                      t.on("destroy", () => {
                        o.removeEventListener("submit", i), n && (o.submit = n);
                      });
                  }
                })(this);
            }
            destroy() {
              return (
                this.sourceElement && this.updateSourceElement(),
                this.ui.destroy(),
                super.destroy()
              );
            }
            static create(t, e = {}) {
              return new Promise((n) => {
                const o = new this(t, e);
                n(
                  o
                    .initPlugins()
                    .then(() => o.ui.init(co(t) ? t : null))
                    .then(() => o.data.init(o.config.get("initialData")))
                    .then(() => o.fire("ready"))
                    .then(() => o)
                );
              });
            }
          }
          ya(Lg, Fh), ya(Lg, Uh);
          const Rg = ["left", "right", "center", "justify"];
          function Og(t) {
            return Rg.includes(t);
          }
          function jg(t, e) {
            return "rtl" == e.contentLanguageDirection
              ? "right" === t
              : "left" === t;
          }
          function Vg(t) {
            const e = t
                .map((t) => {
                  let e;
                  return (e = "string" == typeof t ? { name: t } : t), e;
                })
                .filter((t) => {
                  const e = !!Rg.includes(t.name);
                  return (
                    e ||
                      c("alignment-config-name-not-recognized", { option: t }),
                    e
                  );
                }),
              n = e.filter((t) => !!t.className).length;
            if (n && n < e.length)
              throw new l("alignment-config-classnames-are-missing", {
                configuredOptions: t,
              });
            return (
              e.forEach((e, n, o) => {
                const i = o.slice(n + 1);
                if (i.some((t) => t.name == e.name))
                  throw new l("alignment-config-name-already-defined", {
                    option: e,
                    configuredOptions: t,
                  });
                if (e.className) {
                  if (i.some((t) => t.className == e.className))
                    throw new l("alignment-config-classname-already-defined", {
                      option: e,
                      configuredOptions: t,
                    });
                }
              }),
              e
            );
          }
          const Fg = "alignment";
          class Hg extends F {
            refresh() {
              const t = this.editor.locale,
                e = Ra(
                  this.editor.model.document.selection.getSelectedBlocks()
                );
              (this.isEnabled = !!e && this._canBeAligned(e)),
                this.isEnabled && e.hasAttribute("alignment")
                  ? (this.value = e.getAttribute("alignment"))
                  : (this.value =
                      "rtl" === t.contentLanguageDirection ? "right" : "left");
            }
            execute(t = {}) {
              const e = this.editor,
                n = e.locale,
                o = e.model,
                i = o.document,
                r = t.value;
              o.change((t) => {
                const e = Array.from(i.selection.getSelectedBlocks()).filter(
                    (t) => this._canBeAligned(t)
                  ),
                  o = e[0].getAttribute("alignment");
                jg(r, n) || o === r || !r
                  ? (function (t, e) {
                      for (const n of t) e.removeAttribute(Fg, n);
                    })(e, t)
                  : (function (t, e, n) {
                      for (const o of t) e.setAttribute(Fg, n, o);
                    })(e, t, r);
              });
            }
            _canBeAligned(t) {
              return this.editor.model.schema.checkAttribute(t, Fg);
            }
          }
          class Ug extends j {
            static get pluginName() {
              return "AlignmentEditing";
            }
            constructor(t) {
              super(t),
                t.config.define("alignment", {
                  options: [...Rg.map((t) => ({ name: t }))],
                });
            }
            init() {
              const t = this.editor,
                e = t.locale,
                n = t.model.schema,
                o = Vg(t.config.get("alignment.options")).filter(
                  (t) => Og(t.name) && !jg(t.name, e)
                ),
                i = o.some((t) => !!t.className);
              n.extend("$block", { allowAttributes: "alignment" }),
                t.model.schema.setAttributeProperties("alignment", {
                  isFormatting: !0,
                }),
                i
                  ? t.conversion.attributeToAttribute(
                      (function (t) {
                        const e = {
                          model: {
                            key: "alignment",
                            values: t.map((t) => t.name),
                          },
                          view: {},
                        };
                        for (const n of t)
                          e.view[n.name] = { key: "class", value: n.className };
                        return e;
                      })(o)
                    )
                  : t.conversion.for("downcast").attributeToAttribute(
                      (function (t) {
                        const e = {
                          model: {
                            key: "alignment",
                            values: t.map((t) => t.name),
                          },
                          view: {},
                        };
                        for (const { name: n } of t)
                          e.view[n] = {
                            key: "style",
                            value: { "text-align": n },
                          };
                        return e;
                      })(o)
                    );
              const r = (function (t) {
                const e = [];
                for (const { name: n } of t)
                  e.push({
                    view: { key: "style", value: { "text-align": n } },
                    model: { key: "alignment", value: n },
                  });
                return e;
              })(o);
              for (const e of r)
                t.conversion.for("upcast").attributeToAttribute(e);
              const s = (function (t) {
                const e = [];
                for (const { name: n } of t)
                  e.push({
                    view: { key: "align", value: n },
                    model: { key: "alignment", value: n },
                  });
                return e;
              })(o);
              for (const e of s)
                t.conversion.for("upcast").attributeToAttribute(e);
              t.commands.add("alignment", new Hg(t));
            }
          }
          const Wg = new Map([
            ["left", $h.alignLeft],
            ["right", $h.alignRight],
            ["center", $h.alignCenter],
            ["justify", $h.alignJustify],
          ]);
          class $g extends j {
            get localizedOptionTitles() {
              const t = this.editor.t;
              return {
                left: t("Align left"),
                right: t("Align right"),
                center: t("Align center"),
                justify: t("Justify"),
              };
            }
            static get pluginName() {
              return "AlignmentUI";
            }
            init() {
              const t = this.editor,
                e = t.ui.componentFactory,
                n = t.t,
                o = Vg(t.config.get("alignment.options"));
              o
                .map((t) => t.name)
                .filter(Og)
                .forEach((t) => this._addButton(t)),
                e.add("alignment", (i) => {
                  const r = Wm(i),
                    s = o.map((t) => e.create(`alignment:${t.name}`));
                  $m(r, s, { enableActiveItemFocusOnDropdownOpen: !0 }),
                    r.buttonView.set({
                      label: n("Text alignment"),
                      tooltip: !0,
                    }),
                    (r.toolbarView.isVertical = !0),
                    (r.toolbarView.ariaLabel = n("Text alignment toolbar")),
                    r.extendTemplate({
                      attributes: { class: "ck-alignment-dropdown" },
                    });
                  const a =
                    "rtl" === i.contentLanguageDirection
                      ? Wg.get("right")
                      : Wg.get("left");
                  return (
                    r.buttonView.bind("icon").toMany(s, "isOn", (...t) => {
                      const e = t.findIndex((t) => t);
                      return e < 0 ? a : s[e].icon;
                    }),
                    r
                      .bind("isEnabled")
                      .toMany(s, "isEnabled", (...t) => t.some((t) => t)),
                    this.listenTo(r, "execute", () => {
                      t.editing.view.focus();
                    }),
                    r
                  );
                });
            }
            _addButton(t) {
              const e = this.editor;
              e.ui.componentFactory.add(`alignment:${t}`, (n) => {
                const o = e.commands.get("alignment"),
                  i = new nm(n);
                return (
                  i.set({
                    label: this.localizedOptionTitles[t],
                    icon: Wg.get(t),
                    tooltip: !0,
                    isToggleable: !0,
                  }),
                  i.bind("isEnabled").to(o),
                  i.bind("isOn").to(o, "value", (e) => e === t),
                  this.listenTo(i, "execute", () => {
                    e.execute("alignment", { value: t }),
                      e.editing.view.focus();
                  }),
                  i
                );
              });
            }
          }
          class qg {
            constructor(t, e = 20) {
              (this._batch = null),
                (this.model = t),
                (this._size = 0),
                (this.limit = e),
                (this._isLocked = !1),
                (this._changeCallback = (t, e) => {
                  e.isLocal &&
                    e.isUndoable &&
                    e !== this._batch &&
                    this._reset(!0);
                }),
                (this._selectionChangeCallback = () => {
                  this._reset();
                }),
                this.model.document.on("change", this._changeCallback),
                this.model.document.selection.on(
                  "change:range",
                  this._selectionChangeCallback
                ),
                this.model.document.selection.on(
                  "change:attribute",
                  this._selectionChangeCallback
                );
            }
            get batch() {
              return (
                this._batch ||
                  (this._batch = this.model.createBatch({ isTyping: !0 })),
                this._batch
              );
            }
            get size() {
              return this._size;
            }
            input(t) {
              (this._size += t), this._size >= this.limit && this._reset(!0);
            }
            get isLocked() {
              return this._isLocked;
            }
            lock() {
              this._isLocked = !0;
            }
            unlock() {
              this._isLocked = !1;
            }
            destroy() {
              this.model.document.off("change", this._changeCallback),
                this.model.document.selection.off(
                  "change:range",
                  this._selectionChangeCallback
                ),
                this.model.document.selection.off(
                  "change:attribute",
                  this._selectionChangeCallback
                );
            }
            _reset(t = !1) {
              (this.isLocked && !t) || ((this._batch = null), (this._size = 0));
            }
          }
          class Gg extends F {
            constructor(t, e) {
              super(t), (this._buffer = new qg(t.model, e));
            }
            get buffer() {
              return this._buffer;
            }
            destroy() {
              super.destroy(), this._buffer.destroy();
            }
            execute(t = {}) {
              const e = this.editor.model,
                n = e.document,
                o = t.text || "",
                i = o.length;
              let r = n.selection;
              t.selection
                ? (r = t.selection)
                : t.range && (r = e.createSelection(t.range));
              const s = t.resultRange;
              e.enqueueChange(this._buffer.batch, (t) => {
                this._buffer.lock(),
                  e.deleteContent(r),
                  o &&
                    e.insertContent(
                      t.createText(o, n.selection.getAttributes()),
                      r
                    ),
                  s
                    ? t.setSelection(s)
                    : r.is("documentSelection") || t.setSelection(r),
                  this._buffer.unlock(),
                  this._buffer.input(i);
              });
            }
          }
          const Zg = ["insertText", "insertReplacementText"];
          class Yg extends Ms {
            constructor(t) {
              super(t), ar.isAndroid && Zg.push("insertCompositionText");
              const n = t.document;
              n.on("beforeinput", (o, i) => {
                if (!this.isEnabled) return;
                const {
                  data: r,
                  targetRanges: s,
                  inputType: a,
                  domEvent: l,
                } = i;
                if (!Zg.includes(a)) return;
                const c = new e(n, "insertText");
                n.fire(
                  c,
                  new Ns(t, l, { text: r, selection: t.createSelection(s) })
                ),
                  c.stop.called && o.stop();
              }),
                n.on(
                  "compositionend",
                  (e, { data: o, domEvent: i }) => {
                    this.isEnabled &&
                      !ar.isAndroid &&
                      o &&
                      n.fire(
                        "insertText",
                        new Ns(t, i, { text: o, selection: n.selection })
                      );
                  },
                  { priority: "lowest" }
                );
            }
            observe() {}
          }
          class Kg extends j {
            static get pluginName() {
              return "Input";
            }
            init() {
              const t = this.editor,
                e = t.model,
                n = t.editing.view,
                o = e.document.selection;
              n.addObserver(Yg);
              const i = new Gg(t, t.config.get("typing.undoStep") || 20);
              t.commands.add("insertText", i),
                t.commands.add("input", i),
                this.listenTo(n.document, "insertText", (o, i) => {
                  n.document.isComposing || i.preventDefault();
                  const { text: r, selection: s, resultRange: a } = i,
                    l = Array.from(s.getRanges()).map((e) =>
                      t.editing.mapper.toModelRange(e)
                    );
                  let c = r;
                  if (ar.isAndroid) {
                    const t = Array.from(l[0].getItems()).reduce(
                      (t, e) => t + (e.is("$textProxy") ? e.data : ""),
                      ""
                    );
                    t &&
                      (t.length <= c.length
                        ? c.startsWith(t) &&
                          ((c = c.substring(t.length)),
                          (l[0].start = l[0].start.getShiftedBy(t.length)))
                        : t.startsWith(c) &&
                          ((l[0].start = l[0].start.getShiftedBy(c.length)),
                          (c = "")));
                  }
                  const d = { text: c, selection: e.createSelection(l) };
                  a && (d.resultRange = t.editing.mapper.toModelRange(a)),
                    t.execute("insertText", d);
                }),
                ar.isAndroid
                  ? this.listenTo(n.document, "keydown", (t, r) => {
                      !o.isCollapsed &&
                        229 == r.keyCode &&
                        n.document.isComposing &&
                        Qg(e, i);
                    })
                  : this.listenTo(n.document, "compositionstart", () => {
                      o.isCollapsed || Qg(e, i);
                    });
            }
          }
          function Qg(t, e) {
            if (!e.isEnabled) return;
            const n = e.buffer;
            n.lock(),
              t.enqueueChange(n.batch, () => {
                t.deleteContent(t.document.selection);
              }),
              n.unlock();
          }
          class Jg extends F {
            constructor(t, e) {
              super(t),
                (this.direction = e),
                (this._buffer = new qg(
                  t.model,
                  t.config.get("typing.undoStep")
                ));
            }
            get buffer() {
              return this._buffer;
            }
            execute(t = {}) {
              const e = this.editor.model,
                n = e.document;
              e.enqueueChange(this._buffer.batch, (o) => {
                this._buffer.lock();
                const i = o.createSelection(t.selection || n.selection),
                  r = t.sequence || 1,
                  s = i.isCollapsed;
                if (
                  (i.isCollapsed &&
                    e.modifySelection(i, {
                      direction: this.direction,
                      unit: t.unit,
                      treatEmojiAsSingleUnit: !0,
                    }),
                  this._shouldEntireContentBeReplacedWithParagraph(r))
                )
                  return void this._replaceEntireContentWithParagraph(o);
                if (this._shouldReplaceFirstBlockWithParagraph(i, r))
                  return void this.editor.execute("paragraph", {
                    selection: i,
                  });
                if (i.isCollapsed) return;
                let a = 0;
                i
                  .getFirstRange()
                  .getMinimalFlatRanges()
                  .forEach((t) => {
                    a += Ui(
                      t.getWalker({
                        singleCharacters: !0,
                        ignoreElementEnd: !0,
                        shallow: !0,
                      })
                    );
                  }),
                  e.deleteContent(i, {
                    doNotResetEntireContent: s,
                    direction: this.direction,
                  }),
                  this._buffer.input(a),
                  o.setSelection(i),
                  this._buffer.unlock();
              });
            }
            _shouldEntireContentBeReplacedWithParagraph(t) {
              if (t > 1) return !1;
              const e = this.editor.model,
                n = e.document.selection,
                o = e.schema.getLimitElement(n);
              if (!(n.isCollapsed && n.containsEntireContent(o))) return !1;
              if (!e.schema.checkChild(o, "paragraph")) return !1;
              const i = o.getChild(0);
              return !i || !i.is("element", "paragraph");
            }
            _replaceEntireContentWithParagraph(t) {
              const e = this.editor.model,
                n = e.document.selection,
                o = e.schema.getLimitElement(n),
                i = t.createElement("paragraph");
              t.remove(t.createRangeIn(o)),
                t.insert(i, o),
                t.setSelection(i, 0);
            }
            _shouldReplaceFirstBlockWithParagraph(t, e) {
              const n = this.editor.model;
              if (e > 1 || "backward" != this.direction) return !1;
              if (!t.isCollapsed) return !1;
              const o = t.getFirstPosition(),
                i = n.schema.getLimitElement(o),
                r = i.getChild(0);
              return (
                o.parent == r &&
                !!t.containsEntireContent(r) &&
                !!n.schema.checkChild(i, "paragraph") &&
                "paragraph" != r.name
              );
            }
          }
          const Xg = "word",
            tp = "selection",
            ep = "backward",
            np = "forward",
            op = {
              deleteContent: { unit: tp, direction: ep },
              deleteContentBackward: { unit: "codePoint", direction: ep },
              deleteWordBackward: { unit: Xg, direction: ep },
              deleteHardLineBackward: { unit: tp, direction: ep },
              deleteSoftLineBackward: { unit: tp, direction: ep },
              deleteContentForward: { unit: "character", direction: np },
              deleteWordForward: { unit: Xg, direction: np },
              deleteHardLineForward: { unit: tp, direction: np },
              deleteSoftLineForward: { unit: tp, direction: np },
            };
          class ip extends Ms {
            constructor(t) {
              super(t);
              const e = t.document;
              let n = 0;
              e.on("keydown", () => {
                n++;
              }),
                e.on("keyup", () => {
                  n = 0;
                }),
                e.on("beforeinput", (o, i) => {
                  if (!this.isEnabled) return;
                  const { targetRanges: r, domEvent: s, inputType: a } = i,
                    l = op[a];
                  if (!l) return;
                  const c = {
                    direction: l.direction,
                    unit: l.unit,
                    sequence: n,
                  };
                  c.unit == tp &&
                    (c.selectionToRemove = t.createSelection(r[0])),
                    ar.isAndroid &&
                      "deleteContentBackward" === a &&
                      ((c.sequence = 1),
                      1 != r.length ||
                        (r[0].start.parent == r[0].end.parent &&
                          r[0].start.offset + 1 == r[0].end.offset) ||
                        ((c.unit = tp),
                        (c.selectionToRemove = t.createSelection(r))));
                  const d = new qi(e, "delete", r[0]);
                  e.fire(d, new Ns(t, s, c)), d.stop.called && o.stop();
                }),
                ar.isBlink &&
                  (function (t) {
                    const e = t.view,
                      n = e.document;
                    let o = null,
                      i = !1;
                    function r(t) {
                      return t == ur.backspace || t == ur.delete;
                    }
                    function s(t) {
                      return t == ur.backspace ? ep : np;
                    }
                    n.on("keydown", (t, { keyCode: e }) => {
                      (o = e), (i = !1);
                    }),
                      n.on("keyup", (a, { keyCode: l, domEvent: c }) => {
                        const d = n.selection,
                          u =
                            t.isEnabled &&
                            l == o &&
                            r(l) &&
                            !d.isCollapsed &&
                            !i;
                        if (((o = null), u)) {
                          const t = d.getFirstRange(),
                            o = new qi(n, "delete", t),
                            i = {
                              unit: tp,
                              direction: s(l),
                              selectionToRemove: d,
                            };
                          n.fire(o, new Ns(e, c, i));
                        }
                      }),
                      n.on("beforeinput", (t, { inputType: e }) => {
                        const n = op[e];
                        r(o) && n && n.direction == s(o) && (i = !0);
                      }),
                      n.on(
                        "beforeinput",
                        (t, { inputType: e, data: n }) => {
                          o == ur.delete &&
                            "insertText" == e &&
                            "" == n &&
                            t.stop();
                        },
                        { priority: "high" }
                      );
                  })(this);
            }
            observe() {}
          }
          class rp extends j {
            static get pluginName() {
              return "Delete";
            }
            init() {
              const t = this.editor,
                e = t.editing.view,
                n = e.document,
                o = t.model.document;
              e.addObserver(ip), (this._undoOnBackspace = !1);
              const i = new Jg(t, "forward");
              t.commands.add("deleteForward", i),
                t.commands.add("forwardDelete", i),
                t.commands.add("delete", new Jg(t, "backward")),
                this.listenTo(
                  n,
                  "delete",
                  (o, i) => {
                    n.isComposing || i.preventDefault();
                    const {
                        direction: r,
                        sequence: s,
                        selectionToRemove: a,
                        unit: l,
                      } = i,
                      c = "forward" === r ? "deleteForward" : "delete",
                      d = { sequence: s };
                    if ("selection" == l) {
                      const e = Array.from(a.getRanges()).map((e) =>
                        t.editing.mapper.toModelRange(e)
                      );
                      d.selection = t.model.createSelection(e);
                    } else d.unit = l;
                    t.execute(c, d), e.scrollToTheSelection();
                  },
                  { priority: "low" }
                ),
                this.editor.plugins.has("UndoEditing") &&
                  (this.listenTo(
                    n,
                    "delete",
                    (e, n) => {
                      this._undoOnBackspace &&
                        "backward" == n.direction &&
                        1 == n.sequence &&
                        "codePoint" == n.unit &&
                        ((this._undoOnBackspace = !1),
                        t.execute("undo"),
                        n.preventDefault(),
                        e.stop());
                    },
                    { context: "$capture" }
                  ),
                  this.listenTo(o, "change", () => {
                    this._undoOnBackspace = !1;
                  }));
            }
            requestUndoOnBackspace() {
              this.editor.plugins.has("UndoEditing") &&
                (this._undoOnBackspace = !0);
            }
          }
          class sp extends j {
            static get requires() {
              return [Kg, rp];
            }
            static get pluginName() {
              return "Typing";
            }
          }
          function ap(t, e) {
            let n = t.start;
            return {
              text: Array.from(t.getItems()).reduce(
                (t, o) =>
                  o.is("$text") || o.is("$textProxy")
                    ? t + o.data
                    : ((n = e.createPositionAfter(o)), ""),
                ""
              ),
              range: e.createRange(n, t.end),
            };
          }
          class lp extends N {
            constructor(t, e) {
              super(),
                (this.model = t),
                (this.testCallback = e),
                (this._hasMatch = !1),
                this.set("isEnabled", !0),
                this.on("change:isEnabled", () => {
                  this.isEnabled
                    ? this._startListening()
                    : (this.stopListening(t.document.selection),
                      this.stopListening(t.document));
                }),
                this._startListening();
            }
            get hasMatch() {
              return this._hasMatch;
            }
            _startListening() {
              const t = this.model.document;
              this.listenTo(
                t.selection,
                "change:range",
                (e, { directChange: n }) => {
                  n &&
                    (t.selection.isCollapsed
                      ? this._evaluateTextBeforeSelection("selection")
                      : this.hasMatch &&
                        (this.fire("unmatched"), (this._hasMatch = !1)));
                }
              ),
                this.listenTo(t, "change:data", (t, e) => {
                  !e.isUndo &&
                    e.isLocal &&
                    this._evaluateTextBeforeSelection("data", { batch: e });
                });
            }
            _evaluateTextBeforeSelection(t, e = {}) {
              const n = this.model,
                o = n.document.selection,
                i = n.createRange(
                  n.createPositionAt(o.focus.parent, 0),
                  o.focus
                ),
                { text: r, range: s } = ap(i, n),
                a = this.testCallback(r);
              if (
                (!a && this.hasMatch && this.fire("unmatched"),
                (this._hasMatch = !!a),
                a)
              ) {
                const n = Object.assign(e, { text: r, range: s });
                "object" == typeof a && Object.assign(n, a),
                  this.fire(`matched:${t}`, n);
              }
            }
          }
          class cp extends j {
            static get pluginName() {
              return "TwoStepCaretMovement";
            }
            constructor(t) {
              super(t),
                (this.attributes = new Set()),
                (this._overrideUid = null);
            }
            init() {
              const t = this.editor,
                e = t.model,
                n = t.editing.view,
                o = t.locale,
                i = e.document.selection;
              this.listenTo(
                n.document,
                "arrowKey",
                (t, e) => {
                  if (!i.isCollapsed) return;
                  if (e.shiftKey || e.altKey || e.ctrlKey) return;
                  const n = e.keyCode == ur.arrowright,
                    r = e.keyCode == ur.arrowleft;
                  if (!n && !r) return;
                  const s = o.contentLanguageDirection;
                  let a = !1;
                  (a =
                    ("ltr" === s && n) || ("rtl" === s && r)
                      ? this._handleForwardMovement(e)
                      : this._handleBackwardMovement(e)),
                    !0 === a && t.stop();
                },
                { context: "$text", priority: "highest" }
              ),
                (this._isNextGravityRestorationSkipped = !1),
                this.listenTo(i, "change:range", (t, e) => {
                  this._isNextGravityRestorationSkipped
                    ? (this._isNextGravityRestorationSkipped = !1)
                    : this._isGravityOverridden &&
                      ((!e.directChange &&
                        mp(i.getFirstPosition(), this.attributes)) ||
                        this._restoreGravity());
                });
            }
            registerAttribute(t) {
              this.attributes.add(t);
            }
            _handleForwardMovement(t) {
              const e = this.attributes,
                n = this.editor.model.document.selection,
                o = n.getFirstPosition();
              return (
                !this._isGravityOverridden &&
                (!o.isAtStart || !dp(n, e)) &&
                !!mp(o, e) &&
                (hp(t), this._overrideGravity(), !0)
              );
            }
            _handleBackwardMovement(t) {
              const e = this.attributes,
                n = this.editor.model,
                o = n.document.selection,
                i = o.getFirstPosition();
              return this._isGravityOverridden
                ? (hp(t), this._restoreGravity(), up(n, e, i), !0)
                : i.isAtStart
                ? !!dp(o, e) && (hp(t), up(n, e, i), !0)
                : !!(function (t, e) {
                    return mp(t.getShiftedBy(-1), e);
                  })(i, e) &&
                  (i.isAtEnd && !dp(o, e) && mp(i, e)
                    ? (hp(t), up(n, e, i), !0)
                    : ((this._isNextGravityRestorationSkipped = !0),
                      this._overrideGravity(),
                      !1));
            }
            get _isGravityOverridden() {
              return !!this._overrideUid;
            }
            _overrideGravity() {
              this._overrideUid = this.editor.model.change((t) =>
                t.overrideSelectionGravity()
              );
            }
            _restoreGravity() {
              this.editor.model.change((t) => {
                t.restoreSelectionGravity(this._overrideUid),
                  (this._overrideUid = null);
              });
            }
          }
          function dp(t, e) {
            for (const n of e) if (t.hasAttribute(n)) return !0;
            return !1;
          }
          function up(t, e, n) {
            const o = n.nodeBefore;
            t.change((t) => {
              o
                ? t.setSelectionAttribute(o.getAttributes())
                : t.removeSelectionAttribute(e);
            });
          }
          function hp(t) {
            t.preventDefault();
          }
          function mp(t, e) {
            const { nodeBefore: n, nodeAfter: o } = t;
            for (const t of e) {
              const e = n ? n.getAttribute(t) : void 0;
              if ((o ? o.getAttribute(t) : void 0) !== e) return !0;
            }
            return !1;
          }
          var gp = /[\\^$.*+?()[\]{}|]/g,
            pp = RegExp(gp.source);
          const fp = function (t) {
              return (t = Ko(t)) && pp.test(t) ? t.replace(gp, "\\$&") : t;
            },
            kp = {
              copyright: { from: "(c)", to: "©" },
              registeredTrademark: { from: "(r)", to: "®" },
              trademark: { from: "(tm)", to: "™" },
              oneHalf: {
                from: /(^|[^/a-z0-9])(1\/2)([^/a-z0-9])$/i,
                to: [null, "½", null],
              },
              oneThird: {
                from: /(^|[^/a-z0-9])(1\/3)([^/a-z0-9])$/i,
                to: [null, "⅓", null],
              },
              twoThirds: {
                from: /(^|[^/a-z0-9])(2\/3)([^/a-z0-9])$/i,
                to: [null, "⅔", null],
              },
              oneForth: {
                from: /(^|[^/a-z0-9])(1\/4)([^/a-z0-9])$/i,
                to: [null, "¼", null],
              },
              threeQuarters: {
                from: /(^|[^/a-z0-9])(3\/4)([^/a-z0-9])$/i,
                to: [null, "¾", null],
              },
              lessThanOrEqual: { from: "<=", to: "≤" },
              greaterThanOrEqual: { from: ">=", to: "≥" },
              notEqual: { from: "!=", to: "≠" },
              arrowLeft: { from: "<-", to: "←" },
              arrowRight: { from: "->", to: "→" },
              horizontalEllipsis: { from: "...", to: "…" },
              enDash: { from: /(^| )(--)( )$/, to: [null, "–", null] },
              emDash: { from: /(^| )(---)( )$/, to: [null, "—", null] },
              quotesPrimary: { from: vp('"'), to: [null, "“", null, "”"] },
              quotesSecondary: { from: vp("'"), to: [null, "‘", null, "’"] },
              quotesPrimaryEnGb: { from: vp("'"), to: [null, "‘", null, "’"] },
              quotesSecondaryEnGb: {
                from: vp('"'),
                to: [null, "“", null, "”"],
              },
              quotesPrimaryPl: { from: vp('"'), to: [null, "„", null, "”"] },
              quotesSecondaryPl: { from: vp("'"), to: [null, "‚", null, "’"] },
            },
            bp = {
              symbols: ["copyright", "registeredTrademark", "trademark"],
              mathematical: [
                "oneHalf",
                "oneThird",
                "twoThirds",
                "oneForth",
                "threeQuarters",
                "lessThanOrEqual",
                "greaterThanOrEqual",
                "notEqual",
                "arrowLeft",
                "arrowRight",
              ],
              typography: ["horizontalEllipsis", "enDash", "emDash"],
              quotes: ["quotesPrimary", "quotesSecondary"],
            },
            wp = ["symbols", "mathematical", "typography", "quotes"];
          function Ap(t) {
            return "string" == typeof t ? new RegExp(`(${fp(t)})$`) : t;
          }
          function _p(t) {
            return "string" == typeof t
              ? () => [t]
              : t instanceof Array
              ? () => t
              : t;
          }
          function Cp(t) {
            return (t.textNode ? t.textNode : t.nodeAfter).getAttributes();
          }
          function vp(t) {
            return new RegExp(`(^|\\s)(${t})([^${t}]*)(${t})$`);
          }
          function yp(t, e, n, o) {
            return o.createRange(xp(t, e, n, !0, o), xp(t, e, n, !1, o));
          }
          function xp(t, e, n, o, i) {
            let r = t.textNode || (o ? t.nodeBefore : t.nodeAfter),
              s = null;
            for (; r && r.getAttribute(e) == n; )
              (s = r), (r = o ? r.previousSibling : r.nextSibling);
            return s ? i.createPositionAt(s, o ? "before" : "after") : t;
          }
          function Ep(t, e, n, o) {
            const i = t.editing.view,
              r = new Set();
            i.document.registerPostFixer((i) => {
              const s = t.model.document.selection;
              let a = !1;
              if (s.hasAttribute(e)) {
                const l = yp(
                    s.getFirstPosition(),
                    e,
                    s.getAttribute(e),
                    t.model
                  ),
                  c = t.editing.mapper.toViewRange(l);
                for (const t of c.getItems())
                  t.is("element", n) &&
                    !t.hasClass(o) &&
                    (i.addClass(o, t), r.add(t), (a = !0));
              }
              return a;
            }),
              t.conversion.for("editingDowncast").add((t) => {
                function e() {
                  i.change((t) => {
                    for (const e of r.values())
                      t.removeClass(o, e), r.delete(e);
                  });
                }
                t.on("insert", e, { priority: "highest" }),
                  t.on("remove", e, { priority: "highest" }),
                  t.on("attribute", e, { priority: "highest" }),
                  t.on("selection", e, { priority: "highest" });
              });
          }
          function Dp(t, e, n, o) {
            let i,
              r = null;
            "function" == typeof o
              ? (i = o)
              : ((r = t.commands.get(o)),
                (i = () => {
                  t.execute(o);
                })),
              t.model.document.on("change:data", (s, a) => {
                if ((r && !r.isEnabled) || !e.isEnabled) return;
                const l = Ra(t.model.document.selection.getRanges());
                if (!l.isCollapsed) return;
                if (a.isUndo || !a.isLocal) return;
                const c = Array.from(t.model.document.differ.getChanges()),
                  d = c[0];
                if (
                  1 != c.length ||
                  "insert" !== d.type ||
                  "$text" != d.name ||
                  1 != d.length
                )
                  return;
                const u = d.position.parent;
                if (u.is("element", "codeBlock")) return;
                if (
                  u.is("element", "listItem") &&
                  "function" != typeof o &&
                  !["numberedList", "bulletedList", "todoList"].includes(o)
                )
                  return;
                if (r && !0 === r.value) return;
                const h = u.getChild(0),
                  m = t.model.createRangeOn(h);
                if (!m.containsRange(l) && !l.end.isEqual(m.end)) return;
                const g = n.exec(h.data.substr(0, l.end.offset));
                g &&
                  t.model.enqueueChange((e) => {
                    const n = e.createPositionAt(u, 0),
                      o = e.createPositionAt(u, g[0].length),
                      r = new xl(n, o);
                    if (!1 !== i({ match: g })) {
                      e.remove(r);
                      const n = t.model.document.selection.getFirstRange(),
                        o = e.createRangeIn(u);
                      !u.isEmpty ||
                        o.isEqual(n) ||
                        o.containsRange(n, !0) ||
                        e.remove(u);
                    }
                    r.detach(),
                      t.model.enqueueChange(() => {
                        t.plugins.get("Delete").requestUndoOnBackspace();
                      });
                  });
              });
          }
          function Sp(t, e, n, o) {
            let i, r;
            n instanceof RegExp ? (i = n) : (r = n),
              (r =
                r ||
                ((t) => {
                  let e;
                  const n = [],
                    o = [];
                  for (; null !== (e = i.exec(t)) && !(e && e.length < 4); ) {
                    let { index: t, 1: i, 2: r, 3: s } = e;
                    const a = i + r + s;
                    t += e[0].length - a.length;
                    const l = [t, t + i.length],
                      c = [
                        t + i.length + r.length,
                        t + i.length + r.length + s.length,
                      ];
                    n.push(l),
                      n.push(c),
                      o.push([t + i.length, t + i.length + r.length]);
                  }
                  return { remove: n, format: o };
                })),
              t.model.document.on("change:data", (n, i) => {
                if (i.isUndo || !i.isLocal || !e.isEnabled) return;
                const s = t.model,
                  a = s.document.selection;
                if (!a.isCollapsed) return;
                const l = Array.from(s.document.differ.getChanges()),
                  c = l[0];
                if (
                  1 != l.length ||
                  "insert" !== c.type ||
                  "$text" != c.name ||
                  1 != c.length
                )
                  return;
                const d = a.focus,
                  u = d.parent,
                  { text: h, range: m } = (function (t, e) {
                    let n = t.start;
                    return {
                      text: Array.from(t.getItems()).reduce(
                        (t, o) =>
                          (!o.is("$text") && !o.is("$textProxy")) ||
                          o.getAttribute("code")
                            ? ((n = e.createPositionAfter(o)), "")
                            : t + o.data,
                        ""
                      ),
                      range: e.createRange(n, t.end),
                    };
                  })(s.createRange(s.createPositionAt(u, 0), d), s),
                  g = r(h),
                  p = Ip(m.start, g.format, s),
                  f = Ip(m.start, g.remove, s);
                p.length &&
                  f.length &&
                  s.enqueueChange((e) => {
                    if (!1 !== o(e, p)) {
                      for (const t of f.reverse()) e.remove(t);
                      s.enqueueChange(() => {
                        t.plugins.get("Delete").requestUndoOnBackspace();
                      });
                    }
                  });
              });
          }
          function Ip(t, e, n) {
            return e
              .filter((t) => void 0 !== t[0] && void 0 !== t[1])
              .map((e) =>
                n.createRange(t.getShiftedBy(e[0]), t.getShiftedBy(e[1]))
              );
          }
          function Tp(t, e) {
            return (n, o) => {
              if (!t.commands.get(e).isEnabled) return !1;
              const i = t.model.schema.getValidRanges(o, e);
              for (const t of i) n.setAttribute(e, !0, t);
              n.removeSelectionAttribute(e);
            };
          }
          class Mp extends zs {
            constructor(t) {
              super(t);
              const n = this.document;
              function o(t) {
                return (o, i) => {
                  i.preventDefault();
                  const r = i.dropRange ? [i.dropRange] : null,
                    s = new e(n, t);
                  n.fire(s, {
                    dataTransfer: i.dataTransfer,
                    method: o.name,
                    targetRanges: r,
                    target: i.target,
                  }),
                    s.stop.called && i.stopPropagation();
                };
              }
              (this.domEventType = [
                "paste",
                "copy",
                "cut",
                "drop",
                "dragover",
                "dragstart",
                "dragend",
                "dragenter",
                "dragleave",
              ]),
                this.listenTo(n, "paste", o("clipboardInput"), {
                  priority: "low",
                }),
                this.listenTo(n, "drop", o("clipboardInput"), {
                  priority: "low",
                }),
                this.listenTo(n, "dragover", o("dragging"), {
                  priority: "low",
                });
            }
            onDomEvent(t) {
              const e = {
                dataTransfer: new Ca(
                  "clipboardData" in t ? t.clipboardData : t.dataTransfer
                ),
              };
              ("drop" != t.type && "dragover" != t.type) ||
                (e.dropRange = (function (t, e) {
                  const n = e.target.ownerDocument,
                    o = e.clientX,
                    i = e.clientY;
                  let r;
                  n.caretRangeFromPoint && n.caretRangeFromPoint(o, i)
                    ? (r = n.caretRangeFromPoint(o, i))
                    : e.rangeParent &&
                      ((r = n.createRange()),
                      r.setStart(e.rangeParent, e.rangeOffset),
                      r.collapse(!0));
                  if (r) return t.domConverter.domRangeToView(r);
                  return null;
                })(this.view, t)),
                this.fire(t.type, t, e);
            }
          }
          const Bp = ["figcaption", "li"];
          function Np(t) {
            let e = "";
            if (t.is("$text") || t.is("$textProxy")) e = t.data;
            else if (t.is("element", "img") && t.hasAttribute("alt"))
              e = t.getAttribute("alt");
            else if (t.is("element", "br")) e = "\n";
            else {
              let n = null;
              for (const o of t.getChildren()) {
                const t = Np(o);
                n &&
                  (n.is("containerElement") || o.is("containerElement")) &&
                  (Bp.includes(n.name) || Bp.includes(o.name)
                    ? (e += "\n")
                    : (e += "\n\n")),
                  (e += t),
                  (n = o);
              }
            }
            return e;
          }
          class zp extends j {
            static get pluginName() {
              return "ClipboardPipeline";
            }
            init() {
              this.editor.editing.view.addObserver(Mp),
                this._setupPasteDrop(),
                this._setupCopyCut();
            }
            _setupPasteDrop() {
              const t = this.editor,
                n = t.model,
                o = t.editing.view,
                i = o.document;
              this.listenTo(
                i,
                "clipboardInput",
                (e) => {
                  t.isReadOnly && e.stop();
                },
                { priority: "highest" }
              ),
                this.listenTo(
                  i,
                  "clipboardInput",
                  (t, n) => {
                    const i = n.dataTransfer;
                    let r;
                    if (n.content) r = n.content;
                    else {
                      let t = "";
                      i.getData("text/html")
                        ? (t = (function (t) {
                            return t
                              .replace(
                                /<span(?: class="Apple-converted-space"|)>(\s+)<\/span>/g,
                                (t, e) => (1 == e.length ? " " : e)
                              )
                              .replace(/<!--[\s\S]*?-->/g, "");
                          })(i.getData("text/html")))
                        : i.getData("text/plain") &&
                          (((s = (s = i.getData("text/plain"))
                            .replace(/</g, "&lt;")
                            .replace(/>/g, "&gt;")
                            .replace(/\r?\n\r?\n/g, "</p><p>")
                            .replace(/\r?\n/g, "<br>")
                            .replace(/^\s/, "&nbsp;")
                            .replace(/\s$/, "&nbsp;")
                            .replace(/\s\s/g, " &nbsp;")).includes("</p><p>") ||
                            s.includes("<br>")) &&
                            (s = `<p>${s}</p>`),
                          (t = s)),
                        (r = this.editor.data.htmlProcessor.toView(t));
                    }
                    var s;
                    const a = new e(this, "inputTransformation");
                    this.fire(a, {
                      content: r,
                      dataTransfer: i,
                      targetRanges: n.targetRanges,
                      method: n.method,
                    }),
                      a.stop.called && t.stop(),
                      o.scrollToTheSelection();
                  },
                  { priority: "low" }
                ),
                this.listenTo(
                  this,
                  "inputTransformation",
                  (t, e) => {
                    if (e.content.isEmpty) return;
                    const o = this.editor.data.toModel(
                      e.content,
                      "$clipboardHolder"
                    );
                    0 != o.childCount &&
                      (t.stop(),
                      n.change(() => {
                        this.fire("contentInsertion", {
                          content: o,
                          method: e.method,
                          dataTransfer: e.dataTransfer,
                          targetRanges: e.targetRanges,
                        });
                      }));
                  },
                  { priority: "low" }
                ),
                this.listenTo(
                  this,
                  "contentInsertion",
                  (t, e) => {
                    e.resultRange = n.insertContent(e.content);
                  },
                  { priority: "low" }
                );
            }
            _setupCopyCut() {
              const t = this.editor,
                e = t.model.document,
                n = t.editing.view.document,
                o = (o, i) => {
                  const r = i.dataTransfer;
                  i.preventDefault();
                  const s = t.data.toView(
                    t.model.getSelectedContent(e.selection)
                  );
                  n.fire("clipboardOutput", {
                    dataTransfer: r,
                    content: s,
                    method: o.name,
                  });
                };
              this.listenTo(n, "copy", o, { priority: "low" }),
                this.listenTo(
                  n,
                  "cut",
                  (e, n) => {
                    t.isReadOnly ? n.preventDefault() : o(e, n);
                  },
                  { priority: "low" }
                ),
                this.listenTo(
                  n,
                  "clipboardOutput",
                  (n, o) => {
                    o.content.isEmpty ||
                      (o.dataTransfer.setData(
                        "text/html",
                        this.editor.data.htmlProcessor.toData(o.content)
                      ),
                      o.dataTransfer.setData("text/plain", Np(o.content))),
                      "cut" == o.method && t.model.deleteContent(e.selection);
                  },
                  { priority: "low" }
                );
            }
          }
          function* Pp(t, e) {
            for (const n of e)
              n && t.getAttributeProperties(n[0]).copyOnEnter && (yield n);
          }
          class Lp extends F {
            execute() {
              const t = this.editor.model,
                e = t.document;
              t.change((n) => {
                !(function (t, e, n, o) {
                  const i = n.isCollapsed,
                    r = n.getFirstRange(),
                    s = r.start.parent,
                    a = r.end.parent;
                  if (o.isLimit(s) || o.isLimit(a))
                    return void (i || s != a || t.deleteContent(n));
                  if (i) {
                    const t = Pp(e.model.schema, n.getAttributes());
                    Rp(e, r.start), e.setSelectionAttribute(t);
                  } else {
                    const o = !(r.start.isAtStart && r.end.isAtEnd),
                      i = s == a;
                    t.deleteContent(n, { leaveUnmerged: o }),
                      o && (i ? Rp(e, n.focus) : e.setSelection(a, 0));
                  }
                })(this.editor.model, n, e.selection, t.schema),
                  this.fire("afterExecute", { writer: n });
              });
            }
          }
          function Rp(t, e) {
            t.split(e), t.setSelection(e.parent.nextSibling, 0);
          }
          const Op = {
            insertParagraph: { isSoft: !1 },
            insertLineBreak: { isSoft: !0 },
          };
          class jp extends Ms {
            constructor(t) {
              super(t);
              const e = this.document;
              e.on("beforeinput", (n, o) => {
                if (!this.isEnabled) return;
                const i = o.domEvent,
                  r = Op[o.inputType];
                if (!r) return;
                const s = new qi(e, "enter", o.targetRanges[0]);
                e.fire(s, new Ns(t, i, { isSoft: r.isSoft })),
                  s.stop.called && n.stop();
              });
            }
            observe() {}
          }
          class Vp extends j {
            static get pluginName() {
              return "Enter";
            }
            init() {
              const t = this.editor,
                e = t.editing.view,
                n = e.document;
              e.addObserver(jp),
                t.commands.add("enter", new Lp(t)),
                this.listenTo(
                  n,
                  "enter",
                  (o, i) => {
                    n.isComposing || i.preventDefault(),
                      i.isSoft ||
                        (t.execute("enter"), e.scrollToTheSelection());
                  },
                  { priority: "low" }
                );
            }
          }
          class Fp extends b {
            constructor() {
              super(), (this._stack = []);
            }
            add(t, e) {
              const n = this._stack,
                o = n[0];
              this._insertDescriptor(t);
              const i = n[0];
              o === i ||
                Hp(o, i) ||
                this.fire("change:top", {
                  oldDescriptor: o,
                  newDescriptor: i,
                  writer: e,
                });
            }
            remove(t, e) {
              const n = this._stack,
                o = n[0];
              this._removeDescriptor(t);
              const i = n[0];
              o === i ||
                Hp(o, i) ||
                this.fire("change:top", {
                  oldDescriptor: o,
                  newDescriptor: i,
                  writer: e,
                });
            }
            _insertDescriptor(t) {
              const e = this._stack,
                n = e.findIndex((e) => e.id === t.id);
              if (Hp(t, e[n])) return;
              n > -1 && e.splice(n, 1);
              let o = 0;
              for (; e[o] && Up(e[o], t); ) o++;
              e.splice(o, 0, t);
            }
            _removeDescriptor(t) {
              const e = this._stack,
                n = e.findIndex((e) => e.id === t);
              n > -1 && e.splice(n, 1);
            }
          }
          function Hp(t, e) {
            return (
              t &&
              e &&
              t.priority == e.priority &&
              Wp(t.classes) == Wp(e.classes)
            );
          }
          function Up(t, e) {
            return (
              t.priority > e.priority ||
              (!(t.priority < e.priority) && Wp(t.classes) > Wp(e.classes))
            );
          }
          function Wp(t) {
            return Array.isArray(t) ? t.sort().join(",") : t;
          }
          const $p =
              '<svg viewBox="0 0 16 16" xmlns="http://www.w3.org/2000/svg"><path d="M4 0v1H1v3H0V.5A.5.5 0 0 1 .5 0H4zm8 0h3.5a.5.5 0 0 1 .5.5V4h-1V1h-3V0zM4 16H.5a.5.5 0 0 1-.5-.5V12h1v3h3v1zm8 0v-1h3v-3h1v3.5a.5.5 0 0 1-.5.5H12z"/><path fill-opacity=".256" d="M1 1h14v14H1z"/><g class="ck-icon__selected-indicator"><path d="M7 0h2v1H7V0zM0 7h1v2H0V7zm15 0h1v2h-1V7zm-8 8h2v1H7v-1z"/><path fill-opacity=".254" d="M1 1h14v14H1z"/></g></svg>',
            qp = "ck-widget_selected";
          function Gp(t) {
            return !!t.is("element") && !!t.getCustomProperty("widget");
          }
          function Zp(t, e, n = {}) {
            if (!t.is("containerElement"))
              throw new l("widget-to-widget-wrong-element-type", null, {
                element: t,
              });
            return (
              e.setAttribute("contenteditable", "false", t),
              e.addClass("ck-widget", t),
              e.setCustomProperty("widget", !0, t),
              (t.getFillerOffset = ef),
              n.label &&
                (function (t, e, n) {
                  n.setCustomProperty("widgetLabel", e, t);
                })(t, n.label, e),
              n.hasSelectionHandle &&
                (function (t, e) {
                  const n = e.createUIElement(
                    "div",
                    { class: "ck ck-widget__selection-handle" },
                    function (t) {
                      const e = this.toDomElement(t),
                        n = new Xh();
                      return (
                        n.set("content", $p),
                        n.render(),
                        e.appendChild(n.element),
                        e
                      );
                    }
                  );
                  e.insert(e.createPositionAt(t, 0), n),
                    e.addClass(["ck-widget_with-selection-handle"], t);
                })(t, e),
              Qp(t, e),
              t
            );
          }
          function Yp(t, e, n) {
            if ((e.classes && n.addClass(ko(e.classes), t), e.attributes))
              for (const o in e.attributes)
                n.setAttribute(o, e.attributes[o], t);
          }
          function Kp(t, e, n) {
            if ((e.classes && n.removeClass(ko(e.classes), t), e.attributes))
              for (const o in e.attributes) n.removeAttribute(o, t);
          }
          function Qp(t, e, n = Yp, o = Kp) {
            const i = new Fp();
            i.on("change:top", (e, i) => {
              i.oldDescriptor && o(t, i.oldDescriptor, i.writer),
                i.newDescriptor && n(t, i.newDescriptor, i.writer);
            });
            e.setCustomProperty("addHighlight", (t, e, n) => i.add(e, n), t),
              e.setCustomProperty(
                "removeHighlight",
                (t, e, n) => i.remove(e, n),
                t
              );
          }
          function Jp(t) {
            const e = t.getCustomProperty("widgetLabel");
            return e ? ("function" == typeof e ? e() : e) : "";
          }
          function Xp(t, e, n = {}) {
            return (
              e.addClass(
                ["ck-editor__editable", "ck-editor__nested-editable"],
                t
              ),
              e.setAttribute("role", "textbox", t),
              n.label && e.setAttribute("aria-label", n.label, t),
              e.setAttribute(
                "contenteditable",
                t.isReadOnly ? "false" : "true",
                t
              ),
              t.on("change:isReadOnly", (n, o, i) => {
                e.setAttribute("contenteditable", i ? "false" : "true", t);
              }),
              t.on("change:isFocused", (n, o, i) => {
                i
                  ? e.addClass("ck-editor__nested-editable_focused", t)
                  : e.removeClass("ck-editor__nested-editable_focused", t);
              }),
              Qp(t, e),
              t
            );
          }
          function tf(t, e) {
            const n = t.getSelectedElement();
            if (n) {
              const o = rf(t);
              if (o) return e.createRange(e.createPositionAt(n, o));
            }
            return Fu(t, e);
          }
          function ef() {
            return null;
          }
          const nf = "widget-type-around";
          function of(t, e, n) {
            return !!t && Gp(t) && !n.isInline(e);
          }
          function rf(t) {
            return t.getAttribute(nf);
          }
          var sf = n(5137),
            af = { attributes: { "data-cke": !0 } };
          (af.setAttributes = is()),
            (af.insert = ns().bind(null, "head")),
            (af.domAPI = ts()),
            (af.insertStyleElement = ss());
          Jr()(sf.Z, af);
          sf.Z && sf.Z.locals && sf.Z.locals;
          const lf = ["before", "after"],
            cf = new DOMParser().parseFromString(
              '<svg viewBox="0 0 10 8" xmlns="http://www.w3.org/2000/svg"><path d="M9.055.263v3.972h-6.77M1 4.216l2-2.038m-2 2 2 2.038"/></svg>',
              "image/svg+xml"
            ).firstChild,
            df = "ck-widget__type-around_disabled";
          class uf extends j {
            static get pluginName() {
              return "WidgetTypeAround";
            }
            static get requires() {
              return [Vp, rp];
            }
            constructor(t) {
              super(t), (this._currentFakeCaretModelElement = null);
            }
            init() {
              const t = this.editor,
                e = t.editing.view;
              this.on("change:isEnabled", (n, o, i) => {
                e.change((t) => {
                  for (const n of e.document.roots)
                    i ? t.removeClass(df, n) : t.addClass(df, n);
                }),
                  i ||
                    t.model.change((t) => {
                      t.removeSelectionAttribute(nf);
                    });
              }),
                this._enableTypeAroundUIInjection(),
                this._enableInsertingParagraphsOnButtonClick(),
                this._enableInsertingParagraphsOnEnterKeypress(),
                this._enableInsertingParagraphsOnTypingKeystroke(),
                this._enableTypeAroundFakeCaretActivationUsingKeyboardArrows(),
                this._enableDeleteIntegration(),
                this._enableInsertContentIntegration(),
                this._enableInsertObjectIntegration(),
                this._enableDeleteContentIntegration();
            }
            destroy() {
              super.destroy(), (this._currentFakeCaretModelElement = null);
            }
            _insertParagraph(t, e) {
              const n = this.editor,
                o = n.editing.view,
                i = n.model.schema.getAttributesWithProperty(
                  t,
                  "copyOnReplace",
                  !0
                );
              n.execute("insertParagraph", {
                position: n.model.createPositionAt(t, e),
                attributes: i,
              }),
                o.focus(),
                o.scrollToTheSelection();
            }
            _listenToIfEnabled(t, e, n, o) {
              this.listenTo(
                t,
                e,
                (...t) => {
                  this.isEnabled && n(...t);
                },
                o
              );
            }
            _insertParagraphAccordingToFakeCaretPosition() {
              const t = this.editor.model.document.selection,
                e = rf(t);
              if (!e) return !1;
              const n = t.getSelectedElement();
              return this._insertParagraph(n, e), !0;
            }
            _enableTypeAroundUIInjection() {
              const t = this.editor,
                e = t.model.schema,
                n = t.locale.t,
                o = {
                  before: n("Insert paragraph before block"),
                  after: n("Insert paragraph after block"),
                };
              t.editing.downcastDispatcher.on(
                "insert",
                (t, n, i) => {
                  const r = i.mapper.toViewElement(n.item);
                  of(r, n.item, e) &&
                    (function (t, e, n) {
                      const o = t.createUIElement(
                        "div",
                        { class: "ck ck-reset_all ck-widget__type-around" },
                        function (t) {
                          const n = this.toDomElement(t);
                          return (
                            (function (t, e) {
                              for (const n of lf) {
                                const o = new Xu({
                                  tag: "div",
                                  attributes: {
                                    class: [
                                      "ck",
                                      "ck-widget__type-around__button",
                                      `ck-widget__type-around__button_${n}`,
                                    ],
                                    title: e[n],
                                  },
                                  children: [
                                    t.ownerDocument.importNode(cf, !0),
                                  ],
                                });
                                t.appendChild(o.render());
                              }
                            })(n, e),
                            (function (t) {
                              const e = new Xu({
                                tag: "div",
                                attributes: {
                                  class: [
                                    "ck",
                                    "ck-widget__type-around__fake-caret",
                                  ],
                                },
                              });
                              t.appendChild(e.render());
                            })(n),
                            n
                          );
                        }
                      );
                      t.insert(t.createPositionAt(n, "end"), o);
                    })(i.writer, o, r);
                },
                { priority: "low" }
              );
            }
            _enableTypeAroundFakeCaretActivationUsingKeyboardArrows() {
              const t = this.editor,
                e = t.model,
                n = e.document.selection,
                o = e.schema,
                i = t.editing.view;
              function r(t) {
                return `ck-widget_type-around_show-fake-caret_${t}`;
              }
              this._listenToIfEnabled(
                i.document,
                "arrowKey",
                (t, e) => {
                  this._handleArrowKeyPress(t, e);
                },
                { context: [Gp, "$text"], priority: "high" }
              ),
                this._listenToIfEnabled(n, "change:range", (e, n) => {
                  n.directChange &&
                    t.model.change((t) => {
                      t.removeSelectionAttribute(nf);
                    });
                }),
                this._listenToIfEnabled(e.document, "change:data", () => {
                  const e = n.getSelectedElement();
                  if (e) {
                    if (of(t.editing.mapper.toViewElement(e), e, o)) return;
                  }
                  t.model.change((t) => {
                    t.removeSelectionAttribute(nf);
                  });
                }),
                this._listenToIfEnabled(
                  t.editing.downcastDispatcher,
                  "selection",
                  (t, e, n) => {
                    const i = n.writer;
                    if (this._currentFakeCaretModelElement) {
                      const t = n.mapper.toViewElement(
                        this._currentFakeCaretModelElement
                      );
                      t &&
                        (i.removeClass(lf.map(r), t),
                        (this._currentFakeCaretModelElement = null));
                    }
                    const s = e.selection.getSelectedElement();
                    if (!s) return;
                    const a = n.mapper.toViewElement(s);
                    if (!of(a, s, o)) return;
                    const l = rf(e.selection);
                    l &&
                      (i.addClass(r(l), a),
                      (this._currentFakeCaretModelElement = s));
                  }
                ),
                this._listenToIfEnabled(
                  t.ui.focusTracker,
                  "change:isFocused",
                  (e, n, o) => {
                    o ||
                      t.model.change((t) => {
                        t.removeSelectionAttribute(nf);
                      });
                  }
                );
            }
            _handleArrowKeyPress(t, e) {
              const n = this.editor,
                o = n.model,
                i = o.document.selection,
                r = o.schema,
                s = n.editing.view,
                a = (function (t, e) {
                  const n = fr(t, e);
                  return "down" === n || "right" === n;
                })(e.keyCode, n.locale.contentLanguageDirection),
                l = s.document.selection.getSelectedElement();
              let c;
              of(l, n.editing.mapper.toModelElement(l), r)
                ? (c = this._handleArrowKeyPressOnSelectedWidget(a))
                : i.isCollapsed
                ? (c = this._handleArrowKeyPressWhenSelectionNextToAWidget(a))
                : e.shiftKey ||
                  (c = this._handleArrowKeyPressWhenNonCollapsedSelection(a)),
                c && (e.preventDefault(), t.stop());
            }
            _handleArrowKeyPressOnSelectedWidget(t) {
              const e = this.editor.model,
                n = rf(e.document.selection);
              return e.change((e) => {
                if (!n)
                  return (
                    e.setSelectionAttribute(nf, t ? "after" : "before"), !0
                  );
                if (!(n === (t ? "after" : "before")))
                  return e.removeSelectionAttribute(nf), !0;
                return !1;
              });
            }
            _handleArrowKeyPressWhenSelectionNextToAWidget(t) {
              const e = this.editor,
                n = e.model,
                o = n.schema,
                i = e.plugins.get("Widget"),
                r = i._getObjectElementNextToSelection(t);
              return (
                !!of(e.editing.mapper.toViewElement(r), r, o) &&
                (n.change((e) => {
                  i._setSelectionOverElement(r),
                    e.setSelectionAttribute(nf, t ? "before" : "after");
                }),
                !0)
              );
            }
            _handleArrowKeyPressWhenNonCollapsedSelection(t) {
              const e = this.editor,
                n = e.model,
                o = n.schema,
                i = e.editing.mapper,
                r = n.document.selection,
                s = t
                  ? r.getLastPosition().nodeBefore
                  : r.getFirstPosition().nodeAfter;
              return (
                !!of(i.toViewElement(s), s, o) &&
                (n.change((e) => {
                  e.setSelection(s, "on"),
                    e.setSelectionAttribute(nf, t ? "after" : "before");
                }),
                !0)
              );
            }
            _enableInsertingParagraphsOnButtonClick() {
              const t = this.editor,
                e = t.editing.view;
              this._listenToIfEnabled(e.document, "mousedown", (n, o) => {
                const i = o.domTarget.closest(
                  ".ck-widget__type-around__button"
                );
                if (!i) return;
                const r = (function (t) {
                    return t.classList.contains(
                      "ck-widget__type-around__button_before"
                    )
                      ? "before"
                      : "after";
                  })(i),
                  s = (function (t, e) {
                    const n = t.closest(".ck-widget");
                    return e.mapDomToView(n);
                  })(i, e.domConverter),
                  a = t.editing.mapper.toModelElement(s);
                this._insertParagraph(a, r), o.preventDefault(), n.stop();
              });
            }
            _enableInsertingParagraphsOnEnterKeypress() {
              const t = this.editor,
                e = t.model.document.selection,
                n = t.editing.view;
              this._listenToIfEnabled(
                n.document,
                "enter",
                (n, o) => {
                  if ("atTarget" != n.eventPhase) return;
                  const i = e.getSelectedElement(),
                    r = t.editing.mapper.toViewElement(i),
                    s = t.model.schema;
                  let a;
                  this._insertParagraphAccordingToFakeCaretPosition()
                    ? (a = !0)
                    : of(r, i, s) &&
                      (this._insertParagraph(i, o.isSoft ? "before" : "after"),
                      (a = !0)),
                    a && (o.preventDefault(), n.stop());
                },
                { context: Gp }
              );
            }
            _enableInsertingParagraphsOnTypingKeystroke() {
              const t = this.editor.editing.view.document;
              this._listenToIfEnabled(
                t,
                "insertText",
                (e, n) => {
                  this._insertParagraphAccordingToFakeCaretPosition() &&
                    (n.selection = t.selection);
                },
                { priority: "high" }
              ),
                ar.isAndroid
                  ? this._listenToIfEnabled(t, "keydown", (t, e) => {
                      229 == e.keyCode &&
                        this._insertParagraphAccordingToFakeCaretPosition();
                    })
                  : this._listenToIfEnabled(
                      t,
                      "compositionstart",
                      () => {
                        this._insertParagraphAccordingToFakeCaretPosition();
                      },
                      { priority: "high" }
                    );
            }
            _enableDeleteIntegration() {
              const t = this.editor,
                e = t.editing.view,
                n = t.model,
                o = n.schema;
              this._listenToIfEnabled(
                e.document,
                "delete",
                (e, i) => {
                  if ("atTarget" != e.eventPhase) return;
                  const r = rf(n.document.selection);
                  if (!r) return;
                  const s = i.direction,
                    a = n.document.selection.getSelectedElement(),
                    l = "forward" == s;
                  if (("before" === r) === l)
                    t.execute("delete", {
                      selection: n.createSelection(a, "on"),
                    });
                  else {
                    const e = o.getNearestSelectionRange(
                      n.createPositionAt(a, r),
                      s
                    );
                    if (e)
                      if (e.isCollapsed) {
                        const i = n.createSelection(e.start);
                        if (
                          (n.modifySelection(i, { direction: s }),
                          i.focus.isEqual(e.start))
                        ) {
                          const t = (function (t, e) {
                            let n = e;
                            for (const o of e.getAncestors({
                              parentFirst: !0,
                            })) {
                              if (o.childCount > 1 || t.isLimit(o)) break;
                              n = o;
                            }
                            return n;
                          })(o, e.start.parent);
                          n.deleteContent(n.createSelection(t, "on"), {
                            doNotAutoparagraph: !0,
                          });
                        } else
                          n.change((n) => {
                            n.setSelection(e),
                              t.execute(l ? "deleteForward" : "delete");
                          });
                      } else
                        n.change((n) => {
                          n.setSelection(e),
                            t.execute(l ? "deleteForward" : "delete");
                        });
                  }
                  i.preventDefault(), e.stop();
                },
                { context: Gp }
              );
            }
            _enableInsertContentIntegration() {
              const t = this.editor,
                e = this.editor.model,
                n = e.document.selection;
              this._listenToIfEnabled(
                t.model,
                "insertContent",
                (t, [o, i]) => {
                  if (i && !i.is("documentSelection")) return;
                  const r = rf(n);
                  return r
                    ? (t.stop(),
                      e.change((t) => {
                        const i = n.getSelectedElement(),
                          s = e.createPositionAt(i, r),
                          a = t.createSelection(s),
                          l = e.insertContent(o, a);
                        return t.setSelection(a), l;
                      }))
                    : void 0;
                },
                { priority: "high" }
              );
            }
            _enableInsertObjectIntegration() {
              const t = this.editor,
                e = this.editor.model.document.selection;
              this._listenToIfEnabled(
                t.model,
                "insertObject",
                (t, n) => {
                  const [, o, , i = {}] = n;
                  if (o && !o.is("documentSelection")) return;
                  const r = rf(e);
                  r && ((i.findOptimalPosition = r), (n[3] = i));
                },
                { priority: "high" }
              );
            }
            _enableDeleteContentIntegration() {
              const t = this.editor,
                e = this.editor.model.document.selection;
              this._listenToIfEnabled(
                t.model,
                "deleteContent",
                (t, [n]) => {
                  if (n && !n.is("documentSelection")) return;
                  rf(e) && t.stop();
                },
                { priority: "high" }
              );
            }
          }
          function hf(t) {
            const e = t.model;
            return (n, o) => {
              const i = o.keyCode == ur.arrowup,
                r = o.keyCode == ur.arrowdown,
                s = o.shiftKey,
                a = e.document.selection;
              if (!i && !r) return;
              const l = r;
              if (
                s &&
                (function (t, e) {
                  return !t.isCollapsed && t.isBackward == e;
                })(a, l)
              )
                return;
              const c = (function (t, e, n) {
                const o = t.model;
                if (n) {
                  const t = e.isCollapsed ? e.focus : e.getLastPosition(),
                    n = mf(o, t, "forward");
                  if (!n) return null;
                  const i = o.createRange(t, n),
                    r = gf(o.schema, i, "backward");
                  return r ? o.createRange(t, r) : null;
                }
                {
                  const t = e.isCollapsed ? e.focus : e.getFirstPosition(),
                    n = mf(o, t, "backward");
                  if (!n) return null;
                  const i = o.createRange(n, t),
                    r = gf(o.schema, i, "forward");
                  return r ? o.createRange(r, t) : null;
                }
              })(t, a, l);
              if (c) {
                if (c.isCollapsed) {
                  if (a.isCollapsed) return;
                  if (s) return;
                }
                (c.isCollapsed ||
                  (function (t, e, n) {
                    const o = t.model,
                      i = t.view.domConverter;
                    if (n) {
                      const t = o.createSelection(e.start);
                      o.modifySelection(t),
                        t.focus.isAtEnd ||
                          e.start.isEqual(t.focus) ||
                          (e = o.createRange(t.focus, e.end));
                    }
                    const r = t.mapper.toViewRange(e),
                      s = i.viewRangeToDom(r),
                      a = Ma.getDomRangeRects(s);
                    let l;
                    for (const t of a)
                      if (void 0 !== l) {
                        if (Math.round(t.top) >= l) return !1;
                        l = Math.max(l, Math.round(t.bottom));
                      } else l = Math.round(t.bottom);
                    return !0;
                  })(t, c, l)) &&
                  (e.change((t) => {
                    const n = l ? c.end : c.start;
                    if (s) {
                      const o = e.createSelection(a.anchor);
                      o.setFocus(n), t.setSelection(o);
                    } else t.setSelection(n);
                  }),
                  n.stop(),
                  o.preventDefault(),
                  o.stopPropagation());
              }
            };
          }
          function mf(t, e, n) {
            const o = t.schema,
              i = t.createRangeIn(e.root),
              r = "forward" == n ? "elementStart" : "elementEnd";
            for (const { previousPosition: t, item: s, type: a } of i.getWalker(
              { startPosition: e, direction: n }
            )) {
              if (o.isLimit(s) && !o.isInline(s)) return t;
              if (a == r && o.isBlock(s)) return null;
            }
            return null;
          }
          function gf(t, e, n) {
            const o = "backward" == n ? e.end : e.start;
            if (t.checkChild(o, "$text")) return o;
            for (const { nextPosition: o } of e.getWalker({ direction: n }))
              if (t.checkChild(o, "$text")) return o;
            return null;
          }
          var pf = n(6507),
            ff = { attributes: { "data-cke": !0 } };
          (ff.setAttributes = is()),
            (ff.insert = ns().bind(null, "head")),
            (ff.domAPI = ts()),
            (ff.insertStyleElement = ss());
          Jr()(pf.Z, ff);
          pf.Z && pf.Z.locals && pf.Z.locals;
          class kf extends j {
            static get pluginName() {
              return "Widget";
            }
            static get requires() {
              return [uf, rp];
            }
            init() {
              const t = this.editor,
                e = t.editing.view,
                n = e.document;
              (this._previouslySelected = new Set()),
                this.editor.editing.downcastDispatcher.on(
                  "selection",
                  (e, n, o) => {
                    const i = o.writer,
                      r = n.selection;
                    if (r.isCollapsed) return;
                    const s = r.getSelectedElement();
                    if (!s) return;
                    const a = t.editing.mapper.toViewElement(s);
                    Gp(a) &&
                      o.consumable.consume(r, "selection") &&
                      i.setSelection(i.createRangeOn(a), {
                        fake: !0,
                        label: Jp(a),
                      });
                  }
                ),
                this.editor.editing.downcastDispatcher.on(
                  "selection",
                  (t, e, n) => {
                    this._clearPreviouslySelectedWidgets(n.writer);
                    const o = n.writer,
                      i = o.document.selection;
                    let r = null;
                    for (const t of i.getRanges())
                      for (const e of t) {
                        const t = e.item;
                        Gp(t) &&
                          !bf(t, r) &&
                          (o.addClass(qp, t),
                          this._previouslySelected.add(t),
                          (r = t));
                      }
                  },
                  { priority: "low" }
                ),
                e.addObserver(tu),
                this.listenTo(n, "mousedown", (...t) =>
                  this._onMousedown(...t)
                ),
                this.listenTo(
                  n,
                  "arrowKey",
                  (...t) => {
                    this._handleSelectionChangeOnArrowKeyPress(...t);
                  },
                  { context: [Gp, "$text"] }
                ),
                this.listenTo(
                  n,
                  "arrowKey",
                  (...t) => {
                    this._preventDefaultOnArrowKeyPress(...t);
                  },
                  { context: "$root" }
                ),
                this.listenTo(n, "arrowKey", hf(this.editor.editing), {
                  context: "$text",
                }),
                this.listenTo(
                  n,
                  "delete",
                  (t, e) => {
                    this._handleDelete("forward" == e.direction) &&
                      (e.preventDefault(), t.stop());
                  },
                  { context: "$root" }
                );
            }
            _onMousedown(t, e) {
              const n = this.editor,
                o = n.editing.view,
                i = o.document;
              let r = e.target;
              if (
                (function (t) {
                  let e = t;
                  for (; e; ) {
                    if (e.is("editableElement") && !e.is("rootElement"))
                      return !0;
                    if (Gp(e)) return !1;
                    e = e.parent;
                  }
                  return !1;
                })(r)
              ) {
                if ((ar.isSafari || ar.isGecko) && e.domEvent.detail >= 3) {
                  const t = n.editing.mapper,
                    o = r.is("attributeElement")
                      ? r.findAncestor((t) => !t.is("attributeElement"))
                      : r,
                    i = t.toModelElement(o);
                  e.preventDefault(),
                    this.editor.model.change((t) => {
                      t.setSelection(i, "in");
                    });
                }
                return;
              }
              if (!Gp(r) && ((r = r.findAncestor(Gp)), !r)) return;
              ar.isAndroid && e.preventDefault(), i.isFocused || o.focus();
              const s = n.editing.mapper.toModelElement(r);
              this._setSelectionOverElement(s);
            }
            _handleSelectionChangeOnArrowKeyPress(t, e) {
              const n = e.keyCode,
                o = this.editor.model,
                i = o.schema,
                r = o.document.selection,
                s = r.getSelectedElement(),
                a = fr(n, this.editor.locale.contentLanguageDirection),
                l = "down" == a || "right" == a,
                c = "up" == a || "down" == a;
              if (s && i.isObject(s)) {
                const n = l ? r.getLastPosition() : r.getFirstPosition(),
                  s = i.getNearestSelectionRange(n, l ? "forward" : "backward");
                return void (
                  s &&
                  (o.change((t) => {
                    t.setSelection(s);
                  }),
                  e.preventDefault(),
                  t.stop())
                );
              }
              if (!r.isCollapsed && !e.shiftKey) {
                const n = r.getFirstPosition(),
                  s = r.getLastPosition(),
                  a = n.nodeAfter,
                  c = s.nodeBefore;
                return void (
                  ((a && i.isObject(a)) || (c && i.isObject(c))) &&
                  (o.change((t) => {
                    t.setSelection(l ? s : n);
                  }),
                  e.preventDefault(),
                  t.stop())
                );
              }
              if (!r.isCollapsed) return;
              const d = this._getObjectElementNextToSelection(l);
              if (d && i.isObject(d)) {
                if (i.isInline(d) && c) return;
                this._setSelectionOverElement(d), e.preventDefault(), t.stop();
              }
            }
            _preventDefaultOnArrowKeyPress(t, e) {
              const n = this.editor.model,
                o = n.schema,
                i = n.document.selection.getSelectedElement();
              i && o.isObject(i) && (e.preventDefault(), t.stop());
            }
            _handleDelete(t) {
              if (this.editor.isReadOnly) return;
              const e = this.editor.model.document.selection;
              if (!e.isCollapsed) return;
              const n = this._getObjectElementNextToSelection(t);
              return n
                ? (this.editor.model.change((t) => {
                    let o = e.anchor.parent;
                    for (; o.isEmpty; ) {
                      const e = o;
                      (o = e.parent), t.remove(e);
                    }
                    this._setSelectionOverElement(n);
                  }),
                  !0)
                : void 0;
            }
            _setSelectionOverElement(t) {
              this.editor.model.change((e) => {
                e.setSelection(e.createRangeOn(t));
              });
            }
            _getObjectElementNextToSelection(t) {
              const e = this.editor.model,
                n = e.schema,
                o = e.document.selection,
                i = e.createSelection(o);
              if (
                (e.modifySelection(i, {
                  direction: t ? "forward" : "backward",
                }),
                i.isEqual(o))
              )
                return null;
              const r = t ? i.focus.nodeBefore : i.focus.nodeAfter;
              return r && n.isObject(r) ? r : null;
            }
            _clearPreviouslySelectedWidgets(t) {
              for (const e of this._previouslySelected) t.removeClass(qp, e);
              this._previouslySelected.clear();
            }
          }
          function bf(t, e) {
            return !!e && Array.from(t.getAncestors()).includes(e);
          }
          const wf = function (t, e, n) {
            var o = !0,
              i = !0;
            if ("function" != typeof t)
              throw new TypeError("Expected a function");
            return (
              E(n) &&
                ((o = "leading" in n ? !!n.leading : o),
                (i = "trailing" in n ? !!n.trailing : i)),
              Zs(t, e, { leading: o, maxWait: e, trailing: i })
            );
          };
          var Af = n(390),
            _f = { attributes: { "data-cke": !0 } };
          (_f.setAttributes = is()),
            (_f.insert = ns().bind(null, "head")),
            (_f.domAPI = ts()),
            (_f.insertStyleElement = ss());
          Jr()(Af.Z, _f);
          Af.Z && Af.Z.locals && Af.Z.locals;
          class Cf extends j {
            static get pluginName() {
              return "DragDrop";
            }
            static get requires() {
              return [zp, kf];
            }
            init() {
              const t = this.editor,
                e = t.editing.view;
              (this._draggedRange = null),
                (this._draggingUid = ""),
                (this._draggableElement = null),
                (this._updateDropMarkerThrottled = wf(
                  (t) => this._updateDropMarker(t),
                  40
                )),
                (this._removeDropMarkerDelayed = xf(
                  () => this._removeDropMarker(),
                  40
                )),
                (this._clearDraggableAttributesDelayed = xf(
                  () => this._clearDraggableAttributes(),
                  40
                )),
                e.addObserver(Mp),
                e.addObserver(tu),
                this._setupDragging(),
                this._setupContentInsertionIntegration(),
                this._setupClipboardInputIntegration(),
                this._setupDropMarker(),
                this._setupDraggableAttributeHandling(),
                this.listenTo(t, "change:isReadOnly", (t, e, n) => {
                  n
                    ? this.forceDisabled("readOnlyMode")
                    : this.clearForceDisabled("readOnlyMode");
                }),
                this.on("change:isEnabled", (t, e, n) => {
                  n || this._finalizeDragging(!1);
                }),
                ar.isAndroid && this.forceDisabled("noAndroidSupport");
            }
            destroy() {
              return (
                this._draggedRange &&
                  (this._draggedRange.detach(), (this._draggedRange = null)),
                this._updateDropMarkerThrottled.cancel(),
                this._removeDropMarkerDelayed.cancel(),
                this._clearDraggableAttributesDelayed.cancel(),
                super.destroy()
              );
            }
            _setupDragging() {
              const t = this.editor,
                e = t.model,
                n = e.document,
                o = t.editing.view,
                i = o.document;
              this.listenTo(
                i,
                "dragstart",
                (o, s) => {
                  const a = n.selection;
                  if (s.target && s.target.is("editableElement"))
                    return void s.preventDefault();
                  const l = s.target ? Ef(s.target) : null;
                  if (l) {
                    const n = t.editing.mapper.toModelElement(l);
                    (this._draggedRange = xl.fromRange(e.createRangeOn(n))),
                      t.plugins.has("WidgetToolbarRepository") &&
                        t.plugins
                          .get("WidgetToolbarRepository")
                          .forceDisabled("dragDrop");
                  } else if (!i.selection.isCollapsed) {
                    const t = i.selection.getSelectedElement();
                    (t && Gp(t)) ||
                      (this._draggedRange = xl.fromRange(a.getFirstRange()));
                  }
                  if (!this._draggedRange) return void s.preventDefault();
                  (this._draggingUid = r()),
                    (s.dataTransfer.effectAllowed = this.isEnabled
                      ? "copyMove"
                      : "copy"),
                    s.dataTransfer.setData(
                      "application/ckeditor5-dragging-uid",
                      this._draggingUid
                    );
                  const c = e.createSelection(this._draggedRange.toRange()),
                    d = t.data.toView(e.getSelectedContent(c));
                  i.fire("clipboardOutput", {
                    dataTransfer: s.dataTransfer,
                    content: d,
                    method: "dragstart",
                  }),
                    this.isEnabled ||
                      (this._draggedRange.detach(),
                      (this._draggedRange = null),
                      (this._draggingUid = ""));
                },
                { priority: "low" }
              ),
                this.listenTo(
                  i,
                  "dragend",
                  (t, e) => {
                    this._finalizeDragging(
                      !e.dataTransfer.isCanceled &&
                        "move" == e.dataTransfer.dropEffect
                    );
                  },
                  { priority: "low" }
                ),
                this.listenTo(i, "dragenter", () => {
                  this.isEnabled && o.focus();
                }),
                this.listenTo(i, "dragleave", () => {
                  this._removeDropMarkerDelayed();
                }),
                this.listenTo(
                  i,
                  "dragging",
                  (e, n) => {
                    if (!this.isEnabled)
                      return void (n.dataTransfer.dropEffect = "none");
                    this._removeDropMarkerDelayed.cancel();
                    const o = vf(t, n.targetRanges, n.target);
                    this._draggedRange || (n.dataTransfer.dropEffect = "copy"),
                      ar.isGecko ||
                        ("copy" == n.dataTransfer.effectAllowed
                          ? (n.dataTransfer.dropEffect = "copy")
                          : ["all", "copyMove"].includes(
                              n.dataTransfer.effectAllowed
                            ) && (n.dataTransfer.dropEffect = "move")),
                      o && this._updateDropMarkerThrottled(o);
                  },
                  { priority: "low" }
                );
            }
            _setupClipboardInputIntegration() {
              const t = this.editor,
                e = t.editing.view.document;
              this.listenTo(
                e,
                "clipboardInput",
                (e, n) => {
                  if ("drop" != n.method) return;
                  const o = vf(t, n.targetRanges, n.target);
                  if ((this._removeDropMarker(), !o))
                    return this._finalizeDragging(!1), void e.stop();
                  this._draggedRange &&
                    this._draggingUid !=
                      n.dataTransfer.getData(
                        "application/ckeditor5-dragging-uid"
                      ) &&
                    (this._draggedRange.detach(),
                    (this._draggedRange = null),
                    (this._draggingUid = ""));
                  if (
                    "move" == yf(n.dataTransfer) &&
                    this._draggedRange &&
                    this._draggedRange.containsRange(o, !0)
                  )
                    return this._finalizeDragging(!1), void e.stop();
                  n.targetRanges = [t.editing.mapper.toViewRange(o)];
                },
                { priority: "high" }
              );
            }
            _setupContentInsertionIntegration() {
              const t = this.editor.plugins.get(zp);
              t.on(
                "contentInsertion",
                (t, e) => {
                  if (!this.isEnabled || "drop" !== e.method) return;
                  const n = e.targetRanges.map((t) =>
                    this.editor.editing.mapper.toModelRange(t)
                  );
                  this.editor.model.change((t) => t.setSelection(n));
                },
                { priority: "high" }
              ),
                t.on(
                  "contentInsertion",
                  (t, e) => {
                    if (!this.isEnabled || "drop" !== e.method) return;
                    const n = "move" == yf(e.dataTransfer),
                      o = !e.resultRange || !e.resultRange.isCollapsed;
                    this._finalizeDragging(o && n);
                  },
                  { priority: "lowest" }
                );
            }
            _setupDraggableAttributeHandling() {
              const t = this.editor,
                e = t.editing.view,
                n = e.document;
              this.listenTo(n, "mousedown", (o, i) => {
                if (ar.isAndroid || !i) return;
                this._clearDraggableAttributesDelayed.cancel();
                let r = Ef(i.target);
                if (
                  ar.isBlink &&
                  !t.isReadOnly &&
                  !r &&
                  !n.selection.isCollapsed
                ) {
                  const t = n.selection.getSelectedElement();
                  (t && Gp(t)) || (r = n.selection.editableElement);
                }
                r &&
                  (e.change((t) => {
                    t.setAttribute("draggable", "true", r);
                  }),
                  (this._draggableElement =
                    t.editing.mapper.toModelElement(r)));
              }),
                this.listenTo(n, "mouseup", () => {
                  ar.isAndroid || this._clearDraggableAttributesDelayed();
                });
            }
            _clearDraggableAttributes() {
              const t = this.editor.editing;
              t.view.change((e) => {
                this._draggableElement &&
                  "$graveyard" != this._draggableElement.root.rootName &&
                  e.removeAttribute(
                    "draggable",
                    t.mapper.toViewElement(this._draggableElement)
                  ),
                  (this._draggableElement = null);
              });
            }
            _setupDropMarker() {
              const t = this.editor;
              t.conversion
                .for("editingDowncast")
                .markerToHighlight({
                  model: "drop-target",
                  view: { classes: ["ck-clipboard-drop-target-range"] },
                }),
                t.conversion.for("editingDowncast").markerToElement({
                  model: "drop-target",
                  view: (e, { writer: n }) => {
                    if (t.model.schema.checkChild(e.markerRange.start, "$text"))
                      return n.createUIElement(
                        "span",
                        { class: "ck ck-clipboard-drop-target-position" },
                        function (t) {
                          const e = this.toDomElement(t);
                          return e.append("⁠", t.createElement("span"), "⁠"), e;
                        }
                      );
                  },
                });
            }
            _updateDropMarker(t) {
              const e = this.editor,
                n = e.model.markers;
              e.model.change((e) => {
                n.has("drop-target")
                  ? n.get("drop-target").getRange().isEqual(t) ||
                    e.updateMarker("drop-target", { range: t })
                  : e.addMarker("drop-target", {
                      range: t,
                      usingOperation: !1,
                      affectsData: !1,
                    });
              });
            }
            _removeDropMarker() {
              const t = this.editor.model;
              this._removeDropMarkerDelayed.cancel(),
                this._updateDropMarkerThrottled.cancel(),
                t.markers.has("drop-target") &&
                  t.change((t) => {
                    t.removeMarker("drop-target");
                  });
            }
            _finalizeDragging(t) {
              const e = this.editor,
                n = e.model;
              this._removeDropMarker(),
                this._clearDraggableAttributes(),
                e.plugins.has("WidgetToolbarRepository") &&
                  e.plugins
                    .get("WidgetToolbarRepository")
                    .clearForceDisabled("dragDrop"),
                (this._draggingUid = ""),
                this._draggedRange &&
                  (t &&
                    this.isEnabled &&
                    n.deleteContent(n.createSelection(this._draggedRange), {
                      doNotAutoparagraph: !0,
                    }),
                  this._draggedRange.detach(),
                  (this._draggedRange = null));
            }
          }
          function vf(t, e, n) {
            const o = t.model,
              i = t.editing.mapper;
            let r = null;
            const s = e ? e[0].start : null;
            if (
              (n.is("uiElement") && (n = n.parent),
              (r = (function (t, e) {
                const n = t.model,
                  o = t.editing.mapper;
                if (Gp(e)) return n.createRangeOn(o.toModelElement(e));
                if (!e.is("editableElement")) {
                  const t = e.findAncestor(
                    (t) => Gp(t) || t.is("editableElement")
                  );
                  if (Gp(t)) return n.createRangeOn(o.toModelElement(t));
                }
                return null;
              })(t, n)),
              r)
            )
              return r;
            const a = (function (t, e) {
                const n = t.editing.mapper,
                  o = t.editing.view,
                  i = n.toModelElement(e);
                if (i) return i;
                const r = o.createPositionBefore(e),
                  s = n.findMappedViewAncestor(r);
                return n.toModelElement(s);
              })(t, n),
              l = s ? i.toModelPosition(s) : null;
            return l
              ? ((r = (function (t, e, n) {
                  const o = t.model;
                  if (!o.schema.checkChild(n, "$block")) return null;
                  const i = o.createPositionAt(n, 0),
                    r = e.path.slice(0, i.path.length),
                    s = o.createPositionFromPath(e.root, r).nodeAfter;
                  if (s && o.schema.isObject(s)) return o.createRangeOn(s);
                  return null;
                })(t, l, a)),
                r ||
                  ((r = o.schema.getNearestSelectionRange(
                    l,
                    ar.isGecko ? "forward" : "backward"
                  )),
                  r ||
                    (function (t, e) {
                      const n = t.model;
                      let o = e;
                      for (; o; ) {
                        if (n.schema.isObject(o)) return n.createRangeOn(o);
                        o = o.parent;
                      }
                      return null;
                    })(t, l.parent)))
              : (function (t, e) {
                  const n = t.model,
                    o = n.schema,
                    i = n.createPositionAt(e, 0);
                  return o.getNearestSelectionRange(i, "forward");
                })(t, a);
          }
          function yf(t) {
            return ar.isGecko
              ? t.dropEffect
              : ["all", "copyMove"].includes(t.effectAllowed)
              ? "move"
              : "copy";
          }
          function xf(t, e) {
            let n;
            function o(...i) {
              o.cancel(), (n = setTimeout(() => t(...i), e));
            }
            return (
              (o.cancel = () => {
                clearTimeout(n);
              }),
              o
            );
          }
          function Ef(t) {
            if (t.is("editableElement")) return null;
            if (t.hasClass("ck-widget__selection-handle"))
              return t.findAncestor(Gp);
            if (Gp(t)) return t;
            const e = t.findAncestor((t) => Gp(t) || t.is("editableElement"));
            return Gp(e) ? e : null;
          }
          class Df extends j {
            static get pluginName() {
              return "PastePlainText";
            }
            static get requires() {
              return [zp];
            }
            init() {
              const t = this.editor,
                e = t.model,
                n = t.editing.view,
                o = n.document,
                i = e.document.selection;
              let r = !1;
              n.addObserver(Mp),
                this.listenTo(o, "keydown", (t, e) => {
                  r = e.shiftKey;
                }),
                t.plugins.get(zp).on("contentInsertion", (t, n) => {
                  (r ||
                    (function (t, e) {
                      if (t.childCount > 1) return !1;
                      const n = t.getChild(0);
                      if (e.isObject(n)) return !1;
                      return 0 == Array.from(n.getAttributeKeys()).length;
                    })(n.content, e.schema)) &&
                    e.change((t) => {
                      const o = Array.from(i.getAttributes()).filter(
                        ([t]) => e.schema.getAttributeProperties(t).isFormatting
                      );
                      i.isCollapsed ||
                        e.deleteContent(i, { doNotAutoparagraph: !0 }),
                        o.push(...i.getAttributes());
                      const r = t.createRangeIn(n.content);
                      for (const e of r.getItems())
                        e.is("$textProxy") && t.setAttributes(o, e);
                    });
                });
            }
          }
          class Sf extends j {
            static get pluginName() {
              return "Clipboard";
            }
            static get requires() {
              return [zp, Cf, Df];
            }
          }
          class If extends F {
            constructor(t) {
              super(t),
                (this._stack = []),
                (this._createdBatches = new WeakSet()),
                this.refresh(),
                this.listenTo(
                  t.data,
                  "set",
                  (t, e) => {
                    e[1] = { ...e[1] };
                    const n = e[1];
                    n.batchType || (n.batchType = { isUndoable: !1 });
                  },
                  { priority: "high" }
                ),
                this.listenTo(t.data, "set", (t, e) => {
                  e[1].batchType.isUndoable || this.clearStack();
                });
            }
            refresh() {
              this.isEnabled = this._stack.length > 0;
            }
            addBatch(t) {
              const e = this.editor.model.document.selection,
                n = {
                  ranges: e.hasOwnRange ? Array.from(e.getRanges()) : [],
                  isBackward: e.isBackward,
                };
              this._stack.push({ batch: t, selection: n }), this.refresh();
            }
            clearStack() {
              (this._stack = []), this.refresh();
            }
            _restoreSelection(t, e, n) {
              const o = this.editor.model,
                i = o.document,
                r = [],
                s = t.map((t) => t.getTransformedByOperations(n)),
                a = s.flat();
              for (const t of s) {
                const e = t
                  .filter((t) => t.root != i.graveyard)
                  .filter((t) => !Mf(t, a));
                e.length && (Tf(e), r.push(e[0]));
              }
              r.length &&
                o.change((t) => {
                  t.setSelection(r, { backward: e });
                });
            }
            _undo(t, e) {
              const n = this.editor.model,
                o = n.document;
              this._createdBatches.add(e);
              const i = t.operations
                .slice()
                .filter((t) => t.isDocumentOperation);
              i.reverse();
              for (const t of i) {
                const i = t.baseVersion + 1,
                  r = Array.from(o.history.getOperations(i)),
                  s = qd([t.getReversed()], r, {
                    useRelations: !0,
                    document: this.editor.model.document,
                    padWithNoOps: !1,
                    forceWeakRemove: !0,
                  }).operationsA;
                for (const i of s)
                  e.addOperation(i),
                    n.applyOperation(i),
                    o.history.setOperationAsUndone(t, i);
              }
            }
          }
          function Tf(t) {
            t.sort((t, e) => (t.start.isBefore(e.start) ? -1 : 1));
            for (let e = 1; e < t.length; e++) {
              const n = t[e - 1].getJoined(t[e], !0);
              n && (e--, t.splice(e, 2, n));
            }
          }
          function Mf(t, e) {
            return e.some((e) => e !== t && e.containsRange(t, !0));
          }
          class Bf extends If {
            execute(t = null) {
              const e = t
                  ? this._stack.findIndex((e) => e.batch == t)
                  : this._stack.length - 1,
                n = this._stack.splice(e, 1)[0],
                o = this.editor.model.createBatch({ isUndo: !0 });
              this.editor.model.enqueueChange(o, () => {
                this._undo(n.batch, o);
                const t = this.editor.model.document.history.getOperations(
                  n.batch.baseVersion
                );
                this._restoreSelection(
                  n.selection.ranges,
                  n.selection.isBackward,
                  t
                ),
                  this.fire("revert", n.batch, o);
              }),
                this.refresh();
            }
          }
          class Nf extends If {
            execute() {
              const t = this._stack.pop(),
                e = this.editor.model.createBatch({ isUndo: !0 });
              this.editor.model.enqueueChange(e, () => {
                const n =
                    t.batch.operations[t.batch.operations.length - 1]
                      .baseVersion + 1,
                  o = this.editor.model.document.history.getOperations(n);
                this._restoreSelection(
                  t.selection.ranges,
                  t.selection.isBackward,
                  o
                ),
                  this._undo(t.batch, e);
              }),
                this.refresh();
            }
          }
          class zf extends j {
            static get pluginName() {
              return "UndoEditing";
            }
            constructor(t) {
              super(t), (this._batchRegistry = new WeakSet());
            }
            init() {
              const t = this.editor;
              (this._undoCommand = new Bf(t)),
                (this._redoCommand = new Nf(t)),
                t.commands.add("undo", this._undoCommand),
                t.commands.add("redo", this._redoCommand),
                this.listenTo(
                  t.model,
                  "applyOperation",
                  (t, e) => {
                    const n = e[0];
                    if (!n.isDocumentOperation) return;
                    const o = n.batch,
                      i = this._redoCommand._createdBatches.has(o),
                      r = this._undoCommand._createdBatches.has(o);
                    this._batchRegistry.has(o) ||
                      (this._batchRegistry.add(o),
                      o.isUndoable &&
                        (i
                          ? this._undoCommand.addBatch(o)
                          : r ||
                            (this._undoCommand.addBatch(o),
                            this._redoCommand.clearStack())));
                  },
                  { priority: "highest" }
                ),
                this.listenTo(this._undoCommand, "revert", (t, e, n) => {
                  this._redoCommand.addBatch(n);
                }),
                t.keystrokes.set("CTRL+Z", "undo"),
                t.keystrokes.set("CTRL+Y", "redo"),
                t.keystrokes.set("CTRL+SHIFT+Z", "redo");
            }
          }
          const Pf =
              '<svg viewBox="0 0 20 20" xmlns="http://www.w3.org/2000/svg"><path d="m5.042 9.367 2.189 1.837a.75.75 0 0 1-.965 1.149l-3.788-3.18a.747.747 0 0 1-.21-.284.75.75 0 0 1 .17-.945L6.23 4.762a.75.75 0 1 1 .964 1.15L4.863 7.866h8.917A.75.75 0 0 1 14 7.9a4 4 0 1 1-1.477 7.718l.344-1.489a2.5 2.5 0 1 0 1.094-4.73l.008-.032H5.042z"/></svg>',
            Lf =
              '<svg viewBox="0 0 20 20" xmlns="http://www.w3.org/2000/svg"><path d="m14.958 9.367-2.189 1.837a.75.75 0 0 0 .965 1.149l3.788-3.18a.747.747 0 0 0 .21-.284.75.75 0 0 0-.17-.945L13.77 4.762a.75.75 0 1 0-.964 1.15l2.331 1.955H6.22A.75.75 0 0 0 6 7.9a4 4 0 1 0 1.477 7.718l-.344-1.489A2.5 2.5 0 1 1 6.039 9.4l-.008-.032h8.927z"/></svg>';
          class Rf extends j {
            static get pluginName() {
              return "UndoUI";
            }
            init() {
              const t = this.editor,
                e = t.locale,
                n = t.t,
                o = "ltr" == e.uiLanguageDirection ? Pf : Lf,
                i = "ltr" == e.uiLanguageDirection ? Lf : Pf;
              this._addButton("undo", n("Undo"), "CTRL+Z", o),
                this._addButton("redo", n("Redo"), "CTRL+Y", i);
            }
            _addButton(t, e, n, o) {
              const i = this.editor;
              i.ui.componentFactory.add(t, (r) => {
                const s = i.commands.get(t),
                  a = new nm(r);
                return (
                  a.set({ label: e, icon: o, keystroke: n, tooltip: !0 }),
                  a.bind("isEnabled").to(s, "isEnabled"),
                  this.listenTo(a, "execute", () => {
                    i.execute(t), i.editing.view.focus();
                  }),
                  a
                );
              });
            }
          }
          class Of extends j {
            static get requires() {
              return [zf, Rf];
            }
            static get pluginName() {
              return "Undo";
            }
          }
          class jf extends j {
            static get requires() {
              return [vg];
            }
            static get pluginName() {
              return "WidgetToolbarRepository";
            }
            init() {
              const t = this.editor;
              if (t.plugins.has("BalloonToolbar")) {
                const e = t.plugins.get("BalloonToolbar");
                this.listenTo(
                  e,
                  "show",
                  (e) => {
                    (function (t) {
                      const e = t.getSelectedElement();
                      return !(!e || !Gp(e));
                    })(t.editing.view.document.selection) && e.stop();
                  },
                  { priority: "high" }
                );
              }
              (this._toolbarDefinitions = new Map()),
                (this._balloon = this.editor.plugins.get("ContextualBalloon")),
                this.on("change:isEnabled", () => {
                  this._updateToolbarsVisibility();
                }),
                this.listenTo(t.ui, "update", () => {
                  this._updateToolbarsVisibility();
                }),
                this.listenTo(
                  t.ui.focusTracker,
                  "change:isFocused",
                  () => {
                    this._updateToolbarsVisibility();
                  },
                  { priority: "low" }
                );
            }
            destroy() {
              super.destroy();
              for (const t of this._toolbarDefinitions.values())
                t.view.destroy();
            }
            register(
              t,
              {
                ariaLabel: e,
                items: n,
                getRelatedElement: o,
                balloonClassName: i = "ck-toolbar-container",
              }
            ) {
              if (!n.length)
                return void c("widget-toolbar-no-items", { toolbarId: t });
              const r = this.editor,
                s = r.t,
                a = new Mm(r.locale);
              if (
                ((a.ariaLabel = e || s("Widget toolbar")),
                this._toolbarDefinitions.has(t))
              )
                throw new l("widget-toolbar-duplicated", this, {
                  toolbarId: t,
                });
              a.fillFromConfig(n, r.ui.componentFactory);
              const d = { view: a, getRelatedElement: o, balloonClassName: i };
              r.ui.addToolbar(a, {
                isContextual: !0,
                beforeFocus: () => {
                  const t = o(r.editing.view.document.selection);
                  t && this._showToolbar(d, t);
                },
                afterBlur: () => {
                  this._hideToolbar(d);
                },
              }),
                this._toolbarDefinitions.set(t, d);
            }
            _updateToolbarsVisibility() {
              let t = 0,
                e = null,
                n = null;
              for (const o of this._toolbarDefinitions.values()) {
                const i = o.getRelatedElement(
                  this.editor.editing.view.document.selection
                );
                if (this.isEnabled && i)
                  if (this.editor.ui.focusTracker.isFocused) {
                    const r = i.getAncestors().length;
                    r > t && ((t = r), (e = i), (n = o));
                  } else this._isToolbarVisible(o) && this._hideToolbar(o);
                else this._isToolbarInBalloon(o) && this._hideToolbar(o);
              }
              n && this._showToolbar(n, e);
            }
            _hideToolbar(t) {
              this._balloon.remove(t.view),
                this.stopListening(this._balloon, "change:visibleView");
            }
            _showToolbar(t, e) {
              this._isToolbarVisible(t)
                ? Vf(this.editor, e)
                : this._isToolbarInBalloon(t) ||
                  (this._balloon.add({
                    view: t.view,
                    position: Ff(this.editor, e),
                    balloonClassName: t.balloonClassName,
                  }),
                  this.listenTo(this._balloon, "change:visibleView", () => {
                    for (const t of this._toolbarDefinitions.values())
                      if (this._isToolbarVisible(t)) {
                        const e = t.getRelatedElement(
                          this.editor.editing.view.document.selection
                        );
                        Vf(this.editor, e);
                      }
                  }));
            }
            _isToolbarVisible(t) {
              return this._balloon.visibleView === t.view;
            }
            _isToolbarInBalloon(t) {
              return this._balloon.hasView(t.view);
            }
          }
          function Vf(t, e) {
            const n = t.plugins.get("ContextualBalloon"),
              o = Ff(t, e);
            n.updatePosition(o);
          }
          function Ff(t, e) {
            const n = t.editing.view,
              o = Mh.defaultPositions;
            return {
              target: n.domConverter.mapViewToDom(e),
              positions: [
                o.northArrowSouth,
                o.northArrowSouthWest,
                o.northArrowSouthEast,
                o.southArrowNorth,
                o.southArrowNorthWest,
                o.southArrowNorthEast,
                o.viewportStickyNorth,
              ],
            };
          }
          class Hf extends N {
            constructor(t) {
              super(),
                this.set("activeHandlePosition", null),
                this.set("proposedWidthPercents", null),
                this.set("proposedWidth", null),
                this.set("proposedHeight", null),
                this.set("proposedHandleHostWidth", null),
                this.set("proposedHandleHostHeight", null),
                (this._options = t),
                (this._referenceCoordinates = null);
            }
            get originalWidth() {
              return this._originalWidth;
            }
            get originalHeight() {
              return this._originalHeight;
            }
            get originalWidthPercents() {
              return this._originalWidthPercents;
            }
            get aspectRatio() {
              return this._aspectRatio;
            }
            begin(t, e, n) {
              const o = new Ma(e);
              (this.activeHandlePosition = (function (t) {
                const e = [
                  "top-left",
                  "top-right",
                  "bottom-right",
                  "bottom-left",
                ];
                for (const n of e) if (t.classList.contains(Uf(n))) return n;
              })(t)),
                (this._referenceCoordinates = (function (t, e) {
                  const n = new Ma(t),
                    o = e.split("-"),
                    i = {
                      x: "right" == o[1] ? n.right : n.left,
                      y: "bottom" == o[0] ? n.bottom : n.top,
                    };
                  return (
                    (i.x += t.ownerDocument.defaultView.scrollX),
                    (i.y += t.ownerDocument.defaultView.scrollY),
                    i
                  );
                })(
                  e,
                  (function (t) {
                    const e = t.split("-"),
                      n = {
                        top: "bottom",
                        bottom: "top",
                        left: "right",
                        right: "left",
                      };
                    return `${n[e[0]]}-${n[e[1]]}`;
                  })(this.activeHandlePosition)
                )),
                (this._originalWidth = o.width),
                (this._originalHeight = o.height),
                (this._aspectRatio = o.width / o.height);
              const i = n.style.width;
              i && i.match(/^\d+(\.\d*)?%$/)
                ? (this._originalWidthPercents = parseFloat(i))
                : (this._originalWidthPercents = (function (t, e) {
                    const n = t.parentElement,
                      o = parseFloat(
                        n.ownerDocument.defaultView.getComputedStyle(n).width
                      );
                    return (e.width / o) * 100;
                  })(n, o));
            }
            update(t) {
              (this.proposedWidth = t.width),
                (this.proposedHeight = t.height),
                (this.proposedWidthPercents = t.widthPercents),
                (this.proposedHandleHostWidth = t.handleHostWidth),
                (this.proposedHandleHostHeight = t.handleHostHeight);
            }
          }
          function Uf(t) {
            return `ck-widget__resizer__handle-${t}`;
          }
          class Wf extends Ch {
            constructor() {
              super();
              const t = this.bindTemplate;
              this.setTemplate({
                tag: "div",
                attributes: {
                  class: [
                    "ck",
                    "ck-size-view",
                    t.to("_viewPosition", (t) =>
                      t ? `ck-orientation-${t}` : ""
                    ),
                  ],
                  style: { display: t.if("_isVisible", "none", (t) => !t) },
                },
                children: [{ text: t.to("_label") }],
              });
            }
            _bindToState(t, e) {
              this.bind("_isVisible").to(
                e,
                "proposedWidth",
                e,
                "proposedHeight",
                (t, e) => null !== t && null !== e
              ),
                this.bind("_label").to(
                  e,
                  "proposedHandleHostWidth",
                  e,
                  "proposedHandleHostHeight",
                  e,
                  "proposedWidthPercents",
                  (e, n, o) => ("px" === t.unit ? `${e}×${n}` : `${o}%`)
                ),
                this.bind("_viewPosition").to(
                  e,
                  "activeHandlePosition",
                  e,
                  "proposedHandleHostWidth",
                  e,
                  "proposedHandleHostHeight",
                  (t, e, n) => (e < 50 || n < 50 ? "above-center" : t)
                );
            }
            _dismiss() {
              this.unbind(), (this._isVisible = !1);
            }
          }
          class $f extends N {
            constructor(t) {
              super(),
                (this._options = t),
                (this._viewResizerWrapper = null),
                this.set("isEnabled", !0),
                this.set("isSelected", !1),
                this.bind("isVisible").to(
                  this,
                  "isEnabled",
                  this,
                  "isSelected",
                  (t, e) => t && e
                ),
                this.decorate("begin"),
                this.decorate("cancel"),
                this.decorate("commit"),
                this.decorate("updateSize"),
                this.on(
                  "commit",
                  (t) => {
                    this.state.proposedWidth ||
                      this.state.proposedWidthPercents ||
                      (this._cleanup(), t.stop());
                  },
                  { priority: "high" }
                );
            }
            get state() {
              return this._state;
            }
            show() {
              this._options.editor.editing.view.change((t) => {
                t.removeClass("ck-hidden", this._viewResizerWrapper);
              });
            }
            hide() {
              this._options.editor.editing.view.change((t) => {
                t.addClass("ck-hidden", this._viewResizerWrapper);
              });
            }
            attach() {
              const t = this,
                e = this._options.viewElement;
              this._options.editor.editing.view.change((n) => {
                const o = n.createUIElement(
                  "div",
                  { class: "ck ck-reset_all ck-widget__resizer" },
                  function (e) {
                    const n = this.toDomElement(e);
                    return t._appendHandles(n), t._appendSizeUI(n), n;
                  }
                );
                n.insert(n.createPositionAt(e, "end"), o),
                  n.addClass("ck-widget_with-resizer", e),
                  (this._viewResizerWrapper = o),
                  this.isVisible || this.hide();
              }),
                this.on("change:isVisible", () => {
                  this.isVisible ? (this.show(), this.redraw()) : this.hide();
                });
            }
            begin(t) {
              (this._state = new Hf(this._options)),
                this._sizeView._bindToState(this._options, this.state),
                (this._initialViewWidth =
                  this._options.viewElement.getStyle("width")),
                this.state.begin(
                  t,
                  this._getHandleHost(),
                  this._getResizeHost()
                );
            }
            updateSize(t) {
              const e = this._proposeNewSize(t);
              this._options.editor.editing.view.change((t) => {
                const n = this._options.unit || "%",
                  o = ("%" === n ? e.widthPercents : e.width) + n;
                t.setStyle("width", o, this._options.viewElement);
              });
              const n = this._getHandleHost(),
                o = new Ma(n),
                i = Math.round(o.width),
                r = Math.round(o.height),
                s = new Ma(n);
              (e.width = Math.round(s.width)),
                (e.height = Math.round(s.height)),
                this.redraw(o),
                this.state.update({
                  ...e,
                  handleHostWidth: i,
                  handleHostHeight: r,
                });
            }
            commit() {
              const t = this._options.unit || "%",
                e =
                  ("%" === t
                    ? this.state.proposedWidthPercents
                    : this.state.proposedWidth) + t;
              this._options.editor.editing.view.change(() => {
                this._cleanup(), this._options.onCommit(e);
              });
            }
            cancel() {
              this._cleanup();
            }
            destroy() {
              this.cancel();
            }
            redraw(t) {
              const e = this._domResizerWrapper;
              if (!((n = e) && n.ownerDocument && n.ownerDocument.contains(n)))
                return;
              var n;
              const o = e.parentElement,
                i = this._getHandleHost(),
                r = this._viewResizerWrapper,
                s = [
                  r.getStyle("width"),
                  r.getStyle("height"),
                  r.getStyle("left"),
                  r.getStyle("top"),
                ];
              let a;
              if (o.isSameNode(i)) {
                const e = t || new Ma(i);
                a = [e.width + "px", e.height + "px", void 0, void 0];
              } else
                a = [
                  i.offsetWidth + "px",
                  i.offsetHeight + "px",
                  i.offsetLeft + "px",
                  i.offsetTop + "px",
                ];
              "same" !== Do(s, a) &&
                this._options.editor.editing.view.change((t) => {
                  t.setStyle(
                    { width: a[0], height: a[1], left: a[2], top: a[3] },
                    r
                  );
                });
            }
            containsHandle(t) {
              return this._domResizerWrapper.contains(t);
            }
            static isResizeHandle(t) {
              return t.classList.contains("ck-widget__resizer__handle");
            }
            _cleanup() {
              this._sizeView._dismiss();
              this._options.editor.editing.view.change((t) => {
                t.setStyle(
                  "width",
                  this._initialViewWidth,
                  this._options.viewElement
                );
              });
            }
            _proposeNewSize(t) {
              const e = this.state,
                n = { x: (o = t).pageX, y: o.pageY };
              var o;
              const i =
                  !this._options.isCentered || this._options.isCentered(this),
                r = {
                  x: e._referenceCoordinates.x - (n.x + e.originalWidth),
                  y: n.y - e.originalHeight - e._referenceCoordinates.y,
                };
              i &&
                e.activeHandlePosition.endsWith("-right") &&
                (r.x = n.x - (e._referenceCoordinates.x + e.originalWidth)),
                i && (r.x *= 2);
              let s = Math.abs(e.originalWidth + r.x),
                a = Math.abs(e.originalHeight + r.y);
              return (
                "width" == (s / e.aspectRatio > a ? "width" : "height")
                  ? (a = s / e.aspectRatio)
                  : (s = a * e.aspectRatio),
                {
                  width: Math.round(s),
                  height: Math.round(a),
                  widthPercents: Math.min(
                    Math.round(
                      (e.originalWidthPercents / e.originalWidth) * s * 100
                    ) / 100,
                    100
                  ),
                }
              );
            }
            _getResizeHost() {
              const t = this._domResizerWrapper.parentElement;
              return this._options.getResizeHost(t);
            }
            _getHandleHost() {
              const t = this._domResizerWrapper.parentElement;
              return this._options.getHandleHost(t);
            }
            get _domResizerWrapper() {
              return this._options.editor.editing.view.domConverter.mapViewToDom(
                this._viewResizerWrapper
              );
            }
            _appendHandles(t) {
              const e = [
                "top-left",
                "top-right",
                "bottom-right",
                "bottom-left",
              ];
              for (const o of e)
                t.appendChild(
                  new Xu({
                    tag: "div",
                    attributes: {
                      class:
                        "ck-widget__resizer__handle " +
                        ((n = o), `ck-widget__resizer__handle-${n}`),
                    },
                  }).render()
                );
              var n;
            }
            _appendSizeUI(t) {
              (this._sizeView = new Wf()),
                this._sizeView.render(),
                t.appendChild(this._sizeView.element);
            }
          }
          var qf = n(2263),
            Gf = { attributes: { "data-cke": !0 } };
          (Gf.setAttributes = is()),
            (Gf.insert = ns().bind(null, "head")),
            (Gf.domAPI = ts()),
            (Gf.insertStyleElement = ss());
          Jr()(qf.Z, Gf);
          qf.Z && qf.Z.locals && qf.Z.locals;
          class Zf extends j {
            static get pluginName() {
              return "WidgetResize";
            }
            init() {
              const t = this.editor.editing,
                e = wo.window.document;
              this.set("selectedResizer", null),
                this.set("_activeResizer", null),
                (this._resizers = new Map()),
                t.view.addObserver(tu),
                (this._observer = new Ss()),
                this.listenTo(
                  t.view.document,
                  "mousedown",
                  this._mouseDownListener.bind(this),
                  { priority: "high" }
                ),
                this._observer.listenTo(
                  e,
                  "mousemove",
                  this._mouseMoveListener.bind(this)
                ),
                this._observer.listenTo(
                  e,
                  "mouseup",
                  this._mouseUpListener.bind(this)
                ),
                (this._redrawSelectedResizerThrottled = wf(
                  () => this.redrawSelectedResizer(),
                  200
                )),
                this.editor.ui.on(
                  "update",
                  this._redrawSelectedResizerThrottled
                ),
                this.editor.model.document.on(
                  "change",
                  () => {
                    for (const [t, e] of this._resizers)
                      t.isAttached() || (this._resizers.delete(t), e.destroy());
                  },
                  { priority: "lowest" }
                ),
                this._observer.listenTo(
                  wo.window,
                  "resize",
                  this._redrawSelectedResizerThrottled
                );
              const n = this.editor.editing.view.document.selection;
              n.on("change", () => {
                const t = n.getSelectedElement(),
                  e = this.getResizerByViewElement(t) || null;
                e ? this.select(e) : this.deselect();
              });
            }
            redrawSelectedResizer() {
              this.selectedResizer &&
                this.selectedResizer.isVisible &&
                this.selectedResizer.redraw();
            }
            destroy() {
              super.destroy(), this._observer.stopListening();
              for (const t of this._resizers.values()) t.destroy();
              this._redrawSelectedResizerThrottled.cancel();
            }
            select(t) {
              this.deselect(),
                (this.selectedResizer = t),
                (this.selectedResizer.isSelected = !0);
            }
            deselect() {
              this.selectedResizer && (this.selectedResizer.isSelected = !1),
                (this.selectedResizer = null);
            }
            attachTo(t) {
              const e = new $f(t),
                n = this.editor.plugins;
              if ((e.attach(), n.has("WidgetToolbarRepository"))) {
                const t = n.get("WidgetToolbarRepository");
                e.on(
                  "begin",
                  () => {
                    t.forceDisabled("resize");
                  },
                  { priority: "lowest" }
                ),
                  e.on(
                    "cancel",
                    () => {
                      t.clearForceDisabled("resize");
                    },
                    { priority: "highest" }
                  ),
                  e.on(
                    "commit",
                    () => {
                      t.clearForceDisabled("resize");
                    },
                    { priority: "highest" }
                  );
              }
              this._resizers.set(t.viewElement, e);
              const o =
                this.editor.editing.view.document.selection.getSelectedElement();
              return this.getResizerByViewElement(o) == e && this.select(e), e;
            }
            getResizerByViewElement(t) {
              return this._resizers.get(t);
            }
            _getResizerByHandle(t) {
              for (const e of this._resizers.values())
                if (e.containsHandle(t)) return e;
            }
            _mouseDownListener(t, e) {
              const n = e.domTarget;
              $f.isResizeHandle(n) &&
                ((this._activeResizer = this._getResizerByHandle(n) || null),
                this._activeResizer &&
                  (this._activeResizer.begin(n), t.stop(), e.preventDefault()));
            }
            _mouseMoveListener(t, e) {
              this._activeResizer && this._activeResizer.updateSize(e);
            }
            _mouseUpListener() {
              this._activeResizer &&
                (this._activeResizer.commit(), (this._activeResizer = null));
            }
          }
          function Yf(t) {
            return t.createContainerElement("figure", { class: "image" }, [
              t.createEmptyElement("img"),
              t.createSlot(),
            ]);
          }
          function Kf(t, e) {
            const n = t.plugins.get("ImageUtils"),
              o =
                t.plugins.has("ImageInlineEditing") &&
                t.plugins.has("ImageBlockEditing");
            return (t) => {
              if (!n.isInlineImageView(t)) return null;
              if (!o) return i(t);
              return (t.findAncestor(n.isBlockImageView)
                ? "imageBlock"
                : "imageInline") !== e
                ? null
                : i(t);
            };
            function i(t) {
              const e = { name: !0 };
              return t.hasAttribute("src") && (e.attributes = ["src"]), e;
            }
          }
          function Qf(t, e) {
            const n = Ra(e.getSelectedBlocks());
            return !n || t.isObject(n) || (n.isEmpty && "listItem" != n.name)
              ? "imageBlock"
              : "imageInline";
          }
          class Jf extends j {
            static get pluginName() {
              return "ImageUtils";
            }
            isImage(t) {
              return this.isInlineImage(t) || this.isBlockImage(t);
            }
            isInlineImageView(t) {
              return !!t && t.is("element", "img");
            }
            isBlockImageView(t) {
              return !!t && t.is("element", "figure") && t.hasClass("image");
            }
            insertImage(t = {}, e = null, n = null) {
              const o = this.editor,
                i = o.model,
                r = i.document.selection;
              (n = Xf(o, e || r, n)),
                (t = { ...Object.fromEntries(r.getAttributes()), ...t });
              for (const e in t) i.schema.checkAttribute(n, e) || delete t[e];
              return i.change((o) => {
                const r = o.createElement(n, t);
                return (
                  i.insertObject(r, e, null, {
                    setSelection: "on",
                    findOptimalPosition: !e && "imageInline" != n,
                  }),
                  r.parent ? r : null
                );
              });
            }
            getClosestSelectedImageWidget(t) {
              const e = t.getFirstPosition();
              if (!e) return null;
              const n = t.getSelectedElement();
              if (n && this.isImageWidget(n)) return n;
              let o = e.parent;
              for (; o; ) {
                if (o.is("element") && this.isImageWidget(o)) return o;
                o = o.parent;
              }
              return null;
            }
            getClosestSelectedImageElement(t) {
              const e = t.getSelectedElement();
              return this.isImage(e)
                ? e
                : t.getFirstPosition().findAncestor("imageBlock");
            }
            isImageAllowed() {
              const t = this.editor.model.document.selection;
              return (
                (function (t, e) {
                  if ("imageBlock" == Xf(t, e)) {
                    const n = (function (t, e) {
                      const n = tf(t, e).start.parent;
                      if (n.isEmpty && !n.is("element", "$root"))
                        return n.parent;
                      return n;
                    })(e, t.model);
                    if (t.model.schema.checkChild(n, "imageBlock")) return !0;
                  } else if (t.model.schema.checkChild(e.focus, "imageInline"))
                    return !0;
                  return !1;
                })(this.editor, t) &&
                (function (t) {
                  return [...t.focus.getAncestors()].every(
                    (t) => !t.is("element", "imageBlock")
                  );
                })(t)
              );
            }
            toImageWidget(t, e, n) {
              e.setCustomProperty("image", !0, t);
              return Zp(t, e, {
                label: () => {
                  const e = this.findViewImgElement(t).getAttribute("alt");
                  return e ? `${e} ${n}` : n;
                },
              });
            }
            isImageWidget(t) {
              return !!t.getCustomProperty("image") && Gp(t);
            }
            isBlockImage(t) {
              return !!t && t.is("element", "imageBlock");
            }
            isInlineImage(t) {
              return !!t && t.is("element", "imageInline");
            }
            findViewImgElement(t) {
              if (this.isInlineImageView(t)) return t;
              const e = this.editor.editing.view;
              for (const { item: n } of e.createRangeIn(t))
                if (this.isInlineImageView(n)) return n;
            }
          }
          function Xf(t, e, n) {
            const o = t.model.schema,
              i = t.config.get("image.insert.type");
            return t.plugins.has("ImageBlockEditing")
              ? t.plugins.has("ImageInlineEditing")
                ? n ||
                  ("inline" === i
                    ? "imageInline"
                    : "block" === i
                    ? "imageBlock"
                    : e.is("selection")
                    ? Qf(o, e)
                    : o.checkChild(e, "imageInline")
                    ? "imageInline"
                    : "imageBlock")
                : "imageBlock"
              : "imageInline";
          }
          const tk = new RegExp(
            String(
              /^(http(s)?:\/\/)?[\w-]+\.[\w.~:/[\]@!$&'()*+,;=%-]+/.source +
                /\.(jpg|jpeg|png|gif|ico|webp|JPG|JPEG|PNG|GIF|ICO|WEBP)/
                  .source +
                /(\?[\w.~:/[\]@!$&'()*+,;=%-]*)?/.source +
                /(#[\w.~:/[\]@!$&'()*+,;=%-]*)?$/.source
            )
          );
          const ek = function (t, e, n) {
            var o = t.length;
            return (n = void 0 === n ? o : n), !e && n >= o ? t : ei(t, e, n);
          };
          var nk = RegExp(
            "[\\u200d\\ud800-\\udfff\\u0300-\\u036f\\ufe20-\\ufe2f\\u20d0-\\u20ff\\ufe0e\\ufe0f]"
          );
          const ok = function (t) {
            return nk.test(t);
          };
          const ik = function (t) {
            return t.split("");
          };
          var rk = "[\\ud800-\\udfff]",
            sk = "[\\u0300-\\u036f\\ufe20-\\ufe2f\\u20d0-\\u20ff]",
            ak = "\\ud83c[\\udffb-\\udfff]",
            lk = "[^\\ud800-\\udfff]",
            ck = "(?:\\ud83c[\\udde6-\\uddff]){2}",
            dk = "[\\ud800-\\udbff][\\udc00-\\udfff]",
            uk = "(?:" + sk + "|" + ak + ")" + "?",
            hk = "[\\ufe0e\\ufe0f]?",
            mk =
              hk +
              uk +
              ("(?:\\u200d(?:" + [lk, ck, dk].join("|") + ")" + hk + uk + ")*"),
            gk = "(?:" + [lk + sk + "?", sk, ck, dk, rk].join("|") + ")",
            pk = RegExp(ak + "(?=" + ak + ")|" + gk + mk, "g");
          const fk = function (t) {
            return t.match(pk) || [];
          };
          const kk = function (t) {
            return ok(t) ? fk(t) : ik(t);
          };
          const bk = (function (t) {
              return function (e) {
                e = Ko(e);
                var n = ok(e) ? kk(e) : void 0,
                  o = n ? n[0] : e.charAt(0),
                  i = n ? ek(n, 1).join("") : e.slice(1);
                return o[t]() + i;
              };
            })("toUpperCase"),
            wk = /[\u0000-\u0020\u00A0\u1680\u180E\u2000-\u2029\u205f\u3000]/g,
            Ak =
              /^(?:(?:https?|ftps?|mailto):|[^a-z]|[a-z+.-]+(?:[^a-z+.:-]|$))/i,
            _k =
              /^[\S]+@((?![-_])(?:[-\w\u00a1-\uffff]{0,63}[^-_]\.))+(?:[a-z\u00a1-\uffff]{2,})$/i,
            Ck = /^((\w+:(\/{2,})?)|(\W))/i,
            vk = "Ctrl+K";
          function yk(t, { writer: e }) {
            const n = e.createAttributeElement(
              "a",
              { href: t },
              { priority: 5 }
            );
            return e.setCustomProperty("link", !0, n), n;
          }
          function xk(t) {
            return (function (t) {
              return t.replace(wk, "").match(Ak);
            })((t = String(t)))
              ? t
              : "#";
          }
          function Ek(t, e) {
            return !!t && e.checkAttribute(t.name, "linkHref");
          }
          function Dk(t, e) {
            const n = ((o = t), _k.test(o) ? "mailto:" : e);
            var o;
            const i = !!n && !Sk(t);
            return t && i ? n + t : t;
          }
          function Sk(t) {
            return Ck.test(t);
          }
          function Ik(t) {
            window.open(t, "_blank", "noopener");
          }
          const Tk = new RegExp(
            "(^|\\s)(((?:(?:(?:https?|ftp):)?\\/\\/)(?:\\S+(?::\\S*)?@)?(?:(?:[1-9]\\d?|1\\d\\d|2[01]\\d|22[0-3])(?:\\.(?:1?\\d{1,2}|2[0-4]\\d|25[0-5])){2}(?:\\.(?:[1-9]\\d?|1\\d\\d|2[0-4]\\d|25[0-4]))|(((?!www\\.)|(www\\.))(?![-_])(?:[-_a-z0-9\\u00a1-\\uffff]{1,63}\\.)+(?:[a-z\\u00a1-\\uffff]{2,63})))(?::\\d{2,5})?(?:[/?#]\\S*)?)|((www.|(\\S+@))((?![-_])(?:[-_a-z0-9\\u00a1-\\uffff]{1,63}\\.))+(?:[a-z\\u00a1-\\uffff]{2,63})))$",
            "i"
          );
          class Mk extends j {
            static get requires() {
              return [rp];
            }
            static get pluginName() {
              return "AutoLink";
            }
            init() {
              const t = this.editor.model.document.selection;
              t.on("change:range", () => {
                this.isEnabled = !t.anchor.parent.is("element", "codeBlock");
              }),
                this._enableTypingHandling();
            }
            afterInit() {
              this._enableEnterHandling(), this._enableShiftEnterHandling();
            }
            _enableTypingHandling() {
              const t = this.editor,
                e = new lp(t.model, (t) => {
                  if (
                    !(function (t) {
                      return (
                        t.length > 4 &&
                        " " === t[t.length - 1] &&
                        " " !== t[t.length - 2]
                      );
                    })(t)
                  )
                    return;
                  const e = Bk(t.substr(0, t.length - 1));
                  return e ? { url: e } : void 0;
                });
              e.on("matched:data", (e, n) => {
                const { batch: o, range: i, url: r } = n;
                if (!o.isTyping) return;
                const s = i.end.getShiftedBy(-1),
                  a = s.getShiftedBy(-r.length),
                  l = t.model.createRange(a, s);
                this._applyAutoLink(r, l);
              }),
                e.bind("isEnabled").to(this);
            }
            _enableEnterHandling() {
              const t = this.editor,
                e = t.model,
                n = t.commands.get("enter");
              n &&
                n.on("execute", () => {
                  const t = e.document.selection.getFirstPosition();
                  if (!t.parent.previousSibling) return;
                  const n = e.createRangeIn(t.parent.previousSibling);
                  this._checkAndApplyAutoLinkOnRange(n);
                });
            }
            _enableShiftEnterHandling() {
              const t = this.editor,
                e = t.model,
                n = t.commands.get("shiftEnter");
              n &&
                n.on("execute", () => {
                  const t = e.document.selection.getFirstPosition(),
                    n = e.createRange(
                      e.createPositionAt(t.parent, 0),
                      t.getShiftedBy(-1)
                    );
                  this._checkAndApplyAutoLinkOnRange(n);
                });
            }
            _checkAndApplyAutoLinkOnRange(t) {
              const e = this.editor.model,
                { text: n, range: o } = ap(t, e),
                i = Bk(n);
              if (i) {
                const t = e.createRange(o.end.getShiftedBy(-i.length), o.end);
                this._applyAutoLink(i, t);
              }
            }
            _applyAutoLink(t, e) {
              const n = this.editor.model,
                o = Dk(t, this.editor.config.get("link.defaultProtocol"));
              this.isEnabled &&
                (function (t, e) {
                  return e.schema.checkAttributeInSelection(
                    e.createSelection(t),
                    "linkHref"
                  );
                })(e, n) &&
                Sk(o) &&
                !(function (t) {
                  const e = t.start.nodeAfter;
                  return e && e.hasAttribute("linkHref");
                })(e) &&
                this._persistAutoLink(o, e);
            }
            _persistAutoLink(t, e) {
              const n = this.editor.model,
                o = this.editor.plugins.get("Delete");
              n.enqueueChange((i) => {
                i.setAttribute("linkHref", t, e),
                  n.enqueueChange(() => {
                    o.requestUndoOnBackspace();
                  });
              });
            }
          }
          function Bk(t) {
            const e = Tk.exec(t);
            return e ? e[2] : null;
          }
          class Nk extends F {
            execute() {
              const t = this.editor.model,
                e = t.document;
              t.change((n) => {
                !(function (t, e, n) {
                  const o = n.isCollapsed,
                    i = n.getFirstRange(),
                    r = i.start.parent,
                    s = i.end.parent,
                    a = r == s;
                  if (o) {
                    const o = Pp(t.schema, n.getAttributes());
                    zk(t, e, i.end),
                      e.removeSelectionAttribute(n.getAttributeKeys()),
                      e.setSelectionAttribute(o);
                  } else {
                    const o = !(i.start.isAtStart && i.end.isAtEnd);
                    t.deleteContent(n, { leaveUnmerged: o }),
                      a ? zk(t, e, n.focus) : o && e.setSelection(s, 0);
                  }
                })(t, n, e.selection),
                  this.fire("afterExecute", { writer: n });
              });
            }
            refresh() {
              const t = this.editor.model,
                e = t.document;
              this.isEnabled = (function (t, e) {
                if (e.rangeCount > 1) return !1;
                const n = e.anchor;
                if (!n || !t.checkChild(n, "softBreak")) return !1;
                const o = e.getFirstRange(),
                  i = o.start.parent,
                  r = o.end.parent;
                if ((Pk(i, t) || Pk(r, t)) && i !== r) return !1;
                return !0;
              })(t.schema, e.selection);
            }
          }
          function zk(t, e, n) {
            const o = e.createElement("softBreak");
            t.insertContent(o, n), e.setSelection(o, "after");
          }
          function Pk(t, e) {
            return !t.is("rootElement") && (e.isLimit(t) || Pk(t.parent, e));
          }
          class Lk extends j {
            static get pluginName() {
              return "ShiftEnter";
            }
            init() {
              const t = this.editor,
                e = t.model.schema,
                n = t.conversion,
                o = t.editing.view,
                i = o.document;
              e.register("softBreak", { allowWhere: "$text", isInline: !0 }),
                n
                  .for("upcast")
                  .elementToElement({ model: "softBreak", view: "br" }),
                n
                  .for("downcast")
                  .elementToElement({
                    model: "softBreak",
                    view: (t, { writer: e }) => e.createEmptyElement("br"),
                  }),
                o.addObserver(jp),
                t.commands.add("shiftEnter", new Nk(t)),
                this.listenTo(
                  i,
                  "enter",
                  (e, n) => {
                    i.isComposing || n.preventDefault(),
                      n.isSoft &&
                        (t.execute("shiftEnter"), o.scrollToTheSelection());
                  },
                  { priority: "low" }
                );
            }
          }
          class Rk extends F {
            refresh() {
              (this.value = this._getValue()),
                (this.isEnabled = this._checkEnabled());
            }
            execute(t = {}) {
              const e = this.editor.model,
                n = e.schema,
                o = e.document.selection,
                i = Array.from(o.getSelectedBlocks()),
                r = void 0 === t.forceValue ? !this.value : t.forceValue;
              e.change((t) => {
                if (r) {
                  const e = i.filter((t) => Ok(t) || Vk(n, t));
                  this._applyQuote(t, e);
                } else this._removeQuote(t, i.filter(Ok));
              });
            }
            _getValue() {
              const t = Ra(
                this.editor.model.document.selection.getSelectedBlocks()
              );
              return !(!t || !Ok(t));
            }
            _checkEnabled() {
              if (this.value) return !0;
              const t = this.editor.model.document.selection,
                e = this.editor.model.schema,
                n = Ra(t.getSelectedBlocks());
              return !!n && Vk(e, n);
            }
            _removeQuote(t, e) {
              jk(t, e)
                .reverse()
                .forEach((e) => {
                  if (e.start.isAtStart && e.end.isAtEnd)
                    return void t.unwrap(e.start.parent);
                  if (e.start.isAtStart) {
                    const n = t.createPositionBefore(e.start.parent);
                    return void t.move(e, n);
                  }
                  e.end.isAtEnd || t.split(e.end);
                  const n = t.createPositionAfter(e.end.parent);
                  t.move(e, n);
                });
            }
            _applyQuote(t, e) {
              const n = [];
              jk(t, e)
                .reverse()
                .forEach((e) => {
                  let o = Ok(e.start);
                  o || ((o = t.createElement("blockQuote")), t.wrap(e, o)),
                    n.push(o);
                }),
                n
                  .reverse()
                  .reduce((e, n) =>
                    e.nextSibling == n
                      ? (t.merge(t.createPositionAfter(e)), e)
                      : n
                  );
            }
          }
          function Ok(t) {
            return "blockQuote" == t.parent.name ? t.parent : null;
          }
          function jk(t, e) {
            let n,
              o = 0;
            const i = [];
            for (; o < e.length; ) {
              const r = e[o],
                s = e[o + 1];
              n || (n = t.createPositionBefore(r)),
                (s && r.nextSibling == s) ||
                  (i.push(t.createRange(n, t.createPositionAfter(r))),
                  (n = null)),
                o++;
            }
            return i;
          }
          function Vk(t, e) {
            const n = t.checkChild(e.parent, "blockQuote"),
              o = t.checkChild(["$root", "blockQuote"], e);
            return n && o;
          }
          class Fk extends j {
            static get pluginName() {
              return "BlockQuoteEditing";
            }
            static get requires() {
              return [Vp, rp];
            }
            init() {
              const t = this.editor,
                e = t.model.schema;
              t.commands.add("blockQuote", new Rk(t)),
                e.register("blockQuote", { inheritAllFrom: "$container" }),
                t.conversion.elementToElement({
                  model: "blockQuote",
                  view: "blockquote",
                }),
                t.model.document.registerPostFixer((n) => {
                  const o = t.model.document.differ.getChanges();
                  for (const t of o)
                    if ("insert" == t.type) {
                      const o = t.position.nodeAfter;
                      if (!o) continue;
                      if (o.is("element", "blockQuote") && o.isEmpty)
                        return n.remove(o), !0;
                      if (
                        o.is("element", "blockQuote") &&
                        !e.checkChild(t.position, o)
                      )
                        return n.unwrap(o), !0;
                      if (o.is("element")) {
                        const t = n.createRangeIn(o);
                        for (const o of t.getItems())
                          if (
                            o.is("element", "blockQuote") &&
                            !e.checkChild(n.createPositionBefore(o), o)
                          )
                            return n.unwrap(o), !0;
                      }
                    } else if ("remove" == t.type) {
                      const e = t.position.parent;
                      if (e.is("element", "blockQuote") && e.isEmpty)
                        return n.remove(e), !0;
                    }
                  return !1;
                });
              const n = this.editor.editing.view.document,
                o = t.model.document.selection,
                i = t.commands.get("blockQuote");
              this.listenTo(
                n,
                "enter",
                (e, n) => {
                  if (!o.isCollapsed || !i.value) return;
                  o.getLastPosition().parent.isEmpty &&
                    (t.execute("blockQuote"),
                    t.editing.view.scrollToTheSelection(),
                    n.preventDefault(),
                    e.stop());
                },
                { context: "blockquote" }
              ),
                this.listenTo(
                  n,
                  "delete",
                  (e, n) => {
                    if ("backward" != n.direction || !o.isCollapsed || !i.value)
                      return;
                    const r = o.getLastPosition().parent;
                    r.isEmpty &&
                      !r.previousSibling &&
                      (t.execute("blockQuote"),
                      t.editing.view.scrollToTheSelection(),
                      n.preventDefault(),
                      e.stop());
                  },
                  { context: "blockquote" }
                );
            }
          }
          var Hk = n(636),
            Uk = { attributes: { "data-cke": !0 } };
          (Uk.setAttributes = is()),
            (Uk.insert = ns().bind(null, "head")),
            (Uk.domAPI = ts()),
            (Uk.insertStyleElement = ss());
          Jr()(Hk.Z, Uk);
          Hk.Z && Hk.Z.locals && Hk.Z.locals;
          class Wk extends j {
            static get pluginName() {
              return "BlockQuoteUI";
            }
            init() {
              const t = this.editor,
                e = t.t;
              t.ui.componentFactory.add("blockQuote", (n) => {
                const o = t.commands.get("blockQuote"),
                  i = new nm(n);
                return (
                  i.set({
                    label: e("Block quote"),
                    icon: $h.quote,
                    tooltip: !0,
                    isToggleable: !0,
                  }),
                  i.bind("isOn", "isEnabled").to(o, "value", "isEnabled"),
                  this.listenTo(i, "execute", () => {
                    t.execute("blockQuote"), t.editing.view.focus();
                  }),
                  i
                );
              });
            }
          }
          class $k extends F {
            constructor(t, e) {
              super(t), (this.attributeKey = e);
            }
            refresh() {
              const t = this.editor.model,
                e = t.document;
              (this.value = this._getValueFromFirstAllowedNode()),
                (this.isEnabled = t.schema.checkAttributeInSelection(
                  e.selection,
                  this.attributeKey
                ));
            }
            execute(t = {}) {
              const e = this.editor.model,
                n = e.document.selection,
                o = void 0 === t.forceValue ? !this.value : t.forceValue;
              e.change((t) => {
                if (n.isCollapsed)
                  o
                    ? t.setSelectionAttribute(this.attributeKey, !0)
                    : t.removeSelectionAttribute(this.attributeKey);
                else {
                  const i = e.schema.getValidRanges(
                    n.getRanges(),
                    this.attributeKey
                  );
                  for (const e of i)
                    o
                      ? t.setAttribute(this.attributeKey, o, e)
                      : t.removeAttribute(this.attributeKey, e);
                }
              });
            }
            _getValueFromFirstAllowedNode() {
              const t = this.editor.model,
                e = t.schema,
                n = t.document.selection;
              if (n.isCollapsed) return n.hasAttribute(this.attributeKey);
              for (const t of n.getRanges())
                for (const n of t.getItems())
                  if (e.checkAttribute(n, this.attributeKey))
                    return n.hasAttribute(this.attributeKey);
              return !1;
            }
          }
          const qk = "bold";
          class Gk extends j {
            static get pluginName() {
              return "BoldEditing";
            }
            init() {
              const t = this.editor;
              t.model.schema.extend("$text", { allowAttributes: qk }),
                t.model.schema.setAttributeProperties(qk, {
                  isFormatting: !0,
                  copyOnEnter: !0,
                }),
                t.conversion.attributeToElement({
                  model: qk,
                  view: "strong",
                  upcastAlso: [
                    "b",
                    (t) => {
                      const e = t.getStyle("font-weight");
                      return e
                        ? "bold" == e || Number(e) >= 600
                          ? { name: !0, styles: ["font-weight"] }
                          : void 0
                        : null;
                    },
                  ],
                }),
                t.commands.add(qk, new $k(t, qk)),
                t.keystrokes.set("CTRL+B", qk);
            }
          }
          const Zk = "bold";
          class Yk extends j {
            static get pluginName() {
              return "BoldUI";
            }
            init() {
              const t = this.editor,
                e = t.t;
              t.ui.componentFactory.add(Zk, (n) => {
                const o = t.commands.get(Zk),
                  i = new nm(n);
                return (
                  i.set({
                    label: e("Bold"),
                    icon: $h.bold,
                    keystroke: "CTRL+B",
                    tooltip: !0,
                    isToggleable: !0,
                  }),
                  i.bind("isOn", "isEnabled").to(o, "value", "isEnabled"),
                  this.listenTo(i, "execute", () => {
                    t.execute(Zk), t.editing.view.focus();
                  }),
                  i
                );
              });
            }
          }
          const Kk = { autoRefresh: !0 },
            Qk = 36e5;
          class Jk {
            constructor(t, e = Kk) {
              if (!t) throw new l("token-missing-token-url", this);
              e.initValue && this._validateTokenValue(e.initValue),
                this.set("value", e.initValue),
                (this._refresh =
                  "function" == typeof t
                    ? t
                    : () => {
                        return (
                          (e = t),
                          new Promise((t, n) => {
                            const o = new XMLHttpRequest();
                            o.open("GET", e),
                              o.addEventListener("load", () => {
                                const e = o.status,
                                  i = o.response;
                                return e < 200 || e > 299
                                  ? n(
                                      new l(
                                        "token-cannot-download-new-token",
                                        null
                                      )
                                    )
                                  : t(i);
                              }),
                              o.addEventListener("error", () =>
                                n(new Error("Network Error"))
                              ),
                              o.addEventListener("abort", () =>
                                n(new Error("Abort"))
                              ),
                              o.send();
                          })
                        );
                        var e;
                      }),
                (this._options = Object.assign({}, Kk, e));
            }
            init() {
              return new Promise((t, e) => {
                this.value
                  ? (this._options.autoRefresh &&
                      this._registerRefreshTokenTimeout(),
                    t(this))
                  : this.refreshToken().then(t).catch(e);
              });
            }
            refreshToken() {
              return this._refresh()
                .then((t) => {
                  this._validateTokenValue(t),
                    this.set("value", t),
                    this._options.autoRefresh &&
                      this._registerRefreshTokenTimeout();
                })
                .then(() => this);
            }
            destroy() {
              clearTimeout(this._tokenRefreshTimeout);
            }
            _validateTokenValue(t) {
              const e = "string" == typeof t,
                n = !/^".*"$/.test(t),
                o = e && 3 === t.split(".").length;
              if (!n || !o) throw new l("token-not-in-jwt-format", this);
            }
            _registerRefreshTokenTimeout() {
              const t = this._getTokenRefreshTimeoutTime();
              clearTimeout(this._tokenRefreshTimeout),
                (this._tokenRefreshTimeout = setTimeout(() => {
                  this.refreshToken();
                }, t));
            }
            _getTokenRefreshTimeoutTime() {
              try {
                const [, t] = this.value.split("."),
                  { exp: e } = JSON.parse(atob(t));
                if (!e) return Qk;
                return Math.floor((1e3 * e - Date.now()) / 2);
              } catch (t) {
                return Qk;
              }
            }
            static create(t, e = Kk) {
              return new Jk(t, e).init();
            }
          }
          ya(Jk, B);
          const Xk = Jk,
            tb = /^data:(\S*?);base64,/;
          class eb {
            constructor(t, e, n) {
              if (!t) throw new l("fileuploader-missing-file", null);
              if (!e) throw new l("fileuploader-missing-token", null);
              if (!n) throw new l("fileuploader-missing-api-address", null);
              (this.file = (function (t) {
                if ("string" != typeof t) return !1;
                const e = t.match(tb);
                return !(!e || !e.length);
              })(t)
                ? (function (t, e = 512) {
                    try {
                      const n = t.match(tb)[1],
                        o = atob(t.replace(tb, "")),
                        i = [];
                      for (let t = 0; t < o.length; t += e) {
                        const n = o.slice(t, t + e),
                          r = new Array(n.length);
                        for (let t = 0; t < n.length; t++)
                          r[t] = n.charCodeAt(t);
                        i.push(new Uint8Array(r));
                      }
                      return new Blob(i, { type: n });
                    } catch (t) {
                      throw new l(
                        "fileuploader-decoding-image-data-error",
                        null
                      );
                    }
                  })(t)
                : t),
                (this._token = e),
                (this._apiAddress = n);
            }
            onProgress(t) {
              return this.on("progress", (e, n) => t(n)), this;
            }
            onError(t) {
              return this.once("error", (e, n) => t(n)), this;
            }
            abort() {
              this.xhr.abort();
            }
            send() {
              return (
                this._prepareRequest(),
                this._attachXHRListeners(),
                this._sendRequest()
              );
            }
            _prepareRequest() {
              const t = new XMLHttpRequest();
              t.open("POST", this._apiAddress),
                t.setRequestHeader("Authorization", this._token.value),
                (t.responseType = "json"),
                (this.xhr = t);
            }
            _attachXHRListeners() {
              const t = this,
                e = this.xhr;
              function n(e) {
                return () => t.fire("error", e);
              }
              e.addEventListener("error", n("Network Error")),
                e.addEventListener("abort", n("Abort")),
                e.upload &&
                  e.upload.addEventListener("progress", (t) => {
                    t.lengthComputable &&
                      this.fire("progress", {
                        total: t.total,
                        uploaded: t.loaded,
                      });
                  }),
                e.addEventListener("load", () => {
                  const t = e.status,
                    n = e.response;
                  if (t < 200 || t > 299)
                    return this.fire("error", n.message || n.error);
                });
            }
            _sendRequest() {
              const t = new FormData(),
                e = this.xhr;
              return (
                t.append("file", this.file),
                new Promise((n, o) => {
                  e.addEventListener("load", () => {
                    const t = e.status,
                      i = e.response;
                    return t < 200 || t > 299
                      ? i.message
                        ? o(
                            new l("fileuploader-uploading-data-failed", this, {
                              message: i.message,
                            })
                          )
                        : o(i.error)
                      : n(i);
                  }),
                    e.addEventListener("error", () =>
                      o(new Error("Network Error"))
                    ),
                    e.addEventListener("abort", () => o(new Error("Abort"))),
                    e.send(t);
                })
              );
            }
          }
          ya(eb, k);
          class nb {
            constructor(t, e) {
              if (!t) throw new l("uploadgateway-missing-token", null);
              if (!e) throw new l("uploadgateway-missing-api-address", null);
              (this._token = t), (this._apiAddress = e);
            }
            upload(t) {
              return new eb(t, this._token, this._apiAddress);
            }
          }
          class ob extends xo {
            static get pluginName() {
              return "CloudServicesCore";
            }
            createToken(t, e) {
              return new Xk(t, e);
            }
            createUploadGateway(t, e) {
              return new nb(t, e);
            }
          }
          const ib = "code";
          class rb extends j {
            static get pluginName() {
              return "CodeEditing";
            }
            static get requires() {
              return [cp];
            }
            init() {
              const t = this.editor;
              t.model.schema.extend("$text", { allowAttributes: ib }),
                t.model.schema.setAttributeProperties(ib, {
                  isFormatting: !0,
                  copyOnEnter: !1,
                }),
                t.conversion.attributeToElement({
                  model: ib,
                  view: "code",
                  upcastAlso: { styles: { "word-wrap": "break-word" } },
                }),
                t.commands.add(ib, new $k(t, ib)),
                t.plugins.get(cp).registerAttribute(ib),
                Ep(t, ib, "code", "ck-code_selected");
            }
          }
          var sb = n(8180),
            ab = { attributes: { "data-cke": !0 } };
          (ab.setAttributes = is()),
            (ab.insert = ns().bind(null, "head")),
            (ab.domAPI = ts()),
            (ab.insertStyleElement = ss());
          Jr()(sb.Z, ab);
          sb.Z && sb.Z.locals && sb.Z.locals;
          const lb = "code";
          class cb extends j {
            static get pluginName() {
              return "CodeUI";
            }
            init() {
              const t = this.editor,
                e = t.t;
              t.ui.componentFactory.add(lb, (n) => {
                const o = t.commands.get(lb),
                  i = new nm(n);
                return (
                  i.set({
                    label: e("Code"),
                    icon: '<svg viewBox="0 0 20 20" xmlns="http://www.w3.org/2000/svg"><path d="m12.5 5.7 5.2 3.9v1.3l-5.6 4c-.1.2-.3.2-.5.2-.3-.1-.6-.7-.6-1l.3-.4 4.7-3.5L11.5 7l-.2-.2c-.1-.3-.1-.6 0-.8.2-.2.5-.4.8-.4a.8.8 0 0 1 .4.1zm-5.2 0L2 9.6v1.3l5.6 4c.1.2.3.2.5.2.3-.1.7-.7.6-1 0-.1 0-.3-.2-.4l-5-3.5L8.2 7l.2-.2c.1-.3.1-.6 0-.8-.2-.2-.5-.4-.8-.4a.8.8 0 0 0-.3.1z"/></svg>',
                    tooltip: !0,
                    isToggleable: !0,
                  }),
                  i.bind("isOn", "isEnabled").to(o, "value", "isEnabled"),
                  this.listenTo(i, "execute", () => {
                    t.execute(lb), t.editing.view.focus();
                  }),
                  i
                );
              });
            }
          }
          function db(t) {
            const e = t.t,
              n = t.config.get("codeBlock.languages");
            for (const t of n)
              "Plain text" === t.label && (t.label = e("Plain text")),
                void 0 === t.class && (t.class = `language-${t.language}`);
            return n;
          }
          function ub(t, e, n) {
            const o = {};
            for (const i of t)
              "class" === e
                ? (o[i[e].split(" ").shift()] = i[n])
                : (o[i[e]] = i[n]);
            return o;
          }
          function hb(t) {
            return t.data.match(/^(\s*)/)[0];
          }
          function mb(t) {
            const e = t.document.selection,
              n = [];
            if (e.isCollapsed) n.push(e.anchor);
            else {
              const o = e
                .getFirstRange()
                .getWalker({ ignoreElementEnd: !0, direction: "backward" });
              for (const { item: e } of o)
                if (e.is("$textProxy") && e.parent.is("element", "codeBlock")) {
                  const o = hb(e.textNode),
                    { parent: i, startOffset: r } = e.textNode,
                    s = t.createPositionAt(i, r + o.length);
                  n.push(s);
                }
            }
            return n;
          }
          function gb(t) {
            const e = Ra(t.getSelectedBlocks());
            return e && e.is("element", "codeBlock");
          }
          function pb(t, e) {
            return (
              !e.is("rootElement") &&
              !t.isLimit(e) &&
              t.checkChild(e.parent, "codeBlock")
            );
          }
          class fb extends F {
            constructor(t) {
              super(t), (this._lastLanguage = null);
            }
            refresh() {
              (this.value = this._getValue()),
                (this.isEnabled = this._checkEnabled());
            }
            execute(t = {}) {
              const e = this.editor,
                n = e.model,
                o = n.document.selection,
                i = db(e)[0],
                r = Array.from(o.getSelectedBlocks()),
                s = void 0 === t.forceValue ? !this.value : t.forceValue,
                a = (function (t, e, n) {
                  if (t.language) return t.language;
                  if (t.usePreviousLanguageChoice && e) return e;
                  return n;
                })(t, this._lastLanguage, i.language);
              n.change((t) => {
                s ? this._applyCodeBlock(t, r, a) : this._removeCodeBlock(t, r);
              });
            }
            _getValue() {
              const t = Ra(
                this.editor.model.document.selection.getSelectedBlocks()
              );
              return (
                !!!(!t || !t.is("element", "codeBlock")) &&
                t.getAttribute("language")
              );
            }
            _checkEnabled() {
              if (this.value) return !0;
              const t = this.editor.model.document.selection,
                e = this.editor.model.schema,
                n = Ra(t.getSelectedBlocks());
              return !!n && pb(e, n);
            }
            _applyCodeBlock(t, e, n) {
              this._lastLanguage = n;
              const o = this.editor.model.schema,
                i = e.filter((t) => pb(o, t));
              for (const e of i)
                t.rename(e, "codeBlock"),
                  t.setAttribute("language", n, e),
                  o.removeDisallowedAttributes([e], t),
                  Array.from(e.getChildren())
                    .filter((t) => !o.checkChild(e, t))
                    .forEach((e) => t.remove(e));
              i.reverse().forEach((e, n) => {
                const o = i[n + 1];
                e.previousSibling === o &&
                  (t.appendElement("softBreak", o),
                  t.merge(t.createPositionBefore(e)));
              });
            }
            _removeCodeBlock(t, e) {
              const n = e.filter((t) => t.is("element", "codeBlock"));
              for (const e of n) {
                const n = t.createRangeOn(e);
                for (const e of Array.from(n.getItems()).reverse())
                  if (
                    e.is("element", "softBreak") &&
                    e.parent.is("element", "codeBlock")
                  ) {
                    const { position: n } = t.split(t.createPositionBefore(e));
                    t.rename(n.nodeAfter, "paragraph"),
                      t.removeAttribute("language", n.nodeAfter),
                      t.remove(e);
                  }
                t.rename(e, "paragraph"), t.removeAttribute("language", e);
              }
            }
          }
          class kb extends F {
            constructor(t) {
              super(t),
                (this._indentSequence = t.config.get(
                  "codeBlock.indentSequence"
                ));
            }
            refresh() {
              this.isEnabled = this._checkEnabled();
            }
            execute() {
              const t = this.editor.model;
              t.change((e) => {
                const n = mb(t);
                for (const o of n) {
                  const n = e.createText(this._indentSequence);
                  t.insertContent(n, o);
                }
              });
            }
            _checkEnabled() {
              return (
                !!this._indentSequence &&
                gb(this.editor.model.document.selection)
              );
            }
          }
          class bb extends F {
            constructor(t) {
              super(t),
                (this._indentSequence = t.config.get(
                  "codeBlock.indentSequence"
                ));
            }
            refresh() {
              this.isEnabled = this._checkEnabled();
            }
            execute() {
              const t = this.editor.model;
              t.change(() => {
                const e = mb(t);
                for (const n of e) {
                  const e = wb(t, n, this._indentSequence);
                  e && t.deleteContent(t.createSelection(e));
                }
              });
            }
            _checkEnabled() {
              if (!this._indentSequence) return !1;
              const t = this.editor.model;
              return (
                !!gb(t.document.selection) &&
                mb(t).some((e) => wb(t, e, this._indentSequence))
              );
            }
          }
          function wb(t, e, n) {
            const o = (function (t) {
              let e = t.parent.getChild(t.index);
              (e && !e.is("element", "softBreak")) || (e = t.nodeBefore);
              if (!e || e.is("element", "softBreak")) return null;
              return e;
            })(e);
            if (!o) return null;
            const i = hb(o),
              r = i.lastIndexOf(n);
            if (r + n.length !== i.length) return null;
            if (-1 === r) return null;
            const { parent: s, startOffset: a } = o;
            return t.createRange(
              t.createPositionAt(s, a + r),
              t.createPositionAt(s, a + r + n.length)
            );
          }
          function Ab(t, e, n = !1) {
            const o = ub(e, "language", "class"),
              i = ub(e, "language", "label");
            return (e, r, s) => {
              const { writer: a, mapper: l, consumable: c } = s;
              if (!c.consume(r.item, "insert")) return;
              const d = r.item.getAttribute("language"),
                u = l.toViewPosition(t.createPositionBefore(r.item)),
                h = {};
              n && ((h["data-language"] = i[d]), (h.spellcheck = "false"));
              const m = a.createContainerElement("code", {
                  class: o[d] || null,
                }),
                g = a.createContainerElement("pre", h, m);
              a.insert(u, g), l.bindElements(r.item, m);
            };
          }
          const _b = "paragraph";
          class Cb extends j {
            static get pluginName() {
              return "CodeBlockEditing";
            }
            static get requires() {
              return [Lk];
            }
            constructor(t) {
              super(t),
                t.config.define("codeBlock", {
                  languages: [
                    { language: "plaintext", label: "Plain text" },
                    { language: "c", label: "C" },
                    { language: "cs", label: "C#" },
                    { language: "cpp", label: "C++" },
                    { language: "css", label: "CSS" },
                    { language: "diff", label: "Diff" },
                    { language: "html", label: "HTML" },
                    { language: "java", label: "Java" },
                    { language: "javascript", label: "JavaScript" },
                    { language: "php", label: "PHP" },
                    { language: "python", label: "Python" },
                    { language: "ruby", label: "Ruby" },
                    { language: "typescript", label: "TypeScript" },
                    { language: "xml", label: "XML" },
                  ],
                  indentSequence: "\t",
                });
            }
            init() {
              const t = this.editor,
                e = t.model.schema,
                n = t.model,
                o = t.editing.view,
                i = t.plugins.has("DocumentListEditing"),
                r = db(t);
              t.commands.add("codeBlock", new fb(t)),
                t.commands.add("indentCodeBlock", new kb(t)),
                t.commands.add("outdentCodeBlock", new bb(t)),
                this.listenTo(
                  o.document,
                  "tab",
                  (e, n) => {
                    const o = n.shiftKey
                      ? "outdentCodeBlock"
                      : "indentCodeBlock";
                    t.commands.get(o).isEnabled &&
                      (t.execute(o),
                      n.stopPropagation(),
                      n.preventDefault(),
                      e.stop());
                  },
                  { context: "pre" }
                ),
                e.register("codeBlock", {
                  allowWhere: "$block",
                  allowChildren: "$text",
                  isBlock: !0,
                  allowAttributes: ["language"],
                }),
                e.addAttributeCheck((t, e) => {
                  const n =
                    t.endsWith("codeBlock") &&
                    e.startsWith("list") &&
                    "list" !== e;
                  return (
                    !(!i || !n) || (!t.endsWith("codeBlock $text") && void 0)
                  );
                }),
                t.model.schema.addChildCheck((t, e) => {
                  if (t.endsWith("codeBlock") && e.isObject) return !1;
                }),
                t.editing.downcastDispatcher.on(
                  "insert:codeBlock",
                  Ab(n, r, !0)
                ),
                t.data.downcastDispatcher.on("insert:codeBlock", Ab(n, r)),
                t.data.downcastDispatcher.on(
                  "insert:softBreak",
                  (function (t) {
                    return (e, n, o) => {
                      if ("codeBlock" !== n.item.parent.name) return;
                      const { writer: i, mapper: r, consumable: s } = o;
                      if (!s.consume(n.item, "insert")) return;
                      const a = r.toViewPosition(
                        t.createPositionBefore(n.item)
                      );
                      i.insert(a, i.createText("\n"));
                    };
                  })(n),
                  { priority: "high" }
                ),
                t.data.upcastDispatcher.on(
                  "element:code",
                  (function (t, e) {
                    const n = ub(e, "class", "language"),
                      o = e[0].language;
                    return (t, e, i) => {
                      const r = e.viewItem,
                        s = r.parent;
                      if (!s || !s.is("element", "pre")) return;
                      if (e.modelCursor.findAncestor("codeBlock")) return;
                      const { consumable: a, writer: l } = i;
                      if (!a.test(r, { name: !0 })) return;
                      const c = l.createElement("codeBlock"),
                        d = [...r.getClassNames()];
                      d.length || d.push("");
                      for (const t of d) {
                        const e = n[t];
                        if (e) {
                          l.setAttribute("language", e, c);
                          break;
                        }
                      }
                      c.hasAttribute("language") ||
                        l.setAttribute("language", o, c),
                        i.convertChildren(r, c),
                        i.safeInsert(c, e.modelCursor) &&
                          (a.consume(r, { name: !0 }),
                          i.updateConversionResult(c, e));
                    };
                  })(0, r)
                ),
                t.data.upcastDispatcher.on(
                  "text",
                  (t, e, { consumable: n, writer: o }) => {
                    let i = e.modelCursor;
                    if (!n.test(e.viewItem)) return;
                    if (!i.findAncestor("codeBlock")) return;
                    n.consume(e.viewItem);
                    const r = e.viewItem.data
                        .split("\n")
                        .map((t) => o.createText(t)),
                      s = r[r.length - 1];
                    for (const t of r)
                      if (
                        (o.insert(t, i),
                        (i = i.getShiftedBy(t.offsetSize)),
                        t !== s)
                      ) {
                        const t = o.createElement("softBreak");
                        o.insert(t, i), (i = o.createPositionAfter(t));
                      }
                    (e.modelRange = o.createRange(e.modelCursor, i)),
                      (e.modelCursor = i);
                  }
                ),
                t.data.upcastDispatcher.on(
                  "element:pre",
                  (t, e, { consumable: n }) => {
                    const o = e.viewItem;
                    if (o.findAncestor("pre")) return;
                    const i = Array.from(o.getChildren()),
                      r = i.find((t) => t.is("element", "code"));
                    if (r)
                      for (const t of i)
                        t !== r && t.is("$text") && n.consume(t, { name: !0 });
                  },
                  { priority: "high" }
                ),
                this.listenTo(
                  t.editing.view.document,
                  "clipboardInput",
                  (e, o) => {
                    let i = n.createRange(n.document.selection.anchor);
                    if (
                      (o.targetRanges &&
                        (i = t.editing.mapper.toModelRange(o.targetRanges[0])),
                      !i.start.parent.is("element", "codeBlock"))
                    )
                      return;
                    const r = o.dataTransfer.getData("text/plain"),
                      s = new eu(t.editing.view.document);
                    o.content = (function (t, e) {
                      const n = t.createDocumentFragment(),
                        o = e.split("\n"),
                        i = o.reduce(
                          (e, n, i) => (
                            e.push(n),
                            i < o.length - 1 && e.push(t.createElement("br")),
                            e
                          ),
                          []
                        );
                      return t.appendChild(i, n), n;
                    })(s, r);
                  }
                ),
                this.listenTo(n, "getSelectedContent", (t, [o]) => {
                  const i = o.anchor;
                  !o.isCollapsed &&
                    i.parent.is("element", "codeBlock") &&
                    i.hasSameParentAs(o.focus) &&
                    n.change((n) => {
                      const r = t.return;
                      if (
                        r.childCount > 1 ||
                        o.containsEntireContent(i.parent)
                      ) {
                        const e = n.createElement(
                          "codeBlock",
                          i.parent.getAttributes()
                        );
                        n.append(r, e);
                        const o = n.createDocumentFragment();
                        n.append(e, o), (t.return = o);
                      } else {
                        const t = r.getChild(0);
                        e.checkAttribute(t, "code") &&
                          n.setAttribute("code", !0, t);
                      }
                    });
                });
            }
            afterInit() {
              const t = this.editor,
                e = t.commands,
                n = e.get("indent"),
                o = e.get("outdent");
              n &&
                n.registerChildCommand(e.get("indentCodeBlock"), {
                  priority: "highest",
                }),
                o && o.registerChildCommand(e.get("outdentCodeBlock")),
                this.listenTo(
                  t.editing.view.document,
                  "enter",
                  (e, n) => {
                    t.model.document.selection
                      .getLastPosition()
                      .parent.is("element", "codeBlock") &&
                      ((function (t, e) {
                        const n = t.model.document,
                          o = t.editing.view,
                          i = n.selection.getLastPosition(),
                          r = i.nodeAfter;
                        if (e || !n.selection.isCollapsed || !i.isAtStart)
                          return !1;
                        if (!yb(r)) return !1;
                        return (
                          t.model.change((e) => {
                            t.execute("enter");
                            const o = n.selection.anchor.parent.previousSibling;
                            e.rename(o, _b),
                              e.setSelection(o, "in"),
                              t.model.schema.removeDisallowedAttributes([o], e),
                              e.remove(r);
                          }),
                          o.scrollToTheSelection(),
                          !0
                        );
                      })(t, n.isSoft) ||
                        (function (t, e) {
                          const n = t.model,
                            o = n.document,
                            i = t.editing.view,
                            r = o.selection.getLastPosition(),
                            s = r.nodeBefore;
                          let a;
                          if (
                            e ||
                            !o.selection.isCollapsed ||
                            !r.isAtEnd ||
                            !s ||
                            !s.previousSibling
                          )
                            return !1;
                          if (yb(s) && yb(s.previousSibling))
                            a = n.createRange(
                              n.createPositionBefore(s.previousSibling),
                              n.createPositionAfter(s)
                            );
                          else if (
                            vb(s) &&
                            yb(s.previousSibling) &&
                            yb(s.previousSibling.previousSibling)
                          )
                            a = n.createRange(
                              n.createPositionBefore(
                                s.previousSibling.previousSibling
                              ),
                              n.createPositionAfter(s)
                            );
                          else {
                            if (
                              !(
                                vb(s) &&
                                yb(s.previousSibling) &&
                                vb(s.previousSibling.previousSibling) &&
                                yb(
                                  s.previousSibling.previousSibling
                                    .previousSibling
                                )
                              )
                            )
                              return !1;
                            a = n.createRange(
                              n.createPositionBefore(
                                s.previousSibling.previousSibling
                                  .previousSibling
                              ),
                              n.createPositionAfter(s)
                            );
                          }
                          return (
                            t.model.change((e) => {
                              e.remove(a), t.execute("enter");
                              const n = o.selection.anchor.parent;
                              e.rename(n, _b),
                                t.model.schema.removeDisallowedAttributes(
                                  [n],
                                  e
                                );
                            }),
                            i.scrollToTheSelection(),
                            !0
                          );
                        })(t, n.isSoft) ||
                        (function (t) {
                          const e = t.model.document,
                            n = e.selection.getLastPosition(),
                            o = n.nodeBefore || n.textNode;
                          let i;
                          o && o.is("$text") && (i = hb(o));
                          t.model.change((n) => {
                            t.execute("shiftEnter"),
                              i && n.insertText(i, e.selection.anchor);
                          });
                        })(t),
                      n.preventDefault(),
                      e.stop());
                  },
                  { context: "pre" }
                );
            }
          }
          function vb(t) {
            return t && t.is("$text") && !t.data.match(/\S/);
          }
          function yb(t) {
            return t && t.is("element", "softBreak");
          }
          var xb = n(9085),
            Eb = { attributes: { "data-cke": !0 } };
          (Eb.setAttributes = is()),
            (Eb.insert = ns().bind(null, "head")),
            (Eb.domAPI = ts()),
            (Eb.insertStyleElement = ss());
          Jr()(xb.Z, Eb);
          xb.Z && xb.Z.locals && xb.Z.locals;
          class Db extends j {
            static get pluginName() {
              return "CodeBlockUI";
            }
            init() {
              const t = this.editor,
                e = t.t,
                n = t.ui.componentFactory,
                o = db(t);
              n.add("codeBlock", (n) => {
                const i = t.commands.get("codeBlock"),
                  r = Wm(n, km),
                  s = r.buttonView;
                return (
                  s.set({
                    label: e("Insert code block"),
                    tooltip: !0,
                    icon: '<svg viewBox="0 0 20 20" xmlns="http://www.w3.org/2000/svg"><path d="M12.87 12.61a.75.75 0 0 1-.089.976l-.085.07-3.154 2.254 3.412 2.414a.75.75 0 0 1 .237.95l-.057.095a.75.75 0 0 1-.95.237l-.096-.058-4.272-3.022-.003-1.223 4.01-2.867a.75.75 0 0 1 1.047.174zm2.795-.231.095.057 4.011 2.867-.003 1.223-4.272 3.022-.095.058a.75.75 0 0 1-.88-.151l-.07-.086-.058-.095a.75.75 0 0 1 .15-.88l.087-.07 3.412-2.414-3.154-2.253-.085-.071a.75.75 0 0 1 .862-1.207zM16 0a2 2 0 0 1 2 2v9.354l-.663-.492-.837-.001V2a.5.5 0 0 0-.5-.5H2a.5.5 0 0 0-.5.5v15a.5.5 0 0 0 .5.5h3.118L7.156 19H2a2 2 0 0 1-2-2V2a2 2 0 0 1 2-2h14zM5.009 15l.003 1H3v-1h2.009zm2.188-2-1.471 1H5v-1h2.197zM10 11v.095L8.668 12H7v-1h3zm4-2v1H7V9h7zm0-2v1H7V7h7zm-4-2v1H5V5h5zM6 3v1H3V3h3z"/></svg>',
                    isToggleable: !0,
                  }),
                  s.bind("isOn").to(i, "value", (t) => !!t),
                  s.on("execute", () => {
                    t.execute("codeBlock", { usePreviousLanguageChoice: !0 }),
                      t.editing.view.focus();
                  }),
                  r.on("execute", (e) => {
                    t.execute("codeBlock", {
                      language: e.source._codeBlockLanguage,
                      forceValue: !0,
                    }),
                      t.editing.view.focus();
                  }),
                  (r.class = "ck-code-block-dropdown"),
                  r.bind("isEnabled").to(i),
                  qm(r, this._getLanguageListItemDefinitions(o)),
                  r
                );
              });
            }
            _getLanguageListItemDefinitions(t) {
              const e = this.editor.commands.get("codeBlock"),
                n = new po();
              for (const o of t) {
                const t = {
                  type: "button",
                  model: new fg({
                    _codeBlockLanguage: o.language,
                    label: o.label,
                    withText: !0,
                  }),
                };
                t.model
                  .bind("isOn")
                  .to(e, "value", (e) => e === t.model._codeBlockLanguage),
                  n.add(t);
              }
              return n;
            }
          }
          class Sb extends F {
            constructor(t) {
              super(t), (this.affectsData = !1);
            }
            execute() {
              const t = this.editor.model,
                e = t.document.selection;
              let n = t.schema.getLimitElement(e);
              if (e.containsEntireContent(n) || !Ib(t.schema, n))
                do {
                  if (((n = n.parent), !n)) return;
                } while (!Ib(t.schema, n));
              t.change((t) => {
                t.setSelection(n, "in");
              });
            }
          }
          function Ib(t, e) {
            return (
              t.isLimit(e) &&
              (t.checkChild(e, "$text") || t.checkChild(e, "paragraph"))
            );
          }
          const Tb = gr("Ctrl+A");
          class Mb extends j {
            static get pluginName() {
              return "SelectAllEditing";
            }
            init() {
              const t = this.editor,
                e = t.editing.view.document;
              t.commands.add("selectAll", new Sb(t)),
                this.listenTo(e, "keydown", (e, n) => {
                  mr(n) === Tb && (t.execute("selectAll"), n.preventDefault());
                });
            }
          }
          class Bb extends j {
            static get pluginName() {
              return "SelectAllUI";
            }
            init() {
              const t = this.editor;
              t.ui.componentFactory.add("selectAll", (e) => {
                const n = t.commands.get("selectAll"),
                  o = new nm(e),
                  i = e.t;
                return (
                  o.set({
                    label: i("Select all"),
                    icon: '<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 20 20"><path d="M.75 15.5a.75.75 0 0 1 .75.75V18l.008.09A.5.5 0 0 0 2 18.5h1.75a.75.75 0 1 1 0 1.5H1.5l-.144-.007a1.5 1.5 0 0 1-1.35-1.349L0 18.5v-2.25a.75.75 0 0 1 .75-.75zm18.5 0a.75.75 0 0 1 .75.75v2.25l-.007.144a1.5 1.5 0 0 1-1.349 1.35L18.5 20h-2.25a.75.75 0 1 1 0-1.5H18a.5.5 0 0 0 .492-.41L18.5 18v-1.75a.75.75 0 0 1 .75-.75zm-10.45 3c.11 0 .2.09.2.2v1.1a.2.2 0 0 1-.2.2H7.2a.2.2 0 0 1-.2-.2v-1.1c0-.11.09-.2.2-.2h1.6zm4 0c.11 0 .2.09.2.2v1.1a.2.2 0 0 1-.2.2h-1.6a.2.2 0 0 1-.2-.2v-1.1c0-.11.09-.2.2-.2h1.6zm.45-5.5a.75.75 0 1 1 0 1.5h-8.5a.75.75 0 1 1 0-1.5h8.5zM1.3 11c.11 0 .2.09.2.2v1.6a.2.2 0 0 1-.2.2H.2a.2.2 0 0 1-.2-.2v-1.6c0-.11.09-.2.2-.2h1.1zm18.5 0c.11 0 .2.09.2.2v1.6a.2.2 0 0 1-.2.2h-1.1a.2.2 0 0 1-.2-.2v-1.6c0-.11.09-.2.2-.2h1.1zm-4.55-2a.75.75 0 1 1 0 1.5H4.75a.75.75 0 1 1 0-1.5h10.5zM1.3 7c.11 0 .2.09.2.2v1.6a.2.2 0 0 1-.2.2H.2a.2.2 0 0 1-.2-.2V7.2c0-.11.09-.2.2-.2h1.1zm18.5 0c.11 0 .2.09.2.2v1.6a.2.2 0 0 1-.2.2h-1.1a.2.2 0 0 1-.2-.2V7.2c0-.11.09-.2.2-.2h1.1zm-4.55-2a.75.75 0 1 1 0 1.5h-2.5a.75.75 0 1 1 0-1.5h2.5zm-5 0a.75.75 0 1 1 0 1.5h-5.5a.75.75 0 0 1 0-1.5h5.5zm-6.5-5a.75.75 0 0 1 0 1.5H2a.5.5 0 0 0-.492.41L1.5 2v1.75a.75.75 0 0 1-1.5 0V1.5l.007-.144A1.5 1.5 0 0 1 1.356.006L1.5 0h2.25zM18.5 0l.144.007a1.5 1.5 0 0 1 1.35 1.349L20 1.5v2.25a.75.75 0 1 1-1.5 0V2l-.008-.09A.5.5 0 0 0 18 1.5h-1.75a.75.75 0 1 1 0-1.5h2.25zM8.8 0c.11 0 .2.09.2.2v1.1a.2.2 0 0 1-.2.2H7.2a.2.2 0 0 1-.2-.2V.2c0-.11.09-.2.2-.2h1.6zm4 0c.11 0 .2.09.2.2v1.1a.2.2 0 0 1-.2.2h-1.6a.2.2 0 0 1-.2-.2V.2c0-.11.09-.2.2-.2h1.6z"/></svg>',
                    keystroke: "Ctrl+A",
                    tooltip: !0,
                  }),
                  o.bind("isEnabled").to(n, "isEnabled"),
                  this.listenTo(o, "execute", () => {
                    t.execute("selectAll"), t.editing.view.focus();
                  }),
                  o
                );
              });
            }
          }
          class Nb extends j {
            static get requires() {
              return [Mb, Bb];
            }
            static get pluginName() {
              return "SelectAll";
            }
          }
          var zb = n(1590),
            Pb = { attributes: { "data-cke": !0 } };
          (Pb.setAttributes = is()),
            (Pb.insert = ns().bind(null, "head")),
            (Pb.domAPI = ts()),
            (Pb.insertStyleElement = ss());
          Jr()(zb.Z, Pb);
          zb.Z && zb.Z.locals && zb.Z.locals;
          var Lb = n(9289),
            Rb = { attributes: { "data-cke": !0 } };
          (Rb.setAttributes = is()),
            (Rb.insert = ns().bind(null, "head")),
            (Rb.domAPI = ts()),
            (Rb.insertStyleElement = ss());
          Jr()(Lb.Z, Rb);
          Lb.Z && Lb.Z.locals && Lb.Z.locals;
          class Ob extends Ch {
            constructor(t) {
              super(t);
              const e = t.t;
              this.set("matchCount", 0),
                this.set("highlightOffset", 0),
                this.set("isDirty", !1),
                this.set("_areCommandsEnabled", {}),
                this.set("_resultsCounterText", ""),
                this.set("_matchCase", !1),
                this.set("_wholeWordsOnly", !1),
                this.bind("_searchResultsFound").to(
                  this,
                  "matchCount",
                  this,
                  "isDirty",
                  (t, e) => t > 0 && !e
                ),
                (this._findInputView = this._createInputField(
                  e("Find in text…")
                )),
                (this._replaceInputView = this._createInputField(
                  e("Replace with…")
                )),
                (this._findButtonView = this._createButton({
                  label: e("Find"),
                  class: "ck-button-find ck-button-action",
                  withText: !0,
                })),
                (this._findPrevButtonView = this._createButton({
                  label: e("Previous result"),
                  class: "ck-button-prev",
                  icon: kg,
                  keystroke: "Shift+F3",
                  tooltip: !0,
                })),
                (this._findNextButtonView = this._createButton({
                  label: e("Next result"),
                  class: "ck-button-next",
                  icon: kg,
                  keystroke: "F3",
                  tooltip: !0,
                })),
                (this._optionsDropdown = this._createOptionsDropdown()),
                (this._replaceButtonView = this._createButton({
                  label: e("Replace"),
                  class: "ck-button-replace",
                  withText: !0,
                })),
                (this._replaceAllButtonView = this._createButton({
                  label: e("Replace all"),
                  class: "ck-button-replaceall",
                  withText: !0,
                })),
                (this._findFieldsetView = this._createFindFieldset()),
                (this._replaceFieldsetView = this._createReplaceFieldset()),
                (this._focusTracker = new Oa()),
                (this._keystrokes = new ja()),
                (this._focusables = new Ju()),
                (this._focusCycler = new Cm({
                  focusables: this._focusables,
                  focusTracker: this._focusTracker,
                  keystrokeHandler: this._keystrokes,
                  actions: { focusPrevious: "shift + tab", focusNext: "tab" },
                })),
                this.setTemplate({
                  tag: "form",
                  attributes: {
                    class: ["ck", "ck-find-and-replace-form"],
                    tabindex: "-1",
                  },
                  children: [
                    new rg(t, { label: e("Find and replace") }),
                    this._findFieldsetView,
                    this._replaceFieldsetView,
                  ],
                }),
                Gh(this);
            }
            render() {
              super.render(),
                Zh({ view: this }),
                this._initFocusCycling(),
                this._initKeystrokeHandling();
            }
            destroy() {
              super.destroy(),
                this._focusTracker.destroy(),
                this._keystrokes.destroy();
            }
            focus() {
              this._focusCycler.focusFirst();
            }
            reset() {
              (this._findInputView.errorText = null), (this.isDirty = !0);
            }
            get _textToFind() {
              return this._findInputView.fieldView.element.value;
            }
            get _textToReplace() {
              return this._replaceInputView.fieldView.element.value;
            }
            _createFindFieldset() {
              const t = this.locale,
                e = new Ch(t);
              return (
                this._findInputView.fieldView.on("input", () => {
                  this.isDirty = !0;
                }),
                this._findButtonView.on(
                  "execute",
                  this._onFindButtonExecute.bind(this)
                ),
                this._findPrevButtonView
                  .delegate("execute")
                  .to(this, "findPrevious"),
                this._findNextButtonView
                  .delegate("execute")
                  .to(this, "findNext"),
                this._findPrevButtonView
                  .bind("isEnabled")
                  .to(this, "_areCommandsEnabled", ({ findPrevious: t }) => t),
                this._findNextButtonView
                  .bind("isEnabled")
                  .to(this, "_areCommandsEnabled", ({ findNext: t }) => t),
                this._injectFindResultsCounter(),
                e.setTemplate({
                  tag: "fieldset",
                  attributes: {
                    class: ["ck", "ck-find-and-replace-form__find"],
                  },
                  children: [
                    this._findInputView,
                    this._findButtonView,
                    this._findPrevButtonView,
                    this._findNextButtonView,
                  ],
                }),
                e
              );
            }
            _onFindButtonExecute() {
              if (this._textToFind)
                (this.isDirty = !1),
                  this.fire("findNext", {
                    searchText: this._textToFind,
                    matchCase: this._matchCase,
                    wholeWords: this._wholeWordsOnly,
                  });
              else {
                const t = this.t;
                this._findInputView.errorText = t(
                  "Text to find must not be empty."
                );
              }
            }
            _injectFindResultsCounter() {
              const t = this.locale,
                e = t.t,
                n = this.bindTemplate,
                o = new Ch(t);
              this.bind("_resultsCounterText").to(
                this,
                "highlightOffset",
                this,
                "matchCount",
                (t, n) => e("%0 of %1", [t, n])
              ),
                o.setTemplate({
                  tag: "span",
                  attributes: {
                    class: [
                      "ck",
                      "ck-results-counter",
                      n.if("isDirty", "ck-hidden"),
                    ],
                  },
                  children: [{ text: n.to("_resultsCounterText") }],
                });
              const i = () => {
                const e = this._findInputView.fieldView.element;
                if (!e || !La(e)) return;
                const n = new Ma(o.element).width,
                  i =
                    "ltr" === t.uiLanguageDirection
                      ? "paddingRight"
                      : "paddingLeft";
                e.style[i] = n
                  ? `calc( 2 * var(--ck-spacing-standard) + ${n}px )`
                  : null;
              };
              this.on("change:_resultsCounterText", i, { priority: "low" }),
                this.on("change:isDirty", i, { priority: "low" }),
                this._findInputView.template.children[0].children.push(o);
            }
            _createReplaceFieldset() {
              const t = this.locale,
                e = t.t,
                n = new Ch(t);
              return (
                this._replaceButtonView
                  .bind("isEnabled")
                  .to(
                    this,
                    "_areCommandsEnabled",
                    this,
                    "_searchResultsFound",
                    ({ replace: t }, e) => t && e
                  ),
                this._replaceAllButtonView
                  .bind("isEnabled")
                  .to(
                    this,
                    "_areCommandsEnabled",
                    this,
                    "_searchResultsFound",
                    ({ replaceAll: t }, e) => t && e
                  ),
                this._replaceInputView
                  .bind("isEnabled")
                  .to(
                    this,
                    "_areCommandsEnabled",
                    this,
                    "_searchResultsFound",
                    ({ replace: t }, e) => t && e
                  ),
                this._replaceInputView
                  .bind("infoText")
                  .to(
                    this._replaceInputView,
                    "isEnabled",
                    this._replaceInputView,
                    "isFocused",
                    (t, n) =>
                      t || !n
                        ? ""
                        : e("Tip: Find some text first in order to replace it.")
                  ),
                this._replaceButtonView.on("execute", () => {
                  this.fire("replace", {
                    searchText: this._textToFind,
                    replaceText: this._textToReplace,
                  });
                }),
                this._replaceAllButtonView.on("execute", () => {
                  this.fire("replaceAll", {
                    searchText: this._textToFind,
                    replaceText: this._textToReplace,
                  }),
                    this.focus();
                }),
                n.setTemplate({
                  tag: "fieldset",
                  attributes: {
                    class: ["ck", "ck-find-and-replace-form__replace"],
                  },
                  children: [
                    this._replaceInputView,
                    this._optionsDropdown,
                    this._replaceButtonView,
                    this._replaceAllButtonView,
                  ],
                }),
                n
              );
            }
            _createOptionsDropdown() {
              const t = this.locale,
                e = t.t,
                n = Wm(t);
              (n.class = "ck-options-dropdown"),
                n.buttonView.set({
                  withText: !1,
                  label: e("Show options"),
                  icon: $h.cog,
                  tooltip: !0,
                });
              const o = new fg({
                  withText: !0,
                  label: e("Match case"),
                  _isMatchCaseSwitch: !0,
                }),
                i = new fg({ withText: !0, label: e("Whole words only") });
              return (
                o.bind("isOn").to(this, "_matchCase"),
                i.bind("isOn").to(this, "_wholeWordsOnly"),
                n.on("execute", (t) => {
                  t.source._isMatchCaseSwitch
                    ? (this._matchCase = !this._matchCase)
                    : (this._wholeWordsOnly = !this._wholeWordsOnly),
                    (this.isDirty = !0);
                }),
                qm(
                  n,
                  new po([
                    { type: "switchbutton", model: o },
                    { type: "switchbutton", model: i },
                  ])
                ),
                n
              );
            }
            _initFocusCycling() {
              [
                this._findInputView,
                this._findButtonView,
                this._findPrevButtonView,
                this._findNextButtonView,
                this._replaceInputView,
                this._optionsDropdown,
                this._replaceButtonView,
                this._replaceAllButtonView,
              ].forEach((t) => {
                this._focusables.add(t), this._focusTracker.add(t.element);
              });
            }
            _initKeystrokeHandling() {
              const t = (t) => t.stopPropagation(),
                e = (t) => {
                  t.stopPropagation(), t.preventDefault();
                };
              this._keystrokes.listenTo(this.element),
                this._keystrokes.set("f3", (t) => {
                  e(t), this._findNextButtonView.fire("execute");
                }),
                this._keystrokes.set("shift+f3", (t) => {
                  e(t), this._findPrevButtonView.fire("execute");
                }),
                this._keystrokes.set("enter", (t) => {
                  const n = t.target;
                  n === this._findInputView.fieldView.element
                    ? (this._areCommandsEnabled.findNext
                        ? this._findNextButtonView.fire("execute")
                        : this._findButtonView.fire("execute"),
                      e(t))
                    : n !== this._replaceInputView.fieldView.element ||
                      this.isDirty ||
                      (this._replaceButtonView.fire("execute"), e(t));
                }),
                this._keystrokes.set("shift+enter", (t) => {
                  t.target === this._findInputView.fieldView.element &&
                    (this._areCommandsEnabled.findPrevious
                      ? this._findPrevButtonView.fire("execute")
                      : this._findButtonView.fire("execute"),
                    e(t));
                }),
                this._keystrokes.set("arrowright", t),
                this._keystrokes.set("arrowleft", t),
                this._keystrokes.set("arrowup", t),
                this._keystrokes.set("arrowdown", t),
                this.listenTo(
                  this._findInputView.element,
                  "selectstart",
                  (t, e) => {
                    e.stopPropagation();
                  },
                  { priority: "high" }
                ),
                this.listenTo(
                  this._replaceInputView.element,
                  "selectstart",
                  (t, e) => {
                    e.stopPropagation();
                  },
                  { priority: "high" }
                );
            }
            _createButton(t) {
              const e = new nm(this.locale);
              return e.set(t), e;
            }
            _createInputField(t) {
              const e = new hg(this.locale, mg);
              return (e.label = t), e;
            }
          }
          class jb extends j {
            static get pluginName() {
              return "FindAndReplaceUI";
            }
            constructor(t) {
              super(t), (this.formView = null);
            }
            init() {
              const t = this.editor;
              t.ui.componentFactory.add("findAndReplace", (e) => {
                const n = Wm(e),
                  o = (this.formView = new Ob(t.locale));
                return (
                  n.bind("isEnabled").to(t.commands.get("find")),
                  n.panelView.children.add(o),
                  n.on(
                    "change:isOpen",
                    (t, e, n) => {
                      n
                        ? (o.disableCssTransitions(),
                          o.reset(),
                          o._findInputView.fieldView.select(),
                          o.enableCssTransitions())
                        : this.fire("searchReseted");
                    },
                    { priority: "low" }
                  ),
                  this._setupDropdownButton(n),
                  this._setupFormView(o),
                  n
                );
              });
            }
            _setupDropdownButton(t) {
              const e = this.editor,
                n = e.locale.t;
              t.buttonView.set({
                icon: '<svg viewBox="0 0 20 20" xmlns="http://www.w3.org/2000/svg"><path d="m12.87 13.786 1.532-1.286 3.857 4.596a1 1 0 1 1-1.532 1.286l-3.857-4.596z"/><path d="M16.004 8.5a6.5 6.5 0 0 1-9.216 5.905c-1.154-.53-.863-1.415-.663-1.615.194-.194.564-.592 1.635-.141a4.5 4.5 0 0 0 5.89-5.904l-.104-.227 1.332-1.331c.045-.046.196-.041.224.007a6.47 6.47 0 0 1 .902 3.306zm-3.4-5.715c.562.305.742 1.106.354 1.494-.388.388-.995.414-1.476.178a4.5 4.5 0 0 0-6.086 5.882l.114.236-1.348 1.349c-.038.037-.17.022-.198-.023a6.5 6.5 0 0 1 5.54-9.9 6.469 6.469 0 0 1 3.1.784z"/><path d="M4.001 11.93.948 8.877a.2.2 0 0 1 .141-.341h6.106a.2.2 0 0 1 .141.341L4.283 11.93a.2.2 0 0 1-.282 0zm11.083-6.789 3.053 3.053a.2.2 0 0 1-.14.342H11.89a.2.2 0 0 1-.14-.342l3.052-3.053a.2.2 0 0 1 .282 0z"/></svg>',
                label: n("Find and replace"),
                keystroke: "CTRL+F",
                tooltip: !0,
              }),
                e.keystrokes.set("Ctrl+F", (e, n) => {
                  (t.isOpen = !0), n();
                });
            }
            _setupFormView(t) {
              const e = this.editor.commands,
                n = this.editor.plugins.get("FindAndReplaceEditing").state,
                o = { before: -1, same: 0, after: 1 };
              t.bind("highlightOffset").to(n, "highlightedResult", (t) =>
                t
                  ? Array.from(n.results)
                      .sort(
                        (t, e) =>
                          o[
                            t.marker.getStart().compareWith(e.marker.getStart())
                          ]
                      )
                      .indexOf(t) + 1
                  : 0
              ),
                t.listenTo(n.results, "change", () => {
                  t.matchCount = n.results.length;
                }),
                t
                  .bind("_areCommandsEnabled")
                  .to(
                    e.get("findNext"),
                    "isEnabled",
                    e.get("findPrevious"),
                    "isEnabled",
                    e.get("replace"),
                    "isEnabled",
                    e.get("replaceAll"),
                    "isEnabled",
                    (t, e, n, o) => ({
                      findNext: t,
                      findPrevious: e,
                      replace: n,
                      replaceAll: o,
                    })
                  ),
                t
                  .delegate("findNext", "findPrevious", "replace", "replaceAll")
                  .to(this),
                t.on("change:isDirty", (t, e, n) => {
                  n && this.fire("searchReseted");
                });
            }
          }
          function Vb(t, e, n, o) {
            const i = o || new po();
            return (
              e.change((o) => {
                [...t].forEach(({ type: t, item: s }) => {
                  if ("elementStart" === t && e.schema.checkChild(s, "$text")) {
                    const t = n({ item: s, text: Fb(e.createRangeIn(s)) });
                    if (!t) return;
                    t.forEach((t) => {
                      const e = `findResult:${r()}`,
                        n = o.addMarker(e, {
                          usingOperation: !1,
                          affectsData: !1,
                          range: o.createRange(
                            o.createPositionAt(s, t.start),
                            o.createPositionAt(s, t.end)
                          ),
                        }),
                        a = (function (t, e) {
                          const n = t.find(({ marker: t }) =>
                            e.getStart().isBefore(t.getStart())
                          );
                          return n ? t.getIndex(n) : t.length;
                        })(i, n);
                      i.add({ id: e, label: t.label, marker: n }, a);
                    });
                  }
                });
              }),
              i
            );
          }
          function Fb(t) {
            return Array.from(t.getItems()).reduce(
              (t, e) =>
                e.is("text") || e.is("textProxy") ? t + e.data : `${t}\n`,
              ""
            );
          }
          function Hb(t) {
            const e = t.length - 1;
            let n = t.index;
            return (
              3 === t.length && (n += t[1].length),
              { label: t[e], start: n, end: n + t[e].length }
            );
          }
          function Ub(t, e) {
            let n = "gu";
            e.matchCase || (n += "i");
            let o = `(${fp(t)})`;
            if (e.wholeWords) {
              const e = "[^a-zA-ZÀ-ɏḀ-ỿ]";
              new RegExp("^" + e).test(t) || (o = `(^|${e}|_)${o}`),
                new RegExp(e + "$").test(t) || (o = `${o}(?=_|${e}|$)`);
            }
            const i = new RegExp(o, n);
            return function ({ text: t }) {
              return [...t.matchAll(i)].map(Hb);
            };
          }
          class Wb extends F {
            constructor(t, e) {
              super(t),
                (this.isEnabled = !0),
                (this.affectsData = !1),
                (this._state = e);
            }
            execute(t, { matchCase: e, wholeWords: n } = {}) {
              const { editor: o } = this,
                { model: i } = o;
              let r;
              "string" == typeof t
                ? ((r = Ub(t, { matchCase: e, wholeWords: n })),
                  (this._state.searchText = t))
                : (r = t);
              const s = i.document
                .getRootNames()
                .reduce(
                  (t, e) => Vb(i.createRangeIn(i.document.getRoot(e)), i, r, t),
                  null
                );
              return (
                this._state.clear(i),
                this._state.results.addMany(Array.from(s)),
                (this._state.highlightedResult = s.get(0)),
                "string" == typeof t && (this._state.searchText = t),
                (this._state.matchCase = !!e),
                (this._state.matchWholeWords = !!n),
                { results: s, findCallback: r }
              );
            }
          }
          class $b extends F {
            constructor(t, e) {
              super(t), (this.isEnabled = !0), (this._state = e);
            }
            execute(t, e) {
              const { model: n } = this.editor;
              n.change((o) => {
                const i = e.marker.getRange();
                if ("$graveyard" === i.root.rootName)
                  return void this._state.results.remove(e);
                let r = {};
                for (const t of i.getItems())
                  if (t.is("$text") || t.is("$textProxy")) {
                    r = t.getAttributes();
                    break;
                  }
                n.insertContent(o.createText(t, r), i),
                  this._state.results.has(e) && this._state.results.remove(e);
              });
            }
          }
          class qb extends $b {
            execute(t, e) {
              const { editor: n } = this,
                { model: o } = n,
                i =
                  e instanceof po
                    ? e
                    : o.document
                        .getRootNames()
                        .reduce(
                          (t, n) =>
                            Vb(
                              o.createRangeIn(o.document.getRoot(n)),
                              o,
                              Ub(e, this._state),
                              t
                            ),
                          null
                        );
              i.length &&
                o.change(() => {
                  [...i].forEach((e) => {
                    super.execute(t, e);
                  });
                });
            }
          }
          class Gb extends F {
            constructor(t, e) {
              super(t),
                (this.affectsData = !1),
                (this._state = e),
                (this.isEnabled = !1),
                this.listenTo(this._state.results, "change", () => {
                  this.isEnabled = this._state.results.length > 1;
                });
            }
            refresh() {
              this.isEnabled = this._state.results.length > 1;
            }
            execute() {
              const t = this._state.results,
                e = t.getIndex(this._state.highlightedResult),
                n = e + 1 >= t.length ? 0 : e + 1;
              this._state.highlightedResult = this._state.results.get(n);
            }
          }
          class Zb extends Gb {
            execute() {
              const t = this._state.results.getIndex(
                  this._state.highlightedResult
                ),
                e = t - 1 < 0 ? this._state.results.length - 1 : t - 1;
              this._state.highlightedResult = this._state.results.get(e);
            }
          }
          class Yb {
            constructor(t) {
              this.set("results", new po()),
                this.set("highlightedResult", null),
                this.set("searchText", ""),
                this.set("replaceText", ""),
                this.set("matchCase", !1),
                this.set("matchWholeWords", !1),
                this.results.on("change", (e, { removed: n, index: o }) => {
                  if ((n = Array.from(n)).length) {
                    let e = !1;
                    if (
                      (t.change((o) => {
                        for (const i of n)
                          this.highlightedResult === i && (e = !0),
                            t.markers.has(i.marker.name) &&
                              o.removeMarker(i.marker);
                      }),
                      e)
                    ) {
                      const t = o >= this.results.length ? 0 : o;
                      this.highlightedResult = this.results.get(t);
                    }
                  }
                });
            }
            clear(t) {
              (this.searchText = ""),
                t.change((e) => {
                  if (this.highlightedResult) {
                    const n = this.highlightedResult.marker.name.split(":")[1],
                      o = t.markers.get(`findResultHighlighted:${n}`);
                    o && e.removeMarker(o);
                  }
                  [...this.results].forEach(({ marker: t }) => {
                    e.removeMarker(t);
                  });
                }),
                this.results.clear();
            }
          }
          ya(Yb, B);
          var Kb = n(5436),
            Qb = { attributes: { "data-cke": !0 } };
          (Qb.setAttributes = is()),
            (Qb.insert = ns().bind(null, "head")),
            (Qb.domAPI = ts()),
            (Qb.insertStyleElement = ss());
          Jr()(Kb.Z, Qb);
          Kb.Z && Kb.Z.locals && Kb.Z.locals;
          class Jb extends j {
            static get pluginName() {
              return "FindAndReplaceEditing";
            }
            init() {
              (this._activeResults = null),
                (this.state = new Yb(this.editor.model)),
                this._defineConverters(),
                this._defineCommands(),
                this.listenTo(
                  this.state,
                  "change:highlightedResult",
                  (t, e, n, o) => {
                    const { model: i } = this.editor;
                    i.change((t) => {
                      if (o) {
                        const e = o.marker.name.split(":")[1],
                          n = i.markers.get(`findResultHighlighted:${e}`);
                        n && t.removeMarker(n);
                      }
                      if (n) {
                        const e = n.marker.name.split(":")[1];
                        t.addMarker(`findResultHighlighted:${e}`, {
                          usingOperation: !1,
                          affectsData: !1,
                          range: n.marker.getRange(),
                        });
                      }
                    });
                  }
                );
              const t = Zs(
                function (t, e, n) {
                  if (n) {
                    const t = this.editor.editing.view.domConverter,
                      e = this.editor.editing.mapper.toViewRange(
                        n.marker.getRange()
                      );
                    Ha({ target: t.viewRangeToDom(e), viewportOffset: 40 });
                  }
                }.bind(this),
                32
              );
              this.listenTo(this.state, "change:highlightedResult", t, {
                priority: "low",
              }),
                this.listenTo(this.editor, "destroy", t.cancel);
            }
            find(t) {
              const { editor: e } = this,
                { model: n } = e,
                { findCallback: o, results: i } = e.execute("find", t);
              return (
                (this._activeResults = i),
                this.listenTo(n.document, "change:data", () =>
                  (function (t, e, n) {
                    const o = new Set(),
                      i = new Set();
                    e.document.differ.getChanges().forEach((t) => {
                      "$text" === t.name ||
                      e.schema.isInline(t.position.nodeAfter)
                        ? (o.add(t.position.parent),
                          [
                            ...e.markers.getMarkersAtPosition(t.position),
                          ].forEach((t) => {
                            i.add(t.name);
                          }))
                        : "insert" === t.type && o.add(t.position.nodeAfter);
                    }),
                      e.document.differ
                        .getChangedMarkers()
                        .forEach(({ name: t, data: { newRange: e } }) => {
                          e &&
                            "$graveyard" === e.start.root.rootName &&
                            i.add(t);
                        }),
                      o.forEach((t) => {
                        [
                          ...e.markers.getMarkersIntersectingRange(
                            e.createRangeIn(t)
                          ),
                        ].forEach((t) => i.add(t.name));
                      }),
                      e.change((e) => {
                        i.forEach((n) => {
                          t.has(n) && t.remove(n), e.removeMarker(n);
                        });
                      }),
                      o.forEach((o) => {
                        Vb(e.createRangeOn(o), e, n, t);
                      });
                  })(this._activeResults, n, o)
                ),
                this._activeResults
              );
            }
            stop() {
              this._activeResults &&
                (this.stopListening(this.editor.model.document),
                this.state.clear(this.editor.model),
                (this._activeResults = null));
            }
            _defineCommands() {
              this.editor.commands.add("find", new Wb(this.editor, this.state)),
                this.editor.commands.add(
                  "findNext",
                  new Gb(this.editor, this.state)
                ),
                this.editor.commands.add(
                  "findPrevious",
                  new Zb(this.editor, this.state)
                ),
                this.editor.commands.add(
                  "replace",
                  new $b(this.editor, this.state)
                ),
                this.editor.commands.add(
                  "replaceAll",
                  new qb(this.editor, this.state)
                );
            }
            _defineConverters() {
              const { editor: t } = this;
              t.conversion.for("editingDowncast").markerToHighlight({
                model: "findResult",
                view: ({ markerName: t }) => {
                  const [, e] = t.split(":");
                  return {
                    name: "span",
                    classes: ["ck-find-result"],
                    attributes: { "data-find-result": e },
                  };
                },
              }),
                t.conversion.for("editingDowncast").markerToHighlight({
                  model: "findResultHighlighted",
                  view: ({ markerName: t }) => {
                    const [, e] = t.split(":");
                    return {
                      name: "span",
                      classes: ["ck-find-result_selected"],
                      attributes: { "data-find-result": e },
                    };
                  },
                });
            }
          }
          class Xb extends F {
            constructor(t, e) {
              super(t), (this.attributeKey = e);
            }
            refresh() {
              const t = this.editor.model,
                e = t.document;
              (this.value = e.selection.getAttribute(this.attributeKey)),
                (this.isEnabled = t.schema.checkAttributeInSelection(
                  e.selection,
                  this.attributeKey
                ));
            }
            execute(t = {}) {
              const e = this.editor.model,
                n = e.document.selection,
                o = t.value;
              e.change((t) => {
                if (n.isCollapsed)
                  o
                    ? t.setSelectionAttribute(this.attributeKey, o)
                    : t.removeSelectionAttribute(this.attributeKey);
                else {
                  const i = e.schema.getValidRanges(
                    n.getRanges(),
                    this.attributeKey
                  );
                  for (const e of i)
                    o
                      ? t.setAttribute(this.attributeKey, o, e)
                      : t.removeAttribute(this.attributeKey, e);
                }
              });
            }
          }
          class tw extends po {
            constructor(t) {
              super(t),
                this.set("isEmpty", !0),
                this.on("change", () => {
                  this.set("isEmpty", 0 === this.length);
                });
            }
            add(t, e) {
              this.find((e) => e.color === t.color) || super.add(t, e);
            }
            hasColor(t) {
              return !!this.find((e) => e.color === t);
            }
          }
          ya(tw, B);
          var ew = n(2585),
            nw = { attributes: { "data-cke": !0 } };
          (nw.setAttributes = is()),
            (nw.insert = ns().bind(null, "head")),
            (nw.domAPI = ts()),
            (nw.insertStyleElement = ss());
          Jr()(ew.Z, nw);
          ew.Z && ew.Z.locals && ew.Z.locals;
          class ow extends Ch {
            constructor(
              t,
              {
                colors: e,
                columns: n,
                removeButtonLabel: o,
                documentColorsLabel: i,
                documentColorsCount: r,
              }
            ) {
              super(t),
                (this.items = this.createCollection()),
                (this.colorDefinitions = e),
                (this.focusTracker = new Oa()),
                (this.keystrokes = new ja()),
                this.set("selectedColor"),
                (this.removeButtonLabel = o),
                (this.columns = n),
                (this.documentColors = new tw()),
                (this.documentColorsCount = r),
                (this._focusables = new Ju()),
                (this._focusCycler = new Cm({
                  focusables: this._focusables,
                  focusTracker: this.focusTracker,
                  keystrokeHandler: this.keystrokes,
                  actions: { focusPrevious: "shift + tab", focusNext: "tab" },
                })),
                (this._documentColorsLabel = i),
                this.setTemplate({
                  tag: "div",
                  attributes: { class: ["ck", "ck-color-table"] },
                  children: this.items,
                }),
                this.items.add(this._createRemoveColorButton());
            }
            updateDocumentColors(t, e) {
              const n = t.document,
                o = this.documentColorsCount;
              this.documentColors.clear();
              for (const i of n.getRootNames()) {
                const r = n.getRoot(i),
                  s = t.createRangeIn(r);
                for (const t of s.getItems())
                  if (
                    t.is("$textProxy") &&
                    t.hasAttribute(e) &&
                    (this._addColorToDocumentColors(t.getAttribute(e)),
                    this.documentColors.length >= o)
                  )
                    return;
              }
            }
            updateSelectedColors() {
              const t = this.documentColorsGrid,
                e = this.staticColorsGrid,
                n = this.selectedColor;
              (e.selectedColor = n), t && (t.selectedColor = n);
            }
            render() {
              super.render(), this.keystrokes.listenTo(this.element);
            }
            destroy() {
              super.destroy(),
                this.focusTracker.destroy(),
                this.keystrokes.destroy();
            }
            appendGrids() {
              if (
                !this.staticColorsGrid &&
                ((this.staticColorsGrid = this._createStaticColorsGrid()),
                this.items.add(this.staticColorsGrid),
                this.focusTracker.add(this.staticColorsGrid.element),
                this._focusables.add(this.staticColorsGrid),
                this.documentColorsCount)
              ) {
                const t = Xu.bind(this.documentColors, this.documentColors),
                  e = new Xm(this.locale);
                (e.text = this._documentColorsLabel),
                  e.extendTemplate({
                    attributes: {
                      class: [
                        "ck",
                        "ck-color-grid__label",
                        t.if("isEmpty", "ck-hidden"),
                      ],
                    },
                  }),
                  this.items.add(e),
                  (this.documentColorsGrid = this._createDocumentColorsGrid()),
                  this.items.add(this.documentColorsGrid),
                  this.focusTracker.add(this.documentColorsGrid.element),
                  this._focusables.add(this.documentColorsGrid);
              }
            }
            focus() {
              this._focusCycler.focusFirst();
            }
            focusLast() {
              this._focusCycler.focusLast();
            }
            _createRemoveColorButton() {
              const t = new nm();
              return (
                t.set({
                  withText: !0,
                  icon: $h.eraser,
                  label: this.removeButtonLabel,
                }),
                (t.class = "ck-color-table__remove-color"),
                t.on("execute", () => {
                  this.fire("execute", { value: null });
                }),
                t.render(),
                this.focusTracker.add(t.element),
                this._focusables.add(t),
                t
              );
            }
            _createStaticColorsGrid() {
              const t = new hm(this.locale, {
                colorDefinitions: this.colorDefinitions,
                columns: this.columns,
              });
              return t.delegate("execute").to(this), t;
            }
            _createDocumentColorsGrid() {
              const t = Xu.bind(this.documentColors, this.documentColors),
                e = new hm(this.locale, { columns: this.columns });
              return (
                e.delegate("execute").to(this),
                e.extendTemplate({
                  attributes: { class: t.if("isEmpty", "ck-hidden") },
                }),
                e.items.bindTo(this.documentColors).using((t) => {
                  const e = new cm();
                  return (
                    e.set({
                      color: t.color,
                      hasBorder: t.options && t.options.hasBorder,
                    }),
                    t.label && e.set({ label: t.label, tooltip: !0 }),
                    e.on("execute", () => {
                      this.fire("execute", { value: t.color });
                    }),
                    e
                  );
                }),
                this.documentColors.on("change:isEmpty", (t, n, o) => {
                  o && (e.selectedColor = null);
                }),
                e
              );
            }
            _addColorToDocumentColors(t) {
              const e = this.colorDefinitions.find((e) => e.color === t);
              e
                ? this.documentColors.add(Object.assign({}, e))
                : this.documentColors.add({
                    color: t,
                    label: t,
                    options: { hasBorder: !1 },
                  });
            }
          }
          const iw = "fontColor",
            rw = "fontBackgroundColor";
          function sw(t) {
            return (e) => e.getStyle(t).replace(/\s/g, "");
          }
          function aw(t) {
            return (e, { writer: n }) =>
              n.createAttributeElement(
                "span",
                { style: `${t}:${e}` },
                { priority: 7 }
              );
          }
          class lw extends Xb {
            constructor(t) {
              super(t, rw);
            }
          }
          class cw extends j {
            static get pluginName() {
              return "FontBackgroundColorEditing";
            }
            constructor(t) {
              super(t),
                t.config.define(rw, {
                  colors: [
                    { color: "hsl(0, 0%, 0%)", label: "Black" },
                    { color: "hsl(0, 0%, 30%)", label: "Dim grey" },
                    { color: "hsl(0, 0%, 60%)", label: "Grey" },
                    { color: "hsl(0, 0%, 90%)", label: "Light grey" },
                    {
                      color: "hsl(0, 0%, 100%)",
                      label: "White",
                      hasBorder: !0,
                    },
                    { color: "hsl(0, 75%, 60%)", label: "Red" },
                    { color: "hsl(30, 75%, 60%)", label: "Orange" },
                    { color: "hsl(60, 75%, 60%)", label: "Yellow" },
                    { color: "hsl(90, 75%, 60%)", label: "Light green" },
                    { color: "hsl(120, 75%, 60%)", label: "Green" },
                    { color: "hsl(150, 75%, 60%)", label: "Aquamarine" },
                    { color: "hsl(180, 75%, 60%)", label: "Turquoise" },
                    { color: "hsl(210, 75%, 60%)", label: "Light blue" },
                    { color: "hsl(240, 75%, 60%)", label: "Blue" },
                    { color: "hsl(270, 75%, 60%)", label: "Purple" },
                  ],
                  columns: 5,
                }),
                t.data.addStyleProcessorRules(Du),
                t.conversion
                  .for("upcast")
                  .elementToAttribute({
                    view: {
                      name: "span",
                      styles: { "background-color": /[\s\S]+/ },
                    },
                    model: { key: rw, value: sw("background-color") },
                  }),
                t.conversion
                  .for("downcast")
                  .attributeToElement({
                    model: rw,
                    view: aw("background-color"),
                  }),
                t.commands.add(rw, new lw(t)),
                t.model.schema.extend("$text", { allowAttributes: rw }),
                t.model.schema.setAttributeProperties(rw, {
                  isFormatting: !0,
                  copyOnEnter: !0,
                });
            }
          }
          class dw extends j {
            constructor(
              t,
              { commandName: e, icon: n, componentName: o, dropdownLabel: i }
            ) {
              super(t),
                (this.commandName = e),
                (this.componentName = o),
                (this.icon = n),
                (this.dropdownLabel = i),
                (this.columns = t.config.get(`${this.componentName}.columns`)),
                (this.colorTableView = void 0);
            }
            init() {
              const t = this.editor,
                e = t.locale,
                n = e.t,
                o = t.commands.get(this.commandName),
                i = sm(e, am(t.config.get(this.componentName).colors)),
                r = t.config.get(`${this.componentName}.documentColors`);
              t.ui.componentFactory.add(this.componentName, (e) => {
                const s = Wm(e);
                return (
                  (this.colorTableView = (function ({
                    dropdownView: t,
                    colors: e,
                    columns: n,
                    removeButtonLabel: o,
                    documentColorsLabel: i,
                    documentColorsCount: r,
                  }) {
                    const s = t.locale,
                      a = new ow(s, {
                        colors: e,
                        columns: n,
                        removeButtonLabel: o,
                        documentColorsLabel: i,
                        documentColorsCount: r,
                      });
                    return (
                      (t.colorTableView = a),
                      t.panelView.children.add(a),
                      a.delegate("execute").to(t, "execute"),
                      a
                    );
                  })({
                    dropdownView: s,
                    colors: i.map((t) => ({
                      label: t.label,
                      color: t.model,
                      options: { hasBorder: t.hasBorder },
                    })),
                    columns: this.columns,
                    removeButtonLabel: n("Remove color"),
                    documentColorsLabel:
                      0 !== r ? n("Document colors") : void 0,
                    documentColorsCount: void 0 === r ? this.columns : r,
                  })),
                  this.colorTableView.bind("selectedColor").to(o, "value"),
                  s.buttonView.set({
                    label: this.dropdownLabel,
                    icon: this.icon,
                    tooltip: !0,
                  }),
                  s.extendTemplate({
                    attributes: { class: "ck-color-ui-dropdown" },
                  }),
                  s.bind("isEnabled").to(o),
                  s.on("execute", (e, n) => {
                    t.execute(this.commandName, n), t.editing.view.focus();
                  }),
                  s.on("change:isOpen", (e, n, o) => {
                    s.colorTableView.appendGrids(),
                      o &&
                        (0 !== r &&
                          this.colorTableView.updateDocumentColors(
                            t.model,
                            this.componentName
                          ),
                        this.colorTableView.updateSelectedColors());
                  }),
                  Gm(s, () =>
                    s.colorTableView.staticColorsGrid.items.find((t) => t.isOn)
                  ),
                  s
                );
              });
            }
          }
          class uw extends dw {
            constructor(t) {
              const e = t.locale.t;
              super(t, {
                commandName: rw,
                componentName: rw,
                icon: '<svg viewBox="0 0 20 20" xmlns="http://www.w3.org/2000/svg"><path d="M4 2h12a2 2 0 0 1 2 2v12a2 2 0 0 1-2 2H4a2 2 0 0 1-2-2V4a2 2 0 0 1 2-2zm8.38 9.262H7.62L10 5.506l2.38 5.756zm.532 1.285L14.34 16h1.426L10.804 4H9.196L4.234 16H5.66l1.428-3.453h5.824z"/></svg>',
                dropdownLabel: e("Font Background Color"),
              });
            }
            static get pluginName() {
              return "FontBackgroundColorUI";
            }
          }
          class hw extends Xb {
            constructor(t) {
              super(t, iw);
            }
          }
          class mw extends j {
            static get pluginName() {
              return "FontColorEditing";
            }
            constructor(t) {
              super(t),
                t.config.define(iw, {
                  colors: [
                    { color: "hsl(0, 0%, 0%)", label: "Black" },
                    { color: "hsl(0, 0%, 30%)", label: "Dim grey" },
                    { color: "hsl(0, 0%, 60%)", label: "Grey" },
                    { color: "hsl(0, 0%, 90%)", label: "Light grey" },
                    {
                      color: "hsl(0, 0%, 100%)",
                      label: "White",
                      hasBorder: !0,
                    },
                    { color: "hsl(0, 75%, 60%)", label: "Red" },
                    { color: "hsl(30, 75%, 60%)", label: "Orange" },
                    { color: "hsl(60, 75%, 60%)", label: "Yellow" },
                    { color: "hsl(90, 75%, 60%)", label: "Light green" },
                    { color: "hsl(120, 75%, 60%)", label: "Green" },
                    { color: "hsl(150, 75%, 60%)", label: "Aquamarine" },
                    { color: "hsl(180, 75%, 60%)", label: "Turquoise" },
                    { color: "hsl(210, 75%, 60%)", label: "Light blue" },
                    { color: "hsl(240, 75%, 60%)", label: "Blue" },
                    { color: "hsl(270, 75%, 60%)", label: "Purple" },
                  ],
                  columns: 5,
                }),
                t.conversion
                  .for("upcast")
                  .elementToAttribute({
                    view: { name: "span", styles: { color: /[\s\S]+/ } },
                    model: { key: iw, value: sw("color") },
                  }),
                t.conversion
                  .for("upcast")
                  .elementToAttribute({
                    view: { name: "font", attributes: { color: /^#?\w+$/ } },
                    model: { key: iw, value: (t) => t.getAttribute("color") },
                  }),
                t.conversion
                  .for("downcast")
                  .attributeToElement({ model: iw, view: aw("color") }),
                t.commands.add(iw, new hw(t)),
                t.model.schema.extend("$text", { allowAttributes: iw }),
                t.model.schema.setAttributeProperties(iw, {
                  isFormatting: !0,
                  copyOnEnter: !0,
                });
            }
          }
          class gw extends dw {
            constructor(t) {
              const e = t.locale.t;
              super(t, {
                commandName: iw,
                componentName: iw,
                icon: '<svg viewBox="0 0 20 20" xmlns="http://www.w3.org/2000/svg"><path d="M12.4 10.3 10 4.5l-2.4 5.8h4.8zm.5 1.2H7.1L5.7 15H4.2l5-12h1.6l5 12h-1.5L13 11.5zm3.1 7H4a1 1 0 0 1 0-2h12a1 1 0 0 1 0 2z"/></svg>',
                dropdownLabel: e("Font Color"),
              });
            }
            static get pluginName() {
              return "FontColorUI";
            }
          }
          const pw = "fullscreen.closeOnEscape",
            fw = "fullscreen.closeOnClick";
          var kw = n(3101),
            bw = { attributes: { "data-cke": !0 } };
          (bw.setAttributes = is()),
            (bw.insert = ns().bind(null, "head")),
            (bw.domAPI = ts()),
            (bw.insertStyleElement = ss());
          Jr()(kw.Z, bw);
          kw.Z && kw.Z.locals && kw.Z.locals;
          const ww = [
              { model: "codeBlock", view: "pre" },
              { model: "paragraph", view: "p" },
              { model: "blockQuote", view: "blockquote" },
              { model: "listItem", view: "li" },
              { model: "pageBreak", view: "div" },
              { model: "rawHtml", view: "div" },
              { model: "table", view: "table" },
              { model: "tableRow", view: "tr" },
              { model: "tableCell", view: "td" },
              { model: "tableCell", view: "th" },
              { model: "caption", view: "caption" },
              { model: "caption", view: "figcaption" },
              { model: "imageBlock", view: "img" },
              { model: "imageInline", view: "img" },
              {
                model: "htmlP",
                view: "p",
                modelSchema: { inheritAllFrom: "$block" },
              },
              {
                model: "htmlBlockquote",
                view: "blockquote",
                modelSchema: { inheritAllFrom: "$container" },
              },
              {
                model: "htmlTable",
                view: "table",
                modelSchema: { allowWhere: "$block", isBlock: !0 },
              },
              {
                model: "htmlTbody",
                view: "tbody",
                modelSchema: { allowIn: "htmlTable", isBlock: !1 },
              },
              {
                model: "htmlThead",
                view: "thead",
                modelSchema: { allowIn: "htmlTable", isBlock: !1 },
              },
              {
                model: "htmlTfoot",
                view: "tfoot",
                modelSchema: { allowIn: "htmlTable", isBlock: !1 },
              },
              {
                model: "htmlCaption",
                view: "caption",
                modelSchema: {
                  allowIn: "htmlTable",
                  allowChildren: "$text",
                  isBlock: !1,
                },
              },
              {
                model: "htmlColgroup",
                view: "colgroup",
                modelSchema: {
                  allowIn: "htmlTable",
                  allowChildren: "col",
                  isBlock: !1,
                },
              },
              {
                model: "htmlCol",
                view: "col",
                modelSchema: { allowIn: "htmlColgroup", isBlock: !1 },
              },
              {
                model: "htmlTr",
                view: "tr",
                modelSchema: {
                  allowIn: ["htmlTable", "htmlThead", "htmlTbody"],
                  isLimit: !0,
                },
              },
              {
                model: "htmlTd",
                view: "td",
                modelSchema: {
                  allowIn: "htmlTr",
                  allowContentOf: "$container",
                  isLimit: !0,
                  isBlock: !1,
                },
              },
              {
                model: "htmlTh",
                view: "th",
                modelSchema: {
                  allowIn: "htmlTr",
                  allowContentOf: "$container",
                  isLimit: !0,
                  isBlock: !1,
                },
              },
              {
                model: "htmlFigure",
                view: "figure",
                modelSchema: { inheritAllFrom: "$container", isBlock: !1 },
              },
              {
                model: "htmlFigcaption",
                view: "figcaption",
                modelSchema: {
                  allowIn: "htmlFigure",
                  allowChildren: "$text",
                  isBlock: !1,
                },
              },
              {
                model: "htmlAddress",
                view: "address",
                modelSchema: { inheritAllFrom: "$container", isBlock: !1 },
              },
              {
                model: "htmlAside",
                view: "aside",
                modelSchema: { inheritAllFrom: "$container", isBlock: !1 },
              },
              {
                model: "htmlMain",
                view: "main",
                modelSchema: { inheritAllFrom: "$container", isBlock: !1 },
              },
              {
                model: "htmlDetails",
                view: "details",
                modelSchema: { inheritAllFrom: "$container", isBlock: !1 },
              },
              {
                model: "htmlSummary",
                view: "summary",
                modelSchema: {
                  allowChildren: "$text",
                  allowIn: "htmlDetails",
                  isBlock: !1,
                },
              },
              {
                model: "htmlDiv",
                view: "div",
                paragraphLikeModel: "htmlDivParagraph",
                modelSchema: { inheritAllFrom: "$container" },
              },
              {
                model: "htmlFieldset",
                view: "fieldset",
                modelSchema: { inheritAllFrom: "$container", isBlock: !1 },
              },
              {
                model: "htmlLegend",
                view: "legend",
                modelSchema: {
                  allowIn: "htmlFieldset",
                  allowChildren: "$text",
                },
              },
              {
                model: "htmlHeader",
                view: "header",
                modelSchema: { inheritAllFrom: "$container", isBlock: !1 },
              },
              {
                model: "htmlFooter",
                view: "footer",
                modelSchema: { inheritAllFrom: "$container", isBlock: !1 },
              },
              {
                model: "htmlForm",
                view: "form",
                modelSchema: { inheritAllFrom: "$container", isBlock: !0 },
              },
              {
                model: "htmlHgroup",
                view: "hgroup",
                modelSchema: {
                  allowChildren: [
                    "htmlH1",
                    "htmlH2",
                    "htmlH3",
                    "htmlH4",
                    "htmlH5",
                    "htmlH6",
                  ],
                  isBlock: !1,
                },
              },
              {
                model: "htmlH1",
                view: "h1",
                modelSchema: { inheritAllFrom: "$block" },
              },
              {
                model: "htmlH2",
                view: "h2",
                modelSchema: { inheritAllFrom: "$block" },
              },
              {
                model: "htmlH3",
                view: "h3",
                modelSchema: { inheritAllFrom: "$block" },
              },
              {
                model: "htmlH4",
                view: "h4",
                modelSchema: { inheritAllFrom: "$block" },
              },
              {
                model: "htmlH5",
                view: "h5",
                modelSchema: { inheritAllFrom: "$block" },
              },
              {
                model: "htmlH6",
                view: "h6",
                modelSchema: { inheritAllFrom: "$block" },
              },
              {
                model: "$htmlList",
                modelSchema: {
                  allowWhere: "$container",
                  allowChildren: ["$htmlList", "htmlLi"],
                  isBlock: !1,
                },
              },
              {
                model: "htmlDir",
                view: "dir",
                modelSchema: { inheritAllFrom: "$htmlList" },
              },
              {
                model: "htmlMenu",
                view: "menu",
                modelSchema: { inheritAllFrom: "$htmlList" },
              },
              {
                model: "htmlUl",
                view: "ul",
                modelSchema: { inheritAllFrom: "$htmlList" },
              },
              {
                model: "htmlOl",
                view: "ol",
                modelSchema: { inheritAllFrom: "$htmlList" },
              },
              {
                model: "htmlLi",
                view: "li",
                modelSchema: {
                  allowIn: "$htmlList",
                  allowChildren: "$text",
                  isBlock: !1,
                },
              },
              {
                model: "htmlPre",
                view: "pre",
                modelSchema: { inheritAllFrom: "$block" },
              },
              {
                model: "htmlArticle",
                view: "article",
                modelSchema: { inheritAllFrom: "$container", isBlock: !1 },
              },
              {
                model: "htmlSection",
                view: "section",
                modelSchema: { inheritAllFrom: "$container", isBlock: !1 },
              },
              {
                model: "htmlNav",
                view: "nav",
                modelSchema: { inheritAllFrom: "$container", isBlock: !1 },
              },
              {
                model: "htmlDl",
                view: "dl",
                modelSchema: {
                  allowWhere: "$container",
                  allowChildren: ["htmlDt", "htmlDd"],
                  isBlock: !1,
                },
              },
              {
                model: "htmlDt",
                view: "dt",
                modelSchema: { allowChildren: "$block", isBlock: !1 },
              },
              {
                model: "htmlDd",
                view: "dd",
                modelSchema: { allowChildren: "$block", isBlock: !1 },
              },
              {
                model: "htmlCenter",
                view: "center",
                modelSchema: { inheritAllFrom: "$container", isBlock: !1 },
              },
            ],
            Aw = [
              {
                model: "htmlAcronym",
                view: "acronym",
                attributeProperties: { copyOnEnter: !0 },
              },
              {
                model: "htmlTt",
                view: "tt",
                attributeProperties: { copyOnEnter: !0 },
              },
              {
                model: "htmlFont",
                view: "font",
                attributeProperties: { copyOnEnter: !0 },
              },
              {
                model: "htmlTime",
                view: "time",
                attributeProperties: { copyOnEnter: !0 },
              },
              {
                model: "htmlVar",
                view: "var",
                attributeProperties: { copyOnEnter: !0 },
              },
              {
                model: "htmlBig",
                view: "big",
                attributeProperties: { copyOnEnter: !0 },
              },
              {
                model: "htmlSmall",
                view: "small",
                attributeProperties: { copyOnEnter: !0 },
              },
              {
                model: "htmlSamp",
                view: "samp",
                attributeProperties: { copyOnEnter: !0 },
              },
              {
                model: "htmlQ",
                view: "q",
                attributeProperties: { copyOnEnter: !0 },
              },
              {
                model: "htmlOutput",
                view: "output",
                attributeProperties: { copyOnEnter: !0 },
              },
              {
                model: "htmlKbd",
                view: "kbd",
                attributeProperties: { copyOnEnter: !0 },
              },
              {
                model: "htmlBdi",
                view: "bdi",
                attributeProperties: { copyOnEnter: !0 },
              },
              {
                model: "htmlBdo",
                view: "bdo",
                attributeProperties: { copyOnEnter: !0 },
              },
              {
                model: "htmlAbbr",
                view: "abbr",
                attributeProperties: { copyOnEnter: !0 },
              },
              {
                model: "htmlA",
                view: "a",
                priority: 5,
                coupledAttribute: "linkHref",
                attributeProperties: { copyOnEnter: !0 },
              },
              {
                model: "htmlStrong",
                view: "strong",
                coupledAttribute: "bold",
                attributeProperties: { copyOnEnter: !0 },
              },
              {
                model: "htmlB",
                view: "b",
                coupledAttribute: "bold",
                attributeProperties: { copyOnEnter: !0 },
              },
              {
                model: "htmlI",
                view: "i",
                coupledAttribute: "italic",
                attributeProperties: { copyOnEnter: !0 },
              },
              {
                model: "htmlEm",
                view: "em",
                coupledAttribute: "italic",
                attributeProperties: { copyOnEnter: !0 },
              },
              {
                model: "htmlS",
                view: "s",
                coupledAttribute: "strikethrough",
                attributeProperties: { copyOnEnter: !0 },
              },
              {
                model: "htmlDel",
                view: "del",
                coupledAttribute: "strikethrough",
                attributeProperties: { copyOnEnter: !0 },
              },
              {
                model: "htmlIns",
                view: "ins",
                attributeProperties: { copyOnEnter: !0 },
              },
              {
                model: "htmlU",
                view: "u",
                coupledAttribute: "underline",
                attributeProperties: { copyOnEnter: !0 },
              },
              {
                model: "htmlSub",
                view: "sub",
                coupledAttribute: "subscript",
                attributeProperties: { copyOnEnter: !0 },
              },
              {
                model: "htmlSup",
                view: "sup",
                coupledAttribute: "superscript",
                attributeProperties: { copyOnEnter: !0 },
              },
              {
                model: "htmlCode",
                view: "code",
                coupledAttribute: "code",
                attributeProperties: { copyOnEnter: !0 },
              },
              {
                model: "htmlMark",
                view: "mark",
                attributeProperties: { copyOnEnter: !0 },
              },
              {
                model: "htmlSpan",
                view: "span",
                attributeProperties: { copyOnEnter: !0 },
              },
              {
                model: "htmlCite",
                view: "cite",
                attributeProperties: { copyOnEnter: !0 },
              },
              {
                model: "htmlLabel",
                view: "label",
                attributeProperties: { copyOnEnter: !0 },
              },
              {
                model: "htmlDfn",
                view: "dfn",
                attributeProperties: { copyOnEnter: !0 },
              },
              {
                model: "htmlObject",
                view: "object",
                isObject: !0,
                modelSchema: { inheritAllFrom: "$inlineObject" },
              },
              {
                model: "htmlIframe",
                view: "iframe",
                isObject: !0,
                modelSchema: { inheritAllFrom: "$inlineObject" },
              },
              {
                model: "htmlInput",
                view: "input",
                isObject: !0,
                modelSchema: { inheritAllFrom: "$inlineObject" },
              },
              {
                model: "htmlButton",
                view: "button",
                isObject: !0,
                modelSchema: { inheritAllFrom: "$inlineObject" },
              },
              {
                model: "htmlTextarea",
                view: "textarea",
                isObject: !0,
                modelSchema: { inheritAllFrom: "$inlineObject" },
              },
              {
                model: "htmlSelect",
                view: "select",
                isObject: !0,
                modelSchema: { inheritAllFrom: "$inlineObject" },
              },
              {
                model: "htmlVideo",
                view: "video",
                isObject: !0,
                modelSchema: { inheritAllFrom: "$inlineObject" },
              },
              {
                model: "htmlEmbed",
                view: "embed",
                isObject: !0,
                modelSchema: { inheritAllFrom: "$inlineObject" },
              },
              {
                model: "htmlOembed",
                view: "oembed",
                isObject: !0,
                modelSchema: { inheritAllFrom: "$inlineObject" },
              },
              {
                model: "htmlAudio",
                view: "audio",
                isObject: !0,
                modelSchema: { inheritAllFrom: "$inlineObject" },
              },
              {
                model: "htmlImg",
                view: "img",
                isObject: !0,
                modelSchema: { inheritAllFrom: "$inlineObject" },
              },
              {
                model: "htmlCanvas",
                view: "canvas",
                isObject: !0,
                modelSchema: { inheritAllFrom: "$inlineObject" },
              },
              {
                model: "htmlMeter",
                view: "meter",
                isObject: !0,
                modelSchema: { inheritAllFrom: "$inlineObject" },
              },
              {
                model: "htmlProgress",
                view: "progress",
                isObject: !0,
                modelSchema: { inheritAllFrom: "$inlineObject" },
              },
              {
                model: "htmlScript",
                view: "script",
                modelSchema: { allowWhere: ["$text", "$block"], isInline: !0 },
              },
              {
                model: "htmlStyle",
                view: "style",
                modelSchema: { allowWhere: ["$text", "$block"], isInline: !0 },
              },
              {
                model: "htmlCustomElement",
                view: "$customElement",
                modelSchema: { allowWhere: ["$text", "$block"], isInline: !0 },
              },
            ];
          const _w = yi(function (t, e, n, o) {
            hi(t, e, n, o);
          });
          class Cw extends j {
            constructor(t) {
              super(t), (this._definitions = new Map());
            }
            static get pluginName() {
              return "DataSchema";
            }
            init() {
              for (const t of ww) this.registerBlockElement(t);
              for (const t of Aw) this.registerInlineElement(t);
            }
            registerBlockElement(t) {
              this._definitions.set(t.model, { ...t, isBlock: !0 });
            }
            registerInlineElement(t) {
              this._definitions.set(t.model, { ...t, isInline: !0 });
            }
            extendBlockElement(t) {
              this._extendDefinition({ ...t, isBlock: !0 });
            }
            extendInlineElement(t) {
              this._extendDefinition({ ...t, isInline: !0 });
            }
            getDefinitionsForView(t, e) {
              const n = new Set();
              for (const o of this._getMatchingViewDefinitions(t)) {
                if (e) for (const t of this._getReferences(o.model)) n.add(t);
                n.add(o);
              }
              return n;
            }
            _getMatchingViewDefinitions(t) {
              return Array.from(this._definitions.values()).filter(
                (e) =>
                  e.view &&
                  (function (t, e) {
                    if ("string" == typeof t) return t === e;
                    if (t instanceof RegExp) return t.test(e);
                    return !1;
                  })(t, e.view)
              );
            }
            *_getReferences(t) {
              const { modelSchema: e } = this._definitions.get(t);
              if (!e) return;
              const n = [
                "inheritAllFrom",
                "inheritTypesFrom",
                "allowWhere",
                "allowContentOf",
                "allowAttributesOf",
              ];
              for (const o of n)
                for (const n of ko(e[o] || [])) {
                  const e = this._definitions.get(n);
                  n !== t &&
                    e &&
                    (yield* this._getReferences(e.model), yield e);
                }
            }
            _extendDefinition(t) {
              const e = this._definitions.get(t.model),
                n = _w({}, e, t, (t, e) =>
                  Array.isArray(t) ? t.concat(e) : void 0
                );
              this._definitions.set(t.model, n);
            }
          }
          function vw(t, e, n, o) {
            e &&
              (function (t, e, n) {
                if (e.attributes)
                  for (const [o] of Object.entries(e.attributes))
                    t.removeAttribute(o, n);
                if (e.styles)
                  for (const o of Object.keys(e.styles)) t.removeStyle(o, n);
                e.classes && t.removeClass(e.classes, n);
              })(t, e, o),
              n && yw(t, n, o);
          }
          function yw(t, e, n) {
            if (e.attributes)
              for (const [o, i] of Object.entries(e.attributes))
                t.setAttribute(o, i, n);
            e.styles && t.setStyle(e.styles, n),
              e.classes && t.addClass(e.classes, n);
          }
          function xw(t, e) {
            const n = Nl(t);
            for (const o in e)
              Array.isArray(e[o])
                ? (n[o] = Array.from(new Set([...(t[o] || []), ...e[o]])))
                : (n[o] = { ...t[o], ...e[o] });
            return n;
          }
          function Ew({ model: t }) {
            return (e, n) =>
              n.writer.createElement(t, {
                htmlContent: e.getCustomProperty("$rawContent"),
              });
          }
          function Dw(t, { view: e, isInline: n }) {
            const o = t.t;
            return (t, { writer: i }) => {
              const r = o("HTML object"),
                s = Sw(e, t, i),
                a = t.getAttribute("htmlAttributes");
              i.addClass("html-object-embed__content", s), a && yw(i, a, s);
              return Zp(
                i.createContainerElement(
                  n ? "span" : "div",
                  {
                    class: "html-object-embed",
                    "data-html-object-embed-label": r,
                  },
                  s
                ),
                i,
                { widgetLabel: r }
              );
            };
          }
          function Sw(t, e, n) {
            return n.createRawElement(t, null, (t, n) => {
              n.setContentOf(t, e.getAttribute("htmlContent"));
            });
          }
          function Iw({ priority: t, view: e }) {
            return (n, o) => {
              if (!n) return;
              const { writer: i } = o,
                r = i.createAttributeElement(e, null, { priority: t });
              return yw(i, n, r), r;
            };
          }
          function Tw({ view: t }, e) {
            return (n) => {
              n.on(
                `element:${t}`,
                (t, n, o) => {
                  if (!n.modelRange || n.modelRange.isCollapsed) return;
                  const i = e.processViewAttributes(n.viewItem, o);
                  i && o.writer.setAttribute("htmlAttributes", i, n.modelRange);
                },
                { priority: "low" }
              );
            };
          }
          function Mw({ model: t }) {
            return (e) => {
              e.on(`attribute:htmlAttributes:${t}`, (t, e, n) => {
                if (!n.consumable.consume(e.item, t.name)) return;
                const { attributeOldValue: o, attributeNewValue: i } = e;
                vw(n.writer, o, i, n.mapper.toViewElement(e.item));
              });
            };
          }
          const Bw = function (t, e, n, o) {
            for (var i = t.length, r = n + (o ? 1 : -1); o ? r-- : ++r < i; )
              if (e(t[r], r, t)) return r;
            return -1;
          };
          const Nw = function (t) {
            return t != t;
          };
          const zw = function (t, e, n) {
            for (var o = n - 1, i = t.length; ++o < i; )
              if (t[o] === e) return o;
            return -1;
          };
          const Pw = function (t, e, n) {
            return e == e ? zw(t, e, n) : Bw(t, Nw, n);
          };
          const Lw = function (t, e, n, o) {
            for (var i = n - 1, r = t.length; ++i < r; )
              if (o(t[i], e)) return i;
            return -1;
          };
          var Rw = Array.prototype.splice;
          const Ow = function (t, e, n, o) {
            var i = o ? Lw : Pw,
              r = -1,
              s = e.length,
              a = t;
            for (t === e && (e = an(e)), n && (a = qo(t, Ne(n))); ++r < s; )
              for (
                var l = 0, c = e[r], d = n ? n(c) : c;
                (l = i(a, d, l, o)) > -1;

              )
                a !== t && Rw.call(a, l, 1), Rw.call(t, l, 1);
            return t;
          };
          const jw = Ci(function (t, e) {
            return t && t.length && e && e.length ? Ow(t, e) : t;
          });
          var Vw = n(8468),
            Fw = { attributes: { "data-cke": !0 } };
          (Fw.setAttributes = is()),
            (Fw.insert = ns().bind(null, "head")),
            (Fw.domAPI = ts()),
            (Fw.insertStyleElement = ss());
          Jr()(Vw.Z, Fw);
          Vw.Z && Vw.Z.locals && Vw.Z.locals;
          class Hw extends j {
            constructor(t) {
              super(t),
                (this._dataSchema = t.plugins.get("DataSchema")),
                (this._allowedAttributes = new No()),
                (this._disallowedAttributes = new No()),
                (this._allowedElements = new Set()),
                (this._disallowedElements = new Set()),
                (this._dataInitialized = !1),
                (this._coupledAttributes = null),
                this._registerElementsAfterInit(),
                this._registerElementHandlers(),
                this._registerModelPostFixer();
            }
            static get pluginName() {
              return "DataFilter";
            }
            static get requires() {
              return [Cw, kf];
            }
            loadAllowedConfig(t) {
              for (const e of t) {
                const t = e.name || /[\s\S]+/,
                  n = Gw(e);
                this.allowElement(t), n.forEach((t) => this.allowAttributes(t));
              }
            }
            loadDisallowedConfig(t) {
              for (const e of t) {
                const t = e.name || /[\s\S]+/,
                  n = Gw(e);
                0 == n.length
                  ? this.disallowElement(t)
                  : n.forEach((t) => this.disallowAttributes(t));
              }
            }
            allowElement(t) {
              for (const e of this._dataSchema.getDefinitionsForView(t, !0))
                this._allowedElements.has(e) ||
                  (this._allowedElements.add(e),
                  this._dataInitialized &&
                    this.editor.data.once(
                      "set",
                      () => {
                        this._fireRegisterEvent(e);
                      },
                      { priority: s.get("highest") + 1 }
                    ),
                  (this._coupledAttributes = null));
            }
            disallowElement(t) {
              for (const e of this._dataSchema.getDefinitionsForView(t, !1))
                this._disallowedElements.add(e.view);
            }
            allowAttributes(t) {
              this._allowedAttributes.add(t);
            }
            disallowAttributes(t) {
              this._disallowedAttributes.add(t);
            }
            processViewAttributes(t, e) {
              return (
                Uw(t, e, this._disallowedAttributes),
                Uw(t, e, this._allowedAttributes)
              );
            }
            _registerElementsAfterInit() {
              this.editor.data.on(
                "init",
                () => {
                  this._dataInitialized = !0;
                  for (const t of this._allowedElements)
                    this._fireRegisterEvent(t);
                },
                { priority: s.get("highest") + 1 }
              );
            }
            _registerElementHandlers() {
              this.on(
                "register",
                (t, e) => {
                  const n = this.editor.model.schema;
                  if (e.isObject && !n.isRegistered(e.model))
                    this._registerObjectElement(e);
                  else if (e.isBlock) this._registerBlockElement(e);
                  else {
                    if (!e.isInline)
                      throw new l("data-filter-invalid-definition", null, e);
                    this._registerInlineElement(e);
                  }
                  t.stop();
                },
                { priority: "lowest" }
              );
            }
            _registerModelPostFixer() {
              const t = this.editor.model;
              t.document.registerPostFixer((e) => {
                const n = t.document.differ.getChanges();
                let o = !1;
                const i = this._getCoupledAttributesMap();
                for (const t of n) {
                  if ("attribute" != t.type || null !== t.attributeNewValue)
                    continue;
                  const n = i.get(t.attributeKey);
                  if (n)
                    for (const { item: i } of t.range.getWalker({
                      shallow: !0,
                    }))
                      for (const t of n)
                        i.hasAttribute(t) &&
                          (e.removeAttribute(t, i), (o = !0));
                }
                return o;
              });
            }
            _getCoupledAttributesMap() {
              if (this._coupledAttributes) return this._coupledAttributes;
              this._coupledAttributes = new Map();
              for (const t of this._allowedElements)
                if (t.coupledAttribute && t.model) {
                  const e = this._coupledAttributes.get(t.coupledAttribute);
                  e
                    ? e.push(t.model)
                    : this._coupledAttributes.set(t.coupledAttribute, [
                        t.model,
                      ]);
                }
            }
            _fireRegisterEvent(t) {
              (t.view && this._disallowedElements.has(t.view)) ||
                this.fire(t.view ? `register:${t.view}` : "register", t);
            }
            _registerObjectElement(t) {
              const e = this.editor,
                n = e.model.schema,
                o = e.conversion,
                { view: i, model: r } = t;
              n.register(r, t.modelSchema),
                i &&
                  (n.extend(t.model, {
                    allowAttributes: ["htmlAttributes", "htmlContent"],
                  }),
                  e.data.registerRawContentMatcher({ name: i }),
                  o
                    .for("upcast")
                    .elementToElement({
                      view: i,
                      model: Ew(t),
                      converterPriority: s.get("low") + 1,
                    }),
                  o.for("upcast").add(Tw(t, this)),
                  o
                    .for("editingDowncast")
                    .elementToStructure({
                      model: { name: r, attributes: ["htmlAttributes"] },
                      view: Dw(e, t),
                    }),
                  o
                    .for("dataDowncast")
                    .elementToElement({
                      model: r,
                      view: (t, { writer: e }) => Sw(i, t, e),
                    }),
                  o.for("dataDowncast").add(Mw(t)));
            }
            _registerBlockElement(t) {
              const e = this.editor,
                n = e.model.schema,
                o = e.conversion,
                { view: i, model: r } = t;
              if (!n.isRegistered(t.model)) {
                if ((n.register(t.model, t.modelSchema), !i)) return;
                o
                  .for("upcast")
                  .elementToElement({
                    model: r,
                    view: i,
                    converterPriority: s.get("low") + 1,
                  }),
                  o.for("downcast").elementToElement({ model: r, view: i });
              }
              i &&
                (n.extend(t.model, { allowAttributes: "htmlAttributes" }),
                o.for("upcast").add(Tw(t, this)),
                o.for("downcast").add(Mw(t)));
            }
            _registerInlineElement(t) {
              const e = this.editor,
                n = e.model.schema,
                o = e.conversion,
                i = t.model;
              n.extend("$text", { allowAttributes: i }),
                t.attributeProperties &&
                  n.setAttributeProperties(i, t.attributeProperties),
                o.for("upcast").add(
                  (function ({ view: t, model: e }, n) {
                    return (o) => {
                      o.on(
                        `element:${t}`,
                        (t, o, i) => {
                          let r = n.processViewAttributes(o.viewItem, i);
                          if (
                            r ||
                            i.consumable.test(o.viewItem, { name: !0 })
                          ) {
                            (r = r || {}),
                              i.consumable.consume(o.viewItem, { name: !0 }),
                              o.modelRange ||
                                (o = Object.assign(
                                  o,
                                  i.convertChildren(o.viewItem, o.modelCursor)
                                ));
                            for (const t of o.modelRange.getItems())
                              if (i.schema.checkAttribute(t, e)) {
                                const n = xw(r, t.getAttribute(e) || {});
                                i.writer.setAttribute(e, n, t);
                              }
                          }
                        },
                        { priority: "low" }
                      );
                    };
                  })(t, this)
                ),
                o.for("downcast").attributeToElement({ model: i, view: Iw(t) });
            }
          }
          function Uw(t, e, n) {
            const o = (function (t, { consumable: e }, n) {
                const o = n.matchAll(t) || [],
                  i = [];
                for (const n of o)
                  Ww(e, t, n),
                    delete n.match.name,
                    e.consume(t, n.match),
                    i.push(n);
                return i;
              })(t, e, n),
              {
                attributes: i,
                styles: r,
                classes: s,
              } = (function (t) {
                const e = {
                  attributes: new Set(),
                  classes: new Set(),
                  styles: new Set(),
                };
                for (const n of t)
                  for (const t in e) {
                    (n.match[t] || []).forEach((n) => e[t].add(n));
                  }
                return e;
              })(o),
              a = {};
            if (i.size) for (const t of i) Zw(t) || i.delete(t);
            return (
              i.size && (a.attributes = $w(i, (e) => t.getAttribute(e))),
              r.size && (a.styles = $w(r, (e) => t.getStyle(e))),
              s.size && (a.classes = Array.from(s)),
              Object.keys(a).length ? a : null
            );
          }
          function Ww(t, e, n) {
            for (const o of ["attributes", "classes", "styles"]) {
              const i = n.match[o];
              if (i)
                for (const n of Array.from(i))
                  t.test(e, { [o]: [n] }) || jw(i, n);
            }
          }
          function $w(t, e) {
            const n = {};
            for (const o of t) {
              void 0 !== e(o) && (n[o] = e(o));
            }
            return n;
          }
          function qw(t, e) {
            const { name: n } = t;
            return ut(t[e])
              ? Object.entries(t[e]).map(([t, o]) => ({
                  name: n,
                  [e]: { [t]: o },
                }))
              : Array.isArray(t[e])
              ? t[e].map((t) => ({ name: n, [e]: [t] }))
              : [t];
          }
          function Gw(t) {
            const { name: e, attributes: n, classes: o, styles: i } = t,
              r = [];
            return (
              n && r.push(...qw({ name: e, attributes: n }, "attributes")),
              o && r.push(...qw({ name: e, classes: o }, "classes")),
              i && r.push(...qw({ name: e, styles: i }, "styles")),
              r
            );
          }
          function Zw(t) {
            try {
              document.createAttribute(t);
            } catch (t) {
              return !1;
            }
            return !0;
          }
          class Yw extends j {
            static get requires() {
              return [Hw];
            }
            static get pluginName() {
              return "CodeBlockElementSupport";
            }
            init() {
              if (!this.editor.plugins.has("CodeBlockEditing")) return;
              const t = this.editor.plugins.get(Hw);
              t.on("register:pre", (e, n) => {
                if ("codeBlock" !== n.model) return;
                const o = this.editor,
                  i = o.model.schema,
                  r = o.conversion;
                i.extend("codeBlock", {
                  allowAttributes: ["htmlAttributes", "htmlContentAttributes"],
                }),
                  r.for("upcast").add(
                    (function (t) {
                      return (e) => {
                        e.on(
                          "element:code",
                          (e, n, o) => {
                            const i = n.viewItem,
                              r = i.parent;
                            function s(e, i) {
                              const r = t.processViewAttributes(e, o);
                              r && o.writer.setAttribute(i, r, n.modelRange);
                            }
                            r &&
                              r.is("element", "pre") &&
                              (s(r, "htmlAttributes"),
                              s(i, "htmlContentAttributes"));
                          },
                          { priority: "low" }
                        );
                      };
                    })(t)
                  ),
                  r.for("downcast").add((t) => {
                    t.on("attribute:htmlAttributes:codeBlock", (t, e, n) => {
                      if (!n.consumable.consume(e.item, t.name)) return;
                      const { attributeOldValue: o, attributeNewValue: i } = e,
                        r = n.mapper.toViewElement(e.item).parent;
                      vw(n.writer, o, i, r);
                    }),
                      t.on(
                        "attribute:htmlContentAttributes:codeBlock",
                        (t, e, n) => {
                          if (!n.consumable.consume(e.item, t.name)) return;
                          const { attributeOldValue: o, attributeNewValue: i } =
                              e,
                            r = n.mapper.toViewElement(e.item);
                          vw(n.writer, o, i, r);
                        }
                      );
                  }),
                  e.stop();
              });
            }
          }
          class Kw extends j {
            static get requires() {
              return [Hw];
            }
            static get pluginName() {
              return "DualContentModelElementSupport";
            }
            init() {
              this.editor.plugins.get(Hw).on("register", (t, e) => {
                const n = this.editor,
                  o = n.model.schema,
                  i = n.conversion;
                if (!e.paragraphLikeModel) return;
                if (
                  o.isRegistered(e.model) ||
                  o.isRegistered(e.paragraphLikeModel)
                )
                  return;
                const r = { model: e.paragraphLikeModel, view: e.view };
                o.register(e.model, e.modelSchema),
                  o.register(r.model, { inheritAllFrom: "$block" }),
                  i
                    .for("upcast")
                    .elementToElement({
                      view: e.view,
                      model: (t, { writer: n }) =>
                        this._hasBlockContent(t)
                          ? n.createElement(e.model)
                          : n.createElement(r.model),
                      converterPriority: s.get("low") + 1,
                    }),
                  i
                    .for("downcast")
                    .elementToElement({ view: e.view, model: e.model }),
                  this._addAttributeConversion(e),
                  i
                    .for("downcast")
                    .elementToElement({ view: r.view, model: r.model }),
                  this._addAttributeConversion(r),
                  t.stop();
              });
            }
            _hasBlockContent(t) {
              const e = this.editor.editing.view,
                n = e.domConverter.blockElements;
              for (const o of e.createRangeIn(t).getItems())
                if (o.is("element") && n.includes(o.name)) return !0;
              return !1;
            }
            _addAttributeConversion(t) {
              const e = this.editor,
                n = e.conversion,
                o = e.plugins.get(Hw);
              e.model.schema.extend(t.model, {
                allowAttributes: "htmlAttributes",
              }),
                n.for("upcast").add(Tw(t, o)),
                n.for("downcast").add(Mw(t));
            }
          }
          class Qw extends j {
            static get requires() {
              return [Cw];
            }
            static get pluginName() {
              return "HeadingElementSupport";
            }
            init() {
              const t = this.editor;
              if (!t.plugins.has("HeadingEditing")) return;
              const e = t.plugins.get(Cw),
                n = t.config.get("heading.options"),
                o = [];
              for (const t of n)
                "model" in t &&
                  "view" in t &&
                  (e.registerBlockElement({ view: t.view, model: t.model }),
                  o.push(t.model));
              e.extendBlockElement({
                model: "htmlHgroup",
                modelSchema: { allowChildren: o },
              });
            }
          }
          class Jw extends j {
            static get requires() {
              return [Hw];
            }
            static get pluginName() {
              return "ImageElementSupport";
            }
            init() {
              const t = this.editor;
              if (
                !t.plugins.has("ImageInlineEditing") &&
                !t.plugins.has("ImageBlockEditing")
              )
                return;
              const e = t.model.schema,
                n = t.conversion,
                o = t.plugins.get(Hw);
              o.on("register:figure", () => {
                n.for("upcast").add(
                  (function (t) {
                    return (e) => {
                      e.on(
                        "element:figure",
                        (e, n, o) => {
                          const i = n.viewItem;
                          if (!n.modelRange || !i.hasClass("image")) return;
                          const r = t.processViewAttributes(i, o);
                          r &&
                            o.writer.setAttribute(
                              "htmlFigureAttributes",
                              r,
                              n.modelRange
                            );
                        },
                        { priority: "low" }
                      );
                    };
                  })(o)
                );
              }),
                o.on("register:img", (t, i) => {
                  ("imageBlock" !== i.model && "imageInline" !== i.model) ||
                    (e.isRegistered("imageBlock") &&
                      e.extend("imageBlock", {
                        allowAttributes: [
                          "htmlAttributes",
                          "htmlFigureAttributes",
                          "htmlLinkAttributes",
                        ],
                      }),
                    e.isRegistered("imageInline") &&
                      e.extend("imageInline", {
                        allowAttributes: ["htmlA", "htmlAttributes"],
                      }),
                    n.for("upcast").add(
                      (function (t) {
                        return (e) => {
                          e.on(
                            "element:img",
                            (e, n, o) => {
                              if (!n.modelRange) return;
                              const i = n.viewItem,
                                r = i.parent;
                              function s(e, i) {
                                const r = t.processViewAttributes(e, o);
                                r && o.writer.setAttribute(i, r, n.modelRange);
                              }
                              function a(t) {
                                n.modelRange &&
                                  n.modelRange
                                    .getContainedElement()
                                    .is("element", "imageBlock") &&
                                  s(t, "htmlLinkAttributes");
                              }
                              s(i, "htmlAttributes"),
                                r.is("element", "a") && a(r);
                            },
                            { priority: "low" }
                          );
                        };
                      })(o)
                    ),
                    n.for("downcast").add((t) => {
                      function e(e) {
                        t.on(
                          `attribute:${e}:imageInline`,
                          (t, e, n) => {
                            if (!n.consumable.consume(e.item, t.name)) return;
                            const {
                                attributeOldValue: o,
                                attributeNewValue: i,
                              } = e,
                              r = n.mapper.toViewElement(e.item);
                            vw(n.writer, o, i, r);
                          },
                          { priority: "low" }
                        );
                      }
                      function n(e, n) {
                        t.on(
                          `attribute:${n}:imageBlock`,
                          (t, n, o) => {
                            if (!o.consumable.test(n.item, t.name)) return;
                            const {
                                attributeOldValue: i,
                                attributeNewValue: r,
                              } = n,
                              s = o.mapper.toViewElement(n.item),
                              a = Xw(o.writer, s, e);
                            a &&
                              (vw(o.writer, i, r, a),
                              o.consumable.consume(n.item, t.name));
                          },
                          { priority: "low" }
                        ),
                          "a" === e &&
                            t.on(
                              "attribute:linkHref:imageBlock",
                              (t, e, n) => {
                                if (
                                  !n.consumable.consume(
                                    e.item,
                                    "attribute:htmlLinkAttributes:imageBlock"
                                  )
                                )
                                  return;
                                const o = n.mapper.toViewElement(e.item),
                                  i = Xw(n.writer, o, "a");
                                yw(
                                  n.writer,
                                  e.item.getAttribute("htmlLinkAttributes"),
                                  i
                                );
                              },
                              { priority: "low" }
                            );
                      }
                      e("htmlAttributes"),
                        n("img", "htmlAttributes"),
                        n("figure", "htmlFigureAttributes"),
                        n("a", "htmlLinkAttributes");
                    }),
                    t.stop());
                });
            }
          }
          function Xw(t, e, n) {
            const o = t.createRangeOn(e);
            for (const { item: t } of o.getWalker())
              if (t.is("element", n)) return t;
          }
          class tA extends j {
            static get requires() {
              return [Hw];
            }
            static get pluginName() {
              return "MediaEmbedElementSupport";
            }
            init() {
              const t = this.editor;
              if (
                !t.plugins.has("MediaEmbed") ||
                t.config.get("mediaEmbed.previewsInData")
              )
                return;
              const e = t.model.schema,
                n = t.conversion,
                o = this.editor.plugins.get(Hw),
                i = this.editor.plugins.get(Cw),
                r = t.config.get("mediaEmbed.elementName");
              i.registerBlockElement({ model: "media", view: r }),
                o.on("register:figure", () => {
                  n.for("upcast").add(
                    (function (t) {
                      return (e) => {
                        e.on(
                          "element:figure",
                          (e, n, o) => {
                            const i = n.viewItem;
                            if (!n.modelRange || !i.hasClass("media")) return;
                            const r = t.processViewAttributes(i, o);
                            r &&
                              o.writer.setAttribute(
                                "htmlFigureAttributes",
                                r,
                                n.modelRange
                              );
                          },
                          { priority: "low" }
                        );
                      };
                    })(o)
                  );
                }),
                o.on(`register:${r}`, (t, i) => {
                  "media" === i.model &&
                    (e.extend("media", {
                      allowAttributes: [
                        "htmlAttributes",
                        "htmlFigureAttributes",
                      ],
                    }),
                    n.for("upcast").add(
                      (function (t, e) {
                        return (t) => {
                          t.on(`element:${e}`, n);
                        };
                        function n(e, n, o) {
                          function i(e, i) {
                            const r = t.processViewAttributes(e, o);
                            r && o.writer.setAttribute(i, r, n.modelRange);
                          }
                          i(n.viewItem, "htmlAttributes");
                        }
                      })(o, r)
                    ),
                    n.for("dataDowncast").add(
                      (function (t) {
                        return (e) => {
                          function n(t, n) {
                            e.on(`attribute:${n}:media`, (e, n, o) => {
                              if (!o.consumable.consume(n.item, e.name)) return;
                              const {
                                  attributeOldValue: i,
                                  attributeNewValue: r,
                                } = n,
                                s = o.mapper.toViewElement(n.item),
                                a = (function (t, e, n) {
                                  const o = t.createRangeOn(e);
                                  for (const { item: t } of o.getWalker())
                                    if (t.is("element", n)) return t;
                                })(o.writer, s, t);
                              vw(o.writer, i, r, a);
                            });
                          }
                          n(t, "htmlAttributes"),
                            n("figure", "htmlFigureAttributes");
                        };
                      })(r)
                    ),
                    t.stop());
                });
            }
          }
          class eA extends j {
            static get requires() {
              return [Hw];
            }
            static get pluginName() {
              return "ScriptElementSupport";
            }
            init() {
              const t = this.editor.plugins.get(Hw);
              t.on("register:script", (e, n) => {
                const o = this.editor,
                  i = o.model.schema,
                  r = o.conversion;
                i.register("htmlScript", n.modelSchema),
                  i.extend("htmlScript", {
                    allowAttributes: ["htmlAttributes", "htmlContent"],
                    isContent: !0,
                  }),
                  o.data.registerRawContentMatcher({ name: "script" }),
                  r
                    .for("upcast")
                    .elementToElement({ view: "script", model: Ew(n) }),
                  r.for("upcast").add(Tw(n, t)),
                  r
                    .for("downcast")
                    .elementToElement({
                      model: "htmlScript",
                      view: (t, { writer: e }) => Sw("script", t, e),
                    }),
                  r.for("downcast").add(Mw(n)),
                  e.stop();
              });
            }
          }
          class nA extends j {
            static get requires() {
              return [Hw];
            }
            static get pluginName() {
              return "TableElementSupport";
            }
            init() {
              const t = this.editor;
              if (!t.plugins.has("TableEditing")) return;
              const e = t.model.schema,
                n = t.conversion,
                o = t.plugins.get(Hw);
              o.on("register:figure", () => {
                n.for("upcast").add(
                  (function (t) {
                    return (e) => {
                      e.on(
                        "element:figure",
                        (e, n, o) => {
                          const i = n.viewItem;
                          if (!n.modelRange || !i.hasClass("table")) return;
                          const r = t.processViewAttributes(i, o);
                          r &&
                            o.writer.setAttribute(
                              "htmlFigureAttributes",
                              r,
                              n.modelRange
                            );
                        },
                        { priority: "low" }
                      );
                    };
                  })(o)
                );
              }),
                o.on("register:table", (t, i) => {
                  "table" === i.model &&
                    (e.extend("table", {
                      allowAttributes: [
                        "htmlAttributes",
                        "htmlFigureAttributes",
                        "htmlTheadAttributes",
                        "htmlTbodyAttributes",
                      ],
                    }),
                    n.for("upcast").add(
                      (function (t) {
                        return (e) => {
                          e.on("element:table", (e, n, o) => {
                            const i = n.viewItem;
                            r(i, "htmlAttributes");
                            for (const t of i.getChildren())
                              t.is("element", "thead") &&
                                r(t, "htmlTheadAttributes"),
                                t.is("element", "tbody") &&
                                  r(t, "htmlTbodyAttributes");
                            function r(e, i) {
                              const r = t.processViewAttributes(e, o);
                              r && o.writer.setAttribute(i, r, n.modelRange);
                            }
                          });
                        };
                      })(o)
                    ),
                    n.for("downcast").add((t) => {
                      function e(e, n) {
                        t.on(`attribute:${n}:table`, (t, n, o) => {
                          if (!o.consumable.consume(n.item, t.name)) return;
                          const i = o.mapper.toViewElement(n.item),
                            r = (function (t, e, n) {
                              const o = t.createRangeOn(e);
                              for (const { item: t } of o.getWalker())
                                if (t.is("element", n)) return t;
                            })(o.writer, i, e);
                          yw(o.writer, n.attributeNewValue, r);
                        });
                      }
                      e("table", "htmlAttributes"),
                        e("figure", "htmlFigureAttributes"),
                        e("thead", "htmlTheadAttributes"),
                        e("tbody", "htmlTbodyAttributes");
                    }),
                    t.stop());
                });
            }
          }
          class oA extends j {
            static get requires() {
              return [Hw];
            }
            static get pluginName() {
              return "StyleElementSupport";
            }
            init() {
              const t = this.editor.plugins.get(Hw);
              t.on("register:style", (e, n) => {
                const o = this.editor,
                  i = o.model.schema,
                  r = o.conversion;
                i.register("htmlStyle", n.modelSchema),
                  i.extend("htmlStyle", {
                    allowAttributes: ["htmlAttributes", "htmlContent"],
                    isContent: !0,
                  }),
                  o.data.registerRawContentMatcher({ name: "style" }),
                  r
                    .for("upcast")
                    .elementToElement({ view: "style", model: Ew(n) }),
                  r.for("upcast").add(Tw(n, t)),
                  r
                    .for("downcast")
                    .elementToElement({
                      model: "htmlStyle",
                      view: (t, { writer: e }) => Sw("style", t, e),
                    }),
                  r.for("downcast").add(Mw(n)),
                  e.stop();
              });
            }
          }
          class iA extends j {
            static get requires() {
              return [Hw];
            }
            static get pluginName() {
              return "DocumentListElementSupport";
            }
            init() {
              const t = this.editor;
              if (!t.plugins.has("DocumentListEditing")) return;
              const e = t.model.schema,
                n = t.conversion,
                o = t.plugins.get(Hw),
                i = t.plugins.get("DocumentListEditing");
              i.registerDowncastStrategy({
                scope: "item",
                attributeName: "htmlLiAttributes",
                setAttributeOnDowncast(t, e, n) {
                  yw(t, e, n);
                },
              }),
                i.registerDowncastStrategy({
                  scope: "list",
                  attributeName: "htmlListAttributes",
                  setAttributeOnDowncast(t, e, n) {
                    yw(t, e, n);
                  },
                }),
                o.on("register", (t, i) => {
                  ["ul", "ol", "li"].includes(i.view) &&
                    (t.stop(),
                    e.checkAttribute("$block", "htmlListAttributes") ||
                      (e.extend("$block", {
                        allowAttributes: [
                          "htmlListAttributes",
                          "htmlLiAttributes",
                        ],
                      }),
                      e.extend("$blockObject", {
                        allowAttributes: [
                          "htmlListAttributes",
                          "htmlLiAttributes",
                        ],
                      }),
                      e.extend("$container", {
                        allowAttributes: [
                          "htmlListAttributes",
                          "htmlLiAttributes",
                        ],
                      }),
                      n.for("upcast").add((t) => {
                        t.on("element:ul", rA("htmlListAttributes", o), {
                          priority: "low",
                        }),
                          t.on("element:ol", rA("htmlListAttributes", o), {
                            priority: "low",
                          }),
                          t.on("element:li", rA("htmlLiAttributes", o), {
                            priority: "low",
                          });
                      })));
                }),
                i.on("postFixer", (t, { listNodes: e, writer: n }) => {
                  const o = [];
                  for (const { node: i, previous: r } of e) {
                    if (!r) continue;
                    const e = i.getAttribute("listIndent"),
                      s = r.getAttribute("listIndent");
                    let a = null;
                    if (
                      (e > s
                        ? (o[s] = r)
                        : e < s
                        ? ((a = o[e]), (o.length = e))
                        : (a = r),
                      a)
                    ) {
                      if (
                        a.getAttribute("listType") == i.getAttribute("listType")
                      ) {
                        const e = a.getAttribute("htmlListAttributes");
                        td(i.getAttribute("htmlListAttributes"), e) ||
                          (n.setAttribute("htmlListAttributes", e, i),
                          (t.return = !0));
                      }
                      if (
                        a.getAttribute("listItemId") ==
                        i.getAttribute("listItemId")
                      ) {
                        const e = a.getAttribute("htmlLiAttributes");
                        td(i.getAttribute("htmlLiAttributes"), e) ||
                          (n.setAttribute("htmlLiAttributes", e, i),
                          (t.return = !0));
                      }
                    }
                  }
                });
            }
            afterInit() {
              const t = this.editor;
              t.commands.get("indentList") &&
                this.listenTo(
                  t.commands.get("indentList"),
                  "afterExecute",
                  (e, n) => {
                    t.model.change((t) => {
                      for (const e of n)
                        t.setAttribute("htmlListAttributes", {}, e);
                    });
                  }
                );
            }
          }
          function rA(t, e) {
            return (n, o, i) => {
              const r = o.viewItem;
              o.modelRange ||
                Object.assign(o, i.convertChildren(o.viewItem, o.modelCursor));
              const s = e.processViewAttributes(r, i);
              for (const e of o.modelRange.getItems({ shallow: !0 }))
                e.hasAttribute("listItemId") &&
                  (e.hasAttribute(t) || i.writer.setAttribute(t, s || {}, e));
            };
          }
          class sA extends j {
            static get requires() {
              return [Hw, Cw];
            }
            static get pluginName() {
              return "CustomElementSupport";
            }
            init() {
              const t = this.editor.plugins.get(Hw),
                e = this.editor.plugins.get(Cw);
              t.on("register:$customElement", (n, o) => {
                n.stop();
                const i = this.editor,
                  r = i.model.schema,
                  s = i.conversion,
                  a = i.editing.view.domConverter.unsafeElements,
                  l = i.data.htmlProcessor.domConverter.preElements;
                r.register(o.model, o.modelSchema),
                  r.extend(o.model, {
                    allowAttributes: [
                      "htmlElementName",
                      "htmlAttributes",
                      "htmlContent",
                    ],
                    isContent: !0,
                  }),
                  s.for("upcast").elementToElement({
                    view: /.*/,
                    model: (n, r) => {
                      if ("$comment" == n.name) return;
                      if (
                        !(function (t) {
                          try {
                            document.createElement(t);
                          } catch (t) {
                            return !1;
                          }
                          return !0;
                        })(n.name)
                      )
                        return;
                      if (e.getDefinitionsForView(n.name).size) return;
                      a.includes(n.name) || a.push(n.name),
                        l.includes(n.name) || l.push(n.name);
                      const s = r.writer.createElement(o.model, {
                          htmlElementName: n.name,
                        }),
                        c = t.processViewAttributes(n, r);
                      c && r.writer.setAttribute("htmlAttributes", c, s);
                      const d = new eu(n.document).createDocumentFragment(n),
                        u = i.data.processor.toData(d);
                      r.writer.setAttribute("htmlContent", u, s);
                      for (const { item: t } of i.editing.view.createRangeIn(n))
                        r.consumable.consume(t, { name: !0 });
                      return s;
                    },
                    converterPriority: "low",
                  }),
                  s.for("editingDowncast").elementToElement({
                    model: {
                      name: o.model,
                      attributes: [
                        "htmlElementName",
                        "htmlAttributes",
                        "htmlContent",
                      ],
                    },
                    view: (t, { writer: e }) => {
                      const n = t.getAttribute("htmlElementName"),
                        o = e.createRawElement(n);
                      return (
                        t.hasAttribute("htmlAttributes") &&
                          yw(e, t.getAttribute("htmlAttributes"), o),
                        o
                      );
                    },
                  }),
                  s.for("dataDowncast").elementToElement({
                    model: {
                      name: o.model,
                      attributes: [
                        "htmlElementName",
                        "htmlAttributes",
                        "htmlContent",
                      ],
                    },
                    view: (t, { writer: e }) => {
                      const n = t.getAttribute("htmlElementName"),
                        o = t.getAttribute("htmlContent"),
                        i = e.createRawElement(n, null, (t, e) => {
                          e.setContentOf(t, o);
                          const n = t.firstChild;
                          for (n.remove(); n.firstChild; )
                            t.appendChild(n.firstChild);
                        });
                      return (
                        t.hasAttribute("htmlAttributes") &&
                          yw(e, t.getAttribute("htmlAttributes"), i),
                        i
                      );
                    },
                  });
              });
            }
          }
          function* aA(t, e, n) {
            if (e.is("documentSelection") && e.isCollapsed)
              t.schema.checkAttributeInSelection(e, n) && (yield e);
            else
              for (const o of (function (t, e, n) {
                return e.is("node") || e.is("$text") || e.is("$textProxy")
                  ? t.schema.checkAttribute(e, n)
                    ? [t.createRangeOn(e)]
                    : []
                  : t.schema.getValidRanges(
                      t.createSelection(e).getRanges(),
                      n
                    );
              })(t, e, n))
                yield* o.getItems({ shallow: !0 });
          }
          function lA(t, e, n, o, i) {
            const r = e.getAttribute(n),
              s = {};
            for (const t of ["attributes", "styles", "classes"])
              if (t != o) r && r[t] && (s[t] = r[t]);
              else {
                const e =
                  "classes" == t
                    ? new Set((r && r[t]) || [])
                    : new Map(Object.entries((r && r[t]) || {}));
                i(e),
                  e.size &&
                    (s[t] =
                      "classes" == t ? Array.from(e) : Object.fromEntries(e));
              }
            Object.keys(s).length
              ? e.is("documentSelection")
                ? t.setSelectionAttribute(n, s)
                : t.setAttribute(n, s, e)
              : r &&
                (e.is("documentSelection")
                  ? t.removeSelectionAttribute(n)
                  : t.removeAttribute(n, e));
          }
          class cA extends F {
            refresh() {
              const t = this.editor.model,
                e = Ra(t.document.selection.getSelectedBlocks());
              (this.value = !!e && e.is("element", "paragraph")),
                (this.isEnabled = !!e && dA(e, t.schema));
            }
            execute(t = {}) {
              const e = this.editor.model,
                n = e.document;
              e.change((o) => {
                const i = (t.selection || n.selection).getSelectedBlocks();
                for (const t of i)
                  !t.is("element", "paragraph") &&
                    dA(t, e.schema) &&
                    o.rename(t, "paragraph");
              });
            }
          }
          function dA(t, e) {
            return e.checkChild(t.parent, "paragraph") && !e.isObject(t);
          }
          class uA extends F {
            execute(t) {
              const e = this.editor.model,
                n = t.attributes;
              let o = t.position;
              e.change((t) => {
                const i = t.createElement("paragraph");
                if (
                  (n && e.schema.setAllowedAttributes(i, n, t),
                  !e.schema.checkChild(o.parent, i))
                ) {
                  const n = e.schema.findAllowedParent(o, i);
                  if (!n) return;
                  o = t.split(o, n).position;
                }
                e.insertContent(i, o), t.setSelection(i, "in");
              });
            }
          }
          class hA extends j {
            static get pluginName() {
              return "Paragraph";
            }
            init() {
              const t = this.editor,
                e = t.model;
              t.commands.add("paragraph", new cA(t)),
                t.commands.add("insertParagraph", new uA(t)),
                e.schema.register("paragraph", { inheritAllFrom: "$block" }),
                t.conversion.elementToElement({
                  model: "paragraph",
                  view: "p",
                }),
                t.conversion
                  .for("upcast")
                  .elementToElement({
                    model: (t, { writer: e }) =>
                      hA.paragraphLikeElements.has(t.name)
                        ? t.isEmpty
                          ? null
                          : e.createElement("paragraph")
                        : null,
                    view: /.+/,
                    converterPriority: "low",
                  });
            }
          }
          hA.paragraphLikeElements = new Set([
            "blockquote",
            "dd",
            "div",
            "dt",
            "h1",
            "h2",
            "h3",
            "h4",
            "h5",
            "h6",
            "li",
            "p",
            "td",
            "th",
          ]);
          class mA extends F {
            constructor(t, e) {
              super(t), (this.modelElements = e);
            }
            refresh() {
              const t = Ra(
                this.editor.model.document.selection.getSelectedBlocks()
              );
              (this.value =
                !!t && this.modelElements.includes(t.name) && t.name),
                (this.isEnabled =
                  !!t &&
                  this.modelElements.some((e) =>
                    gA(t, e, this.editor.model.schema)
                  ));
            }
            execute(t) {
              const e = this.editor.model,
                n = e.document,
                o = t.value;
              e.change((t) => {
                const i = Array.from(n.selection.getSelectedBlocks()).filter(
                  (t) => gA(t, o, e.schema)
                );
                for (const e of i) e.is("element", o) || t.rename(e, o);
              });
            }
          }
          function gA(t, e, n) {
            return n.checkChild(t.parent, e) && !n.isObject(t);
          }
          const pA = "paragraph";
          class fA extends j {
            static get pluginName() {
              return "HeadingEditing";
            }
            constructor(t) {
              super(t),
                t.config.define("heading", {
                  options: [
                    {
                      model: "paragraph",
                      title: "Paragraph",
                      class: "ck-heading_paragraph",
                    },
                    {
                      model: "heading1",
                      view: "h2",
                      title: "Heading 1",
                      class: "ck-heading_heading1",
                    },
                    {
                      model: "heading2",
                      view: "h3",
                      title: "Heading 2",
                      class: "ck-heading_heading2",
                    },
                    {
                      model: "heading3",
                      view: "h4",
                      title: "Heading 3",
                      class: "ck-heading_heading3",
                    },
                  ],
                });
            }
            static get requires() {
              return [hA];
            }
            init() {
              const t = this.editor,
                e = t.config.get("heading.options"),
                n = [];
              for (const o of e)
                o.model !== pA &&
                  (t.model.schema.register(o.model, {
                    inheritAllFrom: "$block",
                  }),
                  t.conversion.elementToElement(o),
                  n.push(o.model));
              this._addDefaultH1Conversion(t),
                t.commands.add("heading", new mA(t, n));
            }
            afterInit() {
              const t = this.editor,
                e = t.commands.get("enter"),
                n = t.config.get("heading.options");
              e &&
                this.listenTo(e, "afterExecute", (e, o) => {
                  const i =
                    t.model.document.selection.getFirstPosition().parent;
                  n.some((t) => i.is("element", t.model)) &&
                    !i.is("element", pA) &&
                    0 === i.childCount &&
                    o.writer.rename(i, pA);
                });
            }
            _addDefaultH1Conversion(t) {
              t.conversion
                .for("upcast")
                .elementToElement({
                  model: "heading1",
                  view: "h1",
                  converterPriority: s.get("low") + 1,
                });
            }
          }
          var kA = n(3230),
            bA = { attributes: { "data-cke": !0 } };
          (bA.setAttributes = is()),
            (bA.insert = ns().bind(null, "head")),
            (bA.domAPI = ts()),
            (bA.insertStyleElement = ss());
          Jr()(kA.Z, bA);
          kA.Z && kA.Z.locals && kA.Z.locals;
          class wA extends j {
            static get pluginName() {
              return "HeadingUI";
            }
            init() {
              const t = this.editor,
                e = t.t,
                n = (function (t) {
                  const e = t.t,
                    n = {
                      Paragraph: e("Paragraph"),
                      "Heading 1": e("Heading 1"),
                      "Heading 2": e("Heading 2"),
                      "Heading 3": e("Heading 3"),
                      "Heading 4": e("Heading 4"),
                      "Heading 5": e("Heading 5"),
                      "Heading 6": e("Heading 6"),
                    };
                  return t.config.get("heading.options").map((t) => {
                    const e = n[t.title];
                    return e && e != t.title && (t.title = e), t;
                  });
                })(t),
                o = e("Choose heading"),
                i = e("Heading");
              t.ui.componentFactory.add("heading", (e) => {
                const r = {},
                  s = new po(),
                  a = t.commands.get("heading"),
                  l = t.commands.get("paragraph"),
                  c = [a];
                for (const t of n) {
                  const e = {
                    type: "button",
                    model: new fg({
                      label: t.title,
                      class: t.class,
                      withText: !0,
                    }),
                  };
                  "paragraph" === t.model
                    ? (e.model.bind("isOn").to(l, "value"),
                      e.model.set("commandName", "paragraph"),
                      c.push(l))
                    : (e.model
                        .bind("isOn")
                        .to(a, "value", (e) => e === t.model),
                      e.model.set({
                        commandName: "heading",
                        commandValue: t.model,
                      })),
                    s.add(e),
                    (r[t.model] = t.title);
                }
                const d = Wm(e);
                return (
                  qm(d, s),
                  d.buttonView.set({ isOn: !1, withText: !0, tooltip: i }),
                  d.extendTemplate({
                    attributes: { class: ["ck-heading-dropdown"] },
                  }),
                  d
                    .bind("isEnabled")
                    .toMany(c, "isEnabled", (...t) => t.some((t) => t)),
                  d.buttonView
                    .bind("label")
                    .to(a, "value", l, "value", (t, e) => {
                      const n = t || (e && "paragraph");
                      return r[n] ? r[n] : o;
                    }),
                  this.listenTo(d, "execute", (e) => {
                    t.execute(
                      e.source.commandName,
                      e.source.commandValue
                        ? { value: e.source.commandValue }
                        : void 0
                    ),
                      t.editing.view.focus();
                  }),
                  d
                );
              });
            }
          }
          class AA extends F {
            refresh() {
              const t = this.editor.model,
                e = t.schema,
                n = t.document.selection;
              this.isEnabled = (function (t, e, n) {
                const o = (function (t, e) {
                  const n = tf(t, e).start.parent;
                  if (n.isEmpty && !n.is("element", "$root")) return n.parent;
                  return n;
                })(t, n);
                return e.checkChild(o, "horizontalLine");
              })(n, e, t);
            }
            execute() {
              const t = this.editor.model;
              t.change((e) => {
                const n = e.createElement("horizontalLine");
                t.insertObject(n, null, null, { setSelection: "after" });
              });
            }
          }
          var _A = n(2536),
            CA = { attributes: { "data-cke": !0 } };
          (CA.setAttributes = is()),
            (CA.insert = ns().bind(null, "head")),
            (CA.domAPI = ts()),
            (CA.insertStyleElement = ss());
          Jr()(_A.Z, CA);
          _A.Z && _A.Z.locals && _A.Z.locals;
          class vA extends j {
            static get pluginName() {
              return "HorizontalLineEditing";
            }
            init() {
              const t = this.editor,
                e = t.model.schema,
                n = t.t,
                o = t.conversion;
              e.register("horizontalLine", { inheritAllFrom: "$blockObject" }),
                o
                  .for("dataDowncast")
                  .elementToElement({
                    model: "horizontalLine",
                    view: (t, { writer: e }) => e.createEmptyElement("hr"),
                  }),
                o.for("editingDowncast").elementToStructure({
                  model: "horizontalLine",
                  view: (t, { writer: e }) => {
                    const o = n("Horizontal line"),
                      i = e.createContainerElement(
                        "div",
                        null,
                        e.createEmptyElement("hr")
                      );
                    return (
                      e.addClass("ck-horizontal-line", i),
                      e.setCustomProperty("hr", !0, i),
                      (function (t, e, n) {
                        return (
                          e.setCustomProperty("horizontalLine", !0, t),
                          Zp(t, e, { label: n })
                        );
                      })(i, e, o)
                    );
                  },
                }),
                o
                  .for("upcast")
                  .elementToElement({ view: "hr", model: "horizontalLine" }),
                t.commands.add("horizontalLine", new AA(t));
            }
          }
          class yA extends j {
            static get pluginName() {
              return "HorizontalLineUI";
            }
            init() {
              const t = this.editor,
                e = t.t;
              t.ui.componentFactory.add("horizontalLine", (n) => {
                const o = t.commands.get("horizontalLine"),
                  i = new nm(n);
                return (
                  i.set({
                    label: e("Horizontal line"),
                    icon: '<svg viewBox="0 0 20 20" xmlns="http://www.w3.org/2000/svg"><path d="M2 9h16v2H2z"/></svg>',
                    tooltip: !0,
                  }),
                  i.bind("isEnabled").to(o, "isEnabled"),
                  this.listenTo(i, "execute", () => {
                    t.execute("horizontalLine"), t.editing.view.focus();
                  }),
                  i
                );
              });
            }
          }
          class xA extends F {
            refresh() {
              const t = this.editor.model,
                e = t.schema,
                n = t.document.selection,
                o = EA(n);
              (this.isEnabled = (function (t, e, n) {
                const o = (function (t, e) {
                  const n = tf(t, e).start.parent;
                  if (n.isEmpty && !n.is("element", "$root")) return n.parent;
                  return n;
                })(t, n);
                return e.checkChild(o, "rawHtml");
              })(n, e, t)),
                (this.value = o ? o.getAttribute("value") || "" : null);
            }
            execute(t) {
              const e = this.editor.model,
                n = e.document.selection;
              e.change((o) => {
                let i;
                null !== this.value
                  ? (i = EA(n))
                  : ((i = o.createElement("rawHtml")),
                    e.insertObject(i, null, null, { setSelection: "on" })),
                  o.setAttribute("value", t, i);
              });
            }
          }
          function EA(t) {
            const e = t.getSelectedElement();
            return e && e.is("element", "rawHtml") ? e : null;
          }
          var DA = n(3403),
            SA = { attributes: { "data-cke": !0 } };
          (SA.setAttributes = is()),
            (SA.insert = ns().bind(null, "head")),
            (SA.domAPI = ts()),
            (SA.insertStyleElement = ss());
          Jr()(DA.Z, SA);
          DA.Z && DA.Z.locals && DA.Z.locals;
          class IA extends j {
            static get pluginName() {
              return "HtmlEmbedEditing";
            }
            constructor(t) {
              super(t),
                t.config.define("htmlEmbed", {
                  showPreviews: !1,
                  sanitizeHtml: (t) => (
                    c("html-embed-provide-sanitize-function"),
                    { html: t, hasChanged: !1 }
                  ),
                }),
                (this._widgetButtonViewReferences = new Set());
            }
            init() {
              const t = this.editor;
              t.model.schema.register("rawHtml", {
                inheritAllFrom: "$blockObject",
                allowAttributes: ["value"],
              }),
                t.commands.add("htmlEmbed", new xA(t)),
                this._setupConversion();
            }
            _setupConversion() {
              const t = this.editor,
                e = t.t,
                n = t.editing.view,
                o = this._widgetButtonViewReferences,
                i = t.config.get("htmlEmbed");
              function r({ domElement: t, editor: n, state: i, props: r }) {
                t.textContent = "";
                const a = t.ownerDocument;
                let l;
                if (i.isEditable) {
                  const e = {
                    isDisabled: !1,
                    placeholder: r.textareaPlaceholder,
                  };
                  (l = s({ domDocument: a, state: i, props: e })), t.append(l);
                } else if (i.showPreviews) {
                  const o = { sanitizeHtml: r.sanitizeHtml };
                  t.append(
                    (function ({
                      domDocument: t,
                      state: n,
                      props: o,
                      editor: i,
                    }) {
                      const r = o.sanitizeHtml(n.getRawHtmlValue()),
                        s =
                          n.getRawHtmlValue().length > 0
                            ? e("No preview available")
                            : e("Empty snippet content"),
                        a = Da(
                          t,
                          "div",
                          {
                            class:
                              "ck ck-reset_all raw-html-embed__preview-placeholder",
                          },
                          s
                        ),
                        l = Da(t, "div", {
                          class: "raw-html-embed__preview-content",
                          dir: i.locale.contentLanguageDirection,
                        }),
                        c = t.createRange().createContextualFragment(r.html);
                      l.appendChild(c);
                      return Da(
                        t,
                        "div",
                        { class: "raw-html-embed__preview" },
                        [a, l]
                      );
                    })({ domDocument: a, state: i, props: o, editor: n })
                  );
                } else {
                  const e = {
                    isDisabled: !0,
                    placeholder: r.textareaPlaceholder,
                  };
                  t.append(s({ domDocument: a, state: i, props: e }));
                }
                const c = {
                  onEditClick: r.onEditClick,
                  onSaveClick: () => {
                    r.onSaveClick(l.value);
                  },
                  onCancelClick: r.onCancelClick,
                };
                t.prepend(
                  (function ({
                    editor: t,
                    domDocument: e,
                    state: n,
                    props: i,
                  }) {
                    const r = Da(e, "div", {
                      class: "raw-html-embed__buttons-wrapper",
                    });
                    if (n.isEditable) {
                      const e = TA(t, "save", i.onSaveClick),
                        n = TA(t, "cancel", i.onCancelClick);
                      r.append(e.element, n.element), o.add(e).add(n);
                    } else {
                      const e = TA(t, "edit", i.onEditClick);
                      r.append(e.element), o.add(e);
                    }
                    return r;
                  })({ editor: n, domDocument: a, state: i, props: c })
                );
              }
              function s({ domDocument: t, state: e, props: n }) {
                const o = Da(t, "textarea", {
                  placeholder: n.placeholder,
                  class:
                    "ck ck-reset ck-input ck-input-text raw-html-embed__source",
                });
                return (
                  (o.disabled = n.isDisabled),
                  (o.value = e.getRawHtmlValue()),
                  o
                );
              }
              this.editor.editing.view.on(
                "render",
                () => {
                  for (const t of o) {
                    if (t.element.isConnected) return;
                    t.destroy(), o.delete(t);
                  }
                },
                { priority: "lowest" }
              ),
                t.data.registerRawContentMatcher({
                  name: "div",
                  classes: "raw-html-embed",
                }),
                t.conversion
                  .for("upcast")
                  .elementToElement({
                    view: { name: "div", classes: "raw-html-embed" },
                    model: (t, { writer: e }) =>
                      e.createElement("rawHtml", {
                        value: t.getCustomProperty("$rawContent"),
                      }),
                  }),
                t.conversion.for("dataDowncast").elementToElement({
                  model: "rawHtml",
                  view: (t, { writer: e }) =>
                    e.createRawElement(
                      "div",
                      { class: "raw-html-embed" },
                      function (e) {
                        e.innerHTML = t.getAttribute("value") || "";
                      }
                    ),
                }),
                t.conversion.for("editingDowncast").elementToStructure({
                  model: { name: "rawHtml", attributes: ["value"] },
                  view: (o, { writer: s }) => {
                    let a, l, c;
                    const d = s.createRawElement(
                        "div",
                        { class: "raw-html-embed__content-wrapper" },
                        function (e) {
                          (a = e),
                            r({ domElement: e, editor: t, state: l, props: c }),
                            a.addEventListener(
                              "mousedown",
                              () => {
                                if (l.isEditable) {
                                  const e = t.model;
                                  e.document.selection.getSelectedElement() !==
                                    o &&
                                    e.change((t) => t.setSelection(o, "on"));
                                }
                              },
                              !0
                            );
                        }
                      ),
                      u = {
                        makeEditable() {
                          (l = Object.assign({}, l, { isEditable: !0 })),
                            r({ domElement: a, editor: t, state: l, props: c }),
                            n.change((t) => {
                              t.setAttribute(
                                "data-cke-ignore-events",
                                "true",
                                d
                              );
                            }),
                            a.querySelector("textarea").focus();
                        },
                        save(e) {
                          e !== l.getRawHtmlValue()
                            ? (t.execute("htmlEmbed", e),
                              t.editing.view.focus())
                            : this.cancel();
                        },
                        cancel() {
                          (l = Object.assign({}, l, { isEditable: !1 })),
                            r({ domElement: a, editor: t, state: l, props: c }),
                            t.editing.view.focus(),
                            n.change((t) => {
                              t.removeAttribute("data-cke-ignore-events", d);
                            });
                        },
                      };
                    (l = {
                      showPreviews: i.showPreviews,
                      isEditable: !1,
                      getRawHtmlValue: () => o.getAttribute("value") || "",
                    }),
                      (c = {
                        sanitizeHtml: i.sanitizeHtml,
                        textareaPlaceholder: e("Paste raw HTML here..."),
                        onEditClick() {
                          u.makeEditable();
                        },
                        onSaveClick(t) {
                          u.save(t);
                        },
                        onCancelClick() {
                          u.cancel();
                        },
                      });
                    const h = s.createContainerElement(
                      "div",
                      {
                        class: "raw-html-embed",
                        "data-html-embed-label": e("HTML snippet"),
                        dir: t.locale.uiLanguageDirection,
                      },
                      d
                    );
                    return (
                      s.setCustomProperty("rawHtmlApi", u, h),
                      s.setCustomProperty("rawHtml", !0, h),
                      Zp(h, s, {
                        widgetLabel: e("HTML snippet"),
                        hasSelectionHandle: !0,
                      })
                    );
                  },
                });
            }
          }
          function TA(t, e, n) {
            const o = t.locale.t,
              i = new nm(t.locale),
              r = t.commands.get("htmlEmbed");
            return (
              i.set({
                class: `raw-html-embed__${e}-button`,
                icon: $h.pencil,
                tooltip: !0,
                tooltipPosition:
                  "rtl" === t.locale.uiLanguageDirection ? "e" : "w",
              }),
              i.render(),
              "edit" === e
                ? (i.set({ icon: $h.pencil, label: o("Edit source") }),
                  i.bind("isEnabled").to(r))
                : "save" === e
                ? (i.set({ icon: $h.check, label: o("Save changes") }),
                  i.bind("isEnabled").to(r))
                : i.set({ icon: $h.cancel, label: o("Cancel") }),
              i.on("execute", n),
              i
            );
          }
          class MA extends j {
            static get pluginName() {
              return "HtmlEmbedUI";
            }
            init() {
              const t = this.editor,
                e = t.t;
              t.ui.componentFactory.add("htmlEmbed", (n) => {
                const o = t.commands.get("htmlEmbed"),
                  i = new nm(n);
                return (
                  i.set({
                    label: e("Insert HTML"),
                    icon: '<svg viewBox="0 0 20 20" xmlns="http://www.w3.org/2000/svg"><path d="M17 0a2 2 0 0 1 2 2v7a1 1 0 0 1 1 1v5a1 1 0 0 1-.883.993l-.118.006L19 17a2 2 0 0 1-2 2H3a2 2 0 0 1-2-2l-.001-1.001-.116-.006A1 1 0 0 1 0 15v-5a1 1 0 0 1 .999-1L1 2a2 2 0 0 1 2-2h14zm.499 15.999h-15L2.5 17a.5.5 0 0 0 .5.5h14a.5.5 0 0 0 .5-.5l-.001-1.001zm-3.478-6.013-.014.014H14v.007l-1.525 1.525-1.46-1.46-.015.013V10h-1v5h1v-3.53l1.428 1.43.048.043.131-.129L14 11.421V15h1v-5h-.965l-.014-.014zM2 10H1v5h1v-2h2v2h1v-5H4v2H2v-2zm7 0H6v1h1v4h1v-4h1v-1zm8 0h-1v5h3v-1h-2v-4zm0-8.5H3a.5.5 0 0 0-.5.5l-.001 6.999h15L17.5 2a.5.5 0 0 0-.5-.5zM10 7v1H4V7h6zm3-2v1H4V5h9zm-3-2v1H4V3h6z"/></svg>',
                    tooltip: !0,
                  }),
                  i.bind("isEnabled").to(o, "isEnabled"),
                  this.listenTo(i, "execute", () => {
                    t.execute("htmlEmbed"), t.editing.view.focus();
                    t.editing.view.document.selection
                      .getSelectedElement()
                      .getCustomProperty("rawHtmlApi")
                      .makeEditable();
                  }),
                  i
                );
              });
            }
          }
          class BA extends F {
            refresh() {
              const t = this.editor.plugins
                .get("ImageUtils")
                .getClosestSelectedImageElement(
                  this.editor.model.document.selection
                );
              (this.isEnabled = !!t),
                this.isEnabled && t.hasAttribute("alt")
                  ? (this.value = t.getAttribute("alt"))
                  : (this.value = !1);
            }
            execute(t) {
              const e = this.editor,
                n = e.plugins.get("ImageUtils"),
                o = e.model,
                i = n.getClosestSelectedImageElement(o.document.selection);
              o.change((e) => {
                e.setAttribute("alt", t.newValue, i);
              });
            }
          }
          class NA extends j {
            static get requires() {
              return [Jf];
            }
            static get pluginName() {
              return "ImageTextAlternativeEditing";
            }
            init() {
              this.editor.commands.add(
                "imageTextAlternative",
                new BA(this.editor)
              );
            }
          }
          var zA = n(6831),
            PA = { attributes: { "data-cke": !0 } };
          (PA.setAttributes = is()),
            (PA.insert = ns().bind(null, "head")),
            (PA.domAPI = ts()),
            (PA.insertStyleElement = ss());
          Jr()(zA.Z, PA);
          zA.Z && zA.Z.locals && zA.Z.locals;
          class LA extends Ch {
            constructor(t) {
              super(t);
              const e = this.locale.t;
              (this.focusTracker = new Oa()),
                (this.keystrokes = new ja()),
                (this.labeledInput = this._createLabeledInputView()),
                (this.saveButtonView = this._createButton(
                  e("Save"),
                  $h.check,
                  "ck-button-save"
                )),
                (this.saveButtonView.type = "submit"),
                (this.cancelButtonView = this._createButton(
                  e("Cancel"),
                  $h.cancel,
                  "ck-button-cancel",
                  "cancel"
                )),
                (this._focusables = new Ju()),
                (this._focusCycler = new Cm({
                  focusables: this._focusables,
                  focusTracker: this.focusTracker,
                  keystrokeHandler: this.keystrokes,
                  actions: { focusPrevious: "shift + tab", focusNext: "tab" },
                })),
                this.setTemplate({
                  tag: "form",
                  attributes: {
                    class: [
                      "ck",
                      "ck-text-alternative-form",
                      "ck-responsive-form",
                    ],
                    tabindex: "-1",
                  },
                  children: [
                    this.labeledInput,
                    this.saveButtonView,
                    this.cancelButtonView,
                  ],
                }),
                Gh(this);
            }
            render() {
              super.render(),
                this.keystrokes.listenTo(this.element),
                Zh({ view: this }),
                [
                  this.labeledInput,
                  this.saveButtonView,
                  this.cancelButtonView,
                ].forEach((t) => {
                  this._focusables.add(t), this.focusTracker.add(t.element);
                });
            }
            destroy() {
              super.destroy(),
                this.focusTracker.destroy(),
                this.keystrokes.destroy();
            }
            _createButton(t, e, n, o) {
              const i = new nm(this.locale);
              return (
                i.set({ label: t, icon: e, tooltip: !0 }),
                i.extendTemplate({ attributes: { class: n } }),
                o && i.delegate("execute").to(this, o),
                i
              );
            }
            _createLabeledInputView() {
              const t = this.locale.t,
                e = new hg(this.locale, mg);
              return (e.label = t("Text alternative")), e;
            }
          }
          function RA(t) {
            const e = t.editing.view,
              n = Mh.defaultPositions,
              o = t.plugins.get("ImageUtils");
            return {
              target: e.domConverter.mapViewToDom(
                o.getClosestSelectedImageWidget(e.document.selection)
              ),
              positions: [
                n.northArrowSouth,
                n.northArrowSouthWest,
                n.northArrowSouthEast,
                n.southArrowNorth,
                n.southArrowNorthWest,
                n.southArrowNorthEast,
                n.viewportStickyNorth,
              ],
            };
          }
          class OA extends j {
            static get requires() {
              return [vg];
            }
            static get pluginName() {
              return "ImageTextAlternativeUI";
            }
            init() {
              this._createButton(), this._createForm();
            }
            destroy() {
              super.destroy(), this._form.destroy();
            }
            _createButton() {
              const t = this.editor,
                e = t.t;
              t.ui.componentFactory.add("imageTextAlternative", (n) => {
                const o = t.commands.get("imageTextAlternative"),
                  i = new nm(n);
                return (
                  i.set({
                    label: e("Change image text alternative"),
                    icon: $h.lowVision,
                    tooltip: !0,
                  }),
                  i.bind("isEnabled").to(o, "isEnabled"),
                  i.bind("isOn").to(o, "value", (t) => !!t),
                  this.listenTo(i, "execute", () => {
                    this._showForm();
                  }),
                  i
                );
              });
            }
            _createForm() {
              const t = this.editor,
                e = t.editing.view.document,
                n = t.plugins.get("ImageUtils");
              (this._balloon = this.editor.plugins.get("ContextualBalloon")),
                (this._form = new LA(t.locale)),
                this._form.render(),
                this.listenTo(this._form, "submit", () => {
                  t.execute("imageTextAlternative", {
                    newValue: this._form.labeledInput.fieldView.element.value,
                  }),
                    this._hideForm(!0);
                }),
                this.listenTo(this._form, "cancel", () => {
                  this._hideForm(!0);
                }),
                this._form.keystrokes.set("Esc", (t, e) => {
                  this._hideForm(!0), e();
                }),
                this.listenTo(t.ui, "update", () => {
                  n.getClosestSelectedImageWidget(e.selection)
                    ? this._isVisible &&
                      (function (t) {
                        const e = t.plugins.get("ContextualBalloon");
                        if (
                          t.plugins
                            .get("ImageUtils")
                            .getClosestSelectedImageWidget(
                              t.editing.view.document.selection
                            )
                        ) {
                          const n = RA(t);
                          e.updatePosition(n);
                        }
                      })(t)
                    : this._hideForm(!0);
                }),
                qh({
                  emitter: this._form,
                  activator: () => this._isVisible,
                  contextElements: [this._balloon.view.element],
                  callback: () => this._hideForm(),
                });
            }
            _showForm() {
              if (this._isVisible) return;
              const t = this.editor,
                e = t.commands.get("imageTextAlternative"),
                n = this._form.labeledInput;
              this._form.disableCssTransitions(),
                this._isInBalloon ||
                  this._balloon.add({ view: this._form, position: RA(t) }),
                (n.fieldView.value = n.fieldView.element.value = e.value || ""),
                this._form.labeledInput.fieldView.select(),
                this._form.enableCssTransitions();
            }
            _hideForm(t) {
              this._isInBalloon &&
                (this._form.focusTracker.isFocused &&
                  this._form.saveButtonView.focus(),
                this._balloon.remove(this._form),
                t && this.editor.editing.view.focus());
            }
            get _isVisible() {
              return this._balloon.visibleView === this._form;
            }
            get _isInBalloon() {
              return this._balloon.hasView(this._form);
            }
          }
          class jA extends j {
            static get requires() {
              return [NA, OA];
            }
            static get pluginName() {
              return "ImageTextAlternative";
            }
          }
          function VA(t, e) {
            return (t) => {
              t.on(`attribute:srcset:${e}`, n);
            };
            function n(e, n, o) {
              if (!o.consumable.consume(n.item, e.name)) return;
              const i = o.writer,
                r = o.mapper.toViewElement(n.item),
                s = t.findViewImgElement(r);
              if (null === n.attributeNewValue) {
                const t = n.attributeOldValue;
                t.data &&
                  (i.removeAttribute("srcset", s),
                  i.removeAttribute("sizes", s),
                  t.width && i.removeAttribute("width", s));
              } else {
                const t = n.attributeNewValue;
                t.data &&
                  (i.setAttribute("srcset", t.data, s),
                  i.setAttribute("sizes", "100vw", s),
                  t.width && i.setAttribute("width", t.width, s));
              }
            }
          }
          function FA(t, e, n) {
            return (t) => {
              t.on(`attribute:${n}:${e}`, o);
            };
            function o(e, n, o) {
              if (!o.consumable.consume(n.item, e.name)) return;
              const i = o.writer,
                r = o.mapper.toViewElement(n.item),
                s = t.findViewImgElement(r);
              i.setAttribute(n.attributeKey, n.attributeNewValue || "", s);
            }
          }
          class HA extends Ms {
            observe(t) {
              this.listenTo(
                t,
                "load",
                (t, e) => {
                  const n = e.target;
                  this.checkShouldIgnoreEventFromTarget(n) ||
                    ("IMG" == n.tagName && this._fireEvents(e));
                },
                { useCapture: !0 }
              );
            }
            _fireEvents(t) {
              this.isEnabled &&
                (this.document.fire("layoutChanged"),
                this.document.fire("imageLoaded", t));
            }
          }
          class UA extends F {
            constructor(t) {
              super(t);
              const e = t.config.get("image.insert.type");
              t.plugins.has("ImageBlockEditing") ||
                ("block" === e && c("image-block-plugin-required")),
                t.plugins.has("ImageInlineEditing") ||
                  ("inline" === e && c("image-inline-plugin-required"));
            }
            refresh() {
              this.isEnabled = this.editor.plugins
                .get("ImageUtils")
                .isImageAllowed();
            }
            execute(t) {
              const e = ko(t.source),
                n = this.editor.model.document.selection,
                o = this.editor.plugins.get("ImageUtils"),
                i = Object.fromEntries(n.getAttributes());
              e.forEach((t, e) => {
                const r = n.getSelectedElement();
                if (
                  ("string" == typeof t && (t = { src: t }),
                  e && r && o.isImage(r))
                ) {
                  const e = this.editor.model.createPositionAfter(r);
                  o.insertImage({ ...t, ...i }, e);
                } else o.insertImage({ ...t, ...i });
              });
            }
          }
          class WA extends j {
            static get requires() {
              return [Jf];
            }
            static get pluginName() {
              return "ImageEditing";
            }
            init() {
              const t = this.editor,
                e = t.conversion;
              t.editing.view.addObserver(HA),
                e
                  .for("upcast")
                  .attributeToAttribute({
                    view: { name: "img", key: "alt" },
                    model: "alt",
                  })
                  .attributeToAttribute({
                    view: { name: "img", key: "srcset" },
                    model: {
                      key: "srcset",
                      value: (t) => {
                        const e = { data: t.getAttribute("srcset") };
                        return (
                          t.hasAttribute("width") &&
                            (e.width = t.getAttribute("width")),
                          e
                        );
                      },
                    },
                  });
              const n = new UA(t);
              t.commands.add("insertImage", n),
                t.commands.add("imageInsert", n);
            }
          }
          class $A extends F {
            constructor(t, e) {
              super(t), (this._modelElementName = e);
            }
            refresh() {
              const t = this.editor.plugins.get("ImageUtils"),
                e = t.getClosestSelectedImageElement(
                  this.editor.model.document.selection
                );
              "imageBlock" === this._modelElementName
                ? (this.isEnabled = t.isInlineImage(e))
                : (this.isEnabled = t.isBlockImage(e));
            }
            execute() {
              const t = this.editor,
                e = this.editor.model,
                n = t.plugins.get("ImageUtils"),
                o = n.getClosestSelectedImageElement(e.document.selection),
                i = Object.fromEntries(o.getAttributes());
              return i.src || i.uploadId
                ? e.change((t) => {
                    const r = Array.from(e.markers).filter((t) =>
                        t.getRange().containsItem(o)
                      ),
                      s = n.insertImage(
                        i,
                        e.createSelection(o, "on"),
                        this._modelElementName
                      );
                    if (!s) return null;
                    const a = t.createRangeOn(s);
                    for (const e of r) {
                      const n = e.getRange(),
                        o =
                          "$graveyard" != n.root.rootName
                            ? n.getJoined(a, !0)
                            : a;
                      t.updateMarker(e, { range: o });
                    }
                    return { oldElement: o, newElement: s };
                  })
                : null;
            }
          }
          class qA extends j {
            static get requires() {
              return [WA, Jf, zp];
            }
            static get pluginName() {
              return "ImageBlockEditing";
            }
            init() {
              const t = this.editor;
              t.model.schema.register("imageBlock", {
                inheritAllFrom: "$blockObject",
                allowAttributes: ["alt", "src", "srcset"],
              }),
                this._setupConversion(),
                t.plugins.has("ImageInlineEditing") &&
                  (t.commands.add(
                    "imageTypeBlock",
                    new $A(this.editor, "imageBlock")
                  ),
                  this._setupClipboardIntegration());
            }
            _setupConversion() {
              const t = this.editor,
                e = t.t,
                n = t.conversion,
                o = t.plugins.get("ImageUtils");
              n
                .for("dataDowncast")
                .elementToStructure({
                  model: "imageBlock",
                  view: (t, { writer: e }) => Yf(e),
                }),
                n
                  .for("editingDowncast")
                  .elementToStructure({
                    model: "imageBlock",
                    view: (t, { writer: n }) =>
                      o.toImageWidget(Yf(n), n, e("image widget")),
                  }),
                n
                  .for("downcast")
                  .add(FA(o, "imageBlock", "src"))
                  .add(FA(o, "imageBlock", "alt"))
                  .add(VA(o, "imageBlock")),
                n
                  .for("upcast")
                  .elementToElement({
                    view: Kf(t, "imageBlock"),
                    model: (t, { writer: e }) =>
                      e.createElement(
                        "imageBlock",
                        t.hasAttribute("src")
                          ? { src: t.getAttribute("src") }
                          : null
                      ),
                  })
                  .add(
                    (function (t) {
                      return (t) => {
                        t.on("element:figure", e);
                      };
                      function e(e, n, o) {
                        if (
                          !o.consumable.test(n.viewItem, {
                            name: !0,
                            classes: "image",
                          })
                        )
                          return;
                        const i = t.findViewImgElement(n.viewItem);
                        if (!i || !o.consumable.test(i, { name: !0 })) return;
                        o.consumable.consume(n.viewItem, {
                          name: !0,
                          classes: "image",
                        });
                        const r = Ra(
                          o.convertItem(i, n.modelCursor).modelRange.getItems()
                        );
                        r
                          ? (o.convertChildren(n.viewItem, r),
                            o.updateConversionResult(r, n))
                          : o.consumable.revert(n.viewItem, {
                              name: !0,
                              classes: "image",
                            });
                      }
                    })(o)
                  );
            }
            _setupClipboardIntegration() {
              const t = this.editor,
                e = t.model,
                n = t.editing.view,
                o = t.plugins.get("ImageUtils");
              this.listenTo(
                t.plugins.get("ClipboardPipeline"),
                "inputTransformation",
                (i, r) => {
                  const s = Array.from(r.content.getChildren());
                  let a;
                  if (!s.every(o.isInlineImageView)) return;
                  a = r.targetRanges
                    ? t.editing.mapper.toModelRange(r.targetRanges[0])
                    : e.document.selection.getFirstRange();
                  const l = e.createSelection(a);
                  if ("imageBlock" === Qf(e.schema, l)) {
                    const t = new eu(n.document),
                      e = s.map((e) =>
                        t.createElement("figure", { class: "image" }, e)
                      );
                    r.content = t.createDocumentFragment(e);
                  }
                }
              );
            }
          }
          var GA = n(9048),
            ZA = { attributes: { "data-cke": !0 } };
          (ZA.setAttributes = is()),
            (ZA.insert = ns().bind(null, "head")),
            (ZA.domAPI = ts()),
            (ZA.insertStyleElement = ss());
          Jr()(GA.Z, ZA);
          GA.Z && GA.Z.locals && GA.Z.locals;
          class YA extends j {
            static get requires() {
              return [qA, kf, jA];
            }
            static get pluginName() {
              return "ImageBlock";
            }
          }
          class KA extends j {
            static get requires() {
              return [WA, Jf, zp];
            }
            static get pluginName() {
              return "ImageInlineEditing";
            }
            init() {
              const t = this.editor,
                e = t.model.schema;
              e.register("imageInline", {
                inheritAllFrom: "$inlineObject",
                allowAttributes: ["alt", "src", "srcset"],
              }),
                e.addChildCheck((t, e) => {
                  if (t.endsWith("caption") && "imageInline" === e.name)
                    return !1;
                }),
                this._setupConversion(),
                t.plugins.has("ImageBlockEditing") &&
                  (t.commands.add(
                    "imageTypeInline",
                    new $A(this.editor, "imageInline")
                  ),
                  this._setupClipboardIntegration());
            }
            _setupConversion() {
              const t = this.editor,
                e = t.t,
                n = t.conversion,
                o = t.plugins.get("ImageUtils");
              n
                .for("dataDowncast")
                .elementToElement({
                  model: "imageInline",
                  view: (t, { writer: e }) => e.createEmptyElement("img"),
                }),
                n.for("editingDowncast").elementToStructure({
                  model: "imageInline",
                  view: (t, { writer: n }) =>
                    o.toImageWidget(
                      (function (t) {
                        return t.createContainerElement(
                          "span",
                          { class: "image-inline" },
                          t.createEmptyElement("img")
                        );
                      })(n),
                      n,
                      e("image widget")
                    ),
                }),
                n
                  .for("downcast")
                  .add(FA(o, "imageInline", "src"))
                  .add(FA(o, "imageInline", "alt"))
                  .add(VA(o, "imageInline")),
                n
                  .for("upcast")
                  .elementToElement({
                    view: Kf(t, "imageInline"),
                    model: (t, { writer: e }) =>
                      e.createElement(
                        "imageInline",
                        t.hasAttribute("src")
                          ? { src: t.getAttribute("src") }
                          : null
                      ),
                  });
            }
            _setupClipboardIntegration() {
              const t = this.editor,
                e = t.model,
                n = t.editing.view,
                o = t.plugins.get("ImageUtils");
              this.listenTo(
                t.plugins.get("ClipboardPipeline"),
                "inputTransformation",
                (i, r) => {
                  const s = Array.from(r.content.getChildren());
                  let a;
                  if (!s.every(o.isBlockImageView)) return;
                  a = r.targetRanges
                    ? t.editing.mapper.toModelRange(r.targetRanges[0])
                    : e.document.selection.getFirstRange();
                  const l = e.createSelection(a);
                  if ("imageInline" === Qf(e.schema, l)) {
                    const t = new eu(n.document),
                      e = s.map((e) =>
                        1 === e.childCount
                          ? (Array.from(e.getAttributes()).forEach((n) =>
                              t.setAttribute(...n, o.findViewImgElement(e))
                            ),
                            e.getChild(0))
                          : e
                      );
                    r.content = t.createDocumentFragment(e);
                  }
                }
              );
            }
          }
          class QA extends j {
            static get requires() {
              return [KA, kf, jA];
            }
            static get pluginName() {
              return "ImageInline";
            }
          }
          class JA extends F {
            refresh() {
              const t = this.editor,
                e = t.plugins.get("ImageCaptionUtils");
              if (!t.plugins.has(qA))
                return (this.isEnabled = !1), void (this.value = !1);
              const n = t.model.document.selection,
                o = n.getSelectedElement();
              if (!o) {
                const t = e.getCaptionFromModelSelection(n);
                return (this.isEnabled = !!t), void (this.value = !!t);
              }
              (this.isEnabled = this.editor.plugins
                .get("ImageUtils")
                .isImage(o)),
                this.isEnabled
                  ? (this.value = !!e.getCaptionFromImageModelElement(o))
                  : (this.value = !1);
            }
            execute(t = {}) {
              const { focusCaptionOnShow: e } = t;
              this.editor.model.change((t) => {
                this.value
                  ? this._hideImageCaption(t)
                  : this._showImageCaption(t, e);
              });
            }
            _showImageCaption(t, e) {
              const n = this.editor.model.document.selection,
                o = this.editor.plugins.get("ImageCaptionEditing");
              let i = n.getSelectedElement();
              const r = o._getSavedCaption(i);
              this.editor.plugins.get("ImageUtils").isInlineImage(i) &&
                (this.editor.execute("imageTypeBlock"),
                (i = n.getSelectedElement()));
              const s = r || t.createElement("caption");
              t.append(s, i), e && t.setSelection(s, "in");
            }
            _hideImageCaption(t) {
              const e = this.editor,
                n = e.model.document.selection,
                o = e.plugins.get("ImageCaptionEditing"),
                i = e.plugins.get("ImageCaptionUtils");
              let r,
                s = n.getSelectedElement();
              s
                ? (r = i.getCaptionFromImageModelElement(s))
                : ((r = i.getCaptionFromModelSelection(n)), (s = r.parent)),
                o._saveCaption(s, r),
                t.setSelection(s, "on"),
                t.remove(r);
            }
          }
          class XA extends j {
            static get pluginName() {
              return "ImageCaptionUtils";
            }
            static get requires() {
              return [Jf];
            }
            getCaptionFromImageModelElement(t) {
              for (const e of t.getChildren())
                if (e && e.is("element", "caption")) return e;
              return null;
            }
            getCaptionFromModelSelection(t) {
              const e = this.editor.plugins.get("ImageUtils"),
                n = t.getFirstPosition().findAncestor("caption");
              return n && e.isBlockImage(n.parent) ? n : null;
            }
            matchImageCaptionViewElement(t) {
              const e = this.editor.plugins.get("ImageUtils");
              return "figcaption" == t.name && e.isBlockImageView(t.parent)
                ? { name: !0 }
                : null;
            }
          }
          class t_ extends j {
            static get requires() {
              return [Jf, XA];
            }
            static get pluginName() {
              return "ImageCaptionEditing";
            }
            constructor(t) {
              super(t), (this._savedCaptionsMap = new WeakMap());
            }
            init() {
              const t = this.editor,
                e = t.model.schema;
              e.isRegistered("caption")
                ? e.extend("caption", { allowIn: "imageBlock" })
                : e.register("caption", {
                    allowIn: "imageBlock",
                    allowContentOf: "$block",
                    isLimit: !0,
                  }),
                t.commands.add("toggleImageCaption", new JA(this.editor)),
                this._setupConversion(),
                this._setupImageTypeCommandsIntegration(),
                this._registerCaptionReconversion();
            }
            _setupConversion() {
              const t = this.editor,
                e = t.editing.view,
                n = t.plugins.get("ImageUtils"),
                o = t.plugins.get("ImageCaptionUtils"),
                i = t.t;
              t.conversion
                .for("upcast")
                .elementToElement({
                  view: (t) => o.matchImageCaptionViewElement(t),
                  model: "caption",
                }),
                t.conversion
                  .for("dataDowncast")
                  .elementToElement({
                    model: "caption",
                    view: (t, { writer: e }) =>
                      n.isBlockImage(t.parent)
                        ? e.createContainerElement("figcaption")
                        : null,
                  }),
                t.conversion.for("editingDowncast").elementToElement({
                  model: "caption",
                  view: (t, { writer: o }) => {
                    if (!n.isBlockImage(t.parent)) return null;
                    const r = o.createEditableElement("figcaption");
                    o.setCustomProperty("imageCaption", !0, r),
                      Rd({
                        view: e,
                        element: r,
                        text: i("Enter image caption"),
                        keepOnFocus: !0,
                      });
                    const s = t.parent.getAttribute("alt");
                    return Xp(r, o, {
                      label: s
                        ? i("Caption for image: %0", [s])
                        : i("Caption for the image"),
                    });
                  },
                });
            }
            _setupImageTypeCommandsIntegration() {
              const t = this.editor,
                e = t.plugins.get("ImageUtils"),
                n = t.plugins.get("ImageCaptionUtils"),
                o = t.commands.get("imageTypeInline"),
                i = t.commands.get("imageTypeBlock"),
                r = (t) => {
                  if (!t.return) return;
                  const { oldElement: o, newElement: i } = t.return;
                  if (!o) return;
                  if (e.isBlockImage(o)) {
                    const t = n.getCaptionFromImageModelElement(o);
                    if (t) return void this._saveCaption(i, t);
                  }
                  const r = this._getSavedCaption(o);
                  r && this._saveCaption(i, r);
                };
              o && this.listenTo(o, "execute", r, { priority: "low" }),
                i && this.listenTo(i, "execute", r, { priority: "low" });
            }
            _getSavedCaption(t) {
              const e = this._savedCaptionsMap.get(t);
              return e ? il.fromJSON(e) : null;
            }
            _saveCaption(t, e) {
              this._savedCaptionsMap.set(t, e.toJSON());
            }
            _registerCaptionReconversion() {
              const t = this.editor,
                e = t.model,
                n = t.plugins.get("ImageUtils"),
                o = t.plugins.get("ImageCaptionUtils");
              e.document.on("change:data", () => {
                const i = e.document.differ.getChanges();
                for (const e of i) {
                  if ("alt" !== e.attributeKey) continue;
                  const i = e.range.start.nodeAfter;
                  if (n.isBlockImage(i)) {
                    const e = o.getCaptionFromImageModelElement(i);
                    if (!e) return;
                    t.editing.reconvertItem(e);
                  }
                }
              });
            }
          }
          class e_ extends j {
            static get requires() {
              return [XA];
            }
            static get pluginName() {
              return "ImageCaptionUI";
            }
            init() {
              const t = this.editor,
                e = t.editing.view,
                n = t.plugins.get("ImageCaptionUtils"),
                o = t.t;
              t.ui.componentFactory.add("toggleImageCaption", (i) => {
                const r = t.commands.get("toggleImageCaption"),
                  s = new nm(i);
                return (
                  s.set({ icon: $h.caption, tooltip: !0, isToggleable: !0 }),
                  s.bind("isOn", "isEnabled").to(r, "value", "isEnabled"),
                  s
                    .bind("label")
                    .to(r, "value", (t) =>
                      o(t ? "Toggle caption off" : "Toggle caption on")
                    ),
                  this.listenTo(s, "execute", () => {
                    t.execute("toggleImageCaption", { focusCaptionOnShow: !0 });
                    const o = n.getCaptionFromModelSelection(
                      t.model.document.selection
                    );
                    if (o) {
                      const n = t.editing.mapper.toViewElement(o);
                      e.scrollToTheSelection(),
                        e.change((t) => {
                          t.addClass("image__caption_highlighted", n);
                        });
                    }
                    t.editing.view.focus();
                  }),
                  s
                );
              });
            }
          }
          var n_ = n(8662),
            o_ = { attributes: { "data-cke": !0 } };
          (o_.setAttributes = is()),
            (o_.insert = ns().bind(null, "head")),
            (o_.domAPI = ts()),
            (o_.insertStyleElement = ss());
          Jr()(n_.Z, o_);
          n_.Z && n_.Z.locals && n_.Z.locals;
          var i_ = n(5150),
            r_ = { attributes: { "data-cke": !0 } };
          (r_.setAttributes = is()),
            (r_.insert = ns().bind(null, "head")),
            (r_.domAPI = ts()),
            (r_.insertStyleElement = ss());
          Jr()(i_.Z, r_);
          i_.Z && i_.Z.locals && i_.Z.locals;
          class s_ extends Ch {
            constructor(t, e = {}) {
              super(t);
              const n = this.bindTemplate;
              this.set("class", e.class || null),
                (this.children = this.createCollection()),
                e.children && e.children.forEach((t) => this.children.add(t)),
                this.set("_role", null),
                this.set("_ariaLabelledBy", null),
                e.labelView &&
                  this.set({ _role: "group", _ariaLabelledBy: e.labelView.id }),
                this.setTemplate({
                  tag: "div",
                  attributes: {
                    class: ["ck", "ck-form__row", n.to("class")],
                    role: n.to("_role"),
                    "aria-labelledby": n.to("_ariaLabelledBy"),
                  },
                  children: this.children,
                });
            }
          }
          var a_ = n(9292),
            l_ = { attributes: { "data-cke": !0 } };
          (l_.setAttributes = is()),
            (l_.insert = ns().bind(null, "head")),
            (l_.domAPI = ts()),
            (l_.insertStyleElement = ss());
          Jr()(a_.Z, l_);
          a_.Z && a_.Z.locals && a_.Z.locals;
          class c_ extends Ch {
            constructor(t, e) {
              super(t);
              const { insertButtonView: n, cancelButtonView: o } =
                this._createActionButtons(t);
              if (
                ((this.insertButtonView = n),
                (this.cancelButtonView = o),
                this.set("imageURLInputValue", ""),
                (this.focusTracker = new Oa()),
                (this.keystrokes = new ja()),
                (this._focusables = new Ju()),
                (this._focusCycler = new Cm({
                  focusables: this._focusables,
                  focusTracker: this.focusTracker,
                  keystrokeHandler: this.keystrokes,
                  actions: { focusPrevious: "shift + tab", focusNext: "tab" },
                })),
                this.set("_integrations", new po()),
                e)
              )
                for (const [t, n] of Object.entries(e))
                  "insertImageViaUrl" === t &&
                    (n.fieldView
                      .bind("value")
                      .to(this, "imageURLInputValue", (t) => t || ""),
                    n.fieldView.on("input", () => {
                      this.imageURLInputValue =
                        n.fieldView.element.value.trim();
                    })),
                    (n.name = t),
                    this._integrations.add(n);
              this.setTemplate({
                tag: "form",
                attributes: {
                  class: ["ck", "ck-image-insert-form"],
                  tabindex: "-1",
                },
                children: [
                  ...this._integrations,
                  new s_(t, {
                    children: [this.insertButtonView, this.cancelButtonView],
                    class: "ck-image-insert-form__action-row",
                  }),
                ],
              });
            }
            render() {
              super.render(), Zh({ view: this });
              const t = [
                ...this._integrations,
                this.insertButtonView,
                this.cancelButtonView,
              ];
              t.forEach((t) => {
                this._focusables.add(t), this.focusTracker.add(t.element);
              }),
                this.keystrokes.listenTo(this.element);
              const e = (t) => t.stopPropagation();
              this.keystrokes.set("arrowright", e),
                this.keystrokes.set("arrowleft", e),
                this.keystrokes.set("arrowup", e),
                this.keystrokes.set("arrowdown", e),
                this.listenTo(
                  t[0].element,
                  "selectstart",
                  (t, e) => {
                    e.stopPropagation();
                  },
                  { priority: "high" }
                );
            }
            destroy() {
              super.destroy(),
                this.focusTracker.destroy(),
                this.keystrokes.destroy();
            }
            getIntegration(t) {
              return this._integrations.find((e) => e.name === t);
            }
            _createActionButtons(t) {
              const e = t.t,
                n = new nm(t),
                o = new nm(t);
              return (
                n.set({
                  label: e("Insert"),
                  icon: $h.check,
                  class: "ck-button-save",
                  type: "submit",
                  withText: !0,
                  isEnabled: this.imageURLInputValue,
                }),
                o.set({
                  label: e("Cancel"),
                  icon: $h.cancel,
                  class: "ck-button-cancel",
                  withText: !0,
                }),
                n.bind("isEnabled").to(this, "imageURLInputValue", (t) => !!t),
                n.delegate("execute").to(this, "submit"),
                o.delegate("execute").to(this, "cancel"),
                { insertButtonView: n, cancelButtonView: o }
              );
            }
            focus() {
              this._focusCycler.focusFirst();
            }
          }
          function d_(t) {
            const e = t.t,
              n = new hg(t, mg);
            return (
              n.set({ label: e("Insert image via URL") }),
              (n.fieldView.placeholder = "https://example.com/image.png"),
              n
            );
          }
          class u_ extends j {
            static get pluginName() {
              return "ImageInsertUI";
            }
            init() {
              const t = this.editor,
                e = (t) => this._createDropdownView(t);
              t.ui.componentFactory.add("insertImage", e),
                t.ui.componentFactory.add("imageInsert", e);
            }
            _createDropdownView(t) {
              const e = this.editor,
                n = t.t,
                o = e.commands.get("uploadImage"),
                i = e.commands.get("insertImage");
              this.dropdownView = Wm(t, o ? km : void 0);
              const r = this.dropdownView.buttonView,
                s = this.dropdownView.panelView;
              if (
                (r.set({
                  label: n("Insert image"),
                  icon: $h.image,
                  tooltip: !0,
                }),
                s.extendTemplate({
                  attributes: { class: "ck-image-insert__panel" },
                }),
                o)
              ) {
                const t = this.dropdownView.buttonView;
                (t.actionView = e.ui.componentFactory.create("uploadImage")),
                  t.actionView.extendTemplate({
                    attributes: {
                      class: "ck ck-button ck-splitbutton__action",
                    },
                  });
              }
              return this._setUpDropdown(o || i);
            }
            _setUpDropdown(t) {
              const e = this.editor,
                n = e.t,
                o = new c_(
                  e.locale,
                  (function (t) {
                    const e = t.config.get("image.insert.integrations"),
                      n = t.plugins.get("ImageInsertUI"),
                      o = { insertImageViaUrl: d_(t.locale) };
                    if (!e) return o;
                    if (
                      e.find((t) => "openCKFinder" === t) &&
                      t.ui.componentFactory.has("ckfinder")
                    ) {
                      const e = t.ui.componentFactory.create("ckfinder");
                      e.set({
                        withText: !0,
                        class: "ck-image-insert__ck-finder-button",
                      }),
                        e.delegate("execute").to(n, "cancel"),
                        (o.openCKFinder = e);
                    }
                    return e.reduce(
                      (e, n) => (
                        o[n]
                          ? (e[n] = o[n])
                          : t.ui.componentFactory.has(n) &&
                            (e[n] = t.ui.componentFactory.create(n)),
                        e
                      ),
                      {}
                    );
                  })(e)
                ),
                i = o.insertButtonView,
                r = o.getIntegration("insertImageViaUrl"),
                s = this.dropdownView,
                a = s.panelView,
                l = this.editor.plugins.get("ImageUtils");
              function c() {
                e.editing.view.focus(), (s.isOpen = !1);
              }
              return (
                s.bind("isEnabled").to(t),
                s.once("change:isOpen", () => {
                  a.children.add(o);
                }),
                s.on(
                  "change:isOpen",
                  () => {
                    const t = e.model.document.selection.getSelectedElement();
                    s.isOpen &&
                      (l.isImage(t)
                        ? ((o.imageURLInputValue = t.getAttribute("src")),
                          (i.label = n("Update")),
                          (r.label = n("Update image URL")))
                        : ((o.imageURLInputValue = ""),
                          (i.label = n("Insert")),
                          (r.label = n("Insert image via URL"))));
                  },
                  { priority: "low" }
                ),
                o.delegate("submit", "cancel").to(s),
                this.delegate("cancel").to(s),
                s.on("submit", () => {
                  c(),
                    (function () {
                      const t = e.model.document.selection.getSelectedElement();
                      l.isImage(t)
                        ? e.model.change((e) => {
                            e.setAttribute("src", o.imageURLInputValue, t),
                              e.removeAttribute("srcset", t),
                              e.removeAttribute("sizes", t);
                          })
                        : e.execute("insertImage", {
                            source: o.imageURLInputValue,
                          });
                    })();
                }),
                s.on("cancel", () => {
                  c();
                }),
                s
              );
            }
          }
          class h_ extends j {
            static get pluginName() {
              return "ImageInsertViaUrl";
            }
            static get requires() {
              return [u_];
            }
          }
          class m_ extends N {
            constructor() {
              super();
              const t = new window.FileReader();
              (this._reader = t),
                (this._data = void 0),
                this.set("loaded", 0),
                (t.onprogress = (t) => {
                  this.loaded = t.loaded;
                });
            }
            get error() {
              return this._reader.error;
            }
            get data() {
              return this._data;
            }
            read(t) {
              const e = this._reader;
              return (
                (this.total = t.size),
                new Promise((n, o) => {
                  (e.onload = () => {
                    const t = e.result;
                    (this._data = t), n(t);
                  }),
                    (e.onerror = () => {
                      o("error");
                    }),
                    (e.onabort = () => {
                      o("aborted");
                    }),
                    this._reader.readAsDataURL(t);
                })
              );
            }
            abort() {
              this._reader.abort();
            }
          }
          class g_ extends j {
            static get pluginName() {
              return "FileRepository";
            }
            static get requires() {
              return [Wh];
            }
            init() {
              (this.loaders = new po()),
                this.loaders.on("change", () => this._updatePendingAction()),
                (this._loadersMap = new Map()),
                (this._pendingAction = null),
                this.set("uploaded", 0),
                this.set("uploadTotal", null),
                this.bind("uploadedPercent").to(
                  this,
                  "uploaded",
                  this,
                  "uploadTotal",
                  (t, e) => (e ? (t / e) * 100 : 0)
                );
            }
            getLoader(t) {
              return this._loadersMap.get(t) || null;
            }
            createLoader(t) {
              if (!this.createUploadAdapter)
                return c("filerepository-no-upload-adapter"), null;
              const e = new p_(Promise.resolve(t), this.createUploadAdapter);
              return (
                this.loaders.add(e),
                this._loadersMap.set(t, e),
                t instanceof Promise &&
                  e.file
                    .then((t) => {
                      this._loadersMap.set(t, e);
                    })
                    .catch(() => {}),
                e.on("change:uploaded", () => {
                  let t = 0;
                  for (const e of this.loaders) t += e.uploaded;
                  this.uploaded = t;
                }),
                e.on("change:uploadTotal", () => {
                  let t = 0;
                  for (const e of this.loaders)
                    e.uploadTotal && (t += e.uploadTotal);
                  this.uploadTotal = t;
                }),
                e
              );
            }
            destroyLoader(t) {
              const e = t instanceof p_ ? t : this.getLoader(t);
              e._destroy(),
                this.loaders.remove(e),
                this._loadersMap.forEach((t, n) => {
                  t === e && this._loadersMap.delete(n);
                });
            }
            _updatePendingAction() {
              const t = this.editor.plugins.get(Wh);
              if (this.loaders.length) {
                if (!this._pendingAction) {
                  const e = this.editor.t,
                    n = (t) => `${e("Upload in progress")} ${parseInt(t)}%.`;
                  (this._pendingAction = t.add(n(this.uploadedPercent))),
                    this._pendingAction
                      .bind("message")
                      .to(this, "uploadedPercent", n);
                }
              } else
                t.remove(this._pendingAction), (this._pendingAction = null);
            }
          }
          class p_ extends N {
            constructor(t, e) {
              super(),
                (this.id = r()),
                (this._filePromiseWrapper = this._createFilePromiseWrapper(t)),
                (this._adapter = e(this)),
                (this._reader = new m_()),
                this.set("status", "idle"),
                this.set("uploaded", 0),
                this.set("uploadTotal", null),
                this.bind("uploadedPercent").to(
                  this,
                  "uploaded",
                  this,
                  "uploadTotal",
                  (t, e) => (e ? (t / e) * 100 : 0)
                ),
                this.set("uploadResponse", null);
            }
            get file() {
              return this._filePromiseWrapper
                ? this._filePromiseWrapper.promise.then((t) =>
                    this._filePromiseWrapper ? t : null
                  )
                : Promise.resolve(null);
            }
            get data() {
              return this._reader.data;
            }
            read() {
              if ("idle" != this.status)
                throw new l("filerepository-read-wrong-status", this);
              return (
                (this.status = "reading"),
                this.file
                  .then((t) => this._reader.read(t))
                  .then((t) => {
                    if ("reading" !== this.status) throw this.status;
                    return (this.status = "idle"), t;
                  })
                  .catch((t) => {
                    if ("aborted" === t)
                      throw ((this.status = "aborted"), "aborted");
                    throw (
                      ((this.status = "error"),
                      this._reader.error ? this._reader.error : t)
                    );
                  })
              );
            }
            upload() {
              if ("idle" != this.status)
                throw new l("filerepository-upload-wrong-status", this);
              return (
                (this.status = "uploading"),
                this.file
                  .then(() => this._adapter.upload())
                  .then(
                    (t) => (
                      (this.uploadResponse = t), (this.status = "idle"), t
                    )
                  )
                  .catch((t) => {
                    if ("aborted" === this.status) throw "aborted";
                    throw ((this.status = "error"), t);
                  })
              );
            }
            abort() {
              const t = this.status;
              (this.status = "aborted"),
                this._filePromiseWrapper.isFulfilled
                  ? "reading" == t
                    ? this._reader.abort()
                    : "uploading" == t &&
                      this._adapter.abort &&
                      this._adapter.abort()
                  : (this._filePromiseWrapper.promise.catch(() => {}),
                    this._filePromiseWrapper.rejecter("aborted")),
                this._destroy();
            }
            _destroy() {
              (this._filePromiseWrapper = void 0),
                (this._reader = void 0),
                (this._adapter = void 0),
                (this.uploadResponse = void 0);
            }
            _createFilePromiseWrapper(t) {
              const e = {};
              return (
                (e.promise = new Promise((n, o) => {
                  (e.rejecter = o),
                    (e.isFulfilled = !1),
                    t
                      .then((t) => {
                        (e.isFulfilled = !0), n(t);
                      })
                      .catch((t) => {
                        (e.isFulfilled = !0), o(t);
                      });
                })),
                e
              );
            }
          }
          class f_ extends Ch {
            constructor(t) {
              super(t),
                (this.buttonView = new nm(t)),
                (this._fileInputView = new k_(t)),
                this._fileInputView.bind("acceptedType").to(this),
                this._fileInputView.bind("allowMultipleFiles").to(this),
                this._fileInputView.delegate("done").to(this),
                this.setTemplate({
                  tag: "span",
                  attributes: { class: "ck-file-dialog-button" },
                  children: [this.buttonView, this._fileInputView],
                }),
                this.buttonView.on("execute", () => {
                  this._fileInputView.open();
                });
            }
            focus() {
              this.buttonView.focus();
            }
          }
          class k_ extends Ch {
            constructor(t) {
              super(t),
                this.set("acceptedType", void 0),
                this.set("allowMultipleFiles", !1);
              const e = this.bindTemplate;
              this.setTemplate({
                tag: "input",
                attributes: {
                  class: ["ck-hidden"],
                  type: "file",
                  tabindex: "-1",
                  accept: e.to("acceptedType"),
                  multiple: e.to("allowMultipleFiles"),
                },
                on: {
                  change: e.to(() => {
                    this.element &&
                      this.element.files &&
                      this.element.files.length &&
                      this.fire("done", this.element.files),
                      (this.element.value = "");
                  }),
                },
              });
            }
            open() {
              this.element.click();
            }
          }
          class b_ {
            constructor(t, e) {
              (this.loader = t), (this.options = e);
            }
            upload() {
              return this.loader.file.then(
                (t) =>
                  new Promise((e, n) => {
                    this._initRequest(),
                      this._initListeners(e, n, t),
                      this._sendRequest(t);
                  })
              );
            }
            abort() {
              this.xhr && this.xhr.abort();
            }
            _initRequest() {
              const t = (this.xhr = new XMLHttpRequest());
              t.open("POST", this.options.uploadUrl, !0),
                (t.responseType = "json");
            }
            _initListeners(t, e, n) {
              const o = this.xhr,
                i = this.loader,
                r = `Couldn't upload file: ${n.name}.`;
              o.addEventListener("error", () => e(r)),
                o.addEventListener("abort", () => e()),
                o.addEventListener("load", () => {
                  const n = o.response;
                  if (!n || n.error)
                    return e(
                      n && n.error && n.error.message ? n.error.message : r
                    );
                  const i = n.url ? { default: n.url } : n.urls;
                  t({ ...n, urls: i });
                }),
                o.upload &&
                  o.upload.addEventListener("progress", (t) => {
                    t.lengthComputable &&
                      ((i.uploadTotal = t.total), (i.uploaded = t.loaded));
                  });
            }
            _sendRequest(t) {
              const e = this.options.headers || {},
                n = this.options.withCredentials || !1;
              for (const t of Object.keys(e))
                this.xhr.setRequestHeader(t, e[t]);
              this.xhr.withCredentials = n;
              const o = new FormData();
              o.append("upload", t), this.xhr.send(o);
            }
          }
          function w_(t) {
            const e = t.map((t) => t.replace("+", "\\+"));
            return new RegExp(`^image\\/(${e.join("|")})$`);
          }
          function A_(t) {
            return new Promise((e, n) => {
              const o = t.getAttribute("src");
              fetch(o)
                .then((t) => t.blob())
                .then((t) => {
                  const n = __(t, o),
                    i = n.replace("image/", ""),
                    r = new File([t], `image.${i}`, { type: n });
                  e(r);
                })
                .catch((t) =>
                  t && "TypeError" === t.name
                    ? (function (t) {
                        return (function (t) {
                          return new Promise((e, n) => {
                            const o = wo.document.createElement("img");
                            o.addEventListener("load", () => {
                              const t = wo.document.createElement("canvas");
                              (t.width = o.width), (t.height = o.height);
                              t.getContext("2d").drawImage(o, 0, 0),
                                t.toBlob((t) => (t ? e(t) : n()));
                            }),
                              o.addEventListener("error", () => n()),
                              (o.src = t);
                          });
                        })(t).then((e) => {
                          const n = __(e, t),
                            o = n.replace("image/", "");
                          return new File([e], `image.${o}`, { type: n });
                        });
                      })(o)
                        .then(e)
                        .catch(n)
                    : n(t)
                );
            });
          }
          function __(t, e) {
            return t.type
              ? t.type
              : e.match(/data:(image\/\w+);base64/)
              ? e.match(/data:(image\/\w+);base64/)[1].toLowerCase()
              : "image/jpeg";
          }
          class C_ extends j {
            static get pluginName() {
              return "ImageUploadUI";
            }
            init() {
              const t = this.editor,
                e = t.t,
                n = (n) => {
                  const o = new f_(n),
                    i = t.commands.get("uploadImage"),
                    r = t.config.get("image.upload.types"),
                    s = w_(r);
                  return (
                    o.set({
                      acceptedType: r.map((t) => `image/${t}`).join(","),
                      allowMultipleFiles: !0,
                    }),
                    o.buttonView.set({
                      label: e("Insert image"),
                      icon: $h.image,
                      tooltip: !0,
                    }),
                    o.buttonView.bind("isEnabled").to(i),
                    o.on("done", (e, n) => {
                      const o = Array.from(n).filter((t) => s.test(t.type));
                      o.length &&
                        (t.execute("uploadImage", { file: o }),
                        t.editing.view.focus());
                    }),
                    o
                  );
                };
              t.ui.componentFactory.add("uploadImage", n),
                t.ui.componentFactory.add("imageUpload", n);
            }
          }
          var v_ = n(5870),
            y_ = { attributes: { "data-cke": !0 } };
          (y_.setAttributes = is()),
            (y_.insert = ns().bind(null, "head")),
            (y_.domAPI = ts()),
            (y_.insertStyleElement = ss());
          Jr()(v_.Z, y_);
          v_.Z && v_.Z.locals && v_.Z.locals;
          var x_ = n(9899),
            E_ = { attributes: { "data-cke": !0 } };
          (E_.setAttributes = is()),
            (E_.insert = ns().bind(null, "head")),
            (E_.domAPI = ts()),
            (E_.insertStyleElement = ss());
          Jr()(x_.Z, E_);
          x_.Z && x_.Z.locals && x_.Z.locals;
          var D_ = n(9825),
            S_ = { attributes: { "data-cke": !0 } };
          (S_.setAttributes = is()),
            (S_.insert = ns().bind(null, "head")),
            (S_.domAPI = ts()),
            (S_.insertStyleElement = ss());
          Jr()(D_.Z, S_);
          D_.Z && D_.Z.locals && D_.Z.locals;
          class I_ extends j {
            static get pluginName() {
              return "ImageUploadProgress";
            }
            constructor(t) {
              super(t),
                (this.placeholder =
                  "data:image/gif;base64,R0lGODlhAQABAAAAACH5BAEKAAEALAAAAAABAAEAAAICTAEAOw==");
            }
            init() {
              const t = this.editor;
              t.plugins.has("ImageBlockEditing") &&
                t.editing.downcastDispatcher.on(
                  "attribute:uploadStatus:imageBlock",
                  (...t) => this.uploadStatusChange(...t)
                ),
                t.plugins.has("ImageInlineEditing") &&
                  t.editing.downcastDispatcher.on(
                    "attribute:uploadStatus:imageInline",
                    (...t) => this.uploadStatusChange(...t)
                  );
            }
            uploadStatusChange(t, e, n) {
              const o = this.editor,
                i = e.item,
                r = i.getAttribute("uploadId");
              if (!n.consumable.consume(e.item, t.name)) return;
              const s = o.plugins.get("ImageUtils"),
                a = o.plugins.get(g_),
                l = r ? e.attributeNewValue : null,
                c = this.placeholder,
                d = o.editing.mapper.toViewElement(i),
                u = n.writer;
              if ("reading" == l) return T_(d, u), void M_(s, c, d, u);
              if ("uploading" == l) {
                const t = a.loaders.get(r);
                return (
                  T_(d, u),
                  void (t
                    ? (B_(d, u),
                      (function (t, e, n, o) {
                        const i = (function (t) {
                          const e = t.createUIElement("div", {
                            class: "ck-progress-bar",
                          });
                          return t.setCustomProperty("progressBar", !0, e), e;
                        })(e);
                        e.insert(e.createPositionAt(t, "end"), i),
                          n.on("change:uploadedPercent", (t, e, n) => {
                            o.change((t) => {
                              t.setStyle("width", n + "%", i);
                            });
                          });
                      })(d, u, t, o.editing.view),
                      (function (t, e, n, o) {
                        if (o.data) {
                          const i = t.findViewImgElement(e);
                          n.setAttribute("src", o.data, i);
                        }
                      })(s, d, u, t))
                    : M_(s, c, d, u))
                );
              }
              "complete" == l &&
                a.loaders.get(r) &&
                (function (t, e, n) {
                  const o = e.createUIElement("div", {
                    class: "ck-image-upload-complete-icon",
                  });
                  e.insert(e.createPositionAt(t, "end"), o),
                    setTimeout(() => {
                      n.change((t) => t.remove(t.createRangeOn(o)));
                    }, 3e3);
                })(d, u, o.editing.view),
                (function (t, e) {
                  z_(t, e, "progressBar");
                })(d, u),
                B_(d, u),
                (function (t, e) {
                  e.removeClass("ck-appear", t);
                })(d, u);
            }
          }
          function T_(t, e) {
            t.hasClass("ck-appear") || e.addClass("ck-appear", t);
          }
          function M_(t, e, n, o) {
            n.hasClass("ck-image-upload-placeholder") ||
              o.addClass("ck-image-upload-placeholder", n);
            const i = t.findViewImgElement(n);
            i.getAttribute("src") !== e && o.setAttribute("src", e, i),
              N_(n, "placeholder") ||
                o.insert(
                  o.createPositionAfter(i),
                  (function (t) {
                    const e = t.createUIElement("div", {
                      class: "ck-upload-placeholder-loader",
                    });
                    return t.setCustomProperty("placeholder", !0, e), e;
                  })(o)
                );
          }
          function B_(t, e) {
            t.hasClass("ck-image-upload-placeholder") &&
              e.removeClass("ck-image-upload-placeholder", t),
              z_(t, e, "placeholder");
          }
          function N_(t, e) {
            for (const n of t.getChildren())
              if (n.getCustomProperty(e)) return n;
          }
          function z_(t, e, n) {
            const o = N_(t, n);
            o && e.remove(e.createRangeOn(o));
          }
          class P_ extends F {
            refresh() {
              const t = this.editor,
                e = t.plugins.get("ImageUtils"),
                n = t.model.document.selection.getSelectedElement();
              this.isEnabled = e.isImageAllowed() || e.isImage(n);
            }
            execute(t) {
              const e = ko(t.file),
                n = this.editor.model.document.selection,
                o = this.editor.plugins.get("ImageUtils"),
                i = Object.fromEntries(n.getAttributes());
              e.forEach((t, e) => {
                const r = n.getSelectedElement();
                if (e && r && o.isImage(r)) {
                  const e = this.editor.model.createPositionAfter(r);
                  this._uploadImage(t, i, e);
                } else this._uploadImage(t, i);
              });
            }
            _uploadImage(t, e, n) {
              const o = this.editor,
                i = o.plugins.get(g_).createLoader(t),
                r = o.plugins.get("ImageUtils");
              i && r.insertImage({ ...e, uploadId: i.id }, n);
            }
          }
          class L_ extends j {
            static get requires() {
              return [g_, pg, zp, Jf];
            }
            static get pluginName() {
              return "ImageUploadEditing";
            }
            constructor(t) {
              super(t),
                t.config.define("image", {
                  upload: {
                    types: ["jpeg", "png", "gif", "bmp", "webp", "tiff"],
                  },
                }),
                (this._uploadImageElements = new Map());
            }
            init() {
              const t = this.editor,
                e = t.model.document,
                n = t.conversion,
                o = t.plugins.get(g_),
                i = t.plugins.get("ImageUtils"),
                r = w_(t.config.get("image.upload.types")),
                s = new P_(t);
              t.commands.add("uploadImage", s),
                t.commands.add("imageUpload", s),
                n
                  .for("upcast")
                  .attributeToAttribute({
                    view: { name: "img", key: "uploadId" },
                    model: "uploadId",
                  }),
                this.listenTo(
                  t.editing.view.document,
                  "clipboardInput",
                  (e, n) => {
                    if (
                      ((o = n.dataTransfer),
                      Array.from(o.types).includes("text/html") &&
                        "" !== o.getData("text/html"))
                    )
                      return;
                    var o;
                    const i = Array.from(n.dataTransfer.files).filter(
                      (t) => !!t && r.test(t.type)
                    );
                    i.length &&
                      (e.stop(),
                      t.model.change((e) => {
                        n.targetRanges &&
                          e.setSelection(
                            n.targetRanges.map((e) =>
                              t.editing.mapper.toModelRange(e)
                            )
                          ),
                          t.model.enqueueChange(() => {
                            t.execute("uploadImage", { file: i });
                          });
                      }));
                  }
                ),
                this.listenTo(
                  t.plugins.get("ClipboardPipeline"),
                  "inputTransformation",
                  (e, n) => {
                    const r = Array.from(
                      t.editing.view.createRangeIn(n.content)
                    )
                      .filter(
                        (t) =>
                          (function (t, e) {
                            return (
                              !(
                                !t.isInlineImageView(e) ||
                                !e.getAttribute("src")
                              ) &&
                              (e
                                .getAttribute("src")
                                .match(/^data:image\/\w+;base64,/g) ||
                                e.getAttribute("src").match(/^blob:/g))
                            );
                          })(i, t.item) &&
                          !t.item.getAttribute("uploadProcessed")
                      )
                      .map((t) => ({
                        promise: A_(t.item),
                        imageElement: t.item,
                      }));
                    if (!r.length) return;
                    const s = new eu(t.editing.view.document);
                    for (const t of r) {
                      s.setAttribute("uploadProcessed", !0, t.imageElement);
                      const e = o.createLoader(t.promise);
                      e &&
                        (s.setAttribute("src", "", t.imageElement),
                        s.setAttribute("uploadId", e.id, t.imageElement));
                    }
                  }
                ),
                t.editing.view.document.on("dragover", (t, e) => {
                  e.preventDefault();
                }),
                e.on("change", () => {
                  const n = e.differ
                      .getChanges({ includeChangesInGraveyard: !0 })
                      .reverse(),
                    i = new Set();
                  for (const e of n)
                    if ("insert" == e.type && "$text" != e.name) {
                      const n = e.position.nodeAfter,
                        r = "$graveyard" == e.position.root.rootName;
                      for (const e of R_(t, n)) {
                        const t = e.getAttribute("uploadId");
                        if (!t) continue;
                        const n = o.loaders.get(t);
                        n &&
                          (r
                            ? i.has(t) || n.abort()
                            : (i.add(t),
                              this._uploadImageElements.set(t, e),
                              "idle" == n.status && this._readAndUpload(n)));
                      }
                    }
                }),
                this.on(
                  "uploadComplete",
                  (t, { imageElement: e, data: n }) => {
                    const o = n.urls ? n.urls : n;
                    this.editor.model.change((t) => {
                      t.setAttribute("src", o.default, e),
                        this._parseAndSetSrcsetAttributeOnImage(o, e, t);
                    });
                  },
                  { priority: "low" }
                );
            }
            afterInit() {
              const t = this.editor.model.schema;
              this.editor.plugins.has("ImageBlockEditing") &&
                t.extend("imageBlock", {
                  allowAttributes: ["uploadId", "uploadStatus"],
                }),
                this.editor.plugins.has("ImageInlineEditing") &&
                  t.extend("imageInline", {
                    allowAttributes: ["uploadId", "uploadStatus"],
                  });
            }
            _readAndUpload(t) {
              const e = this.editor,
                n = e.model,
                o = e.locale.t,
                i = e.plugins.get(g_),
                r = e.plugins.get(pg),
                s = e.plugins.get("ImageUtils"),
                a = this._uploadImageElements;
              return (
                n.enqueueChange({ isUndoable: !1 }, (e) => {
                  e.setAttribute("uploadStatus", "reading", a.get(t.id));
                }),
                t
                  .read()
                  .then(() => {
                    const o = t.upload(),
                      i = a.get(t.id);
                    if (ar.isSafari) {
                      const t = e.editing.mapper.toViewElement(i),
                        n = s.findViewImgElement(t);
                      e.editing.view.once("render", () => {
                        if (!n.parent) return;
                        const t = e.editing.view.domConverter.mapViewToDom(
                          n.parent
                        );
                        if (!t) return;
                        const o = t.style.display;
                        (t.style.display = "none"),
                          (t._ckHack = t.offsetHeight),
                          (t.style.display = o);
                      });
                    }
                    return (
                      n.enqueueChange({ isUndoable: !1 }, (t) => {
                        t.setAttribute("uploadStatus", "uploading", i);
                      }),
                      o
                    );
                  })
                  .then((e) => {
                    n.enqueueChange({ isUndoable: !1 }, (n) => {
                      const o = a.get(t.id);
                      n.setAttribute("uploadStatus", "complete", o),
                        this.fire("uploadComplete", {
                          data: e,
                          imageElement: o,
                        });
                    }),
                      l();
                  })
                  .catch((e) => {
                    if ("error" !== t.status && "aborted" !== t.status) throw e;
                    "error" == t.status &&
                      e &&
                      r.showWarning(e, {
                        title: o("Upload failed"),
                        namespace: "upload",
                      }),
                      n.enqueueChange({ isUndoable: !1 }, (e) => {
                        e.remove(a.get(t.id));
                      }),
                      l();
                  })
              );
              function l() {
                n.enqueueChange({ isUndoable: !1 }, (e) => {
                  const n = a.get(t.id);
                  e.removeAttribute("uploadId", n),
                    e.removeAttribute("uploadStatus", n),
                    a.delete(t.id);
                }),
                  i.destroyLoader(t);
              }
            }
            _parseAndSetSrcsetAttributeOnImage(t, e, n) {
              let o = 0;
              const i = Object.keys(t)
                .filter((t) => {
                  const e = parseInt(t, 10);
                  if (!isNaN(e)) return (o = Math.max(o, e)), !0;
                })
                .map((e) => `${t[e]} ${e}w`)
                .join(", ");
              "" != i && n.setAttribute("srcset", { data: i, width: o }, e);
            }
          }
          function R_(t, e) {
            const n = t.plugins.get("ImageUtils");
            return Array.from(t.model.createRangeOn(e))
              .filter((t) => n.isImage(t.item))
              .map((t) => t.item);
          }
          class O_ extends j {
            static get pluginName() {
              return "ImageUpload";
            }
            static get requires() {
              return [L_, C_, I_];
            }
          }
          class j_ extends F {
            refresh() {
              const t = this.editor,
                e = t.plugins
                  .get("ImageUtils")
                  .getClosestSelectedImageElement(t.model.document.selection);
              (this.isEnabled = !!e),
                e && e.hasAttribute("width")
                  ? (this.value = {
                      width: e.getAttribute("width"),
                      height: null,
                    })
                  : (this.value = null);
            }
            execute(t) {
              const e = this.editor,
                n = e.model,
                o = e.plugins
                  .get("ImageUtils")
                  .getClosestSelectedImageElement(n.document.selection);
              (this.value = { width: t.width, height: null }),
                o &&
                  n.change((e) => {
                    e.setAttribute("width", t.width, o);
                  });
            }
          }
          class V_ extends j {
            static get requires() {
              return [Jf];
            }
            static get pluginName() {
              return "ImageResizeEditing";
            }
            constructor(t) {
              super(t),
                t.config.define("image", {
                  resizeUnit: "%",
                  resizeOptions: [
                    {
                      name: "resizeImage:original",
                      value: null,
                      icon: "original",
                    },
                    { name: "resizeImage:25", value: "25", icon: "small" },
                    { name: "resizeImage:50", value: "50", icon: "medium" },
                    { name: "resizeImage:75", value: "75", icon: "large" },
                  ],
                });
            }
            init() {
              const t = this.editor,
                e = new j_(t);
              this._registerSchema(),
                this._registerConverters("imageBlock"),
                this._registerConverters("imageInline"),
                t.commands.add("resizeImage", e),
                t.commands.add("imageResize", e);
            }
            _registerSchema() {
              this.editor.plugins.has("ImageBlockEditing") &&
                this.editor.model.schema.extend("imageBlock", {
                  allowAttributes: "width",
                }),
                this.editor.plugins.has("ImageInlineEditing") &&
                  this.editor.model.schema.extend("imageInline", {
                    allowAttributes: "width",
                  });
            }
            _registerConverters(t) {
              const e = this.editor;
              e.conversion.for("downcast").add((e) =>
                e.on(`attribute:width:${t}`, (t, e, n) => {
                  if (!n.consumable.consume(e.item, t.name)) return;
                  const o = n.writer,
                    i = n.mapper.toViewElement(e.item);
                  null !== e.attributeNewValue
                    ? (o.setStyle("width", e.attributeNewValue, i),
                      o.addClass("image_resized", i))
                    : (o.removeStyle("width", i),
                      o.removeClass("image_resized", i));
                })
              ),
                e.conversion
                  .for("upcast")
                  .attributeToAttribute({
                    view: {
                      name: "imageBlock" === t ? "figure" : "img",
                      styles: { width: /.+/ },
                    },
                    model: { key: "width", value: (t) => t.getStyle("width") },
                  });
            }
          }
          const F_ = {
            small: $h.objectSizeSmall,
            medium: $h.objectSizeMedium,
            large: $h.objectSizeLarge,
            original: $h.objectSizeFull,
          };
          class H_ extends j {
            static get requires() {
              return [V_];
            }
            static get pluginName() {
              return "ImageResizeButtons";
            }
            constructor(t) {
              super(t), (this._resizeUnit = t.config.get("image.resizeUnit"));
            }
            init() {
              const t = this.editor,
                e = t.config.get("image.resizeOptions"),
                n = t.commands.get("resizeImage");
              this.bind("isEnabled").to(n);
              for (const t of e) this._registerImageResizeButton(t);
              this._registerImageResizeDropdown(e);
            }
            _registerImageResizeButton(t) {
              const e = this.editor,
                { name: n, value: o, icon: i } = t,
                r = o ? o + this._resizeUnit : null;
              e.ui.componentFactory.add(n, (n) => {
                const o = new nm(n),
                  s = e.commands.get("resizeImage"),
                  a = this._getOptionLabelValue(t, !0);
                if (!F_[i])
                  throw new l("imageresizebuttons-missing-icon", e, t);
                return (
                  o.set({
                    label: a,
                    icon: F_[i],
                    tooltip: a,
                    isToggleable: !0,
                  }),
                  o.bind("isEnabled").to(this),
                  o.bind("isOn").to(s, "value", U_(r)),
                  this.listenTo(o, "execute", () => {
                    e.execute("resizeImage", { width: r });
                  }),
                  o
                );
              });
            }
            _registerImageResizeDropdown(t) {
              const e = this.editor,
                n = e.t,
                o = t.find((t) => !t.value),
                i = (i) => {
                  const r = e.commands.get("resizeImage"),
                    s = Wm(i, gm),
                    a = s.buttonView;
                  return (
                    a.set({
                      tooltip: n("Resize image"),
                      commandValue: o.value,
                      icon: F_.medium,
                      isToggleable: !0,
                      label: this._getOptionLabelValue(o),
                      withText: !0,
                      class: "ck-resize-image-button",
                    }),
                    a
                      .bind("label")
                      .to(r, "value", (t) =>
                        t && t.width ? t.width : this._getOptionLabelValue(o)
                      ),
                    s.bind("isOn").to(r),
                    s.bind("isEnabled").to(this),
                    qm(s, this._getResizeDropdownListItemDefinitions(t, r)),
                    (s.listView.ariaLabel = n("Image resize list")),
                    this.listenTo(s, "execute", (t) => {
                      e.execute(t.source.commandName, {
                        width: t.source.commandValue,
                      }),
                        e.editing.view.focus();
                    }),
                    s
                  );
                };
              e.ui.componentFactory.add("resizeImage", i),
                e.ui.componentFactory.add("imageResize", i);
            }
            _getOptionLabelValue(t, e) {
              const n = this.editor.t;
              return t.label
                ? t.label
                : e
                ? t.value
                  ? n("Resize image to %0", t.value + this._resizeUnit)
                  : n("Resize image to the original size")
                : t.value
                ? t.value + this._resizeUnit
                : n("Original");
            }
            _getResizeDropdownListItemDefinitions(t, e) {
              const n = new po();
              return (
                t.map((t) => {
                  const o = t.value ? t.value + this._resizeUnit : null,
                    i = {
                      type: "button",
                      model: new fg({
                        commandName: "resizeImage",
                        commandValue: o,
                        label: this._getOptionLabelValue(t),
                        withText: !0,
                        icon: null,
                      }),
                    };
                  i.model.bind("isOn").to(e, "value", U_(o)), n.add(i);
                }),
                n
              );
            }
          }
          function U_(t) {
            return (e) => (null === t && e === t) || (e && e.width === t);
          }
          const W_ = /(image|image-inline)/,
            $_ = "image_resized";
          class q_ extends j {
            static get requires() {
              return [Zf];
            }
            static get pluginName() {
              return "ImageResizeHandles";
            }
            init() {
              const t = this.editor.commands.get("resizeImage");
              this.bind("isEnabled").to(t), this._setupResizerCreator();
            }
            _setupResizerCreator() {
              const t = this.editor,
                e = t.editing.view;
              e.addObserver(HA),
                this.listenTo(e.document, "imageLoaded", (n, o) => {
                  if (
                    !o.target.matches(
                      "figure.image.ck-widget > img,figure.image.ck-widget > picture > img,figure.image.ck-widget > a > img,figure.image.ck-widget > a > picture > img,span.image-inline.ck-widget > img,span.image-inline.ck-widget > picture > img"
                    )
                  )
                    return;
                  const i = t.editing.view.domConverter,
                    r = i.domToView(o.target).findAncestor({ classes: W_ });
                  let s = this.editor.plugins
                    .get(Zf)
                    .getResizerByViewElement(r);
                  if (s) return void s.redraw();
                  const a = t.editing.mapper,
                    l = a.toModelElement(r);
                  (s = t.plugins.get(Zf).attachTo({
                    unit: t.config.get("image.resizeUnit"),
                    modelElement: l,
                    viewElement: r,
                    editor: t,
                    getHandleHost: (t) => t.querySelector("img"),
                    getResizeHost: () =>
                      i.mapViewToDom(a.toViewElement(l.parent)),
                    isCentered() {
                      const t = l.getAttribute("imageStyle");
                      return !t || "block" == t || "alignCenter" == t;
                    },
                    onCommit(n) {
                      e.change((t) => {
                        t.removeClass($_, r);
                      }),
                        t.execute("resizeImage", { width: n });
                    },
                  })),
                    s.on("updateSize", () => {
                      r.hasClass($_) ||
                        e.change((t) => {
                          t.addClass($_, r);
                        });
                    }),
                    s.bind("isEnabled").to(this);
                });
            }
          }
          var G_ = n(1043),
            Z_ = { attributes: { "data-cke": !0 } };
          (Z_.setAttributes = is()),
            (Z_.insert = ns().bind(null, "head")),
            (Z_.domAPI = ts()),
            (Z_.insertStyleElement = ss());
          Jr()(G_.Z, Z_);
          G_.Z && G_.Z.locals && G_.Z.locals;
          class Y_ extends F {
            constructor(t, e) {
              super(t),
                (this._defaultStyles = { imageBlock: !1, imageInline: !1 }),
                (this._styles = new Map(
                  e.map((t) => {
                    if (t.isDefault)
                      for (const e of t.modelElements)
                        this._defaultStyles[e] = t.name;
                    return [t.name, t];
                  })
                ));
            }
            refresh() {
              const t = this.editor.plugins
                .get("ImageUtils")
                .getClosestSelectedImageElement(
                  this.editor.model.document.selection
                );
              (this.isEnabled = !!t),
                this.isEnabled
                  ? t.hasAttribute("imageStyle")
                    ? (this.value = t.getAttribute("imageStyle"))
                    : (this.value = this._defaultStyles[t.name])
                  : (this.value = !1);
            }
            execute(t = {}) {
              const e = this.editor,
                n = e.model,
                o = e.plugins.get("ImageUtils");
              n.change((e) => {
                const i = t.value;
                let r = o.getClosestSelectedImageElement(n.document.selection);
                i &&
                  this.shouldConvertImageType(i, r) &&
                  (this.editor.execute(
                    o.isBlockImage(r) ? "imageTypeInline" : "imageTypeBlock"
                  ),
                  (r = o.getClosestSelectedImageElement(n.document.selection))),
                  !i || this._styles.get(i).isDefault
                    ? e.removeAttribute("imageStyle", r)
                    : e.setAttribute("imageStyle", i, r);
              });
            }
            shouldConvertImageType(t, e) {
              return !this._styles.get(t).modelElements.includes(e.name);
            }
          }
          const {
              objectFullWidth: K_,
              objectInline: Q_,
              objectLeft: J_,
              objectRight: X_,
              objectCenter: tC,
              objectBlockLeft: eC,
              objectBlockRight: nC,
            } = $h,
            oC = {
              get inline() {
                return {
                  name: "inline",
                  title: "In line",
                  icon: Q_,
                  modelElements: ["imageInline"],
                  isDefault: !0,
                };
              },
              get alignLeft() {
                return {
                  name: "alignLeft",
                  title: "Left aligned image",
                  icon: J_,
                  modelElements: ["imageBlock", "imageInline"],
                  className: "image-style-align-left",
                };
              },
              get alignBlockLeft() {
                return {
                  name: "alignBlockLeft",
                  title: "Left aligned image",
                  icon: eC,
                  modelElements: ["imageBlock"],
                  className: "image-style-block-align-left",
                };
              },
              get alignCenter() {
                return {
                  name: "alignCenter",
                  title: "Centered image",
                  icon: tC,
                  modelElements: ["imageBlock"],
                  className: "image-style-align-center",
                };
              },
              get alignRight() {
                return {
                  name: "alignRight",
                  title: "Right aligned image",
                  icon: X_,
                  modelElements: ["imageBlock", "imageInline"],
                  className: "image-style-align-right",
                };
              },
              get alignBlockRight() {
                return {
                  name: "alignBlockRight",
                  title: "Right aligned image",
                  icon: nC,
                  modelElements: ["imageBlock"],
                  className: "image-style-block-align-right",
                };
              },
              get block() {
                return {
                  name: "block",
                  title: "Centered image",
                  icon: tC,
                  modelElements: ["imageBlock"],
                  isDefault: !0,
                };
              },
              get side() {
                return {
                  name: "side",
                  title: "Side image",
                  icon: X_,
                  modelElements: ["imageBlock"],
                  className: "image-style-side",
                };
              },
            },
            iC = {
              full: K_,
              left: eC,
              right: nC,
              center: tC,
              inlineLeft: J_,
              inlineRight: X_,
              inline: Q_,
            },
            rC = [
              {
                name: "imageStyle:wrapText",
                title: "Wrap text",
                defaultItem: "imageStyle:alignLeft",
                items: ["imageStyle:alignLeft", "imageStyle:alignRight"],
              },
              {
                name: "imageStyle:breakText",
                title: "Break text",
                defaultItem: "imageStyle:block",
                items: [
                  "imageStyle:alignBlockLeft",
                  "imageStyle:block",
                  "imageStyle:alignBlockRight",
                ],
              },
            ];
          function sC(t) {
            c("image-style-configuration-definition-invalid", t);
          }
          const aC = {
            normalizeStyles: function (t) {
              return (t.configuredStyles.options || [])
                .map((t) =>
                  (function (t) {
                    t =
                      "string" == typeof t
                        ? oC[t]
                          ? { ...oC[t] }
                          : { name: t }
                        : (function (t, e) {
                            const n = { ...e };
                            for (const o in t)
                              Object.prototype.hasOwnProperty.call(e, o) ||
                                (n[o] = t[o]);
                            return n;
                          })(oC[t.name], t);
                    "string" == typeof t.icon &&
                      (t.icon = iC[t.icon] || t.icon);
                    return t;
                  })(t)
                )
                .filter((e) =>
                  (function (
                    t,
                    { isBlockPluginLoaded: e, isInlinePluginLoaded: n }
                  ) {
                    const { modelElements: o, name: i } = t;
                    if (!(o && o.length && i)) return sC({ style: t }), !1;
                    {
                      const i = [
                        e ? "imageBlock" : null,
                        n ? "imageInline" : null,
                      ];
                      if (!o.some((t) => i.includes(t)))
                        return (
                          c("image-style-missing-dependency", {
                            style: t,
                            missingPlugins: o.map((t) =>
                              "imageBlock" === t
                                ? "ImageBlockEditing"
                                : "ImageInlineEditing"
                            ),
                          }),
                          !1
                        );
                    }
                    return !0;
                  })(e, t)
                );
            },
            getDefaultStylesConfiguration: function (t, e) {
              return t && e
                ? {
                    options: [
                      "inline",
                      "alignLeft",
                      "alignRight",
                      "alignCenter",
                      "alignBlockLeft",
                      "alignBlockRight",
                      "block",
                      "side",
                    ],
                  }
                : t
                ? { options: ["block", "side"] }
                : e
                ? { options: ["inline", "alignLeft", "alignRight"] }
                : {};
            },
            getDefaultDropdownDefinitions: function (t) {
              return t.has("ImageBlockEditing") && t.has("ImageInlineEditing")
                ? [...rC]
                : [];
            },
            warnInvalidStyle: sC,
            DEFAULT_OPTIONS: oC,
            DEFAULT_ICONS: iC,
            DEFAULT_DROPDOWN_DEFINITIONS: rC,
          };
          function lC(t, e) {
            for (const n of e) if (n.name === t) return n;
          }
          class cC extends j {
            static get pluginName() {
              return "ImageStyleEditing";
            }
            static get requires() {
              return [Jf];
            }
            init() {
              const { normalizeStyles: t, getDefaultStylesConfiguration: e } =
                  aC,
                n = this.editor,
                o = n.plugins.has("ImageBlockEditing"),
                i = n.plugins.has("ImageInlineEditing");
              n.config.define("image.styles", e(o, i)),
                (this.normalizedStyles = t({
                  configuredStyles: n.config.get("image.styles"),
                  isBlockPluginLoaded: o,
                  isInlinePluginLoaded: i,
                })),
                this._setupConversion(o, i),
                this._setupPostFixer(),
                n.commands.add("imageStyle", new Y_(n, this.normalizedStyles));
            }
            _setupConversion(t, e) {
              const n = this.editor,
                o = n.model.schema,
                i =
                  ((r = this.normalizedStyles),
                  (t, e, n) => {
                    if (!n.consumable.consume(e.item, t.name)) return;
                    const o = lC(e.attributeNewValue, r),
                      i = lC(e.attributeOldValue, r),
                      s = n.mapper.toViewElement(e.item),
                      a = n.writer;
                    i && a.removeClass(i.className, s),
                      o && a.addClass(o.className, s);
                  });
              var r;
              const s = (function (t) {
                const e = {
                  imageInline: t.filter(
                    (t) =>
                      !t.isDefault && t.modelElements.includes("imageInline")
                  ),
                  imageBlock: t.filter(
                    (t) =>
                      !t.isDefault && t.modelElements.includes("imageBlock")
                  ),
                };
                return (t, n, o) => {
                  if (!n.modelRange) return;
                  const i = n.viewItem,
                    r = Ra(n.modelRange.getItems());
                  if (r && o.schema.checkAttribute(r, "imageStyle"))
                    for (const t of e[r.name])
                      o.consumable.consume(i, { classes: t.className }) &&
                        o.writer.setAttribute("imageStyle", t.name, r);
                };
              })(this.normalizedStyles);
              n.editing.downcastDispatcher.on("attribute:imageStyle", i),
                n.data.downcastDispatcher.on("attribute:imageStyle", i),
                t &&
                  (o.extend("imageBlock", { allowAttributes: "imageStyle" }),
                  n.data.upcastDispatcher.on("element:figure", s, {
                    priority: "low",
                  })),
                e &&
                  (o.extend("imageInline", { allowAttributes: "imageStyle" }),
                  n.data.upcastDispatcher.on("element:img", s, {
                    priority: "low",
                  }));
            }
            _setupPostFixer() {
              const t = this.editor,
                e = t.model.document,
                n = t.plugins.get(Jf),
                o = new Map(this.normalizedStyles.map((t) => [t.name, t]));
              e.registerPostFixer((t) => {
                let i = !1;
                for (const r of e.differ.getChanges())
                  if (
                    "insert" == r.type ||
                    ("attribute" == r.type && "imageStyle" == r.attributeKey)
                  ) {
                    let e =
                      "insert" == r.type
                        ? r.position.nodeAfter
                        : r.range.start.nodeAfter;
                    if (
                      (e &&
                        e.is("element", "paragraph") &&
                        e.childCount > 0 &&
                        (e = e.getChild(0)),
                      !n.isImage(e))
                    )
                      continue;
                    const s = e.getAttribute("imageStyle");
                    if (!s) continue;
                    const a = o.get(s);
                    (a && a.modelElements.includes(e.name)) ||
                      (t.removeAttribute("imageStyle", e), (i = !0));
                  }
                return i;
              });
            }
          }
          var dC = n(4622),
            uC = { attributes: { "data-cke": !0 } };
          (uC.setAttributes = is()),
            (uC.insert = ns().bind(null, "head")),
            (uC.domAPI = ts()),
            (uC.insertStyleElement = ss());
          Jr()(dC.Z, uC);
          dC.Z && dC.Z.locals && dC.Z.locals;
          class hC extends j {
            static get requires() {
              return [cC];
            }
            static get pluginName() {
              return "ImageStyleUI";
            }
            get localizedDefaultStylesTitles() {
              const t = this.editor.t;
              return {
                "Wrap text": t("Wrap text"),
                "Break text": t("Break text"),
                "In line": t("In line"),
                "Full size image": t("Full size image"),
                "Side image": t("Side image"),
                "Left aligned image": t("Left aligned image"),
                "Centered image": t("Centered image"),
                "Right aligned image": t("Right aligned image"),
              };
            }
            init() {
              const t = this.editor.plugins,
                e = this.editor.config.get("image.toolbar") || [],
                n = mC(
                  t.get("ImageStyleEditing").normalizedStyles,
                  this.localizedDefaultStylesTitles
                );
              for (const t of n) this._createButton(t);
              const o = mC(
                [...e.filter(E), ...aC.getDefaultDropdownDefinitions(t)],
                this.localizedDefaultStylesTitles
              );
              for (const t of o) this._createDropdown(t, n);
            }
            _createDropdown(t, e) {
              const n = this.editor.ui.componentFactory;
              n.add(t.name, (o) => {
                let i;
                const { defaultItem: r, items: s, title: a } = t,
                  l = s
                    .filter((t) => e.find(({ name: e }) => gC(e) === t))
                    .map((t) => {
                      const e = n.create(t);
                      return t === r && (i = e), e;
                    });
                s.length !== l.length && aC.warnInvalidStyle({ dropdown: t });
                const c = Wm(o, km),
                  d = c.buttonView,
                  u = d.arrowView;
                return (
                  $m(c, l, { enableActiveItemFocusOnDropdownOpen: !0 }),
                  d.set({ label: pC(a, i.label), class: null, tooltip: !0 }),
                  u.unbind("label"),
                  u.set({ label: a }),
                  d.bind("icon").toMany(l, "isOn", (...t) => {
                    const e = t.findIndex(mi);
                    return e < 0 ? i.icon : l[e].icon;
                  }),
                  d.bind("label").toMany(l, "isOn", (...t) => {
                    const e = t.findIndex(mi);
                    return pC(a, e < 0 ? i.label : l[e].label);
                  }),
                  d.bind("isOn").toMany(l, "isOn", (...t) => t.some(mi)),
                  d
                    .bind("class")
                    .toMany(l, "isOn", (...t) =>
                      t.some(mi) ? "ck-splitbutton_flatten" : null
                    ),
                  d.on("execute", () => {
                    l.some(({ isOn: t }) => t)
                      ? (c.isOpen = !c.isOpen)
                      : i.fire("execute");
                  }),
                  c
                    .bind("isEnabled")
                    .toMany(l, "isEnabled", (...t) => t.some(mi)),
                  this.listenTo(c, "execute", () => {
                    this.editor.editing.view.focus();
                  }),
                  c
                );
              });
            }
            _createButton(t) {
              const e = t.name;
              this.editor.ui.componentFactory.add(gC(e), (n) => {
                const o = this.editor.commands.get("imageStyle"),
                  i = new nm(n);
                return (
                  i.set({
                    label: t.title,
                    icon: t.icon,
                    tooltip: !0,
                    isToggleable: !0,
                  }),
                  i.bind("isEnabled").to(o, "isEnabled"),
                  i.bind("isOn").to(o, "value", (t) => t === e),
                  i.on("execute", this._executeCommand.bind(this, e)),
                  i
                );
              });
            }
            _executeCommand(t) {
              this.editor.execute("imageStyle", { value: t }),
                this.editor.editing.view.focus();
            }
          }
          function mC(t, e) {
            for (const n of t) e[n.title] && (n.title = e[n.title]);
            return t;
          }
          function gC(t) {
            return `imageStyle:${t}`;
          }
          function pC(t, e) {
            return (t ? t + ": " : "") + e;
          }
          class fC extends j {
            static get pluginName() {
              return "IndentEditing";
            }
            init() {
              const t = this.editor;
              t.commands.add("indent", new U(t)),
                t.commands.add("outdent", new U(t));
            }
          }
          const kC =
              '<svg viewBox="0 0 20 20" xmlns="http://www.w3.org/2000/svg"><path d="M2 3.75c0 .414.336.75.75.75h14.5a.75.75 0 1 0 0-1.5H2.75a.75.75 0 0 0-.75.75zm5 6c0 .414.336.75.75.75h9.5a.75.75 0 1 0 0-1.5h-9.5a.75.75 0 0 0-.75.75zM2.75 16.5h14.5a.75.75 0 1 0 0-1.5H2.75a.75.75 0 1 0 0 1.5zM1.632 6.95 5.02 9.358a.4.4 0 0 1-.013.661l-3.39 2.207A.4.4 0 0 1 1 11.892V7.275a.4.4 0 0 1 .632-.326z"/></svg>',
            bC =
              '<svg viewBox="0 0 20 20" xmlns="http://www.w3.org/2000/svg"><path d="M2 3.75c0 .414.336.75.75.75h14.5a.75.75 0 1 0 0-1.5H2.75a.75.75 0 0 0-.75.75zm5 6c0 .414.336.75.75.75h9.5a.75.75 0 1 0 0-1.5h-9.5a.75.75 0 0 0-.75.75zM2.75 16.5h14.5a.75.75 0 1 0 0-1.5H2.75a.75.75 0 1 0 0 1.5zm1.618-9.55L.98 9.358a.4.4 0 0 0 .013.661l3.39 2.207A.4.4 0 0 0 5 11.892V7.275a.4.4 0 0 0-.632-.326z"/></svg>';
          class wC extends j {
            static get pluginName() {
              return "IndentUI";
            }
            init() {
              const t = this.editor,
                e = t.locale,
                n = t.t,
                o = "ltr" == e.uiLanguageDirection ? kC : bC,
                i = "ltr" == e.uiLanguageDirection ? bC : kC;
              this._defineButton("indent", n("Increase indent"), o),
                this._defineButton("outdent", n("Decrease indent"), i);
            }
            _defineButton(t, e, n) {
              const o = this.editor;
              o.ui.componentFactory.add(t, (i) => {
                const r = o.commands.get(t),
                  s = new nm(i);
                return (
                  s.set({ label: e, icon: n, tooltip: !0 }),
                  s.bind("isOn", "isEnabled").to(r, "value", "isEnabled"),
                  this.listenTo(s, "execute", () => {
                    o.execute(t), o.editing.view.focus();
                  }),
                  s
                );
              });
            }
          }
          class AC extends F {
            constructor(t, e) {
              super(t), (this._indentBehavior = e);
            }
            refresh() {
              const t = this.editor.model,
                e = Ra(t.document.selection.getSelectedBlocks());
              e && t.schema.checkAttribute(e, "blockIndent")
                ? (this.isEnabled = this._indentBehavior.checkEnabled(
                    e.getAttribute("blockIndent")
                  ))
                : (this.isEnabled = !1);
            }
            execute() {
              const t = this.editor.model,
                e = (function (t) {
                  const e = t.document.selection,
                    n = t.schema;
                  return Array.from(e.getSelectedBlocks()).filter((t) =>
                    n.checkAttribute(t, "blockIndent")
                  );
                })(t);
              t.change((t) => {
                for (const n of e) {
                  const e = n.getAttribute("blockIndent"),
                    o = this._indentBehavior.getNextIndent(e);
                  o
                    ? t.setAttribute("blockIndent", o, n)
                    : t.removeAttribute("blockIndent", n);
                }
              });
            }
          }
          class _C {
            constructor(t) {
              (this.isForward = "forward" === t.direction),
                (this.offset = t.offset),
                (this.unit = t.unit);
            }
            checkEnabled(t) {
              const e = parseFloat(t || 0);
              return this.isForward || e > 0;
            }
            getNextIndent(t) {
              const e = parseFloat(t || 0);
              if (!(!t || t.endsWith(this.unit)))
                return this.isForward ? this.offset + this.unit : void 0;
              const n = e + (this.isForward ? this.offset : -this.offset);
              return n > 0 ? n + this.unit : void 0;
            }
          }
          class CC {
            constructor(t) {
              (this.isForward = "forward" === t.direction),
                (this.classes = t.classes);
            }
            checkEnabled(t) {
              const e = this.classes.indexOf(t);
              return this.isForward ? e < this.classes.length - 1 : e >= 0;
            }
            getNextIndent(t) {
              const e = this.classes.indexOf(t),
                n = this.isForward ? 1 : -1;
              return this.classes[e + n];
            }
          }
          const vC = [
            "paragraph",
            "heading1",
            "heading2",
            "heading3",
            "heading4",
            "heading5",
            "heading6",
          ];
          const yC = "italic";
          class xC extends j {
            static get pluginName() {
              return "ItalicEditing";
            }
            init() {
              const t = this.editor;
              t.model.schema.extend("$text", { allowAttributes: yC }),
                t.model.schema.setAttributeProperties(yC, {
                  isFormatting: !0,
                  copyOnEnter: !0,
                }),
                t.conversion.attributeToElement({
                  model: yC,
                  view: "i",
                  upcastAlso: ["em", { styles: { "font-style": "italic" } }],
                }),
                t.commands.add(yC, new $k(t, yC)),
                t.keystrokes.set("CTRL+I", yC);
            }
          }
          const EC = "italic";
          class DC extends j {
            static get pluginName() {
              return "ItalicUI";
            }
            init() {
              const t = this.editor,
                e = t.t;
              t.ui.componentFactory.add(EC, (n) => {
                const o = t.commands.get(EC),
                  i = new nm(n);
                return (
                  i.set({
                    label: e("Italic"),
                    icon: '<svg viewBox="0 0 20 20" xmlns="http://www.w3.org/2000/svg"><path d="m9.586 14.633.021.004c-.036.335.095.655.393.962.082.083.173.15.274.201h1.474a.6.6 0 1 1 0 1.2H5.304a.6.6 0 0 1 0-1.2h1.15c.474-.07.809-.182 1.005-.334.157-.122.291-.32.404-.597l2.416-9.55a1.053 1.053 0 0 0-.281-.823 1.12 1.12 0 0 0-.442-.296H8.15a.6.6 0 0 1 0-1.2h6.443a.6.6 0 1 1 0 1.2h-1.195c-.376.056-.65.155-.823.296-.215.175-.423.439-.623.79l-2.366 9.347z"/></svg>',
                    keystroke: "CTRL+I",
                    tooltip: !0,
                    isToggleable: !0,
                  }),
                  i.bind("isOn", "isEnabled").to(o, "value", "isEnabled"),
                  this.listenTo(i, "execute", () => {
                    t.execute(EC), t.editing.view.focus();
                  }),
                  i
                );
              });
            }
          }
          class SC {
            constructor() {
              this._definitions = new Set();
            }
            get length() {
              return this._definitions.size;
            }
            add(t) {
              Array.isArray(t)
                ? t.forEach((t) => this._definitions.add(t))
                : this._definitions.add(t);
            }
            getDispatcher() {
              return (t) => {
                t.on(
                  "attribute:linkHref",
                  (t, e, n) => {
                    if (!n.consumable.test(e.item, "attribute:linkHref"))
                      return;
                    if (!e.item.is("selection") && !n.schema.isInline(e.item))
                      return;
                    const o = n.writer,
                      i = o.document.selection;
                    for (const t of this._definitions) {
                      const r = o.createAttributeElement("a", t.attributes, {
                        priority: 5,
                      });
                      t.classes && o.addClass(t.classes, r);
                      for (const e in t.styles) o.setStyle(e, t.styles[e], r);
                      o.setCustomProperty("link", !0, r),
                        t.callback(e.attributeNewValue)
                          ? e.item.is("selection")
                            ? o.wrap(i.getFirstRange(), r)
                            : o.wrap(n.mapper.toViewRange(e.range), r)
                          : o.unwrap(n.mapper.toViewRange(e.range), r);
                    }
                  },
                  { priority: "high" }
                );
              };
            }
            getDispatcherForLinkedImage() {
              return (t) => {
                t.on(
                  "attribute:linkHref:imageBlock",
                  (t, e, { writer: n, mapper: o }) => {
                    const i = o.toViewElement(e.item),
                      r = Array.from(i.getChildren()).find(
                        (t) => "a" === t.name
                      );
                    for (const t of this._definitions) {
                      const o = Bo(t.attributes);
                      if (t.callback(e.attributeNewValue)) {
                        for (const [t, e] of o)
                          "class" === t
                            ? n.addClass(e, r)
                            : n.setAttribute(t, e, r);
                        t.classes && n.addClass(t.classes, r);
                        for (const e in t.styles) n.setStyle(e, t.styles[e], r);
                      } else {
                        for (const [t, e] of o)
                          "class" === t
                            ? n.removeClass(e, r)
                            : n.removeAttribute(t, r);
                        t.classes && n.removeClass(t.classes, r);
                        for (const e in t.styles) n.removeStyle(e, r);
                      }
                    }
                  }
                );
              };
            }
          }
          class IC extends F {
            constructor(t) {
              super(t),
                (this.manualDecorators = new po()),
                (this.automaticDecorators = new SC());
            }
            restoreManualDecoratorStates() {
              for (const t of this.manualDecorators)
                t.value = this._getDecoratorStateFromModel(t.id);
            }
            refresh() {
              const t = this.editor.model,
                e = t.document.selection,
                n = e.getSelectedElement() || Ra(e.getSelectedBlocks());
              Ek(n, t.schema)
                ? ((this.value = n.getAttribute("linkHref")),
                  (this.isEnabled = t.schema.checkAttribute(n, "linkHref")))
                : ((this.value = e.getAttribute("linkHref")),
                  (this.isEnabled = t.schema.checkAttributeInSelection(
                    e,
                    "linkHref"
                  )));
              for (const t of this.manualDecorators)
                t.value = this._getDecoratorStateFromModel(t.id);
            }
            execute(t, e = {}) {
              const n = this.editor.model,
                o = n.document.selection,
                i = [],
                r = [];
              for (const t in e) e[t] ? i.push(t) : r.push(t);
              n.change((e) => {
                if (o.isCollapsed) {
                  const s = o.getFirstPosition();
                  if (o.hasAttribute("linkHref")) {
                    const a = yp(s, "linkHref", o.getAttribute("linkHref"), n);
                    e.setAttribute("linkHref", t, a),
                      i.forEach((t) => {
                        e.setAttribute(t, !0, a);
                      }),
                      r.forEach((t) => {
                        e.removeAttribute(t, a);
                      }),
                      e.setSelection(e.createPositionAfter(a.end.nodeBefore));
                  } else if ("" !== t) {
                    const r = Bo(o.getAttributes());
                    r.set("linkHref", t),
                      i.forEach((t) => {
                        r.set(t, !0);
                      });
                    const { end: a } = n.insertContent(e.createText(t, r), s);
                    e.setSelection(a);
                  }
                  ["linkHref", ...i, ...r].forEach((t) => {
                    e.removeSelectionAttribute(t);
                  });
                } else {
                  const s = n.schema.getValidRanges(o.getRanges(), "linkHref"),
                    a = [];
                  for (const t of o.getSelectedBlocks())
                    n.schema.checkAttribute(t, "linkHref") &&
                      a.push(e.createRangeOn(t));
                  const l = a.slice();
                  for (const t of s) this._isRangeToUpdate(t, a) && l.push(t);
                  for (const n of l)
                    e.setAttribute("linkHref", t, n),
                      i.forEach((t) => {
                        e.setAttribute(t, !0, n);
                      }),
                      r.forEach((t) => {
                        e.removeAttribute(t, n);
                      });
                }
              });
            }
            _getDecoratorStateFromModel(t) {
              const e = this.editor.model,
                n = e.document.selection,
                o = n.getSelectedElement();
              return Ek(o, e.schema) ? o.getAttribute(t) : n.getAttribute(t);
            }
            _isRangeToUpdate(t, e) {
              for (const n of e) if (n.containsRange(t)) return !1;
              return !0;
            }
          }
          class TC extends F {
            refresh() {
              const t = this.editor.model,
                e = t.document.selection,
                n = e.getSelectedElement();
              Ek(n, t.schema)
                ? (this.isEnabled = t.schema.checkAttribute(n, "linkHref"))
                : (this.isEnabled = t.schema.checkAttributeInSelection(
                    e,
                    "linkHref"
                  ));
            }
            execute() {
              const t = this.editor,
                e = this.editor.model,
                n = e.document.selection,
                o = t.commands.get("link");
              e.change((t) => {
                const i = n.isCollapsed
                  ? [
                      yp(
                        n.getFirstPosition(),
                        "linkHref",
                        n.getAttribute("linkHref"),
                        e
                      ),
                    ]
                  : e.schema.getValidRanges(n.getRanges(), "linkHref");
                for (const e of i)
                  if ((t.removeAttribute("linkHref", e), o))
                    for (const n of o.manualDecorators)
                      t.removeAttribute(n.id, e);
              });
            }
          }
          class MC {
            constructor({
              id: t,
              label: e,
              attributes: n,
              classes: o,
              styles: i,
              defaultValue: r,
            }) {
              (this.id = t),
                this.set("value"),
                (this.defaultValue = r),
                (this.label = e),
                (this.attributes = n),
                (this.classes = o),
                (this.styles = i);
            }
            _createPattern() {
              return {
                attributes: this.attributes,
                classes: this.classes,
                styles: this.styles,
              };
            }
          }
          ya(MC, B);
          var BC = n(399),
            NC = { attributes: { "data-cke": !0 } };
          (NC.setAttributes = is()),
            (NC.insert = ns().bind(null, "head")),
            (NC.domAPI = ts()),
            (NC.insertStyleElement = ss());
          Jr()(BC.Z, NC);
          BC.Z && BC.Z.locals && BC.Z.locals;
          const zC = "automatic",
            PC = /^(https?:)?\/\//;
          class LC extends j {
            static get pluginName() {
              return "LinkEditing";
            }
            static get requires() {
              return [cp, Kg, zp];
            }
            constructor(t) {
              super(t),
                t.config.define("link", { addTargetToExternalLinks: !1 });
            }
            init() {
              const t = this.editor;
              t.model.schema.extend("$text", { allowAttributes: "linkHref" }),
                t.conversion
                  .for("dataDowncast")
                  .attributeToElement({ model: "linkHref", view: yk }),
                t.conversion
                  .for("editingDowncast")
                  .attributeToElement({
                    model: "linkHref",
                    view: (t, e) => yk(xk(t), e),
                  }),
                t.conversion
                  .for("upcast")
                  .elementToAttribute({
                    view: { name: "a", attributes: { href: !0 } },
                    model: {
                      key: "linkHref",
                      value: (t) => t.getAttribute("href"),
                    },
                  }),
                t.commands.add("link", new IC(t)),
                t.commands.add("unlink", new TC(t));
              const e = (function (t, e) {
                const n = {
                  "Open in a new tab": t("Open in a new tab"),
                  Downloadable: t("Downloadable"),
                };
                return (
                  e.forEach(
                    (t) => (t.label && n[t.label] && (t.label = n[t.label]), t)
                  ),
                  e
                );
              })(
                t.t,
                (function (t) {
                  const e = [];
                  if (t)
                    for (const [n, o] of Object.entries(t)) {
                      const t = Object.assign({}, o, { id: `link${bk(n)}` });
                      e.push(t);
                    }
                  return e;
                })(t.config.get("link.decorators"))
              );
              this._enableAutomaticDecorators(e.filter((t) => t.mode === zC)),
                this._enableManualDecorators(
                  e.filter((t) => "manual" === t.mode)
                );
              t.plugins.get(cp).registerAttribute("linkHref"),
                Ep(t, "linkHref", "a", "ck-link_selected"),
                this._enableLinkOpen(),
                this._enableInsertContentSelectionAttributesFixer(),
                this._enableClickingAfterLink(),
                this._enableTypingOverLink(),
                this._handleDeleteContentAfterLink();
            }
            _enableAutomaticDecorators(t) {
              const e = this.editor,
                n = e.commands.get("link").automaticDecorators;
              e.config.get("link.addTargetToExternalLinks") &&
                n.add({
                  id: "linkIsExternal",
                  mode: zC,
                  callback: (t) => PC.test(t),
                  attributes: { target: "_blank", rel: "noopener noreferrer" },
                }),
                n.add(t),
                n.length && e.conversion.for("downcast").add(n.getDispatcher());
            }
            _enableManualDecorators(t) {
              if (!t.length) return;
              const e = this.editor,
                n = e.commands.get("link").manualDecorators;
              t.forEach((t) => {
                e.model.schema.extend("$text", { allowAttributes: t.id }),
                  (t = new MC(t)),
                  n.add(t),
                  e.conversion.for("downcast").attributeToElement({
                    model: t.id,
                    view: (e, { writer: n, schema: o }, { item: i }) => {
                      if ((i.is("selection") || o.isInline(i)) && e) {
                        const e = n.createAttributeElement("a", t.attributes, {
                          priority: 5,
                        });
                        t.classes && n.addClass(t.classes, e);
                        for (const o in t.styles) n.setStyle(o, t.styles[o], e);
                        return n.setCustomProperty("link", !0, e), e;
                      }
                    },
                  }),
                  e.conversion
                    .for("upcast")
                    .elementToAttribute({
                      view: { name: "a", ...t._createPattern() },
                      model: { key: t.id },
                    });
              });
            }
            _enableLinkOpen() {
              const t = this.editor,
                e = t.editing.view.document;
              this.listenTo(
                e,
                "click",
                (t, e) => {
                  if (!(ar.isMac ? e.domEvent.metaKey : e.domEvent.ctrlKey))
                    return;
                  let n = e.domTarget;
                  if (
                    ("a" != n.tagName.toLowerCase() && (n = n.closest("a")), !n)
                  )
                    return;
                  const o = n.getAttribute("href");
                  o && (t.stop(), e.preventDefault(), Ik(o));
                },
                { context: "$capture" }
              ),
                this.listenTo(e, "keydown", (e, n) => {
                  const o = t.commands.get("link").value;
                  o && n.keyCode === ur.enter && n.altKey && (e.stop(), Ik(o));
                });
            }
            _enableInsertContentSelectionAttributesFixer() {
              const t = this.editor.model,
                e = t.document.selection;
              this.listenTo(
                t,
                "insertContent",
                () => {
                  const n = e.anchor.nodeBefore,
                    o = e.anchor.nodeAfter;
                  e.hasAttribute("linkHref") &&
                    n &&
                    n.hasAttribute("linkHref") &&
                    ((o && o.hasAttribute("linkHref")) ||
                      t.change((e) => {
                        RC(e, jC(t.schema));
                      }));
                },
                { priority: "low" }
              );
            }
            _enableClickingAfterLink() {
              const t = this.editor,
                e = t.model;
              t.editing.view.addObserver(tu);
              let n = !1;
              this.listenTo(t.editing.view.document, "mousedown", () => {
                n = !0;
              }),
                this.listenTo(
                  t.editing.view.document,
                  "selectionChange",
                  () => {
                    if (!n) return;
                    n = !1;
                    const t = e.document.selection;
                    if (!t.isCollapsed) return;
                    if (!t.hasAttribute("linkHref")) return;
                    const o = t.getFirstPosition(),
                      i = yp(o, "linkHref", t.getAttribute("linkHref"), e);
                    (o.isTouching(i.start) || o.isTouching(i.end)) &&
                      e.change((t) => {
                        RC(t, jC(e.schema));
                      });
                  }
                );
            }
            _enableTypingOverLink() {
              const t = this.editor,
                e = t.editing.view;
              let n, o;
              this.listenTo(
                e.document,
                "delete",
                () => {
                  o = !0;
                },
                { priority: "high" }
              ),
                this.listenTo(
                  t.model,
                  "deleteContent",
                  () => {
                    const e = t.model.document.selection;
                    e.isCollapsed ||
                      (o
                        ? (o = !1)
                        : OC(t) &&
                          (function (t) {
                            const e = t.document.selection,
                              n = e.getFirstPosition(),
                              o = e.getLastPosition(),
                              i = n.nodeAfter;
                            if (!i) return !1;
                            if (!i.is("$text")) return !1;
                            if (!i.hasAttribute("linkHref")) return !1;
                            const r = o.textNode || o.nodeBefore;
                            if (i === r) return !0;
                            return yp(
                              n,
                              "linkHref",
                              i.getAttribute("linkHref"),
                              t
                            ).containsRange(t.createRange(n, o), !0);
                          })(t.model) &&
                          (n = e.getAttributes()));
                  },
                  { priority: "high" }
                ),
                this.listenTo(
                  t.model,
                  "insertContent",
                  (e, [i]) => {
                    (o = !1),
                      OC(t) &&
                        n &&
                        (t.model.change((t) => {
                          for (const [e, o] of n) t.setAttribute(e, o, i);
                        }),
                        (n = null));
                  },
                  { priority: "high" }
                );
            }
            _handleDeleteContentAfterLink() {
              const t = this.editor,
                e = t.model,
                n = e.document.selection,
                o = t.editing.view;
              let i = !1,
                r = !1;
              this.listenTo(
                o.document,
                "delete",
                (t, e) => {
                  r = "backward" === e.direction;
                },
                { priority: "high" }
              ),
                this.listenTo(
                  e,
                  "deleteContent",
                  () => {
                    i = !1;
                    const t = n.getFirstPosition(),
                      o = n.getAttribute("linkHref");
                    if (!o) return;
                    const r = yp(t, "linkHref", o, e);
                    i = r.containsPosition(t) || r.end.isEqual(t);
                  },
                  { priority: "high" }
                ),
                this.listenTo(
                  e,
                  "deleteContent",
                  () => {
                    r &&
                      ((r = !1),
                      i ||
                        t.model.enqueueChange((t) => {
                          RC(t, jC(e.schema));
                        }));
                  },
                  { priority: "low" }
                );
            }
          }
          function RC(t, e) {
            t.removeSelectionAttribute("linkHref");
            for (const n of e) t.removeSelectionAttribute(n);
          }
          function OC(t) {
            return t.model.change((t) => t.batch).isTyping;
          }
          function jC(t) {
            return t
              .getDefinition("$text")
              .allowAttributes.filter((t) => t.startsWith("link"));
          }
          var VC = n(4827),
            FC = { attributes: { "data-cke": !0 } };
          (FC.setAttributes = is()),
            (FC.insert = ns().bind(null, "head")),
            (FC.domAPI = ts()),
            (FC.insertStyleElement = ss());
          Jr()(VC.Z, FC);
          VC.Z && VC.Z.locals && VC.Z.locals;
          class HC extends Ch {
            constructor(t, e) {
              super(t);
              const n = t.t;
              (this.focusTracker = new Oa()),
                (this.keystrokes = new ja()),
                (this.urlInputView = this._createUrlInput()),
                (this.saveButtonView = this._createButton(
                  n("Save"),
                  $h.check,
                  "ck-button-save"
                )),
                (this.saveButtonView.type = "submit"),
                (this.cancelButtonView = this._createButton(
                  n("Cancel"),
                  $h.cancel,
                  "ck-button-cancel",
                  "cancel"
                )),
                (this._manualDecoratorSwitches =
                  this._createManualDecoratorSwitches(e)),
                (this.children = this._createFormChildren(e.manualDecorators)),
                (this._focusables = new Ju()),
                (this._focusCycler = new Cm({
                  focusables: this._focusables,
                  focusTracker: this.focusTracker,
                  keystrokeHandler: this.keystrokes,
                  actions: { focusPrevious: "shift + tab", focusNext: "tab" },
                }));
              const o = ["ck", "ck-link-form", "ck-responsive-form"];
              e.manualDecorators.length &&
                o.push("ck-link-form_layout-vertical", "ck-vertical-form"),
                this.setTemplate({
                  tag: "form",
                  attributes: { class: o, tabindex: "-1" },
                  children: this.children,
                }),
                Gh(this);
            }
            getDecoratorSwitchesState() {
              return Array.from(this._manualDecoratorSwitches).reduce(
                (t, e) => ((t[e.name] = e.isOn), t),
                {}
              );
            }
            render() {
              super.render(), Zh({ view: this });
              [
                this.urlInputView,
                ...this._manualDecoratorSwitches,
                this.saveButtonView,
                this.cancelButtonView,
              ].forEach((t) => {
                this._focusables.add(t), this.focusTracker.add(t.element);
              }),
                this.keystrokes.listenTo(this.element);
            }
            destroy() {
              super.destroy(),
                this.focusTracker.destroy(),
                this.keystrokes.destroy();
            }
            focus() {
              this._focusCycler.focusFirst();
            }
            _createUrlInput() {
              const t = this.locale.t,
                e = new hg(this.locale, mg);
              return (e.label = t("Link URL")), e;
            }
            _createButton(t, e, n, o) {
              const i = new nm(this.locale);
              return (
                i.set({ label: t, icon: e, tooltip: !0 }),
                i.extendTemplate({ attributes: { class: n } }),
                o && i.delegate("execute").to(this, o),
                i
              );
            }
            _createManualDecoratorSwitches(t) {
              const e = this.createCollection();
              for (const n of t.manualDecorators) {
                const o = new rm(this.locale);
                o.set({ name: n.id, label: n.label, withText: !0 }),
                  o
                    .bind("isOn")
                    .toMany([n, t], "value", (t, e) =>
                      void 0 === e && void 0 === t ? n.defaultValue : t
                    ),
                  o.on("execute", () => {
                    n.set("value", !o.isOn);
                  }),
                  e.add(o);
              }
              return e;
            }
            _createFormChildren(t) {
              const e = this.createCollection();
              if ((e.add(this.urlInputView), t.length)) {
                const t = new Ch();
                t.setTemplate({
                  tag: "ul",
                  children: this._manualDecoratorSwitches.map((t) => ({
                    tag: "li",
                    children: [t],
                    attributes: { class: ["ck", "ck-list__item"] },
                  })),
                  attributes: { class: ["ck", "ck-reset", "ck-list"] },
                }),
                  e.add(t);
              }
              return (
                e.add(this.saveButtonView), e.add(this.cancelButtonView), e
              );
            }
          }
          var UC = n(9465),
            WC = { attributes: { "data-cke": !0 } };
          (WC.setAttributes = is()),
            (WC.insert = ns().bind(null, "head")),
            (WC.domAPI = ts()),
            (WC.insertStyleElement = ss());
          Jr()(UC.Z, WC);
          UC.Z && UC.Z.locals && UC.Z.locals;
          class $C extends Ch {
            constructor(t) {
              super(t);
              const e = t.t;
              (this.focusTracker = new Oa()),
                (this.keystrokes = new ja()),
                (this.previewButtonView = this._createPreviewButton()),
                (this.unlinkButtonView = this._createButton(
                  e("Unlink"),
                  '<svg viewBox="0 0 20 20" xmlns="http://www.w3.org/2000/svg"><path d="m11.077 15 .991-1.416a.75.75 0 1 1 1.229.86l-1.148 1.64a.748.748 0 0 1-.217.206 5.251 5.251 0 0 1-8.503-5.955.741.741 0 0 1 .12-.274l1.147-1.639a.75.75 0 1 1 1.228.86L4.933 10.7l.006.003a3.75 3.75 0 0 0 6.132 4.294l.006.004zm5.494-5.335a.748.748 0 0 1-.12.274l-1.147 1.639a.75.75 0 1 1-1.228-.86l.86-1.23a3.75 3.75 0 0 0-6.144-4.301l-.86 1.229a.75.75 0 0 1-1.229-.86l1.148-1.64a.748.748 0 0 1 .217-.206 5.251 5.251 0 0 1 8.503 5.955zm-4.563-2.532a.75.75 0 0 1 .184 1.045l-3.155 4.505a.75.75 0 1 1-1.229-.86l3.155-4.506a.75.75 0 0 1 1.045-.184zm4.919 10.562-1.414 1.414a.75.75 0 1 1-1.06-1.06l1.414-1.415-1.415-1.414a.75.75 0 0 1 1.061-1.06l1.414 1.414 1.414-1.415a.75.75 0 0 1 1.061 1.061l-1.414 1.414 1.414 1.415a.75.75 0 0 1-1.06 1.06l-1.415-1.414z"/></svg>',
                  "unlink"
                )),
                (this.editButtonView = this._createButton(
                  e("Edit link"),
                  $h.pencil,
                  "edit"
                )),
                this.set("href"),
                (this._focusables = new Ju()),
                (this._focusCycler = new Cm({
                  focusables: this._focusables,
                  focusTracker: this.focusTracker,
                  keystrokeHandler: this.keystrokes,
                  actions: { focusPrevious: "shift + tab", focusNext: "tab" },
                })),
                this.setTemplate({
                  tag: "div",
                  attributes: {
                    class: ["ck", "ck-link-actions", "ck-responsive-form"],
                    tabindex: "-1",
                  },
                  children: [
                    this.previewButtonView,
                    this.editButtonView,
                    this.unlinkButtonView,
                  ],
                });
            }
            render() {
              super.render();
              [
                this.previewButtonView,
                this.editButtonView,
                this.unlinkButtonView,
              ].forEach((t) => {
                this._focusables.add(t), this.focusTracker.add(t.element);
              }),
                this.keystrokes.listenTo(this.element);
            }
            destroy() {
              super.destroy(),
                this.focusTracker.destroy(),
                this.keystrokes.destroy();
            }
            focus() {
              this._focusCycler.focusFirst();
            }
            _createButton(t, e, n) {
              const o = new nm(this.locale);
              return (
                o.set({ label: t, icon: e, tooltip: !0 }),
                o.delegate("execute").to(this, n),
                o
              );
            }
            _createPreviewButton() {
              const t = new nm(this.locale),
                e = this.bindTemplate,
                n = this.t;
              return (
                t.set({ withText: !0, tooltip: n("Open link in new tab") }),
                t.extendTemplate({
                  attributes: {
                    class: ["ck", "ck-link-actions__preview"],
                    href: e.to("href", (t) => t && xk(t)),
                    target: "_blank",
                    rel: "noopener noreferrer",
                  },
                }),
                t
                  .bind("label")
                  .to(this, "href", (t) => t || n("This link has no URL")),
                t.bind("isEnabled").to(this, "href", (t) => !!t),
                (t.template.tag = "a"),
                (t.template.eventListeners = {}),
                t
              );
            }
          }
          const qC =
              '<svg viewBox="0 0 20 20" xmlns="http://www.w3.org/2000/svg"><path d="m11.077 15 .991-1.416a.75.75 0 1 1 1.229.86l-1.148 1.64a.748.748 0 0 1-.217.206 5.251 5.251 0 0 1-8.503-5.955.741.741 0 0 1 .12-.274l1.147-1.639a.75.75 0 1 1 1.228.86L4.933 10.7l.006.003a3.75 3.75 0 0 0 6.132 4.294l.006.004zm5.494-5.335a.748.748 0 0 1-.12.274l-1.147 1.639a.75.75 0 1 1-1.228-.86l.86-1.23a3.75 3.75 0 0 0-6.144-4.301l-.86 1.229a.75.75 0 0 1-1.229-.86l1.148-1.64a.748.748 0 0 1 .217-.206 5.251 5.251 0 0 1 8.503 5.955zm-4.563-2.532a.75.75 0 0 1 .184 1.045l-3.155 4.505a.75.75 0 1 1-1.229-.86l3.155-4.506a.75.75 0 0 1 1.045-.184z"/></svg>',
            GC = "link-ui";
          class ZC extends j {
            static get requires() {
              return [vg];
            }
            static get pluginName() {
              return "LinkUI";
            }
            init() {
              const t = this.editor;
              t.editing.view.addObserver(Xd),
                (this.actionsView = this._createActionsView()),
                (this.formView = this._createFormView()),
                (this._balloon = t.plugins.get(vg)),
                this._createToolbarLinkButton(),
                this._enableUserBalloonInteractions(),
                t.conversion
                  .for("editingDowncast")
                  .markerToHighlight({
                    model: GC,
                    view: { classes: ["ck-fake-link-selection"] },
                  }),
                t.conversion
                  .for("editingDowncast")
                  .markerToElement({
                    model: GC,
                    view: {
                      name: "span",
                      classes: [
                        "ck-fake-link-selection",
                        "ck-fake-link-selection_collapsed",
                      ],
                    },
                  });
            }
            destroy() {
              super.destroy(), this.formView.destroy();
            }
            _createActionsView() {
              const t = this.editor,
                e = new $C(t.locale),
                n = t.commands.get("link"),
                o = t.commands.get("unlink");
              return (
                e.bind("href").to(n, "value"),
                e.editButtonView.bind("isEnabled").to(n),
                e.unlinkButtonView.bind("isEnabled").to(o),
                this.listenTo(e, "edit", () => {
                  this._addFormView();
                }),
                this.listenTo(e, "unlink", () => {
                  t.execute("unlink"), this._hideUI();
                }),
                e.keystrokes.set("Esc", (t, e) => {
                  this._hideUI(), e();
                }),
                e.keystrokes.set(vk, (t, e) => {
                  this._addFormView(), e();
                }),
                e
              );
            }
            _createFormView() {
              const t = this.editor,
                e = t.commands.get("link"),
                n = t.config.get("link.defaultProtocol"),
                o = new HC(t.locale, e);
              return (
                o.urlInputView.fieldView.bind("value").to(e, "value"),
                o.urlInputView.bind("isReadOnly").to(e, "isEnabled", (t) => !t),
                o.saveButtonView.bind("isEnabled").to(e),
                this.listenTo(o, "submit", () => {
                  const { value: e } = o.urlInputView.fieldView.element,
                    i = Dk(e, n);
                  t.execute("link", i, o.getDecoratorSwitchesState()),
                    this._closeFormView();
                }),
                this.listenTo(o, "cancel", () => {
                  this._closeFormView();
                }),
                o.keystrokes.set("Esc", (t, e) => {
                  this._closeFormView(), e();
                }),
                o
              );
            }
            _createToolbarLinkButton() {
              const t = this.editor,
                e = t.commands.get("link"),
                n = t.t;
              t.keystrokes.set(vk, (t, n) => {
                n(), e.isEnabled && this._showUI(!0);
              }),
                t.ui.componentFactory.add("link", (t) => {
                  const o = new nm(t);
                  return (
                    (o.isEnabled = !0),
                    (o.label = n("Link")),
                    (o.icon = qC),
                    (o.keystroke = vk),
                    (o.tooltip = !0),
                    (o.isToggleable = !0),
                    o.bind("isEnabled").to(e, "isEnabled"),
                    o.bind("isOn").to(e, "value", (t) => !!t),
                    this.listenTo(o, "execute", () => this._showUI(!0)),
                    o
                  );
                });
            }
            _enableUserBalloonInteractions() {
              const t = this.editor.editing.view.document;
              this.listenTo(t, "click", () => {
                this._getSelectedLinkElement() && this._showUI();
              }),
                this.editor.keystrokes.set(
                  "Tab",
                  (t, e) => {
                    this._areActionsVisible &&
                      !this.actionsView.focusTracker.isFocused &&
                      (this.actionsView.focus(), e());
                  },
                  { priority: "high" }
                ),
                this.editor.keystrokes.set("Esc", (t, e) => {
                  this._isUIVisible && (this._hideUI(), e());
                }),
                qh({
                  emitter: this.formView,
                  activator: () => this._isUIInPanel,
                  contextElements: [this._balloon.view.element],
                  callback: () => this._hideUI(),
                });
            }
            _addActionsView() {
              this._areActionsInPanel ||
                this._balloon.add({
                  view: this.actionsView,
                  position: this._getBalloonPositionData(),
                });
            }
            _addFormView() {
              if (this._isFormInPanel) return;
              const t = this.editor.commands.get("link");
              this.formView.disableCssTransitions(),
                this._balloon.add({
                  view: this.formView,
                  position: this._getBalloonPositionData(),
                }),
                this._balloon.visibleView === this.formView &&
                  this.formView.urlInputView.fieldView.select(),
                this.formView.enableCssTransitions(),
                (this.formView.urlInputView.fieldView.element.value =
                  t.value || "");
            }
            _closeFormView() {
              const t = this.editor.commands.get("link");
              t.restoreManualDecoratorStates(),
                void 0 !== t.value ? this._removeFormView() : this._hideUI();
            }
            _removeFormView() {
              this._isFormInPanel &&
                (this.formView.saveButtonView.focus(),
                this._balloon.remove(this.formView),
                this.editor.editing.view.focus(),
                this._hideFakeVisualSelection());
            }
            _showUI(t = !1) {
              this._getSelectedLinkElement()
                ? (this._areActionsVisible
                    ? this._addFormView()
                    : this._addActionsView(),
                  t && this._balloon.showStack("main"))
                : (this._showFakeVisualSelection(),
                  this._addActionsView(),
                  t && this._balloon.showStack("main"),
                  this._addFormView()),
                this._startUpdatingUI();
            }
            _hideUI() {
              if (!this._isUIInPanel) return;
              const t = this.editor;
              this.stopListening(t.ui, "update"),
                this.stopListening(this._balloon, "change:visibleView"),
                t.editing.view.focus(),
                this._removeFormView(),
                this._balloon.remove(this.actionsView),
                this._hideFakeVisualSelection();
            }
            _startUpdatingUI() {
              const t = this.editor,
                e = t.editing.view.document;
              let n = this._getSelectedLinkElement(),
                o = r();
              const i = () => {
                const t = this._getSelectedLinkElement(),
                  e = r();
                (n && !t) || (!n && e !== o)
                  ? this._hideUI()
                  : this._isUIVisible &&
                    this._balloon.updatePosition(
                      this._getBalloonPositionData()
                    ),
                  (n = t),
                  (o = e);
              };
              function r() {
                return e.selection.focus
                  .getAncestors()
                  .reverse()
                  .find((t) => t.is("element"));
              }
              this.listenTo(t.ui, "update", i),
                this.listenTo(this._balloon, "change:visibleView", i);
            }
            get _isFormInPanel() {
              return this._balloon.hasView(this.formView);
            }
            get _areActionsInPanel() {
              return this._balloon.hasView(this.actionsView);
            }
            get _areActionsVisible() {
              return this._balloon.visibleView === this.actionsView;
            }
            get _isUIInPanel() {
              return this._isFormInPanel || this._areActionsInPanel;
            }
            get _isUIVisible() {
              return (
                this._balloon.visibleView == this.formView ||
                this._areActionsVisible
              );
            }
            _getBalloonPositionData() {
              const t = this.editor.editing.view,
                e = this.editor.model,
                n = t.document;
              let o = null;
              if (e.markers.has(GC)) {
                const e = Array.from(
                    this.editor.editing.mapper.markerNameToElements(GC)
                  ),
                  n = t.createRange(
                    t.createPositionBefore(e[0]),
                    t.createPositionAfter(e[e.length - 1])
                  );
                o = t.domConverter.viewRangeToDom(n);
              } else
                o = () => {
                  const e = this._getSelectedLinkElement();
                  return e
                    ? t.domConverter.mapViewToDom(e)
                    : t.domConverter.viewRangeToDom(
                        n.selection.getFirstRange()
                      );
                };
              return { target: o };
            }
            _getSelectedLinkElement() {
              const t = this.editor.editing.view,
                e = t.document.selection,
                n = e.getSelectedElement();
              if (e.isCollapsed || (n && Gp(n)))
                return YC(e.getFirstPosition());
              {
                const n = e.getFirstRange().getTrimmed(),
                  o = YC(n.start),
                  i = YC(n.end);
                return o && o == i && t.createRangeIn(o).getTrimmed().isEqual(n)
                  ? o
                  : null;
              }
            }
            _showFakeVisualSelection() {
              const t = this.editor.model;
              t.change((e) => {
                const n = t.document.selection.getFirstRange();
                if (t.markers.has(GC)) e.updateMarker(GC, { range: n });
                else if (n.start.isAtEnd) {
                  const o = n.start.getLastMatchingPosition(
                    ({ item: e }) => !t.schema.isContent(e),
                    { boundaries: n }
                  );
                  e.addMarker(GC, {
                    usingOperation: !1,
                    affectsData: !1,
                    range: e.createRange(o, n.end),
                  });
                } else
                  e.addMarker(GC, {
                    usingOperation: !1,
                    affectsData: !1,
                    range: n,
                  });
              });
            }
            _hideFakeVisualSelection() {
              const t = this.editor.model;
              t.markers.has(GC) &&
                t.change((t) => {
                  t.removeMarker(GC);
                });
            }
          }
          function YC(t) {
            return t.getAncestors().find((t) => {
              return (
                (e = t).is("attributeElement") && !!e.getCustomProperty("link")
              );
              var e;
            });
          }
          class KC extends j {
            static get requires() {
              return ["ImageEditing", "ImageUtils", LC];
            }
            static get pluginName() {
              return "LinkImageEditing";
            }
            init() {
              const t = this.editor,
                e = t.model.schema;
              t.plugins.has("ImageBlockEditing") &&
                e.extend("imageBlock", { allowAttributes: ["linkHref"] }),
                t.conversion.for("upcast").add(
                  (function (t) {
                    const e = t.plugins.has("ImageInlineEditing"),
                      n = t.plugins.get("ImageUtils");
                    return (t) => {
                      t.on(
                        "element:a",
                        (t, o, i) => {
                          const r = o.viewItem,
                            s = n.findViewImgElement(r);
                          if (!s) return;
                          const a = s.findAncestor((t) =>
                            n.isBlockImageView(t)
                          );
                          if (e && !a) return;
                          const l = { attributes: ["href"] };
                          if (!i.consumable.consume(r, l)) return;
                          const c = r.getAttribute("href");
                          if (!c) return;
                          let d = o.modelCursor.parent;
                          if (!d.is("element", "imageBlock")) {
                            const t = i.convertItem(s, o.modelCursor);
                            (o.modelRange = t.modelRange),
                              (o.modelCursor = t.modelCursor),
                              (d = o.modelCursor.nodeBefore);
                          }
                          d &&
                            d.is("element", "imageBlock") &&
                            i.writer.setAttribute("linkHref", c, d);
                        },
                        { priority: "high" }
                      );
                    };
                  })(t)
                ),
                t.conversion.for("downcast").add(
                  (function (t) {
                    const e = t.plugins.get("ImageUtils");
                    return (t) => {
                      t.on(
                        "attribute:linkHref:imageBlock",
                        (t, n, o) => {
                          if (!o.consumable.consume(n.item, t.name)) return;
                          const i = o.mapper.toViewElement(n.item),
                            r = o.writer,
                            s = Array.from(i.getChildren()).find(
                              (t) => "a" === t.name
                            ),
                            a = e.findViewImgElement(i),
                            l = a.parent.is("element", "picture")
                              ? a.parent
                              : a;
                          if (s)
                            n.attributeNewValue
                              ? r.setAttribute("href", n.attributeNewValue, s)
                              : (r.move(
                                  r.createRangeOn(l),
                                  r.createPositionAt(i, 0)
                                ),
                                r.remove(s));
                          else {
                            const t = r.createContainerElement("a", {
                              href: n.attributeNewValue,
                            });
                            r.insert(r.createPositionAt(i, 0), t),
                              r.move(
                                r.createRangeOn(l),
                                r.createPositionAt(t, 0)
                              );
                          }
                        },
                        { priority: "high" }
                      );
                    };
                  })(t)
                ),
                this._enableAutomaticDecorators(),
                this._enableManualDecorators();
            }
            _enableAutomaticDecorators() {
              const t = this.editor,
                e = t.commands.get("link").automaticDecorators;
              e.length &&
                t.conversion
                  .for("downcast")
                  .add(e.getDispatcherForLinkedImage());
            }
            _enableManualDecorators() {
              const t = this.editor,
                e = t.commands.get("link");
              for (const n of e.manualDecorators)
                t.plugins.has("ImageBlockEditing") &&
                  t.model.schema.extend("imageBlock", {
                    allowAttributes: n.id,
                  }),
                  t.plugins.has("ImageInlineEditing") &&
                    t.model.schema.extend("imageInline", {
                      allowAttributes: n.id,
                    }),
                  t.conversion.for("downcast").add(QC(n)),
                  t.conversion.for("upcast").add(JC(t, n));
            }
          }
          function QC(t) {
            return (e) => {
              e.on(`attribute:${t.id}:imageBlock`, (e, n, o) => {
                const i = o.mapper.toViewElement(n.item),
                  r = Array.from(i.getChildren()).find((t) => "a" === t.name);
                if (r) {
                  for (const [e, n] of Bo(t.attributes))
                    o.writer.setAttribute(e, n, r);
                  t.classes && o.writer.addClass(t.classes, r);
                  for (const e in t.styles)
                    o.writer.setStyle(e, t.styles[e], r);
                }
              });
            };
          }
          function JC(t, e) {
            const n = t.plugins.has("ImageInlineEditing"),
              o = t.plugins.get("ImageUtils");
            return (t) => {
              t.on(
                "element:a",
                (t, i, r) => {
                  const s = i.viewItem,
                    a = o.findViewImgElement(s);
                  if (!a) return;
                  const l = a.findAncestor((t) => o.isBlockImageView(t));
                  if (n && !l) return;
                  const c = new No(e._createPattern()).match(s);
                  if (!c) return;
                  if (!r.consumable.consume(s, c.match)) return;
                  const d = i.modelCursor.nodeBefore || i.modelCursor.parent;
                  r.writer.setAttribute(e.id, !0, d);
                },
                { priority: "high" }
              );
            };
          }
          class XC extends j {
            static get requires() {
              return [LC, ZC, "ImageBlockEditing"];
            }
            static get pluginName() {
              return "LinkImageUI";
            }
            init() {
              const t = this.editor,
                e = t.editing.view.document;
              this.listenTo(
                e,
                "click",
                (e, n) => {
                  this._isSelectedLinkedImage(t.model.document.selection) &&
                    (n.preventDefault(), e.stop());
                },
                { priority: "high" }
              ),
                this._createToolbarLinkImageButton();
            }
            _createToolbarLinkImageButton() {
              const t = this.editor,
                e = t.t;
              t.ui.componentFactory.add("linkImage", (n) => {
                const o = new nm(n),
                  i = t.plugins.get("LinkUI"),
                  r = t.commands.get("link");
                return (
                  o.set({
                    isEnabled: !0,
                    label: e("Link image"),
                    icon: qC,
                    keystroke: vk,
                    tooltip: !0,
                    isToggleable: !0,
                  }),
                  o.bind("isEnabled").to(r, "isEnabled"),
                  o.bind("isOn").to(r, "value", (t) => !!t),
                  this.listenTo(o, "execute", () => {
                    this._isSelectedLinkedImage(t.model.document.selection)
                      ? i._addActionsView()
                      : i._showUI(!0);
                  }),
                  o
                );
              });
            }
            _isSelectedLinkedImage(t) {
              const e = t.getSelectedElement();
              return (
                this.editor.plugins.get("ImageUtils").isImage(e) &&
                e.hasAttribute("linkHref")
              );
            }
          }
          var tv = n(3858),
            ev = { attributes: { "data-cke": !0 } };
          (ev.setAttributes = is()),
            (ev.insert = ns().bind(null, "head")),
            (ev.domAPI = ts()),
            (ev.insertStyleElement = ss());
          Jr()(tv.Z, ev);
          tv.Z && tv.Z.locals && tv.Z.locals;
          class nv extends F {
            constructor(t, e) {
              super(t), (this.type = e);
            }
            refresh() {
              (this.value = this._getValue()),
                (this.isEnabled = this._checkEnabled());
            }
            execute(t = {}) {
              const e = this.editor.model,
                n = e.document,
                o = Array.from(n.selection.getSelectedBlocks()).filter((t) =>
                  iv(t, e.schema)
                ),
                i = void 0 !== t.forceValue ? !t.forceValue : this.value;
              e.change((t) => {
                if (i) {
                  let e = o[o.length - 1].nextSibling,
                    n = Number.POSITIVE_INFINITY,
                    i = [];
                  for (
                    ;
                    e &&
                    "listItem" == e.name &&
                    0 !== e.getAttribute("listIndent");

                  ) {
                    const t = e.getAttribute("listIndent");
                    t < n && (n = t);
                    const o = t - n;
                    i.push({ element: e, listIndent: o }), (e = e.nextSibling);
                  }
                  i = i.reverse();
                  for (const e of i)
                    t.setAttribute("listIndent", e.listIndent, e.element);
                }
                if (!i) {
                  let t = Number.POSITIVE_INFINITY;
                  for (const e of o)
                    e.is("element", "listItem") &&
                      e.getAttribute("listIndent") < t &&
                      (t = e.getAttribute("listIndent"));
                  (t = 0 === t ? 1 : t), ov(o, !0, t), ov(o, !1, t);
                }
                for (const e of o.reverse())
                  i && "listItem" == e.name
                    ? t.rename(e, "paragraph")
                    : i || "listItem" == e.name
                    ? i ||
                      "listItem" != e.name ||
                      e.getAttribute("listType") == this.type ||
                      t.setAttribute("listType", this.type, e)
                    : (t.setAttributes(
                        { listType: this.type, listIndent: 0 },
                        e
                      ),
                      t.rename(e, "listItem"));
                this.fire("_executeCleanup", o);
              });
            }
            _getValue() {
              const t = Ra(
                this.editor.model.document.selection.getSelectedBlocks()
              );
              return (
                !!t &&
                t.is("element", "listItem") &&
                t.getAttribute("listType") == this.type
              );
            }
            _checkEnabled() {
              if (this.value) return !0;
              const t = this.editor.model.document.selection,
                e = this.editor.model.schema,
                n = Ra(t.getSelectedBlocks());
              return !!n && iv(n, e);
            }
          }
          function ov(t, e, n) {
            const o = e ? t[0] : t[t.length - 1];
            if (o.is("element", "listItem")) {
              let i = o[e ? "previousSibling" : "nextSibling"],
                r = o.getAttribute("listIndent");
              for (
                ;
                i &&
                i.is("element", "listItem") &&
                i.getAttribute("listIndent") >= n;

              )
                r > i.getAttribute("listIndent") &&
                  (r = i.getAttribute("listIndent")),
                  i.getAttribute("listIndent") == r &&
                    t[e ? "unshift" : "push"](i),
                  (i = i[e ? "previousSibling" : "nextSibling"]);
            }
          }
          function iv(t, e) {
            return e.checkChild(t.parent, "listItem") && !e.isObject(t);
          }
          class rv extends F {
            constructor(t, e) {
              super(t), (this._indentBy = "forward" == e ? 1 : -1);
            }
            refresh() {
              this.isEnabled = this._checkEnabled();
            }
            execute() {
              const t = this.editor.model,
                e = t.document;
              let n = Array.from(e.selection.getSelectedBlocks());
              t.change((t) => {
                const e = n[n.length - 1];
                let o = e.nextSibling;
                for (
                  ;
                  o &&
                  "listItem" == o.name &&
                  o.getAttribute("listIndent") > e.getAttribute("listIndent");

                )
                  n.push(o), (o = o.nextSibling);
                this._indentBy < 0 && (n = n.reverse());
                for (const e of n) {
                  const n = e.getAttribute("listIndent") + this._indentBy;
                  n < 0
                    ? t.rename(e, "paragraph")
                    : t.setAttribute("listIndent", n, e);
                }
                this.fire("_executeCleanup", n);
              });
            }
            _checkEnabled() {
              const t = Ra(
                this.editor.model.document.selection.getSelectedBlocks()
              );
              if (!t || !t.is("element", "listItem")) return !1;
              if (this._indentBy > 0) {
                const e = t.getAttribute("listIndent"),
                  n = t.getAttribute("listType");
                let o = t.previousSibling;
                for (
                  ;
                  o &&
                  o.is("element", "listItem") &&
                  o.getAttribute("listIndent") >= e;

                ) {
                  if (o.getAttribute("listIndent") == e)
                    return o.getAttribute("listType") == n;
                  o = o.previousSibling;
                }
                return !1;
              }
              return !0;
            }
          }
          function sv(t, e) {
            const n = e.mapper,
              o = e.writer,
              i = "numbered" == t.getAttribute("listType") ? "ol" : "ul",
              r = (function (t) {
                const e = t.createContainerElement("li");
                return (e.getFillerOffset = hv), e;
              })(o),
              s = o.createContainerElement(i, null);
            return (
              o.insert(o.createPositionAt(s, 0), r), n.bindElements(t, r), r
            );
          }
          function av(t, e, n, o) {
            const i = e.parent,
              r = n.mapper,
              s = n.writer;
            let a = r.toViewPosition(o.createPositionBefore(t));
            const l = dv(t.previousSibling, {
                sameIndent: !0,
                smallerIndent: !0,
                listIndent: t.getAttribute("listIndent"),
              }),
              c = t.previousSibling;
            if (
              l &&
              l.getAttribute("listIndent") == t.getAttribute("listIndent")
            ) {
              const t = r.toViewElement(l);
              a = s.breakContainer(s.createPositionAfter(t));
            } else if (c && "listItem" == c.name) {
              a = r.toViewPosition(o.createPositionAt(c, "end"));
              const t = r.findMappedViewAncestor(a),
                e = (function (t) {
                  for (const e of t.getChildren())
                    if ("ul" == e.name || "ol" == e.name) return e;
                  return null;
                })(t);
              a = e ? s.createPositionBefore(e) : s.createPositionAt(t, "end");
            } else a = r.toViewPosition(o.createPositionBefore(t));
            if (((a = cv(a)), s.insert(a, i), c && "listItem" == c.name)) {
              const t = r.toViewElement(c),
                n = s
                  .createRange(s.createPositionAt(t, 0), a)
                  .getWalker({ ignoreElementEnd: !0 });
              for (const t of n)
                if (t.item.is("element", "li")) {
                  const o = s.breakContainer(s.createPositionBefore(t.item)),
                    i = t.item.parent,
                    r = s.createPositionAt(e, "end");
                  lv(s, r.nodeBefore, r.nodeAfter),
                    s.move(s.createRangeOn(i), r),
                    (n.position = o);
                }
            } else {
              const n = i.nextSibling;
              if (n && (n.is("element", "ul") || n.is("element", "ol"))) {
                let o = null;
                for (const e of n.getChildren()) {
                  const n = r.toModelElement(e);
                  if (
                    !(
                      n &&
                      n.getAttribute("listIndent") >
                        t.getAttribute("listIndent")
                    )
                  )
                    break;
                  o = e;
                }
                o &&
                  (s.breakContainer(s.createPositionAfter(o)),
                  s.move(
                    s.createRangeOn(o.parent),
                    s.createPositionAt(e, "end")
                  ));
              }
            }
            lv(s, i, i.nextSibling), lv(s, i.previousSibling, i);
          }
          function lv(t, e, n) {
            return !e ||
              !n ||
              ("ul" != e.name && "ol" != e.name) ||
              e.name != n.name ||
              e.getAttribute("class") !== n.getAttribute("class")
              ? null
              : t.mergeContainers(t.createPositionAfter(e));
          }
          function cv(t) {
            return t.getLastMatchingPosition((t) => t.item.is("uiElement"));
          }
          function dv(t, e) {
            const n = !!e.sameIndent,
              o = !!e.smallerIndent,
              i = e.listIndent;
            let r = t;
            for (; r && "listItem" == r.name; ) {
              const t = r.getAttribute("listIndent");
              if ((n && i == t) || (o && i > t)) return r;
              r = "forward" === e.direction ? r.nextSibling : r.previousSibling;
            }
            return null;
          }
          function uv(t, e, n, o) {
            t.ui.componentFactory.add(e, (i) => {
              const r = t.commands.get(e),
                s = new nm(i);
              return (
                s.set({ label: n, icon: o, tooltip: !0, isToggleable: !0 }),
                s.bind("isOn", "isEnabled").to(r, "value", "isEnabled"),
                s.on("execute", () => {
                  t.execute(e), t.editing.view.focus();
                }),
                s
              );
            });
          }
          function hv() {
            const t =
              !this.isEmpty &&
              ("ul" == this.getChild(0).name || "ol" == this.getChild(0).name);
            return this.isEmpty || t ? 0 : Pi.call(this);
          }
          function mv(t) {
            return (e, n, o) => {
              const i = o.consumable;
              if (
                !i.test(n.item, "insert") ||
                !i.test(n.item, "attribute:listType") ||
                !i.test(n.item, "attribute:listIndent")
              )
                return;
              i.consume(n.item, "insert"),
                i.consume(n.item, "attribute:listType"),
                i.consume(n.item, "attribute:listIndent");
              const r = n.item;
              av(r, sv(r, o), o, t);
            };
          }
          function gv(t, e, n) {
            if (!n.consumable.test(e.item, t.name)) return;
            const o = n.mapper.toViewElement(e.item),
              i = n.writer;
            i.breakContainer(i.createPositionBefore(o)),
              i.breakContainer(i.createPositionAfter(o));
            const r = o.parent,
              s = "numbered" == e.attributeNewValue ? "ol" : "ul";
            i.rename(s, r);
          }
          function pv(t, e, n) {
            n.consumable.consume(e.item, t.name);
            const o = n.mapper.toViewElement(e.item).parent,
              i = n.writer;
            lv(i, o, o.nextSibling), lv(i, o.previousSibling, o);
          }
          function fv(t, e, n) {
            if (
              n.consumable.test(e.item, t.name) &&
              "listItem" != e.item.name
            ) {
              let t = n.mapper.toViewPosition(e.range.start);
              const o = n.writer,
                i = [];
              for (
                ;
                ("ul" == t.parent.name || "ol" == t.parent.name) &&
                ((t = o.breakContainer(t)), "li" == t.parent.name);

              ) {
                const e = t,
                  n = o.createPositionAt(t.parent, "end");
                if (!e.isEqual(n)) {
                  const t = o.remove(o.createRange(e, n));
                  i.push(t);
                }
                t = o.createPositionAfter(t.parent);
              }
              if (i.length > 0) {
                for (let e = 0; e < i.length; e++) {
                  const n = t.nodeBefore;
                  if (((t = o.insert(t, i[e]).end), e > 0)) {
                    const e = lv(o, n, n.nextSibling);
                    e && e.parent == n && t.offset--;
                  }
                }
                lv(o, t.nodeBefore, t.nodeAfter);
              }
            }
          }
          function kv(t, e, n) {
            const o = n.mapper.toViewPosition(e.position),
              i = o.nodeBefore,
              r = o.nodeAfter;
            lv(n.writer, i, r);
          }
          function bv(t, e, n) {
            if (n.consumable.consume(e.viewItem, { name: !0 })) {
              const t = n.writer,
                o = t.createElement("listItem"),
                i = (function (t) {
                  let e = 0,
                    n = t.parent;
                  for (; n; ) {
                    if (n.is("element", "li")) e++;
                    else {
                      const t = n.previousSibling;
                      t && t.is("element", "li") && e++;
                    }
                    n = n.parent;
                  }
                  return e;
                })(e.viewItem);
              t.setAttribute("listIndent", i, o);
              const r =
                e.viewItem.parent && "ol" == e.viewItem.parent.name
                  ? "numbered"
                  : "bulleted";
              if (
                (t.setAttribute("listType", r, o),
                !n.safeInsert(o, e.modelCursor))
              )
                return;
              const s = (function (t, e, n) {
                const { writer: o, schema: i } = n;
                let r = o.createPositionAfter(t);
                for (const s of e)
                  if ("ul" == s.name || "ol" == s.name)
                    r = n.convertItem(s, r).modelCursor;
                  else {
                    const e = n.convertItem(s, o.createPositionAt(t, "end")),
                      a = e.modelRange.start.nodeAfter;
                    a &&
                      a.is("element") &&
                      !i.checkChild(t, a.name) &&
                      ((t = e.modelCursor.parent.is("element", "listItem")
                        ? e.modelCursor.parent
                        : vv(e.modelCursor)),
                      (r = o.createPositionAfter(t)));
                  }
                return r;
              })(o, e.viewItem.getChildren(), n);
              (e.modelRange = t.createRange(e.modelCursor, s)),
                n.updateConversionResult(o, e);
            }
          }
          function wv(t, e, n) {
            if (n.consumable.test(e.viewItem, { name: !0 })) {
              const t = Array.from(e.viewItem.getChildren());
              for (const e of t) {
                !(e.is("element", "li") || xv(e)) && e._remove();
              }
            }
          }
          function Av(t, e, n) {
            if (n.consumable.test(e.viewItem, { name: !0 })) {
              if (0 === e.viewItem.childCount) return;
              const t = [...e.viewItem.getChildren()];
              let n = !1;
              for (const e of t) n && !xv(e) && e._remove(), xv(e) && (n = !0);
            }
          }
          function _v(t) {
            return (e, n) => {
              if (n.isPhantom) return;
              const o = n.modelPosition.nodeBefore;
              if (o && o.is("element", "listItem")) {
                const e = n.mapper.toViewElement(o),
                  i = e.getAncestors().find(xv),
                  r = t.createPositionAt(e, 0).getWalker();
                for (const t of r) {
                  if ("elementStart" == t.type && t.item.is("element", "li")) {
                    n.viewPosition = t.previousPosition;
                    break;
                  }
                  if ("elementEnd" == t.type && t.item == i) {
                    n.viewPosition = t.nextPosition;
                    break;
                  }
                }
              }
            };
          }
          function Cv(t, [e, n, o]) {
            let i,
              r = e.is("documentFragment") ? e.getChild(0) : e;
            if (
              ((i = n ? this.createSelection(n, o) : this.document.selection),
              r && r.is("element", "listItem"))
            ) {
              const t = i.getFirstPosition();
              let e = null;
              if (
                (t.parent.is("element", "listItem")
                  ? (e = t.parent)
                  : t.nodeBefore &&
                    t.nodeBefore.is("element", "listItem") &&
                    (e = t.nodeBefore),
                e)
              ) {
                const t = e.getAttribute("listIndent");
                if (t > 0)
                  for (; r && r.is("element", "listItem"); )
                    r._setAttribute(
                      "listIndent",
                      r.getAttribute("listIndent") + t
                    ),
                      (r = r.nextSibling);
              }
            }
          }
          function vv(t) {
            const e = new rl({ startPosition: t });
            let n;
            do {
              n = e.next();
            } while (!n.value.item.is("element", "listItem"));
            return n.value.item;
          }
          function yv(t, e, n, o, i, r) {
            const s = dv(e.nodeBefore, {
                sameIndent: !0,
                smallerIndent: !0,
                listIndent: t,
                foo: "b",
              }),
              a = i.mapper,
              l = i.writer,
              c = s ? s.getAttribute("listIndent") : null;
            let d;
            if (s)
              if (c == t) {
                const t = a.toViewElement(s).parent;
                d = l.createPositionAfter(t);
              } else {
                const t = r.createPositionAt(s, "end");
                d = a.toViewPosition(t);
              }
            else d = n;
            d = cv(d);
            for (const t of [...o.getChildren()])
              xv(t) &&
                ((d = l.move(l.createRangeOn(t), d).end),
                lv(l, t, t.nextSibling),
                lv(l, t.previousSibling, t));
          }
          function xv(t) {
            return t.is("element", "ol") || t.is("element", "ul");
          }
          class Ev extends j {
            static get pluginName() {
              return "ListEditing";
            }
            static get requires() {
              return [Vp, rp];
            }
            init() {
              const t = this.editor;
              t.model.schema.register("listItem", {
                inheritAllFrom: "$block",
                allowAttributes: ["listType", "listIndent"],
              });
              const e = t.data,
                n = t.editing;
              var o;
              t.model.document.registerPostFixer((e) =>
                (function (t, e) {
                  const n = t.document.differ.getChanges(),
                    o = new Map();
                  let i = !1;
                  for (const o of n)
                    if ("insert" == o.type && "listItem" == o.name)
                      r(o.position);
                    else if ("insert" == o.type && "listItem" != o.name) {
                      if ("$text" != o.name) {
                        const n = o.position.nodeAfter;
                        n.hasAttribute("listIndent") &&
                          (e.removeAttribute("listIndent", n), (i = !0)),
                          n.hasAttribute("listType") &&
                            (e.removeAttribute("listType", n), (i = !0)),
                          n.hasAttribute("listStyle") &&
                            (e.removeAttribute("listStyle", n), (i = !0)),
                          n.hasAttribute("listReversed") &&
                            (e.removeAttribute("listReversed", n), (i = !0)),
                          n.hasAttribute("listStart") &&
                            (e.removeAttribute("listStart", n), (i = !0));
                        for (const e of Array.from(t.createRangeIn(n)).filter(
                          (t) => t.item.is("element", "listItem")
                        ))
                          r(e.previousPosition);
                      }
                      r(o.position.getShiftedBy(o.length));
                    } else
                      "remove" == o.type && "listItem" == o.name
                        ? r(o.position)
                        : (("attribute" == o.type &&
                            "listIndent" == o.attributeKey) ||
                            ("attribute" == o.type &&
                              "listType" == o.attributeKey)) &&
                          r(o.range.start);
                  for (const t of o.values()) s(t), a(t);
                  return i;
                  function r(t) {
                    const e = t.nodeBefore;
                    if (e && e.is("element", "listItem")) {
                      let t = e;
                      if (o.has(t)) return;
                      for (
                        let e = t.previousSibling;
                        e && e.is("element", "listItem");
                        e = t.previousSibling
                      )
                        if (((t = e), o.has(t))) return;
                      o.set(e, t);
                    } else {
                      const e = t.nodeAfter;
                      e && e.is("element", "listItem") && o.set(e, e);
                    }
                  }
                  function s(t) {
                    let n = 0,
                      o = null;
                    for (; t && t.is("element", "listItem"); ) {
                      const r = t.getAttribute("listIndent");
                      if (r > n) {
                        let s;
                        null === o
                          ? ((o = r - n), (s = n))
                          : (o > r && (o = r), (s = r - o)),
                          e.setAttribute("listIndent", s, t),
                          (i = !0);
                      } else (o = null), (n = t.getAttribute("listIndent") + 1);
                      t = t.nextSibling;
                    }
                  }
                  function a(t) {
                    let n = [],
                      o = null;
                    for (; t && t.is("element", "listItem"); ) {
                      const r = t.getAttribute("listIndent");
                      if (
                        (o &&
                          o.getAttribute("listIndent") > r &&
                          (n = n.slice(0, r + 1)),
                        0 != r)
                      )
                        if (n[r]) {
                          const o = n[r];
                          t.getAttribute("listType") != o &&
                            (e.setAttribute("listType", o, t), (i = !0));
                        } else n[r] = t.getAttribute("listType");
                      (o = t), (t = t.nextSibling);
                    }
                  }
                })(t.model, e)
              ),
                n.mapper.registerViewToModelLength("li", Dv),
                e.mapper.registerViewToModelLength("li", Dv),
                n.mapper.on("modelToViewPosition", _v(n.view)),
                n.mapper.on(
                  "viewToModelPosition",
                  ((o = t.model),
                  (t, e) => {
                    const n = e.viewPosition,
                      i = n.parent,
                      r = e.mapper;
                    if ("ul" == i.name || "ol" == i.name) {
                      if (n.isAtEnd) {
                        const t = r.toModelElement(n.nodeBefore),
                          i = r.getModelLength(n.nodeBefore);
                        e.modelPosition = o
                          .createPositionBefore(t)
                          .getShiftedBy(i);
                      } else {
                        const t = r.toModelElement(n.nodeAfter);
                        e.modelPosition = o.createPositionBefore(t);
                      }
                      t.stop();
                    } else if (
                      "li" == i.name &&
                      n.nodeBefore &&
                      ("ul" == n.nodeBefore.name || "ol" == n.nodeBefore.name)
                    ) {
                      const s = r.toModelElement(i);
                      let a = 1,
                        l = n.nodeBefore;
                      for (; l && xv(l); )
                        (a += r.getModelLength(l)), (l = l.previousSibling);
                      (e.modelPosition = o
                        .createPositionBefore(s)
                        .getShiftedBy(a)),
                        t.stop();
                    }
                  })
                ),
                e.mapper.on("modelToViewPosition", _v(n.view)),
                t.conversion.for("editingDowncast").add((e) => {
                  e.on("insert", fv, { priority: "high" }),
                    e.on("insert:listItem", mv(t.model)),
                    e.on("attribute:listType:listItem", gv, {
                      priority: "high",
                    }),
                    e.on("attribute:listType:listItem", pv, {
                      priority: "low",
                    }),
                    e.on(
                      "attribute:listIndent:listItem",
                      (function (t) {
                        return (e, n, o) => {
                          if (
                            !o.consumable.consume(
                              n.item,
                              "attribute:listIndent"
                            )
                          )
                            return;
                          const i = o.mapper.toViewElement(n.item),
                            r = o.writer;
                          r.breakContainer(r.createPositionBefore(i)),
                            r.breakContainer(r.createPositionAfter(i));
                          const s = i.parent,
                            a = s.previousSibling,
                            l = r.createRangeOn(s);
                          r.remove(l),
                            a && a.nextSibling && lv(r, a, a.nextSibling),
                            yv(
                              n.attributeOldValue + 1,
                              n.range.start,
                              l.start,
                              i,
                              o,
                              t
                            ),
                            av(n.item, i, o, t);
                          for (const t of n.item.getChildren())
                            o.consumable.consume(t, "insert");
                        };
                      })(t.model)
                    ),
                    e.on(
                      "remove:listItem",
                      (function (t) {
                        return (e, n, o) => {
                          const i = o.mapper
                              .toViewPosition(n.position)
                              .getLastMatchingPosition(
                                (t) => !t.item.is("element", "li")
                              ).nodeAfter,
                            r = o.writer;
                          r.breakContainer(r.createPositionBefore(i)),
                            r.breakContainer(r.createPositionAfter(i));
                          const s = i.parent,
                            a = s.previousSibling,
                            l = r.createRangeOn(s),
                            c = r.remove(l);
                          a && a.nextSibling && lv(r, a, a.nextSibling),
                            yv(
                              o.mapper
                                .toModelElement(i)
                                .getAttribute("listIndent") + 1,
                              n.position,
                              l.start,
                              i,
                              o,
                              t
                            );
                          for (const t of r.createRangeIn(c).getItems())
                            o.mapper.unbindViewElement(t);
                          e.stop();
                        };
                      })(t.model)
                    ),
                    e.on("remove", kv, { priority: "low" });
                }),
                t.conversion.for("dataDowncast").add((e) => {
                  e.on("insert", fv, { priority: "high" }),
                    e.on("insert:listItem", mv(t.model));
                }),
                t.conversion.for("upcast").add((t) => {
                  t.on("element:ul", wv, { priority: "high" }),
                    t.on("element:ol", wv, { priority: "high" }),
                    t.on("element:li", Av, { priority: "high" }),
                    t.on("element:li", bv);
                }),
                t.model.on("insertContent", Cv, { priority: "high" }),
                t.commands.add("numberedList", new nv(t, "numbered")),
                t.commands.add("bulletedList", new nv(t, "bulleted")),
                t.commands.add("indentList", new rv(t, "forward")),
                t.commands.add("outdentList", new rv(t, "backward"));
              const i = n.view.document;
              this.listenTo(
                i,
                "enter",
                (t, e) => {
                  const n = this.editor.model.document,
                    o = n.selection.getLastPosition().parent;
                  n.selection.isCollapsed &&
                    "listItem" == o.name &&
                    o.isEmpty &&
                    (this.editor.execute("outdentList"),
                    e.preventDefault(),
                    t.stop());
                },
                { context: "li" }
              ),
                this.listenTo(
                  i,
                  "delete",
                  (t, e) => {
                    if ("backward" !== e.direction) return;
                    const n = this.editor.model.document.selection;
                    if (!n.isCollapsed) return;
                    const o = n.getFirstPosition();
                    if (!o.isAtStart) return;
                    const i = o.parent;
                    if ("listItem" !== i.name) return;
                    (i.previousSibling &&
                      "listItem" === i.previousSibling.name) ||
                      (this.editor.execute("outdentList"),
                      e.preventDefault(),
                      t.stop());
                  },
                  { context: "li" }
                ),
                this.listenTo(
                  t.editing.view.document,
                  "tab",
                  (e, n) => {
                    const o = n.shiftKey ? "outdentList" : "indentList";
                    this.editor.commands.get(o).isEnabled &&
                      (t.execute(o),
                      n.stopPropagation(),
                      n.preventDefault(),
                      e.stop());
                  },
                  { context: "li" }
                );
            }
            afterInit() {
              const t = this.editor.commands,
                e = t.get("indent"),
                n = t.get("outdent");
              e && e.registerChildCommand(t.get("indentList")),
                n && n.registerChildCommand(t.get("outdentList"));
            }
          }
          function Dv(t) {
            let e = 1;
            for (const n of t.getChildren())
              if ("ul" == n.name || "ol" == n.name)
                for (const t of n.getChildren()) e += Dv(t);
            return e;
          }
          class Sv extends j {
            static get pluginName() {
              return "ListUI";
            }
            init() {
              const t = this.editor.t;
              uv(
                this.editor,
                "numberedList",
                t("Numbered List"),
                '<svg viewBox="0 0 20 20" xmlns="http://www.w3.org/2000/svg"><path d="M7 5.75c0 .414.336.75.75.75h9.5a.75.75 0 1 0 0-1.5h-9.5a.75.75 0 0 0-.75.75zM3.5 3v5H2V3.7H1v-1h2.5V3zM.343 17.857l2.59-3.257H2.92a.6.6 0 1 0-1.04 0H.302a2 2 0 1 1 3.995 0h-.001c-.048.405-.16.734-.333.988-.175.254-.59.692-1.244 1.312H4.3v1h-4l.043-.043zM7 14.75a.75.75 0 0 1 .75-.75h9.5a.75.75 0 1 1 0 1.5h-9.5a.75.75 0 0 1-.75-.75z"/></svg>'
              ),
                uv(
                  this.editor,
                  "bulletedList",
                  t("Bulleted List"),
                  '<svg viewBox="0 0 20 20" xmlns="http://www.w3.org/2000/svg"><path d="M7 5.75c0 .414.336.75.75.75h9.5a.75.75 0 1 0 0-1.5h-9.5a.75.75 0 0 0-.75.75zm-6 0C1 4.784 1.777 4 2.75 4c.966 0 1.75.777 1.75 1.75 0 .966-.777 1.75-1.75 1.75C1.784 7.5 1 6.723 1 5.75zm6 9c0 .414.336.75.75.75h9.5a.75.75 0 1 0 0-1.5h-9.5a.75.75 0 0 0-.75.75zm-6 0c0-.966.777-1.75 1.75-1.75.966 0 1.75.777 1.75 1.75 0 .966-.777 1.75-1.75 1.75-.966 0-1.75-.777-1.75-1.75z"/></svg>'
                );
            }
          }
          function Iv() {
            return {
              baseUrl: null,
              breaks: !1,
              extensions: null,
              gfm: !0,
              headerIds: !0,
              headerPrefix: "",
              highlight: null,
              langPrefix: "language-",
              mangle: !0,
              pedantic: !1,
              renderer: null,
              sanitize: !1,
              sanitizer: null,
              silent: !1,
              smartLists: !1,
              smartypants: !1,
              tokenizer: null,
              walkTokens: null,
              xhtml: !1,
            };
          }
          let Tv = {
            baseUrl: null,
            breaks: !1,
            extensions: null,
            gfm: !0,
            headerIds: !0,
            headerPrefix: "",
            highlight: null,
            langPrefix: "language-",
            mangle: !0,
            pedantic: !1,
            renderer: null,
            sanitize: !1,
            sanitizer: null,
            silent: !1,
            smartLists: !1,
            smartypants: !1,
            tokenizer: null,
            walkTokens: null,
            xhtml: !1,
          };
          const Mv = /[&<>"']/,
            Bv = /[&<>"']/g,
            Nv = /[<>"']|&(?!#?\w+;)/,
            zv = /[<>"']|&(?!#?\w+;)/g,
            Pv = {
              "&": "&amp;",
              "<": "&lt;",
              ">": "&gt;",
              '"': "&quot;",
              "'": "&#39;",
            },
            Lv = (t) => Pv[t];
          function Rv(t, e) {
            if (e) {
              if (Mv.test(t)) return t.replace(Bv, Lv);
            } else if (Nv.test(t)) return t.replace(zv, Lv);
            return t;
          }
          const Ov = /&(#(?:\d+)|(?:#x[0-9A-Fa-f]+)|(?:\w+));?/gi;
          function jv(t) {
            return t.replace(Ov, (t, e) =>
              "colon" === (e = e.toLowerCase())
                ? ":"
                : "#" === e.charAt(0)
                ? "x" === e.charAt(1)
                  ? String.fromCharCode(parseInt(e.substring(2), 16))
                  : String.fromCharCode(+e.substring(1))
                : ""
            );
          }
          const Vv = /(^|[^\[])\^/g;
          function Fv(t, e) {
            (t = t.source || t), (e = e || "");
            const n = {
              replace: (e, o) => (
                (o = (o = o.source || o).replace(Vv, "$1")),
                (t = t.replace(e, o)),
                n
              ),
              getRegex: () => new RegExp(t, e),
            };
            return n;
          }
          const Hv = /[^\w:]/g,
            Uv = /^$|^[a-z][a-z0-9+.-]*:|^[?#]/i;
          function Wv(t, e, n) {
            if (t) {
              let t;
              try {
                t = decodeURIComponent(jv(n)).replace(Hv, "").toLowerCase();
              } catch (t) {
                return null;
              }
              if (
                0 === t.indexOf("javascript:") ||
                0 === t.indexOf("vbscript:") ||
                0 === t.indexOf("data:")
              )
                return null;
            }
            e &&
              !Uv.test(n) &&
              (n = (function (t, e) {
                $v[" " + t] ||
                  (qv.test(t)
                    ? ($v[" " + t] = t + "/")
                    : ($v[" " + t] = Jv(t, "/", !0)));
                const n = -1 === (t = $v[" " + t]).indexOf(":");
                return "//" === e.substring(0, 2)
                  ? n
                    ? e
                    : t.replace(Gv, "$1") + e
                  : "/" === e.charAt(0)
                  ? n
                    ? e
                    : t.replace(Zv, "$1") + e
                  : t + e;
              })(e, n));
            try {
              n = encodeURI(n).replace(/%25/g, "%");
            } catch (t) {
              return null;
            }
            return n;
          }
          const $v = {},
            qv = /^[^:]+:\/*[^/]*$/,
            Gv = /^([^:]+:)[\s\S]*$/,
            Zv = /^([^:]+:\/*[^/]*)[\s\S]*$/;
          const Yv = { exec: function () {} };
          function Kv(t) {
            let e,
              n,
              o = 1;
            for (; o < arguments.length; o++)
              for (n in ((e = arguments[o]), e))
                Object.prototype.hasOwnProperty.call(e, n) && (t[n] = e[n]);
            return t;
          }
          function Qv(t, e) {
            const n = t
              .replace(/\|/g, (t, e, n) => {
                let o = !1,
                  i = e;
                for (; --i >= 0 && "\\" === n[i]; ) o = !o;
                return o ? "|" : " |";
              })
              .split(/ \|/);
            let o = 0;
            if (
              (n[0].trim() || n.shift(),
              n.length > 0 && !n[n.length - 1].trim() && n.pop(),
              n.length > e)
            )
              n.splice(e);
            else for (; n.length < e; ) n.push("");
            for (; o < n.length; o++) n[o] = n[o].trim().replace(/\\\|/g, "|");
            return n;
          }
          function Jv(t, e, n) {
            const o = t.length;
            if (0 === o) return "";
            let i = 0;
            for (; i < o; ) {
              const r = t.charAt(o - i - 1);
              if (r !== e || n) {
                if (r === e || !n) break;
                i++;
              } else i++;
            }
            return t.substr(0, o - i);
          }
          function Xv(t) {
            t &&
              t.sanitize &&
              !t.silent &&
              console.warn(
                "marked(): sanitize and sanitizer parameters are deprecated since version 0.7.0, should not be used and will be removed in the future. Read more here: https://marked.js.org/#/USING_ADVANCED.md#options"
              );
          }
          function ty(t, e) {
            if (e < 1) return "";
            let n = "";
            for (; e > 1; ) 1 & e && (n += t), (e >>= 1), (t += t);
            return n + t;
          }
          function ey(t, e, n, o) {
            const i = e.href,
              r = e.title ? Rv(e.title) : null,
              s = t[1].replace(/\\([\[\]])/g, "$1");
            if ("!" !== t[0].charAt(0)) {
              o.state.inLink = !0;
              const t = {
                type: "link",
                raw: n,
                href: i,
                title: r,
                text: s,
                tokens: o.inlineTokens(s, []),
              };
              return (o.state.inLink = !1), t;
            }
            return { type: "image", raw: n, href: i, title: r, text: Rv(s) };
          }
          class ny {
            constructor(t) {
              this.options = t || Tv;
            }
            space(t) {
              const e = this.rules.block.newline.exec(t);
              if (e && e[0].length > 0) return { type: "space", raw: e[0] };
            }
            code(t) {
              const e = this.rules.block.code.exec(t);
              if (e) {
                const t = e[0].replace(/^ {1,4}/gm, "");
                return {
                  type: "code",
                  raw: e[0],
                  codeBlockStyle: "indented",
                  text: this.options.pedantic ? t : Jv(t, "\n"),
                };
              }
            }
            fences(t) {
              const e = this.rules.block.fences.exec(t);
              if (e) {
                const t = e[0],
                  n = (function (t, e) {
                    const n = t.match(/^(\s+)(?:```)/);
                    if (null === n) return e;
                    const o = n[1];
                    return e
                      .split("\n")
                      .map((t) => {
                        const e = t.match(/^\s+/);
                        if (null === e) return t;
                        const [n] = e;
                        return n.length >= o.length ? t.slice(o.length) : t;
                      })
                      .join("\n");
                  })(t, e[3] || "");
                return {
                  type: "code",
                  raw: t,
                  lang: e[2] ? e[2].trim() : e[2],
                  text: n,
                };
              }
            }
            heading(t) {
              const e = this.rules.block.heading.exec(t);
              if (e) {
                let t = e[2].trim();
                if (/#$/.test(t)) {
                  const e = Jv(t, "#");
                  this.options.pedantic
                    ? (t = e.trim())
                    : (e && !/ $/.test(e)) || (t = e.trim());
                }
                const n = {
                  type: "heading",
                  raw: e[0],
                  depth: e[1].length,
                  text: t,
                  tokens: [],
                };
                return this.lexer.inline(n.text, n.tokens), n;
              }
            }
            hr(t) {
              const e = this.rules.block.hr.exec(t);
              if (e) return { type: "hr", raw: e[0] };
            }
            blockquote(t) {
              const e = this.rules.block.blockquote.exec(t);
              if (e) {
                const t = e[0].replace(/^ *> ?/gm, "");
                return {
                  type: "blockquote",
                  raw: e[0],
                  tokens: this.lexer.blockTokens(t, []),
                  text: t,
                };
              }
            }
            list(t) {
              let e = this.rules.block.list.exec(t);
              if (e) {
                let n,
                  o,
                  i,
                  r,
                  s,
                  a,
                  l,
                  c,
                  d,
                  u,
                  h,
                  m,
                  g = e[1].trim();
                const p = g.length > 1,
                  f = {
                    type: "list",
                    raw: "",
                    ordered: p,
                    start: p ? +g.slice(0, -1) : "",
                    loose: !1,
                    items: [],
                  };
                (g = p ? `\\d{1,9}\\${g.slice(-1)}` : `\\${g}`),
                  this.options.pedantic && (g = p ? g : "[*+-]");
                const k = new RegExp(`^( {0,3}${g})((?: [^\\n]*)?(?:\\n|$))`);
                for (
                  ;
                  t &&
                  ((m = !1), (e = k.exec(t))) &&
                  !this.rules.block.hr.test(t);

                ) {
                  if (
                    ((n = e[0]),
                    (t = t.substring(n.length)),
                    (c = e[2].split("\n", 1)[0]),
                    (d = t.split("\n", 1)[0]),
                    this.options.pedantic
                      ? ((r = 2), (h = c.trimLeft()))
                      : ((r = e[2].search(/[^ ]/)),
                        (r = r > 4 ? 1 : r),
                        (h = c.slice(r)),
                        (r += e[1].length)),
                    (a = !1),
                    !c &&
                      /^ *$/.test(d) &&
                      ((n += d + "\n"),
                      (t = t.substring(d.length + 1)),
                      (m = !0)),
                    !m)
                  ) {
                    const e = new RegExp(
                      `^ {0,${Math.min(3, r - 1)}}(?:[*+-]|\\d{1,9}[.)])`
                    );
                    for (
                      ;
                      t &&
                      ((u = t.split("\n", 1)[0]),
                      (c = u),
                      this.options.pedantic &&
                        (c = c.replace(/^ {1,4}(?=( {4})*[^ ])/g, "  ")),
                      !e.test(c));

                    ) {
                      if (c.search(/[^ ]/) >= r || !c.trim())
                        h += "\n" + c.slice(r);
                      else {
                        if (a) break;
                        h += "\n" + c;
                      }
                      a || c.trim() || (a = !0),
                        (n += u + "\n"),
                        (t = t.substring(u.length + 1));
                    }
                  }
                  f.loose ||
                    (l ? (f.loose = !0) : /\n *\n *$/.test(n) && (l = !0)),
                    this.options.gfm &&
                      ((o = /^\[[ xX]\] /.exec(h)),
                      o &&
                        ((i = "[ ] " !== o[0]),
                        (h = h.replace(/^\[[ xX]\] +/, "")))),
                    f.items.push({
                      type: "list_item",
                      raw: n,
                      task: !!o,
                      checked: i,
                      loose: !1,
                      text: h,
                    }),
                    (f.raw += n);
                }
                (f.items[f.items.length - 1].raw = n.trimRight()),
                  (f.items[f.items.length - 1].text = h.trimRight()),
                  (f.raw = f.raw.trimRight());
                const b = f.items.length;
                for (s = 0; s < b; s++) {
                  (this.lexer.state.top = !1),
                    (f.items[s].tokens = this.lexer.blockTokens(
                      f.items[s].text,
                      []
                    ));
                  const t = f.items[s].tokens.filter((t) => "space" === t.type),
                    e = t.every((t) => {
                      const e = t.raw.split("");
                      let n = 0;
                      for (const t of e)
                        if (("\n" === t && (n += 1), n > 1)) return !0;
                      return !1;
                    });
                  !f.loose &&
                    t.length &&
                    e &&
                    ((f.loose = !0), (f.items[s].loose = !0));
                }
                return f;
              }
            }
            html(t) {
              const e = this.rules.block.html.exec(t);
              if (e) {
                const t = {
                  type: "html",
                  raw: e[0],
                  pre:
                    !this.options.sanitizer &&
                    ("pre" === e[1] || "script" === e[1] || "style" === e[1]),
                  text: e[0],
                };
                return (
                  this.options.sanitize &&
                    ((t.type = "paragraph"),
                    (t.text = this.options.sanitizer
                      ? this.options.sanitizer(e[0])
                      : Rv(e[0])),
                    (t.tokens = []),
                    this.lexer.inline(t.text, t.tokens)),
                  t
                );
              }
            }
            def(t) {
              const e = this.rules.block.def.exec(t);
              if (e) {
                e[3] && (e[3] = e[3].substring(1, e[3].length - 1));
                return {
                  type: "def",
                  tag: e[1].toLowerCase().replace(/\s+/g, " "),
                  raw: e[0],
                  href: e[2],
                  title: e[3],
                };
              }
            }
            table(t) {
              const e = this.rules.block.table.exec(t);
              if (e) {
                const t = {
                  type: "table",
                  header: Qv(e[1]).map((t) => ({ text: t })),
                  align: e[2].replace(/^ *|\| *$/g, "").split(/ *\| */),
                  rows:
                    e[3] && e[3].trim()
                      ? e[3].replace(/\n[ \t]*$/, "").split("\n")
                      : [],
                };
                if (t.header.length === t.align.length) {
                  t.raw = e[0];
                  let n,
                    o,
                    i,
                    r,
                    s = t.align.length;
                  for (n = 0; n < s; n++)
                    /^ *-+: *$/.test(t.align[n])
                      ? (t.align[n] = "right")
                      : /^ *:-+: *$/.test(t.align[n])
                      ? (t.align[n] = "center")
                      : /^ *:-+ *$/.test(t.align[n])
                      ? (t.align[n] = "left")
                      : (t.align[n] = null);
                  for (s = t.rows.length, n = 0; n < s; n++)
                    t.rows[n] = Qv(t.rows[n], t.header.length).map((t) => ({
                      text: t,
                    }));
                  for (s = t.header.length, o = 0; o < s; o++)
                    (t.header[o].tokens = []),
                      this.lexer.inlineTokens(
                        t.header[o].text,
                        t.header[o].tokens
                      );
                  for (s = t.rows.length, o = 0; o < s; o++)
                    for (r = t.rows[o], i = 0; i < r.length; i++)
                      (r[i].tokens = []),
                        this.lexer.inlineTokens(r[i].text, r[i].tokens);
                  return t;
                }
              }
            }
            lheading(t) {
              const e = this.rules.block.lheading.exec(t);
              if (e) {
                const t = {
                  type: "heading",
                  raw: e[0],
                  depth: "=" === e[2].charAt(0) ? 1 : 2,
                  text: e[1],
                  tokens: [],
                };
                return this.lexer.inline(t.text, t.tokens), t;
              }
            }
            paragraph(t) {
              const e = this.rules.block.paragraph.exec(t);
              if (e) {
                const t = {
                  type: "paragraph",
                  raw: e[0],
                  text:
                    "\n" === e[1].charAt(e[1].length - 1)
                      ? e[1].slice(0, -1)
                      : e[1],
                  tokens: [],
                };
                return this.lexer.inline(t.text, t.tokens), t;
              }
            }
            text(t) {
              const e = this.rules.block.text.exec(t);
              if (e) {
                const t = { type: "text", raw: e[0], text: e[0], tokens: [] };
                return this.lexer.inline(t.text, t.tokens), t;
              }
            }
            escape(t) {
              const e = this.rules.inline.escape.exec(t);
              if (e) return { type: "escape", raw: e[0], text: Rv(e[1]) };
            }
            tag(t) {
              const e = this.rules.inline.tag.exec(t);
              if (e)
                return (
                  !this.lexer.state.inLink && /^<a /i.test(e[0])
                    ? (this.lexer.state.inLink = !0)
                    : this.lexer.state.inLink &&
                      /^<\/a>/i.test(e[0]) &&
                      (this.lexer.state.inLink = !1),
                  !this.lexer.state.inRawBlock &&
                  /^<(pre|code|kbd|script)(\s|>)/i.test(e[0])
                    ? (this.lexer.state.inRawBlock = !0)
                    : this.lexer.state.inRawBlock &&
                      /^<\/(pre|code|kbd|script)(\s|>)/i.test(e[0]) &&
                      (this.lexer.state.inRawBlock = !1),
                  {
                    type: this.options.sanitize ? "text" : "html",
                    raw: e[0],
                    inLink: this.lexer.state.inLink,
                    inRawBlock: this.lexer.state.inRawBlock,
                    text: this.options.sanitize
                      ? this.options.sanitizer
                        ? this.options.sanitizer(e[0])
                        : Rv(e[0])
                      : e[0],
                  }
                );
            }
            link(t) {
              const e = this.rules.inline.link.exec(t);
              if (e) {
                const t = e[2].trim();
                if (!this.options.pedantic && /^</.test(t)) {
                  if (!/>$/.test(t)) return;
                  const e = Jv(t.slice(0, -1), "\\");
                  if ((t.length - e.length) % 2 == 0) return;
                } else {
                  const t = (function (t, e) {
                    if (-1 === t.indexOf(e[1])) return -1;
                    const n = t.length;
                    let o = 0,
                      i = 0;
                    for (; i < n; i++)
                      if ("\\" === t[i]) i++;
                      else if (t[i] === e[0]) o++;
                      else if (t[i] === e[1] && (o--, o < 0)) return i;
                    return -1;
                  })(e[2], "()");
                  if (t > -1) {
                    const n =
                      (0 === e[0].indexOf("!") ? 5 : 4) + e[1].length + t;
                    (e[2] = e[2].substring(0, t)),
                      (e[0] = e[0].substring(0, n).trim()),
                      (e[3] = "");
                  }
                }
                let n = e[2],
                  o = "";
                if (this.options.pedantic) {
                  const t = /^([^'"]*[^\s])\s+(['"])(.*)\2/.exec(n);
                  t && ((n = t[1]), (o = t[3]));
                } else o = e[3] ? e[3].slice(1, -1) : "";
                return (
                  (n = n.trim()),
                  /^</.test(n) &&
                    (n =
                      this.options.pedantic && !/>$/.test(t)
                        ? n.slice(1)
                        : n.slice(1, -1)),
                  ey(
                    e,
                    {
                      href: n ? n.replace(this.rules.inline._escapes, "$1") : n,
                      title: o
                        ? o.replace(this.rules.inline._escapes, "$1")
                        : o,
                    },
                    e[0],
                    this.lexer
                  )
                );
              }
            }
            reflink(t, e) {
              let n;
              if (
                (n = this.rules.inline.reflink.exec(t)) ||
                (n = this.rules.inline.nolink.exec(t))
              ) {
                let t = (n[2] || n[1]).replace(/\s+/g, " ");
                if (((t = e[t.toLowerCase()]), !t || !t.href)) {
                  const t = n[0].charAt(0);
                  return { type: "text", raw: t, text: t };
                }
                return ey(n, t, n[0], this.lexer);
              }
            }
            emStrong(t, e, n = "") {
              let o = this.rules.inline.emStrong.lDelim.exec(t);
              if (!o) return;
              if (o[3] && n.match(/[\p{L}\p{N}]/u)) return;
              const i = o[1] || o[2] || "";
              if (
                !i ||
                (i && ("" === n || this.rules.inline.punctuation.exec(n)))
              ) {
                const n = o[0].length - 1;
                let i,
                  r,
                  s = n,
                  a = 0;
                const l =
                  "*" === o[0][0]
                    ? this.rules.inline.emStrong.rDelimAst
                    : this.rules.inline.emStrong.rDelimUnd;
                for (
                  l.lastIndex = 0, e = e.slice(-1 * t.length + n);
                  null != (o = l.exec(e));

                ) {
                  if (((i = o[1] || o[2] || o[3] || o[4] || o[5] || o[6]), !i))
                    continue;
                  if (((r = i.length), o[3] || o[4])) {
                    s += r;
                    continue;
                  }
                  if ((o[5] || o[6]) && n % 3 && !((n + r) % 3)) {
                    a += r;
                    continue;
                  }
                  if (((s -= r), s > 0)) continue;
                  if (((r = Math.min(r, r + s + a)), Math.min(n, r) % 2)) {
                    const e = t.slice(1, n + o.index + r);
                    return {
                      type: "em",
                      raw: t.slice(0, n + o.index + r + 1),
                      text: e,
                      tokens: this.lexer.inlineTokens(e, []),
                    };
                  }
                  const e = t.slice(2, n + o.index + r - 1);
                  return {
                    type: "strong",
                    raw: t.slice(0, n + o.index + r + 1),
                    text: e,
                    tokens: this.lexer.inlineTokens(e, []),
                  };
                }
              }
            }
            codespan(t) {
              const e = this.rules.inline.code.exec(t);
              if (e) {
                let t = e[2].replace(/\n/g, " ");
                const n = /[^ ]/.test(t),
                  o = /^ /.test(t) && / $/.test(t);
                return (
                  n && o && (t = t.substring(1, t.length - 1)),
                  (t = Rv(t, !0)),
                  { type: "codespan", raw: e[0], text: t }
                );
              }
            }
            br(t) {
              const e = this.rules.inline.br.exec(t);
              if (e) return { type: "br", raw: e[0] };
            }
            del(t) {
              const e = this.rules.inline.del.exec(t);
              if (e)
                return {
                  type: "del",
                  raw: e[0],
                  text: e[2],
                  tokens: this.lexer.inlineTokens(e[2], []),
                };
            }
            autolink(t, e) {
              const n = this.rules.inline.autolink.exec(t);
              if (n) {
                let t, o;
                return (
                  "@" === n[2]
                    ? ((t = Rv(this.options.mangle ? e(n[1]) : n[1])),
                      (o = "mailto:" + t))
                    : ((t = Rv(n[1])), (o = t)),
                  {
                    type: "link",
                    raw: n[0],
                    text: t,
                    href: o,
                    tokens: [{ type: "text", raw: t, text: t }],
                  }
                );
              }
            }
            url(t, e) {
              let n;
              if ((n = this.rules.inline.url.exec(t))) {
                let t, o;
                if ("@" === n[2])
                  (t = Rv(this.options.mangle ? e(n[0]) : n[0])),
                    (o = "mailto:" + t);
                else {
                  let e;
                  do {
                    (e = n[0]),
                      (n[0] = this.rules.inline._backpedal.exec(n[0])[0]);
                  } while (e !== n[0]);
                  (t = Rv(n[0])), (o = "www." === n[1] ? "http://" + t : t);
                }
                return {
                  type: "link",
                  raw: n[0],
                  text: t,
                  href: o,
                  tokens: [{ type: "text", raw: t, text: t }],
                };
              }
            }
            inlineText(t, e) {
              const n = this.rules.inline.text.exec(t);
              if (n) {
                let t;
                return (
                  (t = this.lexer.state.inRawBlock
                    ? this.options.sanitize
                      ? this.options.sanitizer
                        ? this.options.sanitizer(n[0])
                        : Rv(n[0])
                      : n[0]
                    : Rv(this.options.smartypants ? e(n[0]) : n[0])),
                  { type: "text", raw: n[0], text: t }
                );
              }
            }
          }
          const oy = {
            newline: /^(?: *(?:\n|$))+/,
            code: /^( {4}[^\n]+(?:\n(?: *(?:\n|$))*)?)+/,
            fences:
              /^ {0,3}(`{3,}(?=[^`\n]*\n)|~{3,})([^\n]*)\n(?:|([\s\S]*?)\n)(?: {0,3}\1[~`]* *(?=\n|$)|$)/,
            hr: /^ {0,3}((?:- *){3,}|(?:_ *){3,}|(?:\* *){3,})(?:\n+|$)/,
            heading: /^ {0,3}(#{1,6})(?=\s|$)(.*)(?:\n+|$)/,
            blockquote: /^( {0,3}> ?(paragraph|[^\n]*)(?:\n|$))+/,
            list: /^( {0,3}bull)( [^\n]+?)?(?:\n|$)/,
            html: "^ {0,3}(?:<(script|pre|style|textarea)[\\s>][\\s\\S]*?(?:</\\1>[^\\n]*\\n+|$)|comment[^\\n]*(\\n+|$)|<\\?[\\s\\S]*?(?:\\?>\\n*|$)|<![A-Z][\\s\\S]*?(?:>\\n*|$)|<!\\[CDATA\\[[\\s\\S]*?(?:\\]\\]>\\n*|$)|</?(tag)(?: +|\\n|/?>)[\\s\\S]*?(?:(?:\\n *)+\\n|$)|<(?!script|pre|style|textarea)([a-z][\\w-]*)(?:attribute)*? */?>(?=[ \\t]*(?:\\n|$))[\\s\\S]*?(?:(?:\\n *)+\\n|$)|</(?!script|pre|style|textarea)[a-z][\\w-]*\\s*>(?=[ \\t]*(?:\\n|$))[\\s\\S]*?(?:(?:\\n *)+\\n|$))",
            def: /^ {0,3}\[(label)\]: *(?:\n *)?<?([^\s>]+)>?(?:(?: +(?:\n *)?| *\n *)(title))? *(?:\n+|$)/,
            table: Yv,
            lheading: /^([^\n]+)\n {0,3}(=+|-+) *(?:\n+|$)/,
            _paragraph:
              /^([^\n]+(?:\n(?!hr|heading|lheading|blockquote|fences|list|html|table| +\n)[^\n]+)*)/,
            text: /^[^\n]+/,
            _label: /(?!\s*\])(?:\\.|[^\[\]\\])+/,
            _title:
              /(?:"(?:\\"?|[^"\\])*"|'[^'\n]*(?:\n[^'\n]+)*\n?'|\([^()]*\))/,
          };
          (oy.def = Fv(oy.def)
            .replace("label", oy._label)
            .replace("title", oy._title)
            .getRegex()),
            (oy.bullet = /(?:[*+-]|\d{1,9}[.)])/),
            (oy.listItemStart = Fv(/^( *)(bull) */)
              .replace("bull", oy.bullet)
              .getRegex()),
            (oy.list = Fv(oy.list)
              .replace(/bull/g, oy.bullet)
              .replace(
                "hr",
                "\\n+(?=\\1?(?:(?:- *){3,}|(?:_ *){3,}|(?:\\* *){3,})(?:\\n+|$))"
              )
              .replace("def", "\\n+(?=" + oy.def.source + ")")
              .getRegex()),
            (oy._tag =
              "address|article|aside|base|basefont|blockquote|body|caption|center|col|colgroup|dd|details|dialog|dir|div|dl|dt|fieldset|figcaption|figure|footer|form|frame|frameset|h[1-6]|head|header|hr|html|iframe|legend|li|link|main|menu|menuitem|meta|nav|noframes|ol|optgroup|option|p|param|section|source|summary|table|tbody|td|tfoot|th|thead|title|tr|track|ul"),
            (oy._comment = /<!--(?!-?>)[\s\S]*?(?:-->|$)/),
            (oy.html = Fv(oy.html, "i")
              .replace("comment", oy._comment)
              .replace("tag", oy._tag)
              .replace(
                "attribute",
                / +[a-zA-Z:_][\w.:-]*(?: *= *"[^"\n]*"| *= *'[^'\n]*'| *= *[^\s"'=<>`]+)?/
              )
              .getRegex()),
            (oy.paragraph = Fv(oy._paragraph)
              .replace("hr", oy.hr)
              .replace("heading", " {0,3}#{1,6} ")
              .replace("|lheading", "")
              .replace("|table", "")
              .replace("blockquote", " {0,3}>")
              .replace(
                "fences",
                " {0,3}(?:`{3,}(?=[^`\\n]*\\n)|~{3,})[^\\n]*\\n"
              )
              .replace("list", " {0,3}(?:[*+-]|1[.)]) ")
              .replace(
                "html",
                "</?(?:tag)(?: +|\\n|/?>)|<(?:script|pre|style|textarea|!--)"
              )
              .replace("tag", oy._tag)
              .getRegex()),
            (oy.blockquote = Fv(oy.blockquote)
              .replace("paragraph", oy.paragraph)
              .getRegex()),
            (oy.normal = Kv({}, oy)),
            (oy.gfm = Kv({}, oy.normal, {
              table:
                "^ *([^\\n ].*\\|.*)\\n {0,3}(?:\\| *)?(:?-+:? *(?:\\| *:?-+:? *)*)(?:\\| *)?(?:\\n((?:(?! *\\n|hr|heading|blockquote|code|fences|list|html).*(?:\\n|$))*)\\n*|$)",
            })),
            (oy.gfm.table = Fv(oy.gfm.table)
              .replace("hr", oy.hr)
              .replace("heading", " {0,3}#{1,6} ")
              .replace("blockquote", " {0,3}>")
              .replace("code", " {4}[^\\n]")
              .replace(
                "fences",
                " {0,3}(?:`{3,}(?=[^`\\n]*\\n)|~{3,})[^\\n]*\\n"
              )
              .replace("list", " {0,3}(?:[*+-]|1[.)]) ")
              .replace(
                "html",
                "</?(?:tag)(?: +|\\n|/?>)|<(?:script|pre|style|textarea|!--)"
              )
              .replace("tag", oy._tag)
              .getRegex()),
            (oy.gfm.paragraph = Fv(oy._paragraph)
              .replace("hr", oy.hr)
              .replace("heading", " {0,3}#{1,6} ")
              .replace("|lheading", "")
              .replace("table", oy.gfm.table)
              .replace("blockquote", " {0,3}>")
              .replace(
                "fences",
                " {0,3}(?:`{3,}(?=[^`\\n]*\\n)|~{3,})[^\\n]*\\n"
              )
              .replace("list", " {0,3}(?:[*+-]|1[.)]) ")
              .replace(
                "html",
                "</?(?:tag)(?: +|\\n|/?>)|<(?:script|pre|style|textarea|!--)"
              )
              .replace("tag", oy._tag)
              .getRegex()),
            (oy.pedantic = Kv({}, oy.normal, {
              html: Fv(
                "^ *(?:comment *(?:\\n|\\s*$)|<(tag)[\\s\\S]+?</\\1> *(?:\\n{2,}|\\s*$)|<tag(?:\"[^\"]*\"|'[^']*'|\\s[^'\"/>\\s]*)*?/?> *(?:\\n{2,}|\\s*$))"
              )
                .replace("comment", oy._comment)
                .replace(
                  /tag/g,
                  "(?!(?:a|em|strong|small|s|cite|q|dfn|abbr|data|time|code|var|samp|kbd|sub|sup|i|b|u|mark|ruby|rt|rp|bdi|bdo|span|br|wbr|ins|del|img)\\b)\\w+(?!:|[^\\w\\s@]*@)\\b"
                )
                .getRegex(),
              def: /^ *\[([^\]]+)\]: *<?([^\s>]+)>?(?: +(["(][^\n]+[")]))? *(?:\n+|$)/,
              heading: /^(#{1,6})(.*)(?:\n+|$)/,
              fences: Yv,
              paragraph: Fv(oy.normal._paragraph)
                .replace("hr", oy.hr)
                .replace("heading", " *#{1,6} *[^\n]")
                .replace("lheading", oy.lheading)
                .replace("blockquote", " {0,3}>")
                .replace("|fences", "")
                .replace("|list", "")
                .replace("|html", "")
                .getRegex(),
            }));
          const iy = {
            escape: /^\\([!"#$%&'()*+,\-./:;<=>?@\[\]\\^_`{|}~])/,
            autolink: /^<(scheme:[^\s\x00-\x1f<>]*|email)>/,
            url: Yv,
            tag: "^comment|^</[a-zA-Z][\\w:-]*\\s*>|^<[a-zA-Z][\\w-]*(?:attribute)*?\\s*/?>|^<\\?[\\s\\S]*?\\?>|^<![a-zA-Z]+\\s[\\s\\S]*?>|^<!\\[CDATA\\[[\\s\\S]*?\\]\\]>",
            link: /^!?\[(label)\]\(\s*(href)(?:\s+(title))?\s*\)/,
            reflink: /^!?\[(label)\]\[(ref)\]/,
            nolink: /^!?\[(ref)\](?:\[\])?/,
            reflinkSearch: "reflink|nolink(?!\\()",
            emStrong: {
              lDelim:
                /^(?:\*+(?:([punct_])|[^\s*]))|^_+(?:([punct*])|([^\s_]))/,
              rDelimAst:
                /^[^_*]*?\_\_[^_*]*?\*[^_*]*?(?=\_\_)|[punct_](\*+)(?=[\s]|$)|[^punct*_\s](\*+)(?=[punct_\s]|$)|[punct_\s](\*+)(?=[^punct*_\s])|[\s](\*+)(?=[punct_])|[punct_](\*+)(?=[punct_])|[^punct*_\s](\*+)(?=[^punct*_\s])/,
              rDelimUnd:
                /^[^_*]*?\*\*[^_*]*?\_[^_*]*?(?=\*\*)|[punct*](\_+)(?=[\s]|$)|[^punct*_\s](\_+)(?=[punct*\s]|$)|[punct*\s](\_+)(?=[^punct*_\s])|[\s](\_+)(?=[punct*])|[punct*](\_+)(?=[punct*])/,
            },
            code: /^(`+)([^`]|[^`][\s\S]*?[^`])\1(?!`)/,
            br: /^( {2,}|\\)\n(?!\s*$)/,
            del: Yv,
            text: /^(`+|[^`])(?:(?= {2,}\n)|[\s\S]*?(?:(?=[\\<!\[`*_]|\b_|$)|[^ ](?= {2,}\n)))/,
            punctuation: /^([\spunctuation])/,
          };
          function ry(t) {
            return t
              .replace(/---/g, "—")
              .replace(/--/g, "–")
              .replace(/(^|[-\u2014/(\[{"\s])'/g, "$1‘")
              .replace(/'/g, "’")
              .replace(/(^|[-\u2014/(\[{\u2018\s])"/g, "$1“")
              .replace(/"/g, "”")
              .replace(/\.{3}/g, "…");
          }
          function sy(t) {
            let e,
              n,
              o = "";
            const i = t.length;
            for (e = 0; e < i; e++)
              (n = t.charCodeAt(e)),
                Math.random() > 0.5 && (n = "x" + n.toString(16)),
                (o += "&#" + n + ";");
            return o;
          }
          (iy._punctuation = "!\"#$%&'()+\\-.,/:;<=>?@\\[\\]`^{|}~"),
            (iy.punctuation = Fv(iy.punctuation)
              .replace(/punctuation/g, iy._punctuation)
              .getRegex()),
            (iy.blockSkip = /\[[^\]]*?\]\([^\)]*?\)|`[^`]*?`|<[^>]*?>/g),
            (iy.escapedEmSt = /\\\*|\\_/g),
            (iy._comment = Fv(oy._comment)
              .replace("(?:--\x3e|$)", "--\x3e")
              .getRegex()),
            (iy.emStrong.lDelim = Fv(iy.emStrong.lDelim)
              .replace(/punct/g, iy._punctuation)
              .getRegex()),
            (iy.emStrong.rDelimAst = Fv(iy.emStrong.rDelimAst, "g")
              .replace(/punct/g, iy._punctuation)
              .getRegex()),
            (iy.emStrong.rDelimUnd = Fv(iy.emStrong.rDelimUnd, "g")
              .replace(/punct/g, iy._punctuation)
              .getRegex()),
            (iy._escapes = /\\([!"#$%&'()*+,\-./:;<=>?@\[\]\\^_`{|}~])/g),
            (iy._scheme = /[a-zA-Z][a-zA-Z0-9+.-]{1,31}/),
            (iy._email =
              /[a-zA-Z0-9.!#$%&'*+/=?^_`{|}~-]+(@)[a-zA-Z0-9](?:[a-zA-Z0-9-]{0,61}[a-zA-Z0-9])?(?:\.[a-zA-Z0-9](?:[a-zA-Z0-9-]{0,61}[a-zA-Z0-9])?)+(?![-_])/),
            (iy.autolink = Fv(iy.autolink)
              .replace("scheme", iy._scheme)
              .replace("email", iy._email)
              .getRegex()),
            (iy._attribute =
              /\s+[a-zA-Z:_][\w.:-]*(?:\s*=\s*"[^"]*"|\s*=\s*'[^']*'|\s*=\s*[^\s"'=<>`]+)?/),
            (iy.tag = Fv(iy.tag)
              .replace("comment", iy._comment)
              .replace("attribute", iy._attribute)
              .getRegex()),
            (iy._label = /(?:\[(?:\\.|[^\[\]\\])*\]|\\.|`[^`]*`|[^\[\]\\`])*?/),
            (iy._href = /<(?:\\.|[^\n<>\\])+>|[^\s\x00-\x1f]*/),
            (iy._title =
              /"(?:\\"?|[^"\\])*"|'(?:\\'?|[^'\\])*'|\((?:\\\)?|[^)\\])*\)/),
            (iy.link = Fv(iy.link)
              .replace("label", iy._label)
              .replace("href", iy._href)
              .replace("title", iy._title)
              .getRegex()),
            (iy.reflink = Fv(iy.reflink)
              .replace("label", iy._label)
              .replace("ref", oy._label)
              .getRegex()),
            (iy.nolink = Fv(iy.nolink).replace("ref", oy._label).getRegex()),
            (iy.reflinkSearch = Fv(iy.reflinkSearch, "g")
              .replace("reflink", iy.reflink)
              .replace("nolink", iy.nolink)
              .getRegex()),
            (iy.normal = Kv({}, iy)),
            (iy.pedantic = Kv({}, iy.normal, {
              strong: {
                start: /^__|\*\*/,
                middle:
                  /^__(?=\S)([\s\S]*?\S)__(?!_)|^\*\*(?=\S)([\s\S]*?\S)\*\*(?!\*)/,
                endAst: /\*\*(?!\*)/g,
                endUnd: /__(?!_)/g,
              },
              em: {
                start: /^_|\*/,
                middle:
                  /^()\*(?=\S)([\s\S]*?\S)\*(?!\*)|^_(?=\S)([\s\S]*?\S)_(?!_)/,
                endAst: /\*(?!\*)/g,
                endUnd: /_(?!_)/g,
              },
              link: Fv(/^!?\[(label)\]\((.*?)\)/)
                .replace("label", iy._label)
                .getRegex(),
              reflink: Fv(/^!?\[(label)\]\s*\[([^\]]*)\]/)
                .replace("label", iy._label)
                .getRegex(),
            })),
            (iy.gfm = Kv({}, iy.normal, {
              escape: Fv(iy.escape).replace("])", "~|])").getRegex(),
              _extended_email:
                /[A-Za-z0-9._+-]+(@)[a-zA-Z0-9-_]+(?:\.[a-zA-Z0-9-_]*[a-zA-Z0-9])+(?![-_])/,
              url: /^((?:ftp|https?):\/\/|www\.)(?:[a-zA-Z0-9\-]+\.?)+[^\s<]*|^email/,
              _backpedal:
                /(?:[^?!.,:;*_~()&]+|\([^)]*\)|&(?![a-zA-Z0-9]+;$)|[?!.,:;*_~)]+(?!$))+/,
              del: /^(~~?)(?=[^\s~])([\s\S]*?[^\s~])\1(?=[^~]|$)/,
              text: /^([`~]+|[^`~])(?:(?= {2,}\n)|(?=[a-zA-Z0-9.!#$%&'*+\/=?_`{\|}~-]+@)|[\s\S]*?(?:(?=[\\<!\[`*~_]|\b_|https?:\/\/|ftp:\/\/|www\.|$)|[^ ](?= {2,}\n)|[^a-zA-Z0-9.!#$%&'*+\/=?_`{\|}~-](?=[a-zA-Z0-9.!#$%&'*+\/=?_`{\|}~-]+@)))/,
            })),
            (iy.gfm.url = Fv(iy.gfm.url, "i")
              .replace("email", iy.gfm._extended_email)
              .getRegex()),
            (iy.breaks = Kv({}, iy.gfm, {
              br: Fv(iy.br).replace("{2,}", "*").getRegex(),
              text: Fv(iy.gfm.text)
                .replace("\\b_", "\\b_| {2,}\\n")
                .replace(/\{2,\}/g, "*")
                .getRegex(),
            }));
          class ay {
            constructor(t) {
              (this.tokens = []),
                (this.tokens.links = Object.create(null)),
                (this.options = t || Tv),
                (this.options.tokenizer = this.options.tokenizer || new ny()),
                (this.tokenizer = this.options.tokenizer),
                (this.tokenizer.options = this.options),
                (this.tokenizer.lexer = this),
                (this.inlineQueue = []),
                (this.state = { inLink: !1, inRawBlock: !1, top: !0 });
              const e = { block: oy.normal, inline: iy.normal };
              this.options.pedantic
                ? ((e.block = oy.pedantic), (e.inline = iy.pedantic))
                : this.options.gfm &&
                  ((e.block = oy.gfm),
                  this.options.breaks
                    ? (e.inline = iy.breaks)
                    : (e.inline = iy.gfm)),
                (this.tokenizer.rules = e);
            }
            static get rules() {
              return { block: oy, inline: iy };
            }
            static lex(t, e) {
              return new ay(e).lex(t);
            }
            static lexInline(t, e) {
              return new ay(e).inlineTokens(t);
            }
            lex(t) {
              let e;
              for (
                t = t.replace(/\r\n|\r/g, "\n").replace(/\t/g, "    "),
                  this.blockTokens(t, this.tokens);
                (e = this.inlineQueue.shift());

              )
                this.inlineTokens(e.src, e.tokens);
              return this.tokens;
            }
            blockTokens(t, e = []) {
              let n, o, i, r;
              for (this.options.pedantic && (t = t.replace(/^ +$/gm, "")); t; )
                if (
                  !(
                    this.options.extensions &&
                    this.options.extensions.block &&
                    this.options.extensions.block.some(
                      (o) =>
                        !!(n = o.call({ lexer: this }, t, e)) &&
                        ((t = t.substring(n.raw.length)), e.push(n), !0)
                    )
                  )
                )
                  if ((n = this.tokenizer.space(t)))
                    (t = t.substring(n.raw.length)),
                      1 === n.raw.length && e.length > 0
                        ? (e[e.length - 1].raw += "\n")
                        : e.push(n);
                  else if ((n = this.tokenizer.code(t)))
                    (t = t.substring(n.raw.length)),
                      (o = e[e.length - 1]),
                      !o || ("paragraph" !== o.type && "text" !== o.type)
                        ? e.push(n)
                        : ((o.raw += "\n" + n.raw),
                          (o.text += "\n" + n.text),
                          (this.inlineQueue[this.inlineQueue.length - 1].src =
                            o.text));
                  else if ((n = this.tokenizer.fences(t)))
                    (t = t.substring(n.raw.length)), e.push(n);
                  else if ((n = this.tokenizer.heading(t)))
                    (t = t.substring(n.raw.length)), e.push(n);
                  else if ((n = this.tokenizer.hr(t)))
                    (t = t.substring(n.raw.length)), e.push(n);
                  else if ((n = this.tokenizer.blockquote(t)))
                    (t = t.substring(n.raw.length)), e.push(n);
                  else if ((n = this.tokenizer.list(t)))
                    (t = t.substring(n.raw.length)), e.push(n);
                  else if ((n = this.tokenizer.html(t)))
                    (t = t.substring(n.raw.length)), e.push(n);
                  else if ((n = this.tokenizer.def(t)))
                    (t = t.substring(n.raw.length)),
                      (o = e[e.length - 1]),
                      !o || ("paragraph" !== o.type && "text" !== o.type)
                        ? this.tokens.links[n.tag] ||
                          (this.tokens.links[n.tag] = {
                            href: n.href,
                            title: n.title,
                          })
                        : ((o.raw += "\n" + n.raw),
                          (o.text += "\n" + n.raw),
                          (this.inlineQueue[this.inlineQueue.length - 1].src =
                            o.text));
                  else if ((n = this.tokenizer.table(t)))
                    (t = t.substring(n.raw.length)), e.push(n);
                  else if ((n = this.tokenizer.lheading(t)))
                    (t = t.substring(n.raw.length)), e.push(n);
                  else {
                    if (
                      ((i = t),
                      this.options.extensions &&
                        this.options.extensions.startBlock)
                    ) {
                      let e = 1 / 0;
                      const n = t.slice(1);
                      let o;
                      this.options.extensions.startBlock.forEach(function (t) {
                        (o = t.call({ lexer: this }, n)),
                          "number" == typeof o &&
                            o >= 0 &&
                            (e = Math.min(e, o));
                      }),
                        e < 1 / 0 && e >= 0 && (i = t.substring(0, e + 1));
                    }
                    if (this.state.top && (n = this.tokenizer.paragraph(i)))
                      (o = e[e.length - 1]),
                        r && "paragraph" === o.type
                          ? ((o.raw += "\n" + n.raw),
                            (o.text += "\n" + n.text),
                            this.inlineQueue.pop(),
                            (this.inlineQueue[this.inlineQueue.length - 1].src =
                              o.text))
                          : e.push(n),
                        (r = i.length !== t.length),
                        (t = t.substring(n.raw.length));
                    else if ((n = this.tokenizer.text(t)))
                      (t = t.substring(n.raw.length)),
                        (o = e[e.length - 1]),
                        o && "text" === o.type
                          ? ((o.raw += "\n" + n.raw),
                            (o.text += "\n" + n.text),
                            this.inlineQueue.pop(),
                            (this.inlineQueue[this.inlineQueue.length - 1].src =
                              o.text))
                          : e.push(n);
                    else if (t) {
                      const e = "Infinite loop on byte: " + t.charCodeAt(0);
                      if (this.options.silent) {
                        console.error(e);
                        break;
                      }
                      throw new Error(e);
                    }
                  }
              return (this.state.top = !0), e;
            }
            inline(t, e) {
              this.inlineQueue.push({ src: t, tokens: e });
            }
            inlineTokens(t, e = []) {
              let n,
                o,
                i,
                r,
                s,
                a,
                l = t;
              if (this.tokens.links) {
                const t = Object.keys(this.tokens.links);
                if (t.length > 0)
                  for (
                    ;
                    null !=
                    (r = this.tokenizer.rules.inline.reflinkSearch.exec(l));

                  )
                    t.includes(r[0].slice(r[0].lastIndexOf("[") + 1, -1)) &&
                      (l =
                        l.slice(0, r.index) +
                        "[" +
                        ty("a", r[0].length - 2) +
                        "]" +
                        l.slice(
                          this.tokenizer.rules.inline.reflinkSearch.lastIndex
                        ));
              }
              for (
                ;
                null != (r = this.tokenizer.rules.inline.blockSkip.exec(l));

              )
                l =
                  l.slice(0, r.index) +
                  "[" +
                  ty("a", r[0].length - 2) +
                  "]" +
                  l.slice(this.tokenizer.rules.inline.blockSkip.lastIndex);
              for (
                ;
                null != (r = this.tokenizer.rules.inline.escapedEmSt.exec(l));

              )
                l =
                  l.slice(0, r.index) +
                  "++" +
                  l.slice(this.tokenizer.rules.inline.escapedEmSt.lastIndex);
              for (; t; )
                if (
                  (s || (a = ""),
                  (s = !1),
                  !(
                    this.options.extensions &&
                    this.options.extensions.inline &&
                    this.options.extensions.inline.some(
                      (o) =>
                        !!(n = o.call({ lexer: this }, t, e)) &&
                        ((t = t.substring(n.raw.length)), e.push(n), !0)
                    )
                  ))
                )
                  if ((n = this.tokenizer.escape(t)))
                    (t = t.substring(n.raw.length)), e.push(n);
                  else if ((n = this.tokenizer.tag(t)))
                    (t = t.substring(n.raw.length)),
                      (o = e[e.length - 1]),
                      o && "text" === n.type && "text" === o.type
                        ? ((o.raw += n.raw), (o.text += n.text))
                        : e.push(n);
                  else if ((n = this.tokenizer.link(t)))
                    (t = t.substring(n.raw.length)), e.push(n);
                  else if ((n = this.tokenizer.reflink(t, this.tokens.links)))
                    (t = t.substring(n.raw.length)),
                      (o = e[e.length - 1]),
                      o && "text" === n.type && "text" === o.type
                        ? ((o.raw += n.raw), (o.text += n.text))
                        : e.push(n);
                  else if ((n = this.tokenizer.emStrong(t, l, a)))
                    (t = t.substring(n.raw.length)), e.push(n);
                  else if ((n = this.tokenizer.codespan(t)))
                    (t = t.substring(n.raw.length)), e.push(n);
                  else if ((n = this.tokenizer.br(t)))
                    (t = t.substring(n.raw.length)), e.push(n);
                  else if ((n = this.tokenizer.del(t)))
                    (t = t.substring(n.raw.length)), e.push(n);
                  else if ((n = this.tokenizer.autolink(t, sy)))
                    (t = t.substring(n.raw.length)), e.push(n);
                  else if (
                    this.state.inLink ||
                    !(n = this.tokenizer.url(t, sy))
                  ) {
                    if (
                      ((i = t),
                      this.options.extensions &&
                        this.options.extensions.startInline)
                    ) {
                      let e = 1 / 0;
                      const n = t.slice(1);
                      let o;
                      this.options.extensions.startInline.forEach(function (t) {
                        (o = t.call({ lexer: this }, n)),
                          "number" == typeof o &&
                            o >= 0 &&
                            (e = Math.min(e, o));
                      }),
                        e < 1 / 0 && e >= 0 && (i = t.substring(0, e + 1));
                    }
                    if ((n = this.tokenizer.inlineText(i, ry)))
                      (t = t.substring(n.raw.length)),
                        "_" !== n.raw.slice(-1) && (a = n.raw.slice(-1)),
                        (s = !0),
                        (o = e[e.length - 1]),
                        o && "text" === o.type
                          ? ((o.raw += n.raw), (o.text += n.text))
                          : e.push(n);
                    else if (t) {
                      const e = "Infinite loop on byte: " + t.charCodeAt(0);
                      if (this.options.silent) {
                        console.error(e);
                        break;
                      }
                      throw new Error(e);
                    }
                  } else (t = t.substring(n.raw.length)), e.push(n);
              return e;
            }
          }
          class ly {
            constructor(t) {
              this.options = t || Tv;
            }
            code(t, e, n) {
              const o = (e || "").match(/\S*/)[0];
              if (this.options.highlight) {
                const e = this.options.highlight(t, o);
                null != e && e !== t && ((n = !0), (t = e));
              }
              return (
                (t = t.replace(/\n$/, "") + "\n"),
                o
                  ? '<pre><code class="' +
                    this.options.langPrefix +
                    Rv(o, !0) +
                    '">' +
                    (n ? t : Rv(t, !0)) +
                    "</code></pre>\n"
                  : "<pre><code>" + (n ? t : Rv(t, !0)) + "</code></pre>\n"
              );
            }
            blockquote(t) {
              return "<blockquote>\n" + t + "</blockquote>\n";
            }
            html(t) {
              return t;
            }
            heading(t, e, n, o) {
              return this.options.headerIds
                ? "<h" +
                    e +
                    ' id="' +
                    this.options.headerPrefix +
                    o.slug(n) +
                    '">' +
                    t +
                    "</h" +
                    e +
                    ">\n"
                : "<h" + e + ">" + t + "</h" + e + ">\n";
            }
            hr() {
              return this.options.xhtml ? "<hr/>\n" : "<hr>\n";
            }
            list(t, e, n) {
              const o = e ? "ol" : "ul";
              return (
                "<" +
                o +
                (e && 1 !== n ? ' start="' + n + '"' : "") +
                ">\n" +
                t +
                "</" +
                o +
                ">\n"
              );
            }
            listitem(t) {
              return "<li>" + t + "</li>\n";
            }
            checkbox(t) {
              return (
                "<input " +
                (t ? 'checked="" ' : "") +
                'disabled="" type="checkbox"' +
                (this.options.xhtml ? " /" : "") +
                "> "
              );
            }
            paragraph(t) {
              return "<p>" + t + "</p>\n";
            }
            table(t, e) {
              return (
                e && (e = "<tbody>" + e + "</tbody>"),
                "<table>\n<thead>\n" + t + "</thead>\n" + e + "</table>\n"
              );
            }
            tablerow(t) {
              return "<tr>\n" + t + "</tr>\n";
            }
            tablecell(t, e) {
              const n = e.header ? "th" : "td";
              return (
                (e.align
                  ? "<" + n + ' align="' + e.align + '">'
                  : "<" + n + ">") +
                t +
                "</" +
                n +
                ">\n"
              );
            }
            strong(t) {
              return "<strong>" + t + "</strong>";
            }
            em(t) {
              return "<em>" + t + "</em>";
            }
            codespan(t) {
              return "<code>" + t + "</code>";
            }
            br() {
              return this.options.xhtml ? "<br/>" : "<br>";
            }
            del(t) {
              return "<del>" + t + "</del>";
            }
            link(t, e, n) {
              if (
                null ===
                (t = Wv(this.options.sanitize, this.options.baseUrl, t))
              )
                return n;
              let o = '<a href="' + Rv(t) + '"';
              return (
                e && (o += ' title="' + e + '"'), (o += ">" + n + "</a>"), o
              );
            }
            image(t, e, n) {
              if (
                null ===
                (t = Wv(this.options.sanitize, this.options.baseUrl, t))
              )
                return n;
              let o = '<img src="' + t + '" alt="' + n + '"';
              return (
                e && (o += ' title="' + e + '"'),
                (o += this.options.xhtml ? "/>" : ">"),
                o
              );
            }
            text(t) {
              return t;
            }
          }
          class cy {
            strong(t) {
              return t;
            }
            em(t) {
              return t;
            }
            codespan(t) {
              return t;
            }
            del(t) {
              return t;
            }
            html(t) {
              return t;
            }
            text(t) {
              return t;
            }
            link(t, e, n) {
              return "" + n;
            }
            image(t, e, n) {
              return "" + n;
            }
            br() {
              return "";
            }
          }
          class dy {
            constructor() {
              this.seen = {};
            }
            serialize(t) {
              return t
                .toLowerCase()
                .trim()
                .replace(/<[!\/a-z].*?>/gi, "")
                .replace(
                  /[\u2000-\u206F\u2E00-\u2E7F\\'!"#$%&()*+,./:;<=>?@[\]^`{|}~]/g,
                  ""
                )
                .replace(/\s/g, "-");
            }
            getNextSafeSlug(t, e) {
              let n = t,
                o = 0;
              if (this.seen.hasOwnProperty(n)) {
                o = this.seen[t];
                do {
                  o++, (n = t + "-" + o);
                } while (this.seen.hasOwnProperty(n));
              }
              return e || ((this.seen[t] = o), (this.seen[n] = 0)), n;
            }
            slug(t, e = {}) {
              const n = this.serialize(t);
              return this.getNextSafeSlug(n, e.dryrun);
            }
          }
          class uy {
            constructor(t) {
              (this.options = t || Tv),
                (this.options.renderer = this.options.renderer || new ly()),
                (this.renderer = this.options.renderer),
                (this.renderer.options = this.options),
                (this.textRenderer = new cy()),
                (this.slugger = new dy());
            }
            static parse(t, e) {
              return new uy(e).parse(t);
            }
            static parseInline(t, e) {
              return new uy(e).parseInline(t);
            }
            parse(t, e = !0) {
              let n,
                o,
                i,
                r,
                s,
                a,
                l,
                c,
                d,
                u,
                h,
                m,
                g,
                p,
                f,
                k,
                b,
                w,
                A,
                _ = "";
              const C = t.length;
              for (n = 0; n < C; n++)
                if (
                  ((u = t[n]),
                  this.options.extensions &&
                    this.options.extensions.renderers &&
                    this.options.extensions.renderers[u.type] &&
                    ((A = this.options.extensions.renderers[u.type].call(
                      { parser: this },
                      u
                    )),
                    !1 !== A ||
                      ![
                        "space",
                        "hr",
                        "heading",
                        "code",
                        "table",
                        "blockquote",
                        "list",
                        "html",
                        "paragraph",
                        "text",
                      ].includes(u.type)))
                )
                  _ += A || "";
                else
                  switch (u.type) {
                    case "space":
                      continue;
                    case "hr":
                      _ += this.renderer.hr();
                      continue;
                    case "heading":
                      _ += this.renderer.heading(
                        this.parseInline(u.tokens),
                        u.depth,
                        jv(this.parseInline(u.tokens, this.textRenderer)),
                        this.slugger
                      );
                      continue;
                    case "code":
                      _ += this.renderer.code(u.text, u.lang, u.escaped);
                      continue;
                    case "table":
                      for (
                        c = "", l = "", r = u.header.length, o = 0;
                        o < r;
                        o++
                      )
                        l += this.renderer.tablecell(
                          this.parseInline(u.header[o].tokens),
                          { header: !0, align: u.align[o] }
                        );
                      for (
                        c += this.renderer.tablerow(l),
                          d = "",
                          r = u.rows.length,
                          o = 0;
                        o < r;
                        o++
                      ) {
                        for (
                          a = u.rows[o], l = "", s = a.length, i = 0;
                          i < s;
                          i++
                        )
                          l += this.renderer.tablecell(
                            this.parseInline(a[i].tokens),
                            { header: !1, align: u.align[i] }
                          );
                        d += this.renderer.tablerow(l);
                      }
                      _ += this.renderer.table(c, d);
                      continue;
                    case "blockquote":
                      (d = this.parse(u.tokens)),
                        (_ += this.renderer.blockquote(d));
                      continue;
                    case "list":
                      for (
                        h = u.ordered,
                          m = u.start,
                          g = u.loose,
                          r = u.items.length,
                          d = "",
                          o = 0;
                        o < r;
                        o++
                      )
                        (f = u.items[o]),
                          (k = f.checked),
                          (b = f.task),
                          (p = ""),
                          f.task &&
                            ((w = this.renderer.checkbox(k)),
                            g
                              ? f.tokens.length > 0 &&
                                "paragraph" === f.tokens[0].type
                                ? ((f.tokens[0].text =
                                    w + " " + f.tokens[0].text),
                                  f.tokens[0].tokens &&
                                    f.tokens[0].tokens.length > 0 &&
                                    "text" === f.tokens[0].tokens[0].type &&
                                    (f.tokens[0].tokens[0].text =
                                      w + " " + f.tokens[0].tokens[0].text))
                                : f.tokens.unshift({ type: "text", text: w })
                              : (p += w)),
                          (p += this.parse(f.tokens, g)),
                          (d += this.renderer.listitem(p, b, k));
                      _ += this.renderer.list(d, h, m);
                      continue;
                    case "html":
                      _ += this.renderer.html(u.text);
                      continue;
                    case "paragraph":
                      _ += this.renderer.paragraph(this.parseInline(u.tokens));
                      continue;
                    case "text":
                      for (
                        d = u.tokens ? this.parseInline(u.tokens) : u.text;
                        n + 1 < C && "text" === t[n + 1].type;

                      )
                        (u = t[++n]),
                          (d +=
                            "\n" +
                            (u.tokens ? this.parseInline(u.tokens) : u.text));
                      _ += e ? this.renderer.paragraph(d) : d;
                      continue;
                    default: {
                      const t =
                        'Token with "' + u.type + '" type was not found.';
                      if (this.options.silent) return void console.error(t);
                      throw new Error(t);
                    }
                  }
              return _;
            }
            parseInline(t, e) {
              e = e || this.renderer;
              let n,
                o,
                i,
                r = "";
              const s = t.length;
              for (n = 0; n < s; n++)
                if (
                  ((o = t[n]),
                  this.options.extensions &&
                    this.options.extensions.renderers &&
                    this.options.extensions.renderers[o.type] &&
                    ((i = this.options.extensions.renderers[o.type].call(
                      { parser: this },
                      o
                    )),
                    !1 !== i ||
                      ![
                        "escape",
                        "html",
                        "link",
                        "image",
                        "strong",
                        "em",
                        "codespan",
                        "br",
                        "del",
                        "text",
                      ].includes(o.type)))
                )
                  r += i || "";
                else
                  switch (o.type) {
                    case "escape":
                    case "text":
                      r += e.text(o.text);
                      break;
                    case "html":
                      r += e.html(o.text);
                      break;
                    case "link":
                      r += e.link(
                        o.href,
                        o.title,
                        this.parseInline(o.tokens, e)
                      );
                      break;
                    case "image":
                      r += e.image(o.href, o.title, o.text);
                      break;
                    case "strong":
                      r += e.strong(this.parseInline(o.tokens, e));
                      break;
                    case "em":
                      r += e.em(this.parseInline(o.tokens, e));
                      break;
                    case "codespan":
                      r += e.codespan(o.text);
                      break;
                    case "br":
                      r += e.br();
                      break;
                    case "del":
                      r += e.del(this.parseInline(o.tokens, e));
                      break;
                    default: {
                      const t =
                        'Token with "' + o.type + '" type was not found.';
                      if (this.options.silent) return void console.error(t);
                      throw new Error(t);
                    }
                  }
              return r;
            }
          }
          function hy(t, e, n) {
            if (null == t)
              throw new Error("marked(): input parameter is undefined or null");
            if ("string" != typeof t)
              throw new Error(
                "marked(): input parameter is of type " +
                  Object.prototype.toString.call(t) +
                  ", string expected"
              );
            if (
              ("function" == typeof e && ((n = e), (e = null)),
              Xv((e = Kv({}, hy.defaults, e || {}))),
              n)
            ) {
              const o = e.highlight;
              let i;
              try {
                i = ay.lex(t, e);
              } catch (t) {
                return n(t);
              }
              const r = function (t) {
                let r;
                if (!t)
                  try {
                    e.walkTokens && hy.walkTokens(i, e.walkTokens),
                      (r = uy.parse(i, e));
                  } catch (e) {
                    t = e;
                  }
                return (e.highlight = o), t ? n(t) : n(null, r);
              };
              if (!o || o.length < 3) return r();
              if ((delete e.highlight, !i.length)) return r();
              let s = 0;
              return (
                hy.walkTokens(i, function (t) {
                  "code" === t.type &&
                    (s++,
                    setTimeout(() => {
                      o(t.text, t.lang, function (e, n) {
                        if (e) return r(e);
                        null != n &&
                          n !== t.text &&
                          ((t.text = n), (t.escaped = !0)),
                          s--,
                          0 === s && r();
                      });
                    }, 0));
                }),
                void (0 === s && r())
              );
            }
            try {
              const n = ay.lex(t, e);
              return (
                e.walkTokens && hy.walkTokens(n, e.walkTokens), uy.parse(n, e)
              );
            } catch (t) {
              if (
                ((t.message +=
                  "\nPlease report this to https://github.com/markedjs/marked."),
                e.silent)
              )
                return (
                  "<p>An error occurred:</p><pre>" +
                  Rv(t.message + "", !0) +
                  "</pre>"
                );
              throw t;
            }
          }
          (hy.options = hy.setOptions =
            function (t) {
              var e;
              return Kv(hy.defaults, t), (e = hy.defaults), (Tv = e), hy;
            }),
            (hy.getDefaults = Iv),
            (hy.defaults = Tv),
            (hy.use = function (...t) {
              const e = Kv({}, ...t),
                n = hy.defaults.extensions || {
                  renderers: {},
                  childTokens: {},
                };
              let o;
              t.forEach((t) => {
                if (
                  (t.extensions &&
                    ((o = !0),
                    t.extensions.forEach((t) => {
                      if (!t.name) throw new Error("extension name required");
                      if (t.renderer) {
                        const e = n.renderers ? n.renderers[t.name] : null;
                        n.renderers[t.name] = e
                          ? function (...n) {
                              let o = t.renderer.apply(this, n);
                              return !1 === o && (o = e.apply(this, n)), o;
                            }
                          : t.renderer;
                      }
                      if (t.tokenizer) {
                        if (
                          !t.level ||
                          ("block" !== t.level && "inline" !== t.level)
                        )
                          throw new Error(
                            "extension level must be 'block' or 'inline'"
                          );
                        n[t.level]
                          ? n[t.level].unshift(t.tokenizer)
                          : (n[t.level] = [t.tokenizer]),
                          t.start &&
                            ("block" === t.level
                              ? n.startBlock
                                ? n.startBlock.push(t.start)
                                : (n.startBlock = [t.start])
                              : "inline" === t.level &&
                                (n.startInline
                                  ? n.startInline.push(t.start)
                                  : (n.startInline = [t.start])));
                      }
                      t.childTokens && (n.childTokens[t.name] = t.childTokens);
                    })),
                  t.renderer)
                ) {
                  const n = hy.defaults.renderer || new ly();
                  for (const e in t.renderer) {
                    const o = n[e];
                    n[e] = (...i) => {
                      let r = t.renderer[e].apply(n, i);
                      return !1 === r && (r = o.apply(n, i)), r;
                    };
                  }
                  e.renderer = n;
                }
                if (t.tokenizer) {
                  const n = hy.defaults.tokenizer || new ny();
                  for (const e in t.tokenizer) {
                    const o = n[e];
                    n[e] = (...i) => {
                      let r = t.tokenizer[e].apply(n, i);
                      return !1 === r && (r = o.apply(n, i)), r;
                    };
                  }
                  e.tokenizer = n;
                }
                if (t.walkTokens) {
                  const n = hy.defaults.walkTokens;
                  e.walkTokens = function (e) {
                    t.walkTokens.call(this, e), n && n.call(this, e);
                  };
                }
                o && (e.extensions = n), hy.setOptions(e);
              });
            }),
            (hy.walkTokens = function (t, e) {
              for (const n of t)
                switch ((e.call(hy, n), n.type)) {
                  case "table":
                    for (const t of n.header) hy.walkTokens(t.tokens, e);
                    for (const t of n.rows)
                      for (const n of t) hy.walkTokens(n.tokens, e);
                    break;
                  case "list":
                    hy.walkTokens(n.items, e);
                    break;
                  default:
                    hy.defaults.extensions &&
                    hy.defaults.extensions.childTokens &&
                    hy.defaults.extensions.childTokens[n.type]
                      ? hy.defaults.extensions.childTokens[n.type].forEach(
                          function (t) {
                            hy.walkTokens(n[t], e);
                          }
                        )
                      : n.tokens && hy.walkTokens(n.tokens, e);
                }
            }),
            (hy.parseInline = function (t, e) {
              if (null == t)
                throw new Error(
                  "marked.parseInline(): input parameter is undefined or null"
                );
              if ("string" != typeof t)
                throw new Error(
                  "marked.parseInline(): input parameter is of type " +
                    Object.prototype.toString.call(t) +
                    ", string expected"
                );
              Xv((e = Kv({}, hy.defaults, e || {})));
              try {
                const n = ay.lexInline(t, e);
                return (
                  e.walkTokens && hy.walkTokens(n, e.walkTokens),
                  uy.parseInline(n, e)
                );
              } catch (t) {
                if (
                  ((t.message +=
                    "\nPlease report this to https://github.com/markedjs/marked."),
                  e.silent)
                )
                  return (
                    "<p>An error occurred:</p><pre>" +
                    Rv(t.message + "", !0) +
                    "</pre>"
                  );
                throw t;
              }
            }),
            (hy.Parser = uy),
            (hy.parser = uy.parse),
            (hy.Renderer = ly),
            (hy.TextRenderer = cy),
            (hy.Lexer = ay),
            (hy.lexer = ay.lex),
            (hy.Tokenizer = ny),
            (hy.Slugger = dy),
            (hy.parse = hy);
          hy.options,
            hy.setOptions,
            hy.use,
            hy.walkTokens,
            hy.parseInline,
            uy.parse,
            ay.lex;
          function my(t, e) {
            return Array(e + 1).join(t);
          }
          hy.use({
            tokenizer: { autolink: () => null, url: () => null },
            renderer: {
              checkbox(...t) {
                return Object.getPrototypeOf(this)
                  .checkbox.call(this, ...t)
                  .trimRight();
              },
              code(...t) {
                return Object.getPrototypeOf(this)
                  .code.call(this, ...t)
                  .replace("\n</code>", "</code>");
              },
            },
          });
          var gy = [
            "address",
            "article",
            "aside",
            "audio",
            "blockquote",
            "body",
            "canvas",
            "center",
            "dd",
            "dir",
            "div",
            "dl",
            "dt",
            "fieldset",
            "figcaption",
            "figure",
            "footer",
            "form",
            "frameset",
            "h1",
            "h2",
            "h3",
            "h4",
            "h5",
            "h6",
            "header",
            "hgroup",
            "hr",
            "html",
            "isindex",
            "li",
            "main",
            "menu",
            "nav",
            "noframes",
            "noscript",
            "ol",
            "output",
            "p",
            "pre",
            "section",
            "table",
            "tbody",
            "td",
            "tfoot",
            "th",
            "thead",
            "tr",
            "ul",
          ];
          function py(t) {
            return -1 !== gy.indexOf(t.nodeName.toLowerCase());
          }
          var fy = [
            "area",
            "base",
            "br",
            "col",
            "command",
            "embed",
            "hr",
            "img",
            "input",
            "keygen",
            "link",
            "meta",
            "param",
            "source",
            "track",
            "wbr",
          ];
          function ky(t) {
            return -1 !== fy.indexOf(t.nodeName.toLowerCase());
          }
          var by = fy.join();
          var wy = {};
          function Ay(t) {
            for (var e in ((this.options = t),
            (this._keep = []),
            (this._remove = []),
            (this.blankRule = { replacement: t.blankReplacement }),
            (this.keepReplacement = t.keepReplacement),
            (this.defaultRule = { replacement: t.defaultReplacement }),
            (this.array = []),
            t.rules))
              this.array.push(t.rules[e]);
          }
          function _y(t, e, n) {
            for (var o = 0; o < t.length; o++) {
              var i = t[o];
              if (Cy(i, e, n)) return i;
            }
          }
          function Cy(t, e, n) {
            var o = t.filter;
            if ("string" == typeof o) {
              if (o === e.nodeName.toLowerCase()) return !0;
            } else if (Array.isArray(o)) {
              if (o.indexOf(e.nodeName.toLowerCase()) > -1) return !0;
            } else {
              if ("function" != typeof o)
                throw new TypeError(
                  "`filter` needs to be a string, array, or function"
                );
              if (o.call(t, e, n)) return !0;
            }
          }
          function vy(t) {
            var e = t.nextSibling || t.parentNode;
            return t.parentNode.removeChild(t), e;
          }
          function yy(t, e, n) {
            return (t && t.parentNode === e) || n(e)
              ? e.nextSibling || e.parentNode
              : e.firstChild || e.nextSibling || e.parentNode;
          }
          (wy.paragraph = {
            filter: "p",
            replacement: function (t) {
              return "\n\n" + t + "\n\n";
            },
          }),
            (wy.lineBreak = {
              filter: "br",
              replacement: function (t, e, n) {
                return n.br + "\n";
              },
            }),
            (wy.heading = {
              filter: ["h1", "h2", "h3", "h4", "h5", "h6"],
              replacement: function (t, e, n) {
                var o = Number(e.nodeName.charAt(1));
                return "setext" === n.headingStyle && o < 3
                  ? "\n\n" +
                      t +
                      "\n" +
                      my(1 === o ? "=" : "-", t.length) +
                      "\n\n"
                  : "\n\n" + my("#", o) + " " + t + "\n\n";
              },
            }),
            (wy.blockquote = {
              filter: "blockquote",
              replacement: function (t) {
                return (
                  "\n\n" +
                  (t = (t = t.replace(/^\n+|\n+$/g, "")).replace(/^/gm, "> ")) +
                  "\n\n"
                );
              },
            }),
            (wy.list = {
              filter: ["ul", "ol"],
              replacement: function (t, e) {
                var n = e.parentNode;
                return "LI" === n.nodeName && n.lastElementChild === e
                  ? "\n" + t
                  : "\n\n" + t + "\n\n";
              },
            }),
            (wy.listItem = {
              filter: "li",
              replacement: function (t, e, n) {
                t = t
                  .replace(/^\n+/, "")
                  .replace(/\n+$/, "\n")
                  .replace(/\n/gm, "\n    ");
                var o = n.bulletListMarker + "   ",
                  i = e.parentNode;
                if ("OL" === i.nodeName) {
                  var r = i.getAttribute("start"),
                    s = Array.prototype.indexOf.call(i.children, e);
                  o = (r ? Number(r) + s : s + 1) + ".  ";
                }
                return o + t + (e.nextSibling && !/\n$/.test(t) ? "\n" : "");
              },
            }),
            (wy.indentedCodeBlock = {
              filter: function (t, e) {
                return (
                  "indented" === e.codeBlockStyle &&
                  "PRE" === t.nodeName &&
                  t.firstChild &&
                  "CODE" === t.firstChild.nodeName
                );
              },
              replacement: function (t, e, n) {
                return (
                  "\n\n    " +
                  e.firstChild.textContent.replace(/\n/g, "\n    ") +
                  "\n\n"
                );
              },
            }),
            (wy.fencedCodeBlock = {
              filter: function (t, e) {
                return (
                  "fenced" === e.codeBlockStyle &&
                  "PRE" === t.nodeName &&
                  t.firstChild &&
                  "CODE" === t.firstChild.nodeName
                );
              },
              replacement: function (t, e, n) {
                for (
                  var o,
                    i = ((e.firstChild.className || "").match(
                      /language-(\S+)/
                    ) || [null, ""])[1],
                    r = e.firstChild.textContent,
                    s = n.fence.charAt(0),
                    a = 3,
                    l = new RegExp("^" + s + "{3,}", "gm");
                  (o = l.exec(r));

                )
                  o[0].length >= a && (a = o[0].length + 1);
                var c = my(s, a);
                return (
                  "\n\n" +
                  c +
                  i +
                  "\n" +
                  r.replace(/\n$/, "") +
                  "\n" +
                  c +
                  "\n\n"
                );
              },
            }),
            (wy.horizontalRule = {
              filter: "hr",
              replacement: function (t, e, n) {
                return "\n\n" + n.hr + "\n\n";
              },
            }),
            (wy.inlineLink = {
              filter: function (t, e) {
                return (
                  "inlined" === e.linkStyle &&
                  "A" === t.nodeName &&
                  t.getAttribute("href")
                );
              },
              replacement: function (t, e) {
                return (
                  "[" +
                  t +
                  "](" +
                  e.getAttribute("href") +
                  (e.title ? ' "' + e.title + '"' : "") +
                  ")"
                );
              },
            }),
            (wy.referenceLink = {
              filter: function (t, e) {
                return (
                  "referenced" === e.linkStyle &&
                  "A" === t.nodeName &&
                  t.getAttribute("href")
                );
              },
              replacement: function (t, e, n) {
                var o,
                  i,
                  r = e.getAttribute("href"),
                  s = e.title ? ' "' + e.title + '"' : "";
                switch (n.linkReferenceStyle) {
                  case "collapsed":
                    (o = "[" + t + "][]"), (i = "[" + t + "]: " + r + s);
                    break;
                  case "shortcut":
                    (o = "[" + t + "]"), (i = "[" + t + "]: " + r + s);
                    break;
                  default:
                    var a = this.references.length + 1;
                    (o = "[" + t + "][" + a + "]"),
                      (i = "[" + a + "]: " + r + s);
                }
                return this.references.push(i), o;
              },
              references: [],
              append: function (t) {
                var e = "";
                return (
                  this.references.length &&
                    ((e = "\n\n" + this.references.join("\n") + "\n\n"),
                    (this.references = [])),
                  e
                );
              },
            }),
            (wy.emphasis = {
              filter: ["em", "i"],
              replacement: function (t, e, n) {
                return t.trim() ? n.emDelimiter + t + n.emDelimiter : "";
              },
            }),
            (wy.strong = {
              filter: ["strong", "b"],
              replacement: function (t, e, n) {
                return t.trim()
                  ? n.strongDelimiter + t + n.strongDelimiter
                  : "";
              },
            }),
            (wy.code = {
              filter: function (t) {
                var e = t.previousSibling || t.nextSibling,
                  n = "PRE" === t.parentNode.nodeName && !e;
                return "CODE" === t.nodeName && !n;
              },
              replacement: function (t) {
                if (!t.trim()) return "";
                var e = "`",
                  n = "",
                  o = "",
                  i = t.match(/`+/gm);
                if (i)
                  for (
                    /^`/.test(t) && (n = " "), /`$/.test(t) && (o = " ");
                    -1 !== i.indexOf(e);

                  )
                    e += "`";
                return e + n + t + o + e;
              },
            }),
            (wy.image = {
              filter: "img",
              replacement: function (t, e) {
                var n = e.alt || "",
                  o = e.getAttribute("src") || "",
                  i = e.title || "";
                return o
                  ? "![" + n + "](" + o + (i ? ' "' + i + '"' : "") + ")"
                  : "";
              },
            }),
            (Ay.prototype = {
              add: function (t, e) {
                this.array.unshift(e);
              },
              keep: function (t) {
                this._keep.unshift({
                  filter: t,
                  replacement: this.keepReplacement,
                });
              },
              remove: function (t) {
                this._remove.unshift({
                  filter: t,
                  replacement: function () {
                    return "";
                  },
                });
              },
              forNode: function (t) {
                return t.isBlank
                  ? this.blankRule
                  : (e = _y(this.array, t, this.options)) ||
                    (e = _y(this._keep, t, this.options)) ||
                    (e = _y(this._remove, t, this.options))
                  ? e
                  : this.defaultRule;
                var e;
              },
              forEach: function (t) {
                for (var e = 0; e < this.array.length; e++) t(this.array[e], e);
              },
            });
          var xy = "undefined" != typeof window ? window : {};
          var Ey,
            Dy = (function () {
              var t = xy.DOMParser,
                e = !1;
              try {
                new t().parseFromString("", "text/html") && (e = !0);
              } catch (t) {}
              return e;
            })()
              ? xy.DOMParser
              : (function () {
                  var t = function () {},
                    e = n(1576).JSDOM;
                  return (
                    (t.prototype.parseFromString = function (t) {
                      return new e(t).window.document;
                    }),
                    t
                  );
                })();
          function Sy(t) {
            var e;
            "string" == typeof t
              ? (e = (Ey = Ey || new Dy())
                  .parseFromString(
                    '<x-turndown id="turndown-root">' + t + "</x-turndown>",
                    "text/html"
                  )
                  .getElementById("turndown-root"))
              : (e = t.cloneNode(!0));
            return (
              (function (t) {
                var e = t.element,
                  n = t.isBlock,
                  o = t.isVoid,
                  i =
                    t.isPre ||
                    function (t) {
                      return "PRE" === t.nodeName;
                    };
                if (e.firstChild && !i(e)) {
                  for (
                    var r = null, s = !1, a = null, l = yy(a, e, i);
                    l !== e;

                  ) {
                    if (3 === l.nodeType || 4 === l.nodeType) {
                      var c = l.data.replace(/[ \r\n\t]+/g, " ");
                      if (
                        ((r && !/ $/.test(r.data)) ||
                          s ||
                          " " !== c[0] ||
                          (c = c.substr(1)),
                        !c)
                      ) {
                        l = vy(l);
                        continue;
                      }
                      (l.data = c), (r = l);
                    } else {
                      if (1 !== l.nodeType) {
                        l = vy(l);
                        continue;
                      }
                      n(l) || "BR" === l.nodeName
                        ? (r && (r.data = r.data.replace(/ $/, "")),
                          (r = null),
                          (s = !1))
                        : o(l) && ((r = null), (s = !0));
                    }
                    var d = yy(a, l, i);
                    (a = l), (l = d);
                  }
                  r && ((r.data = r.data.replace(/ $/, "")), r.data || vy(r));
                }
              })({ element: e, isBlock: py, isVoid: ky }),
              e
            );
          }
          function Iy(t) {
            return (
              (t.isBlock = py(t)),
              (t.isCode =
                "code" === t.nodeName.toLowerCase() || t.parentNode.isCode),
              (t.isBlank = (function (t) {
                return (
                  -1 ===
                    [
                      "A",
                      "TH",
                      "TD",
                      "IFRAME",
                      "SCRIPT",
                      "AUDIO",
                      "VIDEO",
                    ].indexOf(t.nodeName) &&
                  /^\s*$/i.test(t.textContent) &&
                  !ky(t) &&
                  !(function (t) {
                    return t.querySelector && t.querySelector(by);
                  })(t)
                );
              })(t)),
              (t.flankingWhitespace = (function (t) {
                var e = "",
                  n = "";
                if (!t.isBlock) {
                  var o = /^\s/.test(t.textContent),
                    i = /\s$/.test(t.textContent),
                    r = t.isBlank && o && i;
                  o && !Ty("left", t) && (e = " "),
                    r || !i || Ty("right", t) || (n = " ");
                }
                return { leading: e, trailing: n };
              })(t)),
              t
            );
          }
          function Ty(t, e) {
            var n, o, i;
            return (
              "left" === t
                ? ((n = e.previousSibling), (o = / $/))
                : ((n = e.nextSibling), (o = /^ /)),
              n &&
                (3 === n.nodeType
                  ? (i = o.test(n.nodeValue))
                  : 1 !== n.nodeType || py(n) || (i = o.test(n.textContent))),
              i
            );
          }
          var My = Array.prototype.reduce,
            By = /^\n*/,
            Ny = /\n*$/,
            zy = [
              [/\\/g, "\\\\"],
              [/\*/g, "\\*"],
              [/^-/g, "\\-"],
              [/^\+ /g, "\\+ "],
              [/^(=+)/g, "\\$1"],
              [/^(#{1,6}) /g, "\\$1 "],
              [/`/g, "\\`"],
              [/^~~~/g, "\\~~~"],
              [/\[/g, "\\["],
              [/\]/g, "\\]"],
              [/^>/g, "\\>"],
              [/_/g, "\\_"],
              [/^(\d+)\. /g, "$1\\. "],
            ];
          function Py(t) {
            if (!(this instanceof Py)) return new Py(t);
            var e = {
              rules: wy,
              headingStyle: "setext",
              hr: "* * *",
              bulletListMarker: "*",
              codeBlockStyle: "indented",
              fence: "```",
              emDelimiter: "_",
              strongDelimiter: "**",
              linkStyle: "inlined",
              linkReferenceStyle: "full",
              br: "  ",
              blankReplacement: function (t, e) {
                return e.isBlock ? "\n\n" : "";
              },
              keepReplacement: function (t, e) {
                return e.isBlock ? "\n\n" + e.outerHTML + "\n\n" : e.outerHTML;
              },
              defaultReplacement: function (t, e) {
                return e.isBlock ? "\n\n" + t + "\n\n" : t;
              },
            };
            (this.options = (function (t) {
              for (var e = 1; e < arguments.length; e++) {
                var n = arguments[e];
                for (var o in n) n.hasOwnProperty(o) && (t[o] = n[o]);
              }
              return t;
            })({}, e, t)),
              (this.rules = new Ay(this.options));
          }
          function Ly(t) {
            var e = this;
            return My.call(
              t.childNodes,
              function (t, n) {
                var o = "";
                return (
                  3 === (n = new Iy(n)).nodeType
                    ? (o = n.isCode ? n.nodeValue : e.escape(n.nodeValue))
                    : 1 === n.nodeType && (o = Oy.call(e, n)),
                  jy(t, o)
                );
              },
              ""
            );
          }
          function Ry(t) {
            var e = this;
            return (
              this.rules.forEach(function (n) {
                "function" == typeof n.append &&
                  (t = jy(t, n.append(e.options)));
              }),
              t.replace(/^[\t\r\n]+/, "").replace(/[\t\r\n\s]+$/, "")
            );
          }
          function Oy(t) {
            var e = this.rules.forNode(t),
              n = Ly.call(this, t),
              o = t.flankingWhitespace;
            return (
              (o.leading || o.trailing) && (n = n.trim()),
              o.leading + e.replacement(n, t, this.options) + o.trailing
            );
          }
          function jy(t, e) {
            var n,
              o,
              i,
              r =
                ((n = e),
                (o = [t.match(Ny)[0], n.match(By)[0]].sort()),
                (i = o[o.length - 1]).length < 2 ? i : "\n\n");
            return (t = t.replace(Ny, "")) + r + (e = e.replace(By, ""));
          }
          Py.prototype = {
            turndown: function (t) {
              if (
                !(function (t) {
                  return (
                    null != t &&
                    ("string" == typeof t ||
                      (t.nodeType &&
                        (1 === t.nodeType ||
                          9 === t.nodeType ||
                          11 === t.nodeType)))
                  );
                })(t)
              )
                throw new TypeError(
                  t + " is not a string, or an element/document/fragment node."
                );
              if ("" === t) return "";
              var e = Ly.call(this, new Sy(t));
              return Ry.call(this, e);
            },
            use: function (t) {
              if (Array.isArray(t))
                for (var e = 0; e < t.length; e++) this.use(t[e]);
              else {
                if ("function" != typeof t)
                  throw new TypeError(
                    "plugin must be a Function or an Array of Functions"
                  );
                t(this);
              }
              return this;
            },
            addRule: function (t, e) {
              return this.rules.add(t, e), this;
            },
            keep: function (t) {
              return this.rules.keep(t), this;
            },
            remove: function (t) {
              return this.rules.remove(t), this;
            },
            escape: function (t) {
              return zy.reduce(function (t, e) {
                return t.replace(e[0], e[1]);
              }, t);
            },
          };
          const Vy = Py;
          var Fy = /highlight-(?:text|source)-([a-z0-9]+)/;
          function Hy(t) {
            t.addRule("highlightedCodeBlock", {
              filter: function (t) {
                var e = t.firstChild;
                return (
                  "DIV" === t.nodeName &&
                  Fy.test(t.className) &&
                  e &&
                  "PRE" === e.nodeName
                );
              },
              replacement: function (t, e, n) {
                var o = ((e.className || "").match(Fy) || [null, ""])[1];
                return (
                  "\n\n" +
                  n.fence +
                  o +
                  "\n" +
                  e.firstChild.textContent +
                  "\n" +
                  n.fence +
                  "\n\n"
                );
              },
            });
          }
          function Uy(t) {
            t.addRule("strikethrough", {
              filter: ["del", "s", "strike"],
              replacement: function (t) {
                return "~" + t + "~";
              },
            });
          }
          var Wy = Array.prototype.indexOf,
            $y = Array.prototype.every,
            qy = {};
          function Gy(t) {
            var e,
              n,
              o = t.parentNode;
            return (
              "THEAD" === o.nodeName ||
              (o.firstChild === t &&
                ("TABLE" === o.nodeName ||
                  ((n = (e = o).previousSibling),
                  "TBODY" === e.nodeName &&
                    (!n ||
                      ("THEAD" === n.nodeName &&
                        /^\s*$/i.test(n.textContent))))) &&
                $y.call(t.childNodes, function (t) {
                  return "TH" === t.nodeName;
                }))
            );
          }
          function Zy(t, e) {
            var n = " ";
            return (
              0 === Wy.call(e.parentNode.childNodes, e) && (n = "| "),
              n + t + " |"
            );
          }
          function Yy(t) {
            for (var e in (t.keep(function (t) {
              return "TABLE" === t.nodeName && !Gy(t.rows[0]);
            }),
            qy))
              t.addRule(e, qy[e]);
          }
          function Ky(t) {
            t.addRule("taskListItems", {
              filter: function (t) {
                return "checkbox" === t.type && "LI" === t.parentNode.nodeName;
              },
              replacement: function (t, e) {
                return (e.checked ? "[x]" : "[ ]") + " ";
              },
            });
          }
          (qy.tableCell = {
            filter: ["th", "td"],
            replacement: function (t, e) {
              return Zy(t, e);
            },
          }),
            (qy.tableRow = {
              filter: "tr",
              replacement: function (t, e) {
                var n = "",
                  o = { left: ":--", right: "--:", center: ":-:" };
                if (Gy(e))
                  for (var i = 0; i < e.childNodes.length; i++) {
                    var r = "---",
                      s = (
                        e.childNodes[i].getAttribute("align") || ""
                      ).toLowerCase();
                    s && (r = o[s] || r), (n += Zy(r, e.childNodes[i]));
                  }
                return "\n" + t + (n ? "\n" + n : "");
              },
            }),
            (qy.table = {
              filter: function (t) {
                return "TABLE" === t.nodeName && Gy(t.rows[0]);
              },
              replacement: function (t) {
                return "\n\n" + (t = t.replace("\n\n", "\n")) + "\n\n";
              },
            }),
            (qy.tableSection = {
              filter: ["thead", "tbody", "tfoot"],
              replacement: function (t) {
                return t;
              },
            });
          const Qy = Vy.prototype.escape;
          function Jy(t) {
            return (t = (t = Qy(t)).replace(/</g, "\\<"));
          }
          Vy.prototype.escape = function (t) {
            let e = "",
              n = 0;
            for (const o of (function* (t) {
              for (const e of t.matchAll(tx)) {
                const t = e[0],
                  n = ex(t);
                yield Object.assign([t.substring(0, n)], { index: e.index });
              }
            })(t)) {
              const i = o.index;
              i > n && (e += Jy(t.substring(n, i)));
              const r = o[0];
              (e += r), (n = i + r.length);
            }
            return n < t.length && (e += Jy(t.substring(n, t.length))), e;
          };
          const Xy = new Vy({
            codeBlockStyle: "fenced",
            hr: "---",
            headingStyle: "atx",
          });
          Xy.use([
            function (t) {
              t.use([Hy, Uy, Yy, Ky]);
            },
            function (t) {
              t.addRule("taskListItems", {
                filter: (t) =>
                  "checkbox" === t.type &&
                  ("LI" === t.parentNode.nodeName ||
                    "LI" === t.parentNode.parentNode.nodeName),
                replacement: (t, e) => (e.checked ? "[x]" : "[ ]") + " ",
              });
            },
          ]);
          const tx = new RegExp(
            /\b(?:(?:https?|ftp):\/\/|www\.)/.source +
              /(?![-_])(?:[-_a-z0-9\u00a1-\uffff]{1,63}\.)+(?:[a-z\u00a1-\uffff]{2,63})/
                .source +
              /(?:[^\s<>]*)/.source,
            "gi"
          );
          function ex(t) {
            let e = t.length;
            for (; e > 0; ) {
              const n = t[e - 1];
              if ("?!.,:*_~'\"".includes(n)) e--;
              else {
                if (")" != n) break;
                {
                  let n = 0;
                  for (let o = 0; o < e; o++)
                    "(" == t[o] ? n++ : ")" == t[o] && n--;
                  if (!(n < 0)) break;
                  e--;
                }
              }
            }
            return e;
          }
          class nx {
            constructor(t) {
              this._htmlDP = new xc(t);
            }
            keepHtml(t) {
              Xy.keep([t]);
            }
            toView(t) {
              const e =
                ((n = t),
                hy.parse(n, {
                  gfm: !0,
                  breaks: !0,
                  tables: !0,
                  xhtml: !0,
                  headerIds: !1,
                }));
              var n;
              return this._htmlDP.toView(e);
            }
            toData(t) {
              return (function (t) {
                return Xy.turndown(t);
              })(this._htmlDP.toData(t));
            }
            registerRawContentMatcher(t) {
              this._htmlDP.registerRawContentMatcher(t);
            }
            useFillerType() {}
          }
          function ox(t, e) {
            return (t) => {
              t.on("attribute:url:media", n);
            };
            function n(n, o, i) {
              if (!i.consumable.consume(o.item, n.name)) return;
              const r = o.attributeNewValue,
                s = i.writer,
                a = i.mapper.toViewElement(o.item),
                l = [...a.getChildren()].find((t) =>
                  t.getCustomProperty("media-content")
                );
              s.remove(l);
              const c = t.getMediaViewElement(s, r, e);
              s.insert(s.createPositionAt(a, 0), c);
            }
          }
          function ix(t, e, n, o) {
            return t.createContainerElement("figure", { class: "media" }, [
              e.getMediaViewElement(t, n, o),
              t.createSlot(),
            ]);
          }
          function rx(t) {
            const e = t.getSelectedElement();
            return e && e.is("element", "media") ? e : null;
          }
          function sx(t, e, n, o) {
            t.change((i) => {
              const r = i.createElement("media", { url: e });
              t.insertObject(r, n, null, {
                setSelection: "on",
                findOptimalPosition: o,
              });
            });
          }
          class ax extends F {
            refresh() {
              const t = this.editor.model,
                e = t.document.selection,
                n = rx(e);
              (this.value = n ? n.getAttribute("url") : null),
                (this.isEnabled =
                  (function (t) {
                    const e = t.getSelectedElement();
                    return !!e && "media" === e.name;
                  })(e) ||
                  (function (t, e) {
                    let n = tf(t, e).start.parent;
                    n.isEmpty && !e.schema.isLimit(n) && (n = n.parent);
                    return e.schema.checkChild(n, "media");
                  })(e, t));
            }
            execute(t) {
              const e = this.editor.model,
                n = e.document.selection,
                o = rx(n);
              o
                ? e.change((e) => {
                    e.setAttribute("url", t, o);
                  })
                : sx(e, t, n, !0);
            }
          }
          class lx {
            constructor(t, e) {
              const n = e.providers,
                o = e.extraProviders || [],
                i = new Set(e.removeProviders),
                r = n.concat(o).filter((t) => {
                  const e = t.name;
                  return e
                    ? !i.has(e)
                    : (c("media-embed-no-provider-name", { provider: t }), !1);
                });
              (this.locale = t), (this.providerDefinitions = r);
            }
            hasMedia(t) {
              return !!this._getMedia(t);
            }
            getMediaViewElement(t, e, n) {
              return this._getMedia(e).getViewElement(t, n);
            }
            _getMedia(t) {
              if (!t) return new cx(this.locale);
              t = t.trim();
              for (const e of this.providerDefinitions) {
                const n = e.html,
                  o = ko(e.url);
                for (const e of o) {
                  const o = this._getUrlMatches(t, e);
                  if (o) return new cx(this.locale, t, o, n);
                }
              }
              return null;
            }
            _getUrlMatches(t, e) {
              let n = t.match(e);
              if (n) return n;
              let o = t.replace(/^https?:\/\//, "");
              return (
                (n = o.match(e)),
                n ||
                  ((o = o.replace(/^www\./, "")), (n = o.match(e)), n || null)
              );
            }
          }
          class cx {
            constructor(t, e, n, o) {
              (this.url = this._getValidUrl(e)),
                (this._locale = t),
                (this._match = n),
                (this._previewRenderer = o);
            }
            getViewElement(t, e) {
              const n = {};
              let o;
              if (
                e.renderForEditingView ||
                (e.renderMediaPreview && this.url && this._previewRenderer)
              ) {
                this.url && (n["data-oembed-url"] = this.url),
                  e.renderForEditingView && (n.class = "ck-media__wrapper");
                const i = this._getPreviewHtml(e);
                o = t.createRawElement("div", n, (t, e) => {
                  e.setContentOf(t, i);
                });
              } else
                this.url && (n.url = this.url),
                  (o = t.createEmptyElement(e.elementName, n));
              return t.setCustomProperty("media-content", !0, o), o;
            }
            _getPreviewHtml(t) {
              return this._previewRenderer
                ? this._previewRenderer(this._match)
                : this.url && t.renderForEditingView
                ? this._getPlaceholderHtml()
                : "";
            }
            _getPlaceholderHtml() {
              const t = new Xh(),
                e = this._locale.t;
              (t.content =
                '<svg viewBox="0 0 64 42" xmlns="http://www.w3.org/2000/svg"><path d="M47.426 17V3.713L63.102 0v19.389h-.001l.001.272c0 1.595-2.032 3.43-4.538 4.098-2.506.668-4.538-.083-4.538-1.678 0-1.594 2.032-3.43 4.538-4.098.914-.244 2.032-.565 2.888-.603V4.516L49.076 7.447v9.556A1.014 1.014 0 0 0 49 17h-1.574zM29.5 17h-8.343a7.073 7.073 0 1 0-4.657 4.06v3.781H3.3a2.803 2.803 0 0 1-2.8-2.804V8.63a2.803 2.803 0 0 1 2.8-2.805h4.082L8.58 2.768A1.994 1.994 0 0 1 10.435 1.5h8.985c.773 0 1.477.448 1.805 1.149l1.488 3.177H26.7c1.546 0 2.8 1.256 2.8 2.805V17zm-11.637 0H17.5a1 1 0 0 0-1 1v.05A4.244 4.244 0 1 1 17.863 17zm29.684 2c.97 0 .953-.048.953.889v20.743c0 .953.016.905-.953.905H19.453c-.97 0-.953.048-.953-.905V19.89c0-.937-.016-.889.97-.889h28.077zm-4.701 19.338V22.183H24.154v16.155h18.692zM20.6 21.375v1.616h1.616v-1.616H20.6zm0 3.231v1.616h1.616v-1.616H20.6zm0 3.231v1.616h1.616v-1.616H20.6zm0 3.231v1.616h1.616v-1.616H20.6zm0 3.231v1.616h1.616v-1.616H20.6zm0 3.231v1.616h1.616V37.53H20.6zm24.233-16.155v1.616h1.615v-1.616h-1.615zm0 3.231v1.616h1.615v-1.616h-1.615zm0 3.231v1.616h1.615v-1.616h-1.615zm0 3.231v1.616h1.615v-1.616h-1.615zm0 3.231v1.616h1.615v-1.616h-1.615zm0 3.231v1.616h1.615V37.53h-1.615zM29.485 25.283a.4.4 0 0 1 .593-.35l9.05 4.977a.4.4 0 0 1 0 .701l-9.05 4.978a.4.4 0 0 1-.593-.35v-9.956z"/></svg>'),
                (t.viewBox = "0 0 64 42");
              return new Xu({
                tag: "div",
                attributes: { class: "ck ck-reset_all ck-media__placeholder" },
                children: [
                  {
                    tag: "div",
                    attributes: { class: "ck-media__placeholder__icon" },
                    children: [t],
                  },
                  {
                    tag: "a",
                    attributes: {
                      class: "ck-media__placeholder__url",
                      target: "_blank",
                      rel: "noopener noreferrer",
                      href: this.url,
                      "data-cke-tooltip-text": e("Open media in new tab"),
                    },
                    children: [
                      {
                        tag: "span",
                        attributes: {
                          class: "ck-media__placeholder__url__text",
                        },
                        children: [this.url],
                      },
                    ],
                  },
                ],
              }).render().outerHTML;
            }
            _getValidUrl(t) {
              return t ? (t.match(/^https?/) ? t : "https://" + t) : null;
            }
          }
          var dx = n(952),
            ux = { attributes: { "data-cke": !0 } };
          (ux.setAttributes = is()),
            (ux.insert = ns().bind(null, "head")),
            (ux.domAPI = ts()),
            (ux.insertStyleElement = ss());
          Jr()(dx.Z, ux);
          dx.Z && dx.Z.locals && dx.Z.locals;
          class hx extends j {
            static get pluginName() {
              return "MediaEmbedEditing";
            }
            constructor(t) {
              super(t),
                t.config.define("mediaEmbed", {
                  elementName: "oembed",
                  providers: [
                    {
                      name: "dailymotion",
                      url: /^dailymotion\.com\/video\/(\w+)/,
                      html: (t) =>
                        `<div style="position: relative; padding-bottom: 100%; height: 0; "><iframe src="https://www.dailymotion.com/embed/video/${t[1]}" style="position: absolute; width: 100%; height: 100%; top: 0; left: 0;" frameborder="0" width="480" height="270" allowfullscreen allow="autoplay"></iframe></div>`,
                    },
                    {
                      name: "spotify",
                      url: [
                        /^open\.spotify\.com\/(artist\/\w+)/,
                        /^open\.spotify\.com\/(album\/\w+)/,
                        /^open\.spotify\.com\/(track\/\w+)/,
                      ],
                      html: (t) =>
                        `<div style="position: relative; padding-bottom: 100%; height: 0; padding-bottom: 126%;"><iframe src="https://open.spotify.com/embed/${t[1]}" style="position: absolute; width: 100%; height: 100%; top: 0; left: 0;" frameborder="0" allowtransparency="true" allow="encrypted-media"></iframe></div>`,
                    },
                    {
                      name: "youtube",
                      url: [
                        /^(?:m\.)?youtube\.com\/watch\?v=([\w-]+)(?:&t=(\d+))?/,
                        /^(?:m\.)?youtube\.com\/v\/([\w-]+)(?:\?t=(\d+))?/,
                        /^youtube\.com\/embed\/([\w-]+)(?:\?start=(\d+))?/,
                        /^youtu\.be\/([\w-]+)(?:\?t=(\d+))?/,
                      ],
                      html: (t) => {
                        const e = t[1],
                          n = t[2];
                        return `<div style="position: relative; padding-bottom: 100%; height: 0; padding-bottom: 56.2493%;"><iframe src="https://www.youtube.com/embed/${e}${
                          n ? `?start=${n}` : ""
                        }" style="position: absolute; width: 100%; height: 100%; top: 0; left: 0;" frameborder="0" allow="autoplay; encrypted-media" allowfullscreen></iframe></div>`;
                      },
                    },
                    {
                      name: "vimeo",
                      url: [
                        /^vimeo\.com\/(\d+)/,
                        /^vimeo\.com\/[^/]+\/[^/]+\/video\/(\d+)/,
                        /^vimeo\.com\/album\/[^/]+\/video\/(\d+)/,
                        /^vimeo\.com\/channels\/[^/]+\/(\d+)/,
                        /^vimeo\.com\/groups\/[^/]+\/videos\/(\d+)/,
                        /^vimeo\.com\/ondemand\/[^/]+\/(\d+)/,
                        /^player\.vimeo\.com\/video\/(\d+)/,
                      ],
                      html: (t) =>
                        `<div style="position: relative; padding-bottom: 100%; height: 0; padding-bottom: 56.2493%;"><iframe src="https://player.vimeo.com/video/${t[1]}" style="position: absolute; width: 100%; height: 100%; top: 0; left: 0;" frameborder="0" webkitallowfullscreen mozallowfullscreen allowfullscreen></iframe></div>`,
                    },
                    { name: "instagram", url: /^instagram\.com\/p\/(\w+)/ },
                    { name: "twitter", url: /^twitter\.com/ },
                    {
                      name: "googleMaps",
                      url: [
                        /^google\.com\/maps/,
                        /^goo\.gl\/maps/,
                        /^maps\.google\.com/,
                        /^maps\.app\.goo\.gl/,
                      ],
                    },
                    { name: "flickr", url: /^flickr\.com/ },
                    { name: "facebook", url: /^facebook\.com/ },
                  ],
                }),
                (this.registry = new lx(t.locale, t.config.get("mediaEmbed")));
            }
            init() {
              const t = this.editor,
                e = t.model.schema,
                n = t.t,
                o = t.conversion,
                i = t.config.get("mediaEmbed.previewsInData"),
                r = t.config.get("mediaEmbed.elementName"),
                s = this.registry;
              t.commands.add("mediaEmbed", new ax(t)),
                e.register("media", {
                  inheritAllFrom: "$blockObject",
                  allowAttributes: ["url"],
                }),
                o.for("dataDowncast").elementToStructure({
                  model: "media",
                  view: (t, { writer: e }) => {
                    const n = t.getAttribute("url");
                    return ix(e, s, n, {
                      elementName: r,
                      renderMediaPreview: n && i,
                    });
                  },
                }),
                o
                  .for("dataDowncast")
                  .add(ox(s, { elementName: r, renderMediaPreview: i })),
                o.for("editingDowncast").elementToStructure({
                  model: "media",
                  view: (t, { writer: e }) => {
                    const o = t.getAttribute("url");
                    return (function (t, e, n) {
                      return (
                        e.setCustomProperty("media", !0, t),
                        Zp(t, e, { label: n })
                      );
                    })(
                      ix(e, s, o, { elementName: r, renderForEditingView: !0 }),
                      e,
                      n("media widget")
                    );
                  },
                }),
                o
                  .for("editingDowncast")
                  .add(ox(s, { elementName: r, renderForEditingView: !0 })),
                o
                  .for("upcast")
                  .elementToElement({
                    view: (t) =>
                      ["oembed", r].includes(t.name) && t.getAttribute("url")
                        ? { name: !0 }
                        : null,
                    model: (t, { writer: e }) => {
                      const n = t.getAttribute("url");
                      if (s.hasMedia(n))
                        return e.createElement("media", { url: n });
                    },
                  })
                  .elementToElement({
                    view: {
                      name: "div",
                      attributes: { "data-oembed-url": !0 },
                    },
                    model: (t, { writer: e }) => {
                      const n = t.getAttribute("data-oembed-url");
                      if (s.hasMedia(n))
                        return e.createElement("media", { url: n });
                    },
                  })
                  .add((t) => {
                    t.on("element:figure", function (t, e, n) {
                      if (
                        !n.consumable.consume(e.viewItem, {
                          name: !0,
                          classes: "media",
                        })
                      )
                        return;
                      const { modelRange: o, modelCursor: i } =
                        n.convertChildren(e.viewItem, e.modelCursor);
                      (e.modelRange = o), (e.modelCursor = i);
                      Ra(o.getItems()) ||
                        n.consumable.revert(e.viewItem, {
                          name: !0,
                          classes: "media",
                        });
                    });
                  });
            }
          }
          const mx = /^(?:http(s)?:\/\/)?[\w-]+\.[\w-.~:/?#[\]@!$&'()*+,;=%]+$/;
          class gx extends j {
            static get requires() {
              return [Sf, rp, Of];
            }
            static get pluginName() {
              return "AutoMediaEmbed";
            }
            constructor(t) {
              super(t),
                (this._timeoutId = null),
                (this._positionToInsert = null);
            }
            init() {
              const t = this.editor,
                e = t.model.document;
              this.listenTo(
                t.plugins.get("ClipboardPipeline"),
                "inputTransformation",
                () => {
                  const t = e.selection.getFirstRange(),
                    n = yd.fromPosition(t.start);
                  n.stickiness = "toPrevious";
                  const o = yd.fromPosition(t.end);
                  (o.stickiness = "toNext"),
                    e.once(
                      "change:data",
                      () => {
                        this._embedMediaBetweenPositions(n, o),
                          n.detach(),
                          o.detach();
                      },
                      { priority: "high" }
                    );
                }
              ),
                t.commands.get("undo").on(
                  "execute",
                  () => {
                    this._timeoutId &&
                      (wo.window.clearTimeout(this._timeoutId),
                      this._positionToInsert.detach(),
                      (this._timeoutId = null),
                      (this._positionToInsert = null));
                  },
                  { priority: "high" }
                );
            }
            _embedMediaBetweenPositions(t, e) {
              const n = this.editor,
                o = n.plugins.get(hx).registry,
                i = new xl(t, e),
                r = i.getWalker({ ignoreElementEnd: !0 });
              let s = "";
              for (const t of r) t.item.is("$textProxy") && (s += t.item.data);
              if (((s = s.trim()), !s.match(mx))) return void i.detach();
              if (!o.hasMedia(s)) return void i.detach();
              n.commands.get("mediaEmbed").isEnabled
                ? ((this._positionToInsert = yd.fromPosition(t)),
                  (this._timeoutId = wo.window.setTimeout(() => {
                    n.model.change((t) => {
                      let e;
                      (this._timeoutId = null),
                        t.remove(i),
                        i.detach(),
                        "$graveyard" !== this._positionToInsert.root.rootName &&
                          (e = this._positionToInsert),
                        sx(n.model, s, e, !1),
                        this._positionToInsert.detach(),
                        (this._positionToInsert = null);
                    }),
                      n.plugins.get("Delete").requestUndoOnBackspace();
                  }, 100)))
                : i.detach();
            }
          }
          var px = n(3525),
            fx = { attributes: { "data-cke": !0 } };
          (fx.setAttributes = is()),
            (fx.insert = ns().bind(null, "head")),
            (fx.domAPI = ts()),
            (fx.insertStyleElement = ss());
          Jr()(px.Z, fx);
          px.Z && px.Z.locals && px.Z.locals;
          class kx extends Ch {
            constructor(t, e) {
              super(e);
              const n = e.t;
              (this.focusTracker = new Oa()),
                (this.keystrokes = new ja()),
                this.set("mediaURLInputValue", ""),
                (this.urlInputView = this._createUrlInput()),
                (this.saveButtonView = this._createButton(
                  n("Save"),
                  $h.check,
                  "ck-button-save"
                )),
                (this.saveButtonView.type = "submit"),
                this.saveButtonView
                  .bind("isEnabled")
                  .to(this, "mediaURLInputValue", (t) => !!t),
                (this.cancelButtonView = this._createButton(
                  n("Cancel"),
                  $h.cancel,
                  "ck-button-cancel",
                  "cancel"
                )),
                (this._focusables = new Ju()),
                (this._focusCycler = new Cm({
                  focusables: this._focusables,
                  focusTracker: this.focusTracker,
                  keystrokeHandler: this.keystrokes,
                  actions: { focusPrevious: "shift + tab", focusNext: "tab" },
                })),
                (this._validators = t),
                this.setTemplate({
                  tag: "form",
                  attributes: {
                    class: ["ck", "ck-media-form", "ck-responsive-form"],
                    tabindex: "-1",
                  },
                  children: [
                    this.urlInputView,
                    this.saveButtonView,
                    this.cancelButtonView,
                  ],
                }),
                Gh(this);
            }
            render() {
              super.render(), Zh({ view: this });
              [
                this.urlInputView,
                this.saveButtonView,
                this.cancelButtonView,
              ].forEach((t) => {
                this._focusables.add(t), this.focusTracker.add(t.element);
              }),
                this.keystrokes.listenTo(this.element);
              const t = (t) => t.stopPropagation();
              this.keystrokes.set("arrowright", t),
                this.keystrokes.set("arrowleft", t),
                this.keystrokes.set("arrowup", t),
                this.keystrokes.set("arrowdown", t),
                this.listenTo(
                  this.urlInputView.element,
                  "selectstart",
                  (t, e) => {
                    e.stopPropagation();
                  },
                  { priority: "high" }
                );
            }
            destroy() {
              super.destroy(),
                this.focusTracker.destroy(),
                this.keystrokes.destroy();
            }
            focus() {
              this._focusCycler.focusFirst();
            }
            get url() {
              return this.urlInputView.fieldView.element.value.trim();
            }
            set url(t) {
              this.urlInputView.fieldView.element.value = t.trim();
            }
            isValid() {
              this.resetFormStatus();
              for (const t of this._validators) {
                const e = t(this);
                if (e) return (this.urlInputView.errorText = e), !1;
              }
              return !0;
            }
            resetFormStatus() {
              (this.urlInputView.errorText = null),
                (this.urlInputView.infoText = this._urlInputViewInfoDefault);
            }
            _createUrlInput() {
              const t = this.locale.t,
                e = new hg(this.locale, mg),
                n = e.fieldView;
              return (
                (this._urlInputViewInfoDefault = t(
                  "Paste the media URL in the input."
                )),
                (this._urlInputViewInfoTip = t(
                  "Tip: Paste the URL into the content to embed faster."
                )),
                (e.label = t("Media URL")),
                (e.infoText = this._urlInputViewInfoDefault),
                n.on("input", () => {
                  (e.infoText = n.element.value
                    ? this._urlInputViewInfoTip
                    : this._urlInputViewInfoDefault),
                    (this.mediaURLInputValue = n.element.value.trim());
                }),
                e
              );
            }
            _createButton(t, e, n, o) {
              const i = new nm(this.locale);
              return (
                i.set({ label: t, icon: e, tooltip: !0 }),
                i.extendTemplate({ attributes: { class: n } }),
                o && i.delegate("execute").to(this, o),
                i
              );
            }
          }
          class bx extends j {
            static get requires() {
              return [hx];
            }
            static get pluginName() {
              return "MediaEmbedUI";
            }
            init() {
              const t = this.editor,
                e = t.commands.get("mediaEmbed"),
                n = t.plugins.get(hx).registry;
              t.ui.componentFactory.add("mediaEmbed", (o) => {
                const i = Wm(o),
                  r = new kx(
                    (function (t, e) {
                      return [
                        (e) => {
                          if (!e.url.length)
                            return t("The URL must not be empty.");
                        },
                        (n) => {
                          if (!e.hasMedia(n.url))
                            return t("This media URL is not supported.");
                        },
                      ];
                    })(t.t, n),
                    t.locale
                  );
                return (
                  this._setUpDropdown(i, r, e, t), this._setUpForm(i, r, e), i
                );
              });
            }
            _setUpDropdown(t, e, n) {
              const o = this.editor,
                i = o.t,
                r = t.buttonView;
              t.bind("isEnabled").to(n),
                t.panelView.children.add(e),
                r.set({
                  label: i("Insert media"),
                  icon: '<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 20 20"><path d="M18.68 3.03c.6 0 .59-.03.59.55v12.84c0 .59.01.56-.59.56H1.29c-.6 0-.59.03-.59-.56V3.58c0-.58-.01-.55.6-.55h17.38zM15.77 15V5H4.2v10h11.57zM2 4v1h1V4H2zm0 2v1h1V6H2zm0 2v1h1V8H2zm0 2v1h1v-1H2zm0 2v1h1v-1H2zm0 2v1h1v-1H2zM17 4v1h1V4h-1zm0 2v1h1V6h-1zm0 2v1h1V8h-1zm0 2v1h1v-1h-1zm0 2v1h1v-1h-1zm0 2v1h1v-1h-1zM7.5 7.177a.4.4 0 0 1 .593-.351l5.133 2.824a.4.4 0 0 1 0 .7l-5.133 2.824a.4.4 0 0 1-.593-.35V7.176v.001z"/></svg>',
                  tooltip: !0,
                }),
                r.on(
                  "open",
                  () => {
                    e.disableCssTransitions(),
                      (e.url = n.value || ""),
                      e.urlInputView.fieldView.select(),
                      e.enableCssTransitions();
                  },
                  { priority: "low" }
                ),
                t.on("submit", () => {
                  e.isValid() &&
                    (o.execute("mediaEmbed", e.url), o.editing.view.focus());
                }),
                t.on("change:isOpen", () => e.resetFormStatus()),
                t.on("cancel", () => {
                  o.editing.view.focus();
                });
            }
            _setUpForm(t, e, n) {
              e.delegate("submit", "cancel").to(t),
                e.urlInputView.bind("value").to(n, "value"),
                e.urlInputView.bind("isReadOnly").to(n, "isEnabled", (t) => !t);
            }
          }
          var wx = n(5777),
            Ax = { attributes: { "data-cke": !0 } };
          (Ax.setAttributes = is()),
            (Ax.insert = ns().bind(null, "head")),
            (Ax.domAPI = ts()),
            (Ax.insertStyleElement = ss());
          Jr()(wx.Z, Ax);
          wx.Z && wx.Z.locals && wx.Z.locals;
          function _x(t, e, n, { blockElements: o, inlineObjectElements: i }) {
            let r = n.createPositionAt(t, "forward" == e ? "after" : "before");
            return (
              (r = r.getLastMatchingPosition(
                ({ item: t }) =>
                  t.is("element") && !o.includes(t.name) && !i.includes(t.name),
                { direction: e }
              )),
              "forward" == e ? r.nodeAfter : r.nodeBefore
            );
          }
          function Cx(t, e) {
            return !!t && t.is("element") && e.includes(t.name);
          }
          function vx(t, e) {
            if (!t.childCount) return;
            const n = new eu(t.document),
              o = (function (t, e) {
                const n = e.createRangeIn(t),
                  o = new No({
                    name: /^p|h\d+$/,
                    styles: { "mso-list": /.*/ },
                  }),
                  i = [];
                for (const t of n)
                  if ("elementStart" === t.type && o.match(t.item)) {
                    const e = Ex(t.item);
                    i.push({
                      element: t.item,
                      id: e.id,
                      order: e.order,
                      indent: e.indent,
                    });
                  }
                return i;
              })(t, n);
            if (!o.length) return;
            let i = null,
              r = 1;
            o.forEach((t, s) => {
              const a = (function (t, e) {
                  if (!t) return !0;
                  if (t.id !== e.id) return e.indent - t.indent != 1;
                  const n = e.element.previousSibling;
                  if (!n) return !0;
                  return (
                    (o = n), !(o.is("element", "ol") || o.is("element", "ul"))
                  );
                  var o;
                })(o[s - 1], t),
                l = a ? null : o[s - 1],
                c = ((u = t), (d = l) ? u.indent - d.indent : u.indent - 1);
              var d, u;
              if ((a && ((i = null), (r = 1)), !i || 0 !== c)) {
                const o = (function (t, e) {
                  const n = new RegExp(
                      `@list l${t.id}:level${t.indent}\\s*({[^}]*)`,
                      "gi"
                    ),
                    o = /mso-level-number-format:([^;]{0,100});/gi,
                    i = /mso-level-start-at:\s{0,100}([0-9]{0,10})\s{0,100};/gi,
                    r = n.exec(e);
                  let s = "decimal",
                    a = "ol",
                    l = null;
                  if (r && r[1]) {
                    const e = o.exec(r[1]);
                    if (
                      (e &&
                        e[1] &&
                        ((s = e[1].trim()),
                        (a = "bullet" !== s && "image" !== s ? "ol" : "ul")),
                      "bullet" === s)
                    ) {
                      const e = (function (t) {
                        const e = (function (t) {
                          if (t.getChild(0).is("$text")) return null;
                          for (const e of t.getChildren()) {
                            if (!e.is("element", "span")) continue;
                            const t = e.getChild(0);
                            return t.is("$text") ? t : t.getChild(0);
                          }
                        })(t);
                        if (!e) return null;
                        const n = e._data;
                        if ("o" === n) return "circle";
                        if ("·" === n) return "disc";
                        if ("§" === n) return "square";
                        return null;
                      })(t.element);
                      e && (s = e);
                    } else {
                      const t = i.exec(r[1]);
                      t && t[1] && (l = parseInt(t[1]));
                    }
                  }
                  return { type: a, startIndex: l, style: yx(s) };
                })(t, e);
                if (i) {
                  if (t.indent > r) {
                    const t = i.getChild(i.childCount - 1),
                      e = t.getChild(t.childCount - 1);
                    (i = xx(o, e, n)), (r += 1);
                  } else if (t.indent < r) {
                    const e = r - t.indent;
                    (i = (function (t, e) {
                      const n = t.getAncestors({ parentFirst: !0 });
                      let o = null,
                        i = 0;
                      for (const t of n)
                        if (
                          (("ul" !== t.name && "ol" !== t.name) || i++, i === e)
                        ) {
                          o = t;
                          break;
                        }
                      return o;
                    })(i, e)),
                      (r = parseInt(t.indent));
                  }
                } else i = xx(o, t.element, n);
                t.indent <= r &&
                  (i.is("element", o.type) || (i = n.rename(o.type, i)));
              }
              const h = (function (t, e) {
                return (
                  (function (t, e) {
                    const n = new No({
                        name: "span",
                        styles: { "mso-list": "Ignore" },
                      }),
                      o = e.createRangeIn(t);
                    for (const t of o)
                      "elementStart" === t.type &&
                        n.match(t.item) &&
                        e.remove(t.item);
                  })(t, e),
                  e.rename("li", t)
                );
              })(t.element, n);
              n.appendChild(h, i);
            });
          }
          function yx(t) {
            if (t.startsWith("arabic-leading-zero"))
              return "decimal-leading-zero";
            switch (t) {
              case "alpha-upper":
                return "upper-alpha";
              case "alpha-lower":
                return "lower-alpha";
              case "roman-upper":
                return "upper-roman";
              case "roman-lower":
                return "lower-roman";
              case "circle":
              case "disc":
              case "square":
                return t;
              default:
                return null;
            }
          }
          function xx(t, e, n) {
            const o = e.parent,
              i = n.createElement(t.type),
              r = o.getChildIndex(e) + 1;
            return (
              n.insertChild(r, i, o),
              t.style && n.setStyle("list-style-type", t.style, i),
              t.startIndex &&
                t.startIndex > 1 &&
                n.setAttribute("start", t.startIndex, i),
              i
            );
          }
          function Ex(t) {
            const e = {},
              n = t.getStyle("mso-list");
            if (n) {
              const t = n.match(/(^|\s{1,100})l(\d+)/i),
                o = n.match(/\s{0,100}lfo(\d+)/i),
                i = n.match(/\s{0,100}level(\d+)/i);
              t &&
                o &&
                i &&
                ((e.id = t[2]), (e.order = o[1]), (e.indent = i[1]));
            }
            return e;
          }
          const Dx = /id=("|')docs-internal-guid-[-0-9a-f]+("|')/i;
          class Sx {
            constructor(t) {
              this.document = t;
            }
            isActive(t) {
              return Dx.test(t);
            }
            execute(t) {
              const e = new eu(this.document),
                { body: n } = t._parsedData;
              !(function (t, e) {
                for (const n of t.getChildren())
                  if (
                    n.is("element", "b") &&
                    "normal" === n.getStyle("font-weight")
                  ) {
                    const o = t.getChildIndex(n);
                    e.remove(n), e.insertChild(o, n.getChildren(), t);
                  }
              })(n, e),
                (function (t, e) {
                  for (const n of e.createRangeIn(t)) {
                    const t = n.item;
                    if (t.is("element", "li")) {
                      const n = t.getChild(0);
                      n && n.is("element", "p") && e.unwrapElement(n);
                    }
                  }
                })(n, e),
                (function (t, e) {
                  const n = new Xi(e.document.stylesProcessor),
                    o = new Cs(n, { renderingMode: "data" }),
                    i = o.blockElements,
                    r = o.inlineObjectElements,
                    s = [];
                  for (const n of e.createRangeIn(t)) {
                    const t = n.item;
                    if (t.is("element", "br")) {
                      const n = _x(t, "forward", e, {
                          blockElements: i,
                          inlineObjectElements: r,
                        }),
                        o = _x(t, "backward", e, {
                          blockElements: i,
                          inlineObjectElements: r,
                        }),
                        a = Cx(n, i);
                      (Cx(o, i) || a) && s.push(t);
                    }
                  }
                  for (const t of s)
                    t.hasClass("Apple-interchange-newline")
                      ? e.remove(t)
                      : e.replace(t, e.createElement("p"));
                })(n, e),
                (t.content = n);
            }
          }
          function Ix(t, e) {
            if (!t.childCount) return;
            const n = new eu(),
              o = (function (t, e) {
                const n = e.createRangeIn(t),
                  o = new No({ name: /v:(.+)/ }),
                  i = [];
                for (const t of n) {
                  if ("elementStart" != t.type) continue;
                  const e = t.item,
                    n = (e.previousSibling && e.previousSibling.name) || null;
                  o.match(e) &&
                    e.getAttribute("o:gfxdata") &&
                    "v:shapetype" !== n &&
                    i.push(t.item.getAttribute("id"));
                }
                return i;
              })(t, n);
            !(function (t, e, n) {
              const o = n.createRangeIn(e),
                i = new No({ name: "img" }),
                r = [];
              for (const e of o)
                if (i.match(e.item)) {
                  const n = e.item,
                    o = n.getAttribute("v:shapes")
                      ? n.getAttribute("v:shapes").split(" ")
                      : [];
                  o.length && o.every((e) => t.indexOf(e) > -1)
                    ? r.push(n)
                    : n.getAttribute("src") || r.push(n);
                }
              for (const t of r) n.remove(t);
            })(o, t, n),
              (function (t, e) {
                const n = e.createRangeIn(t),
                  o = new No({ name: /v:(.+)/ }),
                  i = [];
                for (const t of n)
                  "elementStart" == t.type && o.match(t.item) && i.push(t.item);
                for (const t of i) e.remove(t);
              })(t, n);
            const i = (function (t, e) {
              const n = e.createRangeIn(t),
                o = new No({ name: "img" }),
                i = [];
              for (const t of n)
                o.match(t.item) &&
                  t.item.getAttribute("src").startsWith("file://") &&
                  i.push(t.item);
              return i;
            })(t, n);
            i.length &&
              (function (t, e, n) {
                if (t.length === e.length)
                  for (let o = 0; o < t.length; o++) {
                    const i = `data:${e[o].type};base64,${Tx(e[o].hex)}`;
                    n.setAttribute("src", i, t[o]);
                  }
              })(
                i,
                (function (t) {
                  if (!t) return [];
                  const e =
                      /{\\pict[\s\S]+?\\bliptag-?\d+(\\blipupi-?\d+)?({\\\*\\blipuid\s?[\da-fA-F]+)?[\s}]*?/,
                    n = new RegExp(
                      "(?:(" + e.source + "))([\\da-fA-F\\s]+)\\}",
                      "g"
                    ),
                    o = t.match(n),
                    i = [];
                  if (o)
                    for (const t of o) {
                      let n = !1;
                      t.includes("\\pngblip")
                        ? (n = "image/png")
                        : t.includes("\\jpegblip") && (n = "image/jpeg"),
                        n &&
                          i.push({
                            hex: t.replace(e, "").replace(/[^\da-fA-F]/g, ""),
                            type: n,
                          });
                    }
                  return i;
                })(e),
                n
              );
          }
          function Tx(t) {
            return btoa(
              t
                .match(/\w{2}/g)
                .map((t) => String.fromCharCode(parseInt(t, 16)))
                .join("")
            );
          }
          const Mx =
              /<meta\s*name="?generator"?\s*content="?microsoft\s*word\s*\d+"?\/?>/i,
            Bx = /xmlns:o="urn:schemas-microsoft-com/i;
          class Nx {
            constructor(t) {
              this.document = t;
            }
            isActive(t) {
              return Mx.test(t) || Bx.test(t);
            }
            execute(t) {
              const { body: e, stylesString: n } = t._parsedData;
              vx(e, n),
                Ix(e, t.dataTransfer.getData("text/rtf")),
                (t.content = e);
            }
          }
          function zx(t) {
            return t.replace(
              /<span(?: class="Apple-converted-space"|)>(\s+)<\/span>/g,
              (t, e) =>
                1 === e.length
                  ? " "
                  : Array(e.length + 1)
                      .join("  ")
                      .substr(0, e.length)
            );
          }
          function Px(t, e) {
            const n = new DOMParser(),
              o = (function (t) {
                return zx(zx(t))
                  .replace(
                    /(<span\s+style=['"]mso-spacerun:yes['"]>[^\S\r\n]*?)[\r\n]+([^\S\r\n]*<\/span>)/g,
                    "$1$2"
                  )
                  .replace(
                    /<span\s+style=['"]mso-spacerun:yes['"]><\/span>/g,
                    ""
                  )
                  .replace(/ <\//g, " </")
                  .replace(/ <o:p><\/o:p>/g, " <o:p></o:p>")
                  .replace(/<o:p>(&nbsp;|\u00A0)<\/o:p>/g, "")
                  .replace(/>([^\S\r\n]*[\r\n]\s*)</g, "><");
              })(
                (function (t) {
                  const e = "</body>",
                    n = "</html>",
                    o = t.indexOf(e);
                  if (o < 0) return t;
                  const i = t.indexOf(n, o + e.length);
                  return (
                    t.substring(0, o + e.length) +
                    (i >= 0 ? t.substring(i) : "")
                  );
                })((t = t.replace(/<!--\[if gte vml 1]>/g, "")))
              ),
              i = n.parseFromString(o, "text/html");
            !(function (t) {
              t.querySelectorAll("span[style*=spacerun]").forEach((t) => {
                const e = t.innerText.length || 0;
                t.innerText = Array(e + 1)
                  .join("  ")
                  .substr(0, e);
              });
            })(i);
            const r = i.body.innerHTML,
              s = (function (t, e) {
                const n = new Xi(e),
                  o = new Cs(n, { renderingMode: "data" }),
                  i = t.createDocumentFragment(),
                  r = t.body.childNodes;
                for (; r.length > 0; ) i.appendChild(r[0]);
                return o.domToView(i, { skipComments: !0 });
              })(i, e),
              a = (function (t) {
                const e = [],
                  n = [],
                  o = Array.from(t.getElementsByTagName("style"));
                for (const t of o)
                  t.sheet &&
                    t.sheet.cssRules &&
                    t.sheet.cssRules.length &&
                    (e.push(t.sheet), n.push(t.innerHTML));
                return { styles: e, stylesString: n.join(" ") };
              })(i);
            return {
              body: s,
              bodyString: r,
              styles: a.styles,
              stylesString: a.stylesString,
            };
          }
          const Lx = "removeFormat";
          class Rx extends j {
            static get pluginName() {
              return "RemoveFormatUI";
            }
            init() {
              const t = this.editor,
                e = t.t;
              t.ui.componentFactory.add(Lx, (n) => {
                const o = t.commands.get(Lx),
                  i = new nm(n);
                return (
                  i.set({
                    label: e("Remove Format"),
                    icon: '<svg viewBox="0 0 20 20" xmlns="http://www.w3.org/2000/svg"><path d="M8.69 14.915c.053.052.173.083.36.093a.366.366 0 0 1 .345.485l-.003.01a.738.738 0 0 1-.697.497h-2.67a.374.374 0 0 1-.353-.496l.013-.038a.681.681 0 0 1 .644-.458c.197-.012.325-.043.386-.093a.28.28 0 0 0 .072-.11L9.592 4.5H6.269c-.359-.017-.609.013-.75.09-.142.078-.289.265-.442.563-.192.29-.516.464-.864.464H4.17a.43.43 0 0 1-.407-.569L4.46 3h13.08l-.62 2.043a.81.81 0 0 1-.775.574h-.114a.486.486 0 0 1-.486-.486c.001-.284-.054-.464-.167-.54-.112-.076-.367-.106-.766-.091h-3.28l-2.68 10.257c-.006.074.007.127.038.158zM3 17h8a.5.5 0 1 1 0 1H3a.5.5 0 1 1 0-1zm11.299 1.17a.75.75 0 1 1-1.06-1.06l1.414-1.415-1.415-1.414a.75.75 0 0 1 1.06-1.06l1.415 1.414 1.414-1.415a.75.75 0 1 1 1.06 1.06l-1.413 1.415 1.414 1.415a.75.75 0 0 1-1.06 1.06l-1.415-1.414-1.414 1.414z"/></svg>',
                    tooltip: !0,
                  }),
                  i.bind("isOn", "isEnabled").to(o, "value", "isEnabled"),
                  this.listenTo(i, "execute", () => {
                    t.execute(Lx), t.editing.view.focus();
                  }),
                  i
                );
              });
            }
          }
          class Ox extends F {
            refresh() {
              const t = this.editor.model;
              this.isEnabled = !!Ra(
                this._getFormattingItems(t.document.selection, t.schema)
              );
            }
            execute() {
              const t = this.editor.model,
                e = t.schema;
              t.change((n) => {
                for (const o of this._getFormattingItems(
                  t.document.selection,
                  e
                ))
                  if (o.is("selection"))
                    for (const t of this._getFormattingAttributes(o, e))
                      n.removeSelectionAttribute(t);
                  else {
                    const t = n.createRangeOn(o);
                    for (const i of this._getFormattingAttributes(o, e))
                      n.removeAttribute(i, t);
                  }
              });
            }
            *_getFormattingItems(t, e) {
              const n = (t) => !!Ra(this._getFormattingAttributes(t, e));
              for (const o of t.getRanges())
                for (const t of o.getItems())
                  !e.isBlock(t) && n(t) && (yield t);
              for (const e of t.getSelectedBlocks()) n(e) && (yield e);
              n(t) && (yield t);
            }
            *_getFormattingAttributes(t, e) {
              for (const [n] of t.getAttributes()) {
                const t = e.getAttributeProperties(n);
                t && t.isFormatting && (yield n);
              }
            }
          }
          class jx extends j {
            static get pluginName() {
              return "RemoveFormatEditing";
            }
            init() {
              const t = this.editor;
              t.commands.add("removeFormat", new Ox(t));
            }
          }
          function Vx(t) {
            const e = [
                { name: "address", isVoid: !1 },
                { name: "article", isVoid: !1 },
                { name: "aside", isVoid: !1 },
                { name: "blockquote", isVoid: !1 },
                { name: "br", isVoid: !0 },
                { name: "details", isVoid: !1 },
                { name: "dialog", isVoid: !1 },
                { name: "dd", isVoid: !1 },
                { name: "div", isVoid: !1 },
                { name: "dl", isVoid: !1 },
                { name: "dt", isVoid: !1 },
                { name: "fieldset", isVoid: !1 },
                { name: "figcaption", isVoid: !1 },
                { name: "figure", isVoid: !1 },
                { name: "footer", isVoid: !1 },
                { name: "form", isVoid: !1 },
                { name: "h1", isVoid: !1 },
                { name: "h2", isVoid: !1 },
                { name: "h3", isVoid: !1 },
                { name: "h4", isVoid: !1 },
                { name: "h5", isVoid: !1 },
                { name: "h6", isVoid: !1 },
                { name: "header", isVoid: !1 },
                { name: "hgroup", isVoid: !1 },
                { name: "hr", isVoid: !0 },
                { name: "input", isVoid: !0 },
                { name: "li", isVoid: !1 },
                { name: "main", isVoid: !1 },
                { name: "nav", isVoid: !1 },
                { name: "ol", isVoid: !1 },
                { name: "p", isVoid: !1 },
                { name: "section", isVoid: !1 },
                { name: "table", isVoid: !1 },
                { name: "tbody", isVoid: !1 },
                { name: "td", isVoid: !1 },
                { name: "textarea", isVoid: !1 },
                { name: "th", isVoid: !1 },
                { name: "thead", isVoid: !1 },
                { name: "tr", isVoid: !1 },
                { name: "ul", isVoid: !1 },
              ],
              n = e.map((t) => t.name).join("|"),
              o = t
                .replace(new RegExp(`</?(${n})( .*?)?>`, "g"), "\n$&\n")
                .split("\n");
            let i = 0;
            return o
              .filter((t) => t.length)
              .map((t) =>
                (function (t, e) {
                  return e.some(
                    (e) =>
                      !e.isVoid && !!new RegExp(`<${e.name}( .*?)?>`).test(t)
                  );
                })(t, e)
                  ? Fx(t, i++)
                  : (function (t, e) {
                      return e.some((e) => new RegExp(`</${e.name}>`).test(t));
                    })(t, e)
                  ? Fx(t, --i)
                  : Fx(t, i)
              )
              .join("\n");
          }
          function Fx(t, e, n = "    ") {
            return `${n.repeat(Math.max(0, e))}${t}`;
          }
          var Hx = n(671),
            Ux = { attributes: { "data-cke": !0 } };
          (Ux.setAttributes = is()),
            (Ux.insert = ns().bind(null, "head")),
            (Ux.domAPI = ts()),
            (Ux.insertStyleElement = ss());
          Jr()(Hx.Z, Ux);
          Hx.Z && Hx.Z.locals && Hx.Z.locals;
          const Wx = "SourceEditingMode";
          function $x(t) {
            return (function (t) {
              return t.startsWith("<");
            })(t)
              ? Vx(t)
              : t;
          }
          const qx = "strikethrough";
          class Gx extends j {
            static get pluginName() {
              return "StrikethroughEditing";
            }
            init() {
              const t = this.editor;
              t.model.schema.extend("$text", { allowAttributes: qx }),
                t.model.schema.setAttributeProperties(qx, {
                  isFormatting: !0,
                  copyOnEnter: !0,
                }),
                t.conversion.attributeToElement({
                  model: qx,
                  view: "s",
                  upcastAlso: [
                    "del",
                    "strike",
                    { styles: { "text-decoration": "line-through" } },
                  ],
                }),
                t.commands.add(qx, new $k(t, qx)),
                t.keystrokes.set("CTRL+SHIFT+X", "strikethrough");
            }
          }
          const Zx = "strikethrough";
          class Yx extends j {
            static get pluginName() {
              return "StrikethroughUI";
            }
            init() {
              const t = this.editor,
                e = t.t;
              t.ui.componentFactory.add(Zx, (n) => {
                const o = t.commands.get(Zx),
                  i = new nm(n);
                return (
                  i.set({
                    label: e("Strikethrough"),
                    icon: '<svg viewBox="0 0 20 20" xmlns="http://www.w3.org/2000/svg"><path d="M7 16.4c-.8-.4-1.5-.9-2.2-1.5a.6.6 0 0 1-.2-.5l.3-.6h1c1 1.2 2.1 1.7 3.7 1.7 1 0 1.8-.3 2.3-.6.6-.4.6-1.2.6-1.3.2-1.2-.9-2.1-.9-2.1h2.1c.3.7.4 1.2.4 1.7v.8l-.6 1.2c-.6.8-1.1 1-1.6 1.2a6 6 0 0 1-2.4.6c-1 0-1.8-.3-2.5-.6zM6.8 9 6 8.3c-.4-.5-.5-.8-.5-1.6 0-.7.1-1.3.5-1.8.4-.6 1-1 1.6-1.3a6.3 6.3 0 0 1 4.7 0 4 4 0 0 1 1.7 1l.3.7c0 .1.2.4-.2.7-.4.2-.9.1-1 0a3 3 0 0 0-1.2-1c-.4-.2-1-.3-2-.4-.7 0-1.4.2-2 .6-.8.6-1 .8-1 1.5 0 .8.5 1 1.2 1.5.6.4 1.1.7 1.9 1H6.8z"/><path d="M3 10.5V9h14v1.5z"/></svg>',
                    keystroke: "CTRL+SHIFT+X",
                    tooltip: !0,
                    isToggleable: !0,
                  }),
                  i.bind("isOn", "isEnabled").to(o, "value", "isEnabled"),
                  this.listenTo(i, "execute", () => {
                    t.execute(Zx), t.editing.view.focus();
                  }),
                  i
                );
              });
            }
          }
          const Kx = "subscript";
          class Qx extends j {
            static get pluginName() {
              return "SubscriptEditing";
            }
            init() {
              const t = this.editor;
              t.model.schema.extend("$text", { allowAttributes: Kx }),
                t.model.schema.setAttributeProperties(Kx, {
                  isFormatting: !0,
                  copyOnEnter: !0,
                }),
                t.conversion.attributeToElement({
                  model: Kx,
                  view: "sub",
                  upcastAlso: [{ styles: { "vertical-align": "sub" } }],
                }),
                t.commands.add(Kx, new $k(t, Kx));
            }
          }
          const Jx = "subscript";
          class Xx extends j {
            static get pluginName() {
              return "SubscriptUI";
            }
            init() {
              const t = this.editor,
                e = t.t;
              t.ui.componentFactory.add(Jx, (n) => {
                const o = t.commands.get(Jx),
                  i = new nm(n);
                return (
                  i.set({
                    label: e("Subscript"),
                    icon: '<svg viewBox="0 0 20 20" xmlns="http://www.w3.org/2000/svg"><path d="m7.03 10.349 3.818-3.819a.8.8 0 1 1 1.132 1.132L8.16 11.48l3.819 3.818a.8.8 0 1 1-1.132 1.132L7.03 12.61l-3.818 3.82a.8.8 0 1 1-1.132-1.132L5.9 11.48 2.08 7.662A.8.8 0 1 1 3.212 6.53l3.818 3.82zm8.147 7.829h2.549c.254 0 .447.05.58.152a.49.49 0 0 1 .201.413.54.54 0 0 1-.159.393c-.105.108-.266.162-.48.162h-3.594c-.245 0-.435-.066-.572-.197a.621.621 0 0 1-.205-.463c0-.114.044-.265.132-.453a1.62 1.62 0 0 1 .288-.444c.433-.436.824-.81 1.172-1.122.348-.312.597-.517.747-.615.267-.183.49-.368.667-.553.177-.185.312-.375.405-.57.093-.194.139-.384.139-.57a1.008 1.008 0 0 0-.554-.917 1.197 1.197 0 0 0-.56-.133c-.426 0-.761.182-1.005.546a2.332 2.332 0 0 0-.164.39 1.609 1.609 0 0 1-.258.488c-.096.114-.237.17-.423.17a.558.558 0 0 1-.405-.156.568.568 0 0 1-.161-.427c0-.218.05-.446.151-.683.101-.238.252-.453.452-.646s.454-.349.762-.467a2.998 2.998 0 0 1 1.081-.178c.498 0 .923.076 1.274.228a1.916 1.916 0 0 1 1.004 1.032 1.984 1.984 0 0 1-.156 1.794c-.2.32-.405.572-.613.754-.208.182-.558.468-1.048.857-.49.39-.826.691-1.008.906a2.703 2.703 0 0 0-.24.309z"/></svg>',
                    tooltip: !0,
                    isToggleable: !0,
                  }),
                  i.bind("isOn", "isEnabled").to(o, "value", "isEnabled"),
                  this.listenTo(i, "execute", () => {
                    t.execute(Jx), t.editing.view.focus();
                  }),
                  i
                );
              });
            }
          }
          const tE = "superscript";
          class eE extends j {
            static get pluginName() {
              return "SuperscriptEditing";
            }
            init() {
              const t = this.editor;
              t.model.schema.extend("$text", { allowAttributes: tE }),
                t.model.schema.setAttributeProperties(tE, {
                  isFormatting: !0,
                  copyOnEnter: !0,
                }),
                t.conversion.attributeToElement({
                  model: tE,
                  view: "sup",
                  upcastAlso: [{ styles: { "vertical-align": "super" } }],
                }),
                t.commands.add(tE, new $k(t, tE));
            }
          }
          const nE = "superscript";
          class oE extends j {
            static get pluginName() {
              return "SuperscriptUI";
            }
            init() {
              const t = this.editor,
                e = t.t;
              t.ui.componentFactory.add(nE, (n) => {
                const o = t.commands.get(nE),
                  i = new nm(n);
                return (
                  i.set({
                    label: e("Superscript"),
                    icon: '<svg viewBox="0 0 20 20" xmlns="http://www.w3.org/2000/svg"><path d="M15.677 8.678h2.549c.254 0 .447.05.58.152a.49.49 0 0 1 .201.413.54.54 0 0 1-.159.393c-.105.108-.266.162-.48.162h-3.594c-.245 0-.435-.066-.572-.197a.621.621 0 0 1-.205-.463c0-.114.044-.265.132-.453a1.62 1.62 0 0 1 .288-.444c.433-.436.824-.81 1.172-1.122.348-.312.597-.517.747-.615.267-.183.49-.368.667-.553.177-.185.312-.375.405-.57.093-.194.139-.384.139-.57a1.008 1.008 0 0 0-.554-.917 1.197 1.197 0 0 0-.56-.133c-.426 0-.761.182-1.005.546a2.332 2.332 0 0 0-.164.39 1.609 1.609 0 0 1-.258.488c-.096.114-.237.17-.423.17a.558.558 0 0 1-.405-.156.568.568 0 0 1-.161-.427c0-.218.05-.446.151-.683.101-.238.252-.453.452-.646s.454-.349.762-.467a2.998 2.998 0 0 1 1.081-.178c.498 0 .923.076 1.274.228a1.916 1.916 0 0 1 1.004 1.032 1.984 1.984 0 0 1-.156 1.794c-.2.32-.405.572-.613.754-.208.182-.558.468-1.048.857-.49.39-.826.691-1.008.906a2.703 2.703 0 0 0-.24.309zM7.03 10.349l3.818-3.819a.8.8 0 1 1 1.132 1.132L8.16 11.48l3.819 3.818a.8.8 0 1 1-1.132 1.132L7.03 12.61l-3.818 3.82a.8.8 0 1 1-1.132-1.132L5.9 11.48 2.08 7.662A.8.8 0 1 1 3.212 6.53l3.818 3.82z"/></svg>',
                    tooltip: !0,
                    isToggleable: !0,
                  }),
                  i.bind("isOn", "isEnabled").to(o, "value", "isEnabled"),
                  this.listenTo(i, "execute", () => {
                    t.execute(nE), t.editing.view.focus();
                  }),
                  i
                );
              });
            }
          }
          function iE(t, e) {
            const {
              viewElement: n,
              defaultValue: o,
              modelAttribute: i,
              styleName: r,
              reduceBoxSides: s = !1,
            } = e;
            t.for("upcast").attributeToAttribute({
              view: { name: n, styles: { [r]: /[\s\S]+/ } },
              model: {
                key: i,
                value: (t) => {
                  const e = t.getNormalizedStyle(r),
                    n = s ? lE(e) : e;
                  if (o !== n) return n;
                },
              },
            });
          }
          function rE(t, e, n, o) {
            t.for("upcast").add((t) =>
              t.on("element:" + e, (t, e, i) => {
                if (!e.modelRange) return;
                const r = [
                  "border-top-width",
                  "border-top-color",
                  "border-top-style",
                  "border-bottom-width",
                  "border-bottom-color",
                  "border-bottom-style",
                  "border-right-width",
                  "border-right-color",
                  "border-right-style",
                  "border-left-width",
                  "border-left-color",
                  "border-left-style",
                ].filter((t) => e.viewItem.hasStyle(t));
                if (!r.length) return;
                const s = { styles: r };
                if (!i.consumable.test(e.viewItem, s)) return;
                const a = [...e.modelRange.getItems({ shallow: !0 })].pop();
                i.consumable.consume(e.viewItem, s);
                const l = {
                    style: e.viewItem.getNormalizedStyle("border-style"),
                    color: e.viewItem.getNormalizedStyle("border-color"),
                    width: e.viewItem.getNormalizedStyle("border-width"),
                  },
                  c = {
                    style: lE(l.style),
                    color: lE(l.color),
                    width: lE(l.width),
                  };
                c.style !== o.style &&
                  i.writer.setAttribute(n.style, c.style, a),
                  c.color !== o.color &&
                    i.writer.setAttribute(n.color, c.color, a),
                  c.width !== o.width &&
                    i.writer.setAttribute(n.width, c.width, a);
              })
            );
          }
          function sE(t, { modelElement: e, modelAttribute: n, styleName: o }) {
            t.for("downcast").attributeToAttribute({
              model: { name: e, key: n },
              view: (t) => ({ key: "style", value: { [o]: t } }),
            });
          }
          function aE(t, { modelAttribute: e, styleName: n }) {
            t.for("downcast").add((t) =>
              t.on(`attribute:${e}:table`, (t, e, o) => {
                const { item: i, attributeNewValue: r } = e,
                  { mapper: s, writer: a } = o;
                if (!o.consumable.consume(e.item, t.name)) return;
                const l = [...s.toViewElement(i).getChildren()].find((t) =>
                  t.is("element", "table")
                );
                r ? a.setStyle(n, r, l) : a.removeStyle(n, l);
              })
            );
          }
          function lE(t) {
            if (!t) return;
            return (
              ["top", "right", "bottom", "left"]
                .map((e) => t[e])
                .reduce((t, e) => (t == e ? t : null)) || t
            );
          }
          function cE(t, e, n, o, i = 1) {
            e > i ? o.setAttribute(t, e, n) : o.removeAttribute(t, n);
          }
          function dE(t, e, n = {}) {
            const o = t.createElement("tableCell", n);
            return t.insertElement("paragraph", o), t.insert(o, e), o;
          }
          function uE(t, e) {
            const n = e.parent.parent,
              o = parseInt(n.getAttribute("headingColumns") || 0),
              { column: i } = t.getCellLocation(e);
            return !!o && i < o;
          }
          function hE(t, e, n) {
            const { modelAttribute: o } = n;
            t.extend("tableCell", { allowAttributes: [o] }),
              iE(e, { viewElement: /^(td|th)$/, ...n }),
              sE(e, { modelElement: "tableCell", ...n });
          }
          function mE() {
            return (t) => {
              t.on("element:table", (t, e, n) => {
                const o = e.viewItem;
                if (!n.consumable.test(o, { name: !0 })) return;
                const {
                    rows: i,
                    headingRows: r,
                    headingColumns: s,
                  } = (function (t) {
                    const e = { headingRows: 0, headingColumns: 0 },
                      n = [],
                      o = [];
                    let i;
                    for (const r of Array.from(t.getChildren()))
                      if (
                        "tbody" === r.name ||
                        "thead" === r.name ||
                        "tfoot" === r.name
                      ) {
                        "thead" !== r.name || i || (i = r);
                        const t = Array.from(r.getChildren()).filter((t) =>
                          t.is("element", "tr")
                        );
                        for (const r of t)
                          if ("thead" === r.parent.name && r.parent === i)
                            e.headingRows++, n.push(r);
                          else {
                            o.push(r);
                            const t = pE(r);
                            t > e.headingColumns && (e.headingColumns = t);
                          }
                      }
                    return (e.rows = [...n, ...o]), e;
                  })(o),
                  a = {};
                s && (a.headingColumns = s), r && (a.headingRows = r);
                const l = n.writer.createElement("table", a);
                if (n.safeInsert(l, e.modelCursor)) {
                  if (
                    (n.consumable.consume(o, { name: !0 }),
                    i.forEach((t) =>
                      n.convertItem(t, n.writer.createPositionAt(l, "end"))
                    ),
                    n.convertChildren(o, n.writer.createPositionAt(l, "end")),
                    l.isEmpty)
                  ) {
                    const t = n.writer.createElement("tableRow");
                    n.writer.insert(t, n.writer.createPositionAt(l, "end")),
                      dE(n.writer, n.writer.createPositionAt(t, "end"));
                  }
                  n.updateConversionResult(l, e);
                }
              });
            };
          }
          function gE(t) {
            return (e) => {
              e.on(
                `element:${t}`,
                (t, e, n) => {
                  if (e.modelRange && e.viewItem.isEmpty) {
                    const t = e.modelRange.start.nodeAfter,
                      o = n.writer.createPositionAt(t, 0);
                    n.writer.insertElement("paragraph", o);
                  }
                },
                { priority: "low" }
              );
            };
          }
          function pE(t) {
            let e = 0,
              n = 0;
            const o = Array.from(t.getChildren()).filter(
              (t) => "th" === t.name || "td" === t.name
            );
            for (; n < o.length && "th" === o[n].name; ) {
              const t = o[n];
              (e += parseInt(t.getAttribute("colspan") || 1)), n++;
            }
            return e;
          }
          class fE {
            constructor(t, e = {}) {
              (this._table = t),
                (this._startRow = void 0 !== e.row ? e.row : e.startRow || 0),
                (this._endRow = void 0 !== e.row ? e.row : e.endRow),
                (this._startColumn =
                  void 0 !== e.column ? e.column : e.startColumn || 0),
                (this._endColumn =
                  void 0 !== e.column ? e.column : e.endColumn),
                (this._includeAllSlots = !!e.includeAllSlots),
                (this._skipRows = new Set()),
                (this._row = 0),
                (this._rowIndex = 0),
                (this._column = 0),
                (this._cellIndex = 0),
                (this._spannedCells = new Map()),
                (this._nextCellAtColumn = -1);
            }
            [Symbol.iterator]() {
              return this;
            }
            next() {
              const t = this._table.getChild(this._rowIndex);
              if (!t || this._isOverEndRow()) return { done: !0 };
              if (!t.is("element", "tableRow"))
                return this._rowIndex++, this.next();
              if (this._isOverEndColumn()) return this._advanceToNextRow();
              let e = null;
              const n = this._getSpanned();
              if (n)
                this._includeAllSlots &&
                  !this._shouldSkipSlot() &&
                  (e = this._formatOutValue(n.cell, n.row, n.column));
              else {
                const n = t.getChild(this._cellIndex);
                if (!n) return this._advanceToNextRow();
                const o = parseInt(n.getAttribute("colspan") || 1),
                  i = parseInt(n.getAttribute("rowspan") || 1);
                (o > 1 || i > 1) && this._recordSpans(n, i, o),
                  this._shouldSkipSlot() || (e = this._formatOutValue(n)),
                  (this._nextCellAtColumn = this._column + o);
              }
              return (
                this._column++,
                this._column == this._nextCellAtColumn && this._cellIndex++,
                e || this.next()
              );
            }
            skipRow(t) {
              this._skipRows.add(t);
            }
            _advanceToNextRow() {
              return (
                this._row++,
                this._rowIndex++,
                (this._column = 0),
                (this._cellIndex = 0),
                (this._nextCellAtColumn = -1),
                this.next()
              );
            }
            _isOverEndRow() {
              return void 0 !== this._endRow && this._row > this._endRow;
            }
            _isOverEndColumn() {
              return (
                void 0 !== this._endColumn && this._column > this._endColumn
              );
            }
            _formatOutValue(t, e = this._row, n = this._column) {
              return { done: !1, value: new kE(this, t, e, n) };
            }
            _shouldSkipSlot() {
              const t = this._skipRows.has(this._row),
                e = this._row < this._startRow,
                n = this._column < this._startColumn,
                o =
                  void 0 !== this._endColumn && this._column > this._endColumn;
              return t || e || n || o;
            }
            _getSpanned() {
              const t = this._spannedCells.get(this._row);
              return (t && t.get(this._column)) || null;
            }
            _recordSpans(t, e, n) {
              const o = { cell: t, row: this._row, column: this._column };
              for (let t = this._row; t < this._row + e; t++)
                for (let e = this._column; e < this._column + n; e++)
                  (t == this._row && e == this._column) ||
                    this._markSpannedCell(t, e, o);
            }
            _markSpannedCell(t, e, n) {
              this._spannedCells.has(t) || this._spannedCells.set(t, new Map());
              this._spannedCells.get(t).set(e, n);
            }
          }
          class kE {
            constructor(t, e, n, o) {
              (this.cell = e),
                (this.row = t._row),
                (this.column = t._column),
                (this.cellAnchorRow = n),
                (this.cellAnchorColumn = o),
                (this._cellIndex = t._cellIndex),
                (this._rowIndex = t._rowIndex),
                (this._table = t._table);
            }
            get isAnchor() {
              return (
                this.row === this.cellAnchorRow &&
                this.column === this.cellAnchorColumn
              );
            }
            get cellWidth() {
              return parseInt(this.cell.getAttribute("colspan") || 1);
            }
            get cellHeight() {
              return parseInt(this.cell.getAttribute("rowspan") || 1);
            }
            get rowIndex() {
              return this._rowIndex;
            }
            getPositionBefore() {
              return this._table.root.document.model.createPositionAt(
                this._table.getChild(this.row),
                this._cellIndex
              );
            }
          }
          function bE(t, e = {}) {
            return (n, { writer: o }) => {
              const i = n.getAttribute("headingRows") || 0,
                r = [];
              i > 0 &&
                r.push(
                  o.createContainerElement(
                    "thead",
                    null,
                    o.createSlot(
                      (t) => t.is("element", "tableRow") && t.index < i
                    )
                  )
                ),
                i < t.getRows(n) &&
                  r.push(
                    o.createContainerElement(
                      "tbody",
                      null,
                      o.createSlot(
                        (t) => t.is("element", "tableRow") && t.index >= i
                      )
                    )
                  );
              const s = o.createContainerElement("figure", { class: "table" }, [
                o.createContainerElement("table", null, r),
                o.createSlot((t) => !t.is("element", "tableRow")),
              ]);
              return e.asWidget
                ? (function (t, e) {
                    return (
                      e.setCustomProperty("table", !0, t),
                      Zp(t, e, { hasSelectionHandle: !0 })
                    );
                  })(s, o)
                : s;
            };
          }
          function wE(t = {}) {
            return (e, { writer: n }) => {
              const o = e.parent,
                i = o.parent,
                r = i.getChildIndex(o),
                s = new fE(i, { row: r }),
                a = i.getAttribute("headingRows") || 0,
                l = i.getAttribute("headingColumns") || 0;
              for (const o of s)
                if (o.cell == e) {
                  const e = o.row < a || o.column < l ? "th" : "td";
                  return t.asWidget
                    ? Xp(n.createEditableElement(e), n)
                    : n.createContainerElement(e);
                }
            };
          }
          function AE(t = {}) {
            return (e, { writer: n, consumable: o, mapper: i }) => {
              if (e.parent.is("element", "tableCell") && _E(e))
                return t.asWidget
                  ? n.createContainerElement("span", {
                      class: "ck-table-bogus-paragraph",
                    })
                  : (o.consume(e, "insert"),
                    void i.bindElements(e, i.toViewElement(e.parent)));
            };
          }
          function _E(t) {
            return (
              1 == t.parent.childCount && ![...t.getAttributeKeys()].length
            );
          }
          class CE extends F {
            refresh() {
              const t = this.editor.model,
                e = t.document.selection,
                n = t.schema;
              this.isEnabled = (function (t, e) {
                const n = t.getFirstPosition().parent,
                  o = n === n.root ? n : n.parent;
                return e.checkChild(o, "table");
              })(e, n);
            }
            execute(t = {}) {
              const e = this.editor.model,
                n = this.editor.plugins.get("TableUtils"),
                o = this.editor.config.get("table"),
                i = o.defaultHeadings.rows,
                r = o.defaultHeadings.columns;
              void 0 === t.headingRows && i && (t.headingRows = i),
                void 0 === t.headingColumns && r && (t.headingColumns = r),
                e.change((o) => {
                  const i = n.createTable(o, t);
                  e.insertObject(i, null, null, {
                    findOptimalPosition: "auto",
                  }),
                    o.setSelection(
                      o.createPositionAt(i.getNodeByPath([0, 0, 0]), 0)
                    );
                });
            }
          }
          class vE extends F {
            constructor(t, e = {}) {
              super(t), (this.order = e.order || "below");
            }
            refresh() {
              const t = this.editor.model.document.selection,
                e = !!this.editor.plugins
                  .get("TableUtils")
                  .getSelectionAffectedTableCells(t).length;
              this.isEnabled = e;
            }
            execute() {
              const t = this.editor,
                e = t.model.document.selection,
                n = t.plugins.get("TableUtils"),
                o = "above" === this.order,
                i = n.getSelectionAffectedTableCells(e),
                r = n.getRowIndexes(i),
                s = o ? r.first : r.last,
                a = i[0].findAncestor("table");
              n.insertRows(a, {
                at: o ? s : s + 1,
                copyStructureFromAbove: !o,
              });
            }
          }
          class yE extends F {
            constructor(t, e = {}) {
              super(t), (this.order = e.order || "right");
            }
            refresh() {
              const t = this.editor.model.document.selection,
                e = !!this.editor.plugins
                  .get("TableUtils")
                  .getSelectionAffectedTableCells(t).length;
              this.isEnabled = e;
            }
            execute() {
              const t = this.editor,
                e = t.model.document.selection,
                n = t.plugins.get("TableUtils"),
                o = "left" === this.order,
                i = n.getSelectionAffectedTableCells(e),
                r = n.getColumnIndexes(i),
                s = o ? r.first : r.last,
                a = i[0].findAncestor("table");
              n.insertColumns(a, { columns: 1, at: o ? s : s + 1 });
            }
          }
          class xE extends F {
            constructor(t, e = {}) {
              super(t), (this.direction = e.direction || "horizontally");
            }
            refresh() {
              const t = this.editor.plugins
                .get("TableUtils")
                .getSelectionAffectedTableCells(
                  this.editor.model.document.selection
                );
              this.isEnabled = 1 === t.length;
            }
            execute() {
              const t = this.editor.plugins.get("TableUtils"),
                e = t.getSelectionAffectedTableCells(
                  this.editor.model.document.selection
                )[0];
              "horizontally" === this.direction
                ? t.splitCellHorizontally(e, 2)
                : t.splitCellVertically(e, 2);
            }
          }
          function EE(t, e, n) {
            const { startRow: o, startColumn: i, endRow: r, endColumn: s } = e,
              a = n.createElement("table"),
              l = r - o + 1;
            for (let t = 0; t < l; t++) n.insertElement("tableRow", a, "end");
            const c = [
              ...new fE(t, {
                startRow: o,
                endRow: r,
                startColumn: i,
                endColumn: s,
                includeAllSlots: !0,
              }),
            ];
            for (const {
              row: t,
              column: e,
              cell: l,
              isAnchor: d,
              cellAnchorRow: u,
              cellAnchorColumn: h,
            } of c) {
              const c = t - o,
                m = a.getChild(c);
              if (d) {
                const o = n.cloneElement(l);
                n.append(o, m), ME(o, t, e, r, s, n);
              } else (u < o || h < i) && dE(n, n.createPositionAt(m, "end"));
            }
            return (
              (function (t, e, n, o, i) {
                const r = parseInt(e.getAttribute("headingRows") || 0);
                if (r > 0) {
                  cE("headingRows", r - n, t, i, 0);
                }
                const s = parseInt(e.getAttribute("headingColumns") || 0);
                if (s > 0) {
                  cE("headingColumns", s - o, t, i, 0);
                }
              })(a, t, o, i, n),
              a
            );
          }
          function DE(t, e, n = 0) {
            const o = [],
              i = new fE(t, { startRow: n, endRow: e - 1 });
            for (const t of i) {
              const { row: n, cellHeight: i } = t,
                r = n + i - 1;
              n < e && e <= r && o.push(t);
            }
            return o;
          }
          function SE(t, e, n) {
            const o = t.parent,
              i = o.parent,
              r = o.index,
              s = e - r,
              a = {},
              l = parseInt(t.getAttribute("rowspan")) - s;
            l > 1 && (a.rowspan = l);
            const c = parseInt(t.getAttribute("colspan") || 1);
            c > 1 && (a.colspan = c);
            const d = r + s,
              u = [
                ...new fE(i, { startRow: r, endRow: d, includeAllSlots: !0 }),
              ];
            let h,
              m = null;
            for (const e of u) {
              const { row: o, column: i, cell: r } = e;
              r === t && void 0 === h && (h = i),
                void 0 !== h &&
                  h === i &&
                  o === d &&
                  (m = dE(n, e.getPositionBefore(), a));
            }
            return cE("rowspan", s, t, n), m;
          }
          function IE(t, e) {
            const n = [],
              o = new fE(t);
            for (const t of o) {
              const { column: o, cellWidth: i } = t,
                r = o + i - 1;
              o < e && e <= r && n.push(t);
            }
            return n;
          }
          function TE(t, e, n, o) {
            const i = n - e,
              r = {},
              s = parseInt(t.getAttribute("colspan")) - i;
            s > 1 && (r.colspan = s);
            const a = parseInt(t.getAttribute("rowspan") || 1);
            a > 1 && (r.rowspan = a);
            const l = dE(o, o.createPositionAfter(t), r);
            return cE("colspan", i, t, o), l;
          }
          function ME(t, e, n, o, i, r) {
            const s = parseInt(t.getAttribute("colspan") || 1),
              a = parseInt(t.getAttribute("rowspan") || 1);
            if (n + s - 1 > i) {
              cE("colspan", i - n + 1, t, r, 1);
            }
            if (e + a - 1 > o) {
              cE("rowspan", o - e + 1, t, r, 1);
            }
          }
          function BE(t, e) {
            const n = e.getColumns(t),
              o = new Array(n).fill(0);
            for (const { column: e } of new fE(t)) o[e]++;
            const i = o.reduce((t, e, n) => (e ? t : [...t, n]), []);
            if (i.length > 0) {
              const n = i[i.length - 1];
              return e.removeColumns(t, { at: n }), !0;
            }
            return !1;
          }
          function NE(t, e) {
            const n = [],
              o = e.getRows(t);
            for (let e = 0; e < o; e++) {
              t.getChild(e).isEmpty && n.push(e);
            }
            if (n.length > 0) {
              const o = n[n.length - 1];
              return e.removeRows(t, { at: o }), !0;
            }
            return !1;
          }
          function zE(t, e) {
            BE(t, e) || NE(t, e);
          }
          function PE(t, e) {
            const n = Array.from(
              new fE(t, {
                startColumn: e.firstColumn,
                endColumn: e.lastColumn,
                row: e.lastRow,
              })
            );
            if (n.every(({ cellHeight: t }) => 1 === t)) return e.lastRow;
            const o = n[0].cellHeight - 1;
            return e.lastRow + o;
          }
          function LE(t, e) {
            const n = Array.from(
              new fE(t, {
                startRow: e.firstRow,
                endRow: e.lastRow,
                column: e.lastColumn,
              })
            );
            if (n.every(({ cellWidth: t }) => 1 === t)) return e.lastColumn;
            const o = n[0].cellWidth - 1;
            return e.lastColumn + o;
          }
          class RE extends F {
            constructor(t, e) {
              super(t),
                (this.direction = e.direction),
                (this.isHorizontal =
                  "right" == this.direction || "left" == this.direction);
            }
            refresh() {
              const t = this._getMergeableCell();
              (this.value = t), (this.isEnabled = !!t);
            }
            execute() {
              const t = this.editor.model,
                e = t.document,
                n = this.editor.plugins
                  .get("TableUtils")
                  .getTableCellsContainingSelection(e.selection)[0],
                o = this.value,
                i = this.direction;
              t.change((t) => {
                const e = "right" == i || "down" == i,
                  r = e ? n : o,
                  s = e ? o : n,
                  a = s.parent;
                !(function (t, e, n) {
                  OE(t) ||
                    (OE(e) && n.remove(n.createRangeIn(e)),
                    n.move(n.createRangeIn(t), n.createPositionAt(e, "end")));
                  n.remove(t);
                })(s, r, t);
                const l = this.isHorizontal ? "colspan" : "rowspan",
                  c = parseInt(n.getAttribute(l) || 1),
                  d = parseInt(o.getAttribute(l) || 1);
                t.setAttribute(l, c + d, r), t.setSelection(t.createRangeIn(r));
                const u = this.editor.plugins.get("TableUtils");
                zE(a.findAncestor("table"), u);
              });
            }
            _getMergeableCell() {
              const t = this.editor.model.document,
                e = this.editor.plugins.get("TableUtils"),
                n = e.getTableCellsContainingSelection(t.selection)[0];
              if (!n) return;
              const o = this.isHorizontal
                ? (function (t, e, n) {
                    const o = t.parent.parent,
                      i = "right" == e ? t.nextSibling : t.previousSibling,
                      r = (o.getAttribute("headingColumns") || 0) > 0;
                    if (!i) return;
                    const s = "right" == e ? t : i,
                      a = "right" == e ? i : t,
                      { column: l } = n.getCellLocation(s),
                      { column: c } = n.getCellLocation(a),
                      d = parseInt(s.getAttribute("colspan") || 1),
                      u = uE(n, s),
                      h = uE(n, a);
                    if (r && u != h) return;
                    return l + d === c ? i : void 0;
                  })(n, this.direction, e)
                : (function (t, e, n) {
                    const o = t.parent,
                      i = o.parent,
                      r = i.getChildIndex(o);
                    if (
                      ("down" == e && r === n.getRows(i) - 1) ||
                      ("up" == e && 0 === r)
                    )
                      return;
                    const s = parseInt(t.getAttribute("rowspan") || 1),
                      a = i.getAttribute("headingRows") || 0,
                      l = "down" == e && r + s === a,
                      c = "up" == e && r === a;
                    if (a && (l || c)) return;
                    const d = parseInt(t.getAttribute("rowspan") || 1),
                      u = "down" == e ? r + d : r,
                      h = [...new fE(i, { endRow: u })],
                      m = h.find((e) => e.cell === t).column,
                      g = h.find(
                        ({ row: t, cellHeight: n, column: o }) =>
                          o === m && ("down" == e ? t === u : u === t + n)
                      );
                    return g && g.cell;
                  })(n, this.direction, e);
              if (!o) return;
              const i = this.isHorizontal ? "rowspan" : "colspan",
                r = parseInt(n.getAttribute(i) || 1);
              return parseInt(o.getAttribute(i) || 1) === r ? o : void 0;
            }
          }
          function OE(t) {
            return (
              1 == t.childCount &&
              t.getChild(0).is("element", "paragraph") &&
              t.getChild(0).isEmpty
            );
          }
          class jE extends F {
            refresh() {
              const t = this.editor.plugins.get("TableUtils"),
                e = t.getSelectionAffectedTableCells(
                  this.editor.model.document.selection
                ),
                n = e[0];
              if (n) {
                const o = n.findAncestor("table"),
                  i = this.editor.plugins.get("TableUtils").getRows(o) - 1,
                  r = t.getRowIndexes(e),
                  s = 0 === r.first && r.last === i;
                this.isEnabled = !s;
              } else this.isEnabled = !1;
            }
            execute() {
              const t = this.editor.model,
                e = this.editor.plugins.get("TableUtils"),
                n = e.getSelectionAffectedTableCells(t.document.selection),
                o = e.getRowIndexes(n),
                i = n[0],
                r = i.findAncestor("table"),
                s = e.getCellLocation(i).column;
              t.change((t) => {
                const n = o.last - o.first + 1;
                e.removeRows(r, { at: o.first, rows: n });
                const i = (function (t, e, n, o) {
                  const i = t.getChild(Math.min(e, o - 1));
                  let r = i.getChild(0),
                    s = 0;
                  for (const t of i.getChildren()) {
                    if (s > n) return r;
                    (r = t), (s += parseInt(t.getAttribute("colspan") || 1));
                  }
                  return r;
                })(r, o.first, s, e.getRows(r));
                t.setSelection(t.createPositionAt(i, 0));
              });
            }
          }
          class VE extends F {
            refresh() {
              const t = this.editor.plugins.get("TableUtils"),
                e = t.getSelectionAffectedTableCells(
                  this.editor.model.document.selection
                ),
                n = e[0];
              if (n) {
                const o = n.findAncestor("table"),
                  i = t.getColumns(o),
                  { first: r, last: s } = t.getColumnIndexes(e);
                this.isEnabled = s - r < i - 1;
              } else this.isEnabled = !1;
            }
            execute() {
              const t = this.editor.plugins.get("TableUtils"),
                [e, n] = (function (t, e) {
                  const n = e.getSelectionAffectedTableCells(t),
                    o = n[0],
                    i = n.pop(),
                    r = [o, i];
                  return o.isBefore(i) ? r : r.reverse();
                })(this.editor.model.document.selection, t),
                o = e.parent.parent,
                i = [...new fE(o)],
                r = {
                  first: i.find((t) => t.cell === e).column,
                  last: i.find((t) => t.cell === n).column,
                },
                s = (function (t, e, n, o) {
                  return parseInt(n.getAttribute("colspan") || 1) > 1
                    ? n
                    : e.previousSibling || n.nextSibling
                    ? n.nextSibling || e.previousSibling
                    : o.first
                    ? t.reverse().find(({ column: t }) => t < o.first).cell
                    : t.reverse().find(({ column: t }) => t > o.last).cell;
                })(i, e, n, r);
              this.editor.model.change((t) => {
                const e = r.last - r.first + 1;
                this.editor.plugins
                  .get("TableUtils")
                  .removeColumns(o, { at: r.first, columns: e }),
                  t.setSelection(t.createPositionAt(s, 0));
              });
            }
          }
          class FE extends F {
            refresh() {
              const t = this.editor.plugins.get("TableUtils"),
                e = this.editor.model,
                n = t.getSelectionAffectedTableCells(e.document.selection),
                o = n.length > 0;
              (this.isEnabled = o),
                (this.value =
                  o && n.every((t) => this._isInHeading(t, t.parent.parent)));
            }
            execute(t = {}) {
              if (t.forceValue === this.value) return;
              const e = this.editor.plugins.get("TableUtils"),
                n = this.editor.model,
                o = e.getSelectionAffectedTableCells(n.document.selection),
                i = o[0].findAncestor("table"),
                { first: r, last: s } = e.getRowIndexes(o),
                a = this.value ? r : s + 1,
                l = i.getAttribute("headingRows") || 0;
              n.change((t) => {
                if (a) {
                  const e = DE(i, a, a > l ? l : 0);
                  for (const { cell: n } of e) SE(n, a, t);
                }
                cE("headingRows", a, i, t, 0);
              });
            }
            _isInHeading(t, e) {
              const n = parseInt(e.getAttribute("headingRows") || 0);
              return !!n && t.parent.index < n;
            }
          }
          class HE extends F {
            refresh() {
              const t = this.editor.model,
                e = this.editor.plugins.get("TableUtils"),
                n = e.getSelectionAffectedTableCells(t.document.selection),
                o = n.length > 0;
              (this.isEnabled = o),
                (this.value = o && n.every((t) => uE(e, t)));
            }
            execute(t = {}) {
              if (t.forceValue === this.value) return;
              const e = this.editor.plugins.get("TableUtils"),
                n = this.editor.model,
                o = e.getSelectionAffectedTableCells(n.document.selection),
                i = o[0].findAncestor("table"),
                { first: r, last: s } = e.getColumnIndexes(o),
                a = this.value ? r : s + 1;
              n.change((t) => {
                if (a) {
                  const e = IE(i, a);
                  for (const { cell: n, column: o } of e) TE(n, o, a, t);
                }
                cE("headingColumns", a, i, t, 0);
              });
            }
          }
          class UE extends j {
            static get pluginName() {
              return "TableUtils";
            }
            init() {
              this.decorate("insertColumns"), this.decorate("insertRows");
            }
            getCellLocation(t) {
              const e = t.parent,
                n = e.parent,
                o = n.getChildIndex(e),
                i = new fE(n, { row: o });
              for (const { cell: e, row: n, column: o } of i)
                if (e === t) return { row: n, column: o };
            }
            createTable(t, e) {
              const n = t.createElement("table"),
                o = parseInt(e.rows) || 2,
                i = parseInt(e.columns) || 2;
              return (
                WE(t, n, 0, o, i),
                e.headingRows &&
                  cE("headingRows", Math.min(e.headingRows, o), n, t, 0),
                e.headingColumns &&
                  cE("headingColumns", Math.min(e.headingColumns, i), n, t, 0),
                n
              );
            }
            insertRows(t, e = {}) {
              const n = this.editor.model,
                o = e.at || 0,
                i = e.rows || 1,
                r = void 0 !== e.copyStructureFromAbove,
                s = e.copyStructureFromAbove ? o - 1 : o,
                a = this.getRows(t),
                c = this.getColumns(t);
              if (o > a)
                throw new l("tableutils-insertrows-insert-out-of-range", this, {
                  options: e,
                });
              n.change((e) => {
                const n = t.getAttribute("headingRows") || 0;
                if (
                  (n > o && cE("headingRows", n + i, t, e, 0),
                  !r && (0 === o || o === a))
                )
                  return void WE(e, t, o, i, c);
                const l = r ? Math.max(o, s) : o,
                  d = new fE(t, { endRow: l }),
                  u = new Array(c).fill(1);
                for (const {
                  row: t,
                  column: n,
                  cellHeight: a,
                  cellWidth: l,
                  cell: c,
                } of d) {
                  const d = t + a - 1,
                    h = t <= s && s <= d;
                  t < o && o <= d
                    ? (e.setAttribute("rowspan", a + i, c), (u[n] = -l))
                    : r && h && (u[n] = l);
                }
                for (let n = 0; n < i; n++) {
                  const n = e.createElement("tableRow");
                  e.insert(n, t, o);
                  for (let t = 0; t < u.length; t++) {
                    const o = u[t],
                      i = e.createPositionAt(n, "end");
                    o > 0 && dE(e, i, o > 1 ? { colspan: o } : null),
                      (t += Math.abs(o) - 1);
                  }
                }
              });
            }
            insertColumns(t, e = {}) {
              const n = this.editor.model,
                o = e.at || 0,
                i = e.columns || 1;
              n.change((e) => {
                const n = t.getAttribute("headingColumns");
                o < n && e.setAttribute("headingColumns", n + i, t);
                const r = this.getColumns(t);
                if (0 === o || r === o) {
                  for (const n of t.getChildren())
                    n.is("element", "tableRow") &&
                      $E(i, e, e.createPositionAt(n, o ? "end" : 0));
                  return;
                }
                const s = new fE(t, { column: o, includeAllSlots: !0 });
                for (const t of s) {
                  const {
                    row: n,
                    cell: r,
                    cellAnchorColumn: a,
                    cellAnchorRow: l,
                    cellWidth: c,
                    cellHeight: d,
                  } = t;
                  if (a < o) {
                    e.setAttribute("colspan", c + i, r);
                    const t = l + d - 1;
                    for (let e = n; e <= t; e++) s.skipRow(e);
                  } else $E(i, e, t.getPositionBefore());
                }
              });
            }
            removeRows(t, e) {
              const n = this.editor.model,
                o = e.rows || 1,
                i = this.getRows(t),
                r = e.at,
                s = r + o - 1;
              if (s > i - 1)
                throw new l(
                  "tableutils-removerows-row-index-out-of-range",
                  this,
                  { table: t, options: e }
                );
              n.change((e) => {
                const { cellsToMove: n, cellsToTrim: o } = (function (t, e, n) {
                  const o = new Map(),
                    i = [];
                  for (const {
                    row: r,
                    column: s,
                    cellHeight: a,
                    cell: l,
                  } of new fE(t, { endRow: n })) {
                    const t = r + a - 1;
                    if (r >= e && r <= n && t > n) {
                      const t = a - (n - r + 1);
                      o.set(s, { cell: l, rowspan: t });
                    }
                    if (r < e && t >= e) {
                      let o;
                      (o = t >= n ? n - e + 1 : t - e + 1),
                        i.push({ cell: l, rowspan: a - o });
                    }
                  }
                  return { cellsToMove: o, cellsToTrim: i };
                })(t, r, s);
                if (n.size) {
                  !(function (t, e, n, o) {
                    const i = [...new fE(t, { includeAllSlots: !0, row: e })],
                      r = t.getChild(e);
                    let s;
                    for (const { column: t, cell: e, isAnchor: a } of i)
                      if (n.has(t)) {
                        const { cell: e, rowspan: i } = n.get(t),
                          a = s
                            ? o.createPositionAfter(s)
                            : o.createPositionAt(r, 0);
                        o.move(o.createRangeOn(e), a),
                          cE("rowspan", i, e, o),
                          (s = e);
                      } else a && (s = e);
                  })(t, s + 1, n, e);
                }
                for (let n = s; n >= r; n--) e.remove(t.getChild(n));
                for (const { rowspan: t, cell: n } of o) cE("rowspan", t, n, e);
                !(function (t, e, n, o) {
                  const i = t.getAttribute("headingRows") || 0;
                  if (e < i) {
                    cE("headingRows", n < i ? i - (n - e + 1) : e, t, o, 0);
                  }
                })(t, r, s, e),
                  BE(t, this) || NE(t, this);
              });
            }
            removeColumns(t, e) {
              const n = this.editor.model,
                o = e.at,
                i = e.columns || 1,
                r = e.at + i - 1;
              n.change((e) => {
                !(function (t, e, n) {
                  const o = t.getAttribute("headingColumns") || 0;
                  if (o && e.first < o) {
                    const i = Math.min(o - 1, e.last) - e.first + 1;
                    n.setAttribute("headingColumns", o - i, t);
                  }
                })(t, { first: o, last: r }, e);
                for (let n = r; n >= o; n--)
                  for (const { cell: o, column: i, cellWidth: r } of [
                    ...new fE(t),
                  ])
                    i <= n && r > 1 && i + r > n
                      ? cE("colspan", r - 1, o, e)
                      : i === n && e.remove(o);
                NE(t, this) || BE(t, this);
              });
            }
            splitCellVertically(t, e = 2) {
              const n = this.editor.model,
                o = t.parent.parent,
                i = parseInt(t.getAttribute("rowspan") || 1),
                r = parseInt(t.getAttribute("colspan") || 1);
              n.change((n) => {
                if (r > 1) {
                  const { newCellsSpan: o, updatedSpan: s } = qE(r, e);
                  cE("colspan", s, t, n);
                  const a = {};
                  o > 1 && (a.colspan = o), i > 1 && (a.rowspan = i);
                  $E(r > e ? e - 1 : r - 1, n, n.createPositionAfter(t), a);
                }
                if (r < e) {
                  const s = e - r,
                    a = [...new fE(o)],
                    { column: l } = a.find(({ cell: e }) => e === t),
                    c = a.filter(
                      ({ cell: e, cellWidth: n, column: o }) =>
                        (e !== t && o === l) || (o < l && o + n > l)
                    );
                  for (const { cell: t, cellWidth: e } of c)
                    n.setAttribute("colspan", e + s, t);
                  const d = {};
                  i > 1 && (d.rowspan = i),
                    $E(s, n, n.createPositionAfter(t), d);
                  const u = o.getAttribute("headingColumns") || 0;
                  u > l && cE("headingColumns", u + s, o, n);
                }
              });
            }
            splitCellHorizontally(t, e = 2) {
              const n = this.editor.model,
                o = t.parent,
                i = o.parent,
                r = i.getChildIndex(o),
                s = parseInt(t.getAttribute("rowspan") || 1),
                a = parseInt(t.getAttribute("colspan") || 1);
              n.change((n) => {
                if (s > 1) {
                  const o = [
                      ...new fE(i, {
                        startRow: r,
                        endRow: r + s - 1,
                        includeAllSlots: !0,
                      }),
                    ],
                    { newCellsSpan: l, updatedSpan: c } = qE(s, e);
                  cE("rowspan", c, t, n);
                  const { column: d } = o.find(({ cell: e }) => e === t),
                    u = {};
                  l > 1 && (u.rowspan = l), a > 1 && (u.colspan = a);
                  for (const t of o) {
                    const { column: e, row: o } = t,
                      i = e === d,
                      s = (o + r + c) % l == 0;
                    o >= r + c && i && s && $E(1, n, t.getPositionBefore(), u);
                  }
                }
                if (s < e) {
                  const o = e - s,
                    l = [...new fE(i, { startRow: 0, endRow: r })];
                  for (const { cell: e, cellHeight: i, row: s } of l)
                    if (e !== t && s + i > r) {
                      const t = i + o;
                      n.setAttribute("rowspan", t, e);
                    }
                  const c = {};
                  a > 1 && (c.colspan = a), WE(n, i, r + 1, o, 1, c);
                  const d = i.getAttribute("headingRows") || 0;
                  d > r && cE("headingRows", d + o, i, n);
                }
              });
            }
            getColumns(t) {
              return [...t.getChild(0).getChildren()].reduce(
                (t, e) => t + parseInt(e.getAttribute("colspan") || 1),
                0
              );
            }
            getRows(t) {
              return Array.from(t.getChildren()).reduce(
                (t, e) => (e.is("element", "tableRow") ? t + 1 : t),
                0
              );
            }
            createTableWalker(t, e = {}) {
              return new fE(t, e);
            }
            getSelectedTableCells(t) {
              const e = [];
              for (const n of this.sortRanges(t.getRanges())) {
                const t = n.getContainedElement();
                t && t.is("element", "tableCell") && e.push(t);
              }
              return e;
            }
            getTableCellsContainingSelection(t) {
              const e = [];
              for (const n of t.getRanges()) {
                const t = n.start.findAncestor("tableCell");
                t && e.push(t);
              }
              return e;
            }
            getSelectionAffectedTableCells(t) {
              const e = this.getSelectedTableCells(t);
              return e.length ? e : this.getTableCellsContainingSelection(t);
            }
            getRowIndexes(t) {
              const e = t.map((t) => t.parent.index);
              return this._getFirstLastIndexesObject(e);
            }
            getColumnIndexes(t) {
              const e = t[0].findAncestor("table"),
                n = [...new fE(e)]
                  .filter((e) => t.includes(e.cell))
                  .map((t) => t.column);
              return this._getFirstLastIndexesObject(n);
            }
            isSelectionRectangular(t) {
              if (t.length < 2 || !this._areCellInTheSameTableSection(t))
                return !1;
              const e = new Set(),
                n = new Set();
              let o = 0;
              for (const i of t) {
                const { row: t, column: r } = this.getCellLocation(i),
                  s = parseInt(i.getAttribute("rowspan") || 1),
                  a = parseInt(i.getAttribute("colspan") || 1);
                e.add(t),
                  n.add(r),
                  s > 1 && e.add(t + s - 1),
                  a > 1 && n.add(r + a - 1),
                  (o += s * a);
              }
              const i = (function (t, e) {
                const n = Array.from(t.values()),
                  o = Array.from(e.values()),
                  i = Math.max(...n),
                  r = Math.min(...n),
                  s = Math.max(...o),
                  a = Math.min(...o);
                return (i - r + 1) * (s - a + 1);
              })(e, n);
              return i == o;
            }
            sortRanges(t) {
              return Array.from(t).sort(GE);
            }
            _getFirstLastIndexesObject(t) {
              const e = t.sort((t, e) => t - e);
              return { first: e[0], last: e[e.length - 1] };
            }
            _areCellInTheSameTableSection(t) {
              const e = t[0].findAncestor("table"),
                n = this.getRowIndexes(t),
                o = parseInt(e.getAttribute("headingRows") || 0);
              if (!this._areIndexesInSameSection(n, o)) return !1;
              const i = parseInt(e.getAttribute("headingColumns") || 0),
                r = this.getColumnIndexes(t);
              return this._areIndexesInSameSection(r, i);
            }
            _areIndexesInSameSection({ first: t, last: e }, n) {
              return t < n === e < n;
            }
          }
          function WE(t, e, n, o, i, r = {}) {
            for (let s = 0; s < o; s++) {
              const o = t.createElement("tableRow");
              t.insert(o, e, n), $E(i, t, t.createPositionAt(o, "end"), r);
            }
          }
          function $E(t, e, n, o = {}) {
            for (let i = 0; i < t; i++) dE(e, n, o);
          }
          function qE(t, e) {
            if (t < e) return { newCellsSpan: 1, updatedSpan: 1 };
            const n = Math.floor(t / e);
            return { newCellsSpan: n, updatedSpan: t - n * e + n };
          }
          function GE(t, e) {
            const n = t.start,
              o = e.start;
            return n.isBefore(o) ? -1 : 1;
          }
          class ZE extends F {
            refresh() {
              const t = this.editor.plugins.get(UE),
                e = t.getSelectedTableCells(
                  this.editor.model.document.selection
                );
              this.isEnabled = t.isSelectionRectangular(
                e,
                this.editor.plugins.get(UE)
              );
            }
            execute() {
              const t = this.editor.model,
                e = this.editor.plugins.get(UE);
              t.change((n) => {
                const o = e.getSelectedTableCells(t.document.selection),
                  i = o.shift(),
                  { mergeWidth: r, mergeHeight: s } = (function (t, e, n) {
                    let o = 0,
                      i = 0;
                    for (const t of e) {
                      const { row: e, column: r } = n.getCellLocation(t);
                      (o = QE(t, r, o, "colspan")),
                        (i = QE(t, e, i, "rowspan"));
                    }
                    const { row: r, column: s } = n.getCellLocation(t);
                    return { mergeWidth: o - s, mergeHeight: i - r };
                  })(i, o, e);
                cE("colspan", r, i, n), cE("rowspan", s, i, n);
                for (const t of o) YE(t, i, n);
                zE(i.findAncestor("table"), e), n.setSelection(i, "in");
              });
            }
          }
          function YE(t, e, n) {
            KE(t) ||
              (KE(e) && n.remove(n.createRangeIn(e)),
              n.move(n.createRangeIn(t), n.createPositionAt(e, "end"))),
              n.remove(t);
          }
          function KE(t) {
            return (
              1 == t.childCount &&
              t.getChild(0).is("element", "paragraph") &&
              t.getChild(0).isEmpty
            );
          }
          function QE(t, e, n, o) {
            const i = parseInt(t.getAttribute(o) || 1);
            return Math.max(n, e + i);
          }
          class JE extends F {
            constructor(t) {
              super(t), (this.affectsData = !1);
            }
            refresh() {
              const t = this.editor.plugins
                .get("TableUtils")
                .getSelectionAffectedTableCells(
                  this.editor.model.document.selection
                );
              this.isEnabled = t.length > 0;
            }
            execute() {
              const t = this.editor.model,
                e = this.editor.plugins.get("TableUtils"),
                n = e.getSelectionAffectedTableCells(t.document.selection),
                o = e.getRowIndexes(n),
                i = n[0].findAncestor("table"),
                r = [];
              for (let e = o.first; e <= o.last; e++)
                for (const n of i.getChild(e).getChildren())
                  r.push(t.createRangeOn(n));
              t.change((t) => {
                t.setSelection(r);
              });
            }
          }
          class XE extends F {
            constructor(t) {
              super(t), (this.affectsData = !1);
            }
            refresh() {
              const t = this.editor.plugins
                .get("TableUtils")
                .getSelectionAffectedTableCells(
                  this.editor.model.document.selection
                );
              this.isEnabled = t.length > 0;
            }
            execute() {
              const t = this.editor.plugins.get("TableUtils"),
                e = this.editor.model,
                n = t.getSelectionAffectedTableCells(e.document.selection),
                o = n[0],
                i = n.pop(),
                r = o.findAncestor("table"),
                s = t.getCellLocation(o),
                a = t.getCellLocation(i),
                l = Math.min(s.column, a.column),
                c = Math.max(s.column, a.column),
                d = [];
              for (const t of new fE(r, { startColumn: l, endColumn: c }))
                d.push(e.createRangeOn(t.cell));
              e.change((t) => {
                t.setSelection(d);
              });
            }
          }
          function tD(t) {
            t.document.registerPostFixer((e) =>
              (function (t, e) {
                const n = e.document.differ.getChanges();
                let o = !1;
                const i = new Set();
                for (const e of n) {
                  let n;
                  "table" == e.name &&
                    "insert" == e.type &&
                    (n = e.position.nodeAfter),
                    ("tableRow" != e.name && "tableCell" != e.name) ||
                      (n = e.position.findAncestor("table")),
                    oD(e) && (n = e.range.start.findAncestor("table")),
                    n &&
                      !i.has(n) &&
                      ((o = eD(n, t) || o), (o = nD(n, t) || o), i.add(n));
                }
                return o;
              })(e, t)
            );
          }
          function eD(t, e) {
            let n = !1;
            const o = (function (t) {
              const e = parseInt(t.getAttribute("headingRows") || 0),
                n = Array.from(t.getChildren()).reduce(
                  (t, e) => (e.is("element", "tableRow") ? t + 1 : t),
                  0
                ),
                o = [];
              for (const { row: i, cell: r, cellHeight: s } of new fE(t)) {
                if (s < 2) continue;
                const t = i < e ? e : n;
                if (i + s > t) {
                  const e = t - i;
                  o.push({ cell: r, rowspan: e });
                }
              }
              return o;
            })(t);
            if (o.length) {
              n = !0;
              for (const t of o) cE("rowspan", t.rowspan, t.cell, e, 1);
            }
            return n;
          }
          function nD(t, e) {
            let n = !1;
            const o = (function (t) {
                const e = new Array(t.childCount).fill(0);
                for (const { rowIndex: n } of new fE(t, {
                  includeAllSlots: !0,
                }))
                  e[n]++;
                return e;
              })(t),
              i = [];
            for (const [e, n] of o.entries())
              !n && t.getChild(e).is("element", "tableRow") && i.push(e);
            if (i.length) {
              n = !0;
              for (const n of i.reverse())
                e.remove(t.getChild(n)), o.splice(n, 1);
            }
            const r = o.filter((e, n) =>
                t.getChild(n).is("element", "tableRow")
              ),
              s = r[0];
            if (!r.every((t) => t === s)) {
              const o = r.reduce((t, e) => (e > t ? e : t), 0);
              for (const [i, s] of r.entries()) {
                const r = o - s;
                if (r) {
                  for (let n = 0; n < r; n++)
                    dE(e, e.createPositionAt(t.getChild(i), "end"));
                  n = !0;
                }
              }
            }
            return n;
          }
          function oD(t) {
            const e = "attribute" === t.type,
              n = t.attributeKey;
            return (
              e && ("headingRows" === n || "colspan" === n || "rowspan" === n)
            );
          }
          function iD(t) {
            t.document.registerPostFixer((e) =>
              (function (t, e) {
                const n = e.document.differ.getChanges();
                let o = !1;
                for (const e of n)
                  "insert" == e.type &&
                    "table" == e.name &&
                    (o = rD(e.position.nodeAfter, t) || o),
                    "insert" == e.type &&
                      "tableRow" == e.name &&
                      (o = sD(e.position.nodeAfter, t) || o),
                    "insert" == e.type &&
                      "tableCell" == e.name &&
                      (o = aD(e.position.nodeAfter, t) || o),
                    lD(e) && (o = aD(e.position.parent, t) || o);
                return o;
              })(e, t)
            );
          }
          function rD(t, e) {
            let n = !1;
            for (const o of t.getChildren())
              o.is("element", "tableRow") && (n = sD(o, e) || n);
            return n;
          }
          function sD(t, e) {
            let n = !1;
            for (const o of t.getChildren()) n = aD(o, e) || n;
            return n;
          }
          function aD(t, e) {
            if (0 == t.childCount) return e.insertElement("paragraph", t), !0;
            const n = Array.from(t.getChildren()).filter((t) => t.is("$text"));
            for (const t of n) e.wrap(e.createRangeOn(t), "paragraph");
            return !!n.length;
          }
          function lD(t) {
            return (
              !(!t.position || !t.position.parent.is("element", "tableCell")) &&
              (("insert" == t.type && "$text" == t.name) || "remove" == t.type)
            );
          }
          function cD(t, e) {
            if (!t.is("element", "paragraph")) return !1;
            const n = e.toViewElement(t);
            return !!n && _E(t) !== n.is("element", "span");
          }
          var dD = n(4777),
            uD = { attributes: { "data-cke": !0 } };
          (uD.setAttributes = is()),
            (uD.insert = ns().bind(null, "head")),
            (uD.domAPI = ts()),
            (uD.insertStyleElement = ss());
          Jr()(dD.Z, uD);
          dD.Z && dD.Z.locals && dD.Z.locals;
          class hD extends j {
            static get pluginName() {
              return "TableEditing";
            }
            static get requires() {
              return [UE];
            }
            init() {
              const t = this.editor,
                e = t.model,
                n = e.schema,
                o = t.conversion,
                i = t.plugins.get(UE);
              n.register("table", {
                inheritAllFrom: "$blockObject",
                allowAttributes: ["headingRows", "headingColumns"],
              }),
                n.register("tableRow", { allowIn: "table", isLimit: !0 }),
                n.register("tableCell", {
                  allowContentOf: "$container",
                  allowIn: "tableRow",
                  allowAttributes: ["colspan", "rowspan"],
                  isLimit: !0,
                  isSelectable: !0,
                }),
                o.for("upcast").add((t) => {
                  t.on("element:figure", (t, e, n) => {
                    if (
                      !n.consumable.test(e.viewItem, {
                        name: !0,
                        classes: "table",
                      })
                    )
                      return;
                    const o = (function (t) {
                      for (const e of t.getChildren())
                        if (e.is("element", "table")) return e;
                    })(e.viewItem);
                    if (!o || !n.consumable.test(o, { name: !0 })) return;
                    n.consumable.consume(e.viewItem, {
                      name: !0,
                      classes: "table",
                    });
                    const i = Ra(
                      n.convertItem(o, e.modelCursor).modelRange.getItems()
                    );
                    i
                      ? (n.convertChildren(
                          e.viewItem,
                          n.writer.createPositionAt(i, "end")
                        ),
                        n.updateConversionResult(i, e))
                      : n.consumable.revert(e.viewItem, {
                          name: !0,
                          classes: "table",
                        });
                  });
                }),
                o.for("upcast").add(mE()),
                o
                  .for("editingDowncast")
                  .elementToStructure({
                    model: { name: "table", attributes: ["headingRows"] },
                    view: bE(i, { asWidget: !0 }),
                  }),
                o
                  .for("dataDowncast")
                  .elementToStructure({
                    model: { name: "table", attributes: ["headingRows"] },
                    view: bE(i),
                  }),
                o
                  .for("upcast")
                  .elementToElement({ model: "tableRow", view: "tr" }),
                o.for("upcast").add((t) => {
                  t.on(
                    "element:tr",
                    (t, e) => {
                      e.viewItem.isEmpty &&
                        0 == e.modelCursor.index &&
                        t.stop();
                    },
                    { priority: "high" }
                  );
                }),
                o
                  .for("downcast")
                  .elementToElement({
                    model: "tableRow",
                    view: (t, { writer: e }) =>
                      t.isEmpty
                        ? e.createEmptyElement("tr")
                        : e.createContainerElement("tr"),
                  }),
                o
                  .for("upcast")
                  .elementToElement({ model: "tableCell", view: "td" }),
                o
                  .for("upcast")
                  .elementToElement({ model: "tableCell", view: "th" }),
                o.for("upcast").add(gE("td")),
                o.for("upcast").add(gE("th")),
                o
                  .for("editingDowncast")
                  .elementToElement({
                    model: "tableCell",
                    view: wE({ asWidget: !0 }),
                  }),
                o
                  .for("dataDowncast")
                  .elementToElement({ model: "tableCell", view: wE() }),
                o
                  .for("editingDowncast")
                  .elementToElement({
                    model: "paragraph",
                    view: AE({ asWidget: !0 }),
                    converterPriority: "high",
                  }),
                o
                  .for("dataDowncast")
                  .elementToElement({
                    model: "paragraph",
                    view: AE(),
                    converterPriority: "high",
                  }),
                o
                  .for("downcast")
                  .attributeToAttribute({ model: "colspan", view: "colspan" }),
                o
                  .for("upcast")
                  .attributeToAttribute({
                    model: { key: "colspan", value: mD("colspan") },
                    view: "colspan",
                  }),
                o
                  .for("downcast")
                  .attributeToAttribute({ model: "rowspan", view: "rowspan" }),
                o
                  .for("upcast")
                  .attributeToAttribute({
                    model: { key: "rowspan", value: mD("rowspan") },
                    view: "rowspan",
                  }),
                t.data.mapper.on("modelToViewPosition", (t, e) => {
                  const n = e.modelPosition.parent,
                    o = e.modelPosition.nodeBefore;
                  if (!n.is("element", "tableCell")) return;
                  if (!o || !o.is("element", "paragraph")) return;
                  const i = e.mapper.toViewElement(o),
                    r = e.mapper.toViewElement(n);
                  i === r &&
                    (e.viewPosition = e.mapper.findPositionIn(r, o.maxOffset));
                }),
                t.config.define("table.defaultHeadings.rows", 0),
                t.config.define("table.defaultHeadings.columns", 0),
                t.commands.add("insertTable", new CE(t)),
                t.commands.add(
                  "insertTableRowAbove",
                  new vE(t, { order: "above" })
                ),
                t.commands.add(
                  "insertTableRowBelow",
                  new vE(t, { order: "below" })
                ),
                t.commands.add(
                  "insertTableColumnLeft",
                  new yE(t, { order: "left" })
                ),
                t.commands.add(
                  "insertTableColumnRight",
                  new yE(t, { order: "right" })
                ),
                t.commands.add("removeTableRow", new jE(t)),
                t.commands.add("removeTableColumn", new VE(t)),
                t.commands.add(
                  "splitTableCellVertically",
                  new xE(t, { direction: "vertically" })
                ),
                t.commands.add(
                  "splitTableCellHorizontally",
                  new xE(t, { direction: "horizontally" })
                ),
                t.commands.add("mergeTableCells", new ZE(t)),
                t.commands.add(
                  "mergeTableCellRight",
                  new RE(t, { direction: "right" })
                ),
                t.commands.add(
                  "mergeTableCellLeft",
                  new RE(t, { direction: "left" })
                ),
                t.commands.add(
                  "mergeTableCellDown",
                  new RE(t, { direction: "down" })
                ),
                t.commands.add(
                  "mergeTableCellUp",
                  new RE(t, { direction: "up" })
                ),
                t.commands.add("setTableColumnHeader", new HE(t)),
                t.commands.add("setTableRowHeader", new FE(t)),
                t.commands.add("selectTableRow", new JE(t)),
                t.commands.add("selectTableColumn", new XE(t)),
                tD(e),
                iD(e),
                this.listenTo(e.document, "change:data", () => {
                  !(function (t, e) {
                    const n = t.document.differ;
                    for (const t of n.getChanges()) {
                      let n,
                        o = !1;
                      if ("attribute" == t.type) {
                        const e = t.range.start.nodeAfter;
                        if (!e || !e.is("element", "table")) continue;
                        if (
                          "headingRows" != t.attributeKey &&
                          "headingColumns" != t.attributeKey
                        )
                          continue;
                        (n = e), (o = "headingRows" == t.attributeKey);
                      } else
                        ("tableRow" != t.name && "tableCell" != t.name) ||
                          ((n = t.position.findAncestor("table")),
                          (o = "tableRow" == t.name));
                      if (!n) continue;
                      const i = n.getAttribute("headingRows") || 0,
                        r = n.getAttribute("headingColumns") || 0,
                        s = new fE(n);
                      for (const t of s) {
                        const n = t.row < i || t.column < r ? "th" : "td",
                          s = e.mapper.toViewElement(t.cell);
                        s &&
                          s.is("element") &&
                          s.name != n &&
                          e.reconvertItem(o ? t.cell.parent : t.cell);
                      }
                    }
                  })(e, t.editing),
                    (function (t, e) {
                      const n = t.document.differ,
                        o = new Set();
                      for (const t of n.getChanges()) {
                        const e =
                          "attribute" == t.type
                            ? t.range.start.parent
                            : t.position.parent;
                        e.is("element", "tableCell") && o.add(e);
                      }
                      for (const t of o.values()) {
                        const n = Array.from(t.getChildren()).filter((t) =>
                          cD(t, e.mapper)
                        );
                        for (const t of n) e.reconvertItem(t);
                      }
                    })(e, t.editing);
                });
            }
          }
          function mD(t) {
            return (e) => {
              const n = parseInt(e.getAttribute(t));
              return Number.isNaN(n) || n <= 0 ? null : n;
            };
          }
          var gD = n(8085),
            pD = { attributes: { "data-cke": !0 } };
          (pD.setAttributes = is()),
            (pD.insert = ns().bind(null, "head")),
            (pD.domAPI = ts()),
            (pD.insertStyleElement = ss());
          Jr()(gD.Z, pD);
          gD.Z && gD.Z.locals && gD.Z.locals;
          class fD extends Ch {
            constructor(t) {
              super(t);
              const e = this.bindTemplate;
              (this.items = this._createGridCollection()),
                (this.keystrokes = new ja()),
                (this.focusTracker = new Oa()),
                this.set("rows", 0),
                this.set("columns", 0),
                this.bind("label").to(
                  this,
                  "columns",
                  this,
                  "rows",
                  (t, e) => `${e} × ${t}`
                ),
                this.setTemplate({
                  tag: "div",
                  attributes: { class: ["ck"] },
                  children: [
                    {
                      tag: "div",
                      attributes: { class: ["ck-insert-table-dropdown__grid"] },
                      on: {
                        "mouseover@.ck-insert-table-dropdown-grid-box":
                          e.to("boxover"),
                      },
                      children: this.items,
                    },
                    {
                      tag: "div",
                      attributes: {
                        class: ["ck", "ck-insert-table-dropdown__label"],
                        "aria-hidden": !0,
                      },
                      children: [{ text: e.to("label") }],
                    },
                  ],
                  on: {
                    mousedown: e.to((t) => {
                      t.preventDefault();
                    }),
                    click: e.to(() => {
                      this.fire("execute");
                    }),
                  },
                }),
                this.on("boxover", (t, e) => {
                  const { row: n, column: o } = e.target.dataset;
                  this.items
                    .get(10 * (parseInt(n, 10) - 1) + (parseInt(o, 10) - 1))
                    .focus();
                }),
                this.focusTracker.on("change:focusedElement", (t, e, n) => {
                  if (!n) return;
                  const { row: o, column: i } = n.dataset;
                  this.set({ rows: parseInt(o), columns: parseInt(i) });
                }),
                this.on("change:columns", () => this._highlightGridBoxes()),
                this.on("change:rows", () => this._highlightGridBoxes());
            }
            render() {
              super.render(),
                Yh({
                  keystrokeHandler: this.keystrokes,
                  focusTracker: this.focusTracker,
                  gridItems: this.items,
                  numberOfColumns: 10,
                });
              for (const t of this.items) this.focusTracker.add(t.element);
              this.keystrokes.listenTo(this.element);
            }
            focus() {
              this.items.get(0).focus();
            }
            focusLast() {
              this.items.get(0).focus();
            }
            _highlightGridBoxes() {
              const t = this.rows,
                e = this.columns;
              this.items.map((n, o) => {
                const i = Math.floor(o / 10) < t && o % 10 < e;
                n.set("isOn", i);
              });
            }
            _createGridButton(t, e, n, o) {
              const i = new nm(t);
              return (
                i.set({ label: o, class: "ck-insert-table-dropdown-grid-box" }),
                i.extendTemplate({
                  attributes: { "data-row": e, "data-column": n },
                }),
                i
              );
            }
            _createGridCollection() {
              const t = [];
              for (let e = 0; e < 100; e++) {
                const n = Math.floor(e / 10),
                  o = e % 10,
                  i = `${n + 1} × ${o + 1}`;
                t.push(this._createGridButton(this.locale, n + 1, o + 1, i));
              }
              return this.createCollection(t);
            }
          }
          class kD extends j {
            static get pluginName() {
              return "TableUI";
            }
            init() {
              const t = this.editor,
                e = this.editor.t,
                n = "ltr" === t.locale.contentLanguageDirection;
              t.ui.componentFactory.add("insertTable", (n) => {
                const o = t.commands.get("insertTable"),
                  i = Wm(n);
                let r;
                return (
                  i.bind("isEnabled").to(o),
                  i.buttonView.set({
                    icon: '<svg viewBox="0 0 20 20" xmlns="http://www.w3.org/2000/svg"><path d="M3 6v3h4V6H3zm0 4v3h4v-3H3zm0 4v3h4v-3H3zm5 3h4v-3H8v3zm5 0h4v-3h-4v3zm4-4v-3h-4v3h4zm0-4V6h-4v3h4zm1.5 8a1.5 1.5 0 0 1-1.5 1.5H3A1.5 1.5 0 0 1 1.5 17V4c.222-.863 1.068-1.5 2-1.5h13c.932 0 1.778.637 2 1.5v13zM12 13v-3H8v3h4zm0-4V6H8v3h4z"/></svg>',
                    label: e("Insert table"),
                    tooltip: !0,
                  }),
                  i.on("change:isOpen", () => {
                    r ||
                      ((r = new fD(n)),
                      i.panelView.children.add(r),
                      r.delegate("execute").to(i),
                      i.on("execute", () => {
                        t.execute("insertTable", {
                          rows: r.rows,
                          columns: r.columns,
                        }),
                          t.editing.view.focus();
                      }));
                  }),
                  i
                );
              }),
                t.ui.componentFactory.add("tableColumn", (t) => {
                  const o = [
                    {
                      type: "switchbutton",
                      model: {
                        commandName: "setTableColumnHeader",
                        label: e("Header column"),
                        bindIsOn: !0,
                      },
                    },
                    { type: "separator" },
                    {
                      type: "button",
                      model: {
                        commandName: n
                          ? "insertTableColumnLeft"
                          : "insertTableColumnRight",
                        label: e("Insert column left"),
                      },
                    },
                    {
                      type: "button",
                      model: {
                        commandName: n
                          ? "insertTableColumnRight"
                          : "insertTableColumnLeft",
                        label: e("Insert column right"),
                      },
                    },
                    {
                      type: "button",
                      model: {
                        commandName: "removeTableColumn",
                        label: e("Delete column"),
                      },
                    },
                    {
                      type: "button",
                      model: {
                        commandName: "selectTableColumn",
                        label: e("Select column"),
                      },
                    },
                  ];
                  return this._prepareDropdown(
                    e("Column"),
                    '<svg viewBox="0 0 20 20" xmlns="http://www.w3.org/2000/svg"><path d="M2.5 1h15A1.5 1.5 0 0 1 19 2.5v15a1.5 1.5 0 0 1-1.5 1.5h-15A1.5 1.5 0 0 1 1 17.5v-15A1.5 1.5 0 0 1 2.5 1zM2 2v16h16V2H2z" opacity=".6"/><path d="M18 7v1H2V7h16zm0 5v1H2v-1h16z" opacity=".6"/><path d="M14 1v18a1 1 0 0 1-1 1H7a1 1 0 0 1-1-1V1a1 1 0 0 1 1-1h6a1 1 0 0 1 1 1zm-2 1H8v4h4V2zm0 6H8v4h4V8zm0 6H8v4h4v-4z"/></svg>',
                    o,
                    t
                  );
                }),
                t.ui.componentFactory.add("tableRow", (t) => {
                  const n = [
                    {
                      type: "switchbutton",
                      model: {
                        commandName: "setTableRowHeader",
                        label: e("Header row"),
                        bindIsOn: !0,
                      },
                    },
                    { type: "separator" },
                    {
                      type: "button",
                      model: {
                        commandName: "insertTableRowAbove",
                        label: e("Insert row above"),
                      },
                    },
                    {
                      type: "button",
                      model: {
                        commandName: "insertTableRowBelow",
                        label: e("Insert row below"),
                      },
                    },
                    {
                      type: "button",
                      model: {
                        commandName: "removeTableRow",
                        label: e("Delete row"),
                      },
                    },
                    {
                      type: "button",
                      model: {
                        commandName: "selectTableRow",
                        label: e("Select row"),
                      },
                    },
                  ];
                  return this._prepareDropdown(
                    e("Row"),
                    '<svg viewBox="0 0 20 20" xmlns="http://www.w3.org/2000/svg"><path d="M2.5 1h15A1.5 1.5 0 0 1 19 2.5v15a1.5 1.5 0 0 1-1.5 1.5h-15A1.5 1.5 0 0 1 1 17.5v-15A1.5 1.5 0 0 1 2.5 1zM2 2v16h16V2H2z" opacity=".6"/><path d="M7 2h1v16H7V2zm5 0h1v16h-1V2z" opacity=".6"/><path d="M1 6h18a1 1 0 0 1 1 1v6a1 1 0 0 1-1 1H1a1 1 0 0 1-1-1V7a1 1 0 0 1 1-1zm1 2v4h4V8H2zm6 0v4h4V8H8zm6 0v4h4V8h-4z"/></svg>',
                    n,
                    t
                  );
                }),
                t.ui.componentFactory.add("mergeTableCells", (t) => {
                  const o = [
                    {
                      type: "button",
                      model: {
                        commandName: "mergeTableCellUp",
                        label: e("Merge cell up"),
                      },
                    },
                    {
                      type: "button",
                      model: {
                        commandName: n
                          ? "mergeTableCellRight"
                          : "mergeTableCellLeft",
                        label: e("Merge cell right"),
                      },
                    },
                    {
                      type: "button",
                      model: {
                        commandName: "mergeTableCellDown",
                        label: e("Merge cell down"),
                      },
                    },
                    {
                      type: "button",
                      model: {
                        commandName: n
                          ? "mergeTableCellLeft"
                          : "mergeTableCellRight",
                        label: e("Merge cell left"),
                      },
                    },
                    { type: "separator" },
                    {
                      type: "button",
                      model: {
                        commandName: "splitTableCellVertically",
                        label: e("Split cell vertically"),
                      },
                    },
                    {
                      type: "button",
                      model: {
                        commandName: "splitTableCellHorizontally",
                        label: e("Split cell horizontally"),
                      },
                    },
                  ];
                  return this._prepareMergeSplitButtonDropdown(
                    e("Merge cells"),
                    '<svg viewBox="0 0 20 20" xmlns="http://www.w3.org/2000/svg"><path d="M2.5 1h15A1.5 1.5 0 0 1 19 2.5v15a1.5 1.5 0 0 1-1.5 1.5h-15A1.5 1.5 0 0 1 1 17.5v-15A1.5 1.5 0 0 1 2.5 1zM2 2v16h16V2H2z" opacity=".6"/><path d="M7 2h1v16H7V2zm5 0h1v7h-1V2zm6 5v1H2V7h16zM8 12v1H2v-1h6z" opacity=".6"/><path d="M7 7h12a1 1 0 0 1 1 1v11a1 1 0 0 1-1 1H7a1 1 0 0 1-1-1V8a1 1 0 0 1 1-1zm1 2v9h10V9H8z"/></svg>',
                    o,
                    t
                  );
                });
            }
            _prepareDropdown(t, e, n, o) {
              const i = this.editor,
                r = Wm(o),
                s = this._fillDropdownWithListOptions(r, n);
              return (
                r.buttonView.set({ label: t, icon: e, tooltip: !0 }),
                r
                  .bind("isEnabled")
                  .toMany(s, "isEnabled", (...t) => t.some((t) => t)),
                this.listenTo(r, "execute", (t) => {
                  i.execute(t.source.commandName),
                    t.source instanceof rm || i.editing.view.focus();
                }),
                r
              );
            }
            _prepareMergeSplitButtonDropdown(t, e, n, o) {
              const i = this.editor,
                r = Wm(o, km),
                s = "mergeTableCells",
                a = i.commands.get(s),
                l = this._fillDropdownWithListOptions(r, n);
              return (
                r.buttonView.set({
                  label: t,
                  icon: e,
                  tooltip: !0,
                  isEnabled: !0,
                }),
                r
                  .bind("isEnabled")
                  .toMany([a, ...l], "isEnabled", (...t) => t.some((t) => t)),
                this.listenTo(r.buttonView, "execute", () => {
                  i.execute(s), i.editing.view.focus();
                }),
                this.listenTo(r, "execute", (t) => {
                  i.execute(t.source.commandName), i.editing.view.focus();
                }),
                r
              );
            }
            _fillDropdownWithListOptions(t, e) {
              const n = this.editor,
                o = [],
                i = new po();
              for (const t of e) bD(t, n, o, i);
              return qm(t, i, n.ui.componentFactory), o;
            }
          }
          function bD(t, e, n, o) {
            const i = (t.model = new fg(t.model)),
              { commandName: r, bindIsOn: s } = t.model;
            if ("button" === t.type || "switchbutton" === t.type) {
              const t = e.commands.get(r);
              n.push(t),
                i.set({ commandName: r }),
                i.bind("isEnabled").to(t),
                s && i.bind("isOn").to(t, "value");
            }
            i.set({ withText: !0 }), o.add(t);
          }
          var wD = n(5593),
            AD = { attributes: { "data-cke": !0 } };
          (AD.setAttributes = is()),
            (AD.insert = ns().bind(null, "head")),
            (AD.domAPI = ts()),
            (AD.insertStyleElement = ss());
          Jr()(wD.Z, AD);
          wD.Z && wD.Z.locals && wD.Z.locals;
          class _D extends j {
            static get pluginName() {
              return "TableSelection";
            }
            static get requires() {
              return [UE, UE];
            }
            init() {
              const t = this.editor,
                e = t.model,
                n = t.editing.view;
              this.listenTo(
                e,
                "deleteContent",
                (t, e) => this._handleDeleteContent(t, e),
                { priority: "high" }
              ),
                this.listenTo(
                  n.document,
                  "insertText",
                  (t, e) => this._handleInsertTextEvent(t, e),
                  { priority: "high" }
                ),
                this._defineSelectionConverter(),
                this._enablePluginDisabling();
            }
            getSelectedTableCells() {
              const t = this.editor.plugins.get(UE),
                e = this.editor.model.document.selection,
                n = t.getSelectedTableCells(e);
              return 0 == n.length ? null : n;
            }
            getSelectionAsFragment() {
              const t = this.editor.plugins.get(UE),
                e = this.getSelectedTableCells();
              return e
                ? this.editor.model.change((n) => {
                    const o = n.createDocumentFragment(),
                      { first: i, last: r } = t.getColumnIndexes(e),
                      { first: s, last: a } = t.getRowIndexes(e),
                      l = e[0].findAncestor("table");
                    let c = a,
                      d = r;
                    if (t.isSelectionRectangular(e)) {
                      const t = {
                        firstColumn: i,
                        lastColumn: r,
                        firstRow: s,
                        lastRow: a,
                      };
                      (c = PE(l, t)), (d = LE(l, t));
                    }
                    const u = EE(
                      l,
                      { startRow: s, startColumn: i, endRow: c, endColumn: d },
                      n
                    );
                    return n.insert(u, o, 0), o;
                  })
                : null;
            }
            setCellSelection(t, e) {
              const n = this._getCellsToSelect(t, e);
              this.editor.model.change((t) => {
                t.setSelection(
                  n.cells.map((e) => t.createRangeOn(e)),
                  { backward: n.backward }
                );
              });
            }
            getFocusCell() {
              const t = [...this.editor.model.document.selection.getRanges()]
                .pop()
                .getContainedElement();
              return t && t.is("element", "tableCell") ? t : null;
            }
            getAnchorCell() {
              const t = Ra(
                this.editor.model.document.selection.getRanges()
              ).getContainedElement();
              return t && t.is("element", "tableCell") ? t : null;
            }
            _defineSelectionConverter() {
              const t = this.editor,
                e = new Set();
              t.conversion.for("editingDowncast").add((t) =>
                t.on(
                  "selection",
                  (t, n, o) => {
                    const i = o.writer;
                    !(function (t) {
                      for (const n of e)
                        t.removeClass("ck-editor__editable_selected", n);
                      e.clear();
                    })(i);
                    const r = this.getSelectedTableCells();
                    if (!r) return;
                    for (const t of r) {
                      const n = o.mapper.toViewElement(t);
                      i.addClass("ck-editor__editable_selected", n), e.add(n);
                    }
                    const s = o.mapper.toViewElement(r[r.length - 1]);
                    i.setSelection(s, 0);
                  },
                  { priority: "lowest" }
                )
              );
            }
            _enablePluginDisabling() {
              const t = this.editor;
              this.on("change:isEnabled", () => {
                if (!this.isEnabled) {
                  const e = this.getSelectedTableCells();
                  if (!e) return;
                  t.model.change((n) => {
                    const o = n.createPositionAt(e[0], 0),
                      i = t.model.schema.getNearestSelectionRange(o);
                    n.setSelection(i);
                  });
                }
              });
            }
            _handleDeleteContent(t, e) {
              const n = this.editor.plugins.get(UE),
                [o, i] = e,
                r = this.editor.model,
                s = !i || "backward" == i.direction,
                a = n.getSelectedTableCells(o);
              a.length &&
                (t.stop(),
                r.change((t) => {
                  const e = a[s ? a.length - 1 : 0];
                  r.change((t) => {
                    for (const e of a)
                      r.deleteContent(t.createSelection(e, "in"));
                  });
                  const n = r.schema.getNearestSelectionRange(
                    t.createPositionAt(e, 0)
                  );
                  o.is("documentSelection") ? t.setSelection(n) : o.setTo(n);
                }));
            }
            _handleInsertTextEvent(t, e) {
              const n = this.editor,
                o = n.model.document.selection,
                i = this.getSelectedTableCells(o);
              if (!i) return;
              const r = n.editing.view,
                s = n.editing.mapper,
                a = i.map((t) => r.createRangeOn(s.toViewElement(t)));
              e.selection = r.createSelection(a);
            }
            _getCellsToSelect(t, e) {
              const n = this.editor.plugins.get("TableUtils"),
                o = n.getCellLocation(t),
                i = n.getCellLocation(e),
                r = Math.min(o.row, i.row),
                s = Math.max(o.row, i.row),
                a = Math.min(o.column, i.column),
                l = Math.max(o.column, i.column),
                c = new Array(s - r + 1).fill(null).map(() => []),
                d = { startRow: r, endRow: s, startColumn: a, endColumn: l };
              for (const { row: e, cell: n } of new fE(
                t.findAncestor("table"),
                d
              ))
                c[e - r].push(n);
              const u = i.row < o.row,
                h = i.column < o.column;
              return (
                u && c.reverse(),
                h && c.forEach((t) => t.reverse()),
                { cells: c.flat(), backward: u || h }
              );
            }
          }
          class CD extends j {
            static get pluginName() {
              return "TableClipboard";
            }
            static get requires() {
              return [_D, UE];
            }
            init() {
              const t = this.editor,
                e = t.editing.view.document;
              this.listenTo(e, "copy", (t, e) => this._onCopyCut(t, e)),
                this.listenTo(e, "cut", (t, e) => this._onCopyCut(t, e)),
                this.listenTo(
                  t.model,
                  "insertContent",
                  (t, e) => this._onInsertContent(t, ...e),
                  { priority: "high" }
                ),
                this.decorate("_replaceTableSlotCell");
            }
            _onCopyCut(t, e) {
              const n = this.editor.plugins.get(_D);
              if (!n.getSelectedTableCells()) return;
              if ("cut" == t.name && this.editor.isReadOnly) return;
              e.preventDefault(), t.stop();
              const o = this.editor.data,
                i = this.editor.editing.view.document,
                r = o.toView(n.getSelectionAsFragment());
              i.fire("clipboardOutput", {
                dataTransfer: e.dataTransfer,
                content: r,
                method: t.name,
              });
            }
            _onInsertContent(t, e, n) {
              if (n && !n.is("documentSelection")) return;
              const o = this.editor.model,
                i = this.editor.plugins.get(UE);
              let r = vD(e, o);
              if (!r) return;
              const s = i.getSelectionAffectedTableCells(o.document.selection);
              s.length
                ? (t.stop(),
                  o.change((t) => {
                    const e = { width: i.getColumns(r), height: i.getRows(r) },
                      n = (function (t, e, n, o) {
                        const i = t[0].findAncestor("table"),
                          r = o.getColumnIndexes(t),
                          s = o.getRowIndexes(t),
                          a = {
                            firstColumn: r.first,
                            lastColumn: r.last,
                            firstRow: s.first,
                            lastRow: s.last,
                          },
                          l = 1 === t.length;
                        l &&
                          ((a.lastRow += e.height - 1),
                          (a.lastColumn += e.width - 1),
                          (function (t, e, n, o) {
                            const i = o.getColumns(t),
                              r = o.getRows(t);
                            n > i &&
                              o.insertColumns(t, { at: i, columns: n - i });
                            e > r && o.insertRows(t, { at: r, rows: e - r });
                          })(i, a.lastRow + 1, a.lastColumn + 1, o));
                        l || !o.isSelectionRectangular(t)
                          ? (function (t, e, n) {
                              const {
                                  firstRow: o,
                                  lastRow: i,
                                  firstColumn: r,
                                  lastColumn: s,
                                } = e,
                                a = { first: o, last: i },
                                l = { first: r, last: s };
                              xD(t, r, a, n),
                                xD(t, s + 1, a, n),
                                yD(t, o, l, n),
                                yD(t, i + 1, l, n, o);
                            })(i, a, n)
                          : ((a.lastRow = PE(i, a)), (a.lastColumn = LE(i, a)));
                        return a;
                      })(s, e, t, i),
                      o = n.lastRow - n.firstRow + 1,
                      a = n.lastColumn - n.firstColumn + 1,
                      l = {
                        startRow: 0,
                        startColumn: 0,
                        endRow: Math.min(o, e.height) - 1,
                        endColumn: Math.min(a, e.width) - 1,
                      };
                    r = EE(r, l, t);
                    const c = s[0].findAncestor("table"),
                      d = this._replaceSelectedCellsWithPasted(r, e, c, n, t);
                    if (this.editor.plugins.get("TableSelection").isEnabled) {
                      const e = i.sortRanges(d.map((e) => t.createRangeOn(e)));
                      t.setSelection(e);
                    } else t.setSelection(d[0], 0);
                  }))
                : zE(r, i);
            }
            _replaceSelectedCellsWithPasted(t, e, n, o, i) {
              const { width: r, height: s } = e,
                a = (function (t, e, n) {
                  const o = new Array(n)
                    .fill(null)
                    .map(() => new Array(e).fill(null));
                  for (const { column: e, row: n, cell: i } of new fE(t))
                    o[n][e] = i;
                  return o;
                })(t, r, s),
                l = [
                  ...new fE(n, {
                    startRow: o.firstRow,
                    endRow: o.lastRow,
                    startColumn: o.firstColumn,
                    endColumn: o.lastColumn,
                    includeAllSlots: !0,
                  }),
                ],
                c = [];
              let d;
              for (const t of l) {
                const { row: e, column: n } = t;
                n === o.firstColumn && (d = t.getPositionBefore());
                const l = e - o.firstRow,
                  u = n - o.firstColumn,
                  h = a[l % s][u % r],
                  m = h ? i.cloneElement(h) : null,
                  g = this._replaceTableSlotCell(t, m, d, i);
                g &&
                  (ME(g, e, n, o.lastRow, o.lastColumn, i),
                  c.push(g),
                  (d = i.createPositionAfter(g)));
              }
              const u = parseInt(n.getAttribute("headingRows") || 0),
                h = parseInt(n.getAttribute("headingColumns") || 0),
                m = o.firstRow < u && u <= o.lastRow,
                g = o.firstColumn < h && h <= o.lastColumn;
              if (m) {
                const t = yD(
                  n,
                  u,
                  { first: o.firstColumn, last: o.lastColumn },
                  i,
                  o.firstRow
                );
                c.push(...t);
              }
              if (g) {
                const t = xD(n, h, { first: o.firstRow, last: o.lastRow }, i);
                c.push(...t);
              }
              return c;
            }
            _replaceTableSlotCell(t, e, n, o) {
              const { cell: i, isAnchor: r } = t;
              return r && o.remove(i), e ? (o.insert(e, n), e) : null;
            }
            getTableIfOnlyTableInContent(t, e) {
              return vD(t, e);
            }
          }
          function vD(t, e) {
            if (!t.is("documentFragment") && !t.is("element")) return null;
            if (t.is("element", "table")) return t;
            if (1 == t.childCount && t.getChild(0).is("element", "table"))
              return t.getChild(0);
            const n = e.createRangeIn(t);
            for (const t of n.getItems())
              if (t.is("element", "table")) {
                const o = e.createRange(n.start, e.createPositionBefore(t));
                if (e.hasContent(o, { ignoreWhitespaces: !0 })) return null;
                const i = e.createRange(e.createPositionAfter(t), n.end);
                return e.hasContent(i, { ignoreWhitespaces: !0 }) ? null : t;
              }
            return null;
          }
          function yD(t, e, n, o, i = 0) {
            if (e < 1) return;
            return DE(t, e, i)
              .filter(({ column: t, cellWidth: e }) => ED(t, e, n))
              .map(({ cell: t }) => SE(t, e, o));
          }
          function xD(t, e, n, o) {
            if (e < 1) return;
            return IE(t, e)
              .filter(({ row: t, cellHeight: e }) => ED(t, e, n))
              .map(({ cell: t, column: n }) => TE(t, n, e, o));
          }
          function ED(t, e, n) {
            const o = t + e - 1,
              { first: i, last: r } = n;
            return (t >= i && t <= r) || (t < i && o >= i);
          }
          class DD extends j {
            static get pluginName() {
              return "TableKeyboard";
            }
            static get requires() {
              return [_D, UE];
            }
            init() {
              const t = this.editor.editing.view.document;
              this.listenTo(t, "arrowKey", (...t) => this._onArrowKey(...t), {
                context: "table",
              }),
                this.listenTo(
                  t,
                  "tab",
                  (...t) => this._handleTabOnSelectedTable(...t),
                  { context: "figure" }
                ),
                this.listenTo(t, "tab", (...t) => this._handleTab(...t), {
                  context: ["th", "td"],
                });
            }
            _handleTabOnSelectedTable(t, e) {
              const n = this.editor,
                o = n.model.document.selection.getSelectedElement();
              o &&
                o.is("element", "table") &&
                (e.preventDefault(),
                e.stopPropagation(),
                t.stop(),
                n.model.change((t) => {
                  t.setSelection(t.createRangeIn(o.getChild(0).getChild(0)));
                }));
            }
            _handleTab(t, e) {
              const n = this.editor,
                o = this.editor.plugins.get(UE),
                i = n.model.document.selection,
                r = !e.shiftKey;
              let s = o.getTableCellsContainingSelection(i)[0];
              if (
                (s ||
                  (s = this.editor.plugins
                    .get("TableSelection")
                    .getFocusCell()),
                !s)
              )
                return;
              e.preventDefault(), e.stopPropagation(), t.stop();
              const a = s.parent,
                l = a.parent,
                c = l.getChildIndex(a),
                d = a.getChildIndex(s),
                u = 0 === d;
              if (!r && u && 0 === c)
                return void n.model.change((t) => {
                  t.setSelection(t.createRangeOn(l));
                });
              const h = d === a.childCount - 1,
                m = c === o.getRows(l) - 1;
              if (
                r &&
                m &&
                h &&
                (n.execute("insertTableRowBelow"), c === o.getRows(l) - 1)
              )
                return void n.model.change((t) => {
                  t.setSelection(t.createRangeOn(l));
                });
              let g;
              if (r && h) {
                const t = l.getChild(c + 1);
                g = t.getChild(0);
              } else if (!r && u) {
                const t = l.getChild(c - 1);
                g = t.getChild(t.childCount - 1);
              } else g = a.getChild(d + (r ? 1 : -1));
              n.model.change((t) => {
                t.setSelection(t.createRangeIn(g));
              });
            }
            _onArrowKey(t, e) {
              const n = this.editor,
                o = fr(e.keyCode, n.locale.contentLanguageDirection);
              this._handleArrowKeys(o, e.shiftKey) &&
                (e.preventDefault(), e.stopPropagation(), t.stop());
            }
            _handleArrowKeys(t, e) {
              const n = this.editor.plugins.get(UE),
                o = this.editor.model,
                i = o.document.selection,
                r = ["right", "down"].includes(t),
                s = n.getSelectedTableCells(i);
              if (s.length) {
                let n;
                return (
                  (n = e
                    ? this.editor.plugins.get("TableSelection").getFocusCell()
                    : r
                    ? s[s.length - 1]
                    : s[0]),
                  this._navigateFromCellInDirection(n, t, e),
                  !0
                );
              }
              const a = i.focus.findAncestor("tableCell");
              if (!a) return !1;
              if (!i.isCollapsed)
                if (e) {
                  if (i.isBackward == r && !i.containsEntireContent(a))
                    return !1;
                } else {
                  const t = i.getSelectedElement();
                  if (!t || !o.schema.isObject(t)) return !1;
                }
              return (
                !!this._isSelectionAtCellEdge(i, a, r) &&
                (this._navigateFromCellInDirection(a, t, e), !0)
              );
            }
            _isSelectionAtCellEdge(t, e, n) {
              const o = this.editor.model,
                i = this.editor.model.schema,
                r = n ? t.getLastPosition() : t.getFirstPosition();
              if (!i.getLimitElement(r).is("element", "tableCell")) {
                return o.createPositionAt(e, n ? "end" : 0).isTouching(r);
              }
              const s = o.createSelection(r);
              return (
                o.modifySelection(s, { direction: n ? "forward" : "backward" }),
                r.isEqual(s.focus)
              );
            }
            _navigateFromCellInDirection(t, e, n = !1) {
              const o = this.editor.model,
                i = t.findAncestor("table"),
                r = [...new fE(i, { includeAllSlots: !0 })],
                { row: s, column: a } = r[r.length - 1],
                l = r.find(({ cell: e }) => e == t);
              let { row: c, column: d } = l;
              switch (e) {
                case "left":
                  d--;
                  break;
                case "up":
                  c--;
                  break;
                case "right":
                  d += l.cellWidth;
                  break;
                case "down":
                  c += l.cellHeight;
              }
              if (c < 0 || c > s || (d < 0 && c <= 0) || (d > a && c >= s))
                return void o.change((t) => {
                  t.setSelection(t.createRangeOn(i));
                });
              d < 0 ? ((d = n ? 0 : a), c--) : d > a && ((d = n ? a : 0), c++);
              const u = r.find((t) => t.row == c && t.column == d).cell,
                h = ["right", "down"].includes(e),
                m = this.editor.plugins.get("TableSelection");
              if (n && m.isEnabled) {
                const e = m.getAnchorCell() || t;
                m.setCellSelection(e, u);
              } else {
                const t = o.createPositionAt(u, h ? 0 : "end");
                o.change((e) => {
                  e.setSelection(t);
                });
              }
            }
          }
          class SD extends zs {
            constructor(t) {
              super(t), (this.domEventType = ["mousemove", "mouseleave"]);
            }
            onDomEvent(t) {
              this.fire(t.type, t);
            }
          }
          class ID extends j {
            static get pluginName() {
              return "TableMouse";
            }
            static get requires() {
              return [_D, UE];
            }
            init() {
              this.editor.editing.view.addObserver(SD),
                this._enableShiftClickSelection(),
                this._enableMouseDragSelection();
            }
            _enableShiftClickSelection() {
              const t = this.editor,
                e = t.plugins.get(UE);
              let n = !1;
              const o = t.plugins.get(_D);
              this.listenTo(t.editing.view.document, "mousedown", (i, r) => {
                const s = t.model.document.selection;
                if (!this.isEnabled || !o.isEnabled) return;
                if (!r.domEvent.shiftKey) return;
                const a =
                  o.getAnchorCell() || e.getTableCellsContainingSelection(s)[0];
                if (!a) return;
                const l = this._getModelTableCellFromDomEvent(r);
                l &&
                  TD(a, l) &&
                  ((n = !0), o.setCellSelection(a, l), r.preventDefault());
              }),
                this.listenTo(t.editing.view.document, "mouseup", () => {
                  n = !1;
                }),
                this.listenTo(
                  t.editing.view.document,
                  "selectionChange",
                  (t) => {
                    n && t.stop();
                  },
                  { priority: "highest" }
                );
            }
            _enableMouseDragSelection() {
              const t = this.editor;
              let e,
                n,
                o = !1,
                i = !1;
              const r = t.plugins.get(_D);
              this.listenTo(t.editing.view.document, "mousedown", (t, n) => {
                this.isEnabled &&
                  r.isEnabled &&
                  (n.domEvent.shiftKey ||
                    n.domEvent.ctrlKey ||
                    n.domEvent.altKey ||
                    (e = this._getModelTableCellFromDomEvent(n)));
              }),
                this.listenTo(t.editing.view.document, "mousemove", (t, s) => {
                  if (!s.domEvent.buttons) return;
                  if (!e) return;
                  const a = this._getModelTableCellFromDomEvent(s);
                  a && TD(e, a) && ((n = a), o || n == e || (o = !0)),
                    o &&
                      ((i = !0), r.setCellSelection(e, n), s.preventDefault());
                }),
                this.listenTo(t.editing.view.document, "mouseup", () => {
                  (o = !1), (i = !1), (e = null), (n = null);
                }),
                this.listenTo(
                  t.editing.view.document,
                  "selectionChange",
                  (t) => {
                    i && t.stop();
                  },
                  { priority: "highest" }
                );
            }
            _getModelTableCellFromDomEvent(t) {
              const e = t.target,
                n = this.editor.editing.view.createPositionAt(e, 0);
              return this.editor.editing.mapper
                .toModelPosition(n)
                .parent.findAncestor("tableCell", { includeSelf: !0 });
            }
          }
          function TD(t, e) {
            return t.parent.parent == e.parent.parent;
          }
          var MD = n(4104),
            BD = { attributes: { "data-cke": !0 } };
          (BD.setAttributes = is()),
            (BD.insert = ns().bind(null, "head")),
            (BD.domAPI = ts()),
            (BD.insertStyleElement = ss());
          Jr()(MD.Z, BD);
          MD.Z && MD.Z.locals && MD.Z.locals;
          function ND(t) {
            const e = t.getSelectedElement();
            return e && PD(e) ? e : null;
          }
          function zD(t) {
            const e = t.getFirstPosition();
            if (!e) return null;
            let n = e.parent;
            for (; n; ) {
              if (n.is("element") && PD(n)) return n;
              n = n.parent;
            }
            return null;
          }
          function PD(t) {
            return !!t.getCustomProperty("table") && Gp(t);
          }
          class LD extends F {
            constructor(t, e, n) {
              super(t), (this.attributeName = e), (this._defaultValue = n);
            }
            refresh() {
              const t = this.editor.model.document.selection
                .getFirstPosition()
                .findAncestor("table");
              (this.isEnabled = !!t), (this.value = this._getValue(t));
            }
            execute(t = {}) {
              const e = this.editor.model,
                n = e.document.selection,
                { value: o, batch: i } = t,
                r = n.getFirstPosition().findAncestor("table"),
                s = this._getValueToSet(o);
              e.enqueueChange(i, (t) => {
                s
                  ? t.setAttribute(this.attributeName, s, r)
                  : t.removeAttribute(this.attributeName, r);
              });
            }
            _getValue(t) {
              if (!t) return;
              const e = t.getAttribute(this.attributeName);
              return e !== this._defaultValue ? e : void 0;
            }
            _getValueToSet(t) {
              if (t !== this._defaultValue) return t;
            }
          }
          class RD extends LD {
            constructor(t, e) {
              super(t, "tableBackgroundColor", e);
            }
          }
          function OD(t) {
            if (!t || !E(t)) return t;
            const { top: e, right: n, bottom: o, left: i } = t;
            return e == n && n == o && o == i ? e : void 0;
          }
          function jD(t, e) {
            const n = parseFloat(t);
            return Number.isNaN(n) || String(n) !== String(t) ? t : `${n}${e}`;
          }
          function VD(t, e = {}) {
            const n = Object.assign(
              {
                borderStyle: "none",
                borderWidth: "",
                borderColor: "",
                backgroundColor: "",
                width: "",
                height: "",
              },
              t
            );
            return (
              e.includeAlignmentProperty &&
                !n.alignment &&
                (n.alignment = "center"),
              e.includePaddingProperty && !n.padding && (n.padding = ""),
              e.includeVerticalAlignmentProperty &&
                !n.verticalAlignment &&
                (n.verticalAlignment = "middle"),
              e.includeHorizontalAlignmentProperty &&
                !n.horizontalAlignment &&
                (n.horizontalAlignment = e.isRightToLeftContent
                  ? "right"
                  : "left"),
              n
            );
          }
          class FD extends LD {
            constructor(t, e) {
              super(t, "tableBorderColor", e);
            }
            _getValue(t) {
              if (!t) return;
              const e = OD(t.getAttribute(this.attributeName));
              return e !== this._defaultValue ? e : void 0;
            }
          }
          class HD extends LD {
            constructor(t, e) {
              super(t, "tableBorderStyle", e);
            }
            _getValue(t) {
              if (!t) return;
              const e = OD(t.getAttribute(this.attributeName));
              return e !== this._defaultValue ? e : void 0;
            }
          }
          class UD extends LD {
            constructor(t, e) {
              super(t, "tableBorderWidth", e);
            }
            _getValue(t) {
              if (!t) return;
              const e = OD(t.getAttribute(this.attributeName));
              return e !== this._defaultValue ? e : void 0;
            }
            _getValueToSet(t) {
              if ((t = jD(t, "px")) !== this._defaultValue) return t;
            }
          }
          class WD extends LD {
            constructor(t, e) {
              super(t, "tableWidth", e);
            }
            _getValueToSet(t) {
              if ((t = jD(t, "px")) !== this._defaultValue) return t;
            }
          }
          class $D extends LD {
            constructor(t, e) {
              super(t, "tableHeight", e);
            }
            _getValueToSet(t) {
              return (t = jD(t, "px")) === this._defaultValue ? null : t;
            }
          }
          class qD extends LD {
            constructor(t, e) {
              super(t, "tableAlignment", e);
            }
          }
          const GD = /^(left|center|right)$/,
            ZD = /^(left|none|right)$/;
          class YD extends j {
            static get pluginName() {
              return "TablePropertiesEditing";
            }
            static get requires() {
              return [hD];
            }
            init() {
              const t = this.editor,
                e = t.model.schema,
                n = t.conversion;
              t.config.define("table.tableProperties.defaultProperties", {});
              const o = VD(
                t.config.get("table.tableProperties.defaultProperties"),
                { includeAlignmentProperty: !0 }
              );
              t.data.addStyleProcessorRules(Su),
                (function (t, e, n) {
                  const o = {
                    width: "tableBorderWidth",
                    color: "tableBorderColor",
                    style: "tableBorderStyle",
                  };
                  t.extend("table", { allowAttributes: Object.values(o) }),
                    rE(e, "table", o, n),
                    aE(e, {
                      modelAttribute: o.color,
                      styleName: "border-color",
                    }),
                    aE(e, {
                      modelAttribute: o.style,
                      styleName: "border-style",
                    }),
                    aE(e, {
                      modelAttribute: o.width,
                      styleName: "border-width",
                    });
                })(e, n, {
                  color: o.borderColor,
                  style: o.borderStyle,
                  width: o.borderWidth,
                }),
                t.commands.add("tableBorderColor", new FD(t, o.borderColor)),
                t.commands.add("tableBorderStyle", new HD(t, o.borderStyle)),
                t.commands.add("tableBorderWidth", new UD(t, o.borderWidth)),
                (function (t, e, n) {
                  t.extend("table", { allowAttributes: ["tableAlignment"] }),
                    e
                      .for("downcast")
                      .attributeToAttribute({
                        model: { name: "table", key: "tableAlignment" },
                        view: (t) => ({
                          key: "style",
                          value: { float: "center" === t ? "none" : t },
                        }),
                        converterPriority: "high",
                      }),
                    e
                      .for("upcast")
                      .attributeToAttribute({
                        view: {
                          name: /^(table|figure)$/,
                          styles: { float: ZD },
                        },
                        model: {
                          key: "tableAlignment",
                          value: (t) => {
                            let e = t.getStyle("float");
                            return (
                              "none" === e && (e = "center"), e === n ? null : e
                            );
                          },
                        },
                      })
                      .attributeToAttribute({
                        view: { attributes: { align: GD } },
                        model: {
                          name: "table",
                          key: "tableAlignment",
                          value: (t) => {
                            const e = t.getAttribute("align");
                            return e === n ? null : e;
                          },
                        },
                      });
                })(e, n, o.alignment),
                t.commands.add("tableAlignment", new qD(t, o.alignment)),
                KD(e, n, {
                  modelAttribute: "tableWidth",
                  styleName: "width",
                  defaultValue: o.width,
                }),
                t.commands.add("tableWidth", new WD(t, o.width)),
                KD(e, n, {
                  modelAttribute: "tableHeight",
                  styleName: "height",
                  defaultValue: o.height,
                }),
                t.commands.add("tableHeight", new $D(t, o.height)),
                t.data.addStyleProcessorRules(Du),
                (function (t, e, n) {
                  const { modelAttribute: o } = n;
                  t.extend("table", { allowAttributes: [o] }),
                    iE(e, { viewElement: "table", ...n }),
                    aE(e, n);
                })(e, n, {
                  modelAttribute: "tableBackgroundColor",
                  styleName: "background-color",
                  defaultValue: o.backgroundColor,
                }),
                t.commands.add(
                  "tableBackgroundColor",
                  new RD(t, o.backgroundColor)
                );
            }
          }
          function KD(t, e, n) {
            const { modelAttribute: o } = n;
            t.extend("table", { allowAttributes: [o] }),
              iE(e, { viewElement: /^(table|figure)$/, ...n }),
              sE(e, { modelElement: "table", ...n });
          }
          var QD = n(4082),
            JD = { attributes: { "data-cke": !0 } };
          (JD.setAttributes = is()),
            (JD.insert = ns().bind(null, "head")),
            (JD.domAPI = ts()),
            (JD.insertStyleElement = ss());
          Jr()(QD.Z, JD);
          QD.Z && QD.Z.locals && QD.Z.locals;
          class XD extends Ch {
            constructor(t, e) {
              super(t),
                this.set("value", ""),
                this.set("isReadOnly", !1),
                this.set("isFocused", !1),
                this.set("isEmpty", !0),
                (this.options = e),
                (this.focusTracker = new Oa()),
                (this._focusables = new Ju()),
                (this.dropdownView = this._createDropdownView()),
                (this.inputView = this._createInputTextView()),
                (this.keystrokes = new ja()),
                (this._stillTyping = !1),
                (this._focusCycler = new Cm({
                  focusables: this._focusables,
                  focusTracker: this.focusTracker,
                  keystrokeHandler: this.keystrokes,
                  actions: { focusPrevious: "shift + tab", focusNext: "tab" },
                })),
                this.setTemplate({
                  tag: "div",
                  attributes: { class: ["ck", "ck-input-color"] },
                  children: [this.dropdownView, this.inputView],
                }),
                this.on("change:value", (t, e, n) => this._setInputValue(n));
            }
            render() {
              super.render(),
                this.keystrokes.listenTo(this.dropdownView.panelView.element);
            }
            focus() {
              this.inputView.focus();
            }
            destroy() {
              super.destroy(),
                this.focusTracker.destroy(),
                this.keystrokes.destroy();
            }
            _createDropdownView() {
              const t = this.locale,
                e = t.t,
                n = this.bindTemplate,
                o = this._createColorGrid(t),
                i = Wm(t),
                r = new Ch(),
                s = this._createRemoveColorButton();
              return (
                r.setTemplate({
                  tag: "span",
                  attributes: {
                    class: ["ck", "ck-input-color__button__preview"],
                    style: { backgroundColor: n.to("value") },
                  },
                  children: [
                    {
                      tag: "span",
                      attributes: {
                        class: [
                          "ck",
                          "ck-input-color__button__preview__no-color-indicator",
                          n.if("value", "ck-hidden", (t) => "" != t),
                        ],
                      },
                    },
                  ],
                }),
                i.buttonView.extendTemplate({
                  attributes: { class: "ck-input-color__button" },
                }),
                i.buttonView.children.add(r),
                (i.buttonView.label = e("Color picker")),
                (i.buttonView.tooltip = !0),
                (i.panelPosition =
                  "rtl" === t.uiLanguageDirection ? "se" : "sw"),
                i.panelView.children.add(s),
                i.panelView.children.add(o),
                i.bind("isEnabled").to(this, "isReadOnly", (t) => !t),
                this._focusables.add(s),
                this._focusables.add(o),
                this.focusTracker.add(s.element),
                this.focusTracker.add(o.element),
                i
              );
            }
            _createInputTextView() {
              const t = this.locale,
                e = new cg(t);
              return (
                e.extendTemplate({ on: { blur: e.bindTemplate.to("blur") } }),
                (e.value = this.value),
                e.bind("isReadOnly", "hasError").to(this),
                this.bind("isFocused", "isEmpty").to(e),
                e.on("input", () => {
                  const t = e.element.value,
                    n = this.options.colorDefinitions.find(
                      (e) => t === e.label
                    );
                  (this._stillTyping = !0), (this.value = (n && n.color) || t);
                }),
                e.on("blur", () => {
                  (this._stillTyping = !1),
                    this._setInputValue(e.element.value);
                }),
                e.delegate("input").to(this),
                e
              );
            }
            _createRemoveColorButton() {
              const t = this.locale,
                e = t.t,
                n = new nm(t),
                o = this.options.defaultColorValue || "",
                i = e(o ? "Restore default" : "Remove color");
              return (
                (n.class = "ck-input-color__remove-color"),
                (n.withText = !0),
                (n.icon = $h.eraser),
                (n.label = i),
                n.on("execute", () => {
                  (this.value = o),
                    (this.dropdownView.isOpen = !1),
                    this.fire("input");
                }),
                n
              );
            }
            _createColorGrid(t) {
              const e = new hm(t, {
                colorDefinitions: this.options.colorDefinitions,
                columns: this.options.columns,
              });
              return (
                e.on("execute", (t, e) => {
                  (this.value = e.value),
                    (this.dropdownView.isOpen = !1),
                    this.fire("input");
                }),
                e.bind("selectedColor").to(this, "value"),
                e
              );
            }
            _setInputValue(t) {
              if (!this._stillTyping) {
                const e = tS(t),
                  n = this.options.colorDefinitions.find(
                    (t) => e === tS(t.color)
                  );
                this.inputView.value = n ? n.label : t || "";
              }
            }
          }
          function tS(t) {
            return t
              .replace(/([(,])\s+/g, "$1")
              .replace(/^\s+|\s+(?=[),\s]|$)/g, "")
              .replace(/,|\s/g, " ");
          }
          const eS = (t) => "" === t;
          function nS(t) {
            return {
              none: t("None"),
              solid: t("Solid"),
              dotted: t("Dotted"),
              dashed: t("Dashed"),
              double: t("Double"),
              groove: t("Groove"),
              ridge: t("Ridge"),
              inset: t("Inset"),
              outset: t("Outset"),
            };
          }
          function oS(t) {
            return t(
              'The color is invalid. Try "#FF0000" or "rgb(255,0,0)" or "red".'
            );
          }
          function iS(t) {
            return t(
              'The value is invalid. Try "10px" or "2em" or simply "2".'
            );
          }
          function rS(t) {
            return (t = t.trim()), eS(t) || lu(t);
          }
          function sS(t) {
            return (
              (t = t.trim()), eS(t) || hS(t) || hu(t) || ((e = t), mu.test(e))
            );
            var e;
          }
          function aS(t) {
            return (t = t.trim()), eS(t) || hS(t) || hu(t);
          }
          function lS(t, e) {
            const n = new po(),
              o = nS(t.t);
            for (const i in o) {
              const r = {
                type: "button",
                model: new fg({
                  _borderStyleValue: i,
                  label: o[i],
                  withText: !0,
                }),
              };
              "none" === i
                ? r.model
                    .bind("isOn")
                    .to(t, "borderStyle", (t) => ("none" === e ? !t : t === i))
                : r.model.bind("isOn").to(t, "borderStyle", (t) => t === i),
                n.add(r);
            }
            return n;
          }
          function cS(t) {
            const {
              view: e,
              icons: n,
              toolbar: o,
              labels: i,
              propertyName: r,
              nameToValue: s,
              defaultValue: a,
            } = t;
            for (const t in i) {
              const l = new nm(e.locale);
              l.set({ label: i[t], icon: n[t], tooltip: i[t] });
              const c = s ? s(t) : t;
              l.bind("isOn").to(e, r, (t) => {
                let e = t;
                return "" === t && a && (e = a), c === e;
              }),
                l.on("execute", () => {
                  e[r] = c;
                }),
                o.items.add(l);
            }
          }
          const dS = [
            { color: "hsl(0, 0%, 0%)", label: "Black" },
            { color: "hsl(0, 0%, 30%)", label: "Dim grey" },
            { color: "hsl(0, 0%, 60%)", label: "Grey" },
            { color: "hsl(0, 0%, 90%)", label: "Light grey" },
            { color: "hsl(0, 0%, 100%)", label: "White", hasBorder: !0 },
            { color: "hsl(0, 75%, 60%)", label: "Red" },
            { color: "hsl(30, 75%, 60%)", label: "Orange" },
            { color: "hsl(60, 75%, 60%)", label: "Yellow" },
            { color: "hsl(90, 75%, 60%)", label: "Light green" },
            { color: "hsl(120, 75%, 60%)", label: "Green" },
            { color: "hsl(150, 75%, 60%)", label: "Aquamarine" },
            { color: "hsl(180, 75%, 60%)", label: "Turquoise" },
            { color: "hsl(210, 75%, 60%)", label: "Light blue" },
            { color: "hsl(240, 75%, 60%)", label: "Blue" },
            { color: "hsl(270, 75%, 60%)", label: "Purple" },
          ];
          function uS(t) {
            return (e, n, o) => {
              const i = new XD(e.locale, {
                colorDefinitions:
                  ((r = t.colorConfig),
                  r.map((t) => ({
                    color: t.model,
                    label: t.label,
                    options: { hasBorder: t.hasBorder },
                  }))),
                columns: t.columns,
                defaultColorValue: t.defaultColorValue,
              });
              var r;
              return (
                i.inputView.set({ id: n, ariaDescribedById: o }),
                i.bind("isReadOnly").to(e, "isEnabled", (t) => !t),
                i.bind("hasError").to(e, "errorText", (t) => !!t),
                i.on("input", () => {
                  e.errorText = null;
                }),
                e.bind("isEmpty", "isFocused").to(i),
                i
              );
            };
          }
          function hS(t) {
            const e = parseFloat(t);
            return !Number.isNaN(e) && t === String(e);
          }
          var mS = n(9865),
            gS = { attributes: { "data-cke": !0 } };
          (gS.setAttributes = is()),
            (gS.insert = ns().bind(null, "head")),
            (gS.domAPI = ts()),
            (gS.insertStyleElement = ss());
          Jr()(mS.Z, gS);
          mS.Z && mS.Z.locals && mS.Z.locals;
          class pS extends Ch {
            constructor(t, e = {}) {
              super(t);
              const n = this.bindTemplate;
              this.set("class", e.class || null),
                (this.children = this.createCollection()),
                e.children && e.children.forEach((t) => this.children.add(t)),
                this.set("_role", null),
                this.set("_ariaLabelledBy", null),
                e.labelView &&
                  this.set({ _role: "group", _ariaLabelledBy: e.labelView.id }),
                this.setTemplate({
                  tag: "div",
                  attributes: {
                    class: ["ck", "ck-form__row", n.to("class")],
                    role: n.to("_role"),
                    "aria-labelledby": n.to("_ariaLabelledBy"),
                  },
                  children: this.children,
                });
            }
          }
          var fS = n(4880),
            kS = { attributes: { "data-cke": !0 } };
          (kS.setAttributes = is()),
            (kS.insert = ns().bind(null, "head")),
            (kS.domAPI = ts()),
            (kS.insertStyleElement = ss());
          Jr()(fS.Z, kS);
          fS.Z && fS.Z.locals && fS.Z.locals;
          var bS = n(198),
            wS = { attributes: { "data-cke": !0 } };
          (wS.setAttributes = is()),
            (wS.insert = ns().bind(null, "head")),
            (wS.domAPI = ts()),
            (wS.insertStyleElement = ss());
          Jr()(bS.Z, wS);
          bS.Z && bS.Z.locals && bS.Z.locals;
          var AS = n(9221),
            _S = { attributes: { "data-cke": !0 } };
          (_S.setAttributes = is()),
            (_S.insert = ns().bind(null, "head")),
            (_S.domAPI = ts()),
            (_S.insertStyleElement = ss());
          Jr()(AS.Z, _S);
          AS.Z && AS.Z.locals && AS.Z.locals;
          const CS = {
            left: $h.objectLeft,
            center: $h.objectCenter,
            right: $h.objectRight,
          };
          class vS extends Ch {
            constructor(t, e) {
              super(t),
                this.set({
                  borderStyle: "",
                  borderWidth: "",
                  borderColor: "",
                  backgroundColor: "",
                  width: "",
                  height: "",
                  alignment: "",
                }),
                (this.options = e);
              const {
                  borderStyleDropdown: n,
                  borderWidthInput: o,
                  borderColorInput: i,
                  borderRowLabel: r,
                } = this._createBorderFields(),
                { backgroundRowLabel: s, backgroundInput: a } =
                  this._createBackgroundFields(),
                {
                  widthInput: l,
                  operatorLabel: c,
                  heightInput: d,
                  dimensionsLabel: u,
                } = this._createDimensionFields(),
                { alignmentToolbar: h, alignmentLabel: m } =
                  this._createAlignmentFields();
              (this.focusTracker = new Oa()),
                (this.keystrokes = new ja()),
                (this.children = this.createCollection()),
                (this.borderStyleDropdown = n),
                (this.borderWidthInput = o),
                (this.borderColorInput = i),
                (this.backgroundInput = a),
                (this.widthInput = l),
                (this.heightInput = d),
                (this.alignmentToolbar = h);
              const { saveButtonView: g, cancelButtonView: p } =
                this._createActionButtons();
              (this.saveButtonView = g),
                (this.cancelButtonView = p),
                (this._focusables = new Ju()),
                (this._focusCycler = new Cm({
                  focusables: this._focusables,
                  focusTracker: this.focusTracker,
                  keystrokeHandler: this.keystrokes,
                  actions: { focusPrevious: "shift + tab", focusNext: "tab" },
                })),
                this.children.add(
                  new rg(t, { label: this.t("Table properties") })
                ),
                this.children.add(
                  new pS(t, {
                    labelView: r,
                    children: [r, n, i, o],
                    class: "ck-table-form__border-row",
                  })
                ),
                this.children.add(
                  new pS(t, {
                    labelView: s,
                    children: [s, a],
                    class: "ck-table-form__background-row",
                  })
                ),
                this.children.add(
                  new pS(t, {
                    children: [
                      new pS(t, {
                        labelView: u,
                        children: [u, l, c, d],
                        class: "ck-table-form__dimensions-row",
                      }),
                      new pS(t, {
                        labelView: m,
                        children: [m, h],
                        class: "ck-table-properties-form__alignment-row",
                      }),
                    ],
                  })
                ),
                this.children.add(
                  new pS(t, {
                    children: [this.saveButtonView, this.cancelButtonView],
                    class: "ck-table-form__action-row",
                  })
                ),
                this.setTemplate({
                  tag: "form",
                  attributes: {
                    class: [
                      "ck",
                      "ck-form",
                      "ck-table-form",
                      "ck-table-properties-form",
                    ],
                    tabindex: "-1",
                  },
                  children: this.children,
                });
            }
            render() {
              super.render(),
                Zh({ view: this }),
                [
                  this.borderStyleDropdown,
                  this.borderColorInput,
                  this.borderColorInput.fieldView.dropdownView.buttonView,
                  this.borderWidthInput,
                  this.backgroundInput,
                  this.backgroundInput.fieldView.dropdownView.buttonView,
                  this.widthInput,
                  this.heightInput,
                  this.alignmentToolbar,
                  this.saveButtonView,
                  this.cancelButtonView,
                ].forEach((t) => {
                  this._focusables.add(t), this.focusTracker.add(t.element);
                }),
                this.keystrokes.listenTo(this.element);
            }
            destroy() {
              super.destroy(),
                this.focusTracker.destroy(),
                this.keystrokes.destroy();
            }
            focus() {
              this._focusCycler.focusFirst();
            }
            _createBorderFields() {
              const t = this.options.defaultTableProperties,
                e = {
                  style: t.borderStyle,
                  width: t.borderWidth,
                  color: t.borderColor,
                },
                n = uS({
                  colorConfig: this.options.borderColors,
                  columns: 5,
                  defaultColorValue: e.color,
                }),
                o = this.locale,
                i = this.t,
                r = new Xm(o);
              r.text = i("Border");
              const s = nS(this.t),
                a = new hg(o, gg);
              a.set({
                label: i("Style"),
                class: "ck-table-form__border-style",
              }),
                a.fieldView.buttonView.set({
                  isOn: !1,
                  withText: !0,
                  tooltip: i("Style"),
                }),
                a.fieldView.buttonView
                  .bind("label")
                  .to(this, "borderStyle", (t) => s[t || "none"]),
                a.fieldView.on("execute", (t) => {
                  this.borderStyle = t.source._borderStyleValue;
                }),
                a.bind("isEmpty").to(this, "borderStyle", (t) => !t),
                qm(a.fieldView, lS(this, e.style));
              const l = new hg(o, mg);
              l.set({
                label: i("Width"),
                class: "ck-table-form__border-width",
              }),
                l.fieldView.bind("value").to(this, "borderWidth"),
                l.bind("isEnabled").to(this, "borderStyle", yS),
                l.fieldView.on("input", () => {
                  this.borderWidth = l.fieldView.element.value;
                });
              const c = new hg(o, n);
              return (
                c.set({
                  label: i("Color"),
                  class: "ck-table-form__border-color",
                }),
                c.fieldView.bind("value").to(this, "borderColor"),
                c.bind("isEnabled").to(this, "borderStyle", yS),
                c.fieldView.on("input", () => {
                  this.borderColor = c.fieldView.value;
                }),
                this.on("change:borderStyle", (t, n, o, i) => {
                  yS(o) || ((this.borderColor = ""), (this.borderWidth = "")),
                    yS(i) ||
                      ((this.borderColor = e.color),
                      (this.borderWidth = e.width));
                }),
                {
                  borderRowLabel: r,
                  borderStyleDropdown: a,
                  borderColorInput: c,
                  borderWidthInput: l,
                }
              );
            }
            _createBackgroundFields() {
              const t = this.locale,
                e = this.t,
                n = new Xm(t);
              n.text = e("Background");
              const o = uS({
                  colorConfig: this.options.backgroundColors,
                  columns: 5,
                  defaultColorValue:
                    this.options.defaultTableProperties.backgroundColor,
                }),
                i = new hg(t, o);
              return (
                i.set({
                  label: e("Color"),
                  class: "ck-table-properties-form__background",
                }),
                i.fieldView.bind("value").to(this, "backgroundColor"),
                i.fieldView.on("input", () => {
                  this.backgroundColor = i.fieldView.value;
                }),
                { backgroundRowLabel: n, backgroundInput: i }
              );
            }
            _createDimensionFields() {
              const t = this.locale,
                e = this.t,
                n = new Xm(t);
              n.text = e("Dimensions");
              const o = new hg(t, mg);
              o.set({
                label: e("Width"),
                class: "ck-table-form__dimensions-row__width",
              }),
                o.fieldView.bind("value").to(this, "width"),
                o.fieldView.on("input", () => {
                  this.width = o.fieldView.element.value;
                });
              const i = new Ch(t);
              i.setTemplate({
                tag: "span",
                attributes: { class: ["ck-table-form__dimension-operator"] },
                children: [{ text: "×" }],
              });
              const r = new hg(t, mg);
              return (
                r.set({
                  label: e("Height"),
                  class: "ck-table-form__dimensions-row__height",
                }),
                r.fieldView.bind("value").to(this, "height"),
                r.fieldView.on("input", () => {
                  this.height = r.fieldView.element.value;
                }),
                {
                  dimensionsLabel: n,
                  widthInput: o,
                  operatorLabel: i,
                  heightInput: r,
                }
              );
            }
            _createAlignmentFields() {
              const t = this.locale,
                e = this.t,
                n = new Xm(t);
              n.text = e("Alignment");
              const o = new Mm(t);
              return (
                o.set({
                  isCompact: !0,
                  ariaLabel: e("Table alignment toolbar"),
                }),
                cS({
                  view: this,
                  icons: CS,
                  toolbar: o,
                  labels: this._alignmentLabels,
                  propertyName: "alignment",
                  defaultValue: this.options.defaultTableProperties.alignment,
                }),
                { alignmentLabel: n, alignmentToolbar: o }
              );
            }
            _createActionButtons() {
              const t = this.locale,
                e = this.t,
                n = new nm(t),
                o = new nm(t),
                i = [
                  this.borderWidthInput,
                  this.borderColorInput,
                  this.backgroundInput,
                  this.widthInput,
                  this.heightInput,
                ];
              return (
                n.set({
                  label: e("Save"),
                  icon: $h.check,
                  class: "ck-button-save",
                  type: "submit",
                  withText: !0,
                }),
                n
                  .bind("isEnabled")
                  .toMany(i, "errorText", (...t) => t.every((t) => !t)),
                o.set({
                  label: e("Cancel"),
                  icon: $h.cancel,
                  class: "ck-button-cancel",
                  withText: !0,
                }),
                o.delegate("execute").to(this, "cancel"),
                { saveButtonView: n, cancelButtonView: o }
              );
            }
            get _alignmentLabels() {
              const t = this.locale,
                e = this.t,
                n = e("Align table to the left"),
                o = e("Center table"),
                i = e("Align table to the right");
              return "rtl" === t.uiLanguageDirection
                ? { right: i, center: o, left: n }
                : { left: n, center: o, right: i };
            }
          }
          function yS(t) {
            return "none" !== t;
          }
          const xS = Mh.defaultPositions,
            ES = [
              xS.northArrowSouth,
              xS.northArrowSouthWest,
              xS.northArrowSouthEast,
              xS.southArrowNorth,
              xS.southArrowNorthWest,
              xS.southArrowNorthEast,
              xS.viewportStickyNorth,
            ];
          function DS(t, e) {
            const n = t.plugins.get("ContextualBalloon");
            if (zD(t.editing.view.document.selection)) {
              let o;
              (o = "cell" === e ? IS(t) : SS(t)), n.updatePosition(o);
            }
          }
          function SS(t) {
            const e = t.model.document.selection
                .getFirstPosition()
                .findAncestor("table"),
              n = t.editing.mapper.toViewElement(e);
            return {
              target: t.editing.view.domConverter.mapViewToDom(n),
              positions: ES,
            };
          }
          function IS(t) {
            const e = t.editing.mapper,
              n = t.editing.view.domConverter,
              o = t.model.document.selection;
            if (o.rangeCount > 1)
              return {
                target: () =>
                  (function (t, e) {
                    const n = e.editing.mapper,
                      o = e.editing.view.domConverter,
                      i = Array.from(t).map((t) => {
                        const e = TS(t.start),
                          i = n.toViewElement(e);
                        return new Ma(o.mapViewToDom(i));
                      });
                    return Ma.getBoundingRect(i);
                  })(o.getRanges(), t),
                positions: ES,
              };
            const i = TS(o.getFirstPosition()),
              r = e.toViewElement(i);
            return { target: n.mapViewToDom(r), positions: ES };
          }
          function TS(t) {
            return t.nodeAfter && t.nodeAfter.is("element", "tableCell")
              ? t.nodeAfter
              : t.findAncestor("tableCell");
          }
          const MS = {
            borderStyle: "tableBorderStyle",
            borderColor: "tableBorderColor",
            borderWidth: "tableBorderWidth",
            backgroundColor: "tableBackgroundColor",
            width: "tableWidth",
            height: "tableHeight",
            alignment: "tableAlignment",
          };
          class BS extends j {
            static get requires() {
              return [vg];
            }
            static get pluginName() {
              return "TablePropertiesUI";
            }
            constructor(t) {
              super(t),
                t.config.define("table.tableProperties", {
                  borderColors: dS,
                  backgroundColors: dS,
                });
            }
            init() {
              const t = this.editor,
                e = t.t;
              (this._defaultTableProperties = VD(
                t.config.get("table.tableProperties.defaultProperties"),
                { includeAlignmentProperty: !0 }
              )),
                (this._balloon = t.plugins.get(vg)),
                (this.view = this._createPropertiesView()),
                (this._undoStepBatch = null),
                t.ui.componentFactory.add("tableProperties", (n) => {
                  const o = new nm(n);
                  o.set({
                    label: e("Table properties"),
                    icon: '<svg viewBox="0 0 20 20" xmlns="http://www.w3.org/2000/svg"><path d="M8 2v5h4V2h1v5h5v1h-5v4h.021l-.172.351-1.916.28-.151.027c-.287.063-.54.182-.755.341L8 13v5H7v-5H2v-1h5V8H2V7h5V2h1zm4 6H8v4h4V8z" opacity=".6"/><path d="m15.5 11.5 1.323 2.68 2.957.43-2.14 2.085.505 2.946L15.5 18.25l-2.645 1.39.505-2.945-2.14-2.086 2.957-.43L15.5 11.5zM17 1a2 2 0 0 1 2 2v9.475l-.85-.124-.857-1.736a2.048 2.048 0 0 0-.292-.44L17 3H3v14h7.808l.402.392L10.935 19H3a2 2 0 0 1-2-2V3a2 2 0 0 1 2-2h14z"/></svg>',
                    tooltip: !0,
                  }),
                    this.listenTo(o, "execute", () => this._showView());
                  const i = Object.values(MS).map((e) => t.commands.get(e));
                  return (
                    o
                      .bind("isEnabled")
                      .toMany(i, "isEnabled", (...t) => t.some((t) => t)),
                    o
                  );
                });
            }
            destroy() {
              super.destroy(), this.view.destroy();
            }
            _createPropertiesView() {
              const t = this.editor,
                e = t.config.get("table.tableProperties"),
                n = am(e.borderColors),
                o = sm(t.locale, n),
                i = am(e.backgroundColors),
                r = sm(t.locale, i),
                s = new vS(t.locale, {
                  borderColors: o,
                  backgroundColors: r,
                  defaultTableProperties: this._defaultTableProperties,
                }),
                a = t.t;
              s.render(),
                this.listenTo(s, "submit", () => {
                  this._hideView();
                }),
                this.listenTo(s, "cancel", () => {
                  this._undoStepBatch.operations.length &&
                    t.execute("undo", this._undoStepBatch),
                    this._hideView();
                }),
                s.keystrokes.set("Esc", (t, e) => {
                  this._hideView(), e();
                }),
                qh({
                  emitter: s,
                  activator: () => this._isViewInBalloon,
                  contextElements: [this._balloon.view.element],
                  callback: () => this._hideView(),
                });
              const l = oS(a),
                c = iS(a);
              return (
                s.on(
                  "change:borderStyle",
                  this._getPropertyChangeCallback(
                    "tableBorderStyle",
                    this._defaultTableProperties.borderStyle
                  )
                ),
                s.on(
                  "change:borderColor",
                  this._getValidatedPropertyChangeCallback({
                    viewField: s.borderColorInput,
                    commandName: "tableBorderColor",
                    errorText: l,
                    validator: rS,
                    defaultValue: this._defaultTableProperties.borderColor,
                  })
                ),
                s.on(
                  "change:borderWidth",
                  this._getValidatedPropertyChangeCallback({
                    viewField: s.borderWidthInput,
                    commandName: "tableBorderWidth",
                    errorText: c,
                    validator: aS,
                    defaultValue: this._defaultTableProperties.borderWidth,
                  })
                ),
                s.on(
                  "change:backgroundColor",
                  this._getValidatedPropertyChangeCallback({
                    viewField: s.backgroundInput,
                    commandName: "tableBackgroundColor",
                    errorText: l,
                    validator: rS,
                    defaultValue: this._defaultTableProperties.backgroundColor,
                  })
                ),
                s.on(
                  "change:width",
                  this._getValidatedPropertyChangeCallback({
                    viewField: s.widthInput,
                    commandName: "tableWidth",
                    errorText: c,
                    validator: sS,
                    defaultValue: this._defaultTableProperties.width,
                  })
                ),
                s.on(
                  "change:height",
                  this._getValidatedPropertyChangeCallback({
                    viewField: s.heightInput,
                    commandName: "tableHeight",
                    errorText: c,
                    validator: sS,
                    defaultValue: this._defaultTableProperties.height,
                  })
                ),
                s.on(
                  "change:alignment",
                  this._getPropertyChangeCallback(
                    "tableAlignment",
                    this._defaultTableProperties.alignment
                  )
                ),
                s
              );
            }
            _fillViewFormFromCommandValues() {
              const t = this.editor.commands,
                e = t.get("tableBorderStyle");
              Object.entries(MS)
                .map(([e, n]) => {
                  const o = this._defaultTableProperties[e] || "";
                  return [e, t.get(n).value || o];
                })
                .forEach(([t, n]) => {
                  (("borderColor" !== t && "borderWidth" !== t) ||
                    "none" !== e.value) &&
                    this.view.set(t, n);
                });
            }
            _showView() {
              const t = this.editor;
              this.listenTo(t.ui, "update", () => {
                this._updateView();
              }),
                this._fillViewFormFromCommandValues(),
                this._balloon.add({ view: this.view, position: SS(t) }),
                (this._undoStepBatch = t.model.createBatch()),
                this.view.focus();
            }
            _hideView() {
              const t = this.editor;
              this.stopListening(t.ui, "update"),
                this.view.saveButtonView.focus(),
                this._balloon.remove(this.view),
                this.editor.editing.view.focus();
            }
            _updateView() {
              const t = this.editor;
              zD(t.editing.view.document.selection)
                ? this._isViewVisible && DS(t, "table")
                : this._hideView();
            }
            get _isViewVisible() {
              return this._balloon.visibleView === this.view;
            }
            get _isViewInBalloon() {
              return this._balloon.hasView(this.view);
            }
            _getPropertyChangeCallback(t, e) {
              return (n, o, i, r) => {
                (r || e !== i) &&
                  this.editor.execute(t, {
                    value: i,
                    batch: this._undoStepBatch,
                  });
              };
            }
            _getValidatedPropertyChangeCallback(t) {
              const {
                  commandName: e,
                  viewField: n,
                  validator: o,
                  errorText: i,
                  defaultValue: r,
                } = t,
                s = Zs(() => {
                  n.errorText = i;
                }, 500);
              return (t, i, a, l) => {
                s.cancel(),
                  (l || r !== a) &&
                    (o(a)
                      ? (this.editor.execute(e, {
                          value: a,
                          batch: this._undoStepBatch,
                        }),
                        (n.errorText = null))
                      : s());
              };
            }
          }
          var NS = n(5737),
            zS = { attributes: { "data-cke": !0 } };
          (zS.setAttributes = is()),
            (zS.insert = ns().bind(null, "head")),
            (zS.domAPI = ts()),
            (zS.insertStyleElement = ss());
          Jr()(NS.Z, zS);
          NS.Z && NS.Z.locals && NS.Z.locals;
          const PS = {
            left: $h.alignLeft,
            center: $h.alignCenter,
            right: $h.alignRight,
            justify: $h.alignJustify,
            top: $h.alignTop,
            middle: $h.alignMiddle,
            bottom: $h.alignBottom,
          };
          class LS extends Ch {
            constructor(t, e) {
              super(t),
                this.set({
                  borderStyle: "",
                  borderWidth: "",
                  borderColor: "",
                  padding: "",
                  backgroundColor: "",
                  width: "",
                  height: "",
                  horizontalAlignment: "",
                  verticalAlignment: "",
                }),
                (this.options = e);
              const {
                  borderStyleDropdown: n,
                  borderWidthInput: o,
                  borderColorInput: i,
                  borderRowLabel: r,
                } = this._createBorderFields(),
                { backgroundRowLabel: s, backgroundInput: a } =
                  this._createBackgroundFields(),
                {
                  widthInput: l,
                  operatorLabel: c,
                  heightInput: d,
                  dimensionsLabel: u,
                } = this._createDimensionFields(),
                {
                  horizontalAlignmentToolbar: h,
                  verticalAlignmentToolbar: m,
                  alignmentLabel: g,
                } = this._createAlignmentFields();
              (this.focusTracker = new Oa()),
                (this.keystrokes = new ja()),
                (this.children = this.createCollection()),
                (this.borderStyleDropdown = n),
                (this.borderWidthInput = o),
                (this.borderColorInput = i),
                (this.backgroundInput = a),
                (this.paddingInput = this._createPaddingField()),
                (this.widthInput = l),
                (this.heightInput = d),
                (this.horizontalAlignmentToolbar = h),
                (this.verticalAlignmentToolbar = m);
              const { saveButtonView: p, cancelButtonView: f } =
                this._createActionButtons();
              (this.saveButtonView = p),
                (this.cancelButtonView = f),
                (this._focusables = new Ju()),
                (this._focusCycler = new Cm({
                  focusables: this._focusables,
                  focusTracker: this.focusTracker,
                  keystrokeHandler: this.keystrokes,
                  actions: { focusPrevious: "shift + tab", focusNext: "tab" },
                })),
                this.children.add(
                  new rg(t, { label: this.t("Cell properties") })
                ),
                this.children.add(
                  new pS(t, {
                    labelView: r,
                    children: [r, n, i, o],
                    class: "ck-table-form__border-row",
                  })
                ),
                this.children.add(
                  new pS(t, {
                    labelView: s,
                    children: [s, a],
                    class: "ck-table-form__background-row",
                  })
                ),
                this.children.add(
                  new pS(t, {
                    children: [
                      new pS(t, {
                        labelView: u,
                        children: [u, l, c, d],
                        class: "ck-table-form__dimensions-row",
                      }),
                      new pS(t, {
                        children: [this.paddingInput],
                        class: "ck-table-cell-properties-form__padding-row",
                      }),
                    ],
                  })
                ),
                this.children.add(
                  new pS(t, {
                    labelView: g,
                    children: [g, h, m],
                    class: "ck-table-cell-properties-form__alignment-row",
                  })
                ),
                this.children.add(
                  new pS(t, {
                    children: [this.saveButtonView, this.cancelButtonView],
                    class: "ck-table-form__action-row",
                  })
                ),
                this.setTemplate({
                  tag: "form",
                  attributes: {
                    class: [
                      "ck",
                      "ck-form",
                      "ck-table-form",
                      "ck-table-cell-properties-form",
                    ],
                    tabindex: "-1",
                  },
                  children: this.children,
                });
            }
            render() {
              super.render(),
                Zh({ view: this }),
                [
                  this.borderStyleDropdown,
                  this.borderColorInput,
                  this.borderColorInput.fieldView.dropdownView.buttonView,
                  this.borderWidthInput,
                  this.backgroundInput,
                  this.backgroundInput.fieldView.dropdownView.buttonView,
                  this.widthInput,
                  this.heightInput,
                  this.paddingInput,
                  this.horizontalAlignmentToolbar,
                  this.verticalAlignmentToolbar,
                  this.saveButtonView,
                  this.cancelButtonView,
                ].forEach((t) => {
                  this._focusables.add(t), this.focusTracker.add(t.element);
                }),
                this.keystrokes.listenTo(this.element);
            }
            destroy() {
              super.destroy(),
                this.focusTracker.destroy(),
                this.keystrokes.destroy();
            }
            focus() {
              this._focusCycler.focusFirst();
            }
            _createBorderFields() {
              const t = this.options.defaultTableCellProperties,
                e = {
                  style: t.borderStyle,
                  width: t.borderWidth,
                  color: t.borderColor,
                },
                n = uS({
                  colorConfig: this.options.borderColors,
                  columns: 5,
                  defaultColorValue: e.color,
                }),
                o = this.locale,
                i = this.t,
                r = new Xm(o);
              r.text = i("Border");
              const s = nS(i),
                a = new hg(o, gg);
              a.set({
                label: i("Style"),
                class: "ck-table-form__border-style",
              }),
                a.fieldView.buttonView.set({
                  isOn: !1,
                  withText: !0,
                  tooltip: i("Style"),
                }),
                a.fieldView.buttonView
                  .bind("label")
                  .to(this, "borderStyle", (t) => s[t || "none"]),
                a.fieldView.on("execute", (t) => {
                  this.borderStyle = t.source._borderStyleValue;
                }),
                a.bind("isEmpty").to(this, "borderStyle", (t) => !t),
                qm(a.fieldView, lS(this, e.style));
              const l = new hg(o, mg);
              l.set({
                label: i("Width"),
                class: "ck-table-form__border-width",
              }),
                l.fieldView.bind("value").to(this, "borderWidth"),
                l.bind("isEnabled").to(this, "borderStyle", RS),
                l.fieldView.on("input", () => {
                  this.borderWidth = l.fieldView.element.value;
                });
              const c = new hg(o, n);
              return (
                c.set({
                  label: i("Color"),
                  class: "ck-table-form__border-color",
                }),
                c.fieldView.bind("value").to(this, "borderColor"),
                c.bind("isEnabled").to(this, "borderStyle", RS),
                c.fieldView.on("input", () => {
                  this.borderColor = c.fieldView.value;
                }),
                this.on("change:borderStyle", (t, n, o, i) => {
                  RS(o) || ((this.borderColor = ""), (this.borderWidth = "")),
                    RS(i) ||
                      ((this.borderColor = e.color),
                      (this.borderWidth = e.width));
                }),
                {
                  borderRowLabel: r,
                  borderStyleDropdown: a,
                  borderColorInput: c,
                  borderWidthInput: l,
                }
              );
            }
            _createBackgroundFields() {
              const t = this.locale,
                e = this.t,
                n = new Xm(t);
              n.text = e("Background");
              const o = uS({
                  colorConfig: this.options.backgroundColors,
                  columns: 5,
                  defaultColorValue:
                    this.options.defaultTableCellProperties.backgroundColor,
                }),
                i = new hg(t, o);
              return (
                i.set({
                  label: e("Color"),
                  class: "ck-table-cell-properties-form__background",
                }),
                i.fieldView.bind("value").to(this, "backgroundColor"),
                i.fieldView.on("input", () => {
                  this.backgroundColor = i.fieldView.value;
                }),
                { backgroundRowLabel: n, backgroundInput: i }
              );
            }
            _createDimensionFields() {
              const t = this.locale,
                e = this.t,
                n = new Xm(t);
              n.text = e("Dimensions");
              const o = new hg(t, mg);
              o.set({
                label: e("Width"),
                class: "ck-table-form__dimensions-row__width",
              }),
                o.fieldView.bind("value").to(this, "width"),
                o.fieldView.on("input", () => {
                  this.width = o.fieldView.element.value;
                });
              const i = new Ch(t);
              i.setTemplate({
                tag: "span",
                attributes: { class: ["ck-table-form__dimension-operator"] },
                children: [{ text: "×" }],
              });
              const r = new hg(t, mg);
              return (
                r.set({
                  label: e("Height"),
                  class: "ck-table-form__dimensions-row__height",
                }),
                r.fieldView.bind("value").to(this, "height"),
                r.fieldView.on("input", () => {
                  this.height = r.fieldView.element.value;
                }),
                {
                  dimensionsLabel: n,
                  widthInput: o,
                  operatorLabel: i,
                  heightInput: r,
                }
              );
            }
            _createPaddingField() {
              const t = this.locale,
                e = this.t,
                n = new hg(t, mg);
              return (
                n.set({
                  label: e("Padding"),
                  class: "ck-table-cell-properties-form__padding",
                }),
                n.fieldView.bind("value").to(this, "padding"),
                n.fieldView.on("input", () => {
                  this.padding = n.fieldView.element.value;
                }),
                n
              );
            }
            _createAlignmentFields() {
              const t = this.locale,
                e = this.t,
                n = new Xm(t);
              n.text = e("Table cell text alignment");
              const o = new Mm(t),
                i = "rtl" === this.locale.contentLanguageDirection;
              o.set({
                isCompact: !0,
                ariaLabel: e("Horizontal text alignment toolbar"),
              }),
                cS({
                  view: this,
                  icons: PS,
                  toolbar: o,
                  labels: this._horizontalAlignmentLabels,
                  propertyName: "horizontalAlignment",
                  nameToValue: (t) => {
                    if (i) {
                      if ("left" === t) return "right";
                      if ("right" === t) return "left";
                    }
                    return t;
                  },
                  defaultValue:
                    this.options.defaultTableCellProperties.horizontalAlignment,
                });
              const r = new Mm(t);
              return (
                r.set({
                  isCompact: !0,
                  ariaLabel: e("Vertical text alignment toolbar"),
                }),
                cS({
                  view: this,
                  icons: PS,
                  toolbar: r,
                  labels: this._verticalAlignmentLabels,
                  propertyName: "verticalAlignment",
                  defaultValue:
                    this.options.defaultTableCellProperties.verticalAlignment,
                }),
                {
                  horizontalAlignmentToolbar: o,
                  verticalAlignmentToolbar: r,
                  alignmentLabel: n,
                }
              );
            }
            _createActionButtons() {
              const t = this.locale,
                e = this.t,
                n = new nm(t),
                o = new nm(t),
                i = [
                  this.borderWidthInput,
                  this.borderColorInput,
                  this.backgroundInput,
                  this.paddingInput,
                ];
              return (
                n.set({
                  label: e("Save"),
                  icon: $h.check,
                  class: "ck-button-save",
                  type: "submit",
                  withText: !0,
                }),
                n
                  .bind("isEnabled")
                  .toMany(i, "errorText", (...t) => t.every((t) => !t)),
                o.set({
                  label: e("Cancel"),
                  icon: $h.cancel,
                  class: "ck-button-cancel",
                  withText: !0,
                }),
                o.delegate("execute").to(this, "cancel"),
                { saveButtonView: n, cancelButtonView: o }
              );
            }
            get _horizontalAlignmentLabels() {
              const t = this.locale,
                e = this.t,
                n = e("Align cell text to the left"),
                o = e("Align cell text to the center"),
                i = e("Align cell text to the right"),
                r = e("Justify cell text");
              return "rtl" === t.uiLanguageDirection
                ? { right: i, center: o, left: n, justify: r }
                : { left: n, center: o, right: i, justify: r };
            }
            get _verticalAlignmentLabels() {
              const t = this.t;
              return {
                top: t("Align cell text to the top"),
                middle: t("Align cell text to the middle"),
                bottom: t("Align cell text to the bottom"),
              };
            }
          }
          function RS(t) {
            return "none" !== t;
          }
          const OS = {
            borderStyle: "tableCellBorderStyle",
            borderColor: "tableCellBorderColor",
            borderWidth: "tableCellBorderWidth",
            height: "tableCellHeight",
            width: "tableCellWidth",
            padding: "tableCellPadding",
            backgroundColor: "tableCellBackgroundColor",
            horizontalAlignment: "tableCellHorizontalAlignment",
            verticalAlignment: "tableCellVerticalAlignment",
          };
          class jS extends j {
            static get requires() {
              return [vg];
            }
            static get pluginName() {
              return "TableCellPropertiesUI";
            }
            constructor(t) {
              super(t),
                t.config.define("table.tableCellProperties", {
                  borderColors: dS,
                  backgroundColors: dS,
                });
            }
            init() {
              const t = this.editor,
                e = t.t;
              (this._defaultTableCellProperties = VD(
                t.config.get("table.tableCellProperties.defaultProperties"),
                {
                  includeVerticalAlignmentProperty: !0,
                  includeHorizontalAlignmentProperty: !0,
                  includePaddingProperty: !0,
                  isRightToLeftContent:
                    "rtl" === t.locale.contentLanguageDirection,
                }
              )),
                (this._balloon = t.plugins.get(vg)),
                (this.view = this._createPropertiesView()),
                (this._undoStepBatch = null),
                t.ui.componentFactory.add("tableCellProperties", (n) => {
                  const o = new nm(n);
                  o.set({
                    label: e("Cell properties"),
                    icon: '<svg viewBox="0 0 20 20" xmlns="http://www.w3.org/2000/svg"><path d="m11.105 18-.17 1H2.5A1.5 1.5 0 0 1 1 17.5v-15A1.5 1.5 0 0 1 2.5 1h15A1.5 1.5 0 0 1 19 2.5v9.975l-.85-.124-.15-.302V8h-5v4h.021l-.172.351-1.916.28-.151.027c-.287.063-.54.182-.755.341L8 13v5h3.105zM2 12h5V8H2v4zm10-4H8v4h4V8zM2 2v5h5V2H2zm0 16h5v-5H2v5zM13 7h5V2h-5v5zM8 2v5h4V2H8z" opacity=".6"/><path d="m15.5 11.5 1.323 2.68 2.957.43-2.14 2.085.505 2.946L15.5 18.25l-2.645 1.39.505-2.945-2.14-2.086 2.957-.43L15.5 11.5zM13 6a1 1 0 0 1 1 1v3.172a2.047 2.047 0 0 0-.293.443l-.858 1.736-1.916.28-.151.027A1.976 1.976 0 0 0 9.315 14H7a1 1 0 0 1-1-1V7a1 1 0 0 1 1-1h6zm-1 2H8v4h4V8z"/></svg>',
                    tooltip: !0,
                  }),
                    this.listenTo(o, "execute", () => this._showView());
                  const i = Object.values(OS).map((e) => t.commands.get(e));
                  return (
                    o
                      .bind("isEnabled")
                      .toMany(i, "isEnabled", (...t) => t.some((t) => t)),
                    o
                  );
                });
            }
            destroy() {
              super.destroy(), this.view.destroy();
            }
            _createPropertiesView() {
              const t = this.editor,
                e = t.editing.view.document,
                n = t.config.get("table.tableCellProperties"),
                o = am(n.borderColors),
                i = sm(t.locale, o),
                r = am(n.backgroundColors),
                s = sm(t.locale, r),
                a = new LS(t.locale, {
                  borderColors: i,
                  backgroundColors: s,
                  defaultTableCellProperties: this._defaultTableCellProperties,
                }),
                l = t.t;
              a.render(),
                this.listenTo(a, "submit", () => {
                  this._hideView();
                }),
                this.listenTo(a, "cancel", () => {
                  this._undoStepBatch.operations.length &&
                    t.execute("undo", this._undoStepBatch),
                    this._hideView();
                }),
                a.keystrokes.set("Esc", (t, e) => {
                  this._hideView(), e();
                }),
                this.listenTo(t.ui, "update", () => {
                  zD(e.selection)
                    ? this._isViewVisible && DS(t, "cell")
                    : this._hideView();
                }),
                qh({
                  emitter: a,
                  activator: () => this._isViewInBalloon,
                  contextElements: [this._balloon.view.element],
                  callback: () => this._hideView(),
                });
              const c = oS(l),
                d = iS(l);
              return (
                a.on(
                  "change:borderStyle",
                  this._getPropertyChangeCallback(
                    "tableCellBorderStyle",
                    this._defaultTableCellProperties.borderStyle
                  )
                ),
                a.on(
                  "change:borderColor",
                  this._getValidatedPropertyChangeCallback({
                    viewField: a.borderColorInput,
                    commandName: "tableCellBorderColor",
                    errorText: c,
                    validator: rS,
                    defaultValue: this._defaultTableCellProperties.borderColor,
                  })
                ),
                a.on(
                  "change:borderWidth",
                  this._getValidatedPropertyChangeCallback({
                    viewField: a.borderWidthInput,
                    commandName: "tableCellBorderWidth",
                    errorText: d,
                    validator: aS,
                    defaultValue: this._defaultTableCellProperties.borderWidth,
                  })
                ),
                a.on(
                  "change:padding",
                  this._getValidatedPropertyChangeCallback({
                    viewField: a.paddingInput,
                    commandName: "tableCellPadding",
                    errorText: d,
                    validator: sS,
                    defaultValue: this._defaultTableCellProperties.padding,
                  })
                ),
                a.on(
                  "change:width",
                  this._getValidatedPropertyChangeCallback({
                    viewField: a.widthInput,
                    commandName: "tableCellWidth",
                    errorText: d,
                    validator: sS,
                    defaultValue: this._defaultTableCellProperties.width,
                  })
                ),
                a.on(
                  "change:height",
                  this._getValidatedPropertyChangeCallback({
                    viewField: a.heightInput,
                    commandName: "tableCellHeight",
                    errorText: d,
                    validator: sS,
                    defaultValue: this._defaultTableCellProperties.height,
                  })
                ),
                a.on(
                  "change:backgroundColor",
                  this._getValidatedPropertyChangeCallback({
                    viewField: a.backgroundInput,
                    commandName: "tableCellBackgroundColor",
                    errorText: c,
                    validator: rS,
                    defaultValue:
                      this._defaultTableCellProperties.backgroundColor,
                  })
                ),
                a.on(
                  "change:horizontalAlignment",
                  this._getPropertyChangeCallback(
                    "tableCellHorizontalAlignment",
                    this._defaultTableCellProperties.horizontalAlignment
                  )
                ),
                a.on(
                  "change:verticalAlignment",
                  this._getPropertyChangeCallback(
                    "tableCellVerticalAlignment",
                    this._defaultTableCellProperties.verticalAlignment
                  )
                ),
                a
              );
            }
            _fillViewFormFromCommandValues() {
              const t = this.editor.commands,
                e = t.get("tableCellBorderStyle");
              Object.entries(OS)
                .map(([e, n]) => {
                  const o = this._defaultTableCellProperties[e] || "";
                  return [e, t.get(n).value || o];
                })
                .forEach(([t, n]) => {
                  (("borderColor" !== t && "borderWidth" !== t) ||
                    "none" !== e.value) &&
                    this.view.set(t, n);
                });
            }
            _showView() {
              const t = this.editor;
              this._fillViewFormFromCommandValues(),
                this._balloon.add({ view: this.view, position: IS(t) }),
                (this._undoStepBatch = t.model.createBatch()),
                this.view.focus();
            }
            _hideView() {
              if (!this._isViewInBalloon) return;
              const t = this.editor;
              this.stopListening(t.ui, "update"),
                this.view.saveButtonView.focus(),
                this._balloon.remove(this.view),
                this.editor.editing.view.focus();
            }
            get _isViewVisible() {
              return this._balloon.visibleView === this.view;
            }
            get _isViewInBalloon() {
              return this._balloon.hasView(this.view);
            }
            _getPropertyChangeCallback(t, e) {
              return (n, o, i, r) => {
                (r || e !== i) &&
                  this.editor.execute(t, {
                    value: i,
                    batch: this._undoStepBatch,
                  });
              };
            }
            _getValidatedPropertyChangeCallback(t) {
              const {
                  commandName: e,
                  viewField: n,
                  validator: o,
                  errorText: i,
                  defaultValue: r,
                } = t,
                s = Zs(() => {
                  n.errorText = i;
                }, 500);
              return (t, i, a, l) => {
                s.cancel(),
                  (l || r !== a) &&
                    (o(a)
                      ? (this.editor.execute(e, {
                          value: a,
                          batch: this._undoStepBatch,
                        }),
                        (n.errorText = null))
                      : s());
              };
            }
          }
          class VS extends F {
            constructor(t, e, n) {
              super(t), (this.attributeName = e), (this._defaultValue = n);
            }
            refresh() {
              const t = this.editor,
                e = this.editor.plugins
                  .get("TableUtils")
                  .getSelectionAffectedTableCells(t.model.document.selection);
              (this.isEnabled = !!e.length),
                (this.value = this._getSingleValue(e));
            }
            execute(t = {}) {
              const { value: e, batch: n } = t,
                o = this.editor.model,
                i = this.editor.plugins
                  .get("TableUtils")
                  .getSelectionAffectedTableCells(o.document.selection),
                r = this._getValueToSet(e);
              o.enqueueChange(n, (t) => {
                r
                  ? i.forEach((e) => t.setAttribute(this.attributeName, r, e))
                  : i.forEach((e) => t.removeAttribute(this.attributeName, e));
              });
            }
            _getAttribute(t) {
              if (!t) return;
              const e = t.getAttribute(this.attributeName);
              return e !== this._defaultValue ? e : void 0;
            }
            _getValueToSet(t) {
              if (t !== this._defaultValue) return t;
            }
            _getSingleValue(t) {
              const e = this._getAttribute(t[0]);
              return t.every((t) => this._getAttribute(t) === e) ? e : void 0;
            }
          }
          class FS extends VS {
            constructor(t, e) {
              super(t, "tableCellWidth", e);
            }
            _getValueToSet(t) {
              if ((t = jD(t, "px")) !== this._defaultValue) return t;
            }
          }
          class HS extends j {
            static get pluginName() {
              return "TableCellWidthEditing";
            }
            static get requires() {
              return [hD];
            }
            init() {
              const t = this.editor,
                e = VD(
                  t.config.get("table.tableCellProperties.defaultProperties")
                );
              hE(t.model.schema, t.conversion, {
                modelAttribute: "tableCellWidth",
                styleName: "width",
                defaultValue: e.width,
              }),
                t.commands.add("tableCellWidth", new FS(t, e.width));
            }
          }
          class US extends VS {
            constructor(t, e) {
              super(t, "tableCellPadding", e);
            }
            _getAttribute(t) {
              if (!t) return;
              const e = OD(t.getAttribute(this.attributeName));
              return e !== this._defaultValue ? e : void 0;
            }
            _getValueToSet(t) {
              if ((t = jD(t, "px")) !== this._defaultValue) return t;
            }
          }
          class WS extends VS {
            constructor(t, e) {
              super(t, "tableCellHeight", e);
            }
            _getValueToSet(t) {
              return (t = jD(t, "px")) === this._defaultValue ? null : t;
            }
          }
          class $S extends VS {
            constructor(t, e) {
              super(t, "tableCellBackgroundColor", e);
            }
          }
          class qS extends VS {
            constructor(t, e) {
              super(t, "tableCellVerticalAlignment", e);
            }
          }
          class GS extends VS {
            constructor(t, e) {
              super(t, "tableCellHorizontalAlignment", e);
            }
          }
          class ZS extends VS {
            constructor(t, e) {
              super(t, "tableCellBorderStyle", e);
            }
            _getAttribute(t) {
              if (!t) return;
              const e = OD(t.getAttribute(this.attributeName));
              return e !== this._defaultValue ? e : void 0;
            }
          }
          class YS extends VS {
            constructor(t, e) {
              super(t, "tableCellBorderColor", e);
            }
            _getAttribute(t) {
              if (!t) return;
              const e = OD(t.getAttribute(this.attributeName));
              return e !== this._defaultValue ? e : void 0;
            }
          }
          class KS extends VS {
            constructor(t, e) {
              super(t, "tableCellBorderWidth", e);
            }
            _getAttribute(t) {
              if (!t) return;
              const e = OD(t.getAttribute(this.attributeName));
              return e !== this._defaultValue ? e : void 0;
            }
            _getValueToSet(t) {
              if ((t = jD(t, "px")) !== this._defaultValue) return t;
            }
          }
          const QS = /^(top|middle|bottom)$/,
            JS = /^(left|center|right|justify)$/;
          class XS extends j {
            static get pluginName() {
              return "TableCellPropertiesEditing";
            }
            static get requires() {
              return [hD, HS];
            }
            init() {
              const t = this.editor,
                e = t.model.schema,
                n = t.conversion;
              t.config.define(
                "table.tableCellProperties.defaultProperties",
                {}
              );
              const o = VD(
                t.config.get("table.tableCellProperties.defaultProperties"),
                {
                  includeVerticalAlignmentProperty: !0,
                  includeHorizontalAlignmentProperty: !0,
                  includePaddingProperty: !0,
                  isRightToLeftContent:
                    "rtl" === t.locale.contentLanguageDirection,
                }
              );
              t.data.addStyleProcessorRules(Su),
                (function (t, e, n) {
                  const o = {
                    width: "tableCellBorderWidth",
                    color: "tableCellBorderColor",
                    style: "tableCellBorderStyle",
                  };
                  t.extend("tableCell", { allowAttributes: Object.values(o) }),
                    rE(e, "td", o, n),
                    rE(e, "th", o, n),
                    sE(e, {
                      modelElement: "tableCell",
                      modelAttribute: o.style,
                      styleName: "border-style",
                    }),
                    sE(e, {
                      modelElement: "tableCell",
                      modelAttribute: o.color,
                      styleName: "border-color",
                    }),
                    sE(e, {
                      modelElement: "tableCell",
                      modelAttribute: o.width,
                      styleName: "border-width",
                    });
                })(e, n, {
                  color: o.borderColor,
                  style: o.borderStyle,
                  width: o.borderWidth,
                }),
                t.commands.add(
                  "tableCellBorderStyle",
                  new ZS(t, o.borderStyle)
                ),
                t.commands.add(
                  "tableCellBorderColor",
                  new YS(t, o.borderColor)
                ),
                t.commands.add(
                  "tableCellBorderWidth",
                  new KS(t, o.borderWidth)
                ),
                hE(e, n, {
                  modelAttribute: "tableCellHeight",
                  styleName: "height",
                  defaultValue: o.height,
                }),
                t.commands.add("tableCellHeight", new WS(t, o.height)),
                t.data.addStyleProcessorRules(ju),
                hE(e, n, {
                  modelAttribute: "tableCellPadding",
                  styleName: "padding",
                  reduceBoxSides: !0,
                  defaultValue: o.padding,
                }),
                t.commands.add("tableCellPadding", new US(t, o.padding)),
                t.data.addStyleProcessorRules(Du),
                hE(e, n, {
                  modelAttribute: "tableCellBackgroundColor",
                  styleName: "background-color",
                  defaultValue: o.backgroundColor,
                }),
                t.commands.add(
                  "tableCellBackgroundColor",
                  new $S(t, o.backgroundColor)
                ),
                (function (t, e, n) {
                  t.extend("tableCell", {
                    allowAttributes: ["tableCellHorizontalAlignment"],
                  }),
                    e
                      .for("downcast")
                      .attributeToAttribute({
                        model: {
                          name: "tableCell",
                          key: "tableCellHorizontalAlignment",
                        },
                        view: (t) => ({
                          key: "style",
                          value: { "text-align": t },
                        }),
                      }),
                    e
                      .for("upcast")
                      .attributeToAttribute({
                        view: {
                          name: /^(td|th)$/,
                          styles: { "text-align": JS },
                        },
                        model: {
                          key: "tableCellHorizontalAlignment",
                          value: (t) => {
                            const e = t.getStyle("text-align");
                            return e === n ? null : e;
                          },
                        },
                      })
                      .attributeToAttribute({
                        view: { name: /^(td|th)$/, attributes: { align: JS } },
                        model: {
                          key: "tableCellHorizontalAlignment",
                          value: (t) => {
                            const e = t.getAttribute("align");
                            return e === n ? null : e;
                          },
                        },
                      });
                })(e, n, o.horizontalAlignment),
                t.commands.add(
                  "tableCellHorizontalAlignment",
                  new GS(t, o.horizontalAlignment)
                ),
                (function (t, e, n) {
                  t.extend("tableCell", {
                    allowAttributes: ["tableCellVerticalAlignment"],
                  }),
                    e
                      .for("downcast")
                      .attributeToAttribute({
                        model: {
                          name: "tableCell",
                          key: "tableCellVerticalAlignment",
                        },
                        view: (t) => ({
                          key: "style",
                          value: { "vertical-align": t },
                        }),
                      }),
                    e
                      .for("upcast")
                      .attributeToAttribute({
                        view: {
                          name: /^(td|th)$/,
                          styles: { "vertical-align": QS },
                        },
                        model: {
                          key: "tableCellVerticalAlignment",
                          value: (t) => {
                            const e = t.getStyle("vertical-align");
                            return e === n ? null : e;
                          },
                        },
                      })
                      .attributeToAttribute({
                        view: { name: /^(td|th)$/, attributes: { valign: QS } },
                        model: {
                          key: "tableCellVerticalAlignment",
                          value: (t) => {
                            const e = t.getAttribute("valign");
                            return e === n ? null : e;
                          },
                        },
                      });
                })(e, n, o.verticalAlignment),
                t.commands.add(
                  "tableCellVerticalAlignment",
                  new qS(t, o.verticalAlignment)
                );
            }
          }
          const tI = "underline";
          class eI extends j {
            static get pluginName() {
              return "UnderlineEditing";
            }
            init() {
              const t = this.editor;
              t.model.schema.extend("$text", { allowAttributes: tI }),
                t.model.schema.setAttributeProperties(tI, {
                  isFormatting: !0,
                  copyOnEnter: !0,
                }),
                t.conversion.attributeToElement({
                  model: tI,
                  view: "u",
                  upcastAlso: { styles: { "text-decoration": "underline" } },
                }),
                t.commands.add(tI, new $k(t, tI)),
                t.keystrokes.set("CTRL+U", "underline");
            }
          }
          const nI = "underline";
          class oI extends j {
            static get pluginName() {
              return "UnderlineUI";
            }
            init() {
              const t = this.editor,
                e = t.t;
              t.ui.componentFactory.add(nI, (n) => {
                const o = t.commands.get(nI),
                  i = new nm(n);
                return (
                  i.set({
                    label: e("Underline"),
                    icon: '<svg viewBox="0 0 20 20" xmlns="http://www.w3.org/2000/svg"><path d="M3 18v-1.5h14V18zm2.2-8V3.6c0-.4.4-.6.8-.6.3 0 .7.2.7.6v6.2c0 2 1.3 2.8 3.2 2.8 1.9 0 3.4-.9 3.4-2.9V3.6c0-.3.4-.5.8-.5.3 0 .7.2.7.5V10c0 2.7-2.2 4-4.9 4-2.6 0-4.7-1.2-4.7-4z"/></svg>',
                    keystroke: "CTRL+U",
                    tooltip: !0,
                    isToggleable: !0,
                  }),
                  i.bind("isOn", "isEnabled").to(o, "value", "isEnabled"),
                  this.listenTo(i, "execute", () => {
                    t.execute(nI), t.editing.view.focus();
                  }),
                  i
                );
              });
            }
          }
          class iI extends Lg {}
          (iI.builtinPlugins = [
            class extends j {
              static get requires() {
                return [Ug, $g];
              }
              static get pluginName() {
                return "Alignment";
              }
            },
            class extends j {
              static get requires() {
                return [rp];
              }
              static get pluginName() {
                return "Autoformat";
              }
              afterInit() {
                this._addListAutoformats(),
                  this._addBasicStylesAutoformats(),
                  this._addHeadingAutoformats(),
                  this._addBlockQuoteAutoformats(),
                  this._addCodeBlockAutoformats(),
                  this._addHorizontalLineAutoformats();
              }
              _addListAutoformats() {
                const t = this.editor.commands;
                t.get("bulletedList") &&
                  Dp(this.editor, this, /^[*-]\s$/, "bulletedList"),
                  t.get("numberedList") &&
                    Dp(this.editor, this, /^1[.|)]\s$/, "numberedList"),
                  t.get("todoList") &&
                    Dp(this.editor, this, /^\[\s?\]\s$/, "todoList"),
                  t.get("checkTodoList") &&
                    Dp(this.editor, this, /^\[\s?x\s?\]\s$/, () => {
                      this.editor.execute("todoList"),
                        this.editor.execute("checkTodoList");
                    });
              }
              _addBasicStylesAutoformats() {
                const t = this.editor.commands;
                if (t.get("bold")) {
                  const t = Tp(this.editor, "bold");
                  Sp(this.editor, this, /(?:^|\s)(\*\*)([^*]+)(\*\*)$/g, t),
                    Sp(this.editor, this, /(?:^|\s)(__)([^_]+)(__)$/g, t);
                }
                if (t.get("italic")) {
                  const t = Tp(this.editor, "italic");
                  Sp(this.editor, this, /(?:^|\s)(\*)([^*_]+)(\*)$/g, t),
                    Sp(this.editor, this, /(?:^|\s)(_)([^_]+)(_)$/g, t);
                }
                if (t.get("code")) {
                  const t = Tp(this.editor, "code");
                  Sp(this.editor, this, /(`)([^`]+)(`)$/g, t);
                }
                if (t.get("strikethrough")) {
                  const t = Tp(this.editor, "strikethrough");
                  Sp(this.editor, this, /(~~)([^~]+)(~~)$/g, t);
                }
              }
              _addHeadingAutoformats() {
                const t = this.editor.commands.get("heading");
                t &&
                  t.modelElements
                    .filter((t) => t.match(/^heading[1-6]$/))
                    .forEach((e) => {
                      const n = e[7],
                        o = new RegExp(`^(#{${n}})\\s$`);
                      Dp(this.editor, this, o, () => {
                        if (!t.isEnabled || t.value === e) return !1;
                        this.editor.execute("heading", { value: e });
                      });
                    });
              }
              _addBlockQuoteAutoformats() {
                this.editor.commands.get("blockQuote") &&
                  Dp(this.editor, this, /^>\s$/, "blockQuote");
              }
              _addCodeBlockAutoformats() {
                const t = this.editor,
                  e = t.model.document.selection;
                t.commands.get("codeBlock") &&
                  Dp(t, this, /^```$/, () => {
                    if (e.getFirstPosition().parent.is("element", "listItem"))
                      return !1;
                    this.editor.execute("codeBlock", {
                      usePreviousLanguageChoice: !0,
                    });
                  });
              }
              _addHorizontalLineAutoformats() {
                this.editor.commands.get("horizontalLine") &&
                  Dp(this.editor, this, /^---$/, "horizontalLine");
              }
            },
            class extends j {
              static get requires() {
                return [Sf, Jf, Of, rp];
              }
              static get pluginName() {
                return "AutoImage";
              }
              constructor(t) {
                super(t),
                  (this._timeoutId = null),
                  (this._positionToInsert = null);
              }
              init() {
                const t = this.editor,
                  e = t.model.document;
                this.listenTo(
                  t.plugins.get("ClipboardPipeline"),
                  "inputTransformation",
                  () => {
                    const t = e.selection.getFirstRange(),
                      n = yd.fromPosition(t.start);
                    n.stickiness = "toPrevious";
                    const o = yd.fromPosition(t.end);
                    (o.stickiness = "toNext"),
                      e.once(
                        "change:data",
                        () => {
                          this._embedImageBetweenPositions(n, o),
                            n.detach(),
                            o.detach();
                        },
                        { priority: "high" }
                      );
                  }
                ),
                  t.commands.get("undo").on(
                    "execute",
                    () => {
                      this._timeoutId &&
                        (wo.window.clearTimeout(this._timeoutId),
                        this._positionToInsert.detach(),
                        (this._timeoutId = null),
                        (this._positionToInsert = null));
                    },
                    { priority: "high" }
                  );
              }
              _embedImageBetweenPositions(t, e) {
                const n = this.editor,
                  o = new xl(t, e),
                  i = o.getWalker({ ignoreElementEnd: !0 }),
                  r = Object.fromEntries(
                    n.model.document.selection.getAttributes()
                  ),
                  s = this.editor.plugins.get("ImageUtils");
                let a = "";
                for (const t of i)
                  t.item.is("$textProxy") && (a += t.item.data);
                (a = a.trim()),
                  a.match(tk)
                    ? ((this._positionToInsert = yd.fromPosition(t)),
                      (this._timeoutId = wo.window.setTimeout(() => {
                        n.commands.get("insertImage").isEnabled
                          ? (n.model.change((t) => {
                              let e;
                              (this._timeoutId = null),
                                t.remove(o),
                                o.detach(),
                                "$graveyard" !==
                                  this._positionToInsert.root.rootName &&
                                  (e = this._positionToInsert.toPosition()),
                                s.insertImage({ ...r, src: a }, e),
                                this._positionToInsert.detach(),
                                (this._positionToInsert = null);
                            }),
                            n.plugins.get("Delete").requestUndoOnBackspace())
                          : o.detach();
                      }, 100)))
                    : o.detach();
              }
            },
            Mk,
            class extends j {
              static get requires() {
                return [Fk, Wk];
              }
              static get pluginName() {
                return "BlockQuote";
              }
            },
            class extends j {
              static get requires() {
                return [Gk, Yk];
              }
              static get pluginName() {
                return "Bold";
              }
            },
            class extends xo {
              static get pluginName() {
                return "CloudServices";
              }
              static get requires() {
                return [ob];
              }
              init() {
                const t = this.context.config.get("cloudServices") || {};
                for (const e in t) this[e] = t[e];
                if (((this._tokens = new Map()), this.tokenUrl))
                  return (
                    (this.token = this.context.plugins
                      .get("CloudServicesCore")
                      .createToken(this.tokenUrl)),
                    this._tokens.set(this.tokenUrl, this.token),
                    this.token.init()
                  );
                this.token = null;
              }
              registerTokenUrl(t) {
                if (this._tokens.has(t))
                  return Promise.resolve(this.getTokenFor(t));
                const e = this.context.plugins
                  .get("CloudServicesCore")
                  .createToken(t);
                return this._tokens.set(t, e), e.init();
              }
              getTokenFor(t) {
                const e = this._tokens.get(t);
                if (!e) throw new l("cloudservices-token-not-registered", this);
                return e;
              }
              destroy() {
                super.destroy();
                for (const t of this._tokens.values()) t.destroy();
              }
            },
            class extends j {
              static get requires() {
                return [rb, cb];
              }
              static get pluginName() {
                return "Code";
              }
            },
            class extends j {
              static get requires() {
                return [Cb, Db];
              }
              static get pluginName() {
                return "CodeBlock";
              }
            },
            class extends j {
              static get requires() {
                return [Sf, Vp, Nb, Lk, sp, Of];
              }
              static get pluginName() {
                return "Essentials";
              }
            },
            class extends j {
              static get requires() {
                return [Jb, jb];
              }
              static get pluginName() {
                return "FindAndReplace";
              }
              init() {
                const t = this.editor.plugins.get("FindAndReplaceUI"),
                  e = this.editor.plugins.get("FindAndReplaceEditing"),
                  n = e.state;
                t.on("findNext", (t, e) => {
                  e
                    ? ((n.searchText = e.searchText),
                      this.editor.execute("find", e.searchText, e))
                    : this.editor.execute("findNext");
                }),
                  t.on("findPrevious", (t, e) => {
                    e && n.searchText !== e.searchText
                      ? this.editor.execute("find", e.searchText)
                      : this.editor.execute("findPrevious");
                  }),
                  t.on("replace", (t, e) => {
                    n.searchText !== e.searchText &&
                      this.editor.execute("find", e.searchText);
                    const o = n.highlightedResult;
                    o && this.editor.execute("replace", e.replaceText, o);
                  }),
                  t.on("replaceAll", (t, e) => {
                    n.searchText !== e.searchText &&
                      this.editor.execute("find", e.searchText),
                      this.editor.execute(
                        "replaceAll",
                        e.replaceText,
                        n.results
                      );
                  }),
                  t.on("searchReseted", () => {
                    n.clear(this.editor.model), e.stop();
                  });
              }
            },
            class extends j {
              static get requires() {
                return [cw, uw];
              }
              static get pluginName() {
                return "FontBackgroundColor";
              }
            },
            class extends j {
              static get requires() {
                return [mw, gw];
              }
              static get pluginName() {
                return "FontColor";
              }
            },
            class extends j {
              static get pluginName() {
                return "FullScreen";
              }
              constructor(t) {
                super(t), this.set("isFullScreen", !1), (this.styles = {});
              }
              init() {
                const t = this.editor,
                  e = t.t,
                  n = t.editing.view.document.getRoot();
                t.config.define(pw, !0), t.config.define(fw, !0);
                const o = () => {
                    const e = t.ui.view.element;
                    e.setAttribute("tabindex", "0"),
                      e.classList.add("ck-plugin-full-screen"),
                      (this.styles = {
                        height: n.getStyle("height"),
                        "overflow-y": n.getStyle("overflow-y"),
                      }),
                      t.editing.view.change((t) => {
                        t.setStyle(
                          { height: "100%", "overflow-y": "scroll" },
                          n
                        );
                      });
                  },
                  i = () => {
                    const e = t.ui.view.element;
                    e.removeAttribute("tabindex"),
                      e.classList.remove("ck-plugin-full-screen"),
                      t.editing.view.change((t) => {
                        this._restoreStyles(t, n);
                      });
                  };
                t.ui.componentFactory.add("fullscreen", () => {
                  const n = t.ui.view.element,
                    r = new nm();
                  r.set({
                    label: e("Full screen"),
                    icon: '\x3c!-- https://github.com/astrit/css.gg/blob/master/icons/svg/maximize-alt.svg --\x3e\n<svg width="24px" height="24px" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">\n<path d="M3 3H9V5H6.46173L11.3047 9.84298L9.8905 11.2572L5 6.3667V9H3V3Z" fill="black"/>\n<path d="M3 21H9V19H6.3764L11.3046 14.0718L9.89038 12.6576L5 17.548V15H3V21Z" fill="black"/>\n<path d="M15 21H21V15H19V17.5244L14.1332 12.6576L12.719 14.0718L17.6472 19H15V21Z" fill="black"/>\n<path d="M21 3H15V5H17.5619L12.7189 9.84301L14.1331 11.2572L19 6.39032V9H21V3Z" fill="black"/>\n</svg>\n',
                    tooltip: !0,
                  }),
                    r.bind("isOn").to(this, "isFullScreen");
                  const s = t.config.get(pw),
                    a = t.config.get(fw),
                    l = (t) => {
                      "Escape" === t.key &&
                        this.isFullScreen &&
                        (r.fire("execute"), t.stopPropagation());
                    },
                    c = (t) => {
                      t.target === t.currentTarget &&
                        this.isFullScreen &&
                        (r.fire("execute"), t.stopPropagation());
                    };
                  return (
                    r.on("execute", () => {
                      this.isFullScreen
                        ? (s && n.removeEventListener("keydown", l),
                          a && n.removeEventListener("click", c),
                          i())
                        : (s && n.addEventListener("keydown", l),
                          a && n.addEventListener("click", c),
                          o()),
                        (this.isFullScreen = !this.isFullScreen),
                        t.editing.view.focus();
                    }),
                    r
                  );
                });
              }
              _restoreStyle(t, e, n, o) {
                void 0 !== n ? t.setStyle(e, n, o) : t.removeStyle(e, o);
              }
              _restoreStyles(t, e) {
                this._restoreStyle(t, "height", this.styles.height, e),
                  this._restoreStyle(
                    t,
                    "overflow-y",
                    this.styles["overflow-y"],
                    e
                  );
              }
            },
            class extends j {
              static get pluginName() {
                return "GeneralHtmlSupport";
              }
              static get requires() {
                return [Hw, Yw, Kw, Qw, Jw, tA, eA, nA, oA, iA, sA];
              }
              init() {
                const t = this.editor,
                  e = t.plugins.get(Hw);
                e.loadAllowedConfig(t.config.get("htmlSupport.allow") || []),
                  e.loadDisallowedConfig(
                    t.config.get("htmlSupport.disallow") || []
                  );
              }
              getGhsAttributeNameForElement(t) {
                const e = this.editor.plugins.get("DataSchema"),
                  n = Array.from(e.getDefinitionsForView(t, !1));
                return n && n.length && n[0].isInline && !n[0].isObject
                  ? n[0].model
                  : "htmlAttributes";
              }
              addModelHtmlClass(t, e, n) {
                const o = this.editor.model,
                  i = this.getGhsAttributeNameForElement(t);
                o.change((t) => {
                  for (const r of aA(o, n, i))
                    lA(t, r, i, "classes", (t) => {
                      for (const n of ko(e)) t.add(n);
                    });
                });
              }
              removeModelHtmlClass(t, e, n) {
                const o = this.editor.model,
                  i = this.getGhsAttributeNameForElement(t);
                o.change((t) => {
                  for (const r of aA(o, n, i))
                    lA(t, r, i, "classes", (t) => {
                      for (const n of ko(e)) t.delete(n);
                    });
                });
              }
              setModelHtmlAttributes(t, e, n) {
                const o = this.editor.model,
                  i = this.getGhsAttributeNameForElement(t);
                o.change((t) => {
                  for (const r of aA(o, n, i))
                    lA(t, r, i, "attributes", (t) => {
                      for (const [n, o] of Object.entries(e)) t.set(n, o);
                    });
                });
              }
              removeModelHtmlAttributes(t, e, n) {
                const o = this.editor.model,
                  i = this.getGhsAttributeNameForElement(t);
                o.change((t) => {
                  for (const r of aA(o, n, i))
                    lA(t, r, i, "attributes", (t) => {
                      for (const n of ko(e)) t.delete(n);
                    });
                });
              }
              setModelHtmlStyles(t, e, n) {
                const o = this.editor.model,
                  i = this.getGhsAttributeNameForElement(t);
                o.change((t) => {
                  for (const r of aA(o, n, i))
                    lA(t, r, i, "styles", (t) => {
                      for (const [n, o] of Object.entries(e)) t.set(n, o);
                    });
                });
              }
              removeModelHtmlStyles(t, e, n) {
                const o = this.editor.model,
                  i = this.getGhsAttributeNameForElement(t);
                o.change((t) => {
                  for (const r of aA(o, n, i))
                    lA(t, r, i, "styles", (t) => {
                      for (const n of ko(e)) t.delete(n);
                    });
                });
              }
            },
            class extends j {
              static get requires() {
                return [fA, wA];
              }
              static get pluginName() {
                return "Heading";
              }
            },
            class extends j {
              static get requires() {
                return [vA, yA, kf];
              }
              static get pluginName() {
                return "HorizontalLine";
              }
            },
            class extends j {
              static get requires() {
                return [IA, MA, kf];
              }
              static get pluginName() {
                return "HtmlEmbed";
              }
            },
            class extends j {
              static get requires() {
                return [YA, QA];
              }
              static get pluginName() {
                return "Image";
              }
            },
            qA,
            class extends j {
              static get requires() {
                return [t_, e_];
              }
              static get pluginName() {
                return "ImageCaption";
              }
            },
            WA,
            h_,
            class extends j {
              static get pluginName() {
                return "ImageInsert";
              }
              static get requires() {
                return [O_, h_, u_];
              }
            },
            class extends j {
              static get requires() {
                return [V_, q_, H_];
              }
              static get pluginName() {
                return "ImageResize";
              }
            },
            class extends j {
              static get requires() {
                return [cC, hC];
              }
              static get pluginName() {
                return "ImageStyle";
              }
            },
            class extends j {
              static get requires() {
                return [jf, Jf];
              }
              static get pluginName() {
                return "ImageToolbar";
              }
              afterInit() {
                const t = this.editor,
                  e = t.t,
                  n = t.plugins.get(jf),
                  o = t.plugins.get("ImageUtils");
                var i;
                n.register("image", {
                  ariaLabel: e("Image toolbar"),
                  items:
                    ((i = t.config.get("image.toolbar") || []),
                    i.map((t) => (E(t) ? t.name : t))),
                  getRelatedElement: (t) => o.getClosestSelectedImageWidget(t),
                });
              }
            },
            O_,
            Jf,
            class extends j {
              static get pluginName() {
                return "Indent";
              }
              static get requires() {
                return [fC, wC];
              }
            },
            class extends j {
              constructor(t) {
                super(t),
                  t.config.define("indentBlock", { offset: 40, unit: "px" });
              }
              static get pluginName() {
                return "IndentBlock";
              }
              init() {
                const t = this.editor,
                  e = t.config.get("indentBlock"),
                  n = !e.classes || !e.classes.length,
                  o = Object.assign({ direction: "forward" }, e),
                  i = Object.assign({ direction: "backward" }, e);
                n
                  ? (t.data.addStyleProcessorRules(Ou),
                    this._setupConversionUsingOffset(t.conversion),
                    t.commands.add("indentBlock", new AC(t, new _C(o))),
                    t.commands.add("outdentBlock", new AC(t, new _C(i))))
                  : (this._setupConversionUsingClasses(e.classes),
                    t.commands.add("indentBlock", new AC(t, new CC(o))),
                    t.commands.add("outdentBlock", new AC(t, new CC(i))));
              }
              afterInit() {
                const t = this.editor,
                  e = t.model.schema,
                  n = t.commands.get("indent"),
                  o = t.commands.get("outdent"),
                  i = t.config.get("heading.options");
                ((i && i.map((t) => t.model)) || vC).forEach((t) => {
                  e.isRegistered(t) &&
                    e.extend(t, { allowAttributes: "blockIndent" });
                }),
                  e.setAttributeProperties("blockIndent", { isFormatting: !0 }),
                  n.registerChildCommand(t.commands.get("indentBlock")),
                  o.registerChildCommand(t.commands.get("outdentBlock"));
              }
              _setupConversionUsingOffset() {
                const t = this.editor.conversion,
                  e =
                    "rtl" === this.editor.locale.contentLanguageDirection
                      ? "margin-right"
                      : "margin-left";
                t
                  .for("upcast")
                  .attributeToAttribute({
                    view: { styles: { [e]: /[\s\S]+/ } },
                    model: { key: "blockIndent", value: (t) => t.getStyle(e) },
                  }),
                  t
                    .for("downcast")
                    .attributeToAttribute({
                      model: "blockIndent",
                      view: (t) => ({ key: "style", value: { [e]: t } }),
                    });
              }
              _setupConversionUsingClasses(t) {
                const e = {
                  model: { key: "blockIndent", values: [] },
                  view: {},
                };
                for (const n of t)
                  e.model.values.push(n),
                    (e.view[n] = { key: "class", value: [n] });
                this.editor.conversion.attributeToAttribute(e);
              }
            },
            class extends j {
              static get requires() {
                return [xC, DC];
              }
              static get pluginName() {
                return "Italic";
              }
            },
            class extends j {
              static get requires() {
                return [LC, ZC, Mk];
              }
              static get pluginName() {
                return "Link";
              }
            },
            class extends j {
              static get requires() {
                return [KC, XC];
              }
              static get pluginName() {
                return "LinkImage";
              }
            },
            class extends j {
              static get requires() {
                return [Ev, Sv];
              }
              static get pluginName() {
                return "List";
              }
            },
            class extends j {
              constructor(t) {
                super(t), (t.data.processor = new nx(t.data.viewDocument));
              }
              static get pluginName() {
                return "Markdown";
              }
            },
            class extends j {
              static get requires() {
                return [hx, bx, gx, kf];
              }
              static get pluginName() {
                return "MediaEmbed";
              }
            },
            hA,
            class extends j {
              static get pluginName() {
                return "PasteFromOffice";
              }
              static get requires() {
                return [zp];
              }
              init() {
                const t = this.editor,
                  e = t.editing.view.document,
                  n = [];
                n.push(new Nx(e)),
                  n.push(new Sx(e)),
                  t.plugins.get("ClipboardPipeline").on(
                    "inputTransformation",
                    (o, i) => {
                      if (i._isTransformedWithPasteFromOffice) return;
                      if (
                        t.model.document.selection
                          .getFirstPosition()
                          .parent.is("element", "codeBlock")
                      )
                        return;
                      const r = i.dataTransfer.getData("text/html"),
                        s = n.find((t) => t.isActive(r));
                      s &&
                        ((i._parsedData = Px(r, e.stylesProcessor)),
                        s.execute(i),
                        (i._isTransformedWithPasteFromOffice = !0));
                    },
                    { priority: "high" }
                  );
              }
            },
            class extends j {
              static get requires() {
                return [jx, Rx];
              }
              static get pluginName() {
                return "RemoveFormat";
              }
            },
            class extends j {
              static get requires() {
                return [g_];
              }
              static get pluginName() {
                return "SimpleUploadAdapter";
              }
              init() {
                const t = this.editor.config.get("simpleUpload");
                t &&
                  (t.uploadUrl
                    ? (this.editor.plugins.get(g_).createUploadAdapter = (e) =>
                        new b_(e, t))
                    : c("simple-upload-adapter-missing-uploadurl"));
              }
            },
            class extends j {
              static get pluginName() {
                return "SourceEditing";
              }
              static get requires() {
                return [Wh];
              }
              constructor(t) {
                super(t),
                  this.set("isSourceEditingMode", !1),
                  (this._elementReplacer = new xa()),
                  (this._replacedRoots = new Map()),
                  (this._dataFromRoots = new Map());
              }
              init() {
                const t = this.editor,
                  e = t.t;
                t.ui.componentFactory.add("sourceEditing", (n) => {
                  const o = new nm(n);
                  return (
                    o.set({
                      label: e("Source"),
                      icon: '<svg viewBox="0 0 20 20" xmlns="http://www.w3.org/2000/svg"><path d="m12.5 0 5 4.5v15.003h-16V0h11zM3 1.5v3.25l-1.497 1-.003 8 1.5 1v3.254L7.685 18l-.001 1.504H17.5V8.002L16 9.428l-.004-4.22-4.222-3.692L3 1.5z"/><path d="M4.06 6.64a.75.75 0 0 1 .958 1.15l-.085.07L2.29 9.75l2.646 1.89c.302.216.4.62.232.951l-.058.095a.75.75 0 0 1-.951.232l-.095-.058-3.5-2.5V9.14l3.496-2.5zm4.194 6.22a.75.75 0 0 1-.958-1.149l.085-.07 2.643-1.89-2.646-1.89a.75.75 0 0 1-.232-.952l.058-.095a.75.75 0 0 1 .95-.232l.096.058 3.5 2.5v1.22l-3.496 2.5zm7.644-.836 2.122 2.122-5.825 5.809-2.125-.005.003-2.116zm2.539-1.847 1.414 1.414a.5.5 0 0 1 0 .707l-1.06 1.06-2.122-2.12 1.061-1.061a.5.5 0 0 1 .707 0z"/></svg>',
                      tooltip: !0,
                      withText: !0,
                      class: "ck-source-editing-button",
                    }),
                    o.bind("isOn").to(this, "isSourceEditingMode"),
                    o
                      .bind("isEnabled")
                      .to(
                        this,
                        "isEnabled",
                        t,
                        "isReadOnly",
                        t.plugins.get(Wh),
                        "hasAny",
                        (t, e, n) => !!t && !e && !n
                      ),
                    this.listenTo(o, "execute", () => {
                      this.isSourceEditingMode = !this.isSourceEditingMode;
                    }),
                    o
                  );
                }),
                  this._isAllowedToHandleSourceEditingMode() &&
                    (this.on("change:isSourceEditingMode", (t, e, n) => {
                      n
                        ? (this._showSourceEditing(), this._disableCommands())
                        : (this._hideSourceEditing(), this._enableCommands());
                    }),
                    this.on("change:isEnabled", (t, e, n) =>
                      this._handleReadOnlyMode(!n)
                    ),
                    this.listenTo(t, "change:isReadOnly", (t, e, n) =>
                      this._handleReadOnlyMode(n)
                    )),
                  t.data.on(
                    "get",
                    () => {
                      this.isSourceEditingMode && this._updateEditorData();
                    },
                    { priority: "high" }
                  );
              }
              afterInit() {
                const t = this.editor;
                [
                  "RealTimeCollaborativeEditing",
                  "CommentsEditing",
                  "TrackChangesEditing",
                  "RevisionHistory",
                ].some((e) => t.plugins.has(e)) &&
                  console.warn(
                    "You initialized the editor with the source editing feature and at least one of the collaboration features. Please be advised that the source editing feature may not work, and be careful when editing document source that contains markers created by the collaboration features."
                  ),
                  t.plugins.has("RestrictedEditingModeEditing") &&
                    console.warn(
                      "You initialized the editor with the source editing feature and restricted editing feature. Please be advised that the source editing feature may not work, and be careful when editing document source that contains markers created by the restricted editing feature."
                    );
              }
              _showSourceEditing() {
                const t = this.editor,
                  e = t.editing.view,
                  n = t.model;
                n.change((t) => {
                  t.setSelection(null),
                    t.removeSelectionAttribute(
                      n.document.selection.getAttributeKeys()
                    );
                });
                for (const [n, o] of e.domRoots) {
                  const i = $x(t.data.get({ rootName: n })),
                    r = Da(o.ownerDocument, "textarea", {
                      rows: "1",
                      "aria-label": "Source code editing area",
                    }),
                    s = Da(
                      o.ownerDocument,
                      "div",
                      { class: "ck-source-editing-area", "data-value": i },
                      [r]
                    );
                  (r.value = i),
                    r.setSelectionRange(0, 0),
                    r.addEventListener("input", () => {
                      s.dataset.value = r.value;
                    }),
                    e.change((t) => {
                      const o = e.document.getRoot(n);
                      t.addClass("ck-hidden", o);
                    }),
                    t.ui.setEditableElement("sourceEditing:" + n, r),
                    this._replacedRoots.set(n, s),
                    this._elementReplacer.replace(o, s),
                    this._dataFromRoots.set(n, i);
                }
                this._focusSourceEditing();
              }
              _hideSourceEditing() {
                const t = this.editor.editing.view;
                this._updateEditorData(),
                  t.change((e) => {
                    for (const [n] of this._replacedRoots)
                      e.removeClass("ck-hidden", t.document.getRoot(n));
                  }),
                  this._elementReplacer.restore(),
                  this._replacedRoots.clear(),
                  this._dataFromRoots.clear(),
                  t.focus();
              }
              _updateEditorData() {
                const t = this.editor,
                  e = {};
                for (const [t, n] of this._replacedRoots) {
                  const o = this._dataFromRoots.get(t),
                    i = n.dataset.value;
                  o !== i && (e[t] = i);
                }
                Object.keys(e).length &&
                  t.data.set(e, { batchType: { isUndoable: !0 } });
              }
              _focusSourceEditing() {
                const t = this.editor,
                  [e] = this._replacedRoots.values(),
                  n = e.querySelector("textarea");
                (t.editing.view.document.isFocused = !1), n.focus();
              }
              _disableCommands() {
                const t = this.editor;
                for (const e of t.commands.commands()) e.forceDisabled(Wx);
              }
              _enableCommands() {
                const t = this.editor;
                for (const e of t.commands.commands()) e.clearForceDisabled(Wx);
              }
              _handleReadOnlyMode(t) {
                if (this.isSourceEditingMode)
                  for (const [, e] of this._replacedRoots)
                    e.querySelector("textarea").readOnly = t;
              }
              _isAllowedToHandleSourceEditingMode() {
                const t = this.editor.ui.view.editable;
                return t && !t._hasExternalElement;
              }
            },
            class extends j {
              static get requires() {
                return [Gx, Yx];
              }
              static get pluginName() {
                return "Strikethrough";
              }
            },
            class extends j {
              static get requires() {
                return [Qx, Xx];
              }
              static get pluginName() {
                return "Subscript";
              }
            },
            class extends j {
              static get requires() {
                return [eE, oE];
              }
              static get pluginName() {
                return "Superscript";
              }
            },
            class extends j {
              static get requires() {
                return [hD, kD, _D, ID, DD, CD, kf];
              }
              static get pluginName() {
                return "Table";
              }
            },
            class extends j {
              static get requires() {
                return [jf];
              }
              static get pluginName() {
                return "TableToolbar";
              }
              afterInit() {
                const t = this.editor,
                  e = t.t,
                  n = t.plugins.get(jf),
                  o = t.config.get("table.contentToolbar"),
                  i = t.config.get("table.tableToolbar");
                o &&
                  n.register("tableContent", {
                    ariaLabel: e("Table toolbar"),
                    items: o,
                    getRelatedElement: zD,
                  }),
                  i &&
                    n.register("table", {
                      ariaLabel: e("Table toolbar"),
                      items: i,
                      getRelatedElement: ND,
                    });
              }
            },
            class extends j {
              static get pluginName() {
                return "TableProperties";
              }
              static get requires() {
                return [YD, BS];
              }
            },
            class extends j {
              static get pluginName() {
                return "TableCellProperties";
              }
              static get requires() {
                return [XS, jS];
              }
            },
            class extends j {
              static get requires() {
                return ["Delete", "Input"];
              }
              static get pluginName() {
                return "TextTransformation";
              }
              constructor(t) {
                super(t),
                  t.config.define("typing", {
                    transformations: { include: wp },
                  });
              }
              init() {
                const t = this.editor.model.document.selection;
                t.on("change:range", () => {
                  this.isEnabled = !t.anchor.parent.is("element", "codeBlock");
                }),
                  this._enableTransformationWatchers();
              }
              _enableTransformationWatchers() {
                const t = this.editor,
                  e = t.model,
                  n = t.plugins.get("Delete"),
                  o = (function (t) {
                    const e = t.extra || [],
                      n = t.remove || [],
                      o = (t) => !n.includes(t);
                    return (function (t) {
                      const e = new Set();
                      for (const n of t)
                        if ("string" == typeof n && bp[n])
                          for (const t of bp[n]) e.add(t);
                        else e.add(n);
                      return Array.from(e);
                    })(t.include.concat(e).filter(o))
                      .filter(o)
                      .map((t) => ("string" == typeof t && kp[t] ? kp[t] : t))
                      .filter((t) => "object" == typeof t)
                      .map((t) => ({ from: Ap(t.from), to: _p(t.to) }));
                  })(t.config.get("typing.transformations")),
                  i = new lp(t.model, (t) => {
                    for (const e of o) {
                      if (e.from.test(t))
                        return { normalizedTransformation: e };
                    }
                  });
                i.on("matched:data", (t, o) => {
                  if (!o.batch.isTyping) return;
                  const { from: i, to: r } = o.normalizedTransformation,
                    s = i.exec(o.text),
                    a = r(s.slice(1)),
                    l = o.range;
                  let c = s.index;
                  e.enqueueChange((t) => {
                    for (let n = 1; n < s.length; n++) {
                      const o = s[n],
                        i = a[n - 1];
                      if (null == i) {
                        c += o.length;
                        continue;
                      }
                      const r = l.start.getShiftedBy(c),
                        d = e.createRange(r, r.getShiftedBy(o.length)),
                        u = Cp(r);
                      e.insertContent(t.createText(i, u), d), (c += i.length);
                    }
                    e.enqueueChange(() => {
                      n.requestUndoOnBackspace();
                    });
                  });
                }),
                  i.bind("isEnabled").to(this);
              }
            },
            class extends j {
              static get requires() {
                return [eI, oI];
              }
              static get pluginName() {
                return "Underline";
              }
            },
          ]),
            (iI.defaultConfig = {
              toolbar: {
                items: [
                  "heading",
                  "|",
                  "bold",
                  "italic",
                  "underline",
                  "strikethrough",
                  "subscript",
                  "superscript",
                  "|",
                  "link",
                  "fontColor",
                  "removeFormat",
                  "|",
                  "bulletedList",
                  "numberedList",
                  "-",
                  "outdent",
                  "indent",
                  "|",
                  "imageInsert",
                  "insertTable",
                  "|",
                  "blockQuote",
                  "code",
                  "horizontalLine",
                  "|",
                  "findAndReplace",
                  "undo",
                  "redo",
                  "|",
                  "fullscreen",
                  "|",
                  "sourceEditing",
                ],
                shouldNotGroupWhenFull: !0,
              },
              language: "en",
              image: {
                toolbar: [
                  "imageTextAlternative",
                  "imageStyle:inline",
                  "imageStyle:block",
                  "imageStyle:side",
                  "imageStyle:alignLeft",
                  "imageStyle:alignRight",
                  "|",
                  "linkImage",
                ],
              },
              table: {
                contentToolbar: [
                  "tableColumn",
                  "tableRow",
                  "mergeTableCells",
                  "tableProperties",
                  "tableCellProperties",
                ],
              },
            });
          const rI = iI;
        })(),
        (o = o.default)
      );
    })()
  );
//# sourceMappingURL=ckeditor.js.map
